const Fas0 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "Fas0",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 192C0 103.6 71.6 32 160 32s160 71.6 160 160v128c0 88.4-71.6 160-160 160S0 408.4 0 320V192zm160-96c-53 0-96 43-96 96v128c0 53 43 96 96 96s96-43 96-96V192c0-53-43-96-96-96z"
        }
    ]
};

const Fas00 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "Fas00",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 32C64.5 32 0 96.5 0 176v160c0 79.5 64.5 144 144 144s144-64.5 144-144V176c0-79.5-64.5-144-144-144zM64 176c0-44.2 35.8-80 80-80s80 35.8 80 80v160c0 44.2-35.8 80-80 80s-80-35.8-80-80V176zM496 32c-79.5 0-144 64.5-144 144v160c0 79.5 64.5 144 144 144s144-64.5 144-144V176c0-79.5-64.5-144-144-144zm-80 144c0-44.2 35.8-80 80-80s80 35.8 80 80v160c0 44.2-35.8 80-80 80s-80-35.8-80-80V176z"
        }
    ]
};

const Fas1 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "Fas1",
    "viewBox": "0 0 256 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 64c0-11.8-6.5-22.6-16.9-28.2s-23-5-32.8 1.6l-96 64C-.5 111.2-4.4 131 5.4 145.8s29.7 18.7 44.4 8.9L96 123.8V416H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h192c17.7 0 32-14.3 32-32s-14.3-32-32-32h-64V64z"
        }
    ]
};

const Fas2 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "Fas2",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M142.9 96c-21.5 0-42.2 8.5-57.4 23.8l-30.9 30.8c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l30.9-30.8C67.5 47.3 104.4 32 142.9 32 223 32 288 97 288 177.1c0 38.5-15.3 75.4-42.5 102.6L109.3 416H288c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9l190.9-190.8c15.2-15.2 23.8-35.9 23.8-57.4 0-44.8-36.3-81.1-81.1-81.1z"
        }
    ]
};

const Fas3 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "Fas3",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 64c0-17.7 14.3-32 32-32h240c13.2 0 25 8.1 29.8 20.4s1.5 26.3-8.2 35.2L162.3 208H184c75.1 0 136 60.9 136 136s-60.9 136-136 136h-78.6C63 480 24.2 456 5.3 418.1l-1.9-3.8c-7.9-15.8-1.5-35 14.3-42.9s35-1.5 42.9 14.3l1.9 3.8c8.1 16.3 24.8 26.5 42.9 26.5H184c39.8 0 72-32.2 72-72s-32.2-72-72-72H80c-13.2 0-25-8.1-29.8-20.4s-1.5-26.3 8.2-35.2L189.7 96H32C14.3 96 0 81.7 0 64z"
        }
    ]
};

const Fas360Degrees = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "Fas360Degrees",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M640 32a32 32 0 1 0-64 0 32 32 0 1 0 64 0zM32 64C14.3 64 0 78.3 0 96s14.3 32 32 32h64l-57.6 76.8c-7.3 9.7-8.4 22.7-3 33.5S51.9 256 64 256h16c26.5 0 48 21.5 48 48v48c0 17.7-14.3 32-32 32h-5.5c-8.5 0-16.6-3.4-22.6-9.4l-13.3-13.2c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L22.6 420c18 18 42.4 28.1 67.9 28.1H96c53 0 96-43 96-96V304c0-47-29-87.3-70.1-103.9l63.7-84.9c7.3-9.7 8.4-22.7 3-33.5S172.1 64 160 64H32zm448 80c0-8.8 7.2-16 16-16s16 7.2 16 16v224c0 8.8-7.2 16-16 16s-16-7.2-16-16V144zm96 224V144c0-44.2-35.8-80-80-80s-80 35.8-80 80v224c0 44.2 35.8 80 80 80s80-35.8 80-80zM288 160c0-17.7 14.3-32 32-32s32-14.3 32-32-14.3-32-32-32c-53 0-96 43-96 96v208c0 44.2 35.8 80 80 80s80-35.8 80-80v-96c0-44.2-35.8-80-80-80-5.5 0-10.8.6-16 1.6V160zm0 112c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16v-96z"
        }
    ]
};

const Fas4 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "Fas4",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M189 77.6c7.5-16 .7-35.1-15.3-42.6s-35.1-.7-42.6 15.3L3 322.4c-4.7 9.9-3.9 21.5 1.9 30.8S21 368 32 368h224v80c0 17.7 14.3 32 32 32s32-14.3 32-32v-80h32c17.7 0 32-14.3 32-32s-14.3-32-32-32h-32V160c0-17.7-14.3-32-32-32s-32 14.3-32 32v144H82.4L189 77.6z"
        }
    ]
};

const Fas5 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "Fas5",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32.5 58.3C35.3 43.1 48.5 32 64 32h192c17.7 0 32 14.3 32 32s-14.3 32-32 32H90.7L70.3 208H184c75.1 0 136 60.9 136 136s-60.9 136-136 136h-83.5c-39.4 0-75.4-22.3-93-57.5l-4.1-8.2c-7.9-15.8-1.5-35 14.3-42.9s35-1.5 42.9 14.3l4.1 8.2c6.8 13.6 20.6 22.1 35.8 22.1H184c39.8 0 72-32.2 72-72s-32.2-72-72-72H32c-9.5 0-18.5-4.2-24.6-11.5s-8.6-16.9-6.9-26.2l32-176z"
        }
    ]
};

const Fas6 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "Fas6",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M232.4 84.7c11.4-13.5 9.7-33.7-3.8-45.1s-33.7-9.7-45.1 3.8L38.6 214.7C14.7 242.9 1.1 278.4.1 315.2c0 1.4-.1 2.9-.1 4.3v.5c0 88.4 71.6 160 160 160s160-71.6 160-160c0-85.5-67.1-155.4-151.5-159.8l63.9-75.6zM256 320a96 96 0 1 1-192 0 96 96 0 1 1 192 0z"
        }
    ]
};

const Fas7 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "Fas7",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 64c0-17.7 14.3-32 32-32h256c11.5 0 22 6.1 27.7 16.1s5.7 22.2-.1 32.1l-224 384c-8.9 15.3-28.5 20.4-43.8 11.5s-20.4-28.5-11.5-43.8L232.3 96H32C14.3 96 0 81.7 0 64z"
        }
    ]
};

const Fas8 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "Fas8",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M304 160c0-70.7-57.3-128-128-128h-32C73.3 32 16 89.3 16 160c0 34.6 13.7 66 36 89-31.5 23.3-52 60.8-52 103 0 70.7 57.3 128 128 128h64c70.7 0 128-57.3 128-128 0-42.2-20.5-79.7-52-103 22.3-23 36-54.4 36-89zM176.1 288H192c35.3 0 64 28.7 64 64s-28.7 64-64 64h-64c-35.3 0-64-28.7-64-64s28.7-64 64-64h48.1zm0-64H144c-35.3 0-64-28.7-64-64s28.7-64 64-64h32c35.3 0 64 28.7 64 64s-28.6 64-64 64z"
        }
    ]
};

const Fas9 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "Fas9",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 192a96 96 0 1 0 192 0 96 96 0 1 0-192 0zm87.5 159.8C67.1 347.4 0 277.5 0 192 0 103.6 71.6 32 160 32s160 71.6 160 160c0 2.6-.1 5.3-.2 7.9-1.7 35.7-15.2 70-38.4 97.4l-145 171.4c-11.4 13.5-31.6 15.2-45.1 3.8s-15.2-31.6-3.8-45.1l63.9-75.6z"
        }
    ]
};

const FasA = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasA",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M221.5 51.7C216.6 39.8 204.9 32 192 32s-24.6 7.8-29.5 19.7l-120 288-40 96c-6.8 16.3.9 35 17.2 41.8s35-.9 41.8-17.2L93.3 384h197.4l31.8 76.3c6.8 16.3 25.5 24 41.8 17.2s24-25.5 17.2-41.8l-40-96-120-288zM264 320H120l72-172.8L264 320z"
        }
    ]
};

const FasAbacus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasAbacus",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 96v112h-64v-32h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V96h64zm-96 32h-8c-13.3 0-24 10.7-24 24s10.7 24 24 24h8v32H288v-32h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V96h128v32zm-160 0h-8c-13.3 0-24 10.7-24 24s10.7 24 24 24h8v32h-96v-32h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V96h96v32zm-128 0h-8c-13.3 0-24 10.7-24 24s10.7 24 24 24h8v32H64V96h64v32zM64 416V240h64v24h-8c-13.3 0-24 10.7-24 24s10.7 24 24 24h8v24h-8c-13.3 0-24 10.7-24 24s10.7 24 24 24h8v32H64zm96-32h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8v-24h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8v-24h96v24h-8c-13.3 0-24 10.7-24 24s10.7 24 24 24h8v24h-8c-13.3 0-24 10.7-24 24s10.7 24 24 24h8v32h-96v-32zm128-72h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8v-24h128v96h-8c-13.3 0-24 10.7-24 24s10.7 24 24 24h8v32H288v-32h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8v-24zm160 72h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8v-96h64v176h-64v-32zM64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z"
        }
    ]
};

const FasAccentGrave = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasAccentGrave",
    "viewBox": "0 0 192 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M108.3 204.8 41.2 95c-6-9.8-9.2-21.2-9.2-32.7C32 28.1 59.7 0 93.9 0c29.2 0 54.4 20.4 60.6 49l27.1 126.6C187 200.5 168 224 142.5 224c-14 0-26.9-7.3-34.2-19.2z"
        }
    ]
};

const FasAcorn = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasAcorn",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M262.4 4.8c10.6 8 12.8 23 4.8 33.6l-4.8 6.4c-4.4 5.9-7.9 12.4-10.3 19.2H352c53 0 96 43 96 96 0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32 0-53 43-96 96-96h106.4c3.6-17.3 10.9-33.7 21.6-48l4.8-6.4c8-10.6 23-12.8 33.6-4.8zm-48.5 471.6C78.5 425.9 48 302.1 48 224h352c0 78.1-30.5 201.9-165.9 252.4-6.5 2.4-13.7 2.4-20.2 0z"
        }
    ]
};

const FasAddressBook = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasAddressBook",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 0C60.7 0 32 28.7 32 64v384c0 35.3 28.7 64 64 64h288c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H96zm112 288h64c44.2 0 80 35.8 80 80 0 8.8-7.2 16-16 16H144c-8.8 0-16-7.2-16-16 0-44.2 35.8-80 80-80zm-32-96a64 64 0 1 1 128 0 64 64 0 1 1-128 0zM512 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V80zm-16 112c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16v-64c0-8.8-7.2-16-16-16zm16 144c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16v-64z"
        }
    ]
};

const FasAddressCard = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasAddressCard",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm80 256h64c44.2 0 80 35.8 80 80 0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16 0-44.2 35.8-80 80-80zm-32-96a64 64 0 1 1 128 0 64 64 0 1 1-128 0zm256-32h128c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64h128c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64h128c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FasAirConditioner = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasAirConditioner",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 0C28.7 0 0 28.7 0 64v96c0 35.3 28.7 64 64 64h448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm16 128h416c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zm176 128h-64v160c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-11.8 6.4-22.2 16-27.7 15.3-8.9 20.5-28.4 11.7-43.7s-28.4-20.5-43.7-11.7c-28.6 16.5-48 47.5-48 83.1 0 53 43 96 96 96s96-43 96-96V256zm64 128c0 53 43 96 96 96s96-43 96-96c0-35.6-19.4-66.6-48-83.1-15.3-8.8-34.9-3.6-43.7 11.7s-3.6 34.9 11.7 43.7c9.6 5.6 16 15.9 16 27.7 0 17.7-14.3 32-32 32s-32-14.3-32-32V256h-64v128z"
        }
    ]
};

const FasAirplay = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasAirplay",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 96H96c-17.7 0-32 14.3-32 32v192c0 17.7 14.3 32 32 32h69.5l-50.7 50.7c-4 4-7.4 8.5-10.2 13.3H96c-53 0-96-43-96-96V128c0-53 43-96 96-96h384c53 0 96 43 96 96v192c0 53-43 96-96 96h-8.6c-2.8-4.8-6.2-9.2-10.2-13.3L410.5 352H480c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32zM265.4 297.4c12.5-12.5 32.8-12.5 45.3 0l128 128c9.2 9.2 11.9 22.9 6.9 34.9S429 480.1 416 480.1H160c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9l128-128z"
        }
    ]
};

const FasAlarmClock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasAlarmClock",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 25.4C143 9.6 120.2 0 95.2 0 42.6 0 0 42.6 0 95.2c0 18.8 5.5 36.3 14.9 51.1L160 25.4zM256 512c50.3 0 96.8-16.6 134.2-44.6l35.2 35.2c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-35.2-35.2c28-37.4 44.6-83.8 44.6-134.2C480 164.3 379.7 64 256 64S32 164.3 32 288c0 50.3 16.6 96.8 44.6 134.2l-35.2 35.2c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l35.2-35.2c37.4 28 83.8 44.6 134.1 44.6zm241.1-365.6c9.4-14.8 14.9-32.4 14.9-51.2C512 42.6 469.4 0 416.8 0c-25 0-47.8 9.6-64.8 25.4l145.1 121zM280 184v94.1l41 41c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-48-48c-4.5-4.5-7-10.6-7-17V184c0-13.3 10.7-24 24-24s24 10.7 24 24z"
        }
    ]
};

const FasAlarmExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasAlarmExclamation",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M14.9 146.4C5.5 131.6 0 114 0 95.2 0 42.6 42.6 0 95.2 0c25 0 47.8 9.6 64.8 25.4l-145.1 121zm375.3 321c-37.4 28-83.9 44.6-134.2 44.6s-96.8-16.6-134.1-44.6l-35.3 35.2c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l35.2-35.2C48.6 384.8 32 338.3 32 288 32 164.3 132.3 64 256 64s224 100.3 224 224c0 50.3-16.6 96.8-44.6 134.2l35.2 35.2c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-35.2-35.2zM352 25.4C369 9.6 391.8 0 416.8 0 469.4 0 512 42.6 512 95.2c0 18.8-5.5 36.3-14.9 51.1L352 25.4zM288 384a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm-8-200c0-13.3-10.7-24-24-24s-24 10.7-24 24v112c0 13.3 10.7 24 24 24s24-10.7 24-24V184z"
        }
    ]
};

const FasAlarmPlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasAlarmPlus",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M14.9 146.4C5.5 131.6 0 114 0 95.2 0 42.6 42.6 0 95.2 0c25 0 47.8 9.6 64.8 25.4l-145.1 121zm375.3 321c-37.4 28-83.9 44.6-134.2 44.6s-96.8-16.6-134.1-44.6l-35.3 35.2c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l35.2-35.2C48.6 384.8 32 338.3 32 288 32 164.3 132.3 64 256 64s224 100.3 224 224c0 50.3-16.6 96.8-44.6 134.2l35.2 35.2c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-35.2-35.2zM352 25.4C369 9.6 391.8 0 416.8 0 469.4 0 512 42.6 512 95.2c0 18.8-5.5 36.3-14.9 51.1L352 25.4zM256 176c-13.3 0-24 10.7-24 24v64h-64c-13.3 0-24 10.7-24 24s10.7 24 24 24h64v64c0 13.3 10.7 24 24 24s24-10.7 24-24v-64h64c13.3 0 24-10.7 24-24s-10.7-24-24-24h-64v-64c0-13.3-10.7-24-24-24z"
        }
    ]
};

const FasAlarmSnooze = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasAlarmSnooze",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 25.4C143 9.6 120.2 0 95.2 0 42.6 0 0 42.6 0 95.2c0 18.8 5.5 36.3 14.9 51.1L160 25.4zM256 512c50.3 0 96.8-16.6 134.2-44.6l35.2 35.2c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-35.2-35.2c28-37.4 44.6-83.8 44.6-134.2C480 164.3 379.7 64 256 64S32 164.3 32 288c0 50.3 16.6 96.8 44.6 134.2l-35.2 35.2c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l35.2-35.2c37.4 28 83.8 44.6 134.1 44.6zm241.1-365.6c9.4-14.8 14.9-32.4 14.9-51.2C512 42.6 469.4 0 416.8 0c-25 0-47.8 9.6-64.8 25.4l145.1 121zM200 192h112c9.2 0 17.5 5.2 21.6 13.5s3 18-2.6 25.3L249.1 336H312c13.3 0 24 10.7 24 24s-10.7 24-24 24H200c-9.2 0-17.5-5.2-21.6-13.5s-3-18 2.6-25.3L262.9 240H200c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
        }
    ]
};

const FasAlbumCirclePlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasAlbumCirclePlus",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v96.7c-5.3-.5-10.6-.7-16-.7-20.1 0-39.5 3.4-57.5 9.6C352.3 140 293.3 96 224 96c-88.4 0-160 71.6-160 160s71.6 160 160 160c12.9 0 25.4-1.5 37.4-4.4 6.5 25.5 18.5 48.7 34.8 68.4H64c-35.3 0-64-28.7-64-64V96zm224 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm208 0a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48h-48c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48h48c8.8 0 16-7.2 16-16s-7.2-16-16-16h-48v-48z"
        }
    ]
};

const FasAlbumCircleUser = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasAlbumCircleUser",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v96.7c-5.3-.5-10.6-.7-16-.7-20.1 0-39.5 3.4-57.5 9.6C352.3 140 293.3 96 224 96c-88.4 0-160 71.6-160 160s71.6 160 160 160c12.9 0 25.4-1.5 37.4-4.4 6.5 25.5 18.5 48.7 34.8 68.4H64c-35.3 0-64-28.7-64-64V96zm224 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64 144a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm221.7 80.7c-6.2-19-24-32.7-45.1-32.7h-65.2c-21 0-38.9 13.7-45.1 32.7 20.2 19.4 47.5 31.3 77.7 31.3s57.5-11.9 77.7-31.3zM480 336a48 48 0 1 0-96 0 48 48 0 1 0 96 0z"
        }
    ]
};

const FasAlbumCollectionCirclePlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasAlbumCollectionCirclePlus",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 24c0 13.3 10.7 24 24 24h400c13.3 0 24-10.7 24-24S469.3 0 456 0H56C42.7 0 32 10.7 32 24zm16 136c-13.8 0-26.9 5.9-36 16.2S-1.3 200.3.4 214l32 256c3 24 23.4 42 47.6 42h314.8a176.48 176.48 0 0 1-47.5-49.9c-26.9 11.4-58 17.9-91.3 17.9-101.6 0-184-60.9-184-136s82.4-136 184-136c45.4 0 86.9 12.1 119 32.2 31.5-29.9 74.2-48.2 121-48.2 4.5 0 9 .2 13.4.5-2-5.9-5.2-11.5-9.4-16.3-9.1-10.3-22.2-16.2-36-16.2H48zm208 216c17.7 0 32-10.7 32-24s-14.3-24-32-24-32 10.7-32 24 14.3 24 32 24zM40 80c-13.3 0-24 10.7-24 24s10.7 24 24 24h432c13.3 0 24-10.7 24-24s-10.7-24-24-24H40zm456 432a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-208v48h48c8.8 0 16 7.2 16 16s-7.2 16-16 16h-48v48c0 8.8-7.2 16-16 16s-16-7.2-16-16v-48h-48c-8.8 0-16-7.2-16-16s7.2-16 16-16h48v-48c0-8.8 7.2-16 16-16s16 7.2 16 16z"
        }
    ]
};

const FasAlbumCollectionCircleUser = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasAlbumCollectionCircleUser",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 24c0 13.3 10.7 24 24 24h400c13.3 0 24-10.7 24-24S469.3 0 456 0H56C42.7 0 32 10.7 32 24zm16 136c-13.8 0-26.9 5.9-36 16.2S-1.3 200.3.4 214l32 256c3 24 23.4 42 47.6 42h314.8a176.48 176.48 0 0 1-47.5-49.9c-26.9 11.4-58 17.9-91.3 17.9-101.6 0-184-60.9-184-136s82.4-136 184-136c45.4 0 86.9 12.1 119 32.2 31.5-29.9 74.2-48.2 121-48.2 4.5 0 9 .2 13.4.5-2-5.9-5.2-11.5-9.4-16.3-9.1-10.3-22.2-16.2-36-16.2H48zm208 216c17.7 0 32-10.7 32-24s-14.3-24-32-24-32 10.7-32 24 14.3 24 32 24zM40 80c-13.3 0-24 10.7-24 24s10.7 24 24 24h432c13.3 0 24-10.7 24-24s-10.7-24-24-24H40zm600 288a144 144 0 1 0-288 0 144 144 0 1 0 288 0zm-66.3 80.7C553.5 468.1 526.2 480 496 480s-57.5-11.9-77.7-31.3c6.2-19 24-32.7 45.1-32.7h65.2c21 0 38.9 13.7 45.1 32.7zM448 336a48 48 0 1 1 96 0 48 48 0 1 1-96 0z"
        }
    ]
};

const FasAlbumCollection = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasAlbumCollection",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 24c0 13.3 10.7 24 24 24h400c13.3 0 24-10.7 24-24S469.3 0 456 0H56C42.7 0 32 10.7 32 24zm16 136c-13.8 0-26.9 5.9-36 16.2S-1.3 200.3.4 214l32 256c3 24 23.4 42 47.6 42h352c24.2 0 44.6-18 47.6-42l32-256c1.7-13.7-2.5-27.4-11.6-37.7s-22.2-16.2-36-16.2H48zm392 184c0 75.1-82.4 136-184 136S72 419.1 72 344s82.4-136 184-136 184 60.9 184 136zm-184 32c17.7 0 32-10.7 32-24s-14.3-24-32-24-32 10.7-32 24 14.3 24 32 24zM40 80c-13.3 0-24 10.7-24 24s10.7 24 24 24h432c13.3 0 24-10.7 24-24s-10.7-24-24-24H40z"
        }
    ]
};

const FasAlbum = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasAlbum",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm384 160a160 160 0 1 0-320 0 160 160 0 1 0 320 0zm-160-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FasAlicorn = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasAlicorn",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 160v80c-.5 30-12.8 56.4-32 75.7V480c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32V346.7c-4.1-.7-8.2-1.6-12.3-2.8l-84-24c.2 2.3.3 4.6.3 6.9 0 18.6-7.4 36.5-20.6 49.7l-12.7 12.7c-4.8 4.8-6.4 11.8-4.3 18.2l20.8 62.5c6.9 20.7-8.5 42.1-30.4 42.1h-33.7c-13.8 0-26-8.8-30.4-21.9l-17.4-52.4c-10.6-31.7-6.5-65.9 10-93.9 7.6-12.9 9.5-29.1 1.2-41.6l-28.3-42.3c-7.3-11-11.9-23.4-13.6-36.4-10 7.3-16.6 19.1-16.6 32.5v56c0 13.3-10.7 24-24 24S0 325.3 0 312v-56c0-44.6 33.2-81.5 76.3-87.2 13-21.4 35.2-36.5 61.1-40 3.8 15.3 9.2 29.8 16.5 43 11.3 20.4 27.4 37.7 49.9 49.8 6.3 3.4 13.1 6.4 20.3 8.8-16.5-11.4-28.9-26-38.2-42.7C163.8 147.9 160 96.1 160 48c0-5.9 3.2-11.3 8.5-14.1s11.5-2.5 16.4.8L320 124.8C321.7 55.6 378.4 0 448 0h96c8.8 0 16 7.2 16 16s-7.2 16-16 16h-5.7c5.2 4.6 9.6 10 13.1 16h79.3c5.1 0 9.3 4.2 9.3 9.3 0 4-2.6 7.6-6.4 8.8L560 90.7v64.8c0 22.1-13.4 41.9-33.9 50.1-26.1 10.4-55.7-.9-68.3-26L448 160zm64-80a16 16 0 1 0-32 0 16 16 0 1 0 32 0z"
        }
    ]
};

const FasAlien8bit = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasAlien8bit",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 48c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v16h48c8.8 0 16 7.2 16 16v48h128V80c0-8.8 7.2-16 16-16h48V48c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-48v64h48c8.8 0 16 7.2 16 16v48h32v-80c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v128c0 8.8-7.2 16-16 16h-48v80c0 8.8-7.2 16-16 16h-48v80c0 8.8-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h48v-32H224v32h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16v-80h-48c-8.8 0-16-7.2-16-16v-80H48c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v80h32v-48c0-8.8 7.2-16 16-16h48V96h-48c-8.8 0-16-7.2-16-16V48zm64 192v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16zm192 0v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16z"
        }
    ]
};

const FasAlien = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasAlien",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 0C100.3 0 0 100.3 0 224c0 135.3 148.8 247.7 194.7 279.2 8.6 5.9 18.9 8.8 29.3 8.8s20.7-2.9 29.3-8.8C299.2 471.7 448 359.3 448 224 448 100.3 347.7 0 224 0zm32 306.3c0-45.4 36.8-82.3 82.3-82.3h32c7.6 0 13.7 6.1 13.7 13.7 0 45.4-36.8 82.3-82.3 82.3h-32c-7.6 0-13.7-6.1-13.7-13.7zM109.7 224c45.4 0 82.3 36.8 82.3 82.3 0 7.6-6.1 13.7-13.7 13.7h-32c-45.5 0-82.3-36.8-82.3-82.3 0-7.6 6.1-13.7 13.7-13.7h32z"
        }
    ]
};

const FasAlignCenter = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasAlignCenter",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 64c0-17.7-14.3-32-32-32H128c-17.7 0-32 14.3-32 32s14.3 32 32 32h192c17.7 0 32-14.3 32-32zm96 128c0-17.7-14.3-32-32-32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h384c17.7 0 32-14.3 32-32zM0 448c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32zm352-128c0-17.7-14.3-32-32-32H128c-17.7 0-32 14.3-32 32s14.3 32 32 32h192c17.7 0 32-14.3 32-32z"
        }
    ]
};

const FasAlignJustify = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasAlignJustify",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 64c0-17.7-14.3-32-32-32H32C14.3 32 0 46.3 0 64s14.3 32 32 32h384c17.7 0 32-14.3 32-32zm0 256c0-17.7-14.3-32-32-32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h384c17.7 0 32-14.3 32-32zM0 192c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32zm448 256c0-17.7-14.3-32-32-32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h384c17.7 0 32-14.3 32-32z"
        }
    ]
};

const FasAlignLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasAlignLeft",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 64c0 17.7-14.3 32-32 32H32C14.3 96 0 81.7 0 64s14.3-32 32-32h224c17.7 0 32 14.3 32 32zm0 256c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h224c17.7 0 32 14.3 32 32zM0 192c0-17.7 14.3-32 32-32h384c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zm448 256c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h384c17.7 0 32 14.3 32 32z"
        }
    ]
};

const FasAlignRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasAlignRight",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 64c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32s14.3-32 32-32h224c17.7 0 32 14.3 32 32zm0 256c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32s14.3-32 32-32h224c17.7 0 32 14.3 32 32zM0 192c0-17.7 14.3-32 32-32h384c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zm448 256c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h384c17.7 0 32 14.3 32 32z"
        }
    ]
};

const FasAlignSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasAlignSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L481.4 352H512c17.7 0 32-14.3 32-32s-14.3-32-32-32H399.7L318 224h194c17.7 0 32-14.3 32-32s-14.3-32-32-32H236.4l-81.6-64H512c17.7 0 32-14.3 32-32s-14.3-32-32-32H128c-13.4 0-24.8 8.2-29.6 19.8L38.8 5.1zM324.9 352l-81.2-64H128c-17.7 0-32 14.3-32 32s14.3 32 32 32h196.9zM162.5 224l-61.8-48.7c-3 4.9-4.7 10.6-4.7 16.7 0 17.7 14.3 32 32 32h34.5zm324.9 256-81.2-64H128c-17.7 0-32 14.3-32 32s14.3 32 32 32h359.4z"
        }
    ]
};

const FasAlt = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasAlt",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 64c-9.7 0-18.9 4.4-25 12L176.6 384H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h160c9.7 0 18.9-4.4 25-12l246.4-308H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H448zm0 320c-17.7 0-32 14.3-32 32s14.3 32 32 32h160c17.7 0 32-14.3 32-32s-14.3-32-32-32H448z"
        }
    ]
};

const FasAmpGuitar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasAmpGuitar",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 0c-48.9 0-92.5 28.8-121.6 53.8-15 12.9-27.3 25.7-35.8 35.3-2.3 2.6-4.3 4.9-6 6.9H64c-35.3 0-64 28.7-64 64v288c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64h-28.5c-1.7-2.1-3.8-4.4-6-6.9-8.5-9.6-20.8-22.4-35.8-35.3C348.5 28.8 304.9 0 256 0zm96.9 96H159.1c2.1-1.9 4.3-3.8 6.5-5.8C192.5 67.2 224.9 48 256 48s63.5 19.2 90.4 42.2c2.2 1.9 4.4 3.9 6.5 5.8zM96 152a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 24a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm152-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 24a24 24 0 1 1 48 0 24 24 0 1 1-48 0zM64 448V256h384v192H64zm64-128a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm48-64a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm16-32a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16 80a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm16-32a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm48-64a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm-16 112a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm48-64a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm16-32a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16 80a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm16-32a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm48-64a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm-16 112a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
        }
    ]
};

const FasAmpersand = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasAmpersand",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M180.7 96h38c20.6 0 37.3 16.7 37.3 37.3 0 11.8-5.5 22.8-14.9 29.9l-48 36-39-41.3c-6.4-6.8-10-15.8-10-25.2 0-20.3 16.4-36.7 36.7-36.7zm56.6 150 42.2-31.6c25.5-19.1 40.5-49.2 40.5-81.1C320 77.4 274.6 32 218.7 32h-38C125.1 32 80 77.1 80 132.7c0 25.7 9.8 50.4 27.5 69.1l34 36L74.7 288C47.8 308.1 32 339.8 32 373.3 32 432.2 79.8 480 138.7 480h74.5c37.4 0 72.4-18.7 93.2-49.9l6.9-10.4 47.4 50.3c12.1 12.8 32.4 13.4 45.2 1.3s13.4-32.4 1.3-45.2l-57.5-60.9 60.9-91.4c9.8-14.7 5.8-34.6-8.9-44.4s-34.6-5.8-44.4 8.9l-52.7 79.1-67.3-71.4zm-51.5 38.6 82.4 87.4-15.1 22.6c-8.9 13.4-23.9 21.4-39.9 21.4h-74.5c-23.6 0-42.7-19.1-42.7-42.7 0-13.4 6.3-26.1 17.1-34.1l72.7-54.5z"
        }
    ]
};

const FasAnchorCircleCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasAnchorCircleCheck",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 96a32 32 0 1 1-64 0 32 32 0 1 1 64 0zm21.1 80C367 158.8 384 129.4 384 96c0-53-43-96-96-96s-96 43-96 96c0 33.4 17 62.8 42.9 80H224c-17.7 0-32 14.3-32 32s14.3 32 32 32h32v208h-48c-53 0-96-43-96-96v-6.1l7 7c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97 263c-9.4-9.4-24.6-9.4-33.9 0L7 319c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l7-7v6.1c0 88.4 71.6 160 160 160h160c8.2 0 16.3-.6 24.2-1.8-22.2-16.2-40.4-37.5-53-62.2H320V240h32c17.7 0 32-14.3 32-32s-14.3-32-32-32h-10.9zM640 368a144 144 0 1 0-288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l28.7 28.7 60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"
        }
    ]
};

const FasAnchorCircleExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasAnchorCircleExclamation",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 96a32 32 0 1 1-64 0 32 32 0 1 1 64 0zm21.1 80C367 158.8 384 129.4 384 96c0-53-43-96-96-96s-96 43-96 96c0 33.4 17 62.8 42.9 80H224c-17.7 0-32 14.3-32 32s14.3 32 32 32h32v208h-48c-53 0-96-43-96-96v-6.1l7 7c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97 263c-9.4-9.4-24.6-9.4-33.9 0L7 319c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l7-7v6.1c0 88.4 71.6 160 160 160h160c8.2 0 16.3-.6 24.2-1.8-22.2-16.2-40.4-37.5-53-62.2H320V240h32c17.7 0 32-14.3 32-32s-14.3-32-32-32h-10.9zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16v-80c0-8.8 7.2-16 16-16z"
        }
    ]
};

const FasAnchorCircleXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasAnchorCircleXmark",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 96a32 32 0 1 1-64 0 32 32 0 1 1 64 0zm21.1 80C367 158.8 384 129.4 384 96c0-53-43-96-96-96s-96 43-96 96c0 33.4 17 62.8 42.9 80H224c-17.7 0-32 14.3-32 32s14.3 32 32 32h32v208h-48c-53 0-96-43-96-96v-6.1l7 7c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97 263c-9.4-9.4-24.6-9.4-33.9 0L7 319c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l7-7v6.1c0 88.4 71.6 160 160 160h160c8.2 0 16.3-.6 24.2-1.8-22.2-16.2-40.4-37.5-53-62.2H320V240h32c17.7 0 32-14.3 32-32s-14.3-32-32-32h-10.9zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L518.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l36.7-36.7-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l36.7 36.7 36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
        }
    ]
};

const FasAnchorLock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasAnchorLock",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 96a32 32 0 1 1-64 0 32 32 0 1 1 64 0zm21.1 80C367 158.8 384 129.4 384 96c0-53-43-96-96-96s-96 43-96 96c0 33.4 17 62.8 42.9 80H224c-17.7 0-32 14.3-32 32s14.3 32 32 32h32v208h-48c-53 0-96-43-96-96v-6.1l7 7c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97 263c-9.4-9.4-24.6-9.4-33.9 0L7 319c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l7-7v6.1c0 88.4 71.6 160 160 160h160c8 0 15.9-.6 23.6-1.7-4.8-9-7.6-19.3-7.6-30.3v-33.3c-5.2.9-10.5 1.3-16 1.3H320V240h32c17.7 0 32-14.3 32-32s-14.3-32-32-32h-10.9zM528 240c17.7 0 32 14.3 32 32v48h-64v-48c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32v128c0 17.7 14.3 32 32 32h160c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32v-48c0-44.2-35.8-80-80-80s-80 35.8-80 80z"
        }
    ]
};

const FasAnchor = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasAnchor",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 96a32 32 0 1 1-64 0 32 32 0 1 1 64 0zm21.1 80C367 158.8 384 129.4 384 96c0-53-43-96-96-96s-96 43-96 96c0 33.4 17 62.8 42.9 80H224c-17.7 0-32 14.3-32 32s14.3 32 32 32h32v208h-48c-53 0-96-43-96-96v-6.1l7 7c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97 263c-9.4-9.4-24.6-9.4-33.9 0L7 319c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l7-7v6.1c0 88.4 71.6 160 160 160h160c88.4 0 160-71.6 160-160v-6.1l7 7c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-56-56c-9.4-9.4-24.6-9.4-33.9 0l-56 56c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l7-7v6.1c0 53-43 96-96 96H320V240h32c17.7 0 32-14.3 32-32s-14.3-32-32-32h-10.9z"
        }
    ]
};

const FasAngel = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasAngel",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 64v.2c0 .1-.1.3-.2.6-.3.6-.9 1.8-2.3 3.5s-3.4 3.6-6.2 5.6c6.7 8.3 12.2 17.6 16.3 27.7C407 91 416 78 416 64c0-35.3-57.3-64-128-64S160 28.7 160 64c0 14 9 27 24.3 37.5 4.1-10 9.6-19.3 16.3-27.7-2.7-2-4.8-4-6.2-5.6-1.4-1.7-2-2.8-2.3-3.5-.1-.3-.2-.5-.2-.6v-.4c0-.1.1-.3.2-.6.3-.6.9-1.8 2.3-3.5 2.9-3.5 8.4-7.9 17.3-12.4C229.6 38.4 256.5 32 288 32s58.4 6.4 76.2 15.4c8.9 4.5 14.4 8.9 17.3 12.4 1.4 1.7 2 2.8 2.3 3.5.1.3.2.5.2.6v.2zm-16 80a80 80 0 1 0-160 0 80 80 0 1 0 160 0zM120 464H49.7l37.9-75.8c5.6-11.1 8.4-23.4 8.4-35.8v-.9c0-12.4-2.9-24.7-8.4-35.8L69.2 279c-3.4-6.7-5.2-14.4-5.2-22.1 0-27.1 22-48.9 48.2-48.9 12.8 0 25 5.1 34.1 14.1l66.4 66.4c-6.8 7.2-12.7 15.5-17.3 24.7L120 464zm133.8-202.2-73.6-73.6c-18-18-42.5-28.2-68-28.2-53.1 0-96.2 43.8-96.2 96.9 0 15.1 3.5 30.1 10.2 43.6l18.4 36.7c2.2 4.4 3.4 9.3 3.4 14.3v.9c0 5-1.2 9.9-3.4 14.3L4.8 446.4C1.6 452.7 0 459.7 0 466.7c0 25 20.3 45.3 45.3 45.3h485.4c25 0 45.3-20.3 45.3-45.3 0-7-1.6-14-4.8-20.3l-39.8-79.7c-2.2-4.4-3.4-9.3-3.4-14.3v-.9c0-5 1.2-9.9 3.4-14.3l18.4-36.7C556.5 287 560 272 560 256.9c0-53.1-43.1-96.9-96.2-96.9-25.5 0-50 10.1-68 28.2l-73.6 73.6c-10.8-3.8-22.4-5.8-34.2-5.8s-23.4 2-34.2 5.8zm126.8 51.4c-4.6-9.2-10.4-17.5-17.3-24.7l66.4-66.4c9-9 21.3-14.1 34.1-14.1 26.1 0 48.2 21.8 48.2 48.9 0 7.7-1.8 15.4-5.2 22.1l-18.4 36.7c-5.6 11.1-8.4 23.4-8.4 35.8v.9c0 12.4 2.9 24.7 8.4 35.8l37.9 75.8H456l-75.4-150.8z"
        }
    ]
};

const FasAngle90 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasAngle90",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64v384c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32s-14.3-32-32-32H64V64zm32 33.6v48.3c31 3.6 60.4 12.5 87.4 25.7l25.3-41.1C174.2 113 136.2 101.6 96 97.6zm115.2 89.7c32.6 21 60.5 48.9 81.5 81.5l40.9-25.2c-25-39-58.2-72.2-97.2-97.2l-25.2 40.9zM334.1 384h48.3c-4-40.2-15.4-78.2-32.9-112.6l-41.1 25.3c13.2 26.9 22 56.3 25.7 87.4z"
        }
    ]
};

const FasAngleDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasAngleDown",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M201.4 342.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 274.7 86.6 137.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"
        }
    ]
};

const FasAngleLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasAngleLeft",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256l137.3-137.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"
        }
    ]
};

const FasAngleRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasAngleRight",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M278.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L210.7 256 73.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z"
        }
    ]
};

const FasAngleUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasAngleUp",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M201.4 137.4c12.5-12.5 32.8-12.5 45.3 0l160 160c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L224 205.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l160-160z"
        }
    ]
};

const FasAngle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasAngle",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M252.6 78.3c7.9-15.8 1.5-35-14.3-42.9s-35-1.5-42.9 14.3l-192 384c-5 9.9-4.4 21.7 1.4 31.1S20.9 480 32 480h384c17.7 0 32-14.3 32-32s-14.3-32-32-32H83.8L252.6 78.3zm-12.2 96-21.9 43.8c21.4 17.4 40.4 37.7 56.2 60.4l40.8-25.3c-20.7-30.1-46.1-56.7-75.1-78.9zM321.1 384h49c-7-37-19.8-71.9-37.6-103.7l-40.8 25.3c13.3 24.2 23.3 50.5 29.5 78.3z"
        }
    ]
};

const FasAnglesDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasAnglesDown",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M246.6 470.6c-12.5 12.5-32.8 12.5-45.3 0l-160-160c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L224 402.7l137.4-137.3c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-160 160zm160-352-160 160c-12.5 12.5-32.8 12.5-45.3 0l-160-160c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L224 210.7 361.4 73.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3z"
        }
    ]
};

const FasAnglesLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasAnglesLeft",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256l137.3-137.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160zm352-160-160 160c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L301.3 256l137.3-137.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0z"
        }
    ]
};

const FasAnglesRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasAnglesRight",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M470.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 256 265.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160zm-352 160 160-160c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L210.7 256 73.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0z"
        }
    ]
};

const FasAnglesUpDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasAnglesUpDown",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M244 7c-11.7-9.3-28.3-9.3-40 0L44 135c-13.8 11-16 31.2-5 45s31.2 16 45 5L224 73l140 112c13.8 11 33.9 8.8 45-5s8.8-33.9-5-45L244 7zm160 370c13.8-11 16-31.2 5-45s-31.2-16-45-5L224 439 84 327c-13.8-11-33.9-8.8-45 5s-8.8 33.9 5 45l160 128c11.7 9.3 28.3 9.3 40 0l160-128z"
        }
    ]
};

const FasAnglesUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasAnglesUp",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M246.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-160 160c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L224 109.3l137.4 137.3c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-160-160zm160 352-160-160c-12.5-12.5-32.8-12.5-45.3 0l-160 160c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L224 301.3l137.4 137.3c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3z"
        }
    ]
};

const FasAnkh = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasAnkh",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 128c0-35.3 28.7-64 64-64s64 28.7 64 64c0 41.6-20.7 76.6-46.6 104.1-5.9 6.2-11.8 11.8-17.4 16.7-5.6-4.9-11.5-10.5-17.4-16.7C116.7 204.6 96 169.6 96 128zM160 0C89.3 0 32 57.3 32 128c0 52.4 21.5 95.5 46.8 128H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h96v160c0 17.7 14.3 32 32 32s32-14.3 32-32V320h96c17.7 0 32-14.3 32-32s-14.3-32-32-32h-46.8c25.4-32.5 46.8-75.6 46.8-128C288 57.3 230.7 0 160 0z"
        }
    ]
};

const FasApartment = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasApartment",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 0c-26.5 0-48 21.5-48 48v48H48c-26.5 0-48 21.5-48 48v320c0 26.5 21.5 48 48 48h208v-96c0-17.7 14.3-32 32-32s32 14.3 32 32v96h208c26.5 0 48-21.5 48-48V240c0-26.5-21.5-48-48-48h-80V48c0-26.5-21.5-48-48-48H176zm192 320h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16zm144 80c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32zm-400-80H80c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16zm16 80c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32zm112-80h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16zM384 80v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16zM240 64c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16h32zm144 144c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32zm112 112h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16zM128 208c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32zm112 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16z"
        }
    ]
};

const FasAperture = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasAperture",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 0c4 0 7.9.1 11.9.3 11.3.5 17.5 12.9 11.8 22.8L177.5 200c-6.2 10.7-21.6 10.7-27.7 0l-67-115.9c-3.6-6.3-2.6-14.3 2.9-19.2C130.9 24.5 190.6 0 256 0zM0 256c0-50.9 14.9-98.3 40.5-138.2 6.1-9.5 19.9-8.6 25.6 1.2l102.1 177c6.2 10.7-1.5 24-13.9 24H20.5c-7.3 0-13.7-4.9-15.2-12.1C1.8 291.2 0 273.8 0 256zm193.7 236c-3.6 6.3-11.1 9.4-18 7.1C111.8 478 59 432.5 28.5 373.6 23.3 363.5 31 352 42.3 352h204.5c12.3 0 20 13.3 13.9 24l-67 116zm62.3 20c-4 0-7.9-.1-11.9-.3-11.3-.5-17.5-12.9-11.8-22.8L334.5 312c6.2-10.7 21.6-10.7 27.7 0l66.9 115.9c3.6 6.3 2.6 14.3-2.9 19.2C381.1 487.5 321.4 512 256 512zm256-256c0 50.9-14.9 98.3-40.5 138.2-6.1 9.5-19.9 8.6-25.6-1.2L343.8 216c-6.2-10.7 1.5-24 13.9-24h133.8c7.3 0 13.7 4.9 15.2 12.1 3.5 16.8 5.3 34.1 5.3 51.9zM318.3 20c3.6-6.3 11.1-9.4 18-7.1C400.2 34 453 79.5 483.5 138.4c5.2 10.1-2.5 21.6-13.8 21.6H265.2c-12.3 0-20-13.3-13.9-24l67-116z"
        }
    ]
};

const FasApostrophe = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasApostrophe",
    "viewBox": "0 0 192 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M72 352c66.3 0 120-53.7 120-120V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v64c0 35.3 28.7 64 64 64h64v8c0 30.9-25.1 56-56 56h-8c-17.7 0-32 14.3-32 32s14.3 32 32 32h8z"
        }
    ]
};

const FasAppleCore = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasAppleCore",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 112c-8.8 0-16-7.2-16-16V80c0-44.2 35.8-80 80-80h16c8.8 0 16 7.2 16 16v16c0 44.2-35.8 80-80 80h-16zM30.5 167c-8-6.5-9.3-18.7-.7-24.3C43.9 133.4 60.7 128 80 128c27.3 0 59.7 10.3 82.7 19.3 18.8 7.3 39.9 7.3 58.7 0 22.9-8.9 55.4-19.3 82.7-19.3 19.3 0 36.1 5.4 50.3 14.7 8.6 5.6 7.3 17.9-.7 24.3-40 32.3-65.5 81.7-65.5 137 0 54.4 24.7 103 63.4 135.3 7 5.9 8.8 16.3 2.7 23.1-28.5 31.3-63.4 49.6-98.3 49.6-16.5 0-38.1-6.6-51.5-11.3-8.1-2.8-16.9-2.8-25 0-13.4 4.7-35 11.3-51.5 11.3-34.9 0-69.8-18.3-98.1-49.6-6.2-6.8-4.4-17.3 2.7-23.1C71.3 407 96 358.4 96 304c0-55.4-25.6-104.7-65.5-137z"
        }
    ]
};

const FasAppleWhole = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasAppleWhole",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 112c-8.8 0-16-7.2-16-16V80c0-44.2 35.8-80 80-80h16c8.8 0 16 7.2 16 16v16c0 44.2-35.8 80-80 80h-16zM0 288c0-76.3 35.7-160 112-160 27.3 0 59.7 10.3 82.7 19.3 18.8 7.3 39.9 7.3 58.7 0 22.9-8.9 55.4-19.3 82.7-19.3 76.3 0 112 83.7 112 160 0 128-80 224-160 224-16.5 0-38.1-6.6-51.5-11.3-8.1-2.8-16.9-2.8-25 0-13.4 4.7-35 11.3-51.5 11.3C80 512 0 416 0 288z"
        }
    ]
};

const FasArchway = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArchway",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 32C14.3 32 0 46.3 0 64s14.3 32 32 32h448c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zm0 384c-17.7 0-32 14.3-32 32s14.3 32 32 32h128V352c0-53 43-96 96-96s96 43 96 96v128h128c17.7 0 32-14.3 32-32s-14.3-32-32-32V128H32v288z"
        }
    ]
};

const FasArrowDown19 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowDown19",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M450.7 38c-8.3-6-19.1-7.7-28.8-4.4l-48 16c-16.8 5.6-25.8 23.7-20.2 40.5s23.7 25.8 40.5 20.2l5.9-2V160H384c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32h-16V64c0-10.3-4.9-19.9-13.3-26zM160 480c9 0 17.5-3.8 23.6-10.4l88-96c11.9-13 11.1-33.3-2-45.2s-33.3-11.1-45.2 2L192 365.7V64c0-17.7-14.3-32-32-32s-32 14.3-32 32v301.7l-32.4-35.3c-11.9-13-32.2-13.9-45.2-2s-13.9 32.2-2 45.2l88 96c6.1 6.6 14.6 10.4 23.6 10.4zm258.3-173a32 32 0 1 1 27.4 57.9 32 32 0 1 1-27.4-57.9zm-13.2 112.8-6.8 9.2c-10.5 14.2-7.5 34.2 6.7 44.8s34.2 7.5 44.8-6.7l48.8-65.8c14-18.9 21.5-41.7 21.5-65.2 0-48.6-39.4-88-88-88s-88 39.4-88 88c0 39.2 25.6 72.4 61.1 83.8z"
        }
    ]
};

const FasArrowDown91 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowDown91",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 480c9 0 17.5-3.8 23.6-10.4l88-96c11.9-13 11.1-33.3-2-45.2s-33.3-11.1-45.2 2L192 365.7V64c0-17.7-14.3-32-32-32s-32 14.3-32 32v301.7l-32.4-35.3c-11.9-13-32.2-13.9-45.2-2s-13.9 32.2-2 45.2l88 96c6.1 6.6 14.6 10.4 23.6 10.4zm290.7-186c-8.3-6-19.1-7.7-28.8-4.4l-48 16c-16.8 5.6-25.8 23.7-20.2 40.5s23.7 25.8 40.5 20.2l5.9-2V416H384c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32h-16v-96c0-10.3-4.9-19.9-13.3-26zM418.3 91a32 32 0 1 1 27.4 57.9A32 32 0 1 1 418.3 91zm-13.2 112.8-6.8 9.2c-10.5 14.2-7.5 34.2 6.7 44.8s34.2 7.5 44.8-6.7l48.8-65.8c14-18.9 21.5-41.7 21.5-65.2 0-48.6-39.4-88-88-88s-88 39.4-88 88c0 39.2 25.6 72.4 61.1 83.8z"
        }
    ]
};

const FasArrowDownAZ = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowDownAZ",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M183.6 469.6C177.5 476.2 169 480 160 480s-17.5-3.8-23.6-10.4l-88-96c-11.9-13-11.1-33.3 2-45.2s33.3-11.1 45.2 2l32.4 35.3V64c0-17.7 14.3-32 32-32s32 14.3 32 32v301.7l32.4-35.4c11.9-13 32.2-13.9 45.2-2s13.9 32.2 2 45.2l-88 96zM320 320c0-17.7 14.3-32 32-32h128c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9L429.3 416H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H352c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9l73.4-73.3H352c-17.7 0-32-14.3-32-32zm96-288c12.1 0 23.2 6.8 28.6 17.7l64 128 16 32c7.9 15.8 1.5 35-14.3 42.9s-35 1.5-42.9-14.3l-7.2-14.3h-88.4l-7.2 14.3c-7.9 15.8-27.1 22.2-42.9 14.3s-22.2-27.1-14.3-42.9l16-32 64-128C392.8 38.8 403.9 32 416 32zm-20.2 144h40.4L416 135.6 395.8 176z"
        }
    ]
};

const FasArrowDownArrowUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowDownArrowUp",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M182.6 470.6c-12.5 12.5-32.8 12.5-45.3 0l-96-96c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l41.4 41.4V64c0-17.7 14.3-32 32-32s32 14.3 32 32v306.7l41.4-41.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-96 96zm352-333.3c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L448 141.3V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V141.3l-41.4 41.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l96-96c12.5-12.5 32.8-12.5 45.3 0l96 96z"
        }
    ]
};

const FasArrowDownBigSmall = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowDownBigSmall",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 480c9 0 17.5-3.8 23.6-10.4l88-96c11.9-13 11.1-33.3-2-45.2s-33.3-11.1-45.2 2L192 365.7V64c0-17.7-14.3-32-32-32s-32 14.3-32 32v301.7l-32.4-35.3c-11.9-13-32.2-13.9-45.2-2s-13.9 32.2-2 45.2l88 96c6.1 6.6 14.6 10.4 23.6 10.4zm160-112v64c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48v-64c0-26.5-21.5-48-48-48h-64c-26.5 0-48 21.5-48 48zm48-336c-26.5 0-48 21.5-48 48v128c0 26.5 21.5 48 48 48h128c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H368z"
        }
    ]
};

const FasArrowDownFromArc = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowDownFromArc",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 64C150 64 64 150 64 256c0 17.7-14.3 32-32 32S0 273.7 0 256C0 114.6 114.6 0 256 0s256 114.6 256 256c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-106-86-192-192-192zM121.4 390.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l57.3 57.4V192c0-17.7 14.3-32 32-32s32 14.3 32 32v210.7l57.4-57.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-112 112c-12.5 12.5-32.8 12.5-45.3 0l-112-112z"
        }
    ]
};

const FasArrowDownFromDottedLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowDownFromDottedLine",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 96a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm96 0a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm128-32a32 32 0 1 1-64 0 32 32 0 1 1 64 0zm64 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm128-32a32 32 0 1 1-64 0 32 32 0 1 1 64 0zm-73.4 278.6-128 128c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l73.4 73.4V192c0-17.7 14.3-32 32-32s32 14.3 32 32v178.7l73.4-73.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3z"
        }
    ]
};

const FasArrowDownFromLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowDownFromLine",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M214.6 470.6c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l73.4 73.4V192c0-17.7 14.3-32 32-32s32 14.3 32 32v178.7l73.4-73.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-128 128zM32 96C14.3 96 0 81.7 0 64s14.3-32 32-32h320c17.7 0 32 14.3 32 32s-14.3 32-32 32H32z"
        }
    ]
};

const FasArrowDownLeftAndArrowUpRightToCenter = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowDownLeftAndArrowUpRightToCenter",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M502.6 54.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L336 130.7V80c0-17.7-14.3-32-32-32s-32 14.3-32 32v128c0 17.7 14.3 32 32 32h128c17.7 0 32-14.3 32-32s-14.3-32-32-32h-50.7L502.6 54.6zM80 272c-17.7 0-32 14.3-32 32s14.3 32 32 32h50.7L9.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L176 381.3V432c0 17.7 14.3 32 32 32s32-14.3 32-32V304c0-17.7-14.3-32-32-32H80z"
        }
    ]
};

const FasArrowDownLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowDownLeft",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 384c0 17.7 14.3 32 32 32h224c17.7 0 32-14.3 32-32s-14.3-32-32-32H141.3l201.3-201.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L96 306.7V160c0-17.7-14.3-32-32-32s-32 14.3-32 32v224z"
        }
    ]
};

const FasArrowDownLong = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowDownLong",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M169.4 502.6c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 402.7V32c0-17.7-14.3-32-32-32s-32 14.3-32 32v370.7l-73.4-73.3c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128z"
        }
    ]
};

const FasArrowDownRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowDownRight",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 416c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32s-32 14.3-32 32v146.7L86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L242.7 352H96c-17.7 0-32 14.3-32 32s14.3 32 32 32h224z"
        }
    ]
};

const FasArrowDownShortWide = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowDownShortWide",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M151.6 469.6C145.5 476.2 137 480 128 480s-17.5-3.8-23.6-10.4l-88-96c-11.9-13-11.1-33.3 2-45.2s33.3-11.1 45.2 2L96 365.7V64c0-17.7 14.3-32 32-32s32 14.3 32 32v301.7l32.4-35.4c11.9-13 32.2-13.9 45.2-2s13.9 32.2 2 45.2l-88 96zM320 32h32c17.7 0 32 14.3 32 32s-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 128h96c17.7 0 32 14.3 32 32s-14.3 32-32 32h-96c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 128h160c17.7 0 32 14.3 32 32s-14.3 32-32 32H320c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 128h224c17.7 0 32 14.3 32 32s-14.3 32-32 32H320c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
        }
    ]
};

const FasArrowDownSmallBig = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowDownSmallBig",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 480c9 0 17.5-3.8 23.6-10.4l88-96c11.9-13 11.1-33.3-2-45.2s-33.3-11.1-45.2 2L192 365.7V64c0-17.7-14.3-32-32-32s-32 14.3-32 32v301.7l-32.4-35.3c-11.9-13-32.2-13.9-45.2-2s-13.9 32.2-2 45.2l88 96c6.1 6.6 14.6 10.4 23.6 10.4zM320 80v64c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48h-64c-26.5 0-48 21.5-48 48zm48 176c-26.5 0-48 21.5-48 48v128c0 26.5 21.5 48 48 48h128c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48H368z"
        }
    ]
};

const FasArrowDownSquareTriangle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowDownSquareTriangle",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M183.6 469.6C177.5 476.2 169 480 160 480s-17.5-3.8-23.6-10.4l-88-96c-11.9-13-11.1-33.3 2-45.2s33.3-11.1 45.2 2l32.4 35.3V64c0-17.7 14.3-32 32-32s32 14.3 32 32v301.7l32.4-35.4c11.9-13 32.2-13.9 45.2-2s13.9 32.2 2 45.2l-88 96zM320 72c0-22.1 17.9-40 40-40h112c22.1 0 40 17.9 40 40v112c0 22.1-17.9 40-40 40H360c-22.1 0-40-17.9-40-40V72zm123.1 231 80 128c6.2 9.9 6.5 22.3.9 32.5S507.6 480 496 480H336c-11.6 0-22.3-6.3-28-16.5s-5.3-22.6.9-32.5l80-128c5.8-9.4 16.1-15 27.1-15s21.3 5.7 27.1 15z"
        }
    ]
};

const FasArrowDownToArc = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowDownToArc",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 448c106 0 192-86 192-192 0-17.7 14.3-32 32-32s32 14.3 32 32c0 141.4-114.6 256-256 256S0 397.4 0 256c0-17.7 14.3-32 32-32s32 14.3 32 32c0 106 86 192 192 192zm134.6-217.4-112 112c-12.5 12.5-32.8 12.5-45.3 0l-112-112c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l57.4 57.4V32c0-17.7 14.3-32 32-32s32 14.3 32 32v210.7l57.4-57.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3z"
        }
    ]
};

const FasArrowDownToBracket = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowDownToBracket",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m374.6 214.6-128 128c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l73.4 73.4V32c0-17.7 14.3-32 32-32s32 14.3 32 32v210.7l73.4-73.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3zM64 352v64c0 17.7 14.3 32 32 32h256c17.7 0 32-14.3 32-32v-64c0-17.7 14.3-32 32-32s32 14.3 32 32v64c0 53-43 96-96 96H96c-53 0-96-43-96-96v-64c0-17.7 14.3-32 32-32s32 14.3 32 32z"
        }
    ]
};

const FasArrowDownToDottedLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowDownToDottedLine",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m374.6 214.6-128 128c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l73.4 73.4V64c0-17.7 14.3-32 32-32s32 14.3 32 32v178.7l73.4-73.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3zM32 480a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm96 0a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm96-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 64a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm128-32a32 32 0 1 1-64 0 32 32 0 1 1 64 0z"
        }
    ]
};

const FasArrowDownToLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowDownToLine",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 480c-17.7 0-32-14.3-32-32s14.3-32 32-32h320c17.7 0 32 14.3 32 32s-14.3 32-32 32H32zm182.6-137.4c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l73.4 73.4V64c0-17.7 14.3-32 32-32s32 14.3 32 32v178.7l73.4-73.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-128 128z"
        }
    ]
};

const FasArrowDownToSquare = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowDownToSquare",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M374.6 246.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 242.7V32c0-17.7-14.3-32-32-32s-32 14.3-32 32v210.7l-41.4-41.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0l96-96zM80 32C35.8 32 0 67.8 0 112v320c0 44.2 35.8 80 80 80h352c44.2 0 80-35.8 80-80V112c0-44.2-35.8-80-80-80h-32c-17.7 0-32 14.3-32 32s14.3 32 32 32h32c8.8 0 16 7.2 16 16v320c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H80z"
        }
    ]
};

const FasArrowDownTriangleSquare = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowDownTriangleSquare",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M183.6 469.6C177.5 476.2 169 480 160 480s-17.5-3.8-23.6-10.4l-88-96c-11.9-13-11.1-33.3 2-45.2s33.3-11.1 45.2 2l32.4 35.3V64c0-17.7 14.3-32 32-32s32 14.3 32 32v301.7l32.4-35.4c11.9-13 32.2-13.9 45.2-2s13.9 32.2 2 45.2l-88 96zM443.1 47l80 128c6.2 9.9 6.5 22.3.9 32.5S507.6 224 496 224H336c-11.6 0-22.3-6.3-28-16.5s-5.3-22.6.9-32.5l80-128c5.8-9.4 16.1-15 27.1-15s21.3 5.7 27.1 15zM320 336c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48h-96c-26.5 0-48-21.5-48-48v-96z"
        }
    ]
};

const FasArrowDownUpAcrossLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowDownUpAcrossLine",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M137.4 502.6c12.5 12.5 32.8 12.5 45.3 0l96-96c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 402.7V288h352c17.7 0 32-14.3 32-32s-14.3-32-32-32h-96V109.3l41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96c-12.5-12.5-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l41.3-41.4V224H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h96v114.7l-41.4-41.3c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96zM128 192h64V64c0-17.7-14.3-32-32-32s-32 14.3-32 32v128zm320 128h-64v128c0 17.7 14.3 32 32 32s32-14.3 32-32V320z"
        }
    ]
};

const FasArrowDownUpLock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowDownUpLock",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m150.6 502.6 96-96c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 402.7V288h256v-16c0-17.2 3.9-33.5 10.8-48H352V109.3l41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96c-6-6-14.1-9.4-22.6-9.4s-16.6 3.4-22.6 9.4l-96 96c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l41.2-41.4V224H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h64v114.7l-41.4-41.3c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0zM160 192V64c0-17.7-14.3-32-32-32S96 46.3 96 64v128h64zm128 128v128c0 17.7 14.3 32 32 32s32-14.3 32-32V320h-64zm240-80c17.7 0 32 14.3 32 32v48h-64v-48c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32v128c0 17.7 14.3 32 32 32h160c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32v-48c0-44.2-35.8-80-80-80s-80 35.8-80 80z"
        }
    ]
};

const FasArrowDownWideShort = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowDownWideShort",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M151.6 469.6C145.5 476.2 137 480 128 480s-17.5-3.8-23.6-10.4l-88-96c-11.9-13-11.1-33.3 2-45.2s33.3-11.1 45.2 2L96 365.7V64c0-17.7 14.3-32 32-32s32 14.3 32 32v301.7l32.4-35.4c11.9-13 32.2-13.9 45.2-2s13.9 32.2 2 45.2l-88 96zM320 480c-17.7 0-32-14.3-32-32s14.3-32 32-32h32c17.7 0 32 14.3 32 32s-14.3 32-32 32h-32zm0-128c-17.7 0-32-14.3-32-32s14.3-32 32-32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32h-96zm0-128c-17.7 0-32-14.3-32-32s14.3-32 32-32h160c17.7 0 32 14.3 32 32s-14.3 32-32 32H320zm0-128c-17.7 0-32-14.3-32-32s14.3-32 32-32h224c17.7 0 32 14.3 32 32s-14.3 32-32 32H320z"
        }
    ]
};

const FasArrowDownZA = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowDownZA",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M183.6 469.6C177.5 476.2 169 480 160 480s-17.5-3.8-23.6-10.4l-88-96c-11.9-13-11.1-33.3 2-45.2s33.3-11.1 45.2 2l32.4 35.3V64c0-17.7 14.3-32 32-32s32 14.3 32 32v301.7l32.4-35.4c11.9-13 32.2-13.9 45.2-2s13.9 32.2 2 45.2l-88 96zM320 64c0-17.7 14.3-32 32-32h128c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9L429.3 160H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H352c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9L402.7 96H352c-17.7 0-32-14.3-32-32zm96 192c12.1 0 23.2 6.8 28.6 17.7l64 128 16 32c7.9 15.8 1.5 35-14.3 42.9s-35 1.5-42.9-14.3l-7.2-14.3h-88.4l-7.2 14.3c-7.9 15.8-27.1 22.2-42.9 14.3s-22.2-27.1-14.3-42.9l16-32 64-128c5.4-10.8 16.5-17.7 28.6-17.7zm-20.2 144h40.4L416 359.6 395.8 400z"
        }
    ]
};

const FasArrowDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowDown",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M169.4 470.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 370.8V64c0-17.7-14.3-32-32-32s-32 14.3-32 32v306.7L54.6 265.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"
        }
    ]
};

const FasArrowLeftFromArc = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowLeftFromArc",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 256c0-106-86-192-192-192-17.7 0-32-14.3-32-32s14.3-32 32-32c141.4 0 256 114.6 256 256S397.4 512 256 512c-17.7 0-32-14.3-32-32s14.3-32 32-32c106 0 192-86 192-192zM121.4 121.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L109.3 224H320c17.7 0 32 14.3 32 32s-14.3 32-32 32H109.3l57.4 57.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-112-112c-12.5-12.5-12.5-32.8 0-45.3l112-112z"
        }
    ]
};

const FasArrowLeftFromLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowLeftFromLine",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 96c0-17.7 14.3-32 32-32s32 14.3 32 32v320c0 17.7-14.3 32-32 32s-32-14.3-32-32V96zM9.4 278.6c-12.5-12.5-12.5-32.8 0-45.3l128-128c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L109.3 224H288c17.7 0 32 14.3 32 32s-14.3 32-32 32H109.3l73.4 73.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-128-128z"
        }
    ]
};

const FasArrowLeftLongToLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowLeftLongToLine",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 96v320c0 17.7 14.3 32 32 32s32-14.3 32-32V96c0-17.7-14.3-32-32-32S0 78.3 0 96zm137.4 137.4c-12.5 12.5-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 288H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H237.3l73.4-73.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-128 128z"
        }
    ]
};

const FasArrowLeftLong = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowLeftLong",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 288H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H109.3l73.4-73.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-128 128z"
        }
    ]
};

const FasArrowLeftToArc = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowLeftToArc",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 256c0-106 86-192 192-192 17.7 0 32-14.3 32-32S273.7 0 256 0C114.6 0 0 114.6 0 256s114.6 256 256 256c17.7 0 32-14.3 32-32s-14.3-32-32-32c-106 0-192-86-192-192zm217.4-134.6-112 112c-12.5 12.5-12.5 32.8 0 45.3l112 112c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L269.3 288H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H269.3l57.4-57.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0z"
        }
    ]
};

const FasArrowLeftToLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowLeftToLine",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 96c0-17.7 14.3-32 32-32s32 14.3 32 32v320c0 17.7-14.3 32-32 32S0 433.7 0 416V96zm137.4 182.6c-12.5-12.5-12.5-32.8 0-45.3l128-128c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L237.3 224H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H237.3l73.4 73.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-128-128z"
        }
    ]
};

const FasArrowLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowLeft",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H109.3l105.3-105.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"
        }
    ]
};

const FasArrowPointer = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowPointer",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 55.2V426c0 12.2 9.9 22 22 22 6.3 0 12.4-2.7 16.6-7.5l82.6-94.5 58.1 116.3c7.9 15.8 27.1 22.2 42.9 14.3s22.2-27.1 14.3-42.9L179.8 320h118.1c12.2 0 22.1-9.9 22.1-22.1 0-6.3-2.7-12.3-7.4-16.5L38.6 37.9c-4.3-3.8-9.7-5.9-15.4-5.9C10.4 32 0 42.4 0 55.2z"
        }
    ]
};

const FasArrowProgress = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowProgress",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 128a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM128 32C57.3 32 0 89.3 0 160s57.3 128 128 128h256c35.3 0 64 28.7 64 64 0 27.9-17.9 51.7-42.8 60.4-11.5-17.1-31-28.4-53.2-28.4-35.3 0-64 28.7-64 64s28.7 64 64 64c24.7 0 46.1-14 56.8-34.4C467.6 466.1 512 414.2 512 352c0-70.7-57.3-128-128-128H128c-35.3 0-64-28.7-64-64s28.7-64 64-64h128v14.1c0 9.9 8 17.9 17.9 17.9 4 0 7.8-1.3 11-3.8l60.8-47.3c4-3.1 6.3-7.9 6.3-12.9s-2.3-9.8-6.3-12.9L284.8 3.8c-3.1-2.4-7-3.8-11-3.8C264 0 256 8 256 17.9V32H128zm-8.6 384c-11.1-19.1-31.7-32-55.4-32-35.3 0-64 28.7-64 64s28.7 64 64 64c23.7 0 44.4-12.9 55.4-32H160v14.1c0 9.9 8 17.9 17.9 17.9 4 0 7.8-1.3 11-3.8l60.8-47.3c4-3.1 6.3-7.9 6.3-12.9s-2.3-9.8-6.3-12.9l-60.8-47.3c-3.1-2.4-7-3.8-11-3.8-9.9 0-17.9 8-17.9 17.9V416h-40.6z"
        }
    ]
};

const FasArrowRightArrowLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowRightArrowLeft",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M438.6 150.6c12.5-12.5 12.5-32.8 0-45.3l-96-96c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.7 96H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h306.7l-41.4 41.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l96-96zm-333.3 352c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 416H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H109.3l41.4-41.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3l96 96z"
        }
    ]
};

const FasArrowRightFromArc = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowRightFromArc",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 256c0-106 86-192 192-192 17.7 0 32-14.3 32-32S273.7 0 256 0C114.6 0 0 114.6 0 256s114.6 256 256 256c17.7 0 32-14.3 32-32s-14.3-32-32-32c-106 0-192-86-192-192zm326.6-134.6c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l57.4 57.3H192c-17.7 0-32 14.3-32 32s14.3 32 32 32h210.7l-57.4 57.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l112-112c12.5-12.5 12.5-32.8 0-45.3l-112-112z"
        }
    ]
};

const FasArrowRightFromBracket = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowRightFromBracket",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M502.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l73.4 73.4H192c-17.7 0-32 14.3-32 32s14.3 32 32 32h210.7l-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128zM160 96c17.7 0 32-14.3 32-32s-14.3-32-32-32H96C43 32 0 75 0 128v256c0 53 43 96 96 96h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H96c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32h64z"
        }
    ]
};

const FasArrowRightFromLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowRightFromLine",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 96c0-17.7-14.3-32-32-32S0 78.3 0 96v320c0 17.7 14.3 32 32 32s32-14.3 32-32V96zm374.6 182.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l73.4 73.4H160c-17.7 0-32 14.3-32 32s14.3 32 32 32h178.7l-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128z"
        }
    ]
};

const FasArrowRightLongToLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowRightLongToLine",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M640 96v320c0 17.7-14.3 32-32 32s-32-14.3-32-32V96c0-17.7 14.3-32 32-32s32 14.3 32 32zM502.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-128 128c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l73.4-73.4H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h370.7l-73.4-73.4c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l128 128z"
        }
    ]
};

const FasArrowRightLong = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowRightLong",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M502.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l73.4 73.4H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h370.7l-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128z"
        }
    ]
};

const FasArrowRightToArc = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowRightToArc",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 256c0-106-86-192-192-192-17.7 0-32-14.3-32-32s14.3-32 32-32c141.4 0 256 114.6 256 256S397.4 512 256 512c-17.7 0-32-14.3-32-32s14.3-32 32-32c106 0 192-86 192-192zM230.6 121.4l112 112c12.5 12.5 12.5 32.8 0 45.3l-112 112c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l57.4-57.4H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h210.7l-57.4-57.4c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0z"
        }
    ]
};

const FasArrowRightToBracket = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowRightToBracket",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 96h64c17.7 0 32 14.3 32 32v256c0 17.7-14.3 32-32 32h-64c-17.7 0-32 14.3-32 32s14.3 32 32 32h64c53 0 96-43 96-96V128c0-53-43-96-96-96h-64c-17.7 0-32 14.3-32 32s14.3 32 32 32zm-9.4 182.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l73.4 73.4H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h210.7l-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128z"
        }
    ]
};

const FasArrowRightToCity = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowRightToCity",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 48c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v144h40v-72c0-13.3 10.7-24 24-24s24 10.7 24 24v72h24c26.5 0 48 21.5 48 48v224c0 26.5-21.5 48-48 48H336c-26.5 0-48-21.5-48-48V48zm64 32v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16zm16 80c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32zm-16 112v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16zm176-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32zm-16 112v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16zM166.6 153.4l80 80c12.5 12.5 12.5 32.8 0 45.3l-80 80c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l25.4-25.4H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h114.7l-25.4-25.4c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0z"
        }
    ]
};

const FasArrowRightToLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowRightToLine",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 96c0-17.7-14.3-32-32-32s-32 14.3-32 32v320c0 17.7 14.3 32 32 32s32-14.3 32-32V96zM310.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l73.4 73.4H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h178.7l-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128z"
        }
    ]
};

const FasArrowRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowRight",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h306.7L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z"
        }
    ]
};

const FasArrowRotateLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowRotateLeft",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M125.7 160H176c17.7 0 32 14.3 32 32s-14.3 32-32 32H48c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32s32 14.3 32 32v51.2l17.6-17.6c87.5-87.5 229.3-87.5 316.8 0s87.5 229.3 0 316.8-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3-163.8-62.5-226.3 0L125.7 160z"
        }
    ]
};

const FasArrowRotateRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowRotateRight",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M386.3 160H336c-17.7 0-32 14.3-32 32s14.3 32 32 32h128c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32s-32 14.3-32 32v51.2l-17.6-17.6c-87.5-87.5-229.3-87.5-316.8 0s-87.5 229.3 0 316.8 229.3 87.5 316.8 0c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0c-62.5 62.5-163.8 62.5-226.3 0s-62.5-163.8 0-226.3 163.8-62.5 226.3 0l17.2 17.2z"
        }
    ]
};

const FasArrowTrendDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowTrendDown",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 352c-17.7 0-32 14.3-32 32s14.3 32 32 32h160c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32s-32 14.3-32 32v82.7L342.6 137.4c-12.5-12.5-32.8-12.5-45.3 0L192 242.7 54.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0L320 205.3 466.7 352H384z"
        }
    ]
};

const FasArrowTrendUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowTrendUp",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 160c-17.7 0-32-14.3-32-32s14.3-32 32-32h160c17.7 0 32 14.3 32 32v160c0 17.7-14.3 32-32 32s-32-14.3-32-32v-82.7L342.6 374.6c-12.5 12.5-32.8 12.5-45.3 0L192 269.3 54.6 406.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l160-160c12.5-12.5 32.8-12.5 45.3 0L320 306.7 466.7 160H384z"
        }
    ]
};

const FasArrowTurnDownLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowTurnDownLeft",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 64c0-17.7 14.3-32 32-32s32 14.3 32 32v160c0 53-43 96-96 96H109.3l73.4 73.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3l128-128c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L109.3 256H416c17.7 0 32-14.3 32-32V64z"
        }
    ]
};

const FasArrowTurnDownRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowTurnDownRight",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64v160c0 53 43 96 96 96h306.7l-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l73.4 73.3H96c-17.7 0-32-14.3-32-32V64z"
        }
    ]
};

const FasArrowTurnDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowTurnDown",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 64C14.3 64 0 49.7 0 32S14.3 0 32 0h96c53 0 96 43 96 96v306.7l73.4-73.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-128 128c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l73.3 73.4V96c0-17.7-14.3-32-32-32H32z"
        }
    ]
};

const FasArrowTurnUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowTurnUp",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 448c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c53 0 96-43 96-96V109.3l73.4 73.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l73.3-73.4V416c0 17.7-14.3 32-32 32H32z"
        }
    ]
};

const FasArrowUp19 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowUp19",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M450.7 38C459 44 464 53.7 464 64v96h16c17.7 0 32 14.3 32 32s-14.3 32-32 32h-96c-17.7 0-32-14.3-32-32s14.3-32 32-32h16v-51.6l-5.9 2c-16.8 5.6-34.9-3.5-40.5-20.2s3.5-34.9 20.2-40.5l48-16c9.8-3.3 20.5-1.6 28.8 4.4zM160 32c9 0 17.5 3.8 23.6 10.4l88 96c11.9 13 11.1 33.3-2 45.2s-33.3 11.1-45.2-2L192 146.3V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V146.3l-32.4 35.3c-11.9 13-32.2 13.9-45.2 2s-13.9-32.2-2-45.2l88-96C142.5 35.8 151 32 160 32zm285.7 332.9a32 32 0 1 0-27.4-57.9 32 32 0 1 0 27.4 57.9zM405 419.8c-35.4-11.4-61-44.6-61-83.8 0-48.6 39.4-88 88-88s88 39.4 88 88c0 23.5-7.5 46.3-21.5 65.2L449.7 467c-10.5 14.2-30.6 17.2-44.8 6.7s-17.2-30.6-6.7-44.8l6.8-9.2z"
        }
    ]
};

const FasArrowUp91 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowUp91",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 32c9 0 17.5 3.8 23.6 10.4l88 96c11.9 13 11.1 33.3-2 45.2s-33.3 11.1-45.2-2L192 146.3V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V146.3l-32.4 35.3c-11.9 13-32.2 13.9-45.2 2s-13.9-32.2-2-45.2l88-96C142.5 35.8 151 32 160 32zm290.7 262c8.3 6 13.3 15.7 13.3 26v96h16c17.7 0 32 14.3 32 32s-14.3 32-32 32h-96c-17.7 0-32-14.3-32-32s14.3-32 32-32h16v-51.6l-5.9 2c-16.8 5.6-34.9-3.5-40.5-20.2s3.5-34.9 20.2-40.5l48-16c9.8-3.3 20.5-1.6 28.8 4.4zm-5-145.1A32 32 0 1 0 418.3 91a32 32 0 1 0 27.4 57.9zM405 203.8c-35.4-11.4-61-44.6-61-83.8 0-48.6 39.4-88 88-88s88 39.4 88 88c0 23.5-7.5 46.3-21.5 65.2L449.7 251c-10.5 14.2-30.6 17.2-44.8 6.7s-17.2-30.6-6.7-44.8l6.8-9.2z"
        }
    ]
};

const FasArrowUpAZ = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowUpAZ",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M183.6 42.4C177.5 35.8 169 32 160 32s-17.5 3.8-23.6 10.4l-88 96c-11.9 13-11.1 33.3 2 45.2s33.3 11.1 45.2-2l32.4-35.3V448c0 17.7 14.3 32 32 32s32-14.3 32-32V146.3l32.4 35.4c11.9 13 32.2 13.9 45.2 2s13.9-32.2 2-45.2l-88-96zM320 320c0 17.7 14.3 32 32 32h50.7l-73.4 73.4c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8h128c17.7 0 32-14.3 32-32s-14.3-32-32-32h-50.7l73.4-73.4c9.2-9.2 11.9-22.9 6.9-34.9S493 288 480 288H352c-17.7 0-32 14.3-32 32zm96-288c-12.1 0-23.2 6.8-28.6 17.7l-64 128-16 32c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3l7.2-14.3h88.4l7.2 14.3c7.9 15.8 27.1 22.2 42.9 14.3s22.2-27.1 14.3-42.9l-16-32-64-128C439.2 38.8 428.1 32 416 32zm-20.2 144 20.2-40.4 20.2 40.4h-40.4z"
        }
    ]
};

const FasArrowUpArrowDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowUpArrowDown",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M182.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l41.4-41.4V448c0 17.7 14.3 32 32 32s32-14.3 32-32V141.3l41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96zm352 333.3c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L448 370.7V64c0-17.7-14.3-32-32-32s-32 14.3-32 32v306.7l-41.4-41.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0l96-96z"
        }
    ]
};

const FasArrowUpBigSmall = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowUpBigSmall",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 32c9 0 17.5 3.8 23.6 10.4l88 96c11.9 13 11.1 33.3-2 45.2s-33.3 11.1-45.2-2L192 146.3V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V146.3l-32.4 35.3c-11.9 13-32.2 13.9-45.2 2s-13.9-32.2-2-45.2l88-96C142.5 35.8 151 32 160 32zm160 336c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48h-64c-26.5 0-48-21.5-48-48v-64zm48-336h128c26.5 0 48 21.5 48 48v128c0 26.5-21.5 48-48 48H368c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48z"
        }
    ]
};

const FasArrowUpFromArc = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowUpFromArc",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 448c-106 0-192-86-192-192 0-17.7-14.3-32-32-32S0 238.3 0 256c0 141.4 114.6 256 256 256s256-114.6 256-256c0-17.7-14.3-32-32-32s-32 14.3-32 32c0 106-86 192-192 192zM121.4 121.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l57.3-57.4V320c0 17.7 14.3 32 32 32s32-14.3 32-32V109.3l57.4 57.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-112-112c-12.5-12.5-32.8-12.5-45.3 0l-112 112z"
        }
    ]
};

const FasArrowUpFromBracket = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowUpFromBracket",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M246.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l73.4-73.4V320c0 17.7 14.3 32 32 32s32-14.3 32-32V109.3l73.4 73.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-128-128zM64 352c0-17.7-14.3-32-32-32S0 334.3 0 352v64c0 53 43 96 96 96h256c53 0 96-43 96-96v-64c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32v-64z"
        }
    ]
};

const FasArrowUpFromDottedLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowUpFromDottedLine",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M246.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l73.4-73.4V320c0 17.7 14.3 32 32 32s32-14.3 32-32V141.3l73.4 73.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-128-128zM32 416a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm96 0a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm128 32a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm64-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm64 32a32 32 0 1 0 64 0 32 32 0 1 0-64 0z"
        }
    ]
};

const FasArrowUpFromGroundWater = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowUpFromGroundWater",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 352c17.7 0 32-14.3 32-32V109.3l25.4 25.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-80-80c-12.5-12.5-32.8-12.5-45.3 0l-80 80c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l25.3-25.4V320c0 17.7 14.3 32 32 32zm-18.5 69.9C247 437.4 219.5 448 192 448c-26.9 0-55.3-10.8-77.4-26.1-11.9-8.5-28.1-7.8-39.2 1.7-14.4 11.9-32.5 21-50.6 25.2-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25 29 15.6 61.5 25.9 94.5 25.9 31.9 0 60.6-9.9 80.4-18.9 5.8-2.7 11.1-5.3 15.6-7.7 4.5 2.4 9.7 5.1 15.6 7.7 19.8 9 48.5 18.9 80.4 18.9 33 0 65.5-10.3 94.5-25.8 13.4 8.4 33.7 19.3 58.2 25 17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2-11.1-9.4-27.3-10.1-39.2-1.7-22 15.2-50.5 26-77.4 26-27.5 0-55-10.6-77.5-26.1-11.1-7.9-25.9-7.9-37 0zM192 192H48c-26.5 0-48 21.5-48 48v185c5.3-3.1 11.2-5.4 17.5-6.9 13.1-3.1 26.7-9.8 37.3-18.6 22.2-18.7 54.3-20.1 78.1-3.4 18 12.4 40.1 20.3 59.1 20.3V192zm384 48c0-26.5-21.5-48-48-48H384v224.5c19 0 41.2-7.9 59.2-20.3 23.8-16.7 55.8-15.3 78.1 3.4 10.6 8.8 24.2 15.6 37.3 18.6 6.3 1.5 12.1 3.8 17.5 6.9V240z"
        }
    ]
};

const FasArrowUpFromLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowUpFromLine",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M214.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l73.4-73.4V320c0 17.7 14.3 32 32 32s32-14.3 32-32V141.3l73.4 73.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-128-128zM32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32h320c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"
        }
    ]
};

const FasArrowUpFromSquare = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowUpFromSquare",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M278.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l41.4-41.4V320c0 17.7 14.3 32 32 32s32-14.3 32-32V109.3l41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96zM64 112c0-8.8 7.2-16 16-16h8c17.7 0 32-14.3 32-32s-14.3-32-32-32h-8C35.8 32 0 67.8 0 112v320c0 44.2 35.8 80 80 80h352c44.2 0 80-35.8 80-80V112c0-44.2-35.8-80-80-80h-8c-17.7 0-32 14.3-32 32s14.3 32 32 32h8c8.8 0 16 7.2 16 16v320c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112z"
        }
    ]
};

const FasArrowUpFromWaterPump = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowUpFromWaterPump",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M112 0C85.5 0 64 21.5 64 48v208H48c-26.5 0-48 21.5-48 48v96c0 8 2 15.6 5.4 22.2 3.8-1.7 7.8-3.1 12-4.1 13.1-3.1 26.7-9.8 37.3-18.6 22.2-18.7 54.3-20.1 78.1-3.4 18 12.4 40.1 20.3 59.2 20.3 21.1 0 42-8.5 59.2-20.3 22.1-15.5 51.6-15.5 73.7 0 18.4 12.7 39.6 20.3 59.2 20.3 19 0 41.2-7.9 59.2-20.3 23.8-16.7 55.8-15.3 78.1 3.4 10.6 8.8 24.2 15.6 37.3 18.6 4.2 1 8.2 2.4 12 4.1 3.3-6.6 5.3-14.2 5.3-22.2v-96c0-26.5-21.5-48-48-48h-48V109.3l25.4 25.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-80-80c-12.5-12.5-32.8-12.5-45.3 0l-80 80c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l25.3-25.4V256H288V48c0-26.5-21.5-48-48-48H112zm194.5 421.9c-11.1-7.9-25.9-7.9-37 0-22.5 15.5-50 26.1-77.5 26.1-26.9 0-55.3-10.8-77.4-26.1-11.9-8.5-28.1-7.8-39.2 1.7-14.4 11.9-32.5 21-50.6 25.2-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25 29 15.6 61.5 25.9 94.5 25.9 31.9 0 60.6-9.9 80.4-18.9 5.8-2.7 11.1-5.3 15.6-7.7 4.5 2.4 9.7 5.1 15.6 7.7 19.8 9 48.5 18.9 80.4 18.9 33 0 65.5-10.3 94.5-25.8 13.4 8.4 33.7 19.3 58.2 25 17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2-11.1-9.4-27.3-10.1-39.2-1.7-22 15.2-50.5 26-77.4 26-27.5 0-55-10.6-77.5-26.1z"
        }
    ]
};

const FasArrowUpLeftFromCircle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowUpLeftFromCircle",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 0H32C14.3 0 0 14.3 0 32v160c0 17.7 14.3 32 32 32s32-14.3 32-32v-82.7l233.4 233.3c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 64H192c17.7 0 32-14.3 32-32S209.7 0 192 0zm133.3 67.1c-17.4-2.9-33.9 8.8-36.9 26.3s8.8 33.9 26.3 36.9C390.4 142.9 448 208.8 448 288c0 88.4-71.6 160-160 160-79.2 0-145.1-57.6-157.8-133.3-2.9-17.4-19.4-29.2-36.9-26.3S64.1 307.8 67 325.3C84.9 431.3 177 512 288 512c123.7 0 224-100.3 224-224 0-111-80.7-203.1-186.7-220.9z"
        }
    ]
};

const FasArrowUpLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowUpLeft",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 96c-17.7 0-32 14.3-32 32v224c0 17.7 14.3 32 32 32s32-14.3 32-32V205.3l201.4 201.3c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L141.3 160H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H64z"
        }
    ]
};

const FasArrowUpLong = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowUpLong",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M214.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l73.4-73.4V480c0 17.7 14.3 32 32 32s32-14.3 32-32V109.3l73.4 73.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-128-128z"
        }
    ]
};

const FasArrowUpRightAndArrowDownLeftFromCenter = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowUpRightAndArrowDownLeftFromCenter",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h50.7L297.4 169.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L448 109.3V160c0 17.7 14.3 32 32 32s32-14.3 32-32V32c0-17.7-14.3-32-32-32H352zM214.6 297.4c-12.5-12.5-32.8-12.5-45.3 0L64 402.7V352c0-17.7-14.3-32-32-32S0 334.3 0 352v128c0 17.7 14.3 32 32 32h128c17.7 0 32-14.3 32-32s-14.3-32-32-32h-50.7l105.3-105.4c12.5-12.5 12.5-32.8 0-45.3z"
        }
    ]
};

const FasArrowUpRightDots = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowUpRightDots",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h50.7L9.4 265.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L256 109.3V160c0 17.7 14.3 32 32 32s32-14.3 32-32V32c0-17.7-14.3-32-32-32H160zm416 80a48 48 0 1 0-96 0 48 48 0 1 0 96 0zM448 208a48 48 0 1 0-96 0 48 48 0 1 0 96 0zm-48 176a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm48 80a48 48 0 1 0-96 0 48 48 0 1 0 96 0zm128 0a48 48 0 1 0-96 0 48 48 0 1 0 96 0zm-304-80a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm48 80a48 48 0 1 0-96 0 48 48 0 1 0 96 0zm-176 48a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm432-176a48 48 0 1 0-96 0 48 48 0 1 0 96 0zm-48-80a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
        }
    ]
};

const FasArrowUpRightFromSquare = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowUpRightFromSquare",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h82.7L201.4 265.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L448 109.3V192c0 17.7 14.3 32 32 32s32-14.3 32-32V32c0-17.7-14.3-32-32-32H320zM80 32C35.8 32 0 67.8 0 112v320c0 44.2 35.8 80 80 80h320c44.2 0 80-35.8 80-80V320c0-17.7-14.3-32-32-32s-32 14.3-32 32v112c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16h112c17.7 0 32-14.3 32-32s-14.3-32-32-32H80z"
        }
    ]
};

const FasArrowUpRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowUpRight",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 128c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32s14.3 32 32 32h146.7L41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L288 205.3V352c0 17.7 14.3 32 32 32s32-14.3 32-32V128z"
        }
    ]
};

const FasArrowUpShortWide = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowUpShortWide",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M151.6 42.4C145.5 35.8 137 32 128 32s-17.5 3.8-23.6 10.4l-88 96c-11.9 13-11.1 33.3 2 45.2s33.3 11.1 45.2-2L96 146.3V448c0 17.7 14.3 32 32 32s32-14.3 32-32V146.3l32.4 35.4c11.9 13 32.2 13.9 45.2 2s13.9-32.2 2-45.2l-88-96zM320 32c-17.7 0-32 14.3-32 32s14.3 32 32 32h32c17.7 0 32-14.3 32-32s-14.3-32-32-32h-32zm0 128c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32h-96zm0 128c-17.7 0-32 14.3-32 32s14.3 32 32 32h160c17.7 0 32-14.3 32-32s-14.3-32-32-32H320zm0 128c-17.7 0-32 14.3-32 32s14.3 32 32 32h224c17.7 0 32-14.3 32-32s-14.3-32-32-32H320z"
        }
    ]
};

const FasArrowUpSmallBig = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowUpSmallBig",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 32c9 0 17.5 3.8 23.6 10.4l88 96c11.9 13 11.1 33.3-2 45.2s-33.3 11.1-45.2-2L192 146.3V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V146.3l-32.4 35.3c-11.9 13-32.2 13.9-45.2 2s-13.9-32.2-2-45.2l88-96C142.5 35.8 151 32 160 32zm160 48c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48h-64c-26.5 0-48-21.5-48-48V80zm48 176h128c26.5 0 48 21.5 48 48v128c0 26.5-21.5 48-48 48H368c-26.5 0-48-21.5-48-48V304c0-26.5 21.5-48 48-48z"
        }
    ]
};

const FasArrowUpSquareTriangle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowUpSquareTriangle",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M183.6 42.4C177.5 35.8 169 32 160 32s-17.5 3.8-23.6 10.4l-88 96c-11.9 13-11.1 33.3 2 45.2s33.3 11.1 45.2-2l32.4-35.3V448c0 17.7 14.3 32 32 32s32-14.3 32-32V146.3l32.4 35.4c11.9 13 32.2 13.9 45.2 2s13.9-32.2 2-45.2l-88-96zM320 80v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48h-96c-26.5 0-48 21.5-48 48zm123.1 223c-5.8-9.4-16.1-15-27.1-15s-21.3 5.7-27.1 15l-80 128c-6.2 9.9-6.5 22.3-.9 32.5s16.4 16.5 28 16.5h160c11.6 0 22.3-6.3 28-16.5s5.3-22.6-.9-32.5l-80-128z"
        }
    ]
};

const FasArrowUpToArc = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowUpToArc",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 64c106 0 192 86 192 192 0 17.7 14.3 32 32 32s32-14.3 32-32C512 114.6 397.4 0 256 0S0 114.6 0 256c0 17.7 14.3 32 32 32s32-14.3 32-32c0-106 86-192 192-192zm134.6 217.4-112-112c-12.5-12.5-32.8-12.5-45.3 0l-112 112c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l57.4-57.4V480c0 17.7 14.3 32 32 32s32-14.3 32-32V269.3l57.4 57.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3z"
        }
    ]
};

const FasArrowUpToDottedLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowUpToDottedLine",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm96 0a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm64 32a32 32 0 1 0 64 0 32 32 0 1 0-64 0zm128-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm64 32a32 32 0 1 0 64 0 32 32 0 1 0-64 0zm-9.4 233.4-128-128c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l73.4-73.4V448c0 17.7 14.3 32 32 32s32-14.3 32-32V269.3l73.4 73.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3z"
        }
    ]
};

const FasArrowUpToLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowUpToLine",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 32C14.3 32 0 46.3 0 64s14.3 32 32 32h320c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zm182.6 137.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l73.4-73.4V448c0 17.7 14.3 32 32 32s32-14.3 32-32V269.3l73.4 73.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-128-128z"
        }
    ]
};

const FasArrowUpTriangleSquare = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowUpTriangleSquare",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M183.6 42.4C177.5 35.8 169 32 160 32s-17.5 3.8-23.6 10.4l-88 96c-11.9 13-11.1 33.3 2 45.2s33.3 11.1 45.2-2l32.4-35.3V448c0 17.7 14.3 32 32 32s32-14.3 32-32V146.3l32.4 35.4c11.9 13 32.2 13.9 45.2 2s13.9-32.2 2-45.2l-88-96zM443.1 47c-5.8-9.3-16.1-15-27.1-15s-21.3 5.7-27.1 15l-80 128c-6.2 9.9-6.5 22.3-.9 32.5s16.4 16.5 28 16.5h160c11.6 0 22.3-6.3 28-16.5s5.3-22.6-.9-32.5l-80-128zM320 336v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48v-96c0-26.5-21.5-48-48-48h-96c-26.5 0-48 21.5-48 48z"
        }
    ]
};

const FasArrowUpWideShort = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowUpWideShort",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M151.6 42.4C145.5 35.8 137 32 128 32s-17.5 3.8-23.6 10.4l-88 96c-11.9 13-11.1 33.3 2 45.2s33.3 11.1 45.2-2L96 146.3V448c0 17.7 14.3 32 32 32s32-14.3 32-32V146.3l32.4 35.4c11.9 13 32.2 13.9 45.2 2s13.9-32.2 2-45.2l-88-96zM320 480h32c17.7 0 32-14.3 32-32s-14.3-32-32-32h-32c-17.7 0-32 14.3-32 32s14.3 32 32 32zm0-128h96c17.7 0 32-14.3 32-32s-14.3-32-32-32h-96c-17.7 0-32 14.3-32 32s14.3 32 32 32zm0-128h160c17.7 0 32-14.3 32-32s-14.3-32-32-32H320c-17.7 0-32 14.3-32 32s14.3 32 32 32zm0-128h224c17.7 0 32-14.3 32-32s-14.3-32-32-32H320c-17.7 0-32 14.3-32 32s14.3 32 32 32z"
        }
    ]
};

const FasArrowUpZA = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowUpZA",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M183.6 42.4C177.5 35.8 169 32 160 32s-17.5 3.8-23.6 10.4l-88 96c-11.9 13-11.1 33.3 2 45.2s33.3 11.1 45.2-2l32.4-35.3V448c0 17.7 14.3 32 32 32s32-14.3 32-32V146.3l32.4 35.4c11.9 13 32.2 13.9 45.2 2s13.9-32.2 2-45.2l-88-96zM320 64c0 17.7 14.3 32 32 32h50.7l-73.4 73.4c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8h128c17.7 0 32-14.3 32-32s-14.3-32-32-32h-50.7l73.4-73.4c9.2-9.2 11.9-22.9 6.9-34.9S493 32 480 32H352c-17.7 0-32 14.3-32 32zm96 192c-12.1 0-23.2 6.8-28.6 17.7l-64 128-16 32c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3l7.2-14.3h88.4l7.2 14.3c7.9 15.8 27.1 22.2 42.9 14.3s22.2-27.1 14.3-42.9l-16-32-64-128c-5.4-10.9-16.5-17.7-28.6-17.7zm-20.2 144 20.2-40.4 20.2 40.4h-40.4z"
        }
    ]
};

const FasArrowUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowUp",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M214.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-160 160c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 141.2V448c0 17.7 14.3 32 32 32s32-14.3 32-32V141.2l105.4 105.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-160-160z"
        }
    ]
};

const FasArrowsCross = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowsCross",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M54.6 41.4c-12.5-12.5-32.8-12.5-45.3 0s-12.4 32.7.1 45.2l146.7 146.8 45.3-45.3L54.6 41.4zM338.7 416H288c-17.7 0-32 14.3-32 32s14.3 32 32 32h128c17.7 0 32-14.3 32-32V320c0-17.7-14.3-32-32-32s-32 14.3-32 32v50.7l-92.1-92.1-45.3 45.3 92.1 92.1zM288 32c-17.7 0-32 14.3-32 32s14.3 32 32 32h50.7L9.4 425.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L384 141.3V192c0 17.7 14.3 32 32 32s32-14.3 32-32V64c0-17.7-14.3-32-32-32H288z"
        }
    ]
};

const FasArrowsDownToLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowsDownToLine",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M544 416H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h512c17.7 0 32-14.3 32-32s-14.3-32-32-32zm22.6-137.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L480 274.7V64c0-17.7-14.3-32-32-32s-32 14.3-32 32v210.7l-41.4-41.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0l96-96zm-320-45.3c-12.5-12.5-32.8-12.5-45.3 0L160 274.7V64c0-17.7-14.3-32-32-32S96 46.3 96 64v210.7l-41.4-41.3c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0l96-96c12.5-12.5 12.5-32.8 0-45.3z"
        }
    ]
};

const FasArrowsDownToPeople = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowsDownToPeople",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 0c-13.3 0-24 10.7-24 24v118.1L97 119c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0l64-64c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-23 23V24c0-13.3-10.7-24-24-24zm216 200a40 40 0 1 0-80 0 40 40 0 1 0 80 0zm-176 96a40 40 0 1 0-80 0 40 40 0 1 0 80 0zm312 40a40 40 0 1 0 0-80 40 40 0 1 0 0 80zM200 441.5l26.9 49.9c6.3 11.7 20.8 16 32.5 9.8s16-20.8 9.8-32.5l-36.3-67.5c1.7-1.7 3.2-3.6 4.3-5.8l26.8-49.9V400c0 17.7 14.3 32 32 32h48c17.7 0 32-14.3 32-32v-54.5l26.9 49.9c1.2 2.2 2.6 4.1 4.3 5.8l-36.3 67.5c-6.3 11.7-1.9 26.2 9.8 32.5s26.2 1.9 32.5-9.8l26.8-49.9V480c0 17.7 14.3 32 32 32h48c17.7 0 32-14.3 32-32v-38.5l26.9 49.9c6.3 11.7 20.8 16 32.5 9.8s16-20.8 9.8-32.5l-37.9-70.3c-15.3-28.5-45.1-46.3-77.5-46.3h-19.6c-16.3 0-31.9 4.5-45.4 12.6l-33.6-62.3c-15.3-28.5-45.1-46.3-77.5-46.3h-19.5c-32.4 0-62.1 17.8-77.5 46.3l-33.6 62.3c-13.5-8.1-29.1-12.6-45.4-12.6h-19.5c-32.4 0-62.1 17.8-77.5 46.3l-37.8 70.2c-6.3 11.7-1.9 26.2 9.8 32.5s26.2 1.9 32.5-9.8L88 441.5V480c0 17.7 14.3 32 32 32h48c17.7 0 32-14.3 32-32v-38.5zM415 153l64 64c9.4 9.4 24.6 9.4 33.9 0l64-64c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-23 23V24c0-13.3-10.7-24-24-24s-24 10.7-24 24v118.1l-23-23c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9z"
        }
    ]
};

const FasArrowsFromDottedLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowsFromDottedLine",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M246.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8h32v32c0 17.7 14.3 32 32 32s32-14.3 32-32V128h32c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-64-64zM192 352v32h-32c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l64 64c12.5 12.5 32.8 12.5 45.3 0l64-64c9.2-9.2 11.9-22.9 6.9-34.9S300.9 384 287.9 384H256v-32c0-17.7-14.3-32-32-32s-32 14.3-32 32zM32 224a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm96 0a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm96 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm96-64a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm64 32a32 32 0 1 0 64 0 32 32 0 1 0-64 0z"
        }
    ]
};

const FasArrowsFromLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowsFromLine",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M246.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8h32v32c0 17.7 14.3 32 32 32s32-14.3 32-32V128h32c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-64-64zM192 352v32h-32c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l64 64c12.5 12.5 32.8 12.5 45.3 0l64-64c9.2-9.2 11.9-22.9 6.9-34.9S300.9 384 287.9 384H256v-32c0-17.7-14.3-32-32-32s-32 14.3-32 32zM32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32h384c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"
        }
    ]
};

const FasArrowsLeftRightToLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowsLeftRightToLine",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 64c17.7 0 32 14.3 32 32v320c0 17.7-14.3 32-32 32S0 433.7 0 416V96c0-17.7 14.3-32 32-32zm214.6 73.4c12.5 12.5 12.5 32.8 0 45.3L205.3 224h229.5l-41.4-41.4c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3l-96 96c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l41.3-41.3H205.2l41.4 41.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-96-96c-12.5-12.5-12.5-32.8 0-45.3l96-96c12.5-12.5 32.8-12.5 45.3 0zM640 96v320c0 17.7-14.3 32-32 32s-32-14.3-32-32V96c0-17.7 14.3-32 32-32s32 14.3 32 32z"
        }
    ]
};

const FasArrowsLeftRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowsLeftRight",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m406.6 374.6 96-96c12.5-12.5 12.5-32.8 0-45.3l-96-96c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l41.4 41.4H109.2l41.4-41.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 288h293.5l-41.4 41.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0z"
        }
    ]
};

const FasArrowsMaximize = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowsMaximize",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 32c-17.7 0-32 14.3-32 32s14.3 32 32 32h50.7L256 210.7 141.3 96H192c17.7 0 32-14.3 32-32s-14.3-32-32-32H64c-17.7 0-32 14.3-32 32v128c0 17.7 14.3 32 32 32s32-14.3 32-32v-50.7L210.7 256 96 370.7V320c0-17.7-14.3-32-32-32s-32 14.3-32 32v128c0 17.7 14.3 32 32 32h128c17.7 0 32-14.3 32-32s-14.3-32-32-32h-50.7L256 301.3 370.7 416H320c-17.7 0-32 14.3-32 32s14.3 32 32 32h128c17.7 0 32-14.3 32-32V320c0-17.7-14.3-32-32-32s-32 14.3-32 32v50.7L301.3 256 416 141.3V192c0 17.7 14.3 32 32 32s32-14.3 32-32V64c0-17.7-14.3-32-32-32H320z"
        }
    ]
};

const FasArrowsMinimize = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowsMinimize",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M9.4 9.4c12.5-12.5 32.7-12.5 45.2 0L160 114.7V64c0-17.7 14.3-32 32-32s32 14.3 32 32v128c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32s14.3-32 32-32h50.7L9.4 54.6C-3.1 42.1-3.1 21.9 9.4 9.4zm448 0c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L397.3 160H448c17.7 0 32 14.3 32 32s-14.3 32-32 32H320c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32s32 14.3 32 32v50.7L457.4 9.4zM32 320c0-17.7 14.3-32 32-32h128c17.7 0 32 14.3 32 32v128c0 17.7-14.3 32-32 32s-32-14.3-32-32v-50.7L54.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L114.7 352H64c-17.7 0-32-14.3-32-32zm256 0c0-17.7 14.3-32 32-32h128c17.7 0 32 14.3 32 32s-14.3 32-32 32h-50.7l105.3 105.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L352 397.3V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V320z"
        }
    ]
};

const FasArrowsRepeat1 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowsRepeat1",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M21.9 254.4c-16.8-5.6-25.8-23.8-20.3-40.5C25.1 143.5 91 96 165.2 96h173.5l-41.3-41.4c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l96 96c9.2 9.2 11.9 22.9 6.9 34.9S429 160 416 160H165.2c-46.7 0-88.1 29.9-102.8 74.1-5.6 16.8-23.7 25.8-40.5 20.2zm468.2 3.3c16.8 5.6 25.8 23.7 20.2 40.5C486.9 368.5 421 416 346.8 416H173.3l41.4 41.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-96-96c-9.2-9.2-11.9-22.9-6.9-34.9S83.1 352 96.1 352h250.7c46.7 0 88.1-29.9 102.8-74.1 5.6-16.8 23.7-25.8 40.5-20.2zM288 216v80c0 13.3-10.7 24-24 24s-24-10.7-24-24v-48c-10 0-19.4-6.4-22.8-16.4-4.2-12.6 2.6-26.2 15.2-30.4l24-8c7.3-2.4 15.4-1.2 21.6 3.3s10 11.8 10 19.5z"
        }
    ]
};

const FasArrowsRepeat = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowsRepeat",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M1.6 213.9c-5.6 16.8 3.5 34.9 20.2 40.5s34.9-3.5 40.5-20.2c14.8-44.3 56.2-74.2 102.9-74.2h173.5l-41.4 41.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l96-96c12.5-12.5 12.5-32.8 0-45.3l-96-96c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.7 96H165.2C91 96 25.1 143.5 1.6 213.9zm508.7 84.2c5.6-16.8-3.5-34.9-20.2-40.5s-34.9 3.5-40.5 20.2c-14.7 44.3-56.1 74.2-102.8 74.2H173.3l41.4-41.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L173.3 416h173.5c74.2 0 140.1-47.5 163.6-117.9z"
        }
    ]
};

const FasArrowsRetweet = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowsRetweet",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M150.6 73.4c-12.5-12.5-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L96 173.3V320c0 53 43 96 96 96h112c17.7 0 32-14.3 32-32s-14.3-32-32-32H192c-17.7 0-32-14.3-32-32V173.3l41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96zM336 96c-17.7 0-32 14.3-32 32s14.3 32 32 32h112c17.7 0 32 14.3 32 32v146.7l-41.4-41.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0l96-96c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L544 338.7V192c0-53-43-96-96-96H336z"
        }
    ]
};

const FasArrowsRotate = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowsRotate",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M105.1 202.6c7.7-21.8 20.2-42.3 37.8-59.8 62.5-62.5 163.8-62.5 226.3 0l17.1 17.2H336c-17.7 0-32 14.3-32 32s14.3 32 32 32h127.9c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32s-32 14.3-32 32v51.2l-17.5-17.6c-87.5-87.5-229.3-87.5-316.8 0-24.4 24.4-42 53.1-52.8 83.8-5.9 16.7 2.9 34.9 19.5 40.8s34.9-2.9 40.8-19.5zM39 289.3c-5 1.5-9.8 4.2-13.7 8.2-4 4-6.7 8.8-8.1 14-.3 1.2-.6 2.5-.8 3.8-.3 1.7-.4 3.4-.4 5.1V448c0 17.7 14.3 32 32 32s32-14.3 32-32v-51.1l17.6 17.5c87.5 87.4 229.3 87.4 316.7 0 24.4-24.4 42.1-53.1 52.9-83.7 5.9-16.7-2.9-34.9-19.5-40.8s-34.9 2.9-40.8 19.5c-7.7 21.8-20.2 42.3-37.8 59.8-62.5 62.5-163.8 62.5-226.3 0l-.1-.1-17.1-17.1H176c17.7 0 32-14.3 32-32s-14.3-32-32-32H48.4c-1.6 0-3.2.1-4.8.3s-3.1.5-4.6 1z"
        }
    ]
};

const FasArrowsSpin = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowsSpin",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 96c38.4 0 73.7 13.5 101.3 36.1l-32.6 32.6c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9h112c8.8 0 16-7.2 16-16V64c0-6.5-3.9-12.3-9.9-14.8s-12.9-1.1-17.4 3.5l-34 34C363.4 52.6 312.1 32 256 32c-10.9 0-21.5.8-32 2.3v64.9c10.3-2.1 21-3.2 32-3.2zm-123.9 58.7 32.6 32.6c4.6 4.6 11.5 5.9 17.4 3.5s9.9-8.3 9.9-14.8V64c0-8.8-7.2-16-16-16H64c-6.5 0-12.3 3.9-14.8 9.9s-1.1 12.9 3.5 17.4l34 34C52.6 148.6 32 199.9 32 256c0 10.9.8 21.5 2.3 32h64.9c-2.1-10.3-3.2-21-3.2-32 0-38.4 13.5-73.7 36.1-101.3zM477.7 224h-64.9c2.1 10.3 3.2 21 3.2 32 0 38.4-13.5 73.7-36.1 101.3l-32.6-32.6c-4.6-4.6-11.5-5.9-17.4-3.5s-9.9 8.3-9.9 14.8v112c0 8.8 7.2 16 16 16h112c6.5 0 12.3-3.9 14.8-9.9s1.1-12.9-3.5-17.4l-34-34C459.4 363.4 480 312.1 480 256c0-10.9-.8-21.5-2.3-32zM256 416c-38.4 0-73.7-13.5-101.3-36.1l32.6-32.6c4.6-4.6 5.9-11.5 3.5-17.4s-8.3-9.9-14.8-9.9H64c-8.8 0-16 7.2-16 16v112c0 6.5 3.9 12.3 9.9 14.8s12.9 1.1 17.4-3.5l34-34C148.6 459.4 199.9 480 256 480c10.9 0 21.5-.8 32-2.3v-64.9c-10.3 2.1-21 3.2-32 3.2z"
        }
    ]
};

const FasArrowsSplitUpAndLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowsSplitUpAndLeft",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M246.6 150.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l96-96c12.5-12.5 32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L352 109.3V384c0 35.3 28.7 64 64 64h64c17.7 0 32 14.3 32 32s-14.3 32-32 32h-64c-70.7 0-128-57.3-128-128 0-35.3-28.7-64-64-64H109.3l41.4 41.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-96-96c-12.5-12.5-12.5-32.8 0-45.3l96-96c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L109.3 256H224c23.3 0 45.2 6.2 64 17.1V109.3l-41.4 41.4z"
        }
    ]
};

const FasArrowsToCircle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowsToCircle",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M9.4 9.4c12.5-12.5 32.7-12.5 45.2 0L160 114.7V96c0-17.7 14.3-32 32-32s32 14.3 32 32v96c0 4.3-.9 8.5-2.4 12.2-1.6 3.7-3.8 7.3-6.9 10.3l-.1.1c-3.1 3-6.6 5.3-10.3 6.9-3.8 1.6-7.9 2.4-12.2 2.4H96c-17.7 0-32-14.3-32-32s14.3-32 32-32h18.7L9.4 54.6C-3.1 42.1-3.1 21.9 9.4 9.4zM256 256a64 64 0 1 1 128 0 64 64 0 1 1-128 0zm-141.3 96H96c-17.7 0-32-14.3-32-32s14.3-32 32-32h96.1c8.8 0 16.7 3.6 22.5 9.3l.1.1c3 3.1 5.3 6.6 6.9 10.3 1.6 3.8 2.4 7.9 2.4 12.2v96c0 17.7-14.3 32-32 32s-32-14.3-32-32v-18.6L54.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L114.7 352zM416 96c0-17.7 14.3-32 32-32s32 14.3 32 32v18.7L585.4 9.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L525.3 160H544c17.7 0 32 14.3 32 32s-14.3 32-32 32h-96c-8.8 0-16.8-3.6-22.6-9.3l-.1-.1c-3-3.1-5.3-6.6-6.9-10.3s-2.4-7.8-2.4-12.2V96zm109.3 256 105.3 105.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L480 397.3V416c0 17.7-14.3 32-32 32s-32-14.3-32-32v-96.1c0-4.3.9-8.4 2.4-12.2 1.6-3.8 3.9-7.3 6.9-10.4 5.8-5.8 13.7-9.3 22.5-9.4h96.1c17.7 0 32 14.3 32 32s-14.3 32-32 32h-18.6z"
        }
    ]
};

const FasArrowsToDot = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowsToDot",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 0c17.7 0 32 14.3 32 32v32h32c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-64 64c-12.5 12.5-32.8 12.5-45.3 0l-64-64c-9.2-9.2-11.9-22.9-6.9-34.9S179.1 64 192.1 64h32V32c0-17.7 14.3-32 32-32zm-86.6 393.4 64-64c12.5-12.5 32.8-12.5 45.3 0l64 64c9.2 9.2 11.9 22.9 6.9 34.9S333 448.1 320 448.1h-32v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448h-32c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9zM32 224h32v-32c0-12.9 7.8-24.6 19.8-29.6s25.7-2.2 34.9 6.9l64 64c12.5 12.5 12.5 32.8 0 45.3l-64 64c-9.2 9.2-22.9 11.9-34.9 6.9S64 332.9 64 319.9V288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32zm297.4 54.6c-12.5-12.5-12.5-32.8 0-45.3l64-64c9.2-9.2 22.9-11.9 34.9-6.9s19.8 16.6 19.8 29.6v32h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H448v32c0 12.9-7.8 24.6-19.8 29.6s-25.7 2.2-34.9-6.9l-64-64zM256 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FasArrowsToDottedLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowsToDottedLine",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32c0-17.7-14.3-32-32-32s-32 14.3-32 32v32h-32c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l64 64c12.5 12.5 32.8 12.5 45.3 0l64-64c9.2-9.2 11.9-22.9 6.9-34.9S300.9 64 287.9 64H256V32zm-54.6 297.4-64 64c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8h32v32c0 17.7 14.3 32 32 32s32-14.3 32-32V448h32c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-64-64c-12.5-12.5-32.8-12.5-45.3 0zM32 224a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm96 0a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm96 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm96-64a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm64 32a32 32 0 1 0 64 0 32 32 0 1 0-64 0z"
        }
    ]
};

const FasArrowsToEye = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowsToEye",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M15 15c9.4-9.3 24.6-9.3 34 0l63 63V40c0-13.3 10.7-24 24-24s24 10.7 24 24v96c0 13.3-10.7 24-24 24H40c-13.3 0-24-10.7-24-24s10.7-24 24-24h38.1L15 49c-9.3-9.4-9.3-24.6 0-34zm118.5 228.9C158.6 193.6 222.7 112 320 112s161.4 81.6 186.5 131.9c3.8 7.6 3.8 16.5 0 24.2C481.4 318.4 417.3 400 320 400s-161.4-81.6-186.5-131.9c-3.8-7.6-3.8-16.5 0-24.2zM320 320a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM591 15c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-63 63H600c13.3 0 24 10.7 24 24s-10.7 24-24 24h-96c-13.3 0-24-10.7-24-24V40c0-13.3 10.7-24 24-24s24 10.7 24 24v38.1l63-63zM15 497c-9.4-9.4-9.4-24.6 0-33.9l63-63H40c-13.3 0-24-10.7-24-24s10.7-24 24-24h96c13.3 0 24 10.7 24 24v96c0 13.3-10.7 24-24 24s-24-10.7-24-24v-38.2L49 497c-9.4 9.4-24.6 9.4-33.9 0zm576 0-63-63v38c0 13.3-10.7 24-24 24s-24-10.7-24-24v-96c0-13.3 10.7-24 24-24h96c13.3 0 24 10.7 24 24s-10.7 24-24 24h-38.1l63 63c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0z"
        }
    ]
};

const FasArrowsToLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowsToLine",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32c0-17.7-14.3-32-32-32s-32 14.3-32 32v32h-32c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l64 64c12.5 12.5 32.8 12.5 45.3 0l64-64c9.2-9.2 11.9-22.9 6.9-34.9S300.9 64 287.9 64H256V32zm-54.6 297.4-64 64c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8h32v32c0 17.7 14.3 32 32 32s32-14.3 32-32V448h32c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-64-64c-12.5-12.5-32.8-12.5-45.3 0zM32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32h384c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"
        }
    ]
};

const FasArrowsTurnRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowsTurnRight",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M297.4 9.4c12.5-12.5 32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3l-96 96c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l41.3-41.4H128c-35.3 0-64 28.7-64 64v32c0 17.7-14.3 32-32 32S0 273.7 0 256v-32C0 153.3 57.3 96 128 96h210.7l-41.3-41.4c-12.5-12.5-12.5-32.8 0-45.3zm-96 256c12.5-12.5 32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3l-96 96c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l41.3-41.4H96c-17.7 0-32 14.3-32 32v32c0 17.7-14.3 32-32 32S0 497.7 0 480v-32c0-53 43-96 96-96h146.7l-41.4-41.4c-12.5-12.5-12.5-32.8 0-45.3z"
        }
    ]
};

const FasArrowsTurnToDots = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowsTurnToDots",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M249.4 25.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L269.3 96H416c53 0 96 43 96 96v32c0 17.7-14.3 32-32 32s-32-14.3-32-32v-32c0-17.7-14.3-32-32-32H269.3l25.4 25.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-80-80c-12.5-12.5-12.5-32.8 0-45.3l80-80zm13.3 256 80 80c12.5 12.5 12.5 32.8 0 45.3l-80 80c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l25.3-25.4H96c-17.7 0-32 14.3-32 32v32c0 17.7-14.3 32-32 32S0 497.7 0 480v-32c0-53 43-96 96-96h146.7l-25.4-25.4c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0zM384 384a64 64 0 1 1 128 0 64 64 0 1 1-128 0zM64 192a64 64 0 1 1 0-128 64 64 0 1 1 0 128z"
        }
    ]
};

const FasArrowsUpDownLeftRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowsUpDownLeftRight",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M278.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l9.4-9.4V224H109.3l9.4-9.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-64 64c-12.5 12.5-12.5 32.8 0 45.3l64 64c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-9.4-9.4H224v114.8l-9.4-9.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l64 64c12.5 12.5 32.8 12.5 45.3 0l64-64c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-9.4 9.4V288h114.8l-9.4 9.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l64-64c12.5-12.5 12.5-32.8 0-45.3l-64-64c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l9.4 9.4H288V109.3l9.4 9.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-64-64z"
        }
    ]
};

const FasArrowsUpDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowsUpDown",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M182.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l41.4-41.4v293.4l-41.4-41.3c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0l96-96c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 402.7V109.3l41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96z"
        }
    ]
};

const FasArrowsUpToLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasArrowsUpToLine",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 96h512c17.7 0 32-14.3 32-32s-14.3-32-32-32H32C14.3 32 0 46.3 0 64s14.3 32 32 32zM9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L96 237.3V448c0 17.7 14.3 32 32 32s32-14.3 32-32V237.3l41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96c-12.5-12.5-32.8-12.5-45.3 0l-96 96zm320 45.3c12.5 12.5 32.8 12.5 45.3 0l41.3-41.4V448c0 17.7 14.3 32 32 32s32-14.3 32-32V237.3l41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96c-12.5-12.5-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3z"
        }
    ]
};

const FasAsterisk = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasAsterisk",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 32c17.7 0 32 14.3 32 32v135.5l111.5-66.9c15.2-9.1 34.8-4.2 43.9 11s4.2 34.8-11 43.9L254.2 256l114.3 68.6c15.2 9.1 20.1 28.7 11 43.9s-28.7 20.1-43.9 11l-111.6-67V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V312.5L48.5 379.4c-15.2 9.1-34.8 4.2-43.9-11s-4.2-34.8 11-43.9L129.8 256 15.5 187.4c-15.2-9.1-20.1-28.7-11-43.9s28.7-20.1 43.9-11l111.6 67V64c0-17.7 14.3-32 32-32z"
        }
    ]
};

const FasAt = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasAt",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 64C150 64 64 150 64 256s86 192 192 192c17.7 0 32 14.3 32 32s-14.3 32-32 32C114.6 512 0 397.4 0 256S114.6 0 256 0s256 114.6 256 256v32c0 53-43 96-96 96-29.3 0-55.6-13.2-73.2-33.9-22.8 21-53.3 33.9-86.8 33.9-70.7 0-128-57.3-128-128s57.3-128 128-128c27.9 0 53.7 8.9 74.7 24.1 5.7-5 13.1-8.1 21.3-8.1 17.7 0 32 14.3 32 32v112c0 17.7 14.3 32 32 32s32-14.3 32-32v-32c0-106-86-192-192-192zm64 192a64 64 0 1 0-128 0 64 64 0 1 0 128 0z"
        }
    ]
};

const FasAtomSimple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasAtomSimple",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M100.9 411.1c-1.3-1.3-12.4-16.8 3.3-64 3.5-10.4 8-21.4 13.6-32.9 11.6 14.2 24.3 28.3 38 41.9s27.7 26.4 41.9 38c-11.4 5.6-22.4 10.2-32.8 13.6-47.2 15.7-62.7 4.6-64 3.3zM153.7 256c13.5-18.3 29.3-36.8 47.4-54.9s36.6-33.9 54.9-47.4c18.3 13.5 36.8 29.3 54.9 47.4s33.9 36.6 47.4 54.9c-13.5 18.3-29.3 36.8-47.4 54.9s-36.6 33.9-54.9 47.4c-18.3-13.5-36.8-29.3-54.9-47.4s-33.9-36.6-47.4-54.9zm44.1-138.1c-14.2 11.6-28.3 24.3-41.9 38s-26.4 27.7-38 41.9c-5.6-11.4-10.2-22.4-13.6-32.8-15.7-47.2-4.6-62.7-3.3-64s16.8-12.4 64 3.3c10.4 3.5 21.4 8 32.8 13.6zM256 76.8C173.9 27.6 94.9 16.5 55.7 55.7S27.6 173.9 76.8 256c-49.2 82.1-60.3 161.1-21.1 200.3s118.2 28.1 200.3-21.1c82.1 49.2 161.1 60.3 200.3 21.1s28.1-118.2-21.1-200.3c49.2-82.1 60.3-161.1 21.1-200.3S338.1 27.6 256 76.8zm58.2 41.1c11.4-5.6 22.4-10.2 32.9-13.6 47.2-15.7 62.7-4.6 64-3.3s12.4 16.8-3.3 64c-3.5 10.4-8 21.4-13.6 32.8-11.6-14.2-24.3-28.3-38-41.9s-27.7-26.4-41.9-38zm79.9 196.3c5.6 11.4 10.2 22.4 13.6 32.9 15.7 47.2 4.6 62.7 3.3 64s-16.8 12.4-64-3.3c-10.4-3.5-21.4-8-32.9-13.6 14.2-11.6 28.3-24.3 41.9-38s26.4-27.7 38-41.9zM288 256a32 32 0 1 0-64 0 32 32 0 1 0 64 0z"
        }
    ]
};

const FasAtom = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasAtom",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 398.8c-11.8 5.1-23.4 9.7-34.9 13.5 16.7 33.8 31 35.7 34.9 35.7s18.1-1.9 34.9-35.7c-11.4-3.9-23.1-8.4-34.9-13.5zM446 256c33 45.2 44.3 90.9 23.6 128-20.2 36.3-62.5 49.3-115.2 43.2-22 52.1-55.6 84.8-98.4 84.8s-76.4-32.7-98.4-84.8c-52.7 6.1-95-6.8-115.2-43.2C21.7 346.9 33 301.2 66 256c-33-45.2-44.3-90.9-23.6-128 20.2-36.3 62.5-49.3 115.2-43.2C179.6 32.7 213.2 0 256 0s76.4 32.7 98.4 84.8c52.7-6.1 95 6.8 115.2 43.2 20.7 37.1 9.4 82.8-23.6 128zm-65.8 67.4c-1.7 14.2-3.9 28-6.7 41.2 31.8 1.4 38.6-8.7 40.2-11.7 2.3-4.2 7-17.9-11.9-48.1-6.8 6.3-14 12.5-21.6 18.6zm-6.7-175.9c2.8 13.1 5 26.9 6.7 41.2 7.6 6.1 14.8 12.3 21.6 18.6 18.9-30.2 14.2-44 11.9-48.1-1.6-2.9-8.4-13-40.2-11.7zm-82.6-47.8C274.1 65.9 259.9 64 256 64s-18.1 1.9-34.9 35.7c11.4 3.9 23.1 8.4 34.9 13.5 11.8-5.1 23.4-9.7 34.9-13.5zm-159 88.9c1.7-14.3 3.9-28 6.7-41.2-31.8-1.4-38.6 8.7-40.2 11.7-2.3 4.2-7 17.9 11.9 48.1 6.8-6.3 14-12.5 21.6-18.6zm-21.7 116.2C91.4 335 96 348.7 98.3 352.9c1.6 2.9 8.4 13 40.2 11.7-2.8-13.1-5-26.9-6.7-41.2-7.6-6.1-14.8-12.3-21.6-18.6zM336 256a80 80 0 1 0-160 0 80 80 0 1 0 160 0zm-80-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FasAudioDescriptionSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasAudioDescriptionSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-30-23.5c4.6-8.8 7.2-18.9 7.2-29.6V96c0-35.3-28.7-64-64-64H96c-6.7 0-13.1 1-19.2 2.9l-38-29.8zM336 238v-54c0-13.3 10.7-24 24-24h56c53 0 96 43 96 96 0 35.3-19 66.1-47.4 82.8l-44.6-35c24.7-2 44.1-22.7 44.1-47.8 0-26.5-21.5-48-48-48H384v67.7L336 238zm151.4 242L314.3 343.6c-2 2.4-4.6 4.4-7.5 5.9-11.9 5.9-26.3 1.1-32.2-10.7l-9.4-18.9h-82.3l-9.4 18.9c-5.9 11.9-20.3 16.7-32.2 10.7s-16.7-20.3-10.7-32.2l42.5-85L32 121.2V416c0 35.3 28.7 64 64 64h391.4zm-254-200.2-21.8-17.2-8.6 17.2h30.4z"
        }
    ]
};

const FasAudioDescription = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasAudioDescription",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm149.5 141.3 72 144c5.9 11.9 1.1 26.3-10.7 32.2s-26.3 1.1-32.2-10.7l-9.4-18.9h-82.3l-9.4 18.9c-5.9 11.9-20.3 16.7-32.2 10.7s-16.7-20.3-10.7-32.2l72-144c4.1-8.1 12.4-13.3 21.5-13.3s17.4 5.1 21.5 13.3zm-.4 106.6L192 237.7l-21.1 42.2h42.2zM304 184c0-13.3 10.7-24 24-24h56c53 0 96 43 96 96s-43 96-96 96h-56c-13.3 0-24-10.7-24-24V184zm48 24v96h32c26.5 0 48-21.5 48-48s-21.5-48-48-48h-32z"
        }
    ]
};

const FasAustralSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasAustralSign",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M253.5 51.7C248.6 39.8 236.9 32 224 32s-24.6 7.8-29.5 19.7L122.7 224H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h64l-13.3 32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h24l-21.5 51.7c-6.8 16.3.9 35 17.2 41.8s35-.9 41.8-17.2l31.8-76.3h197.4l31.8 76.3c6.8 16.3 25.5 24 41.8 17.2s24-25.5 17.2-41.8L392 384h24c17.7 0 32-14.3 32-32s-14.3-32-32-32h-50.7L352 288h64c17.7 0 32-14.3 32-32s-14.3-32-32-32h-90.7L253.5 51.7zM256 224h-64l32-76.8 32 76.8zm-90.7 64h117.4l13.3 32H152l13.3-32z"
        }
    ]
};

const FasAvocado = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasAvocado",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M459.4 255.3c-18.5 15.2-33.5 35.6-38.1 59.1-10.2 51.9-34 104.5-66.3 136.7-81.2 81.2-212.9 81.2-294.2 0s-81.2-212.9 0-294.2c32.3-32.3 84.9-56.1 136.7-66.3C221 86 241.4 71 256.6 52.5 283.1 20.5 323.2 0 368 0c79.5 0 144 64.5 144 144 0 44.8-20.5 84.9-52.6 111.3zm-176.2 91.9c41.7-41.7 49.1-102.1 16.4-134.8s-93-25.3-134.8 16.4-49.1 102.1-16.4 134.8 93 25.3 134.8-16.4z"
        }
    ]
};

const FasAwardSimple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasAwardSimple",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M173.3 5.3c11.5-7 26-7 37.5 0l17.9 10.9c5.9 3.6 12.7 5.4 19.6 5.2l20.9-.5c13.5-.3 26 6.9 32.5 18.7l10 18.4c3.3 6.1 8.3 11 14.3 14.3l18.4 10c11.8 6.5 19.1 19 18.7 32.5l-.5 20.9c-.2 6.9 1.7 13.7 5.2 19.6l10.9 17.9c7 11.5 7 26 0 37.5l-10.9 17.9c-3.6 5.9-5.4 12.7-5.2 19.6l.5 20.9c.3 13.5-6.9 26-18.7 32.5l-18.4 10c-6.1 3.3-11 8.3-14.3 14.3l-10 18.4c-6.5 11.8-19 19.1-32.5 18.7l-20.9-.5c-6.9-.2-13.7 1.7-19.6 5.2l-17.9 10.9c-11.5 7-26 7-37.5 0l-17.9-10.9c-5.9-3.6-12.7-5.4-19.6-5.2l-20.9.5c-13.5.3-26-6.9-32.5-18.7l-10-18.3c-3.3-6.1-8.3-11-14.3-14.3l-18.4-10c-11.8-6.5-19.1-19-18.7-32.5l.5-20.9c.2-6.9-1.7-13.7-5.2-19.6l-11-18c-7-11.5-7-26 0-37.5l10.9-17.9c3.6-5.9 5.4-12.7 5.2-19.6l-.5-20.9c-.3-13.5 6.9-26 18.7-32.5L58 72.4c6.1-3.3 11-8.3 14.3-14.3l10-18.4c6.5-11.8 19-19.1 32.5-18.7l20.9.5c6.9.2 13.7-1.7 19.6-5.2l18-11zM272 192a80 80 0 1 0-160 0 80 80 0 1 0 160 0zM64.4 492.4 88 390c8.9 3.7 18.6 5.6 28.6 5.4l20.7-.5c.2 0 .4.1.6.2l17.6 10.7c22.4 13.6 50.5 13.6 72.9 0l17.7-10.8c.2-.1.4-.2.6-.2l20.7.5c10 .2 19.7-1.7 28.6-5.4l23.6 102.4c1.3 5.5-.5 11.3-4.6 15.2s-10 5.3-15.4 3.8L192 480.6 84.4 511.4c-5.4 1.6-11.3.1-15.4-3.8s-5.8-9.7-4.6-15.2z"
        }
    ]
};

const FasAward = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasAward",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M173.8 5.5c11-7.3 25.4-7.3 36.4 0L228 17.2c6 3.9 13 5.8 20.1 5.4l21.3-1.3c13.2-.8 25.6 6.4 31.5 18.2l9.6 19.1c3.2 6.4 8.4 11.5 14.7 14.7l19.3 9.7c11.8 5.9 19 18.3 18.2 31.5l-1.3 21.3c-.4 7.1 1.5 14.2 5.4 20.1l11.8 17.8c7.3 11 7.3 25.4 0 36.4L366.8 228c-3.9 6-5.8 13-5.4 20.1l1.3 21.3c.8 13.2-6.4 25.6-18.2 31.5l-19.1 9.6c-6.4 3.2-11.5 8.4-14.7 14.7l-9.7 19.3c-5.9 11.8-18.3 19-31.5 18.2l-21.3-1.3c-7.1-.4-14.2 1.5-20.1 5.4l-17.8 11.8c-11 7.3-25.4 7.3-36.4 0L156 366.8c-6-3.9-13-5.8-20.1-5.4l-21.3 1.3c-13.2.8-25.6-6.4-31.5-18.2l-9.6-19.1c-3.2-6.4-8.4-11.5-14.7-14.7L39.5 301c-11.8-5.9-19-18.3-18.2-31.5l1.3-21.3c.4-7.1-1.5-14.2-5.4-20.1L5.5 210.2c-7.3-11-7.3-25.4 0-36.4L17.2 156c3.9-6 5.8-13 5.4-20.1l-1.3-21.3c-.8-13.2 6.4-25.6 18.2-31.5l19.1-9.6C65 70.2 70.2 65 73.4 58.6L83 39.5c5.9-11.8 18.3-19 31.5-18.2l21.3 1.3c7.1.4 14.2-1.5 20.1-5.4l17.9-11.7zM272 192a80 80 0 1 0-160 0 80 80 0 1 0 160 0zM1.3 441.8l43.1-102.5c.2.1.3.2.4.4l9.6 19.1c11.7 23.2 36 37.3 62 35.8l21.3-1.3c.2 0 .5 0 .7.2l17.8 11.8c5.1 3.3 10.5 5.9 16.1 7.7l-37.6 89.3c-2.3 5.5-7.4 9.2-13.3 9.7s-11.6-2.2-14.8-7.2l-32.2-49.3-56.1 8.3c-5.7.8-11.4-1.5-15-6s-4.3-10.7-2.1-16zm248 60.4L211.7 413c5.6-1.8 11-4.3 16.1-7.7l17.8-11.8c.2-.1.4-.2.7-.2l21.3 1.3c26 1.5 50.3-12.6 62-35.8l9.6-19.1c.1-.2.2-.3.4-.4l43.2 102.5c2.2 5.3 1.4 11.4-2.1 16s-9.3 6.9-15 6l-56.1-8.3-32.2 49.2c-3.2 5-8.9 7.7-14.8 7.2s-11-4.3-13.3-9.7z"
        }
    ]
};

const FasAxeBattle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasAxeBattle",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M95.9 14v.1c0 .1.1.4.1.7.1.7.3 1.8.6 3.3.6 3 1.7 7.4 3.5 12.8 3.6 10.8 9.9 25.1 20.6 39.5 13.9 18.6 36 37.9 71.2 48.8v147.6c-29.9 11.1-50.9 29.3-65.6 47.3-11.9 14.6-19.7 29.3-24.5 40.3-2.4 5.5-4 10-5.1 13.1-.5 1.5-.9 2.7-1.1 3.5l-.2.8v.1c-1.5 5.8-6.1 10.3-11.9 11.7s-12-.7-15.8-5.3L80 368l-12.2 10.3-.1-.1-.2-.2-.6-.8c-.5-.7-1.3-1.6-2.3-2.9-1.9-2.5-4.6-6.1-7.7-10.6-6.3-9.2-14.7-22.4-23.1-38.9C17 291.9 0 245.3 0 192S17 92.1 33.7 59.3c8.4-16.5 16.8-29.7 23.1-38.9 3.2-4.6 5.8-8.2 7.7-10.6 1-1.2 1.7-2.2 2.3-2.9l.6-.8.2-.2.1-.1 12.2 10.3L67.8 5.7C71.9.8 78.5-1.1 84.6.7c6.1 1.8 10.5 7 11.3 13.3zM320 266.8V119.2c35.2-10.9 57.3-30.2 71.2-48.8C403.3 54.3 412.8 34 416.1 14c.8-6.3 5.3-11.5 11.3-13.3 6.1-1.8 12.8.3 16.9 5.2 13.3 16.3 24.4 34.8 33.9 53.4 12.4 24.5 25.1 56.6 30.7 93.4.5 3.5-1.4 7-4.7 8.4l-55.1 23.6c-6.5 2.8-6.5 11.9 0 14.7l55.2 23.6c3.3 1.4 5.3 4.8 4.7 8.4-8 53-31.3 105.5-64.5 146.6-3.9 4.6-10.3 7-16.1 5.6s-10.5-6-11.9-11.8c-5.9-21-17.2-40.9-30.9-57.7-14.7-18-35.7-36.2-65.6-47.3zM288 64v416c0 17.7-14.3 32-32 32s-32-14.3-32-32V64c0-17.7 14.3-32 32-32s32 14.3 32 32z"
        }
    ]
};

const FasAxe = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasAxe",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M374.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3L384 301.3V384c0 17.7 14.3 32 32 32 123.7 0 224-100.3 224-224 0-17.7-14.3-32-32-32h-82.7l-56-56 33.4-33.4c12.5-12.5 12.5-32.8 0-45.3l-16-16c-12.5-12.5-32.8-12.5-45.3 0L408 42.7 374.6 9.4zM448 316c45-11.6 80.4-47 92-92h32.8c-12.7 62.7-62.1 112.1-124.8 124.8V316zM244.1 206.6 9.4 441.4c-12.5 12.5-12.5 32.8 0 45.3l16 16c12.5 12.5 32.8 12.5 45.3 0l234.7-234.8-61.3-61.3z"
        }
    ]
};

const FasB = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasB",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h128c70.7 0 128-57.3 128-128 0-46.5-24.8-87.3-62-109.7 18.7-22.3 30-51 30-82.3 0-70.7-57.3-128-128-128H64zm96 192H64V96h96c35.3 0 64 28.7 64 64s-28.7 64-64 64zm-96 64h128c35.3 0 64 28.7 64 64s-28.7 64-64 64H64V288z"
        }
    ]
};

const FasBabyCarriage = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBabyCarriage",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 192H.1C2.7 117.9 41.3 52.9 99 14.1c13.3-8.9 30.8-4.3 39.9 8.8L256 192zm128-32c0-35.3 28.7-64 64-64h32c17.7 0 32 14.3 32 32s-14.3 32-32 32h-32v64c0 25.2-5.8 50.2-17 73.5s-27.8 44.5-48.6 62.3-45.5 32-72.7 41.6S253.4 416 224 416s-58.5-5-85.7-14.6-51.9-23.8-72.7-41.6-37.3-39-48.6-62.3S0 249.2 0 224h384v-64zM80 416a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm240 48a48 48 0 1 1 96 0 48 48 0 1 1-96 0z"
        }
    ]
};

const FasBaby = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBaby",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M152 88a72 72 0 1 1 144 0 72 72 0 1 1-144 0zM39.7 144.5c13-17.9 38-21.8 55.9-8.8l36.2 26.3c26.8 19.5 59.1 30 92.2 30s65.4-10.5 92.2-30l36.2-26.4c17.9-13 42.9-9 55.9 8.8s9 42.9-8.8 55.9l-36.2 26.4c-13.6 9.9-28.1 18.2-43.3 25V288H128v-36.3c-15.2-6.7-29.7-15.1-43.3-25l-36.2-26.4c-17.9-13-21.8-38-8.8-55.9zm89.8 184.8 60.6 53-26 37.2 24.3 24.3c15.6 15.6 15.6 40.9 0 56.6s-40.9 15.6-56.6 0l-48-48C70 438.6 68.1 417 79.2 401.1l50.2-71.8zm128.5 53 60.6-53 50.2 71.8c11.1 15.9 9.2 37.5-4.5 51.2l-48 48c-15.6 15.6-40.9 15.6-56.6 0s-15.6-40.9 0-56.6l24.3-24.3-26-37.2z"
        }
    ]
};

const FasBackpack = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBackpack",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 48h64c4.4 0 8 3.6 8 8v40h-80V56c0-4.4 3.6-8 8-8zm-56 8v40h-8C57.3 96 0 153.3 0 224v224c0 35.3 28.7 64 64 64V352c0-35.3 28.7-64 64-64h192c35.3 0 64 28.7 64 64v160c35.3 0 64-28.7 64-64V224c0-70.7-57.3-128-128-128h-8V56c0-30.9-25.1-56-56-56h-64c-30.9 0-56 25.1-56 56zm216 456v-96H96v96h256zM144 176h160c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16s7.2-16 16-16zm208 208v-32c0-17.7-14.3-32-32-32H128c-17.7 0-32 14.3-32 32v32h256z"
        }
    ]
};

const FasBackwardFast = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBackwardFast",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M493.6 445c-11.2 5.3-24.5 3.6-34.1-4.4L288 297.7V416c0 12.4-7.2 23.7-18.4 29s-24.5 3.6-34.1-4.4L64 297.7V416c0 17.7-14.3 32-32 32S0 433.7 0 416V96c0-17.7 14.3-32 32-32s32 14.3 32 32v118.3L235.5 71.4c9.5-7.9 22.8-9.7 34.1-4.4S288 83.6 288 96v118.3L459.5 71.4c9.5-7.9 22.8-9.7 34.1-4.4S512 83.6 512 96v320c0 12.4-7.2 23.7-18.4 29z"
        }
    ]
};

const FasBackwardStep = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBackwardStep",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M267.5 440.6c9.5 7.9 22.8 9.7 34.1 4.4s18.4-16.6 18.4-29V96c0-12.4-7.2-23.7-18.4-29s-24.5-3.6-34.1 4.4l-192 160L64 241V96c0-17.7-14.3-32-32-32S0 78.3 0 96v320c0 17.7 14.3 32 32 32s32-14.3 32-32V271l11.5 9.6 192 160z"
        }
    ]
};

const FasBackward = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBackward",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M459.5 440.6c9.5 7.9 22.8 9.7 34.1 4.4s18.4-16.6 18.4-29V96c0-12.4-7.2-23.7-18.4-29s-24.5-3.6-34.1 4.4L288 214.3v83.4l171.5 142.9zM256 352V96c0-12.4-7.2-23.7-18.4-29s-24.5-3.6-34.1 4.4l-192 160C4.2 237.5 0 246.5 0 256s4.2 18.5 11.5 24.6l192 160c9.5 7.9 22.8 9.7 34.1 4.4s18.4-16.6 18.4-29v-64z"
        }
    ]
};

const FasBacon = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBacon",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M439.2 1.2c11.2-3.2 23.2-.1 31.4 8.1L518 56.7l-26.5 7.9c-58 16.6-98.1 39.6-129.6 67.4-31.2 27.5-53.2 59.1-75.1 90.9l-2.3 3.3C241.6 288.7 195 356.6 72.8 417.7l-34.9 17.5-28.5-28.6c-7.3-7.3-10.6-17.6-9-27.8s8.1-18.9 17.3-23.5c118.4-59.1 163.2-124.3 205.6-186l2.3-3.4c21.8-31.8 44.9-64.9 77.7-93.9 33.4-29.5 75.8-53.6 135.9-70.8zM61.8 459l25.4-12.7c129.5-64.7 179.9-138.1 223.8-202l2.2-3.3c22.1-32.1 42.1-60.5 69.9-85.1 27.5-24.3 63.4-45.2 117.3-60.6l.2-.1 43.1-12.9 23 23c8 8 11.2 19.7 8.3 30.7s-11.3 19.6-22.2 22.7c-51.9 14.8-85.6 34.7-111.1 57.2-26.1 23-45.1 49.9-67.3 82.1l-2.2 3.2c-44.4 64.7-96.7 140.8-229.9 207.4-12.3 6.2-27.2 3.7-36.9-6L61.8 459z"
        }
    ]
};

const FasBacteria = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBacteria",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M304.9.7c-9.6-2.7-19.5 2.8-22.3 12.4l-4.3 15.2c-8.3-.6-16.8 0-25.2 1.9-7.3 1.7-14.3 3.5-21.1 5.5L226.5 23c-3.9-9.1-14.5-13.4-23.6-9.5s-13.4 14.5-9.5 23.6l4.4 10.4c-16.6 6.7-31.7 14.4-45.4 22.8L147 62c-5.5-8.3-16.7-10.5-25-5s-10.5 16.7-5 25l6 9c-13.7 11-25.5 22.8-35.8 34.9l-10-8c-7.8-6.2-19.1-5-25.3 2.8s-5 19.1 2.8 25.3l11.2 9c-1.8 2.8-3.5 5.7-5.1 8.5-6.6 11.4-11.8 22.6-16 33l-8-3.2c-9.2-3.7-19.7.8-23.4 10s.8 19.7 10 23.4l10.4 4.2c-.2.8-.4 1.5-.5 2.3-2.2 9.3-3.4 17.3-4.1 23.4-.4 3.1-.6 5.7-.8 7.8-.1 1.1-.1 2-.2 2.8l-.1 1.1v.8s0 .1 29.1 1h-.1l-29.1-.8c-.1 3.1 0 6.1.2 9.1L13 282.7C3.5 285.4-2 295.4.7 304.9S13.4 320 23 317.3l15.6-4.5c7.6 13.6 18.9 25 32.6 32.6L66.7 361c-2.7 9.6 2.8 19.5 12.4 22.3s19.5-2.8 22.3-12.4l4.3-15.2c1.2.1 2.4.2 3.6.2 15.6.5 30.3-3.3 43-10.2l9 9c7 7 18.4 7 25.5 0s7-18.4 0-25.5l-7.2-7.2c9.3-12.6 15.2-27.8 16.3-44.5l7.1 3c9.1 3.9 19.7-.3 23.6-9.5s-.3-19.7-9.5-23.6l-8.6-3.7c6.4-9.9 17.3-22.4 36.9-33.3l1.3 4.4c2.7 9.6 12.7 15.1 22.3 12.4s15.1-12.7 12.4-22.3l-2.3-8.1c3.8-1.1 7.7-2.1 11.9-3.1 11.6-2.7 22.1-7.7 31.1-14.4l7.2 7.2c7 7 18.4 7 25.5 0s7-18.4 0-25.5l-9-9c7.6-13.9 11.3-30.1 10.1-46.6l15.2-4.3c9.6-2.7 15.1-12.7 12.4-22.3S370.6 64 361 66.7l-15.6 4.5c-7.7-13.9-19.1-25.1-32.6-32.6l4.5-15.6c2.7-9.6-2.8-19.5-12.4-22.3zM112 272l-48-1.5c11.7.4 27.3.9 48 1.6zm16-80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64-48a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm130.7 345c-2.7 9.6 2.8 19.5 12.4 22.3s19.5-2.8 22.2-12.4l4.3-15.2c8.3.6 16.8 0 25.2-1.9 7.3-1.7 14.3-3.5 21.1-5.5l5.5 12.7c3.9 9.1 14.5 13.4 23.6 9.5s13.4-14.5 9.5-23.6l-4.4-10.4c16.6-6.7 31.7-14.4 45.4-22.8l5.5 8.3c5.5 8.3 16.7 10.5 25 5s10.5-16.7 5-25l-6-9c13.7-11 25.5-22.8 35.8-34.9l10 8c7.8 6.2 19.1 5 25.3-2.8s5-19.1-2.8-25.3l-11.2-9c1.8-2.8 3.5-5.7 5.1-8.5 6.6-11.4 11.8-22.6 16-33l8 3.2c9.2 3.7 19.7-.8 23.4-10s-.8-19.7-10-23.4l-10.4-4.2c.2-.8.4-1.5.5-2.3 2.2-9.3 3.4-17.3 4.1-23.4.4-3.1.6-5.7.8-7.8.1-1.1.1-2 .2-2.8l.1-1.1v-.8s0-.1-29.1-1h.1l29.1.9c.1-3.1 0-6.1-.2-9.1l15.2-4.3c9.6-2.7 15.1-12.7 12.4-22.3s-12.7-15.1-22.3-12.4l-15.6 4.5c-7.6-13.6-18.9-25-32.6-32.6l4.5-15.6c2.7-9.6-2.8-19.5-12.4-22.3s-19.5 2.8-22.3 12.4l-4.3 15.2c-1.2-.1-2.4-.2-3.6-.2-15.6-.5-30.3 3.3-43 10.2l-9-9c-7-7-18.4-7-25.5 0s-7 18.4 0 25.5l7.2 7.2c-9.3 12.6-15.2 27.8-16.3 44.5l-7.1-3c-9.1-3.9-19.7.3-23.6 9.5s.3 19.7 9.5 23.6l8.6 3.7c-6.4 9.9-17.3 22.4-36.9 33.3l-1.3-4.4c-2.7-9.6-12.7-15.1-22.3-12.4s-15.1 12.7-12.4 22.3l2.3 8.1c-3.8 1.1-7.7 2.1-11.9 3.1-11.6 2.7-22.1 7.7-31.1 14.4l-7.2-7.2c-7-7-18.4-7-25.5 0s-7 18.4 0 25.5l9 9c-7.6 13.9-11.3 30.1-10.1 46.6l-15.2 4.3c-9.6 2.7-15.1 12.7-12.4 22.2s12.7 15.1 22.3 12.4l15.6-4.5c7.7 13.9 19.1 25.1 32.6 32.6l-4.4 15.4zM576 241.5c-11.7-.4-27.3-.9-48-1.6l48 1.5zM448 384a32 32 0 1 1-64 0 32 32 0 1 1 64 0z"
        }
    ]
};

const FasBacterium = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBacterium",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M423.1 30.6c3.6-12.7-3.7-26-16.5-29.7s-26 3.7-29.7 16.5l-4.2 14.7c-9.8-.4-19.9.5-29.9 2.8-12.1 2.8-23.7 5.9-34.9 9.4L302 30.6c-5.2-12.2-19.3-17.8-31.5-12.6s-17.8 19.3-12.6 31.5l4.9 11.3c-22 9.4-42 20.1-60.2 31.8l-6.6-9.9c-7.4-11-22.3-14-33.3-6.7s-14 22.3-6.7 33.3l7.8 11.6c-18 15-33.7 30.8-47.3 47.1L103 157.3c-10.4-8.3-25.5-6.6-33.7 3.7s-6.6 25.5 3.7 33.7l15 12c-2.1 3.2-4.1 6.5-6 9.7-9.4 15.7-17 31-23.2 45.3l-9.9-3.9c-12.3-4.9-26.3 1.1-31.2 13.4s1.1 26.3 13.4 31.2l11.6 4.6c-.3 1.1-.6 2.1-.9 3.1-3.5 12.5-5.7 23.2-7.1 31.3-.7 4.1-1.2 7.5-1.6 10.3-.2 1.4-.3 2.6-.4 3.6l-.1 1.4-.1.6v.4s0 .1 39.2 3.7l-39.2-3.6c-.5 5-.6 10-.4 14.9l-14.7 4.2C4.7 380.6-2.7 393.8.9 406.6s16.9 20.1 29.7 16.5l13.8-3.9C55 439.9 72 457 92.9 467.7L89 481.4c-3.6 12.7 3.7 26 16.5 29.7s26-3.7 29.7-16.5l4.2-14.7c23.8 1 46.3-5.5 65.1-17.6L215 473c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-10.6-10.6c9.1-14.1 15.1-30.5 17-48.3l.1-.8c.3-1.7 1-5.1 2.3-9.8l.2-.8 12.6 5.4c12.2 5.2 26.3-.4 31.5-12.6s-.4-26.3-12.6-31.5l-11.3-4.8c9.9-14.9 24.9-31.6 48.6-46l2.1 7.5c3.6 12.7 16.9 20.1 29.7 16.5s20.1-16.9 16.5-29.7l-4-14.4c6.9-2.2 14.3-4.3 22.2-6.1 12.9-3 24.7-8 35.2-14.8L439 249c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-10.6-10.6c12.2-19 18.6-41.6 17.6-65.1l14.7-4.2c12.7-3.6 20.1-16.9 16.5-29.7S494.2 85.4 481.4 89l-13.7 3.9c-10.8-21.2-28-38-48.5-48.5l3.9-13.8zm-331 332.7L144 368l-51.9-4.7zM112 320a48 48 0 1 1 96 0 48 48 0 1 1-96 0zm128-136a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FasBadgeCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBadgeCheck",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 0c36.8 0 68.8 20.7 84.9 51.1C373.8 41 411 49 437 75s34 63.3 23.9 96.1c30.4 16.1 51.1 48.1 51.1 84.9s-20.7 68.8-51.1 84.9C471 373.8 463 411 437 437s-63.3 34-96.1 23.9C324.8 491.3 292.8 512 256 512s-68.8-20.7-84.9-51.1C138.2 471 101 463 75 437s-34-63.3-23.9-96.1C20.7 324.8 0 292.8 0 256s20.7-68.8 51.1-84.9C41 138.2 49 101 75 75s63.3-34 96.1-23.9C187.2 20.7 219.2 0 256 0zm113 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 209z"
        }
    ]
};

const FasBadgeDollar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBadgeDollar",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 0c36.8 0 68.8 20.7 84.9 51.1C373.8 41 411 49 437 75s34 63.3 23.9 96.1c30.4 16.1 51.1 48.1 51.1 84.9s-20.7 68.8-51.1 84.9C471 373.8 463 411 437 437s-63.3 34-96.1 23.9C324.8 491.3 292.8 512 256 512s-68.8-20.7-84.9-51.1C138.2 471 101 463 75 437s-34-63.3-23.9-96.1C20.7 324.8 0 292.8 0 256s20.7-68.8 51.1-84.9C41 138.2 49 101 75 75s63.3-34 96.1-23.9C187.2 20.7 219.2 0 256 0zm20.9 140.4c0-11-9-20-20-20s-20 9-20 20v17.4c-8.8 1.8-17.7 4.8-25.7 9.6-15 8.9-27.7 24.4-27.6 46.9.1 21.5 12.6 35.1 26.3 43.4 11.9 7.2 27 11.7 39.1 15.4l1.9.6c13.9 4.2 24.4 7.6 31.7 12.2 6.1 3.8 7.5 6.8 7.6 11 .1 6.5-2.5 10.4-7.6 13.6-6 3.7-15.2 5.9-25.1 5.6-12.7-.4-24.6-4.4-39.7-9.6-2.6-.9-5.2-1.8-8-2.7-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c2.2.7 4.5 1.5 6.8 2.3 9.7 3.3 20.9 7.2 32.8 9.6v18c0 11 9 20 20 20s20-9 20-20v-17.2c9.3-1.7 18.6-4.9 26.8-10.1 15.3-9.5 26.8-25.7 26.5-48.1-.3-21.6-12.4-35.6-26.3-44.3-12.5-7.9-28.3-12.6-40.8-16.4l-.6-.2c-14.1-4.3-24.6-7.5-31.9-11.9-6.2-3.7-7-6.3-7-9.3 0-5.1 2.1-8.8 7.9-12.3 6.5-3.8 16-6 25-5.8 10.9.2 22.9 2.6 35.2 5.8 10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-7.8-2.1-16.3-4.1-25.1-5.4v-17.3z"
        }
    ]
};

const FasBadgePercent = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBadgePercent",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 0c36.8 0 68.8 20.7 84.9 51.1C373.8 41 411 49 437 75s34 63.3 23.9 96.1c30.4 16.1 51.1 48.1 51.1 84.9s-20.7 68.8-51.1 84.9C471 373.8 463 411 437 437s-63.3 34-96.1 23.9C324.8 491.3 292.8 512 256 512s-68.8-20.7-84.9-51.1C138.2 471 101 463 75 437s-34-63.3-23.9-96.1C20.7 324.8 0 292.8 0 256s20.7-68.8 51.1-84.9C41 138.2 49 101 75 75s63.3-34 96.1-23.9C187.2 20.7 219.2 0 256 0zm-64 224a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160 96a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm-15-111c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L175 303c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L337 209z"
        }
    ]
};

const FasBadgeSheriff = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBadgeSheriff",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M272 48c0 14.8-6.7 28-17.2 36.8l25 42.8c5.7 9.8 16.2 15.8 27.5 15.9l47.6.2c6.7-18.5 24.4-31.7 45.2-31.7 26.5 0 48 21.5 48 48s-21.5 48-48 48c-5.9 0-11.6-1.1-16.9-3.1L363 240.1c-5.6 9.8-5.6 21.9 0 31.8l20.1 35.2c5.3-2 10.9-3.1 16.9-3.1 26.5 0 48 21.5 48 48s-21.5 48-48 48c-20.8 0-38.5-13.2-45.2-31.7l-47.6.2c-11.3 0-21.8 6.1-27.5 15.9l-25 42.8c10.5 8.8 17.2 22 17.2 36.8 0 26.5-21.5 48-48 48s-48-21.5-48-48c0-14.8 6.7-28 17.2-36.8l-25-42.8c-5.7-9.8-16.2-15.8-27.5-15.9l-47.6-.2C86.5 386.8 68.8 400 48 400c-26.5 0-48-21.5-48-48s21.5-48 48-48c5.9 0 11.6 1.1 16.9 3.1L85 271.9c5.6-9.8 5.6-21.9 0-31.8l-20.1-35.2c-5.3 2-10.9 3.1-16.9 3.1-26.5 0-48-21.5-48-48s21.5-48 48-48c20.8 0 38.5 13.2 45.2 31.7l47.6-.2c11.3 0 21.8-6.1 27.5-15.9l25-42.8C182.7 76 176 62.8 176 48c0-26.5 21.5-48 48-48s48 21.5 48 48zm-48 272a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"
        }
    ]
};

const FasBadge = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBadge",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M340.9 51.1C324.8 20.7 292.8 0 256 0s-68.8 20.7-84.9 51.1C138.2 41 101 49 75 75s-34 63.3-23.9 96.1C20.7 187.2 0 219.2 0 256s20.7 68.8 51.1 84.9C41 373.8 49 411 75 437s63.3 34 96.1 23.9c16.1 30.4 48.1 51.1 84.9 51.1s68.8-20.7 84.9-51.1C373.8 471 411 463 437 437s34-63.3 23.9-96.1c30.4-16.1 51.1-48.1 51.1-84.9s-20.7-68.8-51.1-84.9C471 138.2 463 101 437 75s-63.3-34-96.1-23.9z"
        }
    ]
};

const FasBadgerHoney = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBadgerHoney",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m164.6 389.3 16-37.3h118.1l16.9 101.3c2.6 15.4 15.9 26.7 31.6 26.7h31.1c19.8 0 34.8-17.8 31.6-37.3L393 342.1c27.9-29 80.6-70.8 144.1-90.8l16.1 25.8c3.1 5 10.4 5 13.6 0l22.8-36.5c12.9-2.1 25.2-7.4 34.4-16.6 10.2-10.2 16-24.1 16-38.6v-3.8c0-23.2-12.6-44.5-32.8-55.8l-81.9-45.5A128.94 128.94 0 0 0 462.5 64c-20.1 0-39.9 4.7-57.8 13.6L400 80c-21 10.5-44.2 16-67.8 16H128C57.3 96 0 153.3 0 224v32c0 17.7 14.3 32 32 32 5.4 0 10.6-1.4 15-3.7 9.1 17.1 22.1 31.9 37.7 43.3l-16.8 59c-2.5 8.8-2.5 18.2.2 27l13.1 43.7c4.1 13.5 16.5 22.8 30.7 22.8H141c21.4 0 36.8-20.7 30.7-41.2l-8.3-27.7c-2.2-7.2-1.7-14.9 1.2-21.8zM570 160h-51.4c.9 2.5 1.4 5.2 1.4 8 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-2.8.5-5.5 1.4-8h-5.9c-23.2 0-46 6.3-65.9 18.2l-106.8 64.1c-14.9 9-32 13.7-49.4 13.7H192c-46.4 0-86.2-28.2-103.2-68.5C102 161.7 129 144 160 144h172.2c31 0 61.5-7.2 89.2-21.1l4.7-2.4c11.3-5.6 23.7-8.6 36.3-8.6 13.8 0 27.4 3.5 39.5 10.2L570 160z"
        }
    ]
};

const FasBadminton = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBadminton",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M349 64c-36 0-76.4 15.8-108.8 48.2S192 184.9 192 221c0 28.2 9.6 53.2 27.7 71.3 40.4 40.4 120.7 38.9 180.1-20.5C432.2 239.4 448 199.1 448 163c0-28.2-9.6-53.2-27.7-71.3S377.1 64 349 64zm-154 2.9C238.5 23.4 294.8 0 349 0c42.8 0 84.9 14.8 116.6 46.5S512 120.2 512 163c0 54.2-23.4 110.5-66.9 154-54.4 54.4-131.9 78.7-198.2 61.7-29.4-7.5-62.9-5.5-84.3 16L148.3 409c6.4 12.1 4.5 27.4-5.6 37.6l-56 56c-12.5 12.5-32.8 12.5-45.3 0l-32-32c-12.5-12.5-12.5-32.8 0-45.3l56-56c10.2-10.2 25.5-12.1 37.6-5.6l14.5-14.5c21.4-21.4 23.5-54.7 16-84-3.7-14.3-5.5-29.2-5.5-44.2 0-54.2 23.4-110.5 66.9-154zM464 400c0-26.5 21.5-48 48-48s48 21.5 48 48v32h-96v-32zm-15.3 91.4 13-43.4h33.4l-15.8 52.6c-2.5 8.5-11.5 13.3-19.9 10.7s-13.3-11.5-10.7-19.9zM496 496v-48h32v48c0 8.8-7.2 16-16 16s-16-7.2-16-16zm48.7 4.6L528.9 448h33.4l13 43.4c2.5 8.5-2.3 17.4-10.7 19.9s-17.4-2.3-19.9-10.7z"
        }
    ]
};

const FasBagSeedling = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBagSeedling",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64 38.6 38.6c-4.2-4.2-6.6-10-6.6-16C32 10.1 42.1 0 54.6 0h402.8C469.9 0 480 10.1 480 22.6c0 6-2.4 11.8-6.6 16L448 64H64zm-8 32h400l10.6 42.5c8.9 35.5 13.4 72 13.4 108.7v17.7c0 36.6-4.5 73.1-13.4 108.7L456 416H56l-10.6-42.5C36.5 338 32 301.5 32 264.8v-17.6c0-36.6 4.5-73.1 13.4-108.7L56 96zm8 352h384l25.4 25.4c4.2 4.2 6.6 10 6.6 16 0 12.5-10.1 22.6-22.6 22.6H54.6C42.1 512 32 501.9 32 489.4c0-6 2.4-11.8 6.6-16L64 448zm80-288c-8.8 0-16 7.2-16 16 0 59.2 45.9 107.6 104 111.7V328c0 13.3 10.7 24 24 24s24-10.7 24-24v-40.3c58.1-4.1 104-52.6 104-111.7 0-8.8-7.2-16-16-16h-2c-47.3 0-88.4 26-110 64.5C234.4 186 193.3 160 146 160h-2z"
        }
    ]
};

const FasBagShopping = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBagShopping",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 112c0-35.3 28.7-64 64-64s64 28.7 64 64v48H160v-48zm-48 48H48c-26.5 0-48 21.5-48 48v208c0 53 43 96 96 96h256c53 0 96-43 96-96V208c0-26.5-21.5-48-48-48h-64v-48C336 50.1 285.9 0 224 0S112 50.1 112 112v48zm24 48a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm152 24a24 24 0 1 1 48 0 24 24 0 1 1-48 0z"
        }
    ]
};

const FasBagel = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBagel",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M640 208c0 114.9-93.1 208-208 208-3.9 0-7.7-.1-11.5-.3 6.5-12.3 12-25.3 16.3-38.8 4.7-.7 9.3-2.5 13.3-5.3l20.9-14.3c5.1-3.5 11-5.4 17.2-5.6l25.3-.7c13.2-.4 24.8-8.8 29.3-21.3l8.5-23.9c2.1-5.8 5.8-10.9 10.6-14.6l20.1-15.4c10.5-8.1 14.9-21.7 11.2-34.4L586 217c-1.7-5.9-1.7-12.2 0-18.1l7.2-24.3c3.7-12.7-.7-26.3-11.2-34.4l-20.1-15.5c-4.9-3.8-8.6-8.8-10.6-14.6l-8.5-23.9c-4.4-12.5-16.1-20.9-29.3-21.3l-25.3-.7c-6.2-.2-12.1-2.1-17.2-5.6l-20.9-14.2c-10.9-7.5-25.3-7.5-36.2 0L393 58.7c-5.1 3.5-11 5.4-17.2 5.6l-25.3.7c-13.2.4-24.8 8.8-29.3 21.3l-1.8 5.1c-14.4-7.6-29.7-13.7-45.7-18.3C311.8 28.4 368.6 0 432 0c114.9 0 208 93.1 208 208zm-243.9-53c10.2-6.9 22.6-11 35.9-11 35.3 0 64 28.7 64 64 0 30.6-21.5 56.3-50.3 62.5-6-43.3-23.6-82.9-49.5-115.6zM0 304a208 208 0 1 1 416 0 208 208 0 1 1-416 0zm256 0a48 48 0 1 0-96 0 48 48 0 1 0 96 0zM112 416a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm144 16a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm48-16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16-176a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm-176-16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm-48 48a16 16 0 1 0-32 0 16 16 0 1 0 32 0z"
        }
    ]
};

const FasBagsShopping = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBagsShopping",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 96v64h96V96c0-26.5-21.5-48-48-48s-48 21.5-48 48zm-48 64V96c0-53 43-96 96-96s96 43 96 96v64h64c35.3 0 64 28.7 64 64H240c-44.2 0-80 35.8-80 80v160c0 5.5.6 10.8 1.6 16H64c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64h64zm128 96h256c35.3 0 64 28.7 64 64v128c0 35.3-28.7 64-64 64H256c-35.3 0-64-28.7-64-64V320c0-35.3 28.7-64 64-64zm64 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v16c0 53 43 96 96 96s96-43 96-96v-16c0-8.8-7.2-16-16-16s-16 7.2-16 16v16c0 35.3-28.7 64-64 64s-64-28.7-64-64v-16z"
        }
    ]
};

const FasBaguette = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBaguette",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M583 234.5c58.8-39.2 74.7-118.7 35.5-177.5S499.8-17.7 441 21.5l-84.5 56.3 70.8 70.8c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L329.3 96l-88 58.7 74 74c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-78.6-78.6-88 58.7 77.2 77.2c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-81.8-81.6L57 277.5C-1.8 316.7-17.7 396.2 21.5 455s118.7 74.7 177.5 35.5l384-256z"
        }
    ]
};

const FasBahai = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBahai",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 0c14.5 0 27.2 9.7 30.9 23.8l23.9 89.6 75.9-53.3c11.9-8.3 27.8-7.6 39 1.7s14.6 24.9 8.4 38.1l-39.3 84 92.4 8c14.4 1.2 26.2 12 28.8 26.3s-4.9 28.5-18 34.6l-84.1 39.1 65.7 65.5c10.3 10.2 12.4 26.1 5.1 38.7s-22 18.7-36 14.9L391 386.8l8.2 92.4c1.3 14.4-7.3 27.9-20.9 32.9s-28.9.1-37.2-11.7l-53.1-76-53.1 76c-8.3 11.9-23.6 16.7-37.2 11.7s-22.2-18.5-20.9-32.9l8.2-92.4-89.6 24.1c-14 3.8-28.8-2.3-36-14.9s-5.2-28.4 5.1-38.7l65.7-65.5L46 252.7c-13.1-6.1-20.5-20.3-18-34.6s14.3-25.1 28.8-26.3l92.4-8-39.3-84c-6.1-13.1-2.7-28.8 8.4-38.1s27.1-10 39-1.7l75.9 53.3 23.9-89.6C260.8 9.7 273.5 0 288 0zm0 156.2-4.8 18c-2.7 10.1-10.2 18.2-20 21.8s-20.8 2.1-29.3-3.9l-15.2-10.7 7.9 16.8c4.4 9.5 4 20.5-1.3 29.6s-14.5 15-25 15.9l-18.5 1.6 16.8 7.8c9.5 4.4 16.2 13.2 18 23.5s-1.5 20.8-8.9 28.2l-13.2 13.1 17.9-4.8c10.1-2.7 20.9-.3 28.9 6.4s12.2 16.9 11.3 27.3l-1.6 18.5 10.6-15.2c6-8.6 15.8-13.7 26.2-13.7s20.2 5.1 26.2 13.7l10.6 15.2-1.6-18.5c-.9-10.4 3.3-20.6 11.3-27.3s18.8-9.1 28.9-6.4l17.9 4.8-13.2-13.1c-7.4-7.4-10.7-17.9-8.9-28.2s8.5-19.1 18-23.5l16.8-7.8-18.5-1.6c-10.4-.9-19.7-6.8-25-15.9s-5.7-20.1-1.3-29.6l7.9-16.8-15.2 10.7c-8.6 6-19.5 7.5-29.3 3.9s-17.3-11.7-20-21.8l-4.8-18z"
        }
    ]
};

const FasBahtSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBahtSign",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 0c-17.7 0-32 14.3-32 32v32H37.6C16.8 64 0 80.8 0 101.6v304.7c0 23 18.7 41.7 41.7 41.7H112v32c0 17.7 14.3 32 32 32s32-14.3 32-32v-32h32c61.9 0 112-50.1 112-112 0-40.1-21.1-75.3-52.7-95.1 13-18.3 20.7-40.7 20.7-64.9 0-61.9-50.1-112-112-112V32c0-17.7-14.3-32-32-32zm-32 128v96H64v-96h48zm64 96v-96c26.5 0 48 21.5 48 48s-21.5 48-48 48zm-64 64v96H64v-96h48zm64 96v-96h32c26.5 0 48 21.5 48 48s-21.5 48-48 48h-32z"
        }
    ]
};

const FasBallPile = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBallPile",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 160a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM208 328a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm-16 104a80 80 0 1 0-160 0 80 80 0 1 0 160 0zm128 80a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm288-80a80 80 0 1 0-160 0 80 80 0 1 0 160 0zM432 328a80 80 0 1 0 0-160 80 80 0 1 0 0 160z"
        }
    ]
};

const FasBalloon = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBalloon",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 192C0 86 86 0 192 0s192 86 192 192c0 102.6-102.8 194.9-143.6 227.5-9.3 7.4-12.5 20.4-7.1 31l21.4 42.7c.9 1.8 1.4 3.8 1.4 5.8 0 7.1-5.8 12.9-12.9 12.9H140.9c-7.1 0-12.9-5.8-12.9-12.9 0-2 .5-4 1.4-5.8l21.4-42.7c5.3-10.6 2.1-23.6-7.1-31C102.8 386.9 0 294.6 0 192zm96-16c0-44.2 35.8-80 80-80 8.8 0 16-7.2 16-16s-7.2-16-16-16c-61.9 0-112 50.1-112 112 0 8.8 7.2 16 16 16s16-7.2 16-16z"
        }
    ]
};

const FasBalloons = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBalloons",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 160C320 71.6 248.4 0 160 0S0 71.6 0 160c0 92.5 87.2 174 117.7 199.7 5.9 5 7.8 13.4 4.4 20.3l-24.7 49.3c-.9 1.8-1.4 3.8-1.4 5.8 0 7.1 5.8 12.9 12.9 12.9h102.2c7.1 0 12.9-5.8 12.9-12.9 0-2-.5-4-1.4-5.8L198 379.9c-3.5-6.9-1.6-15.3 4.4-20.3C232.8 334 320 252.5 320 160zM144 96c-26.5 0-48 21.5-48 48 0 8.8-7.2 16-16 16s-16-7.2-16-16c0-44.2 35.8-80 80-80 8.8 0 16 7.2 16 16s-7.2 16-16 16zm293.7 327.7c5.9 5 7.8 13.4 4.4 20.3l-24.7 49.3c-.9 1.8-1.4 3.8-1.4 5.8 0 7.1 5.8 12.9 12.9 12.9h102.2c7.1 0 12.9-5.8 12.9-12.9 0-2-.5-4-1.4-5.8L518 443.9c-3.5-6.9-1.6-15.3 4.4-20.3C552.8 398 640 316.5 640 224c0-88.4-71.6-160-160-160-53.7 0-101.2 26.4-130.2 67 1.4 9.5 2.2 19.2 2.2 29 0 37.2-11.5 71.8-27.3 101.9 18.5 76.2 86.8 139.7 113 161.8zM416 208c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-44.2 35.8-80 80-80 8.8 0 16 7.2 16 16s-7.2 16-16 16c-26.5 0-48 21.5-48 48z"
        }
    ]
};

const FasBallotCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBallotCheck",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm0 112c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-32zm0 256c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-32zm144 0h160c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-16-240c0-8.8 7.2-16 16-16h160c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16zm16 112h160c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-52.7-27.3c6.2 6.2 6.2 16.4 0 22.6l-48 48c-6.2 6.2-16.4 6.2-22.6 0l-24-24c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L96 249.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0z"
        }
    ]
};

const FasBallot = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBallot",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm0 112c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-32zm0 128c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-32zm16 112h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16zm112 32c0-8.8 7.2-16 16-16h160c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16zm16-272h160c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-16 144c0-8.8 7.2-16 16-16h160c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16z"
        }
    ]
};

const FasBanBug = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBanBug",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 448c-106 0-192-86-192-192 0-41.5 13.1-79.9 35.5-111.2l267.7 267.7C335.9 434.9 297.5 448 256 448zm89-148.3 19.9 4c8.7 1.7 17.1-3.9 18.8-12.6s-3.9-17.1-12.6-18.8l-35.1-7v-18.6l35.1-7c8.7-1.7 14.3-10.2 12.6-18.8s-10.2-14.3-18.8-12.6l-29.5 5.9c-1.1-9.2-3.8-17.8-7.7-25.8l24.5-14.7c7.6-4.5 10-14.4 5.5-22s-14.4-10-22-5.5L307.8 163c-14-11.9-32.1-19-51.8-19-18.7 0-35.9 6.4-49.6 17.2l-61.6-61.7C176.1 77.1 214.5 64 256 64c106 0 192 86 192 192 0 41.5-13.1 79.9-35.5 111.2L345 299.7zM256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM140.9 272.3c-8.7 1.7-14.3 10.2-12.6 18.8s10.2 14.3 18.8 12.6l29.5-5.9c1.1 9.2 3.8 17.8 7.7 25.8l-24.5 14.7c-7.6 4.5-10 14.4-5.5 22s14.4 10 22 5.5l27.9-16.8c14 11.9 32.1 19 51.8 19 6.6 0 13-.8 19.2-2.3L175 265.5l-34.1 6.8z"
        }
    ]
};

const FasBanParking = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBanParking",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M412.5 367.2 342.3 297c20.6-17.6 33.7-43.8 33.7-73 0-53-43-96-96-96h-72c-9.7 0-18.6 3.5-25.5 9.2l-37.7-37.7C176.1 77.1 214.5 64 256 64c106 0 192 86 192 192 0 41.5-13.1 79.9-35.5 111.2zm-45.3 45.3C335.9 434.9 297.5 448 256 448c-106 0-192-86-192-192 0-41.5 13.1-79.9 35.5-111.2l267.7 267.7zm-70.6-161.1L237.3 192H280c17.7 0 32 14.3 32 32 0 11.6-6.2 21.7-15.4 27.4zM256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-88-250.7V352c0 17.7 14.3 32 32 32s32-14.3 32-32v-26.7l-64-64z"
        }
    ]
};

const FasBanSmoking = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBanSmoking",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m99.5 144.8 79.2 79.2 96 96 92.5 92.5C335.9 434.9 297.5 448 256 448c-106 0-192-86-192-192 0-41.5 13.1-79.9 35.5-111.2zM333.3 288l-32-32H384v32h-50.7zm32 32H400c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16H269.3L144.8 99.5C176.1 77.1 214.5 64 256 64c106 0 192 86 192 192 0 41.5-13.1 79.9-35.5 111.2L365.3 320zM256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm16-416c-8.8 0-16 7.2-16 16 0 26.5 21.5 48 48 48h32c8.8 0 16 7.2 16 16s7.2 16 16 16 16-7.2 16-16c0-26.5-21.5-48-48-48h-32c-8.8 0-16-7.2-16-16s-7.2-16-16-16zm-42.5 224-96-96H112c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h117.5z"
        }
    ]
};

const FasBan = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBan",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M367.2 412.5 99.5 144.8C77.1 176.1 64 214.5 64 256c0 106 86 192 192 192 41.5 0 79.9-13.1 111.2-35.5zm45.3-45.3C434.9 335.9 448 297.5 448 256c0-106-86-192-192-192-41.5 0-79.9 13.1-111.2 35.5l267.7 267.7zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0z"
        }
    ]
};

const FasBanana = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBanana",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M304 144c0 35.7-7.3 69.6-20.5 100.5 4.8 3 9.4 6.2 13.9 9.8l35.5 28.4 81-21.7c10.6-2.8 21.4-4.4 32.3-4.9 1.2-10.5 1.8-21.3 1.8-32.1 0-84.7-36.6-160.9-94.8-213.6C345.6 3.6 335.9 0 326.1 0c-29.4 0-47.5 29.4-38 55 10.3 27.7 15.9 57.7 15.9 89zm-26.6 135.2c-18.8-15-42.1-23.2-66.1-23.2-22.9 0-45.2 7.4-63.5 21.2l-42.2 31.6c-10.6 8-12.8 23-4.8 33.6s23 12.8 33.6 4.8l42.2-31.6c10-7.5 22.2-11.6 34.7-11.6 10.5 0 20.8 2.9 29.7 8.2C194.1 366 125 400 48 400c-26.5 0-48 21.5-48 48v16c0 26.5 21.5 48 48 48h112c117.3 0 218.2-70.1 263.1-170.6l11.5-3.1c5.7-1.5 11.6-2.3 17.5-2.3 23.8 0 45.9 12.5 58.1 32.9l21.3 35.4c6.8 11.4 21.6 15 32.9 8.2s15-21.6 8.2-32.9l-21.3-35.4C530.4 309.3 492.7 288 452 288c-3.8 0-7.5.2-11.3.6-5.5.5-10.9 1.5-16.3 2.8-.8.2-1.5.4-2.3.6l-96.7 25.8-48.1-38.5z"
        }
    ]
};

const FasBandage = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBandage",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 416h96c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64h-96v320zM448 96H192v320h256V96zM64 96c-35.3 0-64 28.7-64 64v192c0 35.3 28.7 64 64 64h96V96H64zm184 112a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm120-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM248 304a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm120-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FasBangladeshiTakaSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBangladeshiTakaSign",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M36 32.2C18.4 30.1 2.4 42.5.2 60S10.5 93.6 28 95.8l7.9 1c16 2 28 15.6 28 31.8V160H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h32v160c0 53 43 96 96 96h32c106 0 192-86 192-192v-32c0-53-43-96-96-96h-16c-17.7 0-32 14.3-32 32s14.3 32 32 32h16c17.7 0 32 14.3 32 32v32c0 70.7-57.3 128-128 128h-32c-17.7 0-32-14.3-32-32V224h32c17.7 0 32-14.3 32-32s-14.3-32-32-32h-32v-31.5c0-48.4-36.1-89.3-84.1-95.3l-7.9-1z"
        }
    ]
};

const FasBanjo = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBanjo",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M465 7c-9.4-9.4-24.6-9.4-33.9 0L383 55c-2.4 2.4-4.3 5.3-5.5 8.5l-15.4 41-76.1 76.2c-20.6-13.9-44.3-23.4-70-27V152c0-13.3-10.7-24-24-24s-24 10.7-24 24v1.7c-28.5 4.1-54.6 15.3-76.6 31.7l-1.2-1.2c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l1.2 1.2C41 241.4 29.8 267.5 25.7 296H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h1.7c4.1 28.5 15.3 54.6 31.7 76.6l-1.2 1.2c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l1.2-1.2c22 16.5 48.2 27.7 76.6 31.7v1.8c0 13.3 10.7 24 24 24s24-10.7 24-24v-1.7c28.5-4.1 54.6-15.3 76.6-31.7l1.2 1.2c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-1.2-1.2c16.5-22 27.7-48.2 31.7-76.6h1.9c13.3 0 24-10.7 24-24s-10.7-24-24-24h-1.7c-3.7-25.7-13.1-49.5-27-70l76.1-76.1 41-15.4c3.2-1.2 6.1-3.1 8.5-5.5l48-48c9.4-9.4 9.4-24.6 0-33.9L465 7zM192 208a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm-36.7 100.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l48 48c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-48-48z"
        }
    ]
};

const FasBarcodeRead = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBarcodeRead",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M56 48c-4.4 0-8 3.6-8 8v80c0 13.3-10.7 24-24 24S0 149.3 0 136V56C0 25.1 25.1 0 56 0h80c13.3 0 24 10.7 24 24s-10.7 24-24 24H56zm96 80h16c13.3 0 24 10.7 24 24v208c0 13.3-10.7 24-24 24h-16c-13.3 0-24-10.7-24-24V152c0-13.3 10.7-24 24-24zm160 0h16c13.3 0 24 10.7 24 24v208c0 13.3-10.7 24-24 24h-16c-13.3 0-24-10.7-24-24V152c0-13.3 10.7-24 24-24zm72 24c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24v208c0 13.3-10.7 24-24 24h-16c-13.3 0-24-10.7-24-24V152zm-144-24c8.8 0 16 7.2 16 16v224c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16zm288-72c0-4.4-3.6-8-8-8h-80c-13.3 0-24-10.7-24-24s10.7-24 24-24h80c30.9 0 56 25.1 56 56v80c0 13.3-10.7 24-24 24s-24-10.7-24-24V56zM56 464h80c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-30.9 0-56-25.1-56-56v-80c0-13.3 10.7-24 24-24s24 10.7 24 24v80c0 4.4 3.6 8 8 8zm472-8v-80c0-13.3 10.7-24 24-24s24 10.7 24 24v80c0 30.9-25.1 56-56 56h-80c-13.3 0-24-10.7-24-24s10.7-24 24-24h80c4.4 0 8-3.6 8-8z"
        }
    ]
};

const FasBarcodeScan = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBarcodeScan",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M88 32c-13.3 0-24 10.7-24 24v136h64V56c0-13.3-10.7-24-24-24H88zM64 456c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V320H64v136zm96 8c0 8.8 7.2 16 16 16s16-7.2 16-16V320h-32v144zm64-8c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V320h-64v136zm0-264h64V56c0-13.3-10.7-24-24-24h-16c-13.3 0-24 10.7-24 24v136zm96 264c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V320h-64v136zm0-264h64V56c0-13.3-10.7-24-24-24h-16c-13.3 0-24 10.7-24 24v136zm128 272c0 8.8 7.2 16 16 16s16-7.2 16-16V320h-32v144zm0-416v144h32V48c0-8.8-7.2-16-16-16s-16 7.2-16 16zm64 408c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V320h-64v136zm0-264h64V56c0-13.3-10.7-24-24-24h-16c-13.3 0-24 10.7-24 24v136zm-352 0h32V48c0-8.8-7.2-16-16-16s-16 7.2-16 16v144zM24 232c-13.3 0-24 10.7-24 24s10.7 24 24 24h592c13.3 0 24-10.7 24-24s-10.7-24-24-24H24z"
        }
    ]
};

const FasBarcode = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBarcode",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M24 32C10.7 32 0 42.7 0 56v400c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24H24zm88 0c-8.8 0-16 7.2-16 16v416c0 8.8 7.2 16 16 16s16-7.2 16-16V48c0-8.8-7.2-16-16-16zm72 0c-13.3 0-24 10.7-24 24v400c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24h-16zm96 0c-13.3 0-24 10.7-24 24v400c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24h-16zm168 24v400c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24h-16c-13.3 0-24 10.7-24 24zm-64-8v416c0 8.8 7.2 16 16 16s16-7.2 16-16V48c0-8.8-7.2-16-16-16s-16 7.2-16 16z"
        }
    ]
};

const FasBarsFilter = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBarsFilter",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 96c0-17.7 14.3-32 32-32h384c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zm64 160c0-17.7 14.3-32 32-32h256c17.7 0 32 14.3 32 32s-14.3 32-32 32H96c-17.7 0-32-14.3-32-32zm224 160c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32s14.3-32 32-32h64c17.7 0 32 14.3 32 32z"
        }
    ]
};

const FasBarsProgress = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBarsProgress",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 160H320v-32h128v32zM48 64C21.5 64 0 85.5 0 112v64c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48v-64c0-26.5-21.5-48-48-48H48zm400 288v32H192v-32h256zM48 288c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48v-64c0-26.5-21.5-48-48-48H48z"
        }
    ]
};

const FasBarsSort = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBarsSort",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 96c0-17.7 14.3-32 32-32h384c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zm0 160c0-17.7 14.3-32 32-32h256c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zm192 160c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h128c17.7 0 32 14.3 32 32z"
        }
    ]
};

const FasBarsStaggered = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBarsStaggered",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 96c0-17.7 14.3-32 32-32h384c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zm64 160c0-17.7 14.3-32 32-32h384c17.7 0 32 14.3 32 32s-14.3 32-32 32H96c-17.7 0-32-14.3-32-32zm384 160c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h384c17.7 0 32 14.3 32 32z"
        }
    ]
};

const FasBars = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBars",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 96c0-17.7 14.3-32 32-32h384c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zm0 160c0-17.7 14.3-32 32-32h384c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zm448 160c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h384c17.7 0 32 14.3 32 32z"
        }
    ]
};

const FasBaseballBatBall = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBaseballBatBall",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M424 0c-12.4 0-24.2 4.9-33 13.7L233.5 171.2c-10.5 10.5-19.8 22.1-27.7 34.6l-73.1 115.8c-7.3 11.5-15.8 22.2-25.5 31.9l-37.3 37.2 51.3 51.3 37.3-37.3c9.6-9.6 20.3-18.2 31.9-25.5l115.8-73.1c12.5-7.9 24.1-17.2 34.6-27.7L498.3 121c8.7-8.7 13.7-20.6 13.7-33s-4.9-24.2-13.7-33L457 13.7C448.2 4.9 436.4 0 424 0zm88 432a80 80 0 1 0-160 0 80 80 0 1 0 160 0zM15 399c-9.4 9.4-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L49 399c-9.4-9.4-24.6-9.4-33.9 0z"
        }
    ]
};

const FasBaseball = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBaseball",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M62.7 223.4c-4.8.4-9.7.6-14.7.6-15.6 0-30.8-2-45.2-5.9C19.2 107.1 107.1 19.2 218.1 2.8 222 17.2 224 32.4 224 48c0 4.9-.2 9.8-.6 14.7-.7 8.8 5.8 16.5 14.6 17.3s16.5-5.8 17.3-14.6c.5-5.7.7-11.5.7-17.3 0-16.5-1.9-32.6-5.6-47.9 1.8 0 3.7-.1 5.6-.1C397.4 0 512 114.6 512 256c0 1.9 0 3.7-.1 5.6-15.4-3.6-31.4-5.6-47.9-5.6-5.8 0-11.6.2-17.3.7-8.8.7-15.4 8.5-14.6 17.3s8.5 15.4 17.3 14.6c4.8-.4 9.7-.6 14.7-.6 15.6 0 30.8 2 45.2 5.9-16.5 111-104.4 198.9-215.4 215.3-3.9-14.4-5.9-29.6-5.9-45.2 0-4.9.2-9.8.6-14.7.7-8.8-5.8-16.5-14.6-17.3s-16.5 5.8-17.3 14.6c-.5 5.7-.7 11.5-.7 17.3 0 16.5 1.9 32.6 5.6 47.9-1.8 0-3.7.1-5.6.1C114.6 512 0 397.4 0 256c0-1.9 0-3.7.1-5.6 15.3 3.7 31.4 5.6 47.9 5.6 5.8 0 11.6-.2 17.3-.7 8.8-.7 15.4-8.5 14.6-17.3s-8.5-15.4-17.3-14.6zm58.6-15.4c-8 3.7-11.6 13.2-7.9 21.2s13.2 11.6 21.2 7.9c45.2-20.8 81.7-57.2 102.5-102.5 3.7-8 .2-17.5-7.9-21.2s-17.5-.2-21.2 7.9c-17.6 38.3-48.5 69.2-86.7 86.7zm277.2 74.7c-3.7-8-13.2-11.6-21.2-7.9-45.2 20.8-81.7 57.2-102.5 102.5-3.7 8-.2 17.5 7.9 21.2s17.5.2 21.2-7.9c17.6-38.3 48.5-69.2 86.7-86.7 8-3.7 11.6-13.2 7.9-21.2z"
        }
    ]
};

const FasBasketShoppingSimple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBasketShoppingSimple",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M243.1 2.7c11.8 6.1 16.3 20.6 10.2 32.4L171.7 192h232.6L322.7 35.1c-6.1-11.8-1.5-26.3 10.2-32.4s26.2-1.5 32.4 10.2L458.4 192H544c17.7 0 32 14.3 32 32s-14.3 32-32 32l-51.9 207.5C485 492 459.4 512 430 512H146c-29.4 0-55-20-62.1-48.5L32 256c-17.7 0-32-14.3-32-32s14.3-32 32-32h85.6l93.1-179.1c6.1-11.8 20.6-16.3 32.4-10.2zM144 296a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm312-24a24 24 0 1 0-48 0 24 24 0 1 0 48 0z"
        }
    ]
};

const FasBasketShopping = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBasketShopping",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M253.3 35.1c6.1-11.8 1.5-26.3-10.2-32.4s-26.3-1.5-32.4 10.2L117.6 192H32c-17.7 0-32 14.3-32 32s14.3 32 32 32l51.9 207.5C91 492 116.6 512 146 512h284c29.4 0 55-20 62.1-48.5L544 256c17.7 0 32-14.3 32-32s-14.3-32-32-32h-85.6L365.3 12.9c-6.1-11.7-20.6-16.3-32.4-10.2s-16.3 20.6-10.2 32.4L404.3 192H171.7l81.6-156.9zM192 304v96c0 8.8-7.2 16-16 16s-16-7.2-16-16v-96c0-8.8 7.2-16 16-16s16 7.2 16 16zm96-16c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16v-96c0-8.8 7.2-16 16-16zm128 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16v-96c0-8.8 7.2-16 16-16s16 7.2 16 16z"
        }
    ]
};

const FasBasketballHoop = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBasketballHoop",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M6.8 187C24.7 153.1 116.7 0 320 0s295.3 153.1 313.2 187c4.9 9.4 6.8 19.1 6.8 28v116.2c0 25.3-14.9 48.2-38 58.5l-96.4 42.9L526.2 288h-32.3l-7.2 50.3-22.9 160c-.9 6.1-5.2 11.2-11.1 13s-12.3.1-16.5-4.4L384.4 451l-52.8 56c-3 3.2-7.2 5-11.6 5s-8.6-1.8-11.6-5l-52.8-56-51.9 55.9c-4.2 4.5-10.6 6.2-16.5 4.4s-10.2-6.9-11.1-13l-22.9-160-7.1-50.3h-32.3l20.7 144.6L38 389.7c-23.1-10.3-38-33.2-38-58.5V214.9c0-8.9 1.8-18.6 6.8-28zm171.6 101 5.2 36.6 44-36.6h-49.2zm99.3 0-.6.5 42.9 46.1 42.8-46.1-.6-.5h-84.4zm134.5 0 44 36.6 5.2-36.6h-49.1zM192 128c-17.7 0-32 14.3-32 32v48h-48c-8.8 0-16 7.2-16 16s7.2 16 16 16h416c8.8 0 16-7.2 16-16s-7.2-16-16-16h-48v-48c0-17.7-14.3-32-32-32H192zm256 32v48H192v-48h256zm-60.5 149-45.7 49.2 42.7 46 51.6-54.7-48.6-40.5zm49.4 151.6 11-76.8-41.5 44 30.5 32.9zM320 381.7l-42.6 45.9 42.6 45.1 42.6-45.2-42.6-45.8zm-21.8-23.5L252.5 309l-48.7 40.5 51.6 54.7 42.7-46zm-64.6 69.5-41.5-44 11 76.8 30.5-32.9z"
        }
    ]
};

const FasBasketball = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBasketball",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m86.6 64 85.2 85.2C194.5 121.7 208 86.4 208 48c0-14.7-2-28.9-5.7-42.4C158.6 15 119 35.5 86.6 64zM64 86.6c-28.5 32.4-49 72-58.4 115.7C19.1 206 33.3 208 48 208c38.4 0 73.7-13.5 101.3-36.1L64 86.6zM256 0c-7.3 0-14.6.3-21.8.9C238 16 240 31.8 240 48c0 47.3-17.1 90.5-45.4 124l61.4 61.4L425.4 64C380.2 24.2 320.9 0 256 0zM48 240c-16.2 0-32-2-47.1-5.8A263 263 0 0 0 0 256c0 64.9 24.2 124.2 64 169.4L233.4 256 172 194.6C138.5 222.9 95.3 240 48 240zm463.1 37.8c.6-7.2.9-14.5.9-21.8 0-64.9-24.2-124.2-64-169.4L278.6 256l61.4 61.4c33.4-28.3 76.7-45.4 124-45.4 16.2 0 32 2 47.1 5.8zm-4.7 31.9c-13.5-3.7-27.7-5.7-42.4-5.7-38.4 0-73.7 13.5-101.3 36.1l85.3 85.3c28.5-32.3 49.1-71.9 58.4-115.7zm-166.3 53C317.5 390.3 304 425.6 304 464c0 14.7 2 28.9 5.7 42.4 43.7-9.4 83.3-29.9 115.7-58.4l-85.2-85.2zM317.4 340 256 278.6 86.6 448c45.1 39.8 104.4 64 169.4 64 7.3 0 14.6-.3 21.8-.9C274 496 272 480.2 272 464c0-47.3 17.1-90.5 45.4-124z"
        }
    ]
};

const FasBat = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBat",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m235.6 52.8 10.8 14.4c6 8.1 15.5 12.8 25.6 12.8h32c10.1 0 19.6-4.7 25.6-12.8l10.8-14.4c2.3-3 5.8-4.8 9.6-4.8 5.8 0 10.8 4.1 11.8 9.8l19 101.4 71.8-34.2c16.2-7.7 35.5-3.6 47.1 10 49.2 57.4 76.3 130.6 76.3 206.2v37.6c0 9.7-10.2 16-18.9 11.7l-63.8-31.9c-7.5-3.7-16.6-1.1-20.9 6.1l-29.8 49.7c-5.4 8.9-17.7 10.4-25 3.1L381 380.9c-6.8-6.8-18.1-6.1-24 1.6l-56.2 73.1c-6.4 8.3-19 8.3-25.4 0l-56.2-73.1c-5.9-7.7-17.2-8.4-24-1.6l-36.6 36.6c-7.4 7.4-19.7 5.8-25-3.1l-29.8-49.7c-4.3-7.2-13.4-9.8-20.9-6.1l-64 31.9c-8.7 4.3-18.9-2-18.9-11.7v-37.6C0 265.6 27.1 192.4 76.3 135c11.6-13.6 30.9-17.7 47.1-10l71.8 34.2 19-101.4c1.1-5.7 6-9.8 11.8-9.8 3.8 0 7.4 1.8 9.6 4.8z"
        }
    ]
};

const FasBath = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBath",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 77.3C96 70 101.9 64 109.3 64c3.5 0 6.9 1.4 9.4 3.9l14.9 14.9c-3.6 9-5.6 18.9-5.6 29.2 0 19.9 7.2 38 19.2 52-5.3 9.2-4 21.1 3.8 29 9.4 9.4 24.6 9.4 33.9 0L289 89c9.4-9.4 9.4-24.6 0-33.9-7.9-7.9-19.8-9.1-29-3.8C246 39.2 227.9 32 208 32c-10.3 0-20.2 2-29.2 5.5l-14.9-14.9C149.4 8.1 129.7 0 109.3 0 66.6 0 32 34.6 32 77.3V256c-17.7 0-32 14.3-32 32s14.3 32 32 32h448c17.7 0 32-14.3 32-32s-14.3-32-32-32H96V77.3zM32 352v16c0 28.4 12.4 54 32 71.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32v-16h256v16c0 17.7 14.3 32 32 32s32-14.3 32-32v-40.4c19.6-17.6 32-43.1 32-71.6v-16H32z"
        }
    ]
};

const FasBatteryBolt = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBatteryBolt",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 96c-44.2 0-80 35.8-80 80v160c0 44.2 35.8 80 80 80h92.2c-12.9-14.5-16.1-35.6-7.2-53.5l5.3-10.5H80c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h139.2l80-64H80zm384 256H324.8l-80 64H464c44.2 0 80-35.8 80-80v-16c17.7 0 32-14.3 32-32v-64c0-17.7-14.3-32-32-32v-16c0-44.2-35.8-80-80-80h-92.2c13 14.5 16.1 35.6 7.2 53.5l-5.3 10.5H464c8.8 0 16 7.2 16 16v160c0 8.8-7.2 16-16 16zM346.1 115.6c-5.8-4.7-14.2-4.7-20.1-.1l-160 128c-5.3 4.2-7.4 11.4-5.1 17.8S169.2 272 176 272h70.1l-52.4 104.8c-3.4 6.7-1.6 14.9 4.3 19.6s14.2 4.7 20.1.1l160-128c5.3-4.2 7.4-11.4 5.1-17.8s-8.3-10.7-15.1-10.7h-70.2l52.4-104.8c3.4-6.7 1.6-14.9-4.2-19.6z"
        }
    ]
};

const FasBatteryEmpty = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBatteryEmpty",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 160c-8.8 0-16 7.2-16 16v160c0 8.8 7.2 16 16 16h384c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16H80zM0 176c0-44.2 35.8-80 80-80h384c44.2 0 80 35.8 80 80v16c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32v16c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80V176z"
        }
    ]
};

const FasBatteryExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBatteryExclamation",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M208 96v64H80c-8.8 0-16 7.2-16 16v160c0 8.8 7.2 16 16 16h118.7c-4.3 9.8-6.7 20.6-6.7 32s2.4 22.2 6.7 32H80c-44.2 0-80-35.8-80-80V176c0-44.2 35.8-80 80-80h128zm256 320H345.3c4.3-9.8 6.7-20.6 6.7-32s-2.4-22.2-6.7-32H464c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16H336V96h128c44.2 0 80 35.8 80 80v16c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32v16c0 44.2-35.8 80-80 80zM272 96c13.3 0 24 10.7 24 24v176c0 13.3-10.7 24-24 24s-24-10.7-24-24V120c0-13.3 10.7-24 24-24zm-32 288a32 32 0 1 1 64 0 32 32 0 1 1-64 0z"
        }
    ]
};

const FasBatteryFull = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBatteryFull",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 160c8.8 0 16 7.2 16 16v160c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h384zM80 96c-44.2 0-80 35.8-80 80v160c0 44.2 35.8 80 80 80h384c44.2 0 80-35.8 80-80v-16c17.7 0 32-14.3 32-32v-64c0-17.7-14.3-32-32-32v-16c0-44.2-35.8-80-80-80H80zm368 96H96v128h352V192z"
        }
    ]
};

const FasBatteryHalf = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBatteryHalf",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 160c8.8 0 16 7.2 16 16v160c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h384zM80 96c-44.2 0-80 35.8-80 80v160c0 44.2 35.8 80 80 80h384c44.2 0 80-35.8 80-80v-16c17.7 0 32-14.3 32-32v-64c0-17.7-14.3-32-32-32v-16c0-44.2-35.8-80-80-80H80zm208 96H96v128h192V192z"
        }
    ]
};

const FasBatteryLow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBatteryLow",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 160c8.8 0 16 7.2 16 16v160c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h384zM80 96c-44.2 0-80 35.8-80 80v160c0 44.2 35.8 80 80 80h384c44.2 0 80-35.8 80-80v-16c17.7 0 32-14.3 32-32v-64c0-17.7-14.3-32-32-32v-16c0-44.2-35.8-80-80-80H80zm80 96H96v128h64V192z"
        }
    ]
};

const FasBatteryQuarter = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBatteryQuarter",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 160c8.8 0 16 7.2 16 16v160c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h384zM80 96c-44.2 0-80 35.8-80 80v160c0 44.2 35.8 80 80 80h384c44.2 0 80-35.8 80-80v-16c17.7 0 32-14.3 32-32v-64c0-17.7-14.3-32-32-32v-16c0-44.2-35.8-80-80-80H80zm112 96H96v128h96V192z"
        }
    ]
};

const FasBatterySlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBatterySlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-87.5-68.6c19.8-14.5 32.7-38 32.7-64.5v-16c17.7 0 32-14.3 32-32v-64c0-17.7-14.3-32-32-32v-16c0-44.2-35.8-80-80-80H154.8L38.8 5.1zM236.4 160H496c8.8 0 16 7.2 16 16v160c0 8.8-7.2 16-16 16h-14.6l-245-192zm88.5 192H112c-8.8 0-16-7.2-16-16V176c0-1.4.2-2.7.5-4l-51.1-40.3C36.9 144.4 32 159.6 32 176v160c0 44.2 35.8 80 80 80h294.2L325 352z"
        }
    ]
};

const FasBatteryThreeQuarters = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBatteryThreeQuarters",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 160c8.8 0 16 7.2 16 16v160c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h384zM80 96c-44.2 0-80 35.8-80 80v160c0 44.2 35.8 80 80 80h384c44.2 0 80-35.8 80-80v-16c17.7 0 32-14.3 32-32v-64c0-17.7-14.3-32-32-32v-16c0-44.2-35.8-80-80-80H80zm272 96H96v128h256V192z"
        }
    ]
};

const FasBedBunk = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBedBunk",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C64 14.3 49.7 0 32 0S0 14.3 0 32v448c0 17.7 14.3 32 32 32s32-14.3 32-32v-32h448v32c0 17.7 14.3 32 32 32s32-14.3 32-32V112C576 50.1 525.9 0 464 0H256c-17.7 0-32 14.3-32 32v96H64V32zm448 224H256c-17.7 0-32 14.3-32 32v96H64V192h448v64zm-320 48a48 48 0 1 0-96 0 48 48 0 1 0 96 0zM144 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
        }
    ]
};

const FasBedEmpty = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBedEmpty",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64v384c0 17.7 14.3 32 32 32s32-14.3 32-32v-32h512v32c0 17.7 14.3 32 32 32s32-14.3 32-32V320c0-53-43-96-96-96H64V64z"
        }
    ]
};

const FasBedFront = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBedFront",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48v129.1c-14.5-8.4-30.7-14-48-16.1v-33c0-17.7-14.3-32-32-32h-96c-17.7 0-32 14.3-32 32v32h-32v-32c0-17.7-14.3-32-32-32h-96c-17.7 0-32 14.3-32 32v33c-17.3 2.2-33.6 7.8-48 16.1V80zM0 320c0-53 43-96 96-96h320c53 0 96 43 96 96v128c0 17.7-14.3 32-32 32s-32-14.3-32-32v-32H64v32c0 17.7-14.3 32-32 32S0 465.7 0 448V320z"
        }
    ]
};

const FasBedPulse = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBedPulse",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M483.2 9.6 524 64h92c13.3 0 24 10.7 24 24s-10.7 24-24 24H512c-7.6 0-14.7-3.6-19.2-9.6l-24.1-32.1-47 99.9c-3.7 7.8-11.3 13.1-19.9 13.7s-16.9-3.4-21.7-10.6L339.2 112H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h136c8 0 15.5 4 20 10.7l24.4 36.6 45.9-97.5C445.9 6.2 453.2 1 461.6.1s16.6 2.7 21.6 9.5zM320 160h12.7l20.7 31.1c11.2 16.8 30.6 26.3 50.7 24.8s37.9-13.7 46.5-32l11.3-23.9H544c53 0 96 43 96 96v224c0 17.7-14.3 32-32 32s-32-14.3-32-32v-32H64v32c0 17.7-14.3 32-32 32S0 497.7 0 480V96c0-17.7 14.3-32 32-32s32 14.3 32 32v256h224V192c0-17.7 14.3-32 32-32zm-144 0a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"
        }
    ]
};

const FasBed = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBed",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 32c17.7 0 32 14.3 32 32v256h224V160c0-17.7 14.3-32 32-32h224c53 0 96 43 96 96v224c0 17.7-14.3 32-32 32s-32-14.3-32-32v-32H64v32c0 17.7-14.3 32-32 32S0 465.7 0 448V64c0-17.7 14.3-32 32-32zm144 96a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"
        }
    ]
};

const FasBee = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBee",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M196.7 4.7c6.2-6.2 16.4-6.2 22.6 0l34.8 34.8c10.3-4.8 21.8-7.5 33.9-7.5s23.6 2.7 33.9 7.5l34.8-34.8c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-31.5 31.5C360.4 73 368 91.6 368 112c0 3-.2 6-.5 8.9C390.3 105 419 96 448 96c65 0 128 44.9 128 112 0 61.9-53.6 104.9-112.9 111.2.6-5.1.9-10.2.9-15.2 0-16.8-2.4-33.1-6.8-48.5 35.2-3.6 54.8-27.9 54.8-47.5 0-21.3-22.9-48-64-48-34.8 0-56.6 19.2-62.4 38.1 28.6 26.3 46.4 64 46.4 105.9 0 83.8-103.6 179.7-129.9 202.8-3.9 3.4-8.9 5.2-14.1 5.2s-10.2-1.8-14.1-5.2C247.6 483.7 144 387.8 144 304c0-41.9 17.9-79.6 46.4-105.9-5.8-18.9-27.6-38.1-62.4-38.1-41.1 0-64 26.7-64 48 0 19.6 19.5 43.9 54.8 47.5-4.4 15.4-6.8 31.7-6.8 48.5 0 5 .3 10.1.9 15.2C53.6 312.9 0 269.9 0 208 0 140.9 63 96 128 96c29 0 57.7 9 80.5 24.9-.3-2.9-.5-5.9-.5-8.9 0-20.4 7.6-39 20.2-53.2l-31.5-31.5c-6.2-6.2-6.2-16.4 0-22.6zm52.8 384.1c12.8 16.4 26.5 31.3 38.5 43.4 12-12.1 25.7-27 38.5-43.4 1.2-1.6 2.5-3.2 3.7-4.8h-84.4c1.2 1.6 2.4 3.2 3.7 4.8zM359.6 336c5.6-12.6 8.4-23.4 8.4-32H208c0 8.6 2.8 19.4 8.4 32h143.2zm-7.6-80c-14.6-19.4-37.8-32-64-32s-49.4 12.6-64 32h128z"
        }
    ]
};

const FasBeerMugEmpty = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBeerMugEmpty",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 64c0-17.7 14.3-32 32-32h288c17.7 0 32 14.3 32 32v32h51.2c42.4 0 76.8 34.4 76.8 76.8v102.1c0 30.4-17.9 57.9-45.6 70.2L384 381.7V416c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V64zm352 247.6 56.4-25.1c4.6-2.1 7.6-6.6 7.6-11.7v-102c0-7.1-5.7-12.8-12.8-12.8H384v151.6zM160 144c0-8.8-7.2-16-16-16s-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16V144zm64 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16V144zm64 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16V144z"
        }
    ]
};

const FasBeerMug = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBeerMug",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M267.7 133.3C253 149.7 231.7 160 208 160s-45-10.3-59.7-26.7c-6.9-7.7-21.4-8.6-29.6-2.3-10.7 8.1-24.1 13-38.7 13-35.3 0-64-28.7-64-64s28.7-64 64-64c14.6 0 28 4.9 38.7 13 8.2 6.3 22.7 5.4 29.6-2.3C163 10.3 184.3 0 208 0s45 10.3 59.7 26.7c6.9 7.7 21.4 8.6 29.6 2.3 10.7-8.1 24.1-13 38.7-13 35.3 0 64 28.7 64 64s-28.7 64-64 64c-14.6 0-28-4.9-38.7-13-8.2-6.3-22.7-5.4-29.6 2.3zM32 448V163.2c14.1 8.1 30.5 12.8 48 12.8 18.7 0 36.2-5.4 51-14.7 20 19 47.2 30.7 77 30.7s57-11.7 77-30.7c14.8 9.3 32.3 14.7 51 14.7 19.6 0 37.9-5.9 53.1-16h46.1c42.4 0 76.8 34.4 76.8 76.8v102.1c0 30.3-17.9 57.9-45.6 70.2L384 445.7v2.3c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64zm352-72.4 56.4-25.1c4.6-2.1 7.6-6.6 7.6-11.7v-102c0-7.1-5.7-12.8-12.8-12.8H384v151.6zM160 240c0-8.8-7.2-16-16-16s-16 7.2-16 16v160c0 8.8 7.2 16 16 16s16-7.2 16-16V240zm64 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v160c0 8.8 7.2 16 16 16s16-7.2 16-16V240zm64 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v160c0 8.8 7.2 16 16 16s16-7.2 16-16V240z"
        }
    ]
};

const FasBellConcierge = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBellConcierge",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M216 64c-13.3 0-24 10.7-24 24s10.7 24 24 24h16v33.3C119.6 157.2 32 252.4 32 368h448c0-115.6-87.6-210.8-200-222.7V112h16c13.3 0 24-10.7 24-24s-10.7-24-24-24h-80zM24 400c-13.3 0-24 10.7-24 24s10.7 24 24 24h464c13.3 0 24-10.7 24-24s-10.7-24-24-24H24z"
        }
    ]
};

const FasBellExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBellExclamation",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 0c-17.7 0-32 14.3-32 32v19.2C119 66 64 130.6 64 208v18.8c0 47-17.3 92.4-48.5 127.6l-7.4 8.3c-8.4 9.4-10.4 22.9-5.3 34.4S19.4 416 32 416h384c12.6 0 24-7.4 29.2-18.9s3.1-25-5.3-34.4l-7.4-8.3c-31.2-35.2-48.5-80.5-48.5-127.6V208c0-77.4-55-142-128-156.8V32c0-17.7-14.3-32-32-32zm45.3 493.3c12-12 18.7-28.3 18.7-45.3H160c0 17 6.7 33.3 18.7 45.3S207 512 224 512s33.3-6.7 45.3-18.7zM192 320a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm56-184v96c0 13.3-10.7 24-24 24s-24-10.7-24-24v-96c0-13.3 10.7-24 24-24s24 10.7 24 24z"
        }
    ]
};

const FasBellOn = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBellOn",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 0c-17.7 0-32 14.3-32 32v19.2C215 66 160 130.6 160 208v18.8c0 47-17.3 92.4-48.5 127.6l-7.4 8.3c-8.4 9.4-10.4 22.9-5.3 34.4S115.4 416 128 416h384c12.6 0 24-7.4 29.2-18.9s3.1-25-5.3-34.4l-7.4-8.3c-31.2-35.2-48.5-80.5-48.5-127.6V208c0-77.4-55-142-128-156.8V32c0-17.7-14.3-32-32-32zm45.3 493.3c12-12 18.7-28.3 18.7-45.3H256c0 17 6.7 33.3 18.7 45.3S303 512 320 512s33.3-6.7 45.3-18.7zM0 200c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H24c-13.3 0-24 10.7-24 24zm536-24c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24h-80zm61.5-154.7c-5.9-11.9-20.3-16.7-32.2-10.7l-64 32c-11.9 5.9-16.7 20.3-10.7 32.2s20.3 16.7 32.2 10.7l64-32c11.9-5.9 16.7-20.3 10.7-32.2zM53.3 53.5l64 32c11.9 5.9 26.3 1.1 32.2-10.7s1.1-26.3-10.7-32.2l-64-32c-11.9-6-26.3-1.2-32.3 10.7s-1.1 26.3 10.7 32.2z"
        }
    ]
};

const FasBellPlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBellPlus",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 0c-17.7 0-32 14.3-32 32v19.2C119 66 64 130.6 64 208v18.8c0 47-17.3 92.4-48.5 127.6l-7.4 8.3c-8.4 9.4-10.4 22.9-5.3 34.4S19.4 416 32 416h384c12.6 0 24-7.4 29.2-18.9s3.1-25-5.3-34.4l-7.4-8.3c-31.2-35.2-48.5-80.5-48.5-127.6V208c0-77.4-55-142-128-156.8V32c0-17.7-14.3-32-32-32zm45.3 493.3c12-12 18.7-28.3 18.7-45.3H160c0 17 6.7 33.3 18.7 45.3S207 512 224 512s33.3-6.7 45.3-18.7zM224 152c13.3 0 24 10.7 24 24v40h40c13.3 0 24 10.7 24 24s-10.7 24-24 24h-40v40c0 13.3-10.7 24-24 24s-24-10.7-24-24v-40h-40c-13.3 0-24-10.7-24-24s10.7-24 24-24h40v-40c0-13.3 10.7-24 24-24z"
        }
    ]
};

const FasBellSchoolSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBellSchoolSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L570.7 422c3.4-6.6 5.3-14.1 5.3-22 0-26.5-21.5-48-48-48-12.1 0-23.1 4.5-31.5 11.8L445 323.5c22.1-33 35-72.8 35-115.5C480 93.1 386.9 0 272 0c-60.8 0-115.4 26.1-153.5 67.6L38.8 5.1zM220 147.2c14-11.9 32.1-19.2 52-19.2 44.2 0 80 35.8 80 80 0 12.9-3.1 25.1-8.5 35.9l-26.1-20.4c1.7-4.9 2.6-10.1 2.6-15.5 0-26.5-21.5-48-48-48-9.5 0-18.4 2.8-25.9 7.6L220 147.2zm288.3 349.3L465.8 463c-3.2.7-6.4 1-9.8 1h-40v-40.2l-16.1-12.7C362.9 434.5 319 448 272 448c-54 0-103.9-17.9-144-48v64c0 26.5 21.5 48 48 48h280c19.3 0 37.3-5.7 52.3-15.5zM373 389.9 71.5 152.4C66.6 170.1 64 188.7 64 208c0 114.9 93.1 208 208 208 36.7 0 71.1-9.5 101-26.1z"
        }
    ]
};

const FasBellSchool = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBellSchool",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M208 128a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm0 288a208 208 0 1 0 0-416 208 208 0 1 0 0 416zm48-208a48 48 0 1 0-96 0 48 48 0 1 0 96 0zm-48 240c-54 0-103.9-17.9-144-48v64c0 26.5 21.5 48 48 48h280c43.4 0 80.1-28.8 92-68.3 16.6-7.6 28-24.3 28-43.7 0-26.5-21.5-48-48-48s-48 21.5-48 48c0 15.5 7.3 29.2 18.7 38-8 15.4-24.1 26-42.7 26h-40v-64c-40.1 30.1-90 48-144 48z"
        }
    ]
};

const FasBellSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBellSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-87.5-68.6c.5-1.7.7-3.5.7-5.4 0-27.6-11-54.1-30.5-73.7L512 320c-20.5-20.5-32-48.3-32-77.3V208c0-77.4-55-142-128-156.8V32c0-17.7-14.3-32-32-32s-32 14.3-32 32v19.2c-42.6 8.6-79 34.2-102 69.3L38.8 5.1zM160 242.7c0 29-11.5 56.8-32 77.3l-1.5 1.5C107 341 96 367.5 96 395.2c0 11.5 9.3 20.8 20.8 20.8h289.4L160 222.1v20.7zM384 448H256c0 17 6.7 33.3 18.7 45.3S303 512 320 512s33.3-6.7 45.3-18.7S384 465 384 448z"
        }
    ]
};

const FasBell = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBell",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 0c-17.7 0-32 14.3-32 32v19.2C119 66 64 130.6 64 208v18.8c0 47-17.3 92.4-48.5 127.6l-7.4 8.3c-8.4 9.4-10.4 22.9-5.3 34.4S19.4 416 32 416h384c12.6 0 24-7.4 29.2-18.9s3.1-25-5.3-34.4l-7.4-8.3c-31.2-35.2-48.5-80.5-48.5-127.6V208c0-77.4-55-142-128-156.8V32c0-17.7-14.3-32-32-32zm45.3 493.3c12-12 18.7-28.3 18.7-45.3H160c0 17 6.7 33.3 18.7 45.3S207 512 224 512s33.3-6.7 45.3-18.7z"
        }
    ]
};

const FasBells = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBells",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m230.8 245.5 18.7 51.2c11.7 31.8 12.9 66.5 3.5 99.1l-1.1 3.9-230.5-83.9C10 311.7 2 301.5.6 289.5s4.1-23.8 14.3-30.4l8.2-5.4C57.6 231 84 197.8 98.2 159l14.7-40C138 50.4 214 15.1 282.6 40.1c4.8 1.7 9.4 3.7 13.9 6-64.1 42.2-93.3 124.2-65.7 199.5zm30.1-10.9c-26.1-71.3 10.5-150.2 81.9-176.2s150.4 10.8 176.5 82.1l18.7 51.2c14 38.2 39.8 71 73.6 93.6l13.7 9.2c10 6.7 15.4 18.5 14 30.4s-9.5 22.1-20.8 26.2L321.1 459.4c-11.3 4.1-24 1.5-32.8-6.7s-12.3-20.7-9-32.2l4.6-15.8c11.2-39 9.7-80.7-4.3-118.9l-18.8-51.2zM480.8 480c-21.2 0-40-10.2-51.7-25.9l116.1-42.3c.1 1.3.1 2.6.1 3.9 0 35.5-28.9 64.3-64.5 64.3zM94.3 376.1l117.6 43.4c-11.6 17.1-31.2 28.4-53.5 28.4-35.6 0-64.5-28.8-64.5-64.3 0-2.5.1-5.1.4-7.5z"
        }
    ]
};

const FasBenchTree = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBenchTree",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M608 96c0 5.1-.4 10.2-1.2 15.1 20.1 14.6 33.2 38.2 33.2 64.9 0 44.2-35.8 80-80 80h-16v224c0 17.7-14.3 32-32 32s-32-14.3-32-32V256h-16c-44.2 0-80-35.8-80-80 0-26.7 13.1-50.3 33.2-64.9-.8-4.9-1.2-10-1.2-15.1 0-53 43-96 96-96s96 43 96 96zM32 224c0-17.7 14.3-32 32-32h256c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32v-64zm0 128h320c17.7 0 32 14.3 32 32s-14.3 32-32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32v-64H96v64c0 17.7-14.3 32-32 32s-32-14.3-32-32v-64c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
        }
    ]
};

const FasBezierCurve = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBezierCurve",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M296 136V88h48v48h-48zm-8-104c-26.5 0-48 21.5-48 48v4H121.6C111.2 62.7 89.3 48 64 48 28.7 48 0 76.7 0 112s28.7 64 64 64c25.3 0 47.2-14.7 57.6-36h66.9c-58.9 39.6-98.9 105-104 180H80c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48v-64c0-26.5-21.5-48-48-48h-3.3c5.9-67 48.5-123.4 107.5-149.1 8.6 12.7 23.2 21.1 39.8 21.1h64c16.6 0 31.1-8.4 39.8-21.1 59 25.7 101.6 82.1 107.5 149.1H496c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48v-64c0-26.5-21.5-48-48-48h-4.5c-5-75-45.1-140.4-104-180h66.9c10.4 21.3 32.3 36 57.6 36 35.3 0 64-28.7 64-64s-28.7-64-64-64c-25.3 0-47.2 14.7-57.6 36H400v-4c0-26.5-21.5-48-48-48h-64zM88 376h48v48H88v-48zm416 48v-48h48v48h-48z"
        }
    ]
};

const FasBicycle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBicycle",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M312 32c-13.3 0-24 10.7-24 24s10.7 24 24 24h25.7l34.6 64H222.9l-27.4-38c-4.5-6.3-11.8-10-19.5-10h-56c-13.3 0-24 10.7-24 24s10.7 24 24 24h43.7l22.1 30.7-26.6 53.1c-10-2.5-20.5-3.8-31.2-3.8C57.3 224 0 281.3 0 352s57.3 128 128 128c65.3 0 119.1-48.9 127-112h49c8.5 0 16.3-4.5 20.7-11.8l84.8-143.5 21.7 40.1C402.4 276.3 384 312 384 352c0 70.7 57.3 128 128 128s128-57.3 128-128-57.3-128-128-128c-13.5 0-26.5 2.1-38.7 6L375.4 48.8C369.8 38.4 359 32 347.2 32H312zm146.6 271.7 32.3 59.7c6.3 11.7 20.9 16 32.5 9.7s16-20.9 9.7-32.5l-32.3-59.7c3.6-.6 7.4-.9 11.2-.9 39.8 0 72 32.2 72 72s-32.2 72-72 72-72-32.2-72-72c0-18.6 7-35.5 18.6-48.3zM133.2 368h65c-7.3 32.1-36 56-70.2 56-39.8 0-72-32.2-72-72s32.2-72 72-72c1.7 0 3.4.1 5.1.2l-24.2 48.5c-9 18.1 4.1 39.4 24.3 39.4zm33.7-48 50.7-101.3 72.9 101.2-.1.1H166.8zm90.6-128h108.4L317 274.8 257.4 192z"
        }
    ]
};

const FasBillboard = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBillboard",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 32c0-17.7-14.3-32-32-32s-32 14.3-32 32H256c0-17.7-14.3-32-32-32s-32 14.3-32 32H80c-26.5 0-48 21.5-48 48v272c-17.7 0-32 14.3-32 32s14.3 32 32 32h256v64c0 17.7 14.3 32 32 32s32-14.3 32-32v-64h256c17.7 0 32-14.3 32-32s-14.3-32-32-32V80c0-26.5-21.5-48-48-48H448zM320 352H96V96h96v32c-17.7 0-32 14.3-32 32s14.3 32 32 32h64c17.7 0 32-14.3 32-32s-14.3-32-32-32V96h128v32c-17.7 0-32 14.3-32 32s14.3 32 32 32h64c17.7 0 32-14.3 32-32s-14.3-32-32-32V96h96v256H320z"
        }
    ]
};

const FasBinBottlesRecycle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBinBottlesRecycle",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M152 0c-13.3 0-24 10.7-24 24v8c-8.8 0-16 7.2-16 16s7.2 16 16 16h128c8.8 0 16-7.2 16-16s-7.2-16-16-16v-8c0-13.3-10.7-24-24-24h-80zM32 192h320c0-26.5-10.7-50.5-28.1-67.9-1.1-1.1-2.1-2.1-3.2-3.1-17.1-15.5-39.7-25-64.6-25H128c-53 0-96 43-96 96zm352 0h191.1c-1.2-9.7-4.6-18.7-9.6-26.5 6.4-9.5 10.1-21 10.1-33.3 0-23.2-13.4-44.3-34.4-54.2L528 71.8c-5.3-2.5-10.8-4.4-16.4-5.7V24c0-13.3-10.7-24-24-24h-80c-13.3 0-24 10.7-24 24v42.1c-5.6 1.3-11.1 3.2-16.4 5.7L354.1 78c-7.2 3.4-13.5 8-18.6 13.6C365 115.1 384 151.3 384 192zM32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l24.2 169c4.5 31.5 31.5 55 63.4 55h401c31.8 0 58.9-23.4 63.4-55l24-169c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zm276.5 102.1-7.6 11.4c-4.8 7.2-14.5 9.3-21.8 4.7-7.6-4.8-9.8-14.9-4.8-22.4l7.6-11.4c8.5-12.7 22.8-20.4 38.1-20.4 15.4 0 29.8 7.7 38.2 20.6l8.5 12.9c4.9 7.5 2.7 17.6-4.9 22.4-7.4 4.6-17.1 2.5-21.8-4.8l-8.5-12.9c-2.6-3.9-6.9-6.2-11.5-6.2s-8.9 2.3-11.5 6.1zm-43.1 64.7-7.9 11.9c-.9 1.4-1.4 3.1-1.4 4.7 0 4.7 3.8 8.6 8.6 8.6h25.2c8.8 0 16 7.2 16 16s-7.2 16-16 16h-25.3c-22.4 0-40.6-18.2-40.6-40.6 0-8 2.4-15.8 6.8-22.5l7.9-11.9c4.8-7.2 14.5-9.3 21.8-4.7 7.6 4.8 9.8 14.9 4.8 22.4zm88.3 25.2h20.9c4.8 0 8.6-3.9 8.6-8.6 0-1.7-.5-3.3-1.4-4.7l-6.6-10.1c-4.9-7.5-2.7-17.6 4.9-22.4 7.4-4.6 17.1-2.5 21.8 4.8l6.6 10.1c4.4 6.6 6.7 14.4 6.7 22.4 0 22.4-18.2 40.6-40.6 40.6h-20.9c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FasBinBottles = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBinBottles",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M152 0h80c13.3 0 24 10.7 24 24v8c8.8 0 16 7.2 16 16s-7.2 16-16 16H128c-8.8 0-16-7.2-16-16s7.2-16 16-16v-8c0-13.3 10.7-24 24-24zM32 192c0-53 43-96 96-96h128c24.9 0 47.6 9.5 64.6 25 1.1 1 2.2 2 3.2 3.1 17.5 17.4 28.2 41.4 28.2 67.9H32zm352 0c0-40.7-19-76.9-48.6-100.4C340.6 86 346.9 81.3 354 78l13.2-6.2c5.3-2.5 10.8-4.4 16.4-5.7V24c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24v42.1c5.6 1.3 11.1 3.2 16.4 5.7l13.2 6.2c21 9.9 34.4 31 34.4 54.2 0 12.3-3.7 23.8-10.1 33.3 5 7.8 8.4 16.9 9.6 26.5H384zM0 256c0-17.7 14.3-32 32-32h576c17.7 0 32 14.3 32 32s-14.3 32-32 32l-24.2 169c-4.5 31.5-31.5 55-63.4 55h-401c-31.8 0-58.9-23.4-63.4-55L32 288c-17.7 0-32-14.3-32-32z"
        }
    ]
};

const FasBinRecycle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBinRecycle",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 64c0-17.7 14.3-32 32-32h512c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64zm32 64h512l-26.7 293.8c-3 33-30.6 58.2-63.7 58.2H122.4c-33.1 0-60.7-25.2-63.7-58.2L32 128zm256 88c2.2 0 4.3 1.1 5.5 2.9l20.7 29.6c7.3 10.5 21.6 13.4 32.4 6.6 11.7-7.3 14.8-22.9 6.9-34.1l-20.7-29.6c-10.2-14.6-27-23.3-44.8-23.3s-34.6 8.7-44.8 23.3L222.5 221c-7.9 11.3-4.7 26.8 6.9 34.1 10.8 6.8 25.1 3.9 32.4-6.6l20.7-29.6c1.3-1.8 3.3-2.9 5.5-2.9zm-88.3 77.1c-10.8-6.8-25.1-3.9-32.4 6.6l-21.5 30.7c-6.4 9.1-9.8 20-9.8 31.2 0 30.1 24.4 54.4 54.4 54.4H240c13.3 0 24-10.7 24-24s-10.7-24-24-24h-49.6c-3.5 0-6.4-2.9-6.4-6.4 0-1.3.4-2.6 1.2-3.7l21.5-30.7c7.9-11.3 4.7-26.8-6.9-34.1zM312 392c0 13.3 10.7 24 24 24h49.6c30.1 0 54.4-24.4 54.4-54.4 0-11.2-3.4-22.1-9.8-31.2l-21.5-30.7c-7.3-10.5-21.6-13.4-32.4-6.6-11.7 7.3-14.8 22.9-6.9 34.1l21.5 30.7c.8 1.1 1.2 2.4 1.2 3.7 0 3.5-2.9 6.4-6.4 6.4H336c-13.3 0-24 10.7-24 24z"
        }
    ]
};

const FasBinaryCircleCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBinaryCircleCheck",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M322.7 6C331 12 336 21.7 336 32v128h16c17.7 0 32 14.3 32 32s-14.3 32-32 32h-96c-17.7 0-32-14.3-32-32s14.3-32 32-32h16V76.4l-5.9 2c-16.8 5.6-34.9-3.5-40.5-20.2s3.5-34.9 20.2-40.5l48-16c9.8-3.3 20.6-1.7 28.9 4.3zm-224 288c8.3 6 13.3 15.7 13.3 26v128h16c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h16v-83.6l-5.9 2c-16.8 5.6-34.9-3.5-40.5-20.2s3.5-34.9 20.2-40.5l48-16c9.8-3.3 20.5-1.6 28.8 4.4zM64 0h64c35.3 0 64 28.7 64 64v96c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0zm0 64v96h64V64H64zm128 288c0-35.3 28.7-64 64-64h64c6.2 0 12.2.9 17.9 2.5-11.2 22.9-17.6 48.6-17.9 75.7V352h-64v96h83.2c7.8 15.3 17.8 29.3 29.5 41.5C357 503.3 339.5 512 320 512h-64c-35.3 0-64-28.7-64-64v-96zm128.7 32h-.7v-14.2c0 4.8.3 9.5.7 14.2zm31.3-16a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L480 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"
        }
    ]
};

const FasBinaryLock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBinaryLock",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M322.7 6c-8.3-6-19.1-7.7-28.8-4.4l-48 16c-16.8 5.6-25.8 23.7-20.2 40.5s23.7 25.8 40.5 20.2l5.9-2V160H256c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32h-16V32c0-10.3-4.9-19.9-13.3-26zm-224 288c-8.3-6-19.1-7.7-28.8-4.4l-48 16c-16.8 5.6-25.8 23.8-20.2 40.5s23.7 25.8 40.5 20.2l5.9-2V448H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32h-16V320c0-10.3-4.9-19.9-13.3-26zM64 0C28.7 0 0 28.7 0 64v96c0 35.3 28.7 64 64 64h64c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm0 64h64v96H64V64zm128 288v96c0 35.3 28.7 64 64 64h64c35.3 0 64-28.7 64-64v-96c0-35.3-28.7-64-64-64h-64c-35.3 0-64 28.7-64 64zm128 0v96h-64v-96h64zm208-112c17.7 0 32 14.3 32 32v48h-64v-48c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32v128c0 17.7 14.3 32 32 32h160c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32v-48c0-44.2-35.8-80-80-80s-80 35.8-80 80z"
        }
    ]
};

const FasBinarySlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBinarySlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L512 376v-24c0-35.3-28.7-64-64-64h-48.3L298 208.3c13.5-11.7 22-29 22-48.3V64c0-35.3-28.7-64-64-64h-64c-35.3 0-64 28.7-64 64v11L38.8 5.1zM192 125.2V64h64v96h-19.6L192 125.2zM464 32c0-10.3-4.9-19.9-13.3-26s-19.1-7.7-28.8-4.4l-48 16c-16.8 5.6-25.8 23.7-20.2 40.5s23.7 25.8 40.5 20.2l5.9-2V160H384c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32h-16V32zM240 320c0-10.3-4.9-19.9-13.3-26s-19.1-7.7-28.8-4.4l-48 16c-16.8 5.6-25.8 23.7-20.2 40.5s23.7 25.8 40.5 20.2l5.9-2V448H160c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32h-16V320zm80 32v96c0 35.3 28.7 64 64 64h64c20.1 0 38.1-9.3 49.8-23.8l-51-40.2H384v-49.5l-63.9-50.3c-.1 1.3-.1 2.5-.1 3.8z"
        }
    ]
};

const FasBinary = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBinary",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M336 32v128h16c17.7 0 32 14.3 32 32s-14.3 32-32 32h-96c-17.7 0-32-14.3-32-32s14.3-32 32-32h16V76.4l-5.9 2c-16.8 5.6-34.9-3.5-40.5-20.2s3.5-34.9 20.2-40.5l48-16c9.8-3.3 20.6-1.7 28.9 4.3S336 21.7 336 32zM112 320v128h16c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h16v-83.6l-5.9 2c-16.8 5.6-34.9-3.5-40.5-20.2s3.5-34.9 20.2-40.5l48-16c9.8-3.3 20.5-1.6 28.8 4.4s13.3 15.7 13.3 26zM0 64C0 28.7 28.7 0 64 0h64c35.3 0 64 28.7 64 64v96c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm128 0H64v96h64V64zm128 224h64c35.3 0 64 28.7 64 64v96c0 35.3-28.7 64-64 64h-64c-35.3 0-64-28.7-64-64v-96c0-35.3 28.7-64 64-64zm0 64v96h64v-96h-64z"
        }
    ]
};

const FasBinoculars = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBinoculars",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 32h32c17.7 0 32 14.3 32 32v32H96V64c0-17.7 14.3-32 32-32zm64 96v320c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32v-59.1c0-34.6 9.4-68.6 27.2-98.3C40.9 267.8 49.7 242.4 53 216l7.5-60c2-16 15.6-28 31.8-28H192zm227.8 0c16.1 0 29.8 12 31.8 28l7.4 60c3.3 26.4 12.1 51.8 25.8 74.6 17.8 29.7 27.2 63.7 27.2 98.3V448c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V128h99.8zM320 64c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32v32h-96V64zm-32 64v160h-64V128h64z"
        }
    ]
};

const FasBiohazard = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBiohazard",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M173.2 0c-1.8 0-3.5.7-4.8 2C138.5 32.3 120 74 120 120c0 26.2 6 50.9 16.6 73-22 2.4-43.8 9.1-64.2 20.5-34.5 19.3-59.1 48.9-72 82.5-.7 1.7-.5 3.7.5 5.2 2.2 3.7 7.4 4.3 10.6 1.3C64.2 254.3 158 245.1 205 324s-8.1 153.1-77.6 173.2c-4.2 1.2-6.3 5.9-4.1 9.6 1 1.6 2.6 2.7 4.5 3 36.5 5.9 75.2.1 109.7-19.2 20.4-11.4 37.4-26.5 50.5-43.8 13.1 17.3 30.1 32.4 50.5 43.8 34.5 19.3 73.3 25.2 109.7 19.2 1.9-.3 3.5-1.4 4.5-3 2.2-3.7.1-8.4-4.1-9.6C379.1 477.1 324 403 371 324s140.7-69.8 193.5-21.4c3.2 2.9 8.4 2.3 10.6-1.3 1-1.6 1.1-3.5.5-5.2-12.9-33.6-37.5-63.2-72.1-82.5a168.77 168.77 0 0 0-64.2-20.5C450 170.9 456 146.2 456 120c0-46-18.5-87.7-48.4-118-1.3-1.3-3-2-4.8-2-5 0-8.4 5.2-6.7 9.9C421.7 80.5 385.6 176 288 176S154.3 80.5 179.9 9.9c1.7-4.7-1.6-9.9-6.7-9.9zM240 272a48 48 0 1 1 96 0 48 48 0 1 1-96 0zm-58.3 145.6c6.3-11.8 9.8-25.1 8.6-39.8-19.5-18-34-41.4-41.2-67.8-12.5-8.1-26.2-11.8-40-12.4-9-.4-18.1.6-27.1 2.7 7.8 57.1 38.7 106.8 82.9 139.4 6.8-6.7 12.6-14.1 16.8-22.1zM288 64c-28.8 0-56.3 5.9-81.2 16.5 2 8.3 5 16.2 9 23.5 6.8 12.4 16.7 23.1 30.1 30.3 13.3-4.1 27.5-6.3 42.2-6.3s28.8 2.2 42.2 6.3c13.4-7.2 23.3-17.9 30.1-30.3 4-7.3 7-15.2 9-23.5C344.3 69.9 316.8 64 288 64zm138.9 246c-7.2 26.4-21.7 49.7-41.2 67.8-1.2 14.7 2.2 28.1 8.6 39.8 4.3 8 10 15.4 16.8 22.1 44.3-32.6 75.2-82.3 82.9-139.4-9-2.2-18.1-3.1-27.1-2.7-13.8.6-27.5 4.4-40 12.4z"
        }
    ]
};

const FasBird = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBird",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 192v-3.6C0 172.7 12.7 160 28.4 160H224c17.7 0 32-14.3 32-32V96c0-53 43-96 96-96 47.5 0 86.9 34.5 94.6 79.7l57.6 34.6c4.8 2.9 7.8 8.1 7.8 13.7s-2.9 10.8-7.8 13.7L448 175.5V192c0 93.9-57.7 174.3-139.7 207.6l40.9 77.2c6.2 11.7 1.7 26.2-10 32.4s-26.2 1.7-32.4-10l-45.7-86.3C249 415 236.6 416 224 416h-3l32.2 60.8c6.2 11.7 1.7 26.2-10 32.4s-26.2 1.7-32.4-10l-48.6-91.9C68.5 380.5 0 294.3 0 192zm376-72a24 24 0 1 0-48 0 24 24 0 1 0 48 0z"
        }
    ]
};

const FasBitcoinSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBitcoinSign",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 32C48 14.3 62.3 0 80 0s32 14.3 32 32v32h32V32c0-17.7 14.3-32 32-32s32 14.3 32 32v32c0 1.5-.1 3.1-.3 4.5C254.1 82.2 288 125.1 288 176c0 24.2-7.7 46.6-20.7 64.9 31.7 19.8 52.7 55 52.7 95.1 0 61.9-50.1 112-112 112v32c0 17.7-14.3 32-32 32s-32-14.3-32-32v-32h-32v32c0 17.7-14.3 32-32 32s-32-14.3-32-32v-32h-6.3C18.7 448 0 429.3 0 406.3V101.6C0 80.8 16.8 64 37.6 64H48V32zm16 192h112c26.5 0 48-21.5 48-48s-21.5-48-48-48H64v96zm112 64H64v96h144c26.5 0 48-21.5 48-48s-21.5-48-48-48h-32z"
        }
    ]
};

const FasBlanketFire = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBlanketFire",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 128v224c0 70.7 57.3 128 128 128h209.6c-16.5-18.6-29.6-40.3-38.1-64H128c-35.3 0-64-28.7-64-64s28.7-64 64-64h173.8c6.3-15.5 14.4-30.8 23.3-45.3 21.7-35.2 51.9-71.2 87.3-102.8 10-8.9 23-12.8 35.5-11.7v-.2c0-53-43-96-96-96H96C43 32 0 75 0 128zm288 222.1c0-9.8 1.3-19.9 3.6-30.1H128c-17.7 0-32 14.3-32 32s14.3 32 32 32h163c-2-11.1-3-22.4-3-33.9zm165.5-186.3c-2.8-2.5-6.3-3.7-9.8-3.8-3.6 0-7.2 1.2-10 3.7-33.2 29.7-61.4 63.4-81.4 95.8-19.7 31.9-32.4 66.2-32.4 92.6C320 439.9 390.3 512 480 512c88.7 0 160-72 160-159.8 0-20.2-9.6-50.9-24.2-79-14.8-28.5-35.7-58.5-60.4-81.1-5.6-5.1-14.4-5.2-20 0-9.6 8.8-18.6 19.6-26.5 29.5-17.3-20.7-35.8-39.9-55.5-57.7zM530 433c-15 10-31 15-49 15-45 0-81-29-81-78 0-24 15-45 45-82 4 5 62 79 62 79l36-42c3 4 5 8 7 12 18 33 10 75-20 96z"
        }
    ]
};

const FasBlanket = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBlanket",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 128v224c0 70.7 57.3 128 128 128h288c17.7 0 32-14.3 32-32s-14.3-32-32-32H128c-35.3 0-64-28.7-64-64s28.7-64 64-64h240c8.8 0 16 7.2 16 16s-7.2 16-16 16H128c-17.7 0-32 14.3-32 32s14.3 32 32 32h240c44.2 0 80-35.8 80-80V128c0-53-43-96-96-96H96C43 32 0 75 0 128z"
        }
    ]
};

const FasBlenderPhone = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBlenderPhone",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 352 196.8 52.3C194.2 24.2 216.3 0 244.6 0h289.5c21.1 0 36.4 20.1 30.9 40.4L558.5 64H400c-8.8 0-16 7.2-16 16s7.2 16 16 16h149.8l-17.5 64H400c-8.8 0-16 7.2-16 16s7.2 16 16 16h123.6l-17.5 64H400c-8.8 0-16 7.2-16 16s7.2 16 16 16h97.5L480 352H224zm-16 32h288c26.5 0 48 21.5 48 48v32c0 26.5-21.5 48-48 48H208c-26.5 0-48-21.5-48-48v-32c0-26.5 21.5-48 48-48zm144 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM147.5 30.7c10.8 6.7 15.3 21 10.6 33.4l-22 57.8c-4.2 10.9-14.5 17.6-25.3 16.4l-33.3-3.6c-13.6 42.2-13.6 88.4 0 130.7l33.3-3.6c10.9-1.2 21.2 5.5 25.3 16.4l22 57.8c4.7 12.4.2 26.7-10.6 33.4l-44 27.2c-9.7 6-21.9 4.2-29.8-4.3C-24.6 286-24.6 114 73.7 7.8c7.9-8.5 20.1-10.3 29.8-4.3l44 27.2z"
        }
    ]
};

const FasBlender = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBlender",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 64C0 28.7 28.7 0 64 0h406.1c21.1 0 36.4 20.1 30.9 40.4L494.5 64H336c-8.8 0-16 7.2-16 16s7.2 16 16 16h149.8l-17.5 64H336c-8.8 0-16 7.2-16 16s7.2 16 16 16h123.6l-17.5 64H336c-8.8 0-16 7.2-16 16s7.2 16 16 16h97.5L416 352H160l-8.7-96H64c-35.3 0-64-28.7-64-64V64zm145.5 128L133.8 64H64v128h81.5zM144 384h288c26.5 0 48 21.5 48 48v32c0 26.5-21.5 48-48 48H144c-26.5 0-48-21.5-48-48v-32c0-26.5 21.5-48 48-48zm144 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FasBlindsOpen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBlindsOpen",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 32C0 14.3 14.3 0 32 0h448c17.7 0 32 14.3 32 32s-14.3 32-32 32H160v194.7c13.6 4.8 24.4 15.6 29.3 29.3.1.3.2.7.4 1 1.5 4.7 2.4 9.7 2.4 15 0 26.5-21.5 48-48 48s-48-21.5-48-48c0-5.6 1-11 2.7-16 4.8-13.6 15.6-24.4 29.3-29.3V64H32C14.3 64 0 49.7 0 32zm47.4 96H96v64H17.8C8 192 0 184 0 174.2c0-4 1.4-7.9 3.9-11.1L22.4 140c6.1-7.6 15.3-12 25-12zm0 160h18.2c-1 5.2-1.6 10.5-1.6 16 0 18 6 34.6 16 48H17.8C8 352 0 344 0 334.2c0-4 1.4-7.9 3.9-11.1L22.4 300c6.1-7.6 15.3-12 25-12zm446.9 64H208c10-13.4 16-30 16-48 0-5.5-.6-10.8-1.6-16h242.2c9.7 0 18.9 4.4 25 12l18.5 23.1c2.5 3.2 3.9 7.1 3.9 11.1 0 9.8-8 17.8-17.8 17.8zm0-160H192v-64h272.6c9.7 0 18.9 4.4 25 12l18.5 23.1c2.5 3.2 3.9 7.1 3.9 11.1 0 9.8-8 17.8-17.8 17.8zM17.8 512C8 512 0 504 0 494.2c0-4 1.4-7.9 3.9-11.1L22.4 460c6.1-7.6 15.3-12 25-12h417.2c9.7 0 18.9 4.4 25 12l18.5 23.1c2.5 3.2 3.9 7.1 3.9 11.1 0 9.8-8 17.8-17.8 17.8H17.8z"
        }
    ]
};

const FasBlindsRaised = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBlindsRaised",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 0C14.3 0 0 14.3 0 32c0 11.9 6.5 22.2 16.1 27.8L1.2 100.6c-.8 2.2-1.2 4.6-1.2 7C0 118.9 9.1 128 20.4 128H128V64h32v64h331.6c11.3 0 20.4-9.1 20.4-20.4 0-2.4-.4-4.7-1.2-7l-14.9-40.8C505.5 54.2 512 43.9 512 32c0-17.7-14.3-32-32-32H32zm112 512c26.5 0 48-21.5 48-48 0-20.9-13.4-38.7-32-45.3V224h331.9c11.1 0 20.1-9 20.1-20.1 0-2.6-.5-5.1-1.4-7.5L496 160H160v64h-32v-64H16L1.4 196.4c-1 2.4-1.4 4.9-1.4 7.5C0 215 9 224 20.1 224H128v194.7c-18.6 6.6-32 24.4-32 45.3 0 26.5 21.5 48 48 48z"
        }
    ]
};

const FasBlinds = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBlinds",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 0C14.3 0 0 14.3 0 32c0 11.4 6 21.4 15 27.1L1.1 100.8c-.7 2.1-1.1 4.3-1.1 6.5C0 118.8 9.2 128 20.6 128H128V64h32v64h331.4c11.4 0 20.6-9.2 20.6-20.6 0-2.2-.4-4.4-1.1-6.5L497 59.1c9-5.7 15-15.7 15-27.1 0-17.7-14.3-32-32-32H32zm-8 160L1.1 228.8c-.7 2.1-1.1 4.3-1.1 6.5C0 246.8 9.2 256 20.6 256h78.1c4.8-13.6 15.6-24.4 29.3-29.3V160H24zm120 160c-20.9 0-38.7-13.4-45.3-32H24L1.1 356.8c-.7 2.1-1.1 4.3-1.1 6.5C0 374.8 9.2 384 20.6 384h470.8c11.4 0 20.6-9.2 20.6-20.6 0-2.2-.4-4.4-1.1-6.5L488 288H189.3c-6.6 18.6-24.4 32-45.3 32zm16-93.3c13.6 4.8 24.4 15.6 29.3 29.3h302.1c11.4 0 20.6-9.2 20.6-20.6 0-2.2-.4-4.4-1.1-6.5L488 160H160v66.7zM20.6 512h470.8c11.4 0 20.6-9.2 20.6-20.6 0-2.2-.4-4.4-1.1-6.5L488 416H24L1.1 484.8c-.7 2.1-1.1 4.3-1.1 6.5C0 502.8 9.2 512 20.6 512z"
        }
    ]
};

const FasBlockBrickFire = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBlockBrickFire",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 32v80h256V32H128zm-32 80V32c-35.3 0-64 28.7-64 64v16h64zm-64 32v96h208v-96H32zm0 224h64v-96H32v96zm0 32v16c0 35.3 28.7 64 64 64h144v-80H32zm240 0v80h65.6c-20.2-22.6-35.1-50-43.1-80H272zm208-256h-.6l.6.6v-.6zm-208 0v96h54.9c20.6-32.8 48.5-66.2 81-96H272zM128 272v96h160.8c-.5-5.9-.8-11.9-.8-17.9 0-25.4 8.5-52.4 21-78.1H128zm352-160V96c0-35.3-28.7-64-64-64v80h64zm-26.5 51.8c-2.8-2.5-6.3-3.7-9.8-3.8-3.6 0-7.2 1.2-10 3.7-33.2 29.7-61.4 63.4-81.4 95.8-19.7 31.9-32.4 66.2-32.4 92.6C320 439.9 390.3 512 480 512c88.7 0 160-72 160-159.8 0-20.2-9.6-50.9-24.2-79-14.8-28.5-35.7-58.5-60.4-81.1-5.6-5.1-14.4-5.2-20 0-9.6 8.8-18.6 19.6-26.5 29.5-17.3-20.7-35.8-39.9-55.5-57.7zM530 433c-15 10-31 15-49 15-45 0-81-29-81-78 0-24 15-45 45-82 4 5 62 79 62 79l36-42c3 4 5 8 7 12 18 33 10 75-20 96z"
        }
    ]
};

const FasBlockBrick = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBlockBrick",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 32v80h256V32H96zm-32 80V32C28.7 32 0 60.7 0 96v16h64zM0 144v96h208v-96H0zm0 224h64v-96H0v96zm0 32v16c0 35.3 28.7 64 64 64h144v-80H0zm240 0v80h144c35.3 0 64-28.7 64-64v-16H240zm208-32v-96h-64v96h64zm-96 0v-96H96v96h256zm96-224H240v96h208v-96zm0-32V96c0-35.3-28.7-64-64-64v80h64z"
        }
    ]
};

const FasBlockQuestion = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBlockQuestion",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 32c-35.3 0-64 28.7-64 64v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H160zm73.8 149.3c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1 0 22.6-12.1 43.5-31.7 54.8L344 280.4c-.2 13-10.9 23.6-24 23.6-13.3 0-24-10.7-24-24v-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1 0-8.4-6.8-15.1-15.1-15.1h-58.3c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM288 368a32 32 0 1 1 64 0 32 32 0 1 1-64 0zM144 104a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm328-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM144 408a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm328-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FasBlockQuote = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBlockQuote",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 64C14.3 64 0 78.3 0 96s14.3 32 32 32h384c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zm128 160c-17.7 0-32 14.3-32 32s14.3 32 32 32h256c17.7 0 32-14.3 32-32s-14.3-32-32-32H160zm-32 192c0 17.7 14.3 32 32 32h256c17.7 0 32-14.3 32-32s-14.3-32-32-32H160c-17.7 0-32 14.3-32 32zM32 224c-17.7 0-32 14.3-32 32v160c0 17.7 14.3 32 32 32s32-14.3 32-32V256c0-17.7-14.3-32-32-32z"
        }
    ]
};

const FasBlock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBlock",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H160c-35.3 0-64-28.7-64-64V96zm96 8a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm280 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM192 408a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm280 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FasBlog = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBlog",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 32c0 17.7 14.3 32 32 32 123.7 0 224 100.3 224 224 0 17.7 14.3 32 32 32s32-14.3 32-32C512 128.9 383.1 0 224 0c-17.7 0-32 14.3-32 32zm0 96c0 17.7 14.3 32 32 32 70.7 0 128 57.3 128 128 0 17.7 14.3 32 32 32s32-14.3 32-32c0-106-86-192-192-192-17.7 0-32 14.3-32 32zm-96 16c0-26.5-21.5-48-48-48S0 117.5 0 144v224c0 79.5 64.5 144 144 144s144-64.5 144-144-64.5-144-144-144h-16v96h16c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48V144z"
        }
    ]
};

const FasBlueberries = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBlueberries",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 176C512 78.8 433.2 0 336 0c-80.6 0-148.6 54.2-169.4 128.2 3.1-.1 6.3-.2 9.4-.2 114.9 0 208 93.1 208 208 0 3.2-.1 6.3-.2 9.4C457.8 324.6 512 256.6 512 176zM176 512a176 176 0 1 0 0-352 176 176 0 1 0 0 352zm0-304c8.8 0 16 7.2 16 16v32h32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32v32c0 8.8-7.2 16-16 16s-16-7.2-16-16v-32h-32c-8.8 0-16-7.2-16-16s7.2-16 16-16h32v-32c0-8.8 7.2-16 16-16zM384 64v32h32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32v32c0 8.8-7.2 16-16 16s-16-7.2-16-16v-32h-32c-8.8 0-16-7.2-16-16s7.2-16 16-16h32V64c0-8.8 7.2-16 16-16s16 7.2 16 16z"
        }
    ]
};

const FasBluetooth = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBluetooth",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M178.8 2.9c11.4-5.2 24.8-3.2 34.3 5.1l128 112c6.9 6 10.9 14.8 10.9 24s-4 18-10.9 24.1L240.6 256l100.5 87.9C348 350 352 358.8 352 368s-4 18-10.9 24.1l-128 112c-9.4 8.3-22.9 10.2-34.3 5.1S160 492.6 160 480V326.5l-74.9 65.6c-13.3 11.6-33.5 10.3-45.2-3s-10.3-33.5 3-45.2L143.4 256 42.9 168.1c-13.3-11.6-14.6-31.9-3-45.2s31.9-14.6 45.2-3l74.9 65.6V32c0-12.6 7.3-24 18.8-29.1zM224 326.5v83l47.4-41.5-47.4-41.5zm0-141 47.4-41.5-47.4-41.5v83z"
        }
    ]
};

const FasBold = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBold",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 64c0-17.7 14.3-32 32-32h192c70.7 0 128 57.3 128 128 0 31.3-11.3 60.1-30 82.3 37.1 22.4 62 63.1 62 109.7 0 70.7-57.3 128-128 128H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h16V96H32C14.3 96 0 81.7 0 64zm224 160c35.3 0 64-28.7 64-64s-28.7-64-64-64H112v128h112zm-112 64v128h144c35.3 0 64-28.7 64-64s-28.7-64-64-64H112z"
        }
    ]
};

const FasBoltAuto = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBoltAuto",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M317.4 44.6c5.9-13.7 1.5-29.7-10.6-38.5s-28.6-8-39.9 1.8l-256 224c-10 8.8-13.5 22.9-8.9 35.4S18.7 288 32 288h111.5L66.6 467.4c-5.9 13.7-1.5 29.7 10.6 38.5s28.6 8 39.9-1.8l256-224c10-8.8 13.6-22.9 8.9-35.3s-16.6-20.7-30-20.7H240.5l76.9-179.5zM464 288c-12.1 0-23.2 6.8-28.6 17.7l-80 160c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3l7.2-14.3h88.4l7.2 14.3c7.9 15.8 27.1 22.2 42.9 14.3s22.2-27.1 14.3-42.9l-80-160c-5.4-10.9-16.5-17.7-28.6-17.7zm-16.2 136 16.2-32.4 16.2 32.4h-32.4z"
        }
    ]
};

const FasBoltLightning = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBoltLightning",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 256 28.5 28c2-16 15.6-28 31.8-28h168.6c15 0 27.1 12.1 27.1 27.1 0 3.2-.6 6.5-1.7 9.5L208 160h139.3c20.2 0 36.7 16.4 36.7 36.7 0 7.4-2.2 14.6-6.4 20.7l-192.2 281c-5.9 8.6-15.6 13.7-25.9 13.7h-2.9c-15.7 0-28.5-12.8-28.5-28.5 0-2.3.3-4.6.9-6.9L176 288H32c-17.7 0-32-14.3-32-32z"
        }
    ]
};

const FasBoltSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBoltSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-182.4-143 52.7-46.1c10-8.8 13.6-22.9 8.9-35.3S493.4 224 480 224H368.5l76.9-179.4c5.9-13.7 1.5-29.7-10.6-38.5s-28.6-8-39.9 1.8L228.4 153.7 38.8 5.1zm100.1 226.8c-10 8.8-13.6 22.9-8.9 35.3s16.6 20.7 30 20.7h83.7l-88.9-70-15.9 13.9zm55.7 235.5c-5.9 13.7-1.5 29.7 10.6 38.5s28.6 8 39.9-1.8L374.4 391l-109.9-86.6-69.9 163z"
        }
    ]
};

const FasBolt = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBolt",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M349.4 44.6c5.9-13.7 1.5-29.7-10.6-38.5s-28.6-8-39.9 1.8l-256 224c-10 8.8-13.6 22.9-8.9 35.3S50.7 288 64 288h111.5L98.6 467.4c-5.9 13.7-1.5 29.7 10.6 38.5s28.6 8 39.9-1.8l256-224c10-8.8 13.6-22.9 8.9-35.3s-16.6-20.7-30-20.7H272.5l76.9-179.5z"
        }
    ]
};

const FasBomb = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBomb",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M459.1 52.4 442.6 6.5c-1.9-3.9-6.1-6.5-10.5-6.5s-8.5 2.6-10.4 6.5l-16.5 45.9-46 16.8c-4.3 1.6-7.3 5.9-7.2 10.4 0 4.5 3 8.7 7.2 10.2l45.7 16.8 16.8 45.8c1.5 4.4 5.8 7.5 10.4 7.5s8.9-3.1 10.4-7.5l16.5-45.8 45.7-16.8c4.2-1.5 7.2-5.7 7.2-10.2 0-4.6-3-8.9-7.2-10.4l-45.6-16.8zm-132.4 53c-12.5-12.5-32.8-12.5-45.3 0l-2.9 2.9c-22-8-45.8-12.3-70.5-12.3C93.1 96 0 189.1 0 304s93.1 208 208 208 208-93.1 208-208c0-24.7-4.3-48.5-12.2-70.5l2.9-2.9c12.5-12.5 12.5-32.8 0-45.3l-80-80zM200 192c-57.4 0-104 46.6-104 104v8c0 8.8-7.2 16-16 16s-16-7.2-16-16v-8c0-75.1 60.9-136 136-136h8c8.8 0 16 7.2 16 16s-7.2 16-16 16h-8z"
        }
    ]
};

const FasBoneBreak = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBoneBreak",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M344 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v80c0 13.3 10.7 24 24 24s24-10.7 24-24V24zM201 71c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l48 48c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-48-48zm272 34c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-48 48c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l48-48zM143.9 223.8C129.3 204.5 106.1 192 80 192c-44.2 0-80 35.8-80 80 0 35.8 23.5 66.1 55.9 76.3 4.6 1.5 8.3 5.1 9.3 9.8s-1.1 9.5-4.8 12.6C43.1 385.5 32 407.5 32 432c0 44.2 35.8 80 80 80s80-35.8 80-80c0-11.9 7-23.8 18.6-26.1L320 384l109.4 21.9C441 408.2 448 420.1 448 432c0 44.2 35.8 80 80 80s80-35.8 80-80c0-24.5-11.1-46.5-28.5-61.2-3.7-3.1-5.7-7.9-4.8-12.6s4.7-8.4 9.3-9.8c32.5-10.3 56-40.6 56-76.4 0-44.2-35.8-80-80-80-26.1 0-49.3 12.5-63.9 31.8-10.1 13.3-25.7 23.8-42.1 20.5l-70.6-14.1c-17.3-3.5-34.2 7.8-37.7 25.1L320 384l-25.7-128.6c-3.5-17.3-20.3-28.6-37.7-25.1L186 244.4c-16.4 3.3-32.1-7.2-42.1-20.5z"
        }
    ]
};

const FasBone = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBone",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M153.7 144.8c6.9 16.3 20.6 31.2 38.3 31.2h192c17.7 0 31.4-14.9 38.3-31.2C434.4 116.1 462.9 96 496 96c44.2 0 80 35.8 80 80 0 30.4-17 56.9-42 70.4-3.6 1.9-6 5.5-6 9.6s2.4 7.7 6 9.6c25 13.5 42 40 42 70.4 0 44.2-35.8 80-80 80-33.1 0-61.6-20.1-73.7-48.8-6.9-16.3-20.6-31.2-38.3-31.2H192c-17.7 0-31.4 14.9-38.3 31.2C141.6 395.9 113.1 416 80 416c-44.2 0-80-35.8-80-80 0-30.4 17-56.9 42-70.4 3.6-1.9 6-5.5 6-9.6s-2.4-7.7-6-9.6c-25-13.5-42-40-42-70.4 0-44.2 35.8-80 80-80 33.1 0 61.6 20.1 73.7 48.8z"
        }
    ]
};

const FasBong = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBong",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 208.5c0 29.1-15.6 53.9-37.2 67.8-17.2 11.1-31.5 26.1-41.7 43.7h221.8c-10.2-17.6-24.5-32.6-41.7-43.7-21.6-13.9-37.2-38.7-37.2-67.8V64h-64v144.5zM288 64v144.5c0 5.7 3.1 10.9 7.9 14 11.2 7.2 21.5 15.5 30.9 24.8l39.3-39.3-7-7c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l24 24 24 24c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-7-7-43.3 43.3C374 314.1 384 347.9 384 384c0 39.4-11.9 76.1-32.2 106.5-9.6 14.4-26.5 21.5-43.8 21.5H76.1c-17.3 0-34.2-7.1-43.8-21.5C11.9 460.1 0 423.4 0 384c0-67.8 35.1-127.3 88.1-161.5 4.8-3.1 7.9-8.3 7.9-14V64c-17.7 0-32-14.3-32-32S78.3 0 96 0h192c17.7 0 32 14.3 32 32s-14.3 32-32 32z"
        }
    ]
};

const FasBookArrowRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBookArrowRight",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 0C43 0 0 43 0 96v320c0 53 43 96 96 96h320c17.7 0 32-14.3 32-32s-14.3-32-32-32v-64c17.7 0 32-14.3 32-32V232h110.1l-39 39c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9l-80-80c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l39 39H448V32c0-17.7-14.3-32-32-32H96zm352 184v48H248c-13.3 0-24-10.7-24-24s10.7-24 24-24h200zM96 384h256v64H96c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
        }
    ]
};

const FasBookArrowUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBookArrowUp",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 96C0 43 43 0 96 0h320c17.7 0 32 14.3 32 32v320c0 17.7-14.3 32-32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32H96c-53 0-96-43-96-96V96zm64 320c0 17.7 14.3 32 32 32h256v-64h-88V209.9l39 39c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-80-80c-9.4-9.4-24.6-9.4-33.9 0l-80 80c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l39-39V384H96c-17.7 0-32 14.3-32 32z"
        }
    ]
};

const FasBookAtlas = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBookAtlas",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 96C0 43 43 0 96 0h320c17.7 0 32 14.3 32 32v320c0 17.7-14.3 32-32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32H96c-53 0-96-43-96-96V96zm64 320c0 17.7 14.3 32 32 32h256v-64H96c-17.7 0-32 14.3-32 32zm183.4-132.2c-3.7 3.7-6.2 4.2-7.4 4.2s-3.7-.5-7.4-4.2c-3.8-3.7-8-10-11.8-18.9-6.2-14.5-10.8-34.3-12.2-56.9h63c-1.5 22.6-6 42.4-12.2 56.9-3.8 8.9-8 15.2-11.8 18.9zm42.7-9.9c7.3-18.3 12-41.1 13.4-65.9h31.1c-4.7 27.9-21.4 51.7-44.5 65.9zm0-163.8c23.2 14.2 39.9 38 44.5 65.9h-31.1c-1.4-24.7-6.1-47.5-13.4-65.9zM368 192a128 128 0 1 0-256 0 128 128 0 1 0 256 0zm-222.7 16h31.1c1.4 24.7 6.1 47.5 13.4 65.9-23.2-14.2-39.9-38-44.5-65.9zm31.1-32h-31.1c4.7-27.9 21.4-51.7 44.5-65.9-7.3 18.3-12 41.1-13.4 65.9zm56.1-75.8c3.7-3.7 6.2-4.2 7.4-4.2s3.7.5 7.4 4.2c3.8 3.7 8 10 11.8 18.9 6.2 14.5 10.8 34.3 12.2 56.9h-63c1.5-22.6 6-42.4 12.2-56.9 3.8-8.9 8-15.2 11.8-18.9z"
        }
    ]
};

const FasBookBible = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBookBible",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 0C43 0 0 43 0 96v320c0 53 43 96 96 96h320c17.7 0 32-14.3 32-32s-14.3-32-32-32v-64c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H96zm0 384h256v64H96c-17.7 0-32-14.3-32-32s14.3-32 32-32zM208 80c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-48v112c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16V192h-48c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h48V80z"
        }
    ]
};

const FasBookBlank = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBookBlank",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 0C43 0 0 43 0 96v320c0 53 43 96 96 96h320c17.7 0 32-14.3 32-32s-14.3-32-32-32v-64c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H96zm0 384h256v64H96c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
        }
    ]
};

const FasBookBookmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBookBookmark",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 96C0 43 43 0 96 0h96v190.7c0 13.4 15.5 20.9 26 12.5l54-43.2 54 43.2c10.5 8.4 26 .9 26-12.5V0h64c17.7 0 32 14.3 32 32v320c0 17.7-14.3 32-32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32H96c-53 0-96-43-96-96V96zm64 320c0 17.7 14.3 32 32 32h256v-64H96c-17.7 0-32 14.3-32 32z"
        }
    ]
};

const FasBookCircleArrowRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBookCircleArrowRight",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 0C43 0 0 43 0 96v320c0 53 43 96 96 96h298.8a177.02 177.02 0 0 1-55.6-64H96c-17.7 0-32-14.3-32-32s14.3-32 32-32h224.7c-.5-5.3-.7-10.6-.7-16 0-80.6 54.1-148.5 128-169.4V32c0-17.7-14.3-32-32-32H96zm544 368a144 144 0 1 0-288 0 144 144 0 1 0 288 0zm-147.3-67.3c6.2-6.2 16.4-6.2 22.6 0l56 56c6.2 6.2 6.2 16.4 0 22.6l-56 56c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l28.7-28.7H432c-8.8 0-16-7.2-16-16s7.2-16 16-16h89.4l-28.7-28.7c-6.2-6.2-6.2-16.4 0-22.6z"
        }
    ]
};

const FasBookCircleArrowUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBookCircleArrowUp",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 0C43 0 0 43 0 96v320c0 53 43 96 96 96h298.8a177.02 177.02 0 0 1-55.6-64H96c-17.7 0-32-14.3-32-32s14.3-32 32-32h224.7c-.5-5.3-.7-10.6-.7-16 0-80.6 54.1-148.5 128-169.4V32c0-17.7-14.3-32-32-32H96zm400 224a144 144 0 1 0 0 288 144 144 0 1 0 0-288zm-67.3 147.3c-6.2-6.2-6.2-16.4 0-22.6l56-56c6.2-6.2 16.4-6.2 22.6 0l56 56c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L512 342.6V432c0 8.8-7.2 16-16 16s-16-7.2-16-16v-89.4l-28.7 28.7c-6.2 6.2-16.4 6.2-22.6 0z"
        }
    ]
};

const FasBookCopy = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBookCopy",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 96H96c-53 0-96 43-96 96v224c0 53 43 96 96 96h256c17.7 0 32-14.3 32-32s-14.3-32-32-32H96c-17.7 0-32-14.3-32-32s14.3-32 32-32h81.1c-10.9-18.8-17.1-40.7-17.1-64V96zm160 320h224c17.7 0 32-14.3 32-32s-14.3-32-32-32v-64c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H288c-53 0-96 43-96 96v224c0 24.6 9.2 47 24.4 64 17.6 19.6 43.1 32 71.6 32h32zm-64-96c0-17.7 14.3-32 32-32h192v64H288c-17.7 0-32-14.3-32-32z"
        }
    ]
};

const FasBookFont = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBookFont",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 96C0 43 43 0 96 0h320c17.7 0 32 14.3 32 32v320c0 17.7-14.3 32-32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32H96c-53 0-96-43-96-96V96zm64 320c0 17.7 14.3 32 32 32h256v-64H96c-17.7 0-32 14.3-32 32zM254.3 72.8C251.6 67.4 246 64 240 64s-11.6 3.4-14.3 8.8l-64 128-32 64c-4 7.9-.7 17.5 7.2 21.5s17.5.7 21.5-7.2l27.5-55.1h108.2l27.6 55.2c4 7.9 13.6 11.1 21.5 7.2s11.1-13.6 7.2-21.5l-32-64-64-128zm-14.3 43 38.1 76.2h-76.2l38.1-76.2z"
        }
    ]
};

const FasBookHeart = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBookHeart",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 96C0 43 43 0 96 0h320c17.7 0 32 14.3 32 32v320c0 17.7-14.3 32-32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32H96c-53 0-96-43-96-96V96zm64 320c0 17.7 14.3 32 32 32h256v-64H96c-17.7 0-32 14.3-32 32zm64-258.7c0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3 0-33.8-27.4-61.3-61.3-61.3-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4C221.1 102.5 205.5 96 189.3 96c-33.8 0-61.3 27.4-61.3 61.3z"
        }
    ]
};

const FasBookJournalWhills = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBookJournalWhills",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 96C0 43 43 0 96 0h320c17.7 0 32 14.3 32 32v320c0 17.7-14.3 32-32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32H96c-53 0-96-43-96-96V96zm64 320c0 17.7 14.3 32 32 32h256v-64H96c-17.7 0-32 14.3-32 32zm90.4-234.4-21.2-21.2c-3 10.1-5.1 20.6-5.1 31.6 0 .2 0 .5.1.8s.1.5.1.8l36.9 32.4c2.5 2.1 3.4 5.8 2.3 8.9-1.3 3-4.1 5.1-7.5 5.1-1.9-.1-3.8-.8-5.2-2l-23.6-20.6C142.8 267 186.9 304 240 304s97.3-37 108.9-86.6L325.3 238c-1.4 1.2-3.3 2-5.3 2-2.2-.1-4.4-1.1-6-2.8-1.2-1.5-1.9-3.4-2-5.2.1-2.2 1.1-4.4 2.8-6l37.1-32.5c0-.3 0-.5.1-.8s.1-.5.1-.8c0-11-2.1-21.5-5.1-31.6l-21.2 21.2c-3.1 3.1-8.1 3.1-11.3 0s-3.1-8.1 0-11.2l26.4-26.5c-8.2-17-20.5-31.7-35.9-42.6-2.7-1.9-6.2 1.4-5 4.5 8.5 22.4 3.6 48-13 65.6-3.2 3.4-3.6 8.9-.9 12.7 9.8 14 12.7 31.9 7.5 48.5-5.9 19.4-22 34.1-41.9 38.3l-1.4-34.3 12.6 8.6c.6.4 1.5.6 2.3.6 1.5 0 2.7-.8 3.5-2s.6-2.8-.1-4l-8.6-14.3 18-3.6c1.8-.4 3.1-2.1 3.1-4s-1.4-3.5-3.1-3.9l-18-3.7 8.5-14.3c.8-1.2.9-2.9.1-4.1s-2-2-3.5-2h-.1c-.7.1-1.5.3-2.1.7l-14.1 9.6L244 87.9c-.1-2.2-1.9-3.9-4-3.9s-3.9 1.6-4 3.9l-4.6 110.8-12-8.1c-1.5-1.1-3.6-.9-5 .4s-1.6 3.4-.8 5l8.6 14.3-18 3.7c-1.8.4-3.1 2-3.1 3.9s1.4 3.6 3.1 4l18 3.8-8.6 14.2c-.2.6-.5 1.4-.5 2 0 1.1.5 2.1 1.2 3 .8.6 1.8 1 2.8 1 .7 0 1.6-.2 2.2-.6l10.4-7.1-1.4 32.8c-19.9-4.1-36-18.9-41.9-38.3-5.1-16.6-2.2-34.4 7.6-48.5 2.7-3.9 2.3-9.3-.9-12.7-16.6-17.5-21.6-43.1-13.1-65.5 1.2-3.1-2.3-6.4-5-4.5-15.3 10.9-27.6 25.6-35.8 42.6l26.4 26.5c3.1 3.1 3.1 8.1 0 11.2s-8.1 3.1-11.2 0z"
        }
    ]
};

const FasBookMedical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBookMedical",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 96C0 43 43 0 96 0h320c17.7 0 32 14.3 32 32v320c0 17.7-14.3 32-32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32H96c-53 0-96-43-96-96V96zm64 320c0 17.7 14.3 32 32 32h256v-64H96c-17.7 0-32 14.3-32 32zm144-304v48h-48c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-48h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-48v-48c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16z"
        }
    ]
};

const FasBookOpenCover = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBookOpenCover",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M304 32v376L96 368V34.7c0-19.8 17.8-34.9 37.3-31.6L304 32zM89.7 405.1 320 451.2l230.3-46.1c15-3 25.7-16.1 25.7-31.4V28.8l25.7-5.1c19.8-4 38.3 11.1 38.3 31.3v366.8c0 15.3-10.8 28.4-25.7 31.4L320 512 25.7 453.1C10.8 450.2 0 437 0 421.8V55c0-20.2 18.5-35.3 38.3-31.3L64 28.8v345c0 15.3 10.8 28.4 25.7 31.4zM336 408V32L506.7 3.1C526.2-.2 544 14.9 544 34.7V368l-208 40z"
        }
    ]
};

const FasBookOpenReader = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBookOpenReader",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 96a96 96 0 1 1 192 0 96 96 0 1 1-192 0zm80 152v264l-48.4-24.2c-20.9-10.4-43.5-17-66.8-19.3l-96-9.6C12.5 457.2 0 443.5 0 427V224c0-17.7 14.3-32 32-32h30.3c63.6 0 125.6 19.6 177.7 56zm32 264V248c52.1-36.4 114.1-56 177.7-56H480c17.7 0 32 14.3 32 32v203c0 16.4-12.5 30.2-28.8 31.8l-96 9.6c-23.2 2.3-45.9 8.9-66.8 19.3L272 512z"
        }
    ]
};

const FasBookOpen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBookOpen",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M249.6 471.5c10.8 3.8 22.4-4.1 22.4-15.5V78.6c0-4.2-1.6-8.4-5-11C247.4 52 202.4 32 144 32 93.5 32 46.3 45.3 18.1 56.1 6.8 60.5 0 71.7 0 83.8v370.3c0 11.9 12.8 20.2 24.1 16.5C55.6 460.1 105.5 448 144 448c33.9 0 79 14 105.6 23.5zm76.8 0C353 462 398.1 448 432 448c38.5 0 88.4 12.1 119.9 22.6 11.3 3.8 24.1-4.6 24.1-16.5V83.8c0-12.1-6.8-23.3-18.1-27.6C529.7 45.3 482.5 32 432 32c-58.4 0-103.4 20-123 35.6-3.3 2.6-5 6.8-5 11V456c0 11.4 11.7 19.3 22.4 15.5z"
        }
    ]
};

const FasBookQuran = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBookQuran",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 0c53 0 96 43 96 96v320c0 53-43 96-96 96H32c-17.7 0-32-14.3-32-32s14.3-32 32-32v-64c-17.7 0-32-14.3-32-32V32C0 14.3 14.3 0 32 0h320zm0 384H96v64h256c17.7 0 32-14.3 32-32s-14.3-32-32-32zm-77.9-233.8-8.9 21.4-23.1 1.9c-5.7.5-8 7.5-3.7 11.2l17.6 15.1-5.4 22.6c-1.3 5.5 4.7 9.9 9.6 6.9l19.8-12.1 19.8 12.1c4.9 3 10.9-1.4 9.6-6.9l-5.4-22.6 17.6-15.1c4.3-3.7 2-10.8-3.7-11.2l-23.1-1.9-8.9-21.4c-2.2-5.3-9.6-5.3-11.8 0zM96 192c0 70.7 57.3 128 128 128 25.6 0 49.5-7.5 69.5-20.5 3.2-2.1 4.5-6.2 3.1-9.7s-5.2-5.6-9-4.8c-6.1 1.2-12.5 1.9-19 1.9-52.4 0-94.9-42.5-94.9-94.9s42.5-94.9 94.9-94.9c6.5 0 12.8.7 19 1.9 3.8.8 7.5-1.3 9-4.8s.2-7.6-3.1-9.7c-20-13-43.9-20.5-69.5-20.5-70.7 0-128 57.3-128 128z"
        }
    ]
};

const FasBookSection = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBookSection",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 96C0 43 43 0 96 0h320c17.7 0 32 14.3 32 32v320c0 17.7-14.3 32-32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32H96c-53 0-96-43-96-96V96zm64 320c0 17.7 14.3 32 32 32h256v-64H96c-17.7 0-32 14.3-32 32zm164.5-174.7 7.5 2c37.9 9.8 46.1 15 43.6 27.7-2.5 13.2-23.7 19.6-51.7 15.7-10.2-1.4-22.4-5.4-33.1-8.9l-5.9-1.9c-8.4-2.7-17.4 1.9-20.1 10.4-2.7 8.4 2 17.4 10.4 20.1l5.8 1.9c12 3.9 25.7 8.3 38.6 10.1 7 1 13.8 1.5 20.2 1.5 36.5 0 62.2-15.8 67.3-42.8 4.1-21.2-4-34.9-16.7-44.4 8.7-7.1 14.5-16.4 16.7-27.6 8.6-45.1-36.9-56.9-67-64.7l-7.3-1.9c-36.5-9.7-38-16.5-36.2-25.8 2.5-13.2 23.8-19.7 51.6-15.7 6.6.9 14.6 2.9 25.2 6.2 8.3 2.6 17.4-2.1 20-10.5 2.6-8.4-2.1-17.4-10.5-20-12.2-3.8-21.9-6.2-30.2-7.3-47.1-6.7-81.5 9.6-87.5 41.3-4.1 21.3 4.4 35.1 16.7 44.5-8.7 7.1-14.5 16.4-16.7 27.5-8.5 44.6 37.4 56.8 59.5 62.7zm-2.9-72.8c.9.2 10.3 2.7 10.3 2.7 37.9 9.8 46.1 15 43.6 27.7-2.2 11.3-16.5 14.9-25.2 16.1-3.6-1-17.7-4.7-17.7-4.7-36.5-9.7-38-16.5-36.2-25.8 2.2-11.3 16.5-14.9 25.2-16.1z"
        }
    ]
};

const FasBookSkull = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBookSkull",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 96C0 43 43 0 96 0h320c17.7 0 32 14.3 32 32v320c0 17.7-14.3 32-32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32H96c-53 0-96-43-96-96V96zm64 320c0 17.7 14.3 32 32 32h256v-64H96c-17.7 0-32 14.3-32 32zm256-304c0-35.3-35.8-64-80-64s-80 28.7-80 64c0 20.9 12.6 39.5 32 51.2V176c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-12.8c19.4-11.7 32-30.3 32-51.2zM208 96a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm-121.7 97.3c-8.1-3.5-17.5.3-21 8.4s.3 17.5 8.4 21l77.7 33.3-77.7 33.3c-8.1 3.5-11.9 12.9-8.4 21s12.9 11.9 21 8.4L240 289.4l105.7 45.3c8.1 3.5 17.5-.3 21-8.4s-.3-17.5-8.4-21L280.6 272l77.7-33.3c8.1-3.5 11.9-12.9 8.4-21s-12.9-11.9-21-8.4L240 254.6l-105.7-45.3z"
        }
    ]
};

const FasBookSparkles = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBookSparkles",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 0C43 0 0 43 0 96v320c0 53 43 96 96 96h320c17.7 0 32-14.3 32-32s-14.3-32-32-32v-64c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H96zm0 384h256v64H96c-17.7 0-32-14.3-32-32s14.3-32 32-32zm168-184 16.6-38.8c2.8-6.5 11.9-6.5 14.7 0L312 200l38.8 16.6c6.5 2.8 6.5 11.9 0 14.7L312 248l-16.6 38.8c-2.8 6.5-11.9 6.5-14.7 0L264 248l-38.8-16.6c-6.5-2.8-6.5-11.9 0-14.7L264 200zM168.8 78.3c2.9-5.9 11.4-5.9 14.3 0L192 96l17.7 8.8c5.9 2.9 5.9 11.4 0 14.3L192 128l-8.8 17.7c-2.9 5.9-11.4 5.9-14.3 0L160 128l-17.7-8.8c-5.9-2.9-5.9-11.4 0-14.3L160 96l8.8-17.7z"
        }
    ]
};

const FasBookTanakh = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBookTanakh",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 0c53 0 96 43 96 96v320c0 53-43 96-96 96H32c-17.7 0-32-14.3-32-32s14.3-32 32-32v-64c-17.7 0-32-14.3-32-32V32C0 14.3 14.3 0 32 0h320zm0 384H96v64h256c17.7 0 32-14.3 32-32s-14.3-32-32-32zM138.7 208l13.9 24h-27.7l13.9-24zm-13.9-24-27.7 48c-6.2 10.7 1.5 24 13.9 24h55.4l27.7 48c6.2 10.7 21.6 10.7 27.7 0l27.7-48H305c12.3 0 20-13.3 13.9-24l-27.7-48 27.7-48c6.2-10.7-1.5-24-13.9-24h-55.4l-27.7-48c-6.2-10.7-21.6-10.7-27.7 0l-27.7 48H111c-12.3 0-20 13.3-13.9 24l27.7 48zm27.7 0 27.7-48h55.4l27.7 48-27.7 48h-55.3l-27.7-48zm0-48-13.9 24-13.9-24h27.7zm41.6-24L208 88l13.9 24h-27.8zm69.3 24h27.7l-13.9 24-13.9-24zm13.9 72 13.9 24h-27.8l13.9-24zm-55.4 48L208 280l-13.9-24h27.7z"
        }
    ]
};

const FasBookUser = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBookUser",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 96C0 43 43 0 96 0h320c17.7 0 32 14.3 32 32v320c0 17.7-14.3 32-32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32H96c-53 0-96-43-96-96V96zm64 320c0 17.7 14.3 32 32 32h256v-64H96c-17.7 0-32 14.3-32 32zm240-288a64 64 0 1 0-128 0 64 64 0 1 0 128 0zM128 304c0 8.8 7.2 16 16 16h192c8.8 0 16-7.2 16-16 0-44.2-35.8-80-80-80h-64c-44.2 0-80 35.8-80 80z"
        }
    ]
};

const FasBook = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBook",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 0C43 0 0 43 0 96v320c0 53 43 96 96 96h320c17.7 0 32-14.3 32-32s-14.3-32-32-32v-64c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H96zm0 384h256v64H96c-17.7 0-32-14.3-32-32s14.3-32 32-32zm32-240c0-8.8 7.2-16 16-16h192c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16zm16 48h192c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FasBookmarkSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBookmarkSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L512 376V48c0-26.5-21.5-48-48-48H176c-26.5 0-48 21.5-48 48v27L38.8 5.1zM128 487.7c0 13.4 10.9 24.3 24.3 24.3 5 0 9.9-1.5 14-4.4L320 400l153.7 107.6c4.1 2.9 9 4.4 14 4.4 9.9 0 18.4-5.9 22.2-14.3L128 196.9v290.8z"
        }
    ]
};

const FasBookmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBookmark",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 48v439.7C0 501.1 10.9 512 24.3 512c5 0 9.9-1.5 14-4.4L192 400l153.7 107.6c4.1 2.9 9 4.4 14 4.4 13.4 0 24.3-10.9 24.3-24.3V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48z"
        }
    ]
};

const FasBooksMedical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBooksMedical",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C64 14.3 78.3 0 96 0h64c17.7 0 32 14.3 32 32v64H64V32zm0 384h128v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32v-64zM224 32c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v64H224V32zm0 96h128v256H224V128zm0 288h128v64c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32v-64zm203.6-19.9L384 232.6v-89.8l100.4-26.9 66 247.4-122.8 32.8zM476.2 85 384 109.6V11l36.9-9.9c16.9-4.6 34.4 5.5 38.9 22.6L476.2 85zm-40.4 342 122.8-32.9 16.3 61.1c4.5 17-5.5 34.5-22.5 39.1L491 510.8c-16.9 4.6-34.4-5.5-38.9-22.6L435.8 427zM64 176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-48v48c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-48H16c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h48v-48z"
        }
    ]
};

const FasBooks = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBooks",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 32C0 14.3 14.3 0 32 0h64c17.7 0 32 14.3 32 32v64H0V32zm0 96h128v256H0V128zm0 288h128v64c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32v-64zM160 32c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v64H160V32zm0 96h128v256H160V128zm0 288h128v64c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32v-64zm203.6-19.9L320 232.6v-89.8l100.4-26.9 66 247.4-122.8 32.8zM412.2 85 320 109.6V11l36.9-9.9c16.9-4.6 34.4 5.5 38.9 22.6L412.2 85zm-40.4 342 122.8-32.9 16.3 61.1c4.5 17-5.5 34.5-22.5 39.1L427 510.8c-16.9 4.6-34.4-5.5-38.9-22.6L371.8 427z"
        }
    ]
};

const FasBoombox = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBoombox",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M120 48h400c22.1 0 40 17.9 40 40v72H448c0-17.7-14.3-32-32-32s-32 14.3-32 32h-32c0-17.7-14.3-32-32-32s-32 14.3-32 32h-32c0-17.7-14.3-32-32-32s-32 14.3-32 32H80V88c0-22.1 17.9-40 40-40zm488 120.6V88c0-48.6-39.4-88-88-88H120C71.4 0 32 39.4 32 88v80.6c-19.1 11-32 31.7-32 55.4v224c0 35.3 28.7 64 64 64h512c35.3 0 64-28.7 64-64V224c0-23.7-12.9-44.4-32-55.4zM256 336a80 80 0 1 0-160 0 80 80 0 1 0 160 0zm-192 0a112 112 0 1 1 224 0 112 112 0 1 1-224 0zm400 80a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0-192a112 112 0 1 1 0 224 112 112 0 1 1 0-224z"
        }
    ]
};

const FasBootHeeled = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBootHeeled",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 0H63.3C46 0 32 14 32 31.3c0 1.8.1 3.9.6 6.2C34.6 47.1 56 154.3 56 232c0 33.2-12.8 93.5-19.7 123.2-2.7 11.8-4.3 24.1-4.3 36.6V488c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24v-15.1l125 34.7c10.5 2.9 21.3 4.4 32.1 4.4H488c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8v-34.3c0-27.3-15.4-52.2-39.8-64.4l-112.4-56.2a71.96 71.96 0 0 1-39.8-64.4V24c0-13.3-10.7-24-24-24H160v240c0 8.8-7.2 16-16 16s-16-7.2-16-16V0z"
        }
    ]
};

const FasBoot = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBoot",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 32C0 14.3 14.3 0 32 0h288c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H0V32zm0 425.4V448h512v9.4c0 14.5-5.8 28.4-16 38.6s-24.1 16-38.6 16h-14.9c-17 0-33.3-6.7-45.3-18.7l-7.6-7.6c-3.1-3.1-8.2-3.1-11.3 0l-7.6 7.6c-12 12-28.3 18.7-45.3 18.7h-11c-17 0-33.3-6.7-45.3-18.7l-7.6-7.6c-3.1-3.1-8.2-3.1-11.3 0l-7.6 7.6c-12 12-28.3 18.7-45.3 18.7h-11c-17 0-33.3-6.7-45.3-18.7l-7.6-7.6c-3.1-3.1-8.2-3.1-11.3 0l-7.6 7.6c-12 12-28.3 18.7-45.3 18.7H54.6c-14.5 0-28.4-5.8-38.6-16S0 471.9 0 457.4zM0 416V128h320v32h-48c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v32h-48c-8.8 0-16 7.2-16 16s7.2 16 16 16h48l119.3 29.8C482 296.5 512 334.9 512 379v37H0z"
        }
    ]
};

const FasBoothCurtain = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBoothCurtain",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 0C28.7 0 0 28.7 0 64v416c0 17.7 14.3 32 32 32s32-14.3 32-32V64h64V0H64zm448 64c0-35.3-28.7-64-64-64H192c-17.7 0-32 14.3-32 32v368c0 26.5 21.5 48 48 48s48-21.5 48-48c0 26.5 21.5 48 48 48s48-21.5 48-48c0 26.5 21.5 48 48 48s48-21.5 48-48v80c0 17.7 14.3 32 32 32s32-14.3 32-32V64z"
        }
    ]
};

const FasBorderAll = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBorderAll",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 96v128H256V96h128zm0 192v128H256V288h128zm-192-64H64V96h128v128zM64 288h128v128H64V288zm0-256C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z"
        }
    ]
};

const FasBorderBottomRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBorderBottomRight",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 64c0-17.7-14.3-32-32-32s-32 14.3-32 32v336c0 8.8-7.2 16-16 16H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h336c44.2 0 80-35.8 80-80V64zm-160 0a32 32 0 1 0 64 0 32 32 0 1 0-64 0zM96 64a32 32 0 1 0 64 0 32 32 0 1 0-64 0zm96 0a32 32 0 1 0 64 0 32 32 0 1 0-64 0zM0 64a32 32 0 1 0 64 0 32 32 0 1 0-64 0zm32 160a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0-32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 128a32 32 0 1 0 0 64 32 32 0 1 0 0-64z"
        }
    ]
};

const FasBorderBottom = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBorderBottom",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 448c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h384c17.7 0 32 14.3 32 32zm-64-96a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm-320 0a32 32 0 1 1-64 0 32 32 0 1 1 64 0zm128 0a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm256-192a32 32 0 1 1-64 0 32 32 0 1 1 64 0zM0 160a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm256 0a32 32 0 1 1-64 0 32 32 0 1 1 64 0zm128 96a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm-320 0a32 32 0 1 1-64 0 32 32 0 1 1 64 0zm128 0a32 32 0 1 1 64 0 32 32 0 1 1-64 0zM448 64a32 32 0 1 1-64 0 32 32 0 1 1 64 0zM0 64a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm256 0a32 32 0 1 1-64 0 32 32 0 1 1 64 0zm32 192a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm64-192a32 32 0 1 1-64 0 32 32 0 1 1 64 0zM96 64a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm64 192a32 32 0 1 1-64 0 32 32 0 1 1 64 0z"
        }
    ]
};

const FasBorderCenterH = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBorderCenterH",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 480a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm96 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-384a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm192 320a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0-320a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-96 320a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0-320a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm192 320a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0-384a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM32 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm192 224a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm192 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM32 320a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm384-128a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM32 128a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm192 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32h384c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"
        }
    ]
};

const FasBorderCenterV = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBorderCenterV",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 448a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm0-96a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm-384 0a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm320-192a32 32 0 1 0 64 0 32 32 0 1 0-64 0zm-320 0a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm320 96a32 32 0 1 0 64 0 32 32 0 1 0-64 0zm-320 0a32 32 0 1 0-64 0 32 32 0 1 0 64 0zM384 64a32 32 0 1 0 64 0 32 32 0 1 0-64 0zM0 64a32 32 0 1 0 64 0 32 32 0 1 0-64 0zm64 384a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm224-192a32 32 0 1 0 64 0 32 32 0 1 0-64 0zm64-192a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm-64 384a32 32 0 1 0 64 0 32 32 0 1 0-64 0zM160 64a32 32 0 1 0-64 0 32 32 0 1 0 64 0zM96 448a32 32 0 1 0 64 0 32 32 0 1 0-64 0zm64-192a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm32 192c0 17.7 14.3 32 32 32s32-14.3 32-32V64c0-17.7-14.3-32-32-32s-32 14.3-32 32v384z"
        }
    ]
};

const FasBorderInner = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBorderInner",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 448a32 32 0 1 1-64 0 32 32 0 1 1 64 0zm96 0a32 32 0 1 1-64 0 32 32 0 1 1 64 0zm0-384a32 32 0 1 1-64 0 32 32 0 1 1 64 0zm160 352a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm32-352a32 32 0 1 1-64 0 32 32 0 1 1 64 0zm64 352a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-384a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 64a32 32 0 1 1-64 0 32 32 0 1 1 64 0zm352 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 352a32 32 0 1 1-64 0 32 32 0 1 1 64 0zm352-224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 160a32 32 0 1 1-64 0 32 32 0 1 1 64 0zM0 256c0-17.7 14.3-32 32-32h160V64c0-17.7 14.3-32 32-32s32 14.3 32 32v160h160c17.7 0 32 14.3 32 32s-14.3 32-32 32H256v160c0 17.7-14.3 32-32 32s-32-14.3-32-32V288H32c-17.7 0-32-14.3-32-32z"
        }
    ]
};

const FasBorderLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBorderLeft",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 480c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32s32 14.3 32 32v384c0 17.7-14.3 32-32 32zm96-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-320a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm192 256a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0-448a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 256a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm-96 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-320a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm192 256a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0-448a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 256a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm-192 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm192 64a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0-256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-192 64a32 32 0 1 1 0-64 32 32 0 1 1 0 64z"
        }
    ]
};

const FasBorderNone = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBorderNone",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 480a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm96-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-384a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 256a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm192 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-320a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-96 256a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0-448a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 256a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm192 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-384a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM32 96a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm384 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM32 288a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm192 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm192 64a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM32 320a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm384-128a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM32 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm192 64a32 32 0 1 1 0-64 32 32 0 1 1 0 64z"
        }
    ]
};

const FasBorderOuter = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBorderOuter",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 96v320h320V96H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm224 96a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm-64 64a32 32 0 1 1-64 0 32 32 0 1 1 64 0zm64 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm128-32a32 32 0 1 1-64 0 32 32 0 1 1 64 0zM224 384a32 32 0 1 1 0-64 32 32 0 1 1 0 64z"
        }
    ]
};

const FasBorderRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBorderRight",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M416 32c17.7 0 32 14.3 32 32v384c0 17.7-14.3 32-32 32s-32-14.3-32-32V64c0-17.7 14.3-32 32-32zm-96 64a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0 320a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-128a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM128 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 448a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0-256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96-128a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0 320a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-128a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM32 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 448a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0-256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm192-32a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM32 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 256a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm192-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FasBorderTopLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBorderTopLeft",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 448c0 17.7 14.3 32 32 32s32-14.3 32-32V112c0-8.8 7.2-16 16-16h336c17.7 0 32-14.3 32-32s-14.3-32-32-32H80C35.8 32 0 67.8 0 112v336zm160 0a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm192 0a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm-96 0a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm192 0a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm-32-160a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0-128a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FasBorderTop = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBorderTop",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 64c0-17.7 14.3-32 32-32h384c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64zm64 96a32 32 0 1 1-64 0 32 32 0 1 1 64 0zm320 0a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm-128 0a32 32 0 1 1-64 0 32 32 0 1 1 64 0zM0 352a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm448 0a32 32 0 1 1-64 0 32 32 0 1 1 64 0zm-256 0a32 32 0 1 1 64 0 32 32 0 1 1-64 0zM64 256a32 32 0 1 1-64 0 32 32 0 1 1 64 0zm320 0a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm-128 0a32 32 0 1 1-64 0 32 32 0 1 1 64 0zM0 448a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm448 0a32 32 0 1 1-64 0 32 32 0 1 1 64 0zm-256 0a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm-32-192a32 32 0 1 1-64 0 32 32 0 1 1 64 0zM96 448a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm256 0a32 32 0 1 1-64 0 32 32 0 1 1 64 0zm-64-192a32 32 0 1 1 64 0 32 32 0 1 1-64 0z"
        }
    ]
};

const FasBoreHole = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBoreHole",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 0c-17.7 0-32 14.3-32 32v264.6c-19.1 11.1-32 31.7-32 55.4 0 35.3 28.7 64 64 64s64-28.7 64-64c0-23.7-12.9-44.4-32-55.4V32c0-17.7-14.3-32-32-32zM48 128c-26.5 0-48 21.5-48 48v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48h-80c-17.7 0-32 14.3-32 32v192c0 53-43 96-96 96s-96-43-96-96V160c0-17.7-14.3-32-32-32H48z"
        }
    ]
};

const FasBottleDroplet = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBottleDroplet",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 0C82.7 0 72 10.7 72 24s10.7 24 24 24c4.4 0 8 3.6 8 8v64.9c0 12.2-7.2 23.1-17.2 30.1C53.7 174.1 32 212.5 32 256v192c0 35.3 28.7 64 64 64h128c35.3 0 64-28.7 64-64V256c0-43.5-21.7-81.9-54.8-105-10-7-17.2-17.9-17.2-30.1V56c0-4.4 3.6-8 8-8 13.3 0 24-10.7 24-24S237.3 0 224 0H96zm64 382c-26.5 0-48-20.1-48-45 0-16.8 22.1-48.1 36.3-66.4 6-7.8 17.5-7.8 23.5 0 14.1 18.3 36.2 49.6 36.2 66.4 0 24.9-21.5 45-48 45z"
        }
    ]
};

const FasBottleWater = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBottleWater",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M120 0h80c13.3 0 24 10.7 24 24v40H96V24c0-13.3 10.7-24 24-24zM32 151.7c0-15.6 9-29.8 23.2-36.5l24.4-11.4c11-5.1 23-7.8 35.1-7.8h90.6c12.1 0 24.1 2.7 35.1 7.8l24.4 11.4c14.1 6.6 23.2 20.8 23.2 36.5 0 14.4-7.5 27-18.9 34.1 11.5 8.8 18.9 22.6 18.9 38.2 0 16.7-8.5 31.4-21.5 40 12.9 8.6 21.5 23.3 21.5 40s-8.5 31.4-21.5 40c12.9 8.6 21.5 23.3 21.5 40s-8.5 31.4-21.5 40c12.9 8.6 21.5 23.3 21.5 40 0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48 0-16.7 8.5-31.4 21.5-40-13-8.6-21.5-23.3-21.5-40s8.5-31.4 21.5-40c-13-8.6-21.5-23.3-21.5-40s8.5-31.4 21.5-40c-13-8.6-21.5-23.3-21.5-40 0-15.6 7.4-29.4 18.9-38.2-11.4-7.1-18.9-19.7-18.9-34.1zM96 240c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16h-96c-8.8 0-16 7.2-16 16zm16 112c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16h-96z"
        }
    ]
};

const FasBowArrow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBowArrow",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M511.7 18.9c1-5.2-.7-10.5-4.4-14.3S498.2-.7 493.1.3l-128 24c-5.8 1.1-10.6 5.3-12.3 11s-.2 11.8 4 16l35 35-247.2 247.1-50.8-12.7c-8.2-2-16.8.4-22.8 6.3L7 391c-6.1 6.1-8.5 15-6.2 23.4s8.9 14.8 17.3 16.9l50 12.5 12.5 50c2.1 8.4 8.5 15 16.9 17.3s17.3 0 23.4-6.2l64-64c6-6 8.4-14.6 6.3-22.8l-12.7-50.8 247.2-247 35 35c4.2 4.2 10.4 5.7 16 4s9.9-6.5 11-12.3l24-128zm-458 85.5c-12.6-11.6-32.1-11.3-44.3.9-12.5 12.5-12.5 32.8 0 45.3L145.8 287l45.2-45.2-90.6-90.6c56.5-30.7 125.2-30.9 181.9-.7l46.8-46.8c-83.8-53.2-191.8-53-275.4.8zm307.8 125.3c30.2 56.7 30 125.4-.7 181.9L270.2 321 225 366.2l136.4 136.4c12.5 12.5 32.8 12.5 45.3 0 12.2-12.2 12.5-31.8.9-44.3 53.7-83.6 54-191.6.8-275.4l-46.8 46.8z"
        }
    ]
};

const FasBowlChopsticksNoodles = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBowlChopsticksNoodles",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M13.1 93.6 128 72V56c0-13.3 10.7-24 24-24s24 10.7 24 24v168h32V40c0-13.3 10.7-24 24-24s24 10.7 24 24v184h222.4c18.2 0 32.7 15.3 31.6 33.5-5.4 91.7-59.7 169.7-136.4 209.7l-1.2 9.7c-2.5 20-19.5 35-39.7 35H179.3c-20.2 0-37.2-15-39.7-35l-1.2-9.7C61.6 427.2 7.4 349.3 2 257.5.9 239.3 15.4 224 33.6 224H128v-48H16.2C7.3 176 0 168.7 0 159.7c0-8.8 7-16 15.7-16.2L128 140v-32L18.5 125.1c-9.7 1.5-18.5-6-18.5-15.8 0-7.7 5.5-14.3 13.1-15.7zM488.4 176H288v-41l199.6-6.2c13.4-.5 24.4 10.2 24.4 23.6 0 13-10.6 23.6-23.6 23.6zm3.9-124.9L288 83V42L484.4 5.2c14.3-2.7 27.6 8.3 27.6 22.9 0 11.5-8.4 21.2-19.7 23z"
        }
    ]
};

const FasBowlChopsticks = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBowlChopsticks",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m18.5 125.1 473.8-74c11.3-1.8 19.7-11.5 19.7-23 0-14.6-13.3-25.6-27.6-22.9L13.1 93.6C5.5 95 0 101.6 0 109.3c0 9.8 8.8 17.3 18.5 15.8zM0 159.7c0 9 7.3 16.2 16.2 16.2h472.2c13 0 23.6-10.6 23.6-23.6 0-13.3-11-24-24.4-23.6L15.7 143.5C7 143.8 0 151 0 159.7zM33.6 224C15.4 224 .9 239.3 2 257.5c5.4 91.7 59.7 169.7 136.4 209.7l1.2 9.7c2.5 20 19.5 35 39.7 35h153.4c20.2 0 37.2-15 39.7-35l1.2-9.7c76.8-40 131-118 136.4-209.7 1.1-18.2-13.4-33.5-31.6-33.5H33.6z"
        }
    ]
};

const FasBowlFood = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBowlFood",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 192c0-35.3 28.7-64 64-64h1.6C73 91.5 105.3 64 144 64c15 0 29 4.1 40.9 11.2C198.2 49.6 225.1 32 256 32s57.8 17.6 71.1 43.2C339 68.1 353 64 368 64c38.7 0 71 27.5 78.4 64h1.6c35.3 0 64 28.7 64 64 0 11.7-3.1 22.6-8.6 32H8.6C3.1 214.6 0 203.7 0 192zm0 91.4C0 268.3 12.3 256 27.4 256h457.2c15.1 0 27.4 12.3 27.4 27.4 0 70.5-44.4 130.7-106.7 154.1l-1.8 14.5c-2 16-15.6 28-31.8 28H140.2c-16.1 0-29.8-12-31.8-28l-1.8-14.4C44.4 414.1 0 353.9 0 283.4z"
        }
    ]
};

const FasBowlHot = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBowlHot",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M152 0c-13.3 0-24 10.7-24 24v8c0 32.7 15.4 63.6 41.6 83.2 14.1 10.6 22.4 27.2 22.4 44.8v8c0 13.3 10.7 24 24 24s24-10.7 24-24v-8c0-32.7-15.4-63.6-41.6-83.2C184.3 66.2 176 49.6 176 32v-8c0-13.3-10.7-24-24-24zM33.6 224C15.4 224 .9 239.3 2 257.5c5.4 91.7 59.7 169.7 136.4 209.7l1.2 9.7c2.5 20 19.5 35 39.7 35h153.4c20.2 0 37.2-15 39.7-35l1.2-9.7c76.8-40 131-118 136.4-209.7 1.1-18.2-13.4-33.5-31.6-33.5H33.6zM304 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v8c0 32.7 15.4 63.6 41.6 83.2 14.1 10.6 22.4 27.2 22.4 44.8v8c0 13.3 10.7 24 24 24s24-10.7 24-24v-8c0-32.7-15.4-63.6-41.6-83.2C312.3 66.2 304 49.6 304 32v-8z"
        }
    ]
};

const FasBowlRice = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBowlRice",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 56c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24s-10.7 24-24 24h-16c-13.3 0-24-10.7-24-24zm24 48h16c13.3 0 24 10.7 24 24s-10.7 24-24 24h-16c-13.3 0-24-10.7-24-24s10.7-24 24-24zM56 176h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-13.3 0-24-10.7-24-24s10.7-24 24-24zM0 283.4C0 268.3 12.3 256 27.4 256h457.2c15.1 0 27.4 12.3 27.4 27.4 0 70.5-44.4 130.7-106.7 154.1l-1.8 14.5c-2 16-15.6 28-31.8 28H140.2c-16.1 0-29.8-12-31.8-28l-1.8-14.4C44.4 414.1 0 353.9 0 283.4zM224 200c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24s-10.7 24-24 24h-16c-13.3 0-24-10.7-24-24zm-96 0c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24s-10.7 24-24 24h-16c-13.3 0-24-10.7-24-24zm-24-96h16c13.3 0 24 10.7 24 24s-10.7 24-24 24h-16c-13.3 0-24-10.7-24-24s10.7-24 24-24zm216 96c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24s-10.7 24-24 24h-16c-13.3 0-24-10.7-24-24zm-24-96h16c13.3 0 24 10.7 24 24s-10.7 24-24 24h-16c-13.3 0-24-10.7-24-24s10.7-24 24-24zm120 96c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24s-10.7 24-24 24h-16c-13.3 0-24-10.7-24-24zm-24-96h16c13.3 0 24 10.7 24 24s-10.7 24-24 24h-16c-13.3 0-24-10.7-24-24s10.7-24 24-24zm-96-72h16c13.3 0 24 10.7 24 24s-10.7 24-24 24h-16c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
        }
    ]
};

const FasBowlScoop = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBowlScoop",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 224h384c0-106-86-192-192-192S32 118 32 224zm-16 32c-4.6 0-9 2-12 5.4s-4.5 8-3.9 12.6l2 15.9c9 72 70.3 126.1 142.9 126.1h40.4l-68.7 68.7c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9h192c6.5 0 12.3-3.9 14.8-9.9s1.1-12.9-3.5-17.4L262.6 416H303c72.6 0 133.9-54.1 142.9-126.1l2-15.9c.6-4.6-.8-9.1-3.9-12.6s-7.4-5.4-12-5.4H16z"
        }
    ]
};

const FasBowlScoops = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBowlScoops",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 208c0 5.4.4 10.8 1.1 16h221.8c.7-5.2 1.1-10.6 1.1-16 0-61.9-50.1-112-112-112h-1.1c-38.7.4-72.7 20.4-92.6 50.6-11.6 17.6-18.3 38.7-18.3 61.4zM0 208c0 5.4.4 10.8 1.1 16h191.8c-.6-5.3-.9-10.6-.9-16 0-22 4.9-42.8 13.7-61.4-13.9-21.2-34.9-37.4-59.6-45.3-10.7-3.4-22.2-5.3-34.1-5.3C50.1 96 0 146.1 0 208zM325.4 64.4C307.5 26.3 268.8 0 224 0s-83.5 26.3-101.4 64.4c40.9 3 77.1 23 101.4 53.1 24.3-30.1 60.5-50.1 101.4-53.1zM16 256c-4.6 0-9 2-12 5.4s-4.5 8-3.9 12.6l2 15.9c9 72 70.3 126.1 142.9 126.1h40.4l-68.7 68.7c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9h192c6.5 0 12.3-3.9 14.8-9.9s1.1-12.9-3.5-17.4L262.6 416H303c72.6 0 133.9-54.1 142.9-126.1l2-15.9c.6-4.6-.8-9.1-3.9-12.6s-7.4-5.4-12-5.4H16z"
        }
    ]
};

const FasBowlSoftServe = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBowlSoftServe",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M257.2 9.9c2.5-6 8.3-9.9 14.8-9.9h36.6C367.9 0 416 48.1 416 107.4c0 19.9-6.9 38.1-18.3 52.6H416c35.3 0 64 28.7 64 64s-28.7 64-64 64H96c-35.3 0-64-28.7-64-64s28.7-64 64-64h8.6c-5.4-9.4-8.6-20.3-8.6-32 0-35.3 28.7-64 64-64h94.1c9.9 0 17.9-8 17.9-17.9 0-4.8-1.9-9.3-5.3-12.7l-6.1-6.1c-4.6-4.6-5.9-11.5-3.5-17.4zM64 320h384c8.8 0 16 7.2 16 16v8c0 57.4-46.6 104-104 104h-30.1l20.4 40.8c1.1 2.3 1.7 4.7 1.7 7.2 0 2.9-.8 5.8-2.4 8.4-2.9 4.7-8.1 7.6-13.6 7.6H176c-5.5 0-10.7-2.9-13.6-7.6-1.6-2.6-2.4-5.5-2.4-8.4 0-2.4.6-4.9 1.7-7.2l20.4-40.8H152c-57.4 0-104-46.6-104-104v-8c0-8.8 7.2-16 16-16z"
        }
    ]
};

const FasBowlSpoon = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBowlSpoon",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M112 192C50.1 192 0 149 0 96S50.1 0 112 0c48.8 0 90.3 26.7 105.6 64H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H217.6c-15.4 37.3-56.9 64-105.6 64zM2 257.5C.9 239.3 15.4 224 33.6 224h444.8c18.2 0 32.7 15.3 31.6 33.5-5.4 91.7-59.7 169.7-136.4 209.7l-1.2 9.7c-2.5 20-19.5 35-39.7 35H179.3c-20.2 0-37.2-15-39.7-35l-1.2-9.7C61.6 427.2 7.4 349.3 2 257.5z"
        }
    ]
};

const FasBowlingBallPin = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBowlingBallPin",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M416 64c0-35.3 28.7-64 64-64s64 28.7 64 64v1.1c0 7.4-1 14.8-3 22l-17.7 64.8c-.7 2.7-1.3 5.4-1.8 8.1h-83c-.5-2.7-1.1-5.4-1.8-8.1l-17.8-64.8c-2-7.2-2.9-14.6-2.9-22V64zm22.8 128h82.3c1 6.3 2.6 12.4 4.8 18.4L566 319.3c6.6 17.9 10 36.8 10 55.8 0 20.5-3.9 40.9-11.5 59.9l-22.7 56.9C536.9 504 525.1 512 512 512h-64c-13.1 0-24.9-8-29.7-20.1l-17.8-44.5c29.8-40 47.5-89.6 47.5-143.4 0-30.7-5.8-60.1-16.3-87.1l2.4-6.5c2.2-6 3.8-12.1 4.8-18.4zM0 304a208 208 0 1 1 416 0 208 208 0 1 1-416 0zm224-132a28 28 0 1 0-56 0 28 28 0 1 0 56 0zm-28 116a28 28 0 1 0 0-56 28 28 0 1 0 0 56zm-44-68a28 28 0 1 0-56 0 28 28 0 1 0 56 0z"
        }
    ]
};

const FasBowlingBall = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBowlingBall",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM240 80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-32 128a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm-64-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FasBowlingPins = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBowlingPins",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 0c35.3 0 64 28.7 64 64v1.1c0 7.4-1 14.8-2.9 22l-17.7 64.8c-.7 2.7-1.3 5.4-1.8 8.1H86.5c-.5-2.7-1.1-5.4-1.8-8.1L66.9 87.1c-2-7.2-2.9-14.6-2.9-22V64c0-35.3 28.7-64 64-64zM82.1 210.4c2.2-6 3.8-12.1 4.8-18.4h82.3c1 6.3 2.6 12.4 4.8 18.4l38.6 104.7c7.6 20.6 11.5 42.5 11.5 64.4 0 28.9-6.7 57.5-19.7 83.4l-15.7 31.4c-5.5 10.9-16.6 17.7-28.7 17.7H96c-12.1 0-23.2-6.8-28.6-17.7l-15.7-31.4C38.7 437 32 408.5 32 379.5c0-22 3.9-43.8 11.5-64.4l38.6-104.7zM384 0c35.3 0 64 28.7 64 64v1.1c0 7.4-1 14.8-2.9 22l-17.7 64.8c-.7 2.7-1.3 5.4-1.8 8.1h-83.1c-.5-2.7-1.1-5.4-1.8-8.1l-17.8-64.8c-2-7.2-2.9-14.6-2.9-22V64c0-35.3 28.7-64 64-64zm-45.9 210.4c2.2-6 3.8-12.1 4.8-18.4h82.3c1 6.3 2.6 12.4 4.8 18.4l40 108.9c6.6 17.9 10 36.8 10 55.8 0 20.5-3.9 40.9-11.5 59.9l-22.7 56.9C440.9 504 429.1 512 416 512h-64c-13.1 0-24.9-8-29.7-20.1L299.5 435c-7.6-19-11.5-39.4-11.5-59.9 0-19 3.4-37.9 10-55.8l40.1-108.9z"
        }
    ]
};

const FasBoxArchive = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBoxArchive",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 32h448c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32zm0 128h448v256c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V160zm128 80c0 8.8 7.2 16 16 16h160c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16z"
        }
    ]
};

const FasBoxBallot = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBoxBallot",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 32c0-17.7 14.3-32 32-32h256c17.7 0 32 14.3 32 32v192H128V32zM0 352h576v112c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V352zm48-192h48v96h384v-96h48c26.5 0 48 21.5 48 48v112H0V208c0-26.5 21.5-48 48-48z"
        }
    ]
};

const FasBoxCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBoxCheck",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M93.7 32H208v128H0L50.7 58.5C58.9 42.3 75.5 32 93.7 32zM240 32h114.3c18.2 0 34.8 10.3 42.9 26.5L448 160H240V32zM0 192h448v224c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192zm337 89c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L337 281z"
        }
    ]
};

const FasBoxCircleCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBoxCircleCheck",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M93.7 32H208v128H0L50.7 58.5C58.9 42.3 75.5 32 93.7 32zM240 32h114.3c18.2 0 34.8 10.3 42.9 26.5L448 160H240V32zM0 416V192h416v.7c-89.7 8.1-160 83.5-160 175.3 0 42.5 15.1 81.6 40.2 112H64c-35.3 0-64-28.7-64-64zm288-48a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L416 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"
        }
    ]
};

const FasBoxDollar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBoxDollar",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M93.7 32H208v128H0L50.7 58.5C58.9 42.3 75.5 32 93.7 32zM240 32h114.3c18.2 0 34.8 10.3 42.9 26.5L448 160H240V32zM0 192h448v224c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192zm244 40c0-11-9-20-20-20s-20 9-20 20v14c-7.6 1.7-15.2 4.4-22.2 8.5-13.9 8.3-25.9 22.8-25.8 43.9.1 20.3 12 33.1 24.7 40.7 11 6.6 24.7 10.8 35.6 14l1.7.5c12.6 3.8 21.8 6.8 28 10.7 5.1 3.2 5.8 5.4 5.9 8.2.1 5-1.8 8-5.9 10.5-5 3.1-12.9 5-21.4 4.7-11.1-.4-21.5-3.9-35.1-8.5-2.3-.8-4.7-1.6-7.2-2.4-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9.6 4 1.3 6.1 2.1 8.3 2.9 17.9 6.2 28.2 8.4V440c0 11 9 20 20 20s20-9 20-20v-13.8c8-1.7 16-4.5 23.2-9 14.3-8.9 25.1-24.1 24.8-45-.3-20.3-11.7-33.4-24.6-41.6-11.5-7.2-25.9-11.6-37.1-15l-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5-5.2-3.1-5.3-4.9-5.3-6.7 0-3.7 1.4-6.5 6.2-9.3 5.4-3.2 13.6-5.1 21.5-5 9.6.1 20.2 2.2 31.2 5.2 10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7V232z"
        }
    ]
};

const FasBoxHeart = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBoxHeart",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M93.7 32H208v128H0L50.7 58.5C58.9 42.3 75.5 32 93.7 32zM240 32h114.3c18.2 0 34.8 10.3 42.9 26.5L448 160H240V32zM0 192h448v224c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192zm212.7 228.7c6.2 6.2 16.4 6.2 22.6 0l77.3-77.3c20.5-20.5 20.5-53.8 0-74.3s-53.8-20.5-74.3 0L224 283.4l-14.3-14.3c-20.5-20.5-53.8-20.5-74.3 0s-20.5 53.8 0 74.3l77.3 77.3z"
        }
    ]
};

const FasBoxOpenFull = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBoxOpenFull",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m508.9 64.9-27.5 73.4L320 158.5l-7.2-.9c4.6-8.8 7.2-18.9 7.2-29.6 0-35.3-28.7-64-64-64s-64 28.7-64 64c0 5.1.6 10 1.7 14.7l-65.5-8.2c-.1-2.2-.2-4.3-.2-6.5C128 57.3 185.3 0 256 0c69.6 0 126.2 55.6 128 124.7l35.1-93.6c9.3-24.8 37-37.4 61.8-28.1s37.4 37 28.1 61.8zM576 338.3v83.4c0 14.7-10 27.5-24.2 31l-216.3 54.1c-10.2 2.6-20.9 2.6-31 0l-216.3-54C74 449.2 64 436.4 64 421.7v-83.4l127.6 36.5c27.8 8 57.6-3.8 72.5-28.6l55.9-93.3 55.9 93.2c14.9 24.8 44.6 36.6 72.5 28.6L576 338.3zM58.9 168.8c3-6.1 9.6-9.6 16.3-8.7L320 190.7l244.8-30.6c6.7-.8 13.3 2.7 16.3 8.7l41.7 83.4c9 17.9-.6 39.6-19.8 45.1L439.6 344c-13.9 4-28.8-1.9-36.2-14.3l-83.4-139-83.4 139c-7.4 12.4-22.3 18.3-36.2 14.3L37.1 297.3c-19.3-5.5-28.8-27.2-19.8-45.1L59 168.8z"
        }
    ]
};

const FasBoxOpen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBoxOpen",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M58.9 42.1c3-6.1 9.6-9.6 16.3-8.7L320 64l244.8-30.6c6.7-.8 13.3 2.7 16.3 8.7l41.7 83.4c9 17.9-.6 39.6-19.8 45.1l-163.4 46.7c-13.9 4-28.8-1.9-36.2-14.3L320 64l-83.4 139c-7.4 12.4-22.3 18.3-36.2 14.3L37.1 170.6c-19.3-5.5-28.8-27.2-19.8-45.1l41.6-83.4zM321.1 128l54.9 91.4c14.9 24.8 44.6 36.6 72.5 28.6L576 211.6v167c0 22-15 41.2-36.4 46.6l-204.1 51c-10.2 2.6-20.9 2.6-31 0l-204.1-51C79 419.7 64 400.5 64 378.5v-167L191.6 248c27.8 8 57.6-3.8 72.5-28.6l54.8-91.4h2.2z"
        }
    ]
};

const FasBoxTaped = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBoxTaped",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M50.7 58.5 0 160h160l32-128H93.7c-18.2 0-34.8 10.3-43 26.5zM288 160h160L397.3 58.5c-8.2-16.2-24.8-26.5-43-26.5H256l32 128zm-128 32H0v224c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V192H288v64c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32v-64z"
        }
    ]
};

const FasBoxTissue = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBoxTissue",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M92.5 0H208c40 0 52 24 64 48s24 48 64 48h85.2c14.8 0 26.8 12 26.8 26.8 0 3.4-.7 6.8-1.9 10L409.6 224 384 288H128l-16-64L64.9 35.4c-.6-2.3-.9-4.6-.9-6.9C64 12.8 76.8 0 92.5 0zM79 224l16 64H80c-8.8 0-16 7.2-16 16s7.2 16 16 16h352c8.8 0 16-7.2 16-16s-7.2-16-16-16h-13.5l25.6-64H464c26.5 0 48 21.5 48 48v112H0V272c0-26.5 21.5-48 48-48h31zM0 416h512v48c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48v-48z"
        }
    ]
};

const FasBox = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBox",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M50.7 58.5 0 160h208V32H93.7c-18.2 0-34.8 10.3-43 26.5zM240 160h208L397.3 58.5c-8.2-16.2-24.8-26.5-43-26.5H240v128zm208 32H0v224c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V192z"
        }
    ]
};

const FasBoxesPacking = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBoxesPacking",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 48c0-26.5 21.5-48 48-48h288c26.5 0 48 21.5 48 48v416c0 26.5-21.5 48-48 48H381.3c1.8-5 2.7-10.4 2.7-16V253.3c18.6-6.6 32-24.4 32-45.3v-32c0-26.5-21.5-48-48-48H256V48zm315.3 299.3c6.2-6.2 6.2-16.4 0-22.6l-64-64c-6.2-6.2-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l36.7-36.7V432c0 8.8 7.2 16 16 16s16-7.2 16-16V310.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0zM0 176c0-8.8 7.2-16 16-16h352c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H16c-8.8 0-16-7.2-16-16v-32zm352 80v224c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V256h320zm-208 64c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16h-96z"
        }
    ]
};

const FasBoxesStacked = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBoxesStacked",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M248 0h-40c-26.5 0-48 21.5-48 48v112c0 35.3 28.7 64 64 64h128c35.3 0 64-28.7 64-64V48c0-26.5-21.5-48-48-48h-40v80c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16V0zM64 256c-35.3 0-64 28.7-64 64v128c0 35.3 28.7 64 64 64h160c35.3 0 64-28.7 64-64V320c0-35.3-28.7-64-64-64h-40v80c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16v-80H64zm288 256h160c35.3 0 64-28.7 64-64V320c0-35.3-28.7-64-64-64h-40v80c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16v-80h-40c-15 0-28.8 5.1-39.7 13.8 4.9 10.4 7.7 22 7.7 34.2v160c0 12.2-2.8 23.8-7.7 34.2C323.2 506.9 337 512 352 512z"
        }
    ]
};

const FasBoxingGlove = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBoxingGlove",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 96C0 43 43 0 96 0h192c53 0 96 43 96 96v32h-32c-26.2 0-49.4 12.6-64 32H144c-21.2 0-34.3-5.3-41.8-9.7-3.8-2.3-6.3-4.4-7.7-5.8-.7-.7-1.1-1.2-1.3-1.5l-.1-.1c-5-7.1-14.7-9-22-4.2-7.4 4.9-9.3 14.8-4.4 22.2L80 152l-13.3 8.9.1.1.1.2.4.5c.3.4.6.8 1.1 1.4.9 1.1 2 2.4 3.6 4 3.1 3.1 7.6 6.9 13.8 10.7 12.5 7.5 31.4 14.2 58.2 14.2h129.6c-1 5.2-1.6 10.5-1.6 16 0 37.3 25.5 68.6 60 77.5 8.6 2.2 17.3-2.9 19.5-11.5s-2.9-17.3-11.5-19.5c-20.7-5.3-36-24.1-36-46.5 0-26.5 21.5-48 48-48h32c35.3 0 64 28.7 64 64v24.2c0 25.5-10.1 49.9-28.1 67.9l-49.1 49.1c-12 12-18.7 28.3-18.7 45.3V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64v-88.4C12.4 342 0 316.4 0 288V96zm152.9 258.7c-7.4-4.9-17.3-2.9-22.2 4.4s-2.9 17.3 4.4 22.2l28 18.7-28 18.7c-7.4 4.9-9.3 14.8-4.4 22.2s14.8 9.3 22.2 4.4l39.1-26.1 39.1 26.1c7.4 4.9 17.3 2.9 22.2-4.4s2.9-17.3-4.4-22.2l-28-18.7 28-18.7c7.4-4.9 9.3-14.8 4.4-22.2s-14.8-9.3-22.2-4.4L192 380.8l-39.1-26.1z"
        }
    ]
};

const FasBracketCurlyRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBracketCurlyRight",
    "viewBox": "0 0 256 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 128c0-53-43-96-96-96H64c-17.7 0-32 14.3-32 32s14.3 32 32 32h32c17.7 0 32 14.3 32 32v37.5c0 25.5 10.1 49.9 28.1 67.9l22.6 22.6-22.6 22.6c-18 18-28.1 42.4-28.1 67.9V384c0 17.7-14.3 32-32 32H64c-17.7 0-32 14.3-32 32s14.3 32 32 32h32c53 0 96-43 96-96v-37.5c0-8.5 3.4-16.6 9.4-22.6l45.3-45.3c12.5-12.5 12.5-32.8 0-45.3L201.4 188c-6-6-9.4-14.1-9.4-22.6V128z"
        }
    ]
};

const FasBracketCurly = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBracketCurly",
    "viewBox": "0 0 256 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 128c0-53 43-96 96-96h32c17.7 0 32 14.3 32 32s-14.3 32-32 32h-32c-17.7 0-32 14.3-32 32v37.5c0 25.5-10.1 49.9-28.1 67.9L77.3 256l22.6 22.6c18 18 28.1 42.4 28.1 67.9V384c0 17.7 14.3 32 32 32h32c17.7 0 32 14.3 32 32s-14.3 32-32 32h-32c-53 0-96-43-96-96v-37.5c0-8.5-3.4-16.6-9.4-22.6L9.4 278.6c-12.5-12.5-12.5-32.8 0-45.3L54.7 188c6-6 9.4-14.1 9.4-22.6V128z"
        }
    ]
};

const FasBracketRoundRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBracketRoundRight",
    "viewBox": "0 0 192 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M37.4 46.2c-9.8 14.8-5.9 34.6 8.9 44.4C71.9 107.7 128 167 128 256S71.9 404.3 46.2 421.4c-14.7 9.8-18.7 29.7-8.9 44.4s29.7 18.7 44.4 8.9C120.1 449 192 371.8 192 256S120.1 62.9 81.8 37.4c-14.8-9.8-34.6-5.9-44.4 8.8z"
        }
    ]
};

const FasBracketRound = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBracketRound",
    "viewBox": "0 0 192 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M154.6 46.2c9.8 14.7 5.8 34.6-8.9 44.4C120.1 107.7 64 167 64 256s56.1 148.3 81.8 165.4c14.7 9.8 18.7 29.7 8.9 44.4s-29.7 18.7-44.4 8.9C71.9 449 0 371.8 0 256S71.9 62.9 110.2 37.4c14.7-9.8 34.6-5.8 44.4 8.9z"
        }
    ]
};

const FasBracketSquareRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBracketSquareRight",
    "viewBox": "0 0 192 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 96c0-35.3-28.7-64-64-64H64c-17.7 0-32 14.3-32 32s14.3 32 32 32h64v320H64c-17.7 0-32 14.3-32 32s14.3 32 32 32h64c35.3 0 64-28.7 64-64V96z"
        }
    ]
};

const FasBracketSquare = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBracketSquare",
    "viewBox": "0 0 192 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 96c0-35.3 28.7-64 64-64h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H64v320h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H64c-35.3 0-64-28.7-64-64V96z"
        }
    ]
};

const FasBracketsCurly = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBracketsCurly",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M416 32h-32c-17.7 0-32 14.3-32 32s14.3 32 32 32h32c17.7 0 32 14.3 32 32v37.5c0 25.5 10.1 49.9 28.1 67.9l22.6 22.6-22.6 22.6c-18 18-28.1 42.4-28.1 67.9V384c0 17.7-14.3 32-32 32h-32c-17.7 0-32 14.3-32 32s14.3 32 32 32h32c53 0 96-43 96-96v-37.5c0-8.5 3.4-16.6 9.4-22.6l45.3-45.3c12.5-12.5 12.5-32.8 0-45.3L521.4 188c-6-6-9.4-14.1-9.4-22.6V128c0-53-43-96-96-96zm-256 0c-53 0-96 43-96 96v37.5c0 8.5-3.4 16.6-9.4 22.6L9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3L54.7 324c6 6 9.4 14.1 9.4 22.6V384c0 53 43 96 96 96h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H160c-17.7 0-32-14.3-32-32v-37.5c0-25.5-10.1-49.9-28.1-67.9L77.3 256l22.6-22.6c18-18 28.1-42.4 28.1-67.9V128c0-17.7 14.3-32 32-32h32c17.7 0 32-14.3 32-32s-14.3-32-32-32h-32z"
        }
    ]
};

const FasBracketsRound = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBracketsRound",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M145.8 90.6c14.7-9.8 18.7-29.7 8.9-44.4s-29.7-18.7-44.4-8.9C71.9 62.9 0 140.2 0 256s71.9 193 110.2 218.6c14.7 9.8 34.6 5.8 44.4-8.9s5.8-34.6-8.9-44.4C120.1 404.3 64 345 64 256s56.1-148.3 81.8-165.4zm220.5 0C391.9 107.7 448 167 448 256s-56.1 148.3-81.8 165.4c-14.7 9.8-18.7 29.7-8.9 44.4s29.7 18.7 44.4 8.9C440.1 449.1 512 371.8 512 256S440.1 62.9 401.8 37.4c-14.7-9.8-34.6-5.8-44.4 8.9s-5.8 34.6 8.9 44.4z"
        }
    ]
};

const FasBracketsSquare = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBracketsSquare",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 32c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64h-64c-17.7 0-32-14.3-32-32s14.3-32 32-32h64V96h-64c-17.7 0-32-14.3-32-32s14.3-32 32-32h64zM64 32h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H64v320h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64z"
        }
    ]
};

const FasBraille = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBraille",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 96a64 64 0 1 1 128 0A64 64 0 1 1 0 96zm224 176a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-80a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM80 416a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm-80 0a64 64 0 1 1 128 0 64 64 0 1 1-128 0zm240 0a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm-80 0a64 64 0 1 1 128 0 64 64 0 1 1-128 0zM64 192a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM224 32a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm128 64a64 64 0 1 1 128 0 64 64 0 1 1-128 0zm240 0a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm-80 0a64 64 0 1 1 128 0 64 64 0 1 1-128 0zm64 176a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-80a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm16 224a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm-80 0a64 64 0 1 1 128 0 64 64 0 1 1-128 0zm-96-144a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-80a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm16 224a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm-80 0a64 64 0 1 1 128 0 64 64 0 1 1-128 0z"
        }
    ]
};

const FasBrainArrowCurvedRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBrainArrowCurvedRight",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M240 56c0-30.9-25.1-56-56-56-28.9 0-52.7 21.9-55.7 49.9C100.6 56.9 80 82.1 80 112c0 6 .8 11.9 2.4 17.4C53.6 135.7 32 161.3 32 192c0 15 5.1 28.8 13.8 39.7C18.7 244.5 0 272.1 0 304c0 34.2 21.4 63.4 51.6 74.8-2.3 6.6-3.6 13.8-3.6 21.2 0 35.3 28.7 64 64 64 5.6 0 11.1-.7 16.3-2.1 2.9 28.2 26.8 50.1 55.7 50.1 30.9 0 56-25.1 56-56V56zm32 0v400c0 30.9 25.1 56 56 56 3.2 0 6.4-.3 9.5-.8C321.3 491 304 459.3 304 416c0-79.5 64.5-144 144-144h32v-16c0-4.9.8-9.8 2.2-14.3-4.9-3.9-10.2-7.3-16-10C474.9 220.8 480 207 480 192c0-30.7-21.6-56.3-50.4-62.6 1.6-5.5 2.4-11.4 2.4-17.4 0-29.9-20.6-55.1-48.3-62.1C380.6 21.9 356.9 0 328 0c-30.9 0-56 25.1-56 56zm267.3 188.7c-4.6-4.6-11.5-5.9-17.4-3.5s-9.9 8.3-9.9 14.8v48h-64c-61.9 0-112 50.1-112 112 0 54.3 34.6 85.6 45 93.8 1.9 1.5 4.3 2.2 6.7 2.2 6.8 0 12.3-5.5 12.3-12.3V464c0-35.3 28.7-64 64-64h48v48c0 6.5 3.9 12.3 9.9 14.8s12.9 1.1 17.4-3.5l96-96c6.2-6.2 6.2-16.4 0-22.6l-96-96z"
        }
    ]
};

const FasBrainCircuit = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBrainCircuit",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M240 56c0-30.9-25.1-56-56-56-28.9 0-52.7 21.9-55.7 49.9C100.6 56.9 80 82.1 80 112c0 6 .8 11.9 2.4 17.4C53.6 135.7 32 161.3 32 192c0 15 5.1 28.8 13.8 39.7C18.7 244.5 0 272.1 0 304c0 34.2 21.4 63.4 51.6 74.8-2.3 6.6-3.6 13.8-3.6 21.2 0 35.3 28.7 64 64 64 5.6 0 11.1-.7 16.3-2.1 2.9 28.2 26.8 50.1 55.7 50.1 30.9 0 56-25.1 56-56V272h-48c-8.8 0-16 7.2-16 16v34.7c18.6 6.6 32 24.4 32 45.3 0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V288c0-26.5 21.5-48 48-48h48v-80h-34.7c-6.6 18.6-24.4 32-45.3 32-26.5 0-48-21.5-48-48s21.5-48 48-48c20.9 0 38.7 13.4 45.3 32H240V56zm32 104v192h34.7c6.6-18.6 24.4-32 45.3-32 26.5 0 48 21.5 48 48s-21.5 48-48 48c-20.9 0-38.7-13.4-45.3-32H272v72c0 30.9 25.1 56 56 56 28.9 0 52.7-21.9 55.7-50.1 5.2 1.4 10.7 2.1 16.3 2.1 35.3 0 64-28.7 64-64 0-7.4-1.3-14.6-3.6-21.2 30.2-11.4 51.6-40.6 51.6-74.8 0-31.9-18.7-59.5-45.8-72.3C474.9 220.8 480 207 480 192c0-30.7-21.6-56.3-50.4-62.6 1.6-5.5 2.4-11.4 2.4-17.4 0-29.9-20.6-55.1-48.3-62.1C380.6 21.9 356.9 0 328 0c-30.9 0-56 25.1-56 56v72h48c26.5 0 48 21.5 48 48v2.7c18.6 6.6 32 24.4 32 45.3 0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V176c0-8.8-7.2-16-16-16h-48zm-128-16a16 16 0 1 0 32 0 16 16 0 1 0-32 0zm208 64a16 16 0 1 0 0 32 16 16 0 1 0 0-32zM144 368a16 16 0 1 0 32 0 16 16 0 1 0-32 0zm192 0a16 16 0 1 0 32 0 16 16 0 1 0-32 0z"
        }
    ]
};

const FasBrain = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBrain",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M184 0c30.9 0 56 25.1 56 56v400c0 30.9-25.1 56-56 56-28.9 0-52.7-21.9-55.7-50.1-5.2 1.4-10.7 2.1-16.3 2.1-35.3 0-64-28.7-64-64 0-7.4 1.3-14.6 3.6-21.2C21.4 367.4 0 338.2 0 304c0-31.9 18.7-59.5 45.8-72.3C37.1 220.8 32 207 32 192c0-30.7 21.6-56.3 50.4-62.6C80.8 123.9 80 118 80 112c0-29.9 20.6-55.1 48.3-62.1 3-28 26.8-49.9 55.7-49.9zm144 0c28.9 0 52.6 21.9 55.7 49.9C411.5 56.9 432 82 432 112c0 6-.8 11.9-2.4 17.4 28.8 6.2 50.4 31.9 50.4 62.6 0 15-5.1 28.8-13.8 39.7 27.1 12.8 45.8 40.4 45.8 72.3 0 34.2-21.4 63.4-51.6 74.8 2.3 6.6 3.6 13.8 3.6 21.2 0 35.3-28.7 64-64 64-5.6 0-11.1-.7-16.3-2.1-3 28.2-26.8 50.1-55.7 50.1-30.9 0-56-25.1-56-56V56c0-30.9 25.1-56 56-56z"
        }
    ]
};

const FasBrakeWarning = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBrakeWarning",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 256a224 224 0 1 1 448 0 224 224 0 1 1-448 0zm248-104c0-13.3-10.7-24-24-24s-24 10.7-24 24v112c0 13.3 10.7 24 24 24s24-10.7 24-24V152zm-24 232a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM91.1 109C63.8 151.4 48 201.8 48 256s15.8 104.6 43.1 147c7.2 11.1 4 26-7.2 33.2s-26 4-33.2-7.2C18.6 379.1 0 319.7 0 256S18.6 132.9 50.7 83c7.2-11.1 22-14.4 33.2-7.2s14.4 22 7.2 33.2zm498.2-26c32.1 49.9 50.7 109.3 50.7 173s-18.6 123.1-50.7 173c-7.2 11.1-22 14.4-33.2 7.2s-14.4-22-7.2-33.2c27.3-42.4 43.1-92.8 43.1-147s-15.8-104.6-43.1-147c-7.2-11.1-4-26 7.2-33.2s26-4 33.2 7.2z"
        }
    ]
};

const FasBrazilianRealSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBrazilianRealSign",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M400 0c17.7 0 32 14.3 32 32v18.2c12.5 2.3 24.7 6.4 36.2 12.1l10.1 5.1c15.8 7.9 22.2 27.1 14.3 42.9s-27.1 22.2-42.9 14.3l-10.2-5.1c-9.9-5-20.9-7.5-32-7.5h-1.7c-29.8 0-53.9 24.1-53.9 53.9 0 22 13.4 41.8 33.9 50l52 20.8c44.7 17.9 74.1 61.2 74.1 109.4v3.4c0 51.2-33.6 94.6-80 109.2V480c0 17.7-14.3 32-32 32s-32-14.3-32-32v-19.4c-15-3.5-29.4-9.7-42.3-18.3l-23.4-15.6c-14.7-9.8-18.7-29.7-8.9-44.4s29.7-18.7 44.4-8.9l23.5 15.6c10.8 7.2 23.4 11 36.3 11 27.9 0 50.5-22.6 50.5-50.5v-3.4c0-22-13.4-41.8-33.9-50l-52-20.8c-44.8-17.9-74.1-61.2-74.1-109.4 0-51.9 33.5-95.9 80-111.7V32c0-17.7 14.3-32 32-32zM0 64c0-17.7 14.3-32 32-32h80c79.5 0 144 64.5 144 144 0 58.8-35.2 109.3-85.7 131.7l51.4 128.4c6.6 16.4-1.4 35-17.8 41.6s-35-1.4-41.6-17.8l-56-139.9H64v128c0 17.7-14.3 32-32 32S0 465.7 0 448V64zm64 192h48c44.2 0 80-35.8 80-80s-35.8-80-80-80H64v160z"
        }
    ]
};

const FasBreadLoaf = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBreadLoaf",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 192C0 64 176 32 240 32s240 32 240 160c0 35.3-28.7 64-64 64v176c0 26.5-21.5 48-48 48H112c-26.5 0-48-21.5-48-48V256c-35.3 0-64-28.7-64-64zM397.4 34.9c-2-.9-4.1-1.9-6.2-2.8 3.1-.1 6-.2 8.8-.2 64 0 240 32 240 160 0 35.3-28.7 64-64 64V432c0 26.5-21.5 48-48 48h-96c10-13.4 16-30 16-48V282.5c37.3-13.2 64-48.7 64-90.5 0-82.2-57.6-130.7-114.6-157.1z"
        }
    ]
};

const FasBreadSliceButter = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBreadSliceButter",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 192C0 64 192 32 256 32s256 32 256 160c0 35.3-28.7 64-64 64v176c0 26.5-21.5 48-48 48H112c-26.5 0-48-21.5-48-48V256c-35.3 0-64-28.7-64-64zm182.6 73.4c-12.5 12.5-12.5 32.8 0 45.3l50.7 50.7c12.5 12.5 32.8 12.5 45.3 0l50.7-50.7c12.5-12.5 12.5-32.8 0-45.3l-50.7-50.7c-12.5-12.5-32.8-12.5-45.3 0l-50.7 50.7z"
        }
    ]
};

const FasBreadSlice = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBreadSlice",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32C192 32 0 64 0 192c0 35.3 28.7 64 64 64v176c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V256c35.3 0 64-28.7 64-64C512 64 320 32 256 32z"
        }
    ]
};

const FasBridgeCircleCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBridgeCircleCheck",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32c-17.7 0-32 14.3-32 32s14.3 32 32 32h40v64H32v128c53 0 96 43 96 96v64c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32v-64c0-53 43-96 96-96 6.3 0 12.4.6 18.3 1.7C367.1 231.8 426.9 192 496 192c42.5 0 81.6 15.1 112 40.2V160h-72V96h40c17.7 0 32-14.3 32-32s-14.3-32-32-32H64zm424 64v64h-80V96h80zm-128 0v64h-80V96h80zm-128 0v64h-80V96h80zm408 272a144 144 0 1 0-288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l28.7 28.7 60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"
        }
    ]
};

const FasBridgeCircleExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBridgeCircleExclamation",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32c-17.7 0-32 14.3-32 32s14.3 32 32 32h40v64H32v128c53 0 96 43 96 96v64c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32v-64c0-53 43-96 96-96 6.3 0 12.4.6 18.3 1.7C367.1 231.8 426.9 192 496 192c42.5 0 81.6 15.1 112 40.2V160h-72V96h40c17.7 0 32-14.3 32-32s-14.3-32-32-32H64zm424 64v64h-80V96h80zm-128 0v64h-80V96h80zm-128 0v64h-80V96h80zm264 416a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16v-80c0-8.8 7.2-16 16-16z"
        }
    ]
};

const FasBridgeCircleXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBridgeCircleXmark",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32c-17.7 0-32 14.3-32 32s14.3 32 32 32h40v64H32v128c53 0 96 43 96 96v64c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32v-64c0-53 43-96 96-96 6.3 0 12.4.6 18.3 1.7C367.1 231.8 426.9 192 496 192c42.5 0 81.6 15.1 112 40.2V160h-72V96h40c17.7 0 32-14.3 32-32s-14.3-32-32-32H64zm424 64v64h-80V96h80zm-128 0v64h-80V96h80zm-128 0v64h-80V96h80zm264 416a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L518.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l36.7-36.7-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l36.7 36.7 36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
        }
    ]
};

const FasBridgeLock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBridgeLock",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 64c0-17.7 14.3-32 32-32h512c17.7 0 32 14.3 32 32s-14.3 32-32 32h-40v64h-8c-61.9 0-112 50.1-112 112v24.6c-9.9 5.8-18.2 14.1-23.8 24.1-17.6-20-43.4-32.7-72.2-32.7-53 0-96 43-96 96v64c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32v-64c0-53-43-96-96-96V160h72V96H64c-17.7 0-32-14.3-32-32zm376 32v64h80V96h-80zm-48 64V96h-80v64h80zM152 96v64h80V96h-80zm376 144c-17.7 0-32 14.3-32 32v48h64v-48c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32v128c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32v-48z"
        }
    ]
};

const FasBridgeSuspension = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBridgeSuspension",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 8c9.1 0 17 5 21.1 12.5C184.2 81.6 249.7 120 320 120s135.8-38.4 170.9-99.5C495 13 502.9 8 512 8c8.8 0 16.5 4.7 20.7 11.8 13.1 21.2 26.6 42.2 42 59.8 15.5 17.7 31.7 30.6 49.4 36.9 12.5 4.5 18.9 18.2 14.4 30.7s-18.2 18.9-30.7 14.4c-25.5-9.2-46.4-25.8-63.9-44.5V256h64c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32-35.3 0-64 28.7-64 64v64c0 17.7-14.3 32-32 32H480c-17.7 0-32-14.3-32-32v-32c0-53-43-96-96-96h-64c-53 0-96 43-96 96v32c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32v-64c0-35.3-28.7-64-64-64-17.7 0-32-14.3-32-32v-32c0-17.7 14.3-32 32-32h64V117.1c-17.4 18.7-38.4 35.3-63.9 44.5-12.5 4.5-26.2-2-30.7-14.4s2-26.2 14.4-30.7c17.7-6.4 33.9-19.3 49.4-36.9 15.4-17.6 29-38.6 42-59.8C111.5 12.7 119.2 8 128 8zm352 100.1c-12.4 10.7-25.8 20.1-40 28.2V256h40V108.1zm-88 49c-15.5 4.8-31.6 8.1-48 9.8V256h48v-99zm-96 9.8c-16.4-1.6-32.5-4.9-48-9.8v99h48v-89.3zm-96-30.5c-14.2-8-27.6-17.5-40-28.2V256h40V136.3z"
        }
    ]
};

const FasBridgeWater = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBridgeWater",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 96c0-17.7 14.3-32 32-32h512c17.7 0 32 14.3 32 32v35.6c0 15.7-12.7 28.4-28.4 28.4-37.3 0-67.6 30.2-67.6 67.6v124.9c-12.9 0-25.8 3.9-36.8 11.7-18 12.4-40.1 20.3-59.2 20.3V256c0-53-43-96-96-96s-96 43-96 96v128.5c-19 0-41.2-7.9-59.1-20.3-11.1-7.8-24-11.7-36.9-11.7V227.6c0-37.4-30.2-67.6-67.6-67.6C12.7 160 0 147.3 0 131.6V96zm306.5 293.9c22.5 15.5 50 26.1 77.5 26.1 26.9 0 55.4-10.8 77.4-26.1 11.9-8.5 28.1-7.8 39.2 1.7 14.4 11.9 32.5 21 50.6 25.2 17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25-29 15.6-61.5 25.9-94.5 25.9-31.9 0-60.6-9.9-80.4-18.9-5.8-2.7-11.1-5.3-15.6-7.7-4.5 2.4-9.7 5.1-15.6 7.7-19.8 9-48.5 18.9-80.4 18.9-33 0-65.5-10.3-94.5-25.8-13.4 8.4-33.7 19.3-58.2 25-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2 11.1-9.4 27.3-10.1 39.2-1.7 22.1 15.2 50.5 26 77.4 26 27.5 0 55-10.6 77.5-26.1 11.1-7.9 25.9-7.9 37 0z"
        }
    ]
};

const FasBridge = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBridge",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 32C14.3 32 0 46.3 0 64s14.3 32 32 32h40v64H0v128c53 0 96 43 96 96v64c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32v-64c0-53 43-96 96-96s96 43 96 96v64c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32v-64c0-53 43-96 96-96V160h-72V96h40c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zm424 64v64h-80V96h80zm-128 0v64h-80V96h80zm-128 0v64h-80V96h80z"
        }
    ]
};

const FasBriefcaseArrowRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBriefcaseArrowRight",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M184 48h144c4.4 0 8 3.6 8 8v40H176V56c0-4.4 3.6-8 8-8zm-56 8v40H64c-35.3 0-64 28.7-64 64v256c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64h-64V56c0-30.9-25.1-56-56-56H184c-30.9 0-56 25.1-56 56zm169 135 80 80c9.4 9.4 9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l39-39H152c-13.3 0-24-10.7-24-24s10.7-24 24-24h150.1l-39-39c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z"
        }
    ]
};

const FasBriefcaseBlank = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBriefcaseBlank",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 56v40h160V56c0-4.4-3.6-8-8-8H184c-4.4 0-8 3.6-8 8zm-48 40V56c0-30.9 25.1-56 56-56h144c30.9 0 56 25.1 56 56v40h64c35.3 0 64 28.7 64 64v256c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64h64z"
        }
    ]
};

const FasBriefcaseMedical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBriefcaseMedical",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M184 48h144c4.4 0 8 3.6 8 8v40H176V56c0-4.4 3.6-8 8-8zm-56 8v40H64c-35.3 0-64 28.7-64 64v256c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64h-64V56c0-30.9-25.1-56-56-56H184c-30.9 0-56 25.1-56 56zm96 152c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-48v48c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-48h-48c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h48v-48z"
        }
    ]
};

const FasBriefcase = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBriefcase",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M184 48h144c4.4 0 8 3.6 8 8v40H176V56c0-4.4 3.6-8 8-8zm-56 8v40H64c-35.3 0-64 28.7-64 64v96h512v-96c0-35.3-28.7-64-64-64h-64V56c0-30.9-25.1-56-56-56H184c-30.9 0-56 25.1-56 56zm384 232H320v32c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32v-32H0v128c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V288z"
        }
    ]
};

const FasBrightnessLow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBrightnessLow",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 80a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm-64 176a96 96 0 1 1 192 0 96 96 0 1 1-192 0zm96 144a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm176-176a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-320 32a32 32 0 1 1-64 0 32 32 0 1 1 64 0zM96 128a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm256 256a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm0-256a32 32 0 1 1 64 0 32 32 0 1 1-64 0zM160 384a32 32 0 1 1-64 0 32 32 0 1 1 64 0z"
        }
    ]
};

const FasBrightness = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBrightness",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 80V32c0-17.7 14.3-32 32-32s32 14.3 32 32v48c0 17.7-14.3 32-32 32s-32-14.3-32-32zm-64 176a96 96 0 1 1 192 0 96 96 0 1 1-192 0zM0 256c0-17.7 14.3-32 32-32h48c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zm432-32h48c17.7 0 32 14.3 32 32s-14.3 32-32 32h-48c-17.7 0-32-14.3-32-32s14.3-32 32-32zM256 512c-17.7 0-32-14.3-32-32v-48c0-17.7 14.3-32 32-32s32 14.3 32 32v48c0 17.7-14.3 32-32 32zM73.4 438.6c-12.5-12.5-12.5-32.8 0-45.3l32-32c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-32 32c-12.5 12.5-32.8 12.5-45.3 0zm288-333.3 32-32c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-32 32c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3zm77.3 333.3c-12.5 12.5-32.8 12.5-45.3 0l-32-32c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l32 32c12.5 12.5 12.5 32.8 0 45.3zm-333.3-288-32-32c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l32 32c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0z"
        }
    ]
};

const FasBringForward = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBringForward",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 448h224V224h-64v-64h64c35.3 0 64 28.7 64 64v224c0 35.3-28.7 64-64 64H224c-35.3 0-64-28.7-64-64v-64h64v64zm64-96H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0h224c35.3 0 64 28.7 64 64v224c0 35.3-28.7 64-64 64z"
        }
    ]
};

const FasBringFront = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBringFront",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64h192c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64v128c0 35.3 28.7 64 64 64h64v-64H64V64zm416 384h-96c0 35.3 28.7 64 64 64h128c35.3 0 64-28.7 64-64V320c0-35.3-28.7-64-64-64h-64v64h64v128h-96zM224 96c-35.3 0-64 28.7-64 64v192c0 35.3 28.7 64 64 64h192c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H224z"
        }
    ]
};

const FasBroccoli = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBroccoli",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 256c0 53 43 96 96 96h320c53 0 96-43 96-96 0-45.5-31.6-83.6-74.1-93.5 6.4-10 10.1-21.8 10.1-34.5 0-35.3-28.7-64-64-64-12.7 0-24.6 3.7-34.5 10.1C339.6 31.6 301.5 0 256 0s-83.6 31.6-93.5 74.1C152.6 67.7 140.7 64 128 64c-35.3 0-64 28.7-64 64 0 12.7 3.7 24.6 10.1 34.5C31.6 172.4 0 210.5 0 256zm192.2 234.3c5 12.8 17.1 21.7 30.9 21.7H289c13.8 0 25.9-8.9 30.9-21.7C337.5 445 359.5 408.2 376 384h-96l-16.8 33.7c-2.9 5.9-11.4 5.9-14.3 0L232 384h-95.9c16.5 24.2 38.5 60.9 56.1 106.3z"
        }
    ]
};

const FasBroomBall = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBroomBall",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M566.6 9.4c12.5 12.5 12.5 32.8 0 45.3l-192 192 34.7 34.7c4.2 4.2 6.6 10 6.6 16 0 12.5-10.1 22.6-22.6 22.6h-29L256 211.7v-29.1c0-12.5 10.1-22.6 22.6-22.6 6 0 11.8 2.4 16 6.6l34.7 34.7 192-192c12.5-12.5 32.8-12.5 45.3 0zm-344 225.5 118.5 118.5c3.7 42.7-11.7 85.2-42.3 115.8-27.4 27.4-64.6 42.8-103.3 42.8H22.1C9.9 512 0 502.1 0 489.9c0-6.3 2.7-12.3 7.3-16.5l126.4-113.7c4.2-3.7-.4-10.4-5.4-7.9l-51.1 25.6c-6.1 3-13.2-1.4-13.2-8.2 0-31.5 12.5-61.7 34.8-84l8-8c30.6-30.6 73.1-45.9 115.8-42.3zM464 352a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"
        }
    ]
};

const FasBroomWide = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBroomWide",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M502.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128-15.8-15.8c-15.2-15.2-38.5-18.4-57.3-8l-32.5 18 156.7 156.5 18-32.5c10.4-18.7 7.1-42.1-8-57.3l-15.8-15.8 128-128c12.5-12.5 12.5-32.8 0-45.3zM187.5 151.8 16.4 246.9C6.3 252.5 0 263.2 0 274.8c0 8.5 3.4 16.6 9.3 22.6l43.2 43.2c2.1 2.1 5.3 2.9 8.2 1.9l52.1-17.4c6.3-2.1 12.2 3.9 10.1 10.1l-17.4 52.1c-1 2.9-.2 6 1.9 8.2l107.3 107.2c6 6 14.1 9.3 22.6 9.3 11.6 0 22.3-6.3 27.9-16.4l95.1-171.1-172.8-172.7z"
        }
    ]
};

const FasBroom = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBroom",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M566.6 54.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192-34.7-34.7c-4.2-4.2-10-6.6-16-6.6-12.5 0-22.6 10.1-22.6 22.6v29.1L364.3 320h29.1c12.5 0 22.6-10.1 22.6-22.6 0-6-2.4-11.8-6.6-16l-34.7-34.7 192-192zM341.1 353.4 222.6 234.9c-42.7-3.7-85.2 11.7-115.8 42.3l-8 8c-22.3 22.3-34.8 52.5-34.8 84 0 6.8 7.1 11.2 13.2 8.2l51.1-25.5c5-2.5 9.5 4.1 5.4 7.9L7.3 473.4C2.7 477.6 0 483.6 0 489.9 0 502.1 9.9 512 22.1 512h173.3c38.8 0 75.9-15.4 103.4-42.8 30.6-30.6 45.9-73.1 42.3-115.8z"
        }
    ]
};

const FasBrowser = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBrowser",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 96c0-35.3 28.7-64 64-64h384c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm64 32a32 32 0 1 0 64 0 32 32 0 1 0-64 0zm384 0c0-13.3-10.7-24-24-24H184c-13.3 0-24 10.7-24 24s10.7 24 24 24h240c13.3 0 24-10.7 24-24z"
        }
    ]
};

const FasBrowsers = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBrowsers",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 0c-35.3 0-64 28.7-64 64v288c0 35.3 28.7 64 64 64h352c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H160zm120 72h208c13.3 0 24 10.7 24 24s-10.7 24-24 24H280c-13.3 0-24-10.7-24-24s10.7-24 24-24zm-56 24a32 32 0 1 1-64 0 32 32 0 1 1 64 0zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120v256c0 75.1 60.9 136 136 136h320c13.3 0 24-10.7 24-24s-10.7-24-24-24H136c-48.6 0-88-39.4-88-88V120z"
        }
    ]
};

const FasBrush = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBrush",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M162.4 6c-1.5-3.6-5-6-8.9-6h-19c-3.9 0-7.5 2.4-8.9 6l-20.7 51.7c-3.2 8-14.6 8-17.8 0L66.4 6c-1.5-3.6-5-6-8.9-6H48C21.5 0 0 21.5 0 48v208h384V48c0-26.5-21.5-48-48-48H230.5c-3.9 0-7.5 2.4-8.9 6l-20.7 51.7c-3.2 8-14.6 8-17.8 0L162.4 6zM0 288v32c0 35.3 28.7 64 64 64h64v64c0 35.3 28.7 64 64 64s64-28.7 64-64v-64h64c35.3 0 64-28.7 64-64v-32H0zm192 144a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
        }
    ]
};

const FasBucket = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBucket",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 152v8H48v-8C48 68.1 116.1 0 200 0h48c83.9 0 152 68.1 152 152v8h-48v-8c0-57.4-46.6-104-104-104h-48C142.6 48 96 94.6 96 152zM0 224c0-17.7 14.3-32 32-32h384c17.7 0 32 14.3 32 32s-14.3 32-32 32h-5.1l-22.4 213c-2.6 24.4-23.2 43-47.7 43H107.2c-24.6 0-45.2-18.5-47.7-43L37.1 256H32c-17.7 0-32-14.3-32-32z"
        }
    ]
};

const FasBugSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBugSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L477.4 348.9c1.7-9.4 2.6-19 2.6-28.9h64c17.7 0 32-14.3 32-32s-14.3-32-32-32h-64.3c-1.1-14.1-5-27.5-11.1-39.5.7-.6 1.4-1.2 2.1-1.9l64-64c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-64 64c-.7.7-1.3 1.4-1.9 2.1-14.3-7.3-30.4-11.4-47.5-11.4H264c-8.3 0-16.3 1-24 2.8L38.8 5.1zM320 0c-53 0-96 43-96 96v3.6c0 15.7 12.7 28.4 28.4 28.4h135.2c15.7 0 28.4-12.7 28.4-28.4V96c0-53-43-96-96-96zM160.3 256H96c-17.7 0-32 14.3-32 32s14.3 32 32 32h64c0 24.6 5.5 47.8 15.4 68.6-2.2 1.3-4.2 2.9-6 4.8l-64 64c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l63.1-63.1c24.5 21.8 55.8 36.2 90.3 39.6V335.5L166.7 227.3c-3.4 9-5.6 18.7-6.4 28.7zM336 479.2c36.6-3.6 69.7-19.6 94.8-43.8L336 360.7v118.5z"
        }
    ]
};

const FasBug = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBug",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 0c53 0 96 43 96 96v3.6c0 15.7-12.7 28.4-28.4 28.4H188.4c-15.7 0-28.4-12.7-28.4-28.4V96c0-53 43-96 96-96zM41.4 105.4c12.5-12.5 32.8-12.5 45.3 0l64 64c.7.7 1.3 1.4 1.9 2.1 14.2-7.3 30.4-11.4 47.5-11.4H312c17.1 0 33.2 4.1 47.5 11.4.6-.7 1.2-1.4 1.9-2.1l64-64c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-64 64c-.7.7-1.4 1.3-2.1 1.9 6.2 12 10.1 25.3 11.1 39.5H480c17.7 0 32 14.3 32 32s-14.3 32-32 32h-64c0 24.6-5.5 47.8-15.4 68.6 2.2 1.3 4.2 2.9 6 4.8l64 64c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-63.1-63.1c-24.5 21.8-55.8 36.2-90.3 39.6V240c0-8.8-7.2-16-16-16s-16 7.2-16 16v239.2c-34.5-3.4-65.8-17.8-90.3-39.6l-63 63c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l64-64c1.9-1.9 3.9-3.4 6-4.8C101.5 367.8 96 344.6 96 320H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h64.3c1.1-14.1 5-27.5 11.1-39.5-.7-.6-1.4-1.2-2.1-1.9l-64-64c-12.5-12.5-12.5-32.8 0-45.3z"
        }
    ]
};

const FasBugs = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBugs",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m164.5 107.4 33.4-73.5c5.5-12.1.1-26.3-11.9-31.8S159.7 2 154.2 14L128 71.7l-26.1-57.6C96.4 2 82.1-3.3 70.1 2.1s-17.4 19.8-12 31.8l33.4 73.5c-10.2 7.1-18.2 17-22.9 28.6h-17l-4.1-20.7c-2.6-13-15.2-21.4-28.2-18.8S-2.1 111.7.5 124.7l8 40C10.7 175.9 20.6 184 32 184h32v23.3l-37.8 9.5c-9.5 2.4-16.6 10.2-17.9 19.9l-8 56c-1.9 13.1 7.2 25.3 20.4 27.2s25.3-7.2 27.2-20.4l5.7-40 18.4-4.6c10.7 19.7 31.8 33.1 56 33.1s45.3-13.4 56.1-33.2l18.4 4.6 5.7 40c1.9 13.1 14 22.2 27.2 20.4s22.2-14 20.4-27.2l-8-56c-1.4-9.7-8.5-17.5-17.9-19.9l-37.9-9.4V184h32c11.4 0 21.3-8.1 23.5-19.3l8-40c2.6-13-5.8-25.6-18.8-28.2s-25.6 5.8-28.2 18.8l-4.2 20.7h-17c-4.7-11.6-12.7-21.5-22.9-28.6zM496 286.5l65.6-47c10.8-7.7 13.3-22.7 5.6-33.5s-22.7-13.3-33.5-5.6l-51.4 36.8 6.1-62.9c1.3-13.2-8.4-24.9-21.6-26.2s-24.9 8.4-26.2 21.6l-7.8 80.3c-12.3 1-24.2 5.6-34.1 13.3l-14.7-8.5 6.8-20c4.2-12.6-2.5-26.2-15-30.4s-26.2 2.5-30.4 15L332.3 258c-3.7 10.8.8 22.8 10.7 28.5l27.7 16-11.7 20.2-37.5-10.7c-9.4-2.7-19.5.6-25.5 8.3l-34.9 44.5c-8.2 10.4-6.4 25.5 4.1 33.7s25.5 6.4 33.7-4.1l25-31.8 18.2 5.2c-.5 22.6 11 44.7 32 56.8s45.9 11 65.2-.7l13.6 13.2-15.1 37.5c-4.9 12.3 1 26.3 13.3 31.2s26.3-1 31.2-13.3l21.2-52.5c3.6-9.1 1.4-19.4-5.6-26.2l-28-27.1 11.6-20.1 27.7 16c9.9 5.7 22.5 3.7 30-4.9l27-30.7c8.7-10 7.8-25.1-2.2-33.9s-25.1-7.8-33.9 2.2l-13.9 15.9-14.7-8.5c1.7-12.4-.2-25-5.5-36.2z"
        }
    ]
};

const FasBuildingCircleArrowRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBuildingCircleArrowRight",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 48C0 21.5 21.5 0 48 0h288c26.5 0 48 21.5 48 48v184.2c-39.1 32.3-64 81.1-64 135.8 0 49.5 20.4 94.2 53.3 126.2-8.8 10.9-22.2 17.8-37.3 17.8h-96v-80c0-26.5-21.5-48-48-48s-48 21.5-48 48v80H48c-26.5 0-48-21.5-48-48V48zm80 176c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16H80zm80 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16zm112-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32zM64 112v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm112-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32zm80 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16zm96 256a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm140.7-67.3c-6.2 6.2-6.2 16.4 0 22.6l28.7 28.7H432c-8.8 0-16 7.2-16 16s7.2 16 16 16h89.4l-28.7 28.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l56-56c6.2-6.2 6.2-16.4 0-22.6l-56-56c-6.2-6.2-16.4-6.2-22.6 0z"
        }
    ]
};

const FasBuildingCircleCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBuildingCircleCheck",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 0C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h96v-80c0-26.5 21.5-48 48-48s48 21.5 48 48v80h96c15.1 0 28.5-6.9 37.3-17.8-32.9-32-53.3-76.7-53.3-126.2 0-54.7 24.9-103.5 64-135.8V48c0-26.5-21.5-48-48-48H48zm16 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-32zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32zM80 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16zm368 272a144 144 0 1 0-288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l28.7 28.7 60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"
        }
    ]
};

const FasBuildingCircleExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBuildingCircleExclamation",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 0C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h96v-80c0-26.5 21.5-48 48-48s48 21.5 48 48v80h96c15.1 0 28.5-6.9 37.3-17.8-32.9-32-53.3-76.7-53.3-126.2 0-54.7 24.9-103.5 64-135.8V48c0-26.5-21.5-48-48-48H48zm16 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-32zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32zM80 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16zm224 416a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16v-80c0-8.8 7.2-16 16-16z"
        }
    ]
};

const FasBuildingCircleXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBuildingCircleXmark",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 0C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h96v-80c0-26.5 21.5-48 48-48s48 21.5 48 48v80h96c15.1 0 28.5-6.9 37.3-17.8-32.9-32-53.3-76.7-53.3-126.2 0-54.7 24.9-103.5 64-135.8V48c0-26.5-21.5-48-48-48H48zm16 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-32zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32zM80 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16zm224 416a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L518.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l36.7-36.7-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l36.7 36.7 36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
        }
    ]
};

const FasBuildingColumns = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBuildingColumns",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m243.4 2.6-224 96c-14 6-21.8 21-18.7 35.8S16.8 160 32 160v8c0 13.3 10.7 24 24 24h400c13.3 0 24-10.7 24-24v-8c15.2 0 28.3-10.7 31.3-25.6s-4.8-29.9-18.7-35.8l-224-96c-8-3.4-17.2-3.4-25.2 0zM128 224H64v196.3c-.6.3-1.2.7-1.8 1.1l-48 32c-11.7 7.8-17 22.4-12.9 35.9S17.9 512 32 512h448c14.1 0 26.5-9.2 30.6-22.7s-1.1-28.1-12.9-35.9l-48-32c-.6-.4-1.2-.7-1.8-1.1V224H384v192h-40V224h-64v192h-48V224h-64v192h-40V224zM256 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FasBuildingFlag = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBuildingFlag",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 0C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h96v-80c0-26.5 21.5-48 48-48s48 21.5 48 48v80h96c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H48zm16 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-32zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32zM80 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16zM448 0c-17.7 0-32 14.3-32 32v480h64V192h144c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H480c0-17.7-14.3-32-32-32z"
        }
    ]
};

const FasBuildingLock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBuildingLock",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 0C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h96v-80c0-26.5 21.5-48 48-48s48 21.5 48 48v80h88.6c-5.4-9.4-8.6-20.3-8.6-32V352c0-23.7 12.9-44.4 32-55.4V272c0-30.5 12.2-58.2 32-78.4V48c0-26.5-21.5-48-48-48H48zm16 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-32zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32zM80 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16zm192 144c17.7 0 32 14.3 32 32v48h-64v-48c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32v128c0 17.7 14.3 32 32 32h160c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32v-48c0-44.2-35.8-80-80-80s-80 35.8-80 80z"
        }
    ]
};

const FasBuildingNgo = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBuildingNgo",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 0C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h96v-80c0-26.5 21.5-48 48-48s48 21.5 48 48v80h96c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H48zm16 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-32zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32zM168 64h48c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32v64h16v-16c0-8.8 7.2-16 16-16s16 7.2 16 16v24c0 13.3-10.7 24-24 24h-32c-13.3 0-24-10.7-24-24V80c0-8.8 7.2-16 16-16zm136 32c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16s16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm-48 16c0-26.5 21.5-48 48-48s48 21.5 48 48v32c0 26.5-21.5 48-48 48s-48-21.5-48-48v-32zM61.3 71.1l34.7 52V80c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 7.1-4.6 13.3-11.4 15.3s-14-.6-17.9-6.4L64 132.8V176c0 8.8-7.2 16-16 16s-16-7.2-16-16V80c0-7.1 4.6-13.3 11.4-15.3s14 .6 17.9 6.4z"
        }
    ]
};

const FasBuildingShield = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBuildingShield",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 48C0 21.5 21.5 0 48 0h288c26.5 0 48 21.5 48 48v159l-42.4 17H272c-8.8 0-16 7.2-16 16v64c0 .9.1 1.7.2 2.6 2.3 58.1 24.1 144.8 98.7 201.5-5.8 2.5-12.2 3.9-18.9 3.9h-96v-80c0-26.5-21.5-48-48-48s-48 21.5-48 48v80H48c-26.5 0-48-21.5-48-48V48zm80 176c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16H80zm80 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16zM64 112v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm112-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32zm80 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16zm167.1 113.7c5.7-2.3 12.1-2.3 17.8 0l120 48c9.1 3.7 15.1 12.5 15.1 22.3 0 63.3-25.9 168.8-134.8 214.2-5.9 2.5-12.6 2.5-18.5 0C313.9 464.8 288 359.3 288 296c0-9.8 6-18.6 15.1-22.3l120-48zM527.4 312 432 273.8v187.9c68.2-33 91.5-99 95.4-149.7z"
        }
    ]
};

const FasBuildingUn = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBuildingUn",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 0C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h96v-80c0-26.5 21.5-48 48-48s48 21.5 48 48v80h96c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H48zm16 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-32zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32zM237.3 71.1l34.7 52V80c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 7.1-4.6 13.3-11.4 15.3s-14-.6-17.9-6.4l-34.7-52V176c0 8.8-7.2 16-16 16s-16-7.2-16-16V80c0-7.1 4.6-13.3 11.4-15.3s14 .6 17.9 6.4zM112 80v64c0 8.8 7.2 16 16 16s16-7.2 16-16V80c0-8.8 7.2-16 16-16s16 7.2 16 16v64c0 26.5-21.5 48-48 48s-48-21.5-48-48V80c0-8.8 7.2-16 16-16s16 7.2 16 16z"
        }
    ]
};

const FasBuildingUser = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBuildingUser",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 0C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h96v-80c0-26.5 21.5-48 48-48s48 21.5 48 48v80h89.9c-6.3-10.2-9.9-22.2-9.9-35.1 0-46.9 25.8-87.8 64-109.2V48c0-26.5-21.5-48-48-48H48zm16 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-32zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32zM80 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16zm304 176a80 80 0 1 0-160 0 80 80 0 1 0 160 0zM352 477.1c0 19.3 15.6 34.9 34.9 34.9h218.2c19.3 0 34.9-15.6 34.9-34.9 0-51.4-41.7-93.1-93.1-93.1H445.1c-51.4 0-93.1 41.7-93.1 93.1z"
        }
    ]
};

const FasBuildingWheat = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBuildingWheat",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 48C0 21.5 21.5 0 48 0h288c26.5 0 48 21.5 48 48v416c0 26.5-21.5 48-48 48h-96v-80c0-26.5-21.5-48-48-48s-48 21.5-48 48v80H48c-26.5 0-48-21.5-48-48V48zm80 176c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16H80zm80 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16zm112-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32zM64 112v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm112-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32zm80 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16zm384 80v16c0 44.2-35.8 80-80 80h-16v-16c0-44.2 35.8-80 80-80h16zm0 128c0 44.2-35.8 80-80 80h-16v-16c0-44.2 35.8-80 80-80h16v16zm0 112c0 44.2-35.8 80-80 80h-16v-16c0-44.2 35.8-80 80-80h16v16zm-128 64v16h-16c-44.2 0-80-35.8-80-80v-16h16c44.2 0 80 35.8 80 80zm0-96h-16c-44.2 0-80-35.8-80-80v-16h16c44.2 0 80 35.8 80 80v16zm0-128v16h-16c-44.2 0-80-35.8-80-80v-16h16c44.2 0 80 35.8 80 80zm16-240c13.3 0 24 10.7 24 24v104c0 13.3-10.7 24-24 24s-24-10.7-24-24V56c0-13.3 10.7-24 24-24zm96 64v32c0 13.3-10.7 24-24 24s-24-10.7-24-24V96c0-13.3 10.7-24 24-24s24 10.7 24 24zM456 72c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24s-24-10.7-24-24V96c0-13.3 10.7-24 24-24z"
        }
    ]
};

const FasBuilding = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBuilding",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 0C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h96v-80c0-26.5 21.5-48 48-48s48 21.5 48 48v80h96c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H48zm16 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-32zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32zM80 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16z"
        }
    ]
};

const FasBuildings = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBuildings",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 0c-35.3 0-64 28.7-64 64v64H64c-35.3 0-64 28.7-64 64v256c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H256zM64 304c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-32zm208 16c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32zm112-16v-32c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16zM80 192h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16zM256 80c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16V80zm144-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16zM256 208v-32c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16zm144 16c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32z"
        }
    ]
};

const FasBullhorn = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBullhorn",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 32c0-12.9-7.8-24.6-19.8-29.6S434.5.2 425.3 9.3L381.7 53c-48 48-113.1 75-181 75H64c-35.3 0-64 28.7-64 64v96c0 35.3 28.7 64 64 64v128c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V352h8.7c67.9 0 133 27 181 75l43.6 43.6c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6V300.4c18.6-8.8 32-32.5 32-60.4s-13.4-51.6-32-60.4V32zm-64 76.7v262.6C357.2 317.8 280.5 288 200.7 288H192v-96h8.7c79.8 0 156.5-29.8 215.3-83.3z"
        }
    ]
};

const FasBullseyeArrow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBullseyeArrow",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M335.2 244.7c.5 3.7.8 7.5.8 11.3 0 44.2-35.8 80-80 80s-80-35.8-80-80 35.8-80 80-80c3.8 0 7.6.3 11.3.8l31.2-31.2-4.8-28.6c-12-3.3-24.7-5-37.7-5-79.5 0-144 64.5-144 144s64.5 144 144 144 144-64.5 144-144c0-13.1-1.7-25.7-5-37.7l-28.6-4.8-31.2 31.2zm110.1-20.8c1.8 10.4 2.7 21.1 2.7 32.1 0 106-86 192-192 192S64 362 64 256 150 64 256 64c10.9 0 21.6.9 32.1 2.7l9.3-9.3 43.1-43.1C314 5 285.6 0 256 0 114.6 0 0 114.6 0 256s114.6 256 256 256 256-114.6 256-256c0-29.6-5-58-14.3-84.5l-43.1 43.1-9.3 9.3zm-80.2-43.1 50.7 8.4c10.2 1.7 20.6-1.6 27.9-8.9l51.2-51.2c8.1-8.1 5.3-21.9-5.4-26.2L432 80l-23-57.5c-4.3-10.7-18-13.5-26.2-5.4l-51.2 51.3c-7.3 7.3-10.6 17.7-8.9 27.9l8.4 50.7-92.1 92c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l92.1-92.1z"
        }
    ]
};

const FasBullseyePointer = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBullseyePointer",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 448c106 0 192-86 192-192S362 64 256 64 64 150 64 256c0 3.9.1 7.8.4 11.7L1.8 286.1C.6 276.2 0 266.2 0 256 0 114.6 114.6 0 256 0s256 114.6 256 256-114.6 256-256 256c-10.2 0-20.2-.6-30.1-1.8l18.4-62.6c3.9.2 7.8.4 11.7.4zm2.3-48 19.7-67c33.5-9.6 58-40.4 58-76.9 0-44.2-35.8-80-80-80-36.5 0-67.4 24.5-76.9 58L112 253.7c1.2-78.5 65.2-141.7 144-141.7 79.5 0 144 64.5 144 144 0 78.8-63.2 142.8-141.7 144zM39 308.5l204.8-60.2c12.1-3.6 23.4 7.7 19.9 19.9L203.5 473c-4.1 13.9-23.2 15.6-29.7 2.6l-28.7-57.3c-.7-1.3-1.5-2.6-2.5-3.7l-88 88c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l88-88c-1.1-1-2.3-1.9-3.7-2.5l-57.2-28.6c-13-6.5-11.3-25.6 2.6-29.7z"
        }
    ]
};

const FasBullseye = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBullseye",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 256a192 192 0 1 0-384 0 192 192 0 1 0 384 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm256 80a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0-224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm-32 144a32 32 0 1 1 64 0 32 32 0 1 1-64 0z"
        }
    ]
};

const FasBuoyMooring = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBuoyMooring",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32c0-17.7 14.3-32 32-32s32 14.3 32 32v36.7c38 11.5 67.8 43.2 75.9 83.7l48.5 242.7c-.4.3-.9.6-1.3.9-18 12.4-40.1 20.3-59.2 20.3-19.6 0-40.8-7.7-59.2-20.3-22.1-15.5-51.6-15.5-73.7 0-17.1 11.8-38 20.3-59.2 20.3-19 0-41.2-7.9-59.2-20.3-.4-.3-.9-.6-1.3-.9l48.5-242.7c8.1-40.6 37.9-72.2 75.9-83.7V32zm32 96c-22 0-40.9 15.5-45.2 37l-24.6 123h139.6l-24.6-123c-4.3-21.5-23.2-37-45.2-37zm18.5 293.9c22.5 15.5 50 26.1 77.5 26.1 26.9 0 55.4-10.8 77.4-26.1 11.9-8.5 28.1-7.8 39.2 1.7 14.4 11.9 32.5 21 50.6 25.2 17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25-29 15.6-61.5 25.9-94.5 25.9-31.9 0-60.6-9.9-80.4-18.9-5.8-2.7-11.1-5.3-15.6-7.7-4.5 2.4-9.7 5.1-15.6 7.7-19.8 9-48.5 18.9-80.4 18.9-33 0-65.5-10.3-94.5-25.8-13.4 8.4-33.7 19.3-58.2 25-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2 11.1-9.4 27.3-10.1 39.2-1.7 22.1 15.2 50.5 26 77.4 26 27.5 0 55-10.6 77.5-26.1 11.1-7.9 25.9-7.9 37 0z"
        }
    ]
};

const FasBuoy = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBuoy",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 0c-17.7 0-32 14.3-32 32 0 15.3 10.8 28.1 25.1 31.3L133.8 320H96c-17.7 0-32 14.3-32 32v16c0 8.2.7 16.1 2 23.9 21-11.1 46.9-9.9 66.9 4.2 18 12.4 40.1 20.3 59.2 20.3 21.1 0 42-8.5 59.2-20.3 22.1-15.5 51.6-15.5 73.7 0 18.4 12.7 39.6 20.3 59.2 20.3 19 0 41.2-7.9 59.2-20.3 20-14.1 45.9-15.3 66.9-4.2 1.3-7.8 2-15.8 2-23.9v-16c0-17.7-14.3-32-32-32h-38.1L390.9 63.3c14.3-3.2 25.1-16 25.1-31.3 0-17.7-14.3-32-32-32H192zm133.8 64 9.8 49-47.6 55.5-47.6-55.5 9.8-49h75.5zm21.8 108.8 17 84.9-44.9-52.4 27.9-32.6zm-91.1 32.6-44.9 52.4 17-84.9 27.9 32.6zM221.3 320l66.7-77.8 66.7 77.8H221.3zm85.2 101.9c-11.1-7.9-25.9-7.9-37 0-22.5 15.5-50 26.1-77.5 26.1-26.9 0-55.3-10.8-77.4-26.1-11.9-8.5-28.1-7.8-39.2 1.7-14.4 11.9-32.5 21-50.6 25.2-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25 29 15.6 61.5 25.9 94.5 25.9 31.9 0 60.6-9.9 80.4-18.9 5.8-2.7 11.1-5.3 15.6-7.7 4.5 2.4 9.7 5.1 15.6 7.7 19.8 9 48.5 18.9 80.4 18.9 33 0 65.5-10.3 94.5-25.8 13.4 8.4 33.7 19.3 58.2 25 17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2-11.1-9.4-27.3-10.1-39.2-1.7-22 15.2-50.5 26-77.4 26-27.5 0-55-10.6-77.5-26.1z"
        }
    ]
};

const FasBurgerCheese = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBurgerCheese",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 194.9C32 211 45 224 61.1 224h389.8c16.1 0 29.1-13 29.1-29.1 0-1.9-.2-3.7-.6-5.6C474.1 168.3 433.2 32 256 32S37.9 168.3 32.6 189.3c-.5 1.9-.6 3.7-.6 5.6zm96-82.9a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm240 16a16 16 0 1 1 32 0 16 16 0 1 1-32 0zM256 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM32 400v16c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64v-16c0-8.8-7.2-16-16-16H48c-8.8 0-16 7.2-16 16zm202-137.3c-6.5-4.4-14.2-6.7-22.1-6.7H64c-26.5 0-48 21.5-48 48s21.5 48 48 48h384c26.5 0 48-21.5 48-48s-21.5-48-48-48h-19.9c-7.9 0-15.6 2.3-22.1 6.7l-68.2 45.5c-10.7 7.2-24.8 7.2-35.5 0L234 262.7z"
        }
    ]
};

const FasBurgerFries = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBurgerFries",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M183.2 1.7c-5-2.5-10.8-2.2-15.6.7S160 10.5 160 16v253.9c9.2 1.4 19.8 2.2 32 2.2s22.8-.8 32-2.2V31.8c-.1-6-3.5-11.4-8.8-14.1l-32-16zm-55.2 13-.2-1.3c-.8-5-4-9.3-8.5-11.6s-9.9-2.3-14.4-.1l-32 16c-6.3 3.1-9.8 10-8.6 16.9l32 192c.5 1.2.9 2.3 1.2 3.4 2 6.3 6.7 15.9 18.7 24.3 3.2 2.2 7.1 4.5 11.8 6.6V14.7zM40.3 85.6l-20.4-5.1c-5.3-1.3-10.8.1-14.8 3.8S-.7 93.4.2 98.8l16.5 93.4c1.6-.1 3.1-.2 4.7-.2H48c3.6 0 7 .4 10.2 1L40.3 85.6zm343.5 13.2c.9-5.3-.9-10.8-4.8-14.5s-9.5-5.1-14.8-3.8l-18 4.5-19 107.8c2-.3 4-.6 6.1-.7 11-6.5 23.3-12.3 37.1-17.2l13.4-76.1zM276.3 337.2c-11.8-10.4-19.5-25.3-20.2-42.1-16.6 5.4-37.6 8.8-64.1 8.8-91.7 0-117.7-41-125.1-64.3C64.3 231.2 56.8 224 48 224H21.4C9.6 224 0 233.6 0 245.4c0 1.7.2 3.4.6 5.1l57.5 237c3.4 14.4 16.3 24.5 31.1 24.5H272c-10-13.4-16-30-16-48 0-14.7 6.6-27.8 17-36.6-10.5-11.4-17-26.6-17-43.4 0-18.5 7.8-35.1 20.3-46.8zm-8.5-82.9c.8-.6 1.6-1.1 2.4-1.7 4.1-6.6 9.4-14 16.1-21.6l.3-.9c.7-2.3 1.7-4.7 2.8-7l30.4-172.3c.9-5.3-.9-10.8-4.8-14.5s-9.5-5.1-14.8-3.8l-32 8c-6.2 1.5-10.9 6.5-12 12.7l-.2 1.4V261c4.8-2.1 8.7-4.4 11.8-6.6zm372.2 38c0-3-.5-5.9-1.7-8.6-8.1-18.4-48.4-91.9-174.3-91.9s-166.2 73.5-174.3 91.9c-1.2 2.7-1.7 5.7-1.7 8.6 0 15.2 12.3 27.5 27.5 27.5h297c15.2 0 27.5-12.3 27.5-27.5zm-256-52.5a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm64 0a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm96 0a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-224 112c-17.7 0-32 14.3-32 32s14.3 32 32 32h288c17.7 0 32-14.3 32-32s-14.3-32-32-32H320zm-16 96c-8.8 0-16 7.2-16 16 0 26.5 21.5 48 48 48h256c26.5 0 48-21.5 48-48 0-8.8-7.2-16-16-16H304z"
        }
    ]
};

const FasBurgerGlass = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBurgerGlass",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 0C23.1 0 14.6 3.7 8.6 10.2S-.6 25.4.1 34.3l28.8 403.4c3 41.9 37.8 74.3 79.8 74.3H272c-10-13.4-16-30-16-48 0-14.7 6.6-27.8 17-36.6-10.5-11.4-17-26.6-17-43.4 0-18.5 7.8-35.1 20.3-46.8-12.4-10.9-20.3-26.9-20.3-44.8 0-6.3 1-13.8 4.4-21.5 5.5-12.5 20.5-40.4 52.7-65.3 16.2-12.5 36.3-23.8 60.9-32l10-139.4c.6-8.9-2.4-17.6-8.5-24.1S360.9 0 352 0H32zm41.2 160-6.8-96h251.2l-6.9 96H73.2zM640 292.3c0-3-.5-5.9-1.7-8.6-8.1-18.4-48.4-91.9-174.3-91.9s-166.2 73.5-174.3 91.9c-1.2 2.7-1.7 5.7-1.7 8.6 0 15.2 12.3 27.5 27.5 27.5h297c15.2 0 27.5-12.3 27.5-27.5zm-256-52.5a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm64 0a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm96 0a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-224 112c-17.7 0-32 14.3-32 32s14.3 32 32 32h288c17.7 0 32-14.3 32-32s-14.3-32-32-32H320zm-16 96c-8.8 0-16 7.2-16 16 0 26.5 21.5 48 48 48h256c26.5 0 48-21.5 48-48 0-8.8-7.2-16-16-16H304z"
        }
    ]
};

const FasBurgerLettuce = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBurgerLettuce",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 194.9C32 211 45 224 61.1 224h389.8c16.1 0 29.1-13 29.1-29.1 0-1.9-.2-3.7-.6-5.6C474.1 168.3 433.2 32 256 32S37.9 168.3 32.6 189.3c-.5 1.9-.6 3.7-.6 5.6zm96-82.9a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm240 16a16 16 0 1 1 32 0 16 16 0 1 1-32 0zM256 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM32 400v16c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64v-16c0-8.8-7.2-16-16-16H48c-8.8 0-16 7.2-16 16zm48-48c24.6 0 44.2-11.8 56.2-19 .9-.5 1.7-1 2.5-1.5 13.7-8.1 20.8-11.5 29.3-11.5 7.7 0 12.3 2.5 25.4 10.9l.2.1c13 8.3 32.6 21 62.4 21 29.7 0 48.6-12.6 61-20.9l.8-.5c11.6-7.7 16.6-10.6 26.2-10.6 10.5 0 17.9 3.7 30.2 11.3.9.5 1.8 1.1 2.8 1.7 11.4 7.1 30.3 19 55 19 21.5 0 38.4-5.4 50.3-11.4 5.9-3 10.5-6 13.9-8.5 1.7-1.3 3.1-2.4 4.1-3.3.5-.5 1-.9 1.4-1.2l.5-.5.2-.2.1-.1-22.6-22.6 22.6 22.6c12.5-12.5 12.5-32.8 0-45.3-12.3-12.3-32-12.5-44.5-.7l-.3.2c-.6.5-2 1.4-4.1 2.5-4.1 2-11.2 4.6-21.7 4.6-5.2 0-9.2-2-24.2-11.3-13.6-8.5-34.2-20.8-63.7-20.8-29.7 0-48.6 12.6-61 20.9l-.8.5c-11.6 7.7-16.5 10.6-26.2 10.6-10 0-16.1-3.2-28-10.9l-1.8-1.1c-11.9-7.7-30.8-20-58.3-20-27.7 0-48.4 12.3-61.6 20.2l-.5.3C90.7 285.6 85.6 288 80 288c-10.5 0-17.6-2.6-21.7-4.6-2.1-1-3.5-2-4.1-2.5l-.3-.2c-12.5-11.8-32.3-11.6-44.5.7-12.5 12.5-12.5 32.8 0 45.3l22.4-22.4-22.4 22.3.1.1.2.2.5.5c.4.4.8.8 1.4 1.2 1.1.9 2.4 2.1 4.1 3.3 3.4 2.5 8 5.6 13.9 8.5 12 6.2 28.9 11.6 50.4 11.6z"
        }
    ]
};

const FasBurgerSoda = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBurgerSoda",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M249.3 0c-26 0-48.6 17.9-54.5 43.2l-20 84.8H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h301.4c14-8.2 30.1-15.4 48.6-20.9 1.3-3.5 2-7.2 2-11.1 0-17.7-14.3-32-32-32H224.2l17.4-73.8c.9-3.6 4.1-6.2 7.8-6.2H280c13.3 0 24-10.7 24-24S293.3 0 280 0h-30.7zM40 224l20.3 244c2.1 24.9 22.9 44 47.8 44H272c-10-13.4-16-30-16-48 0-14.7 6.6-27.8 17-36.6-10.5-11.4-17-26.6-17-43.4 0-18.5 7.8-35.1 20.3-46.8-12.4-10.9-20.3-26.9-20.3-44.8 0-6.3 1-13.8 4.4-21.5 4.2-9.5 13.8-27.8 32.2-47H40zm600 68.3c0-3-.5-5.9-1.7-8.6-8.1-18.4-48.4-91.9-174.3-91.9s-166.2 73.5-174.3 91.9c-1.2 2.7-1.7 5.7-1.7 8.6 0 15.2 12.3 27.5 27.5 27.5h297c15.2 0 27.5-12.3 27.5-27.5zm-256-52.5a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm64 0a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm96 0a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-224 112c-17.7 0-32 14.3-32 32s14.3 32 32 32h288c17.7 0 32-14.3 32-32s-14.3-32-32-32H320zm-16 96c-8.8 0-16 7.2-16 16 0 26.5 21.5 48 48 48h256c26.5 0 48-21.5 48-48 0-8.8-7.2-16-16-16H304z"
        }
    ]
};

const FasBurger = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBurger",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M61.1 224C45 224 32 211 32 194.9c0-1.9.2-3.7.6-5.6C37.9 168.3 78.8 32 256 32s218.1 136.3 223.4 157.3c.5 1.9.6 3.7.6 5.6 0 16.1-13 29.1-29.1 29.1H61.1zm82.9-96a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm240 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM272 96a16 16 0 1 0-32 0 16 16 0 1 0 32 0zM16 304c0-26.5 21.5-48 48-48h384c26.5 0 48 21.5 48 48s-21.5 48-48 48H64c-26.5 0-48-21.5-48-48zm16 96c0-8.8 7.2-16 16-16h416c8.8 0 16 7.2 16 16v16c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64v-16z"
        }
    ]
};

const FasBurrito = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBurrito",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M251.4 52.6 33.9 270.1c-9.9 9.9-17.8 21.3-23.4 33.7C39.2 324.1 74.2 336 112 336c79.2 0 146.2-52.3 168.3-124.3 5-16.3 7.7-33.7 7.7-51.7 0-40.4-13.6-77.7-36.6-107.4zm15-32C299.7 57.5 320 106.4 320 160c0 11.9-1 23.6-2.9 34.9 11.4-1.9 23-2.9 34.9-2.9 53.6 0 102.5 20.3 139.4 53.6 12.8-14.2 20.6-33 20.6-53.6 0-11.4-2.4-22.2-6.7-32 4.3-9.8 6.7-20.6 6.7-32 0-34.6-22-64.1-52.8-75.2C448.1 22 418.6 0 384 0c-11.4 0-22.2 2.4-32 6.7-9.8-4.3-20.6-6.7-32-6.7-20.6 0-39.4 7.8-53.6 20.6zm193 240c-29.7-23-67-36.6-107.4-36.6-15.2 0-29.9 1.9-43.9 5.5C279.5 310.2 202.5 368 112 368c-40.8 0-78.8-11.7-110.9-32-.7 5.3-1.1 10.6-1.1 16 0 30.7 12.2 60.2 33.9 81.9L78 478c21.8 21.8 51.3 34 82 34s60.2-12.2 81.9-33.9l217.5-217.5z"
        }
    ]
};

const FasBurst = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBurst",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M37.6 4.2C28-2.3 15.2-1.1 7 7s-9.4 21-2.8 30.5l112 163.3-99.6 32.4C6.7 236.4 0 245.6 0 256s6.7 19.6 16.6 22.8l103.1 33.4-52.9 100.6c-4.9 9.3-3.2 20.7 4.3 28.1s18.8 9.2 28.1 4.3l100.6-52.9 33.4 103.1c3.2 9.9 12.4 16.6 22.8 16.6s19.6-6.7 22.8-16.6l33.4-103.1 100.6 52.9c9.3 4.9 20.7 3.2 28.1-4.3s9.2-18.8 4.3-28.1l-52.9-100.6 103.1-33.4c9.9-3.2 16.6-12.4 16.6-22.8s-6.7-19.6-16.6-22.8l-106.5-34.5 25.7-70.4c3.2-8.8 1-18.6-5.6-25.2s-16.4-8.8-25.2-5.6l-70.4 25.7-34.6-106.6C275.6 6.7 266.4 0 256 0s-19.6 6.7-22.8 16.6l-32.3 99.6L37.6 4.2z"
        }
    ]
};

const FasBusSchool = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBusSchool",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 0c124.8 0 208 35.2 208 80v32h16c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32h-16v28.2c9.8 8.8 16 21.6 16 35.8v96c0 20.9-13.4 38.7-32 45.3V480c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32v-32H160v32c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32v-34.7c-18.6-6.6-32-24.4-32-45.3v-96c0-14.2 6.2-27 16-35.8V240H32c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32h16V80c0-44.8 83.2-80 208-80zM112 160v64c0 17.7 14.3 32 32 32h96V128h-96c-17.7 0-32 14.3-32 32zm160 96h96c17.7 0 32-14.3 32-32v-64c0-17.7-14.3-32-32-32h-96v128zM112 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm288 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM352 80c0-8.8-7.2-16-16-16H176c-8.8 0-16 7.2-16 16s7.2 16 16 16h160c8.8 0 16-7.2 16-16z"
        }
    ]
};

const FasBusSimple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBusSimple",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 0c124.8 0 224 35.2 224 80v336c0 17.7-14.3 32-32 32v32c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32v-32H128v32c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32v-32c-17.7 0-32-14.3-32-32V80C0 35.2 99.2 0 224 0zM64 128v128c0 17.7 14.3 32 32 32h256c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32zm16 272a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm288 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FasBus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBus",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 0c134.4 0 224 35.2 224 80v48c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32v160c0 17.7-14.3 32-32 32v32c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32v-32H192v32c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32v-32c-17.7 0-32-14.3-32-32V256c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32V80c0-44.8 89.6-80 224-80zM128 160v96c0 17.7 14.3 32 32 32h112V128H160c-17.7 0-32 14.3-32 32zm176 128h112c17.7 0 32-14.3 32-32v-96c0-17.7-14.3-32-32-32H304v160zM144 400a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm288 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM384 80c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16s7.2 16 16 16h160c8.8 0 16-7.2 16-16z"
        }
    ]
};

const FasBusinessTime = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasBusinessTime",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M184 48h144c4.4 0 8 3.6 8 8v40H176V56c0-4.4 3.6-8 8-8zm-56 8v40H64c-35.3 0-64 28.7-64 64v96h360.2c32.3-39.1 81.1-64 135.8-64 5.4 0 10.7.2 16 .7V160c0-35.3-28.7-64-64-64h-64V56c0-30.9-25.1-56-56-56H184c-30.9 0-56 25.1-56 56zm192 296h-96c-17.7 0-32-14.3-32-32v-32H0v128c0 35.3 28.7 64 64 64h296.2c-25.1-30.4-40.2-69.5-40.2-112 0-5.4.2-10.7.7-16h-.7zm320 16a144 144 0 1 0-288 0 144 144 0 1 0 288 0zm-144-80c8.8 0 16 7.2 16 16v48h32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16v-64c0-8.8 7.2-16 16-16z"
        }
    ]
};

const FasButter = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasButter",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 128c0-35.3 28.7-64 64-64h320v224H64V128zM32 320h576c17.7 0 32 14.3 32 32s-14.3 32-32 32v32c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32v-32c-17.7 0-32-14.3-32-32s14.3-32 32-32zM512 64c35.3 0 64 28.7 64 64v160h-96V64h32z"
        }
    ]
};

const FasC = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasC",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M329.1 142.9c-62.5-62.5-155.8-62.5-218.3 0s-62.5 163.8 0 226.3 155.8 62.5 218.3 0c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3c-87.5 87.5-221.3 87.5-308.8 0s-87.5-229.3 0-316.8 221.3-87.5 308.8 0c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0z"
        }
    ]
};

const FasCabin = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCabin",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M237.4 6c11.1-8 26.1-8 37.2 0L384 84.1V64c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32v88.7l18.6 13.3c11.3 8.1 16.1 22.6 11.9 35.8S493.9 224 480 224H32c-13.9 0-26.2-9-30.5-22.2S2.1 174 13.4 166l224-160zM32 280c0-13.3 10.7-24 24-24h112c13.3 0 24 10.7 24 24v16c0 13.3-10.7 24-24 24H56c-13.3 0-24-10.7-24-24v-16zm24 72h112c13.3 0 24 10.7 24 24v16c0 13.3-10.7 24-24 24H56c-13.3 0-24-10.7-24-24v-16c0-13.3 10.7-24 24-24zm0 96h112c13.3 0 24 10.7 24 24v16c0 13.3-10.7 24-24 24H56c-13.3 0-24-10.7-24-24v-16c0-13.3 10.7-24 24-24zm264-168c0-13.3 10.7-24 24-24h112c13.3 0 24 10.7 24 24v16c0 13.3-10.7 24-24 24H344c-13.3 0-24-10.7-24-24v-16zm24 168h112c13.3 0 24 10.7 24 24v16c0 13.3-10.7 24-24 24H344c-13.3 0-24-10.7-24-24v-16c0-13.3 10.7-24 24-24zm-24-72c0-13.3 10.7-24 24-24h112c13.3 0 24 10.7 24 24v16c0 13.3-10.7 24-24 24H344c-13.3 0-24-10.7-24-24v-16zm-64-216a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FasCabinetFiling = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCabinetFiling",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 64C0 28.7 28.7 0 64 0h320c35.3 0 64 28.7 64 64v176H0V64zm0 208h448v176c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V272zm128-144v16c0 8.8 7.2 16 16 16s16-7.2 16-16v-16h128v16c0 8.8 7.2 16 16 16s16-7.2 16-16v-16c0-17.7-14.3-32-32-32H160c-17.7 0-32 14.3-32 32zm0 256v16c0 8.8 7.2 16 16 16s16-7.2 16-16v-16h128v16c0 8.8 7.2 16 16 16s16-7.2 16-16v-16c0-17.7-14.3-32-32-32H160c-17.7 0-32 14.3-32 32z"
        }
    ]
};

const FasCableCar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCableCar",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM160 56a32 32 0 1 1 64 0 32 32 0 1 1-64 0zM32 288c0-35.3 28.7-64 64-64h136v-66.5l-203.1 42c-13 2.7-25.7-5.7-28.4-18.6s5.7-25.7 18.6-28.4l232-48 232-48c13-2.7 25.7 5.7 28.4 18.6s-5.7 25.7-18.6 28.4l-212.9 44V224h136c35.3 0 64 28.7 64 64v160c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V288zm64 0c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16H96zm112 16v64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16h-64c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16h-64z"
        }
    ]
};

const FasCactus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCactus",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 96c0-53 43-96 96-96s96 43 96 96v256h48c8.8 0 16-7.2 16-16v-64c0-26.5 21.5-48 48-48s48 21.5 48 48v64c0 61.9-50.1 112-112 112h-48v16c0 26.5-21.5 48-48 48h-96c-26.5 0-48-21.5-48-48V320h-48C50.1 320 0 269.9 0 208v-64c0-26.5 21.5-48 48-48s48 21.5 48 48v64c0 8.8 7.2 16 16 16h48V96zm80 64a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm48 240a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
        }
    ]
};

const FasCakeCandles = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCakeCandles",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M86.4 5.5 61.8 47.6C58 54.1 56 61.6 56 69.2V72c0 22.1 17.9 40 40 40s40-17.9 40-40v-2.8c0-7.6-2-15-5.8-21.6L105.6 5.5C103.6 2.1 100 0 96 0s-7.6 2.1-9.6 5.5zm128 0-24.6 42.1c-3.8 6.5-5.8 14-5.8 21.6V72c0 22.1 17.9 40 40 40s40-17.9 40-40v-2.8c0-7.6-2-15-5.8-21.6L233.6 5.5C231.6 2.1 228 0 224 0s-7.6 2.1-9.6 5.5zm103.4 42.1c-3.8 6.5-5.8 14-5.8 21.6V72c0 22.1 17.9 40 40 40s40-17.9 40-40v-2.8c0-7.6-2-15-5.8-21.6L361.6 5.5C359.6 2.1 356 0 352 0s-7.6 2.1-9.6 5.5l-24.6 42.1zM128 176c0-17.7-14.3-32-32-32s-32 14.3-32 32v48c-35.3 0-64 28.7-64 64v71c8.3 5.2 18.1 9 28.8 9 13.5 0 27.2-6.1 38.4-13.4 5.4-3.5 9.9-7.1 13-9.7 1.5-1.3 2.7-2.4 3.5-3.1.4-.4.7-.6.8-.8l.1-.1c3.1-3.2 7.4-4.9 11.9-4.8s8.6 2.1 11.6 5.4l.1.1.7.7c.7.7 1.7 1.7 3.1 3 2.8 2.6 6.8 6.1 11.8 9.5 10.2 7.1 23 13.1 36.3 13.1s26.1-6 36.3-13.1c5-3.5 9-6.9 11.8-9.5 1.4-1.3 2.4-2.3 3.1-3l.7-.7.1-.1c3-3.5 7.4-5.4 12-5.4s9 2 12 5.4l.1.1.7.7c.7.7 1.7 1.7 3.1 3 2.8 2.6 6.8 6.1 11.8 9.5 10.2 7.1 23 13.1 36.3 13.1s26.1-6 36.3-13.1c5-3.5 9-6.9 11.8-9.5 1.4-1.3 2.4-2.3 3.1-3l.7-.7.1-.1c2.9-3.4 7.1-5.3 11.6-5.4s8.7 1.6 11.9 4.8l.1.1.8.8c.8.7 1.9 1.8 3.5 3.1 3.1 2.6 7.5 6.2 13 9.7 11.2 7.3 24.9 13.4 38.4 13.4 10.7 0 20.5-3.9 28.8-9v-71c0-35.3-28.7-64-64-64v-48c0-17.7-14.3-32-32-32s-32 14.3-32 32v48H256v-48c0-17.7-14.3-32-32-32s-32 14.3-32 32v48h-64v-48zm320 218.6c-8.5 3.3-18.2 5.4-28.8 5.4-22.5 0-42.4-9.9-55.8-18.6-4.1-2.7-7.8-5.4-10.9-7.8-2.8 2.4-6.1 5-9.8 7.5C329.8 390 310.6 400 288 400s-41.8-10-54.6-18.9c-3.5-2.4-6.7-4.9-9.4-7.2-2.7 2.3-5.9 4.7-9.4 7.2-12.8 8.9-32 18.9-54.6 18.9s-41.8-10-54.6-18.9c-3.7-2.6-7-5.2-9.8-7.5-3.1 2.4-6.8 5.1-10.9 7.8-13.5 8.7-33.4 18.6-55.9 18.6-10.6 0-20.3-2.2-28.8-5.4V480c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32v-85.4z"
        }
    ]
};

const FasCakeSlice = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCakeSlice",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M276.2 38.9c5.6-4.4 12.6-6.9 19.8-6.9 44.3 0 97.6 19.2 139.9 55.8C479.2 125.2 512 181.7 512 256v159.5c0 35.4-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V272c0-9.8 4.5-19.1 12.2-25.1l264-208zM448 288H64v48h384v-24.2.2-24zM64 416h384v-42.2.2-6H64v48z"
        }
    ]
};

const FasCalculatorSimple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCalculatorSimple",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 48C0 21.5 21.5 0 48 0h128c26.5 0 48 21.5 48 48v128c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V48zm288 0c0-26.5 21.5-48 48-48h128c26.5 0 48 21.5 48 48v128c0 26.5-21.5 48-48 48H336c-26.5 0-48-21.5-48-48V48zm48 240h128c26.5 0 48 21.5 48 48v128c0 26.5-21.5 48-48 48H336c-26.5 0-48-21.5-48-48V336c0-26.5 21.5-48 48-48zM0 336c0-26.5 21.5-48 48-48h128c26.5 0 48 21.5 48 48v128c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V336zM416 64c0-8.8-7.2-16-16-16s-16 7.2-16 16v32h-32c-8.8 0-16 7.2-16 16s7.2 16 16 16h32v32c0 8.8 7.2 16 16 16s16-7.2 16-16v-32h32c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32V64zM64 96c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H64zm19.3 252.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L89.4 400l-28.7 28.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l28.7-28.7 28.7 28.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L134.6 400l28.7-28.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L112 377.4l-28.7-28.7zM352 352c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16h-96zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16h-96z"
        }
    ]
};

const FasCalculator = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCalculator",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm32 64h192c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32zm32 160a32 32 0 1 1-64 0 32 32 0 1 1 64 0zM96 352a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm-32 64c0-17.7 14.3-32 32-32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H96c-17.7 0-32-14.3-32-32zm128-160a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1-64 0 32 32 0 1 1 64 0zm64-64a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1-64 0 32 32 0 1 1 64 0zm-32 128a32 32 0 1 1 0-64 32 32 0 1 1 0 64z"
        }
    ]
};

const FasCalendarArrowDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCalendarArrowDown",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 0c17.7 0 32 14.3 32 32v32h128V32c0-17.7 14.3-32 32-32s32 14.3 32 32v32h48c26.5 0 48 21.5 48 48v48H0v-48c0-26.5 21.5-48 48-48h48V32c0-17.7 14.3-32 32-32zM0 192h448v272c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V192zm248 72c0-13.3-10.7-24-24-24s-24 10.7-24 24v102.1l-39-39c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l80 80c9.4 9.4 24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-39 39V264z"
        }
    ]
};

const FasCalendarArrowUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCalendarArrowUp",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 0c17.7 0 32 14.3 32 32v32h128V32c0-17.7 14.3-32 32-32s32 14.3 32 32v32h48c26.5 0 48 21.5 48 48v48H0v-48c0-26.5 21.5-48 48-48h48V32c0-17.7 14.3-32 32-32zM0 192h448v272c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V192zm248 232V321.9l39 39c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-80-80c-9.4-9.4-24.6-9.4-33.9 0l-80 80c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l39-39V424c0 13.3 10.7 24 24 24s24-10.7 24-24z"
        }
    ]
};

const FasCalendarCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCalendarCheck",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 0c17.7 0 32 14.3 32 32v32h128V32c0-17.7 14.3-32 32-32s32 14.3 32 32v32h48c26.5 0 48 21.5 48 48v48H0v-48c0-26.5 21.5-48 48-48h48V32c0-17.7 14.3-32 32-32zM0 192h448v272c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V192zm329 113c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-95 95-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L329 305z"
        }
    ]
};

const FasCalendarCircleExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCalendarCircleExclamation",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 0c-17.7 0-32 14.3-32 32v32H48C21.5 64 0 85.5 0 112v48h448v-48c0-26.5-21.5-48-48-48h-48V32c0-17.7-14.3-32-32-32s-32 14.3-32 32v32H160V32c0-17.7-14.3-32-32-32zm128 368c0-91.8 70.3-167.2 160-175.3v-.7H0v272c0 26.5 21.5 48 48 48h282.8c-45.2-31.9-74.8-84.5-74.8-144zm176 144a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16v-80c0-8.8 7.2-16 16-16z"
        }
    ]
};

const FasCalendarCircleMinus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCalendarCircleMinus",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 0c-17.7 0-32 14.3-32 32v32H48C21.5 64 0 85.5 0 112v48h448v-48c0-26.5-21.5-48-48-48h-48V32c0-17.7-14.3-32-32-32s-32 14.3-32 32v32H160V32c0-17.7-14.3-32-32-32zm128 368c0-91.8 70.3-167.2 160-175.3v-.7H0v272c0 26.5 21.5 48 48 48h282.8c-45.2-31.9-74.8-84.5-74.8-144zm320 0a144 144 0 1 0-288 0 144 144 0 1 0 288 0zm-64 0c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16h128c8.8 0 16 7.2 16 16z"
        }
    ]
};

const FasCalendarCirclePlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCalendarCirclePlus",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 0c-17.7 0-32 14.3-32 32v32H48C21.5 64 0 85.5 0 112v48h448v-48c0-26.5-21.5-48-48-48h-48V32c0-17.7-14.3-32-32-32s-32 14.3-32 32v32H160V32c0-17.7-14.3-32-32-32zm128 368c0-91.8 70.3-167.2 160-175.3v-.7H0v272c0 26.5 21.5 48 48 48h282.8c-45.2-31.9-74.8-84.5-74.8-144zm176 144a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-208v48h48c8.8 0 16 7.2 16 16s-7.2 16-16 16h-48v48c0 8.8-7.2 16-16 16s-16-7.2-16-16v-48h-48c-8.8 0-16-7.2-16-16s7.2-16 16-16h48v-48c0-8.8 7.2-16 16-16s16 7.2 16 16z"
        }
    ]
};

const FasCalendarCircleUser = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCalendarCircleUser",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 0c-17.7 0-32 14.3-32 32v32H48C21.5 64 0 85.5 0 112v48h448v-48c0-26.5-21.5-48-48-48h-48V32c0-17.7-14.3-32-32-32s-32 14.3-32 32v32H160V32c0-17.7-14.3-32-32-32zm128 368c0-91.8 70.3-167.2 160-175.3v-.7H0v272c0 26.5 21.5 48 48 48h282.8c-45.2-31.9-74.8-84.5-74.8-144zm320 0a144 144 0 1 0-288 0 144 144 0 1 0 288 0zm-66.3 80.7C489.5 468.1 462.2 480 432 480s-57.5-11.9-77.7-31.3c6.2-19 24-32.7 45.1-32.7h65.2c21 0 38.9 13.7 45.1 32.7zM384 336a48 48 0 1 1 96 0 48 48 0 1 1-96 0z"
        }
    ]
};

const FasCalendarClock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCalendarClock",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 32v32H48C21.5 64 0 85.5 0 112v48h448v-48c0-26.5-21.5-48-48-48h-48V32c0-17.7-14.3-32-32-32s-32 14.3-32 32v32H160V32c0-17.7-14.3-32-32-32S96 14.3 96 32zm352 160H0v272c0 26.5 21.5 48 48 48h282.8c-45.2-31.9-74.8-84.5-74.8-144 0-97.2 78.8-176 176-176 5.4 0 10.7.2 16 .7v-.7zm128 176a144 144 0 1 0-288 0 144 144 0 1 0 288 0zm-144-80c8.8 0 16 7.2 16 16v48h32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16v-64c0-8.8 7.2-16 16-16z"
        }
    ]
};

const FasCalendarDay = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCalendarDay",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 0c17.7 0 32 14.3 32 32v32h128V32c0-17.7 14.3-32 32-32s32 14.3 32 32v32h48c26.5 0 48 21.5 48 48v48H0v-48c0-26.5 21.5-48 48-48h48V32c0-17.7 14.3-32 32-32zM0 192h448v272c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V192zm80 64c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16v-96c0-8.8-7.2-16-16-16H80z"
        }
    ]
};

const FasCalendarDays = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCalendarDays",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 0c17.7 0 32 14.3 32 32v32h128V32c0-17.7 14.3-32 32-32s32 14.3 32 32v32h48c26.5 0 48 21.5 48 48v48H0v-48c0-26.5 21.5-48 48-48h48V32c0-17.7 14.3-32 32-32zM0 192h448v272c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V192zm64 80v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm128 0v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32zM64 400v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32zm112 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16z"
        }
    ]
};

const FasCalendarExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCalendarExclamation",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 32v32H48C21.5 64 0 85.5 0 112v48h448v-48c0-26.5-21.5-48-48-48h-48V32c0-17.7-14.3-32-32-32s-32 14.3-32 32v32H160V32c0-17.7-14.3-32-32-32S96 14.3 96 32zm352 160H0v272c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V192zM192 432a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm56-176v96c0 13.3-10.7 24-24 24s-24-10.7-24-24v-96c0-13.3 10.7-24 24-24s24 10.7 24 24z"
        }
    ]
};

const FasCalendarHeart = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCalendarHeart",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 0c17.7 0 32 14.3 32 32v32h128V32c0-17.7 14.3-32 32-32s32 14.3 32 32v32h48c26.5 0 48 21.5 48 48v48H0v-48c0-26.5 21.5-48 48-48h48V32c0-17.7 14.3-32 32-32zM0 192h448v272c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V192zm112 125.3c0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3 0-33.8-27.4-61.3-61.3-61.3-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9-33.8 0-61.3 27.4-61.3 61.3z"
        }
    ]
};

const FasCalendarImage = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCalendarImage",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 32v32H48C21.5 64 0 85.5 0 112v48h448v-48c0-26.5-21.5-48-48-48h-48V32c0-17.7-14.3-32-32-32s-32 14.3-32 32v32H160V32c0-17.7-14.3-32-32-32S96 14.3 96 32zm352 160H0v272c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V192zM147.2 360.7c6.5-8.4 19.1-8.3 25.5.2L184 376l58.3-84.2c6.5-9.4 20.5-9.1 26.7.5l83.4 131.1c6.8 10.6-.9 24.6-13.5 24.6H112.5c-13.3 0-20.8-15.2-12.7-25.8l47.3-61.5zM128 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FasCalendarLinesPen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCalendarLinesPen",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 0c17.7 0 32 14.3 32 32v32h128V32c0-17.7 14.3-32 32-32s32 14.3 32 32v32h48c26.5 0 48 21.5 48 48v48H0v-48c0-26.5 21.5-48 48-48h48V32c0-17.7 14.3-32 32-32zM0 192h448v43.6L289.3 394.3c-8.2 8.2-14 18.5-16.8 29.7l-15 60.1c-2.3 9.4-1.8 19 1.4 27.8H48c-26.5 0-48-21.5-48-48V192zm120 80c-13.3 0-24 10.7-24 24s10.7 24 24 24h144c13.3 0 24-10.7 24-24s-10.7-24-24-24H120zM96 392c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24h-80c-13.3 0-24 10.7-24 24zm453.8-156.3 14.4 14.4c15.6 15.6 15.6 40.9 0 56.6l-29.4 29.4-71-71 29.4-29.4c15.6-15.6 40.9-15.6 56.6 0zM311.9 417l129.2-129.2 71 71-129.2 129.1c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9z"
        }
    ]
};

const FasCalendarLines = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCalendarLines",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 32v32H48C21.5 64 0 85.5 0 112v48h448v-48c0-26.5-21.5-48-48-48h-48V32c0-17.7-14.3-32-32-32s-32 14.3-32 32v32H160V32c0-17.7-14.3-32-32-32S96 14.3 96 32zm352 160H0v272c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V192zM96 296c0-13.3 10.7-24 24-24h208c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24zm24 72h112c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
        }
    ]
};

const FasCalendarMinus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCalendarMinus",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 0c17.7 0 32 14.3 32 32v32h128V32c0-17.7 14.3-32 32-32s32 14.3 32 32v32h48c26.5 0 48 21.5 48 48v48H32v-48c0-26.5 21.5-48 48-48h48V32c0-17.7 14.3-32 32-32zM32 192h448v272c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V192zm312 184c13.3 0 24-10.7 24-24s-10.7-24-24-24H168c-13.3 0-24 10.7-24 24s10.7 24 24 24h176z"
        }
    ]
};

const FasCalendarPen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCalendarPen",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 0c17.7 0 32 14.3 32 32v32h128V32c0-17.7 14.3-32 32-32s32 14.3 32 32v32h48c26.5 0 48 21.5 48 48v48H32v-48c0-26.5 21.5-48 48-48h48V32c0-17.7 14.3-32 32-32zM32 192h448v272c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V192zm308.8 75c-14.7-14.7-38.6-14.7-53.3 0l-14.9 15 53.3 53.3 14.9-14.9c14.7-14.7 14.7-38.6 0-53.3zM178.1 376.5c-4.1 4.1-7 9.2-8.4 14.9l-9.2 36.6c-1.4 5.5.2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l36.6-9.2c5.6-1.4 10.8-4.3 14.9-8.4l71.9-71.9-53.3-53.3-71.9 71.9z"
        }
    ]
};

const FasCalendarPlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCalendarPlus",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 32v32H80c-26.5 0-48 21.5-48 48v48h448v-48c0-26.5-21.5-48-48-48h-48V32c0-17.7-14.3-32-32-32s-32 14.3-32 32v32H192V32c0-17.7-14.3-32-32-32s-32 14.3-32 32zm352 160H32v272c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V192zm-224 56c13.3 0 24 10.7 24 24v56h56c13.3 0 24 10.7 24 24s-10.7 24-24 24h-56v56c0 13.3-10.7 24-24 24s-24-10.7-24-24v-56h-56c-13.3 0-24-10.7-24-24s10.7-24 24-24h56v-56c0-13.3 10.7-24 24-24z"
        }
    ]
};

const FasCalendarRange = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCalendarRange",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 32v32H80c-26.5 0-48 21.5-48 48v48h448v-48c0-26.5-21.5-48-48-48h-48V32c0-17.7-14.3-32-32-32s-32 14.3-32 32v32H192V32c0-17.7-14.3-32-32-32s-32 14.3-32 32zm352 160H32v272c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V192zm-320 96a32 32 0 1 1-64 0 32 32 0 1 1 64 0zm224 160a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM224 288c0-13.3 10.7-24 24-24h144c13.3 0 24 10.7 24 24s-10.7 24-24 24H248c-13.3 0-24-10.7-24-24zm40 104c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24s10.7-24 24-24h144z"
        }
    ]
};

const FasCalendarStar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCalendarStar",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 0c17.7 0 32 14.3 32 32v32h128V32c0-17.7 14.3-32 32-32s32 14.3 32 32v32h48c26.5 0 48 21.5 48 48v48H32v-48c0-26.5 21.5-48 48-48h48V32c0-17.7 14.3-32 32-32zM32 192h448v272c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V192zm233.3 58.9c-3.8-7.7-14.8-7.7-18.7 0L223 298.7l-52.7 7.7c-8.5 1.2-11.9 11.7-5.8 17.7l38.2 37.2-9 52.5c-1.5 8.5 7.5 15 15.1 11L256 400l47.2 24.8c7.6 4 16.5-2.5 15.1-11l-9-52.5 38.2-37.2c6.2-6 2.8-16.5-5.8-17.7l-52.7-7.7-23.6-47.8z"
        }
    ]
};

const FasCalendarUsers = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCalendarUsers",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 32v32h-48c-26.5 0-48 21.5-48 48v48h448v-48c0-26.5-21.5-48-48-48h-48V32c0-17.7-14.3-32-32-32s-32 14.3-32 32v32H256V32c0-17.7-14.3-32-32-32s-32 14.3-32 32zm55.4 480h145.2c-5.4-9.4-8.6-20.3-8.6-32 0-43.8 29.4-80.8 69.6-92.3-23-20.5-37.6-50.4-37.6-83.7 0-56.4 41.7-103.1 96-110.9V192H128v1.1c54.3 7.8 96 54.4 96 110.9 0 33.3-14.5 63.2-37.6 83.7 40.2 11.5 69.6 48.5 69.6 92.3 0 11.7-3.1 22.6-8.6 32zM528 384a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm-48 32c-35.3 0-64 28.7-64 64 0 17.7 14.3 32 32 32h160c17.7 0 32-14.3 32-32 0-35.3-28.7-64-64-64h-96zM192 304a80 80 0 1 0-160 0 80 80 0 1 0 160 0zM0 480c0 17.7 14.3 32 32 32h160c17.7 0 32-14.3 32-32 0-35.3-28.7-64-64-64H64c-35.3 0-64 28.7-64 64z"
        }
    ]
};

const FasCalendarWeek = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCalendarWeek",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 0c17.7 0 32 14.3 32 32v32h128V32c0-17.7 14.3-32 32-32s32 14.3 32 32v32h48c26.5 0 48 21.5 48 48v48H0v-48c0-26.5 21.5-48 48-48h48V32c0-17.7 14.3-32 32-32zM0 192h448v272c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V192zm80 64c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h288c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16H80z"
        }
    ]
};

const FasCalendarXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCalendarXmark",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 0c17.7 0 32 14.3 32 32v32h128V32c0-17.7 14.3-32 32-32s32 14.3 32 32v32h48c26.5 0 48 21.5 48 48v48H32v-48c0-26.5 21.5-48 48-48h48V32c0-17.7 14.3-32 32-32zM32 192h448v272c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V192zm305 113c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47z"
        }
    ]
};

const FasCalendar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCalendar",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 32v32H48C21.5 64 0 85.5 0 112v48h448v-48c0-26.5-21.5-48-48-48h-48V32c0-17.7-14.3-32-32-32s-32 14.3-32 32v32H160V32c0-17.7-14.3-32-32-32S96 14.3 96 32zm352 160H0v272c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V192z"
        }
    ]
};

const FasCalendars = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCalendars",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 0c-17.7 0-32 14.3-32 32v32h-48c-26.5 0-48 21.5-48 48v48h416v-48c0-26.5-21.5-48-48-48h-48V32c0-17.7-14.3-32-32-32s-32 14.3-32 32v32h-96V32c0-17.7-14.3-32-32-32zM96 192v176c0 26.5 21.5 48 48 48h320c26.5 0 48-21.5 48-48V192H96zm-48-8c0-13.3-10.7-24-24-24S0 170.7 0 184v208c0 66.3 53.7 120 120 120h272c13.3 0 24-10.7 24-24s-10.7-24-24-24H120c-39.8 0-72-32.2-72-72V184z"
        }
    ]
};

const FasCamcorder = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCamcorder",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 96c-17.7 0-32 14.3-32 32v32h224c35.3 0 64 28.7 64 64v192c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V224c0-23.7 12.9-44.4 32-55.4V128c0-53 43-96 96-96h160c17.7 0 32 14.3 32 32s-14.3 32-32 32H128zm431.1 67.8c10.4 5.6 16.9 16.4 16.9 28.2v256c0 11.8-6.5 22.6-16.9 28.2s-23 5-32.9-1.6l-96-64-14.2-9.5V238.9l14.2-9.5 96-64c9.8-6.5 22.4-7.2 32.9-1.6zM80 224c-8.8 0-16 7.2-16 16s7.2 16 16 16h224c8.8 0 16-7.2 16-16s-7.2-16-16-16H80z"
        }
    ]
};

const FasCameraCctv = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCameraCctv",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M140.3 2.5c-14.9-6.2-32.1-.3-40.1 13.7l-96 168c-4.6 8-5.5 17.5-2.5 26.2s9.5 15.7 18 19.2l158.1 65.9L137.9 400H64v-16c0-17.7-14.3-32-32-32S0 366.3 0 384v96c0 17.7 14.3 32 32 32s32-14.3 32-32v-16h96c13.3 0 25.2-8.2 29.9-20.6l47-123.4 70.8 29.5c9.9 4.1 21.2 3 30.1-2.9l192-128c9.8-6.5 15.2-18 14.1-29.7s-8.6-21.9-19.5-26.5l-384-160zm373.1 396.1c3.9 1.8 8.4 1.9 12.5.3s7.2-4.7 8.9-8.7l40-96c3.3-8-.3-17.2-8.3-20.8l-36.7-16.3-132.9 88.5 116.5 52.9z"
        }
    ]
};

const FasCameraMovie = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCameraMovie",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 64a64 64 0 1 0 0 128 64 64 0 1 0 0-128zm224 192H128C57.3 256 0 198.7 0 128S57.3 0 128 0c48.2 0 90.2 26.6 112 66 21.8-39.4 63.8-66 112-66 70.7 0 128 57.3 128 128s-57.3 128-128 128zm0-192a64 64 0 1 0 0 128 64 64 0 1 0 0-128zm206.3 195.4c10.8 5.4 17.7 16.5 17.7 28.6v192c0 12.1-6.8 23.2-17.7 28.6s-23.8 4.3-33.5-3l-64-48L448 448V320l12.8-9.6 64-48c9.7-7.3 22.7-8.4 33.5-3zM64 288h288c35.3 0 64 28.7 64 64v96c0 35.3-28.7 64-64 64H128c-35.3 0-64-28.7-64-64v-96H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h32z"
        }
    ]
};

const FasCameraPolaroid = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCameraPolaroid",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v150.3l53.3 79.9c7 10.5 10.7 22.9 10.7 35.5V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64v-54.3c0-12.6 3.7-25 10.7-35.5L64 246.3V96zm224 160a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm160-128a32 32 0 1 0-64 0 32 32 0 1 0 64 0zM112 384c-8.8 0-16 7.2-16 16s7.2 16 16 16h352c8.8 0 16-7.2 16-16s-7.2-16-16-16H112z"
        }
    ]
};

const FasCameraRetro = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCameraRetro",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M220.6 121.2 271.1 96H448v96H333.2c-21.9-15.1-48.5-24-77.2-24s-55.2 8.9-77.2 24H64v-64h128c9.9 0 19.7-2.3 28.6-6.8zM0 128v288c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H271.1c-9.9 0-19.7 2.3-28.6 6.8L192 64h-32V48c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16v16C28.7 64 0 92.7 0 128zm168 176a88 88 0 1 1 176 0 88 88 0 1 1-176 0z"
        }
    ]
};

const FasCameraRotate = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCameraRotate",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M213.1 64.8 202.7 96H128c-35.3 0-64 28.7-64 64v256c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64h-74.7l-10.4-31.2C420.4 45.2 402.1 32 381.4 32H258.6c-20.7 0-39 13.2-45.5 32.8zM448 256c0 8.8-7.2 16-16 16h-76.7c-6.2 0-11.3-5.1-11.3-11.3 0-3 1.2-5.9 3.3-8L371 229c-13.6-13.4-31.9-21-51-21-19.2 0-37.7 7.6-51.3 21.3L249 249c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l19.7-19.7C257.4 172.7 288 160 320 160c31.8 0 62.4 12.6 85 35l23.7-23.7c2.1-2.1 5-3.3 8-3.3 6.2 0 11.3 5.1 11.3 11.3V256zm-256 64c0-8.8 7.2-16 16-16h76.7c6.2 0 11.3 5.1 11.3 11.3 0 3-1.2 5.9-3.3 8L269 347c13.6 13.4 31.9 21 51 21 19.2 0 37.7-7.6 51.3-21.3L391 327c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-19.7 19.7C382.6 403.3 352 416 320 416c-31.8 0-62.4-12.6-85-35l-23.7 23.7c-2.1 2.1-5 3.3-8 3.3-6.2 0-11.3-5.1-11.3-11.3V320z"
        }
    ]
};

const FasCameraSecurity = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCameraSecurity",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 64C0 28.7 28.7 0 64 0h320c35.3 0 64 28.7 64 64v288c0 35.3-28.7 64-64 64h-74l59 36.9c12.1 7.6 17.7 22.2 13.8 36S366.3 512 352 512H96c-14.3 0-26.8-9.5-30.8-23.2s1.7-28.4 13.8-36l59-36.8H64c-35.3 0-64-28.7-64-64V64zm128 144a96 96 0 1 1 192 0 96 96 0 1 1-192 0zm224 0a128 128 0 1 0-256 0 128 128 0 1 0 256 0z"
        }
    ]
};

const FasCameraSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCameraSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-55.5-43.5c.5-3.1.7-6.3.7-9.6V160c0-35.3-28.7-64-64-64h-74.7l-10.4-31.2C420.4 45.2 402.1 32 381.4 32H258.6c-20.7 0-39 13.2-45.5 32.8L202.7 96h-47.9L38.8 5.1zm246.6 193.3c10.7-4.1 22.4-6.4 34.6-6.4 53 0 96 43 96 96 0 4.1-.3 8.2-.8 12.2L285.4 198.4zM224 288c0-5 .4-9.9 1.1-14.6l-159.9-126c-.8 4.1-1.2 8.3-1.2 12.6v256c0 35.3 28.7 64 64 64h359.4l-131-103.2c-11.2 4.6-23.5 7.2-36.4 7.2-53 0-96-43-96-96z"
        }
    ]
};

const FasCameraViewfinder = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCameraViewfinder",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M56 0h80c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-4.4 0-8 3.6-8 8v80c0 13.3-10.7 24-24 24S0 149.3 0 136V56C0 25.1 25.1 0 56 0zm320 0h80c30.9 0 56 25.1 56 56v80c0 13.3-10.7 24-24 24s-24-10.7-24-24V56c0-4.4-3.6-8-8-8h-80c-13.3 0-24-10.7-24-24s10.7-24 24-24zM48 376v80c0 4.4 3.6 8 8 8h80c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-30.9 0-56-25.1-56-56v-80c0-13.3 10.7-24 24-24s24 10.7 24 24zm464 0v80c0 30.9-25.1 56-56 56h-80c-13.3 0-24-10.7-24-24s10.7-24 24-24h80c4.4 0 8-3.6 8-8v-80c0-13.3 10.7-24 24-24s24 10.7 24 24zM180 128l6.2-16.4c3.5-9.4 12.5-15.6 22.5-15.6h94.7c10 0 19 6.2 22.5 15.6L332 128h36c26.5 0 48 21.5 48 48v160c0 26.5-21.5 48-48 48H144c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48h36zm140 128a64 64 0 1 0-128 0 64 64 0 1 0 128 0z"
        }
    ]
};

const FasCameraWebSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCameraWebSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-135.2-106C525.9 324.9 544 276.6 544 224 544 100.3 443.7 0 320 0c-72 0-136.1 34-177 86.7L38.8 5.1zm154.5 121.1C222.6 88.4 268.5 64 320 64c88.4 0 160 71.6 160 160 0 37.7-13 72.3-34.8 99.6L420 303.9c17.5-21.9 28-49.7 28-79.9 0-70.7-57.3-128-128-128-41.3 0-78.1 19.6-101.5 50l-25.2-19.7zm88.2 69.1-25.2-19.7C270.9 156.4 294 144 320 144c8.8 0 16 7.2 16 16s-7.2 16-16 16c-15.8 0-29.8 7.6-38.5 19.3zM507.7 496 359.4 379.1c-12.6 3.2-25.8 4.9-39.4 4.9-88.4 0-160-71.6-160-160v-1.9l-58.8-46.3C97.8 191.3 96 207.4 96 224c0 79.5 41.4 149.3 103.8 189.1l-58.2 40.7c-11.4 8-16.4 22.5-12.2 35.8S146 512 160 512h320c11.6 0 22.1-6.2 27.7-16zM324.8 351.9 194.5 249.2C206.2 307.8 257.9 352 320 352c1.6 0 3.2 0 4.8-.1z"
        }
    ]
};

const FasCameraWeb = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCameraWeb",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M344.2 413.1C406.6 373.3 448 303.5 448 224 448 100.3 347.7 0 224 0S0 100.3 0 224c0 79.5 41.4 149.3 103.8 189.1l-58.2 40.7c-11.4 8-16.4 22.5-12.2 35.8S50 512 64 512h320c14 0 26.3-9.1 30.5-22.4s-.7-27.8-12.2-35.8l-58.2-40.7zM224 352a128 128 0 1 0 0-256 128 128 0 1 0 0 256zm0-288a160 160 0 1 1 0 320 160 160 0 1 1 0-320zm-48 160c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-44.2 35.8-80 80-80 8.8 0 16 7.2 16 16s-7.2 16-16 16c-26.5 0-48 21.5-48 48z"
        }
    ]
};

const FasCamera = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCamera",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M149.1 64.8 138.7 96H64c-35.3 0-64 28.7-64 64v256c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64h-74.7l-10.4-31.2C356.4 45.2 338.1 32 317.4 32H194.6c-20.7 0-39 13.2-45.5 32.8zM256 192a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"
        }
    ]
};

const FasCampfire = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCampfire",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M232.2 3.4c-2.5-2.3-5.6-3.4-8.8-3.4-3.2 0-6.4 1.1-9 3.4-29.9 27-55.3 57.7-73.2 87.1-17.7 29-29.2 60.2-29.2 84.2 0 79.8 63.3 145.3 144 145.3 79.9 0 144-65.5 144-145.3 0-18.3-8.7-46.3-21.7-71.8C365 77 346.2 49.7 323.9 29.1c-5-4.7-12.9-4.7-18 0-8.7 8-16.7 17.8-23.8 26.8C266.6 37 250 19.6 232.2 3.4zM301 248.2c-13.5 9.1-27.9 13.6-44.1 13.6-40.5 0-72.9-26.4-72.9-70.9 0-21.8 13.5-40.9 40.5-74.5 3.6 4.5 55.8 71.8 55.8 71.8l32.4-38.2c2.7 3.6 4.5 7.3 6.3 10.9 16.2 30 9 68.2-18 87.3zM42.8 289.9c-16.6-5.9-35 2.7-40.9 19.4s2.7 35 19.4 40.9L160.9 400 21.2 449.9c-16.6 5.9-25.3 24.2-19.3 40.9s24.3 25.3 40.9 19.4L256 434l213.2 76.2c16.6 5.9 35-2.7 40.9-19.4s-2.7-35-19.4-40.9L351.1 400l139.6-49.9c16.6-5.9 25.3-24.3 19.4-40.9s-24.3-25.3-40.9-19.4L256 366 42.8 289.9z"
        }
    ]
};

const FasCampground = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCampground",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M377 52c11-13.8 8.8-33.9-5-45s-33.9-8.8-45 5l-39 48.8L249 12c-11-13.8-31.2-16-45-5s-16 31.2-5 45l48 60L12.3 405.4c-8 10-12.3 22.3-12.3 35V464c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48v-23.6c0-12.7-4.3-25.1-12.3-35L329 112l48-60zm-89 396H168.5L288 291.7 407.5 448H288z"
        }
    ]
};

const FasCanFood = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCanFood",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M270.3 304.5c12.1-2.5 23.4-5.5 33.7-9V426c-2.8 1.6-6.6 3.6-11.8 5.7-22.4 9.2-57.8 16.3-100.2 16.3s-77.8-7.1-100.2-16.3c-5.2-2.1-9-4.1-11.8-5.7V295.5c10.3 3.5 21.6 6.5 33.7 9 7.6 36.3 39.8 63.5 78.3 63.5s70.7-27.2 78.3-63.5zm-100.1-40a32 32 0 1 1 43.5 46.9 32 32 0 1 1-43.5-46.9zM16 72v368c0 39.8 78.8 72 176 72s176-32.2 176-72V72c0-39.8-78.8-72-176-72S16 32.2 16 72zm288 0c0 13.3-50.1 24-112 24S80 85.3 80 72s50.1-24 112-24 112 10.7 112 24z"
        }
    ]
};

const FasCandleHolder = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCandleHolder",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 192c-44.2 0-80-35.8-80-80 0-39.6 49.1-90.1 66.2-106.6C149.9 1.9 154.8 0 160 0s10.1 1.9 13.8 5.4C190.9 21.9 240 72.4 240 112c0 44.2-35.8 80-80 80zm-32 32v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48h64c17.7 0 32 14.3 32 32v208h52.1c-2.7-7.5-4.1-15.6-4.1-24 0-39.8 32.2-72 72-72s72 32.2 72 72-32.2 72-72 72H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h40V256c0-17.7 14.3-32 32-32h32zm272 216a24 24 0 1 0-48 0 24 24 0 1 0 48 0z"
        }
    ]
};

const FasCandyBar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCandyBar",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 320h128v-96H0v96zm0 64c0 35.3 28.7 64 64 64h64v-96H0v32zm288 64v-96H160v96h128zm0-224H160v96h128v-96zm0-160H160v128h128V64zm288 0H320v384h256c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zM44.2 192H128v-83.8c0-7.1-9-11.1-15-7.4-12 7.1-26 11.2-41 11.2-4 0-7.9-.3-11.7-.9-7-1-14.2 6.2-13.1 13.1.6 3.8.9 7.7.9 11.7 0 15-4.1 29-11.3 41-3.6 6.1.4 15 7.4 15z"
        }
    ]
};

const FasCandyCane = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCandyCane",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M348.8 131.5c3.7-2.3 7.9-3.5 12.2-3.5 12.7 0 23 10.3 23 23v5.6c0 9.9-5.1 19.1-13.5 24.3L30.1 393.7C.1 412.5-9 451.9 9.7 481.9s58.2 39.1 88.2 20.4l340.5-212.8c45.8-28.6 73.6-78.8 73.6-132.8V151C512 67.6 444.4 0 361 0c-28.3 0-56 8-80.1 23l-26.8 16.7c-30 18.7-39.1 58.2-20.4 88.2s58.2 39.1 88.2 20.4l26.8-16.8zm-50.4-81.7c9.2-5.7 19.1-10.1 29.4-13.1L348 97.5c-5.7 1.4-11.2 3.7-16.3 6.8l-12.6 7.9-20.7-62.4zm88.5 52.7 46.2-46.2c8.5 6.5 16.1 14.1 22.6 22.6l-46.2 46.2c-5.1-9.6-13-17.5-22.6-22.6zm28.9 59.3 61.6 20.5c-2.2 10.5-5.8 20.7-10.5 30.2l-62-20.7c6.2-8.8 10.1-19.1 11-30.1zm-86.1 82.5 60.4 37.7-30.2 18.9-60.4-37.7 30.2-18.9zm-107.2 67 60.4 37.7-30.2 18.9-60.4-37.7 30.2-18.9zm-103.2 64.4 60.4 37.7-30.2 18.9-60.4-37.7 30.2-18.9z"
        }
    ]
};

const FasCandyCorn = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCandyCorn",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M440.6 256c9.8 25.6 19.6 49 28.7 67.2 3.3 6.7 6.2 12.4 9.3 17.7.5.8 1 1.7 1.4 2.4.5-.8 1-1.6 1.4-2.4 3.1-5.3 6-11 9.3-17.7 9-18.2 18.9-41.5 28.7-67.2h-78.8zM480 0c44.1 0 90.4 4.2 132.6 18.1C629 23.5 640 38.8 640 56c0 17.4-5.3 43.8-12.3 71.4-4.4-1-9.3-2.1-14.5-3.1-30.9-6.2-76-12.3-133.1-12.3s-102.2 6.1-133.1 12.3c-5.3 1.1-10.1 2.1-14.5 3.1-7-27.6-12.3-54-12.3-71.4 0-17.2 11.4-32.6 27.8-38.1C390 4.4 436 0 480 0zM370.3 250.4c-11-30.8-21.3-62.9-29.6-92.1 3.8-.9 8-1.8 12.4-2.7 29.1-5.8 72-11.7 126.9-11.7s97.8 5.9 126.9 11.7c4.5.9 8.6 1.8 12.4 2.7-8.3 29.2-18.6 61.3-29.6 92.1-13.2 37.2-27.9 73.6-41.6 101.3-13.4 27-32.9 64.3-68.1 64.3s-54.6-37.3-68.1-64.3c-13.8-27.7-28.4-64.1-41.6-101.3zM83 211.1c30.4-30.4 65.3-59.4 103.9-79 15-7.5 33.1-4.6 45 7.3 12 12 26.6 33.9 40.7 57.7-3.8 2.3-7.8 5-12.2 7.9-25.6 17.1-60.9 43.9-100.3 83.3S94 363 76.9 388.6c-2.9 4.3-5.5 8.4-7.9 12.2C45.2 386.6 23.3 372 11.3 360c-11.9-11.9-14.6-30.4-7.1-45.4 19.7-38.4 48.4-73.1 78.8-103.5zm97 248.2c-28.8-13.7-58-28.7-83.9-43 2-3.2 4.3-6.7 6.7-10.4 16-24 41.6-57.7 79.4-95.5s71.5-63.4 95.5-79.4c3.7-2.5 7.2-4.7 10.4-6.7 14.4 25.9 29.4 55.1 43.1 83.9 16.5 34.8 31.5 70 41.1 98.5 9.3 27.9 21.7 67-2.6 91.2s-63.4 11.9-91.2 2.6c-28.5-9.6-63.7-24.6-98.5-41.1zm52.3-44.6c24.4 11 47.3 20.2 66.1 26.5 6.9 2.3 12.8 4.2 18.6 5.8.9.2 1.8.5 2.7.7-.2-.9-.4-1.7-.7-2.7-1.5-5.8-3.4-11.7-5.8-18.6-6.3-18.8-15.6-41.7-26.5-66.1l-54.4 54.4z"
        }
    ]
};

const FasCandy = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCandy",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M318.1 64c-24.5.2-47.9 5.1-69.4 13.7L419.9 420c20.3-12.4 38.2-28.5 52.6-47.3L318.1 64zm174.2 276.8c4.7-9.6 8.7-19.6 11.8-30l93.2 46.6c10.5 5.3 23.3 2.1 30.2-7.4s5.8-22.7-2.5-31l-29.6-29.6 29.1-10.9C633.8 275 640 266 640 256s-6.2-19-15.6-22.5l-29.1-10.9L625 193c8.3-8.3 9.4-21.5 2.5-31s-19.7-12.7-30.2-7.4L504 201.1c-20.3-68.2-77.5-120.5-148.5-133.8l136.8 273.5zm-101 93.5L220.1 92c-20.3 12.4-38.2 28.5-52.6 47.3L321.9 448c24.5-.2 47.9-5.1 69.4-13.7zm-106.8 10.4L147.7 171.2c-4.7 9.6-8.7 19.6-11.8 30l-93.2-46.7c-10.5-5.3-23.3-2.1-30.2 7.4s-5.8 22.7 2.5 31l29.6 29.6-29 11C6.2 237 0 246 0 256s6.2 19 15.6 22.5l29.1 10.9L15 319c-8.3 8.3-9.4 21.5-2.5 31s19.7 12.7 30.2 7.4l93.3-46.5c20.3 68.2 77.5 120.6 148.5 133.9z"
        }
    ]
};

const FasCannabis = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCannabis",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 0c5.3 0 10.3 2.7 13.3 7.1 15.8 23.5 36.7 63.7 49.2 109 7.2 26.4 11.8 55.2 10.4 84 11.5-8.8 23.7-16.7 35.8-23.6 41-23.3 84.4-36.9 112.2-42.5 5.2-1 10.7.6 14.4 4.4s5.4 9.2 4.4 14.5c-5.6 27.7-19.3 70.9-42.7 111.7-9.1 15.9-19.9 31.7-32.4 46.3 27.8 6.6 52.4 17.3 67.2 25.5 5.1 2.8 8.2 8.2 8.2 14s-3.2 11.2-8.2 14c-15.2 8.4-40.9 19.5-69.8 26.1-20.2 4.6-42.9 7.2-65.2 4.6l8.3 33.1c1.5 6.1-.6 12.4-5.5 16.4s-11.6 4.6-17.2 1.9L280 417.2V488c0 13.3-10.7 24-24 24s-24-10.7-24-24v-70.8l-58.5 29.1c-5.6 2.8-12.3 2.1-17.2-1.9s-7-10.3-5.5-16.4l8.3-33.1c-22.2 2.6-45 0-65.2-4.6-28.9-6.6-54.6-17.6-69.8-26.1-5.1-2.8-8.2-8.2-8.2-14s3.2-11.2 8.2-14c14.8-8.2 39.4-18.8 67.2-25.5-12.4-14.4-23.2-30.2-32.3-46.1-23.4-40.8-37.1-84-42.7-111.7-1.1-5.2.6-10.7 4.4-14.5s9.2-5.4 14.4-4.4c27.9 5.5 71.2 19.2 112.2 42.5 12.1 6.9 24.3 14.7 35.8 23.6-1.4-28.7 3.1-57.6 10.4-84 12.5-45.3 33.4-85.5 49.2-109 3-4.4 8-7.1 13.3-7.1z"
        }
    ]
};

const FasCapsules = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCapsules",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 144c0-26.5 21.5-48 48-48s48 21.5 48 48v112H64V144zm-64 0v224c0 61.9 50.1 112 112 112s112-50.1 112-112V189.6c1.8 19.1 8.2 38 19.8 54.8l128.5 187.3c35.5 51.7 105.3 64.3 156 28.1s63-107.5 27.5-159.2L427.3 113.3c-35.5-51.8-105.4-64.3-156-28.1-28 20-44.3 50.8-47.3 83V144c0-61.9-50.1-112-112-112S0 82.1 0 144zm296.6 64.2c-16-23.3-10-55.3 11.9-71 21.2-15.1 50.5-10.3 66 12.2l67 97.6-79.9 56-65-94.8zM491 407.7c-.8.6-1.6 1.1-2.4 1.6l4-2.8c-.5.4-1 .8-1.6 1.2z"
        }
    ]
};

const FasCarBattery = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCarBattery",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 96c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32h96c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32h16c35.3 0 64 28.7 64 64v224c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64h16zm304 96c0-8.8-7.2-16-16-16s-16 7.2-16 16v32h-32c-8.8 0-16 7.2-16 16s7.2 16 16 16h32v32c0 8.8 7.2 16 16 16s16-7.2 16-16v-32h32c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32v-32zM80 240c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H96c-8.8 0-16 7.2-16 16z"
        }
    ]
};

const FasCarBolt = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCarBolt",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M74.8 96.3 39.6 196.8C16.4 206.4 0 229.3 0 256v192c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32v-48h320v48c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V256c0-26.7-16.4-49.6-39.6-59.2L437.2 96.3C423.7 57.8 387.4 32 346.6 32H165.4c-40.8 0-77.1 25.8-90.6 64.3zM96 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm288 32a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm-65.7-168.8L281.9 192H336c6.9 0 13 4.4 15.2 10.9s-.1 13.7-5.6 17.9l-128 96c-5.9 4.5-14.2 4.2-19.9-.5s-7.4-12.8-4.1-19.4l36.5-72.9H176c-6.9 0-13-4.4-15.2-10.9s.1-13.7 5.6-17.9l128-96c5.9-4.5 14.2-4.2 19.9.5s7.4 12.8 4.1 19.4z"
        }
    ]
};

const FasCarBuilding = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCarBuilding",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 0C21.5 0 0 21.5 0 48v384c0 26.5 21.5 48 48 48h144V352c0-32.8 16.5-61.8 41.6-79.1l5.6-16.9H208c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h32c8.2 0 14.9 6.1 15.9 14l.5-1.4c10.5-31.6 34.2-56 63.7-68.2V48c0-26.5-21.5-48-48-48H48zm32 192h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16zm0-96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16zm112 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32zM80 288h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16zm282.6-64h138.8c6.9 0 13 4.4 15.2 10.9l17.7 53.1H329.7l17.7-53.1c2.2-6.5 8.3-10.9 15.2-10.9zm-75.9-9.3-26.6 79.7C238.8 304.7 224 326.6 224 352v128c0 17.7 14.3 32 32 32h16c17.7 0 32-14.3 32-32v-32h256v32c0 17.7 14.3 32 32 32h16c17.7 0 32-14.3 32-32V352c0-25.4-14.8-47.3-36.1-57.6l-26.6-79.7C566.4 182 535.8 160 501.4 160H362.6c-34.4 0-65 22-75.9 54.7zM304 344a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm232 24a24 24 0 1 1 48 0 24 24 0 1 1-48 0z"
        }
    ]
};

const FasCarBump = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCarBump",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m145.1 120.6 147.3-39.4c12.7-3.4 26.3 1.3 34.1 12l37.8 51.6-249.7 66.8 7-63.6c1.4-13.1 10.8-24 23.5-27.4zM58 141.1l-10.2 93.1c-20.4 15.2-30.6 41.8-23.6 67.9l33.1 123.7 12.4 46.4c4.6 17.1 22.1 27.2 39.2 22.6l30.9-8.3c17.1-4.6 27.2-22.1 22.6-39.2L150 400.9l278.2-74.5 12.4 46.4c4.6 17.1 22.1 27.2 39.2 22.6l30.9-8.3c17.1-4.6 27.2-22.1 22.6-39.2L521 301.5l-33.2-123.6c-7-26.1-29.1-44.1-54.4-47l-55.3-75.6c-23.4-31.9-64-46.2-102.3-36L128.5 58.8C90.3 69.1 62.3 101.7 58 141.1zm58.9 136.2a32 32 0 1 1 16.6 61.8 32 32 0 1 1-16.6-61.8zM372.5 242a32 32 0 1 1 61.8-16.6 32 32 0 1 1-61.8 16.6zm212.3 270c19.5 0 34.7-17.7 25.8-35-18.6-36.2-56.3-61-99.7-61s-81.2 24.8-99.7 61c-8.9 17.3 6.3 35 25.8 35h147.8z"
        }
    ]
};

const FasCarBurst = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCarBurst",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 8c-6.6 0-12.4 4-14.9 10.1l-29.4 74-76.1-23.2c-6.3-1.9-13.1.2-17.2 5.3S33.8 86.4 37 92.1l39.5 69.1-65.6 45.2c-5.4 3.7-8 10.3-6.5 16.7s6.7 11.2 13.1 12.2l78.7 12.2-5.6 79.5c-.5 6.5 3.1 12.7 9 15.5s12.9 1.8 17.8-2.6l35.3-32.5 9.5-35.4 10.4-38.6c8-29.9 30.5-52.1 57.9-60.9l41-59.2C282.8 97 297.9 84.4 315 76.1c-.4-.6-.8-1.2-1.3-1.8-4.1-5.1-10.9-7.2-17.2-5.3l-76.2 23.1-29.4-74C188.4 12 182.6 8 176 8zm191.7 153.5 135.6 36.3c6.5 1.8 11.3 7.4 11.8 14.2l4.6 56.5-201.5-54 32.2-46.6c3.8-5.6 10.8-8.1 17.3-6.4zm-69.9-30-47.9 69.3c-21.6 3-40.3 18.6-46.3 41l-10.4 38.6-16.6 61.8-8.3 30.9c-4.6 17.1 5.6 34.6 22.6 39.2l15.5 4.1c17.1 4.6 34.6-5.6 39.2-22.6l8.3-30.9 247.3 66.3-8.3 30.9c-4.6 17.1 5.6 34.6 22.6 39.2l15.5 4.1c17.1 4.6 34.6-5.6 39.2-22.6l8.3-30.9L595 388l10.4-38.6c6-22.4-2.5-45.2-19.6-58.7l-6.8-84c-2.7-33.7-26.4-62-59-70.8L384.2 99.7c-32.7-8.8-67.3 4-86.5 31.8zm-17 131a24 24 0 1 1-12.4 46.4 24 24 0 1 1 12.4-46.4zm217.9 83.2a24 24 0 1 1 46.3 12.4 24 24 0 1 1-46.4-12.4z"
        }
    ]
};

const FasCarBus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCarBus",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 416h16v32c0 17.7 14.3 32 32 32h16c17.7 0 32-14.3 32-32v-32h64v-64c0-32.8 16.5-61.8 41.6-79.1l16.3-48.9H208V96h88c13.3 0 24 10.7 24 24v16.4c13.2-5.4 27.7-8.4 42.6-8.4H384V74.5c0-16.2-9.2-31-23.7-38.3C312.8 12.4 260.3 0 207.1 0h-30.2C123.7 0 71.2 12.4 23.7 36.2 9.2 43.4 0 58.2 0 74.5V384c0 17.7 14.3 32 32 32zM88 96h88v128H88c-13.3 0-24-10.7-24-24v-80c0-13.3 10.7-24 24-24zm8 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm266.6-72h138.8c6.9 0 13 4.4 15.2 10.9l17.7 53.1H329.7l17.7-53.1c2.2-6.5 8.3-10.9 15.2-10.9zm-75.9-9.3-26.6 79.7C238.8 304.7 224 326.6 224 352v128c0 17.7 14.3 32 32 32h16c17.7 0 32-14.3 32-32v-32h256v32c0 17.7 14.3 32 32 32h16c17.7 0 32-14.3 32-32V352c0-25.4-14.8-47.3-36.1-57.6l-26.6-79.7C566.4 182 535.8 160 501.4 160H362.6c-34.4 0-65 22-75.9 54.7zM304 344a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm232 24a24 24 0 1 1 48 0 24 24 0 1 1-48 0z"
        }
    ]
};

const FasCarCircleBolt = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCarCircleBolt",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M135.2 117.4 109.1 192h293.8l-26.1-74.6c-4.5-12.8-16.6-21.4-30.2-21.4H165.4c-13.6 0-25.7 8.6-30.2 21.4zm-95.6 79.4L74.8 96.3C88.3 57.8 124.6 32 165.4 32h181.2c40.8 0 77.1 25.8 90.6 64.3l34.1 97.4C385.8 205.7 320 279.2 320 368c0 10.9 1 21.6 2.9 32H96v48c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V256c0-26.7 16.4-49.6 39.6-59.2zM128 288a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm368-64a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm47.9 63c-4.3-3.7-10.6-4-15.1-.6l-96 72c-4.1 3.1-5.8 8.5-4.2 13.4s6.2 8.2 11.4 8.2h35.6l-30.1 54.2c-2.8 5-1.7 11.1 2.6 14.9s10.6 4 15.1.6l96-72c4.1-3.1 5.8-8.5 4.2-13.4s-6.2-8.2-11.4-8.2h-35.6l30.1-54.2c2.8-5 1.7-11.1-2.6-14.9z"
        }
    ]
};

const FasCarGarage = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCarGarage",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M343.8 8.8C329 .4 310.9.4 296.2 8.8L24.1 164.2C8.8 173 3.5 192.5 12.2 207.9s28.3 20.7 43.7 11.9L320 68.9l264.1 150.9c15.3 8.8 34.9 3.4 43.7-11.9s3.4-34.9-11.9-43.7L343.8 8.8zm-94 215.2h140.4c6.8 0 12.8 4.3 15.1 10.6l19 53.4H215.7l19.1-53.4c2.3-6.4 8.3-10.6 15.1-10.6zm-75.3-10.9-28.3 79.3c-20.1 8.5-34.2 28.4-34.2 51.6v136c0 17.7 14.3 32 32 32h16c17.7 0 32-14.3 32-32v-32h256v32c0 17.7 14.3 32 32 32h16c17.7 0 32-14.3 32-32V344c0-23.2-14.1-43.1-34.2-51.6l-28.3-79.3C454.1 181.3 424 160 390.2 160H249.8c-33.8 0-64 21.3-75.3 53.1zM192 344a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm232 24a24 24 0 1 1 48 0 24 24 0 1 1-48 0z"
        }
    ]
};

const FasCarMirrors = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCarMirrors",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M167.2 117.4c4.5-12.8 16.6-21.4 30.2-21.4h181.2c13.6 0 25.7 8.6 30.2 21.4l26.1 74.6H141.1l26.1-74.6zM32 224h8.6c-5.4 9.4-8.6 20.3-8.6 32v192c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32v-48h320v48c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V256c0-11.7-3.1-22.6-8.6-32h8.6c17.7 0 32-14.3 32-32s-14.3-32-32-32h-52.5l-22.3-63.7C455.7 57.8 419.4 32 378.6 32H197.4c-40.8 0-77.1 25.8-90.6 64.3L84.5 160H32c-17.7 0-32 14.3-32 32s14.3 32 32 32zm64 64a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm352-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FasCarOn = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCarOn",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M280 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v80c0 13.3 10.7 24 24 24s24-10.7 24-24V24zm-94.2 200h140.4c6.8 0 12.8 4.3 15.1 10.6l19 53.4H151.7l19.1-53.4c2.3-6.4 8.3-10.6 15.1-10.6zm-75.3-10.9-28.3 79.3C62.1 300.9 48 320.8 48 344v136c0 17.7 14.3 32 32 32h16c17.7 0 32-14.3 32-32v-32h256v32c0 17.7 14.3 32 32 32h16c17.7 0 32-14.3 32-32V344c0-23.2-14.1-43.1-34.2-51.6l-28.3-79.3C390.1 181.3 360 160 326.2 160H185.8c-33.8 0-64 21.3-75.3 53.1zM128 344a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm232 24a24 24 0 1 1 48 0 24 24 0 1 1-48 0zM39 39c-9.4 9.4-9.4 24.6 0 33.9l48 48c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L73 39c-9.4-9.4-24.6-9.4-33.9 0zm400 0-48 48c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l48-48c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0z"
        }
    ]
};

const FasCarRear = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCarRear",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M165.4 96h181.2c13.6 0 25.7 8.6 30.2 21.4l26.1 74.6H109.1l26.1-74.6c4.5-12.8 16.6-21.4 30.2-21.4zm-90.6.3L39.6 196.8C16.4 206.4 0 229.3 0 256v80c0 23.7 12.9 44.4 32 55.4V448c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32v-48h256v48c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32v-56.6c19.1-11.1 32-31.7 32-55.4v-80c0-26.7-16.4-49.6-39.6-59.2L437.2 96.3C423.7 57.8 387.4 32 346.6 32H165.4c-40.8 0-77.1 25.8-90.6 64.3zM208 272h96c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16zm-160 8c0-13.3 10.7-24 24-24h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H72c-13.3 0-24-10.7-24-24zm360-24h32c13.3 0 24 10.7 24 24s-10.7 24-24 24h-32c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
        }
    ]
};

const FasCarSideBolt = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCarSideBolt",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M82.2 92.3 40.6 196.4C16.8 205.8 0 228.9 0 256v112c0 17.7 14.3 32 32 32h33.3c7.6 45.4 47.1 80 94.7 80s87.1-34.6 94.7-80h130.6c7.6 45.4 47.1 80 94.7 80s87.1-34.6 94.7-80H608c17.7 0 32-14.3 32-32v-48c0-65.2-48.8-119-111.8-127l-100-125c-18.2-22.8-45.8-36-75-36H171.3C132 32 96.7 55.9 82.2 92.3zM480 336a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm-365.3 32a48 48 0 1 1 90.5 32 48 48 0 1 1-90.5-32zm216.5-267.4c5.3 5.2 6.3 13.3 2.5 19.6L300.3 176H352c7.1 0 13.4 4.7 15.4 11.6s-.8 14.2-6.9 18l-128 80c-6.3 3.9-14.4 3-19.7-2.2s-6.3-13.3-2.5-19.6l33.4-55.8H192c-7.1 0-13.4-4.7-15.4-11.6s.8-14.2 6.9-18l128-80c6.3-3.9 14.4-3 19.7 2.2z"
        }
    ]
};

const FasCarSide = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCarSide",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M171.3 96H224v96H111.3l30.4-75.9C146.5 104 158.2 96 171.3 96zM272 192V96h81.2c9.7 0 18.9 4.4 25 12l67.2 84H272zm256.2 1-100-125c-18.2-22.8-45.8-36-75-36H171.3C132 32 96.7 55.9 82.2 92.3L40.6 196.4C16.8 205.8 0 228.9 0 256v112c0 17.7 14.3 32 32 32h33.3c7.6 45.4 47.1 80 94.7 80s87.1-34.6 94.7-80h130.6c7.6 45.4 47.1 80 94.7 80s87.1-34.6 94.7-80H608c17.7 0 32-14.3 32-32v-48c0-65.2-48.8-119-111.8-127zm-93.5 175a48 48 0 1 1 90.5 32 48 48 0 1 1-90.5-32zM160 336a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
        }
    ]
};

const FasCarTilt = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCarTilt",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m145.1 120.6 147.3-39.4c12.7-3.4 26.3 1.3 34.1 12l37.8 51.6-249.7 66.8 7-63.6c1.4-13.1 10.8-24 23.5-27.4zM58 141.1l-10.2 93.1c-20.4 15.2-30.6 41.8-23.6 67.9l33.1 123.7 6 22.2H48c-26.5 0-48 21.5-48 48v16h640v-16c0-26.5-21.5-48-48-48H162.6c-.1-.2-.1-.5-.2-.7L150 400.9l278.2-74.5 12.4 46.4c4.6 17.1 22.1 27.2 39.2 22.6l30.9-8.3c17.1-4.6 27.2-22.1 22.6-39.2L521 301.5l-33.2-123.6c-7-26.1-29.1-44.1-54.4-47l-55.3-75.6c-23.4-31.9-64-46.2-102.3-36L128.5 58.8C90.3 69.1 62.3 101.7 58 141.1zm58.9 136.2a32 32 0 1 1 16.6 61.8 32 32 0 1 1-16.6-61.8zM372.5 242a32 32 0 1 1 61.8-16.6 32 32 0 1 1-61.8 16.6z"
        }
    ]
};

const FasCarTunnel = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCarTunnel",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 0C114.6 0 0 114.6 0 256v192c0 35.3 28.7 64 64 64h42.8c-6.6-5.9-10.8-14.4-10.8-24V376c0-20.8 11.3-38.9 28.1-48.6l21-64.7c7.5-23.1 29-38.7 53.3-38.7h115.2c24.3 0 45.8 15.6 53.3 38.7l21 64.7c16.8 9.7 28.2 27.8 28.2 48.6v112c0 9.6-4.2 18.1-10.8 24H448c35.3 0 64-28.7 64-64V256C512 114.6 397.4 0 256 0zm106.8 512c-6.6-5.9-10.8-14.4-10.8-24v-40H160v40c0 9.6-4.2 18.1-10.8 24h213.6zm-172-234.5L177 320h158l-13.8-42.5c-1.1-3.3-4.1-5.5-7.6-5.5H198.4c-3.5 0-6.5 2.2-7.6 5.5zM168 408a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm200-24a24 24 0 1 0-48 0 24 24 0 1 0 48 0z"
        }
    ]
};

const FasCarWash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCarWash",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 128c26.5 0 48-16 48-48 0-22.2-23-52-37.2-68.2-5.8-6.7-15.8-6.7-21.6 0C39 28 16 57.8 16 80c0 26.5 21.5 48 48 48zm160 0c26.5 0 48-16 48-48 0-22.2-23-52-37.2-68.2-5.8-6.7-15.9-6.7-21.7 0C199 28 176 57.8 176 80c0 26.5 21.5 48 48 48zm208-48c0-22.2-23-52-37.2-68.2-5.8-6.7-15.9-6.7-21.7 0C359 28 336 57.8 336 80c0 26.5 21.5 48 48 48s48-16 48-48zM153.8 224h140.4c6.8 0 12.8 4.3 15.1 10.6l19 53.4H119.7l19.1-53.4c2.3-6.4 8.3-10.6 15.1-10.6zm-75.3-10.9-28.3 79.3C30.1 300.9 16 320.8 16 344v136c0 17.7 14.3 32 32 32h16c17.7 0 32-14.3 32-32v-32h256v32c0 17.7 14.3 32 32 32h16c17.7 0 32-14.3 32-32V344c0-23.2-14.1-43.1-34.2-51.6l-28.3-79.3C358.1 181.3 328 160 294.2 160H153.8c-33.8 0-64 21.3-75.3 53.1zM96 344a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm232 24a24 24 0 1 1 48 0 24 24 0 1 1-48 0z"
        }
    ]
};

const FasCarWrench = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCarWrench",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M468.9 104h-13.4c-.7 0-1.4-.1-2.1-.1C441.3 102.5 432 92.4 432 80s9.3-22.5 21.3-23.9c.7-.1 1.4-.1 2.1-.1h31c10.8 0 18.4-10.6 12.5-19.6-3.6-5.5-7.8-10.5-12.5-14.9-4.2-3.9-8.8-7.4-13.8-10.3-1.8-1.2-3.7-2.2-5.7-3.2-10.5-5.1-22.4-8-34.9-8-29.1 0-54.5 15.5-68.5 38.7-3.3 5.4-8.9 9.3-15.3 9.3H163.8c-6.4 0-12-3.8-15.3-9.3C134.5 15.5 109.1 0 80 0 67.5 0 55.6 2.9 45.1 8c-2 1-3.9 2-5.8 3.1-5 2.9-9.6 6.4-13.8 10.3-4.7 4.4-9 9.4-12.5 14.9C7 45.4 14.7 56 25.5 56h31c.7 0 1.4.1 2.1.1C70.7 57.5 80 67.6 80 80s-9.3 22.5-21.3 23.9c-.7.1-1.4.1-2.1.1H25.5c-10.8 0-18.5 10.6-12.6 19.6 3.6 5.5 7.8 10.5 12.5 14.9 4.2 3.9 8.8 7.4 13.8 10.3 1.9 1.1 3.8 2.2 5.8 3.1 10.6 5.1 22.4 8 34.9 8 29.1 0 54.5-15.5 68.5-38.7 3.3-5.4 8.9-9.3 15.3-9.3h184.5c6.4 0 12 3.8 15.3 9.3 14 23.2 39.5 38.7 68.5 38.7 12.5 0 24.4-2.9 34.9-8 2-1 3.9-2 5.8-3.1 5-2.9 9.6-6.4 13.8-10.3 4.7-4.4 9-9.4 12.5-14.9 5.9-9-1.7-19.6-12.5-19.6h-17.6zM185.8 224h140.4c6.8 0 12.8 4.3 15.1 10.6l19 53.4H151.7l19.1-53.4c2.3-6.4 8.3-10.6 15.1-10.6zm-75.3-10.9-28.3 79.3C62.1 300.9 48 320.8 48 344v136c0 17.7 14.3 32 32 32h16c17.7 0 32-14.3 32-32v-32h256v32c0 17.7 14.3 32 32 32h16c17.7 0 32-14.3 32-32V344c0-23.2-14.1-43.1-34.2-51.6l-28.3-79.3C390.1 181.3 360 160 326.2 160H185.8c-33.8 0-64 21.3-75.3 53.1zM128 344a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm232 24a24 24 0 1 1 48 0 24 24 0 1 1-48 0z"
        }
    ]
};

const FasCar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCar",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M135.2 117.4 109.1 192h293.8l-26.1-74.6c-4.5-12.8-16.6-21.4-30.2-21.4H165.4c-13.6 0-25.7 8.6-30.2 21.4zm-95.6 79.4L74.8 96.3C88.3 57.8 124.6 32 165.4 32h181.2c40.8 0 77.1 25.8 90.6 64.3l35.2 100.5c23.2 9.6 39.6 32.5 39.6 59.2v192c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32v-48H96v48c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V256c0-26.7 16.4-49.6 39.6-59.2zM128 288a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm288 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FasCaravanSimple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCaravanSimple",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 32C35.8 32 0 67.8 0 112v224c0 44.2 35.8 80 80 80h16c0 53 43 96 96 96s96-43 96-96h320c17.7 0 32-14.3 32-32s-14.3-32-32-32h-32V192c0-88.4-71.6-160-160-160H80zM64 160c0-17.7 14.3-32 32-32h128c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32v-64zm288-32h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32zM144 416a48 48 0 1 1 96 0 48 48 0 1 1-96 0z"
        }
    ]
};

const FasCaravan = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCaravan",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 112c0-44.2 35.8-80 80-80h336c88.4 0 160 71.6 160 160v160h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H288c0 53-43 96-96 96s-96-43-96-96H80c-44.2 0-80-35.8-80-80V112zm320 240h128v-96h-32c-8.8 0-16-7.2-16-16s7.2-16 16-16h32v-64c0-17.7-14.3-32-32-32h-64c-17.7 0-32 14.3-32 32v192zM96 128c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h128c17.7 0 32-14.3 32-32v-64c0-17.7-14.3-32-32-32H96zm96 336a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
        }
    ]
};

const FasCardClub = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCardClub",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 64C0 28.7 28.7 0 64 0h256c35.3 0 64 28.7 64 64v384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm130.1 144.3c-28.2 3-50.1 26.8-50.1 55.7 0 30.9 25.1 56 56 56 15.7 0 29.8-6.4 40-16.8V336h-16c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16h-16v-32.8c10.2 10.4 24.3 16.8 40 16.8 30.9 0 56-25.1 56-56 0-28.9-21.9-52.7-50.1-55.7 1.4-5.2 2.1-10.7 2.1-16.3 0-35.3-28.7-64-64-64s-64 28.7-64 64c0 5.6.7 11.1 2.1 16.3z"
        }
    ]
};

const FasCardDiamond = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCardDiamond",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 64C0 28.7 28.7 0 64 0h256c35.3 0 64 28.7 64 64v384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm180.7 84.7-96 96c-6.2 6.2-6.2 16.4 0 22.6l96 96c6.2 6.2 16.4 6.2 22.6 0l96-96c6.2-6.2 6.2-16.4 0-22.6l-96-96c-6.2-6.2-16.4-6.2-22.6 0z"
        }
    ]
};

const FasCardHeart = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCardHeart",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm16 221.3c0-33.8 27.4-61.3 61.3-61.3 16.2 0 31.8 6.5 43.3 17.9l7.4 7.4 7.4-7.4c11.5-11.5 27.1-17.9 43.3-17.9 33.8 0 61.3 27.4 61.3 61.3 0 16.2-6.5 31.8-17.9 43.3l-82.7 82.7c-6.2 6.2-16.4 6.2-22.6 0l-82.9-82.7C86.5 253.1 80 237.5 80 221.3z"
        }
    ]
};

const FasCardSpade = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCardSpade",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm111 137.8c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6 64 64c21.9 21.9 21.9 57.3 0 79.2s-57.3 21.9-79.2 0l-7.4-7.4c-.3-.3-.6-.6-1-.9V336h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H160c-8.8 0-16-7.2-16-16s7.2-16 16-16h16v-40.8c-.3.3-.7.6-1 .9l-7.4 7.4c-21.9 21.9-57.3 21.9-79.2 0s-21.9-57.3 0-79.2l64-64 22.6-22.5z"
        }
    ]
};

const FasCardsBlank = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCardsBlank",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M27.8 118.8C1.2 134.2-7.9 168.2 7.5 194.9l167 289.3c15.4 26.6 49.4 35.8 76.1 20.4l192.8-111.4c26.6-15.4 35.8-49.4 20.4-76.1l-167-289.3C281.4 1.2 247.3-7.9 220.7 7.5L27.8 118.8zm431.6 302.1L324.1 499c9.7 8.1 22.2 13 35.9 13h224c30.9 0 56-25.1 56-56V120c0-30.9-25.1-56-56-56H360c-1.8 0-3.5.1-5.3.2l136.8 236.9c24.2 41.9 9.8 95.6-32.1 119.8z"
        }
    ]
};

const FasCards = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCards",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M7.5 194.9c-15.4-26.6-6.3-60.7 20.4-76.1L220.7 7.5c26.6-15.4 60.7-6.3 76.1 20.4l167 289.3c15.4 26.6 6.2 60.7-20.4 76.1L250.5 504.5c-26.6 15.4-60.7 6.2-76.1-20.4L7.5 194.9zM197 159.6c-11.1-3-22.6 3.6-25.6 14.8l-7.2 26.9-20.4 76.1c-7 26 8.5 52.7 34.4 59.7s52.7-8.5 59.7-34.4l2.4-8.8c.1-.4.2-.8.3-1.1l17.7 30.7-12.1 7c-6.7 3.8-8.9 12.4-5.1 19s12.4 8.9 19 5.1l48.2-27.8c6.7-3.8 8.9-12.4 5.1-19s-12.4-8.9-19-5.1l-12.1 7-17.7-30.7c.4.1.8.2 1.1.3l8.8 2.4c26 7 52.7-8.5 59.7-34.4s-8.5-52.7-34.4-59.7l-76.1-20.4-26.7-7.6zm262.4 261.3c41.9-24.2 56.3-77.8 32.1-119.8L354.7 64.2c1.7-.2 3.5-.2 5.3-.2h224c30.9 0 56 25.1 56 56v336c0 30.9-25.1 56-56 56H360c-13.7 0-26.2-4.9-35.9-13l135.3-78.1zm74.5-183.3 48.1-50c14-14.5 13.2-38.5-2.2-51.9-14-11.7-34.5-9.5-46.9 3.2l-4.7 5.2-5-5.2c-12.5-12.7-33.2-15-46.7-3.2-15.7 13.5-16.5 37.5-2.5 51.9l48.4 49.9c3 3.2 8.2 3.2 11.5 0z"
        }
    ]
};

const FasCaretDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCaretDown",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M137.4 374.6c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9S301 191.9 288 191.9L32 192c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l128 128z"
        }
    ]
};

const FasCaretLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCaretLeft",
    "viewBox": "0 0 256 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M9.4 278.6c-12.5-12.5-12.5-32.8 0-45.3l128-128c9.2-9.2 22.9-11.9 34.9-6.9s19.8 16.6 19.8 29.6v256c0 12.9-7.8 24.6-19.8 29.6s-25.7 2.2-34.9-6.9l-128-128z"
        }
    ]
};

const FasCaretRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCaretRight",
    "viewBox": "0 0 256 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M246.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-9.2-9.2-22.9-11.9-34.9-6.9S63.9 115 63.9 128v256c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l128-128z"
        }
    ]
};

const FasCaretUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCaretUp",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M182.6 137.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-9.2 9.2-11.9 22.9-6.9 34.9S19 320.1 32 320.1h256c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-128-128z"
        }
    ]
};

const FasCarrot = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCarrot",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M346.7 6C337.6 17 320 42.3 320 72c0 40 15.3 55.3 40 80s40 40 80 40c29.7 0 55-17.6 66-26.7 4-3.3 6-8.2 6-13.3s-2-10-6-13.2c-11.4-9.1-38.3-26.8-74-26.8-32 0-40 8-40 8s8-8 8-40c0-35.7-17.7-62.6-26.8-74-3.2-4-8.1-6-13.2-6s-10 2-13.3 6zM244.6 136c-40 0-77.1 18.1-101.7 48.2l60.5 60.5c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L125.5 212v.1L2.2 477.9C-2 487-.1 497.8 7 505s17.9 9 27.1 4.8l134.7-62.4-52.1-52.1c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l60.4 60.3 100.2-46.4c46.4-21.5 76.2-68 76.2-119.2C376 194.8 317.2 136 244.6 136z"
        }
    ]
};

const FasCars = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCars",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M123.4 74.9c2.2-6.5 8.3-10.9 15.2-10.9h138.8c6.9 0 13 4.4 15.2 10.9l17.7 53.1H105.7l17.7-53.1zm-87.3 59.5C14.8 144.7 0 166.6 0 192v128c0 17.7 14.3 32 32 32h16c17.7 0 32-14.3 32-32v-32h136.5c5.1-5.7 10.8-10.7 17.1-15.1l22.8-68.3c15.2-45.7 58-76.6 106.3-76.6h15.1l-24.5-73.3C342.4 22 311.8 0 277.4 0H138.6c-34.4 0-65 22-75.9 54.7l-26.6 79.7zM56 208a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm306.6 16h138.8c6.9 0 13 4.4 15.2 10.9l17.7 53.1H329.7l17.7-53.1c2.2-6.5 8.3-10.9 15.2-10.9zm-75.9-9.3-26.6 79.7C238.8 304.7 224 326.6 224 352v128c0 17.7 14.3 32 32 32h16c17.7 0 32-14.3 32-32v-32h256v32c0 17.7 14.3 32 32 32h16c17.7 0 32-14.3 32-32V352c0-25.4-14.8-47.3-36.1-57.6l-26.6-79.7C566.4 182 535.8 160 501.4 160H362.6c-34.4 0-65 22-75.9 54.7zM304 344a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm232 24a24 24 0 1 1 48 0 24 24 0 1 1-48 0z"
        }
    ]
};

const FasCartArrowDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCartArrowDown",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M24 0C10.7 0 0 10.7 0 24s10.7 24 24 24h45.5c3.8 0 7.1 2.7 7.9 6.5l51.6 271c6.5 34 36.2 58.5 70.7 58.5H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H199.7c-11.5 0-21.4-8.2-23.6-19.5l-5.4-28.5h288.5c32.6 0 61.1-21.8 69.5-53.3l41-152.3C576.6 57 557.4 32 531.1 32H360v102.1l23-23c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-64 64c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l23 23V32H120.1C111 12.8 91.6 0 69.5 0H24zm152 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm336-48a48 48 0 1 0-96 0 48 48 0 1 0 96 0z"
        }
    ]
};

const FasCartArrowUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCartArrowUp",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M24 0C10.7 0 0 10.7 0 24s10.7 24 24 24h45.5c3.8 0 7.1 2.7 7.9 6.5l51.6 271c6.5 34 36.2 58.5 70.7 58.5H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H199.7c-11.5 0-21.4-8.2-23.6-19.5l-5.4-28.5H312V177.9l-23 23c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l64-64c9.4-9.4 24.6-9.4 33.9 0l64 64c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-23-23V288h99.2c32.6 0 61.1-21.8 69.5-53.3l41-152.3C576.6 57 557.4 32 531.1 32h-411C111 12.8 91.6 0 69.5 0H24zm152 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm336-48a48 48 0 1 0-96 0 48 48 0 1 0 96 0z"
        }
    ]
};

const FasCartCircleArrowDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCartCircleArrowDown",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M24 0C10.7 0 0 10.7 0 24s10.7 24 24 24h52.1l60.3 316.5c2.2 11.3 12.1 19.5 23.6 19.5h160.7c-.5-5.3-.7-10.6-.7-16 0-10.9 1-21.6 2.9-32h-143l-9.1-48h168.4c29.1-57 88.4-96 156.8-96 14.3 0 28.3 1.7 41.6 4.9l35-124.3C578.3 52.3 563 32 541.8 32H122l-2.4-12.5C117.4 8.2 107.5 0 96 0H24zm152 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm320 0a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm67.3-147.3c6.2 6.2 6.2 16.4 0 22.6l-56 56c-6.2 6.2-16.4 6.2-22.6 0l-56-56c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l28.7 28.7V304c0-8.8 7.2-16 16-16s16 7.2 16 16v89.4l28.7-28.7c6.2-6.2 16.4-6.2 22.6 0z"
        }
    ]
};

const FasCartCircleArrowUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCartCircleArrowUp",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M24 0C10.7 0 0 10.7 0 24s10.7 24 24 24h52.1l60.3 316.5c2.2 11.3 12.1 19.5 23.6 19.5h160.7c-.5-5.3-.7-10.6-.7-16 0-10.9 1-21.6 2.9-32h-143l-9.1-48h168.4c29.1-57 88.4-96 156.8-96 14.3 0 28.3 1.7 41.6 4.9l35-124.3C578.3 52.3 563 32 541.8 32H122l-2.4-12.5C117.4 8.2 107.5 0 96 0H24zm152 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm320-288a144 144 0 1 0 0 288 144 144 0 1 0 0-288zm-67.3 147.3c-6.2-6.2-6.2-16.4 0-22.6l56-56c6.2-6.2 16.4-6.2 22.6 0l56 56c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L512 342.6V432c0 8.8-7.2 16-16 16s-16-7.2-16-16v-89.4l-28.7 28.7c-6.2 6.2-16.4 6.2-22.6 0z"
        }
    ]
};

const FasCartCircleCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCartCircleCheck",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M24 0C10.7 0 0 10.7 0 24s10.7 24 24 24h52.1l60.3 316.5c2.2 11.3 12.1 19.5 23.6 19.5h160.7c-.5-5.3-.7-10.6-.7-16 0-10.9 1-21.6 2.9-32h-143l-9.1-48h168.4c29.1-57 88.4-96 156.8-96 14.3 0 28.3 1.7 41.6 4.9l35-124.3C578.3 52.3 563 32 541.8 32H122l-2.4-12.5C117.4 8.2 107.5 0 96 0H24zm152 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm464-144a144 144 0 1 0-288 0 144 144 0 1 0 288 0zm-99.3-43.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l28.7 28.7 60.7-60.7z"
        }
    ]
};

const FasCartCircleExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCartCircleExclamation",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M24 0C10.7 0 0 10.7 0 24s10.7 24 24 24h52.1l60.3 316.5c2.2 11.3 12.1 19.5 23.6 19.5h160.7c-.5-5.3-.7-10.6-.7-16 0-10.9 1-21.6 2.9-32h-143l-9.1-48h168.4c29.1-57 88.4-96 156.8-96 14.3 0 28.3 1.7 41.6 4.9l35-124.3C578.3 52.3 563 32 541.8 32H122l-2.4-12.5C117.4 8.2 107.5 0 96 0H24zm152 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm320 0a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16v-80c0-8.8 7.2-16 16-16z"
        }
    ]
};

const FasCartCirclePlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCartCirclePlus",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M24 0C10.7 0 0 10.7 0 24s10.7 24 24 24h52.1l60.3 316.5c2.2 11.3 12.1 19.5 23.6 19.5h160.7c-.5-5.3-.7-10.6-.7-16 0-10.9 1-21.6 2.9-32h-143l-9.1-48h168.4c29.1-57 88.4-96 156.8-96 14.3 0 28.3 1.7 41.6 4.9l35-124.3C578.3 52.3 563 32 541.8 32H122l-2.4-12.5C117.4 8.2 107.5 0 96 0H24zm152 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm176-144a144 144 0 1 0 288 0 144 144 0 1 0-288 0zm208 16h-48v48c0 8.8-7.2 16-16 16s-16-7.2-16-16v-48h-48c-8.8 0-16-7.2-16-16s7.2-16 16-16h48v-48c0-8.8 7.2-16 16-16s16 7.2 16 16v48h48c8.8 0 16 7.2 16 16s-7.2 16-16 16z"
        }
    ]
};

const FasCartCircleXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCartCircleXmark",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M24 0C10.7 0 0 10.7 0 24s10.7 24 24 24h52.1l60.3 316.5c2.2 11.3 12.1 19.5 23.6 19.5h160.7c-.5-5.3-.7-10.6-.7-16 0-10.9 1-21.6 2.9-32h-143l-9.1-48h168.4c29.1-57 88.4-96 156.8-96 14.3 0 28.3 1.7 41.6 4.9l35-124.3C578.3 52.3 563 32 541.8 32H122l-2.4-12.5C117.4 8.2 107.5 0 96 0H24zm152 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm320 0a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L518.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l36.7-36.7-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l36.7 36.7 36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
        }
    ]
};

const FasCartFlatbedBoxes = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCartFlatbedBoxes",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 0C14.3 0 0 14.3 0 32s14.3 32 32 32h16c8.8 0 16 7.2 16 16v288c0 44.2 35.8 80 80 80h18.7c-1.8 5-2.7 10.4-2.7 16 0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1-11-2.7-16h197.4c-1.8 5-2.7 10.4-2.7 16 0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1-11-2.7-16H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H144c-8.8 0-16-7.2-16-16V80c0-44.2-35.8-80-80-80H32zm192 32c-17.7 0-32 14.3-32 32v224c0 17.7 14.3 32 32 32h128c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H224zm192 32v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32h-64c-17.7 0-32 14.3-32 32zm32 128c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h128c17.7 0 32-14.3 32-32v-64c0-17.7-14.3-32-32-32H448z"
        }
    ]
};

const FasCartFlatbedEmpty = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCartFlatbedEmpty",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 32C0 14.3 14.3 0 32 0h16c44.2 0 80 35.8 80 80v288c0 8.8 7.2 16 16 16h464c17.7 0 32 14.3 32 32s-14.3 32-32 32h-66.7c1.8 5 2.7 10.4 2.7 16 0 26.5-21.5 48-48 48s-48-21.5-48-48c0-5.6 1-11 2.7-16H253.3c1.8 5 2.7 10.4 2.7 16 0 26.5-21.5 48-48 48s-48-21.5-48-48c0-5.6 1-11 2.7-16H144c-44.2 0-80-35.8-80-80V80c0-8.8-7.2-16-16-16H32C14.3 64 0 49.7 0 32z"
        }
    ]
};

const FasCartFlatbedSuitcase = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCartFlatbedSuitcase",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 32C0 14.3 14.3 0 32 0h16c44.2 0 80 35.8 80 80v288c0 8.8 7.2 16 16 16h464c17.7 0 32 14.3 32 32s-14.3 32-32 32h-66.7c1.8 5 2.7 10.4 2.7 16 0 26.5-21.5 48-48 48s-48-21.5-48-48c0-5.6 1-11 2.7-16H253.3c1.8 5 2.7 10.4 2.7 16 0 26.5-21.5 48-48 48s-48-21.5-48-48c0-5.6 1-11 2.7-16H144c-44.2 0-80-35.8-80-80V80c0-8.8-7.2-16-16-16H32C14.3 64 0 49.7 0 32zm432 64V56c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8v40h96zm-144 0V56c0-30.9 25.1-56 56-56h80c30.9 0 56 25.1 56 56v264H288V96zm224 224V96h16c26.5 0 48 21.5 48 48v128c0 26.5-21.5 48-48 48h-16zM240 96h16v224h-16c-26.5 0-48-21.5-48-48V144c0-26.5 21.5-48 48-48z"
        }
    ]
};

const FasCartFlatbed = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCartFlatbed",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 0C14.3 0 0 14.3 0 32s14.3 32 32 32h16c8.8 0 16 7.2 16 16v288c0 44.2 35.8 80 80 80h18.7c-1.8 5-2.7 10.4-2.7 16 0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1-11-2.7-16h197.4c-1.8 5-2.7 10.4-2.7 16 0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1-11-2.7-16H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H144c-8.8 0-16-7.2-16-16V80c0-44.2-35.8-80-80-80H32zm160 80v192c0 26.5 21.5 48 48 48h320c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48h-96v144c0 5.9-3.2 11.3-8.5 14.1s-11.5 2.5-16.4-.8L400 163.2l-39.1 26.1c-4.9 3.3-11.2 3.6-16.4.8s-8.5-8.2-8.5-14.1V32h-96c-26.5 0-48 21.5-48 48z"
        }
    ]
};

const FasCartMinus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCartMinus",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M24 0C10.7 0 0 10.7 0 24s10.7 24 24 24h45.5c3.8 0 7.1 2.7 7.9 6.5l51.6 271c6.5 34 36.2 58.5 70.7 58.5H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H199.7c-11.5 0-21.4-8.2-23.6-19.5l-5.4-28.5h288.5c32.6 0 61.1-21.8 69.5-53.3l41-152.3C576.6 57 557.4 32 531.1 32h-411C111 12.8 91.6 0 69.5 0H24zm152 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm336-48a48 48 0 1 0-96 0 48 48 0 1 0 96 0zM280 132h112c11 0 20 9 20 20s-9 20-20 20H280c-11 0-20-9-20-20s9-20 20-20z"
        }
    ]
};

const FasCartPlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCartPlus",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 24C0 10.7 10.7 0 24 0h45.5c22 0 41.5 12.8 50.6 32h411c26.3 0 45.5 25 38.6 50.4l-41 152.3c-8.5 31.4-37 53.3-69.5 53.3H170.7l5.4 28.5c2.2 11.3 12.1 19.5 23.6 19.5H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H199.7c-34.6 0-64.3-24.6-70.7-58.5l-51.6-271c-.7-3.8-4-6.5-7.9-6.5H24C10.7 48 0 37.3 0 24zm128 440a48 48 0 1 1 96 0 48 48 0 1 1-96 0zm336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM252 160c0 11 9 20 20 20h44v44c0 11 9 20 20 20s20-9 20-20v-44h44c11 0 20-9 20-20s-9-20-20-20h-44V96c0-11-9-20-20-20s-20 9-20 20v44h-44c-11 0-20 9-20 20z"
        }
    ]
};

const FasCartShoppingFast = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCartShoppingFast",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M88 0C74.7 0 64 10.7 64 24s10.7 24 24 24h45.5c3.8 0 7.1 2.7 7.9 6.5l51.6 271c6.5 34 36.2 58.5 70.7 58.5H552c13.3 0 24-10.7 24-24s-10.7-24-24-24H263.7c-11.5 0-21.4-8.2-23.6-19.5l-5.4-28.5h288.5c32.6 0 61.1-21.8 69.5-53.3l41-152.3C640.6 57 621.4 32 595.1 32h-411C175 12.8 155.6 0 133.5 0H88zm152 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm336-48a48 48 0 1 0-96 0 48 48 0 1 0 96 0zM24 96c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zm0 80c-13.3 0-24 10.7-24 24s10.7 24 24 24h96c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zm0 80c-13.3 0-24 10.7-24 24s10.7 24 24 24h112c13.3 0 24-10.7 24-24s-10.7-24-24-24H24z"
        }
    ]
};

const FasCartShopping = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCartShopping",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 24C0 10.7 10.7 0 24 0h45.5c22 0 41.5 12.8 50.6 32h411c26.3 0 45.5 25 38.6 50.4l-41 152.3c-8.5 31.4-37 53.3-69.5 53.3H170.7l5.4 28.5c2.2 11.3 12.1 19.5 23.6 19.5H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H199.7c-34.6 0-64.3-24.6-70.7-58.5l-51.6-271c-.7-3.8-4-6.5-7.9-6.5H24C10.7 48 0 37.3 0 24zm128 440a48 48 0 1 1 96 0 48 48 0 1 1-96 0zm336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
        }
    ]
};

const FasCartXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCartXmark",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M24 0C10.7 0 0 10.7 0 24s10.7 24 24 24h45.5c3.8 0 7.1 2.7 7.9 6.5l51.6 271c6.5 34 36.2 58.5 70.7 58.5H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H199.7c-11.5 0-21.4-8.2-23.6-19.5l-5.4-28.5h288.5c32.6 0 61.1-21.8 69.5-53.3l41-152.3C576.6 57 557.4 32 531.1 32h-411C111 12.8 91.6 0 69.5 0H24zm152 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm336-48a48 48 0 1 0-96 0 48 48 0 1 0 96 0zM395.4 128.9 364.3 160l31.1 31.1c7.8 7.8 7.8 20.5 0 28.3s-20.5 7.8-28.3 0L336 188.3l-31.1 31.1c-7.8 7.8-20.5 7.8-28.3 0s-7.8-20.5 0-28.3l31.1-31.1-31.1-31.1c-7.8-7.8-7.8-20.5 0-28.3s20.5-7.8 28.3 0l31.1 31.1 31.1-31.1c7.8-7.8 20.5-7.8 28.3 0s7.8 20.5 0 28.3z"
        }
    ]
};

const FasCashRegister = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCashRegister",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 0C46.3 0 32 14.3 32 32v64c0 17.7 14.3 32 32 32h80v32H87c-31.6 0-58.5 23.1-63.3 54.4L1.1 364.1c-.7 4.7-1.1 9.5-1.1 14.3V448c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64v-69.6c0-4.8-.4-9.6-1.1-14.4l-22.7-149.6c-4.7-31.3-31.6-54.4-63.2-54.4H208v-32h80c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H64zm32 48h160c8.8 0 16 7.2 16 16s-7.2 16-16 16H96c-8.8 0-16-7.2-16-16s7.2-16 16-16zM64 432c0-8.8 7.2-16 16-16h352c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm48-168a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm120-24a24 24 0 1 1-48 0 24 24 0 1 1 48 0zm-72 104a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm168-104a24 24 0 1 1-48 0 24 24 0 1 1 48 0zm-72 104a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm168-104a24 24 0 1 1-48 0 24 24 0 1 1 48 0zm-72 104a24 24 0 1 1 0-48 24 24 0 1 1 0 48z"
        }
    ]
};

const FasCassetteBetamax = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCassetteBetamax",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v32h576V96c0-35.3-28.7-64-64-64H64zm512 128H0v256c0 35.3 28.7 64 64 64h448c35.3 0 64-28.7 64-64V160zM192 320a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm-128 0a96 96 0 1 1 192 0 96 96 0 1 1-192 0zm256-64c0-17.7 14.3-32 32-32h128c17.7 0 32 14.3 32 32v128c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V256z"
        }
    ]
};

const FasCassetteTape = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCassetteTape",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 96c0-35.3 28.7-64 64-64h448c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64h-28.9l-36.3-96.9c-7-18.7-24.9-31.1-44.9-31.1H174.2c-20 0-37.9 12.4-44.9 31.1L92.9 480H64c-35.3 0-64-28.7-64-64V96zm416.8 298.4 32.1 85.6H127.1l32.1-85.6c2.3-6.2 8.3-10.4 15-10.4h227.6c6.7 0 12.6 4.1 15 10.4zM341.5 192h-107c3.5 10 5.5 20.8 5.5 32s-1.9 22-5.5 32h107c-3.5-10-5.5-20.8-5.5-32s1.9-22 5.5-32zm90.5 0a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm-320 32a32 32 0 1 0 64 0 32 32 0 1 0-64 0z"
        }
    ]
};

const FasCassetteVhs = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCassetteVhs",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 96v32h576V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96zm0 64v256c0 35.3 28.7 64 64 64h448c35.3 0 64-28.7 64-64V160H0zm467.9 224H416v-34.7c18.6-6.6 32-24.4 32-45.3s-13.4-38.7-32-45.3V224h51.9c17.6 21.9 28.1 49.7 28.1 80s-10.5 58.1-28.1 80zM160 349.3V384h-51.9C90.5 362.1 80 334.3 80 304s10.5-58.1 28.1-80H160v34.7c-18.6 6.6-32 24.4-32 45.3s13.4 38.7 32 45.3zM256 224h64c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32v-96c0-17.7 14.3-32 32-32z"
        }
    ]
};

const FasCastle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCastle",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48V16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h32V16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48V16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v208h64v-48c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v288c0 26.5-21.5 48-48 48H384V384c0-35.3-28.7-64-64-64s-64 28.7-64 64v128H48c-26.5 0-48-21.5-48-48V176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h64V16z"
        }
    ]
};

const FasCatSpace = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCatSpace",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M576 160c0 70.7-57.3 128-128 128s-128-57.3-128-128c0-32.5 12.1-62.1 32-84.7V160c0 53 43 96 96 96s96-43 96-96V75.3c19.9 22.6 32 52.2 32 84.7zM411.2 89.6l-29.4-39.2C401.1 38.7 423.8 32 448 32s46.9 6.7 66.2 18.4l-29.4 39.2c-3 4-7.8 6.4-12.8 6.4h-48c-5 0-9.8-2.4-12.8-6.4zM480 316.8C553 302 608 237.4 608 160 608 71.6 536.4 0 448 0S288 71.6 288 160c0 11.7 1.3 23.1 3.6 34.1-54.9 8.1-102.2 39.5-131.6 83.8v-85.4c0-48.4-36.1-89.3-84.1-95.3l-7.9-1c-17.6-2.1-33.6 10.3-35.8 27.8s10.2 33.5 27.8 35.7l7.9 1c16 2 28 15.6 28 31.8V416c0 53 43 96 96 96H336c17.7 0 32-14.3 32-32s-14.3-32-32-32h-56l136-108.8V480c0 17.7 14.3 32 32 32s32-14.3 32-32V316.8zM400 160a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM231.5 12.3c-2.6-7-12.4-7-15 0l-10.7 28.8c-.8 2.2-2.5 3.9-4.7 4.7l-28.8 10.7c-7 2.6-7 12.4 0 15l28.8 10.7c2.2.8 3.9 2.5 4.7 4.7l10.7 28.8c2.6 7 12.4 7 15 0l10.7-28.8c.8-2.2 2.5-3.9 4.7-4.7l28.8-10.7c7-2.6 7-12.4 0-15l-28.8-10.7c-2.2-.8-3.9-2.5-4.7-4.7l-10.7-28.8z"
        }
    ]
};

const FasCat = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCat",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 192h17.1c22.1 38.3 63.5 64 110.9 64 11 0 21.8-1.4 32-4v228c0 17.7-14.3 32-32 32s-32-14.3-32-32V339.2L280 448h56c17.7 0 32 14.3 32 32s-14.3 32-32 32H192c-53 0-96-43-96-96V192.5c0-16.1-12-29.8-28-31.8l-7.9-1c-17.5-2.2-30-18.2-27.8-35.7S50.5 94 68 96.2l7.9 1c48 6 84.1 46.8 84.1 95.3v85.3c34.4-51.7 93.2-85.8 160-85.8zm160 26.5c-10 3.5-20.8 5.5-32 5.5-28.4 0-54-12.4-71.6-32-3.7-4.1-7-8.5-9.9-13.2C357.3 164 352 146.6 352 128V10.7C352 4.8 356.7.1 362.6 0h.2c3.3 0 6.4 1.6 8.4 4.2v.1l12.8 17 27.2 36.3L416 64h64l4.8-6.4L512 21.3l12.8-17v-.1c2-2.6 5.1-4.2 8.4-4.2h.2c5.9.1 10.6 4.8 10.6 10.7V128c0 17.3-4.6 33.6-12.6 47.6-11.3 19.8-29.6 35.2-51.4 42.9zM432 128a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm48 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
        }
    ]
};

const FasCauldron = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCauldron",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm112 64a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM35.1 224C16.5 257 0 297.1 0 334.4c0 37.4 11.9 69.4 32 95.5V488c0 13.3 10.7 24 24 24s24-10.7 24-24v-15c40.4 25.5 91.8 39 144 39s103.6-13.5 144-39v15c0 13.3 10.7 24 24 24s24-10.7 24-24v-58.1c20.1-26.1 32-58.1 32-95.5 0-37.3-16.5-77.4-35.1-110.4h3.1c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h3.1z"
        }
    ]
};

const FasCediSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCediSign",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32c0-17.7-14.3-32-32-32s-32 14.3-32 32v34.7C101.2 81.9 32 160.9 32 256s69.2 174.1 160 189.3V480c0 17.7 14.3 32 32 32s32-14.3 32-32v-34.7c30.9-5.2 59.2-17.7 83.2-35.8 14.1-10.6 17-30.7 6.4-44.8s-30.7-17-44.8-6.4c-13.2 9.9-28.3 17.3-44.8 21.6V132c16.4 4.2 31.6 11.6 44.8 21.6 14.1 10.6 34.2 7.8 44.8-6.4s7.8-34.2-6.4-44.8c-24-18-52.4-30.6-83.2-35.8V32zm-64 100v248c-55.2-14.2-96-64.3-96-124s40.8-109.8 96-124z"
        }
    ]
};

const FasCentSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCentSign",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 0c17.7 0 32 14.3 32 32v34.7c30.9 5.2 59.2 17.7 83.2 35.8 14.1 10.6 17 30.7 6.4 44.8s-30.7 17-44.8 6.4C279.4 137.5 252.9 128 224 128c-70.7 0-128 57.3-128 128s57.3 128 128 128c28.9 0 55.4-9.5 76.8-25.6 14.1-10.6 34.2-7.8 44.8 6.4s7.8 34.2-6.4 44.8c-24 18-52.4 30.6-83.2 35.8V480c0 17.7-14.3 32-32 32s-32-14.3-32-32v-34.7C101.2 430.1 32 351.1 32 256S101.2 81.9 192 66.7V32c0-17.7 14.3-32 32-32z"
        }
    ]
};

const FasCertificate = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCertificate",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M211 7.3C205 1 196-1.4 187.6.8s-14.9 8.9-17.1 17.3l-15.8 62.5-62-17.5c-8.4-2.4-17.4 0-23.5 6.1s-8.5 15.1-6.1 23.5l17.5 62-62.5 15.9c-8.4 2.1-15 8.7-17.3 17.1S1 205 7.3 211l46.2 45-46.2 45c-6.3 6-8.7 15-6.5 23.4s8.9 14.9 17.3 17.1l62.5 15.8-17.5 62c-2.4 8.4 0 17.4 6.1 23.5s15.1 8.5 23.5 6.1l62-17.5 15.8 62.5c2.1 8.4 8.7 15 17.1 17.3s17.3-.2 23.4-6.4l45-46.2 45 46.2c6.1 6.2 15 8.7 23.4 6.4s14.9-8.9 17.1-17.3l15.8-62.5 62 17.5c8.4 2.4 17.4 0 23.5-6.1s8.5-15.1 6.1-23.5l-17.5-62 62.5-15.8c8.4-2.1 15-8.7 17.3-17.1s-.2-17.3-6.4-23.4l-46.2-45 46.2-45c6.2-6.1 8.7-15 6.4-23.4s-8.9-14.9-17.3-17.1l-62.5-15.8 17.5-62c2.4-8.4 0-17.4-6.1-23.5s-15.1-8.5-23.5-6.1l-62 17.5-15.9-62.5c-2.1-8.4-8.7-15-17.1-17.3S307 1 301 7.3l-45 46.2-45-46.2z"
        }
    ]
};

const FasChairOffice = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasChairOffice",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 0h128c35.3 0 64 28.7 64 64v192H96V64c0-35.3 28.7-64 64-64zM64 160v64c0 17.7-14.3 32-32 32S0 241.7 0 224v-64c0-17.7 14.3-32 32-32s32 14.3 32 32zm384 0v64c0 17.7-14.3 32-32 32s-32-14.3-32-32v-64c0-17.7 14.3-32 32-32s32 14.3 32 32zM51.4 305.7C56.8 294.8 67.9 288 80 288h288c12.1 0 23.2 6.8 28.6 17.7l16 32c5 9.9 4.4 21.7-1.4 31.1S395.1 384 384 384H256v64h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H160c-17.7 0-32-14.3-32-32s14.3-32 32-32h32v-64H64c-11.1 0-21.4-5.7-27.2-15.2s-6.4-21.2-1.4-31.1l16-32z"
        }
    ]
};

const FasChair = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasChair",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M248 48v208h48V58.7c23.9 13.8 40 39.7 40 69.3v128h48V128C384 57.3 326.7 0 256 0h-64C121.3 0 64 57.3 64 128v128h48V128c0-29.6 16.1-55.5 40-69.3V256h48V48h48zM48 288c-12.1 0-23.2 6.8-28.6 17.7l-16 32c-5 9.9-4.4 21.7 1.4 31.1S20.9 384 32 384v96c0 17.7 14.3 32 32 32s32-14.3 32-32v-96h256v96c0 17.7 14.3 32 32 32s32-14.3 32-32v-96c11.1 0 21.4-5.7 27.2-15.2s6.4-21.2 1.4-31.1l-16-32c-5.4-10.9-16.5-17.7-28.6-17.7H48z"
        }
    ]
};

const FasChalkboardUser = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasChalkboardUser",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 64c0-35.3 28.7-64 64-64h352c35.3 0 64 28.7 64 64v288c0 35.3-28.7 64-64 64H336.8c-11.8-25.5-29.9-47.5-52.4-64H384v-32c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v32h64V64H224v49.1C205.2 102.2 183.3 96 160 96V64zm0 64a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm-26.7 224h53.3c73.7 0 133.4 59.7 133.4 133.3 0 14.7-11.9 26.7-26.7 26.7H26.7C11.9 512 0 500.1 0 485.3 0 411.7 59.7 352 133.3 352z"
        }
    ]
};

const FasChalkboard = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasChalkboard",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 32c-35.3 0-64 28.7-64 64v288h64V96h384v288h64V96c0-35.3-28.7-64-64-64H96zm128 352v32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h512c17.7 0 32-14.3 32-32s-14.3-32-32-32H416v-32c0-17.7-14.3-32-32-32H256c-17.7 0-32 14.3-32 32z"
        }
    ]
};

const FasChampagneGlass = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasChampagneGlass",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M88 0C71.9 0 58.3 12 56.3 27.9L33.2 208c-8.3 65.4 34.1 124.4 94.8 140v100H80c-17.7 0-32 14.3-32 32s14.3 32 32 32h160c17.7 0 32-14.3 32-32s-14.3-32-32-32h-48V348c60.7-15.6 103.1-74.6 94.8-140l-23-180.1C261.7 12 248.1 0 232 0H88zm20 128 8.2-64h87.7l8.2 64H108z"
        }
    ]
};

const FasChampagneGlasses = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasChampagneGlasses",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M155.6 17.3C163 3 179.9-3.6 195 1.9l125 45.6L445 1.9c15.1-5.5 32 1.1 39.4 15.4l78.8 152.9c28.8 55.8 10.3 122.3-38.5 156.6l31.4 86.2 41-15c16.6-6 35 2.5 41 19.1s-2.5 35-19.1 41L547.9 484l-71.1 26c-16.6 6.1-35-2.5-41-19.1s2.5-35 19.1-41l41-15-31.3-86.2c-59.4 5.2-116.2-34-130-95.2L320 188.8l-14.6 64.7c-13.8 61.3-70.6 100.4-130 95.2l-31.3 86.2 41 15c16.6 6 25.2 24.4 19.1 41s-24.4 25.2-41 19.1l-71-25.9-71.1-25.9c-16.6-6.1-25.2-24.4-19.1-41s24.4-25.2 41-19.1l41 15 31.3-86.2C66.5 292.5 48.1 226 76.9 170.2l78.7-152.9zm44 54.4-27.2 52.8 89.2 32.5 13.1-57.9-75.1-27.4zm240.9 0-75.1 27.4 13.1 57.9 89.2-32.5-27.2-52.8z"
        }
    ]
};

const FasChargingStation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasChargingStation",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 0C60.7 0 32 28.7 32 64v384c-17.7 0-32 14.3-32 32s14.3 32 32 32h288c17.7 0 32-14.3 32-32s-14.3-32-32-32V304h16c22.1 0 40 17.9 40 40v32c0 39.8 32.2 72 72 72s72-32.2 72-72V252.3c32.5-10.2 56-40.5 56-76.3v-32c0-8.8-7.2-16-16-16h-16V80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48h-32V80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48h-16c-8.8 0-16 7.2-16 16v32c0 35.8 23.5 66.1 56 76.3V376c0 13.3-10.7 24-24 24s-24-10.7-24-24v-32c0-48.6-39.4-88-88-88h-16V64c0-35.3-28.7-64-64-64H96zm120.9 82.7c6 4 8.5 11.5 6.3 18.3l-25 74.9H256c6.7 0 12.7 4.2 15 10.4s.5 13.3-4.6 17.7l-112 96c-5.5 4.7-13.4 5.1-19.3 1.1s-8.5-11.5-6.3-18.3l25-74.9H96c-6.7 0-12.7-4.2-15-10.4s-.5-13.3 4.6-17.7l112-96c5.5-4.7 13.4-5.1 19.3-1.1z"
        }
    ]
};

const FasChartArea = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasChartArea",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64v336c0 44.2 35.8 80 80 80h400c17.7 0 32-14.3 32-32s-14.3-32-32-32H80c-8.8 0-16-7.2-16-16V64zm96 288h288c17.7 0 32-14.3 32-32v-68.2c0-7.6-2.7-15-7.7-20.8l-65.8-76.8c-12.1-14.2-33.7-15-46.9-1.8l-21 21c-10 10-26.4 9.2-35.4-1.6l-39.2-47c-12.6-15.1-35.7-15.4-48.7-.6L135.9 215c-5.1 5.8-7.9 13.3-7.9 21.1v84c0 17.7 14.3 32 32 32z"
        }
    ]
};

const FasChartBar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasChartBar",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 32c17.7 0 32 14.3 32 32v336c0 8.8 7.2 16 16 16h400c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-44.2 0-80-35.8-80-80V64c0-17.7 14.3-32 32-32zm96 96c0-17.7 14.3-32 32-32h192c17.7 0 32 14.3 32 32s-14.3 32-32 32H160c-17.7 0-32-14.3-32-32zm32 64h128c17.7 0 32 14.3 32 32s-14.3 32-32 32H160c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 96h256c17.7 0 32 14.3 32 32s-14.3 32-32 32H160c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
        }
    ]
};

const FasChartBullet = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasChartBullet",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M264 32c13.3 0 24 10.7 24 24v8h176c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H288v8c0 13.3-10.7 24-24 24s-24-10.7-24-24v-8H48c-26.5 0-48-21.5-48-48v-64c0-26.5 21.5-48 48-48h192v-8c0-13.3 10.7-24 24-24zm-104 96v32h80v-32h-80zm128 0v32h160v-32H288zm48 256v-32h-80v32h80zm0 64H48c-26.5 0-48-21.5-48-48v-64c0-26.5 21.5-48 48-48h288v-8c0-13.3 10.7-24 24-24s24 10.7 24 24v8h80c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48h-80v8c0 13.3-10.7 24-24 24s-24-10.7-24-24v-8zm48-96v32h64v-32h-64z"
        }
    ]
};

const FasChartCandlestick = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasChartCandlestick",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64v336c0 44.2 35.8 80 80 80h400c17.7 0 32-14.3 32-32s-14.3-32-32-32H80c-8.8 0-16-7.2-16-16V64zm256-16c0-8.8-7.2-16-16-16s-16 7.2-16 16v48c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48c17.7 0 32-14.3 32-32v-96c0-17.7-14.3-32-32-32V48zm64 176v64c0 17.7 14.3 32 32 32v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48c17.7 0 32-14.3 32-32v-64c0-17.7-14.3-32-32-32v-48c0-8.8-7.2-16-16-16s-16 7.2-16 16v48c-17.7 0-32 14.3-32 32zm-224-96c-17.7 0-32 14.3-32 32v128c0 17.7 14.3 32 32 32v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32V80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48z"
        }
    ]
};

const FasChartColumn = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasChartColumn",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 32c17.7 0 32 14.3 32 32v336c0 8.8 7.2 16 16 16h400c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-44.2 0-80-35.8-80-80V64c0-17.7 14.3-32 32-32zm128 192c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32v-64c0-17.7 14.3-32 32-32zm128-64v160c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32zm64 32c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32s-32-14.3-32-32v-96c0-17.7 14.3-32 32-32zm128-96v224c0 17.7-14.3 32-32 32s-32-14.3-32-32V96c0-17.7 14.3-32 32-32s32 14.3 32 32z"
        }
    ]
};

const FasChartGantt = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasChartGantt",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 32c17.7 0 32 14.3 32 32v336c0 8.8 7.2 16 16 16h400c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-44.2 0-80-35.8-80-80V64c0-17.7 14.3-32 32-32zm96 96c0-17.7 14.3-32 32-32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32h-96c-17.7 0-32-14.3-32-32zm96 64h128c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32zm160 96h64c17.7 0 32 14.3 32 32s-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
        }
    ]
};

const FasChartLineDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasChartLineDown",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64v336c0 44.2 35.8 80 80 80h400c17.7 0 32-14.3 32-32s-14.3-32-32-32H80c-8.8 0-16-7.2-16-16V64zm217.4 57.4L208 194.7l-57.4-57.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l80 80c12.5 12.5 32.8 12.5 45.3 0l73.4-73.3 57.4 57.4L329 279c-15.1 15.1-4.4 41 17 41h110c13.3 0 24-10.7 24-24V185.9c0-21.4-25.9-32.1-41-17l-32.4 32.4-80-80c-12.5-12.5-32.8-12.5-45.3 0z"
        }
    ]
};

const FasChartLineUpDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasChartLineUpDown",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64v336c0 44.2 35.8 80 80 80h400c17.7 0 32-14.3 32-32s-14.3-32-32-32H80c-8.8 0-16-7.2-16-16V64zm313.4 57.4L288 210.7l-57.4-57.4c-12.5-12.5-32.8-12.5-45.3 0l-80 80c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l57.4-57.3 57.4 57.4c12.5 12.5 32.8 12.5 45.3 0l112-112 18.7 18.7c4.2 4.2 10 6.6 16 6.6 12.5 0 22.6-10.1 22.6-22.6V80c0-8.8-7.2-16-16-16h-89.4C362.1 64 352 74.1 352 86.6c0 6 2.4 11.8 6.6 16l18.7 18.7zm64 141.3-18.7 18.7-34.7-34.7-45.3 45.3 34.7 34.7-18.7 18.7c-4.2 4.2-6.6 10-6.6 16 0 12.5 10.1 22.6 22.6 22.6h89.4c8.8 0 16-7.2 16-16v-89.4c0-12.5-10.1-22.6-22.6-22.6-6 0-11.8 2.4-16 6.6z"
        }
    ]
};

const FasChartLineUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasChartLineUp",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64v336c0 44.2 35.8 80 80 80h400c17.7 0 32-14.3 32-32s-14.3-32-32-32H80c-8.8 0-16-7.2-16-16V64zm375 215c15.1 15.1 41 4.4 41-17V152c0-13.3-10.7-24-24-24H345.9c-21.4 0-32.1 25.9-17 41l32.4 32.4-57.3 57.3-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0l-80 80c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l57.4-57.3 73.4 73.4c12.5 12.5 32.8 12.5 45.3 0l80-80L439 279z"
        }
    ]
};

const FasChartLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasChartLine",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64v336c0 44.2 35.8 80 80 80h400c17.7 0 32-14.3 32-32s-14.3-32-32-32H80c-8.8 0-16-7.2-16-16V64zm406.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L320 210.7l-57.4-57.4c-12.5-12.5-32.8-12.5-45.3 0l-112 112c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l89.4-89.3 57.4 57.4c12.5 12.5 32.8 12.5 45.3 0l128-128z"
        }
    ]
};

const FasChartMixedUpCircleCurrency = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasChartMixedUpCircleCurrency",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M400 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h28.8l-109.4 87.5-108.2-81.1c-11.7-8.8-27.8-8.5-39.2.6L12 199c-13.8 11-16 31.2-5 45s31.2 16 45 5l140.6-112.5 108.2 81.1c11.7 8.8 27.8 8.5 39.2-.6l140-112v39c0 17.7 14.3 32 32 32s32-14.3 32-32V32c0-17.7-14.3-32-32-32H400zM192 224c-17.7 0-32 14.3-32 32v192c0 17.7 14.3 32 32 32s32-14.3 32-32V256c0-17.7-14.3-32-32-32zM64 320c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32s32-14.3 32-32v-96c0-17.7-14.3-32-32-32zm368 192a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm25.4-169.4a35.9 35.9 0 1 0-50.7 50.7 35.9 35.9 0 1 0 50.7-50.7zM396.7 426l-17.3 17.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l17.2-17.4c-13.2-21.6-13.2-49.1 0-70.7l-17.3-17.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l17.4 17.3c21.6-13.2 49.1-13.2 70.7 0l17.3-17.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L490 332.7c13.2 21.6 13.2 49.1 0 70.7l17.3 17.3c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L467.3 426c-21.6 13.2-49.1 13.2-70.7 0z"
        }
    ]
};

const FasChartMixedUpCircleDollar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasChartMixedUpCircleDollar",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M400 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h28.8l-109.4 87.5-108.2-81.1c-11.7-8.8-27.8-8.5-39.2.6L12 199c-13.8 11-16 31.2-5 45s31.2 16 45 5l140.6-112.5 108.2 81.1c11.7 8.8 27.8 8.5 39.2-.6l140-112v39c0 17.7 14.3 32 32 32s32-14.3 32-32V32c0-17.7-14.3-32-32-32H400zM192 224c-17.7 0-32 14.3-32 32v192c0 17.7 14.3 32 32 32s32-14.3 32-32V256c0-17.7-14.3-32-32-32zM64 320c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32s32-14.3 32-32v-96c0-17.7-14.3-32-32-32zm368 192a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm-23.9-173v.1c0 .4 0 1.9 4.8 4.5 5.6 3 13.5 5.2 23.9 8.2h.2c9.3 2.6 21.1 6 30.5 11.5 10.2 6 20 16.1 20.5 32.3.5 18.2-9.7 30.4-21.7 36.9-5.8 3.1-12.1 5.1-18.3 6.2v10.8c0 8.8-7.2 16-16 16s-16-7.2-16-16v-11.4c-8.6-1.7-16.7-4.3-23.7-6.6-1.7-.6-3.4-1.1-5-1.6-8.4-2.6-13.2-11.6-10.5-20s11.6-13.2 20-10.5c2 .6 3.9 1.2 5.8 1.8 11.4 3.6 20.4 6.5 29.9 6.8 6.7.2 13.8-1.1 18.5-3.6 2.2-1.2 3.4-2.4 4-3.3.5-.8 1.1-2.1 1-4.5 0-1.4-.2-3-4.7-5.6-5.3-3.1-12.9-5.4-23.2-8.3l-1.8-.5c-8.9-2.5-19.8-5.6-28.6-10.3-9.9-5.3-20.6-14.7-21.6-30.7-1.2-18.8 10-30.9 21.8-37.2 5.7-3.1 12-5.1 18-6.3V288c0-8.8 7.2-16 16-16s16 7.2 16 16v9.4c6.3.9 12.3 2.3 17.9 3.7 8.6 2.1 13.8 10.8 11.7 19.4s-10.8 13.8-19.4 11.7c-9.3-2.3-18.2-4-26.4-4.1-6.2-.1-13.6 1.3-18.7 4-2.4 1.3-3.6 2.5-4.2 3.4-.4.7-.9 1.6-.8 3.6z"
        }
    ]
};

const FasChartMixed = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasChartMixed",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M500 89c13.8-11 16-31.2 5-45s-31.2-16-45-5L319.4 151.5 211.2 70.4c-11.7-8.8-27.8-8.5-39.2.6L12 199c-13.8 11-16 31.2-5 45s31.2 16 45 5l140.6-112.5 108.2 81.1c11.7 8.8 27.8 8.5 39.2-.6L500 89zM160 256v192c0 17.7 14.3 32 32 32s32-14.3 32-32V256c0-17.7-14.3-32-32-32s-32 14.3-32 32zM32 352v96c0 17.7 14.3 32 32 32s32-14.3 32-32v-96c0-17.7-14.3-32-32-32s-32 14.3-32 32zm288-64c-17.7 0-32 14.3-32 32v128c0 17.7 14.3 32 32 32s32-14.3 32-32V320c0-17.7-14.3-32-32-32zm96-32v192c0 17.7 14.3 32 32 32s32-14.3 32-32V256c0-17.7-14.3-32-32-32s-32 14.3-32 32z"
        }
    ]
};

const FasChartNetwork = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasChartNetwork",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 64c0 13.7-4.3 26.3-11.6 36.7l29.2 62.5c9.8-2.1 20-3.2 30.4-3.2 36.1 0 69 13.3 94.3 35.2l82.1-60.2c-.2-2.3-.4-4.6-.4-7 0-35.3 28.7-64 64-64s64 28.7 64 64-28.7 64-64 64c-9.2 0-17.9-1.9-25.8-5.4l-82 60.2c7.6 17.5 11.8 36.9 11.8 57.2 0 15.6-2.5 30.7-7.1 44.8l72 43.2c9.2-5.1 19.8-8 31.1-8 35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64v-1.1l-72.1-43.3C413.7 431 376.8 448 336 448c-68.5 0-125.9-47.9-140.4-112h-76.2c-11.1 19.1-31.7 32-55.4 32-35.3 0-64-28.7-64-64s28.7-64 64-64c23.7 0 44.4 12.9 55.4 32h76.1c7.5-33 26.3-61.6 52.1-81.7l-29.2-62.5C185.7 124.9 160 97.5 160 64c0-35.3 28.7-64 64-64s64 28.7 64 64zm48 288a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
        }
    ]
};

const FasChartPieSimpleCircleCurrency = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasChartPieSimpleCircleCurrency",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M496 192c4.6 0 9.3.2 13.8.5C494.5 83.7 401 0 288 0c-9 0-16 7.6-16 16.6V240h103.2c31.5-29.8 74-48 120.8-48zM320 368c0-28.8 6.9-56 19.2-80H224V66.7c0-18.5-15.7-33.3-33.8-29.5C81.5 60.1 0 156.5 0 272c0 132.6 107.5 240 240 240 43.8 0 84.8-11.7 120.1-32.2C335 449.4 320 410.5 320 368zm320 0a144 144 0 1 0-288 0 144 144 0 1 0 288 0zm-118.6 25.4a35.9 35.9 0 1 0-50.7-50.7 35.9 35.9 0 1 0 50.7 50.7zm10 32.6c-21.6 13.2-49.1 13.2-70.7 0l-17.3 17.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l17.2-17.4c-13.2-21.6-13.2-49.1 0-70.7l-17.3-17.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l17.4 17.3c21.6-13.2 49.1-13.2 70.7 0l17.3-17.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L554 332.7c13.2 21.6 13.2 49.1 0 70.7l17.3 17.3c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L531.3 426z"
        }
    ]
};

const FasChartPieSimpleCircleDollar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasChartPieSimpleCircleDollar",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M496 192c4.6 0 9.3.2 13.8.5C494.5 83.7 401 0 288 0c-9 0-16 7.6-16 16.6V240h103.2c31.5-29.8 74-48 120.8-48zM320 368c0-28.8 6.9-56 19.2-80H224V66.7c0-18.5-15.7-33.3-33.8-29.5C81.5 60.1 0 156.5 0 272c0 132.6 107.5 240 240 240 43.8 0 84.8-11.7 120.1-32.2C335 449.4 320 410.5 320 368zm320 0a144 144 0 1 0-288 0 144 144 0 1 0 288 0zm-167.2-32.6c-.4.7-.9 1.6-.8 3.6v.1c0 .4 0 1.9 4.8 4.5 5.6 3 13.5 5.2 23.9 8.2h.2c9.3 2.6 21.1 6 30.5 11.5 10.2 6 20 16.1 20.5 32.3.5 18.2-9.7 30.4-21.7 36.9-5.8 3.1-12.1 5.1-18.3 6.2v10.8c0 8.8-7.2 16-16 16s-16-7.2-16-16v-11.4c-8.6-1.7-16.7-4.3-23.7-6.6-1.7-.6-3.4-1.1-5-1.6-8.4-2.6-13.2-11.6-10.5-20s11.6-13.2 20-10.5c2 .6 3.9 1.2 5.8 1.8 11.4 3.6 20.4 6.5 29.9 6.8 6.7.2 13.8-1.1 18.5-3.6 2.2-1.2 3.4-2.4 4-3.3.5-.8 1.1-2.1 1-4.5 0-1.4-.2-3-4.7-5.6-5.3-3.1-12.9-5.4-23.2-8.3l-1.8-.5c-8.9-2.5-19.8-5.6-28.6-10.3-9.9-5.3-20.6-14.7-21.6-30.7-1.2-18.8 10-30.9 21.8-37.2 5.7-3.1 12-5.1 18-6.3V288c0-8.8 7.2-16 16-16s16 7.2 16 16v9.4c6.3.9 12.3 2.3 17.9 3.7 8.6 2.1 13.8 10.8 11.7 19.4s-10.8 13.8-19.4 11.7c-9.3-2.3-18.2-4-26.4-4.1-6.2-.1-13.6 1.3-18.7 4-2.4 1.3-3.6 2.5-4.2 3.4z"
        }
    ]
};

const FasChartPieSimple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasChartPieSimple",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M495.4 240H272V16.6c0-9 7-16.6 16-16.6 123.7 0 224 100.3 224 224 0 9-7.6 16-16.6 16zM190.2 37.2c18.1-3.8 33.8 11 33.8 29.5V288h221.3c18.5 0 33.3 15.7 29.5 33.8C451.9 430.5 355.5 512 240 512 107.5 512 0 404.6 0 272 0 156.5 81.5 60.1 190.2 37.2z"
        }
    ]
};

const FasChartPie = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasChartPie",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M304 240V16.6c0-9 7-16.6 16-16.6 123.7 0 224 100.3 224 224 0 9-7.6 16-16.6 16H304zM32 272c0-121.3 90.1-221.7 207-237.7 9.2-1.3 17 6.1 17 15.4V288l156.5 156.5c6.7 6.7 6.2 17.7-1.5 23.1-39.2 28-87.2 44.4-139 44.4-132.5 0-240-107.4-240-240zm526.4 16c9.3 0 16.6 7.8 15.4 17-7.7 55.9-34.6 105.6-73.9 142.3-6 5.6-15.4 5.2-21.2-.7L320 288h238.4z"
        }
    ]
};

const FasChartPyramid = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasChartPyramid",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M290.6 59.7c-15.4-26.5-53.7-26.5-69.1 0L163 160h186L290.6 59.7zM69.6 320h372.8l-74.7-128H144.3L69.6 320zM51 352l-39.6 67.8C-4.2 446.5 15.1 480 45.9 480h420.2c30.9 0 50.1-33.5 34.6-60.2L461 352H51z"
        }
    ]
};

const FasChartRadar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasChartRadar",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M72.5 252c-1.4 2.5-1.4 5.5 0 8l88.3 152.9c1.4 2.5 4.1 4 6.9 4h176.6c2.9 0 5.5-1.5 6.9-4L439.5 260l48.7 28.1-48.7-28.1c1.4-2.5 1.4-5.5 0-8L351.2 99.1c-1.4-2.5-4.1-4-6.9-4H167.7c-2.9 0-5.5 1.5-6.9 4L72.5 252zm-55.4 40a71.814 71.814 0 0 1 0-72l88.3-152.9c12.9-22.3 36.6-36 62.4-36h176.5a72.1 72.1 0 0 1 62.4 36L494.9 220c12.9 22.3 12.9 49.7 0 72l-88.3 152.9c-12.9 22.3-36.6 36-62.4 36H167.7a72.1 72.1 0 0 1-62.4-36L17.1 292zm273.1-111.2 40.2 100.6C347.5 286 360 301.5 360 320c0 22.1-17.9 40-40 40-15.9 0-29.7-9.3-36.1-22.7l-97.2-19.4c-7.1 6.3-16.4 10.2-26.7 10.2-22.1 0-40-17.9-40-40s17.9-40 40-40l57.6-76.8c-1-3.6-1.6-7.3-1.6-11.2 0-22.1 17.9-40 40-40s40 17.9 40 40c0 7.6-2.1 14.7-5.8 20.8zM202 271.9l79.2 15.8-31.7-79.2-47.5 63.4z"
        }
    ]
};

const FasChartScatter3d = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasChartScatter3d",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm256-32c0-17.7-14.3-32-32-32s-32 14.3-32 32v209L43.5 423.4c-13.6 11.3-15.4 31.5-4.1 45.1s31.5 15.4 45.1 4.1L256 329.7l171.5 142.9c13.6 11.3 33.8 9.5 45.1-4.1s9.5-33.8-4.1-45.1L288 273V64zm96 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32 160a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm64-64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-320-32a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm-96 96a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm192 224a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FasChartScatterBubble = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasChartScatterBubble",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 32c17.7 0 32 14.3 32 32v336c0 8.8 7.2 16 16 16h400c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-44.2 0-80-35.8-80-80V64c0-17.7 14.3-32 32-32zm96 272a48 48 0 1 1 96 0 48 48 0 1 1-96 0zm224-80a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm-160-48a48 48 0 1 1 96 0 48 48 0 1 1-96 0zM384 64a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"
        }
    ]
};

const FasChartScatter = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasChartScatter",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64v336c0 44.2 35.8 80 80 80h400c17.7 0 32-14.3 32-32s-14.3-32-32-32H80c-8.8 0-16-7.2-16-16V64zm128 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128 64a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm64 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm64-224a32 32 0 1 0-64 0 32 32 0 1 0 64 0zM160 352a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FasChartSimpleHorizontal = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasChartSimpleHorizontal",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M400 320c26.5 0 48-21.5 48-48v-32c0-26.5-21.5-48-48-48H48c-26.5 0-48 21.5-48 48v32c0 26.5 21.5 48 48 48h352zM208 480c26.5 0 48-21.5 48-48v-32c0-26.5-21.5-48-48-48H48c-26.5 0-48 21.5-48 48v32c0 26.5 21.5 48 48 48h160zm176-368V80c0-26.5-21.5-48-48-48H48C21.5 32 0 53.5 0 80v32c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48z"
        }
    ]
};

const FasChartSimple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasChartSimple",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 80c0-26.5 21.5-48 48-48h32c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48h-32c-26.5 0-48-21.5-48-48V80zM0 272c0-26.5 21.5-48 48-48h32c26.5 0 48 21.5 48 48v160c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V272zM368 96h32c26.5 0 48 21.5 48 48v288c0 26.5-21.5 48-48 48h-32c-26.5 0-48-21.5-48-48V144c0-26.5 21.5-48 48-48z"
        }
    ]
};

const FasChartTreeMap = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasChartTreeMap",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 80c0-26.5 21.5-48 48-48h128c26.5 0 48 21.5 48 48v112c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80zm0 240c0-26.5 21.5-48 48-48h128c26.5 0 48 21.5 48 48v112c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V320zM304 32h160c26.5 0 48 21.5 48 48v32c0 26.5-21.5 48-48 48H304c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48zm-48 208c0-26.5 21.5-48 48-48h160c26.5 0 48 21.5 48 48v32c0 26.5-21.5 48-48 48H304c-26.5 0-48-21.5-48-48v-32zm48 112h160c26.5 0 48 21.5 48 48v32c0 26.5-21.5 48-48 48H304c-26.5 0-48-21.5-48-48v-32c0-26.5 21.5-48 48-48z"
        }
    ]
};

const FasChartUser = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasChartUser",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 64c0-35.3 28.7-64 64-64h352c35.3 0 64 28.7 64 64v288c0 35.3-28.7 64-64 64H336.8c-11.8-25.5-29.9-47.5-52.4-64H576V64H224v49.1C205.2 102.2 183.3 96 160 96V64zm252.7 75.3c-4.6-4.6-5.9-11.5-3.5-17.4s8.3-9.9 14.8-9.9h88c8.8 0 16 7.2 16 16v88c0 6.5-3.9 12.3-9.9 14.8s-12.9 1.1-17.4-3.5l-27-27L401 273c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47 55.7-55.7-27-27zM64 224a96 96 0 1 1 192 0 96 96 0 1 1-192 0zM0 485.3C0 411.7 59.7 352 133.3 352h53.3c73.7 0 133.4 59.7 133.4 133.3 0 14.7-11.9 26.7-26.7 26.7H26.7C11.9 512 0 500.1 0 485.3z"
        }
    ]
};

const FasChartWaterfall = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasChartWaterfall",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 32c17.7 0 32 14.3 32 32v336c0 8.8 7.2 16 16 16h400c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-44.2 0-80-35.8-80-80V64c0-17.7 14.3-32 32-32zm128 192c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32v-64c0-17.7 14.3-32 32-32zm128-64v64c0 17.7-14.3 32-32 32s-32-14.3-32-32v-64c0-17.7 14.3-32 32-32s32 14.3 32 32zm64-96c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V96c0-17.7 14.3-32 32-32zm128 32v224c0 17.7-14.3 32-32 32s-32-14.3-32-32V96c0-17.7 14.3-32 32-32s32 14.3 32 32z"
        }
    ]
};

const FasCheckDouble = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCheckDouble",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M342.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 178.7l-57.4-57.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l80 80c12.5 12.5 32.8 12.5 45.3 0l160-160zm96 128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 402.7 54.6 297.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0l256-256z"
        }
    ]
};

const FasCheckToSlot = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCheckToSlot",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 80c0-26.5 21.5-48 48-48h288c26.5 0 48 21.5 48 48v304H96V80zm313 47c-9.4-9.4-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L409 161c9.4-9.4 9.4-24.6 0-33.9zM0 336c0-26.5 21.5-48 48-48h16v128h448V288h16c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48v-96z"
        }
    ]
};

const FasCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCheck",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7l233.4-233.3c12.5-12.5 32.8-12.5 45.3 0z"
        }
    ]
};

const FasCheeseSwiss = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCheeseSwiss",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M451 93c37.7 37.7 61 89.7 61 147.2V256H0c0-5.4.7-10.7 2.1-15.8 3.8-13.7 12.4-25.8 24.5-33.9L96 160l23.2-15.4c7.8-5.2 18.4-2.3 25.5 3.8 8.4 7.2 19.3 11.6 31.3 11.6 26.5 0 48-21.5 48-48 0-5.2-.8-10.2-2.3-14.9-2.9-9-1.6-19.9 6.3-25.1l47-31.3c8.6-5.7 18.6-8.7 28.9-8.7 56 0 106.8 22.1 144.2 58 1 1 2 2 3 2.9zm-19 195h80v128c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V288h304c8.8 0 15.7 7.4 18.6 15.7C329.1 322.5 347 336 368 336s38.9-13.5 45.4-32.3c2.9-8.4 9.8-15.7 18.6-15.7zm-208 96a48 48 0 1 0-96 0 48 48 0 1 0 96 0z"
        }
    ]
};

const FasCheese = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCheese",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 240.2V256H0c0-20 10-38.7 26.6-49.8L274.9 40.7c8.6-5.7 18.6-8.7 28.9-8.7 115 0 208.2 93.2 208.2 208.2zm0 47.8v128c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V288h512z"
        }
    ]
};

const FasCherries = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCherries",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m288 24 14.1-19.5c-6.9-5-15.9-5.9-23.7-2.5s-13.2 10.7-14.2 19.1v.2l-.1.9c-.1.9-.3 2.2-.6 4-.6 3.6-1.5 9-2.9 15.8-2.8 13.7-7.6 33.3-15.3 56.3-14 42-37.4 94.7-75.8 143.7-17.2-8.5-43-18-73.5-18 0 0-96 0-96 112 0 144 144 176 192 176s192-16 192-176c0-112-96-112-96-112-20.5 0-38.9 4.3-54 9.7 27.1-42.6 45-85.1 56.7-120.2 5.7-17 9.9-32.3 13-45.1 11.7 10.8 25.8 24.7 40.1 41.2 29.6 34.3 59.1 78.4 73.1 128.5-12-5.3-27-10.3-44.2-12.7C397.3 247.7 416 282.9 416 336c0 71.9-26.1 120.9-62.1 152.9 36.5 17.4 73.8 23.1 94.1 23.1 48 0 192-16 192-176 0-112-96-112-96-112-32.3 0-59.2 10.6-76.3 19.6-14.2-67.6-52.5-124.7-87.5-165.3-19.9-23-39.2-41.3-53.6-53.9-7.2-6.3-13.2-11.2-17.5-14.5-2.1-1.7-3.8-3-5-3.9-.6-.4-1.1-.8-1.4-1l-.4-.3-.1-.1L288.1 24z"
        }
    ]
};

const FasChessBishopPiece = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasChessBishopPiece",
    "viewBox": "0 0 256 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M104 32c-13.3 0-24 10.7-24 24 0 12.2 9.1 22.3 20.9 23.8C79.6 100.1 48 139 48 192c0 26.3 13.6 40.5 26.3 48H72c-13.3 0-24 10.7-24 24s10.7 24 24 24h5.7L64 384h128l-13.7-96h5.7c13.3 0 24-10.7 24-24s-10.7-24-24-24h-2.3c12.7-7.5 26.3-21.7 26.3-48 0-22.5-5.7-42.4-13.9-59.5l-38.8 38.8c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l44.3-44.3c-7.4-10-15.2-18.2-21.9-24.6C166.9 78.3 176 68.2 176 56c0-13.3-10.7-24-24-24h-48zM48 416 4.8 473.6C1.7 477.8 0 482.8 0 488c0 13.3 10.7 24 24 24h208c13.3 0 24-10.7 24-24 0-5.2-1.7-10.2-4.8-14.4L208 416H48z"
        }
    ]
};

const FasChessBishop = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasChessBishop",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 0c-17.7 0-32 14.3-32 32 0 16.1 11.9 29.4 27.4 31.7C78.4 106.8 8 190 8 288c0 47.4 30.8 72.3 56 84.7V400h192v-27.3c25.2-12.5 56-37.4 56-84.7 0-37.3-10.2-72.4-25.3-104.1l-99.4 99.4c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l106.1-106.1c-23.2-38.1-51.8-69.5-74.2-90.9C212.1 61.4 224 48.1 224 32c0-17.7-14.3-32-32-32h-64zM48 432 6.6 473.4c-4.2 4.2-6.6 10-6.6 16C0 501.9 10.1 512 22.6 512h274.8c12.5 0 22.6-10.1 22.6-22.6 0-6-2.4-11.8-6.6-16L272 432H48z"
        }
    ]
};

const FasChessBoard = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasChessBoard",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm64 64v64h64V96h64v64h64V96h64v64h-64v64h64v64h-64v64h64v64h-64v-64h-64v64h-64v-64h-64v64H64v-64h64v-64H64v-64h64v-64H64V96h64zm64 128h64v-64h-64v64zm0 64v-64h-64v64h64zm64 0h-64v64h64v-64zm0 0h64v-64h-64v64z"
        }
    ]
};

const FasChessClockFlip = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasChessClockFlip",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 56c0-13.3 10.7-24 24-24h112c13.3 0 24 10.7 24 24s-10.7 24-24 24h-32v48h88c35.3 0 64 28.7 64 64v224c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192c0-35.3 28.7-64 64-64h32v-16c0-8.8 7.2-16 16-16h128c8.8 0 16 7.2 16 16v16h184V80h-32c-13.3 0-24-10.7-24-24zm-96 248a112 112 0 1 0-224 0 112 112 0 1 0 224 0zm-52.7-59.3c6.2 6.2 6.2 16.4 0 22.6l-48 48c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l48-48c6.2-6.2 16.4-6.2 22.6 0zM464 416a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm16-176v64c0 8.8-7.2 16-16 16s-16-7.2-16-16v-64c0-8.8 7.2-16 16-16s16 7.2 16 16z"
        }
    ]
};

const FasChessClock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasChessClock",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 56c0-13.3-10.7-24-24-24H120c-13.3 0-24 10.7-24 24s10.7 24 24 24h32v48H64c-35.3 0-64 28.7-64 64v224c0 35.3 28.7 64 64 64h512c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64h-32v-16c0-8.8-7.2-16-16-16H400c-8.8 0-16 7.2-16 16v16H200V80h32c13.3 0 24-10.7 24-24zm320 248a112 112 0 1 1-224 0 112 112 0 1 1 224 0zm-52.7-59.3c-6.2-6.2-16.4-6.2-22.6 0l-48 48c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l48-48c6.2-6.2 6.2-16.4 0-22.6zM176 192a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm-16 48v64c0 8.8 7.2 16 16 16s16-7.2 16-16v-64c0-8.8-7.2-16-16-16s-16 7.2-16 16z"
        }
    ]
};

const FasChessKingPiece = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasChessKingPiece",
    "viewBox": "0 0 256 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v16H96c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v32H60.2C49.1 96 40 105.1 40 116.2c0 2.5.5 4.9 1.3 7.3L73.8 208H72c-13.3 0-24 10.7-24 24s10.7 24 24 24h4L60 384h136l-16-128h4c13.3 0 24-10.7 24-24s-10.7-24-24-24h-1.8l32.5-84.5c.9-2.3 1.3-4.8 1.3-7.3 0-11.2-9.1-20.2-20.2-20.2H144V64h16c8.8 0 16-7.2 16-16s-7.2-16-16-16h-16V16zM48 416 4.8 473.6C1.7 477.8 0 482.8 0 488c0 13.3 10.7 24 24 24h208c13.3 0 24-10.7 24-24 0-5.2-1.7-10.2-4.8-14.4L208 416H48z"
        }
    ]
};

const FasChessKing = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasChessKing",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 0c17.7 0 32 14.3 32 32v16h16c17.7 0 32 14.3 32 32s-14.3 32-32 32h-16v48h152c22.1 0 40 17.9 40 40 0 5.3-1 10.5-3.1 15.4L368 400H80L3.1 215.4C1 210.5 0 205.3 0 200c0-22.1 17.9-40 40-40h152v-48h-16c-17.7 0-32-14.3-32-32s14.3-32 32-32h16V32c0-17.7 14.3-32 32-32zM38.6 473.4 80 432h288l41.4 41.4c4.2 4.2 6.6 10 6.6 16 0 12.5-10.1 22.6-22.6 22.6H54.6C42.1 512 32 501.9 32 489.4c0-6 2.4-11.8 6.6-16z"
        }
    ]
};

const FasChessKnightPiece = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasChessKnightPiece",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m57.6 102.4-6.9 6.9c-12 12-18.7 28.3-18.7 45.3v81.2c0 10.7 5.3 20.7 14.2 26.6l3.5 2.4c12.7 8.5 29.1 9.5 42.8 2.7 2.3-1.1 4.5-2.5 6.5-4l38.8-29.1c5.5-4.1 13.1-4.1 18.6 0 8.2 6.1 8.3 18.4.2 24.7L81 317c-20.8 16-33 40.7-33 67h224l26.9-107.6c3.4-13.6 5.1-27.5 5.1-41.5 0-94.4-76.5-171-171-171H47.8C39.1 64 32 71.1 32 79.8c0 6 3.4 11.5 8.7 14.2l16.9 8.4zm19.2 54.4a16 16 0 1 1 32 0 16 16 0 1 1-32 0zM48 416 4.8 473.6C1.7 477.8 0 482.8 0 488c0 13.3 10.7 24 24 24h272c13.3 0 24-10.7 24-24 0-5.2-1.7-10.2-4.8-14.4L272 416H48z"
        }
    ]
};

const FasChessKnight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasChessKnight",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 48 82.7 61.3c-12 12-18.7 28.2-18.7 45.2v132.4c0 10.7 5.3 20.7 14.2 26.6l10.6 7c14.3 9.6 32.7 10.7 48.1 3l3.2-1.6c2.6-1.3 5-2.8 7.3-4.5l49.4-37c6.6-5 15.7-5 22.3 0 10.2 7.7 9.9 23.1-.7 30.3L90.4 350C73.9 361.3 64 380 64 400h320l28.9-159c2.1-11.3 3.1-22.8 3.1-34.3V192C416 86 330 0 224 0H83.8C72.9 0 64 8.9 64 19.8c0 7.5 4.2 14.3 10.9 17.7L96 48zm24 68a20 20 0 1 1 40 0 20 20 0 1 1-40 0zM22.6 473.4c-4.2 4.2-6.6 10-6.6 16 0 12.5 10.1 22.6 22.6 22.6h370.8c12.5 0 22.6-10.1 22.6-22.6 0-6-2.4-11.8-6.6-16L384 432H64l-41.4 41.4z"
        }
    ]
};

const FasChessPawnPiece = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasChessPawnPiece",
    "viewBox": "0 0 256 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 240c19.4-14.6 32-37.8 32-64 0-44.2-35.8-80-80-80s-80 35.8-80 80c0 26.2 12.6 49.4 32 64h-8c-13.3 0-24 10.7-24 24s10.7 24 24 24h5.7L64 384h128l-13.7-96h5.7c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8zM4.8 473.6C1.7 477.8 0 482.8 0 488c0 13.3 10.7 24 24 24h208c13.3 0 24-10.7 24-24 0-5.2-1.7-10.2-4.8-14.4L208 416H48L4.8 473.6z"
        }
    ]
};

const FasChessPawn = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasChessPawn",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M215.5 224c29.2-18.4 48.5-50.9 48.5-88 0-57.4-46.6-104-104-104S56 78.6 56 136c0 37.1 19.4 69.6 48.5 88H96c-17.7 0-32 14.3-32 32 0 16.5 12.5 30 28.5 31.8L80 400h160l-12.5-112.2c16-1.8 28.5-15.3 28.5-31.8 0-17.7-14.3-32-32-32h-8.5zM22.6 473.4c-4.2 4.2-6.6 10-6.6 16 0 12.5 10.1 22.6 22.6 22.6h242.8c12.5 0 22.6-10.1 22.6-22.6 0-6-2.4-11.8-6.6-16L256 432H64l-41.4 41.4z"
        }
    ]
};

const FasChessQueenPiece = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasChessQueenPiece",
    "viewBox": "0 0 256 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M104 24a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm125.9 100.9-41.5 67.5c11.2 2.1 19.6 11.8 19.6 23.6 0 13.3-10.7 24-24 24h-8l19.6 144H60.4L80 240h-8c-13.3 0-24-10.7-24-24 0-11.8 8.5-21.5 19.6-23.6l-41.5-67.5c-3.7-6-3-13.6 1.6-18.9s12.1-6.9 18.6-4.1c3 1.3 6.3 2.1 9.8 2.1 11.8 0 21.6-8.5 23.6-19.7 1.1-6.3 6-11.4 12.3-12.8s12.8 1.1 16.5 6.4C112.8 84 119.9 88 128 88s15.2-4 19.6-10.1c3.7-5.3 10.2-7.8 16.5-6.4s11.1 6.4 12.3 12.8c2 11.2 11.8 19.7 23.6 19.7 3.5 0 6.8-.7 9.8-2.1 6.4-2.9 13.9-1.2 18.6 4.1s5.3 13 1.6 18.9zM208 416l43.2 57.6c3.1 4.2 4.8 9.2 4.8 14.4 0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24 0-5.2 1.7-10.2 4.8-14.4L48 416h160z"
        }
    ]
};

const FasChessQueen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasChessQueen",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 0a56 56 0 1 1 0 112 56 56 0 1 1 0-112zM134.1 143.8c3.3-13 15-23.8 30.2-23.8 12.3 0 22.6 7.2 27.7 17 12 23.2 36.2 39 64 39s52-15.8 64-39c5.1-9.8 15.4-17 27.7-17 15.3 0 27 10.8 30.2 23.8 7 27.8 32.2 48.3 62.1 48.3 10.8 0 21-2.7 29.8-7.4 8.4-4.4 18.9-4.5 27.6.9 13 8 17.1 25 9.2 38L399.7 400H112.3L5.4 223.6c-7.9-13-3.8-30 9.2-38 8.7-5.3 19.2-5.3 27.6-.9 8.9 4.7 19 7.4 29.8 7.4 29.9 0 55.1-20.5 62.1-48.3zM256 224zM112 432h288l41.4 41.4c4.2 4.2 6.6 10 6.6 16 0 12.5-10.1 22.6-22.6 22.6H86.6C74.1 512 64 501.9 64 489.4c0-6 2.4-11.8 6.6-16L112 432z"
        }
    ]
};

const FasChessRookPiece = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasChessRookPiece",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M67.4 384 80 264l-30.6-30.6c-6-6-9.4-14.1-9.4-22.6V112c0-8.8 7.2-16 16-16h24c8.8 0 16 7.2 16 16v24c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-24c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v24c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-24c0-8.8 7.2-16 16-16h24c8.8 0 16 7.2 16 16v98.7c0 8.5-3.4 16.6-9.4 22.6L240 264l12.6 120H67.4zM136 280.9c0 3.9 3.2 7.1 7.1 7.1h33.8c3.9 0 7.1-3.2 7.1-7.1V248c0-13.3-10.7-24-24-24s-24 10.7-24 24v32.9zM20.8 473.6 64 416h192l43.2 57.6c3.1 4.2 4.8 9.2 4.8 14.4 0 13.3-10.7 24-24 24H40c-13.3 0-24-10.7-24-24 0-5.2 1.7-10.2 4.8-14.4z"
        }
    ]
};

const FasChessRook = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasChessRook",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 192V48c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16v40c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V48c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16v40c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V48c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16v144c0 10.1-4.7 19.6-12.8 25.6L352 256l16 144H80l16-144-51.2-38.4c-8.1-6-12.8-15.5-12.8-25.6zm176 96h32c8.8 0 16-7.2 16-16v-48c0-17.7-14.3-32-32-32s-32 14.3-32 32v48c0 8.8 7.2 16 16 16zM22.6 473.4 64 432h320l41.4 41.4c4.2 4.2 6.6 10 6.6 16 0 12.5-10.1 22.6-22.6 22.6H38.6C26.1 512 16 501.9 16 489.4c0-6 2.4-11.8 6.6-16z"
        }
    ]
};

const FasChess = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasChess",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v16H96c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v32H60.2C49.1 96 40 105.1 40 116.2c0 2.5.5 4.9 1.3 7.3L73.8 208H72c-13.3 0-24 10.7-24 24s10.7 24 24 24h4L60 384h136l-16-128h4c13.3 0 24-10.7 24-24s-10.7-24-24-24h-1.8l32.5-84.5c.9-2.3 1.3-4.8 1.3-7.3 0-11.2-9.1-20.2-20.2-20.2H144V64h16c8.8 0 16-7.2 16-16s-7.2-16-16-16h-16V16zM48 416 4.8 473.6C1.7 477.8 0 482.8 0 488c0 13.3 10.7 24 24 24h208c13.3 0 24-10.7 24-24 0-5.2-1.7-10.2-4.8-14.4L208 416H48zm288 0-43.2 57.6c-3.1 4.2-4.8 9.2-4.8 14.4 0 13.3 10.7 24 24 24h176c13.3 0 24-10.7 24-24 0-5.2-1.7-10.2-4.8-14.4L464 416H336zm-32-208v51.9c0 7.8 2.8 15.3 8 21.1l27.2 31-2.2 72h125.5l-3.3-72 28.3-30.8c5.4-5.9 8.5-13.6 8.5-21.7V208c0-8.8-7.2-16-16-16h-16c-8.8 0-16 7.2-16 16v16h-24v-16c0-8.8-7.2-16-16-16h-16c-8.8 0-16 7.2-16 16v16h-24v-16c0-8.8-7.2-16-16-16h-16c-8.8 0-16 7.2-16 16zm80 96c0-8.8 7.2-16 16-16s16 7.2 16 16v32h-32v-32z"
        }
    ]
};

const FasChestnut = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasChestnut",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 32c5.3 0 10.3 2.7 13.3 7.1 2.9 4.3 7.9 9.7 15.5 16.6 7.5 6.8 16.7 14.3 27.2 22.8l3.1 2.5c20.3 16.4 44.7 36.1 68.2 59.6C400.8 190.2 448 258 448 352H0c0-94 47.2-161.8 96.7-211.3 23.5-23.5 47.9-43.2 68.2-59.6l3.1-2.5c10.6-8.5 19.7-16 27.2-22.8 7.6-6.9 12.7-12.3 15.5-16.6 3-4.5 8-7.1 13.3-7.1zM4 384h440c-14.2 55.2-64.3 96-124 96H128c-59.6 0-109.8-40.8-124-96z"
        }
    ]
};

const FasChevronDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasChevronDown",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"
        }
    ]
};

const FasChevronLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasChevronLeft",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"
        }
    ]
};

const FasChevronRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasChevronRight",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"
        }
    ]
};

const FasChevronUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasChevronUp",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M233.4 105.4c12.5-12.5 32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 173.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192z"
        }
    ]
};

const FasChevronsDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasChevronsDown",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M278.6 470.6c-12.5 12.5-32.8 12.5-45.3 0l-192-192c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L256 402.7l169.4-169.3c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-192 192zm192-384-192 192c-12.5 12.5-32.8 12.5-45.3 0l-192-192c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L256 210.7 425.4 41.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3z"
        }
    ]
};

const FasChevronsLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasChevronsLeft",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256 278.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192zm384-192-192 192c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L301.3 256 470.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0z"
        }
    ]
};

const FasChevronsRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasChevronsRight",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M470.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-192-192c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 256 233.4 425.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l192-192zm-384 192 192-192c12.5-12.5 12.5-32.8 0-45.3l-192-192c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L210.7 256 41.4 425.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0z"
        }
    ]
};

const FasChevronsUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasChevronsUp",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M278.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-192 192c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L256 109.3l169.4 169.3c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-192-192zm192 384-192-192c-12.5-12.5-32.8-12.5-45.3 0l-192 192c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L256 301.3l169.4 169.3c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3z"
        }
    ]
};

const FasChfSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasChfSign",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 113.4C0 68.5 36.5 32 81.4 32c30.8 0 59 17.4 72.8 45l2.3 4.7c7.9 15.8 1.5 35-14.3 42.9s-35 1.5-42.9-14.3l-2.3-4.7c-3-5.9-9-9.6-15.6-9.6-9.6 0-17.4 7.8-17.4 17.4v285.2c0 9.6 7.8 17.4 17.4 17.4 6.6 0 12.6-3.7 15.6-9.6l2.3-4.7c7.9-15.8 27.1-22.2 42.9-14.3s22.2 27.1 14.3 42.9l-2.3 4.7c-13.8 27.6-42 45-72.8 45C36.5 480 0 443.5 0 398.6V113.4zM224 32c17.7 0 32 14.3 32 32v160h96V64c0-17.7 14.3-32 32-32s32 14.3 32 32v384c0 17.7-14.3 32-32 32s-32-14.3-32-32V288h-96v160c0 17.7-14.3 32-32 32s-32-14.3-32-32V64c0-17.7 14.3-32 32-32zm224 32c0-17.7 14.3-32 32-32h128c17.7 0 32 14.3 32 32s-14.3 32-32 32h-96v128h64c17.7 0 32 14.3 32 32s-14.3 32-32 32h-64v160c0 17.7-14.3 32-32 32s-32-14.3-32-32V64z"
        }
    ]
};

const FasChildCombatant = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasChildCombatant",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 128a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-8 352V352h16v128c0 17.7 14.3 32 32 32s32-14.3 32-32V300.5l12.9 20.5c9.4 15 29.2 19.4 44.1 10s19.4-29.2 10-44.1l-51.7-82.1c-17.6-27.9-48.3-44.9-81.2-44.9h-12.3c-33 0-63.7 16.9-81.2 44.9L36.9 287c-9.4 15-4.9 34.7 10 44.1s34.7 4.9 44.1-10l13-20.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32zM448 0h-32c-8.8 0-16 7.2-16 16s7.2 16 16 16v100.3c-9.6 5.5-16 15.9-16 27.7v32c-17.7 0-32 14.3-32 32v144c0 17.7 14.3 32 32 32h16v96c0 8.8 7.2 16 16 16h59.5c10.4 0 18-9.8 15.5-19.9L484 400h44c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16h-48v-26.7l53.1-17.7c6.5-2.2 10.9-8.3 10.9-15.2V208c0-8.8-7.2-16-16-16h-16c-8.8 0-16 7.2-16 16v56l-16 5.3V160c0-11.8-6.4-22.2-16-27.7V16c0-8.8-7.2-16-16-16z"
        }
    ]
};

const FasChildDress = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasChildDress",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 64a64 64 0 1 0-128 0 64 64 0 1 0 128 0zM88 400v80c0 17.7 14.3 32 32 32s32-14.3 32-32v-80h16v80c0 17.7 14.3 32 32 32s32-14.3 32-32v-80h17.8c10.9 0 18.6-10.7 15.2-21.1l-31.1-93.4 28.6 37.8c10.7 14.1 30.8 16.8 44.8 6.2s16.8-30.7 6.2-44.8L254.6 207c-22.4-29.6-57.5-47-94.6-47s-72.2 17.4-94.6 47L6.5 284.7c-10.7 14.1-7.9 34.2 6.2 44.8s34.2 7.9 44.8-6.2l28.7-37.8L55 378.9c-3.4 10.4 4.3 21.1 15.2 21.1H88z"
        }
    ]
};

const FasChildReaching = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasChildReaching",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 64a64 64 0 1 0-128 0 64 64 0 1 0 128 0zM152.9 169.3c-23.7-8.4-44.5-24.3-58.8-45.8L74.6 94.2C64.8 79.5 45 75.6 30.2 85.4s-18.7 29.7-8.9 44.4L40.9 159c18.1 27.1 42.8 48.4 71.1 62.4V480c0 17.7 14.3 32 32 32s32-14.3 32-32v-96h32v96c0 17.7 14.3 32 32 32s32-14.3 32-32V221.6c29.1-14.2 54.4-36.2 72.7-64.2l18.2-27.9c9.6-14.8 5.4-34.6-9.4-44.3s-34.6-5.5-44.3 9.4L291 122.4c-21.8 33.4-58.9 53.6-98.8 53.6-12.6 0-24.9-2-36.6-5.8-.9-.3-1.8-.7-2.7-.9z"
        }
    ]
};

const FasChild = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasChild",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 64a64 64 0 1 1 128 0 64 64 0 1 1-128 0zm48 320v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V287.8L59.1 321c-9.4 15-29.2 19.4-44.1 10s-19.5-29.1-10.1-44l39.9-63.3C69.7 184 113.2 160 160 160s90.3 24 115.2 63.6l39.9 63.4c9.4 15 4.9 34.7-10 44.1s-34.7 4.9-44.1-10l-21-33.3V480c0 17.7-14.3 32-32 32s-32-14.3-32-32v-96h-32z"
        }
    ]
};

const FasChildren = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasChildren",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 0a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM88 480v-80H70.2c-10.9 0-18.6-10.7-15.2-21.1l31.1-93.4-28.6 37.8c-10.7 14.1-30.8 16.8-44.8 6.2s-16.8-30.7-6.2-44.8L65.4 207c22.4-29.6 57.5-47 94.6-47s72.2 17.4 94.6 47l58.9 77.7c10.7 14.1 7.9 34.2-6.2 44.8s-34.2 7.9-44.8-6.2l-28.6-37.8 31.1 93.4c3.5 10.4-4.3 21.1-15.2 21.1H232v80c0 17.7-14.3 32-32 32s-32-14.3-32-32v-80h-16v80c0 17.7-14.3 32-32 32s-32-14.3-32-32zM480 0a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm-8 384v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V300.5L395.1 321c-9.4 15-29.2 19.4-44.1 10s-19.4-29.2-10-44.1l51.7-82.1c17.6-27.9 48.3-44.9 81.2-44.9h12.3c33 0 63.7 16.9 81.2 44.9l51.7 82.2c9.4 15 4.9 34.7-10 44.1s-34.7 4.9-44.1-10l-13-20.6V480c0 17.7-14.3 32-32 32s-32-14.3-32-32v-96h-16z"
        }
    ]
};

const FasChimney = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasChimney",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 64c0-17.7 14.3-32 32-32h384c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V64zm32 128h96v128H32V192zm384 0v128H160V192h256zM288 352v128H32V352h256zm128 0v128h-96V352h96z"
        }
    ]
};

const FasChopsticks = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasChopsticks",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M368 0c-15.3 0-29 7.2-37.7 18.3L3.4 486.1c-5.5 6.9-4.3 17 2.7 22.5s17 4.2 22.5-2.7L405.7 77.7C412.2 69.5 416 59.2 416 48c0-26.5-21.5-48-48-48zM131.9 506.4c5.8 6.7 15.9 7.5 22.6 1.7l468.7-359.7c10.3-8.8 16.8-21.9 16.8-36.4 0-26.5-21.5-48-48-48-11.9 0-22.8 4.4-31.2 11.6L133.6 483.9c-6.7 5.8-7.5 15.8-1.7 22.6z"
        }
    ]
};

const FasChurch = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasChurch",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M344 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v24h-32c-13.3 0-24 10.7-24 24s10.7 24 24 24h32v46.4L183.3 210c-14.5 8.7-23.3 24.3-23.3 41.2V512h96v-96c0-35.3 28.7-64 64-64s64 28.7 64 64v96h96V251.2c0-16.9-8.8-32.5-23.3-41.2L344 142.4V96h32c13.3 0 24-10.7 24-24s-10.7-24-24-24h-32V24zM24.9 330.3C9.5 338.8 0 354.9 0 372.4V464c0 26.5 21.5 48 48 48h80V273.6L24.9 330.3zM592 512c26.5 0 48-21.5 48-48v-91.6c0-17.5-9.5-33.6-24.9-42.1L512 273.6V512h80z"
        }
    ]
};

const FasCircle0 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircle0",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm0-384c53 0 96 43 96 96v64c0 53-43 96-96 96s-96-43-96-96v-64c0-53 43-96 96-96zm-48 96v64c0 26.5 21.5 48 48 48s48-21.5 48-48v-64c0-26.5-21.5-48-48-48s-48 21.5-48 48z"
        }
    ]
};

const FasCircle1 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircle1",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm268-124.8c-7.4-4.3-16.5-4.3-24-.1l-56 32c-11.5 6.6-15.5 21.2-8.9 32.7s21.2 15.5 32.7 8.9l20.2-11.3V336h-40c-13.3 0-24 10.7-24 24s10.7 24 24 24h128c13.3 0 24-10.7 24-24s-10.7-24-24-24h-40V152c0-8.6-4.6-16.5-12-20.8z"
        }
    ]
};

const FasCircle2 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircle2",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-33.3-327.3-24.2 18.4c-10.5 8-25.6 6-33.6-4.5s-6-25.6 4.5-33.6l24.2-18.4c15.8-12 35.2-18.4 55.1-18.1l3.4.1c46.5.7 83.8 38.6 83.8 85.1 0 23.5-9.7 46-26.9 62.1L244.7 336H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-9.8 0-18.7-6-22.3-15.2s-1.3-19.6 5.9-26.3l108.7-101.9c7.5-7 11.7-16.8 11.7-27.1 0-20.3-16.3-36.8-36.6-37.1l-3.4-.1c-9.1-.1-18 2.8-25.3 8.3z"
        }
    ]
};

const FasCircle3 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircle3",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-72-384h128c9.9 0 18.8 6.1 22.4 15.3s1.1 19.7-6.2 26.4l-50.8 46.5c41.9 4.8 74.6 40.4 74.6 83.6 0 46.5-37.7 84.2-84.2 84.2H240c-30.1 0-58.1-15.6-73.9-41.2l-2.6-4.2c-7-11.3-3.5-26.1 7.8-33s26.1-3.5 33 7.8l2.6 4.2a38.75 38.75 0 0 0 33 18.4h27.8c20 0 36.2-16.2 36.2-36.2 0-20.1-16.3-36.3-36.4-36.2l-51.5.3c-9.9.1-18.9-6-22.5-15.2s-1.2-19.8 6.1-26.5l50.7-46.2H184c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
        }
    ]
};

const FasCircle4 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircle4",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm223.6-126.8c-12.6-4.2-26.2 2.6-30.4 15.2l-48 144c-2.4 7.3-1.2 15.4 3.3 21.6s11.8 10 19.5 10h104v40c0 13.3 10.7 24 24 24s24-10.7 24-24v-40h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8v-56c0-13.3-10.7-24-24-24s-24 10.7-24 24v56h-70.7l37.5-112.4c4.2-12.6-2.6-26.2-15.2-30.4z"
        }
    ]
};

const FasCircle5 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircle5",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-48-384h104c13.3 0 24 10.7 24 24s-10.7 24-24 24h-84l-7.8 43 61.4 6.9c40.1 4.5 70.4 38.4 70.4 78.8 0 43.8-35.5 79.3-79.3 79.3h-36c-27.5 0-53.3-13.7-68.6-36.6l-4.1-6.1c-7.4-11-4.5-25.9 6.5-33.3s25.9-4.5 33.3 6.5l4.1 6.1c6.4 9.6 17.2 15.3 28.8 15.3h36c17.3 0 31.3-14 31.3-31.3 0-15.9-12-29.3-27.8-31.1l-86.9-9.8c-6.6-.7-12.6-4.2-16.6-9.5s-5.5-12.1-4.4-18.6l16-88c2.1-11.4 12-19.7 23.6-19.7z"
        }
    ]
};

const FasCircle6 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircle6",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm256-16a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm-96 48c0 53 43 96 96 96s96-43 96-96c0-44-29.6-81.1-70-92.4l29.6-25.4c10.1-8.6 11.2-23.8 2.6-33.8s-23.8-11.2-33.8-2.6l-81.6 70c-24.6 21-38.8 51.8-38.8 84.2z"
        }
    ]
};

const FasCircle7 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircle7",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-72-384h144c8.4 0 16.3 4.4 20.6 11.7s4.5 16.2.5 23.7l-112 208c-6.3 11.7-20.8 16-32.5 9.8s-16-20.8-9.8-32.5l93-172.6H184c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
        }
    ]
};

const FasCircle8 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircle8",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm264-128h-16c-39.8 0-72 32.2-72 72 0 15.7 5 30.1 13.5 42-18 14.7-29.5 37-29.5 62 0 44.2 35.8 80 80 80h32c44.2 0 80-35.8 80-80 0-25-11.5-47.4-29.5-62 8.5-11.8 13.5-26.3 13.5-42 0-39.8-32.2-72-72-72zm-16 96c-13.2 0-24-10.8-24-24s10.7-24 24-24h16c13.3 0 24 10.7 24 24s-10.7 24-24 24h-16zm16 48h8c17.7 0 32 14.3 32 32s-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32s14.3-32 32-32h24z"
        }
    ]
};

const FasCircle9 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircle9",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm256 16a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm-26 44.4-29.6 25.4c-10.1 8.6-11.2 23.8-2.6 33.8s23.8 11.2 33.8 2.6l81.6-70c24.6-21 38.8-51.8 38.8-84.2 0-53-43-96-96-96s-96 43-96 96c0 44 29.6 81.1 70 92.4z"
        }
    ]
};

const FasCircleA = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircleA",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm0-400c9.1 0 17.4 5.1 21.5 13.3l104 208c5.9 11.9 1.1 26.3-10.7 32.2s-26.3 1.1-32.2-10.7L321.2 320H190.8l-17.4 34.7c-5.9 11.9-20.3 16.7-32.2 10.7s-16.7-20.3-10.7-32.2l104-208c4.1-8.1 12.4-13.3 21.5-13.3zm0 77.7L214.8 272h82.3L256 189.7z"
        }
    ]
};

const FasCircleAmpersand = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircleAmpersand",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-40-320.4c0 4.1 1.6 8.1 4.6 11l14.4 14.5 23.6-17.3c3.4-2.5 5.4-6.4 5.4-10.6 0-7.3-5.9-13.2-13.2-13.2h-19.2c-8.6 0-15.6 7-15.6 15.6zm71 46.9-17.6 12.9 28.7 28.7 26.2-37.8c7.5-10.9 22.5-13.6 33.4-6.1s13.6 22.5 6.1 33.4l-31.1 45L361 343c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-22.4-22.4a79.997 79.997 0 0 1-62 29.4h-32.2c-36.7 0-66.5-29.8-66.5-66.5 0-21.2 10.1-41.1 27.2-53.6l24.7-18.1-9.2-9.2c-11.9-11.9-18.6-28.1-18.6-45 0-35.1 28.5-63.6 63.6-63.6h19.2c33.8 0 61.2 27.4 61.2 61.2 0 19.5-9.3 37.8-25 49.3zm-87.5 64.1c-4.7 3.5-7.5 9-7.5 14.9 0 10.2 8.3 18.5 18.5 18.5h32.2c10.5 0 20.3-5.2 26.3-13.8l1.4-2-40.1-40.1-30.7 22.5z"
        }
    ]
};

const FasCircleArrowDownLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircleArrowDownLeft",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 1 0-512 256 256 0 1 1 0 512zm64-144c13.3 0 24-10.7 24-24s-10.7-24-24-24h-94.1L361 185c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-135 135V184c0-13.3-10.7-24-24-24s-24 10.7-24 24v160c0 13.3 10.7 24 24 24H320z"
        }
    ]
};

const FasCircleArrowDownRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircleArrowDownRight",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 0a256 256 0 1 0 0 512 256 256 0 1 0 0-512zm-64 368c-13.3 0-24-10.7-24-24s10.7-24 24-24h94.1L151 185c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l135 135V184c0-13.3 10.7-24 24-24s24 10.7 24 24v160c0 13.3-10.7 24-24 24H192z"
        }
    ]
};

const FasCircleArrowDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircleArrowDown",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 0a256 256 0 1 0 0 512 256 256 0 1 0 0-512zM127 281c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l71 71L232 136c0-13.3 10.7-24 24-24s24 10.7 24 24v182.1l71-71c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L273 393c-9.4 9.4-24.6 9.4-33.9 0L127 281z"
        }
    ]
};

const FasCircleArrowLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircleArrowLeft",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 256a256 256 0 1 0-512 0 256 256 0 1 0 512 0zM231 127c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-71 71 182.1.1c13.3 0 24 10.7 24 24s-10.7 24-24 24H193.9l71 71c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L119 273c-9.4-9.4-9.4-24.6 0-33.9L231 127z"
        }
    ]
};

const FasCircleArrowRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircleArrowRight",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 256a256 256 0 1 0 512 0 256 256 0 1 0-512 0zm281 129c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l71-71L136 280c-13.3 0-24-10.7-24-24s10.7-24 24-24h182.1l-71-71c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L393 239c9.4 9.4 9.4 24.6 0 33.9L281 385z"
        }
    ]
};

const FasCircleArrowUpLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircleArrowUpLeft",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm64-368c13.3 0 24 10.7 24 24s-10.7 24-24 24h-94.1L361 327c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-135-135V328c0 13.3-10.7 24-24 24s-24-10.7-24-24V168c0-13.3 10.7-24 24-24H320z"
        }
    ]
};

const FasCircleArrowUpRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircleArrowUpRight",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 256a256 256 0 1 0 512 0 256 256 0 1 0-512 0zm368 64c0 13.3-10.7 24-24 24s-24-10.7-24-24v-94.1L185 361c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l135-135L184 192c-13.3 0-24-10.7-24-24s10.7-24 24-24h160c13.3 0 24 10.7 24 24v152z"
        }
    ]
};

const FasCircleArrowUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircleArrowUp",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm129-281c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-71-71V376c0 13.3-10.7 24-24 24s-24-10.7-24-24V193.9l-71 71c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L239 119c9.4-9.4 24.6-9.4 33.9 0L385 231z"
        }
    ]
};

const FasCircleB = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircleB",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-96-360c0-13.3 10.7-24 24-24h92c42 0 76 34 76 76 0 16.2-5.1 31.3-13.8 43.7 18.1 13.9 29.8 35.7 29.8 60.3 0 42-34 76-76 76H184c-13.3 0-24-10.7-24-24V152zm144 52c0-15.5-12.5-28-28-28h-68v56h68c15.5 0 28-12.5 28-28zm-96 132h84c15.5 0 28-12.5 28-28s-12.5-28-28-28h-84v56z"
        }
    ]
};

const FasCircleBolt = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircleBolt",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm74.1-396.4c5.8 4.7 7.6 12.9 4.2 19.6L281.9 240H352c6.8 0 12.9 4.3 15.1 10.7s.2 13.5-5.1 17.8l-160 128c-5.9 4.7-14.2 4.7-20.1-.1s-7.6-12.9-4.3-19.6L230.1 272H160c-6.8 0-12.8-4.3-15.1-10.7s-.2-13.5 5.1-17.8l160-128c5.9-4.7 14.2-4.7 20.1.1z"
        }
    ]
};

const FasCircleBookOpen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircleBookOpen",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-72-176c-23.1 0-41 11.1-46.3 14.8-1.1.8-2.4 1.2-3.7 1.2-3.3 0-5.9-2.7-5.9-5.9V185.3c0-5.8 3.1-11.1 8.3-13.5 10.4-4.7 29.1-11.9 47.7-11.9s37.2 7.1 47.7 11.9c5.2 2.4 8.3 7.7 8.3 13.5v160.8c0 3.3-2.7 5.9-5.9 5.9-1.3 0-2.6-.4-3.7-1.2-5.5-3.7-23.4-14.8-46.5-14.8zm144 0c-23.1 0-41 11.1-46.3 14.8-1.1.8-2.4 1.2-3.7 1.2-3.3 0-5.9-2.7-5.9-5.9V185.3c0-5.8 3.1-11.1 8.3-13.5 10.4-4.7 29.1-11.9 47.7-11.9s37.2 7.1 47.7 11.9c5.2 2.4 8.3 7.7 8.3 13.5v160.8c0 3.3-2.7 5.9-5.9 5.9-1.3 0-2.6-.4-3.7-1.2-5.5-3.7-23.4-14.8-46.5-14.8z"
        }
    ]
};

const FasCircleBookmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircleBookmark",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-96-336c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v192c0 6.2-3.5 11.8-9.1 14.4s-12.1 1.9-16.9-1.9l-70-56-70 56c-4.8 3.8-11.4 4.6-16.9 1.9s-9.1-8.3-9.1-14.4V176z"
        }
    ]
};

const FasCircleC = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircleC",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-56.6-199.4c31.2 31.2 81.9 31.2 113.1 0 9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9c-50 50-131 50-181 0s-50-131 0-181 131-50 181 0c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0c-31.2-31.2-81.9-31.2-113.1 0s-31.2 81.9 0 113.1z"
        }
    ]
};

const FasCircleCalendar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircleCalendar",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM208 96c8.8 0 16 7.2 16 16v16h64v-16c0-8.8 7.2-16 16-16s16 7.2 16 16v16h32c17.7 0 32 14.3 32 32v32H128v-32c0-17.7 14.3-32 32-32h32v-16c0-8.8 7.2-16 16-16zm-80 256V224h256v128c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32z"
        }
    ]
};

const FasCircleCamera = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircleCamera",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-60-352 6.2-16.4c3.5-9.4 12.5-15.6 22.5-15.6h62.7c10 0 19 6.2 22.5 15.6L316 160h36c17.7 0 32 14.3 32 32v128c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V192c0-17.7 14.3-32 32-32h36zm108 96a48 48 0 1 0-96 0 48 48 0 1 0 96 0z"
        }
    ]
};

const FasCircleCaretDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircleCaretDown",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 0a256 256 0 1 0 0 512 256 256 0 1 0 0-512zm0 368c-6.7 0-13-2.8-17.6-7.7l-104-112c-6.5-7-8.2-17.2-4.4-25.9s12.5-14.4 22-14.4h208c9.5 0 18.2 5.7 22 14.4s2.1 18.9-4.4 25.9l-104 112c-4.5 4.9-10.9 7.7-17.6 7.7z"
        }
    ]
};

const FasCircleCaretLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircleCaretLeft",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 256a256 256 0 1 0-512 0 256 256 0 1 0 512 0zm-368 0c0-6.7 2.8-13 7.7-17.6l112-104c7-6.5 17.2-8.2 25.9-4.4s14.4 12.5 14.4 22v208c0 9.5-5.7 18.2-14.4 22s-18.9 2.1-25.9-4.4l-112-104c-4.9-4.5-7.7-10.9-7.7-17.6z"
        }
    ]
};

const FasCircleCaretRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircleCaretRight",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 256a256 256 0 1 0 512 0 256 256 0 1 0-512 0zm368 0c0 6.7-2.8 13-7.7 17.6l-112 104c-7 6.5-17.2 8.2-25.9 4.4S208 369.5 208 360V152c0-9.5 5.7-18.2 14.4-22s18.9-2.1 25.9 4.4l112 104c4.9 4.5 7.7 10.9 7.7 17.6z"
        }
    ]
};

const FasCircleCaretUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircleCaretUp",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm0-368c6.7 0 13 2.8 17.6 7.7l104 112c6.5 7 8.2 17.2 4.4 25.9S369.5 304 360 304H152c-9.5 0-18.2-5.7-22-14.4s-2.1-18.9 4.4-25.9l104-112c4.5-4.9 10.9-7.7 17.6-7.7z"
        }
    ]
};

const FasCircleCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircleCheck",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm113-303L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
        }
    ]
};

const FasCircleChevronDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircleChevronDown",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 0a256 256 0 1 0 0 512 256 256 0 1 0 0-512zM135 241c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l87 87 87-87c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L273 345c-9.4 9.4-24.6 9.4-33.9 0L135 241z"
        }
    ]
};

const FasCircleChevronLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircleChevronLeft",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 256a256 256 0 1 0-512 0 256 256 0 1 0 512 0zM271 135c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-87 87 87 87c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L167 273c-9.4-9.4-9.4-24.6 0-33.9L271 135z"
        }
    ]
};

const FasCircleChevronRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircleChevronRight",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 256a256 256 0 1 0 512 0 256 256 0 1 0-512 0zm241 121c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l87-87-87-87c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L345 239c9.4 9.4 9.4 24.6 0 33.9L241 377z"
        }
    ]
};

const FasCircleChevronUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircleChevronUp",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm121-241c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-87-87-87 87c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L239 167c9.4-9.4 24.6-9.4 33.9 0L377 271z"
        }
    ]
};

const FasCircleD = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircleD",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-72-384h72c70.7 0 128 57.3 128 128s-57.3 128-128 128h-72c-13.3 0-24-10.7-24-24V152c0-13.3 10.7-24 24-24zm72 208c44.2 0 80-35.8 80-80s-35.8-80-80-80h-48v160h48z"
        }
    ]
};

const FasCircleDashed = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircleDashed",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M1.1 232C6 179.3 26.9 131.3 58.8 92.7l45.5 45.5c-20.6 26.6-34.4 58.7-38.8 93.8H1.1zm137.2-127.7L92.7 58.8C131.3 26.9 179.3 6 232 1.1v64.4c-35.1 4.4-67.2 18.2-93.7 38.8zM280 446.5c35.1-4.4 67.2-18.2 93.7-38.8l45.5 45.5c-38.5 31.9-86.5 52.8-139.2 57.7v-64.4zm127.7-72.8c20.6-26.6 34.5-58.7 38.8-93.7h64.4c-4.9 52.7-25.8 100.7-57.7 139.3l-45.5-45.5zm-315 79.5 45.5-45.5c26.6 20.6 58.7 34.5 93.7 38.8v64.4c-52.7-4.9-100.7-25.8-139.3-57.7zm-33.9-33.9C26.9 380.7 6 332.7 1.1 280h64.4c4.4 35.1 18.2 67.2 38.8 93.7l-45.5 45.6zM419.3 58.8l-45.5 45.5c-26.6-20.6-58.7-34.4-93.8-38.8V1.1C332.7 6 380.7 26.9 419.3 58.8zm-11.6 79.5 45.5-45.5c31.9 38.5 52.8 86.6 57.7 139.3h-64.4c-4.4-35.1-18.2-67.2-38.8-93.7z"
        }
    ]
};

const FasCircleDivide = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircleDivide",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm0-384a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-88 104h176c13.3 0 24 10.7 24 24s-10.7 24-24 24H168c-13.3 0-24-10.7-24-24s10.7-24 24-24zm56 120a32 32 0 1 1 64 0 32 32 0 1 1-64 0z"
        }
    ]
};

const FasCircleDollarToSlot = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircleDollarToSlot",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M326.7 403.7c-22.1 8-45.9 12.3-70.7 12.3s-48.7-4.4-70.7-12.3c-.3-.1-.5-.2-.8-.3-30-11-56.8-28.7-78.6-51.4C70 314.6 48 263.9 48 208 48 93.1 141.1 0 256 0s208 93.1 208 208c0 55.9-22 106.6-57.9 144-1 1-2 2.1-3 3.1a208.78 208.78 0 0 1-76.3 48.6zM256 91.9c-11.1 0-20.1 9-20.1 20.1v6c-5.6 1.2-10.9 2.9-15.9 5.1-15 6.8-27.9 19.4-31.1 37.7-1.8 10.2-.8 20 3.4 29 4.2 8.8 10.7 15 17.3 19.5 11.6 7.9 26.9 12.5 38.6 16l2.2.7c13.9 4.2 23.4 7.4 29.3 11.7 2.5 1.8 3.4 3.2 3.7 4 .3.8.9 2.6.2 6.7-.6 3.5-2.5 6.4-8 8.8-6.1 2.6-16 3.9-28.8 1.9-6-1-16.7-4.6-26.2-7.9-2.2-.7-4.3-1.5-6.4-2.1-10.5-3.5-21.8 2.2-25.3 12.7s2.2 21.8 12.7 25.3c1.2.4 2.7.9 4.4 1.5 7.9 2.7 20.3 6.9 29.8 9.1v6.3c0 11.1 9 20.1 20.1 20.1s20.1-9 20.1-20.1v-5.5c5.3-1 10.5-2.5 15.4-4.6 15.7-6.7 28.4-19.7 31.6-38.7 1.8-10.4 1-20.3-3-29.4-3.9-9-10.2-15.6-16.9-20.5-12.2-8.8-28.3-13.7-40.4-17.4l-.8-.2c-14.2-4.3-23.8-7.3-29.9-11.4-2.6-1.8-3.4-3-3.6-3.5-.2-.3-.7-1.6-.1-5 .3-1.9 1.9-5.2 8.2-8.1 6.4-2.9 16.4-4.5 28.6-2.6 4.3.7 17.9 3.3 21.7 4.3 10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-4.4-1.2-14.4-3.2-21-4.4V112c0-11.1-9-20.1-20.1-20.1zM48 352h16c19.5 25.9 44 47.7 72.2 64H64v32h384v-32h-72.2c28.2-16.3 52.8-38.1 72.2-64h16c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48v-64c0-26.5 21.5-48 48-48z"
        }
    ]
};

const FasCircleDollar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircleDollar",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm20.8-378.4v14.2c9.7 1.2 19.4 3.9 29 6.6 1.9.5 3.7 1 5.6 1.6 11.5 3.2 18.3 15.1 15.1 26.6s-15.1 18.2-26.6 15.1c-1.6-.4-3.1-.9-4.7-1.3-7-2-14-3.9-21.1-5.3-13.2-2.5-28.5-1.3-40.8 4-11 4.8-20.1 16.4-7.6 24.4 9.8 6.3 21.8 9.5 33.2 12.6 2.4.6 4.7 1.3 7 1.9 15.6 4.4 35.5 10.1 50.4 20.3 19.4 13.3 28.5 34.9 24.2 58.1-4.1 22.4-19.7 37.1-38.4 44.7-7.8 3.2-16.3 5.2-25.2 6.2v15.2c0 11.9-9.7 21.6-21.6 21.6s-21.6-9.7-21.6-21.6v-17.4c-14.5-3.3-28.7-7.9-42.8-12.5-11.3-3.7-17.5-16-13.7-27.3s16-17.5 27.3-13.7c2.5.8 5 1.7 7.5 2.5 11.3 3.8 22.9 7.7 34.5 9.6 17 2.5 30.6 1 39.5-2.6 12-4.8 17.7-19.1 5.9-27.1-10.1-6.9-22.6-10.3-34.5-13.5-2.3-.6-4.5-1.2-6.8-1.9-15.1-4.3-34-9.6-48.2-18.7-19.5-12.5-29.4-33.3-25.2-56.4 4-21.8 21-36.3 39-44.1 5.5-2.4 11.4-4.3 17.5-5.7v-16.1c0-11.9 9.7-21.6 21.6-21.6s21.6 9.7 21.6 21.6z"
        }
    ]
};

const FasCircleDot = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircleDot",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm0-352a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"
        }
    ]
};

const FasCircleDownLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircleDownLeft",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 1 0-512 256 256 0 1 1 0 512zm-96-313.4V336c0 8.8 7.2 16 16 16h137.4c12.5 0 22.6-10.1 22.6-22.6 0-6-2.4-11.8-6.6-16L296 280l66.3-66.3c3.6-3.6 5.7-8.5 5.7-13.7s-2-10-5.7-13.7l-36.7-36.7c-3.6-3.6-8.5-5.6-13.6-5.6s-10 2-13.7 5.7L232 216l-33.4-33.4c-4.2-4.2-10-6.6-16-6.6-12.5 0-22.6 10.1-22.6 22.6z"
        }
    ]
};

const FasCircleDownRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircleDownRight",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 0a256 256 0 1 0 0 512 256 256 0 1 0 0-512zm96 198.6V336c0 8.8-7.2 16-16 16H198.6c-12.5 0-22.6-10.1-22.6-22.6 0-6 2.4-11.8 6.6-16L216 280l-66.3-66.3c-3.7-3.7-5.7-8.6-5.7-13.7s2-10 5.7-13.7l36.7-36.7c3.6-3.6 8.5-5.7 13.7-5.7s10 2 13.7 5.7L280 216l33.4-33.4c4.2-4.2 10-6.6 16-6.6 12.5 0 22.6 10.1 22.6 22.6z"
        }
    ]
};

const FasCircleDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircleDown",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 0a256 256 0 1 0 0 512 256 256 0 1 0 0-512zm120.9 294.6-107.1 99.9c-3.8 3.5-8.7 5.5-13.8 5.5s-10.1-2-13.8-5.5l-107.1-99.9c-4.5-4.2-7.1-10.1-7.1-16.3 0-12.3 10-22.3 22.3-22.3H208v-96c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32v96h57.7c12.3 0 22.3 10 22.3 22.3 0 6.2-2.6 12.1-7.1 16.3z"
        }
    ]
};

const FasCircleE = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircleE",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-72-384h144c13.3 0 24 10.7 24 24s-10.7 24-24 24H208v56h88c13.3 0 24 10.7 24 24s-10.7 24-24 24h-88v56h120c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24V152c0-13.3 10.7-24 24-24z"
        }
    ]
};

const FasCircleEllipsisVertical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircleEllipsisVertical",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm0-288a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-32-64a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm32 160a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FasCircleEllipsis = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircleEllipsis",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-96-288a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64 32a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm128-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FasCircleEnvelope = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircleEnvelope",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM128 192c0-17.7 14.3-32 32-32h192c17.7 0 32 14.3 32 32v9.3l-119.3 54.3c-2.7 1.2-5.7 1.9-8.7 1.9s-5.9-.6-8.7-1.9L128 201.3V192zm149.9 92.7L384 236.5V320c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32v-83.5l106.1 48.3c6.9 3.1 14.3 4.8 21.9 4.8s15-1.6 21.9-4.8z"
        }
    ]
};

const FasCircleEuro = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircleEuro",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM128 272h16c-.6-5-.9-10.1-.9-15.2 0-5.7.4-11.3 1.1-16.8H128c-8.8 0-16-7.2-16-16s7.2-16 16-16h24.7c19.2-46.9 65.4-80 119.2-80H313c13.3 0 24 10.7 24 24s-10.7 24-24 24h-41.1c-26.3 0-49.6 12.6-64.4 32H288c8.8 0 16 7.2 16 16s-7.2 16-16 16h-95.1c-1.1 5.4-1.7 11-1.7 16.8 0 5.2.5 10.3 1.4 15.2H288c8.8 0 16 7.2 16 16s-7.2 16-16 16h-81.6c14.7 20.3 38.5 33.5 65.5 33.5H313c13.3 0 24 10.7 24 24s-10.7 24-24 24h-41.1c-54.4 0-101-33.8-119.8-81.5H128c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FasCircleExclamationCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircleExclamationCheck",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M506.5 203 480 229.5l-18.7-18.7c-25-25-65.5-25-90.5 0s-25 65.5 0 90.5l64 64c11.9 11.9 27.4 18.2 43 18.7-44.3 76.5-127 128-221.8 128C114.6 512 0 397.4 0 256S114.6 0 256 0c123.2 0 226.1 87 250.5 203zM280 152c0-13.3-10.7-24-24-24s-24 10.7-24 24v112c0 13.3 10.7 24 24 24s24-10.7 24-24V152zm-24 232a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm369-175L497 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L591 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
        }
    ]
};

const FasCircleExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircleExclamation",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm0-384c13.3 0 24 10.7 24 24v112c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zm-32 224a32 32 0 1 1 64 0 32 32 0 1 1-64 0z"
        }
    ]
};

const FasCircleF = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircleF",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-72-384h144c13.3 0 24 10.7 24 24s-10.7 24-24 24H208v64h88c13.3 0 24 10.7 24 24s-10.7 24-24 24h-88v72c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24z"
        }
    ]
};

const FasCircleG = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircleG",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-80-256c0 44.2 35.8 80 80 80 35.8 0 66.1-23.5 76.3-56H280c-13.3 0-24-10.7-24-24s10.7-24 24-24h80c13.3 0 24 10.7 24 24 0 70.7-57.3 128-128 128s-128-57.3-128-128 57.3-128 128-128c32.8 0 62.7 12.3 85.3 32.6 9.9 8.8 10.7 24 1.9 33.9s-24 10.7-33.9 1.9C295.2 183.7 276.5 176 256 176c-44.2 0-80 35.8-80 80z"
        }
    ]
};

const FasCircleH = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircleH",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm112-360v208c0 13.3-10.7 24-24 24s-24-10.7-24-24v-80H192v80c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24s24 10.7 24 24v80h128v-80c0-13.3 10.7-24 24-24s24 10.7 24 24z"
        }
    ]
};

const FasCircleHalfStroke = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircleHalfStroke",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 256c0-106-86-192-192-192v384c106 0 192-86 192-192zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0z"
        }
    ]
};

const FasCircleHalf = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircleHalf",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32c0-17.7-14.4-32.2-31.9-30C97.8 17.7 0 125.4 0 256s97.8 238.3 224.1 254c17.5 2.2 31.9-12.4 31.9-30V32z"
        }
    ]
};

const FasCircleHeart = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircleHeart",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM131.9 280.9c-29.4-29.8-29.4-78.2 0-108s77-29.8 106.4 0l17.7 18 17.7-18c29.4-29.8 77-29.8 106.4 0s29.4 78.2 0 108L278.5 384.1c-6.2 6.3-14.3 9.4-22.5 9.4s-16.3-3.1-22.5-9.4L131.9 280.9z"
        }
    ]
};

const FasCircleI = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircleI",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-72-384h144c13.3 0 24 10.7 24 24s-10.7 24-24 24h-48v160h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24s10.7-24 24-24h48V176h-48c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
        }
    ]
};

const FasCircleInfo = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircleInfo",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-40-176h24v-64h-24c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24v88h8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-80c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FasCircleJ = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircleJ",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm80-360v136c0 53-43 96-96 96s-96-43-96-96v-8c0-13.3 10.7-24 24-24s24 10.7 24 24v8c0 26.5 21.5 48 48 48s48-21.5 48-48V152c0-13.3 10.7-24 24-24s24 10.7 24 24z"
        }
    ]
};

const FasCircleK = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircleK",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm89.1-343.2L272 243.1l75.3 102.7c7.8 10.7 5.5 25.7-5.2 33.5s-25.7 5.5-33.5-5.2L238 277.8l-30 30.5V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24s24 10.7 24 24v87.8l102.9-104.6c9.3-9.5 24.5-9.6 33.9-.3s9.6 24.5.3 33.9z"
        }
    ]
};

const FasCircleL = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircleL",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-48-360v184h120c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24V152c0-13.3 10.7-24 24-24s24 10.7 24 24z"
        }
    ]
};

const FasCircleLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircleLeft",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 256a256 256 0 1 0-512 0 256 256 0 1 0 512 0zM217.4 376.9l-99.9-107.1c-3.5-3.8-5.5-8.7-5.5-13.8s2-10.1 5.5-13.8l99.9-107.1c4.2-4.5 10.1-7.1 16.3-7.1 12.3 0 22.3 10 22.3 22.3V208h96c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32h-96v57.7c0 12.3-10 22.3-22.3 22.3-6.2 0-12.1-2.6-16.3-7.1z"
        }
    ]
};

const FasCircleLocationArrow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircleLocationArrow",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm102.2-329.3-84 196c-3.5 8.1-11.4 13.3-20.2 13.3-1.4 0-2.9-.1-4.4-.4-10.2-2.1-17.6-11.2-17.6-21.6v-90h-90c-10.4 0-19.5-7.4-21.5-17.6-2.1-10.2 3.3-20.5 12.9-24.6l196-84c8.5-3.5 18-1.7 24.2 4.7 6.4 6.3 8.2 15.9 4.7 24.2z"
        }
    ]
};

const FasCircleM = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircleM",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-84.5-374.1L256 255l84.5-117.1c6.1-8.4 16.9-12 26.8-8.8s16.6 12.4 16.6 22.8V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V226.2L275.4 310c-4.5 6.2-11.7 9.9-19.5 9.9s-14.9-3.7-19.5-9.9L176 226.2V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-10.4 6.7-19.6 16.6-22.8s20.7.3 26.8 8.8z"
        }
    ]
};

const FasCircleMicrophoneLines = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircleMicrophoneLines",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zM256 96c-26.5 0-48 21.5-48 48v112c0 26.5 21.5 48 48 48s48-21.5 48-48v-16h-32c-8.8 0-16-7.2-16-16s7.2-16 16-16h32v-32h-32c-8.8 0-16-7.2-16-16s7.2-16 16-16h32c0-26.5-21.5-48-48-48zm-96 144c0-8.8-7.2-16-16-16s-16 7.2-16 16v16c0 65.3 48.9 119.1 112 127v17c0 8.8 7.2 16 16 16s16-7.2 16-16v-17c63.1-7.9 112-61.7 112-127v-16c0-8.8-7.2-16-16-16s-16 7.2-16 16v16c0 53-43 96-96 96s-96-43-96-96v-16z"
        }
    ]
};

const FasCircleMicrophone = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircleMicrophone",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-48-368c0-26.5 21.5-48 48-48s48 21.5 48 48v112c0 26.5-21.5 48-48 48s-48-21.5-48-48V144zm-64 80c8.8 0 16 7.2 16 16v16c0 53 43 96 96 96s96-43 96-96v-16c0-8.8 7.2-16 16-16s16 7.2 16 16v16c0 65.3-48.9 119.1-112 127v17c0 8.8-7.2 16-16 16s-16-7.2-16-16v-17c-63.1-7.9-112-61.7-112-127v-16c0-8.8 7.2-16 16-16z"
        }
    ]
};

const FasCircleMinus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircleMinus",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-72-280h144c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
        }
    ]
};

const FasCircleN = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircleN",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-52.3-373.7L304 283.2V152c0-13.3 10.7-24 24-24s24 10.7 24 24v208c0 10.5-6.8 19.8-16.8 22.9s-20.9-.6-26.9-9.2L208 228.8V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-10.5 6.8-19.8 16.8-22.9s20.9.6 26.9 9.2z"
        }
    ]
};

const FasCircleNodes = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircleNodes",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M418.4 157.9c35.3-8.3 61.6-40 61.6-77.9 0-44.2-35.8-80-80-80-43.4 0-78.7 34.5-80 77.5l-183.8 73.6C121.7 136.8 101.9 128 80 128c-44.2 0-80 35.8-80 80s35.8 80 80 80c12.2 0 23.8-2.7 34.1-7.6l145.6 127.4c-2.4 7.6-3.7 15.8-3.7 24.2 0 44.2 35.8 80 80 80s80-35.8 80-80c0-27.7-14-52.1-35.4-66.4l37.8-207.7zm-262.1 74.3c2.2-6.9 3.5-14.2 3.7-21.7L343.8 137c3.6 3.5 7.4 6.7 11.6 9.5l-37.8 207.6c-5.5 1.3-10.8 3.1-15.8 5.5L156.3 232.2z"
        }
    ]
};

const FasCircleNotch = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircleNotch",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M222.7 32.1c5 16.9-4.6 34.8-21.5 39.8C121.8 95.6 64 169.1 64 256c0 106 86 192 192 192s192-86 192-192c0-86.9-57.8-160.4-137.1-184.1-16.9-5-26.6-22.9-21.5-39.8s22.9-26.6 39.8-21.5C434.9 42.1 512 140 512 256c0 141.4-114.6 256-256 256S0 397.4 0 256C0 140 77.1 42.1 182.9 10.6c16.9-5 34.8 4.6 39.8 21.5z"
        }
    ]
};

const FasCircleO = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircleO",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-80-256a80 80 0 1 0 160 0 80 80 0 1 0-160 0zm80 128a128 128 0 1 1 0-256 128 128 0 1 1 0 256z"
        }
    ]
};

const FasCircleP = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircleP",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-72-384h92c50.8 0 92 41.2 92 92s-41.2 92-92 92h-68v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zm92 136c24.3 0 44-19.7 44-44s-19.7-44-44-44h-68v88h68z"
        }
    ]
};

const FasCircleParking = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircleParking",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 256a192 192 0 1 0-384 0 192 192 0 1 0 384 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm232 0h48c17.7 0 32-14.3 32-32s-14.3-32-32-32h-48v64zm48 64h-48v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V168c0-22.1 17.9-40 40-40h72c53 0 96 43 96 96s-43 96-96 96z"
        }
    ]
};

const FasCirclePause = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCirclePause",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-32-320v128c0 17.7-14.3 32-32 32s-32-14.3-32-32V192c0-17.7 14.3-32 32-32s32 14.3 32 32zm128 0v128c0 17.7-14.3 32-32 32s-32-14.3-32-32V192c0-17.7 14.3-32 32-32s32 14.3 32 32z"
        }
    ]
};

const FasCirclePhoneFlip = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCirclePhoneFlip",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 0a256 256 0 1 1 0 512 256 256 0 1 1 0-512zm69.3 128.7c-9.7-2.6-19.9 2.3-23.7 11.6l-20 48c-3.4 8.2-1 17.6 5.8 23.2l24.6 20.2c-16.6 35.2-45.1 63.7-80.3 80.3l-20.2-24.7c-5.6-6.8-15-9.2-23.2-5.8l-48 20c-9.3 3.9-14.2 14-11.6 23.7l12 44C143.1 378 151 384 160 384c123.7 0 224-100.3 224-224 0-9-6-16.9-14.7-19.3l-44-12z"
        }
    ]
};

const FasCirclePhoneHangup = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCirclePhoneHangup",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm135.4-202c-5.3 8.6-16.8 12.3-26.7 8.5l-46.2-17.6c-8.7-3.3-14.1-11.6-13.1-20.3l2.9-26.7c-33.8-10.8-70.8-10.8-104.6 0l2.9 26.7c.9 8.7-4.4 16.9-13.1 20.3l-46.2 17.6c-9.9 3.8-21.4.2-26.7-8.5l-21.8-35.2c-4.8-7.8-3.4-17.5 3.4-23.8 84.9-78.6 222.6-78.6 307.5 0 6.8 6.3 8.2 16.1 3.4 23.8L391.4 310z"
        }
    ]
};

const FasCirclePhone = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCirclePhone",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-69.3-383.3c9.7-2.6 19.9 2.3 23.7 11.6l20 48c3.4 8.2 1 17.6-5.8 23.2L200 231.7c16.6 35.2 45.1 63.7 80.3 80.3l20.2-24.7c5.6-6.8 15-9.2 23.2-5.8l48 20c9.3 3.9 14.2 14 11.6 23.7l-12 44C368.9 378 361 384 352 384c-123.7 0-224-100.3-224-224 0-9 6-16.9 14.7-19.3l44-12z"
        }
    ]
};

const FasCirclePlay = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCirclePlay",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm188.3-108.9c-7.6 4.2-12.3 12.3-12.3 20.9v176c0 8.7 4.7 16.7 12.3 20.9s16.8 4.1 24.3-.5l144-88c7.1-4.4 11.5-12.1 11.5-20.5s-4.4-16.1-11.5-20.5l-144-88c-7.4-4.5-16.7-4.7-24.3-.5z"
        }
    ]
};

const FasCirclePlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCirclePlus",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-24-168v-64h-64c-13.3 0-24-10.7-24-24s10.7-24 24-24h64v-64c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24h-64v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"
        }
    ]
};

const FasCircleQ = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircleQ",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-80-256c0 44.2 35.8 80 80 80 13.4 0 25.9-3.3 37-9.1l-30-30c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l30 30c5.8-11.1 9.1-23.7 9.1-37 0-44.2-35.8-80-80-80s-80 35.8-80 80zm208 0c0 26.7-8.2 51.4-22.1 71.9L377 343c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L328 361.8c-20.5 14-45.3 22.1-71.9 22.1-70.7 0-128-57.3-128-128s57.3-128 128-128 128 57.3 128 128z"
        }
    ]
};

const FasCircleQuarterStroke = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircleQuarterStroke",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 256h160c17.7 0 32-14.3 32-32V64c106 0 192 86 192 192s-86 192-192 192S64 362 64 256zm-64 0a256 256 0 1 0 512 0 256 256 0 1 0-512 0z"
        }
    ]
};

const FasCircleQuarter = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircleQuarter",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 256c-17.7 0-32.2-14.4-30-31.9C16.4 108.2 108.2 16.4 224.1 2 241.6-.2 256 14.3 256 32v192c0 17.7-14.3 32-32 32H32z"
        }
    ]
};

const FasCircleQuarters = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircleQuarters",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M120.2 391.8 256 256l135.8 135.8C426.5 357 448 309 448 256s-21.5-101-56.2-135.8L256 256 120.2 120.2C85.5 155 64 203 64 256s21.5 101 56.2 135.8zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0z"
        }
    ]
};

const FasCircleQuestion = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircleQuestion",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-86.2-346.7c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1 0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6-13.3 0-24-10.7-24-24v-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1 0-8.4-6.8-15.1-15.1-15.1h-58.3c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1-64 0z"
        }
    ]
};

const FasCircleR = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircleR",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-72-384h104c44.2 0 80 35.8 80 80 0 36.6-24.6 67.5-58.2 77l45.4 60.6c8 10.6 5.8 25.6-4.8 33.6s-25.6 5.8-33.6-4.8L252 288h-44v72c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zm80 112h24c17.7 0 32-14.3 32-32s-14.3-32-32-32h-80v64h56z"
        }
    ]
};

const FasCircleRadiation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircleRadiation",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 64a192 192 0 1 1 0 384 192 192 0 1 1 0-384zm0 448a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-56-256c0-20.7 11.3-38.8 28-48.5l-36-62.3c-8.8-15.3-28.7-20.8-42-9-25.6 22.6-43.9 53.3-50.9 88.1-3.4 17.2 11.2 31.7 28.9 31.7h72zm28 48.5-36 62.4c-8.8 15.3-3.6 35.2 13.1 40.8 16 5.4 33.1 8.3 50.9 8.3s34.9-2.9 50.9-8.3c16.7-5.6 21.9-25.5 13.1-40.8l-36-62.4c-8.2 4.8-17.8 7.5-28 7.5s-19.8-2.7-28-7.5zm84-48.5h72c17.7 0 32.3-14.5 28.8-31.8-7-34.8-25.3-65.5-50.9-88.1-13.2-11.7-33.1-6.3-42 9l-36 62.3c16.7 9.7 28 27.8 28 48.5zm-56 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FasCircleRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircleRight",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 256a256 256 0 1 0 512 0 256 256 0 1 0-512 0zm294.6-120.9 99.9 107.1c3.5 3.8 5.5 8.7 5.5 13.8s-2 10.1-5.5 13.8l-99.9 107.1c-4.2 4.5-10.1 7.1-16.3 7.1-12.3 0-22.3-10-22.3-22.3V304h-96c-17.7 0-32-14.3-32-32v-32c0-17.7 14.3-32 32-32h96v-57.7c0-12.3 10-22.3 22.3-22.3 6.2 0 12.1 2.6 16.3 7.1z"
        }
    ]
};

const FasCircleS = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircleS",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-48.4-315.8c-1.1 6.4-.2 9.7.6 11.6 1 2 2.9 4.6 7.4 7.7 10.1 6.8 25.7 11.5 46.8 17.4l2 .6c18.4 5.2 41.4 11.7 58.6 23.2 9.5 6.4 18.5 15.1 24.1 27.2 5.7 12.3 7 25.9 4.4 40.3-4.7 26.3-23 43.3-45 52-21.3 8.4-47 9.6-72.6 5.7h-.1c-16.3-2.6-43.7-10.7-57.3-15.1-12.6-4-19.6-17.6-15.5-30.2s17.6-19.6 30.2-15.5c13.9 4.5 37.8 11.4 50 13.4 20.2 3 36.8 1.4 47.7-2.9 10.3-4.1 14.2-9.6 15.4-15.8 1.1-6.4.2-9.7-.6-11.6-1-2-2.9-4.6-7.4-7.7-10.1-6.8-25.7-11.5-46.8-17.4l-2-.6c-18.4-5.2-41.4-11.7-58.6-23.2-9.5-6.4-18.5-15.1-24.1-27.2-5.7-12.3-7-25.9-4.4-40.3 4.7-26.3 23-43.3 45-52 21.3-8.4 47-9.6 72.6-5.7 8.1 1.2 24.4 4.8 32 6.7 12.8 3.3 20.6 16.4 17.3 29.2s-16.4 20.6-29.2 17.3c-6.7-1.7-21.3-4.9-27.3-5.7-20.3-3.1-36.8-1.4-47.8 2.9-10.3 4.1-14.2 9.6-15.4 15.8z"
        }
    ]
};

const FasCircleSmall = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircleSmall",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 256a160 160 0 1 1 320 0 160 160 0 1 1-320 0z"
        }
    ]
};

const FasCircleSortDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircleSortDown",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 256a256 256 0 1 0-512 0 256 256 0 1 0 512 0zM267.3 411.3c-6.2 6.2-16.4 6.2-22.6 0l-96-96c-4.6-4.6-5.9-11.5-3.5-17.4s8.3-9.9 14.8-9.9h192c6.5 0 12.3 3.9 14.8 9.9s1.1 12.9-3.5 17.4l-96 96zm0-310.6 96 96c4.6 4.6 5.9 11.5 3.5 17.4s-8.3 9.9-14.8 9.9H160c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4l96-96c6.2-6.2 16.4-6.2 22.6 0zm46.1 91.3L256 134.6 198.6 192h114.8z"
        }
    ]
};

const FasCircleSortUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircleSortUp",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm267.3-155.3c-6.2-6.2-16.4-6.2-22.6 0l-96 96c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9h192c6.5 0 12.3-3.9 14.8-9.9s1.1-12.9-3.5-17.4l-96-96zm0 310.6 96-96c4.6-4.6 5.9-11.5 3.5-17.4s-8.3-9.9-14.8-9.9H160c-6.5 0-12.3 3.9-14.8 9.9s-1.1 12.9 3.5 17.4l96 96c6.2 6.2 16.4 6.2 22.6 0zm46.1-91.3L256 377.4 198.6 320h114.8z"
        }
    ]
};

const FasCircleSort = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircleSort",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm267.3-155.3c-6.2-6.2-16.4-6.2-22.6 0l-96 96c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9h192c6.5 0 12.3-3.9 14.8-9.9s1.1-12.9-3.5-17.4l-96-96zm-22.6 310.6c6.2 6.2 16.4 6.2 22.6 0l96-96c4.6-4.6 5.9-11.5 3.5-17.4s-8.3-9.9-14.8-9.9H160c-6.5 0-12.3 3.9-14.8 9.9s-1.1 12.9 3.5 17.4l96 96z"
        }
    ]
};

const FasCircleStar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircleStar",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm256-152c-6.1 0-11.7 3.5-14.3 8.9l-36.2 73.4-81 11.8c-6 .9-11 5.1-12.9 10.9s-.3 12.2 4 16.4l58.6 57.2-13.8 80.7c-1 6 1.4 12.1 6.4 15.6s11.5 4.1 16.8 1.2l72.4-38 72.5 38.1c5.4 2.8 11.9 2.4 16.9-1.2s7.4-9.6 6.4-15.6L338 282.7l58.6-57.2c4.4-4.3 5.9-10.6 4-16.4s-6.9-10-12.9-10.9l-81.1-11.8-36.2-73.4c-2.7-5.5-8.3-8.9-14.3-8.9z"
        }
    ]
};

const FasCircleSterling = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircleSterling",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm5.5-352c-16.8 0-30.4 13.7-30.3 30.5l.2 33.5H272c8.8 0 16 7.2 16 16s-7.2 16-16 16h-40.3l.1 9.7c.1 18.6-3.1 37-9.6 54.3H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-8.4 0-16.1-4.4-20.5-11.5s-4.7-16-.8-23.5l9.6-18.6c7.7-14.9 11.6-31.5 11.5-48.3l-.1-10.1H176c-8.8 0-16-7.2-16-16s7.2-16 16-16h7.5l-.2-33.1c-.3-43.5 34.8-78.9 78.3-78.9 10 0 19.8 1.9 29.1 5.6l30.3 12.1c12.3 4.9 18.3 18.9 13.4 31.2s-18.9 18.3-31.2 13.4l-30.3-12.1c-3.6-1.4-7.4-2.2-11.3-2.2z"
        }
    ]
};

const FasCircleStop = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircleStop",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-64-352h128c17.7 0 32 14.3 32 32v128c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V192c0-17.7 14.3-32 32-32z"
        }
    ]
};

const FasCircleT = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircleT",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM152 144h208c13.3 0 24 10.7 24 24s-10.7 24-24 24h-80v168c0 13.3-10.7 24-24 24s-24-10.7-24-24V192h-80c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
        }
    ]
};

const FasCircleThreeQuartersStroke = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircleThreeQuartersStroke",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 64v160c0 17.7 14.3 32 32 32h160c0-106-86-192-192-192zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0z"
        }
    ]
};

const FasCircleThreeQuarters = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircleThreeQuarters",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32c0-17.7-14.4-32.2-31.9-30C97.8 17.7 0 125.4 0 256c0 141.4 114.6 256 256 256 130.6 0 238.3-97.8 254-224.1 2.2-17.5-12.4-31.9-30-31.9H256V32z"
        }
    ]
};

const FasCircleTrash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircleTrash",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-96-384h41.4l11.3-11.3c3-3 7.1-4.7 11.3-4.7h64c4.2 0 8.3 1.7 11.3 4.7l11.3 11.3H352c8.8 0 16 7.2 16 16s-7.2 16-16 16H160c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64h192l-13.6 162.7c-1.4 16.6-15.2 29.3-31.9 29.3H205.4c-16.6 0-30.5-12.8-31.9-29.3L160 192z"
        }
    ]
};

const FasCircleU = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircleU",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-64-344v120c0 35.3 28.7 64 64 64s64-28.7 64-64V168c0-13.3 10.7-24 24-24s24 10.7 24 24v120c0 61.9-50.1 112-112 112s-112-50.1-112-112V168c0-13.3 10.7-24 24-24s24 10.7 24 24z"
        }
    ]
};

const FasCircleUpLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircleUpLeft",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-96-198.6V176c0-8.8 7.2-16 16-16h137.4c12.5 0 22.6 10.1 22.6 22.6 0 6-2.4 11.8-6.6 16L296 232l66.3 66.3c3.6 3.6 5.7 8.5 5.7 13.7s-2 10-5.7 13.7l-36.7 36.7c-3.6 3.6-8.5 5.6-13.6 5.6s-10-2-13.7-5.7L232 296l-33.4 33.4c-4.2 4.2-10 6.6-16 6.6-12.5 0-22.6-10.1-22.6-22.6z"
        }
    ]
};

const FasCircleUpRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircleUpRight",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 0a256 256 0 1 1 0 512 256 256 0 1 1 0-512zm96 313.4V176c0-8.8-7.2-16-16-16H198.6c-12.5 0-22.6 10.1-22.6 22.6 0 6 2.4 11.8 6.6 16L216 232l-66.3 66.3c-3.7 3.7-5.7 8.6-5.7 13.7s2 10 5.7 13.7l36.7 36.7c3.6 3.6 8.5 5.7 13.7 5.7s10-2 13.7-5.7L280 296l33.4 33.4c4.2 4.2 10 6.6 16 6.6 12.5 0 22.6-10.1 22.6-22.6z"
        }
    ]
};

const FasCircleUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircleUp",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM135.1 217.4l107.1-99.9c3.8-3.5 8.7-5.5 13.8-5.5s10.1 2 13.8 5.5l107.1 99.9c4.5 4.2 7.1 10.1 7.1 16.3 0 12.3-10 22.3-22.3 22.3H304v96c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32v-96h-57.7c-12.3 0-22.3-10-22.3-22.3 0-6.2 2.6-12.1 7.1-16.3z"
        }
    ]
};

const FasCircleUser = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircleUser",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M399 384.2c-22.1-38.4-63.6-64.2-111-64.2h-64c-47.4 0-88.9 25.8-111 64.2 35.2 39.2 86.2 63.8 143 63.8s107.8-24.7 143-63.8zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm256 16a72 72 0 1 0 0-144 72 72 0 1 0 0 144z"
        }
    ]
};

const FasCircleV = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircleV",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-82.5-354.7 82.5 165 82.5-165.1c5.9-11.9 20.3-16.7 32.2-10.7s16.7 20.3 10.7 32.2l-104 208c-4.1 8.1-12.4 13.3-21.5 13.3s-17.4-5.1-21.5-13.3l-104-208c-5.9-11.9-1.1-26.3 10.7-32.2s26.3-1.1 32.2 10.7z"
        }
    ]
};

const FasCircleVideo = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircleVideo",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM128 192c0-17.7 14.3-32 32-32h128c17.7 0 32 14.3 32 32v128c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V192zm268.9 125.9L352 288v-64l44.9-29.9c2-1.3 4.4-2.1 6.8-2.1 6.8 0 12.3 5.5 12.3 12.3v103.4c0 6.8-5.5 12.3-12.3 12.3-2.4 0-4.8-.7-6.8-2.1z"
        }
    ]
};

const FasCircleW = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircleW",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM150.9 168.7 192 297.3l41.1-128.6c3.2-9.9 12.4-16.7 22.9-16.7s19.7 6.7 22.9 16.7L320 297.3l41.1-128.6c4-12.6 17.5-19.6 30.2-15.5s19.6 17.5 15.5 30.2l-64 200c-3.2 9.9-12.4 16.7-22.9 16.7s-19.7-6.7-22.9-16.7l-41-128.7-41.1 128.6c-3.2 9.9-12.4 16.7-22.9 16.7s-19.7-6.7-22.9-16.7l-64-200c-4-12.6 2.9-26.1 15.5-30.2s26.1 2.9 30.2 15.5z"
        }
    ]
};

const FasCircleWaveformLines = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircleWaveformLines",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm32-368v224c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16s16 7.2 16 16zm-128 32v160c0 8.8-7.2 16-16 16s-16-7.2-16-16V176c0-8.8 7.2-16 16-16s16 7.2 16 16zm192 24v112c0 8.8-7.2 16-16 16s-16-7.2-16-16V200c0-8.8 7.2-16 16-16s16 7.2 16 16zm-128 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16v-80c0-8.8 7.2-16 16-16s16 7.2 16 16zm192 24v32c0 8.8-7.2 16-16 16s-16-7.2-16-16v-32c0-8.8 7.2-16 16-16s16 7.2 16 16z"
        }
    ]
};

const FasCircleX = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircleX",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-69.7-375.5 69.7 82.3 69.7-82.3c8.6-10.1 23.7-11.4 33.8-2.8s11.4 23.7 2.8 33.8L287.4 256l74.9 88.5c8.6 10.1 7.3 25.3-2.8 33.8s-25.3 7.3-33.8-2.8L256 293.2l-69.7 82.3c-8.6 10.1-23.7 11.4-33.8 2.8s-11.4-23.7-2.8-33.8l74.9-88.5-74.9-88.5c-8.6-10.1-7.3-25.3 2.8-33.8s25.3-7.3 33.8 2.8z"
        }
    ]
};

const FasCircleXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircleXmark",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-81-337c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"
        }
    ]
};

const FasCircleY = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircleY",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-85.9-359.7 85.9 99.1 85.9-99.1c8.7-10 23.8-11.1 33.9-2.4s11.1 23.8 2.4 33.9L280 297v79c0 13.3-10.7 24-24 24s-24-10.7-24-24v-79l-98.1-113.3c-8.7-10-7.6-25.2 2.4-33.9s25.2-7.6 33.9 2.4z"
        }
    ]
};

const FasCircleYen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircleYen",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-96.1-361.8c9.8-8.9 25-8.2 33.9 1.6l62.2 68.5 62.2-68.5c8.9-9.8 24.1-10.5 33.9-1.6s10.5 24.1 1.6 33.9L288.4 256H320c8.8 0 16 7.2 16 16s-7.2 16-16 16h-40v32h40c8.8 0 16 7.2 16 16s-7.2 16-16 16h-40v25c0 13.3-10.7 24-24 24s-24-10.7-24-24v-25h-40c-8.8 0-16-7.2-16-16s7.2-16 16-16h40v-32h-40c-8.8 0-16-7.2-16-16s7.2-16 16-16h31.6l-65.3-71.9c-8.9-9.8-8.2-25 1.6-33.9z"
        }
    ]
};

const FasCircleZ = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircleZ",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-72-384h144c8.9 0 17.1 5 21.3 12.9s3.6 17.5-1.5 24.8L229.8 336H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-8.9 0-17.1-5-21.3-12.9s-3.6-17.5 1.5-24.8l118-170.3H184c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
        }
    ]
};

const FasCircle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCircle",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512z"
        }
    ]
};

const FasCirclesOverlap = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCirclesOverlap",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 288c0 34.2 7.7 66.6 21.4 95.7C130 378.2 64 308.8 64 224c0-88.4 71.6-160 160-160 32.2 0 62.2 9.5 87.3 25.9C240.4 127.5 192 202.1 192 288zm32 160c11.2 0 22.1-.8 32.8-2.4 40.6 41 96.9 66.4 159.2 66.4 123.7 0 224-100.3 224-224S539.7 64 416 64c-11.2 0-22.1.8-32.8 2.4C342.6 25.4 286.3 0 224 0 100.3 0 0 100.3 0 224s100.3 224 224 224zm192 0c-32.2 0-62.2-9.5-87.3-25.9C399.6 384.5 448 309.9 448 224c0-34.2-7.7-66.6-21.4-95.7C510 133.8 576 203.2 576 288c0 88.4-71.6 160-160 160z"
        }
    ]
};

const FasCitrusSlice = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCitrusSlice",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M41 391c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9c115.6 115.6 302.6 116 418.3.3S540.5 122.6 425 7c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9c96.9 96.9 97.1 253.6.3 350.4S137.9 487.9 41 391zm116.3 32.9c9.6 2.7 18.8-4.9 18.8-14.9V264.5c0-6.2-4.3-11.5-10-14-5.9-2.6-13-2.1-17.6 2.5l-89.2 89.2c-6.2 6.2-6.2 16.4 0 22.6l4 4c27.1 27.1 59.6 45.5 94 55.2zM250.5 166c2.5 5.7 7.8 10 14 10H409c10 0 17.6-9.1 14.9-18.8-9.7-34.2-27.9-66.6-54.8-93.6l-4.3-4.3c-6.2-6.2-16.4-6.2-22.6 0L253 148.4c-4.6 4.6-5.2 11.7-2.5 17.6zm.6 50.5c-2 4.9-1.4 10.6 2.4 14.3l114 114c6.6 6.6 17.4 6.2 22.9-1.3 26.2-35.8 40.1-77.8 41.5-120.1.3-8.6-6.8-15.4-15.4-15.4H263c-5.3 0-9.8 3.7-11.8 8.5zm-34.6 34.6c-4.9 2-8.5 6.5-8.5 11.8v153.5c0 8.6 6.8 15.7 15.4 15.4 42.4-1.4 84.4-15.3 120.1-41.5 7.5-5.5 7.9-16.3 1.3-22.9l-114-114c-3.7-3.7-9.4-4.4-14.3-2.4z"
        }
    ]
};

const FasCitrus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCitrus",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M304 128h80c53 0 96-43 96-96V16c0-8.8-7.2-16-16-16h-80c-53 0-96 43-96 96v16c0 8.8 7.2 16 16 16zm-48-32c0-23.1 6.1-44.7 16.8-63.4-5.5-.4-11.1-.6-16.8-.6C123.5 32 16 139.5 16 272s107.5 240 240 240 240-107.5 240-240c0-49.5-15-95.5-40.7-133.7C435 152 410.4 160 384 160h-80c-26.5 0-48-21.5-48-48V96z"
        }
    ]
};

const FasCity = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCity",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 48c0-26.5-21.5-48-48-48h-96c-26.5 0-48 21.5-48 48v48h-64V24c0-13.3-10.7-24-24-24s-24 10.7-24 24v72h-64V24c0-13.3-10.7-24-24-24S64 10.7 64 24v72H48c-26.5 0-48 21.5-48 48v320c0 26.5 21.5 48 48 48h544c26.5 0 48-21.5 48-48V240c0-26.5-21.5-48-48-48H480V48zm96 320v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16zm-336 48h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16zm-112-16c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32zm432-144c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h32zm-304-80v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16zm-144-16c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h32zm144 144c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32zm-144 16H80c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16zm304-48v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16zM400 64c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16h32zm16 112v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16z"
        }
    ]
};

const FasClapperboardPlay = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasClapperboardPlay",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M453.8 32.3 327 159l-1 1h-92.1L361 33l1-1h86c2 0 3.9.1 5.8.3zM393.9 160 498 56c8.8 11 14 24.9 14 40v64H393.9zm-192-128H294L167 159l-1 1H73.9L201 33l1-1zM134 32 7 159l-1 1H0V96c0-35.3 28.7-64 64-64h70.1zM0 192h512v224c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192zm216.5 65.9c-5.2 2.8-8.5 8.2-8.5 14.1v128c0 5.9 3.2 11.3 8.5 14.1s11.5 2.5 16.4-.8l96-64c4.4-3 7.1-8 7.1-13.3s-2.7-10.3-7.1-13.3l-96-64c-4.9-3.3-11.2-3.6-16.4-.8z"
        }
    ]
};

const FasClapperboard = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasClapperboard",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 32h-86.1l-1 1-127 127H326l1-1L453.8 32.3c-1.9-.2-3.8-.3-5.8-.3zm64 128V96c0-15.1-5.3-29.1-14-40L394 160h118zM294.1 32h-92.2l-1 1-127 127H166l1-1L294 32zM64 32C28.7 32 0 60.7 0 96v64h6.1l1-1 127-127H64zm448 160H0v224c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V192z"
        }
    ]
};

const FasClarinet = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasClarinet",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 144c0-8.8 7.2-16 16-16h256c8.8 0 16 7.2 16 16s-7.2 16-16 16h-16v32h76.6c9.5 0 18.7-2.8 26.6-8.1l31.9-21.3c4.9-3.3 11.2-3.6 16.4-.8s8.5 8.2 8.5 14.1V368c0 5.9-3.2 11.3-8.5 14.1s-11.5 2.5-16.4-.8L583.2 360c-7.9-5.3-17.1-8.1-26.6-8.1H108.3c-10.2 0-20.3-1.9-29.7-5.7l-68.5-27.3C4 316.4 0 310.5 0 304v-64c0-6.5 4-12.4 10.1-14.9l68.6-27.4c9.4-3.8 19.5-5.7 29.7-5.7H256v-32h-16c-8.8 0-16-7.2-16-16zm224 16h-64v32h64v-32zm-96 0h-64v32h64v-32zm-80 136a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm120-24a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm72 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FasClawMarks = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasClawMarks",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M41.4 9.4c12.5-12.5 32.7-12.5 45.2 0l96 96 64 64 160 160 64 64 64 64c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L434.7 448H384c-17.7 0-32-14.3-32-32v-50.7L210.7 224H160c-17.7 0-32-14.3-32-32v-50.7L41.4 54.6c-12.5-12.5-12.5-32.8 0-45.3zm0 224c12.5-12.5 32.8-12.5 45.3 0l64 64 96 96 64 64c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L210.7 448H128c-17.7 0-32-14.3-32-32v-82.7l-54.6-54.7c-12.5-12.5-12.5-32.8 0-45.3zm269.2-224 32 32 64 64 64 64 64 64 32 32c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L498.7 288H448c-17.7 0-32-14.3-32-32v-50.7L370.7 160H320c-17.7 0-32-14.3-32-32V77.3l-22.6-22.7c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0z"
        }
    ]
};

const FasClipboardCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasClipboardCheck",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 0c-41.8 0-77.4 26.7-90.5 64H64C28.7 64 0 92.7 0 128v320c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64h-37.5C269.4 26.7 233.8 0 192 0zm0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm113 209L177 401c-9.4 9.4-24.6 9.4-33.9 0L79 337c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L271 239c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
        }
    ]
};

const FasClipboardListCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasClipboardListCheck",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 0c-41.8 0-77.4 26.7-90.5 64H64C28.7 64 0 92.7 0 128v320c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64h-37.5C269.4 26.7 233.8 0 192 0zm0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-4.7 132.7c6.2 6.2 6.2 16.4 0 22.6l-64 64c-6.2 6.2-16.4 6.2-22.6 0l-32-32c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l20.7 20.7 52.7-52.7c6.2-6.2 16.4-6.2 22.6 0zM192 272c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16zm-16 80h128c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16zM72 368a24 24 0 1 1 48 0 24 24 0 1 1-48 0z"
        }
    ]
};

const FasClipboardList = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasClipboardList",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 0c-41.8 0-77.4 26.7-90.5 64H64C28.7 64 0 92.7 0 128v320c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64h-37.5C269.4 26.7 233.8 0 192 0zm0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM72 272a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm104-16h128c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16zM72 368a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm88 0c0-8.8 7.2-16 16-16h128c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16z"
        }
    ]
};

const FasClipboardMedical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasClipboardMedical",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 0c-41.8 0-77.4 26.7-90.5 64H64C28.7 64 0 92.7 0 128v320c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64h-37.5C269.4 26.7 233.8 0 192 0zm0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-32 176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-48v48c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-48h-48c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h48v-48z"
        }
    ]
};

const FasClipboardPrescription = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasClipboardPrescription",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 0c-41.8 0-77.4 26.7-90.5 64H64C28.7 64 0 92.7 0 128v320c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64h-37.5C269.4 26.7 233.8 0 192 0zm0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-88 132h72c33.1 0 60 26.9 60 60 0 25.5-15.9 47.2-38.3 55.9l43 40.3 33.8-31c8.1-7.5 20.8-6.9 28.3 1.2s6.9 20.8-1.2 28.3l-31.6 29 31.7 29.7c8.1 7.6 8.5 20.2.9 28.3s-20.2 8.5-28.3.9l-33.9-31.8-34.9 32c-8.1 7.5-20.8 6.9-28.3-1.2s-6.9-20.8 1.2-28.3l32.6-29.9-64.8-60.8c-.9-.8-1.6-1.7-2.3-2.6H124v44c0 11-9 20-20 20s-20-9-20-20V216c0-11 9-20 20-20zm72 80c11 0 20-9 20-20s-9-20-20-20h-52v40h52z"
        }
    ]
};

const FasClipboardQuestion = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasClipboardQuestion",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 0c-41.8 0-77.4 26.7-90.5 64H64C28.7 64 0 92.7 0 128v320c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64h-37.5C269.4 26.7 233.8 0 192 0zm0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-86.2 165.3c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1 0 22.6-12.1 43.5-31.7 54.8L216 328.4c-.2 13-10.9 23.6-24 23.6-13.3 0-24-10.7-24-24v-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1 0-8.4-6.8-15.1-15.1-15.1h-58.3c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM160 416a32 32 0 1 1 64 0 32 32 0 1 1-64 0z"
        }
    ]
};

const FasClipboardUser = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasClipboardUser",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 0c-41.8 0-77.4 26.7-90.5 64H64C28.7 64 0 92.7 0 128v320c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64h-37.5C269.4 26.7 233.8 0 192 0zm0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-64 192a64 64 0 1 1 128 0 64 64 0 1 1-128 0zM80 432c0-44.2 35.8-80 80-80h64c44.2 0 80 35.8 80 80 0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16z"
        }
    ]
};

const FasClipboard = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasClipboard",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 0c-41.8 0-77.4 26.7-90.5 64H64C28.7 64 0 92.7 0 128v320c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64h-37.5C269.4 26.7 233.8 0 192 0zm0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-80 128h160c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FasClockDesk = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasClockDesk",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 224a224 224 0 1 1 448 0 224 224 0 1 1-448 0zM224 96c-13.3 0-24 10.7-24 24v104c0 6.4 2.5 12.5 7 17l48 48c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-41-41V120c0-13.3-10.7-24-24-24zm0 384c96.4 0 180.3-53.3 224-132v116c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V348c43.7 78.7 127.6 132 224 132z"
        }
    ]
};

const FasClockEightThirty = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasClockEightThirty",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 0a256 256 0 1 0 0 512 256 256 0 1 0 0-512zm-24 392v-91.2L173.3 340c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l96-64c7.4-4.9 16.8-5.4 24.6-1.2S280 247.1 280 256v136c0 13.3-10.7 24-24 24s-24-10.7-24-24z"
        }
    ]
};

const FasClockEight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasClockEight",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm24-392v136c0 8-4 15.5-10.7 20l-96 64c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l85.3-56.8V120c0-13.3 10.7-24 24-24s24 10.7 24 24z"
        }
    ]
};

const FasClockElevenThirty = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasClockElevenThirty",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 0a256 256 0 1 0 0 512 256 256 0 1 0 0-512zm-24 392V263.3l-60-90c-7.4-11-4.4-25.9 6.7-33.3s25.9-4.4 33.3 6.7l64 96c2.6 3.9 4 8.6 4 13.3v136c0 13.3-10.7 24-24 24s-24-10.7-24-24z"
        }
    ]
};

const FasClockEleven = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasClockEleven",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 0a256 256 0 1 1 0 512 256 256 0 1 1 0-512zm-24 120v56.7l-20-30c-7.4-11-22.3-14-33.3-6.7s-14 22.3-6.7 33.3l64 96c5.9 8.8 16.8 12.7 26.9 9.7s17-12.4 17-23V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z"
        }
    ]
};

const FasClockFiveThirty = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasClockFiveThirty",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 1 0-512 256 256 0 1 1 0 512zm24-120v-56.7l20 30c7.4 11 22.3 14 33.3 6.7s14-22.3 6.7-33.3l-64-96c-5.9-8.8-16.8-12.7-26.9-9.7s-17 12.4-17 23v136c0 13.3 10.7 24 24 24s24-10.7 24-24z"
        }
    ]
};

const FasClockFive = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasClockFive",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm24-392v128.7l60 90c7.4 11 4.4 25.9-6.7 33.3s-25.9 4.4-33.3-6.7l-64-96c-2.6-3.9-4-8.6-4-13.3V120c0-13.3 10.7-24 24-24s24 10.7 24 24z"
        }
    ]
};

const FasClockFourThirty = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasClockFourThirty",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 1 0-512 256 256 0 1 1 0 512zm24-120v-91.2l58.7 39.2c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3l-96-64c-7.4-4.9-16.8-5.4-24.6-1.2S232 247.1 232 256v136c0 13.3 10.7 24 24 24s24-10.7 24-24z"
        }
    ]
};

const FasClockNineThirty = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasClockNineThirty",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 1 0-512 256 256 0 1 1 0 512zm24-120V256c0-13.3-10.7-24-24-24H152c-13.3 0-24 10.7-24 24s10.7 24 24 24h80v112c0 13.3 10.7 24 24 24s24-10.7 24-24z"
        }
    ]
};

const FasClockNine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasClockNine",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm24-392v136c0 13.3-10.7 24-24 24H152c-13.3 0-24-10.7-24-24s10.7-24 24-24h80V120c0-13.3 10.7-24 24-24s24 10.7 24 24z"
        }
    ]
};

const FasClockOneThirty = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasClockOneThirty",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 1 0-512 256 256 0 1 1 0 512zm24-120V263.3l60-90c7.4-11 4.4-25.9-6.7-33.3s-25.9-4.4-33.3 6.7l-64 96c-2.6 3.9-4 8.6-4 13.3v136c0 13.3 10.7 24 24 24s24-10.7 24-24z"
        }
    ]
};

const FasClockOne = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasClockOne",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm24-392v56.7l20-30c7.4-11 22.3-14 33.3-6.7s14 22.3 6.7 33.3l-64 96c-5.9 8.8-16.8 12.7-26.9 9.7s-17-12.4-17-23V120c0-13.3 10.7-24 24-24s24 10.7 24 24z"
        }
    ]
};

const FasClockRotateLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasClockRotateLeft",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M75 75 41 41C25.9 25.9 0 36.6 0 57.9V168c0 13.3 10.7 24 24 24h110.1c21.4 0 32.1-25.9 17-41l-30.8-30.8C155 85.5 203 64 256 64c106 0 192 86 192 192s-86 192-192 192c-40.8 0-78.6-12.7-109.7-34.4-14.5-10.1-34.4-6.6-44.6 7.9s-6.6 34.4 7.9 44.6C151.2 495 201.7 512 256 512c141.4 0 256-114.6 256-256S397.4 0 256 0C185.3 0 121.3 28.7 75 75zm181 53c-13.3 0-24 10.7-24 24v104c0 6.4 2.5 12.5 7 17l72 72c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-65-65V152c0-13.3-10.7-24-24-24z"
        }
    ]
};

const FasClockSevenThirty = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasClockSevenThirty",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 0a256 256 0 1 0 0 512 256 256 0 1 0 0-512zm-24 392v-56.7l-20 30c-7.4 11-22.3 14-33.3 6.7s-14-22.3-6.7-33.3l64-96c5.9-8.8 16.8-12.7 26.9-9.7s17 12.4 17 23v136c0 13.3-10.7 24-24 24s-24-10.7-24-24z"
        }
    ]
};

const FasClockSeven = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasClockSeven",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 0a256 256 0 1 1 0 512 256 256 0 1 1 0-512zm-24 120v128.7l-60 90c-7.4 11-4.4 25.9 6.7 33.3s25.9 4.4 33.3-6.7l64-96c2.6-3.9 4-8.6 4-13.3V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z"
        }
    ]
};

const FasClockSixThirty = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasClockSixThirty",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 1 0-512 256 256 0 1 1 0 512zm24-120V256c0-13.3-10.7-24-24-24s-24 10.7-24 24v136c0 13.3 10.7 24 24 24s24-10.7 24-24z"
        }
    ]
};

const FasClockSix = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasClockSix",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm24-392v240c0 13.3-10.7 24-24 24s-24-10.7-24-24V120c0-13.3 10.7-24 24-24s24 10.7 24 24z"
        }
    ]
};

const FasClockTenThirty = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasClockTenThirty",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 1 0-512 256 256 0 1 1 0 512zm24-120V256c0-8-4-15.5-10.7-20l-96-64c-11-7.4-25.9-4.4-33.3 6.7s-4.4 25.9 6.7 33.3l85.3 56.8V392c0 13.3 10.7 24 24 24s24-10.7 24-24z"
        }
    ]
};

const FasClockTen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasClockTen",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 0a256 256 0 1 1 0 512 256 256 0 1 1 0-512zm-24 120v91.2L173.3 172c-11-7.4-25.9-4.4-33.3 6.7s-4.4 25.9 6.7 33.3l96 64c7.4 4.9 16.8 5.4 24.6 1.2S280 264.9 280 256V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z"
        }
    ]
};

const FasClockThreeThirty = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasClockThreeThirty",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 0a256 256 0 1 0 0 512 256 256 0 1 0 0-512zm-24 392V256c0-13.3 10.7-24 24-24h104c13.3 0 24 10.7 24 24s-10.7 24-24 24h-80v112c0 13.3-10.7 24-24 24s-24-10.7-24-24z"
        }
    ]
};

const FasClockThree = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasClockThree",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 0a256 256 0 1 1 0 512 256 256 0 1 1 0-512zm-24 120v136c0 13.3 10.7 24 24 24h104c13.3 0 24-10.7 24-24s-10.7-24-24-24h-80V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z"
        }
    ]
};

const FasClockTwelveThirty = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasClockTwelveThirty",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm24-360v240c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24s24 10.7 24 24z"
        }
    ]
};

const FasClockTwelve = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasClockTwelve",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm24-392v136c0 13.3-10.7 24-24 24s-24-10.7-24-24V120c0-13.3 10.7-24 24-24s24 10.7 24 24z"
        }
    ]
};

const FasClockTwoThirty = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasClockTwoThirty",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 0a256 256 0 1 0 0 512 256 256 0 1 0 0-512zm-24 392V256c0-8 4-15.5 10.7-20l96-64c11-7.4 25.9-4.4 33.3 6.7s4.4 25.9-6.7 33.3L280 268.8V392c0 13.3-10.7 24-24 24s-24-10.7-24-24z"
        }
    ]
};

const FasClockTwo = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasClockTwo",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm24-392v91.2l58.7-39.2c11-7.4 25.9-4.4 33.3 6.7s4.4 25.9-6.7 33.3l-96 64c-7.4 4.9-16.8 5.4-24.6 1.2S232 264.9 232 256V120c0-13.3 10.7-24 24-24s24 10.7 24 24z"
        }
    ]
};

const FasClock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasClock",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 0a256 256 0 1 1 0 512 256 256 0 1 1 0-512zm-24 120v136c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z"
        }
    ]
};

const FasClone = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasClone",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 448H64V224h64v-64H64c-35.3 0-64 28.7-64 64v224c0 35.3 28.7 64 64 64h224c35.3 0 64-28.7 64-64v-64h-64v64zm-64-96h224c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H224c-35.3 0-64 28.7-64 64v224c0 35.3 28.7 64 64 64z"
        }
    ]
};

const FasClosedCaptioningSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasClosedCaptioningSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-30-23.5c4.6-8.8 7.2-18.9 7.2-29.6V96c0-35.3-28.7-64-64-64H96c-6.7 0-13.1 1-19.2 2.9l-38-29.8zm197.8 155c26.6 1.2 50.4 13.3 67 31.9 6.1 6.8 7.6 16.2 4.7 24.3l-71.6-56.2zm94 73.7c10-42.3 48-73.8 93.4-73.8 28.4 0 54 12.4 71.5 32 8.8 9.9 8 25-1.9 33.9s-25 8-33.9-1.9c-8.8-9.9-21.6-16-35.8-16-26.5 0-48 21.5-48 48 0 5.4.9 10.5 2.5 15.4l-47.9-37.6zm89.4 70c1.3.1 2.7.2 4.1.2 14.2 0 27-6.1 35.8-16 8.8-9.9 24-10.7 33.9-1.9s10.7 24 1.9 33.9c-7.8 8.7-17.2 16-27.7 21.4l-47.9-37.6zM32 121.2V416c0 35.3 28.7 64 64 64h391.4L295 328.4c-16.8 14.7-38.9 23.6-63 23.6-53 0-96-43-96-96 0-16 3.9-31.1 10.8-44.3L32 121.2zM232 304c8.7 0 16.9-2.3 23.9-6.4l-70-55.1c-1.3 4.3-1.9 8.8-1.9 13.5 0 26.5 21.5 48 48 48z"
        }
    ]
};

const FasClosedCaptioning = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasClosedCaptioning",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 96c0-35.3 28.7-64 64-64h448c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm200 112c14.2 0 27 6.1 35.8 16 8.8 9.9 24 10.7 33.9 1.9s10.7-24 1.9-33.9c-17.5-19.6-43.1-32-71.5-32-53 0-96 43-96 96s43 96 96 96c28.4 0 54-12.4 71.5-32 8.8-9.9 8-25-1.9-33.9s-25-8-33.9 1.9c-8.8 9.9-21.6 16-35.8 16-26.5 0-48-21.5-48-48s21.5-48 48-48zm144 48c0-26.5 21.5-48 48-48 14.2 0 27 6.1 35.8 16 8.8 9.9 24 10.7 33.9 1.9s10.7-24 1.9-33.9c-17.5-19.6-43.1-32-71.5-32-53 0-96 43-96 96s43 96 96 96c28.4 0 54-12.4 71.5-32 8.8-9.9 8-25-1.9-33.9s-25-8-33.9 1.9c-8.8 9.9-21.6 16-35.8 16-26.5 0-48-21.5-48-48z"
        }
    ]
};

const FasClothesHanger = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasClothesHanger",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M209.8 84.8C222.3 35 267.1 0 318.5 0h1.5c61.9 0 112 50.1 112 112v6.3c0 36.5-17.8 70.8-47.8 91.8l-8.3 5.8 232.3 161.3C628.1 391 640 413.7 640 438c0 40.9-33.1 74-74 74H74c-40.9 0-74-33.1-74-74 0-24.2 11.9-47 31.8-60.8l269.8-187.4.1-.1 45.8-32c12.8-9 20.5-23.7 20.5-39.3V112c0-26.5-21.5-48-48-48h-1.5c-22 0-41.2 15-46.6 36.4l-.9 3.4c-4.3 17.1-21.7 27.6-38.8 23.3s-27.6-21.7-23.3-38.8l.9-3.4zM320 255 68.3 429.7c-2.7 1.9-4.3 4.9-4.3 8.2 0 5.5 4.5 10 10 10h492c5.5 0 10-4.5 10-10 0-3.3-1.6-6.4-4.3-8.2L320 255z"
        }
    ]
};

const FasCloudArrowDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCloudArrowDown",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 480C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9-.1-2.7-.2-5.4-.2-8.1 0-88.4 71.6-160 160-160 59.3 0 111 32.2 138.7 80.2A95.51 95.51 0 0 1 448 96c53 0 96 43 96 96 0 12.2-2.3 23.8-6.4 34.6C596 238.4 640 290.1 640 352c0 70.7-57.3 128-128 128H144zm79-167 80 80c9.4 9.4 24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-39 39V184c0-13.3-10.7-24-24-24s-24 10.7-24 24v134.1l-39-39c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9z"
        }
    ]
};

const FasCloudArrowUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCloudArrowUp",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 480C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9-.1-2.7-.2-5.4-.2-8.1 0-88.4 71.6-160 160-160 59.3 0 111 32.2 138.7 80.2A95.51 95.51 0 0 1 448 96c53 0 96 43 96 96 0 12.2-2.3 23.8-6.4 34.6C596 238.4 640 290.1 640 352c0 70.7-57.3 128-128 128H144zm79-217c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l39-39V392c0 13.3 10.7 24 24 24s24-10.7 24-24V257.9l39 39c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-80-80c-9.4-9.4-24.6-9.4-33.9 0l-80 80z"
        }
    ]
};

const FasCloudBinary = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCloudBinary",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 480C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9-.1-2.7-.2-5.4-.2-8.1 0-88.4 71.6-160 160-160 59.3 0 111 32.2 138.7 80.2A95.51 95.51 0 0 1 448 96c53 0 96 43 96 96 0 12.2-2.3 23.8-6.4 34.6C596 238.4 640 290.1 640 352c0 70.7-57.3 128-128 128H144zm16-280v32c0 22.1 17.9 40 40 40h16c22.1 0 40-17.9 40-40v-32c0-22.1-17.9-40-40-40h-16c-22.1 0-40 17.9-40 40zm40-8h16c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8v-32c0-4.4 3.6-8 8-8zm88-16c0 8.8 7.2 16 16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16v-80c0-8.8-7.2-16-16-16h-16c-8.8 0-16 7.2-16 16zm136-16c-22.1 0-40 17.9-40 40v32c0 22.1 17.9 40 40 40h16c22.1 0 40-17.9 40-40v-32c0-22.1-17.9-40-40-40h-16zm-8 40c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8v-32zM176 320c0 8.8 7.2 16 16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16v-80c0-8.8-7.2-16-16-16h-16c-8.8 0-16 7.2-16 16zm96 24v32c0 22.1 17.9 40 40 40h16c22.1 0 40-17.9 40-40v-32c0-22.1-17.9-40-40-40h-16c-22.1 0-40 17.9-40 40zm40-8h16c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8v-32c0-4.4 3.6-8 8-8zm104-32c-8.8 0-16 7.2-16 16s7.2 16 16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16v-80c0-8.8-7.2-16-16-16h-16z"
        }
    ]
};

const FasCloudBoltMoon = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCloudBoltMoon",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M361.4 79.9C380.6 33 427.1 0 481.2 0c3.7 0 7.3.2 10.9.5 7 .6 12.8 5.7 14.3 12.6s-1.7 13.9-7.8 17.4c-26.9 15.1-44.9 43.6-44.9 76.1 0 48.1 39.4 87.4 88.4 87.4 5.2 0 10.3-.4 15.2-1.3 6.9-1.2 13.8 2.3 17 8.6s1.9 13.9-3.2 18.7c-23.3 22.4-55 36.1-89.9 36.1h-2.4c-5.4-37.8-29.7-69.5-63-85.3-1.8-38.6-23.1-72.1-54.3-90.8zM447.8 272c0 44.2-35.8 80-80 80h-18.6c-6.8-19.2-24.9-32-45.2-32h-18.3l29.3-58.5c10.1-20.2 4.8-44.6-12.8-58.8s-42.6-14.2-60.2-.2l-160 128c-6 4.8-10.5 10.7-13.6 17.4C28.8 336 0 299.4 0 255.9c0-47.6 34.6-87 80-94.6V160c0-53 43-96 96-96 34.9 0 65.4 18.6 82.2 46.4C271.2 101.3 287 96 304 96c44.2 0 80 35.8 80 80 0 5.9-.6 11.7-1.9 17.2 37.4 6.7 65.8 39.4 65.8 78.7zm-165.7-44.4c5.8 4.7 7.6 12.9 4.3 19.6L233.9 352H304c6.8 0 12.8 4.3 15.1 10.7s.2 13.5-5.1 17.8l-160 128c-5.9 4.7-14.2 4.7-20.1-.1s-7.6-12.9-4.3-19.6L182.1 384H112c-6.8 0-12.8-4.3-15.1-10.7s-.2-13.5 5.1-17.8l160-128c5.9-4.7 14.2-4.7 20.1.1z"
        }
    ]
};

const FasCloudBoltSun = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCloudBoltSun",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M294.2 1.2c5.1 2.1 8.7 6.7 9.6 12.1l10.4 62.4c-23.3 10.8-42.9 28.4-56 50.3-14.6-9-31.8-14.1-50.2-14.1-53 0-96 43-96 96 0 35.5 19.3 66.6 48 83.2.8 31.8 13.2 60.7 33.1 82.7l-56 39.2c-4.5 3.1-10.3 3.8-15.4 1.6s-8.7-6.7-9.6-12.1l-14-84.6-84.7-14.1c-5.4-.9-10-4.5-12.1-9.6s-1.5-10.9 1.6-15.4L52.5 208 2.9 137.2c-3.2-4.5-3.8-10.3-1.6-15.4s6.7-8.7 12.1-9.6l84.7-14.1 14.1-84.7c.9-5.4 4.5-10 9.6-12.1s10.9-1.5 15.4 1.6L208 52.5l70.8-49.6c4.5-3.2 10.3-3.8 15.4-1.6zM208 144c13.8 0 26.7 4.4 37.1 11.9-1.2 4.1-2.2 8.3-3 12.6-37.9 14.6-67.2 46.6-77.8 86.4-12.5-11.8-20.3-28.4-20.3-46.9 0-35.3 28.7-64 64-64zm431.9 159.9c0 44.2-35.8 80-80 80h-18.6c3.5-10.1 3.7-21.3 0-31.8-6.8-19.2-24.9-32.1-45.3-32.1h-18.3l29.3-58.5c10.1-20.2 4.8-44.6-12.8-58.8s-42.6-14.2-60.2-.2l-160 128c-14.5 11.6-20.9 30.5-16.8 48.4-37.9-12.8-65.2-48.7-65.2-90.9 0-47.6 34.6-87 80-94.6v-1.3c0-53 43-96 96-96 34.9 0 65.4 18.6 82.2 46.4 13-9.1 28.8-14.4 45.8-14.4 44.2 0 80 35.8 80 80 0 5.9-.6 11.7-1.9 17.2 37.4 6.7 65.8 39.4 65.8 78.7zm-165.8-76.3c5.8 4.7 7.6 12.9 4.3 19.6L425.9 352H496c6.8 0 12.8 4.3 15.1 10.7s.2 13.5-5.1 17.8l-160 128c-5.9 4.7-14.2 4.7-20.1-.1s-7.6-12.9-4.3-19.6L374.1 384H304c-6.8 0-12.8-4.3-15.1-10.7s-.2-13.5 5.1-17.8l160-128c5.9-4.7 14.2-4.7 20.1.1z"
        }
    ]
};

const FasCloudBolt = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCloudBolt",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 224c0 53 43 96 96 96h47.2L290 202.5c17.6-14.1 42.6-14 60.2.2s22.8 38.6 12.8 58.8L333.7 320H416c53 0 96-43 96-96s-43-96-96-96h-1.6c1.1-5.2 1.6-10.5 1.6-16 0-44.2-35.8-80-80-80-24.3 0-46.1 10.9-60.8 28C256.5 24.3 219.1 0 176 0 114.1 0 64 50.1 64 112c0 7.1.7 14.1 1.9 20.8C27.6 145.4 0 181.5 0 224zm330.1 3.6c-5.8-4.7-14.2-4.7-20.1-.1l-160 128c-5.3 4.2-7.4 11.4-5.1 17.8S153.2 384 160 384h70.1l-52.4 104.8c-3.4 6.7-1.6 14.9 4.3 19.6s14.2 4.7 20.1.1l160-128c5.3-4.2 7.4-11.4 5.1-17.8s-8.3-10.7-15.1-10.7h-70.2l52.4-104.8c3.4-6.7 1.6-14.9-4.2-19.6z"
        }
    ]
};

const FasCloudCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCloudCheck",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 480C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9-.1-2.7-.2-5.4-.2-8.1 0-88.4 71.6-160 160-160 59.3 0 111 32.2 138.7 80.2A95.51 95.51 0 0 1 448 96c53 0 96 43 96 96 0 12.2-2.3 23.8-6.4 34.6C596 238.4 640 290.1 640 352c0 70.7-57.3 128-128 128H144zm289-239c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L433 241z"
        }
    ]
};

const FasCloudDrizzle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCloudDrizzle",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 320c-53 0-96-43-96-96 0-42.5 27.6-78.6 65.9-91.2-1.2-6.7-1.9-13.7-1.9-20.8C64 50.1 114.1 0 176 0c43.1 0 80.5 24.3 99.2 60 14.7-17.1 36.5-28 60.8-28 44.2 0 80 35.8 80 80 0 5.5-.6 10.8-1.6 16h1.6c53 0 96 43 96 96s-43 96-96 96H96zm-8 56v48c0 13.3-10.7 24-24 24s-24-10.7-24-24v-48c0-13.3 10.7-24 24-24s24 10.7 24 24zm96 64v48c0 13.3-10.7 24-24 24s-24-10.7-24-24v-48c0-13.3 10.7-24 24-24s24 10.7 24 24zm168-24c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24s-24-10.7-24-24v-48c0-13.3 10.7-24 24-24zm-72-40v48c0 13.3-10.7 24-24 24s-24-10.7-24-24v-48c0-13.3 10.7-24 24-24s24 10.7 24 24zm168-24c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24s-24-10.7-24-24v-48c0-13.3 10.7-24 24-24z"
        }
    ]
};

const FasCloudExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCloudExclamation",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 480C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9-.1-2.7-.2-5.4-.2-8.1 0-88.4 71.6-160 160-160 59.3 0 111 32.2 138.7 80.2A95.51 95.51 0 0 1 448 96c53 0 96 43 96 96 0 12.2-2.3 23.8-6.4 34.6C596 238.4 640 290.1 640 352c0 70.7-57.3 128-128 128H144zm176-320c-13.3 0-24 10.7-24 24v112c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0-64 0 32 32 0 1 0 64 0z"
        }
    ]
};

const FasCloudFog = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCloudFog",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 320c-53 0-96-43-96-96 0-42.5 27.6-78.6 65.9-91.2-1.3-6.7-1.9-13.7-1.9-20.8C128 50.1 178.1 0 240 0c43.1 0 80.5 24.3 99.2 60 14.7-17.1 36.5-28 60.8-28 44.2 0 80 35.8 80 80 0 5.5-.6 10.8-1.6 16h1.6c53 0 96 43 96 96s-43 96-96 96H160zM0 392c0-13.3 10.7-24 24-24h528c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24zm64 96c0-13.3 10.7-24 24-24h112c13.3 0 24 10.7 24 24s-10.7 24-24 24H88c-13.3 0-24-10.7-24-24zm208 0c0-13.3 10.7-24 24-24h320c13.3 0 24 10.7 24 24s-10.7 24-24 24H296c-13.3 0-24-10.7-24-24z"
        }
    ]
};

const FasCloudHailMixed = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCloudHailMixed",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 320c-53 0-96-43-96-96 0-42.5 27.6-78.6 65.9-91.2-1.2-6.7-1.9-13.7-1.9-20.8C64 50.1 114.1 0 176 0c43.1 0 80.5 24.3 99.2 60 14.7-17.1 36.5-28 60.8-28 44.2 0 80 35.8 80 80 0 5.5-.6 10.8-1.6 16h1.6c53 0 96 43 96 96s-43 96-96 96H96zm-14.5 33.9c12.2 5.2 17.8 19.3 12.6 31.5l-10.3 24c-5.2 12.2-19.3 17.8-31.5 12.6s-17.8-19.3-12.6-31.5l10.3-24c5.2-12.2 19.3-17.8 31.5-12.6zm120 0c12.2 5.2 17.8 19.3 12.6 31.5l-48 112c-5.2 12.2-19.3 17.8-31.5 12.6s-17.8-19.3-12.6-31.5l48-112c5.2-12.2 19.3-17.8 31.5-12.6zm232 0c12.2 5.2 17.8 19.3 12.6 31.5l-48 112c-5.2 12.2-19.3 17.8-31.5 12.6s-17.8-19.3-12.6-31.5l48-112c5.2-12.2 19.3-17.8 31.5-12.6zm-107.4 31.6-10.3 24c-5.2 12.2-19.3 17.8-31.5 12.6s-17.8-19.3-12.6-31.5l10.3-24c5.2-12.2 19.3-17.8 31.5-12.6s17.8 19.3 12.6 31.5zM32 448a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm192 32a32 32 0 1 1 64 0 32 32 0 1 1-64 0z"
        }
    ]
};

const FasCloudHail = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCloudHail",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 320c-53 0-96-43-96-96 0-42.5 27.6-78.6 65.9-91.2-1.2-6.7-1.9-13.7-1.9-20.8C64 50.1 114.1 0 176 0c43.1 0 80.5 24.3 99.2 60 14.7-17.1 36.5-28 60.8-28 44.2 0 80 35.8 80 80 0 5.5-.6 10.8-1.6 16h1.6c53 0 96 43 96 96s-43 96-96 96H96zm0 64a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm128 0a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm160-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM32 480a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm160-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 32a32 32 0 1 1 64 0 32 32 0 1 1-64 0z"
        }
    ]
};

const FasCloudMeatball = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCloudMeatball",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 224c0 53 43 96 96 96h44.7c9.5-23.5 32.5-40 59.3-40 2 0 3.9.1 5.8.3 11.8-14.8 29.9-24.3 50.2-24.3s38.4 9.5 50.2 24.3c1.9-.2 3.9-.3 5.8-.3 26.9 0 49.9 16.5 59.3 40H416c53 0 96-43 96-96s-43-96-96-96h-1.6c1.1-5.2 1.6-10.5 1.6-16 0-44.2-35.8-80-80-80-24.3 0-46.1 10.9-60.8 28C256.5 24.3 219.1 0 176 0 114.1 0 64 50.1 64 112c0 7.1.7 14.1 1.9 20.8C27.6 145.4 0 181.5 0 224zm288 96c0-17.7-14.3-32-32-32s-32 14.3-32 32c0 1 .1 2.1.1 3.1-.7-.8-1.4-1.6-2.1-2.3-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3c.7.7 1.5 1.4 2.3 2.1-1-.1-2.1-.1-3.1-.1-17.7 0-32 14.3-32 32s14.3 32 32 32c1 0 2.1-.1 3.1-.1-.8.7-1.6 1.3-2.3 2.1-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0c.7-.7 1.4-1.5 2.1-2.3-.1 1-.1 2.1-.1 3.1 0 17.7 14.3 32 32 32s32-14.3 32-32c0-1-.1-2.1-.1-3.1.7.8 1.3 1.6 2.1 2.3 12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3c-.7-.7-1.5-1.4-2.3-2.1 1 .1 2.1.1 3.1.1 17.7 0 32-14.3 32-32s-14.3-32-32-32c-1 0-2.1.1-3.1.1.8-.7 1.6-1.3 2.3-2.1 12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0c-.7.7-1.4 1.5-2.1 2.3.1-1 .1-2.1.1-3.1zM48 448a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm416 0a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
        }
    ]
};

const FasCloudMinus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCloudMinus",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 480C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9-.1-2.7-.2-5.4-.2-8.1 0-88.4 71.6-160 160-160 59.3 0 111 32.2 138.7 80.2A95.51 95.51 0 0 1 448 96c53 0 96 43 96 96 0 12.2-2.3 23.8-6.4 34.6C596 238.4 640 290.1 640 352c0 70.7-57.3 128-128 128H144zm104-216c-13.3 0-24 10.7-24 24s10.7 24 24 24h144c13.3 0 24-10.7 24-24s-10.7-24-24-24H248z"
        }
    ]
};

const FasCloudMoonRain = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCloudMoonRain",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M481.2 0C417 0 363.5 46.5 353.7 107.6c35.4 17.6 60.2 53.3 62.1 95.1 23.2 11 42 29.7 53.1 52.7 4 .4 8.1.6 12.3.6 34.9 0 66.7-13.8 89.9-36.1 5.1-4.9 6.4-12.5 3.2-18.7s-10.1-9.7-17-8.6c-4.9.8-10 1.3-15.2 1.3-49 0-88.4-39.3-88.4-87.4 0-32.6 18-61.1 44.9-76.1 6.1-3.4 9.3-10.5 7.8-17.4S499.1 1 492.1.4c-3.6-.3-7.3-.5-10.9-.5zM367.9 383.9c44.2 0 80-35.8 80-80 0-39.3-28.4-72.1-65.8-78.7 1.2-5.6 1.9-11.3 1.9-17.2 0-44.2-35.8-80-80-80-17 0-32.8 5.3-45.8 14.4C241.3 114.6 210.8 96 176 96c-53 0-96 43-96 96v1.3c-45.4 7.6-80 47.1-80 94.6 0 53 43 96 96 96h271.9zM85.4 420.1c-11-7.4-25.9-4.4-33.3 6.7l-32 48c-7.4 11-4.4 25.9 6.7 33.3s25.9 4.4 33.3-6.7l32-48c7.4-11 4.4-25.9-6.7-33.3zm96 0c-11-7.4-25.9-4.4-33.3 6.7l-32 48c-7.4 11-4.4 25.9 6.7 33.3s25.9 4.4 33.3-6.7l32-48c7.4-11 4.4-25.9-6.7-33.3zm96 0c-11-7.4-25.9-4.4-33.3 6.7l-32 48c-7.4 11-4.4 25.9 6.7 33.3s25.9 4.4 33.3-6.7l32-48c7.4-11 4.4-25.9-6.7-33.3zm96 0c-11-7.4-25.9-4.4-33.3 6.7l-32 48c-7.4 11-4.4 25.9 6.7 33.3s25.9 4.4 33.3-6.7l32-48c7.4-11 4.4-25.9-6.7-33.3z"
        }
    ]
};

const FasCloudMoon = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCloudMoon",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M495.8 0c5.5 0 10.9.2 16.3.7 7 .6 12.8 5.7 14.3 12.5s-1.6 13.9-7.7 17.3c-44.4 25.2-74.4 73-74.4 127.8 0 81 65.5 146.6 146.2 146.6 8.6 0 17-.7 25.1-2.1 6.9-1.2 13.8 2.2 17 8.5s1.9 13.8-3.1 18.7c-34.5 33.6-81.7 54.4-133.6 54.4-9.3 0-18.4-.7-27.4-1.9-11.2-22.6-29.8-40.9-52.6-51.7-2.7-58.5-50.3-105.3-109.2-106.7-1.7-10.4-2.6-21-2.6-31.8C304 86.1 389.8 0 495.8 0zm-47.9 431.9c0 44.2-35.8 80-80 80H96c-53 0-96-43-96-96 0-47.6 34.6-87 80-94.6V320c0-53 43-96 96-96 34.9 0 65.4 18.6 82.2 46.4 13-9.1 28.8-14.4 45.8-14.4 44.2 0 80 35.8 80 80 0 5.9-.6 11.7-1.9 17.2 37.4 6.7 65.8 39.4 65.8 78.7z"
        }
    ]
};

const FasCloudMusic = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCloudMusic",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 480C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9-.1-2.7-.2-5.4-.2-8.1 0-88.4 71.6-160 160-160 59.3 0 111 32.2 138.7 80.2A95.51 95.51 0 0 1 448 96c53 0 96 43 96 96 0 12.2-2.3 23.8-6.4 34.6C596 238.4 640 290.1 640 352c0 70.7-57.3 128-128 128H144zm272-296c0-5.2-2.6-10.2-6.9-13.2s-9.8-3.7-14.7-1.8l-128 48c-6.2 2.3-10.4 8.3-10.4 15v113.8c-5-1.2-10.4-1.8-16-1.8-26.5 0-48 14.3-48 32s21.5 32 48 32 48-14.3 48-32V275.1l96-36v74.7c-5-1.2-10.4-1.8-16-1.8-26.5 0-48 14.3-48 32s21.5 32 48 32 48-14.3 48-32V184z"
        }
    ]
};

const FasCloudPlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCloudPlus",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 480C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9-.1-2.7-.2-5.4-.2-8.1 0-88.4 71.6-160 160-160 59.3 0 111 32.2 138.7 80.2A95.51 95.51 0 0 1 448 96c53 0 96 43 96 96 0 12.2-2.3 23.8-6.4 34.6C596 238.4 640 290.1 640 352c0 70.7-57.3 128-128 128H144zm152-104c0 13.3 10.7 24 24 24s24-10.7 24-24v-64h64c13.3 0 24-10.7 24-24s-10.7-24-24-24h-64v-64c0-13.3-10.7-24-24-24s-24 10.7-24 24v64h-64c-13.3 0-24 10.7-24 24s10.7 24 24 24h64v64z"
        }
    ]
};

const FasCloudQuestion = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCloudQuestion",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 480C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9-.1-2.7-.2-5.4-.2-8.1 0-88.4 71.6-160 160-160 59.3 0 111 32.2 138.7 80.2A95.51 95.51 0 0 1 448 96c53 0 96 43 96 96 0 12.2-2.3 23.8-6.4 34.6C596 238.4 640 290.1 640 352c0 70.7-57.3 128-128 128H144zm89.8-282.7-.4 1.2c-4.4 12.5 2.1 26.2 14.6 30.6s26.2-2.1 30.6-14.6l.4-1.2c1.1-3.2 4.2-5.3 7.5-5.3h58.3c8.4 0 15.1 6.8 15.1 15.1 0 5.4-2.9 10.4-7.6 13.1L308 261.6c-7.5 4.3-12.1 12.2-12.1 20.8V296c0 13.3 10.7 24 24 24 13.1 0 23.8-10.5 24-23.6l32.3-18.5c19.6-11.3 31.7-32.2 31.7-54.8 0-34.9-28.3-63.1-63.1-63.1h-58.2c-23.7 0-44.8 14.9-52.8 37.3zM352 384a32 32 0 1 0-64 0 32 32 0 1 0 64 0z"
        }
    ]
};

const FasCloudRain = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCloudRain",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 320c-53 0-96-43-96-96 0-42.5 27.6-78.6 65.9-91.2-1.2-6.7-1.9-13.7-1.9-20.8C64 50.1 114.1 0 176 0c43.1 0 80.5 24.3 99.2 60 14.7-17.1 36.5-28 60.8-28 44.2 0 80 35.8 80 80 0 5.5-.6 10.8-1.6 16h1.6c53 0 96 43 96 96s-43 96-96 96H96zm-6.8 52c1.3-2.5 3.9-4 6.8-4s5.4 1.5 6.8 4l35.1 64.6c4.1 7.5 6.2 15.8 6.2 24.3v3c0 26.5-21.5 48-48 48s-48-21.5-48-48v-3c0-8.5 2.1-16.9 6.2-24.3L89.2 372zm160 0c1.3-2.5 3.9-4 6.8-4s5.4 1.5 6.8 4l35.1 64.6c4.1 7.5 6.2 15.8 6.2 24.3v3c0 26.5-21.5 48-48 48s-48-21.5-48-48v-3c0-8.5 2.1-16.9 6.2-24.3l34.9-64.6zm124.9 64.6 35.1-64.6c1.3-2.5 3.9-4 6.8-4s5.4 1.5 6.8 4l35.1 64.6c4.1 7.5 6.2 15.8 6.2 24.3v3c0 26.5-21.5 48-48 48s-48-21.5-48-48v-3c0-8.5 2.1-16.9 6.2-24.3z"
        }
    ]
};

const FasCloudRainbow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCloudRainbow",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M560 64.4C466.8 69.5 385.4 119 336.5 192h-.5c-19.7 0-38.3 5.1-54.4 14.1-5.5-6-11.5-11.4-18-16.4C319.9 81.4 430.9 6.1 560 .4c8.8-.4 16 6.8 16 15.6v32c0 8.8-7.2 16-16 16.4zM424 234.7c-13.3-16.9-31.5-29.9-52.3-36.9 43.7-57.9 111.4-96.6 188.3-101.3 8.8-.5 16 6.7 16 15.5v32c0 8.8-7.2 15.9-16 16.7-55.3 4.6-104 32.6-136 74zm23.4 57.2c-1-9.1-3-17.9-6.1-26.2 25.7-40.1 68.9-67.9 118.8-72.9 8.8-.9 16 6.4 16 15.2v32c0 8.8-7.2 15.9-15.9 17.3-31.4 5.2-57.7 25.8-70.9 53.7-12.5-8.7-26.6-15.3-41.8-19.1zM96 512c-53 0-96-43-96-96 0-42.5 27.6-78.6 65.9-91.2-1.2-6.7-1.9-13.7-1.9-20.8 0-61.9 50.1-112 112-112 43.1 0 80.5 24.3 99.2 60 14.7-17.1 36.5-28 60.8-28 44.2 0 80 35.8 80 80 0 5.5-.6 10.8-1.6 16h1.6c53 0 96 43 96 96s-43 96-96 96H96z"
        }
    ]
};

const FasCloudShowersHeavy = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCloudShowersHeavy",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 320c-53 0-96-43-96-96 0-42.5 27.6-78.6 65.9-91.2-1.2-6.7-1.9-13.7-1.9-20.8C64 50.1 114.1 0 176 0c43.1 0 80.5 24.3 99.2 60 14.7-17.1 36.5-28 60.8-28 44.2 0 80 35.8 80 80 0 5.5-.6 10.8-1.6 16h1.6c53 0 96 43 96 96s-43 96-96 96H96zm-14.5 33.9c12.2 5.2 17.8 19.3 12.6 31.5l-48 112c-5.2 12.2-19.3 17.8-31.5 12.6s-17.9-19.3-12.7-31.5l48-112c5.2-12.2 19.3-17.8 31.5-12.6zm120 0c12.2 5.2 17.8 19.3 12.6 31.5l-48 112c-5.2 12.2-19.3 17.8-31.5 12.6s-17.8-19.3-12.6-31.5l48-112c5.2-12.2 19.3-17.8 31.5-12.6zm244.6 31.5-48 112c-5.2 12.2-19.3 17.8-31.5 12.6s-17.8-19.3-12.6-31.5l48-112c5.2-12.2 19.3-17.8 31.5-12.6s17.8 19.3 12.6 31.5zm-132.6-31.5c12.2 5.2 17.8 19.3 12.6 31.5l-48 112c-5.2 12.2-19.3 17.8-31.5 12.6s-17.8-19.3-12.6-31.5l48-112c5.2-12.2 19.3-17.8 31.5-12.6z"
        }
    ]
};

const FasCloudShowersWater = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCloudShowersWater",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 0c38.6 0 71.9 22.8 87.2 55.7C325.7 41.1 345.8 32 368 32c38.7 0 71 27.5 78.4 64h1.6c35.3 0 64 28.7 64 64s-28.7 64-64 64H128c-35.3 0-64-28.7-64-64s28.7-64 64-64c0-53 43-96 96-96zm-83.4 292.3-48 80c-6.8 11.4-21.6 15-32.9 8.2s-15.1-21.6-8.2-32.9l48-80c6.8-11.4 21.6-15.1 32.9-8.2s15.1 21.6 8.2 32.9zm327.8-32.9c11.4 6.8 15 21.6 8.2 32.9l-48 80c-6.8 11.4-21.6 15-32.9 8.2s-15-21.6-8.2-32.9l48-80c6.8-11.4 21.6-15.1 32.9-8.2zm-215.8 32.9-48 80c-6.8 11.4-21.6 15-32.9 8.2s-15.1-21.6-8.2-32.9l48-80c6.8-11.4 21.6-15.1 32.9-8.2s15.1 21.6 8.2 32.9zm103.8-32.9c11.4 6.8 15 21.6 8.2 32.9l-48 80c-6.8 11.4-21.6 15-32.9 8.2s-15.1-21.6-8.2-32.9l48-80c6.8-11.4 21.6-15.1 32.9-8.2zm-49.9 162.5c22.5 15.5 50 26.1 77.5 26.1 26.9 0 55.4-10.8 77.4-26.1 11.9-8.5 28.1-7.8 39.2 1.7 14.4 11.9 32.5 21 50.6 25.2 17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25-29 15.6-61.5 25.9-94.5 25.9-31.9 0-60.6-9.9-80.4-18.9-5.8-2.7-11.1-5.3-15.6-7.7-4.5 2.4-9.7 5.1-15.6 7.7-19.8 9-48.5 18.9-80.4 18.9-33 0-65.5-10.3-94.5-25.8-13.4 8.4-33.7 19.3-58.2 25-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2 11.1-9.4 27.3-10.1 39.2-1.7 22.1 15.2 50.5 26 77.4 26 27.5 0 55-10.6 77.5-26.1 11.1-7.9 25.9-7.9 37 0z"
        }
    ]
};

const FasCloudShowers = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCloudShowers",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 320c-53 0-96-43-96-96 0-42.5 27.6-78.6 65.9-91.2-1.2-6.7-1.9-13.7-1.9-20.8C64 50.1 114.1 0 176 0c43.1 0 80.5 24.3 99.2 60 14.7-17.1 36.5-28 60.8-28 44.2 0 80 35.8 80 80 0 5.5-.6 10.8-1.6 16h1.6c53 0 96 43 96 96s-43 96-96 96H96zm16 32c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24s-24-10.7-24-24v-80c0-13.3 10.7-24 24-24zm192 0c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24s-24-10.7-24-24v-80c0-13.3 10.7-24 24-24zm-72 56v80c0 13.3-10.7 24-24 24s-24-10.7-24-24v-80c0-13.3 10.7-24 24-24s24 10.7 24 24zm168-24c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24s-24-10.7-24-24v-80c0-13.3 10.7-24 24-24z"
        }
    ]
};

const FasCloudSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCloudSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L600 445c24.6-23.3 40-56.3 40-93 0-61.9-44-113.6-102.4-125.4 4.1-10.7 6.4-22.4 6.4-34.6 0-53-43-96-96-96-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32c-46.4 0-88.2 19.8-117.4 51.3L38.8 5.1zm58.4 167.5C96.4 179 96 185.5 96 192c0 2.7.1 5.4.2 8.1C40.2 219.8 0 273.2 0 336c0 79.5 64.5 144 144 144h343.4L97.2 172.6z"
        }
    ]
};

const FasCloudSleet = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCloudSleet",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 320c-53 0-96-43-96-96 0-42.5 27.6-78.6 65.9-91.2-1.2-6.7-1.9-13.7-1.9-20.8C64 50.1 114.1 0 176 0c43.1 0 80.5 24.3 99.2 60 14.7-17.1 36.5-28 60.8-28 44.2 0 80 35.8 80 80 0 5.5-.6 10.8-1.6 16h1.6c53 0 96 43 96 96s-43 96-96 96H96zm-14.5 33.9c12.2 5.2 17.8 19.3 12.6 31.5l-48 112c-5.2 12.2-19.3 17.8-31.5 12.6s-17.9-19.3-12.7-31.5l48-112c5.2-12.2 19.3-17.8 31.5-12.6zm272 0c12.2 5.2 17.8 19.3 12.6 31.5l-48 112c-5.2 12.2-19.3 17.8-31.5 12.6s-17.8-19.3-12.6-31.5l48-112c5.2-12.2 19.3-17.8 31.5-12.6zM216 376v16h16c13.3 0 24 10.7 24 24s-10.7 24-24 24h-16v16c0 13.3-10.7 24-24 24s-24-10.7-24-24v-16h-16c-13.3 0-24-10.7-24-24s10.7-24 24-24h16v-16c0-13.3 10.7-24 24-24s24 10.7 24 24zm256 0v16h16c13.3 0 24 10.7 24 24s-10.7 24-24 24h-16v16c0 13.3-10.7 24-24 24s-24-10.7-24-24v-16h-16c-13.3 0-24-10.7-24-24s10.7-24 24-24h16v-16c0-13.3 10.7-24 24-24s24 10.7 24 24z"
        }
    ]
};

const FasCloudSnow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCloudSnow",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 320c-53 0-96-43-96-96 0-42.5 27.6-78.6 65.9-91.2-1.2-6.7-1.9-13.7-1.9-20.8C64 50.1 114.1 0 176 0c43.1 0 80.5 24.3 99.2 60 14.7-17.1 36.5-28 60.8-28 44.2 0 80 35.8 80 80 0 5.5-.6 10.8-1.6 16h1.6c53 0 96 43 96 96s-43 96-96 96H96zm-32 32c13.3 0 24 10.7 24 24v16h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H88v16c0 13.3-10.7 24-24 24s-24-10.7-24-24v-16H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h16v-16c0-13.3 10.7-24 24-24zm192 32c13.3 0 24 10.7 24 24v16h16c13.3 0 24 10.7 24 24s-10.7 24-24 24h-16v16c0 13.3-10.7 24-24 24s-24-10.7-24-24v-16h-16c-13.3 0-24-10.7-24-24s10.7-24 24-24h16v-16c0-13.3 10.7-24 24-24zm216-8v16h16c13.3 0 24 10.7 24 24s-10.7 24-24 24h-16v16c0 13.3-10.7 24-24 24s-24-10.7-24-24v-16h-16c-13.3 0-24-10.7-24-24s10.7-24 24-24h16v-16c0-13.3 10.7-24 24-24s24 10.7 24 24z"
        }
    ]
};

const FasCloudSunRain = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCloudSunRain",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M294.2 1.2c5.1 2.1 8.7 6.7 9.6 12.1l10.4 62.4c-23.3 10.8-42.9 28.4-56 50.3-14.6-9-31.8-14.1-50.2-14.1-53 0-96 43-96 96 0 35.5 19.3 66.6 48 83.2.8 31.8 13.2 60.7 33.1 82.7l-56 39.2c-4.5 3.1-10.3 3.8-15.4 1.6s-8.7-6.7-9.6-12.1l-14-84.6-84.7-14.1c-5.4-.9-10-4.5-12.1-9.6s-1.5-10.9 1.6-15.4L52.5 208 2.9 137.2c-3.2-4.5-3.8-10.3-1.6-15.4s6.7-8.7 12.1-9.6l84.7-14.1 14.1-84.7c.9-5.4 4.5-10 9.6-12.1s10.9-1.5 15.4 1.6L208 52.5l70.8-49.6c4.5-3.2 10.3-3.8 15.4-1.6zM208 144c13.8 0 26.7 4.4 37.1 11.9-1.2 4.1-2.2 8.3-3 12.6-37.9 14.6-67.2 46.6-77.8 86.4-12.5-11.8-20.3-28.4-20.3-46.9 0-35.3 28.7-64 64-64zm69.4 276c11 7.4 14 22.3 6.7 33.3l-32 48c-7.4 11-22.3 14-33.3 6.7s-14-22.3-6.7-33.3l32-48c7.4-11 22.3-14 33.3-6.7zm96 0c11 7.4 14 22.3 6.7 33.3l-32 48c-7.4 11-22.3 14-33.3 6.7s-14-22.3-6.7-33.3l32-48c7.4-11 22.3-14 33.3-6.7zm96 0c11 7.4 14 22.3 6.7 33.3l-32 48c-7.4 11-22.3 14-33.3 6.7s-14-22.3-6.7-33.3l32-48c7.4-11 22.3-14 33.3-6.7zm96 0c11 7.4 14 22.3 6.7 33.3l-32 48c-7.4 11-22.3 14-33.3 6.7s-14-22.3-6.7-33.3l32-48c7.4-11 22.3-14 33.3-6.7zm74.5-116.1c0 44.2-35.8 80-80 80H288c-53 0-96-43-96-96 0-47.6 34.6-87 80-94.6V192c0-53 43-96 96-96 34.9 0 65.4 18.6 82.2 46.4 13-9.1 28.8-14.4 45.8-14.4 44.2 0 80 35.8 80 80 0 5.9-.6 11.7-1.9 17.2 37.4 6.7 65.8 39.4 65.8 78.7z"
        }
    ]
};

const FasCloudSun = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCloudSun",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M294.2 1.2c5.1 2.1 8.7 6.7 9.6 12.1L317.9 98l84.7 14.1c5.4.9 10 4.5 12.1 9.6s1.5 10.9-1.6 15.4l-38.5 55c-2.2-.1-4.4-.2-6.7-.2-23.3 0-45.1 6.2-64 17.1v-1.1c0-53-43-96-96-96s-96 43-96 96 43 96 96 96c8.1 0 15.9-1 23.4-2.9-36.6 18.1-63.3 53.1-69.8 94.9l-24.4 17c-4.5 3.2-10.3 3.8-15.4 1.6s-8.7-6.7-9.6-12.1l-14-84.5-84.7-14.1c-5.4-.9-10-4.5-12.1-9.6s-1.5-10.9 1.6-15.4L52.5 208 2.9 137.2c-3.2-4.5-3.8-10.3-1.6-15.4s6.7-8.7 12.1-9.6l84.7-14.1 14.1-84.7c.9-5.4 4.5-10 9.6-12.1s10.9-1.5 15.4 1.6L208 52.5l70.8-49.6c4.5-3.2 10.3-3.8 15.4-1.6zM144 208a64 64 0 1 1 128 0 64 64 0 1 1-128 0zm495.9 223.9c0 44.2-35.8 80-80 80H288c-53 0-96-43-96-96 0-47.6 34.6-87 80-94.6V320c0-53 43-96 96-96 34.9 0 65.4 18.6 82.2 46.4 13-9.1 28.8-14.4 45.8-14.4 44.2 0 80 35.8 80 80 0 5.9-.6 11.7-1.9 17.2 37.4 6.7 65.8 39.4 65.8 78.7z"
        }
    ]
};

const FasCloudWord = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCloudWord",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 336c0 79.5 64.5 144 144 144h368c70.7 0 128-57.3 128-128 0-61.9-44-113.6-102.4-125.4 4.1-10.7 6.4-22.4 6.4-34.6 0-53-43-96-96-96-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32c-88.4 0-160 71.6-160 160 0 2.7.1 5.4.2 8.1C40.2 219.8 0 273.2 0 336zm512 32c0 8.8-7.2 16-16 16H304c-8.8 0-16-7.2-16-16s7.2-16 16-16h192c8.8 0 16 7.2 16 16zm-272-16c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16s7.2-16 16-16h96zm-112-48c0-8.8 7.2-16 16-16h192c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16zm272-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FasCloudXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCloudXmark",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 480C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9-.1-2.7-.2-5.4-.2-8.1 0-88.4 71.6-160 160-160 59.3 0 111 32.2 138.7 80.2A95.51 95.51 0 0 1 448 96c53 0 96 43 96 96 0 12.2-2.3 23.8-6.4 34.6C596 238.4 640 290.1 640 352c0 70.7-57.3 128-128 128H144zm95-273c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z"
        }
    ]
};

const FasCloud = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCloud",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 336c0 79.5 64.5 144 144 144h368c70.7 0 128-57.3 128-128 0-61.9-44-113.6-102.4-125.4 4.1-10.7 6.4-22.4 6.4-34.6 0-53-43-96-96-96-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32c-88.4 0-160 71.6-160 160 0 2.7.1 5.4.2 8.1C40.2 219.8 0 273.2 0 336z"
        }
    ]
};

const FasCloudsMoon = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCloudsMoon",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 160c0 11.5 1.2 22.7 3.5 33.4 53.7 8.2 96.5 49.8 106.4 103 14.2 5.5 27.2 13.4 38.5 23.2 3.7.3 7.4.4 11.2.4 43.2 0 82.5-17.3 111.2-45.3 5-4.9 6.3-12.5 3.1-18.7s-10.1-9.7-17-8.5c-6.5 1.1-13.2 1.7-20 1.7-64.3 0-116.5-52.3-116.5-116.9 0-43.7 23.9-81.8 59.3-101.9 6.1-3.5 9.2-10.5 7.7-17.3S532 1.2 525.1.6c-4.5-.4-9-.6-13.5-.6C423.4 0 352 71.7 352 160zM114.8 273.9c20.1-30.1 54.3-49.9 93.2-49.9 12.9 0 25.3 2.2 36.8 6.2 19.6-19.9 45.8-33.5 75-37.2v-.9c0-35.3-28.6-64-64-64-7.4 0-14.6 1.3-21.2 3.6-11.5-30.1-40.6-51.6-74.8-51.6-38.9 0-71.3 27.8-78.5 64.6-3.1-.4-6.3-.6-9.5-.6-39.8 0-72 32.2-72 72s32.2 72 72 72c16.1 0 30.9-5.3 42.9-14.1zM64 431.9c0 44.2 35.8 80 80 80h271.9c53 0 96-43 96-96 0-47.6-34.6-87-80-94.6V320c0-53-43-96-96-96-34.9 0-65.4 18.6-82.2 46.4C240.8 261.3 225 256 208 256c-44.2 0-80 35.8-80 80 0 5.9.6 11.7 1.9 17.2-37.5 6.7-65.9 39.4-65.9 78.7z"
        }
    ]
};

const FasCloudsSun = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCloudsSun",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M294.2 1.2c5.1 2.1 8.7 6.7 9.6 12.1L317.9 98l30.7 5.1c-26.4 10.6-47 32.6-55.7 59.9-16.1-30.3-48.1-51-84.9-51-53 0-96 43-96 96s43 96 96 96c8.1 0 15.9-1 23.4-2.9-36.6 18.1-63.3 53.1-69.8 94.9l-24.4 17.1c-4.5 3.1-10.3 3.8-15.4 1.6s-8.7-6.7-9.6-12.1l-14.1-84.7-84.7-14.1c-5.4-.9-10-4.5-12.1-9.6s-1.5-10.9 1.6-15.4L52.5 208 2.9 137.2c-3.2-4.5-3.8-10.3-1.6-15.4s6.7-8.7 12.1-9.6l84.7-14.1 14.1-84.7c.9-5.4 4.5-10 9.6-12.1s10.9-1.5 15.4 1.6L208 52.5l70.8-49.6c4.5-3.2 10.3-3.8 15.4-1.6zM144 208a64 64 0 1 1 128 0 64 64 0 1 1-128 0zm450.6 75c-18.9-35.1-56-59-98.7-59-12.9 0-25.3 2.2-36.8 6.2-23.2-23.6-55.4-38.2-91.1-38.2-16.7 0-32.6 3.2-47.3 9-.4-2.9-.6-5.9-.6-8.9 0-35.3 28.6-64 64-64 7.4 0 14.6 1.3 21.2 3.6 11.5-30.1 40.6-51.6 74.8-51.6 38.9 0 71.3 27.8 78.5 64.6 3.1-.4 6.3-.6 9.5-.6 39.8 0 72 32.2 72 72 0 30.4-18.8 56.3-45.4 66.9zm45.3 148.9c0 44.2-35.8 80-80 80H288c-53 0-96-43-96-96 0-47.6 34.6-87 80-94.6V320c0-53 43-96 96-96 34.9 0 65.4 18.6 82.2 46.4 13-9.1 28.8-14.4 45.8-14.4 44.2 0 80 35.8 80 80 0 5.9-.6 11.7-1.9 17.2 37.4 6.7 65.8 39.4 65.8 78.7z"
        }
    ]
};

const FasClouds = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasClouds",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M304 160c-74.1 0-135.2 56-143.1 128H96c-53 0-96-43-96-96s43-96 96-96h1.1C104.9 41.7 151.6 0 208 0c47.9 0 88.8 30.1 104.8 72.4C324.8 67 338 64 352 64c53 0 96 43 96 96 0 12.1-2.2 23.6-6.3 34.2-11.4 2.3-22.2 6.4-32.1 11.9C383.3 177.7 345.7 160 304 160zm-80 352c-53 0-96-43-96-96 0-42.5 27.6-78.6 65.9-91.2-1.3-6.7-1.9-13.7-1.9-20.8 0-61.9 50.1-112 112-112 43.1 0 80.5 24.3 99.2 60 14.7-17.1 36.5-28 60.8-28 44.2 0 80 35.8 80 80 0 5.5-.6 10.8-1.6 16h1.6c53 0 96 43 96 96s-43 96-96 96H224z"
        }
    ]
};

const FasClover = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasClover",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M173.3 32C139.4 32 112 59.4 112 93.3v4.9c0 12 3.3 23.7 9.4 34l18.8 31.3c1.1 1.8 1.2 3.1 1 4.2-.2 1.2-.8 2.5-2 3.6s-2.4 1.8-3.6 2c-1 .2-2.4.1-4.2-1l-31.3-18.8c-10.3-6.2-22-9.4-34-9.4h-4.8C27.4 144 0 171.4 0 205.3c0 16.2 6.5 31.8 17.9 43.3l1.2 1.2c3.4 3.4 3.4 9 0 12.4l-1.2 1.2C6.5 274.9 0 290.5 0 306.7 0 340.6 27.4 368 61.3 368h4.9c12 0 23.7-3.3 34-9.4l31.3-18.8c1.8-1.1 3.1-1.2 4.2-1 1.2.2 2.5.8 3.6 2s1.8 2.4 2 3.6c.2 1 .1 2.4-1 4.2l-18.8 31.3c-6.2 10.3-9.4 22-9.4 34v4.9c0 33.8 27.4 61.3 61.3 61.3 16.2 0 31.8-6.5 43.3-17.9l1.2-1.2c3.4-3.4 9-3.4 12.4 0l1.2 1.2c11.5 11.5 27.1 17.9 43.3 17.9 33.8 0 61.3-27.4 61.3-61.3v-4.9c0-12-3.3-23.7-9.4-34l-18.8-31.3c-1.1-1.8-1.2-3.1-1-4.2.2-1.2.8-2.5 2-3.6s2.4-1.8 3.6-2c1-.2 2.4-.1 4.2 1l31.3 18.8c10.3 6.2 22 9.4 34 9.4h4.9c33.8 0 61.3-27.4 61.3-61.3 0-16.2-6.5-31.8-17.9-43.3l-1.2-1.2c-3.4-3.4-3.4-9 0-12.4l1.2-1.2c11.5-11.5 17.9-27.1 17.9-43.3 0-33.8-27.4-61.3-61.3-61.3H382c-12 0-23.7 3.3-34 9.4l-31.3 18.8c-1.8 1.1-3.1 1.2-4.2 1-1.2-.2-2.5-.8-3.6-2s-1.8-2.4-2-3.6c-.2-1-.1-2.4 1-4.2l18.8-31.3c6.2-10.3 9.4-22 9.4-34v-4.8C336 59.4 308.6 32 274.7 32c-16.2 0-31.8 6.5-43.3 17.9l-1.2 1.2c-3.4 3.4-9 3.4-12.4 0l-1.2-1.2C205.1 38.5 189.5 32 173.3 32z"
        }
    ]
};

const FasClub = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasClub",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M380 160.1c2.6-10.2 4-21 4-32.1C384 57.3 326.7 0 256 0S128 57.3 128 128c0 11.1 1.4 21.8 4 32.1-1.3 0-2.7-.1-4-.1C57.3 160 0 217.3 0 288s57.3 128 128 128c38.2 0 72.5-16.8 96-43.3V448h-32c-17.7 0-32 14.3-32 32s14.3 32 32 32h128c17.7 0 32-14.3 32-32s-14.3-32-32-32h-32v-75.3c23.5 26.6 57.8 43.3 96 43.3 70.7 0 128-57.3 128-128s-57.3-128-128-128c-1.4 0-2.7 0-4 .1z"
        }
    ]
};

const FasCoconut = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCoconut",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M141.2 141.2c-43.7 43.7-73 91.8-85.8 133.3-13.2 42.7-7.4 71.9 7.5 86.7s44 20.6 86.7 7.5c41.5-12.8 89.6-42.1 133.3-85.8s73-91.8 85.8-133.3c13.2-42.7 7.4-71.9-7.5-86.7s-44-20.6-86.7-7.5c-41.5 12.7-89.6 42.1-133.3 85.8zM260.4 9.5C309.6-5.7 361.5-4.8 395.2 28.8l40.9 40.9c48.6 48.7 75.9 114.6 75.9 183.2C512 396 396 512 253 512c-68.7 0-134.6-27.3-183.2-75.9l-41-41C-4.8 361.5-5.7 309.6 9.5 260.3c15.6-50.4 49.7-105 97.8-153.1S210 25 260.4 9.5zm63.5 88.1c25 25-5.4 95.9-67.9 158.4s-133.4 92.9-158.4 67.9 5.4-95.9 67.9-158.4 133.4-92.9 158.4-67.9zm95.4 107.1c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l32 32c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-32-32zm-56 136c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l32 32c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-32-32zm-136 56c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l32 32c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-32-32z"
        }
    ]
};

const FasCodeBranch = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCodeBranch",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 104a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm80-24c0 32.8-19.7 61-48 73.3v87.8c18.8-10.9 40.7-17.1 64-17.1h96c35.3 0 64-28.7 64-64v-6.7c-28.3-12.3-48-40.5-48-73.3 0-44.2 35.8-80 80-80s80 35.8 80 80c0 32.8-19.7 61-48 73.3v6.7c0 70.7-57.3 128-128 128h-96c-35.3 0-64 28.7-64 64v6.7c28.3 12.3 48 40.5 48 73.3 0 44.2-35.8 80-80 80S0 476.2 0 432c0-32.8 19.7-61 48-73.3V153.3C19.7 141 0 112.8 0 80 0 35.8 35.8 0 80 0s80 35.8 80 80zm232 0a24 24 0 1 0-48 0 24 24 0 1 0 48 0zM80 456a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FasCodeCommit = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCodeCommit",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 336a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm156.8-48C462 361 397.4 416 320 416s-142-55-156.8-128H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h131.2C178 151 242.6 96 320 96s142 55 156.8 128H608c17.7 0 32 14.3 32 32s-14.3 32-32 32H476.8z"
        }
    ]
};

const FasCodeCompare = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCodeCompare",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 488c0 9.5-5.6 18.1-14.2 21.9s-18.8 2.3-25.8-4.1l-80-72c-5.1-4.6-7.9-11-7.9-17.8s2.9-13.3 7.9-17.8l80-72c7-6.3 17.2-7.9 25.8-4.1S320 334.5 320 344v40h16c35.3 0 64-28.7 64-64V153.3c-28.3-12.3-48-40.5-48-73.3 0-44.2 35.8-80 80-80s80 35.8 80 80c0 32.8-19.7 61-48 73.3V320c0 70.7-57.3 128-128 128h-16v40zM456 80a24 24 0 1 0-48 0 24 24 0 1 0 48 0zM192 24c0-9.5 5.6-18.1 14.2-21.9S225-.2 232 6.2l80 72c5.1 4.6 7.9 11 7.9 17.8s-2.9 13.3-7.9 17.8l-80 72c-7 6.3-17.2 7.9-25.8 4.1S192 177.5 192 168v-40h-16c-35.3 0-64 28.7-64 64v166.7c28.3 12.3 48 40.5 48 73.3 0 44.2-35.8 80-80 80S0 476.2 0 432c0-32.8 19.7-61 48-73.3V192c0-70.7 57.3-128 128-128h16V24zM56 432a24 24 0 1 0 48 0 24 24 0 1 0-48 0z"
        }
    ]
};

const FasCodeFork = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCodeFork",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 104a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm80-24c0 32.8-19.7 61-48 73.3V192c0 17.7 14.3 32 32 32h160c17.7 0 32-14.3 32-32v-38.7c-28.3-12.3-48-40.5-48-73.3 0-44.2 35.8-80 80-80s80 35.8 80 80c0 32.8-19.7 61-48 73.3V192c0 53-43 96-96 96h-48v70.7c28.3 12.3 48 40.5 48 73.3 0 44.2-35.8 80-80 80s-80-35.8-80-80c0-32.8 19.7-61 48-73.3V288h-48c-53 0-96-43-96-96v-38.7C19.7 141 0 112.8 0 80 0 35.8 35.8 0 80 0s80 35.8 80 80zm208 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM248 432a24 24 0 1 0-48 0 24 24 0 1 0 48 0z"
        }
    ]
};

const FasCodeMerge = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCodeMerge",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm32.4 97.2c28-12.4 47.6-40.5 47.6-73.2 0-44.2-35.8-80-80-80S0 35.8 0 80c0 32.8 19.7 61 48 73.3v205.4C19.7 371 0 399.2 0 432c0 44.2 35.8 80 80 80s80-35.8 80-80c0-32.8-19.7-61-48-73.3V272c26.7 20.1 60 32 96 32h86.7c12.3 28.3 40.5 48 73.3 48 44.2 0 80-35.8 80-80s-35.8-80-80-80c-32.8 0-61 19.7-73.3 48H208c-49.9 0-91-38.1-95.6-86.8zM80 408a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm264-136a24 24 0 1 1 48 0 24 24 0 1 1-48 0z"
        }
    ]
};

const FasCodePullRequestClosed = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCodePullRequestClosed",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M329.4 9.4c12.5-12.5 32.8-12.5 45.3 0L400 34.7l25.4-25.3c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L445.3 80l25.4 25.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L400 125.3l-25.4 25.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L354.7 80l-25.3-25.4c-12.5-12.5-12.5-32.8 0-45.3zM136 80a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm56 0c0 32.8-19.7 61-48 73.3v205.4c28.3 12.3 48 40.5 48 73.3 0 44.2-35.8 80-80 80s-80-35.8-80-80c0-32.8 19.7-61 48-73.3V153.3C51.7 141 32 112.8 32 80c0-44.2 35.8-80 80-80s80 35.8 80 80zm-80 376a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm288 0a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0 56c-44.2 0-80-35.8-80-80 0-32.8 19.7-61 48-73.3V224c0-17.7 14.3-32 32-32s32 14.3 32 32v134.7c28.3 12.3 48 40.5 48 73.3 0 44.2-35.8 80-80 80z"
        }
    ]
};

const FasCodePullRequestDraft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCodePullRequestDraft",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M56 80a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm56 73.3c28.3-12.3 48-40.5 48-73.3 0-44.2-35.8-80-80-80S0 35.8 0 80c0 32.8 19.7 61 48 73.3v205.4C19.7 371 0 399.2 0 432c0 44.2 35.8 80 80 80s80-35.8 80-80c0-32.8-19.7-61-48-73.3V153.3zM56 432a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm312-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 104a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm48-432a48 48 0 1 0-96 0 48 48 0 1 0 96 0zm-48 208a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
        }
    ]
};

const FasCodePullRequest = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCodePullRequest",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M305.8 2.1C314.4 5.9 320 14.5 320 24v40h16c70.7 0 128 57.3 128 128v166.7c28.3 12.3 48 40.5 48 73.3 0 44.2-35.8 80-80 80s-80-35.8-80-80c0-32.8 19.7-61 48-73.3V192c0-35.3-28.7-64-64-64h-16v40c0 9.5-5.6 18.1-14.2 21.9s-18.8 2.3-25.8-4.1l-80-72c-5.1-4.6-7.9-11-7.9-17.8s2.9-13.3 7.9-17.8l80-72c7-6.3 17.2-7.9 25.8-4.1zM104 80a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm8 73.3v205.4c28.3 12.3 48 40.5 48 73.3 0 44.2-35.8 80-80 80S0 476.2 0 432c0-32.8 19.7-61 48-73.3V153.3C19.7 141 0 112.8 0 80 0 35.8 35.8 0 80 0s80 35.8 80 80c0 32.8-19.7 61-48 73.3zM104 432a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm328 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FasCodeSimple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCodeSimple",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256l137.3-137.4zm146.7 0L498.7 256 361.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3z"
        }
    ]
};

const FasCode = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCode",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M392.8 1.2c-17-4.9-34.7 5-39.6 22l-128 448c-4.9 17 5 34.7 22 39.6s34.7-5 39.6-22l128-448c4.9-17-5-34.7-22-39.6zm80.6 120.1c-12.5 12.5-12.5 32.8 0 45.3l89.3 89.4-89.4 89.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l112-112c12.5-12.5 12.5-32.8 0-45.3l-112-112c-12.5-12.5-32.8-12.5-45.3 0zm-306.7 0c-12.5-12.5-32.8-12.5-45.3 0l-112 112c-12.5 12.5-12.5 32.8 0 45.3l112 112c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256l89.4-89.4c12.5-12.5 12.5-32.8 0-45.3z"
        }
    ]
};

const FasCoffeeBean = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCoffeeBean",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M331.4 203.3c24.4-24.6 45.4-67.3 59.9-101.7 5.1-12.2 20.9-15.3 28.2-4.3 51.2 77.7 26.2 201.2-63.4 290.8-79.6 79.6-186 108.1-263.2 77.7-14.8-5.8-20-23.2-13.2-37.5.7-1.6 1.5-3.1 2.2-4.7 16.5-34.5 37.5-72.2 57.4-92.3 29.7-29.9 59.7-44.9 91.8-61l.5-.3c32-15.9 66.1-32.9 99.7-66.8zM53.1 409.7c-5.3 11-19.9 13.6-26.9 3.6-54-77.4-29.6-203.2 61.2-294 80.2-80.2 187.7-108.6 265.1-76.9 14 5.7 19.4 22 13.7 36-1.4 3.5-2.9 7.1-4.4 10.8-14.5 34.5-33.5 71.8-53.1 91.5-29.7 29.9-59.7 44.9-91.8 61l-.5.3c-32 15.9-66.1 32.9-99.7 66.8-24.1 24.3-47.1 66.6-63.6 101z"
        }
    ]
};

const FasCoffeeBeans = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCoffeeBeans",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M507.5 209.7c-3.4 12.3-19.1 11.8-25.4.7-5.4-9.5-11.3-18.5-17.6-26-27.6-32.6-60.8-44.5-90.1-55l-1-.3c-30-10.7-55.8-20.2-77.5-45.9-10.8-12.8-21.3-33.4-29.3-52-1.7-4-.6-8.7 3-11.2C320.9-16 401.3-2.6 458 54c45.7 45.7 63.2 106.7 49.5 155.6zm-279-131.4c3.4-12.3 19.1-11.8 25.4-.7 5.3 9.5 11.3 18.5 17.6 26 27.6 32.6 60.8 44.5 90.1 55l1 .3c30 10.7 55.8 20.2 77.5 45.9 10.8 12.8 21.3 33.4 29.3 52 1.7 4 .6 8.7-3 11.2-51.3 36-131.7 22.6-188.4-34-45.7-45.7-63.2-106.7-49.5-155.6zM75.5 206c11.2-6.3 22 5.2 18.5 17.6-2.9 10.5-5.2 21.2-6 31-3.6 42.8 11.6 74.9 25 103.2l.4.9c13.7 28.9 25.3 54.1 22.5 87.8-1.4 16.7-8.6 38.9-16.1 57.9-1.6 4.1-5.8 6.6-10.1 5.8C47.7 499.3 0 432.6 0 352c0-65 31-120.9 75.5-146zm105 292c-11.2 6.3-22-5.2-18.5-17.6 2.9-10.5 5.2-21.2 6-31 3.6-42.8-11.6-74.9-25-103.2l-.4-.9c-13.7-28.9-25.3-54.1-22.5-87.8 1.4-16.7 8.6-38.9 16.1-57.9 1.6-4.1 5.8-6.6 10.1-5.8C208.3 204.7 256 271.4 256 352c0 65-31 120.9-75.5 146z"
        }
    ]
};

const FasCoffeePot = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCoffeePot",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 128c0-17.7 14.3-32 32-32h12.8l34 84.9C95 215.9 64 272.3 64 336v8c0 55.5 34.6 99.4 55.9 121.2 9.9 10.2 23.9 14.8 38.1 14.8h260c14.2 0 28.1-4.7 38.1-14.8C477.4 443.4 512 399.5 512 344v-8c0-63.7-31-120.1-78.8-155.1l44.9-112.1c1.3-3.2 1.9-6.6 1.9-10C480 44 468 32 453.2 32H96C43 32 0 75 0 128v64c0 17.7 14.3 32 32 32s32-14.3 32-32v-64zm65 192c5.2-41.4 30.1-76.6 65-96h188c34.9 19.4 59.8 54.6 65 96H129z"
        }
    ]
};

const FasCoffinCross = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCoffinCross",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m102.4 10.9-91 104a46.668 46.668 0 0 0-9.6 43.4l95.5 330.6c4 13.7 16.5 23.1 30.7 23.1h127.9c14.3 0 26.8-9.4 30.7-23.1l95.5-330.6c1.2-4.2 1.8-8.5 1.8-12.9 0-11.2-4.1-22.1-11.5-30.6l-91-104C275.5 4 266.7 0 257.5 0h-131c-9.2 0-18 4-24.1 10.9zM216 120v40h48c13.3 0 24 10.7 24 24s-10.7 24-24 24h-48v120c0 13.3-10.7 24-24 24s-24-10.7-24-24V208h-48c-13.3 0-24-10.7-24-24s10.7-24 24-24h48v-40c0-13.3 10.7-24 24-24s24 10.7 24 24z"
        }
    ]
};

const FasCoffin = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCoffin",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m11.5 114.9 91-104c6-6.9 14.8-10.9 24-10.9h131c9.2 0 18 4 24.1 10.9l91 104c7.4 8.5 11.5 19.3 11.5 30.6 0 4.4-.6 8.7-1.8 12.9l-95.6 330.5c-4 13.7-16.5 23.1-30.7 23.1H128.1c-14.3 0-26.8-9.4-30.7-23.1L1.8 158.3C.6 154.1 0 149.8 0 145.4c0-11.2 4.1-22.1 11.5-30.6z"
        }
    ]
};

const FasCoinBlank = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCoinBlank",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 208c0 79.5 114.6 144 256 144s256-64.5 256-144S397.4 64 256 64 0 128.5 0 208zm0 82.1V320c0 27.9 17.8 53.6 48 74.6V331c-18.3-11.5-34.8-25.2-48-40.9zM80 413c27.1 12.8 59.8 22.7 96 28.7v-64.3c-35.1-6-67.6-15.9-96-29V413zm128 32.8c15.5 1.5 31.6 2.2 48 2.2s32.5-.8 48-2.2v-64.1c-15.7 1.6-31.7 2.4-48 2.4s-32.3-.8-48-2.4v64.1zm128-4.1c36.2-6 68.9-15.9 96-28.7v-64.7c-28.4 13.2-60.9 23-96 29v64.3zm128-47c30.2-21 48-46.8 48-74.6v-29.9c-13.2 15.6-29.7 29.3-48 40.9v63.7z"
        }
    ]
};

const FasCoinFront = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCoinFront",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zM256 96a160 160 0 1 1 0 320 160 160 0 1 1 0-320zm0 352a192 192 0 1 0 0-384 192 192 0 1 0 0 384zm24-264c0-13.3-10.7-24-24-24s-24 10.7-24 24v144c0 13.3 10.7 24 24 24s24-10.7 24-24V184z"
        }
    ]
};

const FasCoinVertical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCoinVertical",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 256c0 141.4-64.5 256-144 256S0 397.4 0 256 64.5 0 144 0s144 114.6 144 256zM184.2 425.4c11.4-12 20.1-27.7 26.8-44.4 13.4-33.6 21-77.8 21-125s-7.6-91.4-21-125c-6.7-16.7-15.4-32.4-26.8-44.4C172.7 74.5 156.5 64 136 64S99.3 74.5 87.8 86.6C76.5 98.6 67.7 114.3 61 131c-13.4 33.6-21 77.8-21 125s7.6 91.4 21 125c6.7 16.7 15.4 32.4 26.8 44.4C99.3 437.5 115.5 448 136 448s36.7-10.5 48.2-22.6zM136 416c-35.3 0-64-71.6-64-160s28.7-160 64-160 64 71.6 64 160-28.7 160-64 160zm90.1 96c15.6-13.2 29.3-29.7 40.9-48h63.7c-21 30.2-46.8 48-74.6 48h-30zM349 432h-64.7c13.2-28.4 23-60.9 29-96h64.3c-6 36.2-15.9 68.9-28.7 96zm32.8-128h-64.2c1.6-15.7 2.4-31.7 2.4-48s-.8-32.3-2.4-48h64.1c1.5 15.5 2.2 31.6 2.2 48s-.8 32.5-2.2 48zm-4.1-128h-64.4c-6-35.1-15.9-67.6-29-96H349c12.8 27.1 22.7 59.8 28.7 96zm-47-128H267c-11.5-18.3-25.2-34.8-40.9-48H256c27.9 0 53.6 17.8 74.6 48z"
        }
    ]
};

const FasCoin = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCoin",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 352C114.6 352 0 287.5 0 208S114.6 64 256 64s256 64.5 256 144-114.6 144-256 144zM86.6 248.2c12 11.4 27.7 20.1 44.4 26.8 33.6 13.4 77.8 21 125 21s91.4-7.6 125-21c16.7-6.7 32.4-15.4 44.4-26.8 12.1-11.5 22.6-27.7 22.6-48.2s-10.5-36.7-22.6-48.2c-12-11.4-27.7-20.1-44.4-26.8-33.6-13.4-77.8-21-125-21s-91.4 7.6-125 21c-16.7 6.7-32.4 15.4-44.4 26.8C74.5 163.3 64 179.5 64 200s10.5 36.7 22.6 48.2zM96 200c0-35.3 71.6-64 160-64s160 28.7 160 64-71.6 64-160 64-160-28.7-160-64zM0 290.1c13.2 15.6 29.7 29.3 48 40.9v63.7C17.8 373.6 0 347.9 0 320v-29.9zM80 413v-64.7c28.4 13.2 60.9 23 96 29v64.3c-36.2-6-68.9-15.9-96-28.7zm128 32.8v-64.1c15.7 1.6 31.7 2.4 48 2.4s32.3-.8 48-2.4v64.1c-15.5 1.5-31.6 2.2-48 2.2s-32.5-.8-48-2.2zm128-4.1v-64.3c35.1-6 67.6-15.9 96-29v64.7c-27.1 12.8-59.8 22.7-96 28.7zm128-47V331c18.3-11.5 34.8-25.2 48-40.9V320c0 27.9-17.8 53.6-48 74.6z"
        }
    ]
};

const FasCoins = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCoins",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 80c0 18-14.3 34.6-38.4 48-29.1 16.1-72.5 27.5-122.3 30.9-3.7-1.8-7.4-3.5-11.3-5-39.4-16.5-91.8-25.9-148-25.9-8.3 0-16.4.2-24.5.6l-1.1-.6C142.3 114.6 128 98 128 80c0-44.2 86-80 192-80s192 35.8 192 80zm-351.3 81.1c10.2-.7 20.7-1.1 31.3-1.1 62.2 0 117.4 12.3 152.5 31.4 24.8 13.5 39.5 30.3 39.5 48.6 0 4-.7 7.9-2.1 11.7-4.6 13.2-17 25.3-35 35.5-.1.1-.3.1-.4.2-.3.2-.6.3-.9.5-35 19.4-90.8 32-153.6 32-59.6 0-112.9-11.3-148.2-29.1-1.9-.9-3.7-1.9-5.5-2.9C14.3 274.6 0 258 0 240c0-34.8 53.4-64.5 128-75.4 10.5-1.5 21.4-2.7 32.7-3.5zM416 240c0-21.9-10.6-39.9-24.1-53.4 28.3-4.4 54.2-11.4 76.2-20.5 16.3-6.8 31.5-15.2 43.9-25.5V176c0 19.3-16.5 37.1-43.8 50.9-14.6 7.4-32.4 13.7-52.4 18.5.1-1.8.2-3.5.2-5.3zm-32 96c0 18-14.3 34.6-38.4 48-1.8 1-3.6 1.9-5.5 2.9C304.9 404.7 251.6 416 192 416c-62.8 0-118.6-12.6-153.6-32C14.3 370.6 0 354 0 336v-35.4c12.5 10.3 27.6 18.7 43.9 25.5C83.4 342.6 135.8 352 192 352s108.6-9.4 148.1-25.9c7.8-3.2 15.3-6.9 22.4-10.9 6.1-3.4 11.8-7.2 17.2-11.2 1.5-1.1 2.9-2.3 4.3-3.4V336zm32 0v-57.9c19-4.2 36.5-9.5 52.1-16 16.3-6.8 31.5-15.2 43.9-25.5V272c0 10.5-5 21-14.9 30.9-16.3 16.3-45 29.7-81.3 38.4.1-1.7.2-3.5.2-5.3zM192 448c56.2 0 108.6-9.4 148.1-25.9 16.3-6.8 31.5-15.2 43.9-25.5V432c0 44.2-86 80-192 80S0 476.2 0 432v-35.4c12.5 10.3 27.6 18.7 43.9 25.5C83.4 438.6 135.8 448 192 448z"
        }
    ]
};

const FasColonSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasColonSign",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M255 39.8c4.3-17.1-6.1-34.5-23.3-38.8S197.2 7.1 193 24.2l-11.1 44.4C96.1 87.8 32 164.4 32 256c0 58.1 25.8 110.2 66.7 145.4L81 472.2c-4.3 17.1 6.1 34.5 23.3 38.8s34.5-6.1 38.8-23.3l13-52.1c9 3.4 18.4 6.2 28 8.2l-7.1 28.4c-4.3 17.1 6.1 34.5 23.3 38.8s34.5-6.1 38.8-23.3l10.4-41.4c33.4-4.4 64.1-17.4 89.8-36.7 14.1-10.6 17-30.7 6.4-44.8s-30.7-17-44.8-6.4c-10.2 7.7-21.7 13.9-34 18.3L321 160c9.4-.3 18.5-4.7 24.6-12.8 10.6-14.1 7.8-34.2-6.4-44.8l-3.3-2.4L351 39.8c4.3-17.1-6.1-34.5-23.3-38.8S293.2 7.1 289 24.2l-11.8 47.3c-9.3-2.7-18.8-4.6-28.6-5.9l6.4-25.8zm-91.8 103.5-45.9 183.5C103.9 306.5 96 282.2 96 256c0-48.7 27.2-91 67.2-112.7zm8.6 229.5 61.1-244.6c9.9.7 19.5 2.5 28.7 5.3l-62 248.1c-9.7-1.9-19-4.8-27.8-8.8z"
        }
    ]
};

const FasColon = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasColon",
    "viewBox": "0 0 192 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 192a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm0 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"
        }
    ]
};

const FasColumns3 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasColumns3",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm128 64v320H64V96h128zm64 0h128v320H256V96zm320 0v320H448V96h128z"
        }
    ]
};

const FasComet = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasComet",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M299.4 75.6 493.7.9c1.5-.6 3.2-.9 4.8-.9C506 0 512 6 512 13.5c0 1.7-.3 3.3-.9 4.8l-74.7 194.3 29.3-2.3c12.8-1 21.5 12.8 15.1 24L378.6 410.7C342.3 473.4 275.4 512 203 512 90.9 512 0 421.1 0 309c0-72.4 38.6-139.4 101.3-175.7L277.7 31.2c11.1-6.5 25 2.2 24 15.1l-2.3 29.3zM192 200c-6.1 0-11.7 3.5-14.3 8.9l-29.2 59.2-65.3 9.5c-6 .9-11 5.1-12.9 10.9s-.3 12.2 4 16.4l47.2 46-11.2 65c-1 6 1.4 12.1 6.4 15.7s11.5 4.1 16.8 1.2l58.5-30.7 58.4 30.7c5.4 2.8 11.9 2.4 16.8-1.2s7.4-9.6 6.4-15.7l-11.2-65 47.2-46c4.4-4.3 5.9-10.6 4-16.4s-6.9-10-12.9-10.9l-65.3-9.5-29.2-59.2c-2.7-5.5-8.3-8.9-14.3-8.9z"
        }
    ]
};

const FasComma = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasComma",
    "viewBox": "0 0 192 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 350.4V349c0-33.7-27.3-61-61-61-29.5 0-54.8 21.1-60.1 50.1l-22.2 122c-.5 2.6-.7 5.2-.7 7.9v8.2c0 19.7 16.1 35.8 35.9 35.8 12.5 0 24.1-6.5 30.6-17.2L150.8 383c6-9.8 9.2-21.1 9.2-32.6z"
        }
    ]
};

const FasCommand = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCommand",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 96C0 43 43 0 96 0s96 43 96 96v32h128V96c0-53 43-96 96-96s96 43 96 96-43 96-96 96h-32v128h32c53 0 96 43 96 96s-43 96-96 96-96-43-96-96v-32H192v32c0 53-43 96-96 96S0 469 0 416s43-96 96-96h32V192H96c-53 0-96-43-96-96zm128 32V96c0-17.7-14.3-32-32-32S64 78.3 64 96s14.3 32 32 32h32zm64 192h128V192H192v128zm-64 64H96c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32v-32zm256 0v32c0 17.7 14.3 32 32 32s32-14.3 32-32-14.3-32-32-32h-32zm0-256h32c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32v32z"
        }
    ]
};

const FasCommentArrowDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCommentArrowDown",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32 0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9-1.9 24.5-11.4 46.3-21.4 62.9-5.5 9.2-11.1 16.6-15.2 21.6-2.1 2.5-3.7 4.4-4.9 5.7-.6.6-1 1.1-1.3 1.4l-.3.3c-4.6 4.6-5.9 11.4-3.4 17.4 2.5 6 8.3 9.9 14.8 9.9 28.7 0 57.6-8.9 81.6-19.3 22.9-10 42.4-21.9 54.3-30.6 31.8 11.5 67 17.9 104.1 17.9zm24-296v118.1l31-31c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-72 72c-9.4 9.4-24.6 9.4-33.9 0l-72-72c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l31 31V152c0-13.3 10.7-24 24-24s24 10.7 24 24z"
        }
    ]
};

const FasCommentArrowUpRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCommentArrowUpRight",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32 0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9-1.9 24.5-11.4 46.3-21.4 62.9-5.5 9.2-11.1 16.6-15.2 21.6-2.1 2.5-3.7 4.4-4.9 5.7-.6.6-1 1.1-1.3 1.4l-.3.3c-4.6 4.6-5.9 11.4-3.4 17.4 2.5 6 8.3 9.9 14.8 9.9 28.7 0 57.6-8.9 81.6-19.3 22.9-10 42.4-21.9 54.3-30.6 31.8 11.5 67 17.9 104.1 17.9zm-56-288h112c13.3 0 24 10.7 24 24v112c0 13.3-10.7 24-24 24s-24-10.7-24-24v-54.1l-87 87c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l87-87H200c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
        }
    ]
};

const FasCommentArrowUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCommentArrowUp",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32 0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9-1.9 24.5-11.4 46.3-21.4 62.9-5.5 9.2-11.1 16.6-15.2 21.6-2.1 2.5-3.7 4.4-4.9 5.7-.6.6-1 1.1-1.3 1.4l-.3.3c-4.6 4.6-5.9 11.4-3.4 17.4 2.5 6 8.3 9.9 14.8 9.9 28.7 0 57.6-8.9 81.6-19.3 22.9-10 42.4-21.9 54.3-30.6 31.8 11.5 67 17.9 104.1 17.9zm24-120c0 13.3-10.7 24-24 24s-24-10.7-24-24V209.9l-31 31c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l72-72c9.4-9.4 24.6-9.4 33.9 0l72 72c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-31-31V328z"
        }
    ]
};

const FasCommentCaptions = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCommentCaptions",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32 0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9-1.9 24.5-11.4 46.3-21.4 62.9-5.5 9.2-11.1 16.6-15.2 21.6-2.1 2.5-3.7 4.4-4.9 5.7-.6.6-1 1.1-1.3 1.4l-.3.3c-4.6 4.6-5.9 11.4-3.4 17.4 2.5 6 8.3 9.9 14.8 9.9 28.7 0 57.6-8.9 81.6-19.3 22.9-10 42.4-21.9 54.3-30.6 31.8 11.5 67 17.9 104.1 17.9zM120 208h144c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24s10.7-24 24-24zm224 0h48c13.3 0 24 10.7 24 24s-10.7 24-24 24h-48c-13.3 0-24-10.7-24-24s10.7-24 24-24zm-224 80h48c13.3 0 24 10.7 24 24s-10.7 24-24 24h-48c-13.3 0-24-10.7-24-24s10.7-24 24-24zm128 0h144c13.3 0 24 10.7 24 24s-10.7 24-24 24H248c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
        }
    ]
};

const FasCommentCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCommentCheck",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32 0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9-1.9 24.5-11.4 46.3-21.4 62.9-5.5 9.2-11.1 16.6-15.2 21.6-2.1 2.5-3.7 4.4-4.9 5.7-.6.6-1 1.1-1.3 1.4l-.3.3c-4.6 4.6-5.9 11.4-3.4 17.4 2.5 6 8.3 9.9 14.8 9.9 28.7 0 57.6-8.9 81.6-19.3 22.9-10 42.4-21.9 54.3-30.6 31.8 11.5 67 17.9 104.1 17.9zm113-255L241 321c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 159c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
        }
    ]
};

const FasCommentCode = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCommentCode",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32 0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9-1.9 24.5-11.4 46.3-21.4 62.9-5.5 9.2-11.1 16.6-15.2 21.6-2.1 2.5-3.7 4.4-4.9 5.7-.6.6-1 1.1-1.3 1.4l-.3.3c-4.6 4.6-5.9 11.4-3.4 17.4 2.5 6 8.3 9.9 14.8 9.9 28.7 0 57.6-8.9 81.6-19.3 22.9-10 42.4-21.9 54.3-30.6 31.8 11.5 67 17.9 104.1 17.9zm-39-255-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9l64-64c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zm112-34 64 64c9.4 9.4 9.4 24.6 0 33.9l-64 64c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z"
        }
    ]
};

const FasCommentDollar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCommentDollar",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32 0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9-1.9 24.5-11.4 46.3-21.4 62.9-5.5 9.2-11.1 16.6-15.2 21.6-2.1 2.5-3.7 4.4-4.9 5.7-.6.6-1 1.1-1.3 1.4l-.3.3c-4.6 4.6-5.9 11.4-3.4 17.4 2.5 6 8.3 9.9 14.8 9.9 28.7 0 57.6-8.9 81.6-19.3 22.9-10 42.4-21.9 54.3-30.6 31.8 11.5 67 17.9 104.1 17.9zm20-312v13.9c7.5 1.2 14.6 2.9 21.1 4.7 10.7 2.8 17 13.8 14.2 24.5s-13.8 17-24.5 14.2c-11-2.9-21.6-5-31.2-5.2-7.9-.1-16 1.8-21.5 5-4.8 2.8-6.2 5.6-6.2 9.3 0 1.8.1 3.5 5.3 6.7 6.3 3.8 15.5 6.7 28.3 10.5l.7.2c11.2 3.4 25.6 7.7 37.1 15 12.9 8.1 24.3 21.3 24.6 41.6.3 20.9-10.5 36.1-24.8 45-7.2 4.5-15.2 7.3-23.2 9V344c0 11-9 20-20 20s-20-9-20-20v-14.6c-10.3-2.2-20-5.5-28.2-8.4-2.1-.7-4.1-1.4-6.1-2.1-10.5-3.5-16.1-14.8-12.6-25.3s14.8-16.1 25.3-12.6c2.5.8 4.9 1.7 7.2 2.4 13.6 4.6 24 8.1 35.1 8.5 8.6.3 16.5-1.6 21.4-4.7 4.1-2.5 6-5.5 5.9-10.5 0-2.9-.8-5-5.9-8.2-6.3-4-15.4-6.9-28-10.7l-1.7-.5c-10.9-3.3-24.6-7.4-35.6-14-12.7-7.7-24.6-20.5-24.7-40.7-.1-21.1 11.8-35.7 25.8-43.9 6.9-4.1 14.5-6.8 22.2-8.5V136c0-11 9-20 20-20s20 9 20 20z"
        }
    ]
};

const FasCommentDots = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCommentDots",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32 0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9-1.9 24.5-11.4 46.3-21.4 62.9-5.5 9.2-11.1 16.6-15.2 21.6-2.1 2.5-3.7 4.4-4.9 5.7-.6.6-1 1.1-1.3 1.4l-.3.3c-4.6 4.6-5.9 11.4-3.4 17.4 2.5 6 8.3 9.9 14.8 9.9 28.7 0 57.6-8.9 81.6-19.3 22.9-10 42.4-21.9 54.3-30.6 31.8 11.5 67 17.9 104.1 17.9zM128 208a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 32a32 32 0 1 1 64 0 32 32 0 1 1-64 0z"
        }
    ]
};

const FasCommentExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCommentExclamation",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32 0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9-1.9 24.5-11.4 46.3-21.4 62.9-5.5 9.2-11.1 16.6-15.2 21.6-2.1 2.5-3.7 4.4-4.9 5.7-.6.6-1 1.1-1.3 1.4l-.3.3c-4.6 4.6-5.9 11.4-3.4 17.4 2.5 6 8.3 9.9 14.8 9.9 28.7 0 57.6-8.9 81.6-19.3 22.9-10 42.4-21.9 54.3-30.6 31.8 11.5 67 17.9 104.1 17.9zm0-336c13.3 0 24 10.7 24 24v112c0 13.3-10.7 24-24 24s-24-10.7-24-24V136c0-13.3 10.7-24 24-24zm-32 224a32 32 0 1 1 64 0 32 32 0 1 1-64 0z"
        }
    ]
};

const FasCommentHeart = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCommentHeart",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32 0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9-1.9 24.5-11.4 46.3-21.4 62.9-5.5 9.2-11.1 16.6-15.2 21.6-2.1 2.5-3.7 4.4-4.9 5.7-.6.6-1 1.1-1.3 1.4l-.3.3c-4.6 4.6-5.9 11.4-3.4 17.4 2.5 6 8.3 9.9 14.8 9.9 28.7 0 57.6-8.9 81.6-19.3 22.9-10 42.4-21.9 54.3-30.6 31.8 11.5 67 17.9 104.1 17.9zM144 205.3c0-33.8 27.4-61.3 61.3-61.3 16.2 0 31.8 6.5 43.3 17.9l7.4 7.4 7.4-7.4c11.5-11.5 27.1-17.9 43.3-17.9 33.8 0 61.3 27.4 61.3 61.3 0 16.2-6.5 31.8-17.9 43.3l-82.7 82.7c-6.2 6.2-16.4 6.2-22.6 0l-82.7-82.7c-11.5-11.5-17.9-27.1-17.9-43.3z"
        }
    ]
};

const FasCommentImage = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCommentImage",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32 0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9-1.9 24.5-11.4 46.3-21.4 62.9-5.5 9.2-11.1 16.6-15.2 21.6-2.1 2.5-3.7 4.4-4.9 5.7-.6.6-1 1.1-1.3 1.4l-.3.3c-4.6 4.6-5.9 11.4-3.4 17.4 2.5 6 8.3 9.9 14.8 9.9 28.7 0 57.6-8.9 81.6-19.3 22.9-10 42.4-21.9 54.3-30.6 31.8 11.5 67 17.9 104.1 17.9zM128 160a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm168-16c7.6 0 14.7 3.6 19.2 9.6l96 128c5.5 7.3 6.3 17 2.3 25.1S401.1 320 392 320H120c-9.3 0-17.8-5.4-21.7-13.8s-2.7-18.4 3.3-25.5l40-48c4.6-5.5 11.3-8.6 18.4-8.6s13.9 3.2 18.4 8.6l20.6 24.6 77.8-103.7c4.5-6 11.6-9.6 19.2-9.6z"
        }
    ]
};

const FasCommentLines = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCommentLines",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32 0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9-1.9 24.5-11.4 46.3-21.4 62.9-5.5 9.2-11.1 16.6-15.2 21.6-2.1 2.5-3.7 4.4-4.9 5.7-.6.6-1 1.1-1.3 1.4l-.3.3c-4.6 4.6-5.9 11.4-3.4 17.4 2.5 6 8.3 9.9 14.8 9.9 28.7 0 57.6-8.9 81.6-19.3 22.9-10 42.4-21.9 54.3-30.6 31.8 11.5 67 17.9 104.1 17.9zM152 176h208c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 96h112c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
        }
    ]
};

const FasCommentMedical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCommentMedical",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32 0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9-1.9 24.5-11.4 46.3-21.4 62.9-5.5 9.2-11.1 16.6-15.2 21.6-2.1 2.5-3.7 4.4-4.9 5.7-.6.6-1 1.1-1.3 1.4l-.3.3c-4.6 4.6-5.9 11.4-3.4 17.4 2.5 6 8.3 9.9 14.8 9.9 28.7 0 57.6-8.9 81.6-19.3 22.9-10 42.4-21.9 54.3-30.6 31.8 11.5 67 17.9 104.1 17.9zm-32-288c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-48v48c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-48h-48c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h48v-48z"
        }
    ]
};

const FasCommentMiddleTop = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCommentMiddleTop",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m188.3 103.3 44.5-89C237.2 5.5 246.2 0 256 0s18.8 5.5 23.2 14.3l44.5 89C432.2 127.5 512 208.2 512 304c0 114.9-114.6 208-256 208S0 418.9 0 304c0-95.8 79.8-176.5 188.3-200.7z"
        }
    ]
};

const FasCommentMiddle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCommentMiddle",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m188.3 408.7 44.5 89c4.4 8.8 13.3 14.3 23.2 14.3s18.8-5.5 23.2-14.3l44.5-89C432.2 384.5 512 303.8 512 208 512 93.1 397.4 0 256 0S0 93.1 0 208c0 95.8 79.8 176.5 188.3 200.7z"
        }
    ]
};

const FasCommentMinus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCommentMinus",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32 0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9-1.9 24.5-11.4 46.3-21.4 62.9-5.5 9.2-11.1 16.6-15.2 21.6-2.1 2.5-3.7 4.4-4.9 5.7-.6.6-1 1.1-1.3 1.4l-.3.3c-4.6 4.6-5.9 11.4-3.4 17.4 2.5 6 8.3 9.9 14.8 9.9 28.7 0 57.6-8.9 81.6-19.3 22.9-10 42.4-21.9 54.3-30.6 31.8 11.5 67 17.9 104.1 17.9zm-72-232h144c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
        }
    ]
};

const FasCommentMusic = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCommentMusic",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32 0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9-1.9 24.5-11.4 46.3-21.4 62.9-5.5 9.2-11.1 16.6-15.2 21.6-2.1 2.5-3.7 4.4-4.9 5.7-.6.6-1 1.1-1.3 1.4l-.3.3c-4.6 4.6-5.9 11.4-3.4 17.4 2.5 6 8.3 9.9 14.8 9.9 28.7 0 57.6-8.9 81.6-19.3 22.9-10 42.4-21.9 54.3-30.6 31.8 11.5 67 17.9 104.1 17.9zm96-320v160c0 17.7-21.5 32-48 32s-48-14.3-48-32 21.5-32 48-32c5.6 0 11 .6 16 1.8v-74.7l-96 36V320c0 17.7-21.5 32-48 32s-48-14.3-48-32 21.5-32 48-32c5.6 0 11 .6 16 1.8V176c0-6.7 4.1-12.6 10.4-15l128-48c4.9-1.8 10.4-1.2 14.7 1.8s6.9 7.9 6.9 13.2z"
        }
    ]
};

const FasCommentPen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCommentPen",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32 0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9-1.9 24.5-11.4 46.3-21.4 62.9-5.5 9.2-11.1 16.6-15.2 21.6-2.1 2.5-3.7 4.4-4.9 5.7-.6.6-1 1.1-1.3 1.4l-.3.3c-4.6 4.6-5.9 11.4-3.4 17.4 2.5 6 8.3 9.9 14.8 9.9 28.7 0 57.6-8.9 81.6-19.3 22.9-10 42.4-21.9 54.3-30.6 31.8 11.5 67 17.9 104.1 17.9zm84.8-293c14.7 14.7 14.7 38.6 0 53.3l-14.9 14.9-53.3-53.2 14.9-15c14.7-14.7 38.6-14.7 53.3 0zM178.1 264.5l71.9-71.9 53.3 53.3-71.9 71.9c-4.1 4.1-9.2 7-14.9 8.4l-36.6 9.2c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l9.2-36.7c1.4-5.6 4.3-10.8 8.4-14.9z"
        }
    ]
};

const FasCommentPlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCommentPlus",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32 0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9-1.9 24.5-11.4 46.3-21.4 62.9-5.5 9.2-11.1 16.6-15.2 21.6-2.1 2.5-3.7 4.4-4.9 5.7-.6.6-1 1.1-1.3 1.4l-.3.3c-4.6 4.6-5.9 11.4-3.4 17.4 2.5 6 8.3 9.9 14.8 9.9 28.7 0 57.6-8.9 81.6-19.3 22.9-10 42.4-21.9 54.3-30.6 31.8 11.5 67 17.9 104.1 17.9zm-24-120v-64h-64c-13.3 0-24-10.7-24-24s10.7-24 24-24h64v-64c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24h-64v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"
        }
    ]
};

const FasCommentQuestion = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCommentQuestion",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32 0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9-1.9 24.5-11.4 46.3-21.4 62.9-5.5 9.2-11.1 16.6-15.2 21.6-2.1 2.5-3.7 4.4-4.9 5.7-.6.6-1 1.1-1.3 1.4l-.3.3c-4.6 4.6-5.9 11.4-3.4 17.4 2.5 6 8.3 9.9 14.8 9.9 28.7 0 57.6-8.9 81.6-19.3 22.9-10 42.4-21.9 54.3-30.6 31.8 11.5 67 17.9 104.1 17.9zm-86.2-298.7c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1 0 22.6-12.1 43.5-31.7 54.8L280 248.4c-.2 13-10.9 23.6-24 23.6-13.3 0-24-10.7-24-24v-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1 0-8.4-6.8-15.1-15.1-15.1h-58.3c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 336a32 32 0 1 1 64 0 32 32 0 1 1-64 0z"
        }
    ]
};

const FasCommentQuote = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCommentQuote",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32 0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9-1.9 24.5-11.4 46.3-21.4 62.9-5.5 9.2-11.1 16.6-15.2 21.6-2.1 2.5-3.7 4.4-4.9 5.7-.6.6-1 1.1-1.3 1.4l-.3.3c-4.6 4.6-5.9 11.4-3.4 17.4 2.5 6 8.3 9.9 14.8 9.9 28.7 0 57.6-8.9 81.6-19.3 22.9-10 42.4-21.9 54.3-30.6 31.8 11.5 67 17.9 104.1 17.9zm-96-304h48c17.7 0 32 14.3 32 32v87.3c0 35.2-25.4 65.2-60.2 71l-7.9 1.3c-13.1 2.2-25.4-6.7-27.6-19.7s6.7-25.4 19.7-27.6l7.9-1.3c11.6-1.9 20.1-11.9 20.1-23.7V256h-32c-17.7 0-32-14.3-32-32v-48c0-17.7 14.3-32 32-32zm224 80v39.3c0 35.2-25.4 65.2-60.2 71l-7.9 1.3c-13.1 2.2-25.4-6.7-27.6-19.7s6.7-25.4 19.7-27.6l7.9-1.3c11.6-1.9 20.1-11.9 20.1-23.7V256h-32c-17.7 0-32-14.3-32-32v-48c0-17.7 14.3-32 32-32h48c17.7 0 32 14.3 32 32v48z"
        }
    ]
};

const FasCommentSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCommentSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-117.9-92.4C552.2 340.2 576 292.3 576 240c0-114.9-114.6-208-256-208-67.7 0-129.3 21.4-175.1 56.3L38.8 5.1zM64 240c0 45.1 17.7 86.8 47.7 120.9-1.9 24.5-11.4 46.3-21.4 62.9-5.5 9.2-11.1 16.6-15.2 21.6-2.1 2.5-3.7 4.4-4.9 5.7-.6.6-1 1.1-1.3 1.4l-.3.3c-4.6 4.6-5.9 11.4-3.4 17.4 2.5 6 8.3 9.9 14.8 9.9 28.7 0 57.6-8.9 81.6-19.3 22.9-10 42.4-21.9 54.3-30.6 31.8 11.5 67 17.9 104.1 17.9 37 0 72.3-6.4 104-17.9L82.9 161.3C70.7 185.6 64 212.2 64 240z"
        }
    ]
};

const FasCommentSmile = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCommentSmile",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32 0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9-1.9 24.5-11.4 46.3-21.4 62.9-5.5 9.2-11.1 16.6-15.2 21.6-2.1 2.5-3.7 4.4-4.9 5.7-.6.6-1 1.1-1.3 1.4l-.3.3c-4.6 4.6-5.9 11.4-3.4 17.4 2.5 6 8.3 9.9 14.8 9.9 28.7 0 57.6-8.9 81.6-19.3 22.9-10 42.4-21.9 54.3-30.6 31.8 11.5 67 17.9 104.1 17.9zm-64-304a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM150.5 270.1c9.9-8.8 25-8 33.9 1.9 17.6 19.7 43.1 32 71.6 32s53.9-12.3 71.6-32c8.8-9.9 24-10.7 33.9-1.9s10.7 24 1.9 33.9c-26.4 29.4-64.8 48-107.4 48s-81-18.6-107.3-48c-8.8-9.9-8-25 1.9-33.9z"
        }
    ]
};

const FasCommentSms = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCommentSms",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32 0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9-1.9 24.5-11.4 46.3-21.4 62.9-5.5 9.2-11.1 16.6-15.2 21.6-2.1 2.5-3.7 4.4-4.9 5.7-.6.6-1 1.1-1.3 1.4l-.3.3c-4.6 4.6-5.9 11.4-3.4 17.4 2.5 6 8.3 9.9 14.8 9.9 28.7 0 57.6-8.9 81.6-19.3 22.9-10 42.4-21.9 54.3-30.6 31.8 11.5 67 17.9 104.1 17.9zm-53.1-271.2c6.5-2.2 13.7.1 17.9 5.6l35.2 46.9 35.2-46.9c4.1-5.5 11.3-7.8 17.9-5.6S320 185.1 320 192v96c0 8.8-7.2 16-16 16s-16-7.2-16-16v-48l-19.2 25.6c-3 4-7.8 6.4-12.8 6.4s-9.8-2.4-12.8-6.4L224 240v48c0 8.8-7.2 16-16 16s-16-7.2-16-16v-96c0-6.9 4.4-13 10.9-15.2zm173.1 38v.4c.1.1.6.8 2.2 1.7 3.9 2.3 9.6 4.1 18.3 6.8l.6.2c7.4 2.2 17.3 5.2 25.2 10.2 9.1 5.7 17.4 15.2 17.6 29.9.2 15-7.6 26-17.8 32.3-9.5 5.9-20.9 7.9-30.7 7.6-12.2-.4-23.7-4.4-32.6-7.4-1.4-.5-2.7-.9-4-1.4-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1c1.7.6 3.3 1.1 4.9 1.6 9.1 3.1 15.6 5.3 22.6 5.5 5.3.2 10-1 12.8-2.8 1.2-.8 1.8-1.5 2.1-2 .2-.4.6-1.2.6-2.7v-.2c0-.7 0-1.4-2.7-3.1-3.8-2.4-9.6-4.3-18-6.9l-1.2-.4c-7.2-2.2-16.7-5-24.3-9.6-9-5.4-17.7-14.7-17.7-29.4-.1-15.2 8.6-25.7 18.5-31.6 9.4-5.5 20.5-7.5 29.7-7.4 10 .2 19.7 2.3 27.9 4.4 8.5 2.3 13.6 11 11.3 19.6s-11 13.6-19.6 11.3c-7.3-1.9-14.1-3.3-20.1-3.4-4.9-.1-9.8 1.1-12.9 2.9-1.4.8-2.1 1.6-2.4 2-.2.3-.4.8-.4 1.9zm-272 0v.4c.1.1.6.8 2.2 1.7 3.9 2.3 9.6 4.1 18.3 6.8l.6.2c7.4 2.2 17.3 5.2 25.2 10.2 9.1 5.7 17.4 15.2 17.6 29.9.2 15-7.6 26-17.8 32.3-9.5 5.9-20.9 7.9-30.7 7.6-12.3-.4-24.2-4.5-33.2-7.6-1.3-.4-2.5-.8-3.6-1.2-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1c1.4.5 2.8.9 4.1 1.4 9.5 3.2 16.5 5.6 23.7 5.8 5.3.2 10-1 12.8-2.8 1.2-.8 1.8-1.5 2.1-2 .2-.4.6-1.2.6-2.7v-.2c0-.7 0-1.4-2.7-3.1-3.8-2.4-9.6-4.3-18-6.9l-1.2-.4c-7.2-2.2-16.7-5-24.3-9.6-9-5.3-17.7-14.6-17.8-29.3-.1-15.2 8.6-25.7 18.5-31.6 9.4-5.5 20.5-7.5 29.7-7.4 9.5.1 22.2 2.1 31.1 4.4 8.5 2.3 13.6 11 11.3 19.6s-11 13.6-19.6 11.3c-6.6-1.8-16.8-3.3-23.3-3.4-4.9-.1-9.8 1.1-12.9 2.9-1.4.8-2.1 1.6-2.4 2-.2.3-.4.8-.4 1.9z"
        }
    ]
};

const FasCommentText = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCommentText",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32 0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9-1.9 24.5-11.4 46.3-21.4 62.9-5.5 9.2-11.1 16.6-15.2 21.6-2.1 2.5-3.7 4.4-4.9 5.7-.6.6-1 1.1-1.3 1.4l-.3.3c-4.6 4.6-5.9 11.4-3.4 17.4 2.5 6 8.3 9.9 14.8 9.9 28.7 0 57.6-8.9 81.6-19.3 22.9-10 42.4-21.9 54.3-30.6 31.8 11.5 67 17.9 104.1 17.9zm-72-288h144c13.3 0 24 10.7 24 24s-10.7 24-24 24h-48v104c0 13.3-10.7 24-24 24s-24-10.7-24-24V208h-48c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
        }
    ]
};

const FasCommentXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCommentXmark",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32 0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9-1.9 24.5-11.4 46.3-21.4 62.9-5.5 9.2-11.1 16.6-15.2 21.6-2.1 2.5-3.7 4.4-4.9 5.7-.6.6-1 1.1-1.3 1.4l-.3.3c-4.6 4.6-5.9 11.4-3.4 17.4 2.5 6 8.3 9.9 14.8 9.9 28.7 0 57.6-8.9 81.6-19.3 22.9-10 42.4-21.9 54.3-30.6 31.8 11.5 67 17.9 104.1 17.9zm-81-289c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"
        }
    ]
};

const FasComment = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasComment",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 240c0 114.9-114.6 208-256 208-37.1 0-72.3-6.4-104.1-17.9-11.9 8.7-31.3 20.6-54.3 30.6C73.6 471.1 44.7 480 16 480c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.8 3.4-17.4l.3-.3c.3-.3.7-.7 1.3-1.4 1.1-1.2 2.8-3.1 4.9-5.7 4.1-5 9.6-12.4 15.2-21.6 10-16.6 19.5-38.4 21.4-62.9C17.7 326.8 0 285.1 0 240 0 125.1 114.6 32 256 32s256 93.1 256 208z"
        }
    ]
};

const FasCommentsDollar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCommentsDollar",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M416 176c0 97.2-93.1 176-208 176-38.2 0-73.9-8.7-104.7-23.9-7.5 4-16 7.9-25.2 11.4C59.8 346.4 37.8 352 16 352c-6.9 0-13.1-4.5-15.2-11.1S1 327.1 6.6 323l.2-.2c.2-.2.6-.4 1.1-.8 1-.8 2.5-2 4.3-3.7 3.6-3.3 8.5-8.1 13.3-14.3 5.5-7 10.7-15.4 14.2-24.7C14.7 250.3 0 214.6 0 176 0 78.8 93.1 0 208 0s208 78.8 208 176zM231.5 383C348.9 372.9 448 288.3 448 176c0-5.2-.2-10.4-.6-15.5C555.1 167.1 640 243.2 640 336c0 38.6-14.7 74.3-39.6 103.4 3.5 9.4 8.7 17.7 14.2 24.7 4.8 6.2 9.7 11 13.3 14.3 1.8 1.6 3.3 2.9 4.3 3.7.5.4.9.7 1.1.8l.2.2c5.6 4.1 7.9 11.3 5.8 17.9-2.1 6.6-8.3 11.1-15.2 11.1-21.8 0-43.8-5.6-62.1-12.5-9.2-3.5-17.8-7.4-25.2-11.4C505.9 503.3 470.2 512 432 512c-95.6 0-176.2-54.6-200.5-129zM228 72c0-11-9-20-20-20s-20 9-20 20v14c-7.6 1.7-15.2 4.4-22.2 8.5-13.9 8.3-25.9 22.8-25.8 43.9.1 20.3 12 33.1 24.7 40.7 11 6.6 24.7 10.8 35.6 14l1.7.5c12.6 3.8 21.8 6.8 28 10.7 5.1 3.2 5.8 5.4 5.9 8.2.1 5-1.8 8-5.9 10.5-5 3.1-12.9 5-21.4 4.7-11.1-.4-21.5-3.9-35.1-8.5-2.3-.8-4.7-1.6-7.2-2.4-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9.6 4 1.3 6.1 2.1 8.3 2.9 17.9 6.2 28.2 8.4V280c0 11 9 20 20 20s20-9 20-20v-13.8c8-1.7 16-4.5 23.2-9 14.3-8.9 25.1-24.1 24.8-45-.3-20.3-11.7-33.4-24.6-41.6-11.5-7.2-25.9-11.6-37.1-15l-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5-5.2-3.1-5.3-4.9-5.3-6.7 0-3.7 1.4-6.5 6.2-9.3 5.4-3.2 13.6-5.1 21.5-5 9.6.1 20.2 2.2 31.2 5.2 10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7V72z"
        }
    ]
};

const FasCommentsQuestionCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCommentsQuestionCheck",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M208 352c114.9 0 208-78.8 208-176S322.9 0 208 0 0 78.8 0 176c0 38.6 14.7 74.3 39.6 103.4-3.5 9.4-8.7 17.7-14.2 24.7-4.8 6.2-9.7 11-13.3 14.3-1.8 1.6-3.3 2.9-4.3 3.7-.5.4-.9.7-1.1.8l-.2.2C1 327.2-1.4 334.4.8 340.9S9.1 352 16 352c21.8 0 43.8-5.6 62.1-12.5 9.2-3.5 17.8-7.4 25.2-11.4C134.1 343.3 169.8 352 208 352zm240-176c0 112.3-99.1 196.9-216.5 207 24.3 74.4 104.9 129 200.5 129 38.2 0 73.9-8.7 104.7-23.9 7.5 4 16 7.9 25.2 11.4 18.3 6.9 40.3 12.5 62.1 12.5 6.9 0 13.1-4.5 15.2-11.1 2.1-6.6-.2-13.8-5.8-17.9l-.2-.2c-.2-.2-.6-.4-1.1-.8-1-.8-2.5-2-4.3-3.7-3.6-3.3-8.5-8.1-13.3-14.3-5.5-7-10.7-15.4-14.2-24.7 24.9-29 39.6-64.7 39.6-103.4 0-92.8-84.9-168.9-192.6-175.5.4 5.1.6 10.3.6 15.5zM180.2 77.3h48.5c29.1 0 52.6 23.6 52.6 52.6 0 18.8-10.1 36.3-26.4 45.6L228 191c-.2 10.9-9.1 19.6-20 19.6-11 0-20-9-20-20v-11.1c0-7.2 3.8-13.8 10-17.3l37-21.3c3.9-2.3 6.3-6.4 6.3-10.9 0-7-5.7-12.6-12.6-12.6h-48.5c-2.8 0-5.3 1.8-6.3 4.4l-.4 1c-3.7 10.4-15.1 15.9-25.5 12.2s-15.9-15.1-12.2-25.5l.4-1c6.6-18.6 24.2-31.1 44-31.1zm27.8 160a26.7 26.7 0 1 1 0 53.3 26.7 26.7 0 1 1 0-53.3zm358.1 88.8-80 80c-7.8 7.8-20.5 7.8-28.3 0l-40-40c-7.8-7.8-7.8-20.5 0-28.3s20.5-7.8 28.3 0l25.9 25.9 65.9-65.9c7.8-7.8 20.5-7.8 28.3 0s7.8 20.5 0 28.3z"
        }
    ]
};

const FasCommentsQuestion = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCommentsQuestion",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M416 176c0 97.2-93.1 176-208 176-38.2 0-73.9-8.7-104.7-23.9-7.5 4-16 7.9-25.2 11.4C59.8 346.4 37.8 352 16 352c-6.9 0-13.1-4.5-15.2-11.1S1 327.1 6.6 323l.2-.2c.2-.2.6-.4 1.1-.8 1-.8 2.5-2 4.3-3.7 3.6-3.3 8.5-8.1 13.3-14.3 5.5-7 10.7-15.4 14.2-24.7C14.7 250.3 0 214.6 0 176 0 78.8 93.1 0 208 0s208 78.8 208 176zM231.5 383C348.9 372.9 448 288.3 448 176c0-5.2-.2-10.4-.6-15.5C555.1 167.1 640 243.2 640 336c0 38.6-14.7 74.3-39.6 103.4 3.5 9.4 8.7 17.7 14.2 24.7 4.8 6.2 9.7 11 13.3 14.3 1.8 1.6 3.3 2.9 4.3 3.7.5.4.9.7 1.1.8l.2.2c5.6 4.1 7.9 11.3 5.8 17.9-2.1 6.6-8.3 11.1-15.2 11.1-21.8 0-43.8-5.6-62.1-12.5-9.2-3.5-17.8-7.4-25.2-11.4C505.9 503.3 470.2 512 432 512c-95.6 0-176.2-54.6-200.5-129zm-95.3-274.6-.4 1c-3.7 10.4 1.8 21.8 12.2 25.5s21.8-1.8 25.5-12.2l.4-1c.9-2.7 3.5-4.4 6.3-4.4h48.5c7 0 12.6 5.7 12.6 12.6 0 4.5-2.4 8.7-6.3 10.9l-37 21.3c-6.2 3.6-10 10.2-10 17.3v11.2c0 11 9 20 20 20 10.9 0 19.8-8.8 20-19.6l26.9-15.4c16.3-9.4 26.4-26.8 26.4-45.6 0-29.1-23.6-52.6-52.6-52.6h-48.5c-19.8 0-37.4 12.4-44 31.1zM234.7 264a26.7 26.7 0 1 0-53.3 0 26.7 26.7 0 1 0 53.3 0z"
        }
    ]
};

const FasComments = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasComments",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M208 352c114.9 0 208-78.8 208-176S322.9 0 208 0 0 78.8 0 176c0 38.6 14.7 74.3 39.6 103.4-3.5 9.4-8.7 17.7-14.2 24.7-4.8 6.2-9.7 11-13.3 14.3-1.8 1.6-3.3 2.9-4.3 3.7-.5.4-.9.7-1.1.8l-.2.2C1 327.2-1.4 334.4.8 340.9S9.1 352 16 352c21.8 0 43.8-5.6 62.1-12.5 9.2-3.5 17.8-7.4 25.3-11.4C134.1 343.3 169.8 352 208 352zm240-176c0 112.3-99.1 196.9-216.5 207 24.3 74.4 104.9 129 200.5 129 38.2 0 73.9-8.7 104.7-23.9 7.5 4 16 7.9 25.2 11.4 18.3 6.9 40.3 12.5 62.1 12.5 6.9 0 13.1-4.5 15.2-11.1 2.1-6.6-.2-13.8-5.8-17.9l-.2-.2c-.2-.2-.6-.4-1.1-.8-1-.8-2.5-2-4.3-3.7-3.6-3.3-8.5-8.1-13.3-14.3-5.5-7-10.7-15.4-14.2-24.7 24.9-29 39.6-64.7 39.6-103.4 0-92.8-84.9-168.9-192.6-175.5.4 5.1.6 10.3.6 15.5z"
        }
    ]
};

const FasCompactDisc = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCompactDisc",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm256 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm-96-32a96 96 0 1 0 192 0 96 96 0 1 0-192 0zm-64-16c0-35 17.5-71.1 45.2-98.8S205 96 240 96c8.8 0 16-7.2 16-16s-7.2-16-16-16c-45.4 0-89.2 22.3-121.5 54.5S64 194.6 64 240c0 8.8 7.2 16 16 16s16-7.2 16-16z"
        }
    ]
};

const FasCompassDrafting = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCompassDrafting",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 96c0 14.3-3.1 27.9-8.8 40.2l52.8 91.2c-23.7 25.3-54.2 44.1-88.5 53.6L256 192l-68 117.5c21.5 6.8 44.3 10.5 68.1 10.5 70.7 0 133.8-32.7 174.9-84 11.1-13.8 31.2-16 45-5s16 31.2 5 45c-52.9 65.8-134 108-225 108-35.4 0-69.4-6.4-100.7-18.1l-56.6 97.8c-4.7 8.1-11.7 14.7-20.1 18.9l-55.4 27.7c-5 2.5-10.9 2.2-15.6-.7S0 501.5 0 496v-55.4c0-8.4 2.2-16.7 6.5-24.1l60-103.7c-12.8-11.2-24.7-23.5-35.3-36.8-11.1-13.8-8.8-33.9 5-45s33.9-8.8 45 5c5.7 7.1 11.8 13.8 18.2 20.1l69.4-119.9C163.2 124 160 110.4 160 96c0-53 43-96 96-96s96 43 96 96zm21 297.9c32.6-12.8 62.5-30.8 88.9-52.9l43.7 75.5c4.2 7.3 6.5 15.6 6.5 24.1V496c0 5.5-2.9 10.7-7.6 13.6s-10.6 3.2-15.6.7l-55.4-27.7c-8.4-4.2-15.4-10.8-20.1-18.9L373 393.9zM256 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FasCompassSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCompassSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-95.4-74.8C561.1 354.5 576 307 576 256 576 114.6 461.4 0 320 0c-73.2 0-139.1 30.7-185.8 79.9L38.8 5.1zm231.5 181.4 143.3-55.1c19.4-7.5 38.5 11.6 31 31l-47.5 123.5-126.8-99.4zM320 512c55.2 0 106.3-17.5 148.1-47.2L317 345.8l-90.6 34.8c-19.4 7.5-38.5-11.6-31-31l29.4-76.5L82.3 160.8C70.5 190.2 64 222.4 64 256c0 141.4 114.6 256 256 256z"
        }
    ]
};

const FasCompass = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCompass",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm50.7-186.9-144.3 55.5c-19.4 7.5-38.5-11.6-31-31l55.5-144.3c3.3-8.5 9.9-15.1 18.4-18.4l144.3-55.5c19.4-7.5 38.5 11.6 31 31l-55.5 144.3c-3.2 8.5-9.9 15.1-18.4 18.4zM288 256a32 32 0 1 0-64 0 32 32 0 1 0 64 0z"
        }
    ]
};

const FasCompressWide = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCompressWide",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 96c0-17.7-14.3-32-32-32S96 78.3 96 96v64H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32V96zM32 288c-17.7 0-32 14.3-32 32s14.3 32 32 32h64v64c0 17.7 14.3 32 32 32s32-14.3 32-32v-96c0-17.7-14.3-32-32-32H32zM416 96c0-17.7-14.3-32-32-32s-32 14.3-32 32v96c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32h-64V96zm-32 192c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32s32-14.3 32-32v-64h64c17.7 0 32-14.3 32-32s-14.3-32-32-32h-96z"
        }
    ]
};

const FasCompress = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCompress",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 64c0-17.7-14.3-32-32-32S96 46.3 96 64v64H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32V64zM32 320c-17.7 0-32 14.3-32 32s14.3 32 32 32h64v64c0 17.7 14.3 32 32 32s32-14.3 32-32v-96c0-17.7-14.3-32-32-32H32zM352 64c0-17.7-14.3-32-32-32s-32 14.3-32 32v96c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32h-64V64zm-32 256c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32s32-14.3 32-32v-64h64c17.7 0 32-14.3 32-32s-14.3-32-32-32h-96z"
        }
    ]
};

const FasComputerClassic = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasComputerClassic",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 48C0 21.5 21.5 0 48 0h352c26.5 0 48 21.5 48 48v320c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V48zm32 432v-32h384v32c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32zM96 64c-17.7 0-32 14.3-32 32v128c0 17.7 14.3 32 32 32h256c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H96zM80 360a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm144-24c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16s-7.2-16-16-16H240c-8.8 0-16 7.2-16 16z"
        }
    ]
};

const FasComputerMouseScrollwheel = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasComputerMouseScrollwheel",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 0C71.6 0 0 71.6 0 160v192c0 88.4 71.6 160 160 160h64c88.4 0 160-71.6 160-160V160C384 71.6 312.4 0 224 0h-64zm64 128v32c0 17.7-14.3 32-32 32s-32-14.3-32-32v-32c0-17.7 14.3-32 32-32s32 14.3 32 32z"
        }
    ]
};

const FasComputerMouse = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasComputerMouse",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 192h176V0h-16C71.6 0 0 71.6 0 160v32zm0 32v128c0 88.4 71.6 160 160 160h64c88.4 0 160-71.6 160-160V224H0zm384-32v-32C384 71.6 312.4 0 224 0h-16v192h176z"
        }
    ]
};

const FasComputerSpeaker = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasComputerSpeaker",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 432v-16H128c-17.7 0-32 14.3-32 32s14.3 32 32 32h176c-10-13.4-16-30-16-48zM64 32C28.7 32 0 60.7 0 96v224c0 35.3 28.7 64 64 64h224v-64H64V96h224V80c0-18 6-34.6 16-48H64zm304 0c-26.5 0-48 21.5-48 48v352c0 26.5 21.5 48 48 48h224c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H368zm176 288a64 64 0 1 0-128 0 64 64 0 1 0 128 0zm-160 0a96 96 0 1 1 192 0 96 96 0 1 1-192 0zm64-192a32 32 0 1 1 64 0 32 32 0 1 1-64 0z"
        }
    ]
};

const FasComputer = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasComputer",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 96v224H64V96h320zM64 32C28.7 32 0 60.7 0 96v224c0 35.3 28.7 64 64 64h117.3l-10.7 32H96c-17.7 0-32 14.3-32 32s14.3 32 32 32h256c17.7 0 32-14.3 32-32s-14.3-32-32-32h-74.7l-10.7-32H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm464 0c-26.5 0-48 21.5-48 48v352c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48h-64zm16 64h32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-16 80c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16zm32 160a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FasContainerStorage = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasContainerStorage",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 32C14.3 32 0 46.3 0 64s14.3 32 32 32v320c-17.7 0-32 14.3-32 32s14.3 32 32 32h576c17.7 0 32-14.3 32-32s-14.3-32-32-32V96c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zm144 120v208c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24s24 10.7 24 24zm112 0v208c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24s24 10.7 24 24zm112 0v208c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24s24 10.7 24 24zm112 0v208c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24s24 10.7 24 24z"
        }
    ]
};

const FasConveyorBeltArm = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasConveyorBeltArm",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M240.9 0H320c17.7 0 32 14.3 32 32s-14.3 32-32 32h-52.9l-5.7 34c.8 1 1.5 2 2.3 3l204.5 27.3c17.5 2.3 29.8 18.4 27.5 35.9-1.4 10.2-7.4 18.7-15.7 23.5V208c0 8.8-7.2 16-16 16s-16-7.2-16-16v-17.9l-192.8-25.6c-8.4 7.2-19.3 11.6-31.2 11.6-26.5 0-48-21.5-48-48 0-17.1 8.9-32 22.3-40.6l3.9-23.5H160c-17.7 0-32-14.3-32-32s14.3-32 32-32h80.9zm-.9 128a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm176 152c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v40h32c53 0 96 43 96 96s-43 96-96 96H96c-53 0-96-43-96-96s43-96 96-96v-40c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v40h64v-40c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v40h64v-40zM128 448a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm224-32a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm160 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FasConveyorBeltBoxes = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasConveyorBeltBoxes",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C64 14.3 78.3 0 96 0h192c17.7 0 32 14.3 32 32v192c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V32zm320 64c0-17.7 14.3-32 32-32h128c17.7 0 32 14.3 32 32v128c0 17.7-14.3 32-32 32H416c-17.7 0-32-14.3-32-32V96zM0 416c0-53 43-96 96-96h448c53 0 96 43 96 96s-43 96-96 96H96c-53 0-96-43-96-96zm160 0a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm160 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm224-32a32 32 0 1 0-64 0 32 32 0 1 0 64 0z"
        }
    ]
};

const FasConveyorBeltEmpty = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasConveyorBeltEmpty",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 320c-53 0-96 43-96 96s43 96 96 96h448c53 0 96-43 96-96s-43-96-96-96H96zm32 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm160 32a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm224-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FasConveyorBelt = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasConveyorBelt",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 0h80v112c0 5.9 3.2 11.3 8.5 14.1s11.5 2.5 16.4-.8L320 99.2l39.1 26.1c4.9 3.3 11.2 3.6 16.4.8s8.5-8.2 8.5-14.1V0h80c26.5 0 48 21.5 48 48v160c0 26.5-21.5 48-48 48H176c-26.5 0-48-21.5-48-48V48c0-26.5 21.5-48 48-48zM0 416c0-53 43-96 96-96h448c53 0 96 43 96 96s-43 96-96 96H96c-53 0-96-43-96-96zm160 0a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm160 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm224-32a32 32 0 1 0-64 0 32 32 0 1 0 64 0z"
        }
    ]
};

const FasCookieBite = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCookieBite",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M257.5 27.6c-.8-5.4-4.9-9.8-10.3-10.6-22.1-3.1-44.6.9-64.4 11.4l-74 39.5c-19.7 10.5-35.6 27-45.4 47.1l-36.7 75.6c-9.8 20.1-13 42.9-9.1 64.9l14.5 82.8c3.9 22.1 14.6 42.3 30.7 57.9l60.3 58.4c16.1 15.6 36.6 25.6 58.7 28.7l83 11.7c22.1 3.1 44.6-.9 64.4-11.4l74-39.5c19.7-10.5 35.6-27 45.4-47.2l36.7-75.5c9.8-20.1 13-42.9 9.1-64.9-.9-5.3-5.3-9.3-10.6-10.1-51.5-8.2-92.8-47.1-104.5-97.4-1.8-7.6-8-13.4-15.7-14.6-54.6-8.7-97.7-52-106.2-106.8zM208 144a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-64 192a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm224-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FasCookie = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCookie",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M247.2 17c-22.1-3.1-44.6.9-64.4 11.4l-74 39.5c-19.7 10.5-35.6 27-45.4 47.1l-36.7 75.6c-9.8 20.1-13 42.9-9.1 64.9l14.5 82.8c3.9 22.1 14.6 42.3 30.7 57.9l60.3 58.4c16.1 15.6 36.6 25.6 58.7 28.7l83 11.7c22.1 3.1 44.6-.9 64.4-11.4l74-39.5c19.7-10.5 35.6-27 45.4-47.2l36.7-75.5c9.8-20.1 13-42.9 9.1-64.9l-14.6-82.8c-3.9-22.1-14.6-42.3-30.7-57.9l-60.2-58.3c-16.1-15.6-36.6-25.6-58.7-28.7l-83-11.8zM208 144a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-64 192a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm224-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FasCopy = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCopy",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M208 0h124.1C344.8 0 357 5.1 366 14.1L433.9 82c9 9 14.1 21.2 14.1 33.9V336c0 26.5-21.5 48-48 48H208c-26.5 0-48-21.5-48-48V48c0-26.5 21.5-48 48-48zM48 128h80v64H64v256h192v-32h64v48c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48z"
        }
    ]
};

const FasCopyright = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCopyright",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-56.6-199.4c31.2 31.2 81.9 31.2 113.1 0 9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9c-50 50-131 50-181 0s-50-131 0-181 131-50 181 0c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0c-31.2-31.2-81.9-31.2-113.1 0s-31.2 81.9 0 113.1z"
        }
    ]
};

const FasCorn = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCorn",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 40c0 15-8.3 28.1-20.5 34.9 7.7 7.3 12.5 17.7 12.5 29.1 0 18-11.8 33.2-28.2 38.2 2.7 5.4 4.2 11.4 4.2 17.8 0 18-11.8 33.2-28.2 38.2 2.7 5.4 4.2 11.4 4.2 17.8 0 22.1-17.9 40-40 40-1.1 0-2.3 0-3.4-.1 2.2 4.9 3.4 10.4 3.4 16.1 0 13.6-6.8 25.7-17.3 32.9-47.7-29.7-103.6-41.1-157.5-34.2 6.9-53.9-4.5-109.8-34.2-157.5 7.3-10.4 19.4-17.2 33-17.2 5.7 0 11.2 1.2 16.1 3.4-.1-1.1-.1-2.2-.1-3.4 0-22.1 17.9-40 40-40 6.4 0 12.4 1.5 17.8 4.2C318.8 43.8 334 32 352 32c6.4 0 12.4 1.5 17.8 4.2C374.8 19.8 390 8 408 8c11.4 0 21.8 4.8 29.1 12.5C443.9 8.3 457 0 472 0c22.1 0 40 17.9 40 40zM137.7 98c1.2-6.3 8.9-8.7 13.2-3.9 45.4 50.5 69.5 114 56.9 183.4-38.7 10.7-75.2 31.2-105.5 61.6l-77.4 77.4c-34.2-37.7-33.1-96 3.2-132.4l64-64c18.3-18.3 30.6-41.7 35.3-67.1l10.3-55zM92.1 483.9l-44.7-44.7 77.5-77.5c28.6-28.6 63.5-47.1 100.1-55.6 72.2-16.6 139.8 7.4 192.8 55 4.8 4.3 2.4 12.1-3.9 13.2L359 384.5c-25.4 4.7-48.8 17-67.1 35.3l-64 64c-37.5 37.5-98.3 37.5-135.8 0z"
        }
    ]
};

const FasCorner = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCorner",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 192c0-17.7 14.3-32 32-32h352c35.3 0 64 28.7 64 64v128c0 17.7-14.3 32-32 32s-32-14.3-32-32V224H32c-17.7 0-32-14.3-32-32z"
        }
    ]
};

const FasCouch = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCouch",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 160c0-70.7 57.3-128 128-128h256c70.7 0 128 57.3 128 128v33.6c-36.5 7.4-64 39.7-64 78.4v48H128v-48c0-38.7-27.5-71-64-78.4V160zm480 112c0-20.9 13.4-38.7 32-45.3 5-1.8 10.4-2.7 16-2.7 26.5 0 48 21.5 48 48v176c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32H96c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V272c0-26.5 21.5-48 48-48 5.6 0 11 1 16 2.7 18.6 6.6 32 24.4 32 45.3v80h448v-80z"
        }
    ]
};

const FasCow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCow",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 224v192c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32v-88.2c9.9 6.6 20.6 12 32 16.1V368c0 8.8 7.2 16 16 16s16-7.2 16-16v-16.9c5.3.6 10.6.9 16 .9s10.7-.3 16-.9V368c0 8.8 7.2 16 16 16s16-7.2 16-16v-24.2c11.4-4 22.1-9.4 32-16.1V416c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V256l32 32v49.5c0 9.5 2.8 18.7 8.1 26.6L530 427c8.8 13.1 23.5 21 39.3 21 22.5 0 41.9-15.9 46.3-38l20.3-101.6c2.6-13-.3-26.5-8-37.3l-3.9-5.5V184c0-13.3-10.7-24-24-24s-24 10.7-24 24v14.4l-52.9-74.1C496 86.5 452.4 64 405.9 64H144C77.7 64 24 117.7 24 184v54C9.4 249.8 0 267.8 0 288v17.6c0 8 6.4 14.4 14.4 14.4 31.8 0 57.6-25.8 57.6-57.6V184c0-24.3 12.1-45.8 30.5-58.9-4.2 10.8-6.5 22.6-6.5 34.9v64zm464 112a16 16 0 1 1 32 0 16 16 0 1 1-32 0zM166.6 166.6c-4.2-4.2-6.6-10-6.6-16 0-12.5 10.1-22.6 22.6-22.6h178.8c12.5 0 22.6 10.1 22.6 22.6 0 6-2.4 11.8-6.6 16L354 190c-21.8 21.8-51.3 34-82 34s-60.2-12.2-81.9-33.9l-23.4-23.4z"
        }
    ]
};

const FasCowbellCirclePlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCowbellCirclePlus",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M112 96h16V40c0-22.1 17.9-40 40-40h112c22.1 0 40 17.9 40 40v56h16c21.4 0 40.3 14.2 46.2 34.8l18.3 64C318.3 209.7 256 281.6 256 368c0 16.6 2.3 32.7 6.6 48H48c-15.1 0-29.3-7.1-38.3-19.1s-12-27.6-7.8-42.1l64-224C71.7 110.2 90.6 96 112 96zm173.5 369.6c-7.6 26.8-32.3 46.4-61.5 46.4-35.3 0-64-28.7-64-64h115.2c3.1 6.1 6.6 12 10.3 17.6zM272 96V48h-96v48h96zm160 128a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48h-48c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48h48c8.8 0 16-7.2 16-16s-7.2-16-16-16h-48v-48z"
        }
    ]
};

const FasCowbell = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCowbell",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M112 96h16V40c0-22.1 17.9-40 40-40h112c22.1 0 40 17.9 40 40v56h16c21.4 0 40.3 14.2 46.2 34.8l64 224c4.1 14.5 1.2 30.1-7.8 42.1S415.1 416 400.1 416H48c-15.1 0-29.3-7.1-38.3-19.1s-12-27.6-7.8-42.1l64-224C71.7 110.2 90.6 96 112 96zm160 0V48h-96v48h96zm16 352c0 35.3-28.7 64-64 64s-64-28.7-64-64h128z"
        }
    ]
};

const FasCrab = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCrab",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 0C60 0 4.4 53 .2 120v.5L0 128h8-8v33.3c0 28.1 16.3 53.6 41.8 65.4L98.9 253c-3.7 6-6.9 12.4-9.6 19H51.8l-28.6-14.3c-7.9-4-17.5-.7-21.5 7.2s-.7 17.5 7.2 21.5l32 16c2.2 1.1 4.7 1.7 7.2 1.7H81c-.7 5.2-1 10.6-1 16v9.8l-21.1 7c-2.4.8-4.5 2.1-6.3 3.9l-32 32c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L72.6 366l28-9.3 30.7 30.7-40.4 13.4c-2.4.8-4.5 2.1-6.3 3.9l-32 32c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l29.4-29.3 52-17.3 15.7 15.7-36.6 21.9c-4.8 2.9-7.8 8.1-7.8 13.7v32c0 8.8 7.2 16 16 16s16-7.2 16-16v-22.9l41.9-25.1h108.4l41.8 25.1V496c0 8.8 7.2 16 16 16s16-7.2 16-16v-32c0-5.6-3-10.8-7.8-13.7l-36.6-21.9 15.7-15.7 52 17.3 29.3 29.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-32-32c-1.8-1.8-3.9-3.1-6.3-3.9l-40.4-13.5 30.7-30.7 28 9.3 29.3 29.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-32-32c-1.8-1.8-3.9-3.1-6.3-3.9l-21.1-7V320c0-5.4-.3-10.8-1-16h33c2.5 0 4.9-.6 7.2-1.7l32-16c7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2L460.2 272h-37.5c-2.7-6.6-5.9-13-9.6-19l57.1-26.3c25.5-11.8 41.8-37.3 41.8-65.4V128h-8 8l-.2-7.5v-.4C507.6 53 452 0 384 0h-44.7c-7.1 0-10.7 8.6-5.7 13.7l36.7 36.7c5 5 1.5 13.7-5.7 13.7H328c-4.4 0-8.1 3.6-7.5 8 3.9 31.6 30.9 56 63.5 56h80v33.3c0 9.4-5.4 17.9-13.9 21.8L378.7 216c-16.9-12.2-37-20.3-58.7-23v-49c0-8.8-7.2-16-16-16s-16 7.2-16 16v48h-64v-48c0-8.8-7.2-16-16-16s-16 7.2-16 16v49c-21.7 2.7-41.7 10.9-58.7 23l-71.4-32.9c-8.5-3.9-13.9-12.5-13.9-21.8V128h80c32.6 0 59.6-24.4 63.5-56 .5-4.4-3.1-8-7.5-8h-36.7c-7.1 0-10.7-8.6-5.7-13.7l36.7-36.7c5-5 1.5-13.7-5.7-13.7H128z"
        }
    ]
};

const FasCrateApple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCrateApple",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 54.9C160 24.6 184.6 0 214.9 0c5 0 9.1 4.1 9.1 9.1 0 30.3-24.6 54.9-54.9 54.9-5 0-9.1-4.1-9.1-9.1zM32 171.4C32 127.8 52.4 80 96 80c15.6 0 34.1 5.9 47.2 11 10.7 4.2 22.8 4.2 33.5 0 13.1-5.1 31.6-11 47.2-11 43.6 0 64 47.8 64 91.4 0 7-.4 13.9-1.2 20.6H33.2c-.8-6.7-1.2-13.5-1.2-20.6zM319 192c.7-6.7 1-13.6 1-20.6 0-26.1-6-55.1-20.3-78.6-2.7-4.4-5.7-8.7-9-12.7 15 .6 32.2 6.1 44.6 11 10.7 4.2 22.8 4.2 33.5 0 13.1-5.1 31.6-11 47.2-11 43.6 0 64 47.8 64 91.4 0 7-.4 13.9-1.2 20.6H319zM406.9 0c5 0 9.1 4.1 9.1 9.1 0 30.3-24.6 54.9-54.9 54.9-5 0-9.1-4.1-9.1-9.1C352 24.6 376.6 0 406.9 0zM0 272c0-26.5 21.5-48 48-48h416c26.5 0 48 21.5 48 48v80H0v-80zm0 112h512v80c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48v-80zm80-96a16 16 0 1 0-32 0 16 16 0 1 0 32 0zM64 464a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm400-176a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm-16 176a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
        }
    ]
};

const FasCrateEmpty = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCrateEmpty",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 224c-26.5 0-48 21.5-48 48v80h512v-80c0-26.5-21.5-48-48-48H48zm464 160H0v80c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48v-80zM64 272a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM48 448a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm400-176a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-16 176a16 16 0 1 1 32 0 16 16 0 1 1-32 0z"
        }
    ]
};

const FasCreditCardBlank = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCreditCardBlank",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm32 336c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16zm128 0c0-8.8 7.2-16 16-16h128c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-8.8 0-16-7.2-16-16z"
        }
    ]
};

const FasCreditCardFront = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCreditCardFront",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 96c0-35.3 28.7-64 64-64h448c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm112 192c-8.8 0-16 7.2-16 16s7.2 16 16 16h352c8.8 0 16-7.2 16-16s-7.2-16-16-16H112zm-16 80c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16h-64c-8.8 0-16 7.2-16 16zm128 0c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16s-7.2-16-16-16H240c-8.8 0-16 7.2-16 16zM408 96c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24h-80z"
        }
    ]
};

const FasCreditCard = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCreditCard",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v32h576V96c0-35.3-28.7-64-64-64H64zm512 192H0v192c0 35.3 28.7 64 64 64h448c35.3 0 64-28.7 64-64V224zM112 352h64c8.8 0 16 7.2 16 16s-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16s7.2-16 16-16zm112 16c0-8.8 7.2-16 16-16h128c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-8.8 0-16-7.2-16-16z"
        }
    ]
};

const FasCricketBatBall = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCricketBatBall",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M502.6 9.4c12.5 12.5 12.5 32.8 0 45.3l-135 135L409 231c4.5 4.5 7 10.6 7 17s-2.5 12.5-7 17l-23 23H240c-8.8 0-16-7.2-16-16V126.1l23-23c9.4-9.4 24.6-9.4 33.9 0l41.4 41.4 135-135C469.8-3 490.1-3 502.6 9.5zM352 432a80 80 0 1 1 160 0 80 80 0 1 1-160 0zM16.1 334 192 158.1V272c0 26.5 21.5 48 48 48h113.9L178 495.9c-10 10-24.4 16.7-40.4 15.6-11.3-.8-28.6-2.8-46.4-8.2-17.3-5.1-37.1-14.2-52.2-30.3-16.2-15-25.2-34.9-30.4-52.2C3.2 403 1.2 385.7.5 374.4c-1.1-16 5.6-30.4 15.6-40.4z"
        }
    ]
};

const FasCroissant = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCroissant",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M259.4 1.4c3.9 5.9 7 12.5 9.1 19.5l59.9 199.7c1.2 4.1 2 8.2 2.4 12.4L440.3 92.2c13.6-17.4 10.5-42.8-8.6-53.9C389.4 14 340.3 0 288 0c-9.7 0-19.2.5-28.6 1.4zM233 330.8c-4.1-.4-8.3-1.2-12.4-2.4L20.9 268.5c-7-2.1-13.6-5.2-19.5-9.1C.5 268.8 0 278.3 0 288c0 52.3 14 101.4 38.4 143.7 11 19.1 36.4 22.2 53.9 8.6L233 330.8zM232.7 19c2 3 3.6 6.4 4.8 10-1.2-3.6-2.8-6.9-4.8-10zm232.9 92.8L390 209l87.6 14.6c1.6.3 3.2.4 4.9.4 16.3 0 29.6-13.2 29.6-29.6V189c0-4.2-.7-8.3-2.3-12.2-10.1-25.2-24.1-48.5-41.3-69-.9 1.4-1.9 2.7-2.9 4zM209 390l-97.1 75.6c-1.3 1-2.6 2-4 2.9 20.5 17.2 43.8 31.2 69 41.3 3.9 1.5 8 2.3 12.2 2.3h5.4c16.3 0 29.6-13.2 29.6-29.6 0-1.6-.1-3.3-.4-4.9L209 390zM19 232.7c2.3 1.5 4.7 2.8 7.3 3.8 1.2.5 2.5 1 3.8 1.3l199.7 59.9c11.3 3.4 23.5.3 31.8-8l28.1-28.1c8.3-8.3 11.4-20.5 8-31.8L237.8 30.1C232.5 12.2 216 0 197.4 0c-4.6 0-9.2.7-13.5 2.3C99.7 33 33 99.7 2.3 183.9.7 188.2 0 192.8 0 197.4c0 14.5 7.4 27.6 19 35.3z"
        }
    ]
};

const FasCropSimple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCropSimple",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 32c0-17.7-14.3-32-32-32S64 14.3 64 32v32H32C14.3 64 0 78.3 0 96s14.3 32 32 32h32v256c0 35.3 28.7 64 64 64h224v-64H128V32zm256 448c0 17.7 14.3 32 32 32s32-14.3 32-32v-32h32c17.7 0 32-14.3 32-32s-14.3-32-32-32h-32V128c0-35.3-28.7-64-64-64H160v64h224v352z"
        }
    ]
};

const FasCrop = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCrop",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m448 109.3 54.6-54.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L402.7 64H160v64h178.7L128 338.7V32c0-17.7-14.3-32-32-32S64 14.3 64 32v32H32C14.3 64 0 78.3 0 96s14.3 32 32 32h32v256c0 35.3 28.7 64 64 64h224v-64H173.3L384 173.3V480c0 17.7 14.3 32 32 32s32-14.3 32-32v-32h32c17.7 0 32-14.3 32-32s-14.3-32-32-32h-32V109.3z"
        }
    ]
};

const FasCross = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCross",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 0c-26.5 0-48 21.5-48 48v80H48c-26.5 0-48 21.5-48 48v32c0 26.5 21.5 48 48 48h80v208c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V256h80c26.5 0 48-21.5 48-48v-32c0-26.5-21.5-48-48-48h-80V48c0-26.5-21.5-48-48-48h-32z"
        }
    ]
};

const FasCrosshairsSimple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCrosshairsSimple",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M445.3 224H384c-17.7 0-32 14.3-32 32s14.3 32 32 32h61.3c-13.4 80.4-76.9 143.9-157.3 157.3V384c0-17.7-14.3-32-32-32s-32 14.3-32 32v61.3C143.6 431.9 80.1 368.4 66.7 288H128c17.7 0 32-14.3 32-32s-14.3-32-32-32H66.7C80.1 143.6 143.6 80.1 224 66.7V128c0 17.7 14.3 32 32 32s32-14.3 32-32V66.7c80.4 13.4 143.9 76.9 157.3 157.3zM0 256a256 256 0 1 0 512 0 256 256 0 1 0-512 0z"
        }
    ]
};

const FasCrosshairs = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCrosshairs",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 0c17.7 0 32 14.3 32 32v10.4c93.7 13.9 167.7 88 181.6 181.6H480c17.7 0 32 14.3 32 32s-14.3 32-32 32h-10.4c-13.9 93.7-88 167.7-181.6 181.6V480c0 17.7-14.3 32-32 32s-32-14.3-32-32v-10.4C130.3 455.7 56.3 381.7 42.4 288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h10.4C56.3 130.3 130.3 56.3 224 42.4V32c0-17.7 14.3-32 32-32zM107.4 288c12.5 58.3 58.4 104.1 116.6 116.6V384c0-17.7 14.3-32 32-32s32 14.3 32 32v20.6c58.3-12.5 104.1-58.4 116.6-116.6H384c-17.7 0-32-14.3-32-32s14.3-32 32-32h20.6c-12.5-58.3-58.3-104.1-116.6-116.6V128c0 17.7-14.3 32-32 32s-32-14.3-32-32v-20.6c-58.3 12.5-104.1 58.3-116.6 116.6H128c17.7 0 32 14.3 32 32s-14.3 32-32 32h-20.6zM256 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FasCrow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCrow",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M456 0c-48.6 0-88 39.4-88 88v29.2L12.5 390.6c-14 10.8-16.6 30.9-5.9 44.9s30.9 16.6 44.9 5.9l74.6-57.4h133.1l46.6 113.1c5 12.3 19.1 18.1 31.3 13.1s18.1-19.1 13.1-31.3L311.1 384h44.1l46.6 113.2c5 12.3 19.1 18.1 31.3 13.1s18.1-19.1 13.1-31.3l-42-102C484.9 354.1 544 280 544 192v-72l80.5-20.1c8.6-2.1 13.8-10.8 11.6-19.4C629 52 603.4 32 574 32h-50.1C507.7 12.5 483.3 0 456 0zm0 64a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FasCrown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCrown",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M309 106c11.4-7 19-19.7 19-34 0-22.1-17.9-40-40-40s-40 17.9-40 40c0 14.4 7.6 27 19 34l-57.3 114.6c-9.1 18.2-32.7 23.4-48.6 10.7L72 160c5-6.7 8-15 8-24 0-22.1-17.9-40-40-40S0 113.9 0 136s17.9 40 40 40h.7l45.7 251.4c5.5 30.4 32 52.6 63 52.6h277.2c30.9 0 57.4-22.1 63-52.6L535.3 176h.7c22.1 0 40-17.9 40-40s-17.9-40-40-40-40 17.9-40 40c0 9 3 17.3 8 24l-89.1 71.3c-15.9 12.7-39.5 7.5-48.6-10.7L309 106z"
        }
    ]
};

const FasCrutch = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCrutch",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M297.4 9.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0zm-96 144-34.8 34.8c-12.9 12.9-21.9 29.2-25.8 47.1l-24 107.6c-1.3 5.9-4.3 11.4-8.6 15.7L9.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l98.8-98.8c4.3-4.3 9.7-7.3 15.7-8.6l107.6-23.9c17.8-4 34.1-12.9 47.1-25.8l34.7-34.7.1-.1.1-.1 74.6-74.6-45.3-45.3-52.1 51.9-66.7-66.7 52.1-52.1-45.3-45.3-74.7 74.7zm22.6 67.9 66.7 66.7-12.2 12.2c-4.3 4.3-9.7 7.3-15.7 8.6l-76.7 17 17-76.7c1.3-5.9 4.3-11.4 8.6-15.7l12.3-12.1z"
        }
    ]
};

const FasCrutches = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCrutches",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m470.6 9.4 160 160c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-160-160c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0zm-176 178.8L404.1 78.6l45.3 45.3-52.1 52.1 66.7 66.7 52.1-52.1 45.3 45.3-74.6 74.6-.1.1-.1.1-34.7 34.7c-12.9 12.9-29.2 21.9-47.1 25.8l-107.7 24c-5.9 1.3-11.4 4.3-15.7 8.6l-98.8 98.8c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l98.8-98.8c4.3-4.3 7.3-9.7 8.6-15.7l23.9-107.6c4-17.8 12.9-34.1 25.8-47.1zm45.3 45.3c-4.3 4.3-7.3 9.7-8.6 15.7l-17 76.7 76.7-17c5.9-1.3 11.4-4.3 15.7-8.6l12-12.3-66.7-66.7-12.2 12.2zM169.4 9.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-1.4 1.3 84.1 84.1-25.4 25.4c-6.7 6.7-12.6 14.1-17.6 22L168 101.3 101.3 168l122.4 122.4-10.1 45.5-17 17c-2.9-2.3-5.7-4.8-8.4-7.5L56 213.3l-1.4 1.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l160-160zm242.3 393.1c9.3-2.1 18.3-5.2 26.9-9.2l64.1 64.1c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-90.2-90.2 44.5-9.9z"
        }
    ]
};

const FasCruzeiroSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCruzeiroSign",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 256c0-88.4 71.6-160 160-160 41 0 78.3 15.4 106.7 40.7 13.2 11.8 33.4 10.7 45.2-2.5s10.7-33.4-2.5-45.2c-39.6-35.5-92-57-149.3-57C132.3 32 32 132.3 32 256s100.3 224 224 224c57.4 0 109.7-21.6 149.3-57 13.2-11.8 14.3-32 2.5-45.2s-32-14.3-45.2-2.5C334.3 400.6 297 416 256 416V311.3c0-12.8 10.4-23.3 23.3-23.3 4.6 0 9.1 1.4 12.9 3.9l10.1 6.7c14.7 9.8 34.6 5.8 44.4-8.9s5.8-34.6-8.9-44.4l-10.1-6.7c-14.3-9.6-31.2-14.7-48.4-14.7-12.4 0-24.2 2.6-34.9 7.3-5.5-4.5-12.6-7.3-20.3-7.3-17.7 0-32 14.3-32 32v146.8C135.5 378 96 321.6 96 256z"
        }
    ]
};

const FasCrystalBall = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCrystalBall",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 224c0 62.7-25.7 119.3-67.2 160H67.2C25.7 343.3 0 286.7 0 224 0 100.3 100.3 0 224 0s224 100.3 224 224zM152.5 84.3l-9.8 26.4-26.4 9.8c-7 2.6-7 12.4 0 15l26.4 9.8 9.8 26.4c2.6 7 12.4 7 15 0l9.8-26.4 26.4-9.8c7-2.6 7-12.4 0-15l-26.4-9.8-9.8-26.4c-2.6-7-12.4-7-15 0zm159 48c-2.6-7-12.4-7-15 0l-18.4 49.8-49.8 18.4c-7 2.6-7 12.4 0 15l49.8 18.4 18.4 49.8c2.6 7 12.4 7 15 0l18.4-49.8 49.8-18.4c7-2.6 7-12.4 0-15l-49.8-18.4-18.4-49.8zm98.9 331.8c3.7 5.1 5.6 11.3 5.6 17.6 0 16.7-13.6 30.3-30.3 30.3H62.3C45.6 512 32 498.4 32 481.7c0-6.3 2-12.5 5.6-17.6L72 416h304l34.4 48.1z"
        }
    ]
};

const FasCube = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCube",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M234.5 5.7c13.9-5 29.1-5 43.1 0l192 68.6c25.4 9.1 42.4 33.2 42.4 60.3v242.8c0 27-17 51.2-42.5 60.3l-192 68.6c-13.9 5-29.1 5-43.1 0l-192-68.6C17 428.6 0 404.5 0 377.4V134.6c0-27 17-51.2 42.5-60.3l192-68.6zM256 66 82.3 128 256 190l173.7-62L256 66zm32 368.6 160-57.1v-188l-160 57.1v188z"
        }
    ]
};

const FasCubesStacked = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCubesStacked",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 64v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32h-64c-17.7 0-32 14.3-32 32zM82.7 207c-15.3 8.8-20.5 28.4-11.7 43.7l32 55.4c8.8 15.3 28.4 20.5 43.7 11.7l55.4-32c15.3-8.8 20.5-28.4 11.7-43.7l-32-55.4c-8.8-15.3-28.4-20.5-43.7-11.7l-55.4 32zM288 192c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32v-64c0-17.7-14.3-32-32-32h-64zm64 160c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32v-64c0-17.7-14.3-32-32-32h-64zm-192 32v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32v-64c0-17.7-14.3-32-32-32h-64c-17.7 0-32 14.3-32 32zM32 352c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32v-64c0-17.7-14.3-32-32-32H32z"
        }
    ]
};

const FasCubes = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCubes",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m290.8 48.6 78.4 29.7-81.2 31.2-81.2-31.2 78.4-29.7c1.8-.7 3.8-.7 5.7 0zM136 92.5v112.2c-1.3.4-2.6.8-3.9 1.3l-96 36.4C14.4 250.6 0 271.5 0 294.7v119.2c0 22.2 13.1 42.3 33.5 51.3l96 42.2c14.4 6.3 30.7 6.3 45.1 0L288 457.5l113.5 49.9c14.4 6.3 30.7 6.3 45.1 0l96-42.2c20.3-8.9 33.5-29.1 33.5-51.3V294.7c0-23.3-14.4-44.1-36.1-52.4l-96-36.4c-1.3-.5-2.6-.9-3.9-1.3V92.5c0-23.3-14.4-44.1-36.1-52.4L308 3.7c-12.8-4.8-26.9-4.8-39.7 0l-96 36.4C150.4 48.4 136 69.3 136 92.5zm256 118.1-82.4 31.2v-89.2L392 121v89.6zm-237.2 40.3 78.4 29.7-81.2 31.1-81.2-31.1 78.4-29.7c1.8-.7 3.8-.7 5.7 0zm18.8 204.4V354.8l82.4-31.6v95.9l-82.4 36.2zm247.6-204.4c1.8-.7 3.8-.7 5.7 0l78.4 29.7-81.3 31.1-81.2-31.1 78.4-29.7zm102 170.3-77.6 34.1V354.8l82.4-31.6v90.7c0 3.2-1.9 6-4.8 7.3z"
        }
    ]
};

const FasCucumber = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCucumber",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M37.5 474.5c47.8 47.8 124 49.9 174.3 6.3 12.6 10.3 31.1 9.6 42.9-2.2 11.6-11.6 12.4-30 2.4-42.6L436 257c12.6 10.1 31 9.3 42.6-2.4 11.7-11.7 12.5-30.3 2.2-42.9 43.6-50.3 41.5-126.5-6.3-174.3-50-50-131-50-181 0L172 159c-12.6-10.1-31-9.3-42.6 2.4s-12.4 30-2.4 42.6l-89.5 89.5c-50 50-50 131 0 181zM400 88a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-96 160a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-184 56a24 24 0 1 1 48 0 24 24 0 1 1-48 0z"
        }
    ]
};

const FasCupStrawSwoosh = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCupStrawSwoosh",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m194.8 43.2-20 84.8H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h320c17.7 0 32-14.3 32-32s-14.3-32-32-32H224.2l17.4-73.8c.9-3.6 4.1-6.2 7.8-6.2H280c13.3 0 24-10.7 24-24S293.3 0 280 0h-30.7c-26 0-48.6 17.9-54.5 43.2zM40 224l20.3 244c2.1 24.9 22.9 44 47.8 44h167.7c25 0 45.8-19.1 47.8-44L344 224H40zm194.4 78.9c18.8-10.1 42-17.2 72.7-20.6l-4.1 48.9c-20.8 3.1-35.2 8.2-45.8 13.9-17.2 9.3-26.9 21.2-39.9 37.2l-.7.8c-13.3 16.4-29.5 35.9-58.7 50.4-17.7 8.8-39.3 15.2-66.7 18.9l-4-47.9c22.1-3.2 37.7-8.3 49.4-14.1 19.3-9.5 30.1-22 42.8-37.6l1.9-2.3c12.3-15.2 27.4-33.8 53.1-47.7z"
        }
    ]
};

const FasCupStraw = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCupStraw",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M249.3 0H280c13.3 0 24 10.7 24 24s-10.7 24-24 24h-30.7c-3.7 0-6.9 2.6-7.8 6.2L224.2 128H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h142.9l20-84.8C200.8 17.9 223.4 0 249.3 0zm-189 468L40 224h304l-20.3 244c-2.1 24.9-22.9 44-47.8 44H108.2c-25 0-45.8-19.1-47.8-44z"
        }
    ]
};

const FasCupTogo = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCupTogo",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M55.2 17.7C60.6 6.8 71.7 0 83.8 0h280.4c12.1 0 23.2 6.8 28.6 17.7L416 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32l23.2-46.3zm19.5 436.1L48 160h352l-26.7 293.8c-3 33-30.6 58.2-63.7 58.2H138.4c-33.1 0-60.7-25.2-63.7-58.2zm249.1-162.9c1.7-18.7-13.1-34.9-31.9-34.9H156c-18.8 0-33.6 16.2-31.9 34.9l8.7 96c1.5 16.5 15.3 29.1 31.9 29.1h118.5c16.6 0 30.4-12.6 31.9-29.1l8.7-96z"
        }
    ]
};

const FasCupcake = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCupcake",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M240 0c-6.5 0-12.3 3.9-14.8 9.9s-1.1 12.9 3.5 17.4l6.1 6.1c3.4 3.4 5.3 7.9 5.3 12.7C240 56 232 64 222.1 64H160c-35.3 0-64 28.7-64 64v.8c-3.3.5-6.6 1.4-9.9 2.4L50.9 143C20.5 153.2 0 181.6 0 213.6 0 254.7 33.3 288 74.4 288h299.2c41.1 0 74.4-33.3 74.4-74.4 0-32-20.5-60.4-50.9-70.6l-35.3-11.8c-4.1-1.4-8.2-2.3-12.5-2.8 1.7-6.7 2.6-13.8 2.6-21C352 48.1 303.9 0 244.6 0H240zm27.9 512 24-192H156.1l24 192h87.8zM64 320l25.3 151.9c3.9 23.1 23.9 40.1 47.4 40.1h11.2l-24-192H64zm236.1 192h11.2c23.5 0 43.5-17 47.3-40.1L384 320h-59.9l-24 192z"
        }
    ]
};

const FasCurlingStone = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCurlingStone",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 128c0-17.7 14.3-32 32-32h128c17.7 0 32-14.3 32-32s-14.3-32-32-32H256c-53 0-96 43-96 96v32c-35.3 0-64 28.7-64 64-53 0-96 43-96 96v16h576v-16c0-53-43-96-96-96 0-35.3-28.7-64-64-64H224v-32zm352 240H0v16c0 53 43 96 96 96h384c53 0 96-43 96-96v-16z"
        }
    ]
};

const FasCustard = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasCustard",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M396.7 64c30 0 56 20.8 62.5 50.1l13.5 60.8c-21.8-7.5-49.2-14.9-72.7-14.9-26.4 0-45.8 9.4-62.2 17.2l-.7.3c-16.7 8-30.4 14.4-49.1 14.4s-32.3-6.4-49.1-14.4l-.7-.3c-16.4-7.8-35.8-17.2-62.2-17.2-23.5 0-50.9 7.4-72.6 14.9l13.5-60.8c6.5-29.3 32.4-50.1 62.4-50.1h217.4zM64.3 350.9l30.8-138.8c4.1-1.6 8.5-3.3 13.2-5 22-7.9 47.8-15.1 67.7-15.1 18.7 0 32.3 6.4 49.1 14.4l.7.3c16.4 7.9 35.8 17.2 62.2 17.2s45.8-9.4 62.2-17.2l.7-.3c16.7-8 30.4-14.4 49.1-14.4 19.8 0 45.6 7.2 67.7 15.1 4.7 1.7 9.2 3.4 13.2 5L512 352l-447.7-1.1zM32 384h512c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
        }
    ]
};

const FasD = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasD",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 96c0-35.3 28.7-64 64-64h96c123.7 0 224 100.3 224 224S283.7 480 160 480H64c-35.3 0-64-28.7-64-64V96zm160 0H64v320h96c88.4 0 160-71.6 160-160S248.4 96 160 96z"
        }
    ]
};

const FasDagger = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDagger",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 32c0-17.7-14.3-32-32-32s-32 14.3-32 32v96H48c-26.5 0-48 21.5-48 48s21.5 48 48 48c20.9 0 38.7-13.4 45.3-32h197.4c6.6 18.6 24.4 32 45.3 32 26.5 0 48-21.5 48-48s-21.5-48-48-48H224V32zm-96 192v190.8c0 10.5 2.9 20.8 8.5 29.7l35.1 56.2c4.4 7 12.1 11.3 20.4 11.3s16-4.3 20.4-11.3l35.1-56.2c5.6-8.9 8.5-19.2 8.5-29.7V224H128z"
        }
    ]
};

const FasDash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDash",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 256c0-17.7 14.3-32 32-32h448c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32z"
        }
    ]
};

const FasDatabase = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDatabase",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 80v48c0 44.2-100.3 80-224 80S0 172.2 0 128V80C0 35.8 100.3 0 224 0s224 35.8 224 80zm-54.8 134.7c20.8-7.4 39.9-16.9 54.8-28.6V288c0 44.2-100.3 80-224 80S0 332.2 0 288V186.1c14.9 11.8 34 21.2 54.8 28.6C99.7 230.7 159.5 240 224 240s124.3-9.3 169.2-25.3zM0 346.1c14.9 11.8 34 21.2 54.8 28.6C99.7 390.7 159.5 400 224 400s124.3-9.3 169.2-25.3c20.8-7.4 39.9-16.9 54.8-28.6V432c0 44.2-100.3 80-224 80S0 476.2 0 432v-85.9z"
        }
    ]
};

const FasDeerRudolph = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDeerRudolph",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v24c0 30.9 25.1 56 56 56h40l-50.4 12.6c-8 2-13.6 9.2-13.6 17.4 0 9.9 8 18 18 18h38l-9.6 32H106c-54.3 0-99.4 41.8-103.6 96L.1 302.2C-.9 315.4 9 327 22.2 328c13 1 24.4-8.6 25.7-21.5 2.4 3.3 5.2 6.5 8.1 9.5 9 9 9 23.5 2.4 34.4-17.4 28.6-21.5 63.9-10 96.3l15.5 44c4.5 12.7 16.6 21.3 30.2 21.3H128c22.1 0 37.5-21.8 30.2-42.6l-19.3-54.7c-2.2-6.2-.6-13 4-17.7l10.6-10.6c12.1-12.1 19.8-27.9 21.9-44.8 21 16.5 47.5 26.4 76.3 26.4H288v112c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V304l26.7-80h56c25 0 45.3-20.3 45.3-45.3 0-1.2 0-2.4-.1-3.6 2.6.5 5.4.8 8.1.8 22.1 0 40-17.9 40-40s-17.9-40-40-40c-19.6 0-35.9 14.1-39.3 32.7l-37.3-37.2c-.6-.6-1.1-1.1-1.7-1.6 18-9.4 30.3-28.1 30.3-49.8V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v24c0 13.3-10.7 24-24 24h-69.4c3.5-7.3 5.4-15.4 5.4-24V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v24c0 13.3-10.7 24-24 24h-16c-13.3 0-24-10.7-24-24V16zm128 128a16 16 0 1 1 32 0 16 16 0 1 1-32 0z"
        }
    ]
};

const FasDeer = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDeer",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M240 0c8.8 0 16 7.2 16 16v24c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V16c0-8.8 7.2-16 16-16s16 7.2 16 16v24c0 8.6-1.9 16.7-5.4 24H416c13.3 0 24-10.7 24-24V16c0-8.8 7.2-16 16-16s16 7.2 16 16v24c0 21.7-12.3 40.4-30.3 49.8.6.5 1.1 1.1 1.7 1.6l55.3 55.3c8.5 8.5 13.3 20 13.3 32 0 25-20.3 45.3-45.3 45.3h-56L384 304v176c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32V368h-36.3c-28.8 0-55.3-9.8-76.3-26.4-2.1 16.9-9.8 32.6-21.9 44.8L142.9 397c-4.6 4.6-6.2 11.5-4 17.7l19.3 54.7c7.3 20.8-8.1 42.6-30.2 42.6H94.1c-13.6 0-25.7-8.6-30.2-21.4l-15.5-44c-11.4-32.4-7.4-67.8 10-96.3 6.6-10.9 6.6-25.4-2.4-34.4-3-3-5.7-6.1-8.1-9.5-1.3 12.9-12.7 22.5-25.7 21.5-13.3-1-23.1-12.5-22.1-25.7L2.4 272c4.2-54.2 49.3-96 103.7-96h196.3l9.6-32h-38c-9.9 0-18-8-18-18 0-8.2 5.6-15.4 13.6-17.4L320 96h-40c-30.9 0-56-25.1-56-56V16c0-8.8 7.2-16 16-16zm160 160a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
        }
    ]
};

const FasDeleteLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDeleteLeft",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M576 128c0-35.3-28.7-64-64-64H205.3c-17 0-33.3 6.7-45.3 18.7L9.4 233.4c-6 6-9.4 14.1-9.4 22.6s3.4 16.6 9.4 22.6L160 429.3c12 12 28.3 18.7 45.3 18.7H512c35.3 0 64-28.7 64-64V128zm-305 47c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"
        }
    ]
};

const FasDeleteRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDeleteRight",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 128c0-35.3 28.7-64 64-64h306.7c17 0 33.3 6.7 45.3 18.7l150.6 150.7c6 6 9.4 14.1 9.4 22.6s-3.4 16.6-9.4 22.6L416 429.3c-12 12-28.3 18.7-45.3 18.7H64c-35.3 0-64-28.7-64-64V128zm143 47c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z"
        }
    ]
};

const FasDemocrat = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDemocrat",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32c0-8.9 3.8-20.9 6.2-27.3C71.2 1.8 74 0 77 0c1.9 0 3.8.7 5.2 2.1L128 45.7l45.8-43.6C175.2.7 177.1 0 179 0c3 0 5.8 1.8 6.8 4.7 2.4 6.5 6.2 18.4 6.2 27.3 0 26.5-21.9 42-29.5 46.6l76.2 72.6c6 5.7 13.9 8.8 22.1 8.8H512c40.3 0 78.2 19 102.4 51.2l19.2 25.6c10.6 14.1 7.7 34.2-6.4 44.8s-34.2 7.7-44.8-6.4l-19.2-25.6c-5.3-7-11.8-12.8-19.2-17V320H192l-40.4-94.3c-3.9-9.2-15.3-12.6-23.6-7l-42.1 28c-9.1 6.1-19.7 9.3-30.7 9.3h-2C23.9 256 0 232.1 0 202.7c0-12.1 4.1-23.8 11.7-33.3l75.9-94.8C78.1 67.4 64 53.2 64 32zm384 320h96v128c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32v-64H288v64c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32V352h256zM260.9 210.9c-.9-1.8-2.8-2.9-4.8-2.9s-3.9 1.1-4.8 2.9l-10.5 20.5-23.5 3.3c-2 .3-3.7 1.6-4.3 3.5s-.1 3.9 1.3 5.3l17 16-4 22.6c-.3 1.9.5 3.9 2.1 5s3.8 1.3 5.6.4l21-10.7 21 10.7c1.8.9 4 .8 5.6-.4s2.5-3.1 2.1-5l-4-22.6 17-16c1.5-1.4 2-3.4 1.3-5.3s-2.3-3.2-4.3-3.5l-23.5-3.3-10.5-20.5zm107.2-2.9c-2 0-3.9 1.1-4.8 2.9l-10.5 20.5-23.5 3.3c-2 .3-3.7 1.6-4.3 3.5s-.1 3.9 1.3 5.3l17 16-4 22.6c-.3 1.9.5 3.9 2.1 5s3.8 1.3 5.6.4l21-10.7 21 10.7c1.8.9 4 .8 5.6-.4s2.5-3.1 2.1-5l-4-22.6 17-16c1.5-1.4 2-3.4 1.4-5.3s-2.3-3.2-4.3-3.5l-23.5-3.3-10.5-20.5c-.9-1.8-2.8-2.9-4.8-2.9zm116.8 2.9c-.9-1.8-2.8-2.9-4.8-2.9s-3.9 1.1-4.8 2.9l-10.5 20.5-23.5 3.3c-2 .3-3.7 1.6-4.3 3.5s-.1 3.9 1.3 5.3l17 16-4 22.6c-.3 1.9.5 3.9 2.1 5s3.8 1.3 5.6.4l21-10.7 21 10.7c1.8.9 4 .8 5.6-.4s2.5-3.1 2.1-5l-4-22.6 17-16c1.5-1.4 2-3.4 1.4-5.3s-2.3-3.2-4.3-3.5l-23.5-3.3-10.5-20.5z"
        }
    ]
};

const FasDesktopArrowDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDesktopArrowDown",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 0C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h176l-10.7 32H160c-17.7 0-32 14.3-32 32s14.3 32 32 32h256c17.7 0 32-14.3 32-32s-14.3-32-32-32h-69.3L336 416h176c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H352v64h160v224H64V64h160V0H64zm248 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v150.1l-39-39c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l80 80c9.4 9.4 24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-39 39V24z"
        }
    ]
};

const FasDesktop = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDesktop",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 0C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h176l-10.7 32H160c-17.7 0-32 14.3-32 32s14.3 32 32 32h256c17.7 0 32-14.3 32-32s-14.3-32-32-32h-69.3L336 416h176c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm448 64v224H64V64h448z"
        }
    ]
};

const FasDharmachakra = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDharmachakra",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m337.8 205.7 48.6-42.5c13.8 19.3 23.4 41.9 27.4 66.2l-64.4 4.3c-2.4-10.1-6.4-19.5-11.6-28zm140.1 19.5c-5.3-38.8-20.6-74.5-43.2-104.3l.8-.7C449 108.4 449.7 87.6 437 75s-33.4-12-45.2 1.5l-.7.8c-29.8-22.6-65.5-37.9-104.3-43.2l.1-1.1c1.2-17.9-13-33-30.9-33s-32.1 15.2-30.9 33l.1 1.1c-38.8 5.3-74.5 20.6-104.3 43.2l-.7-.8C108.4 63 87.6 62.3 75 75s-12 33.4 1.5 45.2l.8.7c-22.6 29.8-37.9 65.5-43.2 104.3l-1.1-.1c-17.9-1.2-33 13-33 30.9s15.2 32.1 33 30.9l1.1-.1c5.3 38.8 20.6 74.5 43.2 104.3l-.8.7C63 403.6 62.3 424.4 75 437s33.4 12 45.2-1.5l.7-.8c29.8 22.6 65.5 37.9 104.3 43.2l-.1 1.1c-1.2 17.9 13 33 30.9 33s32.1-15.2 30.9-33l-.1-1.1c38.8-5.3 74.5-20.6 104.3-43.2l.7.8c11.8 13.5 32.5 14.2 45.2 1.5s12-33.4-1.5-45.2l-.8-.7c22.6-29.8 37.9-65.5 43.2-104.3l1.1.1c17.9 1.2 33-13 33-30.9s-15.2-32.1-33-30.9l-1.1.1zm-314.7-99.6c19.3-13.8 41.9-23.4 66.2-27.5l4.3 64.4c-10 2.4-19.5 6.4-28 11.6l-42.5-48.6zm-65 103.8c4.1-24.4 13.7-46.9 27.5-66.2l48.6 42.5c-5.3 8.5-9.2 18-11.6 28l-64.4-4.3zm27.5 119.4a159.52 159.52 0 0 1-27.5-66.2l64.4-4.3c2.4 10 6.4 19.5 11.6 28l-48.6 42.5zm103.8 65c-24.4-4.1-46.9-13.7-66.2-27.4l42.5-48.6c8.5 5.3 18 9.2 28 11.6l-4.3 64.4zm119.4-27.4c-19.3 13.8-41.9 23.4-66.2 27.4l-4.3-64.4c10-2.4 19.5-6.4 28-11.6l42.5 48.6zm65-103.8c-4.1 24.4-13.7 46.9-27.4 66.2l-48.6-42.5c5.3-8.5 9.2-18 11.6-28l64.4 4.3zm-65-156.9-42.5 48.6c-8.5-5.3-18-9.2-28-11.6l4.3-64.4c24.4 4.1 46.9 13.7 66.2 27.5zM256 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FasDiagramCells = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDiagramCells",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 160c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h384c35.3 0 64 28.7 64 64v64zm-64 256v-64H64v64h384zm0 64H64c-35.3 0-64-28.7-64-64v-64c0-35.3 28.7-64 64-64h384c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64z"
        }
    ]
};

const FasDiagramLeanCanvas = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDiagramLeanCanvas",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 96v208h64V96h-64zm-48 0h-64v80h64V96zm-112 0h-64v208h64V96zm-112 0h-64v80h64V96zm-112 0H64v208h64V96zM64 352v64h232v-64H64zm280 64h232v-64H344v64zM0 96c0-35.3 28.7-64 64-64h512c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm240 208v-80h-64v80h64zm224-80h-64v80h64v-80z"
        }
    ]
};

const FasDiagramNested = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDiagramNested",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 80c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48h-16v96c0 17.7 14.3 32 32 32h96v-16c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48h-96c-26.5 0-48-21.5-48-48v-16h-96c-53 0-96-43-96-96v-96H48c-26.5 0-48-21.5-48-48V80z"
        }
    ]
};

const FasDiagramNext = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDiagramNext",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 160c0 35.3-28.7 64-64 64H280v64h46.1c21.4 0 32.1 25.9 17 41L273 399c-9.4 9.4-24.6 9.4-33.9 0L169 329c-15.1-15.1-4.4-41 17-41h46v-64H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h384c35.3 0 64 28.7 64 64v64zm-64 256v-64h-82.7l.4-.4c18.4-18.4 20.4-43.7 11-63.6H448c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64v-64c0-35.3 28.7-64 64-64h71.3c-9.4 19.9-7.4 45.2 11 63.6l.4.4H64v64h146.7l5.7 5.7c21.9 21.9 57.3 21.9 79.2 0l5.7-5.7H448z"
        }
    ]
};

const FasDiagramPredecessor = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDiagramPredecessor",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 416v-64H64v64h384zm0 64H64c-35.3 0-64-28.7-64-64v-64c0-35.3 28.7-64 64-64h384c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64zM288 160c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h304c44.2 0 80 35.8 80 80v16h38.1c21.4 0 32.1 25.9 17 41L433 239c-9.4 9.4-24.6 9.4-33.9 0L329 169c-15.1-15.1-4.4-41 17-41h38.1v-16c0-8.8-7.2-16-16-16h-80v64z"
        }
    ]
};

const FasDiagramPrevious = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDiagramPrevious",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 352H64v64h384v-64zm0-64c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64v-64c0-35.3 28.7-64 64-64h168v-64h-46.1c-21.4 0-32.1-25.9-17-41l70.1-70c9.4-9.4 24.6-9.4 33.9 0l70.1 70c15.1 15.1 4.4 41-17 41h-46v64h168zm-82.3-127.6-70.1-70.1c-21.9-21.9-57.3-21.9-79.2 0l-70.1 70.1c-18.4 18.4-20.4 43.7-11 63.6H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h384c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64h-71.3c9.4-19.9 7.4-45.2-11-63.6z"
        }
    ]
};

const FasDiagramProject = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDiagramProject",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 80c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v16h192V80c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48h-96c-26.5 0-48-21.5-48-48v-16H192v16c0 1.7-.1 3.4-.3 5L272 288h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48h-96c-26.5 0-48-21.5-48-48v-96c0-1.7.1-3.4.3-5L144 224H48c-26.5 0-48-21.5-48-48V80z"
        }
    ]
};

const FasDiagramSankey = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDiagramSankey",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M294.4 44.8c6-8.1 15.5-12.8 25.6-12.8h224c17.7 0 32 14.3 32 32s-14.3 32-32 32H336l-86.4 115.2c-6 8.1-15.5 12.8-25.6 12.8H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h176l86.4-115.2zM141.9 320H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h512c17.7 0 32 14.3 32 32s-14.3 32-32 32H216.5l57.6 96H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H256c-11.2 0-21.7-5.9-27.4-15.5L141.9 320z"
        }
    ]
};

const FasDiagramSubtask = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDiagramSubtask",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 96c0-35.3 28.7-64 64-64h384c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H160v96c0 17.7 14.3 32 32 32h32c0-35.3 28.7-64 64-64h160c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H288c-35.3 0-64-28.7-64-64h-32c-53 0-96-43-96-96v-96H64c-35.3 0-64-28.7-64-64V96zm448 256H288v64h160v-64z"
        }
    ]
};

const FasDiagramSuccessor = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDiagramSuccessor",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 416v-64c0-35.3-28.7-64-64-64H64c-35.3 0-64 28.7-64 64v64c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64zM64 160V96h160v64H64zm224 0V96h80c8.8 0 16 7.2 16 16v16h-38.1c-21.4 0-32.1 25.9-17 41l70.1 70c9.4 9.4 24.6 9.4 33.9 0l70.1-70c15.1-15.1 4.4-41-17-41h-38v-16c0-44.2-35.8-80-80-80H64C28.7 32 0 60.7 0 96v64c0 35.3 28.7 64 64 64h160c35.3 0 64-28.7 64-64z"
        }
    ]
};

const FasDiagramVenn = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDiagramVenn",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 412.8c-39.6-40.4-64-95.8-64-156.8s24.4-116.4 64-156.8c-10.3-2.1-21-3.2-32-3.2-88.4 0-160 71.6-160 160s71.6 160 160 160c11 0 21.7-1.1 32-3.2zm64 45.7c-29.1 13.8-61.6 21.6-96 21.6C100.3 480 0 379.7 0 256S100.3 32 224 32c34.4 0 66.9 7.7 96 21.6C349.1 39.7 381.6 32 416 32c123.7 0 224 100.3 224 224S539.7 480 416 480c-34.4 0-66.9-7.7-96-21.6zM370.7 192H269.3c-6.5 14.9-10.8 31.1-12.5 48h126.4c-1.7-16.9-6-33.1-12.5-48zM269.3 320h101.4c6.5-14.9 10.8-31.1 12.5-48H256.8c1.7 16.9 6 33.1 12.5 48zm18.7 32c9.1 12.1 19.9 22.9 32 32 12.1-9.1 22.9-19.9 32-32h-64zm64-192c-9.1-12.1-19.9-22.9-32-32-12.1 9.1-22.9 19.9-32 32h64z"
        }
    ]
};

const FasDialHigh = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDialHigh",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm.4 127.6c80.2 0 146.6 59 158.2 136H288.4c-13.3 0-24 10.7-24 24s10.7 24 24 24h158.2c-11.6 77-78 136-158.2 136-88.4 0-160-71.6-160-160s71.6-160 160-160zM512 288a32 32 0 1 1 64 0 32 32 0 1 1-64 0zM32 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 96a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm416-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 480a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm416-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FasDialLow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDialLow",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-.4 447.6c-80.2 0-146.6-59-158.2-136h158.2c13.3 0 24-10.7 24-24s-10.7-24-24-24H129.4c11.6-77 78-136 158.2-136 88.4 0 160 71.6 160 160s-71.6 160-160 160zM512 288a32 32 0 1 1 64 0 32 32 0 1 1-64 0zM32 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 96a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm416-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 480a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm416-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FasDialMax = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDialMax",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm113.4 174.7c56.7 56.7 61.9 145.4 15.7 208L305.2 270.9c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l111.9 111.9c-62.6 46.2-151.3 41-208-15.7-62.5-62.5-62.5-163.8 0-226.3s163.8-62.5 226.3 0zM512 288a32 32 0 1 1 64 0 32 32 0 1 1-64 0zM32 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 96a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm416-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 480a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm416-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FasDialMedLow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDialMedLow",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM174.6 400.5c-56.7-56.7-62-145.4-15.7-208l111.9 111.8c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L192.8 158.5c62.6-46.2 151.3-41 208 15.7 62.5 62.5 62.5 163.8 0 226.3s-163.8 62.5-226.3 0zM512 288a32 32 0 1 1 64 0 32 32 0 1 1-64 0zM32 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 96a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm416-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 480a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm416-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FasDialMed = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDialMed",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM128 287.2c0-80.2 59-146.6 136-158.2v158.2c0 13.3 10.7 24 24 24s24-10.7 24-24V129c77 11.6 136 78 136 158.2 0 88.4-71.6 160-160 160s-160-71.6-160-160zm384 .8a32 32 0 1 1 64 0 32 32 0 1 1-64 0zM32 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 96a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm416-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 480a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm416-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FasDialMin = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDialMin",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm112.9 401c-56.7 56.7-145.4 62-208 15.7l111.8-111.8c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L158.9 382.8c-46.2-62.6-41-151.3 15.7-208 62.5-62.5 163.8-62.5 226.3 0s62.5 163.8 0 226.3zM512 288a32 32 0 1 1 64 0 32 32 0 1 1-64 0zM32 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 96a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm416-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 480a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm416-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FasDialOff = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDialOff",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm160 288c0 80.2-59 146.6-136 158.2V288c0-13.3-10.7-24-24-24s-24 10.7-24 24v158.2c-77-11.6-136-78-136-158.2 0-88.4 71.6-160 160-160s160 71.6 160 160zm64 0a32 32 0 1 1 64 0 32 32 0 1 1-64 0zM32 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 96a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm416-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 480a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm416-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FasDial = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDial",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM175.1 174.2c56.7-56.7 145.4-62 208-15.7L271.3 270.4c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l111.9-111.9c46.2 62.6 41 151.3-15.7 208-62.5 62.5-163.8 62.5-226.3 0s-62.5-163.8 0-226.3zM512 288a32 32 0 1 1 64 0 32 32 0 1 1-64 0zM32 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 96a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm416-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 480a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm416-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FasDiamondExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDiamondExclamation",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M227.7 11.7c15.6-15.6 40.9-15.6 56.6 0l216 216c15.6 15.6 15.6 40.9 0 56.6l-216 216c-15.6 15.6-40.9 15.6-56.6 0l-216-216c-15.6-15.6-15.6-40.9 0-56.6l216-216zM256 128c-13.3 0-24 10.7-24 24v112c0 13.3 10.7 24 24 24s24-10.7 24-24V152c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0-64 0 32 32 0 1 0 64 0z"
        }
    ]
};

const FasDiamondHalfStroke = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDiamondHalfStroke",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 78.5 433.5 256 256 433.5v-355zm28.3-66.8c-15.6-15.6-40.9-15.6-56.6 0l-216 216c-15.6 15.6-15.6 40.9 0 56.6l216 216c15.6 15.6 40.9 15.6 56.6 0l216-216c15.6-15.6 15.6-40.9 0-56.6l-216-216z"
        }
    ]
};

const FasDiamondHalf = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDiamondHalf",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 0c-10.2 0-20.5 3.9-28.3 11.7l-216 216c-15.6 15.6-15.6 40.9 0 56.6l216 216c7.8 7.8 18 11.7 28.3 11.7V0z"
        }
    ]
};

const FasDiamondTurnRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDiamondTurnRight",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M227.7 11.7c15.6-15.6 40.9-15.6 56.6 0l216 216c15.6 15.6 15.6 40.9 0 56.6l-216 216c-15.6 15.6-40.9 15.6-56.6 0l-216-216c-15.6-15.6-15.6-40.9 0-56.6l216-216zm87.6 137c-4.6-4.6-11.5-5.9-17.4-3.5s-9.9 8.3-9.9 14.8v56h-64c-35.3 0-64 28.7-64 64v48c0 13.3 10.7 24 24 24s24-10.7 24-24v-48c0-8.8 7.2-16 16-16h64v56c0 6.5 3.9 12.3 9.9 14.8s12.9 1.1 17.4-3.5l80-80c6.2-6.2 6.2-16.4 0-22.6l-80-80z"
        }
    ]
};

const FasDiamond = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDiamond",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M284.3 11.7c-15.6-15.6-40.9-15.6-56.6 0l-216 216c-15.6 15.6-15.6 40.9 0 56.6l216 216c15.6 15.6 40.9 15.6 56.6 0l216-216c15.6-15.6 15.6-40.9 0-56.6l-216-216z"
        }
    ]
};

const FasDiceD10 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDiceD10",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M209.7 16.3C212.4 8.3 206.4 0 198 0c-3.8 0-7.3 1.7-9.7 4.6L2.4 237c-1.6 1.9-2.4 4.3-2.4 6.8 0 7 6.4 12.1 13.2 10.6l117.6-26.1c5.5-1.2 9.9-5.2 11.7-10.6l67.2-201.4zM8.7 288.2c-5.1 1.2-8.7 5.7-8.7 10.9 0 3.1 1.3 6.1 3.6 8.2l217.1 201.6c2.1 2 4.9 3.1 7.8 3.1 6.3 0 11.5-5.1 11.5-11.5V328.8c0-5.3-2.6-10.2-6.9-13.2l-78.7-54.5c-3.7-2.5-8.2-3.4-12.6-2.5L8.7 288.2zM272 500.5c0 6.3 5.1 11.5 11.5 11.5 2.9 0 5.7-1.1 7.8-3.1l217.1-201.6c2.3-2.1 3.6-5.1 3.6-8.2 0-5.2-3.6-9.8-8.7-10.9l-133.1-29.5c-4.4-1-8.9-.1-12.6 2.5l-78.7 54.5c-4.3 3-6.9 7.9-6.9 13.2v171.6zm226.8-246.1c6.8 1.5 13.2-3.7 13.2-10.6 0-2.5-.8-4.9-2.4-6.8L323.7 4.6C321.4 1.7 317.8 0 314 0c-8.5 0-14.4 8.3-11.7 16.3l67.2 201.5c1.8 5.3 6.2 9.3 11.7 10.6l117.6 26.1zM246.6 6.8l-71.8 215.5c-2.2 6.7.2 14.2 6.1 18.2l66.1 45.7c5.5 3.8 12.7 3.8 18.2 0l66.1-45.7c5.8-4 8.3-11.5 6.1-18.2l-72-215.5C264 2.7 260.3 0 256 0s-8 2.7-9.4 6.8z"
        }
    ]
};

const FasDiceD12 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDiceD12",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M318.2 0c4.2 0 8.4 1.1 12 3.2l72 41.6c5.9 3.4 5.1 12.2-1.3 14.5l-136.8 48.8c-5.2 1.9-10.9 1.9-16.1 0L111.1 59.3c-6.4-2.3-7.2-11.1-1.3-14.5l72-41.6c3.6-2.1 7.8-3.2 12-3.2h124.4zM149.9 490.4l-75.7-43.8c-3.6-2.1-6.7-5.1-8.8-8.8L3.2 330.2c-2.1-3.6-3.2-7.8-3.2-12v-84.3c0-7.1 8.6-10.7 13.7-5.7l96.1 96.1c2.7 2.7 4.8 6.1 5.9 9.8L161.6 481c2.2 7-5.3 13-11.6 9.3zM512 233.9v84.2c0 4.2-1.1 8.4-3.2 12l-62.2 107.7c-2.1 3.6-5.1 6.7-8.8 8.8L362 490.3c-6.3 3.6-13.8-2.4-11.6-9.3l45.9-146.9c1.2-3.7 3.2-7.1 5.9-9.8l96.1-96.1c5-5 13.7-1.5 13.7 5.7zM15.3 184.7c-5.1-5.1-6.2-13-2.5-19.3L57.4 88c3.9-6.7 12-9.7 19.2-7.1l152.8 54.6c6.4 2.3 10.6 8.3 10.6 15.1v85.7c0 6.1-3.4 11.6-8.8 14.3l-89.7 44.8c-6.2 3.1-13.6 1.9-18.5-3L15.3 184.7zM454.6 88l44.7 77.3c3.6 6.3 2.6 14.2-2.5 19.3L389 292.4c-4.9 4.9-12.3 6.1-18.5 3l-89.7-44.8c-5.4-2.7-8.8-8.3-8.8-14.3v-85.7c0-6.8 4.3-12.8 10.6-15.1l152.8-54.6c7.3-2.6 15.4.4 19.2 7.1zM295.5 512h-79c-7 0-13.2-4.5-15.3-11.2l-49.8-159.6c-2.3-7.5 1.1-15.6 8.1-19.1l89.3-44.7c4.5-2.3 9.8-2.3 14.3 0l89.3 44.7c7 3.5 10.5 11.6 8.1 19.1l-49.8 159.6c-2.1 6.7-8.3 11.2-15.3 11.2z"
        }
    ]
};

const FasDiceD20 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDiceD20",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m48.7 125.8 53.2 31.9c7.8 4.7 17.8 2 22.2-5.9l77.5-139.7c3-5.4-.9-12.1-7.1-12.1-1.6 0-3.2.5-4.6 1.4l-142 97.4c-9.6 6.6-9.2 20.9.8 26.9zM16 171.7v123.6c0 8 10.4 11 14.7 4.4l60-92c5-7.6 2.6-17.8-5.2-22.5L40.2 158c-10.6-6.4-24.2 1.3-24.2 13.7zM310.4 12.1 388 151.7c4.4 7.9 14.5 10.6 22.2 5.9l53.2-31.9c10-6 10.4-20.3.8-26.9L322.1 1.4c-1.4-.9-3-1.4-4.6-1.4-6.2 0-10.1 6.7-7.1 12.1zM496 171.7c0-12.4-13.6-20.1-24.2-13.7l-45.3 27.2c-7.8 4.7-10.1 14.9-5.2 22.5l60 92c4.3 6.7 14.7 3.6 14.7-4.4V171.7zm-49.3 246-160.6 18.9c-8.1.9-14.1 7.8-14.1 15.9v52.8c0 3.7 3 6.8 6.8 6.8.8 0 1.6-.1 2.4-.4l172.7-64c6.1-2.2 10.1-8 10.1-14.5 0-9.3-8.1-16.5-17.3-15.4zM233.2 512c3.7 0 6.8-3 6.8-6.8v-52.6c0-8.1-6.1-14.9-14.1-15.9l-160.6-19c-9.2-1.1-17.3 6.1-17.3 15.4 0 6.5 4 12.3 10.1 14.5l172.7 64c.8.3 1.6.4 2.4.4zM41.7 382.9l170.9 20.2c7.8.9 13.4-7.5 9.5-14.3l-85.7-150c-5.9-10.4-20.7-10.8-27.3-.8L30.2 358.2c-6.5 9.9-.3 23.3 11.5 24.7zm439.6-24.8-78.4-120c-6.5-10-21.4-9.6-27.3.8l-85.4 149.6c-3.9 6.8 1.6 15.2 9.5 14.3l170.1-20c11.8-1.4 18-14.7 11.5-24.6zm-216.9 11 78.4-137.2c6.1-10.7-1.6-23.9-13.9-23.9H183.1c-12.3 0-20 13.3-13.9 23.9l78.4 137.2c3.7 6.4 13 6.4 16.7 0zm-90-193.1h163.2c12.2 0 19.9-13.1 14-23.8l-80-144c-2.8-5.1-8.2-8.2-14-8.2h-3.2c-5.8 0-11.2 3.2-14 8.2l-80 144c-5.9 10.7 1.8 23.8 14 23.8z"
        }
    ]
};

const FasDiceD4 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDiceD4",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M228.8.7C235.5 2.8 240 9 240 16v480c0 6.3-3.7 12-9.4 14.6s-12.5 1.6-17.2-2.6L5.4 324c-6.1-5.4-7.2-14.5-2.5-21.2l208-296c4-5.7 11.3-8.2 17.9-6.1zm54.4 0c6.7-2.1 13.9.3 17.9 6.1l208 296c4.7 6.7 3.6 15.8-2.5 21.2l-208 184c-4.7 4.2-11.4 5.2-17.2 2.6s-9.4-8.3-9.4-14.6V16c0-7 4.5-13.2 11.2-15.3z"
        }
    ]
};

const FasDiceD6 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDiceD6",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M201 10.3c14.3-7.8 31.6-7.8 46 0L422.3 106c5.1 2.8 8.3 8.2 8.3 14s-3.2 11.2-8.3 14L231.7 238c-4.8 2.6-10.5 2.6-15.3 0L25.7 134c-5.1-2.8-8.3-8.2-8.3-14s3.2-11.2 8.3-14L201 10.3zM23.7 170l176 96c5.1 2.8 8.3 8.2 8.3 14v216c0 5.6-3 10.9-7.8 13.8s-10.9 3-15.8.3L25 423.1C9.6 414.7 0 398.6 0 381V184c0-5.6 3-10.9 7.8-13.8s10.9-3 15.8-.3zm400.7 0c5-2.7 11-2.6 15.8.3s7.8 8.1 7.8 13.8V381c0 17.6-9.6 33.7-25 42.1L263.7 510c-5 2.7-11 2.6-15.8-.3s-7.8-8.1-7.8-13.8V280c0-5.9 3.2-11.2 8.3-14l176-96z"
        }
    ]
};

const FasDiceD8 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDiceD8",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M240 16c0-6.5-4-12.4-10-14.8s-13-1-17.5 3.7l-208 216c-3.7 3.9-5.3 9.3-4.1 14.6s4.9 9.5 9.9 11.5l208 80c4.9 1.9 10.5 1.2 14.8-1.7s6.9-7.9 6.9-13.2V16zM34.6 307.5c-4.1 6.3-3.3 14.6 1.9 20l176 179.7c4.5 4.6 11.5 6.1 17.5 3.6s10-8.3 10-14.8V384c0-6.6-4.1-12.6-10.3-14.9l-176-67.7c-7-2.7-15-.1-19.1 6.1zm442.7 0c-4.1-6.3-12.1-8.8-19.1-6.1l-176 67.7c-6.2 2.4-10.3 8.3-10.3 14.9v112c0 6.5 3.9 12.4 10 14.8s12.9 1 17.5-3.6l176-179.7c5.3-5.4 6.1-13.7 1.9-20zM282 1.2c-6 2.4-10 8.3-10 14.8v296c0 5.3 2.6 10.2 6.9 13.2s9.9 3.6 14.8 1.7l208-80c5-1.9 8.7-6.2 9.9-11.5s-.4-10.7-4.1-14.6l-208-216C295 .2 288.1-1.3 282 1.2z"
        }
    ]
};

const FasDiceFive = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDiceFive",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm64 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM96 352a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm128-128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64-64a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm32 160a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FasDiceFour = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDiceFour",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm160 64a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm-32 224a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm224-224a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm-32 224a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FasDiceOne = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDiceOne",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm160 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FasDiceSix = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDiceSix",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm160 64a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm-32 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32 64a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm160-160a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32 64a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm-32 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FasDiceThree = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDiceThree",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm64 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64 128a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm128 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FasDiceTwo = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDiceTwo",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm352 256a32 32 0 1 0-64 0 32 32 0 1 0 64 0zM128 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FasDice = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDice",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M274.9 34.3c-28.1-28.1-73.7-28.1-101.8 0L34.3 173.1c-28.1 28.1-28.1 73.7 0 101.8l138.8 138.8c28.1 28.1 73.7 28.1 101.8 0l138.8-138.8c28.1-28.1 28.1-73.7 0-101.8L274.9 34.3zM200 224a24 24 0 1 1 48 0 24 24 0 1 1-48 0zM96 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm128 176a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm128-176a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-128-80a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm96 328c0 35.3 28.7 64 64 64h192c35.3 0 64-28.7 64-64V256c0-35.3-28.7-64-64-64H461.7c11.6 36 3.1 77-25.4 105.5L320 413.8V448zm160-120a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FasDinosaur = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDinosaur",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M446.2 0h1.8c106 0 192 86 192 192v30.6c0 88-51.5 165.6-128 201.5V480c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32v-22c-15.3 3.9-31.4 6-48 6-6.8 0-13.5-.4-20.1-1-7.5-18.9-24.4-33.3-45.4-36.8L162 408.1c-19.6-3.3-34-20.2-34-40.1 0-8.8-7.2-16-16-16s-16 7.2-16 16c0 35.5 25.7 65.8 60.7 71.7l108.5 18.1c13.2 2.2 22.8 13.6 22.8 26.9 0 15.1-12.2 27.3-27.3 27.3h-140C54.1 512 0 457.9 0 391.3c0-34 14.4-66.5 39.5-89.3l89.7-81.6C172 181.5 227.6 160 285.3 160c50.2 0 99 16.3 139.2 46.4L480 248c6.9 5.2 15.3 8 24 8 22.1 0 40-17.9 40-40v-24c0-35.3-28.7-64-64-64h-64.3c-26.3 0-47.7-21.4-47.7-47.7v-4.7c0-16.7 10.1-31.6 25.6-37.8l1.7-.7c8.2-3.3 14.8-9.4 18.7-17.2C420.2 7.7 432.6 0 446.2 0zM464 64a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
        }
    ]
};

const FasDiploma = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDiploma",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m302 59.7 18 20.6 18-20.6C353.4 42.1 375.6 32 399 32h1c44.2 0 80 35.8 80 80 0 11.4-2.4 22.2-6.7 32H544v32-32h.8c.4 0 .8 0 1.4.1 1 .1 2.3.1 3.8.3 3 .3 7 .9 11.6 2.1 9.2 2.3 21.3 6.9 33.4 15.9 25.9 19.3 45 53.8 45 109.6 0 47.5-13.7 81.1-32 104.1-18 22.6-38.5 32.6-49 36.6-7.3 2.8-14 3.3-19 3.3h-.5c-4.7 0-9.3-.5-13.9-1.5L384 383v81c0 6.2-3.6 11.9-9.2 14.5s-12.3 1.8-17-2.2L320 444.8l-37.8 31.5c-4.8 4-11.4 4.8-17 2.2s-9.2-8.3-9.2-14.5v-81l-141.6 31.5c-4.6 1-9.2 1.5-13.9 1.5h-.5c-4.9 0-11.7-.5-19-3.3-10.5-4-31-14-49-36.6-18.3-23-32-56.6-32-104.1 0-55.8 19.1-90.3 44.8-109.6 12.1-9.1 24.3-13.6 33.4-15.9 4.6-1.2 8.6-1.8 11.6-2.1 1.5-.2 2.8-.3 3.8-.3.5 0 1 0 1.4-.1h.8v32-32h70.7c-4.3-9.8-6.7-20.6-6.7-32 0-44.2 35.8-80 80-80h1c23.4 0 45.6 10.1 61 27.7zM240 144h54.4c6.9 0 10.5-8.1 6-13.3l-34.5-39.4A33.11 33.11 0 0 0 241 80h-1c-17.7 0-32 14.3-32 32s14.3 32 32 32zm105.6 0H400c17.7 0 32-14.3 32-32s-14.3-32-32-32h-1c-1.2 0-2.3.1-3.5.2-8.2.9-15.8 4.8-21.3 11.1l-34.5 39.5c-4.5 5.2-.9 13.3 6 13.3zM256 208H96.6c-.5.1-1.5.2-2.9.5-2.8.7-6.7 2.1-10.6 5.1C76.9 218.3 64 231.8 64 272c0 34.5 9.6 53.7 18.1 64.3 7.2 9 14.9 13.5 19.2 15.6L256 317.4V208zm128 109.4 154.8 34.4c4.3-2 12-6.6 19.2-15.6 8.4-10.6 18.1-29.8 18.1-64.3 0-40.2-12.9-53.7-19.2-58.4-3.9-2.9-7.7-4.4-10.6-5.1-1.4-.3-2.4-.5-2.9-.5H384v109.5zM540.1 352zm-440.2 0z"
        }
    ]
};

const FasDiscDrive = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDiscDrive",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32V96zm192 160a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm192 0a160 160 0 1 0-320 0 160 160 0 1 0 320 0z"
        }
    ]
};

const FasDisease = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDisease",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M236.4 61.4 227 75.5c-21.3 32-59.4 48.5-97.3 42.1l-59.6-9.9C33.4 101.6 0 129.9.1 167.1c0 15.9 6.4 31.2 17.6 42.5l29.2 29.2c11 11 17.2 25.9 17.2 41.5 0 15.8-6.4 30.9-17.7 42l-13.1 12.8C22.2 345.9 16 360.7 16 376.2c0 36.8 34.1 64.2 70.1 56.2l62.3-13.8c7.7-1.7 15.7-2.6 23.6-2.6h10c27.2 0 53.7 9.3 75 26.3l30.8 24.7c10.5 8.4 23.6 13 37 13 32.7 0 59.3-26.5 59.3-59.3v-25.2c0-34.9 21.4-66.2 53.9-78.8l36.9-14.3c22.4-8.7 37.2-30.3 37.2-54.3 0-28.1-20.1-52.3-47.8-57.3l-28-5.1c-36.5-6.7-65.4-34.5-73.6-70.7l-7.1-31.5C348.9 53.4 322.1 32 291.3 32c-22 0-42.6 11-54.9 29.4zM160 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 16a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm0 80a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FasDisplayArrowDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDisplayArrowDown",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 0C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h176l-10.7 32H160c-17.7 0-32 14.3-32 32s14.3 32 32 32h256c17.7 0 32-14.3 32-32s-14.3-32-32-32h-69.3L336 416h176c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H352v64h160v288H64V64h160V0H64zm248 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v182.1l-39-39c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l80 80c9.4 9.4 24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-39 39V24z"
        }
    ]
};

const FasDisplayChartUpCircleCurrency = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDisplayChartUpCircleCurrency",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 64C0 28.7 28.7 0 64 0h448c35.3 0 64 28.7 64 64v147.2c-19.5-10-41.1-16.4-64-18.5V64H64v288h256.7c-.5 5.3-.7 10.6-.7 16 0 59.5 29.5 112.1 74.8 144H160c-17.7 0-32-14.3-32-32s14.3-32 32-32h69.3l10.7-32H64c-35.3 0-64-28.7-64-64V64zm480 56v72.7c-16.7 1.5-32.7 5.3-47.7 11.2-.2-1.3-.3-2.6-.3-3.9v-22.1L321 289c-4.5 4.5-10.6 7-17 7s-12.5-2.5-17-7l-63-63-87 87c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L207 175c9.4-9.4 24.6-9.4 33.9 0l63 63 94.2-94H376c-13.3 0-24-10.7-24-24s10.7-24 24-24h80c13.3 0 24 10.7 24 24zM352 368a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm118.6-25.4a35.9 35.9 0 1 1 50.7 50.7 35.9 35.9 0 1 1-50.7-50.7zm60.7 83.4 17.3 17.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L554 403.3c13.2-21.6 13.2-49.1 0-70.7l17.3-17.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L531.3 310c-21.6-13.2-49.1-13.2-70.7 0l-17.3-17.3c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l17.3 17.4c-13.2 21.6-13.2 49.1 0 70.7l-17.3 17.3c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l17.4-17.3c21.6 13.2 49.1 13.2 70.7 0z"
        }
    ]
};

const FasDisplayChartUpCircleDollar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDisplayChartUpCircleDollar",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 64C0 28.7 28.7 0 64 0h448c35.3 0 64 28.7 64 64v147.2c-19.5-10-41.1-16.4-64-18.5V64H64v288h256.7c-.5 5.3-.7 10.6-.7 16 0 59.5 29.5 112.1 74.8 144H160c-17.7 0-32-14.3-32-32s14.3-32 32-32h69.3l10.7-32H64c-35.3 0-64-28.7-64-64V64zm480 56v72.7c-16.7 1.5-32.7 5.3-47.7 11.2-.2-1.3-.3-2.6-.3-3.9v-22.1L321 289c-4.5 4.5-10.6 7-17 7s-12.5-2.5-17-7l-63-63-87 87c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L207 175c9.4-9.4 24.6-9.4 33.9 0l63 63 94.2-94H376c-13.3 0-24-10.7-24-24s10.7-24 24-24h80c13.3 0 24 10.7 24 24zM352 368a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm120.8-32.6c.6-.9 1.8-2.1 4.2-3.4 5.1-2.7 12.5-4.1 18.7-4 8.2.1 17.1 1.8 26.4 4.1 8.6 2.1 17.3-3.1 19.4-11.7s-3.1-17.3-11.7-19.4c-5.6-1.4-11.6-2.7-17.9-3.7V288c0-8.8-7.2-16-16-16s-16 7.2-16 16v9.5c-6.1 1.2-12.3 3.2-18 6.3-11.8 6.3-23 18.4-21.8 37.2 1 16 11.7 25.3 21.6 30.7 8.8 4.7 19.7 7.8 28.6 10.3l1.8.5c10.3 2.9 17.9 5.2 23.2 8.3 4.5 2.7 4.7 4.2 4.7 5.6.1 2.4-.5 3.7-1 4.5-.6 1-1.8 2.2-4 3.3-4.7 2.5-11.8 3.8-18.5 3.6-9.5-.3-18.5-3.1-29.9-6.8-1.9-.6-3.8-1.2-5.8-1.8-8.4-2.6-17.4 2.1-20 10.5s2.1 17.4 10.5 20c1.6.5 3.3 1 5 1.6 7 2.3 15.1 4.8 23.7 6.6v11.4c0 8.8 7.2 16 16 16s16-7.2 16-16v-10.6c6.2-1.1 12.5-3.1 18.3-6.2 12.1-6.5 22.3-18.7 21.7-36.9-.5-16.2-10.3-26.3-20.5-32.3-9.4-5.6-21.2-8.9-30.5-11.5h-.2c-10.4-2.9-18.3-5.2-23.9-8.2-4.8-2.6-4.8-4-4.8-4.5v-.1c-.1-1.9.3-2.9.8-3.6z"
        }
    ]
};

const FasDisplayChartUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDisplayChartUp",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 64C0 28.7 28.7 0 64 0h448c35.3 0 64 28.7 64 64v288c0 35.3-28.7 64-64 64H336l10.7 32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H160c-17.7 0-32-14.3-32-32s14.3-32 32-32h69.3l10.7-32H64c-35.3 0-64-28.7-64-64V64zm64 0v288h448V64H64zm312 32h80c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24s-24-10.7-24-24v-22.1L321 289c-4.5 4.5-10.6 7-17 7s-12.5-2.5-17-7l-63-63-87 87c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L207 175c9.4-9.4 24.6-9.4 33.9 0l63 63 94.2-94H376c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
        }
    ]
};

const FasDisplayCode = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDisplayCode",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 64C0 28.7 28.7 0 64 0h448c35.3 0 64 28.7 64 64v288c0 35.3-28.7 64-64 64H336l10.7 32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H160c-17.7 0-32-14.3-32-32s14.3-32 32-32h69.3l10.7-32H64c-35.3 0-64-28.7-64-64V64zm64 0v288h448V64H64zm185 113-31 31 31 31c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-48-48c-9.4-9.4-9.4-24.6 0-33.9l48-48c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zm112-34 48 48c9.4 9.4 9.4 24.6 0 33.9l-48 48c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l31-31-31-31c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z"
        }
    ]
};

const FasDisplayMedical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDisplayMedical",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 64C0 28.7 28.7 0 64 0h448c35.3 0 64 28.7 64 64v288c0 35.3-28.7 64-64 64H336l10.7 32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H160c-17.7 0-32-14.3-32-32s14.3-32 32-32h69.3l10.7-32H64c-35.3 0-64-28.7-64-64V64zm64 0v288h448V64H64zm192 64c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-48v48c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-48h-48c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h48v-48z"
        }
    ]
};

const FasDisplaySlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDisplaySlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-70.5-55.2c27.4-7.2 47.6-32.2 47.6-61.9V64c0-35.3-28.7-64-64-64H96C79.6 0 64.6 6.2 53.2 16.4L38.8 5.1zM113.9 64H544v288h-62.6L113.9 64zM32 352c0 35.3 28.7 64 64 64h176l-10.7 32H192c-17.7 0-32 14.3-32 32s14.3 32 32 32h256c17.7 0 32-14.3 32-32 0-2.1-.2-4.1-.6-6.1L446.6 448h-67.9L368 416h38l-81.2-64H96V171.8l-64-50.4V352z"
        }
    ]
};

const FasDisplay = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDisplay",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 0C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h176l-10.7 32H160c-17.7 0-32 14.3-32 32s14.3 32 32 32h256c17.7 0 32-14.3 32-32s-14.3-32-32-32h-69.3L336 416h176c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm448 64v288H64V64h448z"
        }
    ]
};

const FasDistributeSpacingHorizontal = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDistributeSpacingHorizontal",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 24C32 10.7 42.7 0 56 0s24 10.7 24 24v464c0 13.3-10.7 24-24 24s-24-10.7-24-24V24zm128 120c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v224c0 26.5-21.5 48-48 48h-96c-26.5 0-48-21.5-48-48V144zM456 0c13.3 0 24 10.7 24 24v464c0 13.3-10.7 24-24 24s-24-10.7-24-24V24c0-13.3 10.7-24 24-24z"
        }
    ]
};

const FasDistributeSpacingVertical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDistributeSpacingVertical",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 56c0-13.3 10.7-24 24-24h464c13.3 0 24 10.7 24 24s-10.7 24-24 24H24C10.7 80 0 69.3 0 56zm96 152c0-26.5 21.5-48 48-48h224c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H144c-26.5 0-48-21.5-48-48v-96zM24 432h464c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
        }
    ]
};

const FasDitto = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDitto",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 96v2.3c0 3.8.3 7.6 1 11.4l25.5 146.8c3.2 18.2 19 31.5 37.5 31.5s34.3-13.3 37.5-31.5L127 109.6c.7-3.8 1-7.5 1-11.4V96c0-35.3-28.7-64-64-64S0 60.7 0 96zm192 0v2.3c0 3.8.3 7.6 1 11.4l25.5 146.8c3.2 18.2 19 31.5 37.5 31.5s34.3-13.3 37.5-31.5L319 109.6c.7-3.8 1-7.5 1-11.4V96c0-35.3-28.7-64-64-64s-64 28.7-64 64z"
        }
    ]
};

const FasDivide = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDivide",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M272 96a48 48 0 1 0-96 0 48 48 0 1 0 96 0zm0 320a48 48 0 1 0-96 0 48 48 0 1 0 96 0zm128-128c17.7 0 32-14.3 32-32s-14.3-32-32-32H48c-17.7 0-32 14.3-32 32s14.3 32 32 32h352z"
        }
    ]
};

const FasDna = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDna",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M416 0c17.7 0 32 14.3 32 32 0 59.8-30.3 107.5-69.4 146.6-28 28-62.5 53.5-97.3 77.4l-2.5 1.7c-11.9 8.1-23.8 16.1-35.5 23.9l-1.6 1c-6 4-11.9 7.9-17.8 11.9-20.9 14-40.8 27.7-59.3 41.5h118.7c-9.8-7.4-20.1-14.7-30.7-22.1l7-4.7 3-2c15.1-10.1 30.9-20.6 46.7-31.6 25 18.1 48.9 37.3 69.4 57.7 39 39.2 69.3 86.9 69.3 146.7 0 17.7-14.3 32-32 32s-32-14.3-32-32H64c0 17.7-14.3 32-32 32S0 497.7 0 480c0-59.8 30.3-107.5 69.4-146.6 28-28 62.5-53.5 97.3-77.4-34.8-23.9-69.3-49.3-97.3-77.4C30.3 139.5 0 91.8 0 32 0 14.3 14.3 0 32 0s32 14.3 32 32h320c0-17.7 14.3-32 32-32zm-77.4 384H109.4c-10.1 10.6-18.6 21.3-25.5 32h280.2c-6.8-10.7-15.3-21.4-25.5-32zM109.4 128h229.2c10.1-10.7 18.6-21.3 25.5-32H83.9c6.8 10.7 15.3 21.3 25.5 32zm55.4 48c18.4 13.8 38.4 27.5 59.3 41.5 20.9-14 40.8-27.7 59.3-41.5H164.7z"
        }
    ]
};

const FasDoNotEnter = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDoNotEnter",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM96 208h320c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16v-64c0-8.8 7.2-16 16-16z"
        }
    ]
};

const FasDogLeashed = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDogLeashed",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m122.7 4.1 160 144c6.6 5.9 7.1 16 1.2 22.6s-16 7.1-22.6 1.2l-160-144c-6.6-5.9-7.1-16-1.2-22.6s16-7.1 22.6-1.2zM144 192h112v191.3c-5.3.5-10.6.7-16 .7-28.8 0-56-6.9-80-19.2V480c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V249.8c-28.8-10.9-51.4-35.3-59.2-66.5L1 167.8c-4.3-17.1 6.1-34.5 23.3-38.8s34.5 6.1 38.8 23.3l3.9 15.5C70.5 182 83.3 192 98 192h46zm176 172.8c-10.1 5.2-20.8 9.4-32 12.6V208.1L416 262v218c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32V364.8zM426.7 192l-6.2 37.2-114.6-48.3 26.8-161C334.6 8.4 344.5 0 356.1 0c7.5 0 14.5 3.5 19 9.5L392 32h52.1c12.7 0 24.9 5.1 33.9 14.1L496 64h56c13.3 0 24 10.7 24 24v24c0 44.2-35.8 80-80 80h-69.3zM448 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
        }
    ]
};

const FasDog = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDog",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m309.6 158.5 23.1-138.7C334.6 8.4 344.5 0 356.1 0c7.5 0 14.5 3.5 19 9.5L392 32h52.1c12.7 0 24.9 5.1 33.9 14.1L496 64h56c13.3 0 24 10.7 24 24v24c0 44.2-35.8 80-80 80h-69.3l-5.1 30.5-112-64zM416 256.1V480c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32V364.8c-24 12.3-51.2 19.2-80 19.2s-56-6.9-80-19.2V480c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V249.8c-28.8-10.9-51.4-35.3-59.2-66.5L1 167.8c-4.3-17.1 6.1-34.5 23.3-38.8s34.5 6.1 38.8 23.3l3.9 15.5C70.5 182 83.3 192 98 192h205.8L416 256.1zM464 80a16 16 0 1 0-32 0 16 16 0 1 0 32 0z"
        }
    ]
};

const FasDollarSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDollarSign",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 0c17.7 0 32 14.3 32 32v35.7c1.6.2 3.1.4 4.7.7.4.1.7.1 1.1.2l48 8.8c17.4 3.2 28.9 19.9 25.7 37.2s-19.9 28.9-37.2 25.7l-47.5-8.7c-31.3-4.6-58.9-1.5-78.3 6.2s-27.2 18.3-29 28.1c-2 10.7-.5 16.7 1.2 20.4 1.8 3.9 5.5 8.3 12.8 13.2 16.3 10.7 41.3 17.7 73.7 26.3l2.9.8c28.6 7.6 63.6 16.8 89.6 33.8 14.2 9.3 27.6 21.9 35.9 39.5 8.5 17.9 10.3 37.9 6.4 59.2-6.9 38-33.1 63.4-65.6 76.7-13.7 5.6-28.6 9.2-44.4 11V480c0 17.7-14.3 32-32 32s-32-14.3-32-32v-34.9c-.4-.1-.9-.1-1.3-.2h-.2c-24.4-3.8-64.5-14.3-91.5-26.3-16.1-7.2-23.4-26.1-16.2-42.2S44.9 353 61 360.2c20.9 9.3 55.3 18.5 75.2 21.6 31.9 4.7 58.2 2 76-5.3 16.9-6.9 24.6-16.9 26.8-28.9 1.9-10.6.4-16.7-1.3-20.4-1.9-4-5.6-8.4-13-13.3-16.4-10.7-41.5-17.7-74-26.3l-2.8-.7c-28.5-7.6-63.5-16.9-89.5-33.9-14.2-9.3-27.5-22-35.8-39.6-8.4-17.9-10.1-37.9-6.1-59.2 7.2-38.2 35.8-63 68.3-75.9 13.3-5.3 27.9-8.9 43.2-11V32c0-17.7 14.3-32 32-32z"
        }
    ]
};

const FasDollyEmpty = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDollyEmpty",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 0C14.3 0 0 14.3 0 32s14.3 32 32 32h72.9L197 340.2c-22.5 17.6-37 45-37 75.8 0 53 43 96 96 96 52.4 0 95.1-42 96-94.3l202.1-67.4c16.8-5.6 25.8-23.7 20.2-40.5s-23.7-25.8-40.5-20.2l-202 67.4c-17.2-22.1-43.9-36.5-74-37L165.7 43.8C156.9 17.6 132.5 0 104.9 0H32z"
        }
    ]
};

const FasDolly = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDolly",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 32C0 14.3 14.3 0 32 0h72.9c27.5 0 52 17.6 60.7 43.8L257.7 320c30.1.5 56.8 14.9 74 37l202.1-67.4c16.8-5.6 34.9 3.5 40.5 20.2s-3.5 34.9-20.2 40.5L352 417.7c-.9 52.2-43.5 94.3-96 94.3-53 0-96-43-96-96 0-30.8 14.5-58.2 37-75.8L104.9 64H32C14.3 64 0 49.7 0 32zm244.8 102.5c-5.5-16.8 3.7-34.9 20.5-40.3L311 79.4l19.8 60.9 60.9-19.8-19.9-60.9 45.7-14.8c16.8-5.5 34.9 3.7 40.3 20.5l49.4 152.2c5.5 16.8-3.7 34.9-20.5 40.3l-152.2 49.4c-16.8 5.5-34.9-3.7-40.3-20.5l-49.4-152.2z"
        }
    ]
};

const FasDolphin = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDolphin",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M477.3 24.9c3.5-5.3 3.6-12.2.1-17.6s-9.7-8.1-16-7.1c-16.7 2.8-43.1 8.6-68.8 17C378 22 362.5 28 349 35.3 306.5 12.8 258 0 206.5 0H176C96.5 0 32 64.5 32 144c0 18.6 3.5 36.4 10 52.7l-21.5 12.9C7.8 217.2 0 231 0 245.8 0 269.1 18.9 288 42.2 288h161l92 61.3c4.9 3.3 11.2 3.6 16.4.8s8.5-8.2 8.5-14.1v-48h6.6c31.7 0 57.4 25.7 57.4 57.4 0 30.6-24 55.8-54.5 57.3l-53.4 2.7c-20.2-33-56.3-53.4-95.4-53.4H176c-5.5 0-10.7 2.9-13.6 7.6s-3.2 10.6-.7 15.6l28.4 56.8-28.4 56.8c-2.5 5-2.2 10.9.7 15.6s8.1 7.6 13.6 7.6h4.7c35.9 0 69.2-17.1 90.1-45.4l68 3.8c94.1 5.2 173.3-70 173.3-164.3 0-80.8-31.4-154.5-82.7-209.3l48-72zM176 120a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FasDongSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDongSign",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 32c-17.7 0-32 14.3-32 32h-32c-17.7 0-32 14.3-32 32s14.3 32 32 32h32v49.1c-18.8-10.9-40.7-17.1-64-17.1-70.7 0-128 57.3-128 128s57.3 128 128 128c24.5 0 47.4-6.9 66.8-18.8 5 11.1 16.2 18.8 29.2 18.8 17.7 0 32-14.3 32-32V128c17.7 0 32-14.3 32-32s-14.3-32-32-32c0-17.7-14.3-32-32-32zM128 288a64 64 0 1 1 128 0 64 64 0 1 1-128 0zM32 448c-17.7 0-32 14.3-32 32s14.3 32 32 32h320c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"
        }
    ]
};

const FasDonut = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDonut",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 208C0 119.6 114.6 48 256 48s256 71.6 256 160v31c-.7 10-4.3 19.5-10.5 27.4-6.2 8-14.7 14-24.4 17.1l-.3.1-.3.1c-13.1 4.9-24.4 13.8-32 25.5-9.4 13-22 23.3-36.5 30.1-14.7 6.8-30.8 9.6-46.9 8.3h-1.2c-17.7-.2-35.3 3.3-51.7 10.1h-.1c-16.4 7-34.1 10.5-51.9 10.3h-.3c-17.8.2-35.5-3.3-51.9-10.3h-.1c-16.4-6.8-34-10.2-51.7-10.1H151c-16.1 1.3-32.3-1.6-46.9-8.4-14.6-6.8-27.1-17.1-36.5-30.2-7.7-11.7-18.9-20.6-32-25.5l-.4-.1-.4-.1c-9.7-3.1-18.2-9.1-24.4-17.1C4.3 258.4.7 248.9 0 238.9V208zm0 92.7c7.4 5.7 15.7 10.1 24.6 13 6.7 2.6 12.4 7.2 16.3 13.2l.2.3.2.3c12.6 17.6 29.6 31.7 49.3 40.8 19.5 9 41 12.9 62.4 11.3 13.2-.1 26.3 2.5 38.5 7.6 20.4 8.6 42.4 13 64.5 12.8 22.1.2 44.1-4.2 64.5-12.8 12.2-5.1 25.3-7.6 38.5-7.6 21.4 1.7 42.9-2.2 62.3-11.2 19.7-9.1 36.7-23.1 49.3-40.7l.2-.3.2-.3c3.9-6 9.6-10.6 16.3-13.2 8.9-2.9 17.3-7.4 24.6-13v3.1c0 88.4-114.6 160-256 160S0 392.4 0 304v-3.3zM320 192c0-17.7-28.7-32-64-32s-64 14.3-64 32 28.7 32 64 32 64-14.3 64-32zM283.3 84.7c-6.2-6.2-16.4-6.2-22.6 0l-16 16c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l16-16c6.2-6.2 6.2-16.4 0-22.6zm-112 38.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-32 32c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l32-32zm224 9.4c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l32 32c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-32-32zM64 192c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H64zm331.3 36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l32 32c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-32-32zm-240 16c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l32 32c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-32-32zm176 38.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-32 32c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l32-32z"
        }
    ]
};

const FasDoorClosed = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDoorClosed",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 64c0-35.3 28.7-64 64-64h256c35.3 0 64 28.7 64 64v384h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h64V64zm288 224a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FasDoorOpen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDoorOpen",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 32c0-9.9-4.5-19.2-12.3-25.2S289.8-1.4 280.2 1L100.3 46C79 51.3 64 70.5 64 92.5V448H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h288V32zm-64 224c0 17.7-10.7 32-24 32s-24-14.3-24-32 10.7-32 24-32 24 14.3 24 32zm96-128h96v352c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32s-14.3-32-32-32h-32V128c0-35.3-28.7-64-64-64h-96v64z"
        }
    ]
};

const FasDove = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDove",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160.8 96.5c14 17 31 30.9 49.5 42.2 25.9 15.8 53.7 25.9 77.7 31.6v-31.5c-22.2-30.3-38-67.3-39.4-110.8-.4-11.3-7.5-21.5-18.4-24.4-7.6-2-15.8-.2-21 5.8-13.3 15.4-32.7 44.6-48.4 87.2zM320 144v64c-60.8-5.1-185-43.8-219.3-157.2C97.4 40 87.9 32 76.6 32c-7.9 0-15.3 3.9-18.8 11C46.8 65.9 32 112.1 32 176c0 116.9 80.1 180.5 118.4 202.8L11.8 416.6C6.7 418 2.6 421.8.9 426.8s-.8 10.6 2.3 14.8C21.7 466.2 77.3 512 160 512c3.6 0 7.2-1.2 10-3.5l75.6-60.5H320c88.4 0 160-71.6 160-160V128l29.9-44.9c1.3-2 2.1-4.4 2.1-6.8 0-6.8-5.5-12.3-12.3-12.3H400c-44.2 0-80 35.8-80 80zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
        }
    ]
};

const FasDownFromDottedLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDownFromDottedLine",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m73.9 345.9 122.8 122.8c7.2 7.2 17.1 11.3 27.3 11.3s20.1-4.1 27.3-11.3l122.8-122.8c6.4-6.4 9.9-15 9.9-24 0-18.7-15.2-33.9-33.9-33.9H288V160c0-17.7-14.3-32-32-32h-64c-17.7 0-32 14.3-32 32v128H97.9C79.2 288 64 303.2 64 321.9c0 9 3.6 17.6 9.9 24zM32 32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm96 0a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm128 32a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm64-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm128 32a32 32 0 1 0-64 0 32 32 0 1 0 64 0z"
        }
    ]
};

const FasDownFromLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDownFromLine",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m41.9 345.9 122.8 122.8c7.2 7.2 17.1 11.3 27.3 11.3s20.1-4.1 27.3-11.3l122.8-122.8c6.4-6.4 9.9-15 9.9-24 0-18.7-15.2-33.9-33.9-33.9H256V160c0-17.7-14.3-32-32-32h-64c-17.7 0-32 14.3-32 32v128H65.9C47.2 288 32 303.2 32 321.9c0 9 3.6 17.6 9.9 24zM32 96h320c17.7 0 32-14.3 32-32s-14.3-32-32-32H32C14.3 32 0 46.3 0 64s14.3 32 32 32z"
        }
    ]
};

const FasDownLeftAndUpRightToCenter = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDownLeftAndUpRightToCenter",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M439 7c9.4-9.4 24.6-9.4 33.9 0l32 32c9.4 9.4 9.4 24.6 0 33.9l-87 87 39 39c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H296c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2l39 39 87-87zM72 272h144c13.3 0 24 10.7 24 24v144c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-39-39-87 87c-9.4 9.4-24.6 9.4-33.9 0L7 473c-9.4-9.4-9.4-24.6 0-33.9l87-87L55 313c-6.9-6.9-8.9-17.2-5.2-26.2S62.3 272 72 272z"
        }
    ]
};

const FasDownLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDownLeft",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 432h240c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-72-72 134-134c7.2-7.2 11.3-17.1 11.3-27.3s-4.1-20.1-11.3-27.3l-41.4-41.4C324.1 68.1 314.2 64 304 64s-20.1 4.1-27.3 11.3L142.6 209.4l-72-72c-9.2-9.2-22.9-11.9-34.9-6.9s-19.8 16.6-19.8 29.6V400c0 17.7 14.3 32 32 32z"
        }
    ]
};

const FasDownLong = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDownLong",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M2 334.5c-3.8 8.8-2 19 4.6 26l136 144c4.5 4.8 10.8 7.5 17.4 7.5s12.9-2.7 17.4-7.5l136-144c6.6-7 8.4-17.2 4.6-26S305.5 320 296 320h-72V32c0-17.7-14.3-32-32-32h-64c-17.7 0-32 14.3-32 32v288H24c-9.6 0-18.2 5.7-22 14.5z"
        }
    ]
};

const FasDownRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDownRight",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M336 432H96c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9l72-72-134-134C4.1 164.1 0 154.2 0 144s4.1-20.1 11.3-27.3l41.4-41.4C59.9 68.1 69.8 64 80 64s20.1 4.1 27.3 11.3l134.1 134.1 72-72c9.2-9.2 22.9-11.9 34.9-6.9s19.8 16.6 19.8 29.6V400c0 17.7-14.3 32-32 32z"
        }
    ]
};

const FasDownToBracket = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDownToBracket",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M374.1 217.9 251.3 340.7c-7.2 7.2-17.1 11.3-27.3 11.3s-20.1-4.1-27.3-11.3L73.9 217.9c-6.4-6.4-9.9-15-9.9-24 0-18.7 15.2-33.9 33.9-33.9H160V32c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v128h62.1c18.7 0 33.9 15.2 33.9 33.9 0 9-3.6 17.6-9.9 24zM64 352v64c0 17.7 14.3 32 32 32h256c17.7 0 32-14.3 32-32v-64c0-17.7 14.3-32 32-32s32 14.3 32 32v64c0 53-43 96-96 96H96c-53 0-96-43-96-96v-64c0-17.7 14.3-32 32-32s32 14.3 32 32z"
        }
    ]
};

const FasDownToDottedLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDownToDottedLine",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 448a32 32 0 1 0 64 0 32 32 0 1 0-64 0zm128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm64-32a32 32 0 1 0 64 0 32 32 0 1 0-64 0zm128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm96 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM73.9 249.9l122.8 122.8c7.2 7.2 17.1 11.3 27.3 11.3s20.1-4.1 27.3-11.3l122.8-122.8c6.4-6.4 9.9-15 9.9-24 0-18.7-15.2-33.9-33.9-33.9H288V64c0-17.7-14.3-32-32-32h-64c-17.7 0-32 14.3-32 32v128H97.9C79.2 192 64 207.2 64 225.9c0 9 3.6 17.6 9.9 24z"
        }
    ]
};

const FasDownToLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDownToLine",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M342.1 249.9 219.3 372.7c-7.2 7.2-17.1 11.3-27.3 11.3s-20.1-4.1-27.3-11.3L41.9 249.9c-6.4-6.4-9.9-15-9.9-24 0-18.7 15.2-33.9 33.9-33.9H128V64c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v128h62.1c18.7 0 33.9 15.2 33.9 33.9 0 9-3.6 17.6-9.9 24zM32 416h320c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
        }
    ]
};

const FasDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDown",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M214.6 470.6c-12.5 12.5-32.8 12.5-45.3 0l-160-160c-9.2-9.2-11.9-22.9-6.9-34.9S19 255.9 32 255.9h96v-184c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40v184h96c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-160 160z"
        }
    ]
};

const FasDownload = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDownload",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32v242.7l-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 274.7V32zM64 352c-35.3 0-64 28.7-64 64v32c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64v-32c0-35.3-28.7-64-64-64H346.5l-45.3 45.3c-25 25-65.5 25-90.5 0L165.5 352H64zm368 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FasDragon = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDragon",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m352 124.5-51.9-13c-6.5-1.6-11.3-7.1-12-13.8s2.8-13.1 8.7-16.1l40.8-20.4-43.2-32.4c-5.5-4.1-7.8-11.3-5.6-17.9S297.1 0 304 0h160c30.2 0 58.7 14.2 76.8 38.4l57.6 76.8c6.2 8.3 9.6 18.4 9.6 28.8 0 26.5-21.5 48-48 48h-21.5c-17 0-33.3-6.7-45.3-18.7L480 160h-32v21.5c0 24.8 12.8 47.9 33.8 61.1l106.6 66.6c32.1 20.1 51.6 55.2 51.6 93.1 0 60.6-49.1 109.7-109.8 109.7H32.3c-3.3 0-6.6-.4-9.6-1.4-9.2-2.8-16.7-9.6-20.3-18.5C1 488.7.2 485.2 0 481.4c-.2-3.7.3-7.3 1.3-10.7 2.8-9.2 9.6-16.7 18.6-20.4 3-1.2 6.2-2 9.5-2.2L433.3 412c8.3-.7 14.7-7.7 14.7-16.1 0-4.3-1.7-8.4-4.7-11.4l-44.4-44.4c-30-30-46.9-70.7-46.9-113.1V124.5zm160-52.2v-.6.6zm-1.3 7.4-46.4-11.6c-.2 1.3-.3 2.6-.3 3.9 0 13.3 10.7 24 24 24 10.6 0 19.5-6.8 22.7-16.3zm-379.8 36.8c16.3-14.5 40.4-16.2 58.5-4.1l130.6 87V227c0 32.8 8.4 64.8 24 93H112c-6.7 0-12.7-4.2-15-10.4s-.5-13.3 4.6-17.7l69.4-59.6-152.6 23.5c-7 1.1-13.9-2.6-16.9-9S0 232.7 5.3 228l125.6-111.5z"
        }
    ]
};

const FasDrawCircle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDrawCircle",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M472.1 196.7c-20.8-76-80.7-135.9-156.7-156.7-9.6-23.5-32.6-40-59.4-40s-49.8 16.5-59.3 39.9C120.7 60.7 60.8 120.6 40 196.6 16.5 206.2 0 229.2 0 256s16.5 49.8 39.9 59.3c20.8 76 80.7 135.9 156.7 156.7 9.5 23.4 32.5 39.9 59.3 39.9s49.8-16.5 59.3-39.9c76-20.8 135.9-80.7 156.7-156.7 23.4-9.5 39.9-32.5 39.9-59.3s-16.5-49.8-39.9-59.3zM408 206c-14.7 11.7-24 29.8-24 50s9.4 38.3 24 50c-15.8 48.2-53.9 86.2-102 102-11.7-14.7-29.8-24-50-24s-38.3 9.4-50 24c-48.2-15.8-86.2-53.9-102-102 14.7-11.7 24-29.8 24-50s-9.4-38.3-24-50c15.8-48.2 53.9-86.2 102-102 11.7 14.7 29.8 24 50 24s38.3-9.4 50-24c48.2 15.8 86.2 53.9 102 102z"
        }
    ]
};

const FasDrawPolygon = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDrawPolygon",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 151.4v209.2c9.7 5.6 17.8 13.7 23.4 23.4h209.2c0-.1.1-.2.1-.3l-4.5-7.9-32-56c-1.4.1-2.8.1-4.2.1-35.3 0-64-28.7-64-64s28.7-64 64-64c1.4 0 2.8 0 4.2.1l32-56 4.5-7.9-.1-.3H119.4c-5.6 9.7-13.7 17.8-23.4 23.4zM384.3 352c35.2.2 63.7 28.7 63.7 64s-28.7 64-64 64c-23.7 0-44.4-12.9-55.4-32H119.4c-11.1 19.1-31.7 32-55.4 32-35.3 0-64-28.7-64-64 0-23.7 12.9-44.4 32-55.4V151.4C12.9 140.4 0 119.7 0 96c0-35.3 28.7-64 64-64 23.7 0 44.4 12.9 55.4 32h209.2c11.1-19.1 31.7-32 55.4-32 35.3 0 64 28.7 64 64s-28.5 63.8-63.7 64l-4.5 7.9-32 56-2.3 4c4.2 8.5 6.5 18 6.5 28.1s-2.3 19.6-6.5 28.1l2.3 4 32 56 4.5 7.9z"
        }
    ]
};

const FasDrawSquare = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDrawSquare",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 151.4v209.2c9.7 5.6 17.8 13.7 23.4 23.4h209.2c5.6-9.7 13.7-17.8 23.4-23.4V151.4c-9.7-5.6-17.8-13.7-23.4-23.4H119.4c-5.6 9.7-13.7 17.8-23.4 23.4zM119.4 448c-11.1 19.1-31.7 32-55.4 32-35.3 0-64-28.7-64-64 0-23.7 12.9-44.4 32-55.4V151.4C12.9 140.4 0 119.7 0 96c0-35.3 28.7-64 64-64 23.7 0 44.4 12.9 55.4 32h209.2c11.1-19.1 31.7-32 55.4-32 35.3 0 64 28.7 64 64 0 23.7-12.9 44.4-32 55.4v209.2c19.1 11.1 32 31.7 32 55.4 0 35.3-28.7 64-64 64-23.7 0-44.4-12.9-55.4-32H119.4z"
        }
    ]
};

const FasDreidel = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDreidel",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M438.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 146.7l-62.1-62C207.2 66 176.8 66 158 84.7l-57.4 57.4 237.3 237.2 57.4-57.4c18.7-18.7 18.7-49.1 0-67.9l-62-62L438.6 86.6zM315.3 401.9 78.1 164.7 18.7 224C6.7 236 0 252.3 0 269.3V416c0 35.3 28.7 64 64 64h146.7c17 0 33.3-6.7 45.3-18.7l59.3-59.3z"
        }
    ]
};

const FasDroneFront = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDroneFront",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M155.7 112c-5.5-9.6-15.9-16-27.7-16s-22.2 6.4-27.7 16H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h240c13.3 0 24-10.7 24-24s-10.7-24-24-24H155.7zm220.3 0c-13.3 0-24 10.7-24 24s10.7 24 24 24h240c13.3 0 24-10.7 24-24s-10.7-24-24-24h-76.3c-5.5-9.6-15.9-16-27.7-16s-22.2 6.4-27.7 16H376zM96 192v64c0 12.6 7.4 24.1 19 29.2l56.5 25.1c-17.8 21.5-27.5 48.5-27.5 76.4v5.3c0 13.3 10.7 24 24 24s24-10.7 24-24v-5.2c0-16.8 5.9-33.2 16.7-46.1l8.4-10.1 41.9 18.6c4.1 1.8 8.5 2.8 13 2.8h96c4.5 0 8.9-.9 13-2.8l41.9-18.6 8.4 10.1c10.8 12.9 16.7 29.3 16.7 46.1v5.2c0 13.3 10.7 24 24 24s24-10.7 24-24v-5.2c0-27.9-9.7-54.9-27.5-76.4l56.5-25.2c11.6-5.1 19-16.6 19-29.2v-64h-64v43.2l-17.8 7.9-40.6-23.7C390.7 201.5 355.7 192 320 192s-70.7 9.5-101.6 27.5l-40.6 23.7-17.8-8V192H96z"
        }
    ]
};

const FasDrone = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDrone",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m223 127.2-51.4-38.5C162.3 64.9 139.1 48 112 48c-35.3 0-64 28.7-64 64 0 27.1 16.9 50.3 40.7 59.6l38.5 51.4c-5 .7-10.1 1-15.2 1C50.1 224 0 173.9 0 112S50.1 0 112 0s112 50.1 112 112c0 5.2-.3 10.2-1 15.2zm-49.6 2.8 39.8 29.9.1.1h85.3l.1-.1 39.8-29.9 29.7-22.3C370.3 92.1 383.8 80 400 80c17.7 0 32 14.3 32 32 0 16.2-12.1 29.7-27.8 31.7l-22.3 29.7-29.9 39.8-.1.1v85.3l.1.1 29.9 39.8 22.3 29.7c15.7 2.1 27.8 15.5 27.8 31.7 0 17.7-14.3 32-32 32-16.2 0-29.7-12.1-31.7-27.8l-29.7-22.3-39.8-29.9-.1-.1h-85.4l-.1.1-39.8 29.9-29.7 22.3c-2 15.8-15.5 27.9-31.7 27.9-17.7 0-32-14.3-32-32 0-16.2 12.1-29.7 27.8-31.7l22.3-29.7 29.9-39.8.1-.1v-85.4l-.1-.1-29.9-39.8-22.3-29.7C92.1 141.7 80 128.2 80 112c0-17.7 14.3-32 32-32 16.2 0 29.7 12.1 31.7 27.8l29.7 22.3zM224 400c0 61.9-50.1 112-112 112S0 461.9 0 400s50.1-112 112-112c5.2 0 10.2.3 15.2 1l-38.5 51.4C64.9 349.7 48 372.9 48 400c0 35.3 28.7 64 64 64 27.1 0 50.3-16.9 59.6-40.7l51.4-38.5c.7 5 1 10.1 1 15.2zm65-272.8c-.7-5-1-10.1-1-15.2C288 50.1 338.1 0 400 0s112 50.1 112 112-50.1 112-112 112c-5.2 0-10.2-.3-15.2-1l38.5-51.3c23.8-9.3 40.7-32.5 40.7-59.6 0-35.3-28.7-64-64-64-27.1 0-50.3 16.9-59.6 40.7L289 127.2zM288 400c0-5.2.3-10.2 1-15.2l51.3 38.5c9.3 23.8 32.5 40.7 59.6 40.7 35.3 0 64-28.7 64-64 0-27.1-16.9-50.3-40.7-59.6L384.8 289c5-.7 10.1-1 15.2-1 61.9 0 112 50.1 112 112s-50.1 112-112 112-112-50.1-112-112z"
        }
    ]
};

const FasDropletDegree = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDropletDegree",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 512C86 512 0 426 0 320 0 228.8 130.2 57.7 166.6 11.7c6-7.5 14.9-11.7 24.5-11.7h1.8c9.6 0 18.5 4.2 24.5 11.7C253.8 57.7 384 228.8 384 320c0 106-86 192-192 192zm272-400a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm-112 0a80 80 0 1 1 160 0 80 80 0 1 1-160 0z"
        }
    ]
};

const FasDropletPercent = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDropletPercent",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 512C86 512 0 426 0 320 0 228.8 130.2 57.7 166.6 11.7c6-7.5 14.9-11.7 24.5-11.7h1.8c9.6 0 18.5 4.2 24.5 11.7C253.8 57.7 384 228.8 384 320c0 106-86 192-192 192zm75.3-267.3c-6.2-6.2-16.4-6.2-22.6 0l-128 128c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l128-128c6.2-6.2 6.2-16.4 0-22.6zM136 288a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm112 112a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FasDropletSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDropletSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 512c53.2 0 101.4-21.6 136.1-56.6l-298.3-235C140 257.1 128 292.3 128 320c0 106 86 192 192 192zm185.2-141.3c4.4-16.1 6.8-33.1 6.8-50.7 0-91.2-130.2-262.3-166.6-308.3-6-7.5-14.9-11.7-24.5-11.7h-1.8c-9.6 0-18.5 4.2-24.5 11.7C277.8 33 240.7 81.3 205.8 136L38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-125.6-98.4zM224 336c0 44.2 35.8 80 80 80 8.8 0 16 7.2 16 16s-7.2 16-16 16c-61.9 0-112-50.1-112-112 0-8.8 7.2-16 16-16s16 7.2 16 16z"
        }
    ]
};

const FasDroplet = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDroplet",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 512C86 512 0 426 0 320 0 228.8 130.2 57.7 166.6 11.7c6-7.5 14.9-11.7 24.5-11.7h1.8c9.6 0 18.5 4.2 24.5 11.7C253.8 57.7 384 228.8 384 320c0 106-86 192-192 192zM96 336c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 61.9 50.1 112 112 112 8.8 0 16-7.2 16-16s-7.2-16-16-16c-44.2 0-80-35.8-80-80z"
        }
    ]
};

const FasDrumSteelpan = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDrumSteelpan",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 32c159.1 0 288 48 288 128v192c0 80-128.9 128-288 128S0 432 0 352V160C0 80 128.9 32 288 32zm240 128c0-9.9-8-29.9-55-49.8-18.6-7.9-40.9-14.4-66-19.4l-27.8 43.6c-7.3 11.5-11.2 24.8-11.2 38.4 0 17.5 6.4 34.4 18.1 47.5l9.8 11c29.8-5.2 55.9-12.5 77.2-21.5 47.1-19.9 55-39.9 55-49.8zm-178.8 77.3c-8-26.2-32.4-45.3-61.2-45.3s-53.3 19.1-61.2 45.3c19.4 1.7 39.9 2.7 61.2 2.7s41.8-.9 61.2-2.7zM169 90.8c-25.2 5-47.4 11.6-66 19.4-47 19.9-55 39.9-55 49.8s8 29.9 55 49.8c21.3 9 47.4 16.3 77.2 21.5l9.8-11c11.6-13.1 18.1-30 18.1-47.5 0-13.6-3.9-26.9-11.2-38.4L169 90.8zm56.3-8c-.8 4.2-1.3 8.7-1.3 13.2 0 35.3 28.7 64 64 64s64-28.7 64-64c0-4.5-.5-9-1.4-13.2C330.8 81 309.8 80 288 80s-42.8 1-62.6 2.8z"
        }
    ]
};

const FasDrum = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDrum",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M501.2 76.1c11.1-7.3 14.2-22.1 6.9-33.2S486 28.7 474.9 36l-104.7 68.5C335.8 98.7 297 96 256 96 114.6 96 0 128 0 208v160c0 31.3 27.4 58.8 72 78.7V344c0-13.3 10.7-24 24-24s24 10.7 24 24v119.4c33 8.9 71.1 14.5 112 16.1V376c0-13.3 10.7-24 24-24s24 10.7 24 24v103.5c40.9-1.6 79-7.2 112-16.1V344c0-13.3 10.7-24 24-24s24 10.7 24 24v102.7c44.6-19.9 72-47.4 72-78.7V208c0-41.1-30.2-69.5-78.8-87.4l67.9-44.5zm-193.8 69.5-64.6 42.3c-11.1 7.3-14.2 22.1-6.9 33.2s22.1 14.2 33.2 6.9l111.1-72.8c14.7 3.2 27.9 7 39.4 11.5 38.8 15.1 44.4 30.7 44.4 41.3 0 .8-2.7 17.2-46 35.9-38.9 16.8-96 28.1-162 28.1s-123.1-11.3-162-28.1c-43.3-18.7-46-35.1-46-35.9 0-10.6 5.6-26.2 44.4-41.3C130.6 151.9 187.8 144 256 144c18 0 35.1.5 51.4 1.6z"
        }
    ]
};

const FasDrumstickBite = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDrumstickBite",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 265.2c0 8.5-3.4 16.6-9.4 22.6l-26.8 26.8c-12.3 12.3-32.5 11.4-49.4 7.2-4.6-1.2-9.4-1.8-14.4-1.8-33.1 0-60 26.9-60 60s26.9 60 60 60c6.3 0 12 5.7 12 12 0 33.1 26.9 60 60 60s60-26.9 60-60c0-5-.6-9.8-1.8-14.5-4.2-16.9-5.2-37.1 7.2-49.4l26.8-26.8c6-6 14.1-9.4 22.6-9.4H336c6.3 0 12.4-.3 18.5-1 11.9-1.2 16.4-15.5 10.8-26-8.5-15.8-13.3-33.8-13.3-53 0-61.9 50.1-112 112-112 8 0 15.7.8 23.2 2.4 11.7 2.5 24.1-5.9 22-17.6C494.5 62.5 422.5 0 336 0c-97.2 0-176 78.8-176 176v89.2z"
        }
    ]
};

const FasDrumstick = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDrumstick",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M150.6 287.8c6-6 9.4-14.1 9.4-22.6V176C160 78.8 238.8 0 336 0s176 78.8 176 176-78.8 176-176 176h-89.2c-8.5 0-16.6 3.4-22.6 9.4l-26.8 26.8c-12.3 12.3-11.4 32.5-7.2 49.4 1.1 4.6 1.8 9.5 1.8 14.5 0 33.1-26.9 60-60 60s-60-26.9-60-60c0-6.3-5.7-12-12-12-33.1 0-60-26.9-60-60s26.9-60 60-60c5 0 9.8.6 14.5 1.8 16.9 4.2 37.1 5.2 49.4-7.2l26.8-26.8z"
        }
    ]
};

const FasDryerHeat = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDryerHeat",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm160 160a144 144 0 1 1 0 288 144 144 0 1 1 0-288zM64 88a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm120-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-27.3 148.7c-6.2 6.2-6.2 16.4 0 22.6l20.7 20.7c4.2 4.2 6.6 10 6.6 16s-2.4 11.8-6.6 16l-9.4 9.4c-10.2 10.2-16 24.1-16 38.6s5.8 28.4 16 38.6l20.7 20.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L190.6 352c-4.2-4.2-6.6-10-6.6-16s2.4-11.8 6.6-16l9.4-9.4c10.2-10.2 16-24.1 16-38.6s-5.8-28.4-16-38.6l-20.7-20.7c-6.2-6.2-16.4-6.2-22.6 0zm102.6 0c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l20.7 20.7c4.2 4.2 6.6 10 6.6 16s-2.4 11.8-6.6 16l-9.4 9.4c-10.2 10.2-16 24.1-16 38.6s5.8 28.4 16 38.6l20.7 20.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L270.6 352c-4.2-4.2-6.6-10-6.6-16s2.4-11.8 6.6-16l9.4-9.4c10.2-10.2 16-24.1 16-38.6s-5.8-28.4-16-38.6l-20.7-20.7z"
        }
    ]
};

const FasDryer = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDryer",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 64C0 28.7 28.7 0 64 0h320c35.3 0 64 28.7 64 64v384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm368 240a144 144 0 1 0-288 0 144 144 0 1 0 288 0zM88 112a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm120-24a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm128 216c0 61.9-50.1 112-112 112-56.4 0-103.1-41.7-110.9-96H176c8.8 0 16-7.2 16-16s-7.2-16-16-16h-62.9c7.8-54.3 54.4-96 110.9-96 61.9 0 112 50.1 112 112z"
        }
    ]
};

const FasDuck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDuck",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M400.7 224c-.4 0-.7.3-.7.7v24c0 6.6 2.8 12.8 7.2 17.7 20.4 22.7 32.8 52.7 32.8 85.6 0 70.7-57.3 128-128 128H196C87.8 480 0 392.2 0 284v-5.4C0 266.1 10.1 256 22.6 256c6 0 11.8 2.4 16 6.6L54 278c6.2 6.2 15.2 8.5 23.6 6.1l172.8-49.4c10.4-3 15.7-14.5 7.8-21.7-21-19-34.1-46.5-34.1-77 0-57.4 46.6-104 104-104 53.8 0 98.1 40.9 103.5 93.3 0 .4.3.6.7.7 10.5 1.3 21.2 1.3 31.8 0l35.3-4.4c6.8-.8 12.8 4.4 12.8 11.3 0 50.3-40.8 91.1-91.1 91.1h-20.4zM368 136a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm-27.4 160.9c.5-8.8-6.2-16.4-15-16.9s-16.4 6.2-16.9 15c-2.4 41.2-32.6 79-77.3 90.1-40.3 10.1-80.5-4.6-103.7-33.5-5.5-6.9-15.6-8-22.5-2.5s-8 15.6-2.5 22.5c31.1 38.7 84 57.6 136.4 44.5 58-14.5 98.3-63.8 101.5-119.3z"
        }
    ]
};

const FasDumbbell = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDumbbell",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 64c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32v384c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32v-64H64c-17.7 0-32-14.3-32-32v-64c-17.7 0-32-14.3-32-32s14.3-32 32-32v-64c0-17.7 14.3-32 32-32h32V64zm448 0v64h32c17.7 0 32 14.3 32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32v64c0 17.7-14.3 32-32 32h-32v64c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32zM416 224v64H224v-64h192z"
        }
    ]
};

const FasDumpsterFire = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDumpsterFire",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M49.7 32c-10.5 0-19.8 6.9-22.9 16.9L.9 133c-.6 2-.9 4.1-.9 6.1C0 150.7 9.3 160 20.9 160h94l25.6-128H49.7zM272 160V32h-98.9l-25.6 128H272zm32 0h58c15.1-18.1 32.1-35.7 50.5-52.1 1.5-1.4 3.2-2.6 4.8-3.8L402.9 32H304v128zm209.9-23.7c17.4-15.8 43.9-16.2 61.7-1.2-.1-.7-.3-1.4-.5-2.1l-25.9-84.1c-3.1-10-12.4-16.9-22.9-16.9h-90.8l12.8 64.2c9.6 1 19 4.9 26.6 11.8 11.7 10.6 23 21.6 33.9 33.1 1.6-1.6 3.3-3.2 5-4.8zm-188.7 74.4c3.8-6.2 7.9-12.5 12.3-18.7H32l4 32h-4c-17.7 0-32 14.3-32 32s14.3 32 32 32h12l20 160c0 17.7 14.3 32 32 32s32-14.3 32-32h209.6c-31-34.7-49.6-80.6-49.6-129.9 0-35.2 16.3-73.6 37.2-107.4zm128.4-78.9c-2.8-2.5-6.3-3.7-9.8-3.8-3.6 0-7.2 1.2-10 3.7-33.2 29.7-61.4 63.4-81.4 95.8-19.7 31.9-32.4 66.2-32.4 92.6 0 87.8 70.3 159.9 160 159.9 88.7 0 160-72 160-159.8 0-20.2-9.6-50.9-24.2-79-14.8-28.5-35.7-58.5-60.4-81.1-5.6-5.1-14.4-5.2-20 0-9.6 8.8-18.6 19.6-26.5 29.5-17.3-20.7-35.8-39.9-55.5-57.7zM530 401c-15 10-31 15-49 15-45 0-81-29-81-78 0-24 15-45 45-82 4 5 62 79 62 79l36-42c3 4 5 8 7 12 18 33 10 75-20 96z"
        }
    ]
};

const FasDumpster = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDumpster",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M49.7 32c-10.5 0-19.8 6.9-22.9 16.9L.9 133c-.6 2-.9 4.1-.9 6.1C0 150.7 9.3 160 20.9 160h94l25.6-128H49.7zM272 160V32h-98.9l-25.6 128H272zm32 0h124.5L402.9 32H304v128zm157.1 0h94c11.5 0 20.9-9.3 20.9-20.9 0-2.1-.3-4.1-.9-6.1l-25.9-84.1c-3.1-10-12.4-16.9-22.9-16.9h-90.8l25.6 128zM32 192l4 32h-4c-17.7 0-32 14.3-32 32s14.3 32 32 32h12l20 160c0 17.7 14.3 32 32 32s32-14.3 32-32h320c0 17.7 14.3 32 32 32s32-14.3 32-32l20-160h12c17.7 0 32-14.3 32-32s-14.3-32-32-32h-4l4-32H32z"
        }
    ]
};

const FasDungeon = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasDungeon",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M336.6 156.5c1.3 1.1 2.7 2.2 3.9 3.3 9.3 8.2 23 10.5 33.4 3.6l67.6-45.1c11.4-7.6 14.2-23.2 5.1-33.4-16.6-18.3-35.7-34.3-56.9-47.3-11.9-7.3-26.9-1.4-32.1 11.6l-30.5 76.2c-4.5 11.1.2 23.6 9.5 31.2zM328 36.8c5.1-12.8-1.6-27.4-15-30.5C294.7 2.2 275.6 0 256 0s-38.7 2.2-57 6.4c-13.5 3-20.2 17.6-15 30.4l30.3 75.8c4.5 11.3 16.8 17.2 29 16 4.2-.4 8.4-.6 12.7-.6s8.6.2 12.7.6c12.1 1.2 24.4-4.7 29-16L328 36.8zM65.5 85c-9.1 10.2-6.3 25.8 5.1 33.4l67.6 45.1c10.3 6.9 24.1 4.6 33.4-3.6 1.3-1.1 2.6-2.3 4-3.3 9.3-7.5 13.9-20.1 9.5-31.2l-30.7-76.2c-5.2-12.9-20.3-18.8-32.1-11.6-21.2 13-40.3 29-56.8 47.4zm314 137.1c.9 3.3 1.7 6.6 2.3 10 2.5 13 13 23.9 26.2 23.9h80c13.3 0 24.1-10.8 22.9-24-2.5-27.2-9.3-53.2-19.7-77.3-5.5-12.9-21.4-16.6-33.1-8.9l-68.6 45.7c-9.8 6.5-13.2 19.2-10 30.5zM53.9 145.8c-11.6-7.8-27.6-4-33.1 8.9C10.4 178.8 3.6 204.8 1.1 232c-1.2 13.2 9.6 24 22.9 24h80c13.3 0 23.8-10.8 26.2-23.9.6-3.4 1.4-6.7 2.3-10 3.1-11.4-.2-24-10-30.5l-68.6-45.8zM104 288H24c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24zm304 0c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24h-80zM24 416c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24H24zm384 0c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24h-80zM272 192c0-8.8-7.2-16-16-16s-16 7.2-16 16v272c0 8.8 7.2 16 16 16s16-7.2 16-16V192zm-64 32c0-8.8-7.2-16-16-16s-16 7.2-16 16v240c0 8.8 7.2 16 16 16s16-7.2 16-16V224zm128 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v240c0 8.8 7.2 16 16 16s16-7.2 16-16V224z"
        }
    ]
};

const FasE = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasE",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h224c17.7 0 32-14.3 32-32s-14.3-32-32-32H64V288h160c17.7 0 32-14.3 32-32s-14.3-32-32-32H64V96h224c17.7 0 32-14.3 32-32s-14.3-32-32-32H64z"
        }
    ]
};

const FasEarDeaf = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasEarDeaf",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m502.6 54.6-40 40c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l40-40c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3zm-320 320-128 128c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l128-128c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3zM240 128c-57.6 0-105.1 43.6-111.3 99.5-1.9 17.6-17.8 30.2-35.3 28.3S63.2 238 65.1 220.5C74.8 132.5 149.4 64 240 64c97.2 0 176 78.8 176 176 0 46-17.7 87.9-46.6 119.3-12 13-17.4 24.8-17.4 34.7v6c0 61.9-50.1 112-112 112-17.7 0-32-14.3-32-32s14.3-32 32-32c26.5 0 48-21.5 48-48v-6.1c0-32.9 17.4-59.6 34.4-78 18.4-20 29.6-46.6 29.6-75.9 0-61.9-50.1-112-112-112zm0 80c-17.7 0-32 14.3-32 32 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-44.2 35.8-80 80-80s80 35.8 80 80c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-17.7-14.3-32-32-32z"
        }
    ]
};

const FasEarListen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasEarListen",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M398.3 3.4c-15.8-7.9-35-1.5-42.9 14.3-7.9 15.8-1.5 34.9 14.2 42.9l.4.2c.4.2 1.1.6 2.1 1.2 2 1.2 5 3 8.7 5.6 7.5 5.2 17.6 13.2 27.7 24.2C428.5 113.4 448 146 448 192c0 17.7 14.3 32 32 32s32-14.3 32-32c0-66-28.5-113.4-56.5-143.7-13.9-15.1-27.8-26.1-38.2-33.3-5.3-3.7-9.7-6.4-13-8.3-1.6-1-3-1.7-4-2.2-.5-.3-.9-.5-1.2-.7l-.4-.2-.2-.1h-.1l-14.3 28.6 14.2-28.7zM128.7 227.5c6.2-56 53.7-99.5 111.3-99.5 61.9 0 112 50.1 112 112 0 29.3-11.2 55.9-29.6 75.9-17 18.4-34.4 45.1-34.4 78v6.1c0 26.5-21.5 48-48 48-17.7 0-32 14.3-32 32s14.3 32 32 32c61.9 0 112-50.1 112-112v-6.1c0-9.8 5.4-21.7 17.4-34.7C398.3 327.9 416 286 416 240c0-97.2-78.8-176-176-176-90.6 0-165.2 68.5-174.9 156.5-1.9 17.6 10.7 33.4 28.3 35.3s33.4-10.7 35.3-28.3zM32 512a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160-160a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm-150.6 9.4c-12.5 12.5-12.5 32.8 0 45.3l64 64c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-64-64c-12.5-12.5-32.8-12.5-45.3 0zM208 240c0-17.7 14.3-32 32-32s32 14.3 32 32c0 13.3 10.7 24 24 24s24-10.7 24-24c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 13.3 10.7 24 24 24s24-10.7 24-24z"
        }
    ]
};

const FasEarMuffs = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasEarMuffs",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 64c-78.2 0-143.3 56.1-157.2 130.2-6-1.4-12.3-2.2-18.8-2.2-17.7 0-34.1 5.8-47.4 15.6C105 91.5 201.8 0 320 0s215 91.5 223.4 207.6c-13.3-9.8-29.7-15.6-47.4-15.6-6.5 0-12.7.8-18.8 2.2C463.3 120.1 398.2 64 320 64zM179.8 304c7.6 8.5 12.2 19.7 12.2 32s-4.6 23.5-12.2 32c7.6 8.5 12.2 19.7 12.2 32s-4.6 23.5-12.2 32c7.6 8.5 12.2 19.7 12.2 32 0 26.5-21.5 48-48 48-22.1 0-40.8-15-46.3-35.4-5.5 2.2-11.5 3.4-17.7 3.4-26.5 0-48-21.5-48-48 0-6.2 1.2-12.2 3.4-17.7C15 408.8 0 390.1 0 368s15-40.8 35.4-46.3c-2.2-5.5-3.4-11.5-3.4-17.7 0-26.5 21.5-48 48-48 6.2 0 12.2 1.2 17.7 3.4C103.2 239 121.9 224 144 224c26.5 0 48 21.5 48 48 0 12.3-4.6 23.5-12.2 32zm280.4 0c-7.6-8.5-12.2-19.7-12.2-32 0-26.5 21.5-48 48-48 22.1 0 40.8 15 46.3 35.4 5.5-2.2 11.4-3.4 17.7-3.4 26.5 0 48 21.5 48 48 0 6.2-1.2 12.2-3.4 17.7C625 327.2 640 345.9 640 368s-15 40.8-35.4 46.3c2.2 5.5 3.4 11.4 3.4 17.7 0 26.5-21.5 48-48 48-6.2 0-12.2-1.2-17.7-3.4C536.8 497 518.1 512 496 512c-26.5 0-48-21.5-48-48 0-12.3 4.6-23.5 12.2-32-7.6-8.5-12.2-19.7-12.2-32s4.6-23.5 12.2-32c-7.6-8.5-12.2-19.7-12.2-32s4.6-23.5 12.2-32z"
        }
    ]
};

const FasEar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasEar",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M319.9 335.2c-18.2 16.3-30 39.1-35.1 62.9-5.6 26.3-18.6 51.3-39 71.7-56.2 56.2-147.4 56.2-203.6 0C14.1 441.7 0 404.9 0 368V192C0 86 86 0 192 0s192 86 192 192c0 56.9-24.8 108-64.1 143.2zM128 192c0-35.3 28.7-64 64-64s64 28.7 64 64v8c0 13.3 10.7 24 24 24s24-10.7 24-24v-8c0-61.9-50.1-112-112-112S80 130.1 80 192v20.2c0 21.2 12 40.6 31 50.1l14 7c1.8.9 3 2.8 3 4.9 0 1.6-.7 3.2-2 4.2l-37.4 31.2c-10.2 8.5-11.6 23.6-3.1 33.8s23.6 11.6 33.8 3.1l37.4-31.2c12.3-10.2 19.3-25.2 19.3-41.1 0-20.2-11.4-38.8-29.5-47.8l-14-7c-2.7-1.4-4.4-4.1-4.4-7.2V192z"
        }
    ]
};

const FasEarthAfrica = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasEarthAfrica",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m177.8 63.2 10 17.4c2.8 4.8 4.2 10.3 4.2 15.9v41.4c0 3.9 1.6 7.7 4.3 10.4 6.2 6.2 16.5 5.7 22-1.2l13.6-17c4.7-5.9 12.9-7.7 19.6-4.3l15.2 7.6c3.4 1.7 7.2 2.6 11 2.6 6.5 0 12.8-2.6 17.4-7.2l3.9-3.9c2.9-2.9 7.3-3.6 11-1.8l29.2 14.6c7.8 3.9 12.6 11.8 12.6 20.5 0 10.5-7.1 19.6-17.3 22.2l-35.4 8.8c-7.4 1.8-15.1 1.5-22.4-.9l-32-10.7c-3.3-1.1-6.7-1.7-10.2-1.7-7 0-13.8 2.3-19.4 6.5L176 212c-10.1 7.6-16 19.4-16 32v28c0 26.5 21.5 48 48 48h32c8.8 0 16 7.2 16 16v48c0 17.7 14.3 32 32 32 10.1 0 19.6-4.7 25.6-12.8l25.6-34.1c8.3-11.1 12.8-24.6 12.8-38.4v-12.1c0-3.9 2.6-7.3 6.4-8.2l5.3-1.3c11.9-3 20.3-13.7 20.3-26 0-7.1-2.8-13.9-7.8-18.9l-33.5-33.5c-3.7-3.7-3.7-9.7 0-13.4 5.7-5.7 14.1-7.7 21.8-5.1l14.1 4.7c12.3 4.1 25.7-1.5 31.5-13 3.5-7 11.2-10.8 18.9-9.2l27.4 5.5C432 112.4 351.5 48 256 48c-27.7 0-54 5.4-78.2 15.2zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0z"
        }
    ]
};

const FasEarthAmericas = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasEarthAmericas",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m57.7 193 9.4 16.4c8.3 14.5 21.9 25.2 38 29.8l57.9 16.5c17.2 4.9 29 20.6 29 38.5v39.9c0 11 6.2 21 16 25.9s16 14.9 16 25.9v39c0 15.6 14.9 26.9 29.9 22.6 16.1-4.6 28.6-17.5 32.7-33.8l2.8-11.2c4.2-16.9 15.2-31.4 30.3-40l8.1-4.6c15-8.5 24.2-24.5 24.2-41.7v-8.3c0-12.7-5.1-24.9-14.1-33.9l-3.9-3.9c-9-9-21.2-14.1-33.9-14.1H257c-11.1 0-22.1-2.9-31.8-8.4l-34.5-19.7c-4.3-2.5-7.6-6.5-9.2-11.2-3.2-9.6 1.1-20 10.2-24.5l5.9-3c6.6-3.3 14.3-3.9 21.3-1.5l23.2 7.7c8.2 2.7 17.2-.4 21.9-7.5 4.7-7 4.2-16.3-1.2-22.8l-13.6-16.3c-10-12-9.9-29.5.3-41.3l15.7-18.3c8.8-10.3 10.2-25 3.5-36.7l-2.4-4.2c-3.5-.2-6.9-.3-10.4-.3-92.8 0-171.5 60.9-198.2 145zM464 256c0-36.8-9.6-71.4-26.4-101.5L412 164.8c-15.7 6.3-23.8 23.8-18.5 39.8l16.9 50.7c3.5 10.4 12 18.3 22.6 20.9l29.1 7.3c1.2-9 1.8-18.2 1.8-27.5zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0z"
        }
    ]
};

const FasEarthAsia = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasEarthAsia",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m51.7 295.1 31.7 6.3c7.9 1.6 16-.9 21.7-6.6l15.4-15.4c11.6-11.6 31.1-8.4 38.4 6.2l9.3 18.5c4.8 9.6 14.6 15.7 25.4 15.7 15.2 0 26.1-14.6 21.7-29.2l-6-19.9c-4.6-15.4 6.9-30.9 23-30.9h2.3c13.4 0 25.9-6.7 33.3-17.8l10.7-16.1c5.6-8.5 5.3-19.6-.8-27.7l-16.1-21.5c-10.3-13.7-3.3-33.5 13.4-37.7l17-4.3c7.5-1.9 13.6-7.2 16.5-14.4L325 59.4C303.4 52.1 280.2 48 256 48 141.1 48 48 141.1 48 256c0 13.4 1.3 26.5 3.7 39.1zm407.7 4.6c-3-.3-6-.1-9 .8l-15.8 4.4c-6.7 1.9-13.8-.9-17.5-6.7l-2-3.1c-6-9.4-16.4-15.1-27.6-15.1s-21.6 5.7-27.6 15.1l-6.1 9.5c-1.4 2.2-3.4 4.1-5.7 5.3L312 330.1c-18.1 10.1-25.5 32.4-17 51.3l5.5 12.4c8.6 19.2 30.7 28.5 50.5 21.1l2.6-1c10-3.7 21.3-2.2 29.9 4.1l1.5 1.1c37.2-29.5 64.1-71.4 74.4-119.5zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm144.5 92.1c-2.1 8.6 3.1 17.3 11.6 19.4l32 8c8.6 2.1 17.3-3.1 19.4-11.6s-3.1-17.3-11.6-19.4l-32-8c-8.6-2.1-17.3 3.1-19.4 11.6zm92-20c-2.1 8.6 3.1 17.3 11.6 19.4s17.3-3.1 19.4-11.6l8-32c2.1-8.6-3.1-17.3-11.6-19.4s-17.3 3.1-19.4 11.6l-8 32zm106.7-214.4c-7.9-4-17.5-.7-21.5 7.2l-16 32c-4 7.9-.7 17.5 7.2 21.5s17.5.7 21.5-7.2l16-32c4-7.9.7-17.5-7.2-21.5z"
        }
    ]
};

const FasEarthEurope = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasEarthEurope",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m266.3 48.3-33.8 25.3c-5.4 4-8.5 10.4-8.5 17.1v9.1c0 6.8 5.5 12.3 12.3 12.3 2.4 0 4.8-.7 6.8-2.1l41.8-27.9c2-1.3 4.4-2.1 6.8-2.1h1c6.2 0 11.3 5.1 11.3 11.3 0 3-1.2 5.9-3.3 8l-19.9 19.9a53.03 53.03 0 0 1-20.7 12.8l-26.5 8.8c-5.8 1.9-9.6 7.3-9.6 13.4 0 3.7-1.5 7.3-4.1 10L202 182.1c-6.4 6.4-9.9 15-9.9 24v4.3c0 16.4 13.6 29.7 29.9 29.7 11 0 21.2-6.2 26.1-16l4-8.1c2.4-4.8 7.4-7.9 12.8-7.9 4.5 0 8.7 2.1 11.4 5.7l16.3 21.7c2.1 2.9 5.5 4.5 9.1 4.5 8.4 0 13.9-8.9 10.1-16.4l-1.1-2.3c-3.5-7 0-15.5 7.5-18l21.2-7.1c7.6-2.5 12.7-9.6 12.7-17.6 0-10.3 8.3-18.6 18.6-18.6H400c8.8 0 16 7.2 16 16s-7.2 16-16 16h-20.7c-7.2 0-14.2 2.9-19.3 8l-4.7 4.7c-2.1 2.1-3.3 5-3.3 8 0 6.2 5.1 11.3 11.3 11.3h11.3c6 0 11.8 2.4 16 6.6l6.5 6.5c1.8 1.8 2.8 4.3 2.8 6.8s-1 5-2.8 6.8l-7.5 7.5c-3.6 3.8-5.6 8.7-5.6 13.8s2 10 5.7 13.7L408 304c10.2 10.2 24.1 16 38.6 16h7.4c6.5-20.2 10-41.7 10-64 0-111.4-87.6-202.4-197.7-207.7zm172 307.9c-3.7-2.6-8.2-4.1-13-4.1-6 0-11.8-2.4-16-6.6L396 332c-7.7-7.7-18-12-28.9-12-9.7 0-19.2-3.5-26.6-9.8L314 287.4c-11.6-9.9-26.4-15.4-41.7-15.4h-20.9c-12.6 0-25 3.7-35.5 10.7L188.5 301c-17.8 11.9-28.5 31.9-28.5 53.3v3.2c0 17 6.7 33.3 18.7 45.3l16 16c8.5 8.5 20 13.3 32 13.3H248c13.3 0 24 10.7 24 24 0 2.5.4 5 1.1 7.3 71.3-5.8 132.5-47.6 165.2-107.2zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm187.3-155.3c-6.2-6.2-16.4-6.2-22.6 0l-32 32c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l32-32c6.2-6.2 6.2-16.4 0-22.6z"
        }
    ]
};

const FasEarthOceania = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasEarthOceania",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-47.4-154.7-39-13.5c-6.5-2.2-13.6-2.3-20.1-.3l-15.3 4.9c-18.5 5.9-38.5-2.4-47.5-19.5l-3.3-6.2c-10.6-20.1-2.3-45 18.2-54.7l35.3-16.8c2.3-1.1 4.4-2.8 5.9-4.8l5.3-7c7.2-9.6 18.6-15.3 30.6-15.3s23.4 5.7 30.6 15.3l4.6 6.1c2 2.6 4.9 4.5 8.1 5.1 7.8 1.6 15.7-1.5 20.4-7.9l10.4-14.2c2-2.8 5.3-4.4 8.7-4.4 4.4 0 8.4 2.7 10 6.8l10.1 25.9c2.8 7.2 6.7 14 11.5 20.2l17.9 22.8c5.8 7.4 9 16.6 9 26s-3.2 18.6-9 26l-12 15.4c-8.3 10.6-21 16.8-34.4 16.8-8.4 0-16.6-2.4-23.7-7l-25.4-16.4c-2.2-1.4-4.5-2.5-6.9-3.4zm65.2-214.8 22.2 22.2c10.1 10.1 2.9 27.3-11.3 27.3h-29.9c-5.6 0-11.1-1.2-16.2-3.4l-42.8-19c-14.3-6.3-11.9-27.3 3.4-30.3l38.5-7.7c13.1-2.6 26.7 1.5 36.1 10.9zM248 432c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16zm183.2-133.1 8 24c2.8 8.4-1.7 17.4-10.1 20.2s-17.4-1.7-20.2-10.1l-8-24c-2.8-8.4 1.7-17.4 10.1-20.2s17.4 1.7 20.2 10.1zm-19.9 80.4-32 32c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l32-32c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
        }
    ]
};

const FasEclipse = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasEclipse",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M361.5 1.2c5 2.1 8.6 6.6 9.6 11.9l9.6 52.2c-34.2 15-63.7 38.9-85.4 68.8-12.4-4-25.6-6.2-39.4-6.2-70.7 0-128 57.3-128 128s57.3 128 128 128c13.7 0 27-2.2 39.4-6.2 21.7 29.9 51.1 53.9 85.4 68.8l-9.6 52.2c-1 5.3-4.6 9.8-9.6 11.9s-10.7 1.5-15.2-1.6L256 446.9l-90.3 62.3c-4.5 3.1-10.2 3.7-15.2 1.6s-8.6-6.6-9.6-11.9L121 391 13.1 371.1c-5.3-1-9.8-4.6-11.9-9.6s-1.5-10.7 1.6-15.2L65.1 256 2.8 165.7c-3.1-4.5-3.7-10.2-1.6-15.2s6.6-8.6 11.9-9.6L121 121l19.9-107.9c1-5.3 4.6-9.8 9.6-11.9s10.7-1.5 15.2 1.6L256 65.1l90.3-62.3c4.5-3.1 10.2-3.7 15.2-1.6zM256 160c7.6 0 15 .9 22.1 2.6C264 190.7 256 222.4 256 256s8 65.3 22.1 93.4c-7.1 1.7-14.5 2.6-22.1 2.6-53 0-96-43-96-96s43-96 96-96zm208-80a176 176 0 1 1 0 352 176 176 0 1 1 0-352z"
        }
    ]
};

const FasEggFried = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasEggFried",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M284.3 39.3c30.4 31.6 89.1 65.9 131.5 76.7 27.5 7 52.8 23.2 71 47.8 42.1 56.8 30.2 137-26.6 179.1-17.8 13.2-37.9 21.1-58.4 24-37.2 5.2-84.5 32.7-103.3 65.2-44.2 76.5-142 102.7-218.6 58.6S-22.7 348.5 21.4 272c24.8-42.9 38.7-105.9 43.1-155.2C67.1 87 80.1 58 103.3 35.7c51-49 132-47.4 181 3.6zM336 240a112 112 0 1 0-224 0 112 112 0 1 0 224 0zm-160-8c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-39.8 32.2-72 72-72 8.8 0 16 7.2 16 16s-7.2 16-16 16c-22.1 0-40 17.9-40 40z"
        }
    ]
};

const FasEgg = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasEgg",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 496C86 496 0 394 0 288 0 176 64 16 192 16s192 160 192 272c0 106-86 208-192 208zm-37.2-362c6.5-6 7-16.1 1-22.6s-16.1-7-22.6-1c-23.9 21.8-41.1 52.7-52.3 84.2C69.7 226.1 64 259.7 64 288c0 8.8 7.2 16 16 16s16-7.2 16-16c0-24.5 5-54.4 15.1-82.8 10.1-28.5 25-54.1 43.7-71.2z"
        }
    ]
};

const FasEggplant = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasEggplant",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M505 7c9.4 9.4 9.4 24.6 0 33.9l-9 9V192c0 8.8-7.2 16-16 16-26.5 0-48-21.5-48-48 0-5.8-4-10.7-9.4-12.6-13.3-4.8-25.4-13-35.1-22.8s-18-21.9-22.8-35.1c-2-5.4-6.9-9.4-12.6-9.4-26.5 0-48-21.5-48-48 0-8.8 7.2-16 16-16h142l9-9c9.4-9.4 24.6-9.4 33.9 0zM169.9 139.3c40.3-19.6 81-39.3 113.4-66.6 11.8 20 32.1 34.4 55.9 38.3 6.7 14 15.8 26.3 25.8 36.2s22.2 19.1 36.2 25.8c5 30.4 27.1 55.1 56.2 63.8-46.8 125.9-146.3 275.4-281 275.2-96.5-.1-175-80.7-176.4-176-1.6-113.5 83.4-154.7 169.9-196.7z"
        }
    ]
};

const FasEject = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasEject",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 32c13.5 0 26.3 5.6 35.4 15.6l176 192c12.9 14 16.2 34.3 8.6 51.8S419 320 400 320H48c-19 0-36.3-11.2-43.9-28.7s-4.3-37.7 8.6-51.8l176-192c9-9.9 21.8-15.5 35.3-15.5zM0 432c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48s-21.5 48-48 48H48c-26.5 0-48-21.5-48-48z"
        }
    ]
};

const FasElephant = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasElephant",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M304 0c-61.9 0-112 50.1-112 112s50.1 112 112 112c8.8 0 16 7.2 16 16s-7.2 16-16 16c-79.5 0-144-64.5-144-144 0-25.3 6.5-49.1 18-69.8-20.5 7-39.4 17.3-56.1 30.4C67.4 111.9 32 175.8 32 248v19c0 12.4-1.2 24.7-3.7 36.9-1.9 9.3-5.8 18-11.4 25.6L4.8 345.6c-8 10.6-5.8 25.6 4.8 33.6s25.6 5.8 33.6-4.8l12.1-16.2c3.2-4.3 6.1-8.8 8.7-13.5V480c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32v-70c15.3 3.9 31.4 6 48 6s32.7-2.1 48-6v70c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V340.7c16.7 18.9 38.8 32.8 64 39.3v18.6c0 45 36.5 81.4 81.4 81.4 30.8 0 59-17.4 72.8-45l2.3-4.7c7.9-15.8 1.5-35-14.3-42.9s-35-1.5-42.9 14.3l-2.3 4.7c-3 5.9-9 9.6-15.6 9.6-9.6 0-17.4-7.8-17.4-17.4V380c22.9-5.9 43.4-18 59.4-34.4 6.2-6.3 6.1-16.4-.2-22.6-6.3-6.2-16.3-6.1-22.5.1-1.3 1.3-2.6 2.6-4 3.9-1.5 1.4-3.1 2.7-4.6 4-8.3 6.7-17.8 12-28 15.6-10 3.5-20.8 5.5-32 5.5s-22-1.9-32-5.5c-7.5-2.6-14.6-6.2-21.1-10.5-9.1-6.1-17.2-13.7-23.7-22.4-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2C472.5 310 491.1 320 512 320c11.7 0 22.6-3.1 32-8.6V192c0-88.4-71.6-160-160-160h-1.6C362.2 12.2 334.5 0 304 0zm160 192a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
        }
    ]
};

const FasElevator = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasElevator",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m132.7 4.7-64 64c-4.6 4.6-5.9 11.5-3.5 17.4S73.5 96 80 96h128c6.5 0 12.3-3.9 14.8-9.9s1.1-12.9-3.5-17.4l-64-64c-6.2-6.2-16.4-6.2-22.6 0zM64 128c-35.3 0-64 28.7-64 64v256c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64H64zm96 96a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM80 400c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48v16c0 17.7-14.3 32-32 32h-96c-17.7 0-32-14.3-32-32v-16zm192 0c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48v16c0 17.7-14.3 32-32 32h-96c-17.7 0-32-14.3-32-32v-16zm32-128a48 48 0 1 1 96 0 48 48 0 1 1-96 0zm52.7-180.7c6.2 6.2 16.4 6.2 22.6 0l64-64c4.6-4.6 5.9-11.5 3.5-17.4S438.5 0 432 0H304c-6.5 0-12.3 3.9-14.8 9.9s-1.1 12.9 3.5 17.4l64 64z"
        }
    ]
};

const FasEllipsisStrokeVertical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasEllipsisStrokeVertical",
    "viewBox": "0 0 192 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 72a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm0 96a72 72 0 1 1 0-144 72 72 0 1 1 0 144zm24 88a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm-96 0a72 72 0 1 1 144 0 72 72 0 1 1-144 0zm96 160a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm-96 0a72 72 0 1 1 144 0 72 72 0 1 1-144 0z"
        }
    ]
};

const FasEllipsisStroke = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasEllipsisStroke",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M416 280a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm0-96a72 72 0 1 0 0 144 72 72 0 1 0 0-144zm-160 96a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm0-96a72 72 0 1 0 0 144 72 72 0 1 0 0-144zm-136 72a24 24 0 1 1-48 0 24 24 0 1 1 48 0zm-96 0a72 72 0 1 0 144 0 72 72 0 1 0-144 0z"
        }
    ]
};

const FasEllipsisVertical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasEllipsisVertical",
    "viewBox": "0 0 128 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 360a56 56 0 1 0 0 112 56 56 0 1 0 0-112zm0-160a56 56 0 1 0 0 112 56 56 0 1 0 0-112zm56-104A56 56 0 1 0 8 96a56 56 0 1 0 112 0z"
        }
    ]
};

const FasEllipsis = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasEllipsis",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M8 256a56 56 0 1 1 112 0 56 56 0 1 1-112 0zm160 0a56 56 0 1 1 112 0 56 56 0 1 1-112 0zm216-56a56 56 0 1 1 0 112 56 56 0 1 1 0-112z"
        }
    ]
};

const FasEmptySet = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasEmptySet",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m435.4 121.9 67.2-67.2c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-67.1 67.2C352.8 48.6 306.3 32 256 32 132.3 32 32 132.3 32 256c0 50.3 16.6 96.8 44.6 134.2L9.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l67.2-67.2c37.4 28 83.8 44.6 134.1 44.6 123.7 0 224-100.3 224-224 0-50.3-16.6-96.8-44.6-134.1zm-91.2.7L122.5 344.2C105.8 318.9 96 288.6 96 256c0-88.4 71.6-160 160-160 32.6 0 62.9 9.8 88.2 26.5zm-176.5 267 221.8-221.8c16.7 25.3 26.5 55.6 26.5 88.2 0 88.4-71.6 160-160 160-32.6 0-62.9-9.8-88.2-26.5z"
        }
    ]
};

const FasEngineWarning = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasEngineWarning",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M400 112c13.3 0 24-10.7 24-24s-10.7-24-24-24H208c-13.3 0-24 10.7-24 24s10.7 24 24 24h72v32H128c-17.7 0-32 14.3-32 32v56H48v-72c0-13.3-10.7-24-24-24S0 146.7 0 160v192c0 13.3 10.7 24 24 24s24-10.7 24-24v-72h48v72c0 17.7 14.3 32 32 32h44.8l32 40c12.1 15.2 30.5 24 50 24H448c35.3 0 64-28.7 64-64V238.8c0-19.4-8.8-37.8-24-50L449.5 158c-11.3-9.1-25.4-14-40-14H328v-32h72zm144 112v192c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32h-32c-17.7 0-32 14.3-32 32zm-240-36c11 0 20 9 20 20v88c0 11-9 20-20 20s-20-9-20-20v-88c0-11 9-20 20-20zm-24 180a24 24 0 1 1 48 0 24 24 0 1 1-48 0z"
        }
    ]
};

const FasEngine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasEngine",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M400 112c13.3 0 24-10.7 24-24s-10.7-24-24-24H208c-13.3 0-24 10.7-24 24s10.7 24 24 24h72v32H128c-17.7 0-32 14.3-32 32v56H48v-72c0-13.3-10.7-24-24-24S0 146.7 0 160v192c0 13.3 10.7 24 24 24s24-10.7 24-24v-72h48v72c0 17.7 14.3 32 32 32h44.8l32 40c12.1 15.2 30.5 24 50 24H448c35.3 0 64-28.7 64-64V238.8c0-19.4-8.8-37.8-24-50L449.5 158c-11.3-9.1-25.4-14-40-14H328v-32h72zm144 112v192c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32h-32c-17.7 0-32 14.3-32 32zm-256 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-128 32a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm224-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FasEnvelopeCircleCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasEnvelopeCircleCheck",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 64C21.5 64 0 85.5 0 112c0 15.1 7.1 29.3 19.2 38.4l217.6 163.2c11.4 8.5 27 8.5 38.4 0l57.4-43c23.9-59.8 79.7-103.3 146.3-109.8l13.9-10.4c12.1-9.1 19.2-23.3 19.2-38.4 0-26.5-21.5-48-48-48H48zm246.4 275.2a63.9 63.9 0 0 1-76.8 0L0 176v208c0 35.3 28.7 64 64 64h296.2c-25.1-30.4-40.2-69.5-40.2-112 0-5.6.3-11.1.8-16.6l-26.4 19.8zM640 336a144 144 0 1 0-288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l28.7 28.7 60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"
        }
    ]
};

const FasEnvelopeDot = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasEnvelopeDot",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M496 0a80 80 0 1 1 0 160 80 80 0 1 1 0-160zM48 64h337.1c-.7 5.2-1.1 10.6-1.1 16 0 45.6 27.2 84.8 66.3 102.3L275.2 313.6a32.1 32.1 0 0 1-38.4 0L19.2 150.4C7.1 141.3 0 127.1 0 112c0-26.5 21.5-48 48-48zm246.4 275.2 196.4-147.3c1.7.1 3.4.1 5.2.1 5.4 0 10.8-.4 16-1.1V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V176l217.6 163.2a63.9 63.9 0 0 0 76.8 0z"
        }
    ]
};

const FasEnvelopeOpenDollar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasEnvelopeOpenDollar",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M215.4 96H96v177.4L.2 202.5c1.6-18.1 10.9-34.9 25.7-45.8L48 140.3V96c0-26.5 21.5-48 48-48h76.6l49.9-36.9C232.2 3.9 243.9 0 256 0s23.8 3.9 33.5 11l49.9 37H416c26.5 0 48 21.5 48 48v44.3l22.1 16.4c14.8 10.9 24.1 27.7 25.7 45.8L416 273.4V96H215.4zM0 448V242.1l217.6 161.2c11.1 8.2 24.6 12.7 38.4 12.7s27.3-4.4 38.4-12.7L512 242.1V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64zm276-312v13.9c7.5 1.2 14.6 2.9 21.1 4.7 10.7 2.8 17 13.8 14.2 24.5s-13.8 17-24.5 14.2c-11-2.9-21.6-5-31.2-5.2-7.9-.1-16 1.8-21.5 5-4.8 2.8-6.2 5.6-6.2 9.3 0 1.8.1 3.5 5.3 6.7 6.3 3.8 15.5 6.7 28.3 10.5l.7.2c11.2 3.4 25.6 7.7 37.1 15 12.9 8.1 24.3 21.3 24.6 41.6.3 20.9-10.5 36.1-24.8 45-7.2 4.5-15.2 7.3-23.2 9V344c0 11-9 20-20 20s-20-9-20-20v-14.6c-10.3-2.2-20-5.5-28.2-8.4-2.1-.7-4.1-1.4-6.1-2.1-10.5-3.5-16.1-14.8-12.6-25.3s14.8-16.1 25.3-12.6c2.5.8 4.9 1.7 7.2 2.4 13.6 4.6 24 8.1 35.1 8.5 8.6.3 16.5-1.6 21.4-4.7 4.1-2.5 6-5.5 5.9-10.5 0-2.9-.8-5-5.9-8.2-6.3-4-15.4-6.9-28-10.7l-1.7-.5c-10.9-3.3-24.6-7.4-35.6-14-12.7-7.7-24.6-20.5-24.7-40.7-.1-21.1 11.8-35.7 25.8-43.9 6.9-4.1 14.5-6.8 22.2-8.5V136c0-11 9-20 20-20s20 9 20 20z"
        }
    ]
};

const FasEnvelopeOpenText = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasEnvelopeOpenText",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M215.4 96H96v177.4L.2 202.5c1.6-18.1 10.9-34.9 25.7-45.8L48 140.3V96c0-26.5 21.5-48 48-48h76.6l49.9-36.9C232.2 3.9 243.9 0 256 0s23.8 3.9 33.5 11l49.9 37H416c26.5 0 48 21.5 48 48v44.3l22.1 16.4c14.8 10.9 24.1 27.7 25.7 45.8L416 273.4V96H215.4zM0 448V242.1l217.6 161.2c11.1 8.2 24.6 12.7 38.4 12.7s27.3-4.4 38.4-12.7L512 242.1V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64zm176-288h160c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64h160c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FasEnvelopeOpen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasEnvelopeOpen",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 208.1 256 65.9l192 142.2v47.4L289.5 373c-9.7 7.2-21.4 11-33.5 11s-23.8-3.9-33.5-11L64 255.5v-47.4zM256 0c-12.1 0-23.8 3.9-33.5 11L25.9 156.7C9.6 168.8 0 187.8 0 208.1V448c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V208.1c0-20.3-9.6-39.4-25.9-51.4L289.5 11C279.8 3.9 268.1 0 256 0z"
        }
    ]
};

const FasEnvelope = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasEnvelope",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 64C21.5 64 0 85.5 0 112c0 15.1 7.1 29.3 19.2 38.4l217.6 163.2c11.4 8.5 27 8.5 38.4 0l217.6-163.2c12.1-9.1 19.2-23.3 19.2-38.4 0-26.5-21.5-48-48-48H48zM0 176v208c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V176L294.4 339.2a63.9 63.9 0 0 1-76.8 0L0 176z"
        }
    ]
};

const FasEnvelopesBulk = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasEnvelopesBulk",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 0c-17.7 0-32 14.3-32 32v192h96v-32c0-35.3 28.7-64 64-64h224V32c0-17.7-14.3-32-32-32H128zm128 160c-17.7 0-32 14.3-32 32v32h96c35.3 0 64 28.7 64 64v128h192c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32H256zm240 64h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16zM64 256c-17.7 0-32 14.3-32 32v13l155.1 114.9c1.4 1 3.1 1.6 4.9 1.6s3.5-.6 4.9-1.6L352 301v-13c0-17.7-14.3-32-32-32H64zm288 84.8L216 441.6c-6.9 5.1-15.3 7.9-24 7.9s-17-2.8-24-7.9L32 340.8V480c0 17.7 14.3 32 32 32h256c17.7 0 32-14.3 32-32V340.8z"
        }
    ]
};

const FasEnvelopes = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasEnvelopes",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M316.7 249.6c5.6 4.1 12.4 6.4 19.3 6.4s13.7-2.2 19.3-6.4l220-163C570.8 55.7 544.2 32 512 32H160c-32.2 0-58.8 23.7-63.3 54.7l220 163zm57.7 25.7c-11.1 8.3-24.6 12.7-38.4 12.7s-27.3-4.4-38.4-12.7L96 126v194c0 35.3 28.7 64 64 64h352c35.3 0 64-28.7 64-64V126L374.4 275.3zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120v224c0 75.1 60.9 136 136 136h320c13.3 0 24-10.7 24-24s-10.7-24-24-24H136c-48.6 0-88-39.4-88-88V120z"
        }
    ]
};

const FasEquals = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasEquals",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 128c-17.7 0-32 14.3-32 32s14.3 32 32 32h352c17.7 0 32-14.3 32-32s-14.3-32-32-32H48zm0 192c-17.7 0-32 14.3-32 32s14.3 32 32 32h352c17.7 0 32-14.3 32-32s-14.3-32-32-32H48z"
        }
    ]
};

const FasEraser = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasEraser",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M290.7 57.4 57.4 290.7c-25 25-25 65.5 0 90.5l80 80c12 12 28.3 18.7 45.3 18.7H512c17.7 0 32-14.3 32-32s-14.3-32-32-32H387.9l130.7-130.6c25-25 25-65.5 0-90.5L381.3 57.4c-25-25-65.5-25-90.5 0zm6.7 358.6H182.6l-80-80 124.7-124.7 137.4 137.4-67.3 67.3z"
        }
    ]
};

const FasEscalator = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasEscalator",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M208 48a48 48 0 1 1 96 0 48 48 0 1 1-96 0zm197.9 127.8c11.6-10.2 26.6-15.8 42.1-15.8h96c35.3 0 64 28.7 64 64s-28.7 64-64 64h-72L234.1 496.2C222.5 506.4 207.5 512 192 512H96c-35.3 0-64-28.7-64-64s28.7-64 64-64h72l237.9-208.2zM320 192v16.4l-128 112V192c0-35.3 28.7-64 64-64s64 28.7 64 64z"
        }
    ]
};

const FasEthernet = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasEthernet",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 224v192c0 17.7 14.3 32 32 32h64V336c0-8.8 7.2-16 16-16s16 7.2 16 16v112h64V336c0-8.8 7.2-16 16-16s16 7.2 16 16v112h64V336c0-8.8 7.2-16 16-16s16 7.2 16 16v112h64V336c0-8.8 7.2-16 16-16s16 7.2 16 16v112h64c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32h-32v-32c0-17.7-14.3-32-32-32h-32V96c0-17.7-14.3-32-32-32H160c-17.7 0-32 14.3-32 32v32H96c-17.7 0-32 14.3-32 32v32H32c-17.7 0-32 14.3-32 32z"
        }
    ]
};

const FasEuroSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasEuroSign",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48.1 240c-.1 2.7-.1 5.3-.1 8v16c0 2.7 0 5.3.1 8H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h28.3C89.9 419.9 170 480 264 480h24c17.7 0 32-14.3 32-32s-14.3-32-32-32h-24c-57.9 0-108.2-32.4-133.9-80H256c17.7 0 32-14.3 32-32s-14.3-32-32-32H112.2c-.1-2.6-.2-5.3-.2-8v-16c0-2.7.1-5.4.2-8H256c17.7 0 32-14.3 32-32s-14.3-32-32-32H130.1c25.7-47.6 76-80 133.9-80h24c17.7 0 32-14.3 32-32s-14.3-32-32-32h-24C170 32 89.9 92.1 60.3 176H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h16.1z"
        }
    ]
};

const FasExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasExclamation",
    "viewBox": "0 0 64 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64v256c0 17.7 14.3 32 32 32s32-14.3 32-32V64zM32 480a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"
        }
    ]
};

const FasExpandWide = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasExpandWide",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 64C14.3 64 0 78.3 0 96v96c0 17.7 14.3 32 32 32s32-14.3 32-32v-64h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zm32 256c0-17.7-14.3-32-32-32S0 302.3 0 320v96c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H64v-64zM384 64c-17.7 0-32 14.3-32 32s14.3 32 32 32h64v64c0 17.7 14.3 32 32 32s32-14.3 32-32V96c0-17.7-14.3-32-32-32h-96zm128 256c0-17.7-14.3-32-32-32s-32 14.3-32 32v64h-64c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32v-96z"
        }
    ]
};

const FasExpand = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasExpand",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 32C14.3 32 0 46.3 0 64v96c0 17.7 14.3 32 32 32s32-14.3 32-32V96h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zm32 320c0-17.7-14.3-32-32-32S0 334.3 0 352v96c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H64v-64zM320 32c-17.7 0-32 14.3-32 32s14.3 32 32 32h64v64c0 17.7 14.3 32 32 32s32-14.3 32-32V64c0-17.7-14.3-32-32-32h-96zm128 320c0-17.7-14.3-32-32-32s-32 14.3-32 32v64h-64c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32v-96z"
        }
    ]
};

const FasExplosion = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasExplosion",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M499.6 11.3c6.7-10.7 20.5-14.5 31.7-8.5s15.8 19.5 10.6 31L404.8 338.6c2.2 2.3 4.3 4.7 6.3 7.1l97.2-54.7c10.5-5.9 23.6-3.1 30.9 6.4s6.3 23-2.2 31.5l-87 87h-71.5c-13.2-37.3-48.7-64-90.5-64s-77.4 26.7-90.5 64h-79.7l-75.5-52.2c-9.7-6.7-13.1-19.6-7.9-30.3s17.4-15.9 28.7-12.4l97.2 30.4c3-3.9 6.1-7.7 9.4-11.3l-62.3-103.8c-6.1-10.1-3.9-23.1 5.1-30.7s22.2-7.5 31.1.1L246 293.6c1.5-.4 3-.8 4.5-1.1l13.6-142.7c1.2-12.3 11.5-21.7 23.9-21.7s22.7 9.4 23.9 21.7l13.5 141.9L499.6 11.3zM64 448h480c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h32zM288 0c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V24c0-13.3 10.7-24 24-24z"
        }
    ]
};

const FasEyeDropperFull = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasEyeDropperFull",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M341.6 29.2 240.1 130.8l-9.4-9.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-9.4-9.4 101.5-101.6c39-39 39-102.2 0-141.1s-102.2-39-141.1 0zM55.4 323.3c-15 15-23.4 35.4-23.4 56.6v42.4L5.4 462.2c-8.5 12.7-6.8 29.6 4 40.4s27.7 12.5 40.4 4L89.7 480h42.4c21.2 0 41.6-8.4 56.6-23.4l120.7-120.7-133.3-133.3L55.4 323.3z"
        }
    ]
};

const FasEyeDropperHalf = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasEyeDropperHalf",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M240.1 130.8 341.6 29.2c39-39 102.2-39 141.1 0s39 102.2 0 141.1L381.2 271.9l9.4 9.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-160-160c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l9.4 9.4zm-63.9 71.8 45.3 45.3-72.2 72.1h85.5l29.4-29.4 45.3 45.3-120.8 120.7c-15 15-35.4 23.4-56.6 23.4H89.7l-40 26.6c-12.7 8.5-29.6 6.8-40.4-4s-12.5-27.7-4-40.4L32 422.3v-42.4c0-21.2 8.4-41.6 23.4-56.6l120.7-120.7z"
        }
    ]
};

const FasEyeDropper = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasEyeDropper",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M341.6 29.2 240.1 130.8l-9.4-9.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-9.4-9.4 101.5-101.6c39-39 39-102.2 0-141.1s-102.2-39-141.1 0zM55.4 323.3c-15 15-23.4 35.4-23.4 56.6v42.4L5.4 462.2c-8.5 12.7-6.8 29.6 4 40.4s27.7 12.5 40.4 4L89.7 480h42.4c21.2 0 41.6-8.4 56.6-23.4l120.7-120.7-45.3-45.3-120.7 120.7c-3 3-7.1 4.7-11.3 4.7H96v-36.1c0-4.2 1.7-8.3 4.7-11.3l120.7-120.7-45.3-45.3L55.4 323.3z"
        }
    ]
};

const FasEyeEvil = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasEyeEvil",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M254.9 112.2c-10.7 2.8-21.1 6.3-30.9 10.4L114.4 76.1c-8.7-3.7-18.7-1-24.4 6.5s-5.5 17.9.4 25.2l57.3 70.8c-7 9-12.8 18.6-17.3 28.6L15.5 236.1C6.4 238.4 0 246.6 0 256s6.4 17.6 15.5 19.9l114.9 28.7c4.5 10.1 10.3 19.7 17.3 28.6l-57.3 70.9c-5.9 7.3-6.1 17.7-.4 25.2s15.7 10.2 24.4 6.5L224 389.4c9.8 4.1 20.1 7.6 30.9 10.4l42.7 97.6c3.9 8.9 12.7 14.7 22.4 14.7s18.5-5.8 22.4-14.7l42.7-97.6c10.7-2.8 21.1-6.3 30.9-10.4l109.7 46.5c8.7 3.7 18.7 1 24.4-6.5s5.5-17.9-.4-25.2l-57.3-70.8c7-9 12.8-18.6 17.3-28.6l114.9-28.7c9.1-2.3 15.5-10.5 15.5-19.9s-6.4-17.6-15.5-19.9l-115-28.9c-4.5-10.1-10.3-19.7-17.3-28.6l57.3-70.8c5.9-7.3 6.1-17.7.4-25.2s-15.7-10.2-24.4-6.5L416 122.6c-9.8-4.1-20.1-7.6-30.9-10.4l-42.7-97.5C338.5 5.8 329.7 0 320 0s-18.5 5.8-22.4 14.7l-42.7 97.6zM320 352c-53 0-96-43-96-96 0-19.7 6-38.1 16.2-53.3 16.6 9.6 35 16.2 54.7 19.3-3.9 9.4-6.8 20.8-6.8 34 0 31.5 16.5 52.7 23.8 60.6 2.1 2.3 5.1 3.4 8.2 3.4s6.1-1.1 8.2-3.4c7.3-7.9 23.8-29.2 23.8-60.6 0-13.2-2.9-24.6-6.8-34 19.6-3.1 38.1-9.8 54.7-19.3 10 15.2 16 33.6 16 53.3 0 53-43 96-96 96z"
        }
    ]
};

const FasEyeLowVision = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasEyeLowVision",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-105.2-82.4c39.6-40.6 66.4-86.1 79.9-118.4 3.3-7.9 3.3-16.7 0-24.6-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-68.2 0-125 26.3-169.3 60.8L38.8 5.1zM223 149.5c48.6-44.3 123-50.8 179.3-11.7 60.8 42.4 78.9 123.2 44.2 186.9L408 294.5c8.4-19.3 10.6-41.4 4.8-63.3-11.1-41.5-47.8-69.4-88.6-71.1-5.8-.2-9.2 6.1-7.4 11.7 2.1 6.4 3.3 13.2 3.3 20.3 0 10.2-2.4 19.8-6.6 28.3L223 149.5zm223.1 298-363-286c-11 14.4-20.5 28.7-28.4 42.2l339 265.7c18.7-5.5 36.2-13 52.6-21.8zM34.5 268.3c14.9 35.7 46.2 87.7 93 131.1 47 43.8 111.7 80.6 192.5 80.6 3.1 0 6.1-.1 9.2-.2l-296.1-232c-1.8 6.8-1.3 14 1.4 20.5z"
        }
    ]
};

const FasEyeSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasEyeSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-105.2-82.4c39.6-40.6 66.4-86.1 79.9-118.4 3.3-7.9 3.3-16.7 0-24.6-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-68.2 0-125 26.3-169.3 60.8L38.8 5.1zm184.3 144.4c25.5-23.3 59.6-37.5 96.9-37.5 79.5 0 144 64.5 144 144 0 24.9-6.3 48.3-17.4 68.7L408 294.5c8.4-19.3 10.6-41.4 4.8-63.3-11.1-41.5-47.8-69.4-88.6-71.1-5.8-.2-9.2 6.1-7.4 11.7 2.1 6.4 3.3 13.2 3.3 20.3 0 10.2-2.4 19.8-6.6 28.3l-90.3-70.8zM373 389.9c-16.4 6.5-34.3 10.1-53 10.1-79.5 0-144-64.5-144-144 0-6.9.5-13.6 1.4-20.2l-94.3-74.3c-22.8 29.7-39.1 59.3-48.6 82.2-3.3 7.9-3.3 16.7 0 24.6 14.9 35.7 46.2 87.7 93 131.1 47 43.8 111.7 80.6 192.5 80.6 47.8 0 89.9-12.9 126.2-32.5L373 389.9z"
        }
    ]
};

const FasEye = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasEye",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4 142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1 3.3-7.9 3.3-16.7 0-24.6-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm144-64c0 35.3-28.7 64-64 64-7.1 0-13.9-1.2-20.3-3.3-5.5-1.8-11.9 1.6-11.7 7.4.3 6.9 1.3 13.8 3.2 20.7 13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1-5.8-.2-9.2 6.1-7.4 11.7 2.1 6.4 3.3 13.2 3.3 20.3z"
        }
    ]
};

const FasEyes = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasEyes",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 224c-11.1 0-21.6 2.8-30.7 7.8 4-36.7 16.8-68.8 34.5-92.4C121.3 110.8 148.6 96 176 96s54.7 14.8 76.2 43.4C273.7 168.1 288 209.2 288 256s-14.3 87.9-35.8 116.6S203.4 416 176 416s-54.7-14.8-76.2-43.4c-4.9-6.5-9.4-13.6-13.4-21.3 3.1.5 6.4.7 9.6.7 35.3 0 64-28.7 64-64s-28.7-64-64-64zm224-97.3c-5-9.1-10.5-17.6-16.6-25.7-30.6-40.8-75.3-69-127.4-69S79.2 60.2 48.6 101C18 141.8 0 196.7 0 256s18 114.2 48.6 155 75.3 69 127.4 69 96.8-28.2 127.4-69c6-8 11.6-16.6 16.6-25.7 5 9.1 10.5 17.6 16.6 25.7 30.6 40.8 75.3 69 127.4 69s96.8-28.2 127.4-69C622 370.2 640 315.3 640 256s-18-114.2-48.6-155S516.1 32 464 32s-96.8 28.2-127.4 69c-6 8-11.6 16.6-16.6 25.7zm54.4 224.6c3.1.5 6.4.7 9.6.7 35.3 0 64-28.7 64-64s-28.7-64-64-64c-11.1 0-21.6 2.8-30.7 7.8 4-36.7 16.8-68.8 34.5-92.4C409.3 110.8 436.6 96 464 96s54.7 14.8 76.2 43.4C561.7 168.1 576 209.2 576 256s-14.3 87.9-35.8 116.6S491.4 416 464 416s-54.7-14.8-76.2-43.4c-4.9-6.5-9.4-13.6-13.4-21.3z"
        }
    ]
};

const FasF = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasF",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v352c0 17.7 14.3 32 32 32s32-14.3 32-32V288h160c17.7 0 32-14.3 32-32s-14.3-32-32-32H64V96h224c17.7 0 32-14.3 32-32s-14.3-32-32-32H64z"
        }
    ]
};

const FasFaceAngryHorns = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceAngryHorns",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M576 256c0 141.4-114.6 256-256 256S64 397.4 64 256c0-24.6 3.5-48.4 9.9-70.9C29.6 125.8 6.5 50.1.3 19.1-1 12.8 1.7 6.3 7.1 2.7s12.4-3.6 17.8 0c19.3 12.9 48.5 24.2 78.4 33.1 23.3 7 46 12.2 63 15.5C209.1 19.1 262.3 0 320 0s110.9 19.1 153.8 51.3c17-3.3 39.7-8.6 63-15.5 29.8-8.9 59.1-20.2 78.4-33.1 5.4-3.6 12.4-3.6 17.8 0s8.1 10.1 6.8 16.4c-6.2 31-29.3 106.6-73.6 166 6.5 22.5 9.9 46.3 9.9 70.9zM402.7 411.9c6.6-5.9 7.1-16 1.2-22.6-16.1-17.9-44.2-37.3-83.9-37.3s-67.8 19.4-83.9 37.3c-5.9 6.6-5.4 16.7 1.2 22.6s16.7 5.4 22.6-1.2c11.7-13 31.6-26.7 60.1-26.7s48.4 13.7 60.1 26.7c5.9 6.6 16 7.1 22.6 1.2zM240.4 296c13.3 0 24-10.7 24-24 0-2.6-.4-5.1-1.2-7.4l19.7 6.6c8.4 2.8 17.4-1.7 20.2-10.1s-1.7-17.4-10.1-20.2l-96-32c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2l39.6 13.2c-6.2 4.3-10.2 11.5-10.2 19.6 0 13.3 10.7 24 24 24zm184-24c0-8.2-4.1-15.5-10.4-19.8l39.1-13c8.4-2.8 12.9-11.9 10.1-20.2s-11.9-12.9-20.2-10.1l-96 32c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l20.6-6.9c-.8 2.4-1.3 5-1.3 7.7 0 13.3 10.7 24 24 24s24-10.7 24-24z"
        }
    ]
};

const FasFaceAngry = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceAngry",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm338.7 139.9c6.6-5.9 7.1-16 1.2-22.6-16.1-17.9-44.2-37.3-83.9-37.3s-67.8 19.4-83.9 37.3c-5.9 6.6-5.4 16.7 1.2 22.6s16.7 5.4 22.6-1.2c11.7-13 31.6-26.7 60.1-26.7s48.4 13.7 60.1 26.7c5.9 6.6 16 7.1 22.6 1.2zM176.4 272c17.7 0 32-14.3 32-32 0-1.5-.1-3-.3-4.4l10.9 3.6c8.4 2.8 17.4-1.7 20.2-10.1s-1.7-17.4-10.1-20.2l-96-32c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2l30.7 10.2c-5.8 5.8-9.3 13.8-9.3 22.6 0 17.7 14.3 32 32 32zm192-32c0-8.9-3.6-17-9.5-22.8l30.2-10.1c8.4-2.8 12.9-11.9 10.1-20.2S387.3 174 379 176.8l-96 32c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l11.7-3.9c-.2 1.5-.3 3.1-.3 4.7 0 17.7 14.3 32 32 32s32-14.3 32-32z"
        }
    ]
};

const FasFaceAnguished = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceAnguished",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm0-192c44.2 0 80 35.8 80 80 0 8.8-7.2 16-16 16H192c-8.8 0-16-7.2-16-16 0-44.2 35.8-80 80-80zm-111.6-96a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM192 128c-4.4 0-8.8.3-13 .9-21.2 2.8-40.6 12.4-56.1 26.8-6.5 6-16.6 5.7-22.6-.8s-5.7-16.6.8-22.6c20.1-18.7 45.5-31.5 73.7-35.2 5.6-.7 11.4-1.1 17.2-1.1 8.8 0 16 7.2 16 16s-7.2 16-16 16zm141 .9c-4.3-.6-8.6-.9-13-.9-8.8 0-16-7.2-16-16s7.2-16 16-16c5.8 0 11.6.4 17.2 1.1 28.2 3.7 53.7 16.4 73.7 35.2 6.5 6 6.8 16.2.8 22.6s-16.2 6.8-22.6.8c-15.5-14.5-34.8-24-56.1-26.8z"
        }
    ]
};

const FasFaceAnxiousSweat = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceAnxiousSweat",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 512c141.4 0 256-114.6 256-256S429.4 0 288 0 32 114.6 32 256v3.3c16.3-7.1 36.4-2.8 48 12.8 7 9.2 18.1 24.6 27.7 40.7 4.8 8.1 9.6 17 13.2 25.7 3.4 8 7.1 19 7.1 30.5 0 24.5-11.1 46-28.4 60.3C146.4 480.2 213.5 512 288 512zM79.5 404.5C89.6 395.9 96 383.2 96 369c0-20-28.4-60.4-41.6-77.7-3.2-4.4-9.6-4.4-12.8 0-1.7 2.3-3.8 5-5.9 8.1C21.4 319.1 0 351.7 0 369c0 26 21.5 47 48 47 12 0 23-4.3 31.5-11.5zM208 400c0-44.2 35.8-80 80-80s80 35.8 80 80c0 8.8-7.2 16-16 16H224c-8.8 0-16-7.2-16-16zm159.6-160a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-128 32a32 32 0 1 1-64 0 32 32 0 1 1 64 0zm-12.3-100.7-7.4 7.4a159.96 159.96 0 0 1-86.8 44.7l-2.5.4c-8.7 1.5-17-4.4-18.4-13.2s4.4-17 13.2-18.4l2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zm121.4-22.6c6.2-6.2 16.4-6.2 22.6 0l7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5.4c8.7 1.5 14.6 9.7 13.2 18.4s-9.7 14.6-18.4 13.2l-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4c-6.2-6.2-6.2-16.4 0-22.6z"
        }
    ]
};

const FasFaceAstonished = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceAstonished",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm0-208c26.5 0 48 21.5 48 48v32c0 26.5-21.5 48-48 48s-48-21.5-48-48v-32c0-26.5 21.5-48 48-48zm-111.6-80a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM192 128c-4.4 0-8.8.3-13 .9-21.2 2.8-40.6 12.4-56.1 26.8-6.5 6-16.6 5.7-22.6-.8s-5.7-16.6.8-22.6c20.1-18.7 45.5-31.5 73.7-35.2 5.6-.7 11.4-1.1 17.2-1.1 8.8 0 16 7.2 16 16s-7.2 16-16 16zm141 .9c-4.3-.6-8.6-.9-13-.9-8.8 0-16-7.2-16-16s7.2-16 16-16c5.8 0 11.6.4 17.2 1.1 28.2 3.7 53.7 16.4 73.7 35.2 6.5 6 6.8 16.2.8 22.6s-16.2 6.8-22.6.8c-15.5-14.5-34.8-24-56.1-26.8z"
        }
    ]
};

const FasFaceAwesome = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceAwesome",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm203.5-95.6c-5.6 9.4-15.8 15.6-27.5 15.6-17.7 0-32-14.3-32-32 0-9.1 3.8-17.4 10-23.2-3.3-.5-6.6-.8-10-.8-35.3 0-64 28.7-64 64v10.3c0 16.4 13.3 29.7 29.7 29.7h68.6c16.4 0 29.7-13.3 29.7-29.7V184c0-8.3-1.6-16.3-4.5-23.6zM384 176c-17.7 0-32-14.3-32-32 0-8.5 3.3-16.3 8.8-22-5.4-1.3-11-2-16.8-2-39.8 0-72 32.2-72 72v7.5c0 13.5 11 24.5 24.5 24.5h95.1c13.5 0 24.5-11 24.5-24.5V192c0-10.4-2.2-20.2-6.1-29.1-5.8 8-15.2 13.1-25.9 13.1zM245.5 447.8c2.7.1 5.4.2 8.1.2h4.9c55.1 0 105.1-26.1 137-67.5 15.7-20.5 27-44.6 32.4-71.3 2.2-11-6.2-21.2-17.4-21.2H101.6c-11.2 0-19.6 10.2-17.4 21.2 15.6 78.1 82.4 135 161.2 138.6zm-5.4-32.5c1.5-44.1 37.8-79.4 82.2-79.4 19.9 0 38.1 7 52.3 18.7C349 392.1 306.1 416 258.4 416h-4.9c-4.6 0-9.1-.2-13.5-.6z"
        }
    ]
};

const FasFaceBeamHandOverMouth = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceBeamHandOverMouth",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 256c0 113.1-73.3 209.1-175.1 242.9l49-49c18.1-18.1 18.7-47.1 1.8-65.9 16.9-18.8 16.3-47.8-1.8-65.9-1-1-2.1-2-3.2-3 3.7-15.7-.5-32.8-12.8-45s-29.4-16.5-45-12.8c-.9-1.1-1.9-2.2-3-3.2-18.7-18.7-49.1-18.7-67.9 0l-47 47c-9.4-13.7-25.1-22.7-43-22.7-28.7 0-52 23.3-52 52v86.4c0 21.9 5.5 42.5 15.3 60.5C51.2 433 0 350.5 0 256 0 114.6 114.6 0 256 0s256 114.6 256 256zm-294.4-43.2c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2c-9.9 13.2-16.6 30.9-16.6 48.8 0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l.2-.2c.2-.2.4-.5.7-.9.6-.8 1.6-2 2.8-3.4 2.5-2.8 6-6.6 10.2-10.3 8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3 1.2 1.4 2.2 2.6 2.8 3.4.3.4.6.7.7.9l.2.2zm160 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2c-9.9 13.2-16.6 30.9-16.6 48.8 0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l.2-.2c.2-.2.4-.5.7-.9.6-.8 1.6-2 2.8-3.4 2.5-2.8 6-6.6 10.2-10.3 8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3 1.2 1.4 2.2 2.6 2.8 3.4.3.4.6.7.7.9l.2.2zm-78.3 63.9c6.2 6.2 6.2 16.4 0 22.6L248 350.6c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l67.3-67.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L280 382.6c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l51.3-51.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L312 414.6c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l19.3-19.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-56.8 56.8C288.7 502 264.4 512 239.2 512c-52.6 0-95.2-42.6-95.2-95.2v-86.4c0-11 9-20 20-20s20 9 20 20v19.7c0 7.1 8.6 10.7 13.7 5.7l79-79c6.2-6.2 16.4-6.2 22.6 0z"
        }
    ]
};

const FasFaceClouds = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceClouds",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 0c-23.7 0-44.4 12.9-55.4 32H64C28.7 32 0 60.7 0 96s28.7 64 64 64h160c35.3 0 64-28.7 64-64s-28.7-64-64-64c-13.2 0-25.4 4-35.6 10.8C179.7 17.9 155.9 0 128 0zM72.1 192c-5.3 20.5-8.1 41.9-8.1 64 0 114.6 75.4 211.7 179.3 244.3-12.1-17-19.3-37.8-19.3-60.3 0-50.6 36.2-92.8 84.1-102.1C321.2 290.7 364.6 256 416 256c29.1 0 55.6 11.1 75.5 29.2 8.9-3.4 18.5-5.2 28.5-5.2 20 0 38.3 7.3 52.3 19.5 2.4-14.1 3.7-28.7 3.7-43.5C576 114.6 461.4 0 320 0c-20.6 0-40.7 2.4-59.9 7C295.2 21.3 320 55.8 320 96c0 39.6-24 73.6-58.2 88.3 6.5 5.9 10.5 14.3 10.5 23.7 0 17.7-14.3 32-32 32s-32-14.3-32-32c0-5.8 1.6-11.3 4.3-16H72.1zm328.3-16a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM336 368h-8c-39.8 0-72 32.2-72 72s32.2 72 72 72h240c39.8 0 72-32.2 72-72s-32.2-72-72-72h-.7c.4-2.6.7-5.3.7-8 0-26.5-21.5-48-48-48-13.9 0-26.4 5.9-35.1 15.3-14-23.5-39.6-39.3-68.9-39.3-44.2 0-80 35.8-80 80z"
        }
    ]
};

const FasFaceConfounded = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceConfounded",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM116 205.1c0-9 9.6-14.7 17.5-10.5l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5 0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6zm262.5-10.5c7.9-4.2 17.5 1.5 17.5 10.5 0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6 0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9zm-161.6 160 39.1 26.2 39.1-26.1c5.4-3.6 12.4-3.6 17.8 0l40.3 26.8 23.7-11.8c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5l-32 16c-5.1 2.6-11.3 2.2-16-1L304 387.2l-39.1 26.1c-5.4 3.6-12.4 3.6-17.8 0L208 387.2l-39.1 26.1c-4.8 3.2-10.9 3.6-16 1l-32-16c-7.9-4-11.1-13.6-7.2-21.5s13.6-11.1 21.5-7.2l23.7 11.8 40.3-26.8c5.4-3.6 12.4-3.6 17.8 0z"
        }
    ]
};

const FasFaceConfused = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceConfused",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-84.9-116.4-1.1.9c-6.9 5.5-17 4.4-22.5-2.5s-4.4-17 2.5-22.5l1.1-.9C205 327.5 272 304 341 304h11c8.8 0 16 7.2 16 16s-7.2 16-16 16h-11c-61.8 0-121.7 21-169.9 59.6zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FasFaceCowboyHat = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceCowboyHat",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M216 0c9.1 0 17.9 4 26.1 10.7 7.9 6.5 19.8 6.5 27.7 0C278.1 4 286.9 0 296 0c36.8 0 67.4 64.9 82.4 109.8 33.6-10.5 63.6-25.2 88.5-43 2.5-1.8 5.4-2.8 8.4-2.8 8.9 0 15.6 8.3 12.9 16.7C461.2 163.2 367.5 224 256 224S50.8 163.2 23.8 80.7C21 72.3 27.7 64 36.7 64c3 0 6 1 8.4 2.8 24.9 17.8 54.9 32.5 88.5 43C148.6 64.9 179.2 0 216 0zM48 304c0-37.9 10.1-73.4 27.8-104 48.8 35.3 112.5 56 180.2 56s131.4-20.6 180.2-56c17.7 30.6 27.8 66.1 27.8 104 0 114.9-93.1 208-208 208S48 418.9 48 304zm299.8 60.7c-27.9 7.8-59 12.1-91.6 12.1s-63.7-4.3-91.6-12.1c-12.4-3.5-24.3 7.3-18.6 18.8 20.2 40.6 62 68.5 110.2 68.5s90-27.9 110.2-68.6c5.7-11.5-6.2-22.2-18.6-18.8zM216 304a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm104 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FasFaceDiagonalMouth = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceDiagonalMouth",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm116.4-192.6-224 64c-8.5 2.4-17.4-2.5-19.8-11s2.5-17.4 11-19.8l224-64c8.5-2.4 17.4 2.5 19.8 11s-2.5 17.4-11 19.8zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FasFaceDisappointed = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceDisappointed",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm60.1-101.3c-11.7-13-31.6-26.7-60.1-26.7s-48.4 13.7-60.1 26.7c-5.9 6.6-16 7.1-22.6 1.2s-7.1-16-1.2-22.6c16.1-17.9 44.2-37.3 83.9-37.3s67.8 19.4 83.9 37.3c5.9 6.6 5.4 16.7-1.2 22.6s-16.7 5.4-22.6-1.2zM211.3 267.3l-7.4 7.4a159.96 159.96 0 0 1-86.8 44.7l-2.5.4c-8.7 1.5-17-4.4-18.4-13.2s4.4-17 13.2-18.4l2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zm89.4 0c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5.4c8.7 1.5 14.6 9.7 13.2 18.4s-9.7 14.6-18.4 13.2l-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4z"
        }
    ]
};

const FasFaceDisguise = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceDisguise",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512c141.4 0 256-114.6 256-256 0-16.4-1.5-32.5-4.5-48H440c0 50.1-38.4 91.2-87.3 95.6 9.6 7.9 15.3 19.7 15.3 32.4 0 15.9-9 30.4-23.1 37.5l19.6 24.5c5.5 6.9 4.4 17-2.5 22.5s-17 4.4-22.5-2.5l-23.9-29.9-7.3 3.6 10.5 26.3c3.3 8.2-.7 17.5-8.9 20.8s-17.5-.7-20.8-8.9l-10-24.9c-2.4.7-4.8 1.3-7.2 1.8V432c0 8.8-7.2 16-16 16s-16-7.2-16-16v-25.2c-2.4-.5-4.8-1.1-7.2-1.8l-10 24.9c-3.3 8.2-12.6 12.2-20.8 8.9s-12.2-12.6-8.9-20.8l10.5-26.3-7.3-3.6-23.7 29.9c-5.5 6.9-15.6 8-22.5 2.5s-8-15.6-2.5-22.5l19.6-24.5C153 366.4 144 351.9 144 336c0-12.7 5.7-24.5 15.3-32.4C110.4 299.2 72 258.1 72 208H4.5c-3 15.5-4.5 31.6-4.5 48 0 141.4 114.6 256 256 256zm61.9-245.5c7.9 3.5 16.8 5.5 26.1 5.5 35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64c0 2.5.1 4.9.4 7.3 5.4 3.6 10.1 8.4 13.5 14.1l21.4 35.7c1.1.6 1.9 1 2.6 1.3zM232 208c0-35.3-28.7-64-64-64s-64 28.7-64 64 28.7 64 64 64c9.3 0 18.1-2 26.1-5.5.6-.3 1.5-.7 2.6-1.3l21.3-35.7c3.5-5.8 8.1-10.6 13.5-14.1.3-2.4.4-4.9.4-7.3zM12.7 176h64.8c5.3-14.9 14.1-28 25.4-38.5l-5.2-10.3c-4-7.9-.7-17.5 7.2-21.5s17.5-.7 21.5 7.2l3.5 7c4.6-2 9.3-3.6 14.2-4.9V96c0-8.8 7.2-16 16-16s16 7.2 16 16v16.3c4.4.4 8.7 1 13 2l4.7-9.5c4-7.9 13.6-11.1 21.5-7.2s11.1 13.6 7.2 21.5l-3.6 7.3c16.4 10.2 29.5 25.3 37.3 43.1 7.8-17.9 20.9-32.9 37.3-43.1l-3.6-7.3c-4-7.9-.7-17.5 7.2-21.5s17.5-.7 21.5 7.2l4.7 9.5c4.2-.9 8.6-1.6 13-2V96c0-8.8 7.2-16 16-16s16 7.2 16 16v19c4.9 1.3 9.6 2.9 14.2 4.9l3.5-7c4-7.9 13.6-11.1 21.5-7.2s11.1 13.6 7.2 21.5l-5.2 10.3a97.52 97.52 0 0 1 25.4 38.5h64.7C465.7 73.8 369.4 0 256 0S46.3 73.8 12.7 176zM256 240c-4.3 0-8.3 2.3-10.5 6l-39.8 66.3-2.4 4-4.2 2.1-17.7 8.8c-3.4 1.7-5.5 5.1-5.5 8.8s2.1 7.2 5.5 8.8l53.1 26.5c13.5 6.8 29.4 6.8 42.9 0l53.1-26.5c3.4-1.7 5.5-5.1 5.5-8.8s-2.1-7.2-5.5-8.8l-17.7-8.8-4.2-2.1-2.4-4-39.7-66.3c-2.2-3.7-6.2-6-10.5-6zm-112-24a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm200-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FasFaceDizzy = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceDizzy",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm0-224a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM100.7 132.7c6.2-6.2 16.4-6.2 22.6 0l36.7 36.7 36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L182.6 192l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L160 214.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l36.7-36.7-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6zm192 0c6.2-6.2 16.4-6.2 22.6 0l36.7 36.7 36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L374.6 192l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L352 214.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l36.7-36.7-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6z"
        }
    ]
};

const FasFaceDotted = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceDotted",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M216 3.1c13-2 26.4-3.1 40-3.1s27 1.1 40 3.1c17.5 2.7 29.4 19.1 26.6 36.6S303.5 69.1 286 66.3c-9.7-1.5-19.7-2.3-30-2.3s-20.3.8-30.1 2.3c-17.5 2.7-33.8-9.2-36.6-26.6S198.5 5.9 216 3.1zm-65.8 52.8c10.4 14.3 7.2 34.3-7 44.7-16.3 11.9-30.7 26.2-42.5 42.5-10.4 14.3-30.4 17.4-44.7 7s-17.4-30.4-7-44.7c15.8-21.7 34.9-40.8 56.6-56.6 14.3-10.4 34.3-7.2 44.7 7zm211.6 0c10.4-14.3 30.4-17.4 44.7-7 21.7 15.8 40.8 34.9 56.6 56.6 10.4 14.3 7.2 34.3-7 44.7s-34.3 7.2-44.7-7c-11.9-16.3-26.2-30.7-42.5-42.5-14.3-10.4-17.4-30.4-7-44.7zm110.5 133.4c17.5-2.7 33.8 9.2 36.6 26.6 2.1 13.1 3.1 26.4 3.1 40s-1.1 27-3.1 40c-2.7 17.5-19.1 29.4-36.6 26.6s-29.4-19.1-26.6-36.6c1.5-9.8 2.3-19.8 2.3-30.1s-.8-20.3-2.3-30.1c-2.7-17.5 9.2-33.8 26.6-36.6zm-432.6 0c17.5 2.7 29.4 19.1 26.6 36.6-1.5 9.8-2.3 19.8-2.3 30.1s.8 20.3 2.3 30.1c2.7 17.5-9.2 33.8-26.6 36.6S5.9 313.5 3.1 296c-2-13-3.1-26.4-3.1-40s1.1-27 3.1-40c2.7-17.5 19.1-29.4 36.6-26.6zm16.2 172.5c14.3-10.4 34.3-7.2 44.7 7 11.9 16.3 26.2 30.7 42.5 42.5 14.3 10.4 17.4 30.4 7 44.7s-30.4 17.4-44.7 7c-21.7-15.8-40.8-34.9-56.6-56.6-10.4-14.3-7.2-34.3 7-44.7zm400.1 0c14.3 10.4 17.4 30.4 7 44.7-15.8 21.7-34.9 40.8-56.6 56.6-14.3 10.4-34.3 7.2-44.7-7s-7.2-34.3 7-44.7c16.3-11.9 30.7-26.2 42.5-42.5 10.4-14.3 30.4-17.4 44.7-7zM189.3 472.3c2.7-17.5 19.1-29.4 36.6-26.6 9.8 1.5 19.8 2.3 30.1 2.3s20.3-.8 30.1-2.3c17.5-2.7 33.8 9.2 36.6 26.6s-9.2 33.8-26.6 36.6c-13.1 2.1-26.4 3.1-40 3.1s-27-1.1-40-3.1c-17.5-2.7-29.4-19.1-26.6-36.6zM176.4 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm160 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM184 328h144c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
        }
    ]
};

const FasFaceDowncastSweat = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceDowncastSweat",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M35.2 126.3c4.1 1.1 8.4 1.7 12.8 1.7 26.5 0 48-21 48-47 0-5-1.8-11.3-4.6-18.1l-.9-2.1C81.6 40.6 64 15.9 54.5 3.3c-3.2-4.4-9.6-4.4-12.8 0C28.6 20.6 0 61 0 81c0 21.7 14.9 39.8 35.2 45.3zM256 0c-51.4 0-99.3 15.2-139.4 41.2 1.5 3.1 3 6.2 4.3 9.3 3.4 8 7.1 19 7.1 30.5 0 44.3-36.6 79-80 79-9.6 0-18.8-1.7-27.4-4.8C7.3 186.2 0 220.2 0 256c0 141.4 114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zm-60.1 410.7c-5.9 6.6-16 7.1-22.6 1.2s-7.1-16-1.2-22.6c16.1-17.9 44.2-37.3 83.9-37.3s67.8 19.4 83.9 37.3c5.9 6.6 5.4 16.7-1.2 22.6s-16.7 5.4-22.6-1.2c-11.7-13-31.6-26.7-60.1-26.7s-48.4 13.7-60.1 26.7zM96 272c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16zm208-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FasFaceDrooling = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceDrooling",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 477.8c76.5-44.3 128-127 128-221.8C512 114.6 397.4 0 256 0S0 114.6 0 256s114.6 256 256 256c33.9 0 66.4-6.6 96-18.6V370.9c-9.7 6.4-20.3 12.2-32 16.9V448c0 8.8-7.2 16-16 16s-16-7.2-16-16v-50.9c-10.1 1.9-20.8 2.9-32 2.9-67 0-113.8-36.7-140.5-70-5.5-6.9-4.4-17 2.5-22.5s17-4.4 22.5 2.5c22.8 28.5 61.3 58 115.5 58s92.7-29.5 115.5-58c5.5-6.9 15.6-8 22.5-2.5s8 15.6 2.5 22.5c-3.8 4.7-7.9 9.5-12.5 14.2v133.6zM158.6 189.6c-8.4 8-13.5 17.7-15.4 23.5-2.8 8.4-11.9 12.9-20.2 10.1s-12.9-11.9-10.1-20.2c3.4-10.2 11.1-24.6 23.8-36.5 12.8-12.3 31.2-22.5 55.3-22.5 8.8 0 16 7.2 16 16s-7.2 16-16 16c-14.3 0-25.2 5.8-33.4 13.6zm210.2 23.5c-1.9-5.8-7-15.4-15.4-23.5-8.2-7.8-19-13.6-33.4-13.6-8.8 0-16-7.2-16-16s7.2-16 16-16c24.1 0 42.5 10.2 55.4 22.4 12.6 12 20.4 26.3 23.8 36.5 2.8 8.4-1.7 17.4-10.1 20.2s-17.4-1.7-20.2-10.1z"
        }
    ]
};

const FasFaceExhaling = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceExhaling",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512c55.8 0 107.4-17.9 149.5-48.2-10.5-9.3-17.9-22.1-20.5-36.5l-42.2-12.7c-13.5-4-22.8-16.5-22.8-30.6s9.3-26.6 22.8-30.6l42.2-12.7c5.3-30 31.5-52.7 63-52.7h2.1c13.2-14.7 32.3-24 53.7-24 2.7 0 5.4.2 8.1.5.1-2.8.1-5.6.1-8.5C512 114.6 397.4 0 256 0S0 114.6 0 256s114.6 256 256 256zm-60.8-273.6c5.3-7.1 15.3-8.5 22.4-3.2s8.5 15.3 3.2 22.4c-30.4 40.5-91.2 40.5-121.6 0-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2c17.6 23.5 52.8 23.5 70.4 0zm121.6 0c17.6 23.5 52.8 23.5 70.4 0 5.3-7.1 15.3-8.5 22.4-3.2s8.5 15.3 3.2 22.4c-30.4 40.5-91.2 40.5-121.6 0-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2zM256 344a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm287.4-5.5c.1-.8.1-1.7.1-2.5 0-22.1-17.9-40-39.9-40-16.9 0-31.4 10.5-37.2 25.4-3.3-.9-6.9-1.4-10.5-1.4-22.1 0-39.9 17.9-39.9 40l-56.1 14.1c-4.6 1.1-7.8 5.2-7.8 9.9s3.2 8.8 7.8 9.9l56.9 14.2c-.5 2.5-.8 5.1-.8 7.8 0 22.1 17.9 40 39.9 40 4.9 0 9.6-.9 14-2.5 7.1 11.1 19.5 18.5 33.7 18.5 22.1 0 39.9-17.9 39.9-40 0-.8 0-1.7-.1-2.5 19-6.4 32.6-24.4 32.6-45.5s-13.6-39.1-32.6-45.5z"
        }
    ]
};

const FasFaceExplode = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceExplode",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 196.5c0 7.9 2.5 15.4 7 21.6-14.5-6.6-31.5-5.6-45.3 3l-17.3 10.8c-5.2 3.2-11.8 3.2-17 0L230.2 221c-13.8-8.6-30.8-9.6-45.3-3 4.5-6.2 7-13.7 7-21.6V192c0-17.7-14.3-32-32-32H120c-30.9 0-56-25.1-56-56s25.1-56 56-56c8.9 0 17.3 2.1 24.8 5.8C149.7 23.3 176.1 0 208 0c19.1 0 36.3 8.4 48 21.7C267.7 8.4 284.9 0 304 0c31.9 0 58.3 23.3 63.2 53.8 7.5-3.7 15.9-5.8 24.8-5.8 30.9 0 56 25.1 56 56s-25.1 56-56 56h-40c-17.7 0-32 14.3-32 32v4.5zM299 248c5.1-3 11.4-3 16.4 0 .1.1.2.1.3.2L333 259c15.6 9.7 35.3 9.7 50.9 0l17.3-10.8c5.2-3.2 11.8-3.2 17 0l20.7 12.9c12.8 8 28.6 9.5 42.7 4.1l30.4-11.7v2.5c0 141.4-114.6 256-256 256S0 397.4 0 256v-2.5l30.5 11.7c14.1 5.4 29.9 3.9 42.7-4.1l20.7-12.9c5.2-3.2 11.8-3.2 17 0l17.3 10.8c15.6 9.7 35.3 9.7 50.9 0l17.3-10.8c.1-.1.2-.1.3-.2 5.1-3 11.4-3 16.4 0 .1.1.2.1.3.2l17.2 10.8c15.6 9.7 35.3 9.7 50.9 0l17.3-10.8c.1-.1.2-.1.3-.2zm-90.6 88a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM192 437.3c0 5.9 4.8 10.7 10.7 10.7h106.6c5.9 0 10.7-4.8 10.7-10.7 0-29.5-23.9-53.3-53.3-53.3h-21.4c-29.5 0-53.3 23.9-53.3 53.3z"
        }
    ]
};

const FasFaceExpressionless = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceExpressionless",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-96-176h192c8.8 0 16 7.2 16 16s-7.2 16-16 16H160c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-32-128c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16zm176-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FasFaceEyesXmarks = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceEyesXmarks",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM123.3 132.7l36.7 36.7 36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L182.6 192l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L160 214.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l36.7-36.7-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zm192 0 36.7 36.7 36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L374.6 192l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L352 214.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l36.7-36.7-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zM256 304c44.2 0 80 35.8 80 80 0 8.8-7.2 16-16 16H192c-8.8 0-16-7.2-16-16 0-44.2 35.8-80 80-80z"
        }
    ]
};

const FasFaceFearful = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceFearful",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm0-192c44.2 0 80 35.8 80 80 0 8.8-7.2 16-16 16H192c-8.8 0-16-7.2-16-16 0-44.2 35.8-80 80-80zM96 224a64 64 0 1 1 128 0 64 64 0 1 1-128 0zm256-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm-176-48c-4.4 0-8.8.3-13 .9-21.2 2.8-40.6 12.4-56.1 26.8-6.5 6-16.6 5.7-22.6-.8s-5.7-16.6.8-22.6c20.1-18.7 45.5-31.5 73.7-35.2 5.6-.7 11.4-1.1 17.2-1.1 8.8 0 16 7.2 16 16s-7.2 16-16 16zm173 .9c-4.3-.6-8.6-.9-13-.9-8.8 0-16-7.2-16-16s7.2-16 16-16c5.8 0 11.6.4 17.2 1.1 28.2 3.7 53.7 16.4 73.7 35.2 6.5 6 6.8 16.2.8 22.6s-16.2 6.8-22.6.8c-15.5-14.5-34.8-24-56.1-26.8zM192.4 224a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm160 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FasFaceFlushed = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceFlushed",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm176 128c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16s-7.2-16-16-16H192c-8.8 0-16 7.2-16 16zm-16-88a72 72 0 1 0 0-144 72 72 0 1 0 0 144zm264-72a72 72 0 1 0-144 0 72 72 0 1 0 144 0zm-288 0a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm192 0a24 24 0 1 1 48 0 24 24 0 1 1-48 0z"
        }
    ]
};

const FasFaceFrownOpen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceFrownOpen",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-79.6-336a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm-122 174.5c-12.4 5.2-26.5-4.1-21.1-16.4 16-36.6 52.4-62.1 94.8-62.1s78.8 25.6 94.8 62.1c5.4 12.3-8.7 21.6-21.1 16.4-22.4-9.5-47.4-14.8-73.7-14.8s-51.3 5.3-73.7 14.8z"
        }
    ]
};

const FasFaceFrownSlight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceFrownSlight",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm91.9-117.5C330 373.8 299.4 352 256 352s-74 21.8-91.9 42.5c-5.8 6.7-15.9 7.4-22.6 1.6s-7.4-15.9-1.6-22.6c22.2-25.7 61-53.5 116.1-53.5s93.8 27.9 116.1 53.5c5.8 6.7 5.1 16.8-1.6 22.6s-16.8 5.1-22.6-1.6zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FasFaceFrown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceFrown",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-96.7-123.3c-2.6 8.4-11.6 13.2-20 10.5s-13.2-11.6-10.5-20C145.2 326.1 196.3 288 256 288s110.8 38.1 127.3 91.3c2.6 8.4-2.1 17.4-10.5 20s-17.4-2.1-20-10.5C340.5 349.4 302.1 320 256 320s-84.5 29.4-96.7 68.7zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FasFaceGlasses = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceGlasses",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 256c0 141.4-114.6 256-256 256S0 397.4 0 256c0-22.1 2.8-43.5 8.1-64H48v56c0 30.9 25.1 56 56 56h80c30.9 0 56-25.1 56-56v-56h32v56c0 30.9 25.1 56 56 56h80c30.9 0 56-25.1 56-56v-56h39.9c5.3 20.5 8.1 41.9 8.1 64zM256 0c107.4 0 199.4 66.2 237.4 160h-34.8c-9-18.9-28.3-32-50.6-32h-80c-22.3 0-41.6 13.1-50.6 32h-42.8c-9-18.9-28.3-32-50.6-32h-80c-22.3 0-41.6 13.1-50.6 32H18.6C56.6 66.2 148.6 0 256 0zM80 192v-8c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24v64c0 13.3-10.7 24-24 24h-80c-13.3 0-24-10.7-24-24v-56zm61.5 147.9c-6.7 5.8-7.4 15.9-1.6 22.6 22.2 25.7 61 53.5 116.1 53.5s93.8-27.9 116.1-53.5c5.8-6.7 5.1-16.8-1.6-22.6s-16.8-5.1-22.6 1.6C330 362.2 299.4 384 256 384s-74-21.8-91.9-42.5c-5.8-6.7-15.9-7.4-22.6-1.6zM304 184c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24v64c0 13.3-10.7 24-24 24h-80c-13.3 0-24-10.7-24-24v-64zm-119.6 40a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm168 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FasFaceGrimace = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceGrimace",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm96-112h-8v-40h55.3c-3.8 22.7-23.6 40-47.3 40zm47.3-56H344v-40h8c23.8 0 43.5 17.3 47.3 40zm-71.3 0h-64v-40h64v40zm0 56h-64v-40h64v40zm-80-96v40h-64v-40h64zm0 56v40h-64v-40h64zm-80-16h-55.3c3.8-22.7 23.6-40 47.3-40h8v40zm0 56h-8c-23.8 0-43.5-17.3-47.3-40H168v40zm-23.6-192a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FasFaceGrinBeamSweat = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceGrinBeamSweat",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M476.8 126.3c-4.1 1.1-8.4 1.7-12.8 1.7-26.5 0-48-21-48-47 0-5 1.8-11.3 4.6-18.1l.9-2.1c9-20.2 26.5-44.9 36-57.5 3.2-4.4 9.6-4.4 12.8 0C483.4 20.6 512 61 512 81c0 21.7-14.9 39.8-35.2 45.3zM256 0c51.4 0 99.3 15.2 139.4 41.2-1.5 3.1-3 6.2-4.3 9.3-3.4 8-7.1 19-7.1 30.5 0 44.3 36.6 79 80 79 9.6 0 18.8-1.7 27.4-4.8 13.3 30.9 20.6 65 20.6 100.8 0 141.4-114.6 256-256 256S0 397.4 0 256 114.6 0 256 0zm127.8 317.8C345.3 329.4 301.9 336 256 336s-89.3-6.6-127.8-18.2c-12.3-3.7-24.3 7-19.2 18.7 24.5 56.9 81.1 96.7 147 96.7s122.5-39.8 147-96.7c5.1-11.8-6.9-22.4-19.2-18.7zm-166.2-89c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2c-9.9 13.2-16.6 30.9-16.6 48.8 0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l.2-.2c.2-.2.4-.5.7-.9.6-.8 1.6-2 2.8-3.4 2.5-2.8 6-6.6 10.2-10.3 8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3 1.2 1.4 2.2 2.6 2.8 3.4.3.4.6.7.7.9l.2.2zm160 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2c-9.9 13.2-16.6 30.9-16.6 48.8 0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l.2-.2c.2-.2.4-.5.7-.9.6-.8 1.6-2 2.8-3.4 2.5-2.8 6-6.6 10.2-10.3 8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3 1.2 1.4 2.2 2.6 2.8 3.4.3.4.6.7.7.9l.2.2z"
        }
    ]
};

const FasFaceGrinBeam = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceGrinBeam",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm132.1-199.2c12.3-3.8 24.3 6.9 19.3 18.7-25 59.1-83.2 100.5-151.1 100.5s-126.2-41.4-151.1-100.5c-5-11.8 7-22.5 19.3-18.7 39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19zm-170.5-84-.2-.2c-.2-.2-.4-.5-.7-.9-.6-.8-1.6-2-2.8-3.4-2.5-2.8-6-6.6-10.2-10.3-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3-1.2 1.4-2.2 2.6-2.8 3.4-.3.4-.6.7-.7.9l-.2.2c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8 9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8 0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8zm160 0-.2-.2c-.2-.2-.4-.5-.7-.9-.6-.8-1.6-2-2.8-3.4-2.5-2.8-6-6.6-10.2-10.3-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3-1.2 1.4-2.2 2.6-2.8 3.4-.3.4-.6.7-.7.9l-.2.2c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8 9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8 0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8z"
        }
    ]
};

const FasFaceGrinHearts = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceGrinHearts",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm132.1-199.2c12.3-3.8 24.3 6.9 19.3 18.7-25 59.1-83.2 100.5-151.1 100.5s-126.2-41.4-151.1-100.5c-5-11.8 7-22.5 19.3-18.7 39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19zM199.3 129.1c17.8 4.8 28.4 23.1 23.6 40.8l-17.4 65c-2.3 8.5-11.1 13.6-19.6 11.3l-65.1-17.4C103 224 92.4 205.7 97.2 188s23.1-28.4 40.8-23.6l16.1 4.3 4.3-16.1c4.8-17.8 23.1-28.4 40.8-23.6zm154.3 23.6 4.3 16.1 16.1-4.3c17.8-4.8 36.1 5.8 40.8 23.6s-5.8 36.1-23.6 40.8l-65.1 17.4c-8.5 2.3-17.3-2.8-19.6-11.3l-17.4-65c-4.8-17.8 5.8-36.1 23.6-40.8s36.1 5.8 40.9 23.6z"
        }
    ]
};

const FasFaceGrinSquintTears = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceGrinSquintTears",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M426.8 14.2c19.2-19.2 50.7-18.8 70.3.7s20 51 .7 70.3c-6.8 6.8-21.4 12.4-37.4 16.7-16.3 4.4-34.1 7.5-46.3 9.3-1.6.2-3.1.5-4.6.6-4.9.8-9.1-2.8-9.5-7.4-.1-.7 0-1.4.1-2.1 1.6-11.2 4.6-29.6 9-47 .3-1.3.7-2.6 1-3.9 4.3-15.9 9.8-30.5 16.7-37.4zm-44.7 19c-1.5 4.8-2.9 9.6-4.1 14.3-4.8 18.9-8 38.5-9.7 50.3-4 26.8 18.9 49.7 45.7 45.8 11.9-1.6 31.5-4.8 50.4-9.7 4.7-1.2 9.5-2.5 14.3-4.1 55.5 97.7 41.5 224-41.7 307.2-83.2 83.2-209.5 97.2-307.2 41.8 1.5-4.8 2.8-9.6 4-14.3 4.8-18.9 8-38.5 9.7-50.3 4-26.8-18.9-49.7-45.7-45.8-11.9 1.6-31.5 4.8-50.4 9.7-4.7 1.2-9.5 2.5-14.3 4.1C-22.2 284.5-8.2 158.2 75 75c83.2-83.3 209.5-97.2 307.2-41.8zM51.5 410.1c18.5-5 38.8-8.3 50.9-10 .4-.1.7-.1 1-.1 5.1-.2 9.2 4.3 8.4 9.6-1.7 12.1-5 32.4-10 50.9-4.2 15.9-9.8 30.5-16.6 37.3-19.2 19.2-50.7 18.8-70.3-.7s-20-51-.7-70.3c6.8-6.8 21.4-12.4 37.4-16.7zM416.9 209c-4.7-11.9-20.8-11-26.8.3-19 35.5-45 70.8-77.5 103.3s-67.8 58.5-103.3 77.4c-11.3 6-12.2 22.1-.3 26.8 57.6 22.9 125.8 11 172.3-35.5s58.4-114.8 35.5-172.3zM87.1 285.1c2 2 4.6 3.2 7.3 3.4l56.1 5.1 5.1 56.1c.3 2.8 1.5 5.4 3.4 7.3 6.3 6.3 17.2 3.6 19.8-4.9l29.7-97.4c3.5-11.6-7.3-22.5-19-19L92 265.3c-8.6 2.6-11.3 13.4-4.9 19.8zM265.3 92l-29.7 97.4c-3.5 11.6 7.3 22.5 19 19l97.4-29.7c8.6-2.6 11.3-13.4 4.9-19.8-2-2-4.6-3.2-7.3-3.4l-56.1-5.1-5.1-56.1c-.3-2.8-1.5-5.4-3.4-7.3-6.3-6.3-17.2-3.6-19.8 4.9z"
        }
    ]
};

const FasFaceGrinSquint = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceGrinSquint",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm132.1-199.2c12.3-3.8 24.3 6.9 19.3 18.7-25 59.1-83.2 100.5-151.1 100.5s-126.2-41.4-151.1-100.5c-5-11.8 7-22.5 19.3-18.7 39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19zM133.5 146.7l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5 0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6 0-9 9.6-14.7 17.5-10.5zM396 157.1c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6 0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5z"
        }
    ]
};

const FasFaceGrinStars = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceGrinStars",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm407.4 75.5c5-11.8-7-22.5-19.3-18.7-39.7 12.2-84.5 19-131.8 19s-92.1-6.8-131.8-19c-12.3-3.8-24.3 6.9-19.3 18.7 25 59.1 83.2 100.5 151.1 100.5s126.2-41.4 151.1-100.5zM160 120c-3.1 0-5.9 1.8-7.2 4.6l-16.6 34.7-38.1 5c-3.1.4-5.6 2.5-6.6 5.5s-.1 6.2 2.1 8.3l27.9 26.5-7 37.8c-.6 3 .7 6.1 3.2 7.9s5.8 2 8.5.6l33.8-18.4 33.8 18.3c2.7 1.5 6 1.3 8.5-.6s3.7-4.9 3.2-7.9l-7-37.8 27.9-26.5c2.2-2.1 3.1-5.3 2.1-8.3s-3.5-5.1-6.6-5.5l-38.1-5-16.6-34.7c-1.3-2.8-4.1-4.6-7.2-4.6zm192 0c-3.1 0-5.9 1.8-7.2 4.6l-16.6 34.7-38.1 5c-3.1.4-5.6 2.5-6.6 5.5s-.1 6.2 2.1 8.3l27.9 26.5-7 37.8c-.6 3 .7 6.1 3.2 7.9s5.8 2 8.5.6l33.8-18.4 33.8 18.3c2.7 1.5 6 1.3 8.5-.6s3.7-4.9 3.2-7.9l-7-37.8 27.9-26.5c2.2-2.1 3.1-5.3 2.1-8.3s-3.5-5.1-6.6-5.5l-38.1-5-16.6-34.7c-1.3-2.8-4.1-4.6-7.2-4.6z"
        }
    ]
};

const FasFaceGrinTears = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceGrinTears",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M548.6 371.4C506.4 454.8 419.9 512 320 512S133.6 454.8 91.4 371.4c4.5-2.9 8.7-6.3 12.7-10.3 8.1-8.1 13.2-18.6 16.5-26.6 3.6-8.8 6.5-18.4 8.8-27.5 4.6-18.2 7.7-37 9.3-48.2 3.9-26.5-18.8-49.2-45.2-45.4-6.8.9-16.2 2.4-26.6 4.4C85.3 94.5 191.6 0 320 0s234.7 94.5 253.2 217.7c-10.3-2-19.8-3.5-26.6-4.4-26.5-3.9-49.2 18.8-45.2 45.4 1.6 11.3 4.6 30 9.3 48.2 2.3 9.1 5.2 18.8 8.8 27.5 3.3 8.1 8.4 18.5 16.5 26.6 3.9 3.9 8.2 7.4 12.7 10.3zM107 254.1c-3.1 21.5-11.4 70.2-25.5 84.4-.9 1-1.9 1.8-2.9 2.7-18.6 15.5-46.6 14.3-64.3-3.5-18.7-18.7-19.1-48.8-.7-67.2 8.6-8.6 30.1-15.1 50.5-19.6 13-2.8 25.5-4.8 33.9-6 5.4-.8 9.9 3.7 9 9zm454.5 87.1c-.8-.6-1.5-1.3-2.3-2-.2-.2-.5-.4-.7-.7-14.1-14.1-22.5-62.9-25.5-84.4-.8-5.4 3.7-9.9 9-9 1 .1 2.2.3 3.3.5 8.2 1.2 19.2 3 30.6 5.5 20.4 4.4 41.9 10.9 50.5 19.6 18.4 18.4 18 48.5-.7 67.2-17.7 17.7-45.7 19-64.2 3.4zm-90.1-9.7c5-11.8-7-22.5-19.3-18.7-39.7 12.2-84.4 19-131.8 19s-92.1-6.8-131.8-19c-12.3-3.8-24.3 6.9-19.3 18.7 25 59.1 83.2 100.5 151.1 100.5s126.2-41.4 151.1-100.5zM281.6 228.8c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2c-9.9 13.2-16.6 30.9-16.6 48.8 0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l.2-.2c.2-.2.4-.5.7-.9.6-.8 1.6-2 2.8-3.4 2.5-2.8 6-6.6 10.2-10.3 8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3 1.2 1.4 2.2 2.6 2.8 3.4.3.4.6.7.7.9l.2.2zm160 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2c-9.9 13.2-16.6 30.9-16.6 48.8 0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l.2-.2c.2-.2.4-.5.7-.9.6-.8 1.6-2 2.8-3.4 2.5-2.8 6-6.6 10.2-10.3 8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3 1.2 1.4 2.2 2.6 2.8 3.4.3.4.6.7.7.9l.2.2z"
        }
    ]
};

const FasFaceGrinTongueSquint = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceGrinTongueSquint",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 256c0 112.9 73.1 208.7 174.5 242.8C165.3 484 160 466.6 160 448v-47.3c-24-17.5-43.1-41.4-54.8-69.2-5-11.8 7-22.5 19.3-18.7 39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19c12.3-3.8 24.3 6.9 19.3 18.7-11.8 28-31.1 52-55.4 69.6V448c0 18.6-5.3 36-14.5 50.8C438.9 464.7 512 368.9 512 256 512 114.6 397.4 0 256 0S0 114.6 0 256zm116-114.9c0-9 9.6-14.7 17.5-10.5l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5 0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6zm262.5-10.5c7.9-4.2 17.5 1.5 17.5 10.5 0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6 0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9zM320 448v-45.4c0-14.7-11.9-26.6-26.6-26.6h-2c-11.3 0-21.1 7.9-23.6 18.9-2.8 12.6-20.8 12.6-23.6 0-2.5-11.1-12.3-18.9-23.6-18.9h-2c-14.7 0-26.6 11.9-26.6 26.6V448c0 35.3 28.7 64 64 64s64-28.7 64-64z"
        }
    ]
};

const FasFaceGrinTongueWink = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceGrinTongueWink",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M174.5 498.8C73.1 464.7 0 368.9 0 256 0 114.6 114.6 0 256 0s256 114.6 256 256c0 112.9-73.1 208.7-174.5 242.8C346.7 484 352 466.6 352 448v-46.9c24.3-17.5 43.6-41.6 55.4-69.6 5-11.8-7-22.5-19.3-18.7-39.7 12.2-84.5 19-131.8 19s-92.1-6.8-131.8-19c-12.3-3.8-24.3 6.9-19.3 18.7 11.7 27.8 30.8 51.7 54.8 69.2V448c0 18.6 5.3 36 14.5 50.8zm20.7-265.2c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2c17.6-23.5 52.8-23.5 70.4 0zM336 272a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-16 130.6V448c0 35.3-28.7 64-64 64s-64-28.7-64-64v-45.4c0-14.7 11.9-26.6 26.6-26.6h2c11.3 0 21.1 7.9 23.6 18.9 2.8 12.6 20.8 12.6 23.6 0 2.5-11.1 12.3-18.9 23.6-18.9h2c14.7 0 26.6 11.9 26.6 26.6zM336 184a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FasFaceGrinTongue = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceGrinTongue",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 256c0 112.9 73.1 208.7 174.5 242.8C165.3 484 160 466.6 160 448v-47.3c-24-17.5-43.1-41.4-54.8-69.2-5-11.8 7-22.5 19.3-18.7 39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19c12.3-3.8 24.3 6.9 19.3 18.7-11.8 28-31.1 52-55.4 69.6V448c0 18.6-5.3 36-14.5 50.8C438.9 464.7 512 368.9 512 256 512 114.6 397.4 0 256 0S0 114.6 0 256zm176.4-80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1-64 0zM320 448v-45.4c0-14.7-11.9-26.6-26.6-26.6h-2c-11.3 0-21.1 7.9-23.6 18.9-2.8 12.6-20.8 12.6-23.6 0-2.5-11.1-12.3-18.9-23.6-18.9h-2c-14.7 0-26.6 11.9-26.6 26.6V448c0 35.3 28.7 64 64 64s64-28.7 64-64z"
        }
    ]
};

const FasFaceGrinWide = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceGrinWide",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm132.1-199.2c12.3-3.8 24.3 6.9 19.3 18.7-25 59.1-83.2 100.5-151.1 100.5s-126.2-41.4-151.1-100.5c-5-11.8 7-22.5 19.3-18.7 39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19zM208 192c0 35.3-14.3 64-32 64s-32-28.7-32-64 14.3-64 32-64 32 28.7 32 64zm128 64c-17.7 0-32-28.7-32-64s14.3-64 32-64 32 28.7 32 64-14.3 64-32 64z"
        }
    ]
};

const FasFaceGrinWink = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceGrinWink",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm132.1-199.2c12.3-3.8 24.3 6.9 19.3 18.7-25 59.1-83.2 100.5-151.1 100.5s-126.2-41.4-151.1-100.5c-5-11.8 7-22.5 19.3-18.7 39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19zm-16.9-79.2c-17.6-23.5-52.8-23.5-70.4 0-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0 5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2zM176.4 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FasFaceGrin = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceGrin",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm132.1-199.2c12.3-3.8 24.3 6.9 19.3 18.7-25 59.1-83.2 100.5-151.1 100.5s-126.2-41.4-151.1-100.5c-5-11.8 7-22.5 19.3-18.7 39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FasFaceHandOverMouth = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceHandOverMouth",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 256c0 113.1-73.3 209.1-175.1 242.9l49-49c18.1-18.1 18.7-47.1 1.8-65.9 16.9-18.8 16.3-47.8-1.8-65.9-1-1-2.1-2-3.2-3 3.7-15.7-.5-32.8-12.8-45s-29.4-16.5-45-12.8c-.9-1.1-1.9-2.2-3-3.2-18.7-18.7-49.1-18.7-67.9 0l-47 47c-9.4-13.7-25.1-22.7-43-22.7-28.7 0-52 23.3-52 52v86.4c0 21.9 5.5 42.5 15.3 60.5C51.2 433 0 350.5 0 256 0 114.6 114.6 0 256 0s256 114.6 256 256zm-303.6-64a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-37.1 52.7c6.2 6.2 6.2 16.4 0 22.6L248 350.6c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l67.3-67.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L280 382.6c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l51.3-51.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L312 414.6c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l19.3-19.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-56.8 56.8C288.7 502 264.4 512 239.2 512c-52.6 0-95.2-42.6-95.2-95.2v-86.4c0-11 9-20 20-20s20 9 20 20v19.7c0 7.1 8.6 10.7 13.7 5.7l79-79c6.2-6.2 16.4-6.2 22.6 0z"
        }
    ]
};

const FasFaceHandPeeking = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceHandPeeking",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M497.8 144.3c12.9-12.9 31.8-16.1 47.7-9.6C502.2 54.5 417.5 0 320 0c-71.5 0-136.2 29.3-182.7 76.6 7.7 1.8 14.9 5.7 20.9 11.7 17.2 17.2 17.2 45 0 62.2l-1.5 1.5H232c22.1 0 40 17.9 40 40 0 2.6-.2 5.1-.7 7.5 10.1 7.3 16.7 19.1 16.7 32.5s-6.6 25.3-16.7 32.5c.5 2.4.7 4.9.7 7.5 0 22.1-17.9 40-40 40h-8v.9c0 22.1-17.9 40-40 40h-64.8c-13.3 0-26.4-2.2-38.8-6.5C117 443.2 210.4 512 320 512c91.5 0 171.8-48 217.1-120.2-5.4.7-10.8 1.1-16.3 1.1H456c-22.1 0-40-17.9-40-40v-.9h-8c-22.1 0-40-17.9-40-40 0-1.1 0-2.2.1-3.3-37-10.4-64.1-44.4-64.1-84.7 0-48.6 39.4-88 88-88 6.6 0 13 .7 19.2 2.1 11.8-4 25.2-2.4 36.1 5.4l37.9 27.1c1.1-9.6 5.3-18.9 12.6-26.2zM320 448c-35.3 0-64-21.5-64-48s28.7-48 64-48 64 21.5 64 48-28.7 48-64 48zm90.3-208c3.8-4.2 6.1-9.9 6.1-16 0-13.3-10.7-24-24-24s-24 10.7-24 24c0 6.1 2.3 11.8 6.1 16h35.8zM248 192c0-8.8-7.2-16-16-16H118.2c-7.1 0-10.7-8.6-5.7-13.7l28.8-28.8c7.8-7.8 7.8-20.5 0-28.3s-20.5-7.8-28.3 0l-61.1 61.2-.8.8c-36.4 37.2-36.1 96.9.8 133.8 17.9 17.9 42.1 27.9 67.3 27.9H184c8.8 0 16-7.2 16-16s-7.2-16-16-16h-14c-2.5 0-4.5-2-4.5-4.5s2-4.5 4.5-4.5h62c8.8 0 16-7.2 16-16s-7.2-16-16-16h-62.4c-2.2 0-4-1.8-4-4s1.8-4 4-4H248c8.8 0 16-7.2 16-16s-7.2-16-16-16h-78.4c-2.2 0-4-1.8-4-4s1.8-4 4-4H232c8.8 0 16-7.2 16-16zm163-25.3c-5.1 7.2-3.5 17.2 3.7 22.3l59.7 42.6c3.5 2.5 5.6 6.6 5.6 10.9 0 7.4-6 13.4-13.4 13.4l-74.6.1c-8.8 0-16 7.2-16 16s7.2 16 16 16h84c2.2 0 4 1.8 4 4s-1.8 4-4 4h-68c-8.8 0-16 7.2-16 16s7.2 16 16 16h67.5c2.5 0 4.5 2 4.5 4.5s-2 4.5-4.5 4.5H456c-8.8 0-16 7.2-16 16s7.2 16 16 16h64.8c25.2 0 49.5-10 67.3-27.9 36.9-36.9 37.2-96.6.8-133.8l-.8-.8-45.1-45.2c-7.8-7.8-20.5-7.8-28.3 0s-7.8 20.5 0 28.3l14.8 14.8c6.6 6.6 2.7 18-6.6 19-2.8.3-5.6-.4-7.8-2L433.3 163c-7.2-5.1-17.2-3.5-22.3 3.7z"
        }
    ]
};

const FasFaceHandYawn = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceHandYawn",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M336.9 498.9C438.7 465.1 512 369.1 512 256 512 114.6 397.4 0 256 0S0 114.6 0 256c0 94.5 51.2 177 127.3 221.4-9.8-18-15.3-38.6-15.3-60.5v-86.5c0-28.7 23.3-52 52-52 1.8 0 3.6.1 5.3.3 15.5-32.4 48.5-54.7 86.7-54.7 28.7 0 54.5 12.6 72.1 32.6 14.8-2.4 30.4 2 41.8 13.4 12.2 12.2 16.5 29.4 12.8 45 1.1.9 2.2 1.9 3.2 3 18.1 18.1 18.7 47.1 1.8 65.9 16.9 18.8 16.3 47.8-1.8 65.9l-49 49zM204.5 102c5.5 6.9 4.4 17-2.5 22.5l-80 64c-6.9 5.5-17 4.4-22.5-2.5s-4.4-17 2.5-22.5l80-64c6.9-5.5 17-4.4 22.5 2.5zM310 124.5c-6.9-5.5-8-15.6-2.5-22.5s15.6-8 22.5-2.5l80 64c6.9 5.5 8 15.6 2.5 22.5s-15.6 8-22.5 2.5l-80-64zm-10.7 152.2c-6.2-6.2-16.4-6.2-22.6 0l-79 79c-5 5-13.7 1.5-13.7-5.7v-19.6c0-11-9-20-20-20s-20 9-20 20v86.4c0 52.6 42.6 95.2 95.2 95.2 25.2 0 49.5-10 67.3-27.9l56.8-56.8c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L321.4 424c-2.6 2.6-6.8 2.6-9.4 0s-2.6-6.8 0-9.4l51.3-51.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L289.4 392c-2.6 2.6-6.8 2.6-9.4 0s-2.6-6.8 0-9.4l67.3-67.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L257.4 360c-2.6 2.6-6.8 2.6-9.4 0s-2.6-6.8 0-9.4l51.3-51.3c6.2-6.2 6.2-16.4 0-22.6z"
        }
    ]
};

const FasFaceHeadBandage = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceHeadBandage",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 0C213.6 0 146.6 31.8 99.8 82.4c-12.5 2.5-25 5.2-37.3 8.2-8.2 2-15.3 7.1-19.7 14.3-15.9 25.7-27.8 54-35 84.1-2.4 10.2.3 20.9 7.2 28.7-2.5 2.8-4.9 5.6-7.3 8.5C3 231.7.4 238.6.1 245.8c0 3.4-.1 6.8-.1 10.2 0 31.4 5 61.7 14.4 90.1 3.8 11.6 13.9 20 26 21.7 5.6.8 11.2 0 16.3-2C97.8 452.2 185.9 512 288 512c141.4 0 256-114.6 256-256 0-9.5-.5-18.8-1.5-28 6.1-1.1 11.9-3.9 16.5-8.3 8.3-7.9 11.8-19.6 9.2-30.7-7.2-30.1-19.1-58.4-34.9-84.1-3.3-5.3-8-9.5-13.5-12.1-.6-6-2.9-11.9-6.9-16.8-21.2-26.5-47-49.1-76.2-66.8-6.1-3.7-13.4-5.2-20.5-4.4-16.2 2-32.2 4.6-48.1 7.9C342.9 4.5 316 0 288 0zm-68.8 98.5c22.7-1.7 45.7-2.5 68.8-2.5 40 0 79.3 2.5 118 7.4l6.6.9c31.7 4.3 62.9 10.1 93.5 17.5.1.2.2.3.3.5 7.3 11.9 13.7 24.4 19 37.5 4.8 11.8 8.7 24.1 11.7 36.7-11.9-3.6-23.9-6.9-36-10-59.4-15.1-121.2-24-184.8-26h-.8c-9.1-.3-18.3-.4-27.5-.4-17.1 0-34.1.5-51 1.5-48.2 2.8-95.4 9.6-141.2 20-7 1.6-13.9 3.3-20.9 5-12.1 3.1-24.1 6.4-36 10l1.5-6c2.8-10.5 6.2-20.8 10.2-30.7 5.4-13.3 11.8-26 19.3-38 23.2-5.6 46.8-10.3 70.7-14.1.8-.1 1.6-.3 2.5-.4 25-3.9 50.4-6.9 76.1-8.7zM50.3 226.4c41-12.2 83.3-21.3 126.6-27.1-40.6 29.4-77 64.4-108 103.7-8.5 10.7-16.5 21.7-24.2 33.1-4.4-13.3-7.7-27.1-9.9-41.3C33 282.1 32 269.2 32 256c0-3 .1-6.1.2-9.1 5.9-7 12-13.8 18.2-20.5zm126 13.6c13.5-10.8 27.6-20.9 42.1-30.4 12.7 4.2 21.9 16.2 21.9 30.4 0 17.7-14.3 32-32 32s-32-14.3-32-32zM476.2 82.4c-56.9-11.3-115.6-17.5-175.6-18.3 38.3-13 78.3-22.2 119.5-27.4 13.7 8.3 26.6 17.9 38.5 28.5 6.1 5.5 11.9 11.2 17.5 17.2zm-103 315.1C356.4 382.2 330.8 368 296 368c-13.1 0-24.8 2-35.2 5.3-8.4 2.7-17.4-2-20.1-10.5s2-17.4 10.5-20.1c13.4-4.2 28.4-6.8 44.8-6.8 44.2 0 77.2 18.3 98.8 37.9 6.5 5.9 7 16.1 1.1 22.6s-16.1 7-22.6 1.1zM368.4 208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FasFaceHoldingBackTears = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceHoldingBackTears",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm344.5 111.9c-6.7-5.8-16.8-5.1-22.6 1.6C309 384.4 287.1 400 256 400s-53-15.6-65.9-30.5c-5.8-6.7-15.9-7.4-22.6-1.6s-7.4 15.9-1.6 22.6c17.2 19.8 47.3 41.5 90.1 41.5s72.9-21.7 90.1-41.5c5.8-6.7 5.1-16.8-1.6-22.6zM240 272v-32c0-41.5-31.5-75.6-72-79.6 10-10.8 17.6-24.1 21.9-38.8l1.5-5.2c2.4-8.5-2.5-17.4-11-19.8s-17.4 2.5-19.8 11l-1.5 5.2c-7 24.7-28.1 42.7-53.6 45.9L94 160.1c-8.8 1.1-15 9.1-13.9 17.9 1 8.1 7.9 14 15.9 14-10 13.4-16 30-16 48s6 34.6 16 48v32c0 8.8 7.2 16 16 16s16-7.2 16-16v-6.7c9.8 4.3 20.6 6.7 32 6.7 18 0 34.6-6 48-16 0 8.8 7.2 16 16 16s16-7.2 16-16v-32zm144 41.3v6.7c0 8.8 7.2 16 16 16s16-7.2 16-16v-32c10-13.4 16-30 16-48s-6-34.6-16-48c8 0 14.9-5.9 15.9-14 1.1-8.8-5.1-16.8-13.9-17.9l-11.5-1.4c-25.5-3.2-46.6-21.3-53.6-45.9l-1.5-5.2c-2.4-8.5-11.3-13.4-19.8-11s-13.4 11.3-11 19.8l1.5 5.2c4.2 14.8 11.8 28 21.9 38.8-40.4 4-72 38.1-72 79.6 0 44.2 35.8 80 80 80 11.4 0 22.2-2.4 32-6.7zM128 232c17.7 0 32-14.3 32-32 0-5.8-1.5-11.2-4.2-15.8 1.4-.1 2.8-.2 4.2-.2 30.9 0 56 25.1 56 56s-25.1 56-56 56-56-25.1-56-56c0-5.7.8-11.2 2.4-16.4 5.7 5.2 13.3 8.4 21.6 8.4zm224-32c0-5.8-1.5-11.2-4.2-15.8 1.4-.1 2.8-.2 4.2-.2 30.9 0 56 25.1 56 56s-25.1 56-56 56-56-25.1-56-56c0-5.7.8-11.2 2.4-16.4 5.7 5.2 13.3 8.4 21.6 8.4 17.7 0 32-14.3 32-32z"
        }
    ]
};

const FasFaceHushed = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceHushed",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-79.6-288a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1-64 0zM179 160.9c-21.2 2.8-40.6 12.4-56.1 26.8-6.5 6-16.6 5.7-22.6-.8s-5.7-16.6.8-22.6c20.1-18.7 45.5-31.5 73.7-35.2 5.6-.7 11.4-1.1 17.2-1.1 8.8 0 16 7.2 16 16s-7.2 16-16 16c-4.4 0-8.8.3-13 .9zm141-.9c-8.8 0-16-7.2-16-16s7.2-16 16-16c5.8 0 11.6.4 17.2 1.1 28.2 3.7 53.7 16.4 73.7 35.2 6.5 6 6.8 16.2.8 22.6s-16.2 6.8-22.6.8c-15.5-14.5-34.8-24-56.1-26.8-4.3-.6-8.6-.9-13-.9zm-64 176a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
        }
    ]
};

const FasFaceIcicles = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceIcicles",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 256c0 8.3-.4 16.6-1.2 24.7 0 .5-.1 1.1-.1 1.6l-14.8 200c-1.2 16.8-15.1 29.7-31.9 29.7s-30.7-12.9-31.9-29.6l-2.8-37.9c-5 4.6-10.2 9-15.6 13.2l-11.5 32.9c-4.5 12.8-16.6 21.4-30.2 21.4-11.5 0-21.9-6.1-27.5-15.7-27.6 10.2-57.4 15.7-88.5 15.7-69.4 0-132.3-27.6-178.4-72.4-5.7 5.3-13.3 8.4-21.6 8.4-15.6 0-29-11.3-31.6-26.7L6.5 313.4C2.2 294.9 0 275.7 0 256 0 114.6 114.6 0 256 0s256 114.6 256 256zM56 415.8v.2-.2l20-120.2c2.1-12.3-7.4-23.6-20-23.6s-22.1 11.3-20.1 23.7L56 415.8zM344 400l28 80 28-80v-40h-56v40zm55.3-56c-3.8-22.7-23.6-40-47.3-40h-8v40h55.3zm-71.3 0v-40h-64v40h64zm0 56v-40h-64v40l32 48 32-48zm-80-96h-64v40h64v-40zm0 56h-64v40h64v-40zm-80-16v-40h-8c-23.8 0-43.5 17.3-47.3 40H168zm0 56v-40h-55.3c3.8 22.7 23.6 40 47.3 40h8zm40.4-192a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM464 480l21.8-232.1c1.2-12.8-8.9-23.9-21.8-23.9s-23 11.1-21.8 23.9L464 480z"
        }
    ]
};

const FasFaceKissBeam = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceKissBeam",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm48.7-198.3c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4-2.7 1.5-5.7 3-8.7 4.3 3.1 1.3 6 2.7 8.7 4.3 6.6 3.7 12.5 8.2 16.7 13.4 4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4-13.3 7.4-30.6 12.3-48 12.3-3.6 0-6.8-2.5-7.7-6s.6-7.2 3.8-9l.2-.1c.2-.1.5-.3.9-.5.8-.5 2-1.2 3.4-2.1 2.8-1.9 6.5-4.5 10.2-7.6 3.7-3.1 7.2-6.6 9.6-10.1 2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1-3.7-3.1-7.4-5.7-10.2-7.6-1.4-.9-2.6-1.6-3.4-2.1-.4-.2-.7-.4-.9-.5l-.2-.1c-2.5-1.4-4.1-4.1-4.1-7s1.6-5.6 4.1-7l.2-.1.3-.2.6-.4c.8-.5 2-1.2 3.4-2.1 2.8-1.9 6.5-4.5 10.2-7.6 3.7-3.1 7.2-6.6 9.6-10.1 2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1-3.7-3.1-7.4-5.7-10.2-7.6-1.4-.9-2.6-1.6-3.4-2.1l-.4-.3-.5-.3-.2-.1c-3.2-1.8-4.7-5.5-3.8-9s4.1-6 7.7-6c17.4 0 34.7 4.9 47.9 12.3 6.6 3.7 12.5 8.2 16.7 13.4zm-87.1-84.9-.2-.2c-.2-.2-.4-.5-.7-.9-.6-.8-1.6-2-2.8-3.4-2.5-2.8-6-6.6-10.2-10.3-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3-1.2 1.4-2.2 2.6-2.8 3.4-.3.4-.6.7-.7.9l-.2.2c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8 9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8 0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8zm160 0-.2-.2c-.2-.2-.4-.5-.7-.9-.6-.8-1.6-2-2.8-3.4-2.5-2.8-6-6.6-10.2-10.3-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3-1.2 1.4-2.2 2.6-2.8 3.4-.3.4-.6.7-.7.9l-.2.2c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8 9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8 0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8z"
        }
    ]
};

const FasFaceKissClosedEyes = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceKissClosedEyes",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm48.7-198.3c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4-2.7 1.5-5.7 3-8.7 4.3 3.1 1.3 6 2.7 8.7 4.3 6.6 3.7 12.5 8.2 16.7 13.4 4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4-13.3 7.4-30.6 12.3-48 12.3-3.6 0-6.8-2.5-7.7-6s.6-7.2 3.8-9l.2-.1c.2-.1.5-.3.9-.5.8-.5 2-1.2 3.4-2.1 2.8-1.9 6.5-4.5 10.2-7.6 3.7-3.1 7.2-6.6 9.6-10.1 2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1-3.7-3.1-7.4-5.7-10.2-7.6-1.4-.9-2.6-1.6-3.4-2.1-.4-.2-.7-.4-.9-.5l-.2-.1c-2.5-1.4-4.1-4.1-4.1-7s1.6-5.6 4.1-7l.2-.1.3-.2.6-.4c.8-.5 2-1.2 3.4-2.1 2.8-1.9 6.5-4.5 10.2-7.6 3.7-3.1 7.2-6.6 9.6-10.1 2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1-3.7-3.1-7.4-5.7-10.2-7.6-1.4-.9-2.6-1.6-3.4-2.1l-.4-.3-.5-.3-.2-.1c-3.2-1.8-4.7-5.5-3.8-9s4.1-6 7.7-6c17.4 0 34.7 4.9 47.9 12.3 6.6 3.7 12.5 8.2 16.7 13.4zm-93.5-80.1c-17.6-23.5-52.8-23.5-70.4 0-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0 5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2zm89.6 0c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0 5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2c-17.6-23.5-52.8-23.5-70.4 0z"
        }
    ]
};

const FasFaceKissWinkHeart = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceKissWinkHeart",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M498 339.7c9.1-26.2 14-54.4 14-83.7C512 114.6 397.4 0 256 0S0 114.6 0 256s114.6 256 256 256c35.4 0 69.1-7.2 99.7-20.2-4.8-5.5-8.5-12.2-10.4-19.7l-22.9-89.3c-10-39 11.8-80.9 51.8-92.1 37.2-10.4 73.8 10.1 87.5 44 12.7-1.6 25.1.4 36.2 5zM296 332c0 6.9-3.1 13.2-7.3 18.3-4.3 5.2-10.1 9.7-16.7 13.4-2.7 1.5-5.7 3-8.7 4.3 3.1 1.3 6 2.7 8.7 4.3 6.6 3.7 12.5 8.2 16.7 13.4 4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4-13.3 7.4-30.6 12.3-48 12.3-3.6 0-6.8-2.5-7.7-6s.6-7.2 3.8-9l.2-.1c.2-.1.5-.3.9-.5.8-.5 2-1.2 3.4-2.1 2.8-1.9 6.5-4.5 10.2-7.6 3.7-3.1 7.2-6.6 9.6-10.1 2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1-3.7-3.1-7.4-5.7-10.2-7.6-1.4-.9-2.6-1.6-3.4-2.1l-.6-.4-.3-.2-.2-.1c-2.5-1.4-4.1-4.1-4.1-7s1.6-5.6 4.1-7l.2-.1c.2-.1.5-.3.9-.5.8-.5 2-1.2 3.4-2.1 2.8-1.9 6.5-4.5 10.2-7.6 3.7-3.1 7.2-6.6 9.6-10.1 2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1-3.7-3.1-7.4-5.7-10.2-7.6-1.4-.9-2.6-1.6-3.4-2.1-.4-.2-.7-.4-.9-.5l-.2-.1c-3.2-1.8-4.7-5.5-3.8-9s4.1-6 7.7-6c17.4 0 34.7 4.9 47.9 12.3 6.6 3.7 12.5 8.2 16.7 13.4 4.3 5.1 7.3 11.4 7.3 18.3zM176.4 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm194.8 57.6c-17.6-23.5-52.8-23.5-70.4 0-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0 5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2zM434 352.3c-6-23.2-28.8-37-51.1-30.8s-35.4 30.1-29.5 53.4l22.9 89.3c2.2 8.7 11.2 13.9 19.8 11.4l84.9-23.8c22.2-6.2 35.4-30.1 29.5-53.4s-28.8-37-51.1-30.8l-20.2 5.6-5.4-21z"
        }
    ]
};

const FasFaceKiss = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceKiss",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm48.7-198.3c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4-2.7 1.5-5.7 3-8.7 4.3 3.1 1.3 6 2.7 8.7 4.3 6.6 3.7 12.5 8.2 16.7 13.4 4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4-13.3 7.4-30.6 12.3-48 12.3-3.6 0-6.8-2.5-7.7-6s.6-7.2 3.8-9l.2-.1c.2-.1.5-.3.9-.5.8-.5 2-1.2 3.4-2.1 2.8-1.9 6.5-4.5 10.2-7.6 3.7-3.1 7.2-6.6 9.6-10.1 2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1-3.7-3.1-7.4-5.7-10.2-7.6-1.4-.9-2.6-1.6-3.4-2.1-.4-.2-.7-.4-.9-.5l-.2-.1c-2.5-1.4-4.1-4.1-4.1-7s1.6-5.6 4.1-7l.2-.1.3-.2.6-.4c.8-.5 2-1.2 3.4-2.1 2.8-1.9 6.5-4.5 10.2-7.6 3.7-3.1 7.2-6.6 9.6-10.1 2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1-3.7-3.1-7.4-5.7-10.2-7.6-1.4-.9-2.6-1.6-3.4-2.1l-.4-.3-.5-.3-.2-.1c-3.2-1.8-4.7-5.5-3.8-9s4.1-6 7.7-6c17.4 0 34.7 4.9 47.9 12.3 6.6 3.7 12.5 8.2 16.7 13.4zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FasFaceLaughBeam = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceLaughBeam",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM96.8 314.1c-3.8-13.7 7.4-26.1 21.6-26.1h275.2c14.2 0 25.5 12.4 21.6 26.1C396.2 382 332.1 432 256 432S115.8 382 96.8 314.1zm120.8-101.3-.2-.2c-.2-.2-.4-.5-.7-.9-.6-.8-1.6-2-2.8-3.4-2.5-2.8-6-6.6-10.2-10.3-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3-1.2 1.4-2.2 2.6-2.8 3.4-.3.4-.6.7-.7.9l-.2.2c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8 9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8 0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8zm160 0-.2-.2c-.2-.2-.4-.5-.7-.9-.6-.8-1.6-2-2.8-3.4-2.5-2.8-6-6.6-10.2-10.3-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3-1.2 1.4-2.2 2.6-2.8 3.4-.3.4-.6.7-.7.9l-.2.2c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8 9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8 0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8z"
        }
    ]
};

const FasFaceLaughSquint = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceLaughSquint",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM96.8 314.1c-3.8-13.7 7.4-26.1 21.6-26.1h275.2c14.2 0 25.5 12.4 21.6 26.1C396.2 382 332.1 432 256 432S115.8 382 96.8 314.1zm36.7-199.4 89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5 0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6 0-9 9.6-14.7 17.5-10.5zM396 125.1c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6 0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5z"
        }
    ]
};

const FasFaceLaughWink = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceLaughWink",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM96.8 314.1c-3.8-13.7 7.4-26.1 21.6-26.1h275.2c14.2 0 25.5 12.4 21.6 26.1C396.2 382 332.1 432 256 432S115.8 382 96.8 314.1zM144.4 192a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm156.4 25.6c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0 5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2c-17.6-23.5-52.8-23.5-70.4 0z"
        }
    ]
};

const FasFaceLaugh = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceLaugh",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM96.8 314.1c-3.8-13.7 7.4-26.1 21.6-26.1h275.2c14.2 0 25.5 12.4 21.6 26.1C396.2 382 332.1 432 256 432S115.8 382 96.8 314.1zM144.4 192a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FasFaceLying = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceLying",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M494 350.5c-4.5 1-9.2 1.5-14 1.5H352c-8.8 0-16-7.2-16-16s7.2-16 16-16h128c17.7 0 32-14.3 32-32s-14.3-32-32-32H288c-8.8 0-16-7.2-16-16s7.2-16 16-16h192c11.2 0 21.7 2.9 30.9 7.9C498.8 101.8 389.3 0 256 0 114.6 0 0 114.6 0 256s114.6 256 256 256c108 0 200.4-66.9 238-161.5zM144.4 176a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm160 0a32 32 0 1 1 64 0 32 32 0 1 1-64 0zM188.8 393.6c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c17.5-23.3 45.4-38.4 76.8-38.4 13.6 0 26.6 2.8 38.4 8 8.1 3.5 11.8 13 8.3 21.1s-13 11.8-21.1 8.3c-7.8-3.4-16.5-5.3-25.6-5.3-20.9 0-39.5 10-51.2 25.6z"
        }
    ]
};

const FasFaceMask = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceMask",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M410.5 281.7 541.8 222C525.1 96.7 417.9 0 288 0S50.9 96.7 34.2 222l131.3 59.7c8-15.3 24.1-25.7 42.5-25.7h160c18.4 0 34.5 10.4 42.5 25.7zm5.5 32.6V384h93.8c21.8-37.6 34.2-81.3 34.2-127.9l-128 58.2zM413.3 416c-6.6 18.6-24.4 32-45.3 32H208c-20.9 0-38.7-13.4-45.3-32H88.1c46.9 58.5 119 96 199.9 96s152.9-37.5 199.9-96h-74.6zM160 384v-69.7L32 256.1c0 46.6 12.5 90.3 34.2 127.9H160zm-4.7-180.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6C146.4 167 184.6 144 240 144c8.8 0 16 7.2 16 16s-7.2 16-16 16c-47 0-77.1 19.7-84.7 27.3zM336 176c-8.8 0-16-7.2-16-16s7.2-16 16-16c55.4 0 93.6 23 107.3 36.7 6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0C413.1 195.7 383 176 336 176zM208 304c-8.8 0-16 7.2-16 16s7.2 16 16 16h160c8.8 0 16-7.2 16-16s-7.2-16-16-16H208zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16h160c8.8 0 16-7.2 16-16s-7.2-16-16-16H208z"
        }
    ]
};

const FasFaceMehBlank = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceMehBlank",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm208.4-48a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FasFaceMeh = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceMeh",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-79.6-336a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1-64 0zM160 336h192c8.8 0 16 7.2 16 16s-7.2 16-16 16H160c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FasFaceMelting = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceMelting",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M571.4 304.8c-4.5 23.2 11.8 47.2 35.4 47.2h1.2c17.7 0 32 14.3 32 32s-14.3 32-32 32h-48c-8.8 0-16 7.2-16 16s7.2 16 16 16h16c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h12.9c36.8 0 58.4-50.7 42.9-84.1C72.5 331.1 64 294.5 64 256 64 114.6 178.6 0 320 0s256 114.6 256 256c0 16.7-1.6 33-4.6 48.8zm-324.2-84.9a32 32 0 1 0 16.6-61.8 32 32 0 1 0-16.6 61.8zM441 238.7a32 32 0 1 0-61.8-16.6 32 32 0 1 0 61.8 16.6zm-227.8 60.7c-3.9-7.9-13.4-11.3-21.4-7.4s-11.3 13.4-7.4 21.4c14.8 30.5 45.1 67.5 98.3 81.7s97.9-2.6 126-21.7c7.3-5 9.2-14.9 4.3-22.2s-14.9-9.2-22.2-4.3c-22.7 15.4-57.9 28.5-99.8 17.2s-65.8-40.2-77.8-64.8z"
        }
    ]
};

const FasFaceMonocle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceMonocle",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M427.2 446.3C381.9 487.2 321.8 512 256 512 114.6 512 0 397.4 0 256S114.6 0 256 0s256 114.6 256 256c0 62.8-22.6 120.3-60.1 164.9-2.5-8.6-3.9-17.7-3.9-26.9V224c0-61.9-50.1-112-112-112s-112 50.1-112 112 50.1 112 112 112c31.3 0 59.7-12.9 80-33.6v91.5c0 18.4 3.9 36.2 11.2 52.4zM256 224a80 80 0 1 1 160 0 80 80 0 1 1-160 0zm-79.6-32a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm144 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM144 352c0 8.8 7.2 16 16 16 14.3 0 37.9 2.9 60.6 11.7 22.8 8.8 42.7 22.7 53.1 43.4 4 7.9 13.6 11.1 21.5 7.2s11.1-13.6 7.2-21.5c-15.3-30.5-43.3-48.6-70.1-59-27-10.3-54.6-13.8-72.3-13.8-8.8 0-16 7.2-16 16zM305.2 89.9c8-6.4 18-9.9 28.2-9.9 8.9 0 17.6 2.6 25.1 7.6l8.6 5.7c7.4 4.9 17.3 2.9 22.2-4.4s2.9-17.3-4.4-22.2l-8.6-5.7c-12.7-8.5-27.6-13-42.8-13-17.5 0-34.5 6-48.2 16.9L262 83.5c-6.9 5.5-8 15.6-2.5 22.5s15.6 8 22.5 2.5l23.2-18.6z"
        }
    ]
};

const FasFaceNauseated = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceNauseated",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm79.6-336a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-128 32a32 32 0 1 1-64 0 32 32 0 1 1 64 0zm-12.3-84.7-7.4 7.4a159.96 159.96 0 0 1-86.8 44.7l-2.5.4c-8.7 1.5-17-4.4-18.4-13.2s4.4-17 13.2-18.4l2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zm121.4-22.6c6.2-6.2 16.4-6.2 22.6 0l7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5.4c8.7 1.5 14.6 9.7 13.2 18.4s-9.7 14.6-18.4 13.2l-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4c-6.2-6.2-6.2-16.4 0-22.6zM168 282.7c19.5 11.3 33.8 30.5 38.4 53.3h99.2c4.6-22.8 18.9-42 38.4-53.3 7.7-4.4 17.4-1.8 21.9 5.8s1.8 17.4-5.8 21.9c-14.4 8.3-24 23.8-24 41.6s9.6 33.3 24 41.6c7.6 4.4 10.3 14.2 5.8 21.9s-14.2 10.3-21.9 5.8c-19.5-11.3-33.8-30.5-38.4-53.3h-99.2c-4.6 22.8-18.9 42-38.4 53.3-7.6 4.4-17.4 1.8-21.9-5.8s-1.8-17.4 5.8-21.9c14.4-8.3 24-23.8 24-41.6s-9.6-33.3-24-41.6c-7.6-4.4-10.3-14.2-5.8-21.9s14.2-10.3 21.9-5.8z"
        }
    ]
};

const FasFaceNoseSteam = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceNoseSteam",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M498.2 339.1c8.9-26.1 13.8-54 13.8-83.1C512 114.6 397.4 0 256 0S0 114.6 0 256c0 28.6 4.7 56.1 13.3 81.8 4.9-1.5 9.9-2.4 15-2.7 1.2-1.4 2.4-2.7 3.7-4l4 4-4-4c23.3-23.3 60.1-24.9 85.3-4.7l51-30.6c30-18 64.1 16.1 46.1 46.1l-30.6 51c20.2 25.1 18.6 62-4.7 85.3-1.3 1.3-2.6 2.5-4 3.7-.3 5.4-1.3 10.8-3 16C198.4 507 226.6 512 256 512c28.7 0 56.3-4.7 82-13.4-1.6-5.1-2.6-10.5-2.9-15.8-1.4-1.2-2.7-2.4-4-3.7-23.3-23.3-24.9-60.1-4.7-85.3l-30.6-51c-18-30 16.1-64.1 46.1-46.1l51 30.6c25.1-20.2 62-18.6 85.3 4.7 1.3 1.3 2.5 2.6 3.7 4 5.5.3 11 1.3 16.3 3.1zm-12.4 29.7c-1.9-.5-3.8-.8-5.8-.9-5.4-.3-10.8.7-15.7 3.1-1-5.2-3.3-10.1-6.9-14.4-.6-.7-1.2-1.4-1.8-2-12-12-31.2-12.5-43.8-1.4-.5.5-1 .9-1.5 1.4-3.7 3.7-6.3 8.1-7.8 12.8L332.8 323c-2.8-1.8-6.5-1.4-8.8 1l-.2.2c-.3.2-.6.5-.7.8-1.6 2.3-1.7 5.3-.1 7.7l44.2 70.4c-4.9 1.5-9.6 4.1-13.4 8-4.7 4.7-7.6 10.4-8.8 16.4-.5 2.4-.7 4.8-.6 7.2.2 7.9 3.4 15.7 9.4 21.7.7.7 1.3 1.3 2 1.9 4.2 3.6 9.2 5.9 14.4 6.9-1.5 3.2-2.5 6.7-2.9 10.1-.2 1.8-.3 3.7-.2 5.6 0 .7.1 1.4.2 2 .8 6.9 3.9 13.5 9.1 18.8 12.5 12.5 32.8 12.5 45.3 0 2.1-2.1 3.8-4.3 5.2-6.7 18.8 14.5 45.9 13.1 63.1-4.2s18.6-44.3 4.2-63.1c2.4-1.4 4.7-3.1 6.7-5.2 12.5-12.5 12.5-32.8 0-45.3-4.3-4.3-9.5-7.1-15-8.5zM142.4 485.5c.4-1.8.7-3.6.8-5.4.3-5.4-.7-10.8-3.1-15.7 5.2-1 10.1-3.3 14.4-6.9.7-.6 1.4-1.2 2-1.8 1.5-1.5 2.8-3.1 4-4.8 8-11.9 7.1-27.9-2.5-38.9-.5-.5-.9-1-1.4-1.5-3.6-3.6-7.9-6.2-12.5-7.7L189 333c1.8-2.8 1.4-6.5-.9-8.8-2.3-2.3-5.9-2.7-8.7-1L108 367.5c0-.2-.1-.3-.1-.5-1.5-4.8-4.1-9.4-8-13.2-.2-.2-.4-.4-.7-.6-.3-.3-.6-.5-.8-.8-12.6-11.1-31.7-10.6-43.8 1.4-.7.7-1.3 1.3-1.9 2-3.6 4.3-5.9 9.2-6.9 14.4-4.9-2.4-10.3-3.4-15.7-3.1-1.5.1-3.1.3-4.6.6-5.9 1.2-11.6 4.1-16.2 8.7-12.5 12.5-12.5 32.8 0 45.3 2.1 2.1 4.3 3.8 6.7 5.2-14.3 18.7-13 45.8 4.3 63s44.3 18.6 63.1 4.2c1.4 2.4 3.1 4.7 5.2 6.7 12.5 12.5 32.8 12.5 45.3 0 4.4-4.4 7.2-9.8 8.5-15.4zM112 224h96c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16s7.2-16 16-16zm192 32c-8.8 0-16-7.2-16-16s7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96zm95.2-133.1c2.8 8.4-1.7 17.4-10.1 20.2-35.5 11.8-64.4 34.8-73.7 44.1-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6c12-12 45-38.1 86.3-51.9 8.4-2.8 17.4 1.7 20.2 10.1zm-286.4 0c2.8-8.4 11.9-12.9 20.2-10.1 41.3 13.8 74.2 39.9 86.3 51.9 6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0c-9.3-9.3-38.2-32.3-73.7-44.1-8.4-2.8-12.9-11.9-10.1-20.2z"
        }
    ]
};

const FasFaceParty = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceParty",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M531.7 400C485.6 467.6 408 512 320 512 178.6 512 64 397.4 64 256S178.6 0 320 0c113.4 0 209.7 73.8 243.3 176H560c-44.2 0-80 35.8-80 80 0 18 6 34.6 16 48h-80c-1 0-2 0-3 .1-1.2-2.3-2.7-4.4-4.3-6.4-4.3-5.2-10.1-9.7-16.7-13.4-13.3-7.4-30.6-12.3-48-12.3-3.6 0-6.8 2.5-7.7 6s.6 7.2 3.8 9l.2.1c.2.1.5.3.9.5.8.5 2 1.2 3.4 2.1 2.8 1.9 6.5 4.5 10.2 7.6 3.7 3.1 7.2 6.6 9.6 10.1 2.5 3.5 3.5 6.4 3.5 8.6s-1 5-3.5 8.6c-2.5 3.5-5.9 6.9-9.6 10.1-3.7 3.1-7.4 5.7-10.2 7.6-1.4.9-2.6 1.6-3.4 2.1-.4.2-.7.4-.9.5l-.2.1c-2.5 1.4-4.1 4.1-4.1 7s1.6 5.6 4.1 7l.2.1c.2.1.5.3.9.5.8.5 2 1.2 3.4 2.1 2.8 1.9 6.5 4.5 10.2 7.6 3.7 3.1 7.2 6.6 9.6 10.1 2.5 3.5 3.5 6.4 3.5 8.6s-1 5-3.5 8.6c-2.5 3.5-5.9 6.9-9.6 10.1-3.7 3.1-7.4 5.7-10.2 7.6-1.4.9-2.6 1.6-3.4 2.1-.4.2-.7.4-.9.5l-.2.1c-3.2 1.8-4.7 5.5-3.8 9s4.1 6 7.7 6c17.4 0 34.7-4.9 47.9-12.3 6.6-3.7 12.5-8.2 16.7-13.4 1.6-2 3.1-4.1 4.3-6.4 1 .1 2 .1 3 .1h115.8zM275.2 233.6c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2c17.6-23.5 52.8-23.5 70.4 0zm89.6 0c17.6-23.5 52.8-23.5 70.4 0 5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2zM512 256c0-26.5 21.5-48 48-48h32c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H400c-8.8 0-16-7.2-16-16s7.2-16 16-16h192c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16s7.2 16 16 16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16h-16c-26.5 0-48-21.5-48-48zM51.3 152.2l-20-52C46.6 71.8 66 46 88.8 23.4L132 37.8c-35.5 30.7-63.5 69.9-80.7 114.4zm3.8-140C40.9 27.6 28 44.4 16.6 62.1L1.1 21.7C-1.2 16 .2 9.4 4.4 4.9s10.8-6 16.7-4.1l34 11.4z"
        }
    ]
};

const FasFacePensive = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFacePensive",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-48-128h96c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16s7.2-16 16-16zm179.2-113.6c5.3-7.1 15.3-8.5 22.4-3.2s8.5 15.3 3.2 22.4c-30.4 40.5-91.2 40.5-121.6 0-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2c17.6 23.5 52.8 23.5 70.4 0zm-262.4 0c17.6 23.5 52.8 23.5 70.4 0 5.3-7.1 15.3-8.5 22.4-3.2s8.5 15.3 3.2 22.4c-30.4 40.5-91.2 40.5-121.6 0-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2zm-59.1-55.2c-4-7.9-.7-17.5 7.2-21.5l22.9-11.4c14.5-7.2 27.2-17.6 37.4-30.2l14.4-18c5.5-6.9 15.6-8 22.5-2.5s8 15.6 2.5 22.5l-14.4 18c-13 16.3-29.4 29.5-48 38.8l-23 11.4c-7.9 4-17.5.7-21.5-7.2zm373.5-21.5c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2L402 210.9c-18.6-9.3-35-22.6-48.1-38.8l-14.4-18c-5.5-6.9-4.4-17 2.5-22.5s17-4.4 22.5 2.5l14.4 18c10.1 12.7 22.9 23 37.4 30.2l22.9 11.4z"
        }
    ]
};

const FasFacePersevering = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFacePersevering",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm60.1-101.3c-11.7-13-31.6-26.7-60.1-26.7s-48.4 13.7-60.1 26.7c-5.9 6.6-16 7.1-22.6 1.2s-7.1-16-1.2-22.6c16.1-17.9 44.2-37.3 83.9-37.3s67.8 19.4 83.9 37.3c5.9 6.6 5.4 16.7-1.2 22.6s-16.7 5.4-22.6-1.2zm-104.8-310c6.2 6.2 6.2 16.4 0 22.6l-7.4 7.4a159.96 159.96 0 0 1-86.8 44.7l-2.5.4c-8.7 1.5-17-4.4-18.4-13.2s4.4-17 13.2-18.4l2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4c6.2-6.2 16.4-6.2 22.6 0zm89.4 22.6c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5.4c8.7 1.5 14.6 9.7 13.2 18.4s-9.7 14.6-18.4 13.2l-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4zm-167.2 87.4 89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5 0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6 0-9 9.6-14.7 17.5-10.5zM396 221.1c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6 0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5z"
        }
    ]
};

const FasFacePleading = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFacePleading",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm302.7 171.9c6.6-5.9 7.1-16 1.2-22.6-9.2-10.2-25.2-21.3-47.9-21.3s-38.7 11.1-47.9 21.3c-5.9 6.6-5.4 16.7 1.2 22.6s16.7 5.4 22.6-1.2c4.7-5.3 12.7-10.7 24.1-10.7s19.4 5.4 24.1 10.7c5.9 6.6 16 7.1 22.6 1.2zM240 240c0-41.5-31.5-75.6-72-79.6 10-10.8 17.6-24.1 21.9-38.8l1.5-5.2c2.4-8.5-2.5-17.4-11-19.8s-17.4 2.5-19.8 11l-1.5 5.2c-7 24.7-28.1 42.7-53.6 45.9L94 160.1c-8.8 1.1-15 9.1-13.9 17.9 1 8.1 7.9 14 15.9 14-10 13.4-16 30-16 48 0 44.2 35.8 80 80 80s80-35.8 80-80zm192 0c0-18-6-34.6-16-48 8 0 14.9-5.9 15.9-14 1.1-8.8-5.1-16.8-13.9-17.9l-11.5-1.4c-25.5-3.2-46.6-21.3-53.6-45.9l-1.5-5.2c-2.4-8.5-11.3-13.4-19.8-11s-13.4 11.3-11 19.8l1.5 5.2c4.2 14.8 11.8 28 21.9 38.8-40.4 4-72 38.1-72 79.6 0 44.2 35.8 80 80 80s80-35.8 80-80zm-304-8c17.7 0 32-14.3 32-32 0-5.8-1.5-11.2-4.2-15.8 1.4-.1 2.8-.2 4.2-.2 30.9 0 56 25.1 56 56s-25.1 56-56 56-56-25.1-56-56c0-5.7.8-11.2 2.4-16.4 5.7 5.2 13.3 8.4 21.6 8.4zm224-32c0-5.8-1.5-11.2-4.2-15.8 1.4-.1 2.8-.2 4.2-.2 30.9 0 56 25.1 56 56s-25.1 56-56 56-56-25.1-56-56c0-5.7.8-11.2 2.4-16.4 5.7 5.2 13.3 8.4 21.6 8.4 17.7 0 32-14.3 32-32z"
        }
    ]
};

const FasFacePouting = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFacePouting",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm161.3 126.1c-5.4 12.3 8.7 21.6 21.1 16.4 22.4-9.5 47.4-14.8 73.7-14.8s51.3 5.3 73.7 14.8c12.4 5.2 26.5-4.1 21.1-16.4-16-36.6-52.4-62.1-94.8-62.1s-78.8 25.6-94.8 62.1zM176.4 272c17.7 0 32-14.3 32-32 0-1.5-.1-3-.3-4.4l10.9 3.6c8.4 2.8 17.4-1.7 20.2-10.1s-1.7-17.4-10.1-20.2l-96-32c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2l30.7 10.2c-5.8 5.8-9.3 13.8-9.3 22.6 0 17.7 14.3 32 32 32zm192-32c0-8.9-3.6-17-9.5-22.8l30.2-10.1c8.4-2.8 12.9-11.9 10.1-20.2S387.3 174 379 176.8l-96 32c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l11.7-3.9c-.2 1.5-.3 3.1-.3 4.7 0 17.7 14.3 32 32 32s32-14.3 32-32z"
        }
    ]
};

const FasFaceRaisedEyebrow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceRaisedEyebrow",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm208.4-16a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM144 352c0 8.8 7.2 16 16 16h192c8.8 0 16-7.2 16-16s-7.2-16-16-16H160c-8.8 0-16 7.2-16 16zm184.8-210.2c10.7-10.7 28.5-8.9 36.9 3.7l4.9 7.4c4.9 7.4 14.8 9.3 22.2 4.4s9.3-14.8 4.4-22.2l-4.9-7.4c-19.6-29.4-61.2-33.5-86.2-8.5l-29.5 29.5c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l29.5-29.5zM128 144c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16h-64z"
        }
    ]
};

const FasFaceRelieved = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceRelieved",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-68.7-155.3c13 13 35.8 27.3 68.7 27.3s55.6-14.3 68.7-27.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6C329.4 397.2 298.9 416 256 416s-73.4-18.8-91.3-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zm199.9-118.3c5.3-7.1 15.3-8.5 22.4-3.2s8.5 15.3 3.2 22.4c-30.4 40.5-91.2 40.5-121.6 0-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2c17.6 23.5 52.8 23.5 70.4 0zm-262.4 0c17.6 23.5 52.8 23.5 70.4 0 5.3-7.1 15.3-8.5 22.4-3.2s8.5 15.3 3.2 22.4c-30.4 40.5-91.2 40.5-121.6 0-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2zm82.4-163.5c2.8 8.4-1.7 17.4-10.1 20.2l-6.3 2.1c-23.6 7.9-44 23.4-57.8 44.1l-7.6 11.5c-4.9 7.4-14.8 9.3-22.2 4.4s-9.3-14.8-4.4-22.2l7.6-11.5c17.8-26.6 43.9-46.6 74.3-56.7l6.3-2.1c8.4-2.8 17.4 1.7 20.2 10.1zm107.7 20.3c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1l6.3 2.1c30.4 10.1 56.5 30.1 74.3 56.7l7.6 11.5c4.9 7.4 2.9 17.3-4.4 22.2s-17.3 2.9-22.2-4.4l-7.6-11.6c-13.8-20.7-34.1-36.3-57.8-44.1l-6.3-2.1z"
        }
    ]
};

const FasFaceRollingEyes = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceRollingEyes",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-64-144h128c8.8 0 16 7.2 16 16s-7.2 16-16 16H192c-8.8 0-16-7.2-16-16s7.2-16 16-16zm32-144c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-26 15.5-48.4 37.8-58.4-3.7 5.2-5.8 11.6-5.8 18.4 0 17.7 14.3 32 32 32s32-14.3 32-32c0-6.9-2.2-13.2-5.8-18.4 22.3 10 37.8 32.4 37.8 58.4zm128 64c-35.3 0-64-28.7-64-64 0-26 15.5-48.4 37.8-58.4-3.7 5.2-5.8 11.6-5.8 18.4 0 17.7 14.3 32 32 32s32-14.3 32-32c0-6.9-2.2-13.2-5.8-18.4 22.3 10 37.8 32.4 37.8 58.4 0 35.3-28.7 64-64 64z"
        }
    ]
};

const FasFaceSadCry = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceSadCry",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 493.4c-29.6 12-62.1 18.6-96 18.6s-66.4-6.6-96-18.6V288c0-8.8-7.2-16-16-16s-16 7.2-16 16v189.8C51.5 433.5 0 350.8 0 256 0 114.6 114.6 0 256 0s256 114.6 256 256c0 94.8-51.5 177.5-128 221.8V288c0-8.8-7.2-16-16-16s-16 7.2-16 16v205.4zM195.2 233.6c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2c17.6-23.5 52.8-23.5 70.4 0zm121.6 0c17.6-23.5 52.8-23.5 70.4 0 5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2zM208 336v32c0 26.5 21.5 48 48 48s48-21.5 48-48v-32c0-26.5-21.5-48-48-48s-48 21.5-48 48z"
        }
    ]
};

const FasFaceSadSweat = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceSadSweat",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 512c141.4 0 256-114.6 256-256S429.4 0 288 0 32 114.6 32 256v3.3c16.3-7.1 36.4-2.8 48 12.8 7 9.2 18.1 24.6 27.7 40.7 4.8 8.1 9.6 17 13.2 25.7 3.4 8 7.1 19 7.1 30.5 0 24.5-11.1 46-28.4 60.3C146.4 480.2 213.5 512 288 512zM79.5 404.5C89.6 395.9 96 383.2 96 369c0-20-28.4-60.4-41.6-77.7-3.2-4.4-9.6-4.4-12.8 0-1.7 2.3-3.8 5-5.9 8.1C21.4 319.1 0 351.7 0 369c0 26 21.5 47 48 47 12 0 23-4.3 31.5-11.5zm291.3 7.4c-6.6 5.9-16.7 5.4-22.6-1.2-11.7-13-31.6-26.7-60.1-26.7s-48.4 13.7-60.1 26.7c-5.9 6.6-16 7.1-22.6 1.2s-7.1-16-1.2-22.6c16-17.9 44.1-37.3 83.8-37.3s67.8 19.4 83.9 37.3c5.9 6.6 5.4 16.7-1.2 22.6zM367.6 240a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-128 32a32 32 0 1 1-64 0 32 32 0 1 1 64 0zm-12.3-100.7-7.4 7.4a159.96 159.96 0 0 1-86.8 44.7l-2.5.4c-8.7 1.5-17-4.4-18.4-13.2s4.4-17 13.2-18.4l2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zm121.4-22.6c6.2-6.2 16.4-6.2 22.6 0l7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5.4c8.7 1.5 14.6 9.7 13.2 18.4s-9.7 14.6-18.4 13.2l-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4c-6.2-6.2-6.2-16.4 0-22.6z"
        }
    ]
};

const FasFaceSadTear = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceSadTear",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 256a256 256 0 1 0 512 0 256 256 0 1 0-512 0zm240 80c0-8.8 7.2-16 16-16 45 0 85.6 20.5 115.7 53.1 6 6.5 5.6 16.6-.9 22.6s-16.6 5.6-22.6-.9c-25-27.1-57.4-42.9-92.3-42.9-8.8 0-16-7.2-16-16zm-80 80c-26.5 0-48-21-48-47 0-20 28.6-60.4 41.6-77.7 3.2-4.4 9.6-4.4 12.8 0C179.6 308.6 208 349 208 369c0 26-21.5 47-48 47zm207.6-208a32 32 0 1 1-64 0 32 32 0 1 1 64 0zm-192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FasFaceSaluting = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceSaluting",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M258.1 58.5c14.5-9.8 18.4-29.4 8.8-44-.1-.1-.2-.3-.3-.4-9.9-14.7-29.8-18.5-44.4-8.6l-187.1 127c-44.3 30.1-47.1 94.4-5.6 128.2l1.5 1.2c18.9 15.4 43.2 20.9 66 16.5 4.4-.9 8.8-2.1 13.1-3.8.3-.1.7-.3 1-.4l1.5-.6c5.6-2.3 10.9-5.4 16-9l82.3-59.9c14.3-10.4 17.5-30.4 7.1-44.7-4.8-6.7-11.8-10.9-19.3-12.5-3.5-.7-7.2-.9-10.8-.4-5.1.7-10.1 2.6-14.6 5.8L128 185.8v-39l27.3-18.5 13.1-8.9 89.7-60.9zM352 0c-18.4 0-36.3 1.9-53.5 5.6 12.6 27.9 3.8 61.6-22.4 79.4l-54.6 37c8.6 4.4 16.3 10.9 22.3 19.2 8.6 11.9 12.6 25.7 12.2 39.3 4.8-2.8 10.4-4.5 16.3-4.5 17.7 0 32 14.3 32 32s-14.3 32-32 32c-13.9 0-25.8-8.9-30.2-21.4-3.5 4.4-7.7 8.5-12.5 12l-82.3 59.9c-13.9 10.1-29.5 16.6-45.6 19.6C126.5 425.5 229.1 512 352 512c141.4 0 256-114.6 256-256S493.4 0 352 0zm-94.6 341c17.5 12.6 48.9 27 94.6 27s77.2-14.4 94.6-27c7.2-5.2 17.2-3.5 22.3 3.6s3.5 17.2-3.6 22.3c-22.7 16.4-60.7 33-113.4 33s-90.6-16.6-113.4-33c-7.2-5.2-8.8-15.2-3.6-22.3s15.2-8.8 22.3-3.6zm175-165a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FasFaceScream = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceScream",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M573.9 288.5c1.4-10.7 2.1-21.5 2.1-32.5C576 114.6 461.4 0 320 0S64 114.6 64 256c0 11 .7 21.9 2.1 32.6 20.6-2.5 41.7 3.5 57.8 16.9 57.5 48 87.8 118 98 187 30.2 12.6 63.3 19.5 98.1 19.5s68-6.9 98.2-19.5c10.2-69 40.4-139 98-187 16.1-13.4 37.2-19.4 57.8-17zM320 320c26.5 0 48 21.5 48 48v32c0 26.5-21.5 48-48 48s-48-21.5-48-48v-32c0-26.5 21.5-48 48-48zm-46.6-77c-22.5 36.9-62.8 54.7-90.1 39.8s-31.1-56.9-8.7-93.7 62.8-54.7 90.1-39.8 31.1 56.9 8.7 93.7zm183.3 39.8c-27.3 14.9-67.6-2.9-90.1-39.8s-18.6-78.8 8.7-93.7 67.6 2.9 90.1 39.8 18.6 78.8-8.7 93.7zm-353.3 47.3C89.1 318.2 68 316.4 51.6 327c-20 13-25.6 39.5-12.4 59.3 26.4 40 43.6 75.3 43.2 125.7H192c-7-68.4-34.8-137-88.7-181.9zm485.1-3.1c-16.4-10.6-37.6-8.8-51.8 3.1C482.8 375 455 443.6 448 512h109.8c-.4-50.5 16.7-85.7 43.2-125.7 13.1-19.8 7.6-46.3-12.4-59.3z"
        }
    ]
};

const FasFaceShush = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceShush",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 256c0 103.8 61.8 193.1 150.5 233.3-4.2-10.3-6.5-21.5-6.5-33.3v-48c0-37.3 23.2-69.2 56-82v-50.1c-14.8-6.9-26.6-15.9-35.3-24.6-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0c3.7 3.7 8.1 7.4 13.3 10.9 4-27 27.3-47.6 55.4-47.6s51.3 20.7 55.4 47.6c5.2-3.5 9.6-7.3 13.3-10.9 6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6c-8.7 8.7-20.5 17.7-35.3 24.6v58.3c17.9 11.7 31.3 29.7 37 50.9 16-3.2 33.3.6 46.9 11.9 18.4 15.3 24.5 39.9 17.1 61.3 60.3-46.8 99-120 99-202.3C512 114.6 397.4 0 256 0S0 114.6 0 256zM176.4 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1-64 0zM280 248c0-13.3-10.7-24-24-24s-24 10.7-24 24v72h48v-72zm-56 160c0-4.4 3.6-8 8-8h32c4.4 0 8 3.6 8 8v8c0 13.3 10.7 24 24 24s24-10.7 24-24v-8c0-30.9-25.1-56-56-56h-32c-30.9 0-56 25.1-56 56v48c0 30.9 25.1 56 56 56h65.5c21.4 0 41.6-9.5 55.3-25.9l25.6-30.7c8.5-10.2 7.1-25.3-3.1-33.8s-25.3-7.1-33.8 3.1L316 455.4c-4.6 5.5-11.3 8.6-18.4 8.6h-10L224 419.5V408z"
        }
    ]
};

const FasFaceSleeping = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceSleeping",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 256c0-46.6-12.5-90.3-34.2-128H432c-19.4 0-36.9-11.7-44.3-29.6-7.1-17.1-3.7-36.7 8.6-50.4-2.9-3.2-5.4-6.9-7.3-10.8C350.2 13.6 304.7 0 256 0 114.6 0 0 114.6 0 256s114.6 256 256 256 256-114.6 256-256zM272 96c-8.8 0-16-7.2-16-16s7.2-16 16-16h64c6.5 0 12.3 3.9 14.8 9.9s1.1 12.9-3.5 17.4L310.6 128H336c8.8 0 16 7.2 16 16s-7.2 16-16 16h-64c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4L297.4 96H272zm-56 288a40 40 0 1 1 80 0 40 40 0 1 1-80 0zm171.2-145.6c5.3-7.1 15.3-8.5 22.4-3.2s8.5 15.3 3.2 22.4c-30.4 40.5-91.2 40.5-121.6 0-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2c17.6 23.5 52.8 23.5 70.4 0zm-262.4 0c17.6 23.5 52.8 23.5 70.4 0 5.3-7.1 15.3-8.5 22.4-3.2s8.5 15.3 3.2 22.4c-30.4 40.5-91.2 40.5-121.6 0-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2zM416 16c0 8.8 7.2 16 16 16h25.4l-36.7 36.7c-4.6 4.6-5.9 11.5-3.5 17.4S425.5 96 432 96h64c8.8 0 16-7.2 16-16s-7.2-16-16-16h-25.4l36.7-36.7c4.6-4.6 5.9-11.5 3.5-17.4S502.5 0 496 0h-64c-8.8 0-16 7.2-16 16z"
        }
    ]
};

const FasFaceSleepy = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceSleepy",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M385.1 477.1c-37.9 22.2-82 34.9-129.1 34.9C114.6 512 0 397.4 0 256S114.6 0 256 0s256 114.6 256 256c0 37-7.8 72.1-22 103.9-7.4-6.2-15.1-11.8-22.7-16.7C429.6 318.7 383.6 304 352 304c-15.3 0-28.5 10.9-31.4 25.9s5.3 30.1 19.5 35.8c21 8.4 31.6 23.5 37.4 41.7 6.3 19.4 6.5 40.3 6.5 56.6 0 4.5.4 8.9 1.1 13.1zM176 389.5c-6.8 11.1 6 20.7 18.3 16.4 18.9-6.5 39.8-10.1 61.8-10.1s42.9 3.6 61.8 10.1c12.3 4.2 25.1-5.3 18.3-16.4C321 364.8 290.8 348 256 348s-64.9 16.8-80.1 41.5zm140.8-143.1c-5.3-7.1-15.3-8.5-22.4-3.2s-8.5 15.3-3.2 22.4c30.4 40.5 91.2 40.5 121.6 0 5.3-7.1 3.9-17.1-3.2-22.4s-17.1-3.9-22.4 3.2c-17.6 23.5-52.8 23.5-70.4 0zm-121.6 0c-17.6 23.5-52.8 23.5-70.4 0-5.3-7.1-15.3-8.5-22.4-3.2s-8.5 15.3-3.2 22.4c30.4 40.5 91.2 40.5 121.6 0 5.3-7.1 3.9-17.1-3.2-22.4s-17.1-3.9-22.4 3.2zM512 464c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-32 0-102.4-64-128 48 0 160 48 160 128z"
        }
    ]
};

const FasFaceSmileBeam = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceSmileBeam",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-91.9-186.5C182 346.2 212.6 368 256 368s74-21.8 91.9-42.5c5.8-6.7 15.9-7.4 22.6-1.6s7.4 15.9 1.6 22.6c-22.3 25.6-61 53.5-116.1 53.5s-93.8-27.9-116.1-53.5c-5.8-6.7-5.1-16.8 1.6-22.6s16.8-5.1 22.6 1.6zm53.5-96.7-.2-.2c-.2-.2-.4-.5-.7-.9-.6-.8-1.6-2-2.8-3.4-2.5-2.8-6-6.6-10.2-10.3-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3-1.2 1.4-2.2 2.6-2.8 3.4-.3.4-.6.7-.7.9l-.2.2c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8 9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8 0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8zm160 0-.2-.2c-.2-.2-.4-.5-.7-.9-.6-.8-1.6-2-2.8-3.4-2.5-2.8-6-6.6-10.2-10.3-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3-1.2 1.4-2.2 2.6-2.8 3.4-.3.4-.6.7-.7.9l-.2.2c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8 9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8 0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8z"
        }
    ]
};

const FasFaceSmileHalo = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceSmileHalo",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 80c0 44.2-114.6 80-256 80S0 124.2 0 80 114.6 0 256 0s256 35.8 256 80zm-64 0c0-17.7-86-32-192-32S64 62.3 64 80s86 32 192 32 192-14.3 192-32zM16 272c0-41.9 10.7-81.3 29.6-115.5C98.1 178.3 173 192 256 192s157.9-13.7 210.4-35.5C485.3 190.7 496 230.1 496 272c0 132.5-107.5 240-240 240S16 404.5 16 272zm148.1 85.5c-5.8-6.7-15.9-7.4-22.6-1.6s-7.4 15.9-1.6 22.6c22.2 25.7 61 53.5 116.1 53.5s93.8-27.9 116.1-53.5c5.8-6.7 5.1-16.8-1.6-22.6s-16.8-5.1-22.6 1.6C330 378.2 299.4 400 256 400s-74-21.8-91.9-42.5zm53.5-56.7c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2c-9.9 13.2-16.6 30.9-16.6 48.8 0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l.2-.2c.2-.2.4-.5.7-.9.6-.8 1.6-2 2.8-3.4 2.5-2.8 6-6.6 10.2-10.3 8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3 1.2 1.4 2.2 2.6 2.8 3.4.3.4.6.7.7.9l.2.2zm160 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2c-9.9 13.2-16.6 30.9-16.6 48.8 0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l.2-.2c.2-.2.4-.5.7-.9.6-.8 1.6-2 2.8-3.4 2.5-2.8 6-6.6 10.2-10.3 8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3 1.2 1.4 2.2 2.6 2.8 3.4.3.4.6.7.7.9l.2.2z"
        }
    ]
};

const FasFaceSmileHearts = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceSmileHearts",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448.2 34.3c-1.3 19.7 5.5 39.8 20.5 54.9l55.5 55.8c9.2 9.3 21.1 14.2 33.2 14.9 12 29.7 18.6 62.1 18.6 96.1 0 37.4-8 73-22.5 105.1-27-15.2-61.9-11.3-84.8 11.8-25.8 26-27.5 67.1-4.9 94.9-41 27.9-90.5 44.2-143.8 44.2-61.3 0-117.6-21.6-161.7-57.6l13.1-13.1c27.6-27.7 27.6-72.6 0-100.4-24.8-25-63.6-27.6-91.3-7.7-1.7-1.2-3.5-2.4-5.2-3.4C67.8 306.5 64 281.7 64 256 64 114.6 178.6 0 320 0c46.7 0 90.5 12.5 128.2 34.3zM205.5 323.9c-6.7 5.8-7.4 15.9-1.6 22.6 22.2 25.7 61 53.5 116.1 53.5s93.8-27.9 116.1-53.5c5.8-6.7 5.1-16.8-1.6-22.6s-16.8-5.1-22.6 1.6C394 346.2 363.4 368 320 368s-74-21.8-91.9-42.5c-5.8-6.7-15.9-7.4-22.6-1.6zm-.7-90.3c17.6-23.5 52.8-23.5 70.4 0 5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2zm230.4 0c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2c17.6-23.5 52.8-23.5 70.4 0zM573.7 11.5c15.2-15.3 39.8-15.3 54.9 0s15.2 40 0 55.2l-55.4 55.8c-7.3 7.3-19.1 7.3-26.3 0l-55.5-55.8c-15.2-15.3-15.2-40 0-55.2s39.8-15.3 54.9 0L560 25.3l13.7-13.8zm54.9 384c15.2 15.3 15.2 40 0 55.2l-55.4 55.8c-7.3 7.3-19.1 7.3-26.3 0l-55.5-55.8c-15.2-15.3-15.2-40 0-55.2s39.8-15.3 54.9 0l13.7 13.8 13.7-13.8c15.2-15.3 39.8-15.3 54.9 0zm-534.9-32c15.2-15.3 39.8-15.3 54.9 0s15.2 40 0 55.2l-55.4 55.8c-7.3 7.3-19.1 7.3-26.3 0l-55.5-55.8c-15.2-15.3-15.2-40 0-55.2s39.8-15.3 54.9 0L80 377.3l13.7-13.8z"
        }
    ]
};

const FasFaceSmileHorns = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceSmileHorns",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 512c141.4 0 256-114.6 256-256 0-24.6-3.5-48.4-9.9-70.9 44.3-59.4 67.4-135 73.6-166 1.3-6.3-1.4-12.8-6.8-16.4s-12.4-3.6-17.8 0c-19.3 12.9-48.5 24.2-78.4 33.1-23.3 7-46 12.2-63 15.5C430.9 19.1 377.7 0 320 0S209.1 19.1 166.2 51.3c-17-3.3-39.7-8.6-63-15.5-29.8-8.9-59-20.3-78.3-33.1-5.4-3.6-12.4-3.6-17.8 0S-1 12.8.3 19.1c6.2 31 29.3 106.6 73.6 166-6.4 22.5-9.9 46.3-9.9 70.9 0 141.4 114.6 256 256 256zm-91.9-162.5C246 370.2 276.6 392 320 392s74-21.8 91.9-42.5c5.8-6.7 15.9-7.4 22.6-1.6s7.4 15.9 1.6 22.6c-22.3 25.6-61 53.5-116.1 53.5s-93.8-27.9-116.1-53.5c-5.8-6.7-5.1-16.8 1.6-22.6s16.8-5.1 22.6 1.6zm44.3-77.5c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-8.8 3.6-16.8 9.3-22.6L187 239.2c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1l96 32c8.4 2.8 12.9 11.9 10.1 20.2S291.3 274 283 271.2l-10.9-3.6c.2 1.5.3 2.9.3 4.4zm128 32c-17.7 0-32-14.3-32-32 0-1.6.1-3.2.3-4.7l-11.7 3.9c-8.4 2.8-17.4-1.7-20.2-10.1s1.7-17.4 10.1-20.2l96-32c8.4-2.8 17.4 1.7 20.2 10.1s-1.7 17.4-10.1 20.2l-30.2 10.1c5.9 5.8 9.5 13.9 9.5 22.8 0 17.7-14.3 32-32 32z"
        }
    ]
};

const FasFaceSmilePlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceSmilePlus",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M544 0c-13.3 0-24 10.7-24 24v48h-48c-13.3 0-24 10.7-24 24s10.7 24 24 24h48v48c0 13.3 10.7 24 24 24s24-10.7 24-24v-48h48c13.3 0 24-10.7 24-24s-10.7-24-24-24h-48V24c0-13.3-10.7-24-24-24zM224 512a224 224 0 1 0 0-448 224 224 0 1 0 0 448zm-79.6-304a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1-64 0zM140 346.1c20.5 23.3 50.6 37.9 84 37.9s63.5-14.6 84-37.9c5.8-6.6 16-7.3 22.6-1.4s7.3 16 1.4 22.6c-26.4 29.8-65 48.7-108 48.7s-81.6-18.9-108-48.7c-5.8-6.6-5.2-16.7 1.4-22.6s16.7-5.2 22.6 1.4z"
        }
    ]
};

const FasFaceSmileRelaxed = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceSmileRelaxed",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-91.9-186.5C182 346.2 212.6 368 256 368s74-21.8 91.9-42.5c5.8-6.7 15.9-7.4 22.6-1.6s7.4 15.9 1.6 22.6c-22.3 25.6-61 53.5-116.1 53.5s-93.8-27.9-116.1-53.5c-5.8-6.7-5.1-16.8 1.6-22.6s16.8-5.1 22.6 1.6zm47.1-91.9c-17.6-23.5-52.8-23.5-70.4 0-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0 5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2zm89.6 0c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0 5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2c-17.6-23.5-52.8-23.5-70.4 0z"
        }
    ]
};

const FasFaceSmileTear = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceSmileTear",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm141.5 67.9c-6.7 5.8-7.4 15.9-1.6 22.6 22.2 25.7 61 53.5 116.1 53.5 8.8 0 16-7.2 16-16s-7.2-16-16-16c-43.4 0-74-21.8-91.9-42.5-5.8-6.7-15.9-7.4-22.6-1.6zM352 416c26.5 0 48-21 48-47 0-20-28.6-60.4-41.6-77.7-3.2-4.4-9.6-4.4-12.8 0C332.4 308.6 304 349 304 369c0 26 21.5 47 48 47zM208.4 208a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FasFaceSmileTongue = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceSmileTongue",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M503.4 322c5.6-21.1 8.6-43.2 8.6-66C512 114.6 397.4 0 256 0S0 114.6 0 256s114.6 256 256 256c61.5 0 118-21.7 162.1-57.9-2.8-1.2-5.5-2.7-8.2-4.2l-68.1-40.4C316.3 423.8 287.1 432 256 432c-84.1 0-154-59.7-175.5-139.9-2.3-8.5 2.8-17.3 11.3-19.6s17.3 2.8 19.6 11.3C129.5 351.5 187.9 400 256 400s126.5-48.5 144.5-116.1c2.3-8.5 11.1-13.6 19.6-11.3 1.5.4 2.9 1 4.2 1.8l65.4 37.8c5 2.9 9.6 6.2 13.7 10zm-132.8 67.3 55.7 33.1c22.6 13.4 51.8 5.8 65-17 13.3-23 5.4-52.3-17.6-65.6l-48.6-28.1c-11.7 30.4-30.5 57.1-54.5 77.6zm-153-160.5-.2-.2c-.2-.2-.4-.5-.7-.9-.6-.8-1.6-2-2.8-3.4-2.5-2.8-6-6.6-10.2-10.3-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3-1.2 1.4-2.2 2.6-2.8 3.4-.3.4-.6.7-.7.9l-.2.2c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8 9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8 0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8zm160 0-.2-.2c-.2-.2-.4-.5-.7-.9-.6-.8-1.6-2-2.8-3.4-2.5-2.8-6-6.6-10.2-10.3-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3-1.2 1.4-2.2 2.6-2.8 3.4-.3.4-.6.7-.7.9l-.2.2c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8 9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8 0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8z"
        }
    ]
};

const FasFaceSmileUpsideDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceSmileUpsideDown",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 0a256 256 0 1 0 0 512 256 256 0 1 0 0-512zm91.9 186.5C330 165.8 299.4 144 256 144s-74 21.8-91.9 42.5c-5.8 6.7-15.9 7.4-22.6 1.6s-7.4-15.9-1.6-22.6c22.2-25.7 61-53.5 116.1-53.5s93.8 27.9 116.1 53.5c5.8 6.7 5.1 16.8-1.6 22.6s-16.8 5.1-22.6-1.6zM367.6 304a32 32 0 1 1-64 0 32 32 0 1 1 64 0zm-192 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64z"
        }
    ]
};

const FasFaceSmileWink = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceSmileWink",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-91.9-186.5C182 346.2 212.6 368 256 368s74-21.8 91.9-42.5c5.8-6.7 15.9-7.4 22.6-1.6s7.4 15.9 1.6 22.6c-22.3 25.6-61 53.5-116.1 53.5s-93.8-27.9-116.1-53.5c-5.8-6.7-5.1-16.8 1.6-22.6s16.8-5.1 22.6 1.6zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm156.4 25.6c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0 5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2c-17.6-23.5-52.8-23.5-70.4 0z"
        }
    ]
};

const FasFaceSmile = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceSmile",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-91.9-186.5C182 346.2 212.6 368 256 368s74-21.8 91.9-42.5c5.8-6.7 15.9-7.4 22.6-1.6s7.4 15.9 1.6 22.6c-22.3 25.6-61 53.5-116.1 53.5s-93.8-27.9-116.1-53.5c-5.8-6.7-5.1-16.8 1.6-22.6s16.8-5.1 22.6 1.6zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FasFaceSmilingHands = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceSmilingHands",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M411.1 495.3c-17-21.6-27.1-48.9-27.1-78.5V386c-18.1 8.4-39.4 14-64 14s-45.9-5.6-64-14v30.8c0 29.6-10.1 56.9-27.1 78.5 28.3 10.8 59 16.7 91.1 16.7s62.8-5.9 91.1-16.7zM320 0C183.1 0 71.3 107.5 64.3 242.6c16.8-5.8 36.2-2 49.6 11.4l47.1 47.1c9.4-13.7 25.1-22.7 43-22.7 28.7 0 52 23.3 52 52v19.2c16.8 10.6 38.1 18.4 64 18.4s47.2-7.7 64-18.4v-19.2c0-28.7 23.3-52 52-52 17.9 0 33.6 9 43 22.7l47.1-47.1c13.4-13.4 32.8-17.2 49.6-11.4C568.7 107.5 456.9 0 320 0zm-38.4 228.8-.2-.2c-.2-.2-.4-.5-.7-.9-.6-.8-1.6-2-2.8-3.4-2.5-2.8-6-6.6-10.2-10.3-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3-1.2 1.4-2.2 2.6-2.8 3.4-.3.4-.6.7-.7.9l-.2.2c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8 9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8 0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8zm160 0-.2-.2c-.2-.2-.4-.5-.7-.9-.6-.8-1.6-2-2.8-3.4-2.5-2.8-6-6.6-10.2-10.3-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3-1.2 1.4-2.2 2.6-2.8 3.4-.3.4-.6.7-.7.9l-.2.2c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8 9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8 0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8zM68.7 299.3l51.3 51.3c2.6 2.6 2.6 6.8 0 9.4s-6.8 2.6-9.4 0l-67.3-67.3c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L88 382.6c2.6 2.6 2.6 6.8 0 9.4s-6.8 2.6-9.4 0l-51.3-51.3c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L56 414.6c2.6 2.6 2.6 6.8 0 9.4s-6.8 2.6-9.4 0l-19.3-19.3c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l56.8 56.8C79.3 502 103.6 512 128.8 512c52.6 0 95.2-42.6 95.2-95.2v-86.4c0-11-9-20-20-20s-20 9-20 20v19.7c0 7.1-8.6 10.7-13.7 5.7l-79-79c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6zm502.6 0c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-79 79c-5 5-13.7 1.5-13.7-5.7v-19.6c0-11-9-20-20-20s-20 9-20 20v86.4c0 52.6 42.6 95.2 95.2 95.2 25.2 0 49.5-10 67.3-27.9l56.8-56.8c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L593.4 424c-2.6 2.6-6.8 2.6-9.4 0s-2.6-6.8 0-9.4l51.3-51.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L561.4 392c-2.6 2.6-6.8 2.6-9.4 0s-2.6-6.8 0-9.4l67.3-67.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L529.4 360c-2.6 2.6-6.8 2.6-9.4 0s-2.6-6.8 0-9.4l51.3-51.3z"
        }
    ]
};

const FasFaceSmirking = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceSmirking",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm96-48c0 8.8 7.2 16 16 16h32c0 17.7 14.3 32 32 32s32-14.3 32-32-14.3-32-32-32h-64c-8.8 0-16 7.2-16 16zm279.8 130.6c1.5-8.7-4.4-17-13.2-18.4s-17 4.4-18.4 13.2l-.2 1.2c-3.2 19.3-19.9 33.4-39.5 33.4H192c-8.8 0-16 7.2-16 16s7.2 16 16 16h112.6c35.2 0 65.2-25.4 71-60.2l.2-1.2zM288 208c0 8.8 7.2 16 16 16h32c0 17.7 14.3 32 32 32s32-14.3 32-32-14.3-32-32-32h-64c-8.8 0-16 7.2-16 16z"
        }
    ]
};

const FasFaceSpiralEyes = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceSpiralEyes",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm56.9-137.1 14.8-9.9c14.3-9.6 32.7-10.7 48.1-3l15.4 7.7c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-15.4-7.7c-5.1-2.6-11.3-2.2-16 1l-14.8 9.9c-16.1 10.7-37.1 10.7-53.3 0l-12.5-8.3c-5.4-3.6-12.4-3.6-17.8 0l-12.5 8.3c-16.1 10.7-37.1 10.7-53.3 0l-14.8-9.9c-4.8-3.2-10.9-3.6-16-1l-15.4 7.7c-7.9 4-17.5.7-21.5-7.2s-.7-17.5 7.2-21.5l15.4-7.7c15.4-7.7 33.8-6.6 48.1 3l14.8 9.9c5.4 3.6 12.4 3.6 17.8 0l12.5-8.3c16.1-10.7 37.1-10.7 53.3 0l12.5 8.3c5.4 3.6 12.4 3.6 17.8 0zm-147-263.3c.3 6.6-4.9 12.2-11.5 12.5-46.9 1.9-82.2 45-78.1 84.3v.6c2 40.2 40.8 70.7 76.2 66.7h.6c36.3-2 62.1-35.7 58.4-64.5v-.6c-2.1-29.8-31.3-51-56-47.5h-.6c-25.7 2.2-42 26.2-38.9 44.5l.1.4v.4c2.1 19.5 21.5 31.3 35.5 28.6l.3-.1h.3c15.2-2.1 22-16.3 19.9-24l-.1-.4-.1-.4c-.9-4.3-3.4-7.4-6.5-9.2-.9-.5-1.8-.9-2.6-1.2 1.7 1.9 2.8 4.2 3 6.9 1 11.1-8.8 15.8-14.1 16.4-6.6.8-13.4-2.2-17.6-8.5-5-6.8-4.4-15.6-1.8-21.8 2.9-7 8.9-13.2 17.8-16 9.2-3.3 19.4-1.3 27.5 3.3 8.3 4.9 15.5 13.4 17.9 24.8 5.8 22.8-11.9 49.5-39.5 53.6-27.7 5.3-59.8-16.2-63.6-49.2-5.4-33 21.9-68.7 60.3-72.1 38.2-5.2 79.6 25.8 82.9 69.3 5.4 43.3-31.5 88.2-80.6 91.2-48.8 5.3-99.6-35.2-102.5-89.1-5.5-53.8 41.1-108.1 101-110.5 6.6-.3 12.2 4.9 12.5 11.5zM357.6 292c46.9-1.9 82.2-45 78.1-84.3v-.6c-2-40.2-40.8-70.7-76.2-66.7h-.6c-36.3 2-62.1 35.7-58.4 64.5v.6c2.1 29.8 31.3 51 56 47.5h.6c25.7-2.2 42-26.2 38.9-44.5l-.1-.4v-.4c-2.1-19.5-21.5-31.3-35.5-28.6l-.3.1h-.3c-15.2 2.1-21.9 16.3-19.9 24l.1.4.1.4c.9 4.3 3.4 7.4 6.5 9.2.9.5 1.8.9 2.6 1.2-1.7-1.9-2.8-4.2-3-6.9-1-11.1 8.8-15.8 14.1-16.4 6.6-.8 13.4 2.2 17.6 8.5 5 6.8 4.4 15.6 1.8 21.8-2.9 7-8.9 13.2-17.8 16-9.2 3.3-19.4 1.3-27.5-3.3-8.3-4.9-15.5-13.4-17.9-24.8-5.8-22.8 11.9-49.5 39.5-53.6 27.7-5.3 59.8 16.2 63.6 49.2 5.4 33-21.9 68.7-60.3 72.1-38.2 5.2-79.6-25.8-82.9-69.3-5.4-43.3 31.5-88.2 80.6-91.2 48.8-5.3 99.6 35.2 102.5 89.1 5.5 53.8-41.1 108.1-101 110.5-6.6.3-12.2-4.9-12.5-11.5s4.9-12.2 11.5-12.5z"
        }
    ]
};

const FasFaceSunglasses = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceSunglasses",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512c141.4 0 256-114.6 256-256 0-16.6-1.6-32.8-4.6-48.5l2.6-15.7c7.9-47.6-20.5-91.8-63.3-106.6C399.8 32.9 331.8 0 256 0S112.2 32.9 65.3 85.2C22.4 100-6 144.2 2 191.8l2.6 15.7C1.6 223.2 0 239.4 0 256c0 141.4 114.6 256 256 256zm-72.7-240h-78.6c-23.5 0-43.5-17-47.3-40.1l-8-48C44.4 154.6 67 128 96.7 128h94.7c14.4 0 27.1 6.2 35.8 16H285c8.7-9.8 21.4-16 35.8-16h94.7c29.7 0 52.2 26.6 47.3 55.9l-8 48c-4 23.1-24 40.1-47.5 40.1h-78.6c-23.5 0-43.5-17-47.3-40.1l-8-48c-.4-2.7-.7-5.3-.7-7.9h-33.4c0 2.6-.2 5.2-.7 7.9l-8 48c-3.8 23.1-23.8 40.1-47.3 40.1zm-19.2 69.5C182 362.2 212.6 384 256 384s74-21.8 91.9-42.5c5.8-6.7 15.9-7.4 22.6-1.6s7.4 15.9 1.6 22.6c-22.3 25.6-61 53.5-116.1 53.5s-93.8-27.9-116.1-53.5c-5.8-6.7-5.1-16.8 1.6-22.6s16.8-5.1 22.6 1.6z"
        }
    ]
};

const FasFaceSurprise = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceSurprise",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-79.6-336a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1-64 0zM256 288a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"
        }
    ]
};

const FasFaceSwear = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceSwear",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 0C178.6 0 64 114.6 64 256h512C576 114.6 461.4 0 320 0zm-79.6 224c-17.7 0-32-14.3-32-32 0-8.8 3.6-16.8 9.3-22.6L187 159.2c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1l96 32c8.4 2.8 12.9 11.9 10.1 20.2S291.3 194 283 191.2l-10.9-3.6c.2 1.5.3 2.9.3 4.4 0 17.7-14.3 32-32 32zm192-32c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-1.6.1-3.2.3-4.7l-11.7 3.9c-8.4 2.8-17.4-1.7-20.2-10.1s1.7-17.4 10.1-20.2l96-32c8.4-2.8 17.4 1.7 20.2 10.1s-1.7 17.4-10.1 20.2l-30.2 10.1c5.9 5.8 9.5 13.9 9.5 22.8zM48 288c-26.5 0-48 21.5-48 48v128c0 26.5 21.5 48 48 48h544c26.5 0 48-21.5 48-48V336c0-26.5-21.5-48-48-48H48zm352 96h-16v32h16c8.8 0 16 7.2 16 16s-7.2 16-16 16h-16v16c0 8.8-7.2 16-16 16s-16-7.2-16-16v-16h-32v16c0 8.8-7.2 16-16 16s-16-7.2-16-16v-16h-16c-8.8 0-16-7.2-16-16s7.2-16 16-16h16v-32h-16c-8.8 0-16-7.2-16-16s7.2-16 16-16h16v-16c0-8.8 7.2-16 16-16s16 7.2 16 16v16h32v-16c0-8.8 7.2-16 16-16s16 7.2 16 16v16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16zm-80 0v32h32v-32h-32zm250.4-52.1c6.7 5.8 7.5 15.8 1.7 22.6l-96 112c-5.8 6.7-15.8 7.5-22.6 1.7s-7.5-15.8-1.7-22.6l96-112c5.8-6.7 15.8-7.5 22.6-1.7zM448 352a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm104 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM208 320c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16v-64c0-8.8 7.2-16 16-16zm-24 136a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm-56-120v1.8c4.6.8 8.7 1.7 12.1 2.6 8.5 2.3 13.6 11 11.3 19.6s-11 13.6-19.6 11.3c-7.9-2.1-18.5-3.9-26.8-2.9-4.1.5-6.3 1.4-7.4 2.2-.6.4-1.2.9-1.5 2.9-.2 1-.1 1.6-.1 1.8.1.1.5.6 1.5 1.3 3.7 2.5 9.6 4.4 19.2 7.3l.7.2c8 2.4 19.1 5.8 27.6 11.9 4.7 3.4 9.3 8.2 12.1 14.7 2.9 6.6 3.4 13.8 2.2 21.1-2 11.5-7.9 20.5-17 25.9-4.9 3-10.1 4.6-15.3 5.4v.8c0 8.8-7.2 16-16 16s-16-7.2-16-16v-3c-8.1-1.9-15.3-4.2-20.2-5.9-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1c9.5 3.2 21.9 6.9 32 7.1 5 .1 7.6-.8 8.8-1.5.5-.3 1.4-.9 2-4 .2-1.2.2-1.9.2-2.3 0-.4-.1-.6-.1-.6 0-.1-.3-.6-1.6-1.6-3.5-2.5-9.3-4.6-18.7-7.4l-1.5-.4c-7.7-2.3-18.3-5.5-26.4-11-4.7-3.2-9.4-7.7-12.4-14.1-3.1-6.5-3.7-13.7-2.5-20.9 1.8-10.2 7-18.1 14.5-23.5 5.3-3.8 11.2-5.9 16.9-7V336c0-8.8 7.2-16 16-16s16 7.2 16 16zm-31.9 39.4a.1.1 0 1 0 .1-.1.1.1 0 1 0-.1.1z"
        }
    ]
};

const FasFaceThermometer = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceThermometer",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M544 256c0 141.4-114.6 256-256 256S32 397.4 32 256 146.6 0 288 0c112 0 207.2 72 242 172.2-14-4.1-29.8-.7-41 10.2l-150.8 146c-14.9-5.2-31.6-8.4-50.2-8.4-55.1 0-93.8 27.9-116.1 53.5-5.8 6.7-5.1 16.8 1.6 22.6s16.8 5.1 22.6-1.6C214 373.8 244.6 352 288 352s74 21.8 91.9 42.5c5.8 6.7 15.9 7.4 22.6 1.6 5.2-4.5 6.8-11.6 4.5-17.7l9.4-9-24.8-24.8c-4.7-4.7-4.7-12.3 0-17s12.3-4.7 17 0l25.1 25.1 15.3-14.8-25.4-25.4c-4.7-4.7-4.7-12.3 0-17s12.3-4.7 17 0l25.7 25.7 15.3-14.8-26-26c-4.7-4.7-4.7-12.3 0-17s12.3-4.7 17 0l26.3 26.3 15.2-14.7-26.6-26.6c-4.7-4.7-4.7-12.3 0-17s12.3-4.7 17 0l26.9 26.9 12.5-12c.1 3.2.2 6.4.2 9.6zm-303.6-48a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FasFaceThinking = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceThinking",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 256c0 141.4-114.6 256-256 256-10.6 0-21.1-.6-31.4-1.9 4-5.7 7.3-12 9.8-18.8l21-57.7 35.8-13c23.9-8.7 38.3-32 36.8-56.1-1.3-24.4-16.5-46.1-39.2-55.6l-122.6-51.6c-8.1-3.4-17.5.4-21 8.5s.4 17.5 8.5 21l82.4 34.7L144 355v-3c0-30.9-25.1-56-56-56s-56 25.1-56 56v28C11.6 343.3 0 301 0 256 0 114.6 114.6 0 256 0s256 114.6 256 256zm-303.6-80a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm128 48a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM143 121.9c23.5-13.4 52.9-10.6 73.4 7l13.2 11.3c6.7 5.8 16.8 5 22.6-1.7s5-16.8-1.7-22.6l-13.2-11.3c-30.9-26.5-75-30.6-110.2-10.5l-7.1 4c-7.7 4.4-10.3 14.2-6 21.8s14.2 10.3 21.8 6l7.1-4zM112 352v48.6l151.8-55.2c12.5-4.5 26.2 1.9 30.8 14.4s-1.9 26.2-14.4 30.8l-49.8 18.1-26.1 71.7c-6.9 19-24.9 31.6-45.1 31.6H112c-26.5 0-48-21.5-48-48V352c0-13.3 10.7-24 24-24s24 10.7 24 24z"
        }
    ]
};

const FasFaceTired = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceTired",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-91.3-183.3c22-22 53.9-40.7 91.3-40.7s69.3 18.7 91.3 40.7c11.1 11.1 20.1 23.4 26.4 35.4 6.2 11.7 10.3 24.4 10.3 35.9 0 5.2-2.6 10.2-6.9 13.2s-9.8 3.7-14.7 1.8l-20.5-7.7C315 397.2 286.4 392 257.6 392h-3.2c-28.8 0-57.3 5.2-84.3 15.3l-20.5 7.7c-4.9 1.8-10.4 1.2-14.7-1.8s-6.9-7.9-6.9-13.2c0-11.6 4.2-24.2 10.3-35.9 6.3-12 15.3-24.3 26.4-35.4zm-31.2-182 89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5 0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6 0-9 9.6-14.7 17.5-10.5zM396 157.1c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6 0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5z"
        }
    ]
};

const FasFaceTissue = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceTissue",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 256c0 141.4-114.6 256-256 256-11.5 0-22.9-.8-34-2.2.6-1.9 1-3.9 1.4-5.9l18.4-110.2 5.4 3.6c5.4 3.6 12.4 3.6 17.8 0l39-26.1 39.1 26.1c4.8 3.2 10.9 3.6 16 1l32-16c7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2l-23.7 11.8-40.3-26.8c-5.4-3.6-12.4-3.6-17.8 0l-39 26.2-8.5-5.7 7.9-47.2c2.5-15.3-2.4-30.9-13.4-41.8s-26.5-16-41.8-13.4l-192 32c-2 .3-4 .8-5.9 1.4C.8 278.9 0 267.5 0 256 0 114.6 114.6 0 256 0s256 114.6 256 256zM133.5 130.7c-7.9-4.2-17.5 1.5-17.5 10.5 0 2.8 1 5.5 2.8 7.6l36 43.2-36 43.2c-1.8 2.1-2.8 4.8-2.8 7.6 0 9 9.6 14.7 17.5 10.5l89.9-47.9c10.7-5.7 10.7-21.1 0-26.8l-89.9-47.9zM396 141.1c0-9-9.6-14.7-17.5-10.5l-89.9 47.9c-10.7 5.7-10.7 21.1 0 26.8l89.9 47.9c7.9 4.2 17.5-1.5 17.5-10.5 0-2.8-1-5.5-2.8-7.6l-36-43.2 36-43.2c1.8-2.1 2.8-4.8 2.8-7.6zM219.3 292.7c3.7 3.7 5.3 8.8 4.5 13.9l-32 192c-1.1 6.7-6.3 11.9-13 13.1s-13.4-1.9-16.7-7.8l-26-45.5-84.2 21.1c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l21.1-84.2-45.5-26c-5.9-3.4-9-10-7.8-16.7s6.4-11.9 13.1-13l192-32c5.1-.8 10.3.8 13.9 4.5z"
        }
    ]
};

const FasFaceTongueMoney = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceTongueMoney",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 256c0 108.6 67.7 201.5 163.1 238.6-12-17.8-19.1-39.4-19.1-62.6v-10.5c-22.4-20.1-39-46.1-47.2-75.4-3.8-13.7 7.4-26.1 21.6-26.1h275.2c14.2 0 25.5 12.4 21.6 26.1-8.2 29.4-24.9 55.4-47.2 75.4V432c0 23.2-7.1 44.8-19.1 62.6C444.3 457.5 512 364.6 512 256 512 114.6 397.4 0 256 0S0 114.6 0 256zm192-152v9.8c4.6.8 8.7 1.8 12.1 2.7 8.5 2.3 13.6 11 11.3 19.6s-11 13.6-19.6 11.3c-8.3-2.2-18.8-4-27-3.2-4 .4-6.1 1.4-7.1 2.1-2.6 1.9-2.6 5.6-.2 7.2 6.9 4.8 15 6.9 23.3 9.1 8.3 2.2 16.7 4.4 23.9 9.4 4.8 3.3 9.5 8 12.4 14.6 3 6.6 3.5 13.9 2.2 21.2-2 11.5-7.9 20.4-17 25.9-4.6 2.8-9.5 4.4-14.4 5.2v9.1c0 8.8-7.2 16-16 16s-16-7.2-16-16v-10.8c-8.4-1.9-16-4.4-21.1-6-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1c9.5 3.1 21.9 6.9 32 7.1 5 .1 7.6-.8 8.8-1.5 2.8-1.7 3.2-6.2.6-8-3.5-2.4-9.3-4.3-18.8-7l-1.1-.3c-7.9-2.2-18.8-5.4-27.2-11.2-4.8-3.3-9.5-8-12.4-14.6-3-6.6-3.5-13.9-2.2-21.2 1.8-10.2 6.9-18.2 14.4-23.6 5.3-3.9 11.3-6 17-7.1V104c0-8.8 7.2-16 16-16s16 7.2 16 16zm144-16c8.8 0 16 7.2 16 16v9.8c4.6.8 8.7 1.8 12.1 2.7 8.5 2.3 13.6 11 11.3 19.6s-11 13.6-19.6 11.3c-8.3-2.2-18.8-4-27-3.2-4 .4-6.1 1.4-7.1 2.1-2.6 1.9-2.6 5.6-.2 7.2 6.9 4.8 15 6.9 23.3 9.1 8.3 2.2 16.7 4.4 23.9 9.4 4.8 3.3 9.5 8 12.4 14.6 3 6.6 3.5 13.9 2.2 21.2-2 11.5-7.9 20.4-17 25.9-4.6 2.8-9.5 4.4-14.4 5.2v9.1c0 8.8-7.2 16-16 16s-16-7.2-16-16v-10.8c-8.4-1.9-16-4.4-21.1-6-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1c9.5 3.1 21.9 6.9 32 7.1 5 .1 7.6-.8 8.8-1.5 2.8-1.7 3.2-6.2.6-8-3.5-2.4-9.3-4.3-18.8-7l-1.1-.3c-7.9-2.2-18.8-5.4-27.2-11.2-4.8-3.3-9.5-8-12.4-14.6-3-6.6-3.5-13.9-2.2-21.2 1.8-10.2 6.9-18.2 14.4-23.6 5.3-3.9 11.3-6 17-7.1V104c0-8.8 7.2-16 16-16zm0 264H176v80c0 44.2 35.8 80 80 80s80-35.8 80-80v-80zm-80 16c5.9 0 10.7 4.9 10.7 10.9v6.7c3 .6 5.8 1.2 8.1 1.8 5.7 1.6 9.1 7.5 7.6 13.3s-7.4 9.3-13 7.7c-5.5-1.5-12.6-2.8-18-2.2-2.7.3-4.1.9-4.7 1.4-1.7 1.3-1.7 3.8-.2 4.9 4.6 3.3 10 4.7 15.5 6.2 5.6 1.5 11.2 3 15.9 6.4 3.2 2.3 6.3 5.5 8.3 9.9 2 4.5 2.3 9.4 1.5 14.4-1.3 7.8-5.3 13.9-11.3 17.7-3.1 1.9-6.4 3-9.6 3.6v6.1c0 6-4.8 10.9-10.7 10.9s-10.7-4.9-10.7-10.9v-7.3c-5.6-1.3-10.7-3-14-4.1-5.6-1.9-8.6-8.1-6.8-13.8s7.9-8.8 13.5-6.9c6.3 2.1 14.6 4.7 21.3 4.8 3.3.1 5.1-.5 5.9-1 1.8-1.1 2.1-4.3.4-5.5-2.3-1.7-6.2-2.9-12.6-4.8l-.8-.2c-5.2-1.5-12.6-3.7-18.1-7.6-3.2-2.3-6.3-5.5-8.3-9.9-2-4.5-2.3-9.4-1.5-14.4 1.2-6.9 4.6-12.4 9.6-16.1 3.6-2.6 7.5-4.1 11.3-4.9v-6.4c0-6 4.8-10.9 10.7-10.9z"
        }
    ]
};

const FasFaceTongueSweat = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceTongueSweat",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M544 256c0 112.9-73.1 208.7-174.5 242.8C378.7 484 384 466.6 384 448v-31.3c10.2-7.2 16-15.7 16-24.7 0-26.5-50.1-48-112-48s-112 21.5-112 48c0 9 5.8 17.5 16 24.7V448c0 18.6 5.3 36 14.5 50.8-41.3-13.9-78-38-106.9-69.4C116.9 415 128 393.5 128 369c0-11.4-3.8-22.4-7.1-30.5-3.7-8.7-8.4-17.6-13.2-25.7-9.6-16.1-20.7-31.5-27.7-40.7-11.6-15.6-31.7-19.9-48-12.8V256C32 114.6 146.6 0 288 0s256 114.6 256 256zM96 369c0 14.2-6.4 26.9-16.5 35.5C71 411.7 60 416 48 416c-26.5 0-48-21-48-47 0-17.3 21.4-50 35.7-69.7 2.2-3 4.2-5.8 5.9-8.1 3.2-4.4 9.6-4.4 12.8 0C67.6 308.6 96 349 96 369zm239.6-97a32 32 0 1 0 64 0 32 32 0 1 0-64 0zm-128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm19.7-155.3c-6.2-6.2-16.4-6.2-22.6 0l-7.4 7.4c-18.9 18.9-43.2 31.4-69.5 35.7l-2.5.4c-8.7 1.5-14.6 9.7-13.2 18.4s9.7 14.6 18.4 13.2l2.5-.4c32.9-5.5 63.3-21.1 86.8-44.7l7.4-7.4c6.2-6.2 6.2-16.4 0-22.6zm121.4 22.6 7.4 7.4c23.6 23.6 53.9 39.2 86.8 44.7l2.5.4c8.7 1.5 17-4.4 18.4-13.2s-4.4-17-13.2-18.4l-2.5-.4c-26.3-4.4-50.6-16.9-69.5-35.7l-7.4-7.4c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6zm3.3 231.3V448c0 35.3-28.7 64-64 64s-64-28.7-64-64v-45.4c0-14.7 11.9-26.6 26.6-26.6h2c11.3 0 21.1 7.9 23.6 18.9 2.8 12.6 20.8 12.6 23.6 0 2.5-11.1 12.3-18.9 23.6-18.9h2c14.7 0 26.6 11.9 26.6 26.6z"
        }
    ]
};

const FasFaceUnamused = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceUnamused",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm60.1-117.3c-11.7-13-31.6-26.7-60.1-26.7s-48.4 13.7-60.1 26.7c-5.9 6.6-16 7.1-22.6 1.2s-7.1-16-1.2-22.6c16.1-17.9 44.2-37.3 83.9-37.3s67.8 19.4 83.9 37.3c5.9 6.6 5.4 16.7-1.2 22.6s-16.7 5.4-22.6-1.2zM112 192h64c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32h-32c-8.8 0-16-7.2-16-16s7.2-16 16-16zm176 16c0-8.8 7.2-16 16-16h64c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32h-32c-8.8 0-16-7.2-16-16z"
        }
    ]
};

const FasFaceViewfinder = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceViewfinder",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M56 0h80c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-4.4 0-8 3.6-8 8v80c0 13.3-10.7 24-24 24S0 149.3 0 136V56C0 25.1 25.1 0 56 0zm320 0h80c30.9 0 56 25.1 56 56v80c0 13.3-10.7 24-24 24s-24-10.7-24-24V56c0-4.4-3.6-8-8-8h-80c-13.3 0-24-10.7-24-24s10.7-24 24-24zM48 376v80c0 4.4 3.6 8 8 8h80c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-30.9 0-56-25.1-56-56v-80c0-13.3 10.7-24 24-24s24 10.7 24 24zm464 0v80c0 30.9-25.1 56-56 56h-80c-13.3 0-24-10.7-24-24s10.7-24 24-24h80c4.4 0 8-3.6 8-8v-80c0-13.3 10.7-24 24-24s24 10.7 24 24zM96 256a160 160 0 1 1 320 0 160 160 0 1 1-320 0zm128-40a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm88 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-142.1 52.5c-6.4 6.1-6.6 16.2-.5 22.6C191.2 337.8 222 352 256 352s64.8-14.2 86.6-36.9c6.1-6.4 5.9-16.5-.5-22.6s-16.5-5.9-22.6.5c-16 16.6-38.5 27-63.5 27s-47.5-10.4-63.5-27.1c-6.1-6.4-16.2-6.6-22.6-.5z"
        }
    ]
};

const FasFaceVomit = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceVomit",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M544 256c0 72.5-30.1 137.9-78.5 184.5l-16.7-5.6c-11.9-4-21.5-12.3-27.2-22.9 16.7-12.6 26.4-27.7 26.4-44 0-44.2-71.6-80-160-80s-160 35.8-160 80c0 16.3 9.7 31.4 26.4 44-5.7 10.6-15.2 19-27.2 22.9l-16.7 5.6C62.1 393.9 32 328.5 32 256 32 114.6 146.6 0 288 0s256 114.6 256 256zM148 141.1c0 2.8 1 5.5 2.8 7.6l36 43.2-36 43.2c-1.8 2.1-2.8 4.8-2.8 7.6 0 9 9.6 14.7 17.5 10.5l89.9-47.9c10.7-5.7 10.7-21.1 0-26.8l-89.9-47.9c-7.9-4.2-17.5 1.5-17.5 10.5zm262.5-10.5-89.9 47.9c-10.7 5.7-10.7 21.1 0 26.8l89.9 47.9c7.9 4.2 17.5-1.5 17.5-10.5 0-2.8-1-5.5-2.8-7.6l-36-43.2 36-43.2c1.8-2.1 2.8-4.8 2.8-7.6 0-9-9.6-14.7-17.5-10.5zM32 448a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm480 0a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm-320-51.9v-57.4c23.6-11.1 57.3-18.7 96-18.7s72.4 7.6 96 18.7v57.4c0 31 19.8 58.5 49.2 68.3l34.1 11.4c7.6 2.5 12.7 9.6 12.7 17.6 0 10.3-8.3 18.6-18.6 18.6H114.6c-10.3 0-18.6-8.3-18.6-18.6 0-8 5.1-15.1 12.7-17.6l34.1-11.4c29.4-9.8 49.2-37.3 49.2-68.3zM304 384a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm-48 48a16 16 0 1 0-32 0 16 16 0 1 0 32 0z"
        }
    ]
};

const FasFaceWeary = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceWeary",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-91.3-183.3c22-22 53.9-40.7 91.3-40.7s69.3 18.7 91.3 40.7c11.1 11.1 20.1 23.4 26.4 35.4 6.2 11.7 10.3 24.4 10.3 35.9 0 5.2-2.6 10.2-6.9 13.2s-9.8 3.7-14.7 1.8l-20.5-7.7C315 397.2 286.4 392 257.6 392h-3.2c-28.8 0-57.3 5.2-84.3 15.3l-20.5 7.7c-4.9 1.8-10.4 1.2-14.7-1.8s-6.9-7.9-6.9-13.2c0-11.6 4.2-24.2 10.3-35.9 6.3-12 15.3-24.3 26.4-35.4zm46.6-164c6.2 6.2 6.2 16.4 0 22.6l-7.4 7.4a159.96 159.96 0 0 1-86.8 44.7l-2.5.4c-8.7 1.5-17-4.4-18.4-13.2s4.4-17 13.2-18.4l2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4c6.2-6.2 16.4-6.2 22.6 0zm89.4 22.6c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5.4c8.7 1.5 14.6 9.7 13.2 18.4s-9.7 14.6-18.4 13.2l-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4z"
        }
    ]
};

const FasFaceWoozy = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceWoozy",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm155.3-164.7L372 386.6a73.114 73.114 0 0 1-51.7 21.4c-13.7 0-27.1-3.8-38.7-11.1l-14.2-8.9a67.216 67.216 0 0 0-60.7-5.4c-30.4 12.2-64.8 8.6-92-9.6l-11.5-7.7c-7.4-4.9-9.3-14.8-4.4-22.2s14.8-9.3 22.2-4.4l11.5 7.7a67.53 67.53 0 0 0 62.4 6.5c29.4-11.8 62.7-8.8 89.6 8l14.2 8.9c6.5 4.1 14.1 6.2 21.8 6.2 10.9 0 21.3-4.3 29-12l39.3-39.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zM200.9 98.7c7.4 4.9 9.3 14.8 4.4 22.2-28 42-69.6 64.1-88.3 70.3-8.4 2.8-17.4-1.7-20.2-10.1s1.7-17.4 10.1-20.2c13.4-4.5 48.5-22.9 71.7-57.7 4.9-7.4 14.8-9.3 22.2-4.4zm22.6 121.4c2.1 8.6-3.1 17.3-11.6 19.4l-64 16c-8.6 2.1-17.3-3.1-19.4-11.6s3.1-17.3 11.6-19.4l64-16c8.6-2.1 17.3 3.1 19.4 11.6zM336 272c-17.7 0-32-28.7-32-64s14.3-64 32-64 32 28.7 32 64-14.3 64-32 64z"
        }
    ]
};

const FasFaceWorried = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceWorried",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-73.6-97.5c-12.4 5.2-26.5-4.1-21.1-16.4 16-36.6 52.4-62.1 94.8-62.1s78.8 25.6 94.8 62.1c5.4 12.3-8.7 21.6-21.1 16.4-22.4-9.5-47.4-14.8-73.7-14.8s-51.3 5.3-73.7 14.8zm-38-142.5a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM192 160c-4.4 0-8.8.3-13 .9-21.2 2.8-40.6 12.4-56.1 26.8-6.5 6-16.6 5.7-22.6-.8s-5.7-16.6.8-22.6c20.1-18.7 45.5-31.5 73.7-35.2 5.6-.7 11.4-1.1 17.2-1.1 8.8 0 16 7.2 16 16s-7.2 16-16 16zm141 .9c-4.3-.6-8.6-.9-13-.9-8.8 0-16-7.2-16-16s7.2-16 16-16c5.8 0 11.6.4 17.2 1.1 28.2 3.7 53.7 16.4 73.7 35.2 6.5 6 6.8 16.2.8 22.6s-16.2 6.8-22.6.8c-15.5-14.5-34.8-24-56.1-26.8z"
        }
    ]
};

const FasFaceZany = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceZany",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384.1 477.7C506.5 407 548.5 250.4 477.8 128S250.5-36.4 128.1 34.3-36.3 261.6 34.4 384c36.2 62.7 94.9 104.3 160.1 120.5-11.5-15.8-18.4-35.4-18.4-56.5v-39.8c-10.4-6.2-20.1-13.7-28.9-22.2-10.2-9.9-6.6-26.3 5.7-33.4l238.3-137.7c12.3-7.1 28.3-2 31.8 11.8 15.2 59.4-5.9 124.1-55 165V448c0 15.4-3.6 30-10.1 42.9 8.8-3.8 17.5-8.2 26.1-13.2zM128 160a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm112-8a72 72 0 1 1 144 0 72 72 0 1 1-144 0zm96.1 296v-45.4c0-14.7-11.9-26.6-26.6-26.6h-2c-11.3 0-21.1 7.9-23.6 18.9-2.8 12.6-20.8 12.6-23.6 0-2.5-11-12.3-18.9-23.6-18.9h-2c-14.7 0-26.6 11.9-26.6 26.6V448c0 35.3 28.7 64 64 64s64-28.7 64-64zM152 224a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm144-56a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FasFaceZipper = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaceZipper",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M492.4 354.4C505 324.1 512 290.9 512 256 512 114.6 397.4 0 256 0S0 114.6 0 256s114.6 256 256 256c50.3 0 97.2-14.5 136.7-39.5-1.1-1.8-2.2-3.7-3.1-5.7l-29.1-58.1c-9.2-18.5-5.6-40.8 9-55.4l15.7-15.7c14.6-14.6 36.9-18.2 55.4-9l51.8 25.9zM176.4 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1-64 0zM144 336v32c0 8.8-7.2 16-16 16s-16-7.2-16-16v-32c0-8.8 7.2-16 16-16s16 7.2 16 16zm48-16c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16s-16-7.2-16-16v-32c0-8.8 7.2-16 16-16zm80 16v32c0 8.8-7.2 16-16 16s-16-7.2-16-16v-32c0-8.8 7.2-16 16-16s16 7.2 16 16zm48-16c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16s-16-7.2-16-16v-32c0-8.8 7.2-16 16-16zm98.2 132.4c14.7 29.3 53.7 35.6 76.9 12.5l1.8-1.8c23.2-23.2 16.8-62.2-12.5-76.9l-58.1-29.1c-6.2-3.1-13.6-1.9-18.5 3l-15.7 15.7c-4.9 4.9-6.1 12.3-3 18.5l29.1 58.1zm62.3-36.9c4.7 4.7 4.7 12.3 0 17l-16 16c-4.7 4.7-12.3 4.7-17 0s-4.7-12.3 0-17l16-16c4.7-4.7 12.3-4.7 17 0z"
        }
    ]
};

const FasFalafel = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFalafel",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M166.6 162.5c5.9 7.1 8 16.7 5.7 25.7-.3 1.3-.6 2.6-.7 3.9 17.2.6 33.9 8.6 45.1 22.8 28.3.2 52.1 20.3 58.1 47.4 4.8 2.4 9.2 5.4 13.1 8.8 3.9-3.4 8.3-6.4 13.1-8.8 6-27.1 29.8-47.1 58.1-47.4 17.3-21.9 47.4-29.2 72.8-17 1.5-.7 3-1.4 4.5-1.9.1-2.6-.2-5.2-.9-7.8-2.3-9-.1-18.6 5.7-25.7 8.8-10.7 8.8-26.3 0-37-5.9-7.1-8-16.7-5.7-25.7 3.4-13.5-3.2-27.6-15.7-33.3-8.3-3.8-14.3-11.5-16.1-20.6-2.7-13.7-14.6-23.5-28.3-23.1-9.1.3-17.8-4-23.2-11.4C344 .3 329.1-3.2 316.9 3.2c-8.1 4.3-17.7 4.3-25.8 0-12.2-6.4-27.1-2.9-35.3 8.2-5.5 7.4-14.1 11.7-23.2 11.4-13.7-.4-25.7 9.4-28.3 23.1-1.8 9.1-7.8 16.8-16.1 20.6-12.5 5.7-19.2 19.8-15.7 33.3 2.3 9 .1 18.6-5.7 25.7-8.8 10.7-8.8 26.3 0 37zm48.8 84.4c-3.6.1-7.2-.5-10.5-1.8-5-1.9-9.4-5.2-12.7-9.6-8.2-11.2-23.2-14.6-35.3-8.2-8.1 4.3-17.7 4.3-25.8 0-12.2-6.4-27.1-2.9-35.3 8.2-5.5 7.4-14.1 11.7-23.2 11.4-13.7-.4-25.7 9.4-28.3 23.1-1.8 9.1-7.8 16.8-16.1 20.6-12.5 5.7-19.2 19.8-15.7 33.3 2.3 9 .1 18.6-5.7 25.7-8.8 10.7-8.8 26.3 0 37 5.9 7.1 8 16.7 5.7 25.7-3.4 13.5 3.2 27.6 15.7 33.3 8.3 3.8 14.3 11.5 16.1 20.6 2.7 13.7 14.6 23.5 28.3 23.1 9.1-.3 17.8 4 23.2 11.4 8.2 11.2 23.2 14.6 35.3 8.2 8.1-4.3 17.7-4.3 25.8 0 12.2 6.4 27.1 2.9 35.3-8.2 5.5-7.4 14.1-11.7 23.2-11.4 13.7.4 25.7-9.4 28.3-23.1 1.8-9.1 7.8-16.8 16.1-20.6 4.1-1.9 7.6-4.7 10.3-8.1-3.1-10.1-3.7-21-1.2-31.7-17.3-22.1-17.3-53.3 0-75.4-2.4-10.7-1.9-21.7 1.2-31.7-2.7-3.4-6.2-6.2-10.3-8.1-8.3-3.8-14.3-11.5-16.1-20.6-.2-1-.5-2-.8-3-3.7-12.1-14.9-20.4-27.6-20.1zM224 144a16 16 0 1 1 32 0 16 16 0 1 1-32 0zM80 352a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm-16 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm453.4-42.6c4.1-4.1 7-9.2 8.7-14.9 0-.2.1-.3.1-.5 7-25-7.6-62.8-38.6-93.7-23.3-23.3-50.5-37.4-73.1-39.9-2-.2-3.9-.4-5.8-.4-9.6-.2-18.3 1.8-25.1 6.4 0 0-.1 0-.1.1-1.6 1.1-3.1 2.3-4.5 3.6l-.5.5c-19.2 19.2-11.4 59 16.6 94.3 4 5 8.4 10 13.2 14.8 38.4 38.4 87.2 51.7 109.1 29.8zM508.6 412c-26-7.1-52.6-23.3-74.9-45.7s-38.6-48.9-45.7-74.9c-5.3-19.6-6.4-43.3 4.2-63.6-3.2 1.9-6.1 4.4-8.4 7.6-5.5 7.4-14.1 11.7-23.2 11.4-13.7-.4-25.7 9.4-28.3 23.1-1.8 9.1-7.8 16.8-16.1 20.6-12.5 5.7-19.2 19.8-15.7 33.3 2.3 9 .1 18.6-5.7 25.7-8.8 10.7-8.8 26.3 0 37 5.9 7.1 8 16.7 5.7 25.7-3.4 13.5 3.2 27.6 15.7 33.3 8.3 3.8 14.3 11.5 16.1 20.6 2.7 13.7 14.6 23.5 28.3 23.1 9.1-.3 17.8 4 23.2 11.4 8.2 11.2 23.2 14.6 35.3 8.2 8.1-4.3 17.7-4.3 25.8 0 12.2 6.4 27.1 2.9 35.3-8.2 5.5-7.4 14.1-11.7 23.2-11.4 13.7.4 25.7-9.4 28.3-23.1 1.8-9.1 7.8-16.8 16.1-20.6 12.5-5.7 19.2-19.8 15.7-33.3l-.1-.6c-18.1 6.4-38 5-54.9.4zM368 352a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm16 80a16 16 0 1 1 32 0 16 16 0 1 1-32 0z"
        }
    ]
};

const FasFamilyDress = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFamilyDress",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 0a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm-15.7 160h31.4c11.8 0 23 3.2 32.6 8.9-.2 2.3-.3 4.7-.3 7.1 0 24.3 10.9 46.1 28 60.8-35.7 18.7-60 56.1-60 99.2v16c0 28.4 12.4 54 32 71.6V480c0 6.1.8 11.9 2.4 17.5-8.7 9-20.9 14.5-34.4 14.5h-32c-26.5 0-48-21.5-48-48v-80H42.4c-21.3 0-36.6-20.3-30.8-40.8l39.1-136.8c7.8-27.5 33-46.4 61.5-46.4zM368 512c-13.5 0-25.7-5.6-34.4-14.5 1.6-5.5 2.4-11.4 2.4-17.5v-56.4c19.6-17.6 32-43.1 32-71.6v-16c0-43.1-24.3-80.5-60-99.2 17.1-14.7 28-36.5 28-60.8 0-2.4-.1-4.8-.3-7.1 9.6-5.7 20.8-8.9 32.6-8.9h31.4c28.6 0 53.7 18.9 61.5 46.4l39.1 136.8c5.8 20.4-9.5 40.8-30.8 40.8H448v80c0 26.5-21.5 48-48 48h-32zM384 0a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM256 128a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 128c44.2 0 80 35.8 80 80v16c0 23.7-12.9 44.4-32 55.4V480c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32v-72.6c-19.1-11.1-32-31.7-32-55.4v-16c0-44.2 35.8-80 80-80z"
        }
    ]
};

const FasFamilyPants = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFamilyPants",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 0a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm-22.4 160h44.8c9.2 0 18.1 1.6 26.4 4.5-.5 3.8-.8 7.6-.8 11.5 0 24.3 10.9 46.1 28 60.8-35.7 18.7-60 56.1-60 99.2v16c0 28.4 12.4 54 32 71.6V480c0 6.1.8 11.9 2.4 17.5-8.7 9-20.9 14.5-34.4 14.5h-32c-26.5 0-48-21.5-48-48V348.3c-26.5-9.5-44.7-35.8-42.2-65.6l4.1-49.3C29.3 191.9 64 160 105.6 160zM368 512c-13.5 0-25.7-5.6-34.4-14.5 1.6-5.5 2.4-11.4 2.4-17.5v-56.4c19.6-17.6 32-43.1 32-71.6v-16c0-43.1-24.3-80.5-60-99.2 17.1-14.7 28-36.5 28-60.8 0-3.9-.3-7.8-.8-11.5 8.3-2.9 17.2-4.5 26.4-4.5h44.8c41.6 0 76.3 31.9 79.7 73.4l4.1 49.3c2.5 29.8-15.7 56.1-42.2 65.6V464c0 26.5-21.5 48-48 48h-32zM384 0a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM256 128a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 128c44.2 0 80 35.8 80 80v16c0 23.7-12.9 44.4-32 55.4V480c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32v-72.6c-19.1-11.1-32-31.7-32-55.4v-16c0-44.2 35.8-80 80-80z"
        }
    ]
};

const FasFamily = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFamily",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 0a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm-22.4 160h44.8c9.2 0 18.1 1.6 26.4 4.5-.5 3.8-.8 7.6-.8 11.5 0 24.3 10.9 46.1 28 60.8-35.7 18.7-60 56.1-60 99.2v16c0 28.4 12.4 54 32 71.6V480c0 6.1.8 11.9 2.4 17.5-8.7 9-20.9 14.5-34.4 14.5h-32c-26.5 0-48-21.5-48-48V348.3c-26.5-9.5-44.7-35.8-42.2-65.6l4.1-49.3C29.3 191.9 64 160 105.6 160zM368 512c-13.5 0-25.7-5.6-34.4-14.5 1.6-5.6 2.4-11.4 2.4-17.5v-56.4c19.6-17.6 32-43.1 32-71.6v-16c0-43.1-24.3-80.5-60-99.2 17.1-14.7 28-36.5 28-60.8 0-2.4-.1-4.7-.3-7.1 9.6-5.7 20.8-8.9 32.6-8.9h31.4c28.6 0 53.7 18.9 61.5 46.4l39.1 136.8c5.8 20.4-9.5 40.8-30.8 40.8H448v80c0 26.5-21.5 48-48 48h-32zM384 0a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM256 128a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 128c44.2 0 80 35.8 80 80v16c0 23.7-12.9 44.4-32 55.4V480c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32v-72.6c-19.1-11.1-32-31.7-32-55.4v-16c0-44.2 35.8-80 80-80z"
        }
    ]
};

const FasFanTable = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFanTable",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 413.6C355.7 398.2 432 312 432 208 432 93.1 338.9 0 224 0S16 93.1 16 208c0 104 76.3 190.2 176 205.6V448H96c-17.7 0-32 14.3-32 32s14.3 32 32 32h256c17.7 0 32-14.3 32-32s-14.3-32-32-32h-96v-34.4zM184.9 68.5l39.4 97.5c18.5-25.3 50-39.8 83.3-35.1 48.1 6.8 81.7 51.3 74.9 99.4-1.2 8.8-9.3 14.8-18.1 13.6l-104.2-14.7c12.6 28.7 9.5 63.2-11.2 89.7-29.9 38.3-85.2 45.1-123.5 15.2-7-5.4-8.2-15.5-2.8-22.5l64.8-82.9c-31.2-3.4-59.5-23.4-72.1-54.5-18.2-45.1 3.6-96.3 48.7-114.5 8.2-3.3 17.5.6 20.8 8.8zM224 224a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
        }
    ]
};

const FasFan = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFan",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M258.6 0c-1.7 0-3.4.1-5.1.5C168 17 115.6 102.3 130.5 189.3c2.9 17 8.4 32.9 15.9 47.4L32 224h-2.6C13.2 224 0 237.2 0 253.4c0 1.7.1 3.4.5 5.1C17 344 102.3 396.4 189.3 381.5c17-2.9 32.9-8.4 47.4-15.9L224 480v2.6c0 16.2 13.2 29.4 29.4 29.4 1.7 0 3.4-.1 5.1-.5 85.5-16.5 137.9-101.8 123-188.8-2.9-17-8.4-32.9-15.9-47.4L480 288h2.6c16.2 0 29.4-13.2 29.4-29.4 0-1.7-.1-3.4-.5-5.1-16.5-85.5-101.8-137.9-188.8-123-17 2.9-32.9 8.4-47.4 15.9L288 32v-2.6C288 13.2 274.8 0 258.6 0zM256 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FasFarm = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFarm",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 96C0 43 43 0 96 0s96 43 96 96H0zm181.4 32-48.6 118c-3.2 7.7-4.8 16-4.8 24.4V480c0 11.7 3.1 22.6 8.6 32H48c-26.5 0-48-21.5-48-48V128h181.4zM160 480V270.3c0-4.2.8-8.3 2.4-12.2l48.9-118.7c3-7.4 8.7-13.3 15.9-16.7l127.1-60.2c8.7-4.1 18.7-4.1 27.4 0l127.1 60.2c7.2 3.4 12.9 9.4 15.9 16.7l48.9 118.7c1.6 3.9 2.4 8 2.4 12.2V480c0 17.7-14.3 32-32 32H432v-64c0-26.5-21.5-48-48-48h-32c-26.5 0-48 21.5-48 48v64H192c-17.7 0-32-14.3-32-32zm160-232v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24h-48c-13.3 0-24 10.7-24 24z"
        }
    ]
};

const FasFaucetDrip = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaucetDrip",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 0c17.7 0 32 14.3 32 32v12l96-12c17.7 0 32 14.3 32 32s-14.3 32-32 32l-96-12-31-3.9-1-.1-1 .1-31 3.9-96 12c-17.7 0-32-14.3-32-32s14.3-32 32-32l96 12V32c0-17.7 14.3-32 32-32zM0 224c0-17.7 14.3-32 32-32h96l22.6-22.6c6-6 14.1-9.4 22.6-9.4H192v-43.8l32-4 32 4V160h18.7c8.5 0 16.6 3.4 22.6 9.4L320 192h32c88.4 0 160 71.6 160 160 0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32s-14.3-32-32-32h-36.1c-20.2 29-53.9 48-91.9 48s-71.7-19-91.9-48H32c-17.7 0-32-14.3-32-32v-64zm436.8 199.4c1.9-4.5 6.3-7.4 11.2-7.4s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1v1.1c0 17.7-14.3 32-32 32s-32-14.3-32-32v-1.2c0-4.5.9-8.9 2.7-13.1l18.2-42.4z"
        }
    ]
};

const FasFaucet = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFaucet",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 96v12L96 96c-17.7 0-32 14.3-32 32s14.3 32 32 32l96-12 31-3.9 1-.1 1 .1 31 3.9 96 12c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 12V96c0-17.7-14.3-32-32-32s-32 14.3-32 32zM32 256c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h100.1c20.2 29 53.9 48 91.9 48s71.7-19 91.9-48H352c17.7 0 32 14.3 32 32s14.3 32 32 32h64c17.7 0 32-14.3 32-32 0-88.4-71.6-160-160-160h-32l-22.6-22.6c-6-6-14.1-9.4-22.6-9.4H256v-43.8l-32-4-32 4V224h-18.7c-8.5 0-16.6 3.4-22.6 9.4L128 256H32z"
        }
    ]
};

const FasFax = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFax",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 64v96h64V64h194.7L416 93.3V160h64V93.3c0-17-6.7-33.3-18.7-45.3L432 18.7C420 6.7 403.7 0 386.7 0H192c-35.3 0-64 28.7-64 64zM0 160v320c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H32c-17.7 0-32 14.3-32 32zm480 32H128v288c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32zm-224 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 32a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm32 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-160 32a32 32 0 1 1 64 0 32 32 0 1 1-64 0z"
        }
    ]
};

const FasFeatherPointed = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFeatherPointed",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M278.5 215.6 23 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l74.8-74.8c7.4 4.6 15.3 8.2 23.8 10.5 44.8 12.2 114.5 13.9 182.5-31.2 12.2-8.1 5.8-25.4-8.8-25.4h-16.1c-5.1 0-9.2-4.1-9.2-9.2 0-4.1 2.7-7.6 6.5-8.8l97.7-29.3c3.4-1 6.4-3.1 8.4-6.1 4.4-6.4 8.6-12.9 12.6-19.6 6.2-10.3-1.5-23-13.5-23H377c-5.1 0-9.2-4.1-9.2-9.2 0-4.1 2.7-7.6 6.5-8.8l80.9-24.3c4.6-1.4 8.4-4.8 10.2-9.3 29.1-73.4 42.4-150.3 46.5-199.6.8-9.9-3-19.6-10-26.6S485.2-.6 475.3.2C391.5 7 228.5 40.5 137.4 131.6c-80.1 80.1-80.7 170.7-66.1 224.8 2.1 7.9 12 9.6 17.8 3.8l164.5-164.4c6.2-6.2 16.4-6.2 22.6 0 5.4 5.4 6.1 13.6 2.2 19.8z"
        }
    ]
};

const FasFeather = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFeather",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M278.5 215.6 23 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l57-57h68c49.7 0 97.9-14.4 139-41 11.1-7.2 5.5-23-7.8-23-5.1 0-9.2-4.1-9.2-9.2 0-4.1 2.7-7.6 6.5-8.8l81-24.3c2.5-.8 4.8-2.1 6.7-4l22.4-22.4c10.1-10.1 2.9-27.3-11.3-27.3H377c-5.1 0-9.2-4.1-9.2-9.2 0-4.1 2.7-7.6 6.5-8.8l112-33.6c4-1.2 7.4-3.9 9.3-7.7 10.8-21 16.4-44.5 16.4-68.6 0-41-16.3-80.3-45.3-109.3l-5.5-5.5C432.3 16.3 393 0 352 0s-80.3 16.3-109.3 45.3L139 149c-48 48-75 113.1-75 181v55.3l189.6-189.5c6.2-6.2 16.4-6.2 22.6 0 5.4 5.4 6.1 13.6 2.2 19.8z"
        }
    ]
};

const FasFence = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFence",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M76.8 38.4c-3-4-7.8-6.4-12.8-6.4s-9.8 2.4-12.8 6.4L6.4 98.1C2.2 103.7 0 110.4 0 117.3V448c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32v-32h32v-64h-32V224h32v-64h-32v-42.7c0-6.9-2.2-13.7-6.4-19.2L76.8 38.4zm192 0c-3-4-7.8-6.4-12.8-6.4s-9.8 2.4-12.8 6.4l-44.8 59.7c-4.2 5.5-6.4 12.3-6.4 19.2V448c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32v-32h32v-64h-32V224h32v-64h-32v-42.7c0-6.9-2.2-13.7-6.4-19.2l-44.8-59.7zM448 32c-5 0-9.8 2.4-12.8 6.4l-44.8 59.7c-4.2 5.5-6.4 12.3-6.4 19.2V448c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V117.3c0-6.9-2.2-13.7-6.4-19.2l-44.8-59.7c-3-4-7.8-6.4-12.8-6.4z"
        }
    ]
};

const FasFerrisWheel = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFerrisWheel",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M302.7 36.9c27.7 5.9 53.5 16.9 76.4 31.9 6.3-3.1 13.4-4.8 20.9-4.8 26.5 0 48 21.5 48 48 0 7.5-1.7 14.6-4.8 20.9 15.1 22.9 26 48.7 31.9 76.4 21.1 5 36.9 24 36.9 46.7s-15.7 41.7-36.9 46.7c-5.9 27.7-16.9 53.5-31.9 76.4 3.1 6.3 4.8 13.4 4.8 20.9 0 25.6-20 46.4-45.1 47.9l-38.5-80c4.6-5.1 10.3-9.2 16.6-12 17.2-21.5 29-47.5 33.2-75.9h-81.9c2.4-7.6 3.7-15.6 3.7-24s-1.3-16.4-3.7-24h81.9c-3.9-26.3-14.3-50.4-29.4-70.9L326.9 219c-7.6-14.5-19.5-26.4-33.9-33.9l57.9-57.9c-20.5-15.1-44.6-25.4-70.9-29.4v81.9c-7.6-2.4-15.6-3.7-24-3.7s-16.4 1.3-24 3.7V97.8c-26.3 4-50.4 14.3-70.9 29.4l57.9 57.9c-14.5 7.6-26.4 19.5-33.9 33.9l-57.9-57.9c-15.1 20.5-25.4 44.6-29.4 70.9h81.9c-2.4 7.6-3.7 15.6-3.7 24s1.3 16.4 3.7 24H97.8c4.3 28.5 16.1 54.4 33.2 75.9 6.4 2.8 12.1 6.9 16.7 12l-38.5 80C84 446.4 64 425.6 64 400c0-7.5 1.7-14.6 4.8-20.9-15.1-22.9-26.1-48.7-31.9-76.4-21.2-5-36.9-24-36.9-46.7s15.7-41.7 36.9-46.7c5.9-27.7 16.9-53.5 31.9-76.4-3.1-6.3-4.8-13.4-4.8-20.9 0-26.5 21.5-48 48-48 7.5 0 14.6 1.7 20.9 4.8 22.9-15.1 48.7-26.1 76.4-31.9 5-21.2 24-36.9 46.7-36.9s41.7 15.7 46.7 36.9zM304 256c0 11.6-4.1 22.3-11 30.6l88.8 191.3c3.4 7.4 2.9 16.1-1.5 23s-12 11.1-20.2 11.1H152c-8.2 0-15.8-4.2-20.2-11.1s-5-15.6-1.5-23L219 286.6c-6.9-8.3-11-19-11-30.6 0-26.5 21.5-48 48-48s48 21.5 48 48z"
        }
    ]
};

const FasFerry = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFerry",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 0h128c17.7 0 32 14.3 32 32h75.1c20.6 0 31.6 24.3 18.1 39.8L456 96H120L98.8 71.8C85.3 56.3 96.3 32 116.9 32H192c0-17.7 14.3-32 32-32zM96 128h384c17.7 0 32 14.3 32 32v123.5c0 13.3-4.2 26.3-11.9 37.2l-51.4 71.9c-1.9 1.1-3.7 2.2-5.5 3.5-15.5 10.7-34 18-51 19.9h-16.6c-17.1-1.8-35-9-50.8-19.9-22.1-15.5-51.6-15.5-73.7 0-14.8 10.2-32.5 18-50.6 19.9h-16.6c-17-1.8-35.6-9.2-51-19.9-1.8-1.3-3.7-2.4-5.6-3.5l-51.4-71.9C68.2 309.8 64 296.8 64 283.5V160c0-17.7 14.3-32 32-32zm32 64v96h320v-96H128zm178.5 229.9c22.5 15.5 50 26.1 77.5 26.1 26.9 0 55.3-10.8 77.4-26.1 11.9-8.5 28.1-7.8 39.2 1.7 14.4 11.9 32.5 21 50.6 25.2 17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25-29 15.6-61.5 25.9-94.5 25.9-31.9 0-60.6-9.9-80.4-18.9-5.8-2.7-11.1-5.3-15.6-7.7-4.5 2.4-9.7 5.1-15.6 7.7-19.8 9-48.5 18.9-80.4 18.9-33 0-65.5-10.3-94.5-25.8-13.4 8.4-33.7 19.3-58.2 25-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2 11.1-9.4 27.3-10.1 39.2-1.7 22.1 15.2 50.5 26 77.4 26 27.5 0 55-10.6 77.5-26.1 11.1-7.9 25.9-7.9 37 0z"
        }
    ]
};

const FasFieldHockeyStickBall = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFieldHockeyStickBall",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M491.2 8.5c21.8 15.1 27.3 45 12.2 66.8l-52.2 75.5-79.9-53.3 53.1-76.8c15.1-21.8 45-27.3 66.8-12.2zM353.1 123.9l79.9 53.3-192 277.7c-24.6 35.5-64.9 56.8-108.1 56.9C59.5 512 .1 452.3.6 378.9v-2.2c.2-25.7 7.8-50.8 21.8-72.4l17.3-26.5c14.5-22.2 44.2-28.4 66.4-13.9s28.4 44.2 13.9 66.4l-17.3 26.5c-4 6.1-6.2 13.3-6.2 20.6v2.2c-.1 20 16 36.2 36 36.1 11.7 0 22.7-5.8 29.4-15.5l191.2-276.3zM432 352a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"
        }
    ]
};

const FasFileArrowDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFileArrowDown",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zm192 0v128h128L256 0zm-40 232v102.1l31-31c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-72 72c-9.4 9.4-24.6 9.4-33.9 0l-72-72c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l31 31V232c0-13.3 10.7-24 24-24s24 10.7 24 24z"
        }
    ]
};

const FasFileArrowUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFileArrowUp",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zm192 0v128h128L256 0zm-40 408c0 13.3-10.7 24-24 24s-24-10.7-24-24V305.9l-31 31c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l72-72c9.4-9.4 24.6-9.4 33.9 0l72 72c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-31-31V408z"
        }
    ]
};

const FasFileAudio = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFileAudio",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zm192 0v128h128L256 0zm2 226.3c37.1 22.4 62 63.1 62 109.7s-24.9 87.3-62 109.7c-7.6 4.6-17.4 2.1-22-5.4s-2.1-17.4 5.4-22c28-16.8 46.6-47.4 46.6-82.3s-18.6-65.5-46.5-82.3c-7.6-4.6-10-14.4-5.4-22s14.4-10 22-5.4zm-91.9 30.9c6 2.5 9.9 8.3 9.9 14.8v128c0 6.5-3.9 12.3-9.9 14.8s-12.9 1.1-17.4-3.5L113.4 376H80c-8.8 0-16-7.2-16-16v-48c0-8.8 7.2-16 16-16h33.4l35.3-35.3c4.6-4.6 11.5-5.9 17.4-3.5zm51 34.9c6.6-5.9 16.7-5.3 22.6 1.3 10.1 11.2 16.3 26.2 16.3 42.6s-6.2 31.4-16.3 42.7c-5.9 6.6-16 7.1-22.6 1.3s-7.1-16-1.3-22.6c5.1-5.7 8.1-13.1 8.1-21.3s-3.1-15.7-8.1-21.3c-5.9-6.6-5.3-16.7 1.3-22.6z"
        }
    ]
};

const FasFileBinary = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFileBinary",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zm192 0v128h128L256 0zM112 256h32c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48h-32c-26.5 0-48-21.5-48-48v-64c0-26.5 21.5-48 48-48zm-16 48v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16zm144-48h32c8.8 0 16 7.2 16 16v112h16c8.8 0 16 7.2 16 16s-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16s7.2-16 16-16h16v-96h-16c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FasFileCertificate = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFileCertificate",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 64c0-35.3 28.7-64 64-64h160v128c0 17.7 14.3 32 32 32h128v288c0 35.3-28.7 64-64 64H221.3c1.8-5.1 2.7-10.5 2.7-16v-80c1.3-.5 2.5-1 3.8-1.5 6.8-3 14.3-7.8 20.6-15.5 6.4-7.9 10.1-17.2 11.4-27.1.5-3.6.8-5.7 1.1-7.1 1.1-.9 2.8-2.3 5.6-4.5 19.9-15.4 27.1-42.2 17.5-65.5-1.4-3.3-2.1-5.4-2.6-6.7.5-1.4 1.2-3.4 2.6-6.7 9.5-23.3 2.4-50.1-17.5-65.5-2.8-2.2-4.5-3.6-5.6-4.5-.3-1.4-.6-3.6-1.1-7.1-3.4-24.9-23-44.6-47.9-47.9-3.6-.5-5.7-.8-7.1-1.1-.9-1.1-2.3-2.8-4.5-5.6-15.4-19.9-42.2-27.1-65.5-17.5-2.6 1.1-5.1 2.3-6.6 3l-.1.1V64zm384 64H384V0l128 128zm-402.8 33.6L125 168c1.9.8 4.1.8 6.1 0l15.8-6.5c10-4.1 21.5-1 28.1 7.5l10.5 13.5c1.3 1.7 3.2 2.7 5.2 3l16.9 2.3c10.7 1.5 19.1 9.9 20.5 20.5l2.3 16.9c.3 2.1 1.4 4 3 5.2l13.5 10.5c8.5 6.6 11.6 18.1 7.5 28.1l-6.4 16c-.8 1.9-.8 4.1 0 6.1l6.5 15.8c4.1 10 1 21.5-7.5 28.1l-13.5 10.5c-1.7 1.3-2.7 3.2-3 5.2l-2.3 16.9c-1.5 10.7-9.9 19.1-20.5 20.6l-15.7 2V496c0 5.9-3.2 11.3-8.5 14.1s-11.5 2.5-16.4-.8L128 483.2l-39.1 26.1c-4.9 3.3-11.2 3.6-16.4.8S64 501.9 64 496V390.2l-15.5-2.1c-10.7-1.5-19.1-9.9-20.5-20.6l-2.3-16.9c-.3-2.1-1.4-4-3-5.2L9.1 334.9c-8.5-6.6-11.6-18.1-7.5-28.1L8 291c.8-1.9.8-4.1 0-6.1l-6.4-15.7c-4.1-10-1-21.5 7.5-28.1l13.5-10.5c1.7-1.3 2.7-3.2 3-5.2l2.3-16.9c1.5-10.7 9.9-19.1 20.5-20.5l16.9-2.3c2.1-.3 4-1.4 5.2-3L81 169.2c6.6-8.5 18.1-11.6 28.1-7.5zM192 288a64 64 0 1 0-128 0 64 64 0 1 0 128 0z"
        }
    ]
};

const FasFileChartColumn = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFileChartColumn",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zm192 0v128h128L256 0zm-40 248v176c0 13.3-10.7 24-24 24s-24-10.7-24-24V248c0-13.3 10.7-24 24-24s24 10.7 24 24zm88 64v112c0 13.3-10.7 24-24 24s-24-10.7-24-24V312c0-13.3 10.7-24 24-24s24 10.7 24 24zm-176 64v48c0 13.3-10.7 24-24 24s-24-10.7-24-24v-48c0-13.3 10.7-24 24-24s24 10.7 24 24z"
        }
    ]
};

const FasFileChartPie = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFileChartPie",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zm192 0v128h128L256 0zm40 320h-88c-8.8 0-16-7.2-16-16v-88c0-8.8 7.2-16.1 16-14.9 53.5 7.1 95.9 49.5 103 103 1.2 8.8-6.1 16-14.9 16zm-136-90v106c0 8.8 7.2 16 16 16h106c10.1 0 17.7 9.3 14.1 18.8C278.9 415.9 235.2 448 184 448c-66.3 0-120-53.7-120-120 0-51.2 32.1-94.9 77.2-112.2 9.5-3.6 18.8 4 18.8 14.1z"
        }
    ]
};

const FasFileCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFileCheck",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zm192 0v128h128L256 0zm49 281L177 409c-9.4 9.4-24.6 9.4-33.9 0L79 345c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L271 247c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
        }
    ]
};

const FasFileCircleCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFileCircleCheck",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 64C0 28.7 28.7 0 64 0h160v128c0 17.7 14.3 32 32 32h128v38.6c-73.9 20.9-128 88.8-128 169.4 0 59.1 29.1 111.3 73.7 143.3-3.2.5-6.4.7-9.7.7H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0l128 128zm-96 240a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L416 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"
        }
    ]
};

const FasFileCircleExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFileCircleExclamation",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 64C0 28.7 28.7 0 64 0h160v128c0 17.7 14.3 32 32 32h128v38.6c-73.9 20.9-128 88.8-128 169.4 0 59.1 29.1 111.3 73.7 143.3-3.2.5-6.4.7-9.7.7H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0l128 128zm48 96a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-192c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16v-80c0-8.8-7.2-16-16-16z"
        }
    ]
};

const FasFileCircleInfo = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFileCircleInfo",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 64C0 28.7 28.7 0 64 0h160v128c0 17.7 14.3 32 32 32h128v38.6c-73.9 20.9-128 88.8-128 169.4 0 59.1 29.1 111.3 73.7 143.3-3.2.5-6.4.7-9.7.7H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0l128 128zm48 96a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 96a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-32 48c0 8.8 7.2 16 16 16v48c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16v-64c0-8.8-7.2-16-16-16h-16c-8.8 0-16 7.2-16 16z"
        }
    ]
};

const FasFileCircleMinus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFileCircleMinus",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 64C0 28.7 28.7 0 64 0h160v128c0 17.7 14.3 32 32 32h128v38.6c-73.9 20.9-128 88.8-128 169.4 0 59.1 29.1 111.3 73.7 143.3-3.2.5-6.4.7-9.7.7H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0l128 128zm-96 240a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm224 0c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16s7.2 16 16 16h128c8.8 0 16-7.2 16-16z"
        }
    ]
};

const FasFileCirclePlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFileCirclePlus",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 64C0 28.7 28.7 0 64 0h160v128c0 17.7 14.3 32 32 32h128v38.6c-73.9 20.9-128 88.8-128 169.4 0 59.1 29.1 111.3 73.7 143.3-3.2.5-6.4.7-9.7.7H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0l128 128zm48 96a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48h-48c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48h48c8.8 0 16-7.2 16-16s-7.2-16-16-16h-48v-48z"
        }
    ]
};

const FasFileCircleQuestion = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFileCircleQuestion",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 64C0 28.7 28.7 0 64 0h160v128c0 17.7 14.3 32 32 32h128v38.6c-73.9 20.9-128 88.8-128 169.4 0 59.1 29.1 111.3 73.7 143.3-3.2.5-6.4.7-9.7.7H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0l128 128zm48 96a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-64-142.4v6.4c0 8.8 7.2 16 16 16s16-7.2 16-16v-6.4c0-5.3 4.3-9.6 9.6-9.6h40.5c7.7 0 13.9 6.2 13.9 13.9 0 5.2-2.9 9.9-7.4 12.3l-32 16.8c-5.3 2.8-8.6 8.2-8.6 14.2V384c0 8.8 7.2 16 16 16s16-7.2 16-16v-5.1l23.5-12.3C486.6 358.7 496 343 496 326c0-25.4-20.6-45.9-45.9-45.9h-40.5c-23 0-41.6 18.6-41.6 41.6z"
        }
    ]
};

const FasFileCircleXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFileCircleXmark",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 64C0 28.7 28.7 0 64 0h160v128c0 17.7 14.3 32 32 32h128v38.6c-73.9 20.9-128 88.8-128 169.4 0 59.1 29.1 111.3 73.7 143.3-3.2.5-6.4.7-9.7.7H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0l128 128zm48 96a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm59.3 107.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L432 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l36.7 36.7-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l36.7-36.7 36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L454.6 368l36.7-36.7z"
        }
    ]
};

const FasFileCode = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFileCode",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zm192 0v128h128L256 0zM153 289l-31 31 31 31c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L71 337c-9.4-9.4-9.4-24.6 0-33.9l48-48c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zm112-34 48 48c9.4 9.4 9.4 24.6 0 33.9l-48 48c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l31-31-31-31c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z"
        }
    ]
};

const FasFileContract = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFileContract",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zm192 0v128h128L256 0zM80 64h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zm54.2 253.8c-6.1 20.3-24.8 34.2-46 34.2H80c-8.8 0-16-7.2-16-16s7.2-16 16-16h8.2c7.1 0 13.3-4.6 15.3-11.4l14.9-49.5c3.4-11.3 13.8-19.1 25.6-19.1s22.2 7.7 25.6 19.1l11.6 38.6c7.4-6.2 16.8-9.7 26.8-9.7 15.9 0 30.4 9 37.5 23.2l4.4 8.8H304c8.8 0 16 7.2 16 16s-7.2 16-16 16h-64c-6.1 0-11.6-3.4-14.3-8.8l-8.8-17.7c-1.7-3.4-5.1-5.5-8.8-5.5s-7.2 2.1-8.8 5.5l-8.8 17.7c-2.9 5.9-9.2 9.4-15.7 8.8s-12.1-5.1-13.9-11.3L144 349l-9.8 32.8z"
        }
    ]
};

const FasFileCsv = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFileCsv",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 64C0 28.7 28.7 0 64 0h160v128c0 17.7 14.3 32 32 32h128v144H176c-35.3 0-64 28.7-64 64v144H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0l128 128zM200 352h16c22.1 0 40 17.9 40 40v8c0 8.8-7.2 16-16 16s-16-7.2-16-16v-8c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-8c0-8.8 7.2-16 16-16s16 7.2 16 16v8c0 22.1-17.9 40-40 40h-16c-22.1 0-40-17.9-40-40v-80c0-22.1 17.9-40 40-40zm133.1 0H368c8.8 0 16 7.2 16 16s-7.2 16-16 16h-34.9c-7.2 0-13.1 5.9-13.1 13.1 0 5.2 3 9.9 7.8 12l37.4 16.6c16.3 7.2 26.8 23.4 26.8 41.2 0 24.9-20.2 45.1-45.1 45.1H304c-8.8 0-16-7.2-16-16s7.2-16 16-16h42.9c7.2 0 13.1-5.9 13.1-13.1 0-5.2-3-9.9-7.8-12l-37.4-16.6c-16.3-7.2-26.8-23.4-26.8-41.2 0-24.9 20.2-45.1 45.1-45.1zm98.9 0c8.8 0 16 7.2 16 16v31.6c0 23 5.5 45.6 16 66 10.5-20.3 16-42.9 16-66V368c0-8.8 7.2-16 16-16s16 7.2 16 16v31.6c0 34.7-10.3 68.7-29.6 97.6l-5.1 7.7c-3 4.5-8 7.1-13.3 7.1s-10.3-2.7-13.3-7.1l-5.1-7.7c-19.3-28.9-29.6-62.9-29.6-97.6V368c0-8.8 7.2-16 16-16z"
        }
    ]
};

const FasFileDashedLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFileDashedLine",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 64c0-35.3 28.7-64 64-64h160v128c0 17.7 14.3 32 32 32h128v96H128V64zm0 304h384v80c0 35.3-28.7 64-64 64H192c-35.3 0-64-28.7-64-64v-80zm384-240H384V0l128 128zM56 288h112c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-13.3 0-24-10.7-24-24s10.7-24 24-24zm224 0h80c13.3 0 24 10.7 24 24s-10.7 24-24 24h-80c-13.3 0-24-10.7-24-24s10.7-24 24-24zm192 0h112c13.3 0 24 10.7 24 24s-10.7 24-24 24H472c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
        }
    ]
};

const FasFileDoc = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFileDoc",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 64C0 28.7 28.7 0 64 0h160v128c0 17.7 14.3 32 32 32h128v144H176c-35.3 0-64 28.7-64 64v144H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0l128 128zM176 352h32c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48h-32c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16zm16 128h16c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16h-16v96zm264-128h16c22.1 0 40 17.9 40 40v8c0 8.8-7.2 16-16 16s-16-7.2-16-16v-8c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-8c0-8.8 7.2-16 16-16s16 7.2 16 16v8c0 22.1-17.9 40-40 40h-16c-22.1 0-40-17.9-40-40v-80c0-22.1 17.9-40 40-40zm-168 40c0-22.1 17.9-40 40-40h16c22.1 0 40 17.9 40 40v80c0 22.1-17.9 40-40 40h-16c-22.1 0-40-17.9-40-40v-80zm40-8c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-80c0-4.4-3.6-8-8-8h-16z"
        }
    ]
};

const FasFileExcel = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFileExcel",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zm192 0v128h128L256 0zM155.7 250.2l36.3 51.9 36.3-51.9c7.6-10.9 22.6-13.5 33.4-5.9s13.5 22.6 5.9 33.4L221.3 344l46.4 66.2c7.6 10.9 5 25.8-5.9 33.4s-25.8 5-33.4-5.9L192 385.8l-36.3 51.9c-7.6 10.9-22.6 13.5-33.4 5.9s-13.5-22.6-5.9-33.4l46.3-66.2-46.4-66.2c-7.6-10.9-5-25.8 5.9-33.4s25.8-5 33.4 5.9z"
        }
    ]
};

const FasFileExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFileExclamation",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zm192 0v128h128L256 0zm-64 192c13.3 0 24 10.7 24 24v112c0 13.3-10.7 24-24 24s-24-10.7-24-24V216c0-13.3 10.7-24 24-24zm-32 224a32 32 0 1 1 64 0 32 32 0 1 1-64 0z"
        }
    ]
};

const FasFileExport = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFileExport",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 64C0 28.7 28.7 0 64 0h160v128c0 17.7 14.3 32 32 32h128v128H216c-13.3 0-24 10.7-24 24s10.7 24 24 24h168v112c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm384 272v-48h110.1l-39-39c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l80 80c9.4 9.4 9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l39-39H384zm0-208H256V0l128 128z"
        }
    ]
};

const FasFileHeart = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFileHeart",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zm192 0v128h128L256 0zM80 301.3c0-33.8 27.4-61.3 61.3-61.3 16.2 0 31.8 6.5 43.3 17.9l7.4 7.4 7.4-7.4c11.5-11.5 27.1-17.9 43.3-17.9 33.8 0 61.3 27.4 61.3 61.3 0 16.2-6.5 31.8-17.9 43.3l-82.7 82.7c-6.2 6.2-16.4 6.2-22.6 0l-82.9-82.7C86.5 333.1 80 317.5 80 301.3z"
        }
    ]
};

const FasFileImage = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFileImage",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zm192 0v128h128L256 0zM64 256a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm152 32c5.3 0 10.2 2.6 13.2 6.9l88 128c3.4 4.9 3.7 11.3 1 16.5S310 448 304 448H80c-5.8 0-11.1-3.1-13.9-8.1s-2.8-11.2.2-16.1l48-80c2.9-4.8 8.1-7.8 13.7-7.8s10.8 2.9 13.7 7.8l12.8 21.4 48.3-70.2c3-4.3 7.9-6.9 13.2-6.9z"
        }
    ]
};

const FasFileImport = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFileImport",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 64c0-35.3 28.7-64 64-64h160v128c0 17.7 14.3 32 32 32h128v288c0 35.3-28.7 64-64 64H192c-35.3 0-64-28.7-64-64V336h174.1l-39 39c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9l-80-80c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l39 39H128V64zm0 224v48H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h104zm384-160H384V0l128 128z"
        }
    ]
};

const FasFileInvoiceDollar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFileInvoiceDollar",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zm192 0v128h128L256 0zM64 80c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm128 72c8.8 0 16 7.2 16 16v17.3c8.5 1.2 16.7 3.1 24.1 5.1 8.5 2.3 13.6 11 11.3 19.6s-11 13.6-19.6 11.3c-11.1-3-22-5.2-32.1-5.3-8.4-.1-17.4 1.8-23.6 5.5-5.7 3.4-8.1 7.3-8.1 12.8 0 3.7 1.3 6.5 7.3 10.1 6.9 4.1 16.6 7.1 29.2 10.9l.5.1c11.3 3.4 25.3 7.6 36.3 14.6 12.1 7.6 22.4 19.7 22.7 38.2.3 19.3-9.6 33.3-22.9 41.6-7.7 4.8-16.4 7.6-25.1 9.1V440c0 8.8-7.2 16-16 16s-16-7.2-16-16v-17.8c-11.2-2.1-21.7-5.7-30.9-8.9-2.1-.7-4.2-1.4-6.2-2.1-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1c2.5.8 4.8 1.6 7.1 2.4 13.6 4.6 24.6 8.4 36.3 8.7 9.1.3 17.9-1.7 23.7-5.3 5.1-3.2 7.9-7.3 7.8-14-.1-4.6-1.8-7.8-7.7-11.6-6.8-4.3-16.5-7.4-29-11.2l-1.6-.5c-11-3.3-24.3-7.3-34.8-13.7-12-7.2-22.6-18.9-22.7-37.3-.1-19.4 10.8-32.8 23.8-40.5 7.5-4.4 15.8-7.2 24.1-8.7V232c0-8.8 7.2-16 16-16z"
        }
    ]
};

const FasFileInvoice = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFileInvoice",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zm192 0v128h128L256 0zM80 64h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zm16 96h192c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32zm0 32v64h192v-64H96zm144 160h64c8.8 0 16 7.2 16 16s-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FasFileLines = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFileLines",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zm192 0v128h128L256 0zM112 256h160c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64h160c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64h160c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FasFileLock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFileLock",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 64C0 28.7 28.7 0 64 0h160v128c0 17.7 14.3 32 32 32h128v33.6c-19.8 20.2-32 47.9-32 78.4v24.6c-19.1 11.1-32 31.7-32 55.4v128c0 11.4 3 22.2 8.3 31.5-2.7.3-5.5.5-8.3.5H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0l128 128zm80 112c-17.7 0-32 14.3-32 32v48h64v-48c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32v128c0 17.7-14.3 32-32 32H384c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32v-48z"
        }
    ]
};

const FasFileMagnifyingGlass = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFileMagnifyingGlass",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zm192 0v128h128L256 0zm16 304c0 17.8-4.9 34.5-13.3 48.9l38.3 38.3c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-38.4-38.4c-14.3 8.5-30.9 13.3-48.7 13.3-53 0-96-43-96-96s43-96 96-96 96 43 96 96zm-96 48a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
        }
    ]
};

const FasFileMedical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFileMedical",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zm192 0v128h128L256 0zm-96 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-48v48c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-48h-48c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h48v-48z"
        }
    ]
};

const FasFileMinus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFileMinus",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zm192 0v128h128L256 0zM120 304h144c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
        }
    ]
};

const FasFileMusic = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFileMusic",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zm192 0v128h128L256 0zm32 224v160c0 17.7-21.5 32-48 32s-48-14.3-48-32 21.5-32 48-32c5.6 0 11 .6 16 1.8v-74.7l-96 36V416c0 17.7-21.5 32-48 32s-48-14.3-48-32 21.5-32 48-32c5.6 0 11 .6 16 1.8V272c0-6.7 4.1-12.6 10.4-15l128-48c4.9-1.8 10.4-1.2 14.7 1.8s6.9 7.9 6.9 13.2z"
        }
    ]
};

const FasFilePdf = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFilePdf",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 64C0 28.7 28.7 0 64 0h160v128c0 17.7 14.3 32 32 32h128v144H176c-35.3 0-64 28.7-64 64v144H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0l128 128zM176 352h32c30.9 0 56 25.1 56 56s-25.1 56-56 56h-16v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V368c0-8.8 7.2-16 16-16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24h-16v48h16zm96-80h32c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48h-32c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16zm32 128c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16h-16v96h16zm80-112c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32v32h32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V368z"
        }
    ]
};

const FasFilePen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFilePen",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 64C0 28.7 28.7 0 64 0h160v128c0 17.7 14.3 32 32 32h128v125.7l-86.8 86.8c-10.3 10.3-17.5 23.1-21 37.2l-18.7 74.9c-2.3 9.2-1.8 18.8 1.3 27.5H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0l128 128zm165.8 107.7 14.4 14.4c15.6 15.6 15.6 40.9 0 56.6l-29.4 29.4-71-71 29.4-29.4c15.6-15.6 40.9-15.6 56.6 0zM311.9 417l129.2-129.2 71 71-129.2 129.1c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9z"
        }
    ]
};

const FasFilePlusMinus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFilePlusMinus",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zm192 0v128h128L256 0zm-48 208v48h48c8.8 0 16 7.2 16 16s-7.2 16-16 16h-48v48c0 8.8-7.2 16-16 16s-16-7.2-16-16v-48h-48c-8.8 0-16-7.2-16-16s7.2-16 16-16h48v-48c0-8.8 7.2-16 16-16s16 7.2 16 16zm-80 176h128c8.8 0 16 7.2 16 16s-7.2 16-16 16H128c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FasFilePlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFilePlus",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zm192 0v128h128L256 0zm-64 240c13.3 0 24 10.7 24 24v48h48c13.3 0 24 10.7 24 24s-10.7 24-24 24h-48v48c0 13.3-10.7 24-24 24s-24-10.7-24-24v-48h-48c-13.3 0-24-10.7-24-24s10.7-24 24-24h48v-48c0-13.3 10.7-24 24-24z"
        }
    ]
};

const FasFilePowerpoint = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFilePowerpoint",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zm192 0v128h128L256 0zM136 240h68c42 0 76 34 76 76s-34 76-76 76h-44v32c0 13.3-10.7 24-24 24s-24-10.7-24-24V264c0-13.3 10.7-24 24-24zm68 104c15.5 0 28-12.5 28-28s-12.5-28-28-28h-44v56h44z"
        }
    ]
};

const FasFilePrescription = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFilePrescription",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zm192 0v128h128L256 0zM104 196h72c33.1 0 60 26.9 60 60 0 25.5-15.9 47.2-38.3 55.9l43 40.3 33.8-31c8.1-7.5 20.8-6.9 28.3 1.2s6.9 20.8-1.2 28.3l-31.6 29 31.7 29.7c8.1 7.6 8.5 20.2.9 28.3s-20.2 8.5-28.3.9l-33.9-31.8-34.9 32c-8.1 7.5-20.8 6.9-28.3-1.2s-6.9-20.8 1.2-28.3l32.6-29.9-64.8-60.8c-.9-.8-1.6-1.7-2.3-2.6H124v44c0 11-9 20-20 20s-20-9-20-20V216c0-11 9-20 20-20zm72 80c11 0 20-9 20-20s-9-20-20-20h-52v40h52z"
        }
    ]
};

const FasFileShield = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFileShield",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 64C0 28.7 28.7 0 64 0h160v128c0 17.7 14.3 32 32 32h128v47l-92.8 37.1c-21.3 8.5-35.2 29.1-35.2 52 0 56.6 18.9 148 94.2 208.3-9 4.8-19.3 7.6-30.2 7.6H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0l128 128zm39.1 97.7c5.7-2.3 12.1-2.3 17.8 0l120 48c9.1 3.7 15.1 12.5 15.1 22.3 0 63.3-25.9 168.8-134.8 214.2-5.9 2.5-12.6 2.5-18.5 0C313.9 464.8 288 359.3 288 296c0-9.8 6-18.6 15.1-22.3l120-48zM527.4 312 432 273.8v187.9c68.2-33 91.5-99 95.4-149.7z"
        }
    ]
};

const FasFileSignature = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFileSignature",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64v-19.3c-2.7 1.1-5.4 2-8.2 2.7l-60.1 15c-3 .7-6 1.2-9 1.4-.9.1-1.8.2-2.7.2h-64c-6.1 0-11.6-3.4-14.3-8.8l-8.8-17.7c-1.7-3.4-5.1-5.5-8.8-5.5s-7.2 2.1-8.8 5.5l-8.8 17.7c-2.9 5.9-9.2 9.4-15.7 8.8s-12.1-5.1-13.9-11.3L144 381l-9.8 32.8c-6.1 20.3-24.8 34.2-46 34.2H80c-8.8 0-16-7.2-16-16s7.2-16 16-16h8.2c7.1 0 13.3-4.6 15.3-11.4l14.9-49.5c3.4-11.3 13.8-19.1 25.6-19.1s22.2 7.8 25.6 19.1l11.6 38.6c7.4-6.2 16.8-9.7 26.8-9.7 15.9 0 30.4 9 37.5 23.2l4.4 8.8h8.9c-3.1-8.8-3.7-18.4-1.4-27.8l15-60.1c2.8-11.3 8.6-21.5 16.8-29.7l94.8-94.8V160H256c-17.7 0-32-14.3-32-32V0H64zm192 0v128h128L256 0zm293.8 139.7c-15.6-15.6-40.9-15.6-56.6 0l-29.4 29.4 71 71 29.4-29.4c15.6-15.6 15.6-40.9 0-56.6l-14.4-14.4zM311.9 321c-4.1 4.1-7 9.2-8.4 14.9l-15 60.1c-1.4 5.5.2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l60.1-15c5.6-1.4 10.8-4.3 14.9-8.4l129.2-129.3-71-71L311.9 321z"
        }
    ]
};

const FasFileSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFileSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L512 376V160H384c-17.7 0-32-14.3-32-32V0H192c-35.3 0-64 28.7-64 64v11L38.8 5.1zM128 196.9V448c0 35.3 28.7 64 64 64h256c20.1 0 38.1-9.3 49.8-23.8L128 196.9zM512 128 384 0v128h128z"
        }
    ]
};

const FasFileSpreadsheet = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFileSpreadsheet",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zm192 0v128h128L256 0zM88 224h208c17.7 0 32 14.3 32 32v160c0 17.7-14.3 32-32 32H88c-17.7 0-32-14.3-32-32V256c0-17.7 14.3-32 32-32zm0 112h48v-48H88v48zm80 0h48v-48h-48v48zm80 0h48v-48h-48v48zm0 32v48h48v-48h-48zm-32 0h-48v48h48v-48zm-80 0H88v48h48v-48z"
        }
    ]
};

const FasFileUser = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFileUser",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zm192 0v128h128L256 0zM128 256a64 64 0 1 1 128 0 64 64 0 1 1-128 0zM80 432c0-44.2 35.8-80 80-80h64c44.2 0 80 35.8 80 80 0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16z"
        }
    ]
};

const FasFileVideo = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFileVideo",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zm192 0v128h128L256 0zM64 288c0-17.7 14.3-32 32-32h96c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32v-96zm236.9 109.9L256 368v-64l44.9-29.9c2-1.3 4.4-2.1 6.8-2.1 6.8 0 12.3 5.5 12.3 12.3v103.4c0 6.8-5.5 12.3-12.3 12.3-2.4 0-4.8-.7-6.8-2.1z"
        }
    ]
};

const FasFileWaveform = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFileWaveform",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 0C60.7 0 32 28.7 32 64v224h112c6.1 0 11.6 3.4 14.3 8.8l17.7 35.4 49.7-99.4c2.7-5.4 8.3-8.8 14.3-8.8s11.6 3.4 14.3 8.8l27.6 55.2H352c8.8 0 16 7.2 16 16s-7.2 16-16 16h-80c-6.1 0-11.6-3.4-14.3-8.8L240 275.8l-49.7 99.4c-2.7 5.4-8.3 8.8-14.3 8.8s-11.6-3.4-14.3-8.8L134.1 320H32v128c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V160H288c-17.7 0-32-14.3-32-32V0H96zm192 0v128h128L288 0z"
        }
    ]
};

const FasFileWord = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFileWord",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zm192 0v128h128L256 0zM111 257.1l26.8 89.2 31.6-90.3c3.4-9.6 12.5-16.1 22.7-16.1s19.3 6.4 22.7 16.1l31.6 90.3 26.6-89.2c3.8-12.7 17.2-19.9 29.9-16.1s19.9 17.2 16.1 29.9l-48 160c-3 10-12 16.9-22.4 17.1s-19.8-6.2-23.2-16.1L192 336.6l-33.3 95.3c-3.4 9.8-12.8 16.3-23.2 16.1s-19.5-7.1-22.4-17.1l-48-160c-3.8-12.7 3.4-26.1 16.1-29.9s26.1 3.4 29.9 16.1z"
        }
    ]
};

const FasFileXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFileXmark",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zm192 0v128h128L256 0zM111 239c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"
        }
    ]
};

const FasFileZip = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFileZip",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 64C0 28.7 28.7 0 64 0h160v128c0 17.7 14.3 32 32 32h128v144H240c-35.3 0-64 28.7-64 64v144H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0l128 128zM240 352h64c5.5 0 10.7 2.9 13.6 7.6s3.2 10.6.7 15.6L265.9 480H304c8.8 0 16 7.2 16 16s-7.2 16-16 16h-64c-5.5 0-10.7-2.9-13.6-7.6s-3.2-10.6-.7-15.6L278.1 384H240c-8.8 0-16-7.2-16-16s7.2-16 16-16zm144 16v128c0 8.8-7.2 16-16 16s-16-7.2-16-16V368c0-8.8 7.2-16 16-16s16 7.2 16 16zm32 0c0-8.8 7.2-16 16-16h24c30.9 0 56 25.1 56 56s-25.1 56-56 56h-8v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V368zm32 64h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8v48z"
        }
    ]
};

const FasFileZipper = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFileZipper",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zm192 0v128h128L256 0zM96 48c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16zm-6.3 71.8c3.7-14 16.4-23.8 30.9-23.8h14.8c14.5 0 27.2 9.7 30.9 23.8l23.5 88.2c1.4 5.4 2.1 10.9 2.1 16.4 0 35.2-28.8 63.7-64 63.7s-64-28.5-64-63.7c0-5.5.7-11.1 2.1-16.4l23.5-88.2zM112 336c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32z"
        }
    ]
};

const FasFile = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFile",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 64C0 28.7 28.7 0 64 0h160v128c0 17.7 14.3 32 32 32h128v288c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0l128 128z"
        }
    ]
};

const FasFilesMedical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFilesMedical",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 0h160v96c0 17.7 14.3 32 32 32h96v224c0 35.3-28.7 64-64 64H160c-35.3 0-64-28.7-64-64V64c0-35.3 28.7-64 64-64zm256 64 32 32h-96V0l32 32 32 32zM24 96c13.3 0 24 10.7 24 24v256c0 48.6 39.4 88 88 88h192c13.3 0 24 10.7 24 24s-10.7 24-24 24H136C60.9 512 0 451.1 0 376V120c0-13.3 10.7-24 24-24zm216 80v48h-48c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-48h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-48v-48c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16z"
        }
    ]
};

const FasFiles = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFiles",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 0H160c-35.3 0-64 28.7-64 64v288c0 35.3 28.7 64 64 64h224c35.3 0 64-28.7 64-64V128h-96c-17.7 0-32-14.3-32-32V0zm128 96-32-32-32-32-32-32v96h96zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120v256c0 75.1 60.9 136 136 136h192c13.3 0 24-10.7 24-24s-10.7-24-24-24H136c-48.6 0-88-39.4-88-88V120z"
        }
    ]
};

const FasFillDrip = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFillDrip",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M41.4 9.4c12.5-12.5 32.7-12.5 45.2 0L168 90.7l53.1-53.1c28.1-28.1 73.7-28.1 101.8 0l151.4 151.5c28.1 28.1 28.1 73.7 0 101.8L283.9 481.4c-37.5 37.5-98.3 37.5-135.8 0L30.6 363.9c-37.5-37.5-37.5-98.3 0-135.8l92.1-92.1-81.3-81.4c-12.5-12.5-12.5-32.8 0-45.3zm176 221.3L168 181.3l-92.1 92.1c-4.2 4.2-7 9.3-8.4 14.6h319.2l42.3-42.3c3.1-3.1 3.1-8.2 0-11.3L277.7 82.9c-3.1-3.1-8.2-3.1-11.3 0L213.3 136l49.4 49.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0zM512 512c-35.3 0-64-28.7-64-64 0-25.2 32.6-79.6 51.2-108.7 6-9.4 19.5-9.4 25.5 0C543.4 368.4 576 422.8 576 448c0 35.3-28.7 64-64 64z"
        }
    ]
};

const FasFill = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFill",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M86.6 9.4C74.1-3.1 53.9-3.1 41.4 9.4s-12.5 32.8 0 45.3l81.3 81.3-92.1 92.1c-37.5 37.5-37.5 98.3 0 135.8l117.5 117.5c37.5 37.5 98.3 37.5 135.8 0l190.4-190.5c28.1-28.1 28.1-73.7 0-101.8L322.9 37.7c-28.1-28.1-73.7-28.1-101.8 0l-53.1 53L86.6 9.4zM168 181.3l49.4 49.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L213.3 136l53.1-53.1c3.1-3.1 8.2-3.1 11.3 0l151.4 151.4c3.1 3.1 3.1 8.2 0 11.3L386.7 288H67.5c1.4-5.4 4.2-10.4 8.4-14.6l92.1-92.1z"
        }
    ]
};

const FasFilmCanister = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFilmCanister",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 0c-17.7 0-32 14.3-32 32H32C14.3 32 0 46.3 0 64s14.3 32 32 32v352c-17.7 0-32 14.3-32 32s14.3 32 32 32h288c17.7 0 32-14.3 32-32s-14.3-32-32-32V96c17.7 0 32-14.3 32-32s-14.3-32-32-32h-64c0-17.7-14.3-32-32-32h-96zm224 128v288h128c17.7 0 32-14.3 32-32v-32c0-17.7 14.3-32 32-32s32-14.3 32-32V160c0-17.7-14.3-32-32-32H352zm56 40h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16zm-80 144h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16z"
        }
    ]
};

const FasFilmSimple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFilmSimple",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 32H128v48c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64v-48c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h256v-48c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64v48c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16V32zM64 176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-32zm336-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16zM64 304c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-32zm336-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16z"
        }
    ]
};

const FasFilmSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFilmSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-55.5-43.5c.5-3.1.7-6.3.7-9.6V96c0-35.3-28.7-64-64-64H128c-14.4 0-27.8 4.8-38.5 12.9L38.8 5.1zM224 150.3V128c0-17.7 14.3-32 32-32h128c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32h-65.9L224 150.3zM487.4 480l-87-68.5c-4.8 2.9-10.4 4.5-16.4 4.5H256c-17.7 0-32-14.3-32-32v-64c0-14.1 9.1-26.1 21.8-30.3l-71.1-56c.8 2 1.3 4.1 1.3 6.4v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16h32c.9 0 1.9.1 2.8.2L64 146.4V416c0 35.3 28.7 64 64 64h359.4zM112 368c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32zm352-128c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32zm16-144h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16z"
        }
    ]
};

const FasFilm = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFilm",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 96c0-35.3 28.7-64 64-64h384c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm48 272v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16zm368-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32zM48 240v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16zm368-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32zM48 112v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16zm368-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32zm-256 32v64c0 17.7 14.3 32 32 32h128c17.7 0 32-14.3 32-32v-64c0-17.7-14.3-32-32-32H192c-17.7 0-32 14.3-32 32zm32 160c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h128c17.7 0 32-14.3 32-32v-64c0-17.7-14.3-32-32-32H192z"
        }
    ]
};

const FasFilms = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFilms",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 32c-35.3 0-64 28.7-64 64v224c0 35.3 28.7 64 64 64h352c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H160zm8 48h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16zm304 16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16V96zm-304 88h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16zm304 16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16zm-304 88h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16zm304 16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16zM288 80h96c17.7 0 32 14.3 32 32v48c0 17.7-14.3 32-32 32h-96c-17.7 0-32-14.3-32-32v-48c0-17.7 14.3-32 32-32zm-32 176c0-17.7 14.3-32 32-32h96c17.7 0 32 14.3 32 32v48c0 17.7-14.3 32-32 32h-96c-17.7 0-32-14.3-32-32v-48zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120v224c0 75.1 60.9 136 136 136h320c13.3 0 24-10.7 24-24s-10.7-24-24-24H136c-48.6 0-88-39.4-88-88V120z"
        }
    ]
};

const FasFilterCircleDollar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFilterCircleDollar",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M3.9 22.9C10.5 8.9 24.5 0 40 0h432c15.5 0 29.5 8.9 36.1 22.9s4.6 30.5-5.2 42.5L396.4 195.6C316.2 212.1 256 283 256 368c0 27.4 6.3 53.4 17.5 76.5-1.6-.8-3.2-1.8-4.7-2.9l-64-48c-8.1-6-12.8-15.5-12.8-25.6v-79.1L9 65.3C-.7 53.4-2.8 36.8 3.9 22.9zM288 368a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm120.8-32.6c.6-.9 1.8-2.1 4.2-3.4 5.1-2.7 12.5-4.1 18.7-4 8.2.1 17.1 1.8 26.4 4.1 8.6 2.1 17.3-3.1 19.4-11.7s-3.1-17.3-11.7-19.4c-5.6-1.4-11.6-2.7-17.9-3.7V288c0-8.8-7.2-16-16-16s-16 7.2-16 16v9.5c-6.1 1.2-12.3 3.2-18 6.3-11.8 6.3-23 18.4-21.8 37.2 1 16 11.7 25.3 21.6 30.7 8.8 4.7 19.7 7.8 28.6 10.3l1.8.5c10.3 2.9 17.9 5.2 23.2 8.3 4.5 2.7 4.7 4.2 4.7 5.6.1 2.4-.5 3.7-1 4.5-.6 1-1.8 2.2-4 3.3-4.7 2.5-11.8 3.8-18.5 3.6-9.5-.3-18.5-3.1-29.9-6.8-1.9-.6-3.8-1.2-5.8-1.8-8.4-2.6-17.4 2.1-20 10.5s2.1 17.4 10.5 20c1.6.5 3.3 1 5 1.6 7 2.3 15.1 4.8 23.7 6.6v11.4c0 8.8 7.2 16 16 16s16-7.2 16-16v-10.6c6.2-1.1 12.5-3.1 18.3-6.2 12.1-6.5 22.3-18.7 21.7-36.9-.5-16.2-10.3-26.3-20.5-32.3-9.4-5.6-21.2-8.9-30.5-11.5h-.2c-10.4-2.9-18.3-5.2-23.9-8.2-4.8-2.6-4.8-4-4.8-4.5v-.1c-.1-1.9.3-2.9.8-3.6z"
        }
    ]
};

const FasFilterCircleXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFilterCircleXmark",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M3.9 22.9C10.5 8.9 24.5 0 40 0h432c15.5 0 29.5 8.9 36.1 22.9s4.6 30.5-5.2 42.5L396.4 195.6C316.2 212.1 256 283 256 368c0 27.4 6.3 53.4 17.5 76.5-1.6-.8-3.2-1.8-4.7-2.9l-64-48c-8.1-6-12.8-15.5-12.8-25.6v-79.1L9 65.3C-.7 53.4-2.8 36.8 3.9 22.9zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm59.3 107.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L432 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l36.7 36.7-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l36.7-36.7 36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L454.6 368l36.7-36.7z"
        }
    ]
};

const FasFilterList = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFilterList",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M40 64C24.2 64 9.9 73.3 3.5 87.7s-3.8 31.3 6.8 43L112 243.8V368c0 10.1 4.7 19.6 12.8 25.6l64 48c9.7 7.3 22.7 8.4 33.5 3S240 428.1 240 416V243.8l101.7-113c10.6-11.7 13.2-28.6 6.8-43S327.8 64 312 64H40zm312 320c-17.7 0-32 14.3-32 32s14.3 32 32 32h128c17.7 0 32-14.3 32-32s-14.3-32-32-32H352zm-32-128c0 17.7 14.3 32 32 32h128c17.7 0 32-14.3 32-32s-14.3-32-32-32H352c-17.7 0-32 14.3-32 32zm96-192c-17.7 0-32 14.3-32 32s14.3 32 32 32h64c17.7 0 32-14.3 32-32s-14.3-32-32-32h-64z"
        }
    ]
};

const FasFilterSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFilterSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L406.6 293.4 567 97.3c9.8-12 11.8-28.5 5.2-42.5S551.5 32 536 32H104c-8.1 0-15.8 2.5-22.3 6.8L38.8 5.1zM256 400c0 10.1 4.7 19.6 12.8 25.6l64 48c9.7 7.3 22.7 8.4 33.5 3S384 460.1 384 448v-49.5L256 297.7V400z"
        }
    ]
};

const FasFilter = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFilter",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M3.9 54.9C10.5 40.9 24.5 32 40 32h432c15.5 0 29.5 8.9 36.1 22.9s4.6 30.5-5.2 42.5L320 320.9V448c0 12.1-6.8 23.2-17.7 28.6s-23.8 4.3-33.5-3l-64-48c-8.1-6-12.8-15.5-12.8-25.6v-79.1L9 97.3C-.7 85.4-2.8 68.8 3.9 54.9z"
        }
    ]
};

const FasFilters = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFilters",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M232 32c-15.9 0-30.2 9.4-36.6 23.9s-3.6 31.5 7.2 43.2L352 261.5V368c0 10.1 4.7 19.6 12.8 25.6l64 48c9.7 7.3 22.7 8.4 33.5 3S480 428.1 480 416V261.5L629.4 99.1c10.7-11.7 13.6-28.6 7.2-43.2S615.9 32 600 32H232zM40 96c-15.9 0-30.2 9.4-36.6 23.9s-3.6 31.5 7.2 43.2L160 325.5V400c0 10.1 4.7 19.6 12.8 25.6l64 48c9.7 7.3 22.7 8.4 33.5 3S288 460.1 288 448V325.5l32-34.8V274L179 120.7c-6.7-7.3-11.7-15.7-14.9-24.7H40z"
        }
    ]
};

const FasFingerprint = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFingerprint",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 256c0-114.9 93.1-208 208-208 63.1 0 119.6 28.1 157.8 72.5 8.6 10.1 23.8 11.2 33.8 2.6s11.2-23.8 2.6-33.8C403.3 34.6 333.7 0 256 0 114.6 0 0 114.6 0 256v40c0 13.3 10.7 24 24 24s24-10.7 24-24v-40zm458.5-52.9c-2.7-13-15.5-21.3-28.4-18.5s-21.3 15.5-18.5 28.4c2.9 13.9 4.5 28.3 4.5 43.1v40c0 13.3 10.7 24 24 24s24-10.7 24-24V256c0-18.1-1.9-35.8-5.5-52.9zM256 80c-19 0-37.4 3-54.5 8.6-15.2 5-18.7 23.7-8.3 35.9 7.1 8.3 18.8 10.8 29.4 7.9 10.6-2.9 21.8-4.4 33.4-4.4 70.7 0 128 57.3 128 128v24.9c0 25.2-1.5 50.3-4.4 75.3-1.7 14.6 9.4 27.8 24.2 27.8 11.8 0 21.9-8.6 23.3-20.3 3.3-27.4 5-55 5-82.7v-25c0-97.2-78.8-176-176-176zm-105.3 68.7c-9.1-10.6-25.3-11.4-33.9-.4C93.7 178 80 215.4 80 256v24.9c0 24.2-2.6 48.4-7.8 71.9-3.4 15.6 7.9 31.2 23.9 31.2 10.5 0 19.9-7 22.2-17.3 6.4-28.1 9.7-56.8 9.7-85.8V256c0-27.2 8.5-52.4 22.9-73.1 7.2-10.4 8-24.6-.2-34.2zM256 160c-53 0-96 43-96 96v24.9c0 35.9-4.6 71.5-13.8 106.1-3.8 14.3 6.7 29 21.5 29 9.5 0 17.9-6.2 20.4-15.4 10.5-39 15.9-79.2 15.9-119.7V256c0-28.7 23.3-52 52-52s52 23.3 52 52v24.9c0 36.3-3.5 72.4-10.4 107.9-2.7 13.9 7.7 27.2 21.8 27.2 10.2 0 19-7 21-17 7.7-38.8 11.6-78.3 11.6-118.1V256c0-53-43-96-96-96zm24 96c0-13.3-10.7-24-24-24s-24 10.7-24 24v24.9c0 59.9-11 119.3-32.5 175.2l-5.9 15.3c-4.8 12.4 1.4 26.3 13.8 31s26.3-1.4 31-13.8l5.9-15.3A536.19 536.19 0 0 0 280 280.9V256z"
        }
    ]
};

const FasFireBurner = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFireBurner",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M293.5 3.8c19.7 17.8 38.2 37 55.5 57.7 7.9-9.9 16.8-20.7 26.5-29.5 5.6-5.1 14.4-5.1 20 0 24.7 22.7 45.6 52.7 60.4 81.1 14.5 28 24.2 58.8 24.2 79C480 280 408.7 352 320 352c-89.7 0-160-72.1-160-159.8 0-26.4 12.7-60.7 32.4-92.6 20-32.4 48.1-66.1 81.4-95.8 2.8-2.5 6.4-3.8 10-3.7 3.5 0 7 1.3 9.8 3.8zM370 273c30-21 38-63 20-96-2-4-4-8-7-12l-36 42s-58-74-62-79c-30 37-45 58-45 82 0 49 36 78 81 78 18 0 34-5 49-15zM32 288c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32s-14.3 32-32 32v64h448v-64c-17.7 0-32-14.3-32-32s14.3-32 32-32h32c17.7 0 32 14.3 32 32v96c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32v-96zm288 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160-32a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm-288 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FasFireExtinguisher = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFireExtinguisher",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M500.3 7.3c7.4 6 11.7 15.1 11.7 24.7v96c0 9.6-4.3 18.7-11.7 24.7s-17.2 8.5-26.6 6.6l-160-32c-12.2-2.4-21.7-11.6-24.7-23.3h-65v34.8c37.8 18 64 56.5 64 101.2v144H64V240c0-44.7 26.2-83.2 64-101.2V110c-36.2 11.1-66 36.9-82.3 70.5-5.8 11.9-20.2 16.9-32.1 11.1s-16.9-20.2-11.1-32.1C26.7 109.8 72.7 72.6 128 60.4V32c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32v24h65c3-11.7 12.5-20.9 24.7-23.4l160-32c9.4-1.9 19.1.6 26.6 6.6zM288 416v32c0 35.3-28.7 64-64 64h-96c-35.3 0-64-28.7-64-64v-32h224zM176 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
        }
    ]
};

const FasFireFlameCurved = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFireFlameCurved",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m153.6 29.9 16-21.3c4-5.4 10.4-8.6 17.1-8.6C198.4 0 208 9.6 208 21.3v22.2c0 13.1 5.4 25.7 14.9 34.7l84.7 80.8c48.8 46.6 76.4 111.2 76.4 178.7C384 434 306 512 209.7 512H192C86 512 0 426 0 320v-3.8c0-48.8 19.4-95.6 53.9-130.1l3.5-3.5c4.2-4.2 10-6.6 16-6.6 12.5 0 22.6 10.1 22.6 22.6V288c0 35.3 28.7 64 64 64s64-28.7 64-64v-3.9c0-18-7.2-35.3-19.9-48l-38.6-38.6c-24-24-37.5-56.7-37.5-90.7 0-27.7 9-54.8 25.6-76.9z"
        }
    ]
};

const FasFireFlameSimple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFireFlameSimple",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m372.5 256.5-.7-1.9C337.8 160.8 282 76.5 209.1 8.5l-3.3-3C202.1 2 197.1 0 192 0s-10.1 2-13.8 5.5l-3.3 3C102 76.5 46.2 160.8 12.2 254.6l-.7 1.9C3.9 277.3 0 299.4 0 321.6 0 426.7 86.8 512 192 512s192-85.3 192-190.4c0-22.2-3.9-44.2-11.5-65.1zM281.7 306a73.3 73.3 0 0 1 6.2 29.5c0 53-43 96.5-96 96.5s-96-43.5-96-96.5c0-10.1 2.1-20.3 6.2-29.5l1.9-4.3c15.8-35.4 37.9-67.7 65.3-95.1l8.9-8.9c3.6-3.6 8.5-5.6 13.6-5.6s10 2 13.6 5.6l8.9 8.9c27.4 27.4 49.6 59.7 65.3 95.1l1.9 4.3z"
        }
    ]
};

const FasFireFlame = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFireFlame",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m372.5 256.5-.7-1.9C337.8 160.8 282 76.5 209.1 8.5l-3.3-3C202.1 2 197.1 0 192 0s-10.1 2-13.8 5.5l-3.3 3C102 76.5 46.2 160.8 12.2 254.6l-.7 1.9C3.9 277.3 0 299.4 0 321.6 0 426.7 86.8 512 192 512s192-85.3 192-190.4c0-22.2-3.9-44.2-11.5-65.1zM188.8 148.3c2-2.7 5.2-4.3 8.5-4.3 5.9 0 10.7 4.8 10.7 10.7v11.4c0 8.9 3.6 17.4 9.9 23.6l51.5 50.7C291.5 262.2 304 292 304 323c0 60.2-48.8 109-109 109h-3c-61.9 0-112-50.1-112-112v-8.2c0-21.2 7.8-41.6 21.8-57.4l6.9-7.8c2.1-2.4 5.1-3.7 8.3-3.7 6.1 0 11 4.9 11 11v44c0 24.3 19.8 44 44.1 44 24.2 0 43.9-19.6 43.9-43.8 0-11.6-4.6-22.8-12.8-31L190 253.9c-14-14-21.9-33.1-21.9-53 0-16.2 5.3-32 15-44.9l5.8-7.8z"
        }
    ]
};

const FasFireHydrant = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFireHydrant",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 32v4c45 11.6 80.4 47 92 92h12c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-13.3 0-24-10.7-24-24s10.7-24 24-24h12c11.6-45 47-80.4 92-92v-4c0-17.7 14.3-32 32-32s32 14.3 32 32zM32 488c0-13.3 10.7-24 24-24h8v-64H48c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32h16v-64h256v64h16c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32h-16v64h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-13.3 0-24-10.7-24-24zm160-88a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"
        }
    ]
};

const FasFireSmoke = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFireSmoke",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M283.7 0c-3.6 0-7.2 1.2-10 3.7-33.2 29.7-61.4 63.4-81.4 95.8-19.7 31.9-32.4 66.2-32.4 92.6 0 30 8.2 58.3 22.7 82.4 4.6 2.6 9 5.4 13.3 8.5 13.7-16.8 30.7-30.8 50.1-40.9-3.9-9.4-6-20.2-6-32.1 0-24 15-45 45-82 4 5 62 79 62 79l36-42c3 4 5 8 7 12 11.3 20.7 12.3 44.9 4.2 65.2 19.3 10.1 36.2 24 49.9 40.8 4.2-3 8.5-5.8 12.9-8.3 14.6-24.1 23-52.4 23-82.5 0-20.2-9.6-50.9-24.2-79-14.7-28.5-35.6-58.5-60.3-81.2-5.6-5.1-14.4-5.2-20 0-9.6 8.8-18.6 19.6-26.5 29.5-17.3-20.7-35.8-39.9-55.5-57.7-2.8-2.5-6.3-3.7-9.8-3.8zM0 400c0 61.9 50.1 112 112 112h416c61.9 0 112-50.1 112-112s-50.1-112-112-112c-37 0-69.9 18-90.3 45.7C418.2 288 372.8 256 320 256s-98.2 32-117.7 77.7C181.9 306 149 288 112 288 50.1 288 0 338.1 0 400z"
        }
    ]
};

const FasFire = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFire",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M159.3 5.4c7.8-7.3 19.9-7.2 27.7.1 27.6 25.9 53.5 53.8 77.7 84 11-14.4 23.5-30.1 37-42.9 7.9-7.4 20.1-7.4 28 .1 34.6 33 63.9 76.6 84.5 118 20.3 40.8 33.8 82.5 33.8 111.9C448 404.2 348.2 512 224 512 98.4 512 0 404.1 0 276.5c0-38.4 17.8-85.3 45.4-131.7C73.3 97.7 112.7 48.6 159.3 5.4zM225.7 416c25.3 0 47.7-7 68.8-21 42.1-29.4 53.4-88.2 28.1-134.4-4.5-9-16-9.6-22.5-2l-25.2 29.3c-6.6 7.6-18.5 7.4-24.7-.5-16.5-21-46-58.5-62.8-79.8-6.3-8-18.3-8.1-24.7-.1-33.8 42.5-50.8 69.3-50.8 99.4.1 68.5 50.7 109.1 113.8 109.1z"
        }
    ]
};

const FasFireplace = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFireplace",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 32v32c0 17.7 14.3 32 32 32h576c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H32C14.3 0 0 14.3 0 32zm608 96H32v352c0 17.7 14.3 32 32 32h96V352c0-88.4 71.6-160 160-160s160 71.6 160 160v160h96c17.7 0 32-14.3 32-32V128zM300.6 258.7c-2-1.8-4.6-2.7-7.1-2.7-2.6 0-5.2.9-7.3 2.7-24.2 21.6-44.7 46.1-59.2 69.7-14.3 23.2-23.6 48.2-23.6 67.4 0 63.8 51.1 116.3 116.4 116.3 64.5 0 116.4-52.4 116.4-116.3 0-14.7-7-37-17.6-57.4-10.7-20.7-25.9-42.5-43.9-59-4.1-3.7-10.4-3.8-14.5 0-7 6.4-13.5 14.3-19.2 21.5-12.6-15.1-26-29-40.4-42zm55.6 195.8c-10.9 7.3-22.5 10.9-35.6 10.9-32.7 0-58.9-21.1-58.9-56.7 0-17.5 10.9-32.7 32.7-59.6 2.9 3.6 45.1 57.5 45.1 57.5l26.2-30.6c2.2 2.9 3.6 5.8 5.1 8.7 13.1 24 7.3 54.5-14.5 69.8z"
        }
    ]
};

const FasFishBones = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFishBones",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M87.1 148.2c5.6 4.6 8.9 11.4 8.9 18.7V232h40v-72c0-13.3 10.7-24 24-24s24 10.7 24 24v72h48v-72c0-13.3 10.7-24 24-24s24 10.7 24 24v72h48v-72c0-13.3 10.7-24 24-24s24 10.7 24 24v72h40V130.9c0-16.9 17.1-28.4 31.8-20 16 9.1 30.6 19.7 43.7 30.7 39.1 33 66.9 72.4 81 99.8 4.7 9.2 4.7 20.1 0 29.3-14.1 27.4-41.9 66.8-81 99.8-13.1 11-27.7 21.6-43.7 30.7-14.7 8.4-31.8-3.1-31.8-20V280h-40v72c0 13.3-10.7 24-24 24s-24-10.7-24-24v-72h-48v72c0 13.3-10.7 24-24 24s-24-10.7-24-24v-72h-48v72c0 13.3-10.7 24-24 24s-24-10.7-24-24v-72H96v65.1c0 7.2-3.3 14.1-8.9 18.7l-48 38.9c-8.8 7.1-21.3 7.1-30.1.1s-11.5-19.2-6.6-29.3l52.5-106.9c3.3-6.7 3.3-14.5 0-21.2L2.5 138.6c-5-10.1-2.2-22.3 6.6-29.3s21.3-7 30.1.1l48 38.9z"
        }
    ]
};

const FasFishCooked = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFishCooked",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 64c120 0 256 128 256 192S440 448 320 448c-74.8 0-155.9-49.8-206.3-102.8-6-6.3-15.8-7.2-22.5-1.7l-65.1 52.9c-5.3 4.3-12.9 4.8-18.7 1.1s-8.6-10.7-6.9-17.4l30-120.2c.6-2.5.6-5.2 0-7.8L.5 131.9c-1.6-6.5.9-13.2 6.4-17s12.7-3.8 18.2 0l72 49.5c6.6 4.5 15.5 3.5 21.1-2.2C168.9 110.9 247.4 64 320 64zm-4.7 84.7c-6.2-6.2-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64c6.2-6.2 6.2-16.4 0-22.6zm112 16c-6.2-6.2-16.4-6.2-22.6 0l-160 160c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l160-160c6.2-6.2 6.2-16.4 0-22.6zm16 112c-6.2-6.2-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64c6.2-6.2 6.2-16.4 0-22.6z"
        }
    ]
};

const FasFishFins = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFishFins",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M275.2 38.4c-10.6-8-25-8.5-36.3-1.5S222 57.3 224.6 70.3l9.7 48.6c-19.4 9-36.9 19.9-52.4 31.5-15.3 11.5-29 23.9-40.7 36.3l-93.1-54.3c-12.5-7.3-28.4-5.3-38.7 4.9s-12.4 26-5.2 38.6L50 256 4.2 336.1c-7.2 12.6-5 28.4 5.3 38.6s26.1 12.2 38.7 4.9l93.1-54.3c11.8 12.3 25.4 24.8 40.7 36.3 15.5 11.6 33 22.5 52.4 31.5l-9.7 48.6c-2.6 13 3.1 26.3 14.3 33.3s25.6 6.5 36.3-1.5l77.6-58.2c54.9-4 101.5-27 137.2-53.8 39.2-29.4 67.2-64.7 81.6-89.5 5.8-9.9 5.8-22.2 0-32.1-14.4-24.8-42.5-60.1-81.6-89.5-35.8-26.8-82.3-49.8-137.2-53.8l-77.7-58.2zM384 256a32 32 0 1 1 64 0 32 32 0 1 1-64 0z"
        }
    ]
};

const FasFish = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFish",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M180.5 141.5C219.7 108.5 272.6 80 336 80s116.3 28.5 155.5 61.5c39.1 33 66.9 72.4 81 99.8 4.7 9.2 4.7 20.1 0 29.3-14.1 27.4-41.9 66.8-81 99.8C452.3 403.5 399.4 432 336 432s-116.3-28.5-155.5-61.5c-16.2-13.7-30.5-28.5-42.7-43.1l-89.7 52.2c-12.5 7.3-28.4 5.3-38.7-4.9s-12.4-26-5.2-38.6L50 256 4.2 175.9c-7.2-12.6-5-28.4 5.3-38.6s26.1-12.2 38.7-4.9l89.7 52.3c12.2-14.6 26.5-29.4 42.7-43.1zM448 256a32 32 0 1 0-64 0 32 32 0 1 0 64 0z"
        }
    ]
};

const FasFishingRod = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFishingRod",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M295.9 48c-3 0-6 .4-8.8 1.2l-77.3 22.1C137.7 91.9 88 157.8 88 232.8V288h8c17.7 0 32 14.3 32 32v160c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V320c0-17.7 14.3-32 32-32h8v-55.2c0-96.4 63.9-181.2 156.7-207.7l77.1-22C281 1 288.4 0 295.9 0 340.1 0 376 35.9 376 80.1V136c0 13.3-10.7 24-24 24s-24-10.7-24-24V80.1c0-17.7-14.4-32.1-32.1-32.1zM256 344c0-71.6 55.6-127.8 89-148.1 4.3-2.6 9.6-2.6 14 0 33.5 20.3 89 76.6 89 148.1 0 32-16 80-64 112l27.3 27.3c3 3 4.7 7.1 4.7 11.3v1.4c0 8.8-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16v-1.4c0-4.2 1.7-8.3 4.7-11.3L320 456c-48-32-64-80-64-112zm128-32a24 24 0 1 0-48 0 24 24 0 1 0 48 0z"
        }
    ]
};

const FasFlagCheckered = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFlagCheckered",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 0c17.7 0 32 14.3 32 32v16l69-17.2c38.1-9.5 78.3-5.1 113.5 12.5 46.3 23.2 100.8 23.2 147.1 0l9.6-4.8c20.6-10.4 44.8 4.6 44.8 27.6v279.7c0 13.3-8.3 25.3-20.8 30l-34.7 13c-46.2 17.3-97.6 14.6-141.7-7.4-37.9-19-81.3-23.7-122.5-13.4L64 384v96c0 17.7-14.3 32-32 32S0 497.7 0 480V32C0 14.3 14.3 0 32 0zm32 187.1 64-13.9v65.5l-64 13.9V318l48.8-12.2c5.1-1.3 10.1-2.4 15.2-3.3v-63.8l38.9-8.4c8.3-1.8 16.7-2.5 25.1-2.1v-64c13.6.4 27.2 2.6 40.4 6.4l23.6 6.9v66.7l-41.7-12.3c-7.3-2.1-14.8-3.4-22.3-3.8v71.4c21.8 1.9 43.3 6.7 64 14.4v-69.7l22.7 6.7c13.5 4 27.3 6.4 41.3 7.4V194c-7.8-.8-15.6-2.3-23.2-4.5l-40.8-12v-62c-13-3.8-25.8-8.8-38.2-15-8.2-4.1-16.9-7-25.8-8.8v72.4c-13-.4-26 .8-38.7 3.6l-25.3 5.5V98l-64 16v73.1zm256 148.6c16.8 1.5 33.9-.7 50-6.8l14-5.2v-71.8l-7.9 1.8c-18.4 4.3-37.3 5.7-56.1 4.5v77.4zm64-149.4v-70.9c-20.9 6.1-42.4 9.1-64 9.1V194c13.9 1.4 28 .5 41.7-2.6l22.3-5.2z"
        }
    ]
};

const FasFlagPennant = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFlagPennant",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C64 14.3 49.7 0 32 0S0 14.3 0 32v448c0 17.7 14.3 32 32 32s32-14.3 32-32V352l369-138.4c9-3.4 15-12 15-21.6s-6-18.2-15-21.6L64 32z"
        }
    ]
};

const FasFlagSwallowtail = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFlagSwallowtail",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C64 14.3 49.7 0 32 0S0 14.3 0 32v448c0 17.7 14.3 32 32 32s32-14.3 32-32V352h360c13.3 0 24-10.7 24-24 0-5.2-1.7-10.2-4.8-14.4L352 192l91.2-121.6c3.1-4.2 4.8-9.2 4.8-14.4 0-13.3-10.7-24-24-24H64z"
        }
    ]
};

const FasFlagUsa = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFlagUsa",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 0c17.7 0 32 14.3 32 32v16l69-17.2c38.1-9.5 78.3-5.1 113.5 12.5 46.3 23.2 100.8 23.2 147.1 0l9.6-4.8c20.6-10.4 44.8 4.6 44.8 27.6v36.1l-44.7 16.2c-42.8 15.6-90 13.9-131.6-4.6l-16.1-7.2c-20.3-9-41.8-14.7-63.6-16.9v32.2c17.4 2.1 34.4 6.7 50.6 13.9l16.1 7.2c49.2 21.9 105 23.8 155.6 5.4l33.7-12.1v62l-44.7 16.2c-42.8 15.6-90 13.9-131.6-4.6l-16.1-7.2c-40.2-17.9-85-22.5-128.1-13.3L64 203.1v32.7l70.2-15.1c36.4-7.8 74.3-3.9 108.4 11.3l16.1 7.2c49.2 21.9 105 23.8 155.6 5.4l33.7-12.3v62l-44.7 16.2c-42.8 15.6-90 13.9-131.6-4.6l-16.1-7.2c-40.2-17.9-85-22.5-128.1-13.3L64 299.1v32.7l70.2-15.1c36.4-7.8 74.3-3.9 108.4 11.3l16.1 7.2c49.2 21.9 105 23.8 155.6 5.4l33.7-12.3v33.5c0 13.3-8.3 25.3-20.8 30l-34.7 13c-46.2 17.3-97.6 14.6-141.7-7.4-37.9-19-81.3-23.7-122.5-13.4L64 400v80c0 17.7-14.3 32-32 32S0 497.7 0 480V32C0 14.3 14.3 0 32 0zm80 96a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm32 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm-32 48a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm32 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
        }
    ]
};

const FasFlag = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFlag",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C64 14.3 49.7 0 32 0S0 14.3 0 32v448c0 17.7 14.3 32 32 32s32-14.3 32-32V352l64.3-16.1c41.1-10.3 84.6-5.5 122.5 13.4 44.2 22.1 95.5 24.8 141.7 7.4l34.7-13c12.5-4.7 20.8-16.6 20.8-30V66.1c0-23-24.2-38-44.8-27.7l-9.6 4.8c-46.3 23.2-100.8 23.2-147.1 0-35.1-17.6-75.4-22-113.5-12.5L64 48V32z"
        }
    ]
};

const FasFlashlight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFlashlight",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M576 416h32c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32h-32v320zM544 97.7C449.1 107.9 384 160 384 160H48c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48h336s65.1 52.1 160 62.3V97.7zM224 256c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32s-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32z"
        }
    ]
};

const FasFlaskGear = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFlaskGear",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 0H128c-17.7 0-32 14.3-32 32s14.3 32 32 32v132.8c0 11.8-3.3 23.5-9.5 33.5L10.3 406.2C3.6 417.2 0 429.7 0 442.6 0 480.9 31.1 512 69.4 512h309.2c10.6 0 20.7-2.4 29.7-6.6-2.8-6.2-4.2-12.9-4.2-19.7v-.9c-17.6 9.7-41.5 8.1-57.2-8.7-9.2-9.9-17.4-20.9-24.4-33s-12.5-24.7-16.4-37.6c-6.7-21.6 3.4-42.7 20-53.3l-.2-.2h-207l54.1-88.1c12.4-20.2 19-43.4 19-67.1V64h64v132.8c0 23.7 6.6 46.9 19 67.1l29 47.1c.1-4 .8-8.1 2-12.2 4-12.9 9.4-25.5 16.4-37.6 4.1-7.1 8.7-13.9 13.6-20.3l-6.5-10.6c-6.2-10.1-9.5-21.7-9.5-33.5V64c17.7 0 32-14.3 32-32S337.7 0 320 0h-32zm148 218.2v17.4c0 7.9-4.9 15-11.7 18.9-6.8 3.9-15.2 4.5-22 .6l-13.6-7.8c-6.1-3.5-13.7-2.7-18.5 2.4-7.5 8.1-14.3 17.2-20.1 27.2s-10.3 20.4-13.5 31c-2.1 6.7 1.1 13.7 7.2 17.2l14 8.1c6.5 3.8 10.1 11 10.1 18.6s-3.5 14.8-10.1 18.6l-14 8.1c-6.1 3.5-9.2 10.5-7.2 17.2 3.3 10.6 7.8 21 13.5 31s12.5 19.1 20.1 27.2c4.8 5.1 12.5 5.9 18.5 2.4l13.5-7.8c6.8-3.9 15.2-3.3 22 .6 6.9 3.9 11.7 11 11.7 18.9v17.4c0 7 4.5 13.3 11.3 14.8 10.5 2.4 21.5 3.7 32.7 3.7s22.2-1.3 32.7-3.7c6.8-1.5 11.3-7.8 11.3-14.8v-17.9c0-7.8 4.8-14.8 11.6-18.7 6.7-3.9 15.1-4.5 21.8-.6l13.8 7.9c6.1 3.5 13.7 2.7 18.5-2.4 7.6-8.1 14.3-17.2 20.1-27.2s10.3-20.4 13.5-31c2.1-6.7-1.1-13.7-7.2-17.2l-14.4-8.3c-6.5-3.7-10-10.9-10-18.4s3.5-14.7 10-18.4l14.4-8.3c6.1-3.5 9.2-10.5 7.2-17.2-3.3-10.6-7.8-21-13.5-31s-12.5-19.1-20.1-27.2c-4.8-5.1-12.5-5.9-18.5-2.4l-13.8 7.9c-6.7 3.9-15.1 3.3-21.8-.6-6.8-3.9-11.6-10.9-11.6-18.7v-17.5c0-7-4.5-13.3-11.3-14.8-10.5-2.4-21.5-3.7-32.7-3.7s-22.2 1.3-32.7 3.7c-6.8 1.5-11.3 7.8-11.3 14.8zm-4.1 133.5a48.1 48.1 0 1 1 96.1 0 48.1 48.1 0 1 1-96.1 0z"
        }
    ]
};

const FasFlaskRoundPoison = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFlaskRoundPoison",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M328.5 172.1c-5.2-3-8.5-8.4-8.5-14.4V64c17.7 0 32-14.3 32-32S337.7 0 320 0H128c-17.7 0-32 14.3-32 32s14.3 32 32 32v93.7c0 6-3.3 11.4-8.5 14.4-5.3 3.1-10.4 6.4-15.4 9.9C50.8 219.7 16 281.8 16 352c0 56 22.1 106.9 58.2 144.3 10.3 10.7 25.1 15.7 40 15.7h219.6c15 0 29.7-5 40.1-15.7C409.9 458.9 432 408 432 352c0-76.8-41.6-143.8-103.5-179.9zM300 376.6c-7.1 5.2-12 13-12 21.8v9.6c0 13.3-10.7 24-24 24h-80c-13.3 0-24-10.7-24-24v-9.6c0-8.8-4.9-16.7-12-21.8-22.1-16.1-36-39.1-36-64.6 0-48.6 50.1-88 112-88s112 39.4 112 88c0 25.5-13.9 48.6-36 64.6zM184 336a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm104-24a24 24 0 1 0-48 0 24 24 0 1 0 48 0z"
        }
    ]
};

const FasFlaskRoundPotion = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFlaskRoundPotion",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 64h64v93.7c0 30.4 16.9 56.1 40.3 69.7 43 25 71.6 71.4 71.7 124.4-58.6-1.7-85.4-12.6-109.9-22.6-22-9-42.2-17.2-82.1-17.2-42.3 0-73.4 9.2-94.5 18.8 6.5-44.1 33-81.7 70.2-103.4 23.4-13.6 40.3-39.3 40.3-69.7V64zm128 93.7V64c17.7 0 32-14.3 32-32S337.7 0 320 0H128c-17.7 0-32 14.3-32 32s14.3 32 32 32v93.7c0 6-3.3 11.4-8.5 14.4C57.6 208.2 16 275.2 16 352c0 56 22.1 106.9 58.2 144.3 10.3 10.7 25.1 15.7 40 15.7h219.6c15 0 29.7-5 40.1-15.7C409.9 458.9 432 408 432 352c0-76.8-41.6-143.8-103.5-179.9-5.2-3-8.5-8.4-8.5-14.4z"
        }
    ]
};

const FasFlaskVial = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFlaskVial",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M175 389.4c-9.8 16-15 34.3-15 53.1-10 3.5-20.8 5.5-32 5.5-53 0-96-43-96-96V64C14.3 64 0 49.7 0 32S14.3 0 32 0h192c17.7 0 32 14.3 32 32s-14.3 32-32 32v245.9l-49 79.6zM96 64v96h64V64H96zM352 0h160c17.7 0 32 14.3 32 32s-14.3 32-32 32v150.9l117.7 191.3a69.54 69.54 0 0 1 10.3 36.4c0 38.3-31.1 69.4-69.4 69.4H261.4c-38.3 0-69.4-31.1-69.4-69.4 0-12.8 3.6-25.4 10.3-36.4L320 214.9V64c-17.7 0-32-14.3-32-32s14.3-32 32-32h32zm32 64v160c0 5.9-1.6 11.7-4.7 16.8L330.5 320h171l-48.8-79.2c-3.1-5-4.7-10.8-4.7-16.8V64h-64z"
        }
    ]
};

const FasFlask = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFlask",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 0H128c-17.7 0-32 14.3-32 32s14.3 32 32 32v132.8c0 11.8-3.3 23.5-9.5 33.5L10.3 406.2C3.6 417.2 0 429.7 0 442.6 0 480.9 31.1 512 69.4 512h309.2c38.3 0 69.4-31.1 69.4-69.4 0-12.8-3.6-25.4-10.3-36.4L329.5 230.4c-6.2-10.1-9.5-21.7-9.5-33.5V64c17.7 0 32-14.3 32-32S337.7 0 320 0h-32zm-96 196.8V64h64v132.8c0 23.7 6.6 46.9 19 67.1l34.5 56.1h-171l34.5-56.1c12.4-20.2 19-43.4 19-67.1z"
        }
    ]
};

const FasFlatbreadStuffed = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFlatbreadStuffed",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M272.2 4c-12.8-7-28.7-4.5-38.7 6.1l-46.9 49.8c-4.6 4.9-10.5 8.2-17.1 9.5l-67.1 13.3c-14.3 2.8-24.9 15-25.7 29.6l-3.8 68.3c-.4 6.7-2.8 13-7 18.2l-42.8 53.3c-9.1 11.4-9.4 27.5-.7 39.2l40.9 54.8c4 5.3 6.2 11.8 6.4 18.5l.9 41.2c2.6-4.9 5.9-9.4 9.9-13.3l55.9-55.9C121.1 316.3 112 291.2 112 264c0-66.3 53.7-120 120-120 27.2 0 52.3 9.1 72.5 24.3L424.4 48.4c4.6-4.6 10-8.3 15.8-11.1-6.1-3.9-13.4-5.7-21-4.8l-67.9 8.1c-6.6.8-13.3-.5-19.2-3.7L272.2 4zM159.3 313.5l122.2-122.2c-14.1-9.7-31.1-15.3-49.5-15.3-48.6 0-88 39.4-88 88 0 18.4 5.6 35.4 15.3 49.5zM482.8 73.1c-4.3-5.4-10.6-8.6-17.4-9s-13.5 2.2-18.3 7l-43 43-43 43-86 86-86 86-86 86c-4.8 4.8-7.4 11.5-7 18.3s3.7 13.2 9 17.4C150.8 487.1 207.3 512 272 512c150.2 0 272-121.8 272-272 0-64.7-24.9-121.2-61.2-166.9zM256 432a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-48-48a16 16 0 1 1 32 0 16 16 0 1 1-32 0z"
        }
    ]
};

const FasFlatbread = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFlatbread",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm107.3-340.7-192 192c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l192-192c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zm-112-70.6c6.2 6.2 6.2 16.4 0 22.6l-128 128c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l128-128c6.2-6.2 16.4-6.2 22.6 0zm160 182.6-128 128c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l128-128c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
        }
    ]
};

const FasFloppyDiskCircleArrowRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFloppyDiskCircleArrowRight",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h232.2c-17.6-21.4-30.3-46.9-36.3-75-10.2 6.9-22.6 11-35.9 11-35.3 0-64-28.7-64-64s28.7-64 64-64c16.8 0 32.1 6.5 43.6 17.1C292.9 239 357 192 432 192c5.4 0 10.7.2 16 .7v-19.4c0-17-6.7-33.3-18.7-45.3L352 50.7c-12-12-28.3-18.7-45.3-18.7H64zm0 96c0-17.7 14.3-32 32-32h192c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32v-64zm512 240a144 144 0 1 0-288 0 144 144 0 1 0 288 0zm-147.3-67.3c6.2-6.2 16.4-6.2 22.6 0l56 56c6.2 6.2 6.2 16.4 0 22.6l-56 56c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l28.7-28.7H368c-8.8 0-16-7.2-16-16s7.2-16 16-16h89.4l-28.7-28.7c-6.2-6.2-6.2-16.4 0-22.6z"
        }
    ]
};

const FasFloppyDiskCircleXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFloppyDiskCircleXmark",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h232.2c-17.6-21.4-30.3-46.9-36.3-75-10.2 6.9-22.6 11-35.9 11-35.3 0-64-28.7-64-64s28.7-64 64-64c16.8 0 32.1 6.5 43.6 17.1C292.9 239 357 192 432 192c5.4 0 10.7.2 16 .7v-19.4c0-17-6.7-33.3-18.7-45.3L352 50.7c-12-12-28.3-18.7-45.3-18.7H64zm0 96c0-17.7 14.3-32 32-32h192c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32v-64zm368 384a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L454.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L432 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l36.7-36.7-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l36.7 36.7 36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
        }
    ]
};

const FasFloppyDiskPen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFloppyDiskPen",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h194.5l14-55.9c2.8-11.3 8.6-21.5 16.8-29.7L448 235.6v-62.3c0-17-6.7-33.3-18.7-45.3L352 50.7c-12-12-28.3-18.7-45.3-18.7H64zm0 96c0-17.7 14.3-32 32-32h192c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32v-64zm160 160a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm325.8-52.2c-15.6-15.6-40.9-15.6-56.6 0l-29.4 29.4 71 71 29.4-29.4c15.6-15.6 15.6-40.9 0-56.6l-14.4-14.4zM311.9 417.1c-4.1 4.1-7 9.2-8.4 14.9l-15 60.1c-1.4 5.5.2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l60.1-15c5.6-1.4 10.8-4.3 14.9-8.4l129.2-129.3-71-71-129.2 129.3z"
        }
    ]
};

const FasFloppyDisk = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFloppyDisk",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V173.3c0-17-6.7-33.3-18.7-45.3L352 50.7c-12-12-28.3-18.7-45.3-18.7H64zm0 96c0-17.7 14.3-32 32-32h192c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32v-64zm160 160a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"
        }
    ]
};

const FasFloppyDisks = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFloppyDisks",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 56c0-30.9 25.1-56 56-56h218.7c14.9 0 29.1 5.9 39.6 16.4l85.3 85.3c10.5 10.5 16.4 24.7 16.4 39.6V360c0 30.9-25.1 56-56 56H152c-30.9 0-56-25.1-56-56V56zm96 8c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h160c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H192zm176 224a64 64 0 1 0-128 0 64 64 0 1 0 128 0zM48 120v256c0 48.6 39.4 88 88 88h256c13.3 0 24 10.7 24 24s-10.7 24-24 24H136C60.9 512 0 451.1 0 376V120c0-13.3 10.7-24 24-24s24 10.7 24 24z"
        }
    ]
};

const FasFlorinSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFlorinSign",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M314.7 32c-38.8 0-73.7 23.3-88.6 59.1L170.7 224H64c-17.7 0-32 14.3-32 32s14.3 32 32 32h80L98.9 396.3c-5 11.9-16.6 19.7-29.5 19.7H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h37.3c38.8 0 73.7-23.3 88.6-59.1L213.3 288H320c17.7 0 32-14.3 32-32s-14.3-32-32-32h-80l45.1-108.3c5-11.9 16.6-19.7 29.5-19.7H352c17.7 0 32-14.3 32-32s-14.3-32-32-32h-37.3z"
        }
    ]
};

const FasFlowerDaffodil = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFlowerDaffodil",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 281.3c9.8 4.3 20.6 6.7 32 6.7 44.2 0 80-35.8 80-80 0-26.2-12.6-49.4-32-64 19.4-14.6 32-37.8 32-64 0-44.2-35.8-80-80-80-26.2 0-49.4 12.6-64 32-14.6-19.4-37.8-32-64-32-44.2 0-80 35.8-80 80 0 26.2 12.6 49.4 32 64-19.4 14.6-32 37.8-32 64 0 44.2 35.8 80 80 80 11.4 0 22.2-2.4 32-6.7v113.5C192.1 349.5 139.5 320 80 320H29.5C13.2 320 0 333.2 0 349.5 0 439.3 72.7 512 162.5 512h187c89.8 0 162.5-72.7 162.5-162.5 0-16.3-13.2-29.5-29.5-29.5H432c-59.5 0-112.1 29.5-144 74.8V281.3zM208 144a48 48 0 1 1 96 0 48 48 0 1 1-96 0z"
        }
    ]
};

const FasFlowerTulip = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFlowerTulip",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 44v84c0 70.7 57.3 128 128 128v138.8C192.1 349.5 139.5 320 80 320H29.5C13.2 320 0 333.2 0 349.5 0 439.3 72.7 512 162.5 512h187c89.8 0 162.5-72.7 162.5-162.5 0-16.3-13.2-29.5-29.5-29.5H432c-59.5 0-112.1 29.5-144 74.8V256c70.7 0 128-57.3 128-128V44c0-6.6-5.4-12-12-12-2.6 0-5.1.8-7.2 2.4L336 80 268.8 5.3c-3-3.4-7.4-5.3-11.9-5.3h-1.7c-4.5 0-8.9 1.9-11.9 5.3L176 80l-60.8-45.6c-2.1-1.6-4.6-2.4-7.2-2.4-6.6 0-12 5.4-12 12z"
        }
    ]
};

const FasFlower = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFlower",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 480c38.2 0 72.5-16.8 96-43.3 23.5 26.6 57.8 43.3 96 43.3 70.7 0 128-57.3 128-128 0-38.2-16.8-72.5-43.3-96 26.6-23.5 43.3-57.8 43.3-96 0-70.7-57.3-128-128-128-38.2 0-72.5 16.8-96 43.3C200.5 48.8 166.2 32 128 32 57.3 32 0 89.3 0 160c0 38.2 16.8 72.5 43.3 96C16.8 279.5 0 313.8 0 352c0 70.7 57.3 128 128 128zm96-304a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"
        }
    ]
};

const FasFlute = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFlute",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 160h48v192H48c-26.5 0-48-21.5-48-48v-96c0-26.5 21.5-48 48-48zm544 192H128V160h464c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48zm-272-72a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm120-24a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm72 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FasFluxCapacitor = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFluxCapacitor",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm148.7 141.3-49-49c-15.6-15.6-15.6-40.9 0-56.6s40.9-15.6 56.6 0l49 49c1.8-6.6 2.7-13.6 2.7-20.7 0-44.2-35.8-80-80-80s-80 35.8-80 80 35.8 80 80 80c7.2 0 14.1-.9 20.7-2.7zm35.3 45.4c-23.9 13.8-40 39.7-40 69.3 0 44.2 35.8 80 80 80s80-35.8 80-80c0-29.6-16.1-55.5-40-69.3V352c0 22.1-17.9 40-40 40s-40-17.9-40-40v-69.3zm115.3-45.4c6.6 1.8 13.6 2.7 20.7 2.7 44.2 0 80-35.8 80-80s-35.8-80-80-80-80 35.8-80 80c0 7.2.9 14.1 2.7 20.7l49-49c15.6-15.6 40.9-15.6 56.6 0s15.6 40.9 0 56.6l-49 49zm-160-88.6c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l91.3 91.3V352c0 8.8 7.2 16 16 16s16-7.2 16-16v-89.4l91.3-91.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L224 233.4l-84.7-84.7z"
        }
    ]
};

const FasFlyingDisc = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFlyingDisc",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M119.7 456.3c-25.2-25.2-29.6-66.7-16.5-114.9 3.2 9.5 8.4 18.5 16.2 26.3 15.6 15.6 36 20.7 55 20.5 18.8-.1 38.8-5.3 58.2-13.3 39-16.1 82-46 121.2-85.1s69-82.2 85.1-121.2c8-19.4 13.2-39.4 13.3-58.2.1-19-5-39.5-20.5-55-7.8-7.8-16.8-13-26.3-16.2 48.2-13 89.8-8.6 114.9 16.6 55.3 55.3 10.5 189.8-100.2 300.5S175 511.6 119.7 456.3zm211.4-189.2C257.4 340.9 172.7 375.8 142 345s4.1-115.4 77.9-189.2S378.3 47.2 409 77.9s-4.1 115.4-77.9 189.2z"
        }
    ]
};

const FasFolderArrowDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFolderArrowDown",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h128c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8h160c35.3 0 64 28.7 64 64v256zM280 200c0-13.3-10.7-24-24-24s-24 10.7-24 24v102.1l-31-31c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l72 72c9.4 9.4 24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-31 31V200z"
        }
    ]
};

const FasFolderArrowUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFolderArrowUp",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h128c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8h160c35.3 0 64 28.7 64 64v256zm-232-40V273.9l31 31c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-72-72c-9.4-9.4-24.6-9.4-33.9 0l-72 72c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l31-31V376c0 13.3 10.7 24 24 24s24-10.7 24-24z"
        }
    ]
};

const FasFolderBookmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFolderBookmark",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 480H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h128c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8h160c35.3 0 64 28.7 64 64v256c0 35.3-28.7 64-64 64zM288 176v160c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L368 308l54.4 40.8c4.8 3.6 11.3 4.2 16.8 1.5s8.8-8.2 8.8-14.3V176c0-8.8-7.2-16-16-16H304c-8.8 0-16 7.2-16 16z"
        }
    ]
};

const FasFolderClosed = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFolderClosed",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 480H64c-35.3 0-64-28.7-64-64V192h512v224c0 35.3-28.7 64-64 64zm64-320H0V96c0-35.3 28.7-64 64-64h128c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8h160c35.3 0 64 28.7 64 64z"
        }
    ]
};

const FasFolderGear = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFolderGear",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h128c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8h160c35.3 0 64 28.7 64 64v256zM368.6 259.9c6.3-3.6 9.5-11.1 6.8-18-2.1-5.5-4.6-10.8-7.4-15.9l-2.3-4c-3.1-5.1-6.5-9.9-10.2-14.5-4.6-5.7-12.7-6.7-19-3l-2.9 1.7c-9.2 5.3-20.4 4-29.6-1.3s-16.1-14.5-16.1-25.1v-3.4c0-7.3-4.9-13.8-12.1-14.9-6.5-1-13.1-1.5-19.9-1.5s-13.4.5-19.9 1.5c-7.2 1.1-12.1 7.6-12.1 14.9v3.4c0 10.6-6.9 19.8-16.1 25.1s-20.4 6.6-29.6 1.3l-2.9-1.7c-6.3-3.6-14.4-2.6-19 3-3.7 4.6-7.1 9.5-10.2 14.6l-2.3 3.9c-2.8 5.1-5.3 10.4-7.4 15.9-2.6 6.8.5 14.3 6.8 18l2.9 1.7c9.2 5.3 13.7 15.8 13.7 26.4s-4.5 21.1-13.7 26.4l-3 1.7c-6.3 3.6-9.5 11.1-6.8 17.9 2.1 5.5 4.6 10.7 7.4 15.8l2.4 4.1c3.1 5.1 6.4 9.9 10.1 14.5 4.6 5.7 12.7 6.7 19 3l2.9-1.7c9.2-5.3 20.4-4 29.6 1.3s16.1 14.5 16.1 25.1v3.4c0 7.3 4.9 13.8 12.1 14.9 6.5 1 13.1 1.5 19.9 1.5s13.4-.5 19.9-1.5c7.2-1.1 12.1-7.6 12.1-14.9v-3.4c0-10.6 6.9-19.8 16.1-25.1s20.4-6.6 29.6-1.3l2.9 1.7c6.3 3.6 14.4 2.6 19-3 3.7-4.6 7.1-9.4 10.1-14.5l2.4-4.2c2.8-5.1 5.3-10.3 7.4-15.8 2.6-6.8-.5-14.3-6.8-17.9l-3-1.7c-9.2-5.3-13.7-15.8-13.7-26.4s4.5-21.1 13.7-26.4l3-1.7zM216 288a40 40 0 1 1 80 0 40 40 0 1 1-80 0z"
        }
    ]
};

const FasFolderGrid = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFolderGrid",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 480H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h128c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8h160c35.3 0 64 28.7 64 64v256c0 35.3-28.7 64-64 64zM104 240c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24h-48zm128 0c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24h-48zm104 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24h-48c-13.3 0-24 10.7-24 24z"
        }
    ]
};

const FasFolderHeart = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFolderHeart",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h128c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8h160c35.3 0 64 28.7 64 64v256zM144 253.3c0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3 0-33.8-27.4-61.3-61.3-61.3-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9-33.8 0-61.3 27.4-61.3 61.3z"
        }
    ]
};

const FasFolderImage = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFolderImage",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 480H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h128c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8h160c35.3 0 64 28.7 64 64v256c0 35.3-28.7 64-64 64zM176 224a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm120 0c-8 0-15.5 4-20 10.7l-56 84-17.3-21.7c-4.6-5.7-11.5-9-18.7-9s-14.2 3.3-18.7 9l-64 80c-5.8 7.2-6.9 17.1-2.9 25.4S110.8 416 120 416h272c8.9 0 17-4.9 21.2-12.7s3.7-17.3-1.2-24.6l-96-144c-4.5-6.7-12-10.7-20-10.7z"
        }
    ]
};

const FasFolderMagnifyingGlass = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFolderMagnifyingGlass",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 480H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h128c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8h160c35.3 0 64 28.7 64 64v256c0 35.3-28.7 64-64 64zM336 272c0-53-43-96-96-96s-96 43-96 96 43 96 96 96c17.8 0 34.4-4.8 48.7-13.2l38.3 38.3c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-38.3-38.3c8.5-14.3 13.3-31 13.3-48.9zm-96-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
        }
    ]
};

const FasFolderMedical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFolderMedical",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 480H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h128c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8h160c35.3 0 64 28.7 64 64v256c0 35.3-28.7 64-64 64zM224 208v48h-48c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-48h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-48v-48c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16z"
        }
    ]
};

const FasFolderMinus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFolderMinus",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 480H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h128c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8h160c35.3 0 64 28.7 64 64v256c0 35.3-28.7 64-64 64zM184 272c-13.3 0-24 10.7-24 24s10.7 24 24 24h144c13.3 0 24-10.7 24-24s-10.7-24-24-24H184z"
        }
    ]
};

const FasFolderMusic = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFolderMusic",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h128c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8h160c35.3 0 64 28.7 64 64v256zM352 192c0-5.2-2.6-10.2-6.9-13.2s-9.8-3.7-14.7-1.8l-128 48c-6.2 2.3-10.4 8.3-10.4 15v113.8c-5-1.2-10.4-1.8-16-1.8-26.5 0-48 14.3-48 32s21.5 32 48 32 48-14.3 48-32V283.1l96-36v74.7c-5-1.2-10.4-1.8-16-1.8-26.5 0-48 14.3-48 32s21.5 32 48 32 48-14.3 48-32V192z"
        }
    ]
};

const FasFolderOpen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFolderOpen",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M88.7 223.8 0 375.8V96c0-35.3 28.7-64 64-64h117.5c17 0 33.3 6.7 45.3 18.7l26.5 26.5c12 12 28.3 18.7 45.3 18.7H416c35.3 0 64 28.7 64 64v32H144c-22.8 0-43.8 12.1-55.3 31.8zm27.6 16.1c5.8-9.9 16.3-15.9 27.7-15.9h400c11.5 0 22 6.1 27.7 16.1s5.7 22.2-.1 32.1l-112 192C453.9 474 443.4 480 432 480H32c-11.5 0-22-6.1-27.7-16.1s-5.7-22.2.1-32.1l112-192z"
        }
    ]
};

const FasFolderPlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFolderPlus",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h128c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8h160c35.3 0 64 28.7 64 64v256zm-280-40c0 13.3 10.7 24 24 24s24-10.7 24-24v-64h64c13.3 0 24-10.7 24-24s-10.7-24-24-24h-64v-64c0-13.3-10.7-24-24-24s-24 10.7-24 24v64h-64c-13.3 0-24 10.7-24 24s10.7 24 24 24h64v64z"
        }
    ]
};

const FasFolderTree = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFolderTree",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C64 14.3 49.7 0 32 0S0 14.3 0 32v352c0 35.3 28.7 64 64 64h192v-64H64V160h192V96H64V32zm224 160c0 17.7 14.3 32 32 32h224c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32h-98.7c-8.5 0-16.6-3.4-22.6-9.4L409.4 9.4c-6-6-14.1-9.4-22.6-9.4H320c-17.7 0-32 14.3-32 32v160zm0 288c0 17.7 14.3 32 32 32h224c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32h-98.7c-8.5 0-16.6-3.4-22.6-9.4l-13.3-13.3c-6-6-14.1-9.4-22.6-9.4H320c-17.7 0-32 14.3-32 32V480z"
        }
    ]
};

const FasFolderUser = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFolderUser",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h128c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8h160c35.3 0 64 28.7 64 64v256zM320 256a64 64 0 1 0-128 0 64 64 0 1 0 128 0zM144 405.3c0 5.9 4.8 10.7 10.7 10.7h202.6c5.9 0 10.7-4.8 10.7-10.7 0-29.5-23.9-53.3-53.3-53.3H197.3c-29.5 0-53.3 23.9-53.3 53.3z"
        }
    ]
};

const FasFolderXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFolderXmark",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 480H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h128c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8h160c35.3 0 64 28.7 64 64v256c0 35.3-28.7 64-64 64zM175 207c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z"
        }
    ]
};

const FasFolder = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFolder",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 480h384c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H288c-10.1 0-19.6-4.7-25.6-12.8l-19.2-25.6C231.1 41.5 212.1 32 192 32H64C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64z"
        }
    ]
};

const FasFolders = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFolders",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 384c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H394.5c-17 0-33.3-6.7-45.3-18.7l-26.5-26.6c-12-12-28.3-18.7-45.3-18.7H160c-35.3 0-64 28.7-64 64v224c0 35.3 28.7 64 64 64h352zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120v224c0 75.1 60.9 136 136 136h320c13.3 0 24-10.7 24-24s-10.7-24-24-24H136c-48.6 0-88-39.4-88-88V120z"
        }
    ]
};

const FasFonduePot = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFonduePot",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m319 39.8-24 96c-2.9 11.5-11.6 20-22.2 23l-8.3 33.2h-33l10.2-41c-7.9-7.7-11.7-19.3-8.8-30.8l24-96C261.2 7.1 278.6-3.3 295.8 1s27.6 21.7 23.3 38.8zM381.9 160l-21.3 32h-38.5l33.2-49.8c-4.9-9.9-4.5-22.1 2.1-31.9l64-96C431.2-.5 451-4.4 465.8 5.4s18.7 29.7 8.9 44.4l-64 96c-6.6 9.9-17.7 14.9-28.7 14.2zM32 224h32v80c0 8.8 7.2 16 16 16s16-7.2 16-16v-32c0-8.8 7.2-16 16-16s16 7.2 16 16 7.2 16 16 16 16-7.2 16-16v-48h320c17.7 0 32 14.3 32 32s-14.3 32-32 32h-32v32c0 52.3-25.1 98.8-64 128v32c0 17.7-14.3 32-32 32s-32-14.3-32-32v-3.2c-10.3 2.1-21 3.2-32 3.2H160c-11 0-21.7-1.1-32-3.2v3.2c0 17.7-14.3 32-32 32s-32-14.3-32-32v-32C25.1 418.8 0 372.3 0 320v-64c0-17.7 14.3-32 32-32z"
        }
    ]
};

const FasFontAwesome = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFontAwesome",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 48v336c-63.1 22.5-82.3 32-119.5 32-62.8 0-86.6-32-149.3-32-20.6 0-36.6 3.6-51.2 8.2v-64c14.6-4.6 30.6-8.2 51.2-8.2 62.7 0 86.5 32 149.3 32 20.4 0 35.6-3 55.5-9.3v-208c-19.9 6.3-35.1 9.3-55.5 9.3-62.8 0-86.6-32-149.3-32-50.8 0-74.9 20.6-115.2 28.7V448c0 17.7-14.3 32-32 32S0 465.7 0 448V64c0-17.7 14.3-32 32-32s32 14.3 32 32v12.7c40.3-8 64.4-28.7 115.2-28.7 62.7 0 86.5 32 149.3 32 37.1 0 56.4-9.5 119.5-32z"
        }
    ]
};

const FasFontCase = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFontCase",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M206 52.8C201.3 40.3 189.3 32 176 32s-25.3 8.3-30 20.8L2 436.8c-6.2 16.5 2.2 35 18.7 41.2s35-2.2 41.2-18.7L96.2 368h159.6l34.2 91.2c6.2 16.5 24.7 24.9 41.2 18.7s24.9-24.6 18.7-41.2L206 52.8zM231.8 304H120.2L176 155.1 231.8 304zM608 160c-13 0-24.1 7.7-29.2 18.8-19.4-11.9-42.3-18.8-66.8-18.8-70.7 0-128 57.3-128 128v64c0 70.7 57.3 128 128 128 24.5 0 47.4-6.9 66.8-18.8 5 11.1 16.2 18.8 29.2 18.8 17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-32 128v64c0 35.3-28.7 64-64 64s-64-28.7-64-64v-64c0-35.3 28.7-64 64-64s64 28.7 64 64z"
        }
    ]
};

const FasFont = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFont",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M254 52.8C249.3 40.3 237.3 32 224 32s-25.3 8.3-30 20.8L57.8 416H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32h-1.8l18-48h159.6l18 48H320c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32h-25.8L254 52.8zM279.8 304H168.2L224 155.1 279.8 304z"
        }
    ]
};

const FasFootballHelmet = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFootballHelmet",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M488.1 194.9c4.5 17.1-8.2 33.1-25.7 35.3l-122.1 15.3 14 74.5H464c26.5 0 48 21.5 48 48v82.4c0 25.2-20.4 45.6-45.6 45.6h-17c-54.9 0-102-39.1-112.1-93.1l-9.6-50.9H288l9.2 18.3c4.5 9 6.8 18.9 6.8 28.9 0 35.7-29 64.7-64.7 64.7h-1.7c-9 0-17.9-1.8-26.1-5.4l-93.4-40c-4-1.7-8.3-2.6-12.6-2.6h-14c-9.1 0-17.9-3.8-23.5-10.9-32.6-40.9-52-92.7-52-149C16 123.5 123.5 16 256 16c111.4 0 205.1 75.9 232.1 178.9zm-207.1 58c-14.3 1.8-25.1 14-25.1 28.4 0 4.4 1 8.8 3 12.8l13 26h49.7l-13.2-70.6-27.4 3.4zm79.3 99.1 6 32H480v-16c0-8.8-7.2-16-16-16H360.3zM480 416H374.7c13.1 28.7 42 48 74.7 48h17c7.5 0 13.6-6.1 13.6-13.6V416zm-304-56a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FasFootball = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFootball",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M247.5 25.4c-13.5 3.3-26.4 7.2-38.6 11.7-66 24.5-112.2 66.5-142.9 116.5-18.3 29.8-30.9 62.3-39.2 95.4l237.7 237.6c13.5-3.3 26.4-7.2 38.6-11.7 66-24.5 112.2-66.5 142.9-116.5 18.3-29.8 30.9-62.3 39.1-95.3L247.5 25.4zm247.7 179.9c6.1-56.8 1.4-112.2-7.7-156.4-2.7-12.9-13-22.9-26.1-25.1-58.2-9.7-109.9-12-155.6-7.9l189.4 189.4zM206.1 496 16.8 306.7c-6.1 56.8-1.4 112.2 7.7 156.4 2.7 12.9 13 22.9 26.1 25.1 58.2 9.7 109.9 12 155.6 7.9zm54.6-331.3c6.2-6.2 16.4-6.2 22.6 0l64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6zm-48 48c6.2-6.2 16.4-6.2 22.6 0l64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6zm-48 48c6.2-6.2 16.4-6.2 22.6 0l64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6z"
        }
    ]
};

const FasForkKnife = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasForkKnife",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M475.3 27.3c5.8-5.8 6.3-15.1 1.1-21.5S462-1.9 455.1 2.7l-106.5 71c-27.8 18.6-44.6 49.9-44.6 83.4 0 19.3 5.5 37.9 15.7 53.9L73.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L365 256.3c16 10.2 34.7 15.7 53.9 15.7 33.5 0 64.8-16.8 83.4-44.6l71-106.5c4.6-6.8 3.2-16-3.2-21.2s-15.6-4.8-21.5 1.1L457.4 192c-5.2 5.2-13.6 5.2-18.8 0-4.9-4.9-5.2-12.8-.6-18.1l86.1-99.4c5.5-6.3 5.2-15.9-.8-21.8s-15.4-6.3-21.8-.8L402.1 138c-5.3 4.6-13.2 4.3-18.1-.6-5.2-5.2-5.2-13.6 0-18.8l91.3-91.3zM52.5 7.3C47.9 2.6 41.5 0 34.9 0c-11.2 0-21 7.5-23.5 18.4C6.7 38.6 0 71.5 0 96c0 83.3 48.2 130.5 128.9 209.4 6.5 6.4 13.3 13 20.3 19.9 1.9 1.8 3.8 3.5 5.9 5.1l110.3-110.3L52.5 7.3zm404.9 495.3c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L355.9 310.6l-45.3 45.3 146.8 146.7z"
        }
    ]
};

const FasFork = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFork",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M412.4 5.9c5.2 6.4 4.8 15.6-1.1 21.5L320 118.6c-5.2 5.2-5.2 13.6 0 18.8 4.9 4.9 12.8 5.2 18.1.6l99.4-86.1c6.3-5.5 15.9-5.2 21.8.8s6.3 15.4.8 21.8L374 173.9c-4.6 5.3-4.3 13.2.6 18.1 5.2 5.2 13.6 5.2 18.8 0l91.3-91.3c5.8-5.8 15.1-6.3 21.5-1.1s7.7 14.4 3.2 21.2l-71 106.5c-18.6 27.9-49.9 44.6-83.4 44.6-19.3 0-37.9-5.5-53.9-15.7L54.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L255.7 211c-10.2-16-15.7-34.7-15.7-53.9 0-33.5 16.8-64.8 44.6-83.4l106.5-71c6.8-4.6 16-3.2 21.2 3.2z"
        }
    ]
};

const FasForklift = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasForklift",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 160h48V48c0-26.5 21.5-48 48-48h148.7c20.3 0 38.4 12.8 45.2 31.9l75.3 210.8c1.8 5.2 2.8 10.6 2.8 16.1v85.7c19.6 17.6 32 43.1 32 71.6 0 53-43 96-96 96s-96-43-96-96h-64c0 53-43 96-96 96s-96-43-96-96V208c0-26.5 21.5-48 48-48zm208 96h94L281.4 64H160v96l96 96zM96 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm256 0a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM544 32v352h64c17.7 0 32 14.3 32 32s-14.3 32-32 32h-96c-17.7 0-32-14.3-32-32V32c0-17.7 14.3-32 32-32s32 14.3 32 32z"
        }
    ]
};

const FasFort = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFort",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 16C0 7.2 7.2 0 16 0h32c8.8 0 16 7.2 16 16v48h32V16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h32V16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v144h128V16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h32V16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h32V16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v160c0 20.9-13.4 38.7-32 45.3V464c0 26.5-21.5 48-48 48H384V384c0-35.3-28.7-64-64-64s-64 28.7-64 64v128H80c-26.5 0-48-21.5-48-48V221.3C13.4 214.7 0 196.9 0 176V16z"
        }
    ]
};

const FasForwardFast = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasForwardFast",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M18.4 445c11.2 5.3 24.5 3.6 34.1-4.4L224 297.7V416c0 12.4 7.2 23.7 18.4 29s24.5 3.6 34.1-4.4L448 297.7V416c0 17.7 14.3 32 32 32s32-14.3 32-32V96c0-17.7-14.3-32-32-32s-32 14.3-32 32v118.3L276.5 71.4c-9.5-7.9-22.8-9.7-34.1-4.4S224 83.6 224 96v118.3L52.5 71.4C43 63.5 29.7 61.7 18.4 67S0 83.6 0 96v320c0 12.4 7.2 23.7 18.4 29z"
        }
    ]
};

const FasForwardStep = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasForwardStep",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M52.5 440.6c-9.5 7.9-22.8 9.7-34.1 4.4S0 428.4 0 416V96c0-12.4 7.2-23.7 18.4-29s24.5-3.6 34.1 4.4l192 160L256 241V96c0-17.7 14.3-32 32-32s32 14.3 32 32v320c0 17.7-14.3 32-32 32s-32-14.3-32-32V271l-11.5 9.6-192 160z"
        }
    ]
};

const FasForward = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasForward",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M52.5 440.6c-9.5 7.9-22.8 9.7-34.1 4.4S0 428.4 0 416V96c0-12.4 7.2-23.7 18.4-29s24.5-3.6 34.1 4.4L224 214.3v83.4L52.5 440.6zM256 352V96c0-12.4 7.2-23.7 18.4-29s24.5-3.6 34.1 4.4l192 160c7.3 6.1 11.5 15.1 11.5 24.6s-4.2 18.5-11.5 24.6l-192 160c-9.5 7.9-22.8 9.7-34.1 4.4S256 428.4 256 416v-64z"
        }
    ]
};

const FasFrame = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFrame",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 128c0-17.7-14.3-32-32-32h-32V64c0-17.7-14.3-32-32-32s-32 14.3-32 32v32H128V64c0-17.7-14.3-32-32-32S64 46.3 64 64v32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h32v192H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h32v32c0 17.7 14.3 32 32 32s32-14.3 32-32v-32h192v32c0 17.7 14.3 32 32 32s32-14.3 32-32v-32h32c17.7 0 32-14.3 32-32s-14.3-32-32-32h-32V160h32c17.7 0 32-14.3 32-32zM128 352V160h192v192H128z"
        }
    ]
};

const FasFrancSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFrancSign",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 32c-17.7 0-32 14.3-32 32v256H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h16v64c0 17.7 14.3 32 32 32s32-14.3 32-32v-64h80c17.7 0 32-14.3 32-32s-14.3-32-32-32h-80v-64h144c17.7 0 32-14.3 32-32s-14.3-32-32-32H112V96h176c17.7 0 32-14.3 32-32s-14.3-32-32-32H80z"
        }
    ]
};

const FasFrenchFries = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFrenchFries",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M183.2 1.7c-5-2.5-10.8-2.2-15.6.7S160 10.5 160 16v253.9c9.2 1.4 19.8 2.2 32 2.2s22.8-.8 32-2.2V31.8c-.1-6-3.5-11.4-8.8-14.1l-32-16zm-55.2 13-.2-1.3c-.8-5-4-9.3-8.5-11.6s-9.9-2.3-14.4-.1l-32 16c-6.3 3.1-9.8 10-8.6 16.9l32 192c.5 1.2.9 2.3 1.2 3.4 2 6.3 6.7 15.9 18.7 24.3 3.2 2.2 7.1 4.5 11.8 6.6V14.7zM40.3 85.6l-20.4-5.1c-5.3-1.3-10.8.1-14.8 3.8S-.7 93.4.2 98.8l16.5 93.4c1.6-.1 3.1-.2 4.7-.2H48c3.6 0 7 .4 10.2 1L40.3 85.6zm343.5 13.2c.9-5.3-.9-10.8-4.8-14.5s-9.5-5.1-14.8-3.8l-18 4.5-19 107.8c2.8-.5 5.7-.8 8.8-.8h26.6c1.6 0 3.2.1 4.7.2l16.5-93.4zm-64-48c.9-5.3-.9-10.8-4.8-14.5s-9.5-5.1-14.8-3.8l-32 8c-6.2 1.5-10.9 6.5-12 12.7l-.2 1.4V261c4.8-2.1 8.7-4.4 11.8-6.6 12-8.4 16.7-18 18.7-24.3.7-2.3 1.7-4.7 2.8-7l30.5-172.3zM.6 250.5l57.5 237c3.4 14.4 16.3 24.5 31.1 24.5h205.6c14.8 0 27.6-10.1 31.1-24.5l57.5-237c.4-1.7.6-3.3.6-5.1 0-11.8-9.6-21.4-21.4-21.4H336c-8.8 0-16.3 7.2-18.9 15.7C309.7 263 283.7 304 192 304S74.3 263 66.9 239.7C64.3 231.2 56.8 224 48 224H21.4C9.6 224 0 233.6 0 245.4c0 1.7.2 3.4.6 5.1z"
        }
    ]
};

const FasFrog = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFrog",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M368 32c41.7 0 75.9 31.8 79.7 72.5l85.6 26.3c25.4 7.8 42.8 31.3 42.8 57.9 0 21.8-11.7 41.9-30.7 52.7l-144.6 82.1 92.5 92.5H544c17.7 0 32 14.3 32 32s-14.3 32-32 32h-64c-8.5 0-16.6-3.4-22.6-9.4L346.9 360.2c11.7-36 3.2-77.1-25.4-105.7-40.6-40.6-106.3-40.6-146.9-.1l-73.6 70c-6.4 6.1-6.7 16.2-.6 22.6s16.2 6.6 22.6.6l73.8-70.2.1-.1.1-.1c3.5-3.5 7.3-6.6 11.3-9.2 27.9-18.5 65.9-15.4 90.5 9.2 24.7 24.7 27.7 62.9 9 90.9-2.6 3.8-5.6 7.5-9 10.9l-37 37H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H64c-35.3 0-64-28.7-64-64C0 249.6 127 112.9 289.3 97.5 296.2 60.2 328.8 32 368 32zm0 104a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FasFunction = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFunction",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 96c0-53 43-96 96-96h32c17.7 0 32 14.3 32 32s-14.3 32-32 32h-32c-17.7 0-32 14.3-32 32v96h32c17.7 0 32 14.3 32 32s-14.3 32-32 32h-32v127.5c0 48.4-36.1 89.3-84.1 95.3l-7.9 1C18.4 481.9 2.4 469.5.2 452s10.2-33.5 27.8-35.7l7.9-1c16-2 28-15.6 28-31.8V256H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h32V96zm266.7 81.7c-27 40.7-42.7 89.6-42.7 142.3s15.7 101.6 42.7 142.3c9.8 14.7 5.7 34.6-9 44.3s-34.6 5.7-44.3-9C243.6 446.7 224 385.6 224 320s19.6-126.7 53.3-177.7c9.8-14.7 29.6-18.8 44.3-9s18.8 29.6 9 44.3zm202.6 0c-9.8-14.7-5.7-34.6 9-44.3s34.6-5.7 44.3 9c33.8 50.9 53.4 112 53.4 177.6s-19.6 126.7-53.3 177.7c-9.8 14.7-29.6 18.8-44.3 9s-18.8-29.6-9-44.3c27-40.7 42.7-89.6 42.7-142.3s-15.7-101.6-42.7-142.3zm-134.7 63.7 33.4 33.3 33.4-33.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L477.3 320l33.4 33.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L432 365.3l-33.4 33.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l33.4-33.4-33.4-33.4c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0z"
        }
    ]
};

const FasFutbol = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasFutbol",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m417.3 360.1-71.6-4.8c-5.2-.3-10.3 1.1-14.5 4.2s-7.2 7.4-8.4 12.5l-17.6 69.6c-15.7 4.2-32.2 6.4-49.2 6.4s-33.5-2.2-49.2-6.4L189.2 372c-1.3-5-4.3-9.4-8.4-12.5s-9.3-4.5-14.5-4.2l-71.6 4.8c-17.6-27.2-28.5-59.2-30.4-93.6l60.7-38.2c4.4-2.8 7.6-7 9.2-11.9s1.4-10.2-.5-15L107 134.8c21-25.6 48.3-45.8 79.7-57.9l55.2 46c4 3.3 9 5.1 14.1 5.1s10.2-1.8 14.1-5.1l55.2-46c31.3 12.1 58.7 32.3 79.6 57.9l-26.7 66.6c-1.9 4.8-2.1 10.1-.5 15s4.9 9.1 9.2 11.9l60.7 38.2c-1.9 34.4-12.8 66.4-30.4 93.6zM256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm14.1-325.7c-8.4-6.1-19.8-6.1-28.2 0L194 221c-8.4 6.1-11.9 16.9-8.7 26.8l18.3 56.3c3.2 9.9 12.4 16.6 22.8 16.6h59.2c10.4 0 19.6-6.7 22.8-16.6l18.3-56.3c3.2-9.9-.3-20.7-8.7-26.8l-47.9-34.8z"
        }
    ]
};

const FasG = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasG",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 96c-88.4 0-160 71.6-160 160s71.6 160 160 160c77.4 0 142-55 156.8-128H256c-17.7 0-32-14.3-32-32s14.3-32 32-32h144c25.8 0 49.6 21.4 47.2 50.6C437.8 389.6 341.4 480 224 480 100.3 480 0 379.7 0 256S100.3 32 224 32c57.4 0 109.7 21.6 149.3 57 13.2 11.8 14.3 32 2.5 45.2s-32 14.3-45.2 2.5C302.3 111.4 265 96 224 96z"
        }
    ]
};

const FasGalaxy = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasGalaxy",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 0h11.5C342.8 0 352 9.2 352 20.5c0 7.1-3.7 13.7-9.8 17.5l-12.5 7.7c-35.2 21.7-60.9 54.9-73.3 93.1 19.9-7 41.3-10.8 63.5-10.8 106 0 192 86 192 192v11.5c0 11.3-9.2 20.5-20.5 20.5-7.1 0-13.7-3.7-17.5-9.8l-7.7-12.5c-21.7-35.2-54.9-60.9-93.1-73.3 7 19.9 10.8 41.3 10.8 63.5 0 106-86 192-192 192h-11.4c-11.3 0-20.5-9.2-20.5-20.5 0-7.1 3.7-13.7 9.8-17.5l12.5-7.7c35.2-21.7 60.9-54.9 73.3-93.1-19.9 7-41.3 10.8-63.5 10.8C86 384 0 298 0 192v-11.5C0 169.2 9.2 160 20.5 160c7.1 0 13.7 3.7 17.5 9.8l7.7 12.5c21.7 35.2 54.9 60.9 93.1 73.3-7-19.9-10.8-41.3-10.8-63.5C128 86 214 0 320 0zm-64 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FasGalleryThumbnails = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasGalleryThumbnails",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 64v224H64V64h448zM64 0C28.7 0 0 28.7 0 64v224c0 35.3 28.7 64 64 64h448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM0 448v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32v-32c0-17.7-14.3-32-32-32H32c-17.7 0-32 14.3-32 32zm192-32c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32v-32c0-17.7-14.3-32-32-32h-32zm128 32v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32v-32c0-17.7-14.3-32-32-32h-32c-17.7 0-32 14.3-32 32zm192-32c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32v-32c0-17.7-14.3-32-32-32h-32z"
        }
    ]
};

const FasGameBoardSimple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasGameBoardSimple",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm224 0v160h160V96H224zm0 160H64v160h160V256z"
        }
    ]
};

const FasGameBoard = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasGameBoard",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm144 0v80h80V96h-80zm0 160v-80H64v80h80zm80 0h-80v80H64v80h80v-80h80v80h80v-80h80v-80h-80v-80h80V96h-80v80h-80v80zm0 0h80v80h-80v-80z"
        }
    ]
};

const FasGameConsoleHandheldCrank = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasGameConsoleHandheldCrank",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V96zm96 0c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32h256c17.7 0 32-14.3 32-32v-96c0-17.7-14.3-32-32-32H128zm32 240c0-8.8-7.2-16-16-16s-16 7.2-16 16v16h-16c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v16c0 8.8 7.2 16 16 16s16-7.2 16-16v-16h16c8.8 0 16-7.2 16-16s-7.2-16-16-16h-16v-16zm144 24a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm56 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm152-216c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24h-24v72c0 13.3-10.7 24-24 24h-24V168z"
        }
    ]
};

const FasGameConsoleHandheld = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasGameConsoleHandheld",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 64C0 28.7 28.7 0 64 0h256c35.3 0 64 28.7 64 64v352c0 53-43 96-96 96H96c-53 0-96-43-96-96V64zm96 16v112c0 17.7 14.3 32 32 32h128c17.7 0 32-14.3 32-32V80c0-8.8-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zm136 304a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm88-72a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm-224-8v16H80c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v16c0 8.8 7.2 16 16 16s16-7.2 16-16v-16h16c8.8 0 16-7.2 16-16s-7.2-16-16-16h-16v-16c0-8.8-7.2-16-16-16s-16 7.2-16 16z"
        }
    ]
};

const FasGamepadModern = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasGamepadModern",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 369.4v2.8C0 431.7 48.3 480 107.8 480c49.5 0 92.6-33.7 104.6-81.7L216 384h208l3.6 14.3c12 48 55.1 81.7 104.6 81.7 59.5 0 107.8-48.3 107.8-107.8v-2.8c0-6.3-.5-12.5-1.6-18.7l-32.7-190.9c-8.6-50.2-40.9-93.2-90.3-105.5C469.5 42.9 403.8 32 320 32S170.5 42.9 124.7 54.3c-49.5 12.3-81.8 55.3-90.4 105.5L1.6 350.7C.5 356.9 0 363.1 0 369.4zM432 232a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm24-56a40 40 0 1 1 80 0 40 40 0 1 1-80 0zm-240-8v32h32c13.3 0 24 10.7 24 24s-10.7 24-24 24h-32v32c0 13.3-10.7 24-24 24s-24-10.7-24-24v-32h-32c-13.3 0-24-10.7-24-24s10.7-24 24-24h32v-32c0-13.3 10.7-24 24-24s24 10.7 24 24z"
        }
    ]
};

const FasGamepad = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasGamepad",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 64C86 64 0 150 0 256s86 192 192 192h256c106 0 192-86 192-192S554 64 448 64H192zm304 104a40 40 0 1 1 0 80 40 40 0 1 1 0-80zM392 304a40 40 0 1 1 80 0 40 40 0 1 1-80 0zM168 200c0-13.3 10.7-24 24-24s24 10.7 24 24v32h32c13.3 0 24 10.7 24 24s-10.7 24-24 24h-32v32c0 13.3-10.7 24-24 24s-24-10.7-24-24v-32h-32c-13.3 0-24-10.7-24-24s10.7-24 24-24h32v-32z"
        }
    ]
};

const FasGarageCar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasGarageCar",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 488V171.3c0-26.2 15.9-49.7 40.2-59.4L308.1 4.8c7.6-3.1 16.1-3.1 23.8 0l267.9 107.1c24.3 9.7 40.2 33.3 40.2 59.4V488c0 13.3-10.7 24-24 24h-48c-13.3 0-24-10.7-24-24V224c0-17.7-14.3-32-32-32H128c-17.7 0-32 14.3-32 32v264c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24zm254.3-194.6L242.2 328h155.6l-12.1-34.6c-1.1-3.2-4.2-5.4-7.6-5.4H261.8c-3.4 0-6.4 2.2-7.6 5.4zM188.9 335l20.1-57.5c7.9-22.5 29.1-37.5 52.9-37.5h116.3c23.8 0 45 15.1 52.9 37.5l20 57.5c17.2 9.5 28.9 27.9 28.9 49v96c0 17.7-14.3 32-32 32s-32-14.3-32-32v-16H224v16c0 17.7-14.3 32-32 32s-32-14.3-32-32v-96c0-21.1 11.7-39.5 28.9-49zm51.1 89a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm184-24a24 24 0 1 0-48 0 24 24 0 1 0 48 0z"
        }
    ]
};

const FasGarageOpen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasGarageOpen",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 171.3V488c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V224c0-17.7 14.3-32 32-32h384c17.7 0 32 14.3 32 32v264c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V171.3c0-26.2-15.9-49.7-40.2-59.4L331.9 4.8c-7.6-3.1-16.1-3.1-23.8 0L40.2 111.9C15.9 121.6 0 145.2 0 171.3zM194.1 320l-5.2 15c-17.2 9.5-28.9 27.9-28.9 49v96c0 17.7 14.3 32 32 32s32-14.3 32-32v-16h192v16c0 17.7 14.3 32 32 32s32-14.3 32-32v-96c0-21.1-11.7-39.5-28.9-49l-5.2-15H395l2.8 8H242.2l2.8-8h-50.9zm45.9 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm136 24a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm136-176H128v64h384v-64z"
        }
    ]
};

const FasGarage = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasGarage",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 171.3V488c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V224c0-17.7 14.3-32 32-32h384c17.7 0 32 14.3 32 32v264c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V171.3c0-26.2-15.9-49.7-40.2-59.4L331.9 4.8c-7.6-3.1-16.1-3.1-23.8 0L40.2 111.9C15.9 121.6 0 145.2 0 171.3zM128 224v96h384v-96H128zm0 128v160h384V352H128zm128 80c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16z"
        }
    ]
};

const FasGarlic = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasGarlic",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M83.4 169.1C42.3 200.5 0 232.7 0 288c0 104.6 85.5 123.7 116.7 127.2C85 390.5 64 352.6 64 304c0-27.8 4.3-48.7 11-66.5 5.9-15.6 13.6-28.6 20.7-40.5.8-1.4 1.7-2.8 2.5-4.2 7.8-13.2 15.1-26.2 20.5-43.3 1.2-3.7 2.3-7.7 3.3-11.9-11.7 10.9-25.1 21.1-38.7 31.5zM384 416s128 0 128-128c0-55.3-42.3-87.5-83.4-118.9C389.8 139.5 352 110.6 352 64V48c0-26.5-21.5-48-48-48h-16v80c0 30.2 4.7 51.9 11.4 69s15.7 30.3 25.5 43.8c1.2 1.6 2.4 3.3 3.6 4.9 19 25.8 39.4 53.5 39.4 106.3 0 49.2-21.5 87.3-53.7 112H384zM256 80V0h-48c-26.5 0-48 21.5-48 48v32c0 33.4-4.2 58.5-10.8 79.2-6.6 20.7-15.3 36.2-23.5 49.9l-2.5 4.2c-7.2 12.1-13.5 22.6-18.3 35.5-5.3 13.9-9 31-9 55.2 0 69.3 54.9 112 120 112s120-42.7 120-112c0-42.1-15-62.5-33.5-87.7v-.1c-1.1-1.5-2.2-3.1-3.4-4.6-10.2-13.9-21.2-29.8-29.5-50.9-8.2-21.2-13.5-46.9-13.5-80.7zM136 448v40c0 13.3 10.7 24 24 24s24-10.7 24-24v-40h-48zm64 0v40c0 13.3 10.7 24 24 24s24-10.7 24-24v-40h-48zm64 0v40c0 13.3 10.7 24 24 24s24-10.7 24-24v-40h-48zm64 0v40c0 13.3 10.7 24 24 24s24-10.7 24-24v-40h-48z"
        }
    ]
};

const FasGasPumpSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasGasPumpSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-72.2-56.6c10.9-14.6 17.4-32.8 17.4-52.5V154.5c0-17-6.7-33.3-18.7-45.3L480 32c-8.8-8.8-23.2-8.8-32 0s-8.8 23.2 0 32l32 32v64c0 29.8 20.4 54.9 48 62v138c0 8.5-2.7 16.4-7.2 22.9L384 275.7V64c0-35.3-28.7-64-64-64H160c-30.9 0-56.7 21.9-62.7 51L38.8 5.1zM96 171.6V448c-17.7 0-32 14.3-32 32s14.3 32 32 32h288c17.7 0 32-14.3 32-32s-14.3-32-32-32v-49.5L96 171.6z"
        }
    ]
};

const FasGasPump = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasGasPump",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 64C32 28.7 60.7 0 96 0h160c35.3 0 64 28.7 64 64v192h8c48.6 0 88 39.4 88 88v32c0 13.3 10.7 24 24 24s24-10.7 24-24V222c-27.6-7.1-48-32.2-48-62V96l-32-32c-8.8-8.8-8.8-23.2 0-32s23.2-8.8 32 0l77.3 77.3c12 12 18.7 28.3 18.7 45.3V376c0 39.8-32.2 72-72 72s-72-32.2-72-72v-32c0-22.1-17.9-40-40-40h-8v144c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32V64zm64 16v96c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H112c-8.8 0-16 7.2-16 16z"
        }
    ]
};

const FasGaugeCircleBolt = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasGaugeCircleBolt",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M496 192c2.7 0 5.3.1 8 .2C475.6 81.7 375.4 0 256 0 114.6 0 0 114.6 0 256s114.6 256 256 256c39.5 0 77-9 110.4-25-28.8-31.3-46.4-73.1-46.4-119 0-97.2 78.8-176 176-176zM320 352c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-26.9 16.5-49.9 40-59.3V88c0-13.3 10.7-24 24-24s24 10.7 24 24v204.7c23.5 9.5 40 32.5 40 59.3zM144 112a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 256a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm272-112a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm160 368a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm47.9-225c4.3 3.7 5.4 9.9 2.6 14.9L516.4 356H552c5.2 0 9.8 3.3 11.4 8.2s-.1 10.3-4.2 13.4l-96 72c-4.5 3.4-10.8 3.2-15.1-.6s-5.4-9.9-2.6-14.9l30.1-54.1H440c-5.2 0-9.8-3.3-11.4-8.2s.1-10.3 4.2-13.4l96-72c4.5-3.4 10.8-3.2 15.1.6z"
        }
    ]
};

const FasGaugeCircleMinus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasGaugeCircleMinus",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M496 192c2.7 0 5.3.1 8 .2C475.6 81.7 375.4 0 256 0 114.6 0 0 114.6 0 256s114.6 256 256 256c39.5 0 77-9 110.4-25-28.8-31.3-46.4-73.1-46.4-119 0-97.2 78.8-176 176-176zM320 352c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-26.9 16.5-49.9 40-59.3V88c0-13.3 10.7-24 24-24s24 10.7 24 24v204.7c23.5 9.5 40 32.5 40 59.3zM144 112a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 256a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm272-112a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm304 224a144 144 0 1 0-288 0 144 144 0 1 0 288 0zm-64 0c0 8.8-7.2 16-16 16H432c-8.8 0-16-7.2-16-16s7.2-16 16-16h128c8.8 0 16 7.2 16 16z"
        }
    ]
};

const FasGaugeCirclePlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasGaugeCirclePlus",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M496 192c2.7 0 5.3.1 8 .2C475.6 81.7 375.4 0 256 0 114.6 0 0 114.6 0 256s114.6 256 256 256c39.5 0 77-9 110.4-25-28.8-31.3-46.4-73.1-46.4-119 0-97.2 78.8-176 176-176zM320 352c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-26.9 16.5-49.9 40-59.3V88c0-13.3 10.7-24 24-24s24 10.7 24 24v204.7c23.5 9.5 40 32.5 40 59.3zM144 112a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 256a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm272-112a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm160 368a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-208v48h48c8.8 0 16 7.2 16 16s-7.2 16-16 16h-48v48c0 8.8-7.2 16-16 16s-16-7.2-16-16v-48h-48c-8.8 0-16-7.2-16-16s7.2-16 16-16h48v-48c0-8.8 7.2-16 16-16s16 7.2 16 16z"
        }
    ]
};

const FasGaugeHigh = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasGaugeHigh",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zM288 96a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm-32 320c35.3 0 64-28.7 64-64 0-17.4-6.9-33.1-18.1-44.6L366 161.7c5.3-12.1-.2-26.3-12.3-31.6s-26.3.2-31.6 12.3L257.9 288H256c-35.3 0-64 28.7-64 64s28.7 64 64 64zm-80-272a32 32 0 1 0-64 0 32 32 0 1 0 64 0zM96 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm352-32a32 32 0 1 0-64 0 32 32 0 1 0 64 0z"
        }
    ]
};

const FasGaugeLow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasGaugeLow",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zM288 96a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm-32 320c35.3 0 64-28.7 64-64s-28.7-64-64-64h-1.9L190 142.3c-5.3-12.1-19.5-17.6-31.6-12.3s-17.6 19.5-12.3 31.6l64.1 145.7C198.9 318.9 192 334.6 192 352c0 35.3 28.7 64 64 64zM128 256a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm288 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-16-144a32 32 0 1 0-64 0 32 32 0 1 0 64 0z"
        }
    ]
};

const FasGaugeMax = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasGaugeMax",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zM288 96a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm-32 320c35.3 0 64-28.7 64-64 0-3.7-.3-7.3-.9-10.8l117.5-72.8c11.3-7 14.7-21.8 7.8-33s-21.8-14.8-33-7.8l-117.6 72.8c-10.6-7.8-23.7-12.4-37.8-12.4-35.3 0-64 28.7-64 64s28.7 64 64 64zm-80-272a32 32 0 1 0-64 0 32 32 0 1 0 64 0zM96 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm304-144a32 32 0 1 0-64 0 32 32 0 1 0 64 0z"
        }
    ]
};

const FasGaugeMin = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasGaugeMin",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zM288 96a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm-32 320c35.3 0 64-28.7 64-64s-28.7-64-64-64c-14.1 0-27.2 4.6-37.8 12.4l-117.6-72.8c-11.3-7-26.1-3.5-33 7.8s-3.5 26.1 7.8 33l117.5 72.8c-.6 3.5-.9 7.1-.9 10.8 0 35.3 28.7 64 64 64zm-80-272a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm240 144a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-16-144a32 32 0 1 0-64 0 32 32 0 1 0 64 0z"
        }
    ]
};

const FasGaugeSimpleHigh = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasGaugeSimpleHigh",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm320 96c0-15.9-5.8-30.4-15.3-41.6L381.3 163c6.1-11.8 1.5-26.3-10.2-32.4s-26.2-1.5-32.4 10.2l-76.6 147.5c-2-.2-4-.3-6.1-.3-35.3 0-64 28.7-64 64s28.7 64 64 64 64-28.7 64-64z"
        }
    ]
};

const FasGaugeSimpleLow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasGaugeSimpleLow",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm320 96c0-35.3-28.7-64-64-64-2.1 0-4.1.1-6.1.3l-76.6-147.4c-6.1-11.8-20.6-16.3-32.4-10.2s-16.3 20.6-10.2 32.4l76.6 147.4c-9.5 11.1-15.3 25.6-15.3 41.5 0 35.3 28.7 64 64 64s64-28.7 64-64z"
        }
    ]
};

const FasGaugeSimpleMax = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasGaugeSimpleMax",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm320 96c0-3.7-.3-7.3-.9-10.8l117.5-72.8c11.3-7 14.7-21.8 7.8-33s-21.8-14.8-33-7.8l-117.6 72.8c-10.6-7.8-23.7-12.4-37.8-12.4-35.3 0-64 28.7-64 64s28.7 64 64 64 64-28.7 64-64z"
        }
    ]
};

const FasGaugeSimpleMin = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasGaugeSimpleMin",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm320 96c0-35.3-28.7-64-64-64-14.1 0-27.2 4.6-37.8 12.4l-117.6-72.8c-11.3-7-26.1-3.5-33 7.8s-3.5 26.1 7.8 33l117.5 72.8c-.6 3.5-.9 7.1-.9 10.8 0 35.3 28.7 64 64 64s64-28.7 64-64z"
        }
    ]
};

const FasGaugeSimple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasGaugeSimple",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm320 96c0-26.9-16.5-49.9-40-59.3V88c0-13.3-10.7-24-24-24s-24 10.7-24 24v204.7c-23.5 9.5-40 32.5-40 59.3 0 35.3 28.7 64 64 64s64-28.7 64-64z"
        }
    ]
};

const FasGauge = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasGauge",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm320 96c0-26.9-16.5-49.9-40-59.3V88c0-13.3-10.7-24-24-24s-24 10.7-24 24v204.7c-23.5 9.5-40 32.5-40 59.3 0 35.3 28.7 64 64 64s64-28.7 64-64zM144 176a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-16 80a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm288 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-16-144a32 32 0 1 0-64 0 32 32 0 1 0 64 0z"
        }
    ]
};

const FasGavel = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasGavel",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M318.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-120 120c-12.5 12.5-12.5 32.8 0 45.3l16 16c12.5 12.5 32.8 12.5 45.3 0l4-4 106.8 106.7-4 4c-12.5 12.5-12.5 32.8 0 45.3l16 16c12.5 12.5 32.8 12.5 45.3 0l120-120c12.5-12.5 12.5-32.8 0-45.3l-16-16c-12.5-12.5-32.8-12.5-45.3 0l-4 4L330.6 74.6l4-4c12.5-12.5 12.5-32.8 0-45.3l-16-16zm-152 288c-12.5-12.5-32.8-12.5-45.3 0l-112 112c-12.5 12.5-12.5 32.8 0 45.3l48 48c12.5 12.5 32.8 12.5 45.3 0l112-112c12.5-12.5 12.5-32.8 0-45.3l-1.4-1.4 58.8-58.7-45.3-45.3-58.7 58.7-1.4-1.4z"
        }
    ]
};

const FasGearCode = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasGearCode",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M495.9 166.6c3.2 8.7.5 18.4-6.4 24.6l-43.3 39.4c1.1 8.3 1.7 16.8 1.7 25.4s-.6 17.1-1.7 25.4l43.3 39.4c6.9 6.2 9.6 15.9 6.4 24.6-4.4 11.9-9.7 23.3-15.8 34.3l-4.7 8.1c-6.6 11-14 21.4-22.1 31.2-5.9 7.2-15.7 9.6-24.5 6.8l-55.7-17.7c-13.4 10.3-28.2 18.9-44 25.4l-12.5 57.1c-2 9.1-9 16.3-18.2 17.8-13.8 2.3-28 3.5-42.5 3.5s-28.7-1.2-42.5-3.5c-9.2-1.5-16.2-8.7-18.2-17.8l-12.5-57.1c-15.8-6.5-30.6-15.1-44-25.4l-55.6 17.8c-8.8 2.8-18.6.3-24.5-6.8-8.1-9.8-15.5-20.2-22.1-31.2l-4.7-8.1c-6.1-11-11.4-22.4-15.8-34.3-3.2-8.7-.5-18.4 6.4-24.6l43.3-39.4c-1.1-8.4-1.7-16.9-1.7-25.5s.6-17.1 1.7-25.4l-43.3-39.4c-6.9-6.2-9.6-15.9-6.4-24.6 4.4-11.9 9.7-23.3 15.8-34.3l4.7-8.1c6.6-11 14-21.4 22.1-31.2 5.9-7.2 15.7-9.6 24.5-6.8l55.7 17.7c13.4-10.3 28.2-18.9 44-25.4l12.5-57.1c2-9.1 9-16.3 18.2-17.8C227.3 1.2 241.5 0 256 0s28.7 1.2 42.5 3.5c9.2 1.5 16.2 8.7 18.2 17.8l12.5 57.1c15.8 6.5 30.6 15.1 44 25.4l55.7-17.7c8.8-2.8 18.6-.3 24.5 6.8 8.1 9.8 15.5 20.2 22.1 31.2l4.7 8.1c6.1 11 11.4 22.4 15.8 34.3zm-208.2-3.9c1.5-8.7-4.4-17-13.2-18.4s-17 4.4-18.4 13.2l-32 192c-1.5 8.7 4.4 17 13.2 18.4s17-4.4 18.4-13.2l32-192zm-100.4 64.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-40 40c-6.2 6.2-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L158.6 256l28.7-28.7zm160-22.6c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l28.7 28.7-28.7 28.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l40-40c6.2-6.2 6.2-16.4 0-22.6l-40-40z"
        }
    ]
};

const FasGearComplexCode = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasGearComplexCode",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M305.4 21.8c-1.3-10.4-9.1-18.8-19.5-20C276.1.6 266.1 0 256 0c-11.1 0-22.1.7-32.8 2.1-10.3 1.3-18 9.7-19.3 20L201 45.2c-.8 6.4-5.4 11.6-11.5 13.7-9.6 3.2-19 7.2-27.9 11.7-5.8 3-12.8 2.5-18-1.5l-18-14c-8.2-6.4-19.7-6.8-27.9-.4-16.6 13-31.5 28-44.4 44.7-6.3 8.2-5.9 19.6.5 27.8L68 145.5c4 5.1 4.4 12 1.5 17.8-4.4 8.8-8.2 17.9-11.3 27.4-2 6.2-7.3 10.8-13.7 11.6l-22.8 2.9c-10.3 1.3-18.7 9.1-20 19.4C.7 234.8 0 245.3 0 256c0 10.6.6 21.1 1.9 31.4 1.3 10.3 9.7 18.1 20 19.4l22.8 2.9c6.4.8 11.7 5.4 13.7 11.6 3.1 9.5 6.9 18.7 11.3 27.5 2.9 5.8 2.4 12.7-1.5 17.8L54 384.8c-6.4 8.2-6.8 19.6-.5 27.8 12.9 16.7 27.8 31.7 44.4 44.7 8.2 6.4 19.7 6 27.9-.4l18-14c5.1-4 12.2-4.4 18-1.5 9 4.6 18.3 8.5 27.9 11.7 6.1 2.1 10.7 7.3 11.5 13.7l2.9 23.1c1.3 10.3 9 18.7 19.3 20 10.7 1.4 21.7 2.1 32.8 2.1 10.1 0 20.1-.6 29.9-1.7 10.4-1.2 18.2-9.7 19.5-20l2.8-22.5c.8-6.5 5.5-11.8 11.7-13.8 10-3.2 19.7-7.2 29-11.8 5.8-2.9 12.7-2.4 17.8 1.5l18.1 14.2c8.2 6.4 19.6 6.8 27.8.5 2.8-2.2 5.5-4.4 8.2-6.7l30.7-30.7 5.4-6.6c6.5-8.2 6-19.7-.4-27.9l-14-17.9c-4-5.1-4.4-12.2-1.5-18 4.8-9.4 9-19.3 12.3-29.5 2-6.2 7.3-10.8 13.7-11.6l22.8-2.8c10.3-1.3 18.8-9.1 20-19.4.2-1.7.4-3.5.6-5.2v-52c-.2-1.7-.4-3.5-.6-5.2-1.3-10.3-9.7-18.1-20-19.4l-22.8-2.8c-6.4-.8-11.7-5.4-13.7-11.6-3.4-10.2-7.5-20.1-12.3-29.5-3-5.8-2.5-12.8 1.5-18l14-17.9c6.4-8.2 6.8-19.7.4-27.9l-5.4-6.6L421 60.3c-2.7-2.3-5.4-4.5-8.2-6.7-8.2-6.4-19.6-5.9-27.8.5l-18.3 14.2c-5.1 4-12.1 4.4-17.8 1.5-9.3-4.6-19-8.6-29-11.8-6.2-2-10.9-7.3-11.7-13.7l-2.8-22.5zm-17.6 140.8-32 192c-1.5 8.7-9.7 14.6-18.4 13.2s-14.6-9.7-13.2-18.4l32-192c1.5-8.7 9.7-14.6 18.4-13.2s14.6 9.7 13.2 18.4zm-100.5 64.7L158.6 256l28.7 28.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6l40-40c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zm160-22.6 40 40c6.2 6.2 6.2 16.4 0 22.6l-40 40c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l28.7-28.7-28.7-28.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0z"
        }
    ]
};

const FasGearComplex = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasGearComplex",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M305.4 21.8c-1.3-10.4-9.1-18.8-19.5-20C276.1.6 266.1 0 256 0c-11.1 0-22.1.7-32.8 2.1-10.3 1.3-18 9.7-19.3 20L201 45.2c-.8 6.4-5.4 11.6-11.5 13.7-9.6 3.2-19 7.2-27.9 11.7-5.8 3-12.8 2.5-18-1.5l-18-14c-8.2-6.4-19.7-6.8-27.9-.4-16.6 13-31.5 28-44.4 44.7-6.3 8.2-5.9 19.6.5 27.8L68 145.5c4 5.1 4.4 12 1.5 17.8-4.4 8.8-8.2 17.9-11.3 27.4-2 6.2-7.3 10.8-13.7 11.6l-22.8 2.9c-10.3 1.3-18.7 9.1-20 19.4C.7 234.8 0 245.3 0 256c0 10.6.6 21.1 1.9 31.4 1.3 10.3 9.7 18.1 20 19.4l22.8 2.9c6.4.8 11.7 5.4 13.7 11.6 3.1 9.5 6.9 18.7 11.3 27.5 2.9 5.8 2.4 12.7-1.5 17.8L54 384.8c-6.4 8.2-6.8 19.6-.5 27.8 12.9 16.7 27.8 31.7 44.4 44.7 8.2 6.4 19.7 6 27.9-.4l18-14c5.1-4 12.2-4.4 18-1.5 9 4.6 18.3 8.5 27.9 11.7 6.1 2.1 10.7 7.3 11.5 13.7l2.9 23.1c1.3 10.3 9 18.7 19.3 20 10.7 1.4 21.7 2.1 32.8 2.1 10.1 0 20.1-.6 29.9-1.7 10.4-1.2 18.2-9.7 19.5-20l2.8-22.5c.8-6.5 5.5-11.8 11.7-13.8 10-3.2 19.7-7.2 29-11.8 5.8-2.9 12.7-2.4 17.8 1.5l18.1 14.2c8.2 6.4 19.6 6.8 27.8.5 2.8-2.2 5.5-4.4 8.2-6.7l30.7-30.7 5.4-6.6c6.5-8.2 6-19.7-.4-27.9l-14-17.9c-4-5.1-4.4-12.2-1.5-18 4.8-9.4 9-19.3 12.3-29.5 2-6.2 7.3-10.8 13.7-11.6l22.8-2.8c10.3-1.3 18.8-9.1 20-19.4.2-1.7.4-3.5.6-5.2v-52c-.2-1.7-.4-3.5-.6-5.2-1.3-10.3-9.7-18.1-20-19.4l-22.8-2.8c-6.4-.8-11.7-5.4-13.7-11.6-3.4-10.2-7.5-20.1-12.3-29.5-3-5.8-2.5-12.8 1.5-18l14-17.9c6.4-8.2 6.8-19.7.4-27.9l-5.4-6.6L421 60.3c-2.7-2.3-5.4-4.5-8.2-6.7-8.2-6.4-19.6-5.9-27.8.5l-18.3 14.2c-5.1 4-12.1 4.4-17.8 1.5-9.3-4.6-19-8.6-29-11.8-6.2-2-10.9-7.3-11.7-13.7l-2.8-22.5zM256 176a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"
        }
    ]
};

const FasGear = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasGear",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M495.9 166.6c3.2 8.7.5 18.4-6.4 24.6l-43.3 39.4c1.1 8.3 1.7 16.8 1.7 25.4s-.6 17.1-1.7 25.4l43.3 39.4c6.9 6.2 9.6 15.9 6.4 24.6-4.4 11.9-9.7 23.3-15.8 34.3l-4.7 8.1c-6.6 11-14 21.4-22.1 31.2-5.9 7.2-15.7 9.6-24.5 6.8l-55.7-17.7c-13.4 10.3-28.2 18.9-44 25.4l-12.5 57.1c-2 9.1-9 16.3-18.2 17.8-13.8 2.3-28 3.5-42.5 3.5s-28.7-1.2-42.5-3.5c-9.2-1.5-16.2-8.7-18.2-17.8l-12.5-57.1c-15.8-6.5-30.6-15.1-44-25.4l-55.6 17.8c-8.8 2.8-18.6.3-24.5-6.8-8.1-9.8-15.5-20.2-22.1-31.2l-4.7-8.1c-6.1-11-11.4-22.4-15.8-34.3-3.2-8.7-.5-18.4 6.4-24.6l43.3-39.4c-1.1-8.4-1.7-16.9-1.7-25.5s.6-17.1 1.7-25.4l-43.3-39.4c-6.9-6.2-9.6-15.9-6.4-24.6 4.4-11.9 9.7-23.3 15.8-34.3l4.7-8.1c6.6-11 14-21.4 22.1-31.2 5.9-7.2 15.7-9.6 24.5-6.8l55.7 17.7c13.4-10.3 28.2-18.9 44-25.4l12.5-57.1c2-9.1 9-16.3 18.2-17.8C227.3 1.2 241.5 0 256 0s28.7 1.2 42.5 3.5c9.2 1.5 16.2 8.7 18.2 17.8l12.5 57.1c15.8 6.5 30.6 15.1 44 25.4l55.7-17.7c8.8-2.8 18.6-.3 24.5 6.8 8.1 9.8 15.5 20.2 22.1 31.2l4.7 8.1c6.1 11 11.4 22.4 15.8 34.3zM256 336a80 80 0 1 0 0-160 80 80 0 1 0 0 160z"
        }
    ]
};

const FasGears = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasGears",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M308.5 135.3c7.1-6.3 9.9-16.2 6.2-25-2.3-5.3-4.8-10.5-7.6-15.5l-3.1-5.4c-3-5-6.3-9.9-9.8-14.6-5.7-7.6-15.7-10.1-24.7-7.1L241.3 77c-10.7-8.8-23-16-36.2-20.9l-6.1-29c-1.9-9.3-9.1-16.7-18.5-17.8-6.6-.9-13.3-1.3-20.1-1.3h-.7c-6.8 0-13.5.4-20.1 1.2-9.4 1.1-16.6 8.6-18.5 17.8L115 56.1c-13.3 5-25.5 12.1-36.2 20.9l-28.3-9.2c-9-3-19-.5-24.7 7.1-3.5 4.7-6.8 9.6-9.9 14.6l-3 5.3c-2.8 5-5.3 10.2-7.6 15.6-3.7 8.7-.9 18.6 6.2 25l22.2 19.8c-1.1 6.7-1.7 13.7-1.7 20.8s.6 14.1 1.7 20.9l-22.2 19.8c-7.1 6.3-9.9 16.2-6.2 25 2.3 5.3 4.8 10.5 7.6 15.6l3 5.2c3 5.1 6.3 9.9 9.9 14.6 5.7 7.6 15.7 10.1 24.7 7.1l28.2-9.3c10.7 8.8 23 16 36.2 20.9l6.1 29.1c1.9 9.3 9.1 16.7 18.5 17.8 6.7.8 13.5 1.2 20.4 1.2s13.7-.4 20.4-1.2c9.4-1.1 16.6-8.6 18.5-17.8l6.1-29.1c13.3-5 25.5-12.1 36.2-20.9l28.2 9.3c9 3 19 .5 24.7-7.1 3.5-4.7 6.8-9.5 9.8-14.6l3.1-5.4c2.8-5 5.3-10.2 7.6-15.5 3.7-8.7.9-18.6-6.2-25l-22.2-19.8c1.1-6.8 1.7-13.8 1.7-20.9s-.6-14.1-1.7-20.9l22.2-19.8zM112 176a48 48 0 1 1 96 0 48 48 0 1 1-96 0zm392.7 324.5c6.3 7.1 16.2 9.9 25 6.2 5.3-2.3 10.5-4.8 15.5-7.6l5.4-3.1c5-3 9.9-6.3 14.6-9.8 7.6-5.7 10.1-15.7 7.1-24.7l-9.3-28.2c8.8-10.7 16-23 20.9-36.2L613 391c9.3-1.9 16.7-9.1 17.8-18.5.8-6.7 1.2-13.5 1.2-20.4s-.4-13.7-1.2-20.4c-1.1-9.4-8.6-16.6-17.8-18.5l-29.1-6.2c-5-13.3-12.1-25.5-20.9-36.2l9.3-28.2c3-9 .5-19-7.1-24.7-4.7-3.5-9.6-6.8-14.6-9.9l-5.3-3c-5-2.8-10.2-5.3-15.6-7.6-8.7-3.7-18.6-.9-25 6.2l-19.8 22.2c-6.8-1.1-13.8-1.7-20.9-1.7s-14.1.6-20.9 1.7l-19.8-22.2c-6.3-7.1-16.2-9.9-25-6.2-5.3 2.3-10.5 4.8-15.6 7.6l-5.2 3c-5.1 3-9.9 6.3-14.6 9.9-7.6 5.7-10.1 15.7-7.1 24.7l9.3 28.2c-8.8 10.7-16 23-20.9 36.2l-29.1 6c-9.3 1.9-16.7 9.1-17.8 18.5-.8 6.7-1.2 13.5-1.2 20.4s.4 13.7 1.2 20.4c1.1 9.4 8.6 16.6 17.8 18.5l29.1 6.1c5 13.3 12.1 25.5 20.9 36.2l-9.3 28.2c-3 9-.5 19 7.1 24.7 4.7 3.5 9.5 6.8 14.6 9.8l5.4 3.1c5 2.8 10.2 5.3 15.5 7.6 8.7 3.7 18.6.9 25-6.2l19.8-22.2c6.8 1.1 13.8 1.7 20.9 1.7s14.1-.6 20.9-1.7l19.8 22.2zM464 304a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
        }
    ]
};

const FasGem = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasGem",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M116.7 33.8c4.5-6.1 11.7-9.8 19.3-9.8h240c7.6 0 14.8 3.6 19.3 9.8l112 152c6.8 9.2 6.1 21.9-1.5 30.4l-232 256c-4.5 5-11 7.9-17.8 7.9s-13.2-2.9-17.8-7.9l-232-256c-7.7-8.5-8.3-21.2-1.5-30.4l112-152zm38.5 39.8c-3.3 2.5-4.2 7-2.1 10.5l57.4 95.6L63.3 192c-4.1.3-7.3 3.8-7.3 8s3.2 7.6 7.3 8l192 16h1.3l192-16c4.1-.3 7.3-3.8 7.3-8s-3.2-7.6-7.3-8l-147.1-12.2 57.4-95.6c2.1-3.5 1.2-8.1-2.1-10.5s-7.9-2-10.7 1L256 172.2l-90.1-97.6c-2.8-3-7.4-3.4-10.7-1z"
        }
    ]
};

const FasGenderless = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasGenderless",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 144a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 288a176 176 0 1 0 0-352 176 176 0 1 0 0 352z"
        }
    ]
};

const FasGhost = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasGhost",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m40.1 467.1-11.2 9c-3.2 2.5-7.1 3.9-11.1 3.9C8 480 0 472 0 462.2V192C0 86 86 0 192 0s192 86 192 192v270.2c0 9.8-8 17.8-17.8 17.8-4 0-7.9-1.4-11.1-3.9l-11.2-9c-13.4-10.7-32.8-9-44.1 3.9l-30.5 35c-3.3 3.8-8.2 6-13.3 6s-9.9-2.2-13.3-6l-26.6-30.5c-12.7-14.6-35.4-14.6-48.2 0L141.3 506c-3.3 3.8-8.2 6-13.3 6s-9.9-2.2-13.3-6l-30.5-35c-11.3-12.9-30.7-14.6-44.1-3.9zM160 192a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm96 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FasGif = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasGif",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 96c0-35.3 28.7-64 64-64h448c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm296 64c-13.3 0-24 10.7-24 24v144c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24zm56 24v144c0 13.3 10.7 24 24 24s24-10.7 24-24v-40h40c13.3 0 24-10.7 24-24s-10.7-24-24-24h-40v-32h64c13.3 0 24-10.7 24-24s-10.7-24-24-24h-88c-13.3 0-24 10.7-24 24zm-224 72c0-26.5 21.5-48 48-48 8 0 15.4 1.9 22 5.3 11.8 6.1 26.3 1.5 32.3-10.3s1.5-26.3-10.3-32.3c-13.2-6.8-28.2-10.7-44-10.7-53 0-96 43-96 96s43 96 96 96c19.6 0 37.5-6.1 52.8-15.8 7-4.4 11.2-12.1 11.2-20.3V264c0-13.3-10.7-24-24-24h-32c-13.3 0-24 10.7-24 24s10.7 24 24 24h8v13.1c-5.3 1.9-10.6 2.9-16 2.9-26.5 0-48-21.5-48-48z"
        }
    ]
};

const FasGiftCard = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasGiftCard",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M353.5 68.8c7.6-12.9 21.4-20.8 36.3-20.8h2.2c22.1 0 40 17.9 40 40s-17.9 40-40 40h-73.3l34.8-59.2zm-131 0 34.8 59.2H184c-22.1 0-40-17.9-40-40s17.9-40 40-40h2.2c14.9 0 28.8 7.9 36.3 20.8zm89.6-24.3-24.1 41-24.1-41C247.7 16.9 218.1 0 186.2 0H184c-48.6 0-88 39.4-88 88 0 14.4 3.5 28 9.6 40H64c-35.3 0-64 28.7-64 64v256c0 35.3 28.7 64 64 64h448c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64h-41.6c6.1-12 9.6-25.6 9.6-40 0-48.6-39.4-88-88-88h-2.2c-31.9 0-61.5 16.9-77.7 44.4zM512 384v64H64v-64h448zm0-64H64V192h166.1l-40.5 48.6c-8.5 10.2-7.1 25.3 3.1 33.8s25.3 7.1 33.8-3.1l61.5-73.8 61.6 73.9c8.5 10.2 23.6 11.6 33.8 3.1s11.6-23.6 3.1-33.8L345.9 192H512v128z"
        }
    ]
};

const FasGift = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasGift",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m190.5 68.8 34.8 59.2H152c-22.1 0-40-17.9-40-40s17.9-40 40-40h2.2c14.9 0 28.8 7.9 36.3 20.8zM64 88c0 14.4 3.5 28 9.6 40H32c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32v-64c0-17.7-14.3-32-32-32h-41.6c6.1-12 9.6-25.6 9.6-40 0-48.6-39.4-88-88-88h-2.2c-31.9 0-61.5 16.9-77.7 44.4L256 85.5l-24.1-41C215.7 16.9 186.1 0 154.2 0H152c-48.6 0-88 39.4-88 88zm336 0c0 22.1-17.9 40-40 40h-73.3l34.8-59.2c7.6-12.9 21.4-20.8 36.3-20.8h2.2c22.1 0 40 17.9 40 40zM32 288v176c0 26.5 21.5 48 48 48h144V288H32zm256 224h144c26.5 0 48-21.5 48-48V288H288v224z"
        }
    ]
};

const FasGifts = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasGifts",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M200.6 32C205 19.5 198.5 5.8 186 1.4S159.8 3.5 155.4 16l-10.7 30.2-9.9-29.8C130.6 3.8 117-3 104.4 1.2S85 19 89.2 31.6l8.3 25-27.4-20c-10.7-7.8-25.7-5.4-33.5 5.3s-5.4 25.7 5.3 33.5L70.2 96H48c-26.5 0-48 21.5-48 48v320c0 26.5 21.5 48 48 48h152.6c-5.4-9.4-8.6-20.3-8.6-32V256c0-29.9 20.5-55 48.2-62 1.8-31 17.1-58.2 40.1-76.1C271.7 104.7 256.9 96 240 96h-22.2l28.3-20.6c10.7-7.8 13.1-22.8 5.3-33.5s-22.8-13.1-33.5-5.3l-25.4 18.5 8.1-23.1zm162.9 153.5 29.6 38.5H344c-13.3 0-24-10.7-24-24 0-13.1 10.8-24 24.2-24 7.6 0 14.7 3.5 19.3 9.5zM272 200c0 8.4 1.4 16.5 4.1 24H272c-26.5 0-48 21.5-48 48v80h192v-96h32v96h192v-80c0-26.5-21.5-48-48-48h-4.1c2.7-7.5 4.1-15.6 4.1-24 0-39.9-32.5-72-72.2-72-22.4 0-43.6 10.4-57.3 28.2L432 195.8l-30.5-39.6c-13.7-17.8-35-28.2-57.3-28.2-39.7 0-72.2 32.1-72.2 72zm-48 264c0 26.5 21.5 48 48 48h144V384H224v80zm224 48h144c26.5 0 48-21.5 48-48v-80H448v128zm96-312c0 13.3-10.7 24-24 24h-49.1l29.6-38.5c4.6-5.9 11.7-9.5 19.3-9.5 13.4 0 24.2 10.9 24.2 24z"
        }
    ]
};

const FasGingerbreadMan = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasGingerbreadMan",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M296.9 158.5c-5.2 6-1.2 17.5 6.7 17.5H368c35.3 0 64 28.7 64 64s-28.7 64-64 64h-20.9c-19 0-29.4 22.2-17.2 36.7l55.3 66.3c22.6 27.2 19 67.5-8.2 90.1s-67.5 19-90.1-8.2l-45.6-54.8c-9-10.7-25.5-10.7-34.4 0L161.2 489c-22.6 27.2-63 30.8-90.1 8.2s-30.8-63-8.2-90.1l55.2-66.3c12.2-14.6 1.8-36.7-17.2-36.7H80c-35.3 0-64-28.7-64-64s28.7-64 64-64h64.4c7.9 0 11.9-11.5 6.7-17.5C136.7 141.7 128 119.9 128 96c0-53 43-96 96-96s96 43 96 96c0 23.9-8.7 45.7-23.1 62.5zM192 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-16a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm-48 160a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16 112a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm-16-48a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
        }
    ]
};

const FasGlassCitrus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasGlassCitrus",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 144c0-44.2-35.8-80-80-80-26.2 0-49.4 12.6-64 32h-71.8C252 40.1 305.3 0 368 0c79.5 0 144 64.5 144 144 0 78.4-62.6 142.1-140.5 144l6.5-64.6c39.5-4.9 70-38.6 70-79.4zm-198.7 80-.1 1.3-.9-1.3h1zm-241-85.5C14.3 131.8 23 128 32 128h288c9 0 17.7 3.8 23.7 10.5s9 15.7 8.1 24.7l-29.1 291.2c-3.2 32.7-30.8 57.6-63.7 57.6H93c-32.9 0-60.4-24.9-63.7-57.6L.2 163.2c-.9-9 2-18 8.1-24.7zM67.4 192l6.4 64h204.4l6.4-64H67.4z"
        }
    ]
};

const FasGlassEmpty = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasGlassEmpty",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M8.6 10.2C14.6 3.7 23.1 0 32 0h320c8.9 0 17.4 3.7 23.4 10.2s9.1 15.2 8.5 24.1l-28.8 403.4c-3 41.9-37.8 74.3-79.8 74.3H108.7c-42 0-76.8-32.4-79.8-74.3L.1 34.3c-.6-8.9 2.4-17.6 8.5-24.1zM66.4 64l26.3 369.1c.6 8.4 7.6 14.9 16 14.9h166.6c8.4 0 15.4-6.5 16-14.9L317.6 64H66.4z"
        }
    ]
};

const FasGlassHalf = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasGlassHalf",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 0C23.1 0 14.6 3.7 8.6 10.2S-.6 25.4.1 34.3l28.8 403.4c3 41.9 37.8 74.3 79.8 74.3h166.6c42 0 76.8-32.4 79.8-74.3l28.8-403.4c.6-8.9-2.4-17.6-8.5-24.1S360.9 0 352 0H32zm45.8 224L66.4 64h251.2l-11.4 160H77.8z"
        }
    ]
};

const FasGlassWaterDroplet = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasGlassWaterDroplet",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 0C23.1 0 14.6 3.7 8.6 10.2S-.6 25.4.1 34.3l28.8 403.4c3 41.9 37.8 74.3 79.8 74.3h166.6c42 0 76.8-32.4 79.8-74.3l28.8-403.4c.6-8.9-2.4-17.6-8.5-24.1S360.9 0 352 0H32zm51 297.5L66.4 64h251.2L301 297.5l-13 6.5c-20.1 10.1-43.9 10.1-64 0s-43.9-10.1-64 0-43.9 10.1-64 0l-13-6.5zM256 196c0-24-33.7-70.1-52.2-93.5-6.1-7.7-17.5-7.7-23.6 0C161.7 125.9 128 172 128 196c0 33.1 28.7 60 64 60s64-26.9 64-60z"
        }
    ]
};

const FasGlassWater = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasGlassWater",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 0C23.1 0 14.6 3.7 8.6 10.2S-.6 25.4.1 34.3l28.8 403.4c3 41.9 37.8 74.3 79.8 74.3h166.6c42 0 76.8-32.4 79.8-74.3l28.8-403.4c.6-8.9-2.4-17.6-8.5-24.1S360.9 0 352 0H32zm41 156.5L66.4 64h251.2l-6.6 92.5-24.2 12.1c-19.4 9.7-42.2 9.7-61.6 0a74.556 74.556 0 0 0-66.4 0c-19.4 9.7-42.2 9.7-61.6 0L73 156.5z"
        }
    ]
};

const FasGlass = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasGlass",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 0C23.1 0 14.6 3.7 8.6 10.2S-.6 25.4.1 34.3l28.8 403.4c3 41.9 37.8 74.3 79.8 74.3h166.6c42 0 76.8-32.4 79.8-74.3l28.8-403.4c.6-8.9-2.4-17.6-8.5-24.1S360.9 0 352 0H32zm38.9 128-4.5-64h251.2l-4.6 64H70.9z"
        }
    ]
};

const FasGlassesRound = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasGlassesRound",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M118.6 80c-11.5 0-21.4 7.9-24 19.1L64.4 228.3C85.2 215.4 109.7 208 136 208c55.1 0 102.6 32.8 124 80h56c21.3-47.2 68.8-80 124-80 26.3 0 50.8 7.4 71.6 20.3L481.4 99.1c-2.6-11.2-12.6-19.1-24-19.1-3.1 0-6.2.6-9.2 1.8l-31.3 12.5c-12.3 4.9-26.3-1.1-31.2-13.4s1.1-26.3 13.4-31.2l31.3-12.5c8.6-3.4 17.7-5.2 27-5.2 33.8 0 63.1 23.3 70.8 56.2l40.5 173.7c4.9 20.9 7.3 42.2 7.3 63.6V336c0 .8 0 1.6-.1 2.4.1 1.9.1 3.8.1 5.6 0 75.1-60.9 136-136 136-72.4 0-131.6-56.6-135.8-128h-32.4c-4.1 71.4-63.3 128-135.8 128C60.9 480 0 419.1 0 344c0-1.9 0-3.8.1-5.6-.1-.8-.1-1.6-.1-2.4v-10.5c0-21.4 2.5-42.8 7.3-63.6L47.9 88.2C55.5 55.3 84.8 32 118.6 32c9.2 0 18.4 1.8 27 5.2l31.3 12.5c12.3 4.9 18.3 18.9 13.4 31.2s-18.9 18.3-31.2 13.4l-31.3-12.5c-2.9-1.2-6-1.8-9.2-1.8zM136 416a72 72 0 1 0 0-144 72 72 0 1 0 0 144zm376-72a72 72 0 1 0-144 0 72 72 0 1 0 144 0z"
        }
    ]
};

const FasGlasses = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasGlasses",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M118.6 80c-11.5 0-21.4 7.9-24 19.1L57 260.3c20.5-6.2 48.3-12.3 78.7-12.3 32.3 0 61.8 6.9 82.8 13.5 10.6 3.3 19.3 6.7 25.4 9.2 3.1 1.3 5.5 2.4 7.3 3.2.9.4 1.6.7 2.1 1l.6.3.2.1h.1l-6.3 12.7 6.3-12.7c5.8 2.9 10.4 7.3 13.5 12.7h40.6c3.1-5.3 7.7-9.8 13.5-12.7l6.3 12.7-6.3-12.7h.1l.2-.1.6-.3c.5-.2 1.2-.6 2.1-1 1.8-.8 4.2-1.9 7.3-3.2 6.1-2.6 14.8-5.9 25.4-9.2 21-6.6 50.4-13.5 82.8-13.5 30.4 0 58.2 6.1 78.7 12.3L481.4 99.1c-2.6-11.2-12.6-19.1-24-19.1-3.1 0-6.2.6-9.2 1.8l-31.3 12.5c-12.3 4.9-26.3-1.1-31.2-13.4s1.1-26.3 13.4-31.2l31.3-12.5c8.6-3.4 17.7-5.2 27-5.2 33.8 0 63.1 23.3 70.8 56.2l43.9 188c1.7 7.3 2.9 14.7 3.5 22.1.3 1.9.5 3.8.5 5.7v64c0 61.9-50.1 112-112 112h-44.4c-59.4 0-108.5-46.4-111.8-105.8l-1.3-22.2h-37.2l-1.2 22.2C264.9 433.6 215.8 480 156.3 480H112C50.1 480 0 429.9 0 368v-64c0-1.9.2-3.8.5-5.7.6-7.4 1.8-14.8 3.5-22.1l43.9-188C55.5 55.3 84.8 32 118.6 32c9.2 0 18.4 1.8 27 5.2l31.3 12.5c12.3 4.9 18.3 18.9 13.4 31.2s-18.9 18.3-31.2 13.4l-31.3-12.5c-2.9-1.2-6-1.8-9.2-1.8zM64 325.4V368c0 26.5 21.5 48 48 48h44.3c25.5 0 46.5-19.9 47.9-45.3l2.5-45.6c-2.3-.8-4.9-1.7-7.5-2.5-17.2-5.4-39.9-10.5-63.6-10.5-23.7 0-46.2 5.1-63.2 10.5-3.1 1-5.9 1.9-8.5 2.9zM512 368v-42.6c-2.6-.9-5.5-1.9-8.5-2.9-17-5.4-39.5-10.5-63.2-10.5-23.7 0-46.4 5.1-63.6 10.5-2.7.8-5.2 1.7-7.5 2.5l2.5 45.6c1.4 25.4 22.5 45.3 47.9 45.3H464c26.5 0 48-21.5 48-48z"
        }
    ]
};

const FasGlobePointer = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasGlobePointer",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 256c0 22.2-1.2 43.6-3.3 64h-66.9l12.6-42.8c10.7-36.4-23.1-70.3-59.6-59.6l-74.6 21.9c.4-16.3 1.5-32.2 3.1-47.5h185.4c2.2 20.4 3.3 41.8 3.3 64zM20.4 280.6c-7.1 2.1-13.1 5.5-18.1 9.9C.8 279.2 0 267.7 0 256c0-22.1 2.8-43.5 8.1-64h123.1c-1.9 18.4-2.9 37.4-3.1 57L20.4 280.6zm211 211 41-139.6h71.9c-6.1 36.4-15.5 68.6-27 94.6-10.5 23.6-22.2 40.7-33.5 51.5-11.2 10.7-20.5 13.9-27.8 13.9-7.2 0-16.3-3.1-27.3-13.4 1-2.2 1.9-4.6 2.7-7.1zM380.8 192h123.1c5.3 20.5 8.1 41.9 8.1 64s-2.8 43.5-8.1 64H380.8c2.1-20.6 3.2-42 3.2-64s-1.1-43.4-3.2-64zm112.6-32H376.7c-10-63.9-29.8-117.4-55.3-151.6 78.3 20.7 142 77.5 171.9 151.6zm-325.7 0c6.1-36.4 15.5-68.6 27-94.7 10.5-23.6 22.2-40.7 33.5-51.5C239.4 3.2 248.7 0 256 0s16.6 3.2 27.8 13.8c11.3 10.8 23 27.9 33.5 51.5 11.6 26 20.9 58.2 27 94.7H167.7zm-32.4 0H18.6c30-74.1 93.6-130.9 172-151.6-25.5 34.2-45.3 87.7-55.3 151.6zm358.1 192c-30 74.1-93.6 130.9-171.9 151.6 25.5-34.2 45.2-87.7 55.3-151.6h116.6zM39 308.5l204.8-60.2c12.1-3.6 23.4 7.7 19.9 19.9L203.5 473c-4.1 13.9-23.2 15.6-29.7 2.6l-28.7-57.3c-.7-1.3-1.5-2.6-2.5-3.7l-88 88c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l88-88c-1.1-1-2.3-1.9-3.7-2.5l-57.2-28.6c-13-6.5-11.3-25.6 2.6-29.7z"
        }
    ]
};

const FasGlobeSnow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasGlobeSnow",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 224c0 62.7-25.7 119.3-67.2 160H256v-32h64c6.5 0 12.3-3.9 14.8-9.9s1.1-12.9-3.5-17.4L262.6 256H288c6.5 0 12.3-3.9 14.8-9.9s1.1-12.9-3.5-17.4l-64-64c-6.2-6.2-16.4-6.2-22.6 0l-64 64c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9h25.4l-68.7 68.7c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9h64v32H67.2C25.7 343.3 0 286.7 0 224 0 100.3 100.3 0 224 0s224 100.3 224 224zM256 80a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm80 112a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM96 208a16 16 0 1 0-32 0 16 16 0 1 0 32 0zM20.3 474.2 61.1 416h325.8l40.8 58.2c5.1 7.3 5.8 16.9 1.6 24.8s-12.4 13-21.3 13H40c-8.9 0-17.2-5-21.3-12.9s-3.5-17.5 1.6-24.8z"
        }
    ]
};

const FasGlobeStand = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasGlobeStand",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M15 367c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l18.5-18.5c34.3 27.7 74.9 43.8 116.5 48.3V464H88c-13.3 0-24 10.7-24 24s10.7 24 24 24h240c13.3 0 24-10.7 24-24s-10.7-24-24-24h-96v-33.3c49.1-5.3 96.8-26.7 134.4-64.3 81.7-81.7 87.1-211 16.1-298.9L401 49c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-34.6 34.5c-9.4 9.4-9.4 24.6 0 33.9 68.7 68.7 68.7 180.2 0 248.9s-180.2 68.7-248.9 0c-9.4-9.4-24.6-9.4-33.9 0L15 367zm193-15a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"
        }
    ]
};

const FasGlobe = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasGlobe",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 256c0 22.2-1.2 43.6-3.3 64H163.3c-2.2-20.4-3.3-41.8-3.3-64s1.2-43.6 3.3-64h185.4c2.2 20.4 3.3 41.8 3.3 64zm28.8-64h123.1c5.3 20.5 8.1 41.9 8.1 64s-2.8 43.5-8.1 64H380.8c2.1-20.6 3.2-42 3.2-64s-1.1-43.4-3.2-64zm112.6-32H376.7c-10-63.9-29.8-117.4-55.3-151.6 78.3 20.7 142 77.5 171.9 151.6zm-149.1 0H167.7c6.1-36.4 15.5-68.6 27-94.7 10.5-23.6 22.2-40.7 33.5-51.5C239.4 3.2 248.7 0 256 0s16.6 3.2 27.8 13.8c11.3 10.8 23 27.9 33.5 51.5 11.6 26 20.9 58.2 27 94.7zm-209 0H18.6c30-74.1 93.6-130.9 172-151.6-25.5 34.2-45.3 87.7-55.3 151.6zM8.1 192h123.1c-2.1 20.6-3.2 42-3.2 64s1.1 43.4 3.2 64H8.1C2.8 299.5 0 278.1 0 256s2.8-43.5 8.1-64zm186.6 254.6c-11.6-26-20.9-58.2-27-94.6h176.6c-6.1 36.4-15.5 68.6-27 94.6-10.5 23.6-22.2 40.7-33.5 51.5-11.2 10.7-20.5 13.9-27.8 13.9s-16.6-3.2-27.8-13.8c-11.3-10.8-23-27.9-33.5-51.5zM135.3 352c10 63.9 29.8 117.4 55.3 151.6-78.4-20.7-142-77.5-172-151.6h116.7zm358.1 0c-30 74.1-93.6 130.9-171.9 151.6 25.5-34.2 45.2-87.7 55.3-151.6h116.6z"
        }
    ]
};

const FasGoalNet = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasGoalNet",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 128c0-17.7 14.3-32 32-32h448c17.7 0 32 14.3 32 32v320c0 17.7 14.3 32 32 32s32-14.3 32-32V128c0-53-43-96-96-96H96C43 32 0 75 0 128v320c0 17.7 14.3 32 32 32s32-14.3 32-32V128zm112 0c-8.8 0-16 7.2-16 16v48h-48c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v64h-48c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v64h-48c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48h64v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48h64v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48h64v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48h48c8.8 0 16-7.2 16-16s-7.2-16-16-16h-48v-64h48c8.8 0 16-7.2 16-16s-7.2-16-16-16h-48v-64h48c8.8 0 16-7.2 16-16s-7.2-16-16-16h-48v-48c0-8.8-7.2-16-16-16s-16 7.2-16 16v48h-64v-48c0-8.8-7.2-16-16-16s-16 7.2-16 16v48h-64v-48c0-8.8-7.2-16-16-16s-16 7.2-16 16v48h-64v-48c0-8.8-7.2-16-16-16zm80 256h-64v-64h64v64zm96 0h-64v-64h64v64zm96 0h-64v-64h64v64zm0-96h-64v-64h64v64zm-96 0h-64v-64h64v64zm-96 0h-64v-64h64v64z"
        }
    ]
};

const FasGolfBallTee = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasGolfBallTee",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 192c0 66.8-34.1 125.6-85.8 160H85.8C34.1 317.6 0 258.8 0 192 0 86 86 0 192 0s192 86 192 192zm-141.9 64.6c0 18.5-15 33.5-33.5 33.5-4.9 0-9.1 5.1-5.4 8.4 5.9 5.2 13.7 8.4 22.1 8.4 18.5 0 33.5-15 33.5-33.5 0-8.5-3.2-16.2-8.4-22.1-3.3-3.7-8.4.5-8.4 5.4zm-52.3-49.3c-4.9 0-9.1 5.1-5.4 8.4 5.9 5.2 13.7 8.4 22.1 8.4 18.5 0 33.5-15 33.5-33.5 0-8.5-3.2-16.2-8.4-22.1-3.3-3.7-8.4.5-8.4 5.4 0 18.5-15 33.5-33.5 33.5zm113.5-17.5c0 18.5-15 33.5-33.5 33.5-4.9 0-9.1 5.1-5.4 8.4 5.9 5.2 13.7 8.4 22.1 8.4 18.5 0 33.5-15 33.5-33.5 0-8.5-3.2-16.2-8.4-22.1-3.3-3.7-8.4.5-8.4 5.4zM96 416c0-17.7 14.3-32 32-32h128c17.7 0 32 14.3 32 32s-14.3 32-32 32h-16c-8.8 0-16 7.2-16 16v16c0 17.7-14.3 32-32 32s-32-14.3-32-32v-16c0-8.8-7.2-16-16-16h-16c-17.7 0-32-14.3-32-32z"
        }
    ]
};

const FasGolfClub = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasGolfClub",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M508.6 46.3c7.9-15.8 1.5-35-14.3-42.9s-35-1.5-42.9 14.3L264 392.5v-.5L42.1 318C21.4 311.1 0 326.6 0 348.4V376h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H0v32h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H0v8c0 17.7 14.3 32 32 32h223.3c12 .3 23.6-6.3 29.3-17.7l224-448z"
        }
    ]
};

const FasGolfFlagHole = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasGolfFlagHole",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M162.7 2.5c-7.4-3.7-16.3-3.3-23.4 1.1S128 15.7 128 24v208c0 1.3.1 2.7.3 4-.2 1.3-.3 2.6-.3 4v92.8C51.5 349.4 0 380.5 0 416c0 53 114.6 96 256 96s256-43 256-96-114.6-96-256-96c-27.9 0-54.8 1.7-80 4.8v-78l194.7-97.4c8.1-4.1 13.3-12.4 13.3-21.5s-5.1-17.4-13.3-21.5l-208-104zM288 416c0 17.7-28.7 32-64 32s-64-14.3-64-32 28.7-32 64-32 64 14.3 64 32z"
        }
    ]
};

const FasGopuram = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasGopuram",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M120 0c13.3 0 24 10.7 24 24v8h40v-8c0-13.3 10.7-24 24-24s24 10.7 24 24v8h48v-8c0-13.3 10.7-24 24-24s24 10.7 24 24v8h40v-8c0-13.3 10.7-24 24-24s24 10.7 24 24v104c17.7 0 32 14.3 32 32v64c17.7 0 32 14.3 32 32v96c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32h-64V352h-32V224h-32v-96h-32v96h32v128h32v160h-80v-48c0-26.5-21.5-48-48-48s-48 21.5-48 48v48h-80V352h32V224h32v-96h-32v96h-32v128H96v160H32c-17.7 0-32-14.3-32-32v-96c0-17.7 14.3-32 32-32v-96c0-17.7 14.3-32 32-32v-64c0-17.7 14.3-32 32-32V24c0-13.3 10.7-24 24-24zm136 272c-17.7 0-32 14.3-32 32v48h64v-48c0-17.7-14.3-32-32-32zm-32-80v32h64v-32c0-17.7-14.3-32-32-32s-32 14.3-32 32z"
        }
    ]
};

const FasGraduationCap = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasGraduationCap",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 32c-8.1 0-16.1 1.4-23.7 4.1L15.8 137.4C6.3 140.9 0 149.9 0 160s6.3 19.1 15.8 22.6l57.9 20.9C57.3 229.3 48 259.8 48 291.9V320c0 28.4-10.8 57.7-22.3 80.8-6.5 13-13.9 25.8-22.5 37.6-3.2 4.3-4.1 9.9-2.3 15s6 8.9 11.2 10.2l64 16c4.2 1.1 8.7.3 12.4-2s6.3-6.1 7.1-10.4c8.6-42.8 4.3-81.2-2.1-108.7-3.2-14.2-7.5-28.7-13.5-42v-24.6c0-30.2 10.2-58.7 27.9-81.5 12.9-15.5 29.6-28 49.2-35.7l157-61.7c8.2-3.2 17.5.8 20.7 9s-.8 17.5-9 20.7l-157 61.7c-12.4 4.9-23.3 12.4-32.2 21.6l159.6 57.6c7.6 2.7 15.6 4.1 23.7 4.1s16.1-1.4 23.7-4.1l280.6-101c9.5-3.4 15.8-12.5 15.8-22.6s-6.3-19.1-15.8-22.6L343.7 36.1c-7.6-2.7-15.6-4.1-23.7-4.1zM128 408c0 35.3 86 72 192 72s192-36.7 192-72l-15.3-145.4L354.5 314c-11.1 4-22.8 6-34.5 6s-23.5-2-34.5-6l-142.2-51.4L128 408z"
        }
    ]
};

const FasGramophone = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasGramophone",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M127 0c10.5-.4 20 6 23.6 15.9v.1l.3.7c.3.7.7 1.7 1.3 3.2 1.2 2.9 3.2 7.3 6 12.8 5.7 11.1 14.8 27 28.2 45.1 26.9 36.2 71.4 81.5 141.3 116.8 17.3 8.7 31.6 22.9 40.1 40.4 5.4 10.9 8.2 23 8.2 35v.6c0 45-36.5 81.4-81.4 81.4H184c-13.3 0-24-10.7-24-24s10.7-24 24-24h110c18.7 0 33.9-15.1 34-33.7-.1-5.4-1.5-10.7-4.1-15.6-3.1-4.9-7.7-7.8-12.4-8.6-44.1-7.3-133.1-7.9-241.4 69.4-.3.2-.7.5-1 .7-2.7 1.8-5.6 2.9-8.7 3.5-3.2.6-6.6.6-10-.2-1.2-.3-2.4-.7-3.6-1.1-.5-.2-1-.5-1.5-.7-.9-.4-1.7-.9-2.5-1.5-1.2-.8-2.2-1.6-3.2-2.6-1.4-1.3-2.5-2.7-3.6-4.2-1.8-2.8-3-5.8-3.6-8.9-.6-3.1-.5-6.4.2-9.6.1-.3.2-.7.3-1l71.9-272C107.5 7.7 116.5.4 127 0zM32 416c0-17.7 14.3-32 32-32h256c17.7 0 32 14.3 32 32v32c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32v-32z"
        }
    ]
};

const FasGrapes = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasGrapes",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M346.7 6C337.6 17 320 42.3 320 72c0 40 15.3 55.3 40 80s40 40 80 40c29.7 0 55-17.6 66-26.7 4-3.3 6-8.2 6-13.3s-2-10-6-13.2c-11.4-9.1-38.3-26.8-74-26.8-32 0-40 8-40 8s8-8 8-40c0-35.7-17.7-62.6-26.8-74-3.2-4-8.1-6-13.2-6s-10 2-13.3 6zM304 152a56 56 0 1 0-112 0 56 56 0 1 0 112 0zm-192 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112zm32 80a56 56 0 1 0-112 0 56 56 0 1 0 112 0zm-32 144a56 56 0 1 0-112 0 56 56 0 1 0 112 0zm144-32a56 56 0 1 0-112 0 56 56 0 1 0 112 0zm80 32a56 56 0 1 0 0-112 56 56 0 1 0 0 112zm-56-168a56 56 0 1 0-112 0 56 56 0 1 0 112 0zm80 32a56 56 0 1 0 0-112 56 56 0 1 0 0 112z"
        }
    ]
};

const FasGrateDroplet = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasGrateDroplet",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v66.2c-15.1 4.3-28.2 14.6-35.8 28.8l-75.3 141.2A144.61 144.61 0 0 0 320 400c0 29.6 8.9 57.1 24.2 80H64c-35.3 0-64-28.7-64-64V96zm96 0H64v128h32V96zM64 416h32V288H64v128zm128 0V288h-32v128h32zm96 0V288h-32v128h32zm96-320h-32v128h32V96zm-128 0v128h32V96h-32zm-96 0v128h32V96h-32zm280.5 110.1c4.6-8.7 13.7-14.1 23.5-14.1s18.9 5.4 23.5 14.1l75.3 141.2c8.7 16.2 13.2 34.3 13.2 52.7 0 61.9-50.1 112-112 112s-112-50.1-112-112c0-18.4 4.5-36.5 13.2-52.7l75.3-141.2z"
        }
    ]
};

const FasGrate = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasGrate",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm0 64h32v128H64V96zm0 192h32v128H64V288zm96 128V288h32v128h-32zm96 0V288h32v128h-32zm96 0V288h32v128h-32zm32-192h-32V96h32v128zM288 96v128h-32V96h32zm-96 0v128h-32V96h32z"
        }
    ]
};

const FasGreaterThanEqual = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasGreaterThanEqual",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M52.1 93.7c-16.4-6.6-24.4-25.2-17.8-41.6s25.2-24.4 41.6-17.8l320 128C408 167.1 416 178.9 416 192s-8 24.9-20.1 29.7l-320 128c-16.4 6.6-35-1.4-41.6-17.8s1.4-35 17.8-41.6L297.8 192 52.1 93.7zM416 416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h384z"
        }
    ]
};

const FasGreaterThan = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasGreaterThan",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M3.4 81.7c-7.9 15.8-1.5 35 14.3 42.9L280.5 256 17.7 387.4c-15.8 7.9-22.2 27.1-14.3 42.9s27.1 22.2 42.9 14.3l320-160c10.8-5.4 17.7-16.5 17.7-28.6s-6.8-23.2-17.7-28.6l-320-160c-15.8-7.9-35-1.5-42.9 14.3z"
        }
    ]
};

const FasGrid2Plus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasGrid2Plus",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 32h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48zm0 256h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48v-96c0-26.5 21.5-48 48-48zM288 80c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48h-96c-26.5 0-48-21.5-48-48V80zm96 192c13.3 0 24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24h-64v64c0 13.3-10.7 24-24 24s-24-10.7-24-24v-64h-64c-13.3 0-24-10.7-24-24s10.7-24 24-24h64v-64c0-13.3 10.7-24 24-24z"
        }
    ]
};

const FasGrid2 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasGrid2",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 80c0-26.5-21.5-48-48-48H80c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V80zm0 256c0-26.5-21.5-48-48-48H80c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48v-96zm64-256v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48h-96c-26.5 0-48 21.5-48 48zm192 256c0-26.5-21.5-48-48-48h-96c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48v-96z"
        }
    ]
};

const FasGrid4 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasGrid4",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 48c0-8.8 7.2-16 16-16h57.6c8.8 0 16 7.2 16 16v57.6c0 8.8-7.2 16-16 16H16c-8.8 0-16-7.2-16-16V48zm0 119.5c0-8.8 7.2-16 16-16h57.6c8.8 0 16 7.2 16 16v57.6c0 8.8-7.2 16-16 16H16c-8.8 0-16-7.2-16-16v-57.6zm16 103.4h57.6c8.8 0 16 7.2 16 16v57.6c0 8.8-7.2 16-16 16H16c-8.8 0-16-7.2-16-16v-57.6c0-8.8 7.2-16 16-16zM0 406.4c0-8.8 7.2-16 16-16h57.6c8.8 0 16 7.2 16 16V464c0 8.8-7.2 16-16 16H16c-8.8 0-16-7.2-16-16v-57.6zM119.5 48c0-8.8 7.2-16 16-16h57.6c8.8 0 16 7.2 16 16v57.6c0 8.8-7.2 16-16 16h-57.6c-8.8 0-16-7.2-16-16V48zm0 119.5c0-8.8 7.2-16 16-16h57.6c8.8 0 16 7.2 16 16v57.6c0 8.8-7.2 16-16 16h-57.6c-8.8 0-16-7.2-16-16v-57.6zm16 103.5h57.6c8.8 0 16 7.2 16 16v57.6c0 8.8-7.2 16-16 16h-57.6c-8.8 0-16-7.2-16-16v-57.7c0-8.8 7.2-16 16-16zm-16 135.5c0-8.8 7.2-16 16-16h57.6c8.8 0 16 7.2 16 16V464c0 8.8-7.2 16-16 16h-57.6c-8.8 0-16-7.2-16-16v-57.6zM254.9 32h57.6c8.8 0 16 7.2 16 16v57.6c0 8.8-7.2 16-16 16h-57.6c-8.8 0-16-7.2-16-16V48c0-8.8 7.2-16 16-16zm0 119.5h57.6c8.8 0 16 7.2 16 16v57.6c0 8.8-7.2 16-16 16h-57.6c-8.8 0-16-7.2-16-16v-57.6c0-8.8 7.2-16 16-16zm-16 135.5c0-8.8 7.2-16 16-16h57.6c8.8 0 16 7.2 16 16v57.6c0 8.8-7.2 16-16 16h-57.6c-8.8 0-16-7.2-16-16v-57.7zm16 103.5h57.6c8.8 0 16 7.2 16 16V464c0 8.8-7.2 16-16 16h-57.6c-8.8 0-16-7.2-16-16v-57.6c0-8.8 7.2-16 16-16zM358.4 48c0-8.8 7.2-16 16-16H432c8.8 0 16 7.2 16 16v57.6c0 8.8-7.2 16-16 16h-57.6c-8.8 0-16-7.2-16-16V48zm0 119.5c0-8.8 7.2-16 16-16H432c8.8 0 16 7.2 16 16v57.6c0 8.8-7.2 16-16 16h-57.6c-8.8 0-16-7.2-16-16v-57.6zm16 103.5H432c8.8 0 16 7.2 16 16v57.6c0 8.8-7.2 16-16 16h-57.6c-8.8 0-16-7.2-16-16v-57.7c0-8.8 7.2-16 16-16zm-16 135.5c0-8.8 7.2-16 16-16H432c8.8 0 16 7.2 16 16V464c0 8.8-7.2 16-16 16h-57.6c-8.8 0-16-7.2-16-16v-57.6z"
        }
    ]
};

const FasGrid5 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasGrid5",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 48c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H16C7.2 96 0 88.8 0 80V48zm0 96c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H16c-8.8 0-16-7.2-16-16v-32zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H16c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16zM0 336c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H16c-8.8 0-16-7.2-16-16v-32zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H16c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16zM96 48c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16V48zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16zM96 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16zM96 432c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32zM208 32h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16V48c0-8.8 7.2-16 16-16zm-16 112c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16zm-16 112c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16zm80-368c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16V48zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16zm-16 112c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16zm-16 112c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32zM400 32h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16V48c0-8.8 7.2-16 16-16zm-16 112c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16zm-16 112c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16z"
        }
    ]
};

const FasGridDividers = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasGridDividers",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 24C0 10.7 10.7 0 24 0h464c13.3 0 24 10.7 24 24s-10.7 24-24 24H24C10.7 48 0 37.3 0 24zm64 72h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32zm0 288h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32zm128-256c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32v-64zm32 256h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32zm128-256c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32v-64zm32 256h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32zM24 288h464c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
        }
    ]
};

const FasGridHorizontal = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasGridHorizontal",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 168c0-22.1-17.9-40-40-40H40c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40v-48zm0 160c0-22.1-17.9-40-40-40H40c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40v-48zm32-160v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40v-48c0-22.1-17.9-40-40-40h-48c-22.1 0-40 17.9-40 40zm128 160c0-22.1-17.9-40-40-40h-48c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40v-48zm32-160v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40v-48c0-22.1-17.9-40-40-40h-48c-22.1 0-40 17.9-40 40zm128 160c0-22.1-17.9-40-40-40h-48c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40v-48z"
        }
    ]
};

const FasGridRound2Plus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasGridRound2Plus",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 224a96 96 0 1 1 0-192 96 96 0 1 1 0 192zm0 256a96 96 0 1 1 0-192 96 96 0 1 1 0 192zm352-352a96 96 0 1 1-192 0 96 96 0 1 1 192 0zm-96 144c13.3 0 24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24h-64v64c0 13.3-10.7 24-24 24s-24-10.7-24-24v-64h-64c-13.3 0-24-10.7-24-24s10.7-24 24-24h64v-64c0-13.3 10.7-24 24-24z"
        }
    ]
};

const FasGridRound2 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasGridRound2",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 32a96 96 0 1 0 0 192 96 96 0 1 0 0-192zm0 256a96 96 0 1 0 0 192 96 96 0 1 0 0-192zm160-160a96 96 0 1 0 192 0 96 96 0 1 0-192 0zm96 160a96 96 0 1 0 0 192 96 96 0 1 0 0-192z"
        }
    ]
};

const FasGridRound4 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasGridRound4",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M44.8 121.6a44.8 44.8 0 1 1 0-89.6 44.8 44.8 0 1 1 0 89.6zm0 119.5a44.8 44.8 0 1 1 0-89.6 44.8 44.8 0 1 1 0 89.6zm44.8 74.7a44.8 44.8 0 1 1-89.6-.1 44.8 44.8 0 1 1 89.6 0zM44.8 480a44.8 44.8 0 1 1 0-89.6 44.8 44.8 0 1 1 0 89.6zM209.1 76.8a44.8 44.8 0 1 1-89.6 0 44.8 44.8 0 1 1 89.6 0zm-44.8 164.3a44.8 44.8 0 1 1 0-89.6 44.8 44.8 0 1 1 0 89.6zm44.8 74.7a44.8 44.8 0 1 1-89.6 0 44.8 44.8 0 1 1 89.6 0zM164.3 480a44.8 44.8 0 1 1 0-89.6 44.8 44.8 0 1 1 0 89.6zM328.5 76.8a44.8 44.8 0 1 1-89.6 0 44.8 44.8 0 1 1 89.6 0zm-44.8 164.3a44.8 44.8 0 1 1 0-89.6 44.8 44.8 0 1 1 0 89.6zm44.8 74.7a44.8 44.8 0 1 1-89.6 0 44.8 44.8 0 1 1 89.6 0zM283.7 480a44.8 44.8 0 1 1 0-89.6 44.8 44.8 0 1 1 0 89.6zM448 76.8a44.8 44.8 0 1 1-89.6 0 44.8 44.8 0 1 1 89.6 0zm-44.8 164.3a44.8 44.8 0 1 1 0-89.6 44.8 44.8 0 1 1 0 89.6zm44.8 74.6a44.8 44.8 0 1 1-89.6 0 44.8 44.8 0 1 1 89.6 0zM403.2 480a44.8 44.8 0 1 1 0-89.6 44.8 44.8 0 1 1 0 89.6z"
        }
    ]
};

const FasGridRound5 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasGridRound5",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64a32 32 0 1 1-64 0 32 32 0 1 1 64 0zm0 96a32 32 0 1 1-64 0 32 32 0 1 1 64 0zM32 288a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1-64 0 32 32 0 1 1 64 0zM32 480a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM160 64a32 32 0 1 1-64 0 32 32 0 1 1 64 0zm-32 128a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1-64 0 32 32 0 1 1 64 0zm-32 128a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1-64 0 32 32 0 1 1 64 0zm64-352a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1-64 0 32 32 0 1 1 64 0zm-32 128a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1-64 0 32 32 0 1 1 64 0zm-32 128a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM352 64a32 32 0 1 1-64 0 32 32 0 1 1 64 0zm-32 128a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1-64 0 32 32 0 1 1 64 0zm-32 128a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1-64 0 32 32 0 1 1 64 0zm64-352a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1-64 0 32 32 0 1 1 64 0zm-32 128a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1-64 0 32 32 0 1 1 64 0zm-32 128a32 32 0 1 1 0-64 32 32 0 1 1 0 64z"
        }
    ]
};

const FasGridRound = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasGridRound",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 96A64 64 0 1 1 0 96a64 64 0 1 1 128 0zm0 160a64 64 0 1 1-128 0 64 64 0 1 1 128 0zM64 480a64 64 0 1 1 0-128 64 64 0 1 1 0 128zM288 96a64 64 0 1 1-128 0 64 64 0 1 1 128 0zm-64 224a64 64 0 1 1 0-128 64 64 0 1 1 0 128zm64 96a64 64 0 1 1-128 0 64 64 0 1 1 128 0zm96-256a64 64 0 1 1 0-128 64 64 0 1 1 0 128zm64 96a64 64 0 1 1-128 0 64 64 0 1 1 128 0zm-64 224a64 64 0 1 1 0-128 64 64 0 1 1 0 128z"
        }
    ]
};

const FasGrid = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasGrid",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 72c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40H40c-22.1 0-40-17.9-40-40V72zm0 160c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40H40c-22.1 0-40-17.9-40-40v-48zm128 160v48c0 22.1-17.9 40-40 40H40c-22.1 0-40-17.9-40-40v-48c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40zm32-320c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40h-48c-22.1 0-40-17.9-40-40V72zm128 160v48c0 22.1-17.9 40-40 40h-48c-22.1 0-40-17.9-40-40v-48c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40zM160 392c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40h-48c-22.1 0-40-17.9-40-40v-48zM448 72v48c0 22.1-17.9 40-40 40h-48c-22.1 0-40-17.9-40-40V72c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40zM320 232c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40h-48c-22.1 0-40-17.9-40-40v-48zm128 160v48c0 22.1-17.9 40-40 40h-48c-22.1 0-40-17.9-40-40v-48c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40z"
        }
    ]
};

const FasGrillFire = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasGrillFire",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 72c0-22.1 17.9-40 40-40h368c22.1 0 40 17.9 40 40v24c0 24.1-3.8 47.3-10.9 69.1-8.5-8.6-17.2-17-26.2-25.1-17.7-16-44.7-16-62.5-.1-35.4 31.6-65.6 67.7-87.3 102.8-15 24.3-27.7 51-33.6 77.3h-3.6c-16.9 0-33.4-1.9-49.3-5.4L151.8 368h73c1.5 16.6 5.2 32.7 10.7 48H160c0 35.3-28.7 64-64 64s-64-28.7-64-64 28.7-64 64-64c3.4 0 6.8.3 10.1.8l23.1-53.8C52.9 263.3 0 185.8 0 96V72zm96 368a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm293.5-276.2c19.7 17.8 38.2 37 55.5 57.7 7.9-9.9 16.8-20.7 26.5-29.5 5.6-5.1 14.4-5.1 20 0 24.7 22.7 45.6 52.7 60.4 81.1 14.5 28 24.2 56.7 24.2 76.9-.1 87.9-71.4 162-160.1 162-89.7 0-160-74.2-160-161.9 0-26.4 12.7-58.6 32.4-90.6 20-32.4 48.1-66.1 81.4-95.8 5.6-5 14.2-5 19.8 0zM466 433c30-21 38-63 20-96-2-4-4-8-7-12l-36 42s-58-74-62-79c-30 37-45 58-45 82 0 49 36 78 81 78 18 0 34-5 49-15z"
        }
    ]
};

const FasGrillHot = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasGrillHot",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M120 0c13.3 0 24 10.7 24 24v2.6c0 5.3 2.7 10.3 7.1 13.3l12.4 8.3C181.3 60 192 80 192 101.4v2.6c0 13.3-10.7 24-24 24s-24-10.7-24-24v-2.6c0-5.3-2.7-10.3-7.1-13.3l-12.4-8.3C106.7 68 96 48 96 26.6V24c0-13.3 10.7-24 24-24zM0 192c0-17.7 14.3-32 32-32h384c17.7 0 32 14.3 32 32 0 78.1-46.6 145.3-113.6 175.3l47.7 111.2c5.2 12.2-.4 26.3-12.6 31.5s-26.3-.4-31.5-12.6L327 472H155.3c-9.5 23.5-32.5 40-59.3 40-35.3 0-64-28.7-64-64s28.7-64 64-64c3.4 0 6.8.3 10.1.8l7.5-17.5C46.6 337.3 0 270.1 0 192zm155.3 232h151.2l-18.3-42.7c-10.5 1.8-21.2 2.7-32.2 2.7h-64c-11 0-21.7-.9-32.2-2.7L147.5 410c3.2 4.3 5.8 9 7.8 14zM96 472a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM256 24v2.6c0 5.3 2.7 10.3 7.1 13.3l12.4 8.3C293.3 60 304 80 304 101.4v2.6c0 13.3-10.7 24-24 24s-24-10.7-24-24v-2.6c0-5.3-2.7-10.3-7.1-13.3l-12.4-8.3C218.7 68 208 48 208 26.6V24c0-13.3 10.7-24 24-24s24 10.7 24 24z"
        }
    ]
};

const FasGrill = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasGrill",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 72c0-22.1 17.9-40 40-40h368c22.1 0 40 17.9 40 40v24c0 89.8-52.9 167.3-129.2 203L382 446.5c5.2 12.2-.4 26.3-12.6 31.5s-26.3-.4-31.5-12.6L316.7 416H160c0 35.3-28.7 64-64 64s-64-28.7-64-64 28.7-64 64-64c3.4 0 6.8.3 10.1.8l23.1-53.8C52.9 263.3 0 185.8 0 96V72zm151.8 296h144.4l-22.9-53.4c-15.9 3.6-32.3 5.4-49.3 5.4s-33.4-1.9-49.3-5.4L151.8 368zM96 440a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FasGripDotsVertical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasGripDotsVertical",
    "viewBox": "0 0 256 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 144a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0 160a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm48 112a48 48 0 1 0-96 0 48 48 0 1 0 96 0zm112-272a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm48 112a48 48 0 1 0-96 0 48 48 0 1 0 96 0zm-48 208a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
        }
    ]
};

const FasGripDots = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasGripDots",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M336 176a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm-160 0a48 48 0 1 0 96 0 48 48 0 1 0-96 0zM64 224a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm272 112a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm-112 48a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM16 336a48 48 0 1 0 96 0 48 48 0 1 0-96 0z"
        }
    ]
};

const FasGripLinesVertical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasGripLinesVertical",
    "viewBox": "0 0 192 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64v384c0 17.7 14.3 32 32 32s32-14.3 32-32V64zm128 0c0-17.7-14.3-32-32-32s-32 14.3-32 32v384c0 17.7 14.3 32 32 32s32-14.3 32-32V64z"
        }
    ]
};

const FasGripLines = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasGripLines",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 288c-17.7 0-32 14.3-32 32s14.3 32 32 32h384c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zm0-128c-17.7 0-32 14.3-32 32s14.3 32 32 32h384c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"
        }
    ]
};

const FasGripVertical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasGripVertical",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M40 352h48c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40H40c-22.1 0-40-17.9-40-40v-48c0-22.1 17.9-40 40-40zm192 0h48c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40h-48c-22.1 0-40-17.9-40-40v-48c0-22.1 17.9-40 40-40zM40 320c-22.1 0-40-17.9-40-40v-48c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40H40zm192-128h48c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40h-48c-22.1 0-40-17.9-40-40v-48c0-22.1 17.9-40 40-40zM40 160c-22.1 0-40-17.9-40-40V72c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40H40zM232 32h48c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40h-48c-22.1 0-40-17.9-40-40V72c0-22.1 17.9-40 40-40z"
        }
    ]
};

const FasGrip = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasGrip",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 136c0-22.1-17.9-40-40-40H40c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40v-48zm0 192c0-22.1-17.9-40-40-40H40c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40v-48zm32-192v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40v-48c0-22.1-17.9-40-40-40h-48c-22.1 0-40 17.9-40 40zm128 192c0-22.1-17.9-40-40-40h-48c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40v-48zm32-192v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40v-48c0-22.1-17.9-40-40-40h-48c-22.1 0-40 17.9-40 40zm128 192c0-22.1-17.9-40-40-40h-48c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40v-48z"
        }
    ]
};

const FasGroupArrowsRotate = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasGroupArrowsRotate",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M201.1 71.9c16.9-5 26.6-22.9 21.5-39.8s-22.9-26.6-39.8-21.5a255.9 255.9 0 0 0-60.6 27C114.3 34 105.4 32 96 32c-35.3 0-64 28.7-64 64 0 9.4 2 18.3 5.6 26.3-11.5 18.7-20.6 39-27 60.6-5 16.9 4.6 34.8 21.5 39.8s34.8-4.6 39.8-21.5c4.3-14.6 10.4-28.5 17.9-41.4 2 .2 4.1.3 6.1.3 35.3 0 64-28.7 64-64 0-2.1-.1-4.1-.3-6.1 12.9-7.5 26.8-13.6 41.4-17.9zm128-61.3c-16.9-5-34.8 4.6-39.8 21.5s4.6 34.8 21.5 39.8c14.6 4.3 28.5 10.4 41.4 17.9-.2 2-.3 4.1-.3 6.1 0 35.3 28.7 64 64 64 2.1 0 4.1-.1 6.2-.3 7.5 12.9 13.6 26.8 17.9 41.4 5 16.9 22.9 26.6 39.8 21.5s26.6-22.9 21.5-39.8a255.9 255.9 0 0 0-27-60.6c3.6-8 5.6-16.9 5.6-26.3 0-35.3-28.7-64-64-64-9.4 0-18.3 2-26.3 5.6-18.7-11.5-39-20.6-60.6-27zM71.9 310.9c-5-16.9-22.9-26.6-39.8-21.5s-26.6 22.9-21.5 39.8a255.9 255.9 0 0 0 27 60.6C34 397.7 32 406.6 32 416c0 35.3 28.7 64 64 64 9.4 0 18.3-2 26.3-5.6 18.7 11.5 39 20.6 60.6 27 16.9 5 34.8-4.6 39.8-21.5s-4.6-34.8-21.5-39.8c-14.6-4.3-28.5-10.4-41.4-17.9.2-2 .3-4.1.3-6.2 0-35.3-28.7-64-64-64-2.1 0-4.1.1-6.2.3-7.5-12.9-13.6-26.8-17.9-41.4zm429.4 18.3c5-16.9-4.6-34.8-21.5-39.8S445 294 440 310.9c-4.3 14.6-10.4 28.5-17.9 41.4-2-.2-4.1-.3-6.2-.3-35.3 0-64 28.7-64 64 0 2.1.1 4.1.3 6.2-12.9 7.5-26.8 13.6-41.4 17.9-16.9 5-26.6 22.9-21.5 39.8s22.9 26.6 39.8 21.5a255.9 255.9 0 0 0 60.6-27c8 3.6 16.9 5.6 26.3 5.6 35.3 0 64-28.7 64-64 0-9.4-2-18.3-5.6-26.3 11.5-18.7 20.6-39 27-60.6zm-308.5-72.4c0-15.6 5.6-29.9 14.9-41.1L223 231c6.6 6.6 17.8 1.9 17.8-7.4v-60.4c0-5.7-4.7-10.4-10.4-10.4h-60.5c-9.3 0-13.9 11.2-7.4 17.8l11.2 11.2c-17.9 19.8-28.9 46.2-28.9 75.1 0 43.6 24.9 81.3 61.1 99.8 11.8 6 26.3 1.4 32.3-10.4s1.4-26.3-10.4-32.3c-20.8-10.6-34.9-32.2-34.9-57zm93.1-58.6c20.8 10.6 34.9 32.2 34.9 57 0 15.6-5.6 29.9-14.9 41.1L290.6 281c-6.6-6.6-17.8-1.9-17.8 7.4v60.5c0 5.7 4.7 10.4 10.4 10.4h60.5c9.3 0 13.9-11.2 7.4-17.8l-11.2-11.2c17.9-19.8 28.9-46.2 28.9-75.1 0-43.6-24.9-81.3-61.1-99.8-11.8-6-26.3-1.4-32.3 10.4s-1.4 26.3 10.4 32.3z"
        }
    ]
};

const FasGuaraniSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasGuaraniSign",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 0c-17.7 0-32 14.3-32 32v34.7C69.2 81.9 0 160.9 0 256s69.2 174.1 160 189.3V480c0 17.7 14.3 32 32 32s32-14.3 32-32v-34.7c90.8-15.2 160-94.2 160-189.3 0-17.7-14.3-32-32-32H224v-92c22.1 5.7 41.8 17.1 57.6 32.6 12.6 12.4 32.9 12.2 45.3-.4s12.2-32.9-.5-45.3C299 92 263.5 73.3 224 66.7V32c0-17.7-14.3-32-32-32zm-32 132v248c-55.2-14.2-96-64.3-96-124s40.8-109.8 96-124zm64 248v-92h92c-11.6 45-47 80.4-92 92z"
        }
    ]
};

const FasGuitarElectric = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasGuitarElectric",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 81.1v33.6L243.8 223c-14.6-26.1-5.5-50.4 3.2-64.7 4.8-7.9 4.8-18.7-1.7-25.3s-17.1-6.6-23.6 0l-29.9 30.2c-9.1 9.2-14.7 21.5-20.2 33.5-1.2 2.6-2.3 5.1-3.5 7.6-3.5 7.3-8.9 15.7-17.1 24-24.7 25-64.7 40.2-89.6 47.7-14.5 4.4-28.1 11.7-38.7 22.4-30 30.4-30 79.6 0 110l79.9 80.8c30 30.4 78.7 30.4 108.8 0 10.7-10.8 17.9-24.5 22.2-39.2 7.5-25.2 22.5-65.6 47.2-90.6 10-10.1 20-16 28.3-19.3l1.1-.5c11.3-4.6 23-9.4 31.6-18l21.6-21.8c6.5-6.6 6.5-17.3 0-23.8s-17.3-6.6-25.8-3c-11.1 4.7-28 7.3-48.3-4.7L461.3 96h2.7c26.5 0 48-21.5 48-48S490.5 0 464 0h-1.1c-9.7 0-19.2 2.9-27.3 8.3l-69.4 46.2c-8.9 5.9-14.2 15.9-14.2 26.6zM195.3 268.7l48 48c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-48-48c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zm-64 64 48 48c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-48-48c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0z"
        }
    ]
};

const FasGuitar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasGuitar",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M465 7c-9.4-9.4-24.6-9.4-33.9 0L383 55c-2.4 2.4-4.3 5.3-5.5 8.5l-15.4 41-77.5 77.6c-45.1-29.4-99.3-30.2-131 1.6-11 11-18 24.6-21.4 39.6-3.7 16.6-19.1 30.7-36.1 31.6-25.6 1.3-49.3 10.7-67.3 28.6-44.8 44.9-36.4 125.9 18.7 181s136.1 63.5 180.9 18.7c17.9-17.9 27.4-41.7 28.6-67.3.9-17 15-32.3 31.6-36.1 15-3.4 28.6-10.5 39.6-21.4 31.8-31.8 31-85.9 1.6-131l77.6-77.6 41-15.4c3.2-1.2 6.1-3.1 8.5-5.5l48-48c9.4-9.4 9.4-24.6 0-33.9L465 7zM208 256a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
        }
    ]
};

const FasGuitars = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasGuitars",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M104 0h48c13.3 0 24 10.7 24 24v52.2c0 6.2-1.4 12.3-4.2 17.9L152 133.7V178c50.3 8.6 88 43.8 88 86 0 14-4.2 27.3-11.6 39.1-8.2 13-7.5 32 2.9 43.4 5.9 6.5 10.9 13.7 14.8 21.3-2.3 4.9-4.7 9.6-7 13.9-8.8 16.3-15 35.6-15 56.5 0 11.6 1.9 22.8 5.4 33.3C205.9 496.1 169.3 512 128 512 57.3 512 0 465.4 0 408c0-23 9.2-44.3 24.8-61.5 10.3-11.4 11.1-30.4 2.9-43.4C20.2 291.3 16 278 16 264c0-42.1 37.7-77.3 88-86v-44.3L84.2 94.1C81.4 88.6 80 82.4 80 76.2V24c0-13.3 10.7-24 24-24zm24 344a40 40 0 1 0 0-80 40 40 0 1 0 0 80zm232-195.4-21.4-24.5c-6.6-7.6-9.3-17.9-7.2-27.8l13.9-64.8C349.2 13.1 365.4 0 384.2 0c22 0 39.8 17.8 39.8 39.8v4.6c0 12.4-6.4 23.3-16 29.7v164.8c27.9-4.2 39.6-19.4 44.5-31.3 3.3-8.2 10.7-15.5 19.5-15.5s16 7.2 16 16v29.3c0 11.6-4.8 22.8-9.3 33.5l-.5 1.1c-3.3 7.8-6.2 18.5-6.2 32.1 0 33.5 17 70.9 28.8 92.9 6.9 12.7 11.2 26.9 11.2 41.3 0 40.8-33 73.8-73.8 73.8H329.8C289 512 256 479 256 438.2c0-14.5 4.3-28.6 11.2-41.3 11.8-22 28.8-59.4 28.8-92.9 0-11.2-2-20.5-4.5-27.8l-2.7-7.5c-4.3-11.8-8.8-23.8-8.8-36.2V192c0-8.8 7.2-16 16-16s16.1 7.2 18.2 15.8c3.9 16.4 14.9 40.5 45.8 46.7v-89.9zM336 320c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16h-64c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16h-64c-8.8 0-16 7.2-16 16z"
        }
    ]
};

const FasGunSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasGunSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L412.3 297.8l20.6-57.8H464c8.5 0 16.6-3.4 22.6-9.4l22.7-22.6H576c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32h-16v-8c0-13.3-10.7-24-24-24s-24 10.7-24 24v8H113.9L38.8 5.1zM195.6 128H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H236.4l-40.8-32zm142.9 112h43.4l-9.5 26.6-33.9-26.6zm-13.6 112L264 304h-3l.5-2L32 121.2V208c0 17.7 14.3 32 32 32h10c20.8 0 36.1 19.6 31 39.8L65 440.2c-2.4 9.6-.2 19.7 5.8 27.5S86.1 480 96 480h96c14.7 0 27.5-10 31-24.2L249 352h75.9z"
        }
    ]
};

const FasGunSquirt = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasGunSquirt",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 56c0-13.3-10.7-24-24-24S80 42.7 80 56v9.3C34.6 72.9 0 112.4 0 160c0 47.3 34.3 86.7 79.4 94.6L33 440.2c-2.4 9.6-.2 19.7 5.8 27.5S54.1 480 64 480h104c14.7 0 27.5-10 31-24.2l20-79.8h53v16c0 13.3 10.7 24 24 24s24-10.7 24-24v-80c0-13.3-10.7-24-24-24s-24 10.7-24 24v16h-41l18-72h199c41.8 0 77.4-26.7 90.5-64H552c13.3 0 24-10.7 24-24v-16c0-13.3-10.7-24-24-24h-13.5c-13.1-37.3-48.7-64-90.5-64H128v-8zm-32 72h352c17.7 0 32 14.3 32 32s-14.3 32-32 32H96c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
        }
    ]
};

const FasGun = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasGun",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M528 56c0-13.3-10.7-24-24-24s-24 10.7-24 24v8H32C14.3 64 0 78.3 0 96v112c0 17.7 14.3 32 32 32h10c20.8 0 36.1 19.6 31 39.8L33 440.2c-2.4 9.6-.2 19.7 5.8 27.5S54.1 480 64 480h96c14.7 0 27.5-10 31-24.2L217 352h104.4c23.7 0 44.8-14.9 52.7-37.2l26.8-74.8H432c8.5 0 16.6-3.4 22.6-9.4l22.7-22.6H544c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32h-16v-8zM321.4 304H229l16-64h105l-21 58.7c-1.1 3.2-4.2 5.3-7.5 5.3zM80 128h384c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FasH = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasH",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 256v192c0 17.7 14.3 32 32 32s32-14.3 32-32V64c0-17.7-14.3-32-32-32s-32 14.3-32 32v128H64V64c0-17.7-14.3-32-32-32S0 46.3 0 64v384c0 17.7 14.3 32 32 32s32-14.3 32-32V256h256z"
        }
    ]
};

const FasH1 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasH1",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 96c0-17.7-14.3-32-32-32S0 78.3 0 96v320c0 17.7 14.3 32 32 32s32-14.3 32-32V288h192v128c0 17.7 14.3 32 32 32s32-14.3 32-32V96c0-17.7-14.3-32-32-32s-32 14.3-32 32v128H64V96zm448 0c0-11.1-5.7-21.4-15.2-27.2s-21.2-6.4-31.1-1.4l-64 32c-15.8 7.9-22.2 27.1-14.3 42.9s27.1 22.2 42.9 14.3l17.7-8.8V384h-32c-17.7 0-32 14.3-32 32s14.3 32 32 32h128c17.7 0 32-14.3 32-32s-14.3-32-32-32h-32V96z"
        }
    ]
};

const FasH2 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasH2",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 96c0-17.7-14.3-32-32-32S0 78.3 0 96v320c0 17.7 14.3 32 32 32s32-14.3 32-32V288h192v128c0 17.7 14.3 32 32 32s32-14.3 32-32V96c0-17.7-14.3-32-32-32s-32 14.3-32 32v128H64V96zm385.9 47.4c11.6-9.9 26.4-15.4 41.7-15.4h4.4c35.3 0 64 28.7 64 64v5.8c0 17.9-7.5 35.1-20.8 47.2L378.4 392.4c-9.7 8.9-13 22.9-8.2 35.2S386.8 448 400 448h208c17.7 0 32-14.3 32-32s-14.3-32-32-32H482.3l100.2-91.9c26.4-24.2 41.5-58.5 41.5-94.4V192c0-70.7-57.3-128-128-128h-4.5c-30.6 0-60.1 10.9-83.3 30.8l-29 24.9c-13.4 11.5-15 31.7-3.5 45.1s31.7 15 45.1 3.5l29-24.9z"
        }
    ]
};

const FasH3 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasH3",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 96c0-17.7-14.3-32-32-32S0 78.3 0 96v320c0 17.7 14.3 32 32 32s32-14.3 32-32V288h192v128c0 17.7 14.3 32 32 32s32-14.3 32-32V96c0-17.7-14.3-32-32-32s-32 14.3-32 32v128H64V96zm336-32c-17.7 0-32 14.3-32 32s14.3 32 32 32h114.7l-89.4 89.4c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8h72c30.9 0 56 25.1 56 56s-25.1 56-56 56h-64.6c-11.7 0-21.7-8.5-23.7-20.1l-.2-1.2c-2.9-17.4-19.4-29.2-36.8-26.3s-29.2 19.4-26.3 36.8l.2 1.2c7.1 42.4 43.8 73.5 86.8 73.5H520c66.3 0 120-53.7 120-120 0-64.6-51-117.2-114.9-119.9l89.5-89.5c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8H400z"
        }
    ]
};

const FasH4 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasH4",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M479 103.8 441 256h135V96c0-17.7 14.3-32 32-32s32 14.3 32 32v320c0 17.7-14.3 32-32 32s-32-14.3-32-32v-96H400c-9.9 0-19.2-4.5-25.2-12.3s-8.2-17.9-5.8-27.5l48-192c4.3-17.1 21.7-27.6 38.8-23.3s27.6 21.7 23.3 38.8zM32 64c17.7 0 32 14.3 32 32v128h192V96c0-17.7 14.3-32 32-32s32 14.3 32 32v320c0 17.7-14.3 32-32 32s-32-14.3-32-32V288H64v128c0 17.7-14.3 32-32 32S0 433.7 0 416V96c0-17.7 14.3-32 32-32z"
        }
    ]
};

const FasH5 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasH5",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 96c0-17.7-14.3-32-32-32S0 78.3 0 96v320c0 17.7 14.3 32 32 32s32-14.3 32-32V288h192v128c0 17.7 14.3 32 32 32s32-14.3 32-32V96c0-17.7-14.3-32-32-32s-32 14.3-32 32v128H64V96zm368-32c-15.1 0-28.2 10.6-31.3 25.4l-32 152c-2 9.4.4 19.3 6.5 26.8S390.4 280 400 280h124c28.7 0 52 23.3 52 52s-23.3 52-52 52h-67.6c-10.3 0-19.5-6.6-22.8-16.4l-3.2-9.7c-5.6-16.8-23.7-25.8-40.5-20.2s-25.8 23.7-20.2 40.5l3.2 9.7c12 35.9 45.6 60.2 83.5 60.2H524c64.1 0 116-51.9 116-116s-51.9-116-116-116h-84.6L458 128h118c17.7 0 32-14.3 32-32s-14.3-32-32-32H432z"
        }
    ]
};

const FasH6 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasH6",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m537 116-35.3 44.1c76.9 3 138.3 66.3 138.3 143.9 0 79.5-64.5 144-144 144s-144-64.5-144-144c0-38.3 13-75.5 37-105.5L487 76c11-13.8 31.2-16 45-5s16 31.2 5 45zM416 304a80 80 0 1 0 160 0 80 80 0 1 0-160 0zM32 64c17.7 0 32 14.3 32 32v128h192V96c0-17.7 14.3-32 32-32s32 14.3 32 32v320c0 17.7-14.3 32-32 32s-32-14.3-32-32V288H64v128c0 17.7-14.3 32-32 32S0 433.7 0 416V96c0-17.7 14.3-32 32-32z"
        }
    ]
};

const FasHammerCrash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHammerCrash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m283.9 378.6 18.3-60.1c18-4.1 34.2-16 43.1-33.8l64-128c10.5-21.1 8.4-45.2-3.7-63.6l52.7-76.6c3.7-5.4 10.4-8 16.7-6.5s11.2 6.7 12.3 13.1l16.2 104.1 105.1-7.4c6.5-.5 12.7 3.1 15.5 9s1.8 12.9-2.6 17.8L550.1 224l71.3 77.5c4.4 4.8 5.5 11.9 2.6 17.8s-9 9.5-15.5 9l-105.1-7.4L487.3 425c-1 6.5-5.9 11.7-12.3 13.1s-13-1.1-16.7-6.5l-59.7-86.7-91.4 52.2c-5.7 3.3-12.8 2.7-17.9-1.4s-7.2-10.9-5.3-17.2zm28.3-101.7c-9.3 10.9-25.2 14.4-38.6 7.7l-65.9-32.9-85.7-42.9-104.3-52.2c-15.8-7.9-22.2-27.1-14.3-42.9l40-80C48.8 22.8 59.9 16 72 16h120c5 0 9.9 1.2 14.3 3.4l78.2 39.1 81.8 40.9c15.8 7.9 22.2 27.1 14.3 42.9l-64 128c-1.2 2.4-2.7 4.6-4.4 6.6zm-204.6-39.5 85.9 42.9L90.9 485.5C79 509.2 50.2 518.8 26.5 507s-33.3-40.8-21.4-64.5l102.5-205.1z"
        }
    ]
};

const FasHammerWar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHammerWar",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 0c17.7 0 32 14.3 32 32v18.8l123.3-18.4c9.2-1.4 18.6 1.3 25.6 7.4S384 54.7 384 64v192c0 9.3-4.1 18.2-11.1 24.2s-16.4 8.8-25.6 7.4l-150.6-22.5c-3.1-.5-6.3-.5-9.5 0L36.7 287.6c-9.2 1.4-18.6-1.3-25.6-7.4S0 265.3 0 256V64c0-9.3 4.1-18.2 11.1-24.2s16.4-8.8 25.6-7.4L160 50.8V32c0-17.7 14.3-32 32-32zm0 296.7 32 4.8V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V301.5l32-4.8z"
        }
    ]
};

const FasHammer = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHammer",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M413.5 237.5c-28.2 4.8-58.2-3.6-80-25.4L295.4 174c-15-15-23.4-35.2-23.4-56.4v-12.1L192.3 62c-5.3-2.9-8.6-8.6-8.3-14.7s3.9-11.5 9.5-14l47.2-21C259.1 4.2 279 0 299.2 0h18.1c36.7 0 72 14 98.7 39.1l44.6 42c24.2 22.8 33.2 55.7 26.6 86L503 183l8-8c9.4-9.4 24.6-9.4 33.9 0l24 24c9.4 9.4 9.4 24.6 0 33.9l-88 88c-9.4 9.4-24.6 9.4-33.9 0l-24-24c-9.4-9.4-9.4-24.6 0-33.9l8-8-17.5-17.5zM27.4 377.1l233.5-194.5c3.5 4.9 7.5 9.6 11.8 14l38.1 38.1c6 6 12.4 11.2 19.2 15.7L134.9 484.6C120.4 502 98.9 512 76.3 512 34.1 512 0 477.8 0 435.7c0-22.6 10.1-44.1 27.4-58.6z"
        }
    ]
};

const FasHamsa = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHamsa",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M34.6 288H80c8.8 0 16-7.2 16-16V72c0-22.1 17.9-40 40-40s40 17.9 40 40v132c0 11 9 20 20 20s20-9 20-20V40c0-22.1 17.9-40 40-40s40 17.9 40 40v164c0 11 9 20 20 20s20-9 20-20V72c0-22.1 17.9-40 40-40s40 17.9 40 40v200c0 8.8 7.2 16 16 16h45.4c19.1 0 34.6 15.5 34.6 34.6 0 8.6-3.2 16.9-9 23.3L416.6 441c-41.1 45.2-99.4 71-160.6 71s-119.4-25.8-160.6-71L9 345.9c-5.8-6.4-9-14.7-9-23.3C0 303.5 15.5 288 34.6 288zm221.4 0c-38.4 0-76.8 35.8-90.6 50.2-3.6 3.7-5.4 8.7-5.4 13.8s1.8 10.1 5.4 13.8c13.8 14.4 52.2 50.2 90.6 50.2s76.8-35.8 90.6-50.2c3.6-3.7 5.4-8.7 5.4-13.8s-1.8-10.1-5.4-13.8C332.8 323.8 294.4 288 256 288zm0 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FasHandBackFist = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHandBackFist",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 0c-26.5 0-48 21.5-48 48v128c0 8.8-7.2 16-16 16s-16-7.2-16-16v-26.7l-9 7.5C40.4 169 32 187 32 206v38c0 38 16.9 74 46.1 98.3L128 384v96c0 17.7 14.3 32 32 32h160c17.7 0 32-14.3 32-32V374.7c46.9-19 80-65 80-118.7V144c0-26.5-21.5-48-48-48-12.4 0-23.6 4.7-32.1 12.3C350 83.5 329.3 64 304 64c-12.4 0-23.6 4.7-32.1 12.3C270 51.5 249.3 32 224 32c-12.4 0-23.6 4.7-32.1 12.3C190 19.5 169.3 0 144 0z"
        }
    ]
};

const FasHandBackPointDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHandBackPointDown",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M136 512c-22.1 0-40-17.9-40-40V192c0-8.8-7.2-16-16-16s-16 7.2-16 16v55.7c-2-1.4-3.9-3-5.8-4.5l-19.2-16C24.4 215 16 197 16 178v-38c0-38 16.9-74 46.1-98.3l5.4-4.5C96.3 13.1 132.5 0 169.9 0H288c70.7 0 128 57.3 128 128v96c0 26.5-21.5 48-48 48-12.4 0-23.6-4.7-32.1-12.3C334 284.5 313.3 304 288 304c-12.4 0-23.6-4.7-32.1-12.3C254 316.5 233.3 336 208 336c-12.3 0-23.5-4.6-32-12.2V472c0 22.1-17.9 40-40 40z"
        }
    ]
};

const FasHandBackPointLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHandBackPointLeft",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 168c0-22.1 17.9-40 40-40h280c8.8 0 16-7.2 16-16s-7.2-16-16-16h-55.7c1.4-2 3-3.9 4.5-5.8l16-19.2C297 56.4 315 48 334 48h38c38 0 74 16.9 98.3 46.1l4.5 5.4c24 28.8 37.1 65 37.1 102.4L512 320c0 70.7-57.3 128-128 128h-96c-26.5 0-48-21.5-48-48 0-12.4 4.7-23.6 12.3-32.1C227.5 366 208 345.3 208 320c0-12.4 4.7-23.6 12.3-32.1C195.5 286 176 265.3 176 240c0-12.3 4.6-23.5 12.2-32H40c-22.1 0-40-17.9-40-40z"
        }
    ]
};

const FasHandBackPointRibbon = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHandBackPointRibbon",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M112 128H43.8c-6.5 0-11.8-5.3-11.8-11.8 0-3.9 1.9-7.5 5.1-9.7L75.6 80 37.1 53.5c-3.2-2.2-5.1-5.8-5.1-9.7C32 37.3 37.3 32 43.8 32h69c3.7-18.3 19.8-32 39.2-32 22.1 0 40 17.9 40 40v88h-80zm0 112v-80h80v28.2c8.5-7.6 19.7-12.2 32-12.2 25.3 0 46 19.5 47.9 44.3 8.5-7.7 19.8-12.3 32.1-12.3 25.3 0 46 19.5 47.9 44.3 8.5-7.7 19.8-12.3 32.1-12.3 26.5 0 48 21.5 48 48v96c0 70.7-57.3 128-128 128H185.9c-37.4 0-73.7-13.1-102.4-37.1l-5.4-4.5C48.9 446.1 32 410 32 372v-38c0-19 8.4-37 23-49.2l19.2-16c1.9-1.6 3.8-3.1 5.8-4.5V320c0 8.8 7.2 16 16 16s16-7.2 16-16v-80z"
        }
    ]
};

const FasHandBackPointRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHandBackPointRight",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 168c0-22.1-17.9-40-40-40H192c-8.8 0-16-7.2-16-16s7.2-16 16-16h55.7c-1.4-2-3-3.9-4.5-5.8l-16-19.2C215 56.4 197 48 178 48h-38c-38 0-74 16.9-98.3 46.1l-4.5 5.4C13.1 128.3 0 164.5 0 201.9V320c0 70.7 57.3 128 128 128h96c26.5 0 48-21.5 48-48 0-12.4-4.7-23.6-12.3-32.1C284.5 366 304 345.3 304 320c0-12.4-4.7-23.6-12.3-32.1C316.5 286 336 265.3 336 240c0-12.3-4.6-23.5-12.2-32H472c22.1 0 40-17.9 40-40z"
        }
    ]
};

const FasHandBackPointUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHandBackPointUp",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M136 0c-22.1 0-40 17.9-40 40v280c0 8.8-7.2 16-16 16s-16-7.2-16-16v-55.7c-2 1.4-3.9 3-5.8 4.5l-19.2 16C24.4 297 16 315 16 334v38c0 38 16.9 74 46.1 98.3l5.4 4.5c28.8 24 65 37.1 102.4 37.1H288c70.7 0 128-57.3 128-128V288c0-26.5-21.5-48-48-48-12.4 0-23.6 4.7-32.1 12.3C334 227.5 313.3 208 288 208c-12.4 0-23.6 4.7-32.1 12.3C254 195.5 233.3 176 208 176c-12.3 0-23.5 4.6-32 12.2V40c0-22.1-17.9-40-40-40z"
        }
    ]
};

const FasHandDots = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHandDots",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32v208c0 8.8-7.2 16-16 16s-16-7.2-16-16V64c0-17.7-14.3-32-32-32s-32 14.3-32 32v272c0 1.5 0 3.1.1 4.6L67.6 283c-16-15.2-41.3-14.6-56.6 1.4s-14.6 41.3 1.4 56.6l112.4 107c43.1 41.1 100.4 64 160 64H304c97.2 0 176-78.8 176-176V128c0-17.7-14.3-32-32-32s-32 14.3-32 32v112c0 8.8-7.2 16-16 16s-16-7.2-16-16V64c0-17.7-14.3-32-32-32s-32 14.3-32 32v176c0 8.8-7.2 16-16 16s-16-7.2-16-16V32zm-48 304a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm80 16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48-16a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm-16 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-112 16a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm-48-48a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
        }
    ]
};

const FasHandFingersCrossed = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHandFingersCrossed",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m93 18.5 17.3 37.2L75 131.3 35 45.5c-7.5-16-.5-35.1 15.5-42.5S85.6 2.5 93 18.5zM150.6 272h1.4c22.1 0 40 17.9 40 40s-17.9 40-40 40H96c-8.8 0-16 7.2-16 16s7.2 16 16 16h56c39.8 0 72-32.2 72-72v-.6c9.4 5.4 20.3 8.6 32 8.6 13.2 0 25.4-4 35.6-10.8 8.7 24.9 32.5 42.8 60.4 42.8 11.7 0 22.6-3.1 32-8.6v8.6c0 88.4-71.6 160-160 160h-61.7c-42.4 0-83.1-16.9-113.1-46.9l-11.7-11.6C13.5 429.5 0 396.9 0 363v-27c0-35.3 28.7-64 64-64h86.6zm41.4-19.9c-8-5.4-17.2-9.2-27-11l16-34.1 11 23.7v21.5zM130.2 240H59.6L163 18.5c7.5-16 26.5-22.9 42.5-15.5s22.9 26.5 15.5 42.5L130.2 240zm93.8-48c0-17.7 14.3-32 32-32s32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32v-64zm96 32c0-17.7 14.3-32 32-32s32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32v-64z"
        }
    ]
};

const FasHandFist = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHandFist",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 0c17.7 0 32 14.3 32 32v112h-64V32c0-17.7 14.3-32 32-32zM64 64c0-17.7 14.3-32 32-32s32 14.3 32 32v80H64V64zm192 0c0-17.7 14.3-32 32-32s32 14.3 32 32v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V64zm96 64c0-17.7 14.3-32 32-32s32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32v-64zm-96 88v-.6c9.4 5.4 20.3 8.6 32 8.6 13.2 0 25.4-4 35.6-10.8 8.7 24.9 32.5 42.8 60.4 42.8 11.7 0 22.6-3.1 32-8.6v8.6c0 52.3-25.1 98.8-64 128v96c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32v-78.4c-17.3-7.9-33.2-18.8-46.9-32.5l-11.6-11.6c-24-24-37.5-56.6-37.5-90.5v-27c0-35.3 28.7-64 64-64h88c22.1 0 40 17.9 40 40s-17.9 40-40 40h-56c-8.8 0-16 7.2-16 16s7.2 16 16 16h56c39.8 0 72-32.2 72-72z"
        }
    ]
};

const FasHandHeart = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHandHeart",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 0c17.7 0 32 14.3 32 32v208c0 8.8 7.2 16 16 16s16-7.2 16-16V64c0-17.7 14.3-32 32-32s32 14.3 32 32v176c0 8.8 7.2 16 16 16s16-7.2 16-16V128c0-17.7 14.3-32 32-32s32 14.3 32 32v208c0 97.2-78.8 176-176 176h-19.2c-59.6 0-116.9-22.9-160-64L12.4 341c-16-15.2-16.6-40.6-1.4-56.6s40.6-16.6 56.6-1.4l60.5 57.6c0-1.5-.1-3.1-.1-4.6V64c0-17.7 14.3-32 32-32s32 14.3 32 32v176c0 8.8 7.2 16 16 16s16-7.2 16-16V32c0-17.7 14.3-32 32-32zm-48 362.6c0 12.1 5.1 23.6 14.1 31.6l55.2 49.7c6.1 5.5 15.3 5.5 21.4 0l55.2-49.7c9-8.1 14.1-19.6 14.1-31.6 0-23.5-19.1-42.6-42.6-42.6h-1.1c-14.6 0-28.3 7.3-36.4 19.5-8.1-12.2-21.7-19.5-36.4-19.5h-1.1c-23.5 0-42.6 19.1-42.6 42.6z"
        }
    ]
};

const FasHandHoldingBox = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHandHoldingBox",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 121.7c0 3.5 2.8 6.3 6.3 6.3 1.1 0 2.2-.3 3.1-.8l46.6-26.6c4.9-2.8 11-2.8 15.9 0l46.6 26.6c1 .5 2 .8 3.1.8 3.5 0 6.3-2.8 6.3-6.3V0h80c26.5 0 48 21.5 48 48v160c0 26.5-21.5 48-48 48H144c-26.5 0-48-21.5-48-48V48c0-26.5 21.5-48 48-48h80v121.7zm344.2 214.6c13.1 17.8 9.3 42.8-8.5 55.9l-126.6 93.3c-23.4 17.2-51.6 26.5-80.7 26.5H32c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32h36.8l44.9-36c22.7-18.2 50.9-28 80-28H352c17.7 0 32 14.3 32 32s-14.3 32-32 32h-80c-8.8 0-16 7.2-16 16s7.2 16 16 16h120.6l119.7-88.2c17.8-13.1 42.8-9.3 55.9 8.5zM193.6 384h-.9.9z"
        }
    ]
};

const FasHandHoldingDollar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHandHoldingDollar",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M312 24v10.5c6.4 1.2 12.6 2.7 18.2 4.2 12.8 3.4 20.4 16.6 17 29.4s-16.6 20.4-29.4 17c-10.9-2.9-21.1-4.9-30.2-5-7.3-.1-14.7 1.7-19.4 4.4-2.1 1.3-3.1 2.4-3.5 3-.3.5-.7 1.2-.7 2.8v.6c.2.2.9 1.2 3.3 2.6 5.8 3.5 14.4 6.2 27.4 10.1l.9.3c11.1 3.3 25.9 7.8 37.9 15.3 13.7 8.6 26.1 22.9 26.4 44.9.3 22.5-11.4 38.9-26.7 48.5-6.7 4.1-13.9 7-21.3 8.8V232c0 13.3-10.7 24-24 24s-24-10.7-24-24v-11.4c-9.5-2.3-18.2-5.3-25.6-7.8-2.1-.7-4.1-1.4-6-2-12.6-4.2-19.4-17.8-15.2-30.4s17.8-19.4 30.4-15.2c2.6.9 5 1.7 7.3 2.5 13.6 4.6 23.4 7.9 33.9 8.3 8 .3 15.1-1.6 19.2-4.1 1.9-1.2 2.8-2.2 3.2-2.9.4-.6.9-1.8.8-4.1v-.2c0-1 0-2.1-4-4.6-5.7-3.6-14.3-6.4-27.1-10.3l-1.9-.6c-10.8-3.2-25-7.5-36.4-14.4-13.5-8.1-26.5-22-26.6-44.1-.1-22.9 12.9-38.6 27.7-47.4 6.4-3.8 13.3-6.4 20.2-8.2V24c0-13.3 10.7-24 24-24s24 10.7 24 24zm256.2 312.3c13.1 17.8 9.3 42.8-8.5 55.9l-126.6 93.3c-23.4 17.2-51.6 26.5-80.7 26.5H32c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32h36.8l44.9-36c22.7-18.2 50.9-28 80-28H352c17.7 0 32 14.3 32 32s-14.3 32-32 32h-80c-8.8 0-16 7.2-16 16s7.2 16 16 16h120.6l119.7-88.2c17.8-13.1 42.8-9.3 55.9 8.5zM193.6 384h-.9.9z"
        }
    ]
};

const FasHandHoldingDroplet = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHandHoldingDroplet",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M275.5 6.6C278.3 2.5 283 0 288 0s9.7 2.5 12.5 6.6l66.3 96.4c11.2 16.3 17.2 35.6 17.2 55.3v1.7c0 53-43 96-96 96s-96-43-96-96v-1.7c0-19.8 6-39 17.2-55.3l66.3-96.4zm292.7 329.7c13.1 17.8 9.3 42.8-8.5 55.9l-126.6 93.3c-23.4 17.2-51.6 26.5-80.7 26.5H32c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32h36.8l44.9-36c22.7-18.2 50.9-28 80-28H352c17.7 0 32 14.3 32 32s-14.3 32-32 32h-80c-8.8 0-16 7.2-16 16s7.2 16 16 16h120.6l119.7-88.2c17.8-13.1 42.8-9.3 55.9 8.5zM193.6 384h-.9.9z"
        }
    ]
};

const FasHandHoldingHand = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHandHoldingHand",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M7.8 207.7c-13.1-17.8-9.3-42.8 8.5-55.9l126.6-93.3C166.2 41.3 194.5 32 223.5 32H544c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32h-36.8l-44.9 36c-22.7 18.2-50.9 28-80 28H224c-17.7 0-32-14.3-32-32s14.3-32 32-32h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H183.4L63.7 216.2c-17.8 13.1-42.8 9.3-55.9-8.5zM382.4 160h.9-.9zm185.8 144.3c13.1 17.8 9.3 42.8-8.5 55.9l-126.6 93.3c-23.4 17.2-51.6 26.5-80.7 26.5H32c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32h36.8l44.9-36c22.7-18.2 50.9-28 80-28H352c17.7 0 32 14.3 32 32s-14.3 32-32 32h-80c-8.8 0-16 7.2-16 16s7.2 16 16 16h120.6l119.7-88.2c17.8-13.1 42.8-9.3 55.9 8.5zM193.6 352h-.9.9z"
        }
    ]
};

const FasHandHoldingHeart = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHandHoldingHeart",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M163.9 136.9c-29.4-29.8-29.4-78.2 0-108s77-29.8 106.4 0l17.7 18 17.7-18c29.4-29.8 77-29.8 106.4 0s29.4 78.2 0 108L310.5 240.1c-6.2 6.3-14.3 9.4-22.5 9.4s-16.3-3.1-22.5-9.4L163.9 136.9zm404.3 199.4c13.1 17.8 9.3 42.8-8.5 55.9l-126.6 93.3c-23.4 17.2-51.6 26.5-80.7 26.5H32c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32h36.8l44.9-36c22.7-18.2 50.9-28 80-28H352c17.7 0 32 14.3 32 32s-14.3 32-32 32h-80c-8.8 0-16 7.2-16 16s7.2 16 16 16h120.6l119.7-88.2c17.8-13.1 42.8-9.3 55.9 8.5zM193.6 384h-.9.9z"
        }
    ]
};

const FasHandHoldingMagic = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHandHoldingMagic",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 80c0 8.8 7.2 16 16 16h80c17.7 0 32 14.3 32 32s-14.3 32-32 32h-80c-44.2 0-80-35.8-80-80s35.8-80 80-80h112c70.7 0 128 57.3 128 128s-57.3 128-128 128h-32c0 17.7-14.3 32-32 32s-32-14.3-32-32v-32c0-17.7 14.3-32 32-32h64c35.3 0 64-28.7 64-64s-28.7-64-64-64H208c-8.8 0-16 7.2-16 16zm376.2 256.3c13.1 17.8 9.3 42.8-8.5 55.9l-126.6 93.3c-23.4 17.2-51.6 26.5-80.7 26.5H32c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32h36.8l44.9-36c22.7-18.2 50.9-28 80-28H352c17.7 0 32 14.3 32 32s-14.3 32-32 32h-80c-8.8 0-16 7.2-16 16s7.2 16 16 16h120.6l119.7-88.2c17.8-13.1 42.8-9.3 55.9 8.5zM193.6 384h-.9.9z"
        }
    ]
};

const FasHandHoldingMedical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHandHoldingMedical",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 24v56h-56c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h56v56c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24v-56h56c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24h-56V24c0-13.3-10.7-24-24-24h-48c-13.3 0-24 10.7-24 24zm335.7 368.2c17.8-13.1 21.6-38.1 8.5-55.9s-38.1-21.6-55.9-8.5L392.6 416H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h80c17.7 0 32-14.3 32-32s-14.3-32-32-32H193.7c-29.1 0-57.3 9.9-80 28l-44.9 36H32c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h320.5c29 0 57.3-9.3 80.7-26.5l126.6-93.3zm-367-8.2h.9-.9z"
        }
    ]
};

const FasHandHoldingSeedling = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHandHoldingSeedling",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 14.5c0-8 6.5-14.5 14.5-14.5H160c88.4 0 160 71.6 160 160v96c0 17.7-14.3 32-32 32s-32-14.3-32-32v-96h-14.5C161.1 160 96 94.9 96 14.5zm384 0C480 89 424.1 150.3 352 159c-.2-44.9-15.9-86.2-42-118.8C338.2 15.2 375.3 0 416 0h49.5c8 0 14.5 6.5 14.5 14.5zm88.2 321.7c13.1 17.8 9.3 42.8-8.5 55.9l-126.6 93.4c-23.4 17.2-51.6 26.5-80.7 26.5H32c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32h36.8l44.9-36c22.7-18.2 50.9-28 80-28H352c17.7 0 32 14.3 32 32s-14.3 32-32 32h-80c-8.8 0-16 7.2-16 16s7.2 16 16 16h120.6l119.7-88.2c17.8-13.1 42.8-9.3 55.9 8.5zM193.6 384h-.9.9z"
        }
    ]
};

const FasHandHoldingSkull = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHandHoldingSkull",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M371.6 232.2c-6 3.8-9.4 10.8-8 17.7l4.1 20.6c.2.9.3 1.9.3 2.9 0 8-6.5 14.6-14.6 14.6H222.6c-8 0-14.6-6.5-14.6-14.6 0-1 .1-1.9.3-2.9l4.1-20.6c1.4-7-2-13.9-8-17.7C167.8 209 144 171 144 128 144 57.3 208.5 0 288 0s144 57.3 144 128c0 43-23.8 81-60.4 104.2zM240 176a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128-32a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm200.2 192.3c13.1 17.8 9.3 42.8-8.5 55.9l-126.6 93.3c-23.4 17.2-51.6 26.5-80.7 26.5H32c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32h36.8l44.9-36c22.7-18.2 50.9-28 80-28H352c17.7 0 32 14.3 32 32s-14.3 32-32 32h-80c-8.8 0-16 7.2-16 16s7.2 16 16 16h120.6l119.7-88.2c17.8-13.1 42.8-9.3 55.9 8.5zM193.6 384h-.9.9z"
        }
    ]
};

const FasHandHolding = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHandHolding",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M559.7 392.2c17.8-13.1 21.6-38.1 8.5-55.9s-38.1-21.6-55.9-8.5L392.6 416H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h80c17.7 0 32-14.3 32-32s-14.3-32-32-32H193.7c-29.1 0-57.3 9.9-80 28l-44.9 36H32c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h320.5c29 0 57.3-9.3 80.7-26.5l126.6-93.3zm-366.1-8.3a.5.5 0 1 1-.9.1.5.5 0 1 1 .9-.1z"
        }
    ]
};

const FasHandHorns = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHandHorns",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 32C32 14.3 46.3 0 64 0s32 14.3 32 32v208H32V32zm192 160c0-17.7 14.3-32 32-32s32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32v-64zm-64-64c17.7 0 32 14.3 32 32v48c0 17.7-14.3 32-32 32s-32-14.3-32-32v-48c0-17.7 14.3-32 32-32zm160-32c0-17.7 14.3-32 32-32s32 14.3 32 32v256c0 88.4-71.6 160-160 160h-61.7c-42.4 0-83.1-16.9-113.1-46.9l-11.7-11.6C13.5 429.5 0 396.9 0 363v-27c0-35.3 28.7-64 64-64h88c22.1 0 40 17.9 40 40s-17.9 40-40 40H96c-8.8 0-16 7.2-16 16s7.2 16 16 16h56c39.8 0 72-32.2 72-72v-.6c9.4 5.4 20.3 8.6 32 8.6 35.3 0 64-28.7 64-64V96z"
        }
    ]
};

const FasHandLizard = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHandLizard",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 112c0-26.5 21.5-48 48-48h238.5c36.8 0 71.2 18 92.1 48.2l113.5 164c13 18.7 19.9 41 19.9 63.8v76c0 17.7-14.3 32-32 32h-96c-17.7 0-32-14.3-32-32v-13.8L273.9 352H112c-26.5 0-48-21.5-48-48s21.5-48 48-48h128c26.5 0 48-21.5 48-48s-21.5-48-48-48H48c-26.5 0-48-21.5-48-48z"
        }
    ]
};

const FasHandLove = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHandLove",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 0c17.7 0 32 14.3 32 32v256c0 35.3 28.7 64 64 64 19.1 0 36.3-8.4 48-21.7 11.7 13.3 28.9 21.7 48 21.7 35.3 0 64-28.7 64-64V96c0-17.7 14.3-32 32-32s32 14.3 32 32v240c0 97.2-78.8 176-176 176h-19.2c-59.6 0-116.9-22.9-160-64L12.4 341c-16-15.2-16.6-40.6-1.4-56.6s40.6-16.6 56.6-1.4l60.5 57.6c0-1.5-.1-3.1-.1-4.6V32c0-17.7 14.3-32 32-32zm64 192c0-17.7 14.3-32 32-32s32 14.3 32 32v96c0 17.7-14.3 32-32 32s-32-14.3-32-32v-96zm128 0c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32v-64c0-17.7 14.3-32 32-32z"
        }
    ]
};

const FasHandMiddleFinger = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHandMiddleFinger",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M232 0c-22.1 0-40 17.9-40 40v164.2c-8.5-7.6-19.7-12.2-32-12.2-26.5 0-48 21.5-48 48v80c0 8.8-7.2 16-16 16s-16-7.2-16-16v-55.7c-2 1.4-3.9 3-5.8 4.5l-19.2 16C40.4 297 32 315 32 334v38c0 38 16.9 74 46.1 98.3l5.4 4.5c28.8 24 65 37.1 102.4 37.1H304c70.7 0 128-57.3 128-128V288c0-26.5-21.5-48-48-48-12.4 0-23.6 4.7-32.1 12.3C350 227.5 329.3 208 304 208c-12.3 0-23.5 4.6-32 12.2V40c0-22.1-17.9-40-40-40z"
        }
    ]
};

const FasHandPeace = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHandPeace",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 0c17.7 0 32 14.3 32 32v208h-64V32c0-17.7 14.3-32 32-32zm96 160c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32v-64c0-17.7 14.3-32 32-32zm64 64c0-17.7 14.3-32 32-32s32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32v-64zM93.3 51.2 175.9 240h-69.8L34.7 76.8c-7.1-16.2.3-35 16.5-42.1s35.1.3 42.1 16.5zm27 221.3-.2-.5H216c22.1 0 40 17.9 40 40s-17.9 40-40 40h-56c-8.8 0-16 7.2-16 16s7.2 16 16 16h56c39.8 0 72-32.2 72-72v-.6c9.4 5.4 20.3 8.6 32 8.6 13.2 0 25.4-4 35.6-10.8 8.7 24.9 32.5 42.8 60.4 42.8 11.7 0 22.6-3.1 32-8.6v8.6c0 88.4-71.6 160-160 160h-61.7c-42.4 0-83.1-16.9-113.1-46.9l-11.6-11.6C77.5 429.5 64 396.9 64 363v-27c0-32.7 24.6-59.7 56.3-63.5z"
        }
    ]
};

const FasHandPointDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHandPointDown",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 480c0 17.7 14.3 32 32 32s32-14.3 32-32V272H32v208zm192-160c0 17.7 14.3 32 32 32s32-14.3 32-32v-64c0-17.7-14.3-32-32-32s-32 14.3-32 32v64zm-64 64c17.7 0 32-14.3 32-32v-48c0-17.7-14.3-32-32-32s-32 14.3-32 32v48c0 17.7 14.3 32 32 32zm160-96c0 17.7 14.3 32 32 32s32-14.3 32-32v-64c0-17.7-14.3-32-32-32s-32 14.3-32 32v64zm-96-88v.6c9.4-5.4 20.3-8.6 32-8.6 13.2 0 25.4 4 35.6 10.8 8.7-24.9 32.5-42.8 60.4-42.8 11.7 0 22.6 3.1 32 8.6V160C384 71.6 312.4 0 224 0h-61.7C119.8 0 79.1 16.9 49.1 46.9L37.5 58.5C13.5 82.5 0 115.1 0 149v27c0 35.3 28.7 64 64 64h88c22.1 0 40-17.9 40-40s-17.9-40-40-40H96c-8.8 0-16-7.2-16-16s7.2-16 16-16h56c39.8 0 72 32.2 72 72z"
        }
    ]
};

const FasHandPointLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHandPointLeft",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 96c-17.7 0-32 14.3-32 32s14.3 32 32 32h208V96H32zm160 192c-17.7 0-32 14.3-32 32s14.3 32 32 32h64c17.7 0 32-14.3 32-32s-14.3-32-32-32h-64zm-64-64c0 17.7 14.3 32 32 32h48c17.7 0 32-14.3 32-32s-14.3-32-32-32h-48c-17.7 0-32 14.3-32 32zm96 160c-17.7 0-32 14.3-32 32s14.3 32 32 32h64c17.7 0 32-14.3 32-32s-14.3-32-32-32h-64zm88-96h-.6c5.4 9.4 8.6 20.3 8.6 32 0 13.2-4 25.4-10.8 35.6 24.9 8.7 42.8 32.5 42.8 60.4 0 11.7-3.1 22.6-8.6 32h8.6c88.4 0 160-71.6 160-160v-61.7c0-42.4-16.9-83.1-46.9-113.1l-11.6-11.6C429.5 77.5 396.9 64 363 64h-27c-35.3 0-64 28.7-64 64v88c0 22.1 17.9 40 40 40s40-17.9 40-40v-56c0-8.8 7.2-16 16-16s16 7.2 16 16v56c0 39.8-32.2 72-72 72z"
        }
    ]
};

const FasHandPointRibbon = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHandPointRibbon",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C64 14.3 78.3 0 96 0s32 14.3 32 32h16c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H11.8C5.3 128 0 122.7 0 116.2c0-3.9 1.9-7.5 5.1-9.7L43.6 80 5.1 53.5C1.9 51.3 0 47.7 0 43.8 0 37.3 5.3 32 11.8 32H64zm0 208v-80h64v80H64zm192-48c0-17.7 14.3-32 32-32s32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32v-64zm-64-64c17.7 0 32 14.3 32 32v48c0 17.7-14.3 32-32 32s-32-14.3-32-32v-48c0-17.7 14.3-32 32-32zm160 96c0-17.7 14.3-32 32-32s32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32v-64zm-96 88v-.6c9.4 5.4 20.3 8.6 32 8.6 13.2 0 25.4-4 35.6-10.8 8.7 24.9 32.5 42.8 60.4 42.8 11.7 0 22.6-3.1 32-8.6v8.6c0 88.4-71.6 160-160 160h-61.7c-42.4 0-83.1-16.9-113.1-46.9l-11.7-11.6c-24-24-37.5-56.6-37.5-90.5v-27c0-35.3 28.7-64 64-64h88c22.1 0 40 17.9 40 40s-17.9 40-40 40h-56c-8.8 0-16 7.2-16 16s7.2 16 16 16h56c39.8 0 72-32.2 72-72z"
        }
    ]
};

const FasHandPointRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHandPointRight",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 96c17.7 0 32 14.3 32 32s-14.3 32-32 32H272V96h208zM320 288c17.7 0 32 14.3 32 32s-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32s14.3-32 32-32h64zm64-64c0 17.7-14.3 32-32 32h-48c-17.7 0-32-14.3-32-32s14.3-32 32-32h48c17.7 0 32 14.3 32 32zm-96 160c17.7 0 32 14.3 32 32s-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32s14.3-32 32-32h64zm-88-96h.6c-5.4 9.4-8.6 20.3-8.6 32 0 13.2 4 25.4 10.8 35.6-24.9 8.7-42.8 32.5-42.8 60.4 0 11.7 3.1 22.6 8.6 32H160C71.6 448 0 376.4 0 288v-61.7c0-42.4 16.9-83.1 46.9-113.1l11.6-11.6C82.5 77.5 115.1 64 149 64h27c35.3 0 64 28.7 64 64v88c0 22.1-17.9 40-40 40s-40-17.9-40-40v-56c0-8.8-7.2-16-16-16s-16 7.2-16 16v56c0 39.8 32.2 72 72 72z"
        }
    ]
};

const FasHandPointUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHandPointUp",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 32C32 14.3 46.3 0 64 0s32 14.3 32 32v208H32V32zm192 160c0-17.7 14.3-32 32-32s32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32v-64zm-64-64c17.7 0 32 14.3 32 32v48c0 17.7-14.3 32-32 32s-32-14.3-32-32v-48c0-17.7 14.3-32 32-32zm160 96c0-17.7 14.3-32 32-32s32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32v-64zm-96 88v-.6c9.4 5.4 20.3 8.6 32 8.6 13.2 0 25.4-4 35.6-10.8 8.7 24.9 32.5 42.8 60.4 42.8 11.7 0 22.6-3.1 32-8.6v8.6c0 88.4-71.6 160-160 160h-61.7c-42.4 0-83.1-16.9-113.1-46.9l-11.7-11.6C13.5 429.5 0 396.9 0 363v-27c0-35.3 28.7-64 64-64h88c22.1 0 40 17.9 40 40s-17.9 40-40 40H96c-8.8 0-16 7.2-16 16s7.2 16 16 16h56c39.8 0 72-32.2 72-72z"
        }
    ]
};

const FasHandPointer = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHandPointer",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 40c0-22.1 17.9-40 40-40s40 17.9 40 40v148.2c8.5-7.6 19.7-12.2 32-12.2 20.6 0 38.2 13 45 31.2 8.8-9.3 21.2-15.2 35-15.2 25.3 0 46 19.5 47.9 44.3 8.5-7.7 19.8-12.3 32.1-12.3 26.5 0 48 21.5 48 48v112c0 70.7-57.3 128-128 128h-85.3c-5 0-9.9-.3-14.7-1-55.3-5.6-106.2-34-140-79L8 336c-13.3-17.7-9.7-42.7 8-56s42.7-9.7 56 8l56 74.7V40zm112 264c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16v-96zm48-16c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16v-96c0-8.8-7.2-16-16-16zm80 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16v-96z"
        }
    ]
};

const FasHandScissors = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHandScissors",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M40 208c-22.1 0-40 17.9-40 40s17.9 40 40 40h180.2c-7.6 8.5-12.2 19.7-12.2 32 0 25.3 19.5 46 44.3 47.9-7.7 8.5-12.3 19.8-12.3 32.1 0 26.5 21.5 48 48 48h96c70.7 0 128-57.3 128-128V206.9c0-40.2-16-78.8-44.4-107.3C444.8 76.8 413.9 64 381.7 64H336c-21.3 0-39.3 13.9-45.6 33.1l74.5 23.7c8.4 2.7 13.1 11.7 10.4 20.1s-11.7 13.1-20.1 10.4L288 129.9v.1L84 65.8C62.9 59.2 40.5 70.9 33.8 92s5.1 43.5 26.2 50.2L269.5 208H40z"
        }
    ]
};

const FasHandSparkles = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHandSparkles",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 0c17.7 0 32 14.3 32 32v208c0 8.8 7.2 16 16 16s16-7.2 16-16V64c0-17.7 14.3-32 32-32s32 14.3 32 32v176c0 8.8 7.2 16 16 16s16-7.2 16-16V128c0-17.7 14.3-32 32-32s32 14.3 32 32v195.1c-11.9 4.8-21.3 14.9-25 27.8l-8.9 31.2-31.2 8.9c-18.3 5.3-30.9 22-30.9 41 0 18.9 12.5 35.6 30.6 40.9C448.4 497.4 409.9 512 368 512h-19.2c-59.6 0-116.9-22.9-160-64L76.4 341c-16-15.2-16.6-40.6-1.4-56.6s40.6-16.6 56.6-1.4l60.5 57.6c0-1.5-.1-3.1-.1-4.6V64c0-17.7 14.3-32 32-32s32 14.3 32 32v176c0 8.8 7.2 16 16 16s16-7.2 16-16V32c0-17.7 14.3-32 32-32zm-7.3 326.6c-1.1-3.9-4.7-6.6-8.7-6.6s-7.6 2.7-8.7 6.6L288 352l-25.4 7.3c-3.9 1.1-6.6 4.7-6.6 8.7s2.7 7.6 6.6 8.7L288 384l7.3 25.4c1.1 3.9 4.7 6.6 8.7 6.6s7.6-2.7 8.7-6.6L320 384l25.4-7.3c3.9-1.1 6.6-4.7 6.6-8.7s-2.7-7.6-6.6-8.7L320 352l-7.3-25.4zM104 120l48.3 13.8c4.6 1.3 7.7 5.5 7.7 10.2s-3.1 8.9-7.7 10.2L104 168l-13.8 48.3c-1.3 4.6-5.5 7.7-10.2 7.7s-8.9-3.1-10.2-7.7L56 168 7.7 154.2C3.1 152.9 0 148.7 0 144s3.1-8.9 7.7-10.2L56 120l13.8-48.3C71.1 67.1 75.3 64 80 64s8.9 3.1 10.2 7.7L104 120zm480 288 48.3 13.8c4.6 1.3 7.7 5.5 7.7 10.2s-3.1 8.9-7.7 10.2L584 456l-13.8 48.3c-1.3 4.6-5.5 7.7-10.2 7.7s-8.9-3.1-10.2-7.7L536 456l-48.3-13.8c-4.6-1.3-7.7-5.5-7.7-10.2s3.1-8.9 7.7-10.2L536 408l13.8-48.3c1.3-4.6 5.5-7.7 10.2-7.7s8.9 3.1 10.2 7.7L584 408z"
        }
    ]
};

const FasHandSpock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHandSpock",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M246.9 23.7c-4.6-17.1-22.1-27.2-39.2-22.6s-27.2 22.1-22.6 39.2L238 237.8c2.5 9.2-4.5 18.2-14 18.2-6.4 0-12-4.2-13.9-10.3l-43.5-143c-5.1-16.9-23-26.4-39.9-21.3s-26.4 23-21.3 39.9l62.8 206.4c2.4 7.9-7.2 13.8-13.2 8.1L99.6 283c-16-15.2-41.3-14.6-56.6 1.4s-14.6 41.3 1.4 56.6l112.4 107c43.1 41.1 100.4 64 160 64h19.1c.1 0 .1-.1.1-.1 0-.1.1-.1.1-.1 58.3-3.5 108.6-43.2 125.3-99.7l81.2-275c5-16.9-4.7-34.7-21.6-39.8s-34.7 4.7-39.8 21.6l-37.7 128.2c-1.6 5.3-6.4 8.9-12 8.9-7.9 0-13.8-7.3-12.2-15.1l36-170.3c3.7-17.3-7.4-34.3-24.7-37.9s-34.3 7.4-37.9 24.7l-37.6 177.7c-2.6 12.2-13.3 20.9-25.8 20.9-11.9 0-22.4-8-25.4-19.5l-57-212.8z"
        }
    ]
};

const FasHandWave = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHandWave",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m352.2 82.3-1.2-8.5c-3-21.1-19.6-37.7-40.7-40.7l-8.5-1.2c-8.7-1.2-14.8-9.4-13.6-18.1S297.5-1.1 306.3.2l8.5 1.2c35.2 5 62.9 32.7 67.9 67.9l1.2 8.5c1.2 8.7-4.8 16.9-13.6 18.1s-16.9-4.8-18.1-13.6zM185.4 70.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192c3.3 3.3 9.4 1.1 9.4-3.7v-77.7c0-22.1 17.9-40 40-40s40 17.9 40 40v176.4c0 60.2-27.9 116.9-75.5 153.7-50.9 39.3-115.6 49.7-173.6 32.7-28.4-7.1-55.3-21.8-77.6-44.1l-4.9-4.9L73.4 342.6l-32-32c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l31.9 31.9.1.1 46.6 46.7c5.2 5.2 13.6 5.2 18.7 0s5.2-13.6 0-18.7L57.4 198.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L229.3 280c5.2 5.2 13.6 5.2 18.7 0s5.2-13.6 0-18.7L105.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L293.3 216c5.2 5.2 13.6 5.2 18.7 0s5.2-13.6 0-18.7L185.4 70.6zM13.7 352.2c8.7-1.2 16.9 4.8 18.1 13.6l1.2 8.5c3 21.1 19.6 37.7 40.7 40.7l8.5 1.2c8.7 1.3 14.8 9.4 13.6 18.1s-9.4 14.8-18.1 13.6l-8.5-1.2C34 441.7 6.3 414 1.3 378.8l-1.1-8.5c-1.2-8.7 4.8-16.9 13.6-18.1z"
        }
    ]
};

const FasHand = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHand",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32v208c0 8.8-7.2 16-16 16s-16-7.2-16-16V64c0-17.7-14.3-32-32-32s-32 14.3-32 32v272c0 1.5 0 3.1.1 4.6L67.6 283c-16-15.2-41.3-14.6-56.6 1.4s-14.6 41.3 1.4 56.6l112.4 107c43.1 41.1 100.4 64 160 64H304c97.2 0 176-78.8 176-176V128c0-17.7-14.3-32-32-32s-32 14.3-32 32v112c0 8.8-7.2 16-16 16s-16-7.2-16-16V64c0-17.7-14.3-32-32-32s-32 14.3-32 32v176c0 8.8-7.2 16-16 16s-16-7.2-16-16V32z"
        }
    ]
};

const FasHandcuffs = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHandcuffs",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M240 32a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm-48 16a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-32 80c17.7 0 32 14.3 32 32h8c13.3 0 24 10.7 24 24v16c0 1.7-.2 3.4-.5 5.1C280.3 229.6 320 286.2 320 352c0 88.4-71.6 160-160 160S0 440.4 0 352c0-65.8 39.7-122.4 96.5-146.9-.4-1.6-.5-3.3-.5-5.1v-16c0-13.3 10.7-24 24-24h8c0-17.7 14.3-32 32-32zm0 320a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm192-96c0-25.9-5.1-50.5-14.4-73.1 16.9-32.9 44.8-59.1 78.9-73.9-.4-1.6-.5-3.3-.5-5.1V184c0-13.3 10.7-24 24-24h8c0-17.7 14.3-32 32-32s32 14.3 32 32h8c13.3 0 24 10.7 24 24v16c0 1.7-.2 3.4-.5 5.1C600.3 229.6 640 286.2 640 352c0 88.4-71.6 160-160 160-62 0-115.8-35.3-142.4-86.9 9.3-22.5 14.4-47.2 14.4-73.1zm224 0a96 96 0 1 0-192 0 96 96 0 1 0 192 0zM368 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm80 48a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FasHandsAslInterpreting = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHandsAslInterpreting",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M156.6 46.3c7.9-15.8 1.5-35-14.3-42.9s-35-1.5-42.9 14.3L13.5 189.4C4.6 207.2 0 226.8 0 246.7v9.3c0 70.7 57.3 128 128 128h80v-.3c35.2-2.7 65.4-22.8 82.1-51.7 8.8-15.3 3.6-34.9-11.7-43.7s-34.9-3.6-43.7 11.7c-7 12-19.9 20-34.7 20-22.1 0-40-17.9-40-40s17.9-40 40-40c14.8 0 27.7 8 34.7 20 8.8 15.3 28.4 20.5 43.7 11.7s20.5-28.4 11.7-43.7c-12.8-22.1-33.6-39.1-58.4-47.1l80.8-22c17-4.6 27.1-22.2 22.5-39.3s-22.2-27.1-39.3-22.5l-100.8 27.5 81.6-68c13.6-11.3 15.4-31.5 4.1-45.1s-31.5-15.4-45.1-4.1L133.6 92.3l23-46zm326.8 419.4c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3l85.9-171.7c8.9-17.8 13.5-37.4 13.5-57.2V256c0-70.7-57.3-128-128-128h-80v.3c-35.2 2.7-65.4 22.8-82.1 51.7-8.9 15.3-3.6 34.9 11.7 43.7s34.9 3.6 43.7-11.7c7-12 19.9-20 34.7-20 22.1 0 40 17.9 40 40s-17.9 40-40 40c-14.8 0-27.7-8-34.7-20-8.9-15.3-28.4-20.5-43.7-11.7s-20.5 28.4-11.7 43.7c12.8 22.1 33.6 39.1 58.4 47.1l-80.8 22c-17.1 4.7-27.1 22.2-22.5 39.3s22.2 27.1 39.3 22.5L445 387.4l-81.6 68c-13.6 11.3-15.4 31.5-4.1 45.1s31.5 15.4 45.1 4.1l101.9-84.9-23 46z"
        }
    ]
};

const FasHandsBound = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHandsBound",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 32C96 14.3 81.7 0 64 0S32 14.3 32 32v181.9c0 14.2 5.1 27.9 14.3 38.7l85.3 99.4H128c-13.3 0-24 10.7-24 24s10.7 24 24 24h384c13.3 0 24-10.7 24-24s-10.7-24-24-24h-3.6l85.3-99.5c9.2-10.8 14.3-24.5 14.3-38.7V32c0-17.7-14.3-32-32-32s-32 14.3-32 32v112.8l-69.3 92.4c-5.7 7.6-16.1 9.6-24.2 4.8-9.7-5.7-12.1-18.7-5.1-27.5L473 180c10.8-13.5 8.9-33.3-4.4-44.5s-33-9.8-44.5 3.2l-46.7 52.5C361 209.7 352 233.4 352 258.1V352h-64v-93.9c0-24.6-9-48.4-25.4-66.8l-46.7-52.5c-11.5-13-31.3-14.4-44.5-3.2s-15.2 30.9-4.4 44.5l27.6 34.5c7 8.8 4.7 21.8-5.1 27.5-8.1 4.8-18.6 2.7-24.2-4.8L96 144.8V32zm64 448v32h128v-32h64v32h128v-32h32c13.3 0 24-10.7 24-24s-10.7-24-24-24H128c-13.3 0-24 10.7-24 24s10.7 24 24 24h32z"
        }
    ]
};

const FasHandsBubbles = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHandsBubbles",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M416 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm96 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM160 464a48 48 0 1 0-96 0 48 48 0 1 0 96 0zM32 160l.1 72.6c.1 52.2 24 101 64 133.1-.1-1.9-.1-3.8-.1-5.7v-8c0-71.8 37-138.6 97.9-176.7l60.2-37.6c8.6-5.4 17.9-8.4 27.3-9.4l45.9-79.5c6.6-11.5 2.7-26.2-8.8-32.8s-26.2-2.7-32.8 8.8l-78 135.1c-3.3 5.7-10.7 7.7-16.4 4.4s-7.7-10.7-4.4-16.4l62-107.4c6.6-11.5 2.7-26.2-8.8-32.8S214 5 207.4 16.5l-68 117.8-43.3 75L96 160c0-17.7-14.4-32-32-32s-32 14.4-32 32zm300.1-71.5L307.5 131c13.9 4.5 26.4 13.7 34.7 27 .9 1.5 1.7 2.9 2.5 4.4l28.9-50c6.6-11.5 2.7-26.2-8.8-32.8s-26.2-2.7-32.8 8.8zm46.4 63.7-26.8 46.4c-.6 6-2.1 11.8-4.3 17.4H397l23-39.8c6.6-11.5 2.7-26.2-8.8-32.8s-26.2-2.7-32.8 8.8zM315.1 175c-9.4-15-29.1-19.5-44.1-10.2l-60.2 37.6C159.3 234.7 128 291.2 128 352v8c0 8.9.8 17.6 2.2 26.1 35.4 8.2 61.8 40 61.8 77.9 0 6.3-.7 12.5-2.1 18.4C215.1 501 246.3 512 280 512h176c13.3 0 24-10.7 24-24s-10.7-24-24-24h-92c-6.6 0-12-5.4-12-12s5.4-12 12-12h124c13.3 0 24-10.7 24-24s-10.7-24-24-24H364c-6.6 0-12-5.4-12-12s5.4-12 12-12h156c13.3 0 24-10.7 24-24s-10.7-24-24-24H364c-6.6 0-12-5.4-12-12s5.4-12 12-12h124c13.3 0 24-10.7 24-24s-10.7-24-24-24H258.8l46.2-28.9c15-9.4 19.5-29.1 10.2-44.1z"
        }
    ]
};

const FasHandsClapping = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHandsClapping",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M336 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V16c0-8.8 7.2-16 16-16s16 7.2 16 16zm-98.7 7.1 32 48c4.9 7.4 2.9 17.3-4.4 22.2s-17.3 2.9-22.2-4.4l-32-48c-4.9-7.4-2.9-17.3 4.4-22.2s17.3-2.9 22.2 4.4zM135 119c9.4-9.4 24.6-9.4 33.9 0l123.8 123.7c10.1 10.1 27.3 2.9 27.3-11.3V192c0-17.7 14.3-32 32-32s32 14.3 32 32v153.6c0 57.1-30 110-78.9 139.4-64 38.4-145.8 28.3-198.5-24.4L7 361c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l53 53c6.1 6.1 16 6.1 22.1 0s6.1-16 0-22.1l-93-93c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l93 93c6.1 6.1 16 6.1 22.1 0s6.1-16 0-22.1L55 185c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l117 117c6.1 6.1 16 6.1 22.1 0s6.1-16 0-22.1l-93-93c-9.4-9.4-9.4-24.6 0-33.9zm298.1 365.9c-24.2 14.5-50.9 22.1-77.7 23.1 48.1-39.6 76.6-99 76.6-162.4v-98.1c8.2-.1 16-6.4 16-16V192c0-17.7 14.3-32 32-32s32 14.3 32 32v153.6c0 57.1-30 110-78.9 139.4zm-8.2-466.2c7.4 4.9 9.3 14.8 4.4 22.2l-32 48c-4.9 7.4-14.8 9.3-22.2 4.4s-9.3-14.8-4.4-22.2l32-48c4.9-7.4 14.8-9.3 22.2-4.4z"
        }
    ]
};

const FasHandsHoldingChild = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHandsHoldingChild",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 0a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm44.7 164.3 11.1 88.7c1.6 13.2-7.7 25.1-20.8 26.8s-25.1-7.7-26.8-20.8l-4.4-35h-7.6l-4.4 35c-1.6 13.2-13.6 22.5-26.8 20.8s-22.5-13.6-20.8-26.8l11.1-88.8-19.8 16.8c-10.1 8.6-25.3 7.3-33.8-2.8s-7.3-25.3 2.8-33.8l27.9-23.6c18.9-16 42.9-24.8 67.6-24.8s48.7 8.8 67.6 24.7l27.9 23.6c10.1 8.6 11.4 23.7 2.8 33.8s-23.7 11.4-33.8 2.8l-19.8-16.7zM40 64c22.1 0 40 17.9 40 40v160.2c0 17 6.7 33.3 18.7 45.3l51.1 51.1c8.3 8.3 21.3 9.6 31 3.1 12.9-8.6 14.7-26.9 3.7-37.8l-15.2-15.2-32-32c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l32 32 15.2 15.2 25.3 25.3c21 21 32.8 49.5 32.8 79.2V464c0 26.5-21.5 48-48 48h-66.6c-17 0-33.3-6.7-45.3-18.7l-99.9-99.9C10.1 375.4 0 351 0 325.5V104c0-22.1 17.9-40 40-40zm560 0c22.1 0 40 17.9 40 40v221.5c0 25.5-10.1 49.9-28.1 67.9L512 493.3c-12 12-28.3 18.7-45.3 18.7H400c-26.5 0-48-21.5-48-48v-78.9c0-29.7 11.8-58.2 32.8-79.2l25.3-25.3 15.2-15.2 32-32c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-32 32-15.2 15.2c-11 11-9.2 29.2 3.7 37.8 9.7 6.5 22.7 5.2 31-3.1l51.1-51.1c12-12 18.7-28.3 18.7-45.3V104c0-22.1 17.9-40 40-40z"
        }
    ]
};

const FasHandsHoldingCircle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHandsHoldingCircle",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 0a128 128 0 1 1 0 256 128 128 0 1 1 0-256zM40 64c22.1 0 40 17.9 40 40v160.2c0 17 6.7 33.3 18.7 45.3l51.1 51.1c8.3 8.3 21.3 9.6 31 3.1 12.9-8.6 14.7-26.9 3.7-37.8l-15.2-15.2-32-32c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l32 32 15.2 15.2 25.3 25.3c21 21 32.8 49.5 32.8 79.2V464c0 26.5-21.5 48-48 48h-66.6c-17 0-33.3-6.7-45.3-18.7l-99.9-99.9C10.1 375.4 0 351 0 325.5V104c0-22.1 17.9-40 40-40zm560 0c22.1 0 40 17.9 40 40v221.5c0 25.5-10.1 49.9-28.1 67.9L512 493.3c-12 12-28.3 18.7-45.3 18.7H400c-26.5 0-48-21.5-48-48v-78.9c0-29.7 11.8-58.2 32.8-79.2l25.3-25.3 15.2-15.2 32-32c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-32 32-15.2 15.2c-11 11-9.2 29.2 3.7 37.8 9.7 6.5 22.7 5.2 31-3.1l51.1-51.1c12-12 18.7-28.3 18.7-45.3V104c0-22.1 17.9-40 40-40z"
        }
    ]
};

const FasHandsHoldingDiamond = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHandsHoldingDiamond",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m297.4 9.4-96 96c-12.5 12.5-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0l96-96c12.5-12.5 12.5-32.8 0-45.3l-96-96c-12.5-12.5-32.8-12.5-45.3 0zM80 104c0-22.1-17.9-40-40-40S0 81.9 0 104v221.5c0 25.5 10.1 49.9 28.1 67.9l99.9 99.9c12 12 28.3 18.7 45.3 18.7H240c26.5 0 48-21.5 48-48v-78.9c0-29.7-11.8-58.2-32.8-79.2l-25.3-25.3-15.2-15.2-32-32c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l32 32 15.2 15.2c11 11 9.2 29.2-3.7 37.8-9.7 6.5-22.7 5.2-31-3.1l-51.2-51.1c-12-12-18.7-28.3-18.7-45.3V104zm480 0v160.2c0 17-6.7 33.3-18.7 45.3l-51.1 51.1c-8.3 8.3-21.3 9.6-31 3.1-12.9-8.6-14.7-26.9-3.7-37.8l15.2-15.2 32-32c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-32 32-15.2 15.2-25.3 25.3c-21 21-32.8 49.5-32.8 79.2V464c0 26.5 21.5 48 48 48h66.7c17 0 33.3-6.7 45.3-18.7l99.9-99.9c18-18 28.1-42.4 28.1-67.9V104c0-22.1-17.9-40-40-40s-40 17.9-40 40z"
        }
    ]
};

const FasHandsHoldingDollar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHandsHoldingDollar",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M344 24v10.5c6.4 1.2 12.6 2.7 18.2 4.2 12.8 3.4 20.4 16.6 17 29.4s-16.6 20.4-29.4 17c-10.9-2.9-21.1-4.9-30.2-5-7.3-.1-14.7 1.7-19.4 4.4-2.1 1.3-3.1 2.4-3.5 3-.3.5-.7 1.2-.7 2.8v.6c.2.2.9 1.2 3.3 2.6 5.8 3.5 14.4 6.2 27.4 10.1l.9.3c11.1 3.3 25.9 7.8 37.9 15.3 13.7 8.6 26.1 22.9 26.4 44.9.3 22.5-11.4 38.9-26.7 48.5-6.7 4.1-13.9 7-21.3 8.8V232c0 13.3-10.7 24-24 24s-24-10.7-24-24v-11.4c-9.5-2.3-18.2-5.3-25.6-7.8-2.1-.7-4.1-1.4-5.9-2-12.6-4.2-19.4-17.8-15.2-30.4s17.8-19.4 30.4-15.2c2.6.9 5 1.7 7.3 2.5 13.6 4.6 23.4 7.9 33.9 8.3 8 .3 15.1-1.6 19.2-4.1 1.9-1.2 2.8-2.2 3.2-2.9.4-.6.9-1.8.8-4.1v-.2c0-1 0-2.1-4-4.6-5.7-3.6-14.3-6.4-27.1-10.3l-1.9-.6c-10.8-3.2-25-7.5-36.4-14.4-13.5-8.1-26.5-22-26.6-44.1-.1-22.9 12.9-38.6 27.7-47.4 6.4-3.8 13.3-6.4 20.2-8.2V24c0-13.3 10.7-24 24-24s24 10.7 24 24zM40 64c22.1 0 40 17.9 40 40v160.2c0 17 6.7 33.3 18.7 45.3l51.1 51.1c8.3 8.3 21.3 9.6 31 3.1 12.9-8.6 14.7-26.9 3.7-37.8l-15.2-15.2-32-32c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l32 32 15.2 15.2 25.3 25.3c21 21 32.8 49.5 32.8 79.2V464c0 26.5-21.5 48-48 48h-66.6c-17 0-33.3-6.7-45.3-18.7l-99.9-99.9C10.1 375.4 0 351 0 325.5V104c0-22.1 17.9-40 40-40zm560 0c22.1 0 40 17.9 40 40v221.5c0 25.5-10.1 49.9-28.1 67.9L512 493.3c-12 12-28.3 18.7-45.3 18.7H400c-26.5 0-48-21.5-48-48v-78.9c0-29.7 11.8-58.2 32.8-79.2l25.3-25.3 15.2-15.2 32-32c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-32 32-15.2 15.2c-11 11-9.2 29.2 3.7 37.8 9.7 6.5 22.7 5.2 31-3.1l51.1-51.1c12-12 18.7-28.3 18.7-45.3V104c0-22.1 17.9-40 40-40z"
        }
    ]
};

const FasHandsHoldingHeart = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHandsHoldingHeart",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M195.9 136.9c-29.4-29.8-29.4-78.2 0-108s77-29.8 106.4 0l17.7 18 17.7-18c29.4-29.8 77-29.8 106.4 0s29.4 78.2 0 108L342.5 240.1c-6.2 6.3-14.3 9.4-22.5 9.4s-16.3-3.1-22.5-9.4L195.9 136.9zM40 64c22.1 0 40 17.9 40 40v160.2c0 17 6.7 33.3 18.7 45.3l51.1 51.1c8.3 8.3 21.3 9.6 31 3.1 12.9-8.6 14.7-26.9 3.7-37.8l-15.2-15.2-32-32c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l32 32 15.2 15.2 25.3 25.3c21 21 32.8 49.5 32.8 79.2V464c0 26.5-21.5 48-48 48h-66.6c-17 0-33.3-6.7-45.3-18.7l-99.9-99.9C10.1 375.4 0 351 0 325.5V104c0-22.1 17.9-40 40-40zm560 0c22.1 0 40 17.9 40 40v221.5c0 25.5-10.1 49.9-28.1 67.9L512 493.3c-12 12-28.3 18.7-45.3 18.7H400c-26.5 0-48-21.5-48-48v-78.9c0-29.7 11.8-58.2 32.8-79.2l25.3-25.3 15.2-15.2 32-32c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-32 32-15.2 15.2c-11 11-9.2 29.2 3.7 37.8 9.7 6.5 22.7 5.2 31-3.1l51.1-51.1c12-12 18.7-28.3 18.7-45.3V104c0-22.1 17.9-40 40-40z"
        }
    ]
};

const FasHandsHolding = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHandsHolding",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 104c0-22.1-17.9-40-40-40S0 81.9 0 104v221.5c0 25.5 10.1 49.9 28.1 67.9l99.9 99.9c12 12 28.3 18.7 45.3 18.7H240c26.5 0 48-21.5 48-48v-78.9c0-29.7-11.8-58.2-32.8-79.2l-25.3-25.3-15.2-15.2-32-32c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l32 32 15.2 15.2c11 11 9.2 29.2-3.7 37.8-9.7 6.5-22.7 5.2-31-3.1l-51.2-51.1c-12-12-18.7-28.3-18.7-45.3V104zm480 0v160.2c0 17-6.7 33.3-18.7 45.3l-51.1 51.1c-8.3 8.3-21.3 9.6-31 3.1-12.9-8.6-14.7-26.9-3.7-37.8l15.2-15.2 32-32c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-32 32-15.2 15.2-25.3 25.3c-21 21-32.8 49.5-32.8 79.2V464c0 26.5 21.5 48 48 48h66.7c17 0 33.3-6.7 45.3-18.7l99.9-99.9c18-18 28.1-42.4 28.1-67.9V104c0-22.1-17.9-40-40-40s-40 17.9-40 40z"
        }
    ]
};

const FasHandsPraying = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHandsPraying",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M351.2 4.8c3.2-2 6.6-3.3 10-4.1 4.7-1 9.6-.9 14.1.1 7.7 1.8 14.8 6.5 19.4 13.6l119.9 179.8c8.8 13.1 13.4 28.6 13.4 44.4v73.5c0 6.9 4.4 13 10.9 15.2l79.2 26.4C631.2 358 640 370.2 640 384v96c0 9.9-4.6 19.3-12.5 25.4s-18.1 8.1-27.7 5.5l-168.8-45c-56-14.9-95-65.7-95-123.7V224c0-17.7 14.3-32 32-32s32 14.3 32 32v80c0 8.8 7.2 16 16 16s16-7.2 16-16v-84.9c0-7-1.8-13.8-5.3-19.8L340.3 48.1c-1.7-3-2.9-6.1-3.6-9.3-1-4.7-1-9.6.1-14.1 1.9-8 6.8-15.2 14.3-19.9zm-62.4 0c7.5 4.6 12.4 11.9 14.3 19.9 1.1 4.6 1.2 9.4.1 14.1-.7 3.2-1.9 6.3-3.6 9.3l-86.3 151.2c-3.5 6-5.3 12.9-5.3 19.8V304c0 8.8 7.2 16 16 16s16-7.2 16-16v-80c0-17.7 14.3-32 32-32s32 14.3 32 32v118.3c0 58-39 108.7-95 123.7L40.3 511c-9.6 2.6-19.9.5-27.7-5.5S0 490 0 480v-96c0-13.8 8.8-26 21.9-30.4l79.2-26.4c6.5-2.2 10.9-8.3 10.9-15.2v-73.5c0-15.8 4.7-31.2 13.4-44.4L245.2 14.5c4.6-7.1 11.7-11.8 19.4-13.6 4.6-1.1 9.4-1.2 14.1-.1 3.5.8 6.9 2.1 10 4.1z"
        }
    ]
};

const FasHands = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHands",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m544 160-.1 72.6c-.1 52.2-24 101-64 133.1.1-1.9.1-3.8.1-5.7v-8c0-71.8-37-138.6-97.9-176.7l-60.2-37.6c-8.6-5.4-17.9-8.4-27.3-9.4l-45.9-79.5c-6.6-11.5-2.7-26.2 8.8-32.8s26.2-2.7 32.8 8.8l78 135.1c3.3 5.7 10.7 7.7 16.4 4.4s7.7-10.7 4.4-16.4l-62-107.4c-6.6-11.5-2.7-26.2 8.8-32.8S362 5 368.6 16.5l68 117.8 43.3 75 .1-49.3c0-17.7 14.4-32 32-32s32 14.4 32 32zM243.9 88.5l24.6 42.5c-13.9 4.5-26.4 13.7-34.7 27-.9 1.4-1.7 2.9-2.5 4.4l-28.9-50c-6.6-11.5-2.7-26.2 8.8-32.8s26.2-2.7 32.8 8.8zm-46.4 63.7 26.8 46.4c.6 6 2.1 11.8 4.3 17.4H179l-23-39.8c-6.6-11.5-2.7-26.2 8.8-32.8s26.2-2.7 32.8 8.8zm63.4 22.8c9.4-15 29.1-19.5 44.1-10.2l60.2 37.6C416.7 234.7 448 291.2 448 352v8c0 83.9-68.1 152-152 152H120c-13.3 0-24-10.7-24-24s10.7-24 24-24h92c6.6 0 12-5.4 12-12s-5.4-12-12-12H88c-13.3 0-24-10.7-24-24s10.7-24 24-24h124c6.6 0 12-5.4 12-12s-5.4-12-12-12H56c-13.3 0-24-10.7-24-24s10.7-24 24-24h156c6.6 0 12-5.4 12-12s-5.4-12-12-12H88c-13.3 0-24-10.7-24-24s10.7-24 24-24h229.2L271 219.1c-15-9.4-19.5-29.1-10.2-44.1z"
        }
    ]
};

const FasHandshakeAngle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHandshakeAngle",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M544 248v3.3l69.7-69.7c21.9-21.9 21.9-57.3 0-79.2l-78.1-78c-21.9-21.9-57.3-21.9-79.2 0l-40.1 40.1c-2.7-.3-5.5-.5-8.3-.5H296c-37.1 0-67.6 28-71.6 64h-.4v120c0 22.1 17.9 40 40 40s40-17.9 40-40v-88h160c44.2 0 80 35.8 80 80v8zm-208-56v56c0 39.8-32.2 72-72 72s-72-32.2-72-72V129.4c-35.9 6.2-65.8 32.3-76 68.2l-16.5 57.6-73.2 73.2c-21.9 21.9-21.9 57.3 0 79.2l78.1 78.1c21.9 21.9 57.3 21.9 79.2 0l37.7-37.7c.9 0 1.8.1 2.7.1h160c26.5 0 48-21.5 48-48 0-5.6-1-11-2.7-16h2.7c26.5 0 48-21.5 48-48 0-12.8-5-24.4-13.2-33 25.7-5 45.1-27.6 45.2-54.8v-.4c-.1-30.8-25.1-55.8-56-55.8H336z"
        }
    ]
};

const FasHandshakeSimpleSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHandshakeSimpleSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-135-105.8c-1.1-11.3-6.3-22.3-15.3-30.7l-134.2-123-23.4 18.2-26-20.3 77.2-60.1c7-5.4 17-4.2 22.5 2.8s4.2 17-2.8 22.5l-20.9 16.2L550.2 352H592c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48h-80.7l-3.9-2.5L434.8 79c-15.3-9.8-33.2-15-51.4-15-21.8 0-43 7.5-60 21.2l-89.7 72.6-25.8-20.3 81.8-66.2c-11.6-4.9-24.1-7.4-36.8-7.4C234 64 215.7 69.6 200 80l-35.5 23.7L38.8 5.1zm374.8 416.8L41.2 128.5C17.9 131.8 0 151.8 0 176v128c0 26.5 21.5 48 48 48h108.2l91.4 83.4c19.6 17.9 49.9 16.5 67.8-3.1 5.5-6.1 9.2-13.2 11.1-20.6l17 15.6c19.5 17.9 49.9 16.6 67.8-2.9.8-.8 1.5-1.7 2.2-2.6z"
        }
    ]
};

const FasHandshakeSimple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHandshakeSimple",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m323.4 85.2-96.8 78.4c-16.1 13-19.2 36.4-7 53.1 12.9 17.8 38 21.3 55.3 7.8l99.3-77.2c7-5.4 17-4.2 22.5 2.8s4.2 17-2.8 22.5L373 188.8 550.2 352H592c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48h-80.7l-3.9-2.5L434.8 79c-15.3-9.8-33.2-15-51.4-15-21.8 0-43 7.5-60 21.2zm22.8 124.4-51.7 40.2c-31.5 24.6-77.2 18.2-100.8-14.2-22.2-30.5-16.6-73.1 12.7-96.8l83.2-67.3c-11.6-4.9-24.1-7.4-36.8-7.4C234 64 215.7 69.6 200 80l-72 48H48c-26.5 0-48 21.5-48 48v128c0 26.5 21.5 48 48 48h108.2l91.4 83.4c19.6 17.9 49.9 16.5 67.8-3.1 5.5-6.1 9.2-13.2 11.1-20.6l17 15.6c19.5 17.9 49.9 16.6 67.8-2.9 4.5-4.9 7.8-10.6 9.9-16.5 19.4 13 45.8 10.3 62.1-7.5 17.9-19.5 16.6-49.9-2.9-67.8l-134.2-123z"
        }
    ]
};

const FasHandshakeSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHandshakeSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-135-105.8c-1.1-11.3-6.3-22.3-15.3-30.7l-134.2-123-23.4 18.2-26-20.3 77.2-60.1c7-5.4 17-4.2 22.5 2.8s4.2 17-2.8 22.5l-20.9 16.2L512 316.8V128h-.7l-3.9-2.5L434.8 79c-15.3-9.8-33.2-15-51.4-15-21.8 0-43 7.5-60 21.2l-89.7 72.6-25.8-20.3 81.8-66.2c-11.6-4.9-24.1-7.4-36.8-7.4C234 64 215.7 69.6 200 80l-35.5 23.7L38.8 5.1zm374.8 416.8L128 196.8V352h28.2l91.4 83.4c19.6 17.9 49.9 16.5 67.8-3.1 5.5-6.1 9.2-13.2 11.1-20.6l17 15.6c19.5 17.9 49.9 16.6 67.8-2.9.8-.8 1.5-1.7 2.2-2.6zM96 171.6 40.6 128H16c-8.8 0-16 7.2-16 16v208c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V171.6zM48 320a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm496-192v224c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V144c0-8.8-7.2-16-16-16h-80zm32 208a16 16 0 1 1 32 0 16 16 0 1 1-32 0z"
        }
    ]
};

const FasHandshake = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHandshake",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m323.4 85.2-96.8 78.4c-16.1 13-19.2 36.4-7 53.1 12.9 17.8 38 21.3 55.3 7.8l99.3-77.2c7-5.4 17-4.2 22.5 2.8s4.2 17-2.8 22.5L373 188.8l139 128V128h-.7l-3.9-2.5L434.8 79c-15.3-9.8-33.2-15-51.4-15-21.8 0-43 7.5-60 21.2zm22.8 124.4-51.7 40.2c-31.5 24.6-77.2 18.2-100.8-14.2-22.2-30.5-16.6-73.1 12.7-96.8l83.2-67.3c-11.6-4.9-24.1-7.4-36.8-7.4C234 64 215.7 69.6 200 80l-72 48v224h28.2l91.4 83.4c19.6 17.9 49.9 16.5 67.8-3.1 5.5-6.1 9.2-13.2 11.1-20.6l17 15.6c19.5 17.9 49.9 16.6 67.8-2.9 4.5-4.9 7.8-10.6 9.9-16.5 19.4 13 45.8 10.3 62.1-7.5 17.9-19.5 16.6-49.9-2.9-67.8l-134.2-123zM16 128c-8.8 0-16 7.2-16 16v208c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V128H16zm32 192a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm496-192v224c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V144c0-8.8-7.2-16-16-16h-80zm32 208a16 16 0 1 1 32 0 16 16 0 1 1-32 0z"
        }
    ]
};

const FasHanukiah = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHanukiah",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M314.2 3.3C309.1 12.1 296 36.6 296 56c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3zm-288 48C21.1 60.1 8 84.6 8 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3zM88 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3C101.1 60.1 88 84.6 88 104zm82.2-52.7C165.1 60.1 152 84.6 152 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3zM216 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3C229.1 60.1 216 84.6 216 104zm178.2-52.7C389.1 60.1 376 84.6 376 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3zM440 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3C453.1 60.1 440 84.6 440 104zm82.2-52.7C517.1 60.1 504 84.6 504 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3zM584 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3C597.1 60.1 584 84.6 584 104zm-472 56c-8.8 0-16 7.2-16 16v112h32V176c0-8.8-7.2-16-16-16zm64 0c-8.8 0-16 7.2-16 16v112h32V176c0-8.8-7.2-16-16-16zm64 0c-8.8 0-16 7.2-16 16v112h32V176c0-8.8-7.2-16-16-16zm160 0c-8.8 0-16 7.2-16 16v112h32V176c0-8.8-7.2-16-16-16zm64 0c-8.8 0-16 7.2-16 16v112h32V176c0-8.8-7.2-16-16-16zm64 0c-8.8 0-16 7.2-16 16v112h32V176c0-8.8-7.2-16-16-16zm-176-16c0-17.7-14.3-32-32-32s-32 14.3-32 32v176H96c-17.7 0-32-14.3-32-32v-96c0-17.7-14.3-32-32-32S0 174.3 0 192v96c0 53 43 96 96 96h192v64H160c-17.7 0-32 14.3-32 32s14.3 32 32 32h320c17.7 0 32-14.3 32-32s-14.3-32-32-32H352v-64h192c53 0 96-43 96-96v-96c0-17.7-14.3-32-32-32s-32 14.3-32 32v96c0 17.7-14.3 32-32 32H352V144z"
        }
    ]
};

const FasHardDrive = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHardDrive",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 96c0-35.3 28.7-64 64-64h384c35.3 0 64 28.7 64 64v184.4c-17-15.2-39.4-24.4-64-24.4H64c-24.6 0-47 9.2-64 24.4V96zm64 192h384c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64v-64c0-35.3 28.7-64 64-64zm256 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128-32a32 32 0 1 0-64 0 32 32 0 1 0 64 0z"
        }
    ]
};

const FasHashtagLock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHashtagLock",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M181.3 32.4c17.4 2.9 29.2 19.4 26.3 36.8l-9.8 58.8h95.1l11.5-69.3c2.9-17.4 19.4-29.2 36.8-26.3s29.2 19.4 26.3 36.8l-9.7 58.8H416c17.7 0 32 14.3 32 32v1.1c-24.1 3.5-45.8 14.6-62.4 30.9h-38.5l-21.3 128h2.8c-5.4 9.4-8.6 20.3-8.6 32v32h-4.9l-11.5 69.3c-2.9 17.4-19.4 29.2-36.8 26.3s-29.2-19.4-26.3-36.8l9.8-58.7h-95.2l-11.5 69.3c-2.9 17.4-19.4 29.2-36.8 26.3s-29.2-19.4-26.3-36.8l9.7-58.9H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h68.9l21.3-128H64c-17.7 0-32-14.3-32-32s14.3-32 32-32h68.9l11.5-69.3c2.9-17.4 19.4-29.2 36.8-26.3zm5.8 159.6-21.3 128h95.1l21.3-128h-95.1zM464 240c-17.7 0-32 14.3-32 32v48h64v-48c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32v128c0 17.7-14.3 32-32 32H384c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32v-48z"
        }
    ]
};

const FasHashtag = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHashtag",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M181.3 32.4c17.4 2.9 29.2 19.4 26.3 36.8l-9.8 58.8h95.1l11.5-69.3c2.9-17.4 19.4-29.2 36.8-26.3s29.2 19.4 26.3 36.8l-9.7 58.8H416c17.7 0 32 14.3 32 32s-14.3 32-32 32h-68.9l-21.3 128H384c17.7 0 32 14.3 32 32s-14.3 32-32 32h-68.9l-11.5 69.3c-2.9 17.4-19.4 29.2-36.8 26.3s-29.2-19.4-26.3-36.8l9.8-58.7h-95.2l-11.5 69.3c-2.9 17.4-19.4 29.2-36.8 26.3s-29.2-19.4-26.3-36.8l9.7-58.9H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h68.9l21.3-128H64c-17.7 0-32-14.3-32-32s14.3-32 32-32h68.9l11.5-69.3c2.9-17.4 19.4-29.2 36.8-26.3zm5.8 159.6-21.3 128h95.1l21.3-128h-95.1z"
        }
    ]
};

const FasHatBeach = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHatBeach",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 448c176.7 0 320-57.3 320-128 0-19.3-11.8-36.7-29.7-43.9L574.9 262c.7 4.2 1.1 8.5 1.1 12.8 0 42.7-34.6 77.3-77.3 77.3-12.2 0-24.1-2.9-34.7-8.3-10.7 5.4-22.6 8.3-34.7 8.3-38.6 0-70.6-28.3-76.3-65.4-10.6.9-21.6 1.4-32.9 1.4-88.4 0-160-28.7-160-64l-130.4 52C11.8 283.3 0 300.7 0 320c0 70.7 143.3 128 320 128zm32-242.7c0-42.7 34.6-77.3 77.3-77.3 7.1 0 14.1 1 20.9 2.9C421.1 90.4 373.6 64 320 64c-70.4 0-130.2 45.5-151.6 108.7l.1-.2c6.2 28.8 71.6 51.5 151.5 51.5 11.7 0 23-.5 34-1.4-1.3-5.6-2-11.5-2-17.3zM473.1 168c-5.5 3.8-12.7 3.8-18.2 0-7.5-5.2-16.4-8-25.7-8-25 0-45.3 20.3-45.3 45.3 0 9.2 2.8 18.2 8 25.7 3.8 5.5 3.8 12.7 0 18.2-5.2 7.5-8 16.4-8 25.7 0 25 20.3 45.3 45.3 45.3 9.2 0 18.2-2.8 25.7-8 5.5-3.8 12.7-3.8 18.2 0 7.5 5.2 16.4 8 25.7 8 25 0 45.3-20.3 45.3-45.3 0-9.2-2.8-18.2-8-25.7-3.8-5.5-3.8-12.7 0-18.2 5.2-7.5 8-16.4 8-25.7 0-25-20.3-45.3-45.3-45.3-9.2 0-18.2 2.8-25.7 8zm-9.1 48a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FasHatChef = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHatChef",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M153.6 51.2C177 20.1 214.1 0 256 0s79 20.1 102.4 51.2c16-12.1 36-19.2 57.6-19.2 7.1 0 14.4.8 21.6 2.5C482 44.7 512 84.3 512 128c0 7.1-.8 14.4-2.5 21.6C496 224 448 320 448 320h-74.4l26.2-157.4c1.5-8.7-4.4-17-13.2-18.4s-17 4.4-18.4 13.2L341.1 320H272V160c0-8.8-7.2-16-16-16s-16 7.2-16 16v160h-69.1l-27.1-162.6c-1.5-8.7-9.7-14.6-18.4-13.2s-14.6 9.7-13.2 18.4L138.4 320H64S16 224 2.5 149.6C.8 142.4 0 135.1 0 128c0-43.7 30-83.3 74.4-93.5C81.6 32.8 88.9 32 96 32c21.6 0 41.6 7.1 57.6 19.2zM448 448c0 35.3-28.7 64-64 64H128c-35.3 0-64-28.7-64-64v-96h384v96z"
        }
    ]
};

const FasHatCowboySide = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHatCowboySide",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m152.7 135.9-10.4 57.2c6.8-.7 13.6-1.1 20.5-1.1h10.7c39.4 0 77.8 12.1 110.1 34.7l278.8 195.1 35.1 24.6c24.4-6 42.5-28.1 42.5-54.4 0-75.8-94.7-126.6-134.6-144.7L474 83.9C468.2 53.8 441.8 32 411.1 32h-2.7c-5.6 0-11.1.7-16.5 2.2L199.2 85.5c-23.9 6.4-42 26-46.5 50.4zM0 384c0 35.3 28.7 64 64 64h480L265.3 252.9c-26.9-18.8-58.9-28.9-91.8-28.9h-10.6c-60.6 0-116 34.2-143.1 88.4L13.5 325C4.6 342.7 0 362.3 0 382.2v1.8z"
        }
    ]
};

const FasHatCowboy = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHatCowboy",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 64c14.4 0 22.3-7 30.8-14.4C360.4 41.1 370.7 32 392 32c49.3 0 84.4 152.2 97.9 221.9-42.1 18.2-99 34.1-169.9 34.1s-127.8-15.9-169.9-34.1C163.6 184.2 198.7 32 248 32c21.3 0 31.6 9.1 41.2 17.6C297.7 57 305.6 64 320 64zM111.1 270.7c47.2 24.5 117.5 49.3 209 49.3s161.8-24.8 208.9-49.3c24.8-12.9 49.8-28.3 70.1-47.7 7.9-7.9 20.2-9.2 29.6-3.3 9.5 5.9 13.5 17.9 9.9 28.5-13.5 37.7-38.4 72.3-66.1 100.6C523.7 398.9 443.6 448 320 448s-203.6-49.1-252.5-99.2c-27.7-28.4-52.6-63-66.1-100.7-3.6-10.6.4-22.6 9.9-28.5 9.5-5.9 21.7-4.5 29.6 3.3 20.4 19.4 45.3 34.8 70.1 47.7z"
        }
    ]
};

const FasHatSanta = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHatSanta",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M149.7 137.8 64 352h384l-62.9-141.4c-.8-1.7-1.1-3.5-1.1-5.4 0-7.3 5.9-13.2 13.2-13.2h.8c1.4 0 2.7.2 4 .6l55.3 16.6c2.1-3.2 4.5-6.1 7.2-8.8 0-14.3 5.5-28.7 16.4-39.6 2.2-2.2 4.6-4.2 7.1-6l-53.6-63.2c-32-37.8-79-59.6-128.5-59.6-68.8 0-130.7 41.9-156.3 105.8zM584 182.2c-1-12.4-11.3-22.2-24-22.2s-23 9.8-23.9 22.2c-9.4-8.1-23.7-7.7-32.6 1.2s-9.4 23.2-1.2 32.6c-12.5 1-22.3 11.3-22.3 24s9.8 23 22.2 23.9c-8.1 9.4-7.7 23.7 1.2 32.6s23.2 9.4 32.6 1.2c1 12.5 11.3 22.3 24 22.3s23-9.8 23.9-22.2c9.4 8.1 23.7 7.7 32.6-1.2s9.4-23.2 1.2-32.6c12.5-1 22.3-11.3 22.3-24s-9.8-23-22.2-23.9c8.1-9.4 7.7-23.7-1.2-32.6s-23.2-9.4-32.6-1.2zM0 432c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48s-21.5-48-48-48H48c-26.5 0-48 21.5-48 48z"
        }
    ]
};

const FasHatWinter = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHatWinter",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M279.9 22.2C279 9.8 268.7 0 256 0s-23 9.8-23.9 22.2c-9.4-8.1-23.7-7.7-32.6 1.2s-9.4 23.2-1.2 32.6C185.8 57 176 67.3 176 80s9.8 23 22.2 23.9c-8.1 9.4-7.7 23.7 1.2 32.6s23.2 9.4 32.6 1.2c1 12.5 11.3 22.3 24 22.3s23-9.8 23.9-22.2c9.4 8.1 23.7 7.7 32.6-1.2s9.4-23.2 1.2-32.6c12.5-1 22.3-11.3 22.3-24s-9.8-23-22.2-23.9c8.1-9.4 7.7-23.7-1.2-32.6s-23.2-9.4-32.6-1.2zM0 480c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32zm216.4-304.4c-14.2 0-28.4-5.4-39.3-16.1-62.7 27.1-98.6 85.4-118.9 139.6 4.2 1.6 8.9 1.4 13-.6l35.4-17.7c13.5-6.8 29.4-6.8 42.9 0l35.4 17.7c4.5 2.3 9.8 2.3 14.3 0l35.4-17.7c13.5-6.8 29.4-6.8 42.9 0l35.4 17.7c4.5 2.3 9.8 2.3 14.3 0l35.4-17.7c13.5-6.8 29.4-6.8 42.9 0l35.4 17.7c4.1 2 8.8 2.2 13 .6-20.3-54.2-56.2-112.5-118.9-139.6-10.9 10.7-25.1 16.1-39.3 16.1-10.2 10.1-24.2 16.4-39.7 16.4s-29.5-6.3-39.6-16.4zM48.1 329.5C34.3 377.5 32 416 32 416h448s-2.3-38.5-16.1-86.5a47.52 47.52 0 0 1-37.3-2.4l-35.4-17.7c-4.5-2.3-9.8-2.3-14.3 0l-35.4 17.7c-13.5 6.8-29.4 6.8-42.9 0l-35.4-17.7c-4.5-2.3-9.8-2.3-14.3 0l-35.4 17.7c-13.5 6.8-29.4 6.8-42.9 0l-35.4-17.7c-4.5-2.3-9.8-2.3-14.3 0l-35.4 17.8c-11.7 5.8-25.2 6.6-37.3 2.4z"
        }
    ]
};

const FasHatWitch = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHatWitch",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M200.7 181.4 112 384h112v-48c0-26.5 21.5-48 48-48h32c26.5 0 48 21.5 48 48v48h112l-77.3-177.9c-1.8-4-2.7-8.4-2.7-12.8v-.8c0-5.6 1.5-11 4.2-15.9l18.6-32.5c5.7-10 16.3-16.1 27.8-16.1H455c14.7 0 27.5 10 31 24.2l6.2 24.6c2.2 8.9 10.2 15.1 19.4 15.1 9.5 0 17.7-6.7 19.6-16.1l12.2-60.8c.4-2.1.6-4.2.6-6.3v-6.8c0-9-3.8-17.5-10.4-23.6L457.2 8.4C451.3 3 443.6 0 435.6 0h-2.2c-6.1 0-12.1 1.8-17.3 5l-143 91.6c-32 20.5-57.2 50-72.4 84.8zM320 384v-48c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48h64zM22.6 416C10.1 416 0 426.1 0 438.6c0 6 2.4 11.7 6.9 15.6C25.9 470.3 82.6 512 160 512h256c77.4 0 134.1-41.7 153.1-57.8 4.6-3.9 6.9-9.6 6.9-15.6 0-12.5-10.1-22.6-22.6-22.6H22.6z"
        }
    ]
};

const FasHatWizard = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHatWizard",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m64 416 104.6-235.3c15.3-34.4 40.3-63.5 72-83.7L387.5 3c3-1.9 6.5-2.9 10-2.9C407.7 0 416 8.3 416 18.6v1.6c0 2.6-.5 5.1-1.4 7.5l-59.8 149.2c-1.9 4.7-2.8 9.7-2.8 14.7 0 5.5 1.2 11 3.4 16.1L448 416H240.9l11.8-35.4 40.4-13.5c6.5-2.2 10.9-8.3 10.9-15.2s-4.4-13-10.9-15.2l-40.4-13.5-13.5-40.4c-2.2-6.4-8.3-10.8-15.2-10.8s-13 4.4-15.2 10.9l-13.5 40.4-40.4 13.5c-6.5 2.2-10.9 8.3-10.9 15.2s4.4 13 10.9 15.2l40.4 13.5 11.8 35.3H64zm215.6-274.5c-1.1-3.3-4.1-5.5-7.6-5.5s-6.5 2.2-7.6 5.5l-6.7 20.2-20.2 6.7c-3.3 1.1-5.5 4.1-5.5 7.6s2.2 6.5 5.5 7.6l20.2 6.7 6.7 20.2c1.1 3.3 4.1 5.5 7.6 5.5s6.5-2.2 7.6-5.5l6.7-20.2 20.2-6.7c3.3-1.1 5.5-4.1 5.5-7.6s-2.2-6.5-5.5-7.6l-20.2-6.7-6.7-20.2zM32 448h448c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
        }
    ]
};

const FasHeadSideBrain = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHeadSideBrain",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 224.2C0 100.6 100.2 0 224 0h24c95.2 0 181.2 69.3 197.3 160.2 2.3 13 6.8 25.7 15.1 36l42 52.6c6.2 7.8 9.6 17.4 9.6 27.4 0 24.2-19.6 43.8-43.8 43.8H448v64c0 35.3-28.7 64-64 64h-64v32c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32v-72.7c0-16.7-6.9-32.5-17.1-45.8C16.6 322.4 0 274.1 0 224.2zM285.3 208H336c26.5 0 48-21.5 48-48s-21.5-48-48-48c-.9 0-1.8 0-2.7.1C326.7 93.4 308.9 80 288 80c-8.6 0-16.6 2.2-23.5 6.2C255.9 72.8 241 64 224 64s-31.9 8.8-40.5 22.2c-7-3.9-15-6.2-23.5-6.2-26.5 0-48 21.5-48 48-26.5 0-48 21.5-48 48 0 20.9 13.4 38.7 32.1 45.3 0 .9-.1 1.8-.1 2.7 0 26.5 21.5 48 48 48 5.6 0 11-1 16-2.7V288c0 17.7 14.3 32 32 32s32-14.3 32-32v-18.7c5 1.8 10.4 2.7 16 2.7 26.5 0 48-21.5 48-48 0-5.6-1-11-2.7-16zM160 176v2.7h-.1c0-.9.1-1.8.1-2.7z"
        }
    ]
};

const FasHeadSideCoughSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHeadSideCoughSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m448 325.8 44 34.5c8.1 1.4 14.8 6.8 18 14.1l42.9 33.6c10.6.4 19.5 7.6 22.2 17.4l39.1 30.6c.6 0 1.2-.1 1.8-.1 11.1 0 20.4 7.5 23.2 17.8h-3.9c6.2 8.5 6.4 20.4-.4 29-8.2 10.4-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2S28.4-3.1 38.8 5.1l50.8 39.8C127 16.7 173.5 0 224 0h24c95.2 0 181.2 69.3 197.3 160.2 2.3 13 6.8 25.7 15.1 36l42 52.6c6.2 7.8 9.6 17.4 9.6 27.4 0 24.2-19.6 43.8-43.8 43.8H448v5.8zM0 224.2c0-38.7 9.8-75.1 27.1-106.9l314.7 248-2.5.3c-11 1.4-19.2 10.7-19.2 21.8 0 11.6 9 21.2 20.6 21.9l62 3.9 43 33.9c-6.4 19.1-24.5 32.9-45.7 32.9h-80v8c0 13.3-10.7 24-24 24H96c-17.7 0-32-14.3-32-32v-72.7c0-16.7-6.9-32.5-17.1-45.8C16.6 322.4 0 274.1 0 224.2zM616 360a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-64-48a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm40-24a24 24 0 1 1 48 0 24 24 0 1 1-48 0z"
        }
    ]
};

const FasHeadSideCough = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHeadSideCough",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 224.2C0 100.6 100.2 0 224 0h24c95.2 0 181.2 69.3 197.3 160.2 2.3 13 6.8 25.7 15.1 36l42 52.6c6.2 7.8 9.6 17.4 9.6 27.4 0 24.2-19.6 43.8-43.8 43.8H448v32l-108.8 13.6c-11 1.4-19.2 10.7-19.2 21.8 0 11.6 9 21.2 20.6 21.9L448 416v16c0 26.5-21.5 48-48 48h-80v8c0 13.3-10.7 24-24 24H96c-17.7 0-32-14.3-32-32v-72.7c0-16.7-6.9-32.5-17.1-45.8C16.6 322.4 0 274.1 0 224.2zm352-.2a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm112 160a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm152-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-24 120a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm-40-168a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm40-24a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm-40 120a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FasHeadSideGear = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHeadSideGear",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 224.2C0 100.6 100.2 0 224 0h24c95.2 0 181.2 69.3 197.3 160.2 2.3 13 6.8 25.7 15.1 36l42 52.6c6.2 7.8 9.6 17.4 9.6 27.4 0 24.2-19.6 43.8-43.8 43.8H448v64c0 35.3-28.7 64-64 64h-64v32c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32v-72.7c0-16.7-6.9-32.5-17.1-45.8C16.6 322.4 0 274.1 0 224.2zm336.6-28.3c6.3-3.6 9.5-11.1 6.8-18-2.1-5.5-4.6-10.8-7.4-15.9l-2.3-4c-3.1-5.1-6.5-9.9-10.2-14.5-4.6-5.7-12.7-6.7-19-3l-2.9 1.7c-9.2 5.3-20.4 4-29.6-1.3s-16.1-14.5-16.1-25.1v-3.4c0-7.3-4.9-13.8-12.1-14.9-6.5-1-13.1-1.5-19.9-1.5s-13.4.5-19.9 1.5c-7.2 1.1-12.1 7.6-12.1 14.9v3.4c0 10.6-6.9 19.8-16.1 25.1s-20.4 6.6-29.6 1.3l-2.9-1.7c-6.3-3.6-14.4-2.6-19 3-3.7 4.6-7.1 9.5-10.2 14.6l-2.3 3.9c-2.8 5.1-5.3 10.4-7.4 15.9-2.6 6.8.5 14.3 6.8 18l2.9 1.7c9.2 5.3 13.7 15.8 13.7 26.4s-4.5 21.1-13.7 26.4l-3 1.7c-6.3 3.6-9.5 11.1-6.8 18 2.1 5.5 4.6 10.7 7.4 15.8l2.4 4.1c3.1 5.1 6.4 9.9 10.1 14.5 4.6 5.7 12.7 6.7 19 3l2.9-1.7c9.2-5.3 20.4-4 29.6 1.3s16.1 14.5 16.1 25.1v3.4c0 7.3 4.9 13.8 12.1 14.9 6.5 1 13.1 1.5 19.9 1.5s13.4-.5 19.9-1.5c7.2-1.1 12.1-7.6 12.1-14.9v-3.4c0-10.6 6.9-19.8 16.1-25.1s20.4-6.6 29.6-1.3l2.9 1.7c6.3 3.6 14.4 2.6 19-3 3.7-4.6 7.1-9.4 10.1-14.5l2.4-4.2c2.8-5.1 5.3-10.3 7.4-15.8 2.6-6.8-.5-14.3-6.8-18l-3-1.7c-9.2-5.3-13.7-15.8-13.7-26.4s4.5-21.1 13.7-26.4l3-1.7zM184 224a40 40 0 1 1 80 0 40 40 0 1 1-80 0z"
        }
    ]
};

const FasHeadSideGoggles = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHeadSideGoggles",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M45.9 128C75.3 53.1 148.3 0 233.7 0H256c39.3 0 75.8 11.8 106.2 32H304c-61.9 0-112 50.1-112 112 0 17.2 3.9 33.5 10.8 48H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h13.9zM304 256h203.1c3.2 6.2 4.9 13.1 4.9 20.2 0 24.2-19.6 43.8-43.8 43.8H448v64c0 35.3-28.7 64-64 64h-64v32c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V375.8c0-17-7.1-33-17.5-46.4-23.5-30.3-40.2-67.8-45-105.4h192.1c20.2 19.8 47.9 32 78.4 32zm0-192h112v160H304c-44.2 0-80-35.8-80-80s35.8-80 80-80zm176 160h-32V64h32c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32z"
        }
    ]
};

const FasHeadSideHeadphones = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHeadSideHeadphones",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 0c95.2 0 174.2 69.3 189.4 160.1 2.2 13 6.7 25.7 15 36.1l42 52.6c6.2 7.8 9.6 17.4 9.6 27.4 0 24.2-19.6 43.8-43.8 43.8H448v64c0 35.3-28.7 64-64 64h-64v32c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32v-72.7c0-16.7-6.9-32.5-17.1-45.8C16.6 322.4 0 274.1 0 224.2 0 122.8 67.4 36.9 160 9.3v77.3c0 12.4-7.4 23.3-17.4 30.5C114.4 137.4 96 170.6 96 208c0 61.9 50.1 112 112 112s112-50.1 112-112c0-37.4-18.4-70.6-46.6-90.9-10-7.2-17.4-18.2-17.4-30.5V0zm-16 208a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0 64 64 0 1 1-128 0z"
        }
    ]
};

const FasHeadSideHeart = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHeadSideHeart",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 224.2C0 100.6 100.2 0 224 0h24c95.2 0 181.2 69.3 197.3 160.2 2.3 13 6.8 25.7 15.1 36l42 52.6c6.2 7.8 9.6 17.4 9.6 27.4 0 24.2-19.6 43.8-43.8 43.8H448v64c0 35.3-28.7 64-64 64h-64v32c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32v-72.7c0-16.7-6.9-32.5-17.1-45.8C16.6 322.4 0 274.1 0 224.2zm112-35c0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3 0-33.8-27.4-61.3-61.3-61.3-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9-33.8 0-61.3 27.4-61.3 61.3z"
        }
    ]
};

const FasHeadSideMask = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHeadSideMask",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 224.2c0-22.2 3.2-43.6 9.2-63.9l221 160.7c-4 9.5-6.2 20-6.2 31v160H128c-17.7 0-32-14.3-32-32v-72.7c0-16.7-6.9-32.5-17.1-45.8C48.6 322.4 32 274.1 32 224.2zm248.3 70.4L53 129.3C88.7 53 166.2 0 256 0h24c95.2 0 181.2 69.3 197.3 160.2 2.3 13 6.8 25.7 15.1 36l42 52.6c5.4 6.7 8.6 14.8 9.4 23.2H336c-21.7 0-41.3 8.6-55.7 22.6zM336 304h208l-19.7 64H368c-8.8 0-16 7.2-16 16s7.2 16 16 16h146.5l-9.8 32H368c-8.8 0-16 7.2-16 16s7.2 16 16 16h126.8l-.9 2.8c-8.3 26.9-33.1 45.2-61.2 45.2H288V352c0-14 6-26.7 15.6-35.4 8.5-7.8 19.9-12.6 32.4-12.6zm48-80a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FasHeadSideMedical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHeadSideMedical",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 224.2C0 100.6 100.2 0 224 0h24c95.2 0 181.2 69.3 197.3 160.2 2.3 13 6.8 25.7 15.1 36l42 52.6c6.2 7.8 9.6 17.4 9.6 27.4 0 24.2-19.6 43.8-43.8 43.8H448v64c0 35.3-28.7 64-64 64h-64v32c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32v-72.7c0-16.7-6.9-32.5-17.1-45.8C16.6 322.4 0 274.1 0 224.2zM192 112v48h-48c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-48h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-48v-48c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16z"
        }
    ]
};

const FasHeadSideVirus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHeadSideVirus",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 224.2C0 100.6 100.2 0 224 0h24c95.2 0 181.2 69.3 197.3 160.2 2.3 13 6.8 25.7 15.1 36l42 52.6c6.2 7.8 9.6 17.4 9.6 27.4 0 24.2-19.6 43.8-43.8 43.8H448v64c0 35.3-28.7 64-64 64h-64v32c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32v-72.7c0-16.7-6.9-32.5-17.1-45.8C16.6 322.4 0 274.1 0 224.2zM224 64c-8.8 0-16 7.2-16 16 0 33-39.9 49.5-63.2 26.2-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6C145.5 152.1 129 192 96 192c-8.8 0-16 7.2-16 16s7.2 16 16 16c33 0 49.5 39.9 26.2 63.2-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0C168.1 286.5 208 303 208 336c0 8.8 7.2 16 16 16s16-7.2 16-16c0-33 39.9-49.5 63.2-26.2 6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6C302.5 263.9 319 224 352 224c8.8 0 16-7.2 16-16s-7.2-16-16-16c-33 0-49.5-39.9-26.2-63.2 6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0C279.9 129.5 240 113 240 80c0-8.8-7.2-16-16-16zm-24 96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm40 80a16 16 0 1 1 32 0 16 16 0 1 1-32 0z"
        }
    ]
};

const FasHeadSide = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHeadSide",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 224.2C0 100.6 100.2 0 224 0h24c95.2 0 181.2 69.3 197.3 160.2 2.3 13 6.8 25.7 15.1 36l42 52.6c6.2 7.8 9.6 17.4 9.6 27.4 0 24.2-19.6 43.8-43.8 43.8H448v64c0 35.3-28.7 64-64 64h-64v32c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32v-72.7c0-16.7-6.9-32.5-17.1-45.8C16.6 322.4 0 274.1 0 224.2zm352-.2a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FasHeading = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHeading",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 64c0-17.7 14.3-32 32-32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32h-16v112h224V96h-16c-17.7 0-32-14.3-32-32s14.3-32 32-32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32h-16v320h16c17.7 0 32 14.3 32 32s-14.3 32-32 32h-96c-17.7 0-32-14.3-32-32s14.3-32 32-32h16V272H112v144h16c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h16V96H32C14.3 96 0 81.7 0 64z"
        }
    ]
};

const FasHeadphonesSimple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHeadphonesSimple",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 80C141.1 80 48 173.1 48 288v104c0 13.3-10.7 24-24 24S0 405.3 0 392V288C0 146.6 114.6 32 256 32s256 114.6 256 256v104c0 13.3-10.7 24-24 24s-24-10.7-24-24V288c0-114.9-93.1-208-208-208zM80 352c0-35.3 28.7-64 64-64h16c17.7 0 32 14.3 32 32v128c0 17.7-14.3 32-32 32h-16c-35.3 0-64-28.7-64-64v-64zm288-64c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64h-16c-17.7 0-32-14.3-32-32V320c0-17.7 14.3-32 32-32h16z"
        }
    ]
};

const FasHeadphones = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHeadphones",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 80C149.9 80 62.4 159.4 49.6 262c9.4-3.8 19.6-6 30.4-6 26.5 0 48 21.5 48 48v128c0 26.5-21.5 48-48 48-44.2 0-80-35.8-80-80V288C0 146.6 114.6 32 256 32s256 114.6 256 256v112c0 44.2-35.8 80-80 80-26.5 0-48-21.5-48-48V304c0-26.5 21.5-48 48-48 10.8 0 21 2.1 30.4 6C449.6 159.4 362.1 80 256 80z"
        }
    ]
};

const FasHeadset = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHeadset",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 48C141.1 48 48 141.1 48 256v40c0 13.3-10.7 24-24 24S0 309.3 0 296v-40C0 114.6 114.6 0 256 0s256 114.6 256 256v144.1c0 48.6-39.4 88-88.1 88l-110.3-.1c-8.3 14.3-23.8 24-41.6 24h-32c-26.5 0-48-21.5-48-48s21.5-48 48-48h32c17.8 0 33.3 9.7 41.6 24l110.4.1c22.1 0 40-17.9 40-40V256c0-114.9-93.1-208-208-208zM144 208h16c17.7 0 32 14.3 32 32v112c0 17.7-14.3 32-32 32h-16c-35.3 0-64-28.7-64-64v-48c0-35.3 28.7-64 64-64zm224 0c35.3 0 64 28.7 64 64v48c0 35.3-28.7 64-64 64h-16c-17.7 0-32-14.3-32-32V240c0-17.7 14.3-32 32-32h16z"
        }
    ]
};

const FasHeartCircleBolt = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHeartCircleBolt",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m47.6 300.4 180.7 168.7c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9l2.6-2.4C267.2 438.6 256 404.6 256 368c0-97.2 78.8-176 176-176 28.3 0 55 6.7 78.7 18.5.9-6.5 1.3-13 1.3-19.6v-5.8c0-69.9-50.5-129.5-119.4-141-45.6-7.6-92 7.3-124.6 39.9l-12 12-12-12c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm47.9-225c4.3 3.7 5.4 9.9 2.6 14.9L452.4 356H488c5.2 0 9.8 3.3 11.4 8.2s-.1 10.3-4.2 13.4l-96 72c-4.5 3.4-10.8 3.2-15.1-.6s-5.4-9.9-2.6-14.9l30.1-54.1H376c-5.2 0-9.8-3.3-11.4-8.2s.1-10.3 4.2-13.4l96-72c4.5-3.4 10.8-3.2 15.1.6z"
        }
    ]
};

const FasHeartCircleCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHeartCircleCheck",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m47.6 300.4 180.7 168.7c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9l2.6-2.4C267.2 438.6 256 404.6 256 368c0-97.2 78.8-176 176-176 28.3 0 55 6.7 78.7 18.5.9-6.5 1.3-13 1.3-19.6v-5.8c0-69.9-50.5-129.5-119.4-141-45.6-7.6-92 7.3-124.6 39.9l-12 12-12-12c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5zM576 368a144 144 0 1 0-288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l28.7 28.7 60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"
        }
    ]
};

const FasHeartCircleExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHeartCircleExclamation",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m47.6 300.4 180.7 168.7c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9l2.6-2.4C267.2 438.6 256 404.6 256 368c0-97.2 78.8-176 176-176 28.3 0 55 6.7 78.7 18.5.9-6.5 1.3-13 1.3-19.6v-5.8c0-69.9-50.5-129.5-119.4-141-45.6-7.6-92 7.3-124.6 39.9l-12 12-12-12c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16v-80c0-8.8 7.2-16 16-16z"
        }
    ]
};

const FasHeartCircleMinus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHeartCircleMinus",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m47.6 300.4 180.7 168.7c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9l2.6-2.4C267.2 438.6 256 404.6 256 368c0-97.2 78.8-176 176-176 28.3 0 55 6.7 78.7 18.5.9-6.5 1.3-13 1.3-19.6v-5.8c0-69.9-50.5-129.5-119.4-141-45.6-7.6-92 7.3-124.6 39.9l-12 12-12-12c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5zM576 368a144 144 0 1 0-288 0 144 144 0 1 0 288 0zm-64 0c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16h128c8.8 0 16 7.2 16 16z"
        }
    ]
};

const FasHeartCirclePlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHeartCirclePlus",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m47.6 300.4 180.7 168.7c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9l2.6-2.4C267.2 438.6 256 404.6 256 368c0-97.2 78.8-176 176-176 28.3 0 55 6.7 78.7 18.5.9-6.5 1.3-13 1.3-19.6v-5.8c0-69.9-50.5-129.5-119.4-141-45.6-7.6-92 7.3-124.6 39.9l-12 12-12-12c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-208v48h48c8.8 0 16 7.2 16 16s-7.2 16-16 16h-48v48c0 8.8-7.2 16-16 16s-16-7.2-16-16v-48h-48c-8.8 0-16-7.2-16-16s7.2-16 16-16h48v-48c0-8.8 7.2-16 16-16s16 7.2 16 16z"
        }
    ]
};

const FasHeartCircleXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHeartCircleXmark",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m47.6 300.4 180.7 168.7c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9l2.6-2.4C267.2 438.6 256 404.6 256 368c0-97.2 78.8-176 176-176 28.3 0 55 6.7 78.7 18.5.9-6.5 1.3-13 1.3-19.6v-5.8c0-69.9-50.5-129.5-119.4-141-45.6-7.6-92 7.3-124.6 39.9l-12 12-12-12c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L454.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L432 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l36.7-36.7-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l36.7 36.7 36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
        }
    ]
};

const FasHeartCrack = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHeartCrack",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M119.4 44.1c23.3-3.9 46.8-1.9 68.6 5.3l49.8 77.5-75.4 75.4c-1.5 1.5-2.4 3.6-2.3 5.8s1 4.2 2.6 5.7l112 104c2.9 2.7 7.4 2.9 10.5.3s3.8-7 1.7-10.4l-60.4-98.1 90.7-75.6c2.6-2.1 3.5-5.7 2.4-8.8l-22.8-63.4c28.5-16.7 62.4-23.2 95.7-17.6 69 11.4 119.5 71 119.5 140.9v5.8c0 41.5-17.2 81.2-47.6 109.5L283.7 469.1c-7.5 7-17.4 10.9-27.7 10.9s-20.2-3.9-27.7-10.9L47.6 300.4C17.2 272.1 0 232.4 0 190.9v-5.8c0-69.9 50.5-129.5 119.4-141z"
        }
    ]
};

const FasHeartHalfStroke = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHeartHalfStroke",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 186.5v220.9l164.7-153.8a85.66 85.66 0 0 0 27.3-62.7v-5.8c0-38.6-27.9-71.5-66-77.9-25.1-4.2-50.8 4-68.8 22l-12 12-45.2 45.3zM119.4 44.1C165 36.5 211.3 51.4 244 84l12 12 12-12c32.6-32.6 79-47.5 124.6-39.9 68.9 11.5 119.4 71.1 119.4 141v5.8c0 41.5-17.2 81.2-47.6 109.5L283.7 469.1c-7.5 7-17.4 10.9-27.7 10.9s-20.2-3.9-27.7-10.9L47.6 300.4C17.2 272.1 0 232.4 0 190.9v-5.8c0-69.9 50.5-129.5 119.4-141z"
        }
    ]
};

const FasHeartHalf = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHeartHalf",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m256 96-12-12c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5l180.7 168.7c7.5 7 17.4 10.9 27.7 10.9V96z"
        }
    ]
};

const FasHeartPulse = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHeartPulse",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M228.3 469.1 47.6 300.4c-4.2-3.9-8.2-8.1-11.9-12.4h87c22.6 0 43-13.6 51.7-34.5l10.5-25.2 49.3 109.5c3.8 8.5 12.1 14 21.4 14.1s17.8-5 22-13.3l42.4-84.9 1.7 3.4c9.5 19 28.9 31 50.1 31h104.5c-3.7 4.3-7.7 8.5-11.9 12.4L283.7 469.1c-7.5 7-17.4 10.9-27.7 10.9s-20.2-3.9-27.7-10.9zM503.7 240h-132c-3 0-5.8-1.7-7.2-4.4l-23.2-46.3c-4.1-8.1-12.4-13.3-21.5-13.3s-17.4 5.1-21.5 13.3l-41.4 82.8-51-113.9c-3.9-8.7-12.7-14.3-22.2-14.1s-18.1 5.9-21.8 14.8l-31.8 76.3c-1.2 3-4.2 4.9-7.4 4.9H16c-2.6 0-5 .4-7.3 1.1-5.7-16-8.7-33-8.7-50.3v-5.8c0-69.9 50.5-129.5 119.4-141 45.6-7.6 92 7.3 124.6 39.9l12 12 12-12c32.6-32.6 79-47.5 124.6-39.9 68.9 11.5 119.4 71.1 119.4 141v5.8c0 16.9-2.8 33.5-8.3 49.1z"
        }
    ]
};

const FasHeart = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHeart",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m47.6 300.4 180.7 168.7c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9l180.7-168.7c30.4-28.3 47.6-68 47.6-109.5v-5.8c0-69.9-50.5-129.5-119.4-141-45.6-7.6-92 7.3-124.6 39.9l-12 12-12-12c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5z"
        }
    ]
};

const FasHeat = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHeat",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 32c17.7 0 32 14.3 32 32v80c0 34.6 11.2 68.3 32 96l19.2 25.6C288.3 304.4 304 351.5 304 400v48c0 17.7-14.3 32-32 32s-32-14.3-32-32v-48c0-34.6-11.2-68.3-32-96l-19.2-25.6C159.7 239.6 144 192.5 144 144V64c0-17.7 14.3-32 32-32zM32 96c17.7 0 32 14.3 32 32v32c0 34.6 11.2 68.3 32 96l19.2 25.6C144.3 320.4 160 367.5 160 416v32c0 17.7-14.3 32-32 32s-32-14.3-32-32v-32c0-34.6-11.2-68.3-32-96l-19.2-25.6C15.7 255.6 0 208.5 0 160v-32c0-17.7 14.3-32 32-32zm320 32v32c0 34.6 11.2 68.3 32 96l19.2 25.6C432.3 320.4 448 367.5 448 416v32c0 17.7-14.3 32-32 32s-32-14.3-32-32v-32c0-34.6-11.2-68.3-32-96l-19.2-25.6C303.7 255.6 288 208.5 288 160v-32c0-17.7 14.3-32 32-32s32 14.3 32 32z"
        }
    ]
};

const FasHelicopterSymbol = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHelicopterSymbol",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M445.3 224H510C495.6 108.2 403.8 16.4 288 2v64.7c80.4 13.4 143.9 76.9 157.3 157.3zm64.7 64h-64.7c-13.4 80.4-76.9 143.9-157.3 157.4V510c115.8-14.4 207.6-106.2 222-222zM2 288c14.4 115.8 106.2 207.6 222 222v-64.6c-80.4-13.5-143.9-77-157.3-157.4H2zm0-64h64.7C80.1 143.6 143.6 80.1 224 66.7V2C108.2 16.4 16.4 108.2 2 224zm206-64c0-17.7-14.3-32-32-32s-32 14.3-32 32v192c0 17.7 14.3 32 32 32s32-14.3 32-32v-64h96v64c0 17.7 14.3 32 32 32s32-14.3 32-32V160c0-17.7-14.3-32-32-32s-32 14.3-32 32v64h-96v-64z"
        }
    ]
};

const FasHelicopter = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHelicopter",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 32c0-17.7 14.3-32 32-32h384c17.7 0 32 14.3 32 32s-14.3 32-32 32H384v64h32c88.4 0 160 71.6 160 160v64c0 17.7-14.3 32-32 32H320c-20.1 0-39.1-9.5-51.2-25.6l-71.4-95.2c-3.5-4.7-8.3-8.3-13.7-10.5L47.2 198.1c-9.5-3.8-16.7-12-19.2-22L5 83.9C2.4 73.8 10.1 64 20.5 64H48c10.1 0 19.6 4.7 25.6 12.8L112 128h208V64H160c-17.7 0-32-14.3-32-32zm256 288h128v-32c0-53-43-96-96-96h-32v128zm246.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-3.9 3.9c-24 24-56.6 37.5-90.5 37.5H256c-17.7 0-32-14.3-32-32s14.3-32 32-32h280.2c17 0 33.3-6.7 45.3-18.7l3.9-3.9c12.5-12.5 32.8-12.5 45.3 0z"
        }
    ]
};

const FasHelmetBattle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHelmetBattle",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 17.1c.6-8.3-5.3-15.7-13.6-17s-16.1 4.1-18 12.2L.8 218.8c-.5 2.2-.8 4.5-.8 6.8C0 242.4 13.6 256 30.4 256h2.2c17.1 0 31.3-13.2 32.5-30.2L80 17.1zM320 352v136c0 18.4 20.8 30.1 36.5 20.5l144-88c9.2-5.6 13.5-16.7 10.6-27.1-17-59.8-31.1-123.2-31.1-185.4 0-85-89.1-149.2-153.1-189-1.9-1.2-4-2.6-6.3-4.1C311.2 8.4 298.7 0 288 0s-23.2 8.4-32.7 14.9c-2.3 1.5-4.4 3-6.3 4.1C185.1 58.8 96 123 96 208c0 62.2-14.1 125.6-31.1 185.4-3 10.4 1.4 21.4 10.6 27.1l144 88c15.7 9.6 36.5-2.1 36.5-20.5V267.5c0-6.9-4.4-13-10.9-15.2l-72.3-24.1c-7.6-2.5-12.7-9.6-12.7-17.6 0-10.3 8.3-18.6 18.6-18.6h218.7c10.3 0 18.6 8.3 18.6 18.6 0 8-5.1 15.1-12.7 17.6L331 252.3c-6.5 2.2-10.9 8.3-10.9 15.2V352zM509.6.2c-8.3 1.2-14.2 8.6-13.6 17l14.9 208.6c1.2 17 15.4 30.2 32.5 30.2h2.2c16.8 0 30.4-13.6 30.4-30.4 0-2.3-.3-4.6-.8-6.8L527.6 12.4c-1.9-8.1-9.7-13.5-18-12.2z"
        }
    ]
};

const FasHelmetSafety = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHelmetSafety",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32c-17.7 0-32 14.3-32 32v101.9c0 5.6-4.5 10.1-10.1 10.1-3.6 0-7-1.9-8.8-5.1l-48-83.9C83 123.5 32 199.8 32 288v64h512v-66.4c-.9-87.2-51.7-162.4-125.1-198.6l-48 83.9c-1.8 3.2-5.2 5.1-8.8 5.1-5.6 0-10.1-4.5-10.1-10.1V64c0-17.7-14.3-32-32-32h-64zM16.6 384C7.4 384 0 391.4 0 400.6c0 4.7 2 9.2 5.8 11.9C27.5 428.4 111.8 480 288 480s260.5-51.6 282.2-67.5c3.8-2.8 5.8-7.2 5.8-11.9 0-9.2-7.4-16.6-16.6-16.6H16.6z"
        }
    ]
};

const FasHelmetUn = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHelmetUn",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M479.5 224C471.2 98.9 367.2 0 240 0 107.5 0 0 107.5 0 240v56.3C0 344.8 39.2 384 87.7 384h127.2l128.6 121.4c4.5 4.2 10.4 6.6 16.5 6.6h96c13.3 0 24-10.7 24-24s-10.7-24-24-24h-86.5l-1.5-1.5V288h112c17.7 0 32-14.3 32-32s-14.3-32-32-32h-.5zM320 417.2l-78-73.7 32.4-55.5H320v129.2zm-34.7-314.1 34.7 52V112c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 7.1-4.6 13.3-11.4 15.3s-14-.6-17.9-6.4l-34.7-52V208c0 8.8-7.2 16-16 16s-16-7.2-16-16v-96c0-7.1 4.6-13.3 11.4-15.3s14 .6 17.9 6.4zM160 112v64c0 8.8 7.2 16 16 16s16-7.2 16-16v-64c0-8.8 7.2-16 16-16s16 7.2 16 16v64c0 26.5-21.5 48-48 48s-48-21.5-48-48v-64c0-8.8 7.2-16 16-16s16 7.2 16 16z"
        }
    ]
};

const FasHexagonCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHexagonCheck",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M17.1 292a71.814 71.814 0 0 1 0-72l88.3-152.9c12.9-22.3 36.6-36 62.4-36h176.5a72.1 72.1 0 0 1 62.4 36L494.9 220c12.9 22.3 12.9 49.7 0 72l-88.3 152.9c-12.9 22.3-36.6 36-62.4 36H167.7a72.1 72.1 0 0 1-62.4-36L17.1 292zM369 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 209z"
        }
    ]
};

const FasHexagonDivide = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHexagonDivide",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M17.1 292a71.814 71.814 0 0 1 0-72l88.3-152.9c12.9-22.3 36.6-36 62.4-36h176.5a72.1 72.1 0 0 1 62.4 36L494.9 220c12.9 22.3 12.9 49.7 0 72l-88.3 152.9c-12.9 22.3-36.6 36-62.4 36H167.7a72.1 72.1 0 0 1-62.4-36L17.1 292zM256 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-88 40c-13.3 0-24 10.7-24 24s10.7 24 24 24h176c13.3 0 24-10.7 24-24s-10.7-24-24-24H168zm120 120a32 32 0 1 0-64 0 32 32 0 1 0 64 0z"
        }
    ]
};

const FasHexagonExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHexagonExclamation",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M17.1 292a71.814 71.814 0 0 1 0-72l88.3-152.9c12.9-22.3 36.6-36 62.4-36h176.5a72.1 72.1 0 0 1 62.4 36L494.9 220c12.9 22.3 12.9 49.7 0 72l-88.3 152.9c-12.9 22.3-36.6 36-62.4 36H167.7a72.1 72.1 0 0 1-62.4-36L17.1 292zM256 128c-13.3 0-24 10.7-24 24v112c0 13.3 10.7 24 24 24s24-10.7 24-24V152c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0-64 0 32 32 0 1 0 64 0z"
        }
    ]
};

const FasHexagonImage = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHexagonImage",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M17.1 220a71.814 71.814 0 0 0 0 72l88.3 152.9c12.9 22.3 36.6 36 62.4 36h176.5a72.1 72.1 0 0 0 62.4-36L494.9 292c12.9-22.3 12.9-49.7 0-72L406.6 67.1c-12.9-22.3-36.6-36-62.4-36H167.7a72.1 72.1 0 0 0-62.4 36L17.1 220zm141.2 59.8c4.5-4.9 10.8-7.7 17.4-7.8s13 2.6 17.6 7.4l38.9 40.6 71.6-86.2c4.6-5.5 11.3-8.7 18.5-8.7s13.9 3.2 18.5 8.7l72.6 87.4-55.2 95.7c-2.9 5-8.1 8-13.9 8H167.7c-5.7 0-11-3-13.9-8l-46.8-81 51.2-56.1zM192 120a40 40 0 1 1 0 80 40 40 0 1 1 0-80z"
        }
    ]
};

const FasHexagonMinus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHexagonMinus",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M17.1 292a71.814 71.814 0 0 1 0-72l88.3-152.9c12.9-22.3 36.6-36 62.4-36h176.5a72.1 72.1 0 0 1 62.4 36L494.9 220c12.9 22.3 12.9 49.7 0 72l-88.3 152.9c-12.9 22.3-36.6 36-62.4 36H167.7a72.1 72.1 0 0 1-62.4-36L17.1 292zM184 232c-13.3 0-24 10.7-24 24s10.7 24 24 24h144c13.3 0 24-10.7 24-24s-10.7-24-24-24H184z"
        }
    ]
};

const FasHexagonPlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHexagonPlus",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M17.1 292a71.814 71.814 0 0 1 0-72l88.3-152.9c12.9-22.3 36.6-36 62.4-36h176.5a72.1 72.1 0 0 1 62.4 36L494.9 220c12.9 22.3 12.9 49.7 0 72l-88.3 152.9c-12.9 22.3-36.6 36-62.4 36H167.7a72.1 72.1 0 0 1-62.4-36L17.1 292zM232 344c0 13.3 10.7 24 24 24s24-10.7 24-24v-64h64c13.3 0 24-10.7 24-24s-10.7-24-24-24h-64v-64c0-13.3-10.7-24-24-24s-24 10.7-24 24v64h-64c-13.3 0-24 10.7-24 24s10.7 24 24 24h64v64z"
        }
    ]
};

const FasHexagonVerticalNftSlanted = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHexagonVerticalNftSlanted",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M260.9 495.5a71.814 71.814 0 0 1-72 0L36 407.2c-22.3-12.8-36-36.6-36-62.3V168.3a72.1 72.1 0 0 1 36-62.4l152.9-88.2c22.3-12.9 49.7-12.9 72 0L413.8 106c22.3 12.9 36 36.6 36 62.4v176.5a72.1 72.1 0 0 1-36 62.4l-152.9 88.2zm11.1-372c0-5.7-3.1-11-8.1-13.9l-47.8-27.3c-2-1.2-4.3-2-6.8-2.2-.5 0-1-.1-1.4-.1h-.1c-3.3 0-6.3 1-8.8 2.6-1.5 1-2.9 2.2-4 3.7-1.2 1.5-2.1 3.3-2.6 5.2-.4 1.6-.6 3.1-.6 4.7v304.4c0 8.8 7.2 16 16 16s16-7.2 16-16v-128h32c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32v-117l24.2 13.8c10.7 6.1 23.9-1.6 23.9-13.9zm16 27.4c0 5.7 3.1 11 8.1 13.9l23.8 13.6v174.2c0 8.8 7.2 16 16 16s16-7.2 16-16v-156l16.2 9.3c7.7 4.4 17.4 1.7 21.8-6s1.7-17.4-6-21.8l-72-41.1c-10.7-6.1-23.9 1.6-23.9 13.9zm-144.2-22.3c-8.8 0-16 7.2-16 16V270L95 171.5c-2.5-7.4-10-12-17.7-10.7s-13.4 7.9-13.4 15.8v160c0 8.8 7.2 16 16 16s16-7.2 16-16v-61.4l32.8 98.5c2.5 7.4 10 12 17.7 10.7s13.4-7.9 13.4-15.8v-224c0-8.8-7.2-16-16-16z"
        }
    ]
};

const FasHexagonVerticalNft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHexagonVerticalNft",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M260.9 495.5a71.814 71.814 0 0 1-72 0L36 407.2c-22.3-12.8-36-36.6-36-62.3V168.3a72.1 72.1 0 0 1 36-62.4l152.9-88.2c22.3-12.9 49.7-12.9 72 0L413.8 106c22.3 12.9 36 36.6 36 62.4v176.5a72.1 72.1 0 0 1-36 62.4l-152.9 88.2zM95.8 170.6c-2.8-7.1-10.3-11.2-17.9-9.8s-13 8-13 15.7v160c0 8.8 7.2 16 16 16s16-7.2 16-16v-76.8l33.1 82.9c2.8 7.1 10.3 11.2 17.9 9.8s13-8 13-15.7v-160c0-8.8-7.2-16-16-16s-16 7.2-16 16v76.9l-33.1-83zm97.1 5.9v160c0 8.8 7.2 16 16 16s16-7.2 16-16v-64h32c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32v-48h32c8.8 0 16-7.2 16-16s-7.2-16-16-16h-48c-8.8 0-16 7.2-16 16zm112-16c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v144c0 8.8 7.2 16 16 16s16-7.2 16-16v-144h16c8.8 0 16-7.2 16-16s-7.2-16-16-16h-64z"
        }
    ]
};

const FasHexagonXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHexagonXmark",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M17.1 292a71.814 71.814 0 0 1 0-72l88.3-152.9c12.9-22.3 36.6-36 62.4-36h176.5a72.1 72.1 0 0 1 62.4 36L494.9 220c12.9 22.3 12.9 49.7 0 72l-88.3 152.9c-12.9 22.3-36.6 36-62.4 36H167.7a72.1 72.1 0 0 1-62.4-36L17.1 292zM175 175c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z"
        }
    ]
};

const FasHexagon = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHexagon",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M17.1 220a71.814 71.814 0 0 0 0 72l88.3 152.9c12.9 22.3 36.6 36 62.4 36h176.6a72.1 72.1 0 0 0 62.4-36L494.9 292c12.9-22.3 12.9-49.7 0-72L406.6 67.1c-12.9-22.3-36.6-36-62.4-36H167.6a72.1 72.1 0 0 0-62.4 36L17.1 220z"
        }
    ]
};

const FasHighDefinition = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHighDefinition",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 96c0-35.3 28.7-64 64-64h448c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm304 88v144c0 13.3 10.7 24 24 24h56c53 0 96-43 96-96s-43-96-96-96h-56c-13.3 0-24 10.7-24 24zm80 24c26.5 0 48 21.5 48 48s-21.5 48-48 48h-32v-96h32zm-224-24c0-13.3-10.7-24-24-24s-24 10.7-24 24v144c0 13.3 10.7 24 24 24s24-10.7 24-24v-48h64v48c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24s-24 10.7-24 24v48h-64v-48z"
        }
    ]
};

const FasHighlighterLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHighlighterLine",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M229 229 444 70.6l29.3 29.3L315 315l-86-86zm-101 91-25.4 25.4c-12.5 12.5-12.5 32.8 0 45.3l50.7 50.7c12.5 12.5 32.8 12.5 45.3 0L224 416h71.7c15.3 0 29.6-7.2 38.6-19.5l201.3-273.1c5.5-7.4 8.4-16.4 8.4-25.6 0-11.4-4.5-22.4-12.6-30.5l-54.8-54.7C468.5 4.5 457.6 0 446.2 0 437 0 428 2.9 420.6 8.4L147.5 209.6c-12.3 9-19.5 23.4-19.5 38.6V320zm-57.9 83.3-63 63c-4.5 4.5-7 10.6-7 17v4.7c0 13.3 10.7 24 24 24h68.6c6.4 0 12.5-2.5 17-7l31-31-70.6-70.7zM224 464c-13.3 0-24 10.7-24 24s10.7 24 24 24h328c13.3 0 24-10.7 24-24s-10.7-24-24-24H224z"
        }
    ]
};

const FasHighlighter = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHighlighter",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m315 315 158.4-215-29.3-29.4L229 229l86 86zm-187 5v-71.7c0-15.3 7.2-29.6 19.5-38.6L420.6 8.4C428 2.9 437 0 446.2 0c11.4 0 22.4 4.5 30.5 12.6l54.8 54.8c8.1 8.1 12.6 19 12.6 30.5 0 9.2-2.9 18.2-8.4 25.6l-201.3 273c-9 12.3-23.4 19.5-38.6 19.5H224l-25.4 25.4c-12.5 12.5-32.8 12.5-45.3 0l-50.7-50.7c-12.5-12.5-12.5-32.8 0-45.3L128 320zM7 466.3l63-63 70.6 70.6-31 31c-4.5 4.5-10.6 7-17 7H24c-13.3 0-24-10.7-24-24v-4.7c0-6.4 2.5-12.5 7-17z"
        }
    ]
};

const FasHillAvalanche = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHillAvalanche",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M439.7 401.9c34.2 23.1 81.1 19.5 111.4-10.8 34.4-34.4 34.4-90.1 0-124.4-27.8-27.8-69.5-33.1-102.6-16-11.8 6.1-16.4 20.6-10.3 32.3s20.6 16.4 32.3 10.3c15.1-7.8 34-5.3 46.6 7.3 15.6 15.6 15.6 40.9 0 56.6s-40.9 15.6-56.6 0l-81.7-81.7c22.4-14.2 37.2-39.1 37.2-67.5 0-33.9-21.1-62.9-50.9-74.5 1.9-6.8 2.9-14 2.9-21.5 0-44.2-35.8-80-80-80-27.3 0-51.5 13.7-65.9 34.6-5.8-20-24.2-34.6-46.1-34.6-26.5 0-48 21.5-48 48 0 4 .5 7.9 1.4 11.6l310.3 310.3zM480 64a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm0 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM68.3 87C43.1 61.8 0 79.7 0 115.3V432c0 44.2 35.8 80 80 80h316.7c35.6 0 53.5-43.1 28.3-68.3L68.3 87z"
        }
    ]
};

const FasHillRockslide = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHillRockslide",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m252.4 103.8 27 48c2.8 5 8.2 8.2 13.9 8.2h53.3c5.8 0 11.1-3.1 13.9-8.2l27-48c2.7-4.9 2.7-10.8 0-15.7l-27-48c-2.8-5-8.2-8.2-13.9-8.2h-53.2c-5.8 0-11.1 3.1-13.9 8.2l-27 48c-2.7 4.9-2.7 10.8 0 15.7zM68.3 87C43.1 61.8 0 79.7 0 115.3V432c0 44.2 35.8 80 80 80h316.7c35.6 0 53.5-43.1 28.3-68.3L68.3 87zm435.9 316.6c4.9 2.7 10.8 2.7 15.7 0l48-27c5-2.8 8.2-8.2 8.2-13.9v-53.3c0-5.8-3.1-11.1-8.2-13.9l-48-27c-4.9-2.7-10.8-2.7-15.7 0l-48 27c-5 2.8-8.2 8.2-8.2 13.9v53.3c0 5.8 3.1 11.1 8.2 13.9l48 27zM192 64a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm192 224a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FasHippo = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHippo",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M407 47c9.4-9.4 24.6-9.4 33.9 0l17.2 17.2c1.9-.1 3.9-.2 5.8-.2h32c11.2 0 21.9 2.3 31.6 6.5L543 55c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-12.9 13c7.6 12.2 12 26.7 12 42.1 0 10.2 7.4 18.8 16.7 23 27.9 12.5 47.3 40.5 47.3 73 0 26.2-12.6 49.4-32 64v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-16h-64v16c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-17.6c-11.8-2.4-22.7-7.4-32-14.4-1.5-1.1-2.9-2.3-4.3-3.5-17-14.7-27.7-36.4-27.7-60.5 0-8.8-7.2-16-16-16s-16 7.2-16 16c0 44.7 26.2 83.2 64 101.2V352c0 17.7 14.3 32 32 32h32v64c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32v-76c-19.8 7.7-41.4 12-64 12s-44.2-4.3-64-12v76c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V329.1l-18.1 40.6c-5.4 12.1-19.6 17.6-31.7 12.2s-17.5-19.5-12.1-31.6L24 300.9c5.3-11.9 8-24.7 8-37.7C32 155.7 117.2 68 223.8 64.1l.2-.1h64c41.7 0 83.4 12.1 117.2 25.7 1.7-1.8 3.5-3.6 5.3-5.2L407 81c-9.4-9.4-9.4-24.6 0-33.9zm73 185a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm88 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-88-112a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm48 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
        }
    ]
};

const FasHockeyMask = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHockeyMask",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 240C0 111 64 0 224 0s224 111 224 240c0 192-48 272-224 272S0 432 0 240zm160-136a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm88 24a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm-72 216a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0 64a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 40a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm72-104a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm40-264a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm-40 328a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 40a24 24 0 1 0-48 0 24 24 0 1 0 48 0zM128 272c35.3 0 64-28.7 64-64 0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32 0 35.3 28.7 64 64 64zm256-64c0-17.7-14.3-32-32-32h-64c-17.7 0-32 14.3-32 32 0 35.3 28.7 64 64 64s64-28.7 64-64z"
        }
    ]
};

const FasHockeyPuck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHockeyPuck",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 256C114.6 256 0 213 0 160s114.6-96 256-96 256 43 256 96-114.6 96-256 96zm192.3 1.8c24.7-9.3 46.9-21 63.7-35.6V352c0 53-114.6 96-256 96S0 405 0 352V222.3c16.8 14.6 39 26.3 63.7 35.6 50.8 19 118.8 30.1 192.3 30.1s141.5-11.1 192.3-30.2z"
        }
    ]
};

const FasHockeyStickPuck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHockeyStickPuck",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M462.3 3.4c15.8 7.9 22.2 27.1 14.3 42.9L261.5 476.6c-10.8 21.7-33 35.4-57.2 35.4H96V352h156.2L419.4 17.7c7.9-15.8 27.1-22.2 42.9-14.3zM0 384c0-17.7 14.3-32 32-32h32v160H32c-17.7 0-32-14.3-32-32v-96zm416 32h192c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H416c-17.7 0-32-14.3-32-32v-32c0-17.7 14.3-32 32-32z"
        }
    ]
};

const FasHockeySticks = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHockeySticks",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m220.6 17.7 82.3 164.6-35.8 71.6L163.4 46.3c-7.9-15.8-1.5-35 14.3-42.9s35-1.5 42.9 14.3zm152.2 304.4 15 29.9H544v160H435.8c-24.2 0-46.4-13.7-57.2-35.4l-41.5-83 35.8-71.6zM576 352h32c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32h-32V352zM462.3 3.4c15.8 7.9 22.2 27.1 14.3 42.9L261.5 476.6c-10.8 21.7-33 35.4-57.2 35.4H96V352h156.2L419.4 17.7c7.9-15.8 27.1-22.2 42.9-14.3zM0 384c0-17.7 14.3-32 32-32h32v160H32c-17.7 0-32-14.3-32-32v-96z"
        }
    ]
};

const FasHollyBerry = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHollyBerry",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-80 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm100.8 191.8c1 .1 2.1.2 3.2.2 39.8 0 72 32.2 72 72v22.7c0 16.4 16 27.9 31.6 22.8l12.8-4.3c18-6 37.3-6.5 55.6-1.5l19.4 5.3c17.9 4.9 34.4-11.6 29.5-29.5l-5.3-19.5c-5-18.3-4.4-37.6 1.5-55.6l4.3-12.8c5.2-15.5-6.4-31.6-22.8-31.6-34.6 0-62.7-28.1-62.7-62.7v-32c0-16.4-16-27.9-31.6-22.8l-12.8 4.3c-18 6-37.3 6.5-55.6 1.5l-29.6-8.1c-2.9-.8-5.9-1-8.7-.7 4.2 9.7 5.8 20.8 3.7 32.3l-6.3 34.9c-1.5 8.4-1.4 17 .5 25.3l5.3 23.9c2.8 12.7 1.1 25.2-4 35.9zM127.6 234.5c-15.5-5.2-31.6 6.4-31.6 22.8v32c0 34.6-28.1 62.7-62.7 62.7-16.4 0-27.9 16-22.8 31.6l4.3 12.8c6 18 6.5 37.3 1.5 55.6L11 471.4c-4.8 18 11.6 34.4 29.5 29.6l19.5-5.4c18.3-5 37.6-4.5 55.6 1.5l12.8 4.3c15.5 5.2 31.6-6.4 31.6-22.8v-32c0-34.6 28.1-62.7 62.7-62.7 16.4 0 27.9-16 22.8-31.6l-4.3-12.8c-6-18-6.5-37.3-1.5-55.6l5.3-19.4c4.9-17.9-11.6-34.4-29.5-29.5l-19.5 5.4c-18.3 5-37.6 4.4-55.6-1.5l-12.8-4.3zM384 144a48 48 0 1 0-96 0 48 48 0 1 0 96 0z"
        }
    ]
};

const FasHoneyPot = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHoneyPot",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 32H64c-17.7 0-32 14.3-32 32s14.3 32 32 32C25.1 125.2 0 171.7 0 224c0 138.8 79.6 217.9 113.3 245.1 9.3 7.5 21.1 10.9 33.1 10.9h155.2c12 0 23.7-3.3 33.1-10.9C368.4 441.9 448 362.8 448 224c0-52.3-25.1-98.8-64-128 17.7 0 32-14.3 32-32s-14.3-32-32-32H176v104c0 13.3-10.7 24-24 24s-24-10.7-24-24V32zM64 224h320c0 53.7-14.7 96.1-32.9 128H96.9C78.7 320.1 64 277.7 64 224z"
        }
    ]
};

const FasHoodCloak = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHoodCloak",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M432 0H288c-9.8 0-66 0-120.2 37.7C111.4 76.9 64 151.8 64 288c0 58.5-14.6 101.6-28.6 129.7-7 14.1-14 24.5-19 31.1-2.5 3.3-4.5 5.7-5.7 7.1-.6.7-1.1 1.2-1.3 1.4l-.2.2c-9 9.1-11.7 22.8-6.8 34.7C7.4 504.2 19 512 32 512h96V320c0-88.4 71.6-160 160-160s160 71.6 160 160v192h96c12.9 0 24.6-7.8 29.6-19.8 4.9-11.9 2.2-25.6-6.8-34.7l-.1-.1c-.2-.2-.7-.7-1.3-1.4-1.3-1.4-3.2-3.8-5.7-7.1-5-6.6-11.9-17-19-31.1C526.6 389.6 512 346.5 512 288c0-103.1-46.5-172.8-95.8-217.2l32-29c7.3-6.7 9.8-17.2 6.2-26.4S441.9 0 432 0zm-16 512V320c0-70.7-57.3-128-128-128s-128 57.3-128 128v192h256z"
        }
    ]
};

const FasHorizontalRule = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHorizontalRule",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 256c0-17.7 14.3-32 32-32h576c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32z"
        }
    ]
};

const FasHorseHead = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHorseHead",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 464V316.9c0-108.4 68.3-205.1 170.5-241.3l169.7-60.1c21.4-7.6 43.8 8.3 43.8 30.9 0 11-5.5 21.2-14.6 27.3L400 96c48.1 0 91.2 29.8 108.1 74.9l48.6 129.5c11.8 31.4 4.1 66.8-19.6 90.5-16 16-37.8 25.1-60.5 25.1h-3.4c-26.1 0-50.9-11.6-67.6-31.7l-32.3-38.7c-11.7 4.1-24.2 6.4-37.3 6.4h-.1c-6.3 0-12.5-.5-18.6-1.5-3.6-.6-7.2-1.4-10.7-2.3-28.9-7.8-53.1-26.8-67.8-52.2-4.4-7.6-14.2-10.3-21.9-5.8s-10.3 14.2-5.8 21.9c24 41.5 68.3 70 119.3 71.9l47.2 70.8c4 6.1 6.2 13.2 6.2 20.4 0 20.3-16.5 36.8-36.8 36.8H112c-26.5 0-48-21.5-48-48zm328-240a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FasHorseSaddle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHorseSaddle",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 238.1V160h16l9.8 19.6c12.5 25.1 42.2 36.4 68.3 26 20.5-8.2 33.9-28 33.9-50.1V80c0-19.1-8.4-36.3-21.7-48h5.7c8.8 0 16-7.2 16-16s-7.2-16-16-16H448c-70.7 0-128 57.3-128 128v32c0 41.8-26.7 77.4-64 90.5v78.6l51.7 14.8c4.1 1.2 8.2 2.1 12.3 2.8V480c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V315.7c19.2-19.2 31.5-45.7 32-75.7v-1.9zM224 320v-64c-53 0-96-43-96-96v-29.4c-21.8 5.5-40.3 19.5-51.7 38.2C33.2 174.5 0 211.4 0 256v56c0 13.3 10.7 24 24 24s24-10.7 24-24v-56c0-13.4 6.6-25.2 16.7-32.5 1.6 13 6.3 25.4 13.6 36.4l28.2 42.4c8.3 12.4 6.4 28.7-1.2 41.6-16.5 28-20.6 62.2-10 93.9l17.5 52.4c4.4 13.1 16.6 21.9 30.4 21.9h33.7c21.8 0 37.3-21.4 30.4-42.1l-20.8-62.5c-2.1-6.4-.5-13.4 4.3-18.2l12.7-12.7c13.2-13.2 20.6-31.1 20.6-49.7 0-2.3-.1-4.6-.3-6.9l.3.1zm64-160v-32H160v32c0 35.3 28.7 64 64 64s64-28.7 64-64zm208-96a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
        }
    ]
};

const FasHorse = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHorse",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 238.1V160h16l9.8 19.6c12.5 25.1 42.2 36.4 68.3 26 20.5-8.2 33.9-28 33.9-50.1V80c0-19.1-8.4-36.3-21.7-48h5.7c8.8 0 16-7.2 16-16s-7.2-16-16-16H448c-70.7 0-128 57.3-128 128H148.8c-30.7 0-57.6 16.3-72.5 40.8C33.2 174.5 0 211.4 0 256v56c0 13.3 10.7 24 24 24s24-10.7 24-24v-56c0-13.4 6.6-25.2 16.7-32.5 1.6 13 6.3 25.4 13.6 36.4l28.2 42.4c8.3 12.4 6.4 28.7-1.2 41.6-16.5 28-20.6 62.2-10 93.9l17.5 52.4c4.4 13.1 16.6 21.9 30.4 21.9h33.7c21.8 0 37.3-21.4 30.4-42.1l-20.8-62.5c-2.1-6.4-.5-13.4 4.3-18.2l12.7-12.7c13.2-13.2 20.6-31.1 20.6-49.7 0-2.3-.1-4.6-.3-6.9l84 24c4.1 1.2 8.2 2.1 12.3 2.8V480c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V315.7c19.2-19.2 31.5-45.7 32-75.7v-1.9zM496 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
        }
    ]
};

const FasHoseReel = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHoseReel",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 64c-106 0-192 86-192 192s86 192 192 192c40.8 0 78.6-12.7 109.7-34.4 14.5-10.1 34.4-6.6 44.6 7.9s6.6 34.4-7.9 44.6C424.8 495 374.3 512 320 512 178.6 512 64 397.4 64 256S178.6 0 320 0s256 114.6 256 256v96h8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-2.3l-11.5 80.2c7.8 1.1 13.7 7.8 13.7 15.8 0 8.8-7.2 16-16 16H520c-8.8 0-16-7.2-16-16 0-8.1 6-14.7 13.7-15.8L506.3 400H504c-13.3 0-24-10.7-24-24s10.7-24 24-24h8v-96c0-106-86-192-192-192zm-96 192a96 96 0 1 0 192 0 96 96 0 1 0-192 0zm96 160a160 160 0 1 1 0-320 160 160 0 1 1 0 320zm-64-160a64 64 0 1 1 128 0 64 64 0 1 1-128 0z"
        }
    ]
};

const FasHose = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHose",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 104c0 13.3 10.7 24 24 24s24-10.7 24-24v-2.3l80.2-11.5c1.1 7.8 7.7 13.8 15.8 13.8 8.8 0 16-7.2 16-16V40c0-8.8-7.2-16-16-16-8.1 0-14.7 6-15.8 13.7L336 26.3V24c0-13.3-10.7-24-24-24s-24 10.7-24 24v80zM64 176c0-44.2 35.8-80 80-80h112V32H144C64.5 32 0 96.5 0 176s64.5 144 144 144h272c17.7 0 32-14.3 32-32s-14.3-32-32-32H144c-44.2 0-80-35.8-80-80zM32 352c-17.7 0-32 14.3-32 32s14.3 32 32 32h384c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zm0 96c-17.7 0-32 14.3-32 32s14.3 32 32 32h384c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"
        }
    ]
};

const FasHospitalUser = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHospitalUser",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 0C21.5 0 0 21.5 0 48v208h144c8.8 0 16 7.2 16 16s-7.2 16-16 16H0v64h144c8.8 0 16 7.2 16 16s-7.2 16-16 16H0v80c0 26.5 21.5 48 48 48h217.9c-6.3-10.2-9.9-22.2-9.9-35.1 0-46.9 25.8-87.8 64-109.2V48c0-26.5-21.5-48-48-48H48zm104 64h16c8.8 0 16 7.2 16 16v24h24c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-24v24c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-24h-24c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16h24V80c0-8.8 7.2-16 16-16zm360 208a80 80 0 1 0-160 0 80 80 0 1 0 160 0zM288 477.1c0 19.3 15.6 34.9 34.9 34.9h218.2c19.3 0 34.9-15.6 34.9-34.9 0-51.4-41.7-93.1-93.1-93.1H381.1c-51.4 0-93.1 41.7-93.1 93.1z"
        }
    ]
};

const FasHospital = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHospital",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 48c0-26.5 21.5-48 48-48h160c26.5 0 48 21.5 48 48v464h-80v-80c0-26.5-21.5-48-48-48s-48 21.5-48 48v80h-80V48zM48 96h112v416H48c-26.5 0-48-21.5-48-48V320h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H0v-64h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H0v-48c0-26.5 21.5-48 48-48zm544 0c26.5 0 48 21.5 48 48v48h-80c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v64h-80c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v144c0 26.5-21.5 48-48 48H480V96h112zM312 64c-8.8 0-16 7.2-16 16v24h-24c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h24v24c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-24h24c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16h-24V80c0-8.8-7.2-16-16-16h-16z"
        }
    ]
};

const FasHospitals = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHospitals",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M304 0c-26.5 0-48 21.5-48 48v16c35.3 0 64 28.7 64 64v352c0 11.7-3.1 22.6-8.6 32H528c26.5 0 48-21.5 48-48v-80H464c-8.8 0-16-7.2-16-16s7.2-16 16-16h112v-64H464c-8.8 0-16-7.2-16-16s7.2-16 16-16h112V48c0-26.5-21.5-48-48-48H304zm104 96c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v24h24c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-24v24c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-24h-24c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16h24V96zM0 144v240h144c8.8 0 16 7.2 16 16s-7.2 16-16 16H0v48c0 26.5 21.5 48 48 48h192c26.5 0 48-21.5 48-48V144c0-26.5-21.5-48-48-48H48c-26.5 0-48 21.5-48 48zm120 48c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v24h24c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-24v24c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-24H96c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16h24v-24z"
        }
    ]
};

const FasHotTubPerson = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHotTubPerson",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M272 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v5.2c0 34 14.4 66.4 39.7 89.2l16.4 14.8c15.2 13.7 23.8 33.1 23.8 53.5V200c0 13.3 10.7 24 24 24s24-10.7 24-24v-13.2c0-34-14.4-66.4-39.7-89.2l-16.4-14.8C280.7 69.1 272 49.7 272 29.2V24zM0 320v128c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V320c0-35.3-28.7-64-64-64H277.3c-13.8 0-27.3-4.5-38.4-12.8l-85.3-64C137 166.7 116.8 160 96 160c-53 0-96 43-96 96v64zm128 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16v-96c0-8.8 7.2-16 16-16s16 7.2 16 16zm80-16c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16v-96c0-8.8 7.2-16 16-16zm112 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16v-96c0-8.8 7.2-16 16-16s16 7.2 16 16zm80-16c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16v-96c0-8.8 7.2-16 16-16zM360 0c-13.3 0-24 10.7-24 24v5.2c0 34 14.4 66.4 39.7 89.2l16.4 14.8c15.2 13.7 23.8 33.1 23.8 53.5V200c0 13.3 10.7 24 24 24s24-10.7 24-24v-13.2c0-34-14.4-66.4-39.7-89.2l-16.4-14.8C392.7 69.1 384 49.7 384 29.2V24c0-13.3-10.7-24-24-24zM64 128A64 64 0 1 0 64 0a64 64 0 1 0 0 128z"
        }
    ]
};

const FasHotdog = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHotdog",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M488.6 23.4c31.2 31.2 31.2 81.9 0 113.1l-352 352c-31.2 31.2-81.9 31.2-113.1 0s-31.2-81.9 0-113.1l352-352c31.2-31.2 81.9-31.2 113.1 0zm-45.3 69.3c-6.2-6.2-16.4-6.2-22.6 0-12.5 12.5-23.8 15.1-37.5 17.6l-2.5.4c-13.8 2.5-31.6 5.6-48 22-16.7 16.7-20.9 36-24.1 50.9l-.2 1c-3.4 15.6-6 26.4-15.7 36.1s-20.5 12.3-36.1 15.7l-1 .2c-14.9 3.2-34.2 7.4-50.9 24.1s-20.9 36-24.1 50.9l-.2 1c-3.4 15.6-6 26.4-15.7 36.1-9.2 9.2-18 10.8-32.7 13.4l-.9.2c-15.6 2.8-34.9 6.9-54.4 26.4-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0c12.5-12.5 23.8-15.1 37.5-17.6l2.5-.4c13.8-2.5 31.6-5.6 48-22 16.7-16.7 20.9-36 24.1-50.9l.2-1c3.4-15.6 6-26.4 15.7-36.1s20.5-12.3 36.1-15.7l1-.2c14.9-3.2 34.2-7.4 50.9-24.1s20.9-36 24.1-50.9l.2-1c3.4-15.6 6-26.4 15.7-36.1 9.2-9.2 18-10.8 32.7-13.4l.9-.2c15.6-2.8 34.9-6.9 54.4-26.4 6.2-6.2 6.2-16.4 0-22.6zM191.2 479.2l288-288L495 207c10.9 10.9 17 25.6 17 41s-6.1 30.1-17 41L289 495c-10.9 10.9-25.6 17-41 17s-30.1-6.1-41-17l-15.8-15.8zM17 305C6.1 294.1 0 279.4 0 264s6.1-30.1 17-41L223 17c10.9-10.9 25.6-17 41-17s30.1 6.1 41 17l15.8 15.8-288 288L17 305z"
        }
    ]
};

const FasHotel = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHotel",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 32C0 14.3 14.3 0 32 0h448c17.7 0 32 14.3 32 32s-14.3 32-32 32v384c17.7 0 32 14.3 32 32s-14.3 32-32 32H304v-48c0-26.5-21.5-48-48-48s-48 21.5-48 48v48H32c-17.7 0-32-14.3-32-32s14.3-32 32-32V64C14.3 64 0 49.7 0 32zm96 80v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32zm112 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16zm-240 80c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32zm112 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32zm-40 192c13.3 0 24.3-10.9 21-23.8-10.6-41.5-48.2-72.2-93-72.2s-82.5 30.7-93 72.2c-3.3 12.8 7.8 23.8 21 23.8h144z"
        }
    ]
};

const FasHourglassClock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHourglassClock",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 0C14.3 0 0 14.3 0 32s14.3 32 32 32v11c0 42.4 16.9 83.1 46.9 113.1l67.8 67.9-67.8 67.9C48.9 353.9 32 394.6 32 437v11c-17.7 0-32 14.3-32 32s14.3 32 32 32h298.8c-45.2-31.9-74.8-84.5-74.8-144 0-27.2 6.2-53 17.2-76l-36-36 67.9-67.9c30-30 46.9-70.7 46.9-113.1V64c17.7 0 32-14.3 32-32S369.7 0 352 0H32zm64 75V64h192v11c0 19-5.6 37.4-16 53H112c-10.3-15.6-16-34-16-53zm480 293a144 144 0 1 0-288 0 144 144 0 1 0 288 0zm-144-80c8.8 0 16 7.2 16 16v48h32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16v-64c0-8.8 7.2-16 16-16z"
        }
    ]
};

const FasHourglassEnd = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHourglassEnd",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 0C14.3 0 0 14.3 0 32s14.3 32 32 32v11c0 42.4 16.9 83.1 46.9 113.1l67.8 67.9-67.8 67.9C48.9 353.9 32 394.6 32 437v11c-17.7 0-32 14.3-32 32s14.3 32 32 32h320c17.7 0 32-14.3 32-32s-14.3-32-32-32v-11c0-42.4-16.9-83.1-46.9-113.1L237.3 256l67.9-67.9c30-30 46.9-70.7 46.9-113.1V64c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zm64 75V64h192v11c0 25.5-10.1 49.9-28.1 67.9L192 210.7l-67.9-67.9C106.1 124.9 96 100.4 96 75z"
        }
    ]
};

const FasHourglassHalf = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHourglassHalf",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 0C14.3 0 0 14.3 0 32s14.3 32 32 32v11c0 42.4 16.9 83.1 46.9 113.1l67.8 67.9-67.8 67.9C48.9 353.9 32 394.6 32 437v11c-17.7 0-32 14.3-32 32s14.3 32 32 32h320c17.7 0 32-14.3 32-32s-14.3-32-32-32v-11c0-42.4-16.9-83.1-46.9-113.1L237.3 256l67.9-67.9c30-30 46.9-70.7 46.9-113.1V64c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zm64 75V64h192v11c0 19-5.6 37.4-16 53H112c-10.3-15.6-16-34-16-53zm16 309c3.5-5.3 7.6-10.3 12.1-14.9l67.9-67.8 67.9 67.9c4.6 4.6 8.6 9.6 12.1 14.9H112z"
        }
    ]
};

const FasHourglassStart = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHourglassStart",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 0C14.3 0 0 14.3 0 32s14.3 32 32 32v11c0 42.4 16.9 83.1 46.9 113.1l67.8 67.9-67.8 67.9C48.9 353.9 32 394.6 32 437v11c-17.7 0-32 14.3-32 32s14.3 32 32 32h320c17.7 0 32-14.3 32-32s-14.3-32-32-32v-11c0-42.4-16.9-83.1-46.9-113.1L237.3 256l67.9-67.9c30-30 46.9-70.7 46.9-113.1V64c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zm256 437v11H96v-11c0-25.5 10.1-49.9 28.1-67.9l67.9-67.8 67.9 67.9c18 18 28.1 42.4 28.1 67.9z"
        }
    ]
};

const FasHourglass = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHourglass",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 32C0 14.3 14.3 0 32 0h320c17.7 0 32 14.3 32 32s-14.3 32-32 32v11c0 42.4-16.9 83.1-46.9 113.1L237.3 256l67.9 67.9c30 30 46.9 70.7 46.9 113.1v11c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32v-11c0-42.4 16.9-83.1 46.9-113.1l67.8-67.9-67.8-67.9C48.9 158.1 32 117.4 32 75V64C14.3 64 0 49.7 0 32zm96 32v11c0 25.5 10.1 49.9 28.1 67.9l67.9 67.8 67.9-67.9c18-18 28.1-42.4 28.1-67.9V64H96zm0 384h192v-11c0-25.5-10.1-49.9-28.1-67.9L192 301.3l-67.9 67.9c-18 18-28.1 42.4-28.1 67.9v11z"
        }
    ]
};

const FasHouseBlank = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHouseBlank",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c.2 35.5-28.5 64.3-64 64.3H128.1c-35.3 0-64-28.7-64-64V287.6H32c-18 0-32-14-32-32.1 0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7l255.4 224.5c8 7 12 15 11 24z"
        }
    ]
};

const FasHouseBuilding = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHouseBuilding",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M368 0c-26.5 0-48 21.5-48 48v105.9l64 58.7V208c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-18.8c1.9 6.8 2.8 13.9 2.8 21.1V288h16c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-16v112c0 18-6 34.6-16 48h192c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H368zm144 208c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16zM400 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16zm112 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32zM0 277.1V464c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V277.1c0-13.5-5.6-26.3-15.6-35.4l-144-132c-18.4-16.8-46.5-16.8-64.9 0l-144 132C5.6 250.8 0 263.7 0 277.1zM144 296c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24h-48c-13.3 0-24-10.7-24-24v-48z"
        }
    ]
};

const FasHouseChimneyBlank = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHouseChimneyBlank",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M543.8 287.6c17 0 32-14 32-32.1 1-9-3-17-11-24L512 185V64c0-17.7-14.3-32-32-32h-32c-17.7 0-32 14.3-32 32v36.7L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24 0 18 14 32.1 32 32.1h32V448c0 35.3 28.7 64 64 64h320.5c35.5 0 64.2-28.8 64-64.3l-.7-160.2h32z"
        }
    ]
};

const FasHouseChimneyCrack = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHouseChimneyCrack",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c.2 35.5-28.5 64.3-64 64.3H326.4L288 448l80.8-67.3c7.8-6.5 7.6-18.6-.4-24.9l-117.8-92.6c-14.6-11.5-33.8 7-22.8 22L288 368l-85.5 71.2c-6.1 5-7.5 13.8-3.5 20.5l31.4 52.3H128.1c-35.3 0-64-28.7-64-64V287.6H32c-18 0-32-14-32-32.1 0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L416 100.7V64c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32v121l52.8 46.4c8 7 12 15 11 24z"
        }
    ]
};

const FasHouseChimneyHeart = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHouseChimneyHeart",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c.2 35.5-28.5 64.3-64 64.3H128.1c-35.3 0-64-28.7-64-64V287.6H32c-18 0-32-14-32-32.1 0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L416 100.7V64c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32v121l52.8 46.4c8 7 12 15 11 24zM237.3 208c-33.8 0-61.3 27.4-61.3 61.3 0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3 0-33.8-27.4-61.3-61.3-61.3-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9z"
        }
    ]
};

const FasHouseChimneyMedical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHouseChimneyMedical",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c.2 35.5-28.5 64.3-64 64.3H128.1c-35.3 0-64-28.7-64-64V287.6H32c-18 0-32-14-32-32.1 0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L416 100.7V64c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32v121l52.8 46.4c8 7 12 15 11 24zM272 192c-8.8 0-16 7.2-16 16v48h-48c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-48h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-48v-48c0-8.8-7.2-16-16-16h-32z"
        }
    ]
};

const FasHouseChimneyUser = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHouseChimneyUser",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M543.8 287.6c17 0 32-14 32-32.1 1-9-3-17-11-24L512 185V64c0-17.7-14.3-32-32-32h-32c-17.7 0-32 14.3-32 32v36.7L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24 0 18 14 32.1 32 32.1h32V448c0 35.3 28.7 64 64 64h320.5c35.5 0 64.2-28.8 64-64.3l-.7-160.2h32zM288 160a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM176 400c0-44.2 35.8-80 80-80h64c44.2 0 80 35.8 80 80 0 8.8-7.2 16-16 16H192c-8.8 0-16-7.2-16-16z"
        }
    ]
};

const FasHouseChimneyWindow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHouseChimneyWindow",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c.2 35.5-28.5 64.3-64 64.3H128.1c-35.3 0-64-28.7-64-64V287.6H32c-18 0-32-14-32-32.1 0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L416 100.7V64c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32v121l52.8 46.4c8 7 12 15 11 24zM248 192c-13.3 0-24 10.7-24 24v80c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24v-80c0-13.3-10.7-24-24-24h-80z"
        }
    ]
};

const FasHouseChimney = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHouseChimney",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M543.8 287.6c17 0 32-14 32-32.1 1-9-3-17-11-24L512 185V64c0-17.7-14.3-32-32-32h-32c-17.7 0-32 14.3-32 32v36.7L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24 0 18 14 32.1 32 32.1h32v69.7c-.1.9-.1 1.8-.1 2.8V472c0 22.1 17.9 40 40 40h16c1.2 0 2.4-.1 3.6-.2 1.5.1 3 .2 4.5.2h56c22.1 0 40-17.9 40-40v-88c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v88c0 22.1 17.9 40 40 40h56.5c1.4 0 2.8 0 4.2-.1 1.1.1 2.2.1 3.3.1h16c22.1 0 40-17.9 40-40v-16.2c.3-2.6.5-5.3.5-8.1l-.7-160.2h32z"
        }
    ]
};

const FasHouseCircleCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHouseCircleCheck",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320.7 352c8.1-89.7 83.5-160 175.3-160 8.9 0 17.6.7 26.1 1.9L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24 0 18 14 32.1 32 32.1h32v69.7c-.1.9-.1 1.8-.1 2.8V472c0 22.1 17.9 40 40 40h16c1.2 0 2.4-.1 3.6-.2 1.5.1 3 .2 4.5.2h56c22.1 0 40-17.9 40-40v-88c0-17.7 14.3-32 32-32h64.7zM640 368a144 144 0 1 0-288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l28.7 28.7 60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"
        }
    ]
};

const FasHouseCircleExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHouseCircleExclamation",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320.7 352c8.1-89.7 83.5-160 175.3-160 8.9 0 17.6.7 26.1 1.9L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24 0 18 14 32.1 32 32.1h32v69.7c-.1.9-.1 1.8-.1 2.8V472c0 22.1 17.9 40 40 40h16c1.2 0 2.4-.1 3.6-.2 1.5.1 3 .2 4.5.2h56c22.1 0 40-17.9 40-40v-88c0-17.7 14.3-32 32-32h64.7zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16v-80c0-8.8 7.2-16 16-16z"
        }
    ]
};

const FasHouseCircleXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHouseCircleXmark",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320.7 352c8.1-89.7 83.5-160 175.3-160 8.9 0 17.6.7 26.1 1.9L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24 0 18 14 32.1 32 32.1h32v69.7c-.1.9-.1 1.8-.1 2.8V472c0 22.1 17.9 40 40 40h16c1.2 0 2.4-.1 3.6-.2 1.5.1 3 .2 4.5.2h56c22.1 0 40-17.9 40-40v-88c0-17.7 14.3-32 32-32h64.7zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L518.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l36.7-36.7-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l36.7 36.7 36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
        }
    ]
};

const FasHouseCrack = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHouseCrack",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M543.8 287.6c17 0 32-14 32-32.1 1-9-3-17-11-24L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24 0 18 14 32.1 32 32.1h32V448c0 35.3 28.7 64 64 64h102.4l-31.3-52.2c-4.1-6.8-2.6-15.5 3.5-20.5L288 368l-60.2-82.8c-10.9-15 8.2-33.5 22.8-22l117.9 92.6c8 6.3 8.2 18.4.4 24.9L288 448l38.4 64h122.1c35.5 0 64.2-28.8 64-64.3l-.7-160.2h32z"
        }
    ]
};

const FasHouseDay = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHouseDay",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M174.2 8.3c-2.8-5.1-8.2-8.4-14.1-8.4S148.8 3.1 146 8.3l-27.6 51.2-55.6-16.6c-5.6-1.7-11.7-.1-15.9 4s-5.7 10.3-4 15.9l16.7 55.7-51.3 27.6c-5.2 2.8-8.4 8.2-8.4 14.1s3.2 11.3 8.4 14.1l51.2 27.6-16.7 55.7c-1.7 5.6-.1 11.7 4 15.9s10.3 5.7 15.9 4l55.7-16.7 14.7 27.2 57.4-53c-9.4 3.9-19.7 6-30.5 6-44.2 0-80-35.8-80-80s35.8-80 80-80 80 35.8 80 80c0 13.1-3.1 25.4-8.7 36.3l64.7-59.8-35.3-19 16.7-55.7c1.7-5.6.1-11.7-4-15.9s-10.3-5.7-15.9-4l-55.7 16.6-27.6-51.2zM112 160a48 48 0 1 1 96 0 48 48 0 1 1-96 0zm309.7-55.5c-12.3-11.3-31.2-11.3-43.4 0l-208 192c-9.7 8.9-12.9 22.9-8.1 35.2S178.8 352 192 352h32v112c0 26.5 21.5 48 48 48h256c26.5 0 48-21.5 48-48V352h32c13.2 0 25-8.1 29.8-20.3s1.6-26.2-8.1-35.2l-208-192zM352 304c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16v-64z"
        }
    ]
};

const FasHouseFire = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHouseFire",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 350.1v1.9h-32c-17.7 0-32 14.3-32 32v88c0 22.1-17.9 40-40 40h-55.9c-1.5 0-3-.1-4.5-.2-1.2.1-2.4.2-3.6.2h-16c-22.1 0-40-17.9-40-40V360c0-.9 0-1.9.1-2.8v-69.6H32c-18 0-32-14-32-32.1 0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7l137.9 121.1c-12.3-1-25 3-34.8 11.7-35.4 31.6-65.6 67.7-87.3 102.8-20.9 33.9-37.2 72.3-37.2 107.5zm165.5-186.3c19.7 17.8 38.2 37 55.5 57.7 7.9-9.9 16.8-20.7 26.5-29.5 5.6-5.1 14.4-5.1 20 0 24.7 22.7 45.6 52.7 60.4 81.1 14.5 28 24.2 58.8 24.2 79C640 440 568.7 512 480 512c-89.7 0-160-72.1-160-159.8 0-26.4 12.7-60.7 32.4-92.6 20-32.4 48.1-66.1 81.4-95.8 2.8-2.5 6.4-3.8 10-3.7 3.5 0 7 1.3 9.8 3.8zM530 433c30-21 38-63 20-96-2-4-4-8-7-12l-36 42s-58-74-62-79c-30 37-45 58-45 82 0 49 36 78 81 78 18 0 34-5 49-15z"
        }
    ]
};

const FasHouseFlag = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHouseFlag",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 0c-17.7 0-32 14.3-32 32v480h64V192h112c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H512c0-17.7-14.3-32-32-32zm-64 159L276.8 39.7c-12-10.3-29.7-10.3-41.7 0l-224 192C1 240.4-2.7 254.5 2 267.1S18.6 288 32 288h32v192c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32v-96c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v96c0 17.7 14.3 32 32 32h64.9-1V159z"
        }
    ]
};

const FasHouseFloodWaterCircleArrowRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHouseFloodWaterCircleArrowRight",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 144a144 144 0 1 0-288 0 144 144 0 1 0 288 0zM140.7 76.7c6.2-6.2 16.4-6.2 22.6 0l56 56c6.2 6.2 6.2 16.4 0 22.6l-56 56c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l28.7-28.7H80c-8.8 0-16-7.2-16-16s7.2-16 16-16h89.4l-28.7-28.7c-6.2-6.2-6.2-16.4 0-22.6zM320 144c0 57.3-27.4 108.2-69.8 140.3 11.8-3.6 23-9.4 33-16.2 22.1-15.5 51.6-15.5 73.7 0 18.4 12.7 39.6 20.3 59.2 20.3 19 0 41.2-7.9 59.2-20.3 23.8-16.7 55.8-15.4 78.1 3.4 2.1 1.7 4.2 3.3 6.5 4.9l-.3-84.4H576c13.9 0 26.1-8.9 30.4-22.1s-.4-27.6-11.6-35.8l-176-128c-11.2-8.1-26.4-8.1-37.6 0L301 64.4c12.1 23.9 19 50.9 19 79.6zm18.5 165.9c-11.1-7.9-25.9-7.9-37 0-22.5 15.5-50 26.1-77.5 26.1-26.9 0-55.3-10.8-77.4-26.1-11.9-8.5-28.1-7.8-39.2 1.7-14.4 11.9-32.5 21-50.6 25.2-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25 29 15.6 61.5 25.9 94.5 25.9 31.9 0 60.6-9.9 80.4-18.9 5.8-2.7 11.1-5.3 15.6-7.7 4.5 2.4 9.7 5.1 15.6 7.7 19.8 9 48.6 18.9 80.4 18.9 33 0 65.5-10.3 94.5-25.8 13.4 8.4 33.7 19.3 58.2 25 17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2-11.1-9.5-27.3-10.1-39.2-1.7-22 15.2-50.5 26-77.4 26-27.5 0-55-10.6-77.5-26.1zm0 112c-11.1-7.9-25.9-7.9-37 0-22.5 15.5-50 26.1-77.5 26.1-26.9 0-55.3-10.8-77.4-26.1-11.9-8.5-28.1-7.8-39.2 1.7-14.4 11.9-32.5 21-50.6 25.2-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25 29 15.6 61.5 25.9 94.5 25.9 31.9 0 60.6-9.9 80.4-18.9 5.8-2.7 11.1-5.3 15.6-7.7 4.5 2.4 9.7 5.1 15.6 7.7 19.8 9 48.6 18.9 80.4 18.9 33 0 65.5-10.3 94.5-25.8 13.4 8.4 33.7 19.3 58.2 25 17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2-11.1-9.4-27.3-10.1-39.2-1.7-22 15.2-50.5 26-77.4 26-27.5 0-55-10.6-77.5-26.1z"
        }
    ]
};

const FasHouseFloodWater = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHouseFloodWater",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M306.8 6.1c-11.2-8.1-26.4-8.1-37.6 0l-176 128c-11.2 8.2-15.9 22.6-11.6 35.8S98.1 192 112 192h16v73c1.7 1 3.3 2 4.9 3.1 18 12.4 40.1 20.3 59.2 20.3 21.1 0 42-8.5 59.2-20.3 22.1-15.5 51.6-15.5 73.7 0 18.4 12.7 39.6 20.3 59.2 20.3 19 0 41.2-7.9 59.2-20.3 1.5-1 3-2 4.5-2.9l-.3-73.2H464c13.9 0 26.1-8.9 30.4-22.1s-.4-27.6-11.6-35.8l-176-128zm-37.3 303.8C247 325.4 219.5 336 192 336c-26.9 0-55.3-10.8-77.4-26.1-11.9-8.5-28.1-7.8-39.2 1.7-14.4 11.9-32.5 21-50.6 25.2-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25 29 15.6 61.5 25.9 94.5 25.9 31.9 0 60.6-9.9 80.4-18.9 5.8-2.7 11.1-5.3 15.6-7.7 4.5 2.4 9.7 5.1 15.6 7.7 19.8 9 48.5 18.9 80.4 18.9 33 0 65.5-10.3 94.5-25.8 13.4 8.4 33.7 19.3 58.2 25 17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2-11.1-9.5-27.3-10.1-39.2-1.7-22 15.2-50.5 26-77.4 26-27.5 0-55-10.6-77.5-26.1-11.1-7.9-25.9-7.9-37 0zM384 448c-27.5 0-55-10.6-77.5-26.1-11.1-7.9-25.9-7.9-37 0-22.5 15.5-50 26.1-77.5 26.1-26.9 0-55.3-10.8-77.4-26.1-11.9-8.5-28.1-7.8-39.2 1.7-14.4 11.9-32.5 21-50.6 25.2-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25 29 15.6 61.5 25.9 94.5 25.9 31.9 0 60.6-9.9 80.4-18.9 5.8-2.7 11.1-5.3 15.6-7.7 4.5 2.4 9.7 5.1 15.6 7.7 19.8 9 48.5 18.9 80.4 18.9 33 0 65.5-10.3 94.5-25.8 13.4 8.4 33.7 19.3 58.2 25 17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2-11.1-9.4-27.3-10.1-39.2-1.7-22 15.2-50.5 26-77.4 26z"
        }
    ]
};

const FasHouseHeart = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHouseHeart",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M543.8 287.6c17 0 32-14 32-32.1 1-9-3-17-11-24L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24 0 18 14 32.1 32 32.1h32V448c0 35.3 28.7 64 64 64h320.5c35.5 0 64.2-28.8 64-64.3l-.7-160.2h32zM176 269.3c0-33.8 27.4-61.3 61.3-61.3 16.2 0 31.8 6.5 43.3 17.9l7.4 7.4 7.4-7.4c11.5-11.5 27.1-17.9 43.3-17.9 33.8 0 61.3 27.4 61.3 61.3 0 16.2-6.5 31.8-17.9 43.3l-82.7 82.7c-6.2 6.2-16.4 6.2-22.6 0l-82.7-82.7c-11.5-11.5-17.9-27.1-17.9-43.3z"
        }
    ]
};

const FasHouseLaptop = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHouseLaptop",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M218.3 8.5c12.3-11.3 31.2-11.3 43.4 0l208 192c6.7 6.2 10.3 14.8 10.3 23.5H336c-19.1 0-36.3 8.4-48 21.7V208c0-8.8-7.2-16-16-16h-64c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h64v128H112c-26.5 0-48-21.5-48-48V256H32c-13.2 0-25-8.1-29.8-20.3s-1.6-26.2 8.1-35.2l208-192zM352 304v144h192V304H352zm-48-16c0-17.7 14.3-32 32-32h224c17.7 0 32 14.3 32 32v160h32c8.8 0 16 7.2 16 16 0 26.5-21.5 48-48 48H304c-26.5 0-48-21.5-48-48 0-8.8 7.2-16 16-16h32V288z"
        }
    ]
};

const FasHouseLock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHouseLock",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 480c0 11.7 3.1 22.6 8.6 32h-.6c-22.1 0-40-17.9-40-40v-88c0-17.7-14.3-32-32-32h-64c-17.7 0-32 14.3-32 32v88c0 22.1-17.9 40-40 40h-55.9c-1.5 0-3-.1-4.5-.2-1.2.1-2.4.2-3.6.2h-16c-22.1 0-40-17.9-40-40V360c0-.9 0-1.9.1-2.8v-69.6H32c-18 0-32-14-32-32.1 0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7l181.3 159.3C447.2 181.7 416 223.2 416 272v24.6c-19.1 11.1-32 31.7-32 55.4v128zm144-240c-17.7 0-32 14.3-32 32v48h64v-48c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32v128c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32v-48z"
        }
    ]
};

const FasHouseMedicalCircleCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHouseMedicalCircleCheck",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 368c0 59.5 29.5 112.1 74.8 144H128.1c-35.3 0-64-28.7-64-64V287.6H32c-18 0-32-14-32-32.1 0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7l212.7 186.9c-8.5-1.3-17.3-1.9-26.1-1.9-54.7 0-103.5 24.9-135.8 64H320v-48c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48h-48c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16zm32 0a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L480 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"
        }
    ]
};

const FasHouseMedicalCircleExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHouseMedicalCircleExclamation",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 368c0 59.5 29.5 112.1 74.8 144H128.1c-35.3 0-64-28.7-64-64V287.6H32c-18 0-32-14-32-32.1 0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7l212.7 186.9c-8.5-1.3-17.3-1.9-26.1-1.9-54.7 0-103.5 24.9-135.8 64H320v-48c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48h-48c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16zm176-144a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-192c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16v-80c0-8.8-7.2-16-16-16z"
        }
    ]
};

const FasHouseMedicalCircleXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHouseMedicalCircleXmark",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 368c0 59.5 29.5 112.1 74.8 144H128.1c-35.3 0-64-28.7-64-64V287.6H32c-18 0-32-14-32-32.1 0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7l212.7 186.9c-8.5-1.3-17.3-1.9-26.1-1.9-54.7 0-103.5 24.9-135.8 64H320v-48c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48h-48c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16zm176-144a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm22.6 144 36.7-36.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L496 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l36.7 36.7-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l36.7-36.7 36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L518.6 368z"
        }
    ]
};

const FasHouseMedicalFlag = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHouseMedicalFlag",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 0c17.7 0 32 14.3 32 32h112c8.8 0 16 7.2 16 16v128c0 8.8-7.2 16-16 16H512v320h-64V32c0-17.7 14.3-32 32-32zM276.8 39.7 416 159v353h1H96c-17.7 0-32-14.3-32-32V288H32c-13.4 0-25.4-8.3-30-20.9s-1-26.7 9.2-35.4l224-192c12-10.3 29.7-10.3 41.7 0zM224 208v48h-48c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-48h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-48v-48c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16z"
        }
    ]
};

const FasHouseMedical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHouseMedical",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M543.8 287.6c17 0 32-14 32-32.1 1-9-3-17-11-24L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24 0 18 14 32.1 32 32.1h32V448c0 35.3 28.7 64 64 64h320.5c35.5 0 64.2-28.8 64-64.3l-.7-160.2h32zM256 208c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-48v48c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-48h-48c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h48v-48z"
        }
    ]
};

const FasHouseNight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHouseNight",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M125.2 16.1c6.2-4.4 5.4-14.8-2.2-15.6-3.6-.4-7.3-.5-11-.5C50.1 0 0 50.1 0 112s50.1 112 112 112c32.1 0 61.1-13.5 81.5-35.2 5.2-5.6-1-14-8.6-13.2-2.9.3-5.9.4-9 .4-48.6 0-88-39.4-88-88 0-29.7 14.7-55.9 37.2-71.9zm138.3-3.8c-2.6-7-12.4-7-15 0l-11.9 32.3-32.3 11.9c-7 2.6-7 12.4 0 15l32.3 11.9 11.9 32.3c2.6 7 12.4 7 15 0l11.9-32.3 32.3-11.9c7-2.6 7-12.4 0-15l-32.3-11.9-11.9-32.3zm158.2 92.2c-12.3-11.3-31.2-11.3-43.4 0l-208 192c-9.7 8.9-12.9 22.9-8.1 35.2S178.8 352 192 352h32v112c0 26.5 21.5 48 48 48h256c26.5 0 48-21.5 48-48V352h32c13.2 0 25-8.1 29.8-20.3s1.6-26.2-8.1-35.2l-208-192zM352 304c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16v-64zM88.5 332.3l-11.9 32.3-32.3 11.9c-7 2.6-7 12.4 0 15l32.3 11.9 11.9 32.3c2.6 7 12.4 7 15 0l11.9-32.3 32.3-11.9c7-2.6 7-12.4 0-15l-32.3-11.9-11.9-32.3c-2.6-7-12.4-7-15 0z"
        }
    ]
};

const FasHousePersonLeave = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHousePersonLeave",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M218.3 8.5c12.3-11.3 31.2-11.3 43.4 0l117.8 108.7c-32.6 19.5-57.5 50.2-69.6 86.7l-2.6 7.8c-11.2 33.5 6.9 69.8 40.5 81 15.8 5.3 32.2 4 46.3-2.3L361.5 372l-44 44H112c-26.5 0-48-21.5-48-48V256H32c-13.2 0-25-8.1-29.8-20.3s-1.6-26.2 8.1-35.2l208-192zM128 208v64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16h-64c-8.8 0-16 7.2-16 16zM528 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm-84.3 200.5-8 3.5c-16.4 7.3-29 21.2-34.7 38.2l-2.6 7.8c-5.6 16.8-23.7 25.8-40.5 20.2s-25.8-23.7-20.2-40.5l2.6-7.8c11.4-34.1 36.6-61.9 69.4-76.5l8-3.5c20.8-9.2 43.3-14 66.1-14 44.6 0 84.8 26.8 101.9 67.9l15.3 36.9 21.4 10.7c15.8 7.9 22.2 27.1 14.3 42.9s-27.1 22.2-42.9 14.3L567 287.3c-10.3-5.2-18.4-13.8-22.8-24.5l-9.6-23-19.3 65.5 49.5 54c5.4 5.9 9.2 13 11.2 20.8l23 92.1c4.3 17.1-6.1 34.5-23.3 38.8s-34.5-6.1-38.8-23.3l-22-88.1-70.7-77.1c-14.8-16.1-20.3-38.6-14.7-59.7l16.9-63.5c-1 .4-1.9.8-2.9 1.2zm-30 135.1c2.1 3 4.5 5.8 7 8.6l40.7 44.4-14.5 36.2c-2.4 6-6 11.5-10.6 16.1l-61.7 61.7c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l59.4-59.3 25-62.4z"
        }
    ]
};

const FasHousePersonReturn = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHousePersonReturn",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M218.3 8.5c12.3-11.3 31.2-11.3 43.4 0l127.2 117.4c-19 14.8-34.4 34.5-44.1 57.7l-10.7 25.8-10.7 5.4c-31.6 15.8-44.4 54.3-28.6 85.9 15.4 30.9 52.5 43.8 83.6 29.7l-6.8 7.5c-9 9.8-15.4 21.7-18.6 34.7L342 416H112c-26.5 0-48-21.5-48-48V256H32c-13.2 0-25-8.1-29.8-20.3s-1.6-26.2 8.1-35.2l208-192zM128 208v64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16h-64c-8.8 0-16 7.2-16 16zM432 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm84.3 200.5c-1-.4-1.9-.8-2.9-1.2l16.9 63.5c5.6 21.1.1 43.6-14.7 59.7l-70.7 77.1-22 88.1c-4.3 17.1-21.7 27.6-38.8 23.3s-27.6-21.7-23.3-38.8l23-92.1c1.9-7.8 5.8-14.9 11.2-20.8l49.5-54-19.3-65.5-9.6 23c-4.4 10.6-12.5 19.3-22.8 24.5l-26.7 13.3c-15.8 7.9-35 1.5-42.9-14.3s-1.5-35 14.3-42.9l21.5-10.7 15.3-36.8c17.1-41.1 57.3-67.9 101.9-67.9 22.8 0 45.3 4.8 66.1 14l8 3.5c32.9 14.6 58.1 42.4 69.4 76.5l2.6 7.8c5.6 16.8-3.5 34.9-20.2 40.5s-34.9-3.5-40.5-20.2l-2.6-7.8c-5.7-17.1-18.3-30.9-34.7-38.2l-8-3.5zm30 135.1 25 62.4 59.4 59.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L523.7 441c-4.6-4.6-8.2-10.1-10.6-16.1l-14.5-36.2 40.7-44.4c2.5-2.7 4.8-5.6 7-8.6z"
        }
    ]
};

const FasHouseSignal = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHouseSignal",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M357.7 8.5c-12.3-11.3-31.2-11.3-43.4 0l-208 192c-9.4 8.6-12.7 22-8.5 34 87.1 25.3 155.6 94.2 180.3 181.6H464c26.5 0 48-21.5 48-48V256h32c13.2 0 25-8.1 29.8-20.3s1.6-26.2-8.1-35.2l-208-192zM288 208c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16v-64zM24 256c-13.3 0-24 10.7-24 24s10.7 24 24 24c101.6 0 184 82.4 184 184 0 13.3 10.7 24 24 24s24-10.7 24-24c0-128.1-103.9-232-232-232zm8 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM0 376c0 13.3 10.7 24 24 24 48.6 0 88 39.4 88 88 0 13.3 10.7 24 24 24s24-10.7 24-24c0-75.1-60.9-136-136-136-13.3 0-24 10.7-24 24z"
        }
    ]
};

const FasHouseTree = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHouseTree",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M393.4 9.4c12.5-12.5 32.8-12.5 45.3 0l128 128c9.2 9.2 11.9 22.9 6.9 34.9S557 192.1 544 192.1h-29.4L601 300c7.7 9.6 9.2 22.8 3.9 33.9S588.3 352 576 352h-29.4L633 460c7.7 9.6 9.2 22.8 3.9 33.9S620.3 512 608 512H400c10-13.4 16-30 16-48V277.1c0-22.4-9.4-43.8-25.9-59l-107.2-98.2L393.4 9.4zM0 277.1c0-13.5 5.6-26.3 15.6-35.4l144-132c18.4-16.8 46.5-16.8 64.9 0l144 132c9.9 9.1 15.6 21.9 15.6 35.4V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V277.1zM144 296v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24h-48c-13.3 0-24 10.7-24 24z"
        }
    ]
};

const FasHouseTsunami = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHouseTsunami",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80.8 136.5C104.9 93.8 152.6 64 209 64c16.9 0 33.1 2.7 48.2 7.7 16.8 5.5 34.9-3.6 40.4-20.4s-3.6-34.9-20.4-40.4C255.8 3.8 232.8 0 209 0 95.2 0 0 88 0 200c0 91.6 53.5 172.1 142.2 194.1 13.4 3.8 27.5 5.9 42.2 5.9.7 0 1.4 0 2.1-.1 1.8 0 3.7.1 5.5.1 31.9 0 60.6-9.9 80.4-18.9 5.8-2.7 11.1-5.3 15.6-7.7 4.5 2.4 9.7 5.1 15.6 7.7 19.8 9 48.5 18.9 80.4 18.9 33 0 65.5-10.3 94.5-25.8 13.4 8.4 33.7 19.3 58.2 25 17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2-11.1-9.5-27.3-10.1-39.2-1.7-22 15.2-50.5 26-77.4 26-27.5 0-55-10.6-77.5-26.1-11.1-7.9-25.9-7.9-37 0-22.4 15.5-49.9 26.1-77.4 26.1h-.1c-12.4 0-24-1.5-34.9-4.3C121.6 320.2 96 287 96 248c0-48.5 39.5-88 88.4-88 13.5 0 26.1 3 37.5 8.3 16 7.5 35.1.6 42.5-15.5s.6-35.1-15.5-42.5c-19.6-9.2-41.5-14.3-64.5-14.3-40 0-76.4 15.4-103.6 40.5zm252-18.1c-8.1 6-12.8 15.5-12.8 25.6v121c1.6 1 3.3 2 4.8 3.1 18.4 12.7 39.6 20.3 59.2 20.3 19 0 41.2-7.9 59.2-20.3 23.8-16.7 55.8-15.3 78.1 3.4 10.6 8.8 24.2 15.6 37.3 18.6 5.8 1.4 11.2 3.4 16.2 6.2.7-2.7 1.1-5.5 1.1-8.4l-.4-144c0-10-4.7-19.4-12.7-25.5l-95.5-72a31.95 31.95 0 0 0-38.5 0l-96 72zM384 448c-27.5 0-55-10.6-77.5-26.1-11.1-7.9-25.9-7.9-37 0-22.5 15.5-50 26.1-77.5 26.1-26.9 0-55.3-10.8-77.4-26.1-11.9-8.5-28.1-7.8-39.2 1.7-14.4 11.9-32.5 21-50.6 25.2-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25 29 15.6 61.5 25.9 94.5 25.9 31.9 0 60.6-9.9 80.4-18.9 5.8-2.7 11.1-5.3 15.6-7.7 4.5 2.4 9.7 5.1 15.6 7.7 19.8 9 48.5 18.9 80.4 18.9 33 0 65.5-10.3 94.5-25.8 13.4 8.4 33.7 19.3 58.2 25 17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2-11.1-9.4-27.3-10.1-39.2-1.7-22 15.2-50.5 26-77.4 26z"
        }
    ]
};

const FasHouseTurret = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHouseTurret",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 464V277.1c0-13.5 5.6-26.3 15.6-35.4l144-132c18.4-16.8 46.5-16.8 64.9 0l144 132c9.9 9.1 15.6 21.9 15.6 35.4V464c0 26.5-21.5 48-48 48H304c-26.5 0-48-21.5-48-48zm168-192c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24h-48zM24 0C10.7 0 0 10.7 0 24v173.5c0 17 6.7 33.3 18.7 45.3L64 288v176c0 26.5 21.5 48 48 48h128c-10-13.4-16-30-16-48V277.1c0-22.4 9.4-43.8 25.9-59L352 124.6V24c0-13.3-10.7-24-24-24h-48c-13.3 0-24 10.7-24 24v72h-32V24c0-13.3-10.7-24-24-24h-48c-13.3 0-24 10.7-24 24v72H96V24C96 10.7 85.3 0 72 0H24zm152 160c22.1 0 40 17.9 40 40v24c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16v-24c0-22.1 17.9-40 40-40z"
        }
    ]
};

const FasHouseUser = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHouseUser",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c.2 35.5-28.5 64.3-64 64.3H128.1c-35.3 0-64-28.7-64-64V287.6H32c-18 0-32-14-32-32.1 0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7l255.4 224.5c8 7 12 15 11 24zM352 224a64 64 0 1 0-128 0 64 64 0 1 0 128 0zm-96 96c-44.2 0-80 35.8-80 80 0 8.8 7.2 16 16 16h192c8.8 0 16-7.2 16-16 0-44.2-35.8-80-80-80h-64z"
        }
    ]
};

const FasHouseWater = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHouseWater",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M543.8 287.6c17 0 32-14 32-32.1 1-9-3-17-11-24L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24 0 18 14 32.1 32 32.1h32V393c21.3-12.2 48.1-11.4 68.8 3.1 18 12.4 40.1 20.3 59.2 20.3 21.1 0 42-8.5 59.2-20.3 22.1-15.5 51.6-15.5 73.7 0 18.4 12.7 39.6 20.3 59.2 20.3 19 0 41.2-7.9 59.2-20.3 20.7-14.6 47.7-15.4 69.1-3l-.5-105.6h32zM224 216c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24h-80c-13.3 0-24-10.7-24-24v-80zm82.5 205.9c-11.1-7.9-25.9-7.9-37 0-22.5 15.5-50 26.1-77.5 26.1-26.9 0-55.3-10.8-77.4-26.1-11.9-8.5-28.1-7.8-39.2 1.7-14.4 11.9-32.5 21-50.6 25.2-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25 29 15.6 61.5 25.9 94.5 25.9 31.9 0 60.6-9.9 80.4-18.9 5.8-2.7 11.1-5.3 15.6-7.7 4.5 2.4 9.7 5.1 15.6 7.7 19.8 9 48.5 18.9 80.4 18.9 33 0 65.5-10.3 94.5-25.8 13.4 8.4 33.7 19.3 58.2 25 17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2-11.1-9.4-27.3-10.1-39.2-1.7-22 15.2-50.5 26-77.4 26-27.5 0-55-10.6-77.5-26.1z"
        }
    ]
};

const FasHouseWindow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHouseWindow",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M543.8 287.6c17 0 32-14 32-32.1 1-9-3-17-11-24L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24 0 18 14 32.1 32 32.1h32V448c0 35.3 28.7 64 64 64h320.5c35.5 0 64.2-28.8 64-64.3l-.7-160.2h32zM248 192h80c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24h-80c-13.3 0-24-10.7-24-24v-80c0-13.3 10.7-24 24-24z"
        }
    ]
};

const FasHouse = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHouse",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c0 2.7-.2 5.4-.5 8.1V472c0 22.1-17.9 40-40 40h-16c-1.1 0-2.2 0-3.3-.1-1.4.1-2.8.1-4.2.1H392c-22.1 0-40-17.9-40-40v-88c0-17.7-14.3-32-32-32h-64c-17.7 0-32 14.3-32 32v88c0 22.1-17.9 40-40 40h-55.9c-1.5 0-3-.1-4.5-.2-1.2.1-2.4.2-3.6.2h-16c-22.1 0-40-17.9-40-40V360c0-.9 0-1.9.1-2.8v-69.6H32c-18 0-32-14-32-32.1 0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7l255.4 224.5c8 7 12 15 11 24z"
        }
    ]
};

const FasHryvniaSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHryvniaSign",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M121.9 116.2c16.4-13.1 36.8-20.2 57.7-20.2H223c27.1 0 49 21.9 49 49 0 11.5-4 22.4-11.1 31H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h123.5l-50.6 28.9c-1.7 1-3.4 2-5.1 3.1H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h20.3c-2.8 9.9-4.3 20.4-4.3 31 0 62.4 50.6 113 113 113h43.4c35.5 0 70-12.1 97.7-34.3l5.9-4.7c13.8-11 16-31.2 5-45s-31.2-16-45-5l-5.9 4.7c-16.4 13.1-36.7 20.2-57.7 20.2H161c-27.1 0-49-21.9-49-49 0-11.5 4-22.4 11.1-31H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H228.5l50.6-28.9c1.7-1 3.4-2 5.1-3.1H352c17.7 0 32-14.3 32-32s-14.3-32-32-32h-20.3c2.8-10 4.3-20.4 4.3-31 0-62.4-50.6-113-113-113h-43.4c-35.5 0-70 12.1-97.7 34.3L76 71c-13.8 11-16 31.2-5 45s31.2 16 45 5l5.9-4.7z"
        }
    ]
};

const FasHundredPoints = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHundredPoints",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M163 101.8c5-39.9 38.9-69.8 79-69.8 47.9 0 85 42 79 89.5l-12 96.7c-5 39.8-38.9 69.8-79 69.8-47.9 0-85-42-79-89.5l12-96.7zm79-5.8c-7.9 0-14.5 5.9-15.5 13.7l-12.1 96.7c-1.2 9.3 6.1 17.6 15.5 17.6 7.9 0 14.5-5.9 15.5-13.7l12.1-96.7c1.2-9.3-6.1-17.6-15.5-17.6zM135.7 68l-32 224c-2.5 17.5-18.7 30-36.2 27.7S37.8 301.5 40.3 284l24-167.5-19.7 8.7c-16.2 7.2-35.1 0-42-16.1S3.2 74 19.4 66.8l72-32c10.6-4.7 22.9-3.4 32.1 3.5s13.8 18.2 12.2 29.7zm376 247.5c2.5 17.5-9.7 33.7-27.2 36.2l-448 64C19 418.2 2.8 406 .3 388.5s9.7-33.7 27.2-36.2l448-64c17.5-2.5 33.7 9.7 36.2 27.2zm0 96c2.5 17.5-9.7 33.7-27.2 36.2l-224 32c-17.5 2.5-33.7-9.7-36.2-27.2s9.7-33.7 27.2-36.2l224-32c17.5-2.5 33.7 9.7 36.2 27.2zM427.7 32c46.9 0 83.7 40.3 79.5 87l-7.3 80.4c-3.7 41.1-38.2 72.6-79.5 72.6-46.9 0-83.7-40.3-79.5-87l7.3-80.4c3.7-41.1 38.2-72.6 79.5-72.6zM412 110.4l-7.3 80.4c-.8 9.3 6.4 17.2 15.7 17.2 8.2 0 15-6.2 15.7-14.4l7.3-80.4c.8-9.3-6.4-17.2-15.7-17.2-8.2 0-15 6.2-15.7 14.4z"
        }
    ]
};

const FasHurricane = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHurricane",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 208C0 104.4 75.7 18.5 174.9 2.6c9.1-1.4 17.1 6 17.1 15.3v63.3c0 8.4 6.5 15.3 14.7 16.5C307 112.5 384 199 384 303.4c0 103.6-75.7 189.5-174.9 205.4-9.2 1.5-17.1-5.9-17.1-15.2v-63.4c0-8.4-6.5-15.3-14.7-16.5C77 398.9 0 312.4 0 208zm288 48a96 96 0 1 0-192 0 96 96 0 1 0 192 0zm-96-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FasHyphen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasHyphen",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 256c0-17.7 14.3-32 32-32h256c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32z"
        }
    ]
};

const FasICursor = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasICursor",
    "viewBox": "0 0 256 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M.1 29.3C-1.4 47 11.7 62.4 29.3 63.9l8 .7C70.5 67.3 96 95 96 128.3V224H64c-17.7 0-32 14.3-32 32s14.3 32 32 32h32v95.7c0 33.3-25.5 61-58.7 63.8l-8 .7C11.7 449.6-1.4 465 .1 482.7s16.9 30.7 34.5 29.2l8-.7c34.1-2.8 64.2-18.9 85.4-42.9 21.2 24 51.2 40.1 85.4 42.9l8 .7c17.6 1.5 33.1-11.6 34.5-29.2s-11.6-33.1-29.2-34.5l-8-.7c-33.2-2.8-58.7-30.5-58.7-63.8V288h32c17.7 0 32-14.3 32-32s-14.3-32-32-32h-32v-95.7c0-33.3 25.5-61 58.7-63.8l8-.7c17.6-1.5 30.7-16.9 29.2-34.5S239-1.4 221.3.1l-8 .7c-34.1 2.8-64.1 18.9-85.3 42.9-21.2-24-51.2-40-85.4-42.9l-8-.7C17-1.4 1.6 11.7.1 29.3z"
        }
    ]
};

const FasI = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasI",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 32C14.3 32 0 46.3 0 64s14.3 32 32 32h96v320H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h256c17.7 0 32-14.3 32-32s-14.3-32-32-32h-96V96h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"
        }
    ]
};

const FasIceCream = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasIceCream",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M367.1 160c.6-5.3.9-10.6.9-16C368 64.5 303.5 0 224 0S80 64.5 80 144c0 5.4.3 10.7.9 16H80c-26.5 0-48 21.5-48 48s21.5 48 48 48h288c26.5 0 48-21.5 48-48s-21.5-48-48-48h-.9zM96 288l104.8 209.7c4.4 8.8 13.3 14.3 23.2 14.3s18.8-5.5 23.2-14.3L352 288H96z"
        }
    ]
};

const FasIceSkate = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasIceSkate",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 336c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V132.2c0-21.4 14.2-40.3 34.8-46.2L256 32c0-17.7 14.3-32 32-32s32 14.3 32 32v64h-48c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v32h-48c-8.8 0-16 7.2-16 16s7.2 16 16 16h48l119.3 29.8C482 232.5 512 270.9 512 315v21zm40 72c13.3 0 24 10.7 24 24v8c0 39.8-32.2 72-72 72H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h72v-48h48v48h240v-48h48v48h72c13.3 0 24-10.7 24-24v-8c0-13.3 10.7-24 24-24z"
        }
    ]
};

const FasIcicles = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasIcicles",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M75.8 304.8 1 35.7c-.7-2.5-1-5-1-7.5C0 12.6 12.6 0 28.2 0h454.2C498.8 0 512 13.2 512 29.6c0 1.6-.1 3.3-.4 4.9l-77 461.6c-1.5 9.2-9.5 15.9-18.8 15.9-9.2 0-17.1-6.6-18.7-15.6L336 160l-28.8 143.9c-1.9 9.3-10.1 16.1-19.6 16.1-9.2 0-17.2-6.2-19.4-15.1L240 192l-29.4 176.2c-1.5 9.1-9.4 15.8-18.6 15.8s-17.1-6.7-18.6-15.8L144 192l-28.1 112.3c-2.3 9.2-10.6 15.7-20.1 15.7-9.3 0-17.5-6.2-20-15.2z"
        }
    ]
};

const FasIcons = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasIcons",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M500.3 7.3c7.4 6 11.7 15.1 11.7 24.7v144c0 26.5-28.7 48-64 48s-64-21.5-64-48 28.7-48 64-48V71l-96 19.2V208c0 26.5-28.7 48-64 48s-64-21.5-64-48 28.7-48 64-48V64c0-15.3 10.8-28.4 25.7-31.4l160-32c9.4-1.9 19.1.6 26.6 6.6zM74.7 304l11.8-17.8c5.9-8.9 15.9-14.2 26.6-14.2h61.7c10.7 0 20.7 5.3 26.6 14.2l11.9 17.8H240c26.5 0 48 21.5 48 48v112c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V352c0-26.5 21.5-48 48-48h26.7zM192 408a48 48 0 1 0-96 0 48 48 0 1 0 96 0zm286.7-129.7L440.3 368H496c6.7 0 12.6 4.1 15 10.4s.6 13.3-4.4 17.7l-128 112c-5.6 4.9-13.9 5.3-19.9.9s-8.2-12.4-5.3-19.2l38.3-89.8H336c-6.7 0-12.6-4.1-15-10.4s-.6-13.3 4.4-17.7l128-112c5.6-4.9 13.9-5.3 19.9-.9s8.2 12.4 5.3 19.2zm-339-59.2c-6.5 6.5-17 6.5-23 0l-96.8-99.9c-28-29-26.5-76.9 5-103.9 27-23.5 68.4-19 93.4 6.5l10 10.5 9.5-10.5c25-25.5 65.9-30 93.9-6.5 31 27 32.5 74.9 4.5 103.9l-96.4 99.9z"
        }
    ]
};

const FasIdBadge = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasIdBadge",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm96 320h64c44.2 0 80 35.8 80 80 0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16 0-44.2 35.8-80 80-80zm-32-96a64 64 0 1 1 128 0 64 64 0 1 1-128 0zm16-160h96c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FasIdCardClip = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasIdCardClip",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 0h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32V32c0-17.7 14.3-32 32-32zM64 64h128v48c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V64h128c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128c0-35.3 28.7-64 64-64zm112 373.3c0 5.9 4.8 10.7 10.7 10.7h202.6c5.9 0 10.7-4.8 10.7-10.7 0-29.5-23.9-53.3-53.3-53.3H229.3c-29.5 0-53.3 23.9-53.3 53.3zM288 352a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"
        }
    ]
};

const FasIdCard = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasIdCard",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 96h576c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96zm0 32v288c0 35.3 28.7 64 64 64h448c35.3 0 64-28.7 64-64V128H0zm64 277.3c0-29.5 23.9-53.3 53.3-53.3h117.4c29.5 0 53.3 23.9 53.3 53.3 0 5.9-4.8 10.7-10.7 10.7H74.7c-5.9 0-10.7-4.8-10.7-10.7zM176 192a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm176 16c0-8.8 7.2-16 16-16h128c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16h128c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16h128c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16z"
        }
    ]
};

const FasIgloo = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasIgloo",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 33.8V160H48.5C100.2 82.8 188.1 32 288 32c10.8 0 21.5.6 32 1.8zM352 160V39.1C424.9 55.7 487.2 99.8 527.5 160H352zM29.9 192H96v128H0c0-46 10.8-89.4 29.9-128zM192 320h-64V192h320v128h-64v32h192v80c0 26.5-21.5 48-48 48H352V352c0-35.3-28.7-64-64-64s-64 28.7-64 64v128H48c-26.5 0-48-21.5-48-48v-80h192v-32zm288 0V192h66.1c19.2 38.6 29.9 82 29.9 128h-96z"
        }
    ]
};

const FasImageLandscape = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasImageLandscape",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 128c0-35.3 28.7-64 64-64h448c35.3 0 64 28.7 64 64v256c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zm328 64c-8 0-15.5 4-20 10.7l-56 84-17.3-21.7c-4.6-5.7-11.4-9-18.7-9s-14.2 3.3-18.7 9l-64 80c-5.8 7.2-6.9 17.1-2.9 25.4S142.8 384 152 384h272c8.9 0 17-4.9 21.2-12.7s3.7-17.3-1.2-24.6l-96-144c-4.5-6.7-12-10.7-20-10.7zm-168 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FasImagePolaroidUser = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasImagePolaroidUser",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm64 32v192c0 17.7 14.3 32 32 32h16c0-35.3 28.7-64 64-64h96c35.3 0 64 28.7 64 64h16c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32zm96 64a64 64 0 1 1 128 0 64 64 0 1 1-128 0z"
        }
    ]
};

const FasImagePolaroid = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasImagePolaroid",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm32 64h256c17.7 0 32 14.3 32 32v192c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32zm152 64c-5.3 0-10.2 2.6-13.2 6.9l-52.4 76.3-9.6-12.8c-3-4-7.8-6.4-12.8-6.4s-9.8 2.4-12.8 6.4l-48 64c-3.6 4.8-4.2 11.3-1.5 16.8S106 320 112 320h224c5.9 0 11.4-3.3 14.2-8.6s2.4-11.6-1-16.5l-88-128c-3-4.3-7.9-6.9-13.2-6.9zm-120 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FasImagePortrait = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasImagePortrait",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V64zM128 192a64 64 0 1 1 128 0 64 64 0 1 1-128 0zM80 356.6c0-37.9 30.7-68.6 68.6-68.6h86.9c37.9 0 68.6 30.7 68.6 68.6 0 15.1-12.3 27.4-27.4 27.4H107.4C92.3 384 80 371.7 80 356.6z"
        }
    ]
};

const FasImageSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasImageSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-55.5-43.5c.5-3.1.7-6.3.7-9.6V96c0-35.3-28.7-64-64-64H128c-14.4 0-27.8 4.8-38.5 12.9L38.8 5.1zm120 94.1c5.3-2 11.1-3.2 17.2-3.2 26.5 0 48 21.5 48 48 0 2-.1 4-.4 6l-64.8-50.8zm169.3 132.7 20-29.4c4.5-6.6 11.9-10.5 19.8-10.5s15.4 3.9 19.8 10.5l111.7 163.6-171.3-134.2zm-106.4 40.6c.3-.4.6-.7 1-1.1L64 146.4V416c0 35.3 28.7 64 64 64h359.4l-81.2-64H152c-9.3 0-17.8-5.4-21.8-13.9s-2.6-18.5 3.5-25.6l88-104z"
        }
    ]
};

const FasImageUser = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasImageUser",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm128 160a64 64 0 1 1 128 0 64 64 0 1 1-128 0zm-48 164.6c0-37.9 30.7-68.6 68.6-68.6h86.9c37.9 0 68.6 30.7 68.6 68.6 0 15.1-12.3 27.4-27.4 27.4H171.4c-15.1 0-27.4-12.3-27.4-27.4z"
        }
    ]
};

const FasImage = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasImage",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 96c0-35.3 28.7-64 64-64h384c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm323.8 106.5c-4.5-6.6-11.9-10.5-19.8-10.5s-15.4 3.9-19.8 10.5l-87 127.6-26.5-33.1c-4.6-5.7-11.5-9-18.7-9s-14.2 3.3-18.7 9l-64 80c-5.8 7.2-6.9 17.1-2.9 25.4S78.8 416 88 416h336c8.9 0 17.1-4.9 21.2-12.8s3.6-17.4-1.4-24.7l-120-176zM112 192a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
        }
    ]
};

const FasImagesUser = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasImagesUser",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 96v224c0 35.3 28.7 64 64 64h352c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H160c-35.3 0-64 28.7-64 64zm240 0a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm-66.3 160h132.6c25.2 0 45.7 20.5 45.7 45.7 0 10.1-8.2 18.3-18.3 18.3H242.3c-10.1 0-18.3-8.2-18.3-18.3 0-25.2 20.5-45.7 45.7-45.7zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120v224c0 75.1 60.9 136 136 136h320c13.3 0 24-10.7 24-24s-10.7-24-24-24H136c-48.6 0-88-39.4-88-88V120z"
        }
    ]
};

const FasImages = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasImages",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 32c-35.3 0-64 28.7-64 64v224c0 35.3 28.7 64 64 64h352c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H160zm236 106.7 96 144c4.9 7.4 5.4 16.8 1.2 24.6S480.9 320 472 320H200c-9.2 0-17.6-5.3-21.6-13.6s-2.9-18.2 2.9-25.4l64-80c4.6-5.7 11.4-9 18.7-9s14.2 3.3 18.7 9l17.3 21.6 56-84c4.5-6.6 12-10.6 20-10.6s15.5 4 20 10.7zM192 128a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm-144-8c0-13.3-10.7-24-24-24S0 106.7 0 120v224c0 75.1 60.9 136 136 136h320c13.3 0 24-10.7 24-24s-10.7-24-24-24H136c-48.6 0-88-39.4-88-88V120z"
        }
    ]
};

const FasInboxFull = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasInboxFull",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M58.9 80.5C66 52 91.6 32 121 32h270c29.4 0 55 20 62.1 48.5l57 227.9c1.3 5.1 1.9 10.3 1.9 15.5V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64v-92.1c0-5.2.6-10.4 1.9-15.5l57-227.9zM391 96H121L73 288h51.2c12.1 0 23.2 6.8 28.6 17.7l14.3 28.6c5.4 10.8 16.5 17.7 28.6 17.7h120.5c12.1 0 23.2-6.8 28.6-17.7l14.3-28.6c5.4-10.8 16.5-17.7 28.6-17.7H439L391 96zm-215 48h160c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-32 80h224c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FasInboxIn = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasInboxIn",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 32v178.7l41.4-41.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-96 96c-12.5 12.5-32.8 12.5-45.3 0l-96-96c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l41.3 41.4V32c0-17.7 14.3-32 32-32s32 14.3 32 32zM48 320h76.2c12.1 0 23.2 6.8 28.6 17.7l14.3 28.6c5.4 10.8 16.5 17.7 28.6 17.7h120.5c12.1 0 23.2-6.8 28.6-17.7l14.3-28.6c5.4-10.8 16.5-17.7 28.6-17.7H464c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48v-96c0-26.5 21.5-48 48-48z"
        }
    ]
};

const FasInboxOut = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasInboxOut",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 109.3V288c0 17.7-14.3 32-32 32s-32-14.3-32-32V109.3l-41.4 41.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l96-96c12.5-12.5 32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L288 109.3zM48 320h76.2c12.1 0 23.2 6.8 28.6 17.7l14.3 28.6c5.4 10.8 16.5 17.7 28.6 17.7h120.5c12.1 0 23.2-6.8 28.6-17.7l14.3-28.6c5.4-10.8 16.5-17.7 28.6-17.7H464c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48v-96c0-26.5 21.5-48 48-48z"
        }
    ]
};

const FasInbox = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasInbox",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M121 32c-29.4 0-55 20-62.1 48.5l-57 227.9C.6 313.5 0 318.7 0 323.9V416c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64v-92.1c0-5.2-.6-10.4-1.9-15.5l-57-227.9C446 52 420.4 32 391 32H121zm0 64h270l48 192h-51.2c-12.1 0-23.2 6.8-28.6 17.7l-14.3 28.6c-5.4 10.8-16.5 17.7-28.6 17.7H195.8c-12.1 0-23.2-6.8-28.6-17.7l-14.3-28.6c-5.4-10.8-16.5-17.7-28.6-17.7H73l48-192z"
        }
    ]
};

const FasInboxes = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasInboxes",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m117.7 64-38.4 96h45c12.1 0 23.2 6.8 28.6 17.7l14.3 28.6c5.4 10.8 16.5 17.7 28.6 17.7h120.4c12.1 0 23.2-6.8 28.6-17.7l14.3-28.6c5.4-10.8 16.5-17.7 28.6-17.7h45l-38.4-96H117.7zM60.3 35.2C68.8 13.9 89.4 0 112.2 0h287.6c22.9 0 43.5 13.9 52 35.2L508 175.8c2.6 6.6 4 13.7 4 20.8V264c0 30.9-25.1 56-56 56H56c-30.9 0-56-25.1-56-56v-67.4c0-7.1 1.4-14.2 4-20.8L60.3 35.2zM48 352h76.2c12.1 0 23.2 6.8 28.6 17.7l14.3 28.6c5.4 10.8 16.5 17.7 28.6 17.7h120.5c12.1 0 23.2-6.8 28.6-17.7l14.3-28.6c5.4-10.8 16.5-17.7 28.6-17.7H464c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48v-64c0-26.5 21.5-48 48-48z"
        }
    ]
};

const FasIndent = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasIndent",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 64c0-17.7 14.3-32 32-32h384c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64zm192 128c0-17.7 14.3-32 32-32h192c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32zm32 96h192c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32zM0 448c0-17.7 14.3-32 32-32h384c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zm127.8-179.4-102 79.3c-10.5 8.2-25.8.7-25.8-12.6V176.7c0-13.3 15.3-20.8 25.8-12.6l101.9 79.3c8.2 6.4 8.2 18.9 0 25.3z"
        }
    ]
};

const FasIndianRupeeSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasIndianRupeeSign",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 64c0-17.7 14.3-32 32-32h256c17.7 0 32 14.3 32 32s-14.3 32-32 32h-56.2c9.6 14.4 16.7 30.6 20.7 48H288c17.7 0 32 14.3 32 32s-14.3 32-32 32h-35.6c-13.2 58.3-61.9 103.2-122.2 110.9L274.6 422c14.4 10.3 17.7 30.3 7.4 44.6s-30.3 17.7-44.6 7.4l-224-160c-11.3-8-16.1-22.5-11.9-35.8S18.1 256 32 256h80c32.8 0 61-19.7 73.3-48H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h153.3C173 115.7 144.8 96 112 96H32C14.3 96 0 81.7 0 64z"
        }
    ]
};

const FasIndustryWindows = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasIndustryWindows",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 64c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v151.4L316.6 131c16-8.6 35.4 3 35.4 21.1v63.2L508.6 131c16-8.6 35.4 3 35.4 21.1V432c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V64zm232 248c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16v-48c0-8.8-7.2-16-16-16h-48zm-144 16v48c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16v-48c0-8.8-7.2-16-16-16h-48c-8.8 0-16 7.2-16 16zm272-16c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16v-48c0-8.8-7.2-16-16-16h-48z"
        }
    ]
};

const FasIndustry = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasIndustry",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32c-17.7 0-32 14.3-32 32v368c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V152.2c0-18.2-19.4-29.7-35.4-21.1L352 215.4v-63.2c0-18.2-19.4-29.7-35.4-21.1L160 215.4V64c0-17.7-14.3-32-32-32H64z"
        }
    ]
};

const FasInfinity = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasInfinity",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 241.1C0 161 65 96 145.1 96c38.5 0 75.4 15.3 102.6 42.5l72.3 72.2 72.2-72.2C419.5 111.3 456.4 96 494.9 96 575 96 640 161 640 241.1v29.7C640 351 575 416 494.9 416c-38.5 0-75.4-15.3-102.6-42.5L320 301.3l-72.2 72.2c-27.3 27.2-64.2 42.5-102.7 42.5C65 416 0 351 0 270.9v-29.8zM274.7 256l-72.2-72.2c-15.2-15.2-35.9-23.8-57.4-23.8-44.8 0-81.1 36.3-81.1 81.1v29.7c0 44.8 36.3 81.1 81.1 81.1 21.5 0 42.2-8.5 57.4-23.8l72.2-72.1zm90.5 0 72.2 72.2c15.2 15.2 35.9 23.8 57.4 23.8 44.8 0 81.1-36.3 81.1-81.1v-29.8c0-44.8-36.3-81.1-81.1-81.1-21.5 0-42.2 8.5-57.4 23.8L365.3 256z"
        }
    ]
};

const FasInfo = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasInfo",
    "viewBox": "0 0 192 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 80a48 48 0 1 1 96 0 48 48 0 1 1-96 0zM0 224c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v224h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h32V256H32c-17.7 0-32-14.3-32-32z"
        }
    ]
};

const FasInhaler = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasInhaler",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M429.8 32.7c-12.7-3.2-25.6 4.4-29 17l-14 51.8L533.2 248l42-153.7c1.7-6.2.8-12.9-2.4-18.4s-8.6-9.6-14.9-11.2l-128-32zm104.3 272.8c1.5-5.5-.1-11.5-4.1-15.5L383.8 143.8c-8.7-8.7-23.6-4.7-26.8 7.2l-16.5 61.2c-1.9 7-8.2 11.8-15.4 11.8H232c-22.1 0-40 17.9-40 40v176c0 22.1 17.9 40 40 40h224c18 0 33.8-12.1 38.6-29.5l39.5-145zM64 256a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm0 96a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm64-16a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM64 448a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm64-16a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FasInputNumeric = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasInputNumeric",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M576 128v256H64V128h512zM64 64C28.7 64 0 92.7 0 128v256c0 35.3 28.7 64 64 64h512c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm40 120c0 13.3 10.7 24 24 24h8v96h-16c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24h-16V184c0-13.3-10.7-24-24-24h-32c-13.3 0-24 10.7-24 24zm190.6 30.4c5.7-8 17.5-8.6 24-1.2 5.2 5.9 5 14.7-.3 20.5l-72 78c-6.5 7-8.2 17.2-4.3 25.9s12.5 14.4 22 14.4h88c13.3 0 24-10.7 24-24s-10.7-24-24-24h-33.2l34.8-37.7c22-23.8 22.4-60.3 1.1-84.7-26.9-30.7-75.4-28.4-99.2 4.9l-11.1 15.6c-7.7 10.8-5.2 25.8 5.6 33.5s25.8 5.2 33.5-5.6l11.1-15.6z"
        }
    ]
};

const FasInputPipe = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasInputPipe",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 128v256h512V128H64zm-64 0c0-35.3 28.7-64 64-64h512c35.3 0 64 28.7 64 64v256c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zm144 56v144c0 13.3-10.7 24-24 24s-24-10.7-24-24V184c0-13.3 10.7-24 24-24s24 10.7 24 24z"
        }
    ]
};

const FasInputText = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasInputText",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 128v256h512V128H64zm-64 0c0-35.3 28.7-64 64-64h512c35.3 0 64 28.7 64 64v256c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zm184 32c9.5 0 18.1 5.6 21.9 14.3l64 144c5.4 12.1-.1 26.3-12.2 31.7s-26.3-.1-31.7-12.2l-4.3-9.7h-75.4l-4.3 9.7c-5.4 12.1-19.6 17.6-31.7 12.2s-17.6-19.6-12.2-31.7l64-144c3.9-8.7 12.4-14.3 21.9-14.3zm0 83.1L167.6 280h32.8L184 243.1zM304 184c0-13.3 10.7-24 24-24h52c33.1 0 60 26.9 60 60 0 9.2-2.1 17.9-5.8 25.7 13.3 11 21.8 27.6 21.8 46.3 0 33.1-26.9 60-60 60h-68c-13.3 0-24-10.7-24-24V184zm48 24v24h28c6.6 0 12-5.4 12-12s-5.4-12-12-12h-28zm0 96h44c6.6 0 12-5.4 12-12s-5.4-12-12-12h-44v24z"
        }
    ]
};

const FasIntegral = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasIntegral",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M216 64c-13.3 0-24 10.7-24 24v336c0 48.6-39.4 88-88 88s-88-39.4-88-88v-8c0-17.7 14.3-32 32-32s32 14.3 32 32v8c0 13.3 10.7 24 24 24s24-10.7 24-24V88c0-48.6 39.4-88 88-88s88 39.4 88 88v8c0 17.7-14.3 32-32 32s-32-14.3-32-32v-8c0-13.3-10.7-24-24-24z"
        }
    ]
};

const FasInterrobang = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasInterrobang",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 96c-35.3 0-64 28.7-64 64 0 17.7-14.3 32-32 32s-32-14.3-32-32C16 89.3 73.3 32 144 32h32c70.7 0 128 57.3 128 128v3.6c0 43.6-22.1 84.1-58.8 107.7L203 298.4c-6.9 4.4-11 12-11 20.2v1.4c0 17.7-14.3 32-32 32s-32-14.3-32-32V176c0-17.7 14.3-32 32-32s32 14.3 32 32v53.4l18.6-12c18.3-11.8 29.4-32.1 29.4-53.8V160c0-35.3-28.7-64-64-64h-32zm-24 344a40 40 0 1 1 80 0 40 40 0 1 1-80 0z"
        }
    ]
};

const FasIntersection = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasIntersection",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 480c17.7 0 32-14.3 32-32V224c0-70.7 57.3-128 128-128s128 57.3 128 128v224c0 17.7 14.3 32 32 32s32-14.3 32-32V224c0-106-86-192-192-192S0 118 0 224v224c0 17.7 14.3 32 32 32z"
        }
    ]
};

const FasIslandTropical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasIslandTropical",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M114.3 93.7c-1.5 1.5-3.5 2.3-5.7 2.3H78.2c-8.8 0-16.1-7.2-13.8-15.8C73.6 44.8 112.8 0 190.2 0c58.4 0 95 25.5 113.5 53.2C323.6 40.6 350.2 32 384 32c77.4 0 116.6 44.8 125.8 80.2 2.2 8.6-5 15.8-13.8 15.8h-44.7c-2.1 0-4.2-.8-5.7-2.3l-24-24c-3.1-3.1-8.2-3.1-11.3 0l-24 24c-1.5 1.5-3.5 2.3-5.7 2.3h-79.1c28 79.9 21.2 170.2 9.9 226.1C370.9 365.1 416 417.3 416 480c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32 0-70.7 57.3-128 128-128h64c29.7-79.3 29.4-150.9 22.8-194l-87.6 87.6c-6.2 6.2-16.5 6.2-21-1.4-18.5-31.6-22.5-90.9 32.3-145.7 1.4-1.4 2.8-2.7 4.1-4-.3-.3-.7-.5-1-.8l-24-24c-3.1-3.1-8.2-3.1-11.3 0l-24 24z"
        }
    ]
};

const FasItalic = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasItalic",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 64c0-17.7 14.3-32 32-32h192c17.7 0 32 14.3 32 32s-14.3 32-32 32h-58.7L160 416h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h58.7L224 96h-64c-17.7 0-32-14.3-32-32z"
        }
    ]
};

const FasJ = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasJ",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 32c17.7 0 32 14.3 32 32v256c0 88.4-71.6 160-160 160S0 408.4 0 320v-32c0-17.7 14.3-32 32-32s32 14.3 32 32v32c0 53 43 96 96 96s96-43 96-96V64c0-17.7 14.3-32 32-32z"
        }
    ]
};

const FasJackOLantern = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasJackOLantern",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M234.6 103.9c16.9-5.1 34.8-7.9 53.4-7.9 22.8 0 44.7 4.2 64.8 11.7-.6-2-.8-4.1-.8-6.3v-66c0-6.9-4.1-13.2-10.5-15.9L299.3 1.4c-2.2-.9-4.5-1.4-6.8-1.4h-1.2c-6.9 0-13.1 4.1-15.8 10.4l-40.9 93.5zm161.6 27.3c12.1 8.8 23.1 19.1 32.7 30.5 5.6 6.7-2.9 14.6-10.4 10.1C380.3 149 335.7 136 288 136s-92.3 13-130.5 35.7c-7.5 4.5-16-3.4-10.4-10.1 9.6-11.4 20.6-21.7 32.7-30.5l-1.8-.3c-8.5-1.8-17.2-2.8-26-2.8C68.1 128 0 214 0 320s68.1 192 152 192c19.3 0 37.8-4.5 54.7-12.8 8.3-4.1 18.2-4.1 26.5 0 17 8.3 35.4 12.8 54.7 12.8s37.8-4.5 54.7-12.8c8.3-4.1 18.2-4.1 26.5 0 17 8.3 35.4 12.8 54.7 12.8 83.9 0 152-86 152-192s-68.1-192-152-192c-8.9 0-17.6 1-26 2.8l-1.8.3zM208 208c5.3 0 10.3 2.7 13.3 7.1l32 48c3.3 4.9 3.6 11.2.8 16.4s-8.2 8.5-14.1 8.5h-64c-5.9 0-11.3-3.2-14.1-8.5s-2.5-11.5.8-16.4l32-48c3-4.5 8-7.1 13.3-7.1zm173.3 7.1 32 48c3.3 4.9 3.6 11.2.8 16.4s-8.2 8.5-14.1 8.5h-64c-5.9 0-11.3-3.2-14.1-8.5s-2.5-11.5.8-16.4l32-48c3-4.5 8-7.1 13.3-7.1s10.3 2.7 13.3 7.1zM368 437.5c-21.8 6.5-48.2 10.5-80 10.5s-58.2-4-80-10.5V416c0-8.8-7.2-16-16-16h-16c-8.6 0-15.7 6.9-16 15.4-36.9-24.7-49.9-56.7-54.1-71.4-1.4-5 .3-10.2 4-13.8 5.8-5.8 15.1-6.6 22.2-2.4 18 10.6 55.5 29.1 107.9 36.8V384c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-16c77.6 0 132.8-26.6 155.9-40.2 7.1-4.2 16.4-3.4 22.2 2.4 3.7 3.7 5.4 8.8 4 13.8-4.2 14.7-17.3 46.8-54.1 71.4-.3-8.6-7.3-15.4-16-15.4h-16c-8.8 0-16 7.2-16 16v21.5z"
        }
    ]
};

const FasJarWheat = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasJarWheat",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 32C32 14.3 46.3 0 64 0h192c17.7 0 32 14.3 32 32s-14.3 32-32 32H64c-17.7 0-32-14.3-32-32zM0 160c0-35.3 28.7-64 64-64h192c35.3 0 64 28.7 64 64v288c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V160zm112 0H69.8c-3.2 0-5.8 2.6-5.8 5.8C64 198 90 224 122.2 224h75.6c32.1 0 58.2-26 58.2-58.2 0-3.2-2.6-5.8-5.8-5.8H208c-19.1 0-36.3 8.4-48 21.7-11.7-13.3-28.9-21.7-48-21.7zm48 117.7c-11.7-13.3-28.9-21.7-48-21.7H69.8c-3.2 0-5.8 2.6-5.8 5.8C64 294 90 320 122.2 320h75.6c32.1 0 58.2-26 58.2-58.2 0-3.2-2.6-5.8-5.8-5.8H208c-19.1 0-36.3 8.4-48 21.7zM112 352H69.8c-3.2 0-5.8 2.6-5.8 5.8C64 390 90 416 122.2 416H144v32c0 8.8 7.2 16 16 16s16-7.2 16-16v-32h21.8c32.1 0 58.2-26 58.2-58.2 0-3.2-2.6-5.8-5.8-5.8H208c-19.1 0-36.3 8.4-48 21.7-11.7-13.3-28.9-21.7-48-21.7z"
        }
    ]
};

const FasJar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasJar",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 32C32 14.3 46.3 0 64 0h192c17.7 0 32 14.3 32 32s-14.3 32-32 32H64c-17.7 0-32-14.3-32-32zM0 160c0-35.3 28.7-64 64-64h192c35.3 0 64 28.7 64 64v288c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V160zm96 64c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32h128c17.7 0 32-14.3 32-32v-96c0-17.7-14.3-32-32-32H96z"
        }
    ]
};

const FasJedi = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasJedi",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m246 315.7-21.2-31.9c-2.1-3.2-1.7-7.4 1-10.1s6.9-3.1 10.1-1l29.5 19.7c2.1 1.4 4.9 0 5-2.6L279.7 8c.1-4.5 3.8-8 8.3-8s8.1 3.5 8.3 8l9.4 281.9c.1 2.5 2.9 3.9 5 2.6l29.5-19.7c3.2-2.1 7.4-1.7 10.1 1s3.1 6.9 1 10.1L330 315.7c-1.3 1.9-.2 4.5 2 4.9l37.6 7.5c3.7.7 6.4 4 6.4 7.8s-2.7 7.1-6.4 7.8l-37.6 7.7c-2.2.4-3.3 3-2 4.9l21.2 31.9c2.1 3.2 1.7 7.4-1 10.1s-6.9 3.1-10.1 1l-26.3-17.6c-2.2-1.4-5.1.2-5 2.8l2.1 61.5C370.6 435.2 416 382.9 416 320c0-37-15.7-70.4-40.8-93.7-7-6.5-6.5-18.6 1-24.4C410.1 175.5 432 134.3 432 88c0-16.8-2.9-33-8.2-48-4.6-13 10.2-30 21.4-22 53.5 38 92.7 94.8 107.8 160.7.5 2.1-.2 4.3-1.7 5.9L522.9 213c-4 4-1.2 10.9 4.5 10.9h26c3.4 0 6.2 2.6 6.3 6 .1 3.3.2 6.6.2 10 0 17.5-1.7 34.7-4.8 51.3-.2 1.2-.9 2.4-1.7 3.3L506.9 341c-4 4-1.2 10.9 4.5 10.9H526c4.6 0 7.7 4.8 5.7 9C487.2 450.5 394.8 512 288 512S88.8 450.5 44.3 361c-2.1-4.2 1-9 5.7-9h14.5c5.7 0 8.6-6.9 4.5-10.9l-46.4-46.5c-.9-.9-1.5-2-1.7-3.3-3.2-16.6-4.9-33.8-4.9-51.3 0-3.3.1-6.7.2-10 .1-3.4 2.9-6 6.3-6h26c5.7 0 8.6-6.9 4.5-10.9l-28.4-28.5c-1.5-1.5-2.2-3.8-1.7-5.9C38.1 112.8 77.3 56 130.8 18c11.3-8 26 8.9 21.4 22-5.3 15-8.2 31.2-8.2 48 0 46.3 21.9 87.5 55.8 113.9 7.5 5.8 8 17.9 1 24.4C175.7 249.6 160 283 160 320c0 62.9 45.4 115.2 105.1 126l2.1-61.5c.1-2.6-2.8-4.2-5-2.8l-26.3 17.6c-3.2 2.1-7.4 1.7-10.1-1s-3.1-6.9-1-10.1l21.2-31.9c1.3-1.9.2-4.5-2-4.9l-37.6-7.5c-3.7-.7-6.4-4-6.4-7.8s2.7-7.1 6.4-7.8l37.6-7.5c2.2-.4 3.3-3 2-4.9z"
        }
    ]
};

const FasJetFighterUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasJetFighterUp",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M270.7 9.7C268.2 3.8 262.4 0 256 0s-12.2 3.8-14.7 9.7l-44.1 102.9c-3.4 8-5.2 16.5-5.2 25.2v77l-144 84V280c0-13.3-10.7-24-24-24S0 266.7 0 280v112c0 13.3 10.7 24 24 24s24-10.7 24-24v-8h144v32.7L133.5 468c-3.5 3-5.5 7.4-5.5 12v16c0 8.8 7.2 16 16 16h96v-64c0-8.8 7.2-16 16-16s16 7.2 16 16v64h96c8.8 0 16-7.2 16-16v-16c0-4.6-2-9-5.5-12L320 416.7V384h144v8c0 13.3 10.7 24 24 24s24-10.7 24-24V280c0-13.3-10.7-24-24-24s-24 10.7-24 24v18.8l-144-84v-77c0-8.7-1.8-17.2-5.2-25.2L270.7 9.7z"
        }
    ]
};

const FasJetFighter = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasJetFighter",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 24c0-13.3 10.7-24 24-24h112c13.3 0 24 10.7 24 24s-10.7 24-24 24h-16l104 144h116.4c7.7 0 15.3 1.4 22.5 4.1L625 234.4c9 3.4 15 12 15 21.6s-6 18.2-15 21.6l-102.1 38.3c-7.2 2.7-14.8 4.1-22.5 4.1H384L280 464h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24s10.7-24 24-24h8V320h-32l-54.6 54.6c-6 6-14.1 9.4-22.6 9.4H64c-17.7 0-32-14.3-32-32v-64c-17.7 0-32-14.3-32-32s14.3-32 32-32v-64c0-17.7 14.3-32 32-32h18.7c8.5 0 16.6 3.4 22.6 9.4L160 192h32V48h-8c-13.3 0-24-10.7-24-24zM80 240c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H80z"
        }
    ]
};

const FasJoint = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasJoint",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 32c0-17.7-14.3-32-32-32s-32 14.3-32 32v11c0 55.2 21.9 108.1 60.9 147.1l21 21c9 9 14.1 21.2 14.1 33.9v11c0 17.7 14.3 32 32 32s32-14.3 32-32v-11c0-29.7-11.8-58.2-32.8-79.2l-21-21c-27-27-42.2-63.6-42.2-101.8V32zm128 224c0 17.7 14.3 32 32 32s32-14.3 32-32v-11c0-55.2-21.9-108.1-60.9-147.1l-21-21c-9-9-14.1-21.2-14.1-33.9V32c0-17.7-14.3-32-32-32s-32 14.3-32 32v11c0 29.7 11.8 58.2 32.8 79.2l21 21c27 27 42.2 63.6 42.2 101.8v11zM229.8 360c-4.7-2.3-10-2.7-15.2-2-37.8 5.6-75.2 14.3-106.9 22.8-26.4 7.2-49.4 14.3-65.7 19.6-8.2 2.7-14.7 4.9-19.2 6.5-2.3.8-4 1.4-5.2 1.8l-1.3.5C6.8 412.5 0 421.4 0 432s6.8 19.5 16.3 22.7l1.3.5c1.2.4 3 1.1 5.2 1.8 4.5 1.6 11 3.8 19.2 6.5 16.3 5.4 39.2 12.5 65.7 19.6C160.3 497.3 228.8 512 288 512h67.3c4.1 0 6.3-5.1 3.6-8.3L256.5 380.8c-7.4-8.9-16.5-15.9-26.7-20.8zM445 512h70.3c4.1 0 6.3-5.1 3.6-8.3L416.5 380.8C401.3 362.5 378.8 352 355 352h-70.4c-4.1 0-6.2 5.1-3.5 8.3l102.4 122.9c15.2 18.3 37.7 28.8 61.5 28.8zm-3.9-151.7 102.4 122.9c14.6 17.5 35.9 27.9 58.6 28.7 21.1-1.1 37.9-18.6 37.9-39.9v-80c0-22.1-17.9-40-40-40H444.7c-4.1 0-6.3 5.1-3.6 8.3z"
        }
    ]
};

const FasJoystick = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasJoystick",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M336 112c0 50.7-33.7 93.6-80 107.4V320h-64V219.4c-46.3-13.8-80-56.6-80-107.4C112 50.1 162.1 0 224 0s112 50.1 112 112zM200 96a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM64 352c0-17.7 14.3-32 32-32s32 14.3 32 32h256c35.3 0 64 28.7 64 64v32c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64v-32c0-35.3 28.7-64 64-64z"
        }
    ]
};

const FasJugBottle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasJugBottle",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M120 0c-13.3 0-24 10.7-24 24v24h-8c-13.3 0-24 10.7-24 24s10.7 24 24 24h144c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V24c0-13.3-10.7-24-24-24h-80zm8 128C57.3 128 0 185.3 0 256v192c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V256c0-70.7-57.3-128-128-128H128zm160 96c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32s-32-14.3-32-32v-96c0-17.7 14.3-32 32-32zM472 64c-13.3 0-24 10.7-24 24v40h128V88c0-13.3-10.7-24-24-24h-80zm-55.6 328.4c-.1.1-.2.1-.4.2V448c0 16.9-4.3 32.7-12 46.5 11.5 10.9 27 17.5 44 17.5h128c35.3 0 64-28.7 64-64 0-24.1-13.3-45.1-33-56 19.7-10.9 33-31.9 33-56 0-23.5-12.6-44-31.5-55.1 18.7-10.1 31.5-29.9 31.5-52.7 0-23.2-13.4-44.3-34.4-54.2l-13.2-6.2c-11-5.1-23-7.8-35.1-7.8h-90.6c-12.1 0-24.1 2.7-35.1 7.8l-13.2 6.2c-6.9 3.2-13 7.7-18 13 10 20.9 15.6 44.3 15.6 69v135.4c.3.2.7.4 1 .6-.2.1-.4.2-.6.4z"
        }
    ]
};

const FasJugDetergent = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasJugDetergent",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 24c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24v24h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H88c-13.3 0-24-10.7-24-24s10.7-24 24-24h8V24zM0 256c0-70.7 57.3-128 128-128h128c70.7 0 128 57.3 128 128v192c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256zm256 0v96c0 17.7 14.3 32 32 32s32-14.3 32-32v-96c0-17.7-14.3-32-32-32s-32 14.3-32 32z"
        }
    ]
};

const FasJug = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasJug",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 0h128c17.7 0 32 14.3 32 32s-14.3 32-32 32H160c-17.7 0-32-14.3-32-32s14.3-32 32-32zm240 168c0-13.3-10.7-24-24-24-10.3 0-19.1 6.5-22.5 15.6l25.1 32.2c12.1-1.3 21.4-11.5 21.4-23.9zm-89.3-63.3 11.8 15.1C335.7 105.2 354.8 96 376 96c39.8 0 72 32.2 72 72 0 29.2-17.4 54.3-42.3 65.6 6.8 15.8 10.3 32.9 10.3 50.3V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V283.9c0-28.5 9.5-56.1 27-78.6l78.3-100.7c2.1-2.6 3.7-5.6 4.8-8.7h163.8c1.1 3.1 2.7 6 4.8 8.7zM128 288c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h192c17.7 0 32-14.3 32-32v-64c0-17.7-14.3-32-32-32H128z"
        }
    ]
};

const FasK = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasK",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M311 86.3c12.3-12.7 12-32.9-.7-45.2s-32.9-12-45.2.7l-155.2 160L64 249V64c0-17.7-14.3-32-32-32S0 46.3 0 64v384c0 17.7 14.3 32 32 32s32-14.3 32-32V341l64.7-66.7 133 192c10.1 14.5 30 18.1 44.5 8.1s18.1-30 8.1-44.5L174.1 227.4 311 86.3z"
        }
    ]
};

const FasKaaba = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasKaaba",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m60 120 228 71.2L516 120 288 48.8 60 120zM278.5 1.5c6.2-1.9 12.9-1.9 19.1 0l256 80C566.9 85.6 576 98 576 112v37.2l-283.2 88.5c-3.1 1-6.4 1-9.5 0L0 149.2V112c0-14 9.1-26.4 22.5-30.5l256-80zm23.9 266.8L576 182.8v46.5l-52.8 16.5c-8.4 2.6-13.1 11.6-10.5 20s11.6 13.1 20 10.5l43.3-13.5V400c0 14-9.1 26.4-22.5 30.5l-256 80c-6.2 1.9-12.9 1.9-19.1 0l-256-80C9.1 426.4 0 414 0 400V262.8l43.2 13.5c8.4 2.6 17.4-2.1 20-10.5s-2.1-17.4-10.5-20L0 229.2v-46.4l273.7 85.5c9.3 2.9 19.3 2.9 28.6 0zm-185.5-2.6c-8.4-2.6-17.4 2.1-20 10.5s2.1 17.4 10.5 20l64 20c8.4 2.6 17.4-2.1 20-10.5s-2.1-17.4-10.5-20l-64-20zm352 30.5c8.4-2.6 13.1-11.6 10.5-20s-11.6-13.1-20-10.5l-64 20c-8.4 2.6-13.1 11.6-10.5 20s11.6 13.1 20 10.5l64-20zm-224 9.5c-8.4-2.6-17.4 2.1-20 10.5s2.1 17.4 10.5 20l38.5 12c9.3 2.9 19.3 2.9 28.6 0l38.5-12c8.4-2.6 13.1-11.6 10.5-20s-11.6-13.1-20-10.5l-38.5 12c-3.1 1-6.4 1-9.5 0l-38.5-12z"
        }
    ]
};

const FasKazoo = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasKazoo",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M514 128h94c17.7 0 32 14.3 32 32v192c0 17.7-14.3 32-32 32h-94c-19.8 10.2-42.2 16-66 16s-46.3-5.8-66-16H224c-3 0-6-.4-9-1.3l-192-56c-13.6-4-23-16.5-23-30.7v-80c0-14.2 9.4-26.7 23-30.7l192-56c2.9-.8 5.9-1.3 9-1.3h158c19.8-10.2 42.2-16 66-16s46.3 5.8 66 16zm30 128a96 96 0 1 0-192 0 96 96 0 1 0 192 0zm-116.7-43.3 20.7 20.7 20.7-20.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L470.6 256l20.7 20.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L448 278.6l-20.7 20.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l20.7-20.7-20.7-20.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0z"
        }
    ]
};

const FasKerning = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasKerning",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M454.3 23.2c4-7.9.7-17.5-7.2-21.5s-17.5-.7-21.5 7.2l-240 480c-4 7.9-.7 17.5 7.2 21.5s17.5.7 21.5-7.2l240-480zM60.6 113.7c-7.9-15.8-27.1-22.2-42.9-14.3s-22.2 27.1-14.3 42.9l128 256c5.4 10.8 16.5 17.7 28.6 17.7s23.2-6.8 28.6-17.7l128-256c7.9-15.8 1.5-35-14.3-42.9s-35-1.5-42.9 14.3L160 312.4 60.6 113.7zm320 284.6 23.2-46.3h152.4l23.2 46.3c7.9 15.8 27.1 22.2 42.9 14.3s22.2-27.1 14.3-42.9l-128-256C503.2 102.8 492.1 96 480 96s-23.2 6.8-28.6 17.7l-128 256c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3zM480 199.6l44.2 88.4h-88.4l44.2-88.4z"
        }
    ]
};

const FasKeySkeletonLeftRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasKeySkeletonLeftRight",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M576 128a64 64 0 1 0-128 0 64 64 0 1 0 128 0zm64 0c0 70.7-57.3 128-128 128-59.6 0-109.8-40.8-124-96h-68v32c0 17.7-14.3 32-32 32s-32-14.3-32-32v-32h-32v32c0 17.7-14.3 32-32 32s-32-14.3-32-32v-64c0-17.7 14.3-32 32-32h196c14.2-55.2 64.4-96 124-96 70.7 0 128 57.3 128 128zM64 384a64 64 0 1 0 128 0 64 64 0 1 0-128 0zm-64 0c0-70.7 57.3-128 128-128 59.6 0 109.8 40.8 124 96h68v-32c0-17.7 14.3-32 32-32s32 14.3 32 32v32h32v-32c0-17.7 14.3-32 32-32s32 14.3 32 32v64c0 17.7-14.3 32-32 32H252c-14.2 55.2-64.3 96-124 96C57.3 512 0 454.7 0 384z"
        }
    ]
};

const FasKeySkeleton = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasKeySkeleton",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M304 64a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm0 224c79.5 0 144-64.5 144-144S383.5 0 304 0 160 64.5 160 144c0 28.2 8.1 54.5 22.1 76.7L9.4 393.4c-12.5 12.5-12.5 32.8 0 45.3l64 64c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 416 96 397.3l41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L141.3 352l86.1-86.1c22.2 14 48.5 22.1 76.7 22.1z"
        }
    ]
};

const FasKey = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasKey",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M336 352c97.2 0 176-78.8 176-176S433.2 0 336 0 160 78.8 160 176c0 18.7 2.9 36.8 8.3 53.7L7 391c-4.5 4.5-7 10.6-7 17v80c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24v-40h40c13.3 0 24-10.7 24-24v-40h40c6.4 0 12.5-2.5 17-7l33.3-33.3c16.9 5.4 35 8.3 53.7 8.3zm40-256a40 40 0 1 1 0 80 40 40 0 1 1 0-80z"
        }
    ]
};

const FasKeyboardBrightnessLow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasKeyboardBrightnessLow",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-160 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm352-32a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm32 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-416-32a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm96-32c-17.7 0-32 14.3-32 32s14.3 32 32 32h192c17.7 0 32-14.3 32-32s-14.3-32-32-32H224z"
        }
    ]
};

const FasKeyboardBrightness = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasKeyboardBrightness",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M134.6 153.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l64 64c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-64-64zM288 192c0 17.7 14.3 32 32 32s32-14.3 32-32V96c0-17.7-14.3-32-32-32s-32 14.3-32 32v96zm153.4 25.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l64-64c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-64 64zM0 384c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32zm224-32c-17.7 0-32 14.3-32 32s14.3 32 32 32h192c17.7 0 32-14.3 32-32s-14.3-32-32-32H224zm320 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h64c17.7 0 32-14.3 32-32s-14.3-32-32-32h-64z"
        }
    ]
};

const FasKeyboardDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasKeyboardDown",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 0C28.7 0 0 28.7 0 64v160c0 35.3 28.7 64 64 64h448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm16 64h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16zM64 176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-32zm112-16h224c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16zm272 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32zM176 64h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16V80zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16V80zM153.8 366.8c-3.7 9-1.7 19.3 5.2 26.2l112 112c9.4 9.4 24.6 9.4 33.9 0L417 393c6.9-6.9 8.9-17.2 5.2-26.2S409.7 352 400 352H176c-9.7 0-18.5 5.8-22.2 14.8z"
        }
    ]
};

const FasKeyboardLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasKeyboardLeft",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 64c-35.3 0-64 28.7-64 64v256c0 35.3 28.7 64 64 64h352c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H224zm16 64h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16zm-16 112c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16zm80-176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16zm-16 112c0-8.8 7.2-16 16-16h128c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H336c-8.8 0-16-7.2-16-16v-32zm112-208h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16zm-16 112c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32zm112-112h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16zm-16 112c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16zM113.2 153.8c-9-3.7-19.3-1.7-26.2 5.2L7 239c-9.4 9.4-9.4 24.6 0 33.9l80 80c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2V176c0-9.7-5.8-18.5-14.8-22.2z"
        }
    ]
};

const FasKeyboard = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasKeyboard",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64C28.7 64 0 92.7 0 128v256c0 35.3 28.7 64 64 64h448c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm16 64h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-32zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16zm80-176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16zm-16 112c0-8.8 7.2-16 16-16h224c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16v-32zm112-208h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16zm-16 112c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32zm112-112h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16zm-16 112c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32zm112-112h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16zm-16 112c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16z"
        }
    ]
};

const FasKeynote = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasKeynote",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M184 72h14.4c8.3 14.3 23.8 24 41.6 24h64c26.5 0 48-21.5 48-48S330.5 0 304 0h-64c-17.8 0-33.3 9.7-41.6 24H184c-48.6 0-88 39.4-88 88v48H80c-12.1 0-23.2 6.8-28.6 17.7l-48 96C1.2 278.1 0 283 0 288v32c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32v-32c0-5-1.2-9.9-3.4-14.3l-48-96c-5.4-10.9-16.5-17.7-28.6-17.7H144v-48c0-22.1 17.9-40 40-40zm-24 376c-17.7 0-32 14.3-32 32s14.3 32 32 32h192c17.7 0 32-14.3 32-32s-14.3-32-32-32h-64v-64h-64v64h-64z"
        }
    ]
};

const FasKhanda = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasKhanda",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M245.8 3.7c5.9-4.9 14.6-4.9 20.5 0l48 40c5.9 4.9 7.5 13.2 3.8 19.9l-.1.1-.3.6c-.3.5-.7 1.3-1.2 2.3-1 2-2.6 5-4.4 8.6-.5.9-.9 1.9-1.4 2.9C344.9 97.4 368 134 368 176s-23.1 78.6-57.3 97.8c.5 1 1 2 1.4 2.9 1.8 3.7 3.3 6.6 4.4 8.6.5 1 .9 1.8 1.2 2.3l.3.6.1.1c3.6 6.7 2 15-3.8 19.9L272 343.5v19.8l35.6-24.5 41.1-28.2c42.8-29.4 68.4-78 68.4-130 0-31.1-9.2-61.6-26.5-87.5l-2.8-4.2c-4-6-3.5-14 1.3-19.5s12.7-7 19.2-3.7L401.1 80l7.2-14.3h.1l.3.2 1 .5c.8.4 2 1.1 3.5 1.9 2.9 1.7 7 4.1 11.8 7.3 9.6 6.4 22.5 16.1 35.4 29 25.7 25.7 52.7 65.6 52.7 119.3 0 53.1-26.4 100.5-51.2 133.6-12.6 16.7-25.1 30.3-34.5 39.7-4.7 4.7-8.7 8.4-11.5 10.9-1.4 1.3-2.5 2.2-3.3 2.9l-.9.8-.3.2-.1.1-10.2-12.3 10.2 12.3c-5.1 4.3-12.4 4.9-18.2 1.6l-75.6-43-32.7 22.5 45.5 31.3c1.8-.4 3.7-.7 5.7-.7 13.3 0 24 10.7 24 24s-10.7 24-24 24c-12.2 0-22.3-9.1-23.8-21L272 423.4v28.9c9.6 5.5 16 15.9 16 27.7 0 17.7-14.3 32-32 32s-32-14.3-32-32c0-11.8 6.4-22.2 16-27.7v-28.2l-40.3 27.7c-1.9 11.5-11.8 20.2-23.7 20.2-13.3 0-24-10.7-24-24s10.7-24 24-24c2.2 0 4.4.3 6.5.9l45.8-31.5-32.7-22.5-75.6 43c-5.8 3.3-13 2.7-18.2-1.6L112 400c-10.2 12.3-10.2 12.3-10.3 12.3l-.1-.1-.3-.2-.9-.8c-.8-.7-1.9-1.7-3.3-2.9-2.8-2.5-6.7-6.2-11.5-10.9-9.4-9.4-21.9-23-34.5-39.7C26.4 324.5 0 277.1 0 224c0-53.7 26.9-93.6 52.7-119.3 12.9-12.9 25.8-22.6 35.4-29C93 72.5 97 70 99.9 68.4c1.5-.8 2.6-1.5 3.5-1.9l1-.5.3-.2h.1l7.2 14.3-7.2-14.3c6.5-3.2 14.3-1.7 19.2 3.7s5.3 13.4 1.3 19.5l-2.8 4.2C105.2 119 96 149.5 96 180.6c0 51.9 25.6 100.6 68.4 130l41.1 28.2 34.5 23.8v-19.1l-42.2-35.2c-5.9-4.9-7.5-13.2-3.8-19.9l.1-.1.3-.6c.3-.5.7-1.3 1.2-2.3 1-2 2.6-5 4.4-8.6.5-.9.9-1.9 1.4-2.9C167.1 254.6 144 218 144 176s23.1-78.6 57.3-97.8c-.5-1-1-2-1.4-2.9-1.8-3.7-3.3-6.6-4.4-8.6-.5-1-.9-1.8-1.2-2.3l-.3-.6-.1-.1c-3.6-6.7-2-15 3.8-19.9l48-40zm-25.6 119.2c-17 11.5-28.2 31-28.2 53.1s11.2 41.6 28.2 53.1C227 210.2 232 190.9 232 176s-5-34.2-11.8-53.1zm71.5 106.2c17-11.5 28.2-31 28.2-53.1s-11.2-41.6-28.2-53.1C285 141.8 280 161.1 280 176s5 34.2 11.8 53.1z"
        }
    ]
};

const FasKidneys = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasKidneys",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M152 0c-21.5 0-45.5 6.3-64.3 23.8C56.4 52.8 0 119.6 0 224c0 24.9 3.5 54.7 7.1 79.1 7.1 48 48.8 80.9 95.3 80.9 58.4 0 104-50.4 98.2-108.5l-4.1-41.2c-2-20.1 4.5-40.1 17.9-55.1l18.2-20.5c15.2-17.1 23.5-39.1 23.5-61.9 0-31.2-15.6-60.2-41.5-77.5l-3.4-2.3c-16.7-11.1-36.1-17-56-17H152zm336 0h-3.2c-19.9 0-39.4 5.9-55.9 16.9l-3.4 2.3C399.6 36.5 384 65.6 384 96.7c0 22.8 8.4 44.8 23.5 61.9l18.2 20.5c13.4 15.1 19.9 35.1 17.9 55.1l-4.1 41.2c-5.8 58.2 39.8 108.6 98.2 108.6 46.5 0 88.2-32.9 95.3-80.9 3.6-24.4 7.1-54.2 7.1-79.1 0-104.4-56.4-171.2-87.7-200.2C533.5 6.3 509.5 0 488 0zM228.2 231.1l1.9 18.8 21.5 10.7c2.7 1.4 4.4 4.1 4.4 7.2V488c0 13.3 10.7 24 24 24s24-10.7 24-24V267.8c0-21.2-12-40.6-31-50.1l-34.8-17.4-.1.1c-7.5 8.4-11.1 19.5-10 30.7zm173.6-30.7-.1-.1-34.7 17.4c-19 9.5-31 28.9-31 50.1V488c0 13.3 10.7 24 24 24s24-10.7 24-24V267.8c0-3 1.7-5.8 4.4-7.2l21.5-10.7 1.9-18.8c1.1-11.2-2.5-22.3-10-30.7z"
        }
    ]
};

const FasKipSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasKipSign",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M340.8 88.3c13.4-11.5 15-31.7 3.5-45.1s-31.7-15-45.1-3.5L128 186.4V64c0-17.7-14.3-32-32-32S64 46.3 64 64v160H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h32v160c0 17.7 14.3 32 32 32s32-14.3 32-32V325.6l171.2 146.7c13.4 11.5 33.6 9.9 45.1-3.5s9.9-33.6-3.5-45.1L182.5 288H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H182.5L340.8 88.3z"
        }
    ]
};

const FasKitMedical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasKitMedical",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h32V32H64zm64 0v448h320V32H128zm384 448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64h-32v448h32zM256 176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-48v48c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-48h-48c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h48v-48z"
        }
    ]
};

const FasKitchenSet = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasKitchenSet",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M240 144a96 96 0 1 0-192 0 96 96 0 1 0 192 0zm44.4 32c-14.5 64.1-71.9 112-140.4 112C64.5 288 0 223.5 0 144S64.5 0 144 0c68.5 0 125.9 47.9 140.4 112h71.8c8.8-9.8 21.6-16 35.8-16h104c26.5 0 48 21.5 48 48s-21.5 48-48 48H392c-14.2 0-27-6.2-35.8-16h-71.8zM144 80a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm256 160c13.3 0 24 10.7 24 24v8h96c13.3 0 24 10.7 24 24s-10.7 24-24 24H280c-13.3 0-24-10.7-24-24s10.7-24 24-24h96v-8c0-13.3 10.7-24 24-24zM288 464V352h224v112c0 26.5-21.5 48-48 48H336c-26.5 0-48-21.5-48-48zM48 320h128c26.5 0 48 21.5 48 48s-21.5 48-48 48h-16c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32v-80c0-8.8 7.2-16 16-16zm128 64c8.8 0 16-7.2 16-16s-7.2-16-16-16h-16v32h16zM24 464h176c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
        }
    ]
};

const FasKite = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasKite",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M344 0c-14.9 0-27.8 10.3-31.2 24.8l-80 344c-.4 1.7-.7 3.5-.8 5.2l-85.4 85.4c-2.9 2.9-6.9 4.6-11 4.6-8.6 0-15.6-7-15.6-15.6v-88.6l-24-12-24 12v88.6c0 35.1 28.5 63.6 63.6 63.6 16.9 0 33-6.7 45-18.6l85.4-85.5c1.8-.1 3.5-.4 5.2-.8l344-80c14.5-3.4 24.8-16.3 24.8-31.2V32c0-17.7-14.3-32-32-32H344zM24 128c-13.3 0-24 10.7-24 24s10.7 24 24 24h8c22.1 0 40 17.9 40 40v68l-53.3-26.6c-1.8-.9-3.8-1.4-5.8-1.4C5.8 256 0 261.8 0 268.9V339c0 7.2 5.8 13 12.9 13 2 0 4-.5 5.8-1.4L72 324l9.7-4.8c4.5-2.3 9.4-3.4 14.3-3.4h.5c3.5.1 7 .7 10.4 1.9 1.2.4 2.3.9 3.4 1.5l9.7 4.8 53.3 26.6c1.8.9 3.8 1.4 5.8 1.4 7.1 0 12.9-5.8 12.9-12.9v-70.2c0-7.1-5.8-12.9-12.9-12.9-2 0-4 .5-5.8 1.4L120 284v-68c0-48.6-39.4-88-88-88h-8zm403.3-43.3 52.7 52.7 52.7-52.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L502.6 160l52.7 52.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L480 182.6 363.3 299.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L457.4 160l-52.7-52.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0z"
        }
    ]
};

const FasKiwiBird = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasKiwiBird",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M291.2 388.4c31.2-18.8 64.7-36.4 101.1-36.4H448c4.6 0 9.1-.2 13.6-.7l85.3 121.9c4 5.7 11.3 8.2 17.9 6.1S576 471 576 464V224c0-70.7-57.3-128-128-128h-55.7c-36.4 0-69.9-17.6-101.1-36.4C262.3 42.1 228.3 32 192 32 86 32 0 118 0 224c0 71.1 38.6 133.1 96 166.3V456c0 13.3 10.7 24 24 24s24-10.7 24-24v-46c15.3 3.9 31.4 6 48 6 5.4 0 10.7-.2 16-.7V456c0 13.3 10.7 24 24 24s24-10.7 24-24v-50.9c12.4-4.4 24.2-10 35.2-16.7zM448 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FasKiwiFruit = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasKiwiFruit",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 176c0 79.5-100.3 144-224 144S0 255.5 0 176 100.3 32 224 32s224 64.5 224 144zM224 64c-8.8 0-16 7.2-16 16v24c0 8.8 7.2 16 16 16s16-7.2 16-16V80c0-8.8-7.2-16-16-16zM64 176c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm256 0c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16zm-96 56c-8.8 0-16 7.2-16 16v24c0 8.8 7.2 16 16 16s16-7.2 16-16v-24c0-8.8-7.2-16-16-16zM139.3 92.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l16 16c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-16-16zm192 0c-6.2-6.2-16.4-6.2-22.6 0l-16 16c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l16-16c6.2-6.2 6.2-16.4 0-22.6zm-176 150.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-16 16c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l16-16zm160-22.6c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l16 16c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-16-16zM280 176c0-13.3-25.1-24-56-24s-56 10.7-56 24 25.1 24 56 24 56-10.7 56-24zm-56 304C102.4 480 3.4 383.1.1 262.2c13.2 16.4 29.8 30.7 48.2 42.5C94.7 334.6 156.9 352 224 352s129.3-17.4 175.7-47.3c18.5-11.9 35-26.2 48.2-42.5C444.6 383.1 345.6 480 224 480z"
        }
    ]
};

const FasKnifeKitchen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasKnifeKitchen",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M488 0c9.4 0 18.3 3.7 25 10.3L557.7 55c6.6 6.6 10.3 15.6 10.3 25s-3.7 18.3-10.3 25l-97 97c-3 3-4.7 7.1-4.7 11.3v31.9c0 17.4-9.4 33.5-24.7 42l-31 17.2-104.4-104.3-11.3-11.3L463 10.3C469.7 3.7 478.6 0 488 0zm-56 160a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-80a16 16 0 1 0-32 0 16 16 0 1 0 32 0zM262 211.4l11.3 11.3 126 126c6.2 6.2 6.2 16.4 0 22.6C321.4 449.2 235.3 512 112 512c-25.6 0-50.9-4.2-69.5-8.4-9.4-2.1-17.2-4.2-22.7-5.7-2.8-.8-4.9-1.4-6.5-1.9-.8-.2-1.4-.4-1.8-.6l-.5-.2h-.1L16 480l-5.1 15.2c-5.3-1.8-9.2-6.1-10.5-11.5s.3-11.1 4.3-15l246-246 11.3-11.3z"
        }
    ]
};

const FasKnife = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasKnife",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m217.5 249.3 242-242c4.7-4.7 11-7.3 17.6-7.3 11.2 0 21 7.5 23.5 18.4C505.3 38.6 512 71.5 512 96c0 83.3-48.2 130.5-128.9 209.4-6.5 6.4-13.3 13-20.3 19.9-12.1 11.9-28.4 18.7-45.3 18.7h-11c-17 0-33.3-6.7-45.3-18.7l-14.6-14.6-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192 16-16 .1-.1z"
        }
    ]
};

const FasL = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasL",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32c17.7 0 32 14.3 32 32v352h192c17.7 0 32 14.3 32 32s-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32z"
        }
    ]
};

const FasLacrosseStickBall = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasLacrosseStickBall",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M336 64h.3c19.9 0 48.1 13.6 73.1 38.6s38.6 53.2 38.6 73.1v.3c0 33.1-21.9 62.1-53.7 71.2l-11.5 3.3c-19.6 5.6-37.9 15.1-53.9 27.8L294 306.2c-11.1 8.9-25 13.8-39.2 13.8-34.7 0-62.8-28.1-62.8-62.8 0-14.3 4.9-28.1 13.8-39.2l27.9-34.9c12.8-15.9 22.2-34.3 27.8-53.9l3.3-11.5C273.9 85.9 302.9 64 336 64zm0-64c-61.6 0-115.8 40.9-132.7 100.1l-3.3 11.6c-3.3 11.5-8.8 22.2-16.2 31.5l-27.9 34.9c-18 22.5-27.8 50.4-27.8 79.2 0 23.4 6.3 45.3 17.4 64.1l-136 136C-3 469.9-3 490.2 9.5 502.7s32.8 12.5 45.3 0l136-136c18.8 11.1 40.7 17.4 64.1 17.4 28.8 0 56.7-9.8 79.2-27.8l34.9-27.9c9.3-7.4 20-13 31.5-16.2l11.5-3.3c59.1-17.1 100-71.3 100-132.9v-.3c0-43.8-26.4-87.4-57.3-118.4S380.1 0 336.3 0h-.3zm160 512a80 80 0 1 0 0-160 80 80 0 1 0 0 160z"
        }
    ]
};

const FasLacrosseStick = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasLacrosseStick",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M336 64h.3c19.9 0 48.1 13.6 73.1 38.6s38.6 53.2 38.6 73.1v.3c0 33.1-21.9 62.1-53.7 71.2l-11.5 3.3c-19.6 5.6-37.9 15.1-53.9 27.8L294 306.2c-11.1 8.9-25 13.8-39.2 13.8-34.7 0-62.8-28.1-62.8-62.8 0-14.3 4.9-28.1 13.8-39.2l27.9-34.9c12.8-15.9 22.2-34.3 27.8-53.9l3.3-11.5C273.9 85.9 302.9 64 336 64zm0-64c-61.6 0-115.8 40.9-132.7 100.1l-3.3 11.6c-3.3 11.5-8.8 22.2-16.2 31.5l-27.9 34.9c-18 22.5-27.8 50.4-27.8 79.2 0 23.4 6.3 45.3 17.4 64.1l-136 136C-3 469.9-3 490.2 9.5 502.7s32.8 12.5 45.3 0l136-136c18.8 11.1 40.7 17.4 64.1 17.4 28.8 0 56.7-9.8 79.2-27.8l34.9-27.9c9.3-7.4 20-13 31.5-16.2l11.5-3.3c59.1-17.1 100-71.3 100-132.9v-.3c0-43.8-26.4-87.4-57.3-118.4S380.1 0 336.3 0h-.3z"
        }
    ]
};

const FasLambda = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasLambda",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 32C14.3 32 0 46.3 0 64s14.3 32 32 32h108.2l16.4 32.7L18.8 434.9c-7.3 16.1-.1 35.1 16 42.3s35.1.1 42.3-16l116.4-258.6 121 242c10.8 21.7 33 35.4 57.2 35.4H416c17.7 0 32-14.3 32-32s-14.3-32-32-32h-44.2L197.5 67.4c-10.9-21.7-33-35.4-57.3-35.4H32z"
        }
    ]
};

const FasLampDesk = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasLampDesk",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 65.9C192 29.5 221.5 0 257.9 0c17.5 0 34.3 6.9 46.6 19.3L349.3 64H480c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-73.5 73.5-45.1 45.1-73.5 73.5c-9.2 9.2-22.9 11.9-34.9 6.9s-19.8-16.6-19.8-29.6V173.3l-92.6 92.6L209 448h143c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h111L97 263.8c-2.7-10.9.5-22.4 8.4-30.4L218.7 120l-7.4-7.4C198.9 100.2 192 83.4 192 65.9zM432 288c-14.7 0-27.8-6.6-36.6-16.9l67.7-67.7c10.3 8.8 16.9 21.9 16.9 36.6 0 26.5-21.5 48-48 48z"
        }
    ]
};

const FasLampFloor = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasLampFloor",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M194.3 20.1C199.1 8 210.9 0 224 0h192c13.1 0 24.9 8 29.7 20.1l64 160c3.9 9.9 2.7 21-3.2 29.8S490.6 224 480 224H160c-10.6 0-20.5-5.3-26.5-14.1s-7.2-20-3.2-29.8l64-160zM288 256h64v192h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32h64V256z"
        }
    ]
};

const FasLampStreet = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasLampStreet",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 176c0-61.9 50.1-112 112-112 57.4 0 104.7 43.2 111.2 98.8-80.1 13.8-143.2 77.1-156.6 157.3-2.9 17.5 11.7 31.9 29.4 31.9h320c17.7 0 32.3-14.4 29.4-31.9-13.5-80.6-77.2-144.2-157.9-157.6C344.6 71.6 268.7 0 176 0 78.8 0 0 78.8 0 176v304c0 17.7 14.3 32 32 32s32-14.3 32-32V176zm256 272c35.3 0 64-28.7 64-64H256c0 35.3 28.7 64 64 64z"
        }
    ]
};

const FasLamp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasLamp",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M82.5 19.7C87.4 7.8 99.1 0 112 0h224c12.9 0 24.6 7.8 29.5 19.7l80 192c4.1 9.9 3 21.2-2.9 30.1S426.7 256 416 256H32c-10.7 0-20.7-5.3-26.6-14.2s-7-20.2-2.9-30.1l80-192zM160 288h128v32s64 50.5 64 112c0 24.4-8.3 44.6-16.4 58.7-8.5 14.7-25.2 21.3-42.1 21.3h-139c-17 0-33.6-6.6-42.1-21.3C104.3 476.6 96 456.4 96 432c0-61.5 64-112 64-112v-32z"
        }
    ]
};

const FasLandMineOn = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasLandMineOn",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M344 24v144c0 13.3-10.7 24-24 24s-24-10.7-24-24V24c0-13.3 10.7-24 24-24s24 10.7 24 24zM192 320c0-17.7 14.3-32 32-32h192c17.7 0 32 14.3 32 32v32H192v-32zm-77.3 90.5c8.1-16.3 24.8-26.5 42.9-26.5h324.7c18.2 0 34.8 10.3 42.9 26.5l27.6 55.2C563.5 487 548 512 524.2 512H115.8c-23.8 0-39.3-25-28.6-46.3l27.6-55.2zM36.3 138.3c7.5-10.9 22.5-13.6 33.4-6.1l104 72c10.9 7.5 13.6 22.5 6.1 33.4s-22.5 13.6-33.4 6.1l-104-72c-10.9-7.5-13.6-22.5-6.1-33.4zm534.1-6.1c10.9-7.5 25.8-4.8 33.4 6.1s4.8 25.8-6.1 33.4l-104 72c-10.9 7.5-25.8 4.8-33.4-6.1s-4.8-25.8 6.1-33.4l104-72z"
        }
    ]
};

const FasLandmarkDome = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasLandmarkDome",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M248 0h16c13.3 0 24 10.7 24 24v10.7c80.4 13.4 143.9 76.9 157.3 157.3h2.7c17.7 0 32 14.3 32 32s-14.3 32-32 32H64c-17.7 0-32-14.3-32-32s14.3-32 32-32h2.7C80.1 111.6 143.6 48.1 224 34.7V24c0-13.3 10.7-24 24-24zM64 288h64v128h40V288h64v128h48V288h64v128h40V288h64v132.3c.6.3 1.2.7 1.7 1.1l48 32c11.7 7.8 17 22.4 12.9 35.9S494.1 512 480 512H32c-14.1 0-26.5-9.2-30.6-22.7s1.1-28.1 12.9-35.9l48-32c.6-.4 1.2-.7 1.8-1.1V288z"
        }
    ]
};

const FasLandmarkFlag = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasLandmarkFlag",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M272 0h80c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16h-80v32h192c17.7 0 32 14.3 32 32s-14.3 32-32 32H48c-17.7 0-32-14.3-32-32s14.3-32 32-32h192V16c0-8.8 7.2-16 16-16h16zM64 224h64v192h40V224h64v192h48V224h64v192h40V224h64v196.3c.6.3 1.2.7 1.8 1.1l48 32c11.7 7.8 17 22.4 12.9 35.9S494.1 512 480 512H32c-14.1 0-26.5-9.2-30.6-22.7s1.1-28.1 12.9-35.9l48-32c.6-.4 1.2-.7 1.8-1.1V224z"
        }
    ]
};

const FasLandmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasLandmark",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M240.1 4.2c9.8-5.6 21.9-5.6 31.8 0l171.8 98.1 4.3 1.7v.9l47.9 27.4c12.6 7.2 18.8 22 15.1 36s-16.4 23.8-30.9 23.8H32c-14.5 0-27.2-9.8-30.9-23.8s2.5-28.8 15.1-36L64 104.9v-.9l4.4-1.6L240.1 4.2zM64 224h64v192h40V224h64v192h48V224h64v192h40V224h64v196.3c.6.3 1.2.7 1.8 1.1l48 32c11.7 7.8 17 22.4 12.9 35.9S494.1 512 480 512H32c-14.1 0-26.5-9.2-30.6-22.7s1.1-28.1 12.9-35.9l48-32c.6-.4 1.2-.7 1.8-1.1V224z"
        }
    ]
};

const FasLanguage = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasLanguage",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 128c0-35.3 28.7-64 64-64h512c35.3 0 64 28.7 64 64v256c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zm320 0v256h256V128H320zm-141.7 47.9c-3.2-7.2-10.4-11.9-18.3-11.9s-15.1 4.7-18.3 11.9l-64 144c-4.5 10.1.1 21.9 10.2 26.4s21.9-.1 26.4-10.2l8.9-20.1h73.6l8.9 20.1c4.5 10.1 16.3 14.6 26.4 10.2s14.6-16.3 10.2-26.4l-64-144zM160 233.2l19 42.8h-38l19-42.8zM448 164c11 0 20 9 20 20v4h60c11 0 20 9 20 20s-9 20-20 20h-2l-1.6 4.5c-8.9 24.4-22.4 46.6-39.6 65.4.9.6 1.8 1.1 2.7 1.6l18.9 11.3c9.5 5.7 12.5 18 6.9 27.4s-18 12.5-27.4 6.9L467 333.8c-4.5-2.7-8.8-5.5-13.1-8.5-10.6 7.5-21.9 14-34 19.4l-3.6 1.6c-10.1 4.5-21.9-.1-26.4-10.2s.1-21.9 10.2-26.4l3.6-1.6c6.4-2.9 12.6-6.1 18.5-9.8L410 286.1c-7.8-7.8-7.8-20.5 0-28.3s20.5-7.8 28.3 0l14.6 14.6.5.5c12.4-13.1 22.5-28.3 29.8-45H376c-11 0-20-9-20-20s9-20 20-20h52v-4c0-11 9-20 20-20z"
        }
    ]
};

const FasLaptopArrowDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasLaptopArrowDown",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 32c-35.3 0-64 28.7-64 64v256h64V96h128V32H128zm384 64v256h64V96c0-35.3-28.7-64-64-64H384v64h128zM19.2 384C8.6 384 0 392.6 0 403.2 0 445.6 34.4 480 76.8 480h486.4c42.4 0 76.8-34.4 76.8-76.8 0-10.6-8.6-19.2-19.2-19.2H19.2zM344 56c0-13.3-10.7-24-24-24s-24 10.7-24 24v182.1l-39-39c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l80 80c9.4 9.4 24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-39 39V56z"
        }
    ]
};

const FasLaptopBinary = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasLaptopBinary",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 96c0-35.3 28.7-64 64-64h384c35.3 0 64 28.7 64 64v256h-64V96H128v256H64V96zM0 403.2C0 392.6 8.6 384 19.2 384h601.6c10.6 0 19.2 8.6 19.2 19.2 0 42.4-34.4 76.8-76.8 76.8H76.8C34.4 480 0 445.6 0 403.2zM200 128h16c22.1 0 40 17.9 40 40v32c0 22.1-17.9 40-40 40h-16c-22.1 0-40-17.9-40-40v-32c0-22.1 17.9-40 40-40zm-8 40v32c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-32c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8zm112-40h16c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16v-64c-8.8 0-16-7.2-16-16s7.2-16 16-16zm80 40c0-22.1 17.9-40 40-40h16c22.1 0 40 17.9 40 40v32c0 22.1-17.9 40-40 40h-16c-22.1 0-40-17.9-40-40v-32zm40-8c-4.4 0-8 3.6-8 8v32c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-32c0-4.4-3.6-8-8-8h-16zM192 272h16c8.8 0 16 7.2 16 16v64h-32v-48c-8.8 0-16-7.2-16-16s7.2-16 16-16zm256 16v64h-32v-48c-8.8 0-16-7.2-16-16s7.2-16 16-16h16c8.8 0 16 7.2 16 16zm-80 24v40h-32v-40c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v40h-32v-40c0-22.1 17.9-40 40-40h16c22.1 0 40 17.9 40 40z"
        }
    ]
};

const FasLaptopCode = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasLaptopCode",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 96c0-35.3 28.7-64 64-64h384c35.3 0 64 28.7 64 64v256h-64V96H128v256H64V96zM0 403.2C0 392.6 8.6 384 19.2 384h601.6c10.6 0 19.2 8.6 19.2 19.2 0 42.4-34.4 76.8-76.8 76.8H76.8C34.4 480 0 445.6 0 403.2zM281 209l-31 31 31 31c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-48-48c-9.4-9.4-9.4-24.6 0-33.9l48-48c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zm112-34 48 48c9.4 9.4 9.4 24.6 0 33.9l-48 48c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l31-31-31-31c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z"
        }
    ]
};

const FasLaptopFile = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasLaptopFile",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 0C92.7 0 64 28.7 64 64v224H19.2C8.6 288 0 296.6 0 307.2 0 349.6 34.4 384 76.8 384H320v-96H128V64h320v32h64V64c0-35.3-28.7-64-64-64H128zm384 128H400c-26.5 0-48 21.5-48 48v288c0 26.5 21.5 48 48 48h192c26.5 0 48-21.5 48-48V256h-96c-17.7 0-32-14.3-32-32v-96zm32 0v96h96l-96-96z"
        }
    ]
};

const FasLaptopMedical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasLaptopMedical",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 96c0-35.3 28.7-64 64-64h384c35.3 0 64 28.7 64 64v256h-64V96H128v256H64V96zM0 403.2C0 392.6 8.6 384 19.2 384h601.6c10.6 0 19.2 8.6 19.2 19.2 0 42.4-34.4 76.8-76.8 76.8H76.8C34.4 480 0 445.6 0 403.2zM288 160c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-48v48c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-48h-48c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h48v-48z"
        }
    ]
};

const FasLaptopMobile = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasLaptopMobile",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 0C92.7 0 64 28.7 64 64v224H19.2C8.6 288 0 296.6 0 307.2 0 349.6 34.4 384 76.8 384H352v-96H128V64h320v32h64V64c0-35.3-28.7-64-64-64H128zm320 448V192h128v256H448zm-64-272v288c0 26.5 21.5 48 48 48h160c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48H432c-26.5 0-48 21.5-48 48z"
        }
    ]
};

const FasLaptopSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasLaptopSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-14-10.9c14.3-13.9 23.2-33.4 23.2-55 0-10.6-8.6-19.2-19.2-19.2h-98.6L154.8 96H512v256h64V96c0-35.3-28.7-64-64-64H128c-14.4 0-27.8 4.8-38.5 12.9L38.8 5.1zM128 197l-64-50.4V352h64V197zm359.2 283-121.9-96H19.2C8.6 384 0 392.6 0 403.2 0 445.6 34.4 480 76.8 480h410.4z"
        }
    ]
};

const FasLaptop = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasLaptop",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 32c-35.3 0-64 28.7-64 64v256h64V96h384v256h64V96c0-35.3-28.7-64-64-64H128zM19.2 384C8.6 384 0 392.6 0 403.2 0 445.6 34.4 480 76.8 480h486.4c42.4 0 76.8-34.4 76.8-76.8 0-10.6-8.6-19.2-19.2-19.2H19.2z"
        }
    ]
};

const FasLariSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasLariSign",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 32c17.7 0 32 14.3 32 32v32.7c5.3-.4 10.6-.7 16-.7s10.7.2 16 .7V64c0-17.7 14.3-32 32-32s32 14.3 32 32v49.4c54.9 25.2 95.8 75.5 108.2 136.2 3.5 17.3-7.7 34.2-25 37.7s-34.2-7.7-37.7-25c-6.1-29.9-22.5-55.9-45.4-74.3v68c0 17.7-14.3 32-32 32s-32-14.3-32-32v-95c-5.2-.7-10.6-1-16-1s-10.8.3-16 1v95c0 17.7-14.3 32-32 32s-32-14.3-32-32v-67.9C82.7 211.5 64 247.6 64 288c0 70.7 57.3 128 128 128h160c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h16.9C18.5 382 0 337.2 0 288c0-77.5 45.9-144.3 112-174.6V64c0-17.7 14.3-32 32-32z"
        }
    ]
};

const FasLassoSparkles = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasLassoSparkles",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M290.7 0H288C128.9 0 0 78.8 0 176c0 57.2 44.7 108.1 113.9 140.2l-.2.4 46.8 23.4c19.3 9.7 31.5 29.4 31.5 51 0 31.5-25.5 57-57 57H64c-17.7 0-32 14.3-32 32s14.3 32 32 32h71c66.8 0 121-54.2 121-121 0-14.1-2.4-27.8-7-40.6 12.8 1.1 25.8 1.6 39 1.6 159.1 0 288-78.8 288-176 0-76.4-79.6-141.4-191-165.8l5.6 15.1 26 9.6C435.5 42 448 59.9 448 80c0 5.6-1 11.1-2.8 16.2 41.2 20.3 66.8 48.6 66.8 79.8 0 61.9-100.3 112-224 112S64 237.9 64 176c0-51 68.2-94 161.4-107.6 3.8-15.2 14.8-27.9 29.9-33.4l26-9.6L290.7 0zM351 10.4C348.7 4.2 342.7 0 336 0s-12.7 4.2-15 10.4l-14.7 39.9L266.4 65c-6.3 2.3-10.4 8.3-10.4 15s4.2 12.7 10.4 15l39.8 14.7 14.8 39.9c2.3 6.3 8.3 10.4 15 10.4s12.7-4.2 15-10.4l14.7-39.8L405.6 95c6.3-2.3 10.4-8.3 10.4-15s-4.2-12.7-10.4-15l-39.9-14.7L351 10.4zM496 352c-6.7 0-12.7 4.2-15 10.4l-14.7 39.8-39.9 14.8c-6.3 2.3-10.4 8.3-10.4 15s4.2 12.7 10.4 15l39.8 14.7 14.8 39.9c2.3 6.3 8.3 10.4 15 10.4s12.7-4.2 15-10.4l14.7-39.8 39.9-14.8c6.3-2.3 10.4-8.3 10.4-15s-4.2-12.7-10.4-15l-39.8-14.7-14.8-39.9c-2.3-6.3-8.3-10.4-15-10.4z"
        }
    ]
};

const FasLasso = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasLasso",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M576 176c0 97.2-128.9 176-288 176-13.2 0-26.3-.5-39-1.6 4.6 12.8 7 26.5 7 40.6 0 66.8-54.2 121-121 121H64c-17.7 0-32-14.3-32-32s14.3-32 32-32h71c31.5 0 57-25.5 57-57 0-21.6-12.2-41.3-31.5-51l-46.8-23.4.2-.4C44.7 284.1 0 233.2 0 176 0 78.8 128.9 0 288 0s288 78.8 288 176zM288 288c123.7 0 224-50.1 224-112S411.7 64 288 64 64 114.1 64 176s100.3 112 224 112z"
        }
    ]
};

const FasLayerGroup = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasLayerGroup",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M264.5 5.2c14.9-6.9 32.1-6.9 47 0l218.6 101c8.5 3.9 13.9 12.4 13.9 21.8s-5.4 17.9-13.9 21.8l-218.6 101c-14.9 6.9-32.1 6.9-47 0l-218.6-101c-8.5-4-13.9-12.5-13.9-21.8s5.4-17.9 13.9-21.8l218.6-101zm212.4 204.4 53.2 24.6c8.5 3.9 13.9 12.4 13.9 21.8s-5.4 17.9-13.9 21.8l-218.6 101c-14.9 6.9-32.1 6.9-47 0l-218.6-101c-8.5-4-13.9-12.5-13.9-21.8s5.4-17.9 13.9-21.8l53.2-24.6 152 70.2a88.1 88.1 0 0 0 73.8 0l152-70.2zm-152 198.2 152-70.2 53.2 24.6c8.5 3.9 13.9 12.4 13.9 21.8s-5.4 17.9-13.9 21.8l-218.6 101c-14.9 6.9-32.1 6.9-47 0l-218.6-101c-8.5-4-13.9-12.5-13.9-21.8s5.4-17.9 13.9-21.8l53.2-24.6 152 70.2a88.1 88.1 0 0 0 73.8 0z"
        }
    ]
};

const FasLayerMinus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasLayerMinus",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M408 56c-13.3 0-24 10.7-24 24s10.7 24 24 24h112c13.3 0 24-10.7 24-24s-10.7-24-24-24H408zm-96.5 77.2c-14.9-6.9-32.1-6.9-47 0l-218.6 101C37.4 238.1 32 246.6 32 256s5.4 17.9 13.9 21.8l218.6 101c14.9 6.9 32.1 6.9 47 0l218.6-101c8.5-3.9 13.9-12.4 13.9-21.8s-5.4-17.9-13.9-21.8l-218.6-101zm13.4 274.7a88.1 88.1 0 0 1-73.8 0l-152-70.2-53.2 24.5C37.4 366.1 32 374.6 32 384s5.4 17.9 13.9 21.8l218.6 101c14.9 6.9 32.1 6.9 47 0l218.6-101c8.5-3.9 13.9-12.4 13.9-21.8s-5.4-17.9-13.9-21.8l-53.2-24.6-152 70.2z"
        }
    ]
};

const FasLayerPlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasLayerPlus",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 0c-13.3 0-24 10.7-24 24v32h-32c-13.3 0-24 10.7-24 24s10.7 24 24 24h32v32c0 13.3 10.7 24 24 24s24-10.7 24-24v-32h32c13.3 0 24-10.7 24-24s-10.7-24-24-24h-32V24c0-13.3-10.7-24-24-24zM311.5 133.2c-14.9-6.9-32.1-6.9-47 0l-218.6 101C37.4 238.1 32 246.6 32 256s5.4 17.9 13.9 21.8l218.6 101c14.9 6.9 32.1 6.9 47 0l218.6-101c8.5-3.9 13.9-12.4 13.9-21.8s-5.4-17.9-13.9-21.8l-218.6-101zm13.4 274.7a88.1 88.1 0 0 1-73.8 0l-152-70.2-53.2 24.5C37.4 366.1 32 374.6 32 384s5.4 17.9 13.9 21.8l218.6 101c14.9 6.9 32.1 6.9 47 0l218.6-101c8.5-3.9 13.9-12.4 13.9-21.8s-5.4-17.9-13.9-21.8l-53.2-24.6-152 70.2z"
        }
    ]
};

const FasLeafHeart = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasLeafHeart",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M272 96h104c42.7 0 79.9-23.9 98.8-59.1 3.5-6.5 13.6-6.8 16.2.1 13.5 36.5 21.1 77 21.1 119.6C512 317.1 405.1 447.3 273 448h-1c-81.7 0-150.4-55.7-170.2-131.2C68.7 347.5 48 391.4 48 440v16c0 13.3-10.7 24-24 24S0 469.3 0 456v-16c0-75.1 38.3-141.2 96.4-179.9C102.5 168.5 178.8 96 272 96zm-82.3 146.8c0 14.4 5.8 28.3 16.2 38.4l70.9 69c6.2 6 16.1 6 22.3 0l70.9-69c10.4-10.1 16.2-23.9 16.2-38.4 0-29.5-23.9-53.5-53.5-53.5h-1.5c-14.3 0-28.1 5.6-38.4 15.6l-4.9 4.8-4.9-4.8c-10.3-10-24-15.6-38.4-15.6h-1.5c-29.5 0-53.5 23.9-53.5 53.5z"
        }
    ]
};

const FasLeafMaple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasLeafMaple",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m339.8 7.5 15.8 31.6c7.1 14.2 23.6 21.1 38.7 16l67.6-22.5c1.4-.5 2.9-.7 4.4-.7 7.6 0 13.8 6.2 13.8 13.8 0 1.5-.2 2.9-.7 4.4l-22.5 67.6c-5 15.1 1.8 31.6 16 38.7l31.6 15.8c4.6 2.3 7.5 7 7.5 12.2 0 4.7-2.4 9.1-6.4 11.6l-97.9 61.2c-6.8 4.3-3.8 14.8 4.2 14.8h38.3c7.6 0 13.8 6.2 13.8 13.8 0 1.5-.2 2.9-.7 4.4l-8.5 25.5c-4.1 12.3-.3 25.9 9.5 34.4l34.3 29.4c3.4 2.9 5.4 7.2 5.4 11.7 0 5.5-3 10.6-7.8 13.4l-28.9 16.5c-11.6 6.6-17.9 19.8-15.7 33l4.2 25.1c.1.6.2 1.3.2 1.9 0 7.6-7.2 13.2-14.6 11.2l-155-40.4c-8.2-2.1-16.6 2.4-19.2 10.4l-8.5 25.4c-1.7 5-6.3 8.4-11.6 8.4-4.4 0-8.5-2.4-10.7-6.3l-53-95.3L73 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l200.2-200.3c3.6-6.1 2.7-14.1-2.5-19.4-6.2-6.2-16.4-6.2-22.6 0l-84 84-107.9-59.9c-3.9-2.2-6.3-6.2-6.3-10.7 0-5.3 3.4-9.9 8.4-11.6l25.4-8.5c8-2.7 12.5-11.1 10.4-19.2L19.8 70.6C17.9 63.2 23.4 56 31 56c.6 0 1.3.1 1.9.2L58 60.3c13.2 2.2 26.4-4.1 33-15.7l16.5-28.9c2.8-4.7 7.9-7.7 13.4-7.7 4.5 0 8.8 2 11.7 5.4L162 47.7c8.5 9.9 22.1 13.6 34.4 9.5l25.5-8.5c1.4-.5 2.9-.7 4.4-.7 7.6 0 13.8 6.2 13.8 13.8v38.3c0 8 10.5 11.1 14.8 4.2L316 6.4c2.5-4 6.9-6.4 11.6-6.4 5.2 0 9.9 2.9 12.2 7.5z"
        }
    ]
};

const FasLeafOak = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasLeafOak",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m429.7 268.6 40.9-10.2c24.4-6.1 41.4-28 41.4-53.1 0-18.3-9.1-35.4-24.4-45.5l-14.3-9.5c-5.6-3.8-8.3-10.6-6.6-17.2l5-20.1c5.1-20.4-.9-42-15.8-56.9S419.4 35.2 399 40.3l-20.1 5c-6.6 1.6-13.4-1-17.2-6.6l-9.5-14.3C342.1 9.1 325 0 306.7 0c-25.1 0-47 17.1-53.1 41.4l-10.2 40.9c-1.5 6-9 8.1-13.4 3.7l-22-22c-17.7-17.7-46.3-17.7-64 0-10.1 10.1-14.8 24.3-12.8 38.4l10.7 75.1c.8 5.6-5.4 9.5-10.1 6.4-20.8-13.9-48.5-11.2-66.2 6.5L62 194c-17.9 17.9-22.3 45.2-11 67.8L66.5 293c8.9 17.7 13.5 37.3 13.5 57.2v35.2l149.6-149.6c6.2-6.2 16.4-6.2 22.6 0 5.4 5.4 6.1 13.6 2.2 19.8L39 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l73-73h15.8c19.9 0 39.5 4.6 57.2 13.5l31.1 15.5c22.6 11.3 49.9 6.9 67.8-11l3.6-3.6c17.7-17.7 20.4-45.4 6.6-66.2-3.1-4.7.8-10.9 6.4-10.1l75.1 10.7c14.1 2 28.3-2.7 38.4-12.8 17.7-17.7 17.7-46.3 0-64l-22-22c-4.4-4.4-2.3-11.9 3.7-13.4z"
        }
    ]
};

const FasLeaf = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasLeaf",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M272 96c-78.6 0-145.1 51.5-167.7 122.5 33.6-17 71.5-26.5 111.7-26.5h88c8.8 0 16 7.2 16 16s-7.2 16-16 16h-88c-16.6 0-32.7 1.9-48.2 5.4-25.9 5.9-50 16.4-71.4 30.7C38.3 298.8 0 364.9 0 440v16c0 13.3 10.7 24 24 24s24-10.7 24-24v-16c0-48.7 20.7-92.5 53.8-123.2C121.6 392.3 190.3 448 272 448h1c132.1-.7 239-130.9 239-291.4 0-42.6-7.5-83.1-21.1-119.6-2.6-6.9-12.7-6.6-16.2-.1C455.9 72.1 418.7 96 376 96H272z"
        }
    ]
};

const FasLeafyGreen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasLeafyGreen",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M97.9 28.4C92 34.4 87 40.8 83 47.7c-13 21.9-32.4 42.2-52.1 58.2-2.3 1.8-4.4 3.8-6.5 5.9-25.8 25.8-31.2 64.4-15.9 95.4 5.7 11.7 11 24.1 11 37.1V280c0 14.7 5.8 28.8 16.3 39.2l26.3 26.3c10.4 10.4 16.3 24.5 16.3 39.2v12.9c0 2.9.2 5.8.7 8.7l7.6-7.6c6-6 9.4-14.1 9.4-22.6v-45.6c0-25.5 10.1-49.9 28.1-67.9l10.5-10.5c6-6 9.4-14.1 9.4-22.6v-43c0-25.5 10.1-49.9 28.1-67.9l29.1-29.1c5-5 8.8-12.9 13.7-27 4.4-12.9 10.8-24.8 18.9-35.5-38-36.5-98.4-36-135.8 1.5zm469.6 201.5c-3.1-29.1-2.3-61.5 5-89.9 2.3-8.9 3.5-18.3 3.5-28C576 50.1 525.9 0 464 0c-9.7 0-19 1.2-28 3.5-28.4 7.3-60.8 8.1-89.9 5-3.3-.3-6.7-.5-10.1-.5-42.1 0-77.9 27.1-90.8 64.9-4.9 14.3-10.6 28.6-21.3 39.3l-29.1 29.1c-12 12-18.7 28.3-18.7 45.3v43c0 17-6.7 33.3-18.7 45.3l-10.5 10.5c-12 12-18.7 28.3-18.7 45.3v45.7c0 17-6.7 33.3-18.7 45.3l-36.1 35.7c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l35.9-35.9c12-12 28.3-18.7 45.3-18.7h45.7c17 0 33.3-6.7 45.3-18.7l10.5-10.5c12-12 28.3-18.7 45.3-18.7h43c17 0 33.3-6.7 45.3-18.7l29.1-29.1c10.7-10.7 25-16.4 39.3-21.3 37.5-13.2 64.6-49 64.6-91.1 0-3.4-.2-6.8-.5-10.1zm-92.2-129.2c6.2 6.2 6.2 16.4 0 22.6L390.6 208H448c8.8 0 16 7.2 16 16s-7.2 16-16 16h-89.4l-59.3 59.3-48 48c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l43.3-43.3V192c0-8.8 7.2-16 16-16s16 7.2 16 16v57.4l36.7-36.7 112-112c6.2-6.2 16.4-6.2 22.6 0z"
        }
    ]
};

const FasLeftFromLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasLeftFromLine",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M134.1 406.1 11.3 283.3C4.1 276.1 0 266.2 0 256s4.1-20.1 11.3-27.3l122.8-122.8c6.4-6.4 15-9.9 24-9.9 18.7 0 33.9 15.2 33.9 33.9V192h128c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H192v62.1c0 18.7-15.2 33.9-33.9 33.9-9 0-17.6-3.6-24-9.9zM384 416V96c0-17.7 14.3-32 32-32s32 14.3 32 32v320c0 17.7-14.3 32-32 32s-32-14.3-32-32z"
        }
    ]
};

const FasLeftLongToLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasLeftLongToLine",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 96v320c0 17.7 14.3 32 32 32s32-14.3 32-32V96c0-17.7-14.3-32-32-32S0 78.3 0 96zm279.5 313.4c7 6.6 17.2 8.4 26 4.6s14.5-12.5 14.5-22v-72h288c17.7 0 32-14.3 32-32v-64c0-17.7-14.3-32-32-32H320v-72c0-9.6-5.7-18.2-14.5-22s-19-2-26 4.6l-144 136c-4.8 4.5-7.5 10.8-7.5 17.4s2.7 12.9 7.5 17.4l144 136z"
        }
    ]
};

const FasLeftLong = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasLeftLong",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M177.5 414c-8.8 3.8-19 2-26-4.6l-144-136C2.7 268.9 0 262.6 0 256s2.7-12.9 7.5-17.4l144-136c7-6.6 17.2-8.4 26-4.6s14.5 12.5 14.5 22v72h288c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H192v72c0 9.6-5.7 18.2-14.5 22z"
        }
    ]
};

const FasLeftRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasLeftRight",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M504.3 273.6c4.9-4.5 7.7-10.9 7.7-17.6s-2.8-13-7.7-17.6l-112-104c-7-6.5-17.2-8.2-25.9-4.4S352 142.5 352 152v56H160v-56c0-9.5-5.7-18.2-14.4-22s-18.9-2.1-25.9 4.4l-112 104C2.8 243 0 249.3 0 256s2.8 13 7.7 17.6l112 104c7 6.5 17.2 8.2 25.9 4.4s14.4-12.5 14.4-22v-56h192v56c0 9.5 5.7 18.2 14.4 22s18.9 2.1 25.9-4.4l112-104z"
        }
    ]
};

const FasLeftToLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasLeftToLine",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M230.1 406.1 107.3 283.3C100.1 276.1 96 266.2 96 256s4.1-20.1 11.3-27.3l122.8-122.8c6.4-6.4 15-9.9 24-9.9 18.7 0 33.9 15.2 33.9 33.9V192h128c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H288v62.1c0 18.7-15.2 33.9-33.9 33.9-9 0-17.6-3.6-24-9.9zM64 96v320c0 17.7-14.3 32-32 32S0 433.7 0 416V96c0-17.7 14.3-32 32-32s32 14.3 32 32z"
        }
    ]
};

const FasLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasLeft",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M9.4 278.6c-12.5-12.5-12.5-32.8 0-45.3l160-160c9.2-9.2 22.9-11.9 34.9-6.9S224.1 83 224.1 96v96h184c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40h-184v96c0 12.9-7.8 24.6-19.8 29.6s-25.7 2.2-34.9-6.9l-160-160z"
        }
    ]
};

const FasLemon = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasLemon",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 96c0-35.3-28.7-64-64-64-6.6 0-13 1-19 2.9-22.5 7-48.1 14.9-71 9-75.2-19.1-156.4 11-213.7 68.3S-7.2 250.8 11.9 326c5.8 22.9-2 48.4-9 71C1 403 0 409.4 0 416c0 35.3 28.7 64 64 64 6.6 0 13-1 19.1-2.9 22.5-7 48.1-14.9 71-9 75.2 19.1 156.4-11 213.7-68.3s87.5-138.5 68.3-213.7c-5.8-22.9 2-48.4 9-71 1.9-6 2.9-12.4 2.9-19.1zm-235.5 31.4c-54.6 16-101.1 62.5-117.1 117.1-2.5 8.5-11.4 13.3-19.9 10.9S62.2 244 64.6 235.5c19.1-65.1 73.7-119.8 138.9-138.9 8.5-2.5 17.4 2.4 19.9 10.9s-2.4 17.4-10.9 19.9z"
        }
    ]
};

const FasLessThanEqual = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasLessThanEqual",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M395.9 93.7c16.4-6.6 24.4-25.2 17.8-41.6s-25.2-24.4-41.6-17.8l-320 128C40 167.1 32 178.9 32 192s8 24.9 20.1 29.7l320 128c16.4 6.6 35-1.4 41.6-17.8s-1.4-35-17.8-41.6L150.2 192l245.7-98.3zM32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32h384c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"
        }
    ]
};

const FasLessThan = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasLessThan",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M380.6 81.7c7.9 15.8 1.5 35-14.3 42.9L103.6 256l262.7 131.4c15.8 7.9 22.2 27.1 14.3 42.9s-27.1 22.2-42.9 14.3l-320-160C6.8 279.2 0 268.1 0 256s6.8-23.2 17.7-28.6l320-160c15.8-7.9 35-1.5 42.9 14.3z"
        }
    ]
};

const FasLifeRing = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasLifeRing",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M367.2 412.5C335.9 434.9 297.5 448 256 448s-79.9-13.1-111.2-35.5l58-58c15.8 8.6 34 13.5 53.3 13.5s37.4-4.9 53.3-13.5l58 58zm90.7.8c33.8-43.4 54-98 54-157.3s-20.2-113.9-54-157.3c9-12.5 7.9-30.1-3.4-41.3S425.8 45 413.3 54C369.9 20.2 315.3 0 256 0S142.1 20.2 98.7 54c-12.5-9-30.1-7.9-41.3 3.4S45 86.2 54 98.7C20.2 142.1 0 196.7 0 256s20.2 113.9 54 157.3c-9 12.5-7.9 30.1 3.4 41.3S86.2 467 98.7 458c43.4 33.8 98 54 157.3 54s113.9-20.2 157.3-54c12.5 9 30.1 7.9 41.3-3.4s12.4-28.8 3.4-41.3zm-45.5-46.1-58-58c8.6-15.8 13.5-34 13.5-53.3s-4.9-37.4-13.5-53.3l58-58C434.9 176.1 448 214.5 448 256s-13.1 79.9-35.5 111.2zM367.2 99.5l-58 58c-15.8-8.6-34-13.5-53.3-13.5s-37.4 4.9-53.3 13.5l-58-58C176.1 77.1 214.5 64 256 64s79.9 13.1 111.2 35.5zM157.5 309.3l-58 58C77.1 335.9 64 297.5 64 256s13.1-79.9 35.5-111.2l58 58c-8.6 15.8-13.5 34-13.5 53.3s4.9 37.4 13.5 53.3zM208 256a48 48 0 1 1 96 0 48 48 0 1 1-96 0z"
        }
    ]
};

const FasLightCeiling = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasLightCeiling",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 0c17.7 0 32 14.3 32 32v130c115.8 14.4 207.6 106.3 222 222.1 2.2 17.5-12.4 31.9-30 31.9H32c-17.7 0-32.2-14.4-30-31.9C16.4 268.2 108.2 176.4 224 162V32c0-17.7 14.3-32 32-32zm0 512c-35.3 0-64-28.7-64-64h128c0 35.3-28.7 64-64 64z"
        }
    ]
};

const FasLightEmergencyOn = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasLightEmergencyOn",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M69.3 36c-11-7.4-25.9-4.4-33.3 6.7S31.6 68.6 42.7 76l48 32c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3l-48-32zm528 40c11-7.4 14-22.3 6.7-33.3s-22.3-14-33.3-6.7l-48 32c-11 7.4-14 22.3-6.7 33.3s22.3 14 33.3 6.7l48-32zM24 192c-13.3 0-24 10.7-24 24s10.7 24 24 24h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zm528 0c-13.3 0-24 10.7-24 24s10.7 24 24 24h64c13.3 0 24-10.7 24-24s-10.7-24-24-24h-64zM320 32c-88.4 0-160 71.6-160 160v160h320V192c0-88.4-71.6-160-160-160zm-80 160c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-61.9 50.1-112 112-112 8.8 0 16 7.2 16 16s-7.2 16-16 16c-44.2 0-80 35.8-80 80zM96 416v32c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32v-32c0-17.7-14.3-32-32-32H128c-17.7 0-32 14.3-32 32z"
        }
    ]
};

const FasLightEmergency = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasLightEmergency",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 192c0-88.4 71.6-160 160-160s160 71.6 160 160v160H64V192zm160-80c8.8 0 16-7.2 16-16s-7.2-16-16-16c-61.9 0-112 50.1-112 112 0 8.8 7.2 16 16 16s16-7.2 16-16c0-44.2 35.8-80 80-80zM32 384h384c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32v-32c0-17.7 14.3-32 32-32z"
        }
    ]
};

const FasLightSwitchOff = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasLightSwitchOff",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 512c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0h256c35.3 0 64 28.7 64 64v384c0 35.3-28.7 64-64 64H64zm96-96h64c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64h-64c-35.3 0-64 28.7-64 64v192c0 35.3 28.7 64 64 64zm32 32a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm0-416a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm-32 352c-17.7 0-32-14.3-32-32v-96h128v96c0 17.7-14.3 32-32 32h-64z"
        }
    ]
};

const FasLightSwitchOn = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasLightSwitchOn",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm96 96h64c35.3 0 64 28.7 64 64v192c0 35.3-28.7 64-64 64h-64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64zm32-64a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 416a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-32-320c-17.7 0-32 14.3-32 32v96h128v-96c0-17.7-14.3-32-32-32h-64z"
        }
    ]
};

const FasLightSwitch = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasLightSwitch",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm96 96h64c35.3 0 64 28.7 64 64v80H96v-80c0-35.3 28.7-64 64-64zm128 176v80c0 35.3-28.7 64-64 64h-64c-35.3 0-64-28.7-64-64v-80h192zM192 32a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 416a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
        }
    ]
};

const FasLightbulbCflOn = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasLightbulbCflOn",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M351 24.2c4.3 17.1-6.1 34.5-23.3 38.8l-128 32c-17.1 4.3-34.5-6.1-38.8-23.3s6.1-34.5 23.3-38.8l128-32C329.3-3.4 346.7 7 351 24.2zM455.8 127l-256 64c-17.1 4.3-34.5-6.1-38.8-23.3s6.1-34.5 23.3-38.8l256-64c17.1-4.3 34.5 6.1 38.8 23.3s-6.1 34.5-23.3 38.8zm23.2 57.2c4.3 17.1-6.1 34.5-23.3 38.8l-256 64c-17.1 4.3-34.5-6.1-38.8-23.3s6.1-34.5 23.3-38.8l256-64c17.1-4.3 34.5 6.1 38.8 23.3zM256 384v-78l48-12v90h80c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32h-32c0 17.7-14.3 32-32 32s-32-14.3-32-32h-32c-17.7 0-32-14.3-32-32v-32c0-17.7 14.3-32 32-32zm199.8-65-64 16-7.8 2v47h-48v-80h.2c1.6-12.7 10.8-23.7 24-27l16-4 64-16c17.1-4.3 34.5 6.1 38.8 23.3s-6.1 34.5-23.3 38.8zM53.3 4l48 32c11 7.4 14 22.3 6.7 33.3s-22.3 14-33.3 6.7l-48-32c-11-7.4-14-22.3-6.7-33.3S42.3-3.3 53.3 4zm560 40-48 32c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l48-32c11-7.4 25.9-4.4 33.3 6.7s4.4 25.9-6.7 33.3zM24 160h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24zm528 0h64c13.3 0 24 10.7 24 24s-10.7 24-24 24h-64c-13.3 0-24-10.7-24-24s10.7-24 24-24zM101.3 332l-48 32c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l48-32c11-7.4 25.9-4.4 33.3 6.7s4.4 25.9-6.7 33.3zm464-39.9 48 32c11 7.4 14 22.3 6.7 33.3s-22.3 14-33.3 6.7l-48-32c-11-7.4-14-22.3-6.7-33.3s22.3-14 33.3-6.7z"
        }
    ]
};

const FasLightbulbCfl = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasLightbulbCfl",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M167.8 63c17.1-4.3 27.6-21.7 23.3-38.8S169.4-3.3 152.2 1l-128 32C7.1 37.2-3.3 54.6 1 71.8S22.6 99.3 39.8 95l128-32zM319 88.2c-4.3-17.1-21.7-27.6-38.8-23.3l-256 64C7.1 133.2-3.3 150.6 1 167.8s21.7 27.6 38.8 23.3l256-64c17.1-4.3 27.6-21.7 23.3-38.8zM295.8 223c17.1-4.3 27.6-21.7 23.3-38.8s-21.7-27.6-38.8-23.3l-256 64C7.1 229.2-3.3 246.6 1 263.8s21.7 27.6 38.8 23.3l256-64zM64 416v32c0 17.7 14.3 32 32 32h32c0 17.7 14.3 32 32 32s32-14.3 32-32h32c17.7 0 32-14.3 32-32v-32c0-17.7-14.3-32-32-32h-80v-90l-48 12v78c-17.7 0-32 14.3-32 32zm255-135.8c-4.3-17.1-21.7-27.6-38.8-23.3l-64 16-16 4c-13.2 3.3-22.4 14.3-24 27h-.2V384h48v-47l7.8-1.9 64-16c17.1-4.3 27.6-21.7 23.3-38.8z"
        }
    ]
};

const FasLightbulbDollar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasLightbulbDollar",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M272 384c9.6-31.9 29.5-59.1 49.2-86.2 5.2-7.1 10.4-14.2 15.4-21.4 19.8-28.5 31.4-63 31.4-100.3C368 78.8 289.2 0 192 0S16 78.8 16 176c0 37.3 11.6 71.9 31.4 100.3 5 7.2 10.2 14.3 15.4 21.4 19.8 27.1 39.7 54.4 49.2 86.2h160zm-80 128c44.2 0 80-35.8 80-80v-16H112v16c0 44.2 35.8 80 80 80zm20-424v13.9c7.5 1.2 14.6 2.9 21.1 4.7 10.7 2.8 17 13.8 14.2 24.5s-13.8 17-24.5 14.2c-11-2.9-21.6-5-31.2-5.2-7.9-.1-16 1.8-21.5 5-4.8 2.8-6.2 5.6-6.2 9.3 0 1.8.1 3.5 5.3 6.7 6.3 3.8 15.5 6.7 28.3 10.5l.7.2c11.2 3.4 25.6 7.7 37.1 15 12.9 8.1 24.3 21.3 24.6 41.6.3 20.9-10.5 36.1-24.8 45-7.2 4.5-15.2 7.3-23.2 9V296c0 11-9 20-20 20s-20-9-20-20v-14.6c-10.3-2.2-20-5.5-28.2-8.4-2.1-.7-4.1-1.4-6.1-2.1-10.5-3.5-16.1-14.8-12.6-25.3s14.8-16.1 25.3-12.6c2.5.8 4.9 1.7 7.2 2.4 13.6 4.6 24 8.1 35.1 8.5 8.6.3 16.5-1.6 21.4-4.7 4.1-2.5 6-5.5 5.9-10.5 0-2.9-.8-5-5.9-8.2-6.3-4-15.4-6.9-28-10.7l-1.7-.5c-10.9-3.3-24.6-7.4-35.6-14-12.7-7.7-24.6-20.5-24.7-40.7-.1-21.1 11.8-35.7 25.8-43.9 6.9-4.1 14.5-6.8 22.2-8.5V88c0-11 9-20 20-20s20 9 20 20z"
        }
    ]
};

const FasLightbulbExclamationOn = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasLightbulbExclamationOn",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m69.3 4 48 32c11 7.4 14 22.3 6.7 33.3s-22.3 14-33.3 6.7l-48-32c-11-7.4-14-22.3-6.7-33.3S58.3-3.3 69.3 4zm528 40-48 32c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l48-32c11-7.4 25.9-4.4 33.3 6.7s4.4 25.9-6.7 33.3zM24 160h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24zm528 0h64c13.3 0 24 10.7 24 24s-10.7 24-24 24h-64c-13.3 0-24-10.7-24-24s10.7-24 24-24zM117.3 332l-48 32c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l48-32c11-7.4 25.9-4.4 33.3 6.7s4.4 25.9-6.7 33.3zm432-39.9 48 32c11 7.4 14 22.3 6.7 33.3s-22.3 14-33.3 6.7l-48-32c-11-7.4-14-22.3-6.7-33.3s22.3-14 33.3-6.7zm-100.1 5.7c-19.8 27.1-39.7 54.4-49.2 86.2H240c-9.6-31.9-29.5-59.1-49.2-86.2-5.2-7.1-10.4-14.2-15.4-21.4C155.6 247.9 144 213.3 144 176 144 78.8 222.8 0 320 0s176 78.8 176 176c0 37.3-11.6 71.9-31.4 100.3-5 7.2-10.2 14.3-15.4 21.4zM400 432c0 44.2-35.8 80-80 80s-80-35.8-80-80v-16h160v16zM344 88c0-13.3-10.7-24-24-24s-24 10.7-24 24v112c0 13.3 10.7 24 24 24s24-10.7 24-24V88zm-24 232a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FasLightbulbExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasLightbulbExclamation",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M272 384c9.6-31.9 29.5-59.1 49.2-86.2 5.2-7.1 10.4-14.2 15.4-21.4 19.8-28.5 31.4-63 31.4-100.3C368 78.8 289.2 0 192 0S16 78.8 16 176c0 37.3 11.6 71.9 31.4 100.3 5 7.2 10.2 14.3 15.4 21.4 19.8 27.1 39.7 54.4 49.2 86.2h160zm-80 128c44.2 0 80-35.8 80-80v-16H112v16c0 44.2 35.8 80 80 80zm0-448c13.3 0 24 10.7 24 24v112c0 13.3-10.7 24-24 24s-24-10.7-24-24V88c0-13.3 10.7-24 24-24zm-32 224a32 32 0 1 1 64 0 32 32 0 1 1-64 0z"
        }
    ]
};

const FasLightbulbGear = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasLightbulbGear",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M262.1 352.2c-11 7-19.1 18.6-21.4 31.8H112c-9.6-31.9-29.5-59.1-49.2-86.2-5.2-7.1-10.4-14.2-15.4-21.4C27.6 247.9 16 213.3 16 176 16 78.8 94.8 0 192 0c97 0 175.6 78.4 176 175.3-17.8 7.7-28 25.6-28 43.3v.9c-17.6-9.7-41.5-8.2-57.2 8.7-9.2 9.9-17.4 20.9-24.4 33S246 285.9 242 298.8c-6.7 21.6 3.4 42.7 20 53.3zM112 416h133.6c3.5 9.2 7.7 18.3 12.8 27 2.9 5 6 9.9 9.4 14.6-10.7 31.6-40.6 54.4-75.8 54.4-44.2 0-80-35.8-80-80v-16zm0-240c0-44.2 35.8-80 80-80 8.8 0 16-7.2 16-16s-7.2-16-16-16c-61.9 0-112 50.1-112 112 0 8.8 7.2 16 16 16s16-7.2 16-16zm260 42.2c0-7 4.5-13.3 11.3-14.8 10.5-2.4 21.5-3.7 32.7-3.7s22.2 1.3 32.7 3.7c6.8 1.5 11.3 7.8 11.3 14.8v17.7c0 7.8 4.8 14.8 11.6 18.7 6.8 3.9 15.1 4.5 21.8.6l13.8-7.9c6.1-3.5 13.7-2.7 18.5 2.4 7.6 8.1 14.3 17.2 20.1 27.2s10.3 20.4 13.5 31c2.1 6.7-1.1 13.7-7.2 17.2l-14.4 8.3c-6.5 3.7-10 10.9-10 18.4s3.5 14.7 10 18.4l14.4 8.3c6.1 3.5 9.2 10.5 7.2 17.2-3.3 10.6-7.8 21-13.5 31s-12.5 19.1-20.1 27.2c-4.8 5.1-12.5 5.9-18.5 2.4l-13.8-7.9c-6.7-3.9-15.1-3.3-21.8.6-6.8 3.9-11.6 10.9-11.6 18.7v17.7c0 7-4.5 13.3-11.3 14.8-10.5 2.4-21.5 3.7-32.7 3.7s-22.2-1.3-32.7-3.7c-6.8-1.5-11.3-7.8-11.3-14.8v-17.6c0-7.9-4.9-14.9-11.7-18.9-6.8-3.9-15.2-4.5-22-.6l-13.5 7.8c-6.1 3.5-13.7 2.7-18.5-2.4-7.6-8.1-14.3-17.2-20.1-27.2s-10.3-20.4-13.5-31c-2.1-6.7 1.1-13.7 7.2-17.2l14-8.1c6.5-3.8 10.1-11.1 10.1-18.6s-3.5-14.8-10.1-18.6l-14-8.1c-6.1-3.5-9.2-10.5-7.2-17.2 3.3-10.6 7.7-21 13.5-31s12.5-19.1 20.1-27.2c4.8-5.1 12.4-5.9 18.5-2.4l13.6 7.8c6.8 3.9 15.2 3.3 22-.6 6.9-3.9 11.7-11 11.7-18.9v-17.2zm92.1 133.5a48.1 48.1 0 1 0-96.1 0 48.1 48.1 0 1 0 96.1 0z"
        }
    ]
};

const FasLightbulbOn = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasLightbulbOn",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m69.3 4 48 32c11 7.4 14 22.3 6.7 33.3s-22.3 14-33.3 6.7l-48-32c-11-7.4-14-22.3-6.7-33.3S58.3-3.3 69.3 4zm528 40-48 32c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l48-32c11-7.4 25.9-4.4 33.3 6.7s4.4 25.9-6.7 33.3zM24 160h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24zm528 0h64c13.3 0 24 10.7 24 24s-10.7 24-24 24h-64c-13.3 0-24-10.7-24-24s10.7-24 24-24zM117.3 332l-48 32c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l48-32c11-7.4 25.9-4.4 33.3 6.7s4.4 25.9-6.7 33.3zm432-39.9 48 32c11 7.4 14 22.3 6.7 33.3s-22.3 14-33.3 6.7l-48-32c-11-7.4-14-22.3-6.7-33.3s22.3-14 33.3-6.7zm-100.1 5.7c-19.8 27.1-39.7 54.4-49.2 86.2H240c-9.6-31.9-29.5-59.1-49.2-86.2-5.2-7.1-10.4-14.2-15.4-21.4C155.6 247.9 144 213.3 144 176 144 78.8 222.8 0 320 0s176 78.8 176 176c0 37.3-11.6 71.9-31.4 100.3-5 7.2-10.2 14.3-15.4 21.4zM400 432c0 44.2-35.8 80-80 80s-80-35.8-80-80v-16h160v16zM320 96c8.8 0 16-7.2 16-16s-7.2-16-16-16c-61.9 0-112 50.1-112 112 0 8.8 7.2 16 16 16s16-7.2 16-16c0-44.2 35.8-80 80-80z"
        }
    ]
};

const FasLightbulbSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasLightbulbSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-195-152.8c4.4-6.2 8.9-12.4 13.4-18.6 5.2-7.1 10.4-14.2 15.4-21.4 19.8-28.5 31.4-63 31.4-100.3C496 78.8 417.2 0 320 0c-70.3 0-130.9 41.2-159.2 100.8L38.8 5.1zm174.5 136.8C227.7 96.7 270 64 320 64c8.8 0 16 7.2 16 16s-7.2 16-16 16c-40 0-73.1 29.3-79 67.6l-27.7-21.7zm-60.9 87.9c5.4 16.8 13.2 32.4 23 46.6 5 7.2 10.2 14.3 15.4 21.4 19.8 27.1 39.7 54.4 49.2 86.2h108.1L152.4 229.8zM240 416v16c0 44.2 35.8 80 80 80s80-35.8 80-80v-7.1l-11.3-8.9H240z"
        }
    ]
};

const FasLightbulb = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasLightbulb",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M272 384c9.6-31.9 29.5-59.1 49.2-86.2 5.2-7.1 10.4-14.2 15.4-21.4 19.8-28.5 31.4-63 31.4-100.3C368 78.8 289.2 0 192 0S16 78.8 16 176c0 37.3 11.6 71.9 31.4 100.3 5 7.2 10.2 14.3 15.4 21.4 19.8 27.1 39.7 54.4 49.2 86.2h160zm-80 128c44.2 0 80-35.8 80-80v-16H112v16c0 44.2 35.8 80 80 80zm-80-336c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-61.9 50.1-112 112-112 8.8 0 16 7.2 16 16s-7.2 16-16 16c-44.2 0-80 35.8-80 80z"
        }
    ]
};

const FasLighthouse = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasLighthouse",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m33.5 1.9 112 48c12.2 5.2 17.8 19.3 12.6 31.5S138.8 99.2 126.6 94l-112-48C2.4 40.8-3.3 26.7 1.9 14.6S21.3-3.3 33.5 1.9zm112 204.1-112 48c-12.2 5.2-26.3-.4-31.5-12.6s.4-26.3 12.6-31.5l112-48c12.2-5.2 26.3.4 31.5 12.6s-.4 26.3-12.6 31.5zM303.9 4.4c10-5.8 22.3-5.8 32.2 0l96 56c15.3 8.9 20.4 28.5 11.5 43.8C437.7 114.3 427 120 416 120v40c17.7 0 32 14.3 32 32 0 13.3-8.1 24.7-19.7 29.5L473.6 448h6.4c17.7 0 32 14.3 32 32s-14.3 32-32 32H352v-64c0-17.7-14.3-32-32-32s-32 14.3-32 32v64H160c-17.7 0-32-14.3-32-32s14.3-32 32-32h6.4l45.3-226.5c-11.6-4.8-19.7-16.2-19.7-29.5 0-17.7 14.3-32 32-32v-40c-11 0-21.7-5.7-27.6-15.9-8.9-15.3-3.7-34.9 11.5-43.8l96-56zM352 87.7l-32-18.6-32 18.6V160h64V87.7zm286.1-73.1c5.2 12.2-.4 26.3-12.6 31.5l-112 48c-12.2 5.2-26.3-.4-31.5-12.6s.4-26.3 12.6-31.5l112-48c12.2-5.2 26.3.4 31.5 12.6zM482 174.6c5.2-12.2 19.3-17.8 31.5-12.6l112 48c12.2 5.2 17.8 19.3 12.6 31.5s-19.3 17.8-31.5 12.6l-112-48c-12.2-5.2-17.8-19.3-12.6-31.5z"
        }
    ]
};

const FasLightsHoliday = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasLightsHoliday",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M5.4 78.2c9.8-14.7 29.6-18.7 44.3-9l.4.3c.5.3 1.3.8 2.5 1.5 2.4 1.4 6.3 3.6 11.7 6.3 10.7 5.4 27.3 12.8 49.8 20.3C159 112.6 227.6 128 320 128s161-15.4 205.9-30.4c22.5-7.5 39.1-14.9 49.8-20.3 5.4-2.7 9.3-4.9 11.7-6.3 1.2-.7 2.1-1.2 2.5-1.5l.4-.2h.1c14.7-9.7 34.5-5.8 44.3 8.9 9.8 14.7 5.8 34.6-8.9 44.4L608 96c17.8 26.6 17.7 26.6 17.7 26.6h-.1l-.2.1-.4.3c-.3.2-.7.5-1.2.8-1 .6-2.4 1.5-4.2 2.5-3.6 2.1-8.7 4.9-15.3 8.2-13.3 6.6-32.7 15.2-58.2 23.7C495 175.4 419.6 192 320 192s-175-16.6-226.1-33.6c-25.5-8.5-44.9-17.1-58.2-23.7-6.6-3.3-11.7-6.1-15.3-8.2-1.8-1-3.2-1.9-4.2-2.5-.5-.3-.9-.6-1.2-.8l-.4-.3-.1-.1h-.1l17.7-26.6-17.9 26.4C-.5 112.8-4.4 93 5.4 78.2zm517.8 120.5 9.4 25.8c30.8 1.9 59 21.7 70.2 52.5 16.4 45.1-8.8 139.4-31.4 147.6s-102.5-47.8-119-92.9c-11.2-30.8-2.3-64.1 20-85.3l-12.3-33.8c23.2-4 44.2-8.7 63.1-13.8zM320 224c10.9 0 21.6-.2 32-.6v39.2c28.3 12.3 48 40.5 48 73.3 0 48-56 128-80 128s-80-80-80-128c0-32.8 19.7-61 48-73.3v-39.2c10.4.4 21.1.6 32 .6zm-140.1-11.5-12.3 33.8c22.3 21.3 31.2 54.5 20 85.3-16.4 45.1-96.4 101.1-119 92.9S20.8 322.1 37.3 277c11.2-30.8 39.4-50.6 70.2-52.5l9.4-25.8c18.8 5.1 39.9 9.9 63.1 13.8z"
        }
    ]
};

const FasLineColumns = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasLineColumns",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 64c0-17.7-14.3-32-32-32H32C14.3 32 0 46.3 0 64s14.3 32 32 32h160c17.7 0 32-14.3 32-32zm0 128c0-17.7-14.3-32-32-32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h160c17.7 0 32-14.3 32-32zM0 320c0 17.7 14.3 32 32 32h160c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32zm224 128c0-17.7-14.3-32-32-32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h160c17.7 0 32-14.3 32-32zm64-384c0 17.7 14.3 32 32 32h160c17.7 0 32-14.3 32-32s-14.3-32-32-32H320c-17.7 0-32 14.3-32 32zm224 128c0-17.7-14.3-32-32-32H320c-17.7 0-32 14.3-32 32s14.3 32 32 32h160c17.7 0 32-14.3 32-32zM288 320c0 17.7 14.3 32 32 32h160c17.7 0 32-14.3 32-32s-14.3-32-32-32H320c-17.7 0-32 14.3-32 32zm224 128c0-17.7-14.3-32-32-32H320c-17.7 0-32 14.3-32 32s14.3 32 32 32h160c17.7 0 32-14.3 32-32z"
        }
    ]
};

const FasLineHeight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasLineHeight",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M118.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l9.4-9.4v229.4l-9.4-9.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l64 64c12.5 12.5 32.8 12.5 45.3 0l64-64c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-9.4 9.4V141.3l9.4 9.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-64-64zM288 64c-17.7 0-32 14.3-32 32s14.3 32 32 32h256c17.7 0 32-14.3 32-32s-14.3-32-32-32H288zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32h256c17.7 0 32-14.3 32-32s-14.3-32-32-32H288zm-32 192c0 17.7 14.3 32 32 32h256c17.7 0 32-14.3 32-32s-14.3-32-32-32H288c-17.7 0-32 14.3-32 32z"
        }
    ]
};

const FasLinesLeaning = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasLinesLeaning",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M190.4 74.1c5.6-16.8-3.5-34.9-20.2-40.5s-34.9 3.5-40.5 20.2l-128 384c-5.6 16.8 3.5 34.9 20.2 40.5s34.9-3.5 40.5-20.2l128-384zm70.9-41.7c-17.4-2.9-33.9 8.9-36.8 26.3l-64 384c-2.9 17.4 8.9 33.9 26.3 36.8s33.9-8.9 36.8-26.3l64-384c2.9-17.4-8.9-33.9-26.3-36.8zM352 32c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32s32-14.3 32-32V64c0-17.7-14.3-32-32-32z"
        }
    ]
};

const FasLinkHorizontalSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasLinkHorizontalSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-56.7-44.4c39.6-25.8 65.9-70.5 65.9-121.3 0-70.7-51.1-131-120.8-142.6l-1.9-.3c-17.4-2.9-33.9 8.9-36.8 26.3s8.9 33.9 26.3 36.8l1.9.3c38.9 6.5 67.4 40.1 67.4 79.5 0 36.6-24.4 67.6-57.9 77.4l-102.9-80.6c20.5-25.1 32.7-57.1 32.7-91.6C448 128.7 383.3 64 303.4 64H144.6c-9.4 0-18.5.9-27.4 2.6L38.8 5.1zM195.6 128h107.8c44.5 0 80.6 36.1 80.6 80.6 0 19.7-7.1 38-19.1 52.1L195.6 128zm251.2 320-81.2-64h-29c-44.5 0-80.6-36.1-80.6-80.6 0-1.9.1-3.7.2-5.5l-55.5-43.8c-5.6 15.4-8.6 32.1-8.6 49.3C192 383.3 256.7 448 336.6 448h110.2zM30.4 119.9C11.3 144.4 0 175.2 0 208.6c0 70.7 51.1 131 120.8 142.6l1.9.3c17.4 2.9 33.9-8.9 36.8-26.3s-8.9-33.9-26.3-36.8l-1.9-.3C92.5 281.6 64 248 64 208.6c0-18.5 6.2-35.5 16.6-49.1l-50.2-39.6z"
        }
    ]
};

const FasLinkHorizontal = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasLinkHorizontal",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144.6 64C64.7 64 0 128.7 0 208.6c0 70.7 51.1 131 120.8 142.6l1.9.3c17.4 2.9 33.9-8.9 36.8-26.3s-8.9-33.9-26.3-36.8l-1.9-.3C92.5 281.6 64 248 64 208.6c0-44.5 36.1-80.6 80.6-80.6h158.8c44.5 0 80.6 36.1 80.6 80.6 0 39.4-28.5 73-67.4 79.5l-1.9.3c-17.4 2.9-29.2 19.4-26.3 36.8s19.4 29.2 36.8 26.3l1.9-.3c69.7-11.6 120.8-72 120.8-142.6C448 128.7 383.3 64 303.4 64H144.6zm350.8 384c79.9 0 144.6-64.7 144.6-144.6 0-70.7-51.1-131-120.8-142.6l-1.9-.3c-17.4-2.9-33.9 8.9-36.8 26.3s8.9 33.9 26.3 36.8l1.9.3c38.9 6.5 67.4 40.1 67.4 79.5 0 44.5-36.1 80.6-80.6 80.6H336.6c-44.5 0-80.6-36.1-80.6-80.6 0-39.4 28.5-73 67.4-79.5l1.9-.3c17.4-2.9 29.2-19.4 26.3-36.8s-19.4-29.2-36.8-26.3l-1.9.3C243.1 172.4 192 232.7 192 303.4c0 79.9 64.7 144.6 144.6 144.6h158.8z"
        }
    ]
};

const FasLinkSimpleSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasLinkSimpleSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L532.4 392c45.4-28.2 75.6-78.6 75.6-136 0-88.4-71.6-160-160-160h-64c-17.7 0-32 14.3-32 32s14.3 32 32 32h64c53 0 96 43 96 96 0 43.3-28.6 79.8-67.9 91.8L399.7 288H416c17.7 0 32-14.3 32-32s-14.3-32-32-32h-97.9l-81.7-64H256c17.7 0 32-14.3 32-32s-14.3-32-32-32h-64c-11.3 0-22.3 1.2-32.9 3.4L38.8 5.1zM121 191.4l-50.3-39.7C46.6 179.7 32 216.1 32 256c0 88.4 71.6 160 160 160h64c17.7 0 32-14.3 32-32s-14.3-32-32-32h-64c-53 0-96-43-96-96 0-24.9 9.5-47.6 25-64.6z"
        }
    ]
};

const FasLinkSimple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasLinkSimple",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 256C0 167.6 71.6 96 160 96h64c17.7 0 32 14.3 32 32s-14.3 32-32 32h-64c-53 0-96 43-96 96s43 96 96 96h64c17.7 0 32 14.3 32 32s-14.3 32-32 32h-64C71.6 416 0 344.4 0 256zm576 0c0 88.4-71.6 160-160 160h-64c-17.7 0-32-14.3-32-32s14.3-32 32-32h64c53 0 96-43 96-96s-43-96-96-96h-64c-17.7 0-32-14.3-32-32s14.3-32 32-32h64c88.4 0 160 71.6 160 160zm-384-32h192c17.7 0 32 14.3 32 32s-14.3 32-32 32H192c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
        }
    ]
};

const FasLinkSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasLinkSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L489.3 358.2l90.5-90.5c56.5-56.5 56.5-148 0-204.5-50-50-128.8-56.5-186.3-15.4l-1.6 1.1c-14.4 10.3-17.7 30.3-7.4 44.6s30.3 17.7 44.6 7.4l1.6-1.1c32.1-22.9 76-19.3 103.8 8.6 31.5 31.5 31.5 82.5 0 114l-96 96-31.9-25c24.3-53.8 13.5-118.3-29.6-161.4-52.2-52.3-134.5-56.2-191.3-11.7L38.8 5.1zM239 162c30.1-14.9 67.7-9.9 92.8 15.3 20 20 27.5 48.3 21.7 74.5L239 162zm167.6 254.4L220.9 270c-2.1 39.8 12.2 80.1 42.2 110 38.9 38.9 94.4 51 143.6 36.3zm-290-228.5-56.4 56.4c-56.5 56.5-56.5 148 0 204.5 50 50 128.8 56.5 186.3 15.4l1.6-1.1c14.4-10.3 17.7-30.3 7.4-44.6s-30.3-17.7-44.6-7.4l-1.6 1.1c-32.1 22.9-76 19.3-103.8-8.6C74 372 74 321 105.5 289.5l61.8-61.8-50.6-39.9z"
        }
    ]
};

const FasLink = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasLink",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M579.8 267.7c56.5-56.5 56.5-148 0-204.5-50-50-128.8-56.5-186.3-15.4l-1.6 1.1c-14.4 10.3-17.7 30.3-7.4 44.6s30.3 17.7 44.6 7.4l1.6-1.1c32.1-22.9 76-19.3 103.8 8.6 31.5 31.5 31.5 82.5 0 114L422.3 334.8c-31.5 31.5-82.5 31.5-114 0-27.9-27.9-31.5-71.8-8.6-103.8l1.1-1.6c10.3-14.4 6.9-34.4-7.4-44.6s-34.4-6.9-44.6 7.4l-1.1 1.6C206.5 251.2 213 330 263 380c56.5 56.5 148 56.5 204.5 0l112.3-112.3zM60.2 244.3c-56.5 56.5-56.5 148 0 204.5 50 50 128.8 56.5 186.3 15.4l1.6-1.1c14.4-10.3 17.7-30.3 7.4-44.6s-30.3-17.7-44.6-7.4l-1.6 1.1c-32.1 22.9-76 19.3-103.8-8.6C74 372 74 321 105.5 289.5l112.2-112.3c31.5-31.5 82.5-31.5 114 0 27.9 27.9 31.5 71.8 8.6 103.9l-1.1 1.6c-10.3 14.4-6.9 34.4 7.4 44.6s34.4 6.9 44.6-7.4l1.1-1.6C433.5 260.8 427 182 377 132c-56.5-56.5-148-56.5-204.5 0L60.2 244.3z"
        }
    ]
};

const FasLips = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasLips",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 101.3c3-2.4 6.2-4.8 9.7-7.3 17.8-12.7 46.8-30 78.3-30 20.3 0 42.8 9.3 61.4 19.2 20 10.6 41.1 24.7 60.2 39.5s37.1 31.2 50.8 46.5c6.8 7.6 13.1 15.7 17.9 23.7 4.3 7.2 9.7 18.3 9.7 31 0 9.2-2.6 19.1-5.3 27.5-3 9.1-7.4 19.4-12.8 30.3-10.8 21.7-26.8 46.9-47.7 71.1C468.8 400.9 404.7 448 320 448h-64c-84.7 0-148.8-47.1-190.2-95.1-20.9-24.1-36.8-49.4-47.7-71.1-5.4-10.8-9.7-21.1-12.8-30.3C2.6 243.1 0 233.2 0 224c0-12.8 5.5-23.8 9.7-31 4.8-8.1 11.1-16.1 17.9-23.7 13.6-15.3 31.7-31.7 50.8-46.5 19.1-14.9 40.2-29 60.2-39.5C157.2 73.3 179.7 64 200 64c31.5 0 60.6 17.2 78.3 30 3.4 2.5 6.7 4.9 9.7 7.3zM64 224c0 7.9 80 96 224 96s224-88.1 224-96c0-7.7-46.3-31.1-138.8-32-3.4 0-6.9.5-10.1 1.5C350 197.6 313.7 208 288 208s-62-10.4-75.1-14.4c-3.3-1-6.7-1.6-10.1-1.5C110.3 192.9 64 216.3 64 224z"
        }
    ]
};

const FasLiraSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasLiraSign",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M112 160.4c0-35.5 28.8-64.4 64.4-64.4 6.9 0 13.8 1.1 20.4 3.3l81.2 27.1c16.8 5.6 34.9-3.5 40.5-20.2s-3.5-34.9-20.2-40.5L217 38.6c-13.1-4.4-26.8-6.6-40.6-6.6C105.5 32 48 89.5 48 160.4V192H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h16v32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h14c-2.2 10.5-6.1 20.6-11.7 29.9L4.6 431.5c-5.9 9.9-6.1 22.2-.4 32.2S20.5 480 32 480h256c17.7 0 32-14.3 32-32s-14.3-32-32-32H88.5l.7-1.1c11.6-19.3 18.9-40.7 21.6-62.9H224c17.7 0 32-14.3 32-32s-14.3-32-32-32H112v-32h112c17.7 0 32-14.3 32-32s-14.3-32-32-32H112v-31.6z"
        }
    ]
};

const FasListCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasListCheck",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M152.1 38.2c9.9 8.9 10.7 24 1.8 33.9l-72 80c-4.4 4.9-10.6 7.8-17.2 7.9s-12.9-2.4-17.6-7L7 113c-9.3-9.4-9.3-24.6 0-34s24.6-9.4 33.9 0L63 101.1l55.1-61.2c8.9-9.9 24-10.7 33.9-1.8zm0 160c9.9 8.9 10.7 24 1.8 33.9l-72 80c-4.4 4.9-10.6 7.8-17.2 7.9s-12.9-2.4-17.6-7L7 273c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L63 261.2l55.1-61.2c8.9-9.9 24-10.7 33.9-1.8zM224 96c0-17.7 14.3-32 32-32h224c17.7 0 32 14.3 32 32s-14.3 32-32 32H256c-17.7 0-32-14.3-32-32zm0 160c0-17.7 14.3-32 32-32h224c17.7 0 32 14.3 32 32s-14.3 32-32 32H256c-17.7 0-32-14.3-32-32zm-64 160c0-17.7 14.3-32 32-32h288c17.7 0 32 14.3 32 32s-14.3 32-32 32H192c-17.7 0-32-14.3-32-32zM48 368a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
        }
    ]
};

const FasListDropdown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasListDropdown",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm384 160v224H64V192h384zm-11.3-96c7.1 0 10.7 8.6 5.7 13.7l-36.7 36.7c-3.1 3.1-8.2 3.1-11.3 0l-36.7-36.7c-5-5-1.5-13.7 5.7-13.7h73.4zM128 232c-13.3 0-24 10.7-24 24s10.7 24 24 24h256c13.3 0 24-10.7 24-24s-10.7-24-24-24H128zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24h256c13.3 0 24-10.7 24-24s-10.7-24-24-24H128z"
        }
    ]
};

const FasListMusic = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasListMusic",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M498.7 6C507 12 512 21.7 512 32v64c0 13.8-8.8 26-21.9 30.4L416 151.1V432c0 44.2-50.1 80-112 80s-112-35.8-112-80 50.1-80 112-80c17.2 0 33.5 2.8 48 7.7V64c0-13.8 8.8-26 21.9-30.4l96-32c9.7-3.2 20.5-1.6 28.8 4.4zM32 64h224c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 128h224c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 128h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
        }
    ]
};

const FasListOl = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasListOl",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M24 56c0-13.3 10.7-24 24-24h32c13.3 0 24 10.7 24 24v120h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H40c-13.3 0-24-10.7-24-24s10.7-24 24-24h16V80h-8c-13.3 0-24-10.7-24-24zm62.7 285.2c-6.5-7.4-18.3-6.9-24 1.2l-11.2 15.5c-7.7 10.8-22.7 13.3-33.5 5.6S4.7 340.8 12.4 330l11.1-15.6c23.7-33.2 72.3-35.6 99.2-4.9 21.3 24.4 20.8 60.9-1.1 84.7L86.8 432H120c13.3 0 24 10.7 24 24s-10.7 24-24 24H32c-9.5 0-18.2-5.6-22-14.4s-2.1-18.9 4.3-25.9l72-78c5.3-5.8 5.4-14.6.3-20.5zM224 64h256c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 160h256c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 160h256c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
        }
    ]
};

const FasListRadio = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasListRadio",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 160a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm128-96c-17.7 0-32 14.3-32 32s14.3 32 32 32h288c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32h288c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32h288c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zM40 416a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm88 0a64 64 0 1 0-128 0 64 64 0 1 0 128 0zM64 232a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 88a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"
        }
    ]
};

const FasListTimeline = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasListTimeline",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M16 96a48 48 0 1 1 96 0 48 48 0 1 1-96 0zm48 112a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 160a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM191.5 54.4c5.5-4.2 12.3-6.4 19.2-6.4H424c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H210.7c-6.9 0-13.7-2.2-19.2-6.4l-38.4-28.8c-8.5-6.4-8.5-19.2 0-25.6l38.4-28.8zm-38.4 188.8 38.4-28.8c5.5-4.2 12.3-6.4 19.2-6.4H488c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H210.7c-6.9 0-13.7-2.2-19.2-6.4l-38.4-28.8c-8.5-6.4-8.5-19.2 0-25.6zm0 160 38.4-28.8c5.5-4.2 12.3-6.4 19.2-6.4H424c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H210.7c-6.9 0-13.7-2.2-19.2-6.4l-38.4-28.8c-8.5-6.4-8.5-19.2 0-25.6z"
        }
    ]
};

const FasListTree = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasListTree",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M24 48C10.7 48 0 58.7 0 72v48c0 13.3 10.7 24 24 24v240c0 30.9 25.1 56 56 56h48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24h-48c-13.3 0-24 10.7-24 24H80c-4.4 0-8-3.6-8-8V280h56c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24h-48c-13.3 0-24 10.7-24 24H72v-88c13.3 0 24-10.7 24-24V72c0-13.3-10.7-24-24-24H24zm136 48c0 17.7 14.3 32 32 32h288c17.7 0 32-14.3 32-32s-14.3-32-32-32H192c-17.7 0-32 14.3-32 32zm128 160c0 17.7 14.3 32 32 32h160c17.7 0 32-14.3 32-32s-14.3-32-32-32H320c-17.7 0-32 14.3-32 32zm0 160c0 17.7 14.3 32 32 32h160c17.7 0 32-14.3 32-32s-14.3-32-32-32H320c-17.7 0-32 14.3-32 32z"
        }
    ]
};

const FasListUl = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasListUl",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 144a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm128-80c-17.7 0-32 14.3-32 32s14.3 32 32 32h288c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32h288c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32h288c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zM64 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm48-208a48 48 0 1 0-96 0 48 48 0 1 0 96 0z"
        }
    ]
};

const FasList = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasList",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M40 48c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V72c0-13.3-10.7-24-24-24H40zm152 16c-17.7 0-32 14.3-32 32s14.3 32 32 32h288c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32h288c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32h288c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zM16 232v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24H40c-13.3 0-24 10.7-24 24zm24 136c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24H40z"
        }
    ]
};

const FasLitecoinSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasLitecoinSign",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 64c0-17.7-14.3-32-32-32S64 46.3 64 64v149.6l-40.8 11.6c-17 4.9-26.8 22.6-22 39.6s22.6 26.8 39.6 22l23.2-6.7V448c0 17.7 14.3 32 32 32h256c17.7 0 32-14.3 32-32s-14.3-32-32-32H128V261.9l136.8-39.1c17-4.9 26.8-22.6 22-39.6s-22.6-26.8-39.6-22L128 195.3V64z"
        }
    ]
};

const FasLoader = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasLoader",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 17.7 14.3 32 32 32s32-14.3 32-32V32zm0 384c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 17.7 14.3 32 32 32s32-14.3 32-32v-64zM0 256c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32zm416-32c-17.7 0-32 14.3-32 32s14.3 32 32 32h64c17.7 0 32-14.3 32-32s-14.3-32-32-32h-64zM75 75c-12.5 12.5-12.5 32.8 0 45.3l45.3 45.3c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L120.2 75C107.7 62.5 87.5 62.5 75 75zm316.8 271.5c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l45.3 45.2c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-45.3-45.3zM75 437c12.5 12.5 32.8 12.5 45.3 0l45.3-45.3c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L75 391.8c-12.5 12.5-12.5 32.8 0 45.3zm271.5-316.8c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l45.2-45.3c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-45.3 45.3z"
        }
    ]
};

const FasLobster = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasLobster",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 8.2c0-3.7-2.5-6.9-6.1-7.5C70.7.3 67.4 0 64 0 28.7 0 0 28.7 0 64v64c0 35.3 28.7 64 64 64h.7l41.8 27.9c19.7 13.1 42.9 20.1 66.6 20.1H192v16h-48.9c-7.5 0-14.8-1.7-21.5-5.1l-34.4-17.2c-7.9-4-17.5-.7-21.5 7.2s-.7 17.5 7.2 21.5l34.5 17.2c11.1 5.6 23.4 8.4 35.8 8.4H192v16h-69.6c-5.2 0-10.3-.8-15.2-2.5l-38.1-12.7c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2l38.1 12.7c8.2 2.7 16.7 4.1 25.3 4.1H192v16h-16.9c-12.4 0-24.7 2.9-35.8 8.4l-18.5 9.2c-7.9 4-11.1 13.6-7.2 21.5s13.6 11.1 21.5 7.2l18.5-9.2c6.7-3.3 14-5.1 21.5-5.1H192l21.4 64.1c-29.8 1.8-53.4 26.5-53.4 56.8 0 3.9 3.2 7.1 7.1 7.1h177.8c3.9 0 7.1-3.2 7.1-7.1 0-30.2-23.6-55-53.4-56.8l21.4-64h16.9c7.4 0 14.8 1.7 21.5 5.1l18.5 9.2c7.9 4 17.5.7 21.5-7.2s.7-17.5-7.2-21.5l-18.5-9.2c-11.1-5.6-23.4-8.4-35.8-8.4H320v-16h69.6c8.6 0 17.1-1.4 25.3-4.1l38.1-12.7c8.4-2.8 12.9-11.9 10.1-20.2s-11.9-12.9-20.2-10.1l-38.1 12.7c-4.9 1.6-10 2.5-15.2 2.5H320V288h48.9c12.4 0 24.7-2.9 35.8-8.4l34.5-17.2c7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2l-34.5 17.2c-6.7 3.3-14 5.1-21.5 5.1H320v-16h18.9c23.7 0 46.9-7 66.6-20.2l41.8-27.8h.7c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64-3.4 0-6.7.3-9.9.8-3.6.6-6.1 3.8-6.1 7.5V72c0 7.7-9.8 11-14.4 4.8l-20.2-26.9c-3.7-4.9-11.2-3.9-12.3 2.1-.7 3.9-1.1 7.9-1.1 11.9v64c0 14.9 5.1 28.6 13.6 39.4l-18.7 12.5a71.6 71.6 0 0 1-40 12.2h-24.7c-2.7-7.3-6.2-14-10.2-20.2V80.7c0-15.6 11.3-29 26.7-31.6l7.9-1.3c8.7-1.5 14.6-9.7 13.2-18.4s-9.7-14.6-18.4-13.2l-7.9 1.3C294.6 22.7 272 49.4 272 80.7V138c-3.1-2.3-6.2-4.4-9-6.1-4.3-2.6-9.7-2.6-13.9 0-2.8 1.7-5.9 3.8-9 6.1V80.7c0-31.3-22.6-58-53.5-63.1l-7.9-1.3c-8.7-1.5-17 4.4-18.4 13.2s4.4 17 13.2 18.4l7.9 1.3C196.7 51.7 208 65 208 80.7v91.1c-4 6.2-7.5 13-10.2 20.2h-24.7c-14.2 0-28.1-4.2-39.9-12.1l-18.7-12.5c8.5-10.9 13.6-24.6 13.6-39.4V64c0-4.1-.4-8.1-1.1-11.9-1.1-6-8.6-7.1-12.3-2.1L94.4 76.8C89.8 83 80 79.7 80 72V8.2z"
        }
    ]
};

const FasLocationArrow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasLocationArrow",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M429.6 92.1c4.9-11.9 2.1-25.6-7-34.7s-22.8-11.9-34.7-7l-352 144c-14.2 5.8-22.2 20.8-19.3 35.8S32.7 256 48 256h176v176c0 15.3 10.8 28.4 25.8 31.4s30-5.1 35.8-19.3l144-352z"
        }
    ]
};

const FasLocationCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasLocationCheck",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M215.7 499.2C267 435 384 279.4 384 192 384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2 12.3 15.3 35.1 15.3 47.4 0zM305 145 177 273c-9.4 9.4-24.6 9.4-33.9 0L79 209c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L271 111c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
        }
    ]
};

const FasLocationCrosshairsSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasLocationCrosshairsSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-146-114.5c12.1-20.1 20.6-42.6 24.6-66.6H544c17.7 0 32-14.3 32-32s-14.3-32-32-32h-34.7C495.9 143.6 432.4 80.1 352 66.7V32c0-17.7-14.3-32-32-32s-32 14.3-32 32v34.7c-39.9 6.7-75.6 25.7-103.1 52.9L38.8 5.1zm197 154.4c22.5-19.6 52-31.5 84.2-31.5 70.7 0 128 57.3 128 128 0 21.2-5.1 41.1-14.2 58.7l-38.9-30.5c3.3-8.8 5.1-18.3 5.1-28.2 0-44.2-35.8-80-80-80-16.8 0-32.4 5.2-45.3 14l-38.9-30.5zm179.1 263.4-56.8-44.7c-12 3.8-24.8 5.8-38.1 5.8-70.7 0-128-57.3-128-128 0-2.9.1-5.7.3-8.5l-56.8-44.7c-2 6.9-3.6 14-4.8 21.3H96c-17.7 0-32 14.3-32 32s14.3 32 32 32h34.7C144.2 368.5 207.6 432 288 445.4V480c0 17.7 14.3 32 32 32s32-14.3 32-32v-34.7c22.6-3.8 43.8-11.5 62.9-22.4z"
        }
    ]
};

const FasLocationCrosshairs = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasLocationCrosshairs",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 0c17.7 0 32 14.3 32 32v34.7c80.4 13.4 143.9 76.9 157.3 157.3H480c17.7 0 32 14.3 32 32s-14.3 32-32 32h-34.7c-13.4 80.4-76.9 143.9-157.3 157.3V480c0 17.7-14.3 32-32 32s-32-14.3-32-32v-34.7C143.6 431.9 80.1 368.4 66.7 288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h34.7C80.1 143.6 143.6 80.1 224 66.7V32c0-17.7 14.3-32 32-32zM128 256a128 128 0 1 0 256 0 128 128 0 1 0-256 0zm128-80a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"
        }
    ]
};

const FasLocationDotSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasLocationDotSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L459 334.5c30-51.6 53-103.7 53-142.5C512 86 426 0 320 0c-70.8 0-132.7 38.4-166 95.4L38.8 5.1zm219 171.7c6.8-28 32.1-48.8 62.2-48.8 35.3 0 64 28.7 64 64 0 24.7-13.9 46-34.4 56.7l-91.8-72zm85.9 322.4c16.2-20.2 39-49.6 62.5-83.1L128.1 196.9c4.2 88.2 117.8 239.3 168.2 302.2 12.3 15.3 35.1 15.3 47.4 0z"
        }
    ]
};

const FasLocationDot = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasLocationDot",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M215.7 499.2C267 435 384 279.4 384 192 384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2 12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"
        }
    ]
};

const FasLocationExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasLocationExclamation",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M215.7 499.2C267 435 384 279.4 384 192 384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2 12.3 15.3 35.1 15.3 47.4 0zM192 96c13.3 0 24 10.7 24 24v112c0 13.3-10.7 24-24 24s-24-10.7-24-24V120c0-13.3 10.7-24 24-24zm-32 224a32 32 0 1 1 64 0 32 32 0 1 1-64 0z"
        }
    ]
};

const FasLocationMinus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasLocationMinus",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M215.7 499.2C267 435 384 279.4 384 192 384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2 12.3 15.3 35.1 15.3 47.4 0zM120 168h144c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
        }
    ]
};

const FasLocationPen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasLocationPen",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M215.7 499.2C267 435 384 279.4 384 192 384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2 12.3 15.3 35.1 15.3 47.4 0zM276.8 107c14.7 14.7 14.7 38.6 0 53.3l-14.9 14.9-53.3-53.2 14.9-15c14.7-14.7 38.6-14.7 53.3 0zM114.1 216.5l71.9-71.9 53.3 53.3-71.9 71.9c-4.1 4.1-9.2 7-14.9 8.4l-36.6 9.2c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l9.2-36.7c1.4-5.6 4.3-10.8 8.4-14.9z"
        }
    ]
};

const FasLocationPinLock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasLocationPinLock",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M215.7 499.2c11-13.8 25.1-31.7 40.3-52.3V352c0-23.7 12.9-44.4 32-55.4V272c0-55.6 40.5-101.7 93.6-110.5C367 70 287.7 0 192 0 86 0 0 86 0 192c0 87.4 117 243 168.3 307.2 12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm208 112c17.7 0 32 14.3 32 32v48h-64v-48c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32v128c0 17.7 14.3 32 32 32h160c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32v-48c0-44.2-35.8-80-80-80s-80 35.8-80 80z"
        }
    ]
};

const FasLocationPinSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasLocationPinSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L459 334.5c30-51.6 53-103.7 53-142.5C512 86 426 0 320 0c-70.8 0-132.7 38.4-166 95.4L38.8 5.1zm304.9 494.1c16.2-20.2 39-49.6 62.5-83.1L128.1 196.9c4.2 88.2 117.8 239.3 168.2 302.2 12.3 15.3 35.1 15.3 47.4 0z"
        }
    ]
};

const FasLocationPin = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasLocationPin",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 192c0 87.4-117 243-168.3 307.2-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192 0 86 86 0 192 0s192 86 192 192z"
        }
    ]
};

const FasLocationPlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasLocationPlus",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M215.7 499.2C267 435 384 279.4 384 192 384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2 12.3 15.3 35.1 15.3 47.4 0zM168 280v-64h-64c-13.3 0-24-10.7-24-24s10.7-24 24-24h64v-64c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24h-64v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"
        }
    ]
};

const FasLocationQuestion = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasLocationQuestion",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M215.7 499.2C267 435 384 279.4 384 192 384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2 12.3 15.3 35.1 15.3 47.4 0zM105.8 133.3C113.7 111 134.9 96 158.6 96h58.3c34.9 0 63.1 28.3 63.1 63.1 0 22.6-12.1 43.5-31.7 54.8L216 232.4c-.2 13-10.9 23.6-24 23.6-13.3 0-24-10.7-24-24v-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1 0-8.4-6.8-15.1-15.1-15.1h-58.3c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM160 320a32 32 0 1 1 64 0 32 32 0 1 1-64 0z"
        }
    ]
};

const FasLocationSmile = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasLocationSmile",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M215.7 499.2C267 435 384 279.4 384 192 384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2 12.3 15.3 35.1 15.3 47.4 0zM128 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 32a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm-95.4 84.9c6.2 9.4 29.1 31.1 63.4 31.1s57.1-21.7 63.4-31.1c6.1-9.2 18.5-11.7 27.7-5.5s11.7 18.5 5.5 27.7C277.1 284.4 243.1 316 192 316s-85.1-31.6-96.6-48.9c-6.1-9.2-3.6-21.6 5.5-27.7s21.6-3.6 27.7 5.5z"
        }
    ]
};

const FasLocationXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasLocationXmark",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M215.7 499.2C267 435 384 279.4 384 192 384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2 12.3 15.3 35.1 15.3 47.4 0zM111 111c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"
        }
    ]
};

const FasLockA = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasLockA",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 64c44.2 0 80 35.8 80 80v48H144v-48c0-44.2 35.8-80 80-80zM80 144v48H64c-35.3 0-64 28.7-64 64v192c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V256c0-35.3-28.7-64-64-64h-16v-48C368 64.5 303.5 0 224 0S80 64.5 80 144zm49.7 280.8L209.6 265c.8-1.6 1.8-3 3-4.3 1.4-1.5 3.1-2.6 5-3.4 2.1-.9 4.2-1.3 6.4-1.3s4.3.4 6.4 1.3c1.8.8 3.5 1.9 5 3.4 1.3 1.3 2.3 2.7 3.1 4.3l79.9 159.9c4 7.9.7 17.5-7.2 21.5s-17.5.7-21.5-7.2L270.1 400h-92.2l-19.6 39.2c-4 7.9-13.6 11.1-21.5 7.2s-11.1-13.6-7.2-21.5zm64.2-56.8h60.2L224 307.8 193.9 368z"
        }
    ]
};

const FasLockHashtag = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasLockHashtag",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 144v48h160v-48c0-44.2-35.8-80-80-80s-80 35.8-80 80zm-64 48v-48C80 64.5 144.5 0 224 0s144 64.5 144 144v48h16c35.3 0 64 28.7 64 64v192c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256c0-35.3 28.7-64 64-64h16zm96 48c-8.8 0-16 7.2-16 16v32h-32c-8.8 0-16 7.2-16 16s7.2 16 16 16h32v64h-32c-8.8 0-16 7.2-16 16s7.2 16 16 16h32v32c0 8.8 7.2 16 16 16s16-7.2 16-16v-32h64v32c0 8.8 7.2 16 16 16s16-7.2 16-16v-32h32c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32v-64h32c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32v-32c0-8.8-7.2-16-16-16s-16 7.2-16 16v32h-64v-32c0-8.8-7.2-16-16-16zm16 144v-64h64v64h-64z"
        }
    ]
};

const FasLockKeyholeOpen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasLockKeyholeOpen",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M432 64c-44.2 0-80 35.8-80 80v48h32c35.3 0 64 28.7 64 64v192c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256c0-35.3 28.7-64 64-64h224v-48C288 64.5 352.5 0 432 0s144 64.5 144 144v48c0 17.7-14.3 32-32 32s-32-14.3-32-32v-48c0-44.2-35.8-80-80-80zM256 384c17.7 0 32-14.3 32-32s-14.3-32-32-32h-64c-17.7 0-32 14.3-32 32s14.3 32 32 32h64z"
        }
    ]
};

const FasLockKeyhole = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasLockKeyhole",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 64c44.2 0 80 35.8 80 80v48H144v-48c0-44.2 35.8-80 80-80zM80 144v48H64c-35.3 0-64 28.7-64 64v192c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V256c0-35.3-28.7-64-64-64h-16v-48C368 64.5 303.5 0 224 0S80 64.5 80 144zm176 176v64c0 17.7-14.3 32-32 32s-32-14.3-32-32v-64c0-17.7 14.3-32 32-32s32 14.3 32 32z"
        }
    ]
};

const FasLockOpen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasLockOpen",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 144c0-44.2 35.8-80 80-80s80 35.8 80 80v48c0 17.7 14.3 32 32 32s32-14.3 32-32v-48C576 64.5 511.5 0 432 0S288 64.5 288 144v48H64c-35.3 0-64 28.7-64 64v192c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V256c0-35.3-28.7-64-64-64h-32v-48z"
        }
    ]
};

const FasLock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasLock",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 144v48h160v-48c0-44.2-35.8-80-80-80s-80 35.8-80 80zm-64 48v-48C80 64.5 144.5 0 224 0s144 64.5 144 144v48h16c35.3 0 64 28.7 64 64v192c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256c0-35.3 28.7-64 64-64h16z"
        }
    ]
};

const FasLocust = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasLocust",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M312 32c-13.3 0-24 10.7-24 24s10.7 24 24 24h16c98.7 0 180.6 71.4 197 165.4-9-3.5-18.8-5.4-29-5.4h-64.2L390 142.5c-3.4-7.9-10.8-13.4-19.3-14.4s-17 2.7-22.1 9.6l-40.9 55.5-21.7-50.7c-3.3-7.8-10.5-13.2-18.9-14.3s-16.7 2.3-22 8.9l-240 304c-8.2 10.4-6.4 25.5 4 33.7s25.5 6.4 33.7-4l79.4-100.5 43 16.4-40.5 55c-7.9 10.7-5.6 25.7 5.1 33.6s25.7 5.6 33.6-5.1l51.7-70.2h74.5l-29.3 42.3c-7.5 10.9-4.8 25.8 6.1 33.4s25.8 4.8 33.4-6.1L348 400h80.4l38.8 67.9c6.6 11.5 21.2 15.5 32.7 8.9s15.5-21.2 8.9-32.7L483.6 400H496c44.1 0 79.8-35.7 80-79.7V280c0-137-111-248-248-248h-16zm50.5 168 17.1 40H333l29.5-40zm-87.7 38.1-1.4 1.9h-48.3l32.7-41.5 16.9 39.5zm-186 1.9C57.4 240 32 265.4 32 296.8c0 15.5 6.3 30 16.9 40.4l77.8-97.2H88.8zM496 288a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
        }
    ]
};

const FasLollipop = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasLollipop",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M210.8 334.8C265.3 314.2 304 261.6 304 200v-8c0-61.9-50.1-112-112-112S80 130.1 80 192c0 39.8 32.2 72 72 72s72-32.2 72-72v-8c0-13.3-10.7-24-24-24s-24 10.7-24 24v8c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-35.3 28.7-64 64-64s64 28.7 64 64v8c0 53-43 96-96 96h-8c-57.4 0-104-46.6-104-104 0-79.5 64.5-144 144-144s144 64.5 144 144c0 73.2-54.6 133.6-125.2 142.8zM0 192c0 106 86 192 192 192 41.5 0 79.9-13.1 111.2-35.5l154.2 154.1c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L348.5 303.2C370.9 271.9 384 233.5 384 192 384 86 298 0 192 0S0 86 0 192z"
        }
    ]
};

const FasLoveseat = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasLoveseat",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 160c0-70.7 57.3-128 128-128h128c70.7 0 128 57.3 128 128v33.6c-36.5 7.4-64 39.7-64 78.4v48H128v-48c0-38.7-27.5-71-64-78.4V160zm352 112c0-20.9 13.4-38.7 32-45.3 5-1.8 10.4-2.7 16-2.7 26.5 0 48 21.5 48 48v176c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32H96c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V272c0-26.5 21.5-48 48-48 5.6 0 11 1 16 2.7 18.6 6.6 32 24.4 32 45.3v80h320v-80z"
        }
    ]
};

const FasLuchadorMask = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasLuchadorMask",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 0C100.3 0 0 100.3 0 224v96c0 106 86 192 192 192h64c106 0 192-86 192-192v-96C448 100.3 347.7 0 224 0zm-96 384c0 17.7 14.3 32 32 32h128c17.7 0 32-14.3 32-32s-14.3-32-32-32H160c-17.7 0-32 14.3-32 32zm-32 0c0-33.2 25.2-60.5 57.6-63.7-1-3.7-1.6-7.6-1.6-11.6 0-7.3 1.8-14.4 5.3-20.7H144c-44.2 0-80-35.8-80-80 0-26.5 21.5-48 48-48h32c44.2 0 80 35.8 80 80 0-44.2 35.8-80 80-80h32c26.5 0 48 21.5 48 48 0 44.2-35.8 80-80 80h-13.3c3.4 6.3 5.3 13.4 5.3 20.7 0 4-.6 7.9-1.6 11.6 32.3 3.2 57.6 30.5 57.6 63.7 0 35.3-28.7 64-64 64H160c-35.3 0-64-28.7-64-64zm156.7-64h.2c6.1 0 11.1-5 11.1-11.1v-.2c0-3-1.2-5.9-3.3-8l-8-8-4.2-4.2-.4-.4-10.3-10.3c-3.8-3.8-8.7-5.8-13.8-5.8s-10 2-13.7 5.7L200 288l-.4.4-4.2 4.2-8 8c-2.1 2.1-3.3 5-3.3 8v.2c0 6.1 5 11.1 11.1 11.1h57.5zM112 192c-8.8 0-16 7.2-16 16 0 26.5 21.5 48 48 48h32c8.8 0 16-7.2 16-16 0-26.5-21.5-48-48-48h-32zm240 16c0-8.8-7.2-16-16-16h-32c-26.5 0-48 21.5-48 48 0 8.8 7.2 16 16 16h32c26.5 0 48-21.5 48-48z"
        }
    ]
};

const FasLungsVirus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasLungsVirus",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 0c17.7 0 32 14.3 32 32v124.2c-8.5-7.6-19.7-12.2-32-12.2s-23.5 4.6-32 12.2V32c0-17.7 14.3-32 32-32zm124.5 195.5c-16.4-16.4-41.8-18.5-60.5-6.1v-24.1C384 127 415 96 453.3 96c21.7 0 42.8 10.2 55.8 28.8 15.4 22.1 44.3 65.4 71 116.9 26.5 50.9 52.4 112.5 59.6 170.3.2 1.3.2 2.6.2 4v7c0 49.1-39.8 89-89 89-7.3 0-14.5-.9-21.6-2.7l-72.7-18.2c-20.9-5.2-38.7-17.1-51.5-32.9 14 1.5 28.5-3 39.2-13.8l-22.6-22.6 22.6 22.6c18.7-18.7 18.7-49.1 0-67.9-1.1-1.1-1.4-2-1.5-2.5-.1-.8-.1-1.8.4-2.9s1.2-1.9 1.8-2.3c.5-.3 1.3-.8 2.9-.8 26.5 0 48-21.5 48-48s-21.5-48-48-48c-1.6 0-2.4-.4-2.9-.8-.6-.4-1.3-1.2-1.8-2.3s-.5-2.2-.4-2.9c.1-.6.4-1.4 1.5-2.5 18.7-18.7 18.7-49.1 0-67.9zm-22.7 226.3c-6.2 6.2-16.4 6.2-22.6 0C375.9 398.5 336 415 336 448c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-33-39.9-49.5-63.2-26.2-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6C241.5 375.9 225 336 192 336c-8.8 0-16-7.2-16-16s7.2-16 16-16c33 0 49.5-39.9 26.2-63.2-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0C264.1 241.5 304 225 304 192c0-8.8 7.2-16 16-16s16 7.2 16 16c0 33 39.9 49.5 63.2 26.2 6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6C398.5 264.1 415 304 448 304c8.8 0 16 7.2 16 16s-7.2 16-16 16c-33 0-49.5 39.9-26.2 63.2 6.2 6.2 6.2 16.4 0 22.6zm-238.5 69.4-72.7 18.2c-7.1 1.8-14.3 2.7-21.6 2.7-49.1 0-89-39.8-89-89v-7c0-1.3.1-2.7.2-4 7.2-57.9 33.1-119.4 59.6-170.3 26.8-51.5 55.6-94.8 71-116.9 13-18.6 34-28.8 55.8-28.8C225 96 256 127 256 165.3v24.1c-18.6-12.4-44-10.3-60.5 6.1-18.7 18.7-18.7 49.1 0 67.9 1.1 1.1 1.4 2 1.5 2.5.1.8.1 1.8-.4 2.9s-1.2 1.9-1.8 2.3c-.5.3-1.3.8-2.9.8-26.5 0-48 21.5-48 48s21.5 48 48 48c1.6 0 2.4.4 2.9.8.6.4 1.3 1.2 1.8 2.3s.5 2.2.4 2.9c-.1.6-.4 1.4-1.5 2.5-18.7 18.7-18.7 49.1 0 67.9 10.7 10.7 25.3 15.3 39.2 13.8-12.8 15.9-30.6 27.7-51.5 32.9zM296 320a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm72 32a16 16 0 1 0-32 0 16 16 0 1 0 32 0z"
        }
    ]
};

const FasLungs = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasLungs",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 0c17.7 0 32 14.3 32 32v132.1c0 16.4 8.4 31.7 22.2 40.5l9.8 6.2v-45.5C384 127 415 96 453.3 96c21.7 0 42.8 10.2 55.8 28.8 15.4 22.1 44.3 65.4 71 116.9 26.5 50.9 52.4 112.5 59.6 170.3.2 1.3.2 2.6.2 4v7c0 49.1-39.8 89-89 89-7.3 0-14.5-.9-21.6-2.7l-72.7-18.2C414 480.5 384 442.1 384 398v-73l90.5 57.6c7.5 4.7 17.3 2.5 22.1-4.9s2.5-17.3-4.9-22.1L384 287.1v-.4l-44.1-28.1c-7.3-4.6-13.9-10.1-19.9-16.1-5.9 6-12.6 11.5-19.9 16.1L256 286.7 161.2 347l-13.5 8.6h-.1c-7.4 4.8-9.6 14.6-4.8 22.1 4.7 7.5 14.6 9.7 22.1 4.9l91.1-58V398c0 44.1-30 82.5-72.7 93.1l-72.7 18.2c-7.1 1.8-14.3 2.7-21.6 2.7-49.1 0-89-39.8-89-89v-7c0-1.3.1-2.7.2-4 7.2-57.9 33.1-119.4 59.6-170.3 26.8-51.5 55.6-94.8 71-116.9 13-18.6 34-28.8 55.8-28.8 38.4 0 69.4 31 69.4 69.3v45.5l9.8-6.2c13.8-8.8 22.2-24.1 22.2-40.5V32c0-17.7 14.3-32 32-32z"
        }
    ]
};

const FasM = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasM",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M22.7 33.4c13.5-4.1 28.1 1.1 35.9 12.9l165.4 248L389.4 46.2c7.8-11.7 22.4-17 35.9-12.9S448 49.9 448 64v384c0 17.7-14.3 32-32 32s-32-14.3-32-32V169.7L250.6 369.8c-5.9 8.9-15.9 14.2-26.6 14.2s-20.7-5.3-26.6-14.2L64 169.7V448c0 17.7-14.3 32-32 32S0 465.7 0 448V64c0-14.1 9.2-26.5 22.7-30.6z"
        }
    ]
};

const FasMace = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMace",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m244.8 95 28-84.1C275 4.4 281.1 0 288 0s13 4.4 15.2 10.9l28 84.1c40.4 13.5 72.3 45.4 85.8 85.8l84.1 28c6.5 2.2 10.9 8.3 10.9 15.2s-4.4 13-10.9 15.2l-84.1 28c-13.5 40.4-45.4 72.3-85.8 85.8l-28 84.1c-2.2 6.5-8.3 10.9-15.2 10.9s-13-4.4-15.2-10.9l-28-84.1c-9.8-3.3-19-7.6-27.7-12.9L54.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l162.6-162.4c-5.3-8.6-9.6-17.9-12.9-27.7l-84.1-28C68.4 237 64 230.9 64 224s4.4-13 10.9-15.2l84.1-28c13.5-40.4 45.4-72.3 85.8-85.8zM288 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FasMagnet = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMagnet",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 160v96c0 123.7 100.3 224 224 224s224-100.3 224-224v-96H320v96c0 53-43 96-96 96s-96-43-96-96v-96H0zm0-32h128V64c0-17.7-14.3-32-32-32H32C14.3 32 0 46.3 0 64v64zm320 0h128V64c0-17.7-14.3-32-32-32h-64c-17.7 0-32 14.3-32 32v64z"
        }
    ]
};

const FasMagnifyingGlassArrowRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMagnifyingGlassArrowRight",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M416 208c0 45.9-14.9 88.3-40 122.7l126.6 126.7c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0s208 93.1 208 208zm-175-89c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l31 31H120c-13.3 0-24 10.7-24 24s10.7 24 24 24h118.1l-31 31c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9l-72-72z"
        }
    ]
};

const FasMagnifyingGlassChart = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMagnifyingGlassChart",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M416 208c0 45.9-14.9 88.3-40 122.7l126.6 126.7c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0s208 93.1 208 208zm-312 8v64c0 13.3 10.7 24 24 24s24-10.7 24-24v-64c0-13.3-10.7-24-24-24s-24 10.7-24 24zm80-96v160c0 13.3 10.7 24 24 24s24-10.7 24-24V120c0-13.3-10.7-24-24-24s-24 10.7-24 24zm80 64v96c0 13.3 10.7 24 24 24s24-10.7 24-24v-96c0-13.3-10.7-24-24-24s-24 10.7-24 24z"
        }
    ]
};

const FasMagnifyingGlassDollar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMagnifyingGlassDollar",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M416 208c0 45.9-14.9 88.3-40 122.7l126.6 126.7c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0s208 93.1 208 208zM228 104c0-11-9-20-20-20s-20 9-20 20v14c-7.6 1.7-15.2 4.4-22.2 8.5-13.9 8.3-25.9 22.8-25.8 43.9.1 20.3 12 33.1 24.7 40.7 11 6.6 24.7 10.8 35.6 14l1.7.5c12.6 3.8 21.8 6.8 28 10.7 5.1 3.2 5.8 5.4 5.9 8.2.1 5-1.8 8-5.9 10.5-5 3.1-12.9 5-21.4 4.7-11.1-.4-21.5-3.9-35.1-8.5-2.3-.8-4.7-1.6-7.2-2.4-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9.6 4 1.3 6.1 2.1 8.3 2.9 17.9 6.2 28.2 8.4V312c0 11 9 20 20 20s20-9 20-20v-13.8c8-1.7 16-4.5 23.2-9 14.3-8.9 25.1-24.1 24.8-45-.3-20.3-11.7-33.4-24.6-41.6-11.5-7.2-25.9-11.6-37.1-15l-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5-5.2-3.1-5.3-4.9-5.3-6.7 0-3.7 1.4-6.5 6.2-9.3 5.4-3.2 13.6-5.1 21.5-5 9.6.1 20.2 2.2 31.2 5.2 10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7V104z"
        }
    ]
};

const FasMagnifyingGlassLocation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMagnifyingGlassLocation",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M416 208c0 45.9-14.9 88.3-40 122.7l126.6 126.7c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0s208 93.1 208 208zm-128-32c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 48.8 46.5 111.6 68.6 138.6 6 7.3 16.8 7.3 22.7 0 22.1-27 68.6-89.8 68.6-138.6zm-112 0a32 32 0 1 1 64 0 32 32 0 1 1-64 0z"
        }
    ]
};

const FasMagnifyingGlassMinus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMagnifyingGlassMinus",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M416 208c0 45.9-14.9 88.3-40 122.7l126.6 126.7c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0s208 93.1 208 208zm-280-24c-13.3 0-24 10.7-24 24s10.7 24 24 24h144c13.3 0 24-10.7 24-24s-10.7-24-24-24H136z"
        }
    ]
};

const FasMagnifyingGlassPlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMagnifyingGlassPlus",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M416 208c0 45.9-14.9 88.3-40 122.7l126.6 126.7c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0s208 93.1 208 208zm-232 88c0 13.3 10.7 24 24 24s24-10.7 24-24v-64h64c13.3 0 24-10.7 24-24s-10.7-24-24-24h-64v-64c0-13.3-10.7-24-24-24s-24 10.7-24 24v64h-64c-13.3 0-24 10.7-24 24s10.7 24 24 24h64v64z"
        }
    ]
};

const FasMagnifyingGlass = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMagnifyingGlass",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M416 208c0 45.9-14.9 88.3-40 122.7l126.6 126.7c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0s208 93.1 208 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"
        }
    ]
};

const FasMailboxFlagUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMailboxFlagUp",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M400 16c-29.8 0-54.9 20.4-62 48h-92.8c45.2 31.9 74.8 84.5 74.8 144v176c0 24.6-9.2 47-24.4 64H512c35.3 0 64-28.7 64-64V208c0-42.6-18.5-81-48-107.3V80c0-35.3-28.7-64-64-64h-64zm0 208c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-48v80c0 8.8-7.2 16-16 16zM0 208v176c0 35.3 28.7 64 64 64h160c35.3 0 64-28.7 64-64V208c0-79.5-64.5-144-144-144S0 128.5 0 208zm64 0c0-8.8 7.2-16 16-16h128c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16z"
        }
    ]
};

const FasMailbox = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMailbox",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 208v176c0 35.3 28.7 64 64 64h160c35.3 0 64-28.7 64-64V208c0-79.5-64.5-144-144-144S0 128.5 0 208zm64 0c0-8.8 7.2-16 16-16h128c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm256 0v176c0 24.6-9.2 47-24.4 64H512c35.3 0 64-28.7 64-64V208c0-79.5-64.5-144-144-144H245.2c45.2 31.9 74.8 84.5 74.8 144zm64 0c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-48h-48c-8.8 0-16-7.2-16-16z"
        }
    ]
};

const FasManatSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasManatSign",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 32c-17.7 0-32 14.3-32 32v34.7C69.2 113.9 0 192.9 0 288v160c0 17.7 14.3 32 32 32s32-14.3 32-32V288c0-59.6 40.8-109.8 96-124v284c0 17.7 14.3 32 32 32s32-14.3 32-32V164c55.2 14.2 96 64.3 96 124v160c0 17.7 14.3 32 32 32s32-14.3 32-32V288c0-95.1-69.2-174.1-160-189.3V64c0-17.7-14.3-32-32-32z"
        }
    ]
};

const FasMandolin = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMandolin",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M435.3 3.6C444.8-2.3 457.1-.9 465 7l40 40c7.9 7.9 9.3 20.2 3.4 29.7l-40 64c-3.2 5.1-8.2 8.8-14 10.4L388 169.2l-65.9 65.9C323.7 322.4 311.5 512 176 512 78.8 512 0 433.2 0 336c0-135.5 189.6-147.7 276.9-146.2l65.9-65.8 18.1-66.3c1.6-5.8 5.3-10.8 10.4-14l64-40zM208 352a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
        }
    ]
};

const FasMango = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMango",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M344 0h96c39.8 0 72 32.2 72 72 0 13.3-10.7 24-24 24h-40c-33.4 0-62.8-17-80-42.9v49c32.2 8.3 62.6 25 87.8 50.2C493.3 189.7 512 238.9 512 288c0 76.6-57.5 224-224 224-144 0-244.1-43.3-244.1-43.3-33.6-11.1-51.8-47.3-40.6-80.8C7.4 375.4 15 365 24.7 357.5c34.3-25.7 52.1-57.6 71.2-91.8 20.6-36.8 42.6-76.3 88.4-113.5C221.7 114.7 270.9 96 320 96V24c0-13.3 10.7-24 24-24zm88 304c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 53-43 96-96 96-8.8 0-16 7.2-16 16s7.2 16 16 16c70.7 0 128-57.3 128-128z"
        }
    ]
};

const FasManhole = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasManhole",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 256a192 192 0 1 0-384 0 192 192 0 1 0 384 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm281.4-140.6c5.8-7.5 14.5-14.7 23.6-11.8 64.4 20.7 111 81.1 111 152.4s-46.6 131.7-111 152.4c-9 2.9-17.8-4.3-23.6-11.8-5.8-7.6-15.1-12.6-25.4-12.6s-19.6 4.9-25.4 12.6c-5.8 7.5-14.5 14.7-23.6 11.8C142.6 387.7 96 327.3 96 256s46.6-131.7 111-152.4c9-2.9 17.8 4.3 23.6 11.8 5.8 7.6 15.1 12.6 25.4 12.6s19.6-4.9 25.4-12.6zM192 176a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm0 64a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm0 64a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm80-112a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm-32 64a16 16 0 1 0 32 0 16 16 0 1 0-32 0zm32 64a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm48-144a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm0 64a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm0 64a16 16 0 1 0 0 32 16 16 0 1 0 0-32z"
        }
    ]
};

const FasMapLocationDot = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMapLocationDot",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M408 120c0 54.6-73.1 151.9-105.2 192-7.7 9.6-22 9.6-29.6 0C241.1 271.9 168 174.6 168 120 168 53.7 221.7 0 288 0s120 53.7 120 120zm8 80.4c3.5-6.9 6.7-13.8 9.6-20.6.5-1.2 1-2.5 1.5-3.7l116-46.4c15.8-6.3 32.9 5.3 32.9 22.3v270.8c0 9.8-6 18.6-15.1 22.3L416 503V200.4zm-278.4-62.1c2.4 14.1 7.2 28.3 12.8 41.5 2.9 6.8 6.1 13.7 9.6 20.6v251.4L32.9 502.7C17.1 509 0 497.4 0 480.4V209.6c0-9.8 6-18.6 15.1-22.3l122.6-49zM327.8 332c13.9-17.4 35.7-45.7 56.2-77v249.3l-192-54.9V255c20.5 31.3 42.3 59.6 56.2 77 20.5 25.6 59.1 25.6 79.6 0zM288 152a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"
        }
    ]
};

const FasMapLocation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMapLocation",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M302.8 312C334.9 271.9 408 174.6 408 120 408 53.7 354.3 0 288 0S168 53.7 168 120c0 54.6 73.1 151.9 105.2 192 7.7 9.6 22 9.6 29.6 0zM416 503l144.9-58c9.1-3.6 15.1-12.5 15.1-22.3V152c0-17-17.1-28.6-32.9-22.3l-116 46.4c-.5 1.2-1 2.5-1.5 3.7-2.9 6.8-6.1 13.7-9.6 20.6V503zM15.1 187.3C6 191 0 199.8 0 209.6v270.8c0 17 17.1 28.6 32.9 22.3L160 451.8V200.4c-3.5-6.9-6.7-13.8-9.6-20.6-5.6-13.2-10.4-27.4-12.8-41.5L15 187.3zM384 255c-20.5 31.3-42.3 59.6-56.2 77-20.5 25.6-59.1 25.6-79.6 0-13.9-17.4-35.7-45.7-56.2-77v194.4l192 54.9V255z"
        }
    ]
};

const FasMapPin = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMapPin",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M16 144a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm144-64c8.8 0 16-7.2 16-16s-7.2-16-16-16c-53 0-96 43-96 96 0 8.8 7.2 16 16 16s16-7.2 16-16c0-35.3 28.7-64 64-64zm-32 400V317.1a177.984 177.984 0 0 0 64 0V480c0 17.7-14.3 32-32 32s-32-14.3-32-32z"
        }
    ]
};

const FasMap = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMap",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m384 476.1-192-54.9V35.9l192 54.9v385.3zm32-1.2V88.4l127.1-50.9c15.8-6.3 32.9 5.3 32.9 22.3v334.8c0 9.8-6 18.6-15.1 22.3L416 474.8zM15.1 95.1 160 37.2v386.4L32.9 474.5C17.1 480.8 0 469.2 0 452.2V117.4c0-9.8 6-18.6 15.1-22.3z"
        }
    ]
};

const FasMarker = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMarker",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M481 31c-35.9-35.8-94.1-35.8-130 0l-15 15-13.1-13c-28.1-28.1-73.7-28.1-101.8 0L135 119c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l86.1-86c9.4-9.4 24.6-9.4 33.9 0L302.1 80 186.3 195.7l130 130L481 161c35.9-35.9 35.9-94.1 0-129.9zM293.7 348.3l-130-130-64.2 64.2c-48 48-80.8 109.2-94.1 175.8l-5 25c-1.6 7.9.9 16 6.6 21.7s13.8 8.1 21.7 6.6l25-5c66.6-13.3 127.8-46.1 175.8-94.1l64.2-64.2z"
        }
    ]
};

const FasMarsAndVenusBurst = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMarsAndVenusBurst",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M504 0c-9.7 0-18.5 5.8-22.2 14.8S480.1 34.1 487 41l39 39-22.2 22.2C475.9 78.4 439.6 64 400 64c-88.4 0-160 71.6-160 160 0 80.2 59.1 146.7 136.1 158.2 0 .6-.1 1.2-.1 1.8v23.8h-24c-13.3 0-24 10.7-24 24s10.7 24 24 24h24v31.9h24-24c0 13.3 10.7 24 24 24s24-10.7 24-24h-24 24v-3 .3-1.1.1-10.1.1-4.4.4-14h24c13.3 0 24-10.7 24-24s-10.7-24-24-24h-24v-20.2.2-4c0-.6 0-1.2-.1-1.8 77-11.6 136.1-78 136.1-158.2 0-31.4-9-60.7-24.7-85.4l24.7-24.7 39 39c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2V24c0-13.3-10.7-24-24-24H504zM400 128a96 96 0 1 1 0 192 96 96 0 1 1 0-192zM190.9 18.1C188.4 12 182.6 8 176 8s-12.4 4-14.9 10.1l-29.4 74-76.1-23.2c-6.3-1.9-13.1.2-17.2 5.3S33.8 86.4 37 92.1l39.5 69.1-65.6 45.2c-5.4 3.7-8 10.3-6.5 16.7s6.7 11.2 13.1 12.2l78.7 12.2-5.6 79.5c-.5 6.5 3.1 12.7 9 15.5s12.9 1.8 17.8-2.6l58.6-53.8 58.6 53.9c4.1 3.8 9.9 5.1 15.2 3.6C223.6 310.8 208 269.2 208 224c0-60.8 28.3-115 72.4-150.2l-60.1 18.3-29.4-74z"
        }
    ]
};

const FasMarsAndVenus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMarsAndVenus",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M337.8 14.8C341.5 5.8 350.3 0 360 0h112c13.3 0 24 10.7 24 24v112c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-39-39-24.7 24.7C407 163.3 416 192.6 416 224c0 80.2-59.1 146.7-136.1 158.2 0 .6.1 1.2.1 1.8v23.8h24c13.3 0 24 10.7 24 24s-10.7 24-24 24h-24v31.9h-48v-3 .3-1.1.1-10.1.1-4.4.4-14h-24c-13.3 0-24-10.7-24-24s10.7-24 24-24h24v-20.2.2-4c0-.6 0-1.2.1-1.8C155.1 370.7 96 304.2 96 224c0-88.4 71.6-160 160-160 39.6 0 75.9 14.4 103.8 38.2L382.1 80 343 41c-6.9-6.9-8.9-17.2-5.2-26.2zM448 48zM256 488h24c0 13.3-10.7 24-24 24s-24-10.7-24-24h24zm96-264a96 96 0 1 0-192 0 96 96 0 1 0 192 0z"
        }
    ]
};

const FasMarsDouble = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMarsDouble",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M312 32c-9.7 0-18.5 5.8-22.2 14.8S288.1 66.1 295 73l33.4 33.4-52.6 52.6c-28.4-19.5-62.7-31-99.8-31C78.8 128 0 206.8 0 304s78.8 176 176 176 176-78.8 176-176c0-37-11.4-71.4-31-99.8l52.6-52.6L407 185c6.9 6.9 17.2 8.9 26.2 5.2S448 177.7 448 168V56c0-13.3-10.7-24-24-24H312zm88 48zM64 304a112 112 0 1 1 224 0 112 112 0 1 1-224 0zm304 176c97.2 0 176-78.8 176-176 0-37-11.4-71.4-31-99.8l52.6-52.6L599 185c6.9 6.9 17.2 8.9 26.2 5.2S640 177.7 640 168V56c0-13.3-10.7-24-24-24H504c-9.7 0-18.5 5.8-22.2 14.8-1.2 2.9-1.8 6-1.8 9v.4c0 6.2 2.5 12.2 7 16.8l33.4 33.4-40.4 40.3V168c0 22.6-13.6 43.1-34.6 51.7-.8.3-1.7.7-2.5 1 22.8 20.5 37.1 50.2 37.1 83.3 0 61.9-50.1 112-112 112-5.4 0-10.8-.4-16-1.1-12.9 20.4-29.1 38.3-48.1 53.1 19.8 7.8 41.4 12 64 12z"
        }
    ]
};

const FasMarsStrokeRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMarsStrokeRight",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M208 368a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm174.4-88c-11.7 85.8-85.3 152-174.4 152-97.2 0-176-78.8-176-176S110.8 80 208 80c89.1 0 162.7 66.2 174.4 152H416v-56c0-13.3 10.7-24 24-24s24 10.7 24 24v56h32v-56c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2l80 80c9.4 9.4 9.4 24.6 0 33.9l-80 80c-6.9 6.9-17.2 8.9-26.2 5.2S496 345.6 496 335.9V280h-32v56c0 13.3-10.7 24-24 24s-24-10.7-24-24v-56h-33.6z"
        }
    ]
};

const FasMarsStrokeUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMarsStrokeUp",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M148.7 4.7c6.2-6.2 16.4-6.2 22.6 0l64 64c4.6 4.6 5.9 11.5 3.5 17.4S230.5 96 224 96h-40v24h32c13.3 0 24 10.7 24 24s-10.7 24-24 24h-32v24c0 .6 0 1.2-.1 1.8 77 11.6 136.1 78 136.1 158.2 0 88.4-71.6 160-160 160S0 440.4 0 352c0-80.2 59.1-146.7 136.1-158.2 0-.6-.1-1.2-.1-1.8v-24h-32c-13.3 0-24-10.7-24-24s10.7-24 24-24h32V96H96c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4l64-64zM256 352a96 96 0 1 0-192 0 96 96 0 1 0 192 0z"
        }
    ]
};

const FasMarsStroke = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMarsStroke",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M376 0c-9.7 0-18.5 5.8-22.2 14.8S352.1 34.1 359 41l33.4 33.4-22.1 22L345 71c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l25.4 25.4-28.7 28.7c-28.4-19.5-62.7-31-99.8-31-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176c0-37-11.4-71.4-31-99.8l28.6-28.6L407 201c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-25.4-25.4 22.1-22.1L471 153c6.9 6.9 17.2 8.9 26.2 5.2S512 145.7 512 136V24c0-13.3-10.7-24-24-24H376zm88 48zM96 304a112 112 0 1 1 224 0 112 112 0 1 1-224 0z"
        }
    ]
};

const FasMars = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMars",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M289.8 46.8c3.7-9 12.5-14.8 22.2-14.8h112c13.3 0 24 10.7 24 24v112c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-33.4-33.4-52.6 52.6c19.5 28.4 31 62.7 31 99.8 0 97.2-78.8 176-176 176S0 401.2 0 304s78.8-176 176-176c37 0 71.4 11.4 99.8 31l52.6-52.6L295 73c-6.9-6.9-8.9-17.2-5.2-26.2zM400 80zM176 416a112 112 0 1 0 0-224 112 112 0 1 0 0 224z"
        }
    ]
};

const FasMartiniGlassCitrus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMartiniGlassCitrus",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M432 240c53 0 96-43 96-96s-43-96-96-96c-35.5 0-66.6 19.3-83.2 48h-52.6C316 40.1 369.3 0 432 0c79.5 0 144 64.5 144 144s-64.5 144-144 144c-27.7 0-53.5-7.8-75.5-21.3l35.4-35.4c12.2 5.6 25.8 8.7 40.1 8.7zM1.8 142.8c3.7-9 12.5-14.8 22.2-14.8h368c9.7 0 18.5 5.8 22.2 14.8s1.7 19.3-5.2 26.2L232 346v118h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V345.9L7 169c-6.9-6.9-8.9-17.2-5.2-26.2z"
        }
    ]
};

const FasMartiniGlassEmpty = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMartiniGlassEmpty",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 0C19.1 0 7.4 7.8 2.4 19.8S.2 45.5 9.3 54.7L224 269.3V448h-64c-17.7 0-32 14.3-32 32s14.3 32 32 32h192c17.7 0 32-14.3 32-32s-14.3-32-32-32h-64V269.3L502.6 54.6c9.2-9.2 11.9-22.9 6.9-34.9S492.9 0 480 0H32zm224 210.7L109.3 64h293.4L256 210.7z"
        }
    ]
};

const FasMartiniGlass = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMartiniGlass",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 0C19.1 0 7.4 7.8 2.4 19.8S.2 45.5 9.3 54.7L224 269.3V448h-64c-17.7 0-32 14.3-32 32s14.3 32 32 32h192c17.7 0 32-14.3 32-32s-14.3-32-32-32h-64V269.3L502.6 54.6c9.2-9.2 11.9-22.9 6.9-34.9S492.9 0 480 0H32zm141.3 128-64-64h293.4l-64 64H173.3z"
        }
    ]
};

const FasMaskFace = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMaskFace",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 64c-27.2 0-53.8 8-76.4 23.1l-37.1 24.8a96.2 96.2 0 0 1-53.3 16.1H56c-30.9 0-56 25.1-56 56v85c0 55.1 37.5 103.1 90.9 116.4l108 27C233.8 435 275.4 448 320 448s86.2-13 121.1-35.5l108-27C602.5 372.1 640 324.1 640 269v-85c0-30.9-25.1-56-56-56h-97.2c-19 0-37.5-5.6-53.3-16.1l-37.1-24.8C373.8 72 347.2 64 320 64zM132.3 346.3l-29.8-7.4c-32-8-54.5-36.8-54.5-69.9v-85c0-4.4 3.6-8 8-8h40v48c0 45.1 13.4 87.2 36.3 122.3zm405.1-7.4-29.8 7.4c23-35.2 36.3-77.2 36.3-122.3v-48h40c4.4 0 8 3.6 8 8v85c0 33-22.5 61.8-54.5 69.9zM192 208c0-8.8 7.2-16 16-16h224c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16zm16 48h224c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16s7.2-16 16-16zm16 80c0-8.8 7.2-16 16-16h160c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-8.8 0-16-7.2-16-16z"
        }
    ]
};

const FasMaskSnorkel = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMaskSnorkel",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M544 32c-17.7 0-32 14.3-32 32v96h64V64c0-17.7-14.3-32-32-32zm-32 335.4c0 44.5-36.1 80.6-80.6 80.6-39.4 0-73-28.5-79.5-67.4l-.3-1.9c-2.9-17.4-19.4-29.2-36.8-26.3s-29.2 19.4-26.3 36.8l.3 1.9C300.4 460.9 360.7 512 431.4 512c79.9 0 144.6-64.7 144.6-144.6V192h-64v175.4zM64 64C28.7 64 0 92.7 0 128v96c0 35.3 28.7 64 64 64h79.7c28.6 0 53.7-18.9 61.5-46.4l3.4-11.7c4.4-15.5 26.3-15.5 30.8 0l3.4 11.7c7.8 27.5 33 46.4 61.5 46.4H384c35.3 0 64-28.7 64-64v-96c0-35.3-28.7-64-64-64H64z"
        }
    ]
};

const FasMaskVentilator = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMaskVentilator",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M159.1 176c-19.7 43.2-31.1 88.7-31.1 124.8 0 15.9 2.2 31.4 6.3 46l-31.8-7.9c-32-8-54.5-36.8-54.5-69.9v-85c0-4.4 3.6-8 8-8h103.1zm26-48H56c-30.9 0-56 25.1-56 56v85c0 55.1 37.5 103.1 90.9 116.4l71.3 17.8c22.7 30.5 55.4 54.1 93.8 66.6v-76.5c-19.7-16.4-32-40.3-32-66.9 0-49.5 43-134.4 96-134.4 52.5 0 96 84.9 96 134.4 0 26.7-12.4 50.4-32 66.8v76.6c38-12.6 70.6-36 93.5-66.4l71.6-17.9C602.5 372.1 640 324.1 640 269v-85c0-30.9-25.1-56-56-56H454.5C419.7 73.8 372.1 32 320 32c-52.6 0-100.2 41.8-134.9 96zm295.6 48H584c4.4 0 8 3.6 8 8v85c0 33-22.5 61.8-54.5 69.9l-31.8 8c4.2-14.7 6.4-30.1 6.4-46.1 0-36.1-11.6-81.6-31.3-124.8zM288 320v192h64V320c0-17.7-14.3-32-32-32s-32 14.3-32 32z"
        }
    ]
};

const FasMask = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMask",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 64C64 64 0 160 0 272s80 176 176 176h8.4c24.2 0 46.4-13.7 57.2-35.4l23.2-46.3c4.4-8.8 13.3-14.3 23.2-14.3s18.8 5.5 23.2 14.3l23.2 46.3c10.8 21.7 33 35.4 57.2 35.4h8.4c96 0 176-64 176-176S512 64 288 64zM96 256a64 64 0 1 1 128 0 64 64 0 1 1-128 0zm320-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"
        }
    ]
};

const FasMasksTheater = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMasksTheater",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M74.6 373.2c41.7 36.1 108 82.5 166.1 73.7 6.1-.9 12.1-2.5 18-4.5-9.2-12.3-17.3-24.4-24.2-35.4-21.9-35-28.8-75.2-25.9-113.6-20.6 4.1-39.2 13-54.7 25.4-6.5 5.2-16.3 1.3-14.8-7 6.4-33.5 33-60.9 68.2-66.3 2.6-.4 5.3-.7 7.9-.8l19.4-131.3c2-13.8 8-32.7 25-45.9 18.6-14.3 50.9-30.5 103.6-35.3l-2.4-2.1c-20.2-15.6-72.4-41.6-185.1-24.5S20.5 63 5.7 83.9C0 91.9-.8 102 .6 111.8l24.2 164.3c5.5 37.3 21.5 72.6 49.8 97.2zm87.7-219.6c4.4-3.1 10.8-2 11.8 3.3.1.5.2 1.1.3 1.6 3.2 21.8-11.6 42-33.1 45.3S99.8 192 96.6 170.3c-.1-.5-.1-1.1-.2-1.6-.6-5.4 5.2-8.4 10.3-6.7 9 3 18.8 3.9 28.7 2.4s19.1-5.3 26.8-10.8zM261.6 390c29.4 46.9 79.5 110.9 137.6 119.7s124.5-37.5 166.1-73.7c28.3-24.5 44.3-59.8 49.8-97.2l24.2-164.3c1.4-9.8.6-19.9-5.1-27.9-14.8-20.9-57.3-61.2-170-78.3s-164.8 8.9-185 24.5c-7.8 6-11.5 15.4-12.9 25.2l-24.2 164.3c-5.5 37.3-.4 75.8 19.6 107.7zm142.9-154.7c-7.7-5.5-16.8-9.3-26.8-10.8s-19.8-.6-28.7 2.4c-5.1 1.7-10.9-1.3-10.3-6.7.1-.5.1-1.1.2-1.6 3.2-21.8 23.2-36.8 44.7-33.5s36.3 23.5 33.1 45.3c-.1.5-.2 1.1-.3 1.6-1 5.3-7.4 6.4-11.8 3.3zm136.2 15.5c-1 5.3-7.4 6.4-11.8 3.3-7.7-5.5-16.8-9.3-26.8-10.8s-19.8-.6-28.7 2.4c-5.1 1.7-10.9-1.3-10.3-6.7.1-.5.1-1.1.2-1.6 3.2-21.8 23.2-36.8 44.7-33.5s36.3 23.5 33.1 45.3c-.1.5-.2 1.1-.3 1.6zM530 350.2c-19.6 44.7-66.8 72.5-116.8 64.9s-87.1-48.2-93-96.7c-1-8.3 8.9-12.1 15.2-6.7 23.9 20.8 53.6 35.3 87 40.3s66.1.1 94.9-12.8c7.6-3.4 16 3.2 12.6 10.9z"
        }
    ]
};

const FasMattressPillow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMattressPillow",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 64H64C28.7 64 0 92.7 0 128v256c0 35.3 28.7 64 64 64h192V64zm32 384h288c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H288v384zM64 160c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v192c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V160z"
        }
    ]
};

const FasMaximize = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMaximize",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M200 32H56c-13.3 0-24 10.7-24 24v144c0 9.7 5.8 18.5 14.8 22.2s19.3 1.7 26.2-5.2l40-40 79 79-79 79-40-40c-6.9-6.9-17.2-8.9-26.2-5.2S32 302.3 32 312v144c0 13.3 10.7 24 24 24h144c9.7 0 18.5-5.8 22.2-14.8s1.7-19.3-5.2-26.2l-40-40 79-79 79 79-40 40c-6.9 6.9-8.9 17.2-5.2 26.2S302.3 480 312 480h144c13.3 0 24-10.7 24-24V312c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2l-40 40-79-79 79-79 40 40c6.9 6.9 17.2 8.9 26.2 5.2S480 209.7 480 200V56c0-13.3-10.7-24-24-24H312c-9.7 0-18.5 5.8-22.2 14.8S288.1 66.1 295 73l40 40-79 79-79-79 40-40c6.9-6.9 8.9-17.2 5.2-26.2S209.7 32 200 32z"
        }
    ]
};

const FasMeat = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMeat",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M243.6 19.6c40.1-40 128.3-16.8 196.9 51.9s91.9 156.8 51.8 196.9l-40.5 40.5C403.9 357 338.7 384 270.8 384h-58.2c-7.1 0-13.9 2.8-18.9 7.8-10.3 10.3-9.7 26.9-5 40.7 2.1 6.1 3.2 12.7 3.2 19.5 0 33.1-26.9 60-60 60s-60-26.9-60-60c0-6.3-5.7-12-12-12-33.1 0-60-26.9-60-60s26.9-60 60-60c6.8 0 13.4 1.1 19.5 3.2 13.8 4.7 30.4 5.3 40.7-5 5-5 7.8-11.8 7.8-18.9v-58c0-67.9 27-133 75-181l40.7-40.7zm64 184.8c49.6 49.6 113.3 66.4 142.2 37.4s12.2-92.6-37.4-142.2-113.3-66.4-142.2-37.4-12.2 92.6 37.4 142.2zm36.3-36.3c-15.3-15.3-20.4-34.9-11.5-43.8s28.5-3.7 43.8 11.5 20.4 34.9 11.5 43.8-28.5 3.7-43.8-11.5z"
        }
    ]
};

const FasMedal = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMedal",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M4.1 38.2C1.4 34.2 0 29.4 0 24.6 0 11 11 0 24.6 0h109.3c11.2 0 21.7 5.9 27.4 15.5l68.5 114.1c-48.2 6.1-91.3 28.6-123.4 61.9L4.1 38.2zm503.7 0L405.6 191.5c-32.1-33.3-75.2-55.8-123.4-61.9l68.5-114.1C356.5 5.9 366.9 0 378.1 0h109.3C501 0 512 11 512 24.6c0 4.8-1.4 9.6-4.1 13.6zM80 336a176 176 0 1 1 352 0 176 176 0 1 1-352 0zm184.4-94.9c-3.4-7-13.3-7-16.8 0l-22.4 45.4c-1.4 2.8-4 4.7-7 5.1l-50.2 7.3c-7.7 1.1-10.7 10.5-5.2 16l36.3 35.4c2.2 2.2 3.2 5.2 2.7 8.3l-8.6 49.9c-1.3 7.6 6.7 13.5 13.6 9.9l44.8-23.6c2.7-1.4 6-1.4 8.7 0l44.8 23.6c6.9 3.6 14.9-2.2 13.6-9.9l-8.6-49.9c-.5-3 .5-6.1 2.7-8.3l36.3-35.4c5.6-5.4 2.5-14.8-5.2-16l-50.1-7.3c-3-.4-5.7-2.4-7-5.1l-22.4-45.4z"
        }
    ]
};

const FasMegaphone = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMegaphone",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M544 32c17.7 0 32 14.3 32 32v384c0 17.7-14.3 32-32 32s-32-14.3-32-32V64c0-17.7 14.3-32 32-32zM64 190.3 480 64v384l-131.1-39.8C338.2 449.5 300.7 480 256 480c-53 0-96-43-96-96 0-11 1.9-21.7 5.3-31.5L64 321.7c-.9 16.9-14.9 30.3-32 30.3-17.7 0-32-14.3-32-32V192c0-17.7 14.3-32 32-32 17.1 0 31.1 13.4 32 30.3zm239 203.9-91.6-27.8c-2.1 5.4-3.3 11.4-3.3 17.6 0 26.5 21.5 48 48 48 23 0 42.2-16.2 46.9-37.8z"
        }
    ]
};

const FasMelonSlice = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMelonSlice",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M41 391c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9c115.6 115.6 302.6 116 418.3.3S540.5 122.6 425 7c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9c96.9 96.9 97.1 253.6.3 350.4S137.9 487.9 41 391zm279-263c0 106-86 192-192 192-11.4 0-22.5-1-33.3-2.9-5.4-.9-11 .6-14.8 4.5l-20.6 20.6c-6.2 6.2-6.2 16.4 0 22.6l4 4c84.4 84.4 221.1 84.4 305.5 0 84.2-84.2 84.4-220.7.3-305.1l-4.3-4.3c-6.2-6.2-16.4-6.2-22.6 0l-20.6 20.4c-3.9 3.9-5.4 9.4-4.5 14.8 1.9 10.8 2.9 22 2.9 33.3z"
        }
    ]
};

const FasMelon = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMelon",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512c-38.5 0-75-8.5-107.7-23.7 67.1-5.8 149.8-48.2 220.8-119.2s113.4-153.8 119.2-220.8C503.5 181 512 217.5 512 256c0 141.4-114.6 256-256 256zM74.7 436.8c-19.1-19.4-26.8-55.8-11.9-108 14.6-51.2 49.6-110.2 102.7-163.3S277.6 77.4 328.8 62.8c52.4-15 88.9-7.1 108.2 12.2s27.2 55.9 12.2 108.2c-14.6 51.2-49.6 110.2-102.7 163.3s-112.1 88.1-163.3 102.7c-52.1 14.9-88.6 7.2-108-11.9l-.5-.5zm-51-73.1C8.5 331 0 294.5 0 256 0 114.6 114.6 0 256 0c38.5 0 75 8.5 107.7 23.7-67.1 5.8-149.8 48.2-220.8 119.2S29.5 296.7 23.7 363.7z"
        }
    ]
};

const FasMemoCircleCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMemoCircleCheck",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 64C0 28.7 28.7 0 64 0h256c35.3 0 64 28.7 64 64v134.6c-73.9 20.9-128 88.8-128 169.4 0 59.1 29.1 111.3 73.7 143.3-3.2.5-6.4.7-9.7.7H64c-35.3 0-64-28.7-64-64V64zm64 80c0 8.8 7.2 16 16 16h224c8.8 0 16-7.2 16-16s-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm16 80c-8.8 0-16 7.2-16 16s7.2 16 16 16h160c8.8 0 16-7.2 16-16s-7.2-16-16-16H80zm0 96c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H80zm208 48a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm188.7-43.3L416 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0z"
        }
    ]
};

const FasMemoCircleInfo = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMemoCircleInfo",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 64C0 28.7 28.7 0 64 0h256c35.3 0 64 28.7 64 64v134.6c-73.9 20.9-128 88.8-128 169.4 0 59.1 29.1 111.3 73.7 143.3-3.2.5-6.4.7-9.7.7H64c-35.3 0-64-28.7-64-64V64zm64 80c0 8.8 7.2 16 16 16h224c8.8 0 16-7.2 16-16s-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm16 80c-8.8 0-16 7.2-16 16s7.2 16 16 16h160c8.8 0 16-7.2 16-16s-7.2-16-16-16H80zm0 96c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H80zm352-96a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 96a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-32 48c0 8.8 7.2 16 16 16v48c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16v-64c0-8.8-7.2-16-16-16h-16c-8.8 0-16 7.2-16 16z"
        }
    ]
};

const FasMemoPad = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMemoPad",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 64v32h448V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64zm0 64v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V128H0zm96 96c0-8.8 7.2-16 16-16h224c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16zm0 96c0-8.8 7.2-16 16-16h224c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16zm0 96c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16z"
        }
    ]
};

const FasMemo = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMemo",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 64C0 28.7 28.7 0 64 0h256c35.3 0 64 28.7 64 64v384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm64 80c0 8.8 7.2 16 16 16h224c8.8 0 16-7.2 16-16s-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm16 80c-8.8 0-16 7.2-16 16s7.2 16 16 16h224c8.8 0 16-7.2 16-16s-7.2-16-16-16H80zm0 96c-8.8 0-16 7.2-16 16s7.2 16 16 16h128c8.8 0 16-7.2 16-16s-7.2-16-16-16H80z"
        }
    ]
};

const FasMemory = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMemory",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64C28.7 64 0 92.7 0 128v7.4c0 6.8 4.4 12.6 10.1 16.3C23.3 160.3 32 175.1 32 192s-8.7 31.7-21.9 40.3C4.4 236 0 241.8 0 248.6V320h576v-71.4c0-6.8-4.4-12.6-10.1-16.3-13.2-8.6-21.9-23.4-21.9-40.3s8.7-31.7 21.9-40.3c5.7-3.7 10.1-9.5 10.1-16.3V128c0-35.3-28.7-64-64-64H64zm512 288H0v64c0 17.7 14.3 32 32 32h48v-32c0-8.8 7.2-16 16-16s16 7.2 16 16v32h96v-32c0-8.8 7.2-16 16-16s16 7.2 16 16v32h96v-32c0-8.8 7.2-16 16-16s16 7.2 16 16v32h96v-32c0-8.8 7.2-16 16-16s16 7.2 16 16v32h48c17.7 0 32-14.3 32-32v-64zM192 160v64c0 17.7-14.3 32-32 32s-32-14.3-32-32v-64c0-17.7 14.3-32 32-32s32 14.3 32 32zm128 0v64c0 17.7-14.3 32-32 32s-32-14.3-32-32v-64c0-17.7 14.3-32 32-32s32 14.3 32 32zm128 0v64c0 17.7-14.3 32-32 32s-32-14.3-32-32v-64c0-17.7 14.3-32 32-32s32 14.3 32 32z"
        }
    ]
};

const FasMenorah = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMenorah",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M20.8 7.4C22.8 2.9 27.1 0 32 0s9.2 2.9 11.2 7.4l18.1 42.3c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32S0 81.7 0 64v-1.2c0-4.5.9-8.9 2.7-13.1L20.8 7.4zm96 0c2-4.5 6.3-7.4 11.2-7.4s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32s-32-14.3-32-32v-1.2c0-4.5.9-8.9 2.7-13.1l18-42.3zm77.8 42.4 18.2-42.4c2-4.5 6.3-7.4 11.2-7.4s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32s-32-14.3-32-32v-1.2c0-4.5.9-8.9 2.7-13.1zM308.8 7.4c2-4.5 6.3-7.4 11.2-7.4s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32s-32-14.3-32-32v-1.2c0-4.5.9-8.9 2.7-13.1l18-42.3zm77.8 42.4 18.2-42.4c2-4.5 6.3-7.4 11.2-7.4s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32s-32-14.3-32-32v-1.2c0-4.5.9-8.9 2.7-13.1zM500.8 7.4c2-4.5 6.3-7.4 11.2-7.4s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32s-32-14.3-32-32v-1.2c0-4.5.9-8.9 2.7-13.1l18-42.3zm77.8 42.4 18.2-42.4c2-4.5 6.3-7.4 11.2-7.4s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32s-32-14.3-32-32v-1.2c0-4.5.9-8.9 2.7-13.1zM32 128c17.7 0 32 14.3 32 32v128c0 17.7 14.3 32 32 32h192V160c0-17.7 14.3-32 32-32s32 14.3 32 32v160h192c17.7 0 32-14.3 32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32v128c0 53-43 96-96 96H352v64h128c17.7 0 32 14.3 32 32s-14.3 32-32 32H160c-17.7 0-32-14.3-32-32s14.3-32 32-32h128v-64H96c-53 0-96-43-96-96V160c0-17.7 14.3-32 32-32zm96 0c17.7 0 32 14.3 32 32v128H96V160c0-17.7 14.3-32 32-32zm96 0c17.7 0 32 14.3 32 32v128h-64V160c0-17.7 14.3-32 32-32zm192 0c17.7 0 32 14.3 32 32v128h-64V160c0-17.7 14.3-32 32-32zm96 0c17.7 0 32 14.3 32 32v128h-64V160c0-17.7 14.3-32 32-32z"
        }
    ]
};

const FasMercury = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMercury",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M72.1 7C85.8-4 106-1.8 117 12c17.6 22 44.7 36 75 36s57.3-14 75-36c11.1-13.8 31.2-16 45-5s16 31.2 5 45c-7.8 9.7-16.6 18.4-26.4 26.1C337.3 109.7 368 163.3 368 224c0 89.1-66.2 162.7-152 174.4V424h32c13.3 0 24 10.7 24 24s-10.7 24-24 24h-32v16c0 13.3-10.7 24-24 24s-24-10.7-24-24v-16h-32c-13.3 0-24-10.7-24-24s10.7-24 24-24h32v-25.6C82.2 386.7 16 313.1 16 224c0-60.7 30.7-114.3 77.5-145.9-9.8-7.6-18.6-16.4-26.4-26.1-11.1-13.8-8.8-33.9 5-45zM80 224a112 112 0 1 0 224 0 112 112 0 1 0-224 0z"
        }
    ]
};

const FasMerge = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMerge",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 64C14.3 64 0 78.3 0 96s14.3 32 32 32h97.2c9.7 0 18.9 4.4 25 12L247 256l-92.8 116c-6.1 7.6-15.3 12-25 12H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h97.2c29.2 0 56.7-13.3 75-36l99.2-124H384v32c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l64-64c6-6 9.4-14.1 9.4-22.6s-3.4-16.6-9.4-22.6l-64-64c-9.2-9.2-22.9-11.9-34.9-6.9S384 179.2 384 192.2v32h-80.6L204.2 100c-18.2-22.8-45.8-36-75-36H32z"
        }
    ]
};

const FasMessageArrowDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMessageArrowDown",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 64C0 28.7 28.7 0 64 0h384c35.3 0 64 28.7 64 64v288c0 35.3-28.7 64-64 64H309.3l-123.7 92.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3v-80H64c-35.3 0-64-28.7-64-64V64zm280 56c0-13.3-10.7-24-24-24s-24 10.7-24 24v118.1l-31-31c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l72 72c9.4 9.4 24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-31 31V120z"
        }
    ]
};

const FasMessageArrowUpRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMessageArrowUpRight",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 64C0 28.7 28.7 0 64 0h384c35.3 0 64 28.7 64 64v288c0 35.3-28.7 64-64 64H309.3l-123.7 92.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3v-80H64c-35.3 0-64-28.7-64-64V64zm200 64c-13.3 0-24 10.7-24 24s10.7 24 24 24h54.1l-87 87c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l87-87V264c0 13.3 10.7 24 24 24s24-10.7 24-24V152c0-13.3-10.7-24-24-24H200z"
        }
    ]
};

const FasMessageArrowUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMessageArrowUp",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 64C0 28.7 28.7 0 64 0h384c35.3 0 64 28.7 64 64v288c0 35.3-28.7 64-64 64H309.3l-123.7 92.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3v-80H64c-35.3 0-64-28.7-64-64V64zm280 232V177.9l31 31c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-72-72c-9.4-9.4-24.6-9.4-33.9 0l-72 72c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l31-31V296c0 13.3 10.7 24 24 24s24-10.7 24-24z"
        }
    ]
};

const FasMessageBot = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMessageBot",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 0c-35.3 0-64 28.7-64 64v112H59.7c-5.5-9.6-15.9-16-27.7-16-17.7 0-32 14.3-32 32s14.3 32 32 32c11.8 0 22.2-6.4 27.7-16H96v144c0 35.3 28.7 64 64 64h64v80c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L373.3 416H480c35.3 0 64-28.7 64-64V208h36.3c5.5 9.6 15.9 16 27.7 16 17.7 0 32-14.3 32-32s-14.3-32-32-32c-11.8 0-22.2 6.4-27.7 16H544V64c0-35.3-28.7-64-64-64H160zm0 128c0-17.7 14.3-32 32-32h256c17.7 0 32 14.3 32 32v128c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V128zm64 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm192 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FasMessageCaptions = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMessageCaptions",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 64C0 28.7 28.7 0 64 0h384c35.3 0 64 28.7 64 64v288c0 35.3-28.7 64-64 64H309.3l-123.7 92.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3v-80H64c-35.3 0-64-28.7-64-64V64zm120 128c-13.3 0-24 10.7-24 24s10.7 24 24 24h144c13.3 0 24-10.7 24-24s-10.7-24-24-24H120zm224 0c-13.3 0-24 10.7-24 24s10.7 24 24 24h48c13.3 0 24-10.7 24-24s-10.7-24-24-24h-48zm-224 80c-13.3 0-24 10.7-24 24s10.7 24 24 24h48c13.3 0 24-10.7 24-24s-10.7-24-24-24h-48zm128 0c-13.3 0-24 10.7-24 24s10.7 24 24 24h144c13.3 0 24-10.7 24-24s-10.7-24-24-24H248z"
        }
    ]
};

const FasMessageCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMessageCheck",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 64C0 28.7 28.7 0 64 0h384c35.3 0 64 28.7 64 64v288c0 35.3-28.7 64-64 64H309.3l-123.7 92.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3v-80H64c-35.3 0-64-28.7-64-64V64zm369 89c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 153z"
        }
    ]
};

const FasMessageCode = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMessageCode",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 64C0 28.7 28.7 0 64 0h384c35.3 0 64 28.7 64 64v288c0 35.3-28.7 64-64 64H309.3l-123.7 92.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3v-80H64c-35.3 0-64-28.7-64-64V64zm217 97c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-64 64c-9.4 9.4-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47zm112-34c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l64-64c9.4-9.4 9.4-24.6 0-33.9l-64-64z"
        }
    ]
};

const FasMessageDollar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMessageDollar",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 64C0 28.7 28.7 0 64 0h384c35.3 0 64 28.7 64 64v288c0 35.3-28.7 64-64 64H309.3l-123.7 92.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3v-80H64c-35.3 0-64-28.7-64-64V64zm276 40c0-11-9-20-20-20s-20 9-20 20v14c-7.6 1.7-15.2 4.4-22.2 8.5-13.9 8.3-25.9 22.8-25.8 43.9.1 20.3 12 33.1 24.7 40.7 11 6.6 24.7 10.8 35.6 14l1.7.5c12.6 3.8 21.8 6.8 28 10.7 5.1 3.2 5.8 5.4 5.9 8.2.1 5-1.8 8-5.9 10.5-5 3.1-12.9 5-21.4 4.7-11.1-.4-21.5-3.9-35.1-8.5-2.3-.8-4.7-1.6-7.2-2.4-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9.6 4 1.3 6.1 2.1 8.3 2.9 17.9 6.2 28.2 8.4V312c0 11 9 20 20 20s20-9 20-20v-13.8c8-1.7 16-4.5 23.2-9 14.3-8.9 25.1-24.1 24.8-45-.3-20.3-11.7-33.4-24.6-41.6-11.5-7.2-25.9-11.6-37.1-15l-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5-5.2-3.1-5.3-4.9-5.3-6.7 0-3.7 1.4-6.5 6.2-9.3 5.4-3.2 13.6-5.1 21.5-5 9.6.1 20.2 2.2 31.2 5.2 10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7V104z"
        }
    ]
};

const FasMessageDots = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMessageDots",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 64C0 28.7 28.7 0 64 0h384c35.3 0 64 28.7 64 64v288c0 35.3-28.7 64-64 64H309.3l-123.7 92.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3v-80H64c-35.3 0-64-28.7-64-64V64zm128 176a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160-32a32 32 0 1 0-64 0 32 32 0 1 0 64 0z"
        }
    ]
};

const FasMessageExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMessageExclamation",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 64C0 28.7 28.7 0 64 0h384c35.3 0 64 28.7 64 64v288c0 35.3-28.7 64-64 64H309.3l-123.7 92.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3v-80H64c-35.3 0-64-28.7-64-64V64zm256 16c-13.3 0-24 10.7-24 24v112c0 13.3 10.7 24 24 24s24-10.7 24-24V104c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0-64 0 32 32 0 1 0 64 0z"
        }
    ]
};

const FasMessageHeart = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMessageHeart",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 64C0 28.7 28.7 0 64 0h384c35.3 0 64 28.7 64 64v288c0 35.3-28.7 64-64 64H309.3l-123.7 92.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3v-80H64c-35.3 0-64-28.7-64-64V64zm144 109.3c0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3 0-33.8-27.4-61.3-61.3-61.3-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9-33.8 0-61.3 27.4-61.3 61.3z"
        }
    ]
};

const FasMessageImage = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMessageImage",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 64C0 28.7 28.7 0 64 0h384c35.3 0 64 28.7 64 64v288c0 35.3-28.7 64-64 64H309.3l-123.7 92.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3v-80H64c-35.3 0-64-28.7-64-64V64zm176 64a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm120 0c-8 0-15.5 4-20 10.7l-56 84-17.3-21.7c-4.6-5.7-11.4-9-18.7-9s-14.2 3.3-18.7 9l-64 80c-5.8 7.2-6.9 17.1-2.9 25.4S110.8 320 120 320h272c8.9 0 17-4.9 21.2-12.7s3.7-17.3-1.2-24.6l-96-144c-4.5-6.7-12-10.7-20-10.7z"
        }
    ]
};

const FasMessageLines = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMessageLines",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 64C0 28.7 28.7 0 64 0h384c35.3 0 64 28.7 64 64v288c0 35.3-28.7 64-64 64H309.3l-123.7 92.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3v-80H64c-35.3 0-64-28.7-64-64V64zm152 80c-13.3 0-24 10.7-24 24s10.7 24 24 24h208c13.3 0 24-10.7 24-24s-10.7-24-24-24H152zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24h112c13.3 0 24-10.7 24-24s-10.7-24-24-24H152z"
        }
    ]
};

const FasMessageMedical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMessageMedical",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 64C0 28.7 28.7 0 64 0h384c35.3 0 64 28.7 64 64v288c0 35.3-28.7 64-64 64H309.3l-123.7 92.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3v-80H64c-35.3 0-64-28.7-64-64V64zm224 64v48h-48c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-48h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-48v-48c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16z"
        }
    ]
};

const FasMessageMiddleTop = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMessageMiddleTop",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M343.5 96H448c35.3 0 64 28.7 64 64v288c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64h104.5l75.2-90.2c3-3.6 7.5-5.8 12.3-5.8s9.3 2.1 12.3 5.8L343.5 96z"
        }
    ]
};

const FasMessageMiddle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMessageMiddle",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M343.5 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h104.5l75.2 90.2c3 3.6 7.5 5.8 12.3 5.8s9.3-2.1 12.3-5.8l75.2-90.2z"
        }
    ]
};

const FasMessageMinus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMessageMinus",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 64C0 28.7 28.7 0 64 0h384c35.3 0 64 28.7 64 64v288c0 35.3-28.7 64-64 64H309.3l-123.7 92.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3v-80H64c-35.3 0-64-28.7-64-64V64zm184 120c-13.3 0-24 10.7-24 24s10.7 24 24 24h144c13.3 0 24-10.7 24-24s-10.7-24-24-24H184z"
        }
    ]
};

const FasMessageMusic = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMessageMusic",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 64C0 28.7 28.7 0 64 0h384c35.3 0 64 28.7 64 64v288c0 35.3-28.7 64-64 64H309.3l-123.7 92.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3v-80H64c-35.3 0-64-28.7-64-64V64zm352 32c0-5.2-2.6-10.2-6.9-13.2s-9.8-3.7-14.7-1.8l-128 48c-6.2 2.3-10.4 8.3-10.4 15v113.8c-5-1.2-10.4-1.8-16-1.8-26.5 0-48 14.3-48 32s21.5 32 48 32 48-14.3 48-32V187.1l96-36v74.7c-5-1.2-10.4-1.8-16-1.8-26.5 0-48 14.3-48 32s21.5 32 48 32 48-14.3 48-32V96z"
        }
    ]
};

const FasMessagePen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMessagePen",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 64C0 28.7 28.7 0 64 0h384c35.3 0 64 28.7 64 64v288c0 35.3-28.7 64-64 64H309.3l-123.7 92.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3v-80H64c-35.3 0-64-28.7-64-64V64zm340.8 59c-14.7-14.7-38.6-14.7-53.3 0l-14.9 15 53.3 53.3 14.9-14.9c14.7-14.7 14.7-38.6 0-53.3zM178.1 232.5c-4.1 4.1-7 9.2-8.4 14.9l-9.2 36.6c-1.4 5.5.2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l36.6-9.2c5.6-1.4 10.8-4.3 14.9-8.4l71.9-71.9-53.3-53.3-71.9 71.9z"
        }
    ]
};

const FasMessagePlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMessagePlus",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 64C0 28.7 28.7 0 64 0h384c35.3 0 64 28.7 64 64v288c0 35.3-28.7 64-64 64H309.3l-123.7 92.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3v-80H64c-35.3 0-64-28.7-64-64V64zm232 232c0 13.3 10.7 24 24 24s24-10.7 24-24v-64h64c13.3 0 24-10.7 24-24s-10.7-24-24-24h-64v-64c0-13.3-10.7-24-24-24s-24 10.7-24 24v64h-64c-13.3 0-24 10.7-24 24s10.7 24 24 24h64v64z"
        }
    ]
};

const FasMessageQuestion = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMessageQuestion",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 64C0 28.7 28.7 0 64 0h384c35.3 0 64 28.7 64 64v288c0 35.3-28.7 64-64 64H309.3l-123.7 92.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3v-80H64c-35.3 0-64-28.7-64-64V64zm169.8 53.3-.4 1.2c-4.4 12.5 2.1 26.2 14.6 30.6s26.2-2.1 30.6-14.6l.4-1.2c1.1-3.2 4.2-5.3 7.5-5.3h58.3c8.4 0 15.1 6.8 15.1 15.1 0 5.4-2.9 10.4-7.6 13.1L244 181.6c-7.5 4.3-12.1 12.2-12.1 20.8V216c0 13.3 10.7 24 24 24 13.1 0 23.8-10.5 24-23.6l32.3-18.5c19.6-11.3 31.7-32.2 31.7-54.8 0-34.9-28.3-63.1-63.1-63.1h-58.2c-23.7 0-44.8 14.9-52.8 37.3zM288 304a32 32 0 1 0-64 0 32 32 0 1 0 64 0z"
        }
    ]
};

const FasMessageQuote = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMessageQuote",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 64C0 28.7 28.7 0 64 0h384c35.3 0 64 28.7 64 64v288c0 35.3-28.7 64-64 64H309.3l-123.7 92.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3v-80H64c-35.3 0-64-28.7-64-64V64zm160 48c-17.7 0-32 14.3-32 32v48c0 17.7 14.3 32 32 32h32v7.3c0 11.7-8.5 21.7-20.1 23.7l-7.9 1.3c-13.1 2.2-21.9 14.5-19.7 27.6s14.5 21.9 27.6 19.7l7.9-1.3c34.7-5.8 60.2-35.8 60.2-71V144c0-17.7-14.3-32-32-32h-48zm224 80v-48c0-17.7-14.3-32-32-32h-48c-17.7 0-32 14.3-32 32v48c0 17.7 14.3 32 32 32h32v7.3c0 11.7-8.5 21.7-20.1 23.7l-7.9 1.3c-13.1 2.2-21.9 14.5-19.7 27.6s14.5 21.9 27.6 19.7l7.9-1.3c34.7-5.8 60.2-35.8 60.2-71V192z"
        }
    ]
};

const FasMessageSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMessageSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-82.3-64.5C565.1 393 576 373.8 576 352V64c0-35.3-28.7-64-64-64H128c-23.6 0-44.2 12.7-55.3 31.7L38.8 5.1zM64 352c0 35.3 28.7 64 64 64h96v80c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L373.3 416h32.8L64 146.4V352z"
        }
    ]
};

const FasMessageSmile = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMessageSmile",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 64C0 28.7 28.7 0 64 0h384c35.3 0 64 28.7 64 64v288c0 35.3-28.7 64-64 64H309.3l-123.7 92.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3v-80H64c-35.3 0-64-28.7-64-64V64zm192 112a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-169.5 62.1c-9.9 8.8-10.7 24-1.9 33.9 26.3 29.4 64.7 48 107.3 48s81-18.6 107.3-48c8.8-9.9 8-25-1.9-33.9s-25-8-33.9 1.9c-17.6 19.7-43.1 32-71.6 32s-53.9-12.3-71.6-32c-8.8-9.9-24-10.7-33.9-1.9z"
        }
    ]
};

const FasMessageSms = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMessageSms",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 64C0 28.7 28.7 0 64 0h384c35.3 0 64 28.7 64 64v288c0 35.3-28.7 64-64 64H309.3l-123.7 92.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3v-80H64c-35.3 0-64-28.7-64-64V64zm202.9 80.8c-6.5 2.2-10.9 8.3-10.9 15.2v96c0 8.8 7.2 16 16 16s16-7.2 16-16v-48l19.2 25.6c3 4 7.8 6.4 12.8 6.4s9.8-2.4 12.8-6.4L288 208v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-96c0-6.9-4.4-13-10.9-15.2s-13.7.1-17.9 5.6L256 197.3l-35.2-46.9c-4.1-5.5-11.3-7.8-17.9-5.6zm173.1 38c0-1.1.2-1.6.4-1.9.3-.4.9-1.2 2.4-2 3.1-1.8 8-3 12.9-2.9 6.1.1 12.9 1.4 20.1 3.4 8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6c-8.2-2.2-17.9-4.3-27.9-4.4-9.3-.1-20.4 1.9-29.7 7.4-9.9 5.9-18.6 16.4-18.5 31.6.1 14.7 8.8 24 17.7 29.4 7.6 4.6 17.1 7.4 24.3 9.6l1.2.4c8.5 2.6 14.2 4.5 18 6.9 2.7 1.7 2.7 2.4 2.7 3.1v.2c0 1.6-.3 2.3-.6 2.7-.3.5-.9 1.2-2.1 2-2.8 1.7-7.5 2.9-12.8 2.8-7-.2-13.5-2.4-22.6-5.5-1.5-.5-3.2-1.1-4.9-1.6-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2c1.2.4 2.6.9 4 1.4 8.8 3 20.4 7 32.6 7.4 9.8.3 21.2-1.6 30.7-7.6 10.2-6.4 18-17.3 17.8-32.3-.2-14.7-8.5-24.2-17.6-29.9-8-5-17.9-8-25.2-10.2l-.6-.2c-8.6-2.6-14.4-4.4-18.2-6.8-1.6-1-2.1-1.6-2.2-1.7v-.4zm-272 0c0-1.1.2-1.6.4-1.9.3-.4.9-1.2 2.4-2 3.1-1.8 8-3 12.9-2.9 6.6.1 16.7 1.6 23.3 3.4 8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6c-8.8-2.4-21.6-4.3-31.1-4.4-9.3-.1-20.4 1.9-29.7 7.4C80.6 157.3 72 167.8 72 183c.1 14.7 8.8 24 17.7 29.4 7.6 4.6 17.1 7.4 24.3 9.6l1.2.4c8.5 2.6 14.2 4.5 18 6.9 2.7 1.7 2.7 2.4 2.7 3.1v.2c0 1.6-.3 2.3-.6 2.7-.3.5-.9 1.2-2.1 2-2.8 1.7-7.5 2.9-12.8 2.8-7.2-.2-14.2-2.6-23.7-5.8-1.3-.4-2.7-.9-4.1-1.4-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2c1.1.4 2.4.8 3.6 1.2 9 3.1 20.9 7.2 33.2 7.6 9.8.3 21.2-1.6 30.7-7.6 10.2-6.4 18-17.3 17.8-32.3-.2-14.7-8.5-24.2-17.6-29.9-8-5-17.9-8-25.2-10.2l-.6-.2c-8.6-2.6-14.4-4.4-18.3-6.8-1.6-1-2.1-1.6-2.2-1.7v-.4z"
        }
    ]
};

const FasMessageText = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMessageText",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 64C0 28.7 28.7 0 64 0h384c35.3 0 64 28.7 64 64v288c0 35.3-28.7 64-64 64H309.3l-123.7 92.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3v-80H64c-35.3 0-64-28.7-64-64V64zm168 48c-13.3 0-24 10.7-24 24s10.7 24 24 24h64v136c0 13.3 10.7 24 24 24s24-10.7 24-24V160h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H168z"
        }
    ]
};

const FasMessageXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMessageXmark",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 64C0 28.7 28.7 0 64 0h384c35.3 0 64 28.7 64 64v288c0 35.3-28.7 64-64 64H309.3l-123.7 92.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3v-80H64c-35.3 0-64-28.7-64-64V64zm175 63c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z"
        }
    ]
};

const FasMessage = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMessage",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 0C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v80c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64z"
        }
    ]
};

const FasMessagesDollar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMessagesDollar",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 64C0 28.7 28.7 0 64 0h288c35.3 0 64 28.7 64 64v192c0 35.3-28.7 64-64 64H202.7l-81.1 60.8c-4.8 3.6-11.3 4.2-16.8 1.5S96 374.1 96 368v-48H64c-35.3 0-64-28.7-64-64V64zm256 288h96c53 0 96-43 96-96V128h128c35.3 0 64 28.7 64 64v192c0 35.3-28.7 64-64 64h-32v48c0 6.1-3.4 11.6-8.8 14.3s-11.9 2.1-16.8-1.5L437.3 448H320c-35.3 0-64-28.7-64-64v-32zM228 56c0-11-9-20-20-20s-20 9-20 20v14c-7.6 1.7-15.2 4.4-22.2 8.5-13.9 8.3-25.9 22.8-25.8 43.9.1 20.3 12 33.1 24.7 40.7 11 6.6 24.7 10.8 35.6 14l1.7.5c12.6 3.8 21.8 6.8 28 10.7 5.1 3.2 5.8 5.4 5.9 8.2.1 5-1.8 8-5.9 10.5-5 3.1-12.9 5-21.4 4.7-11.1-.4-21.5-3.9-35.1-8.5-2.3-.8-4.7-1.6-7.2-2.4-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9.6 4 1.3 6.1 2.1 8.3 2.9 17.9 6.2 28.2 8.4V264c0 11 9 20 20 20s20-9 20-20v-13.8c8-1.7 16-4.5 23.2-9 14.3-8.9 25.1-24.1 24.8-45-.3-20.3-11.7-33.4-24.6-41.6-11.5-7.2-25.9-11.6-37.1-15l-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5-5.2-3.1-5.3-4.9-5.3-6.7 0-3.7 1.4-6.5 6.2-9.3 5.4-3.2 13.6-5.1 21.5-5 9.6.1 20.2 2.2 31.2 5.2 10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7V56z"
        }
    ]
};

const FasMessagesQuestion = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMessagesQuestion",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 64C0 28.7 28.7 0 64 0h288c35.3 0 64 28.7 64 64v192c0 35.3-28.7 64-64 64H202.7l-81.1 60.8c-4.8 3.6-11.3 4.2-16.8 1.5S96 374.1 96 368v-48H64c-35.3 0-64-28.7-64-64V64zm256 288h96c53 0 96-43 96-96V128h128c35.3 0 64 28.7 64 64v192c0 35.3-28.7 64-64 64h-32v48c0 6.1-3.4 11.6-8.8 14.3s-11.9 2.1-16.8-1.5L437.3 448H320c-35.3 0-64-28.7-64-64v-32zM136.2 92.4l-.4 1c-3.7 10.4 1.8 21.8 12.2 25.5s21.8-1.8 25.5-12.2l.4-1c.9-2.7 3.5-4.4 6.3-4.4h48.5c7 0 12.6 5.7 12.6 12.6 0 4.5-2.4 8.7-6.3 10.9l-37 21.3c-6.2 3.6-10 10.2-10 17.3v11.2c0 11 9 20 20 20 10.9 0 19.8-8.8 20-19.6l26.9-15.4c16.3-9.4 26.4-26.8 26.4-45.6 0-29.1-23.6-52.6-52.6-52.6h-48.5c-19.8 0-37.4 12.4-44 31.1zM234.7 248a26.7 26.7 0 1 0-53.3 0 26.7 26.7 0 1 0 53.3 0z"
        }
    ]
};

const FasMessages = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMessages",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 0C28.7 0 0 28.7 0 64v192c0 35.3 28.7 64 64 64h32v48c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5l81.1-60.8H352c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm288 352h-96v32c0 35.3 28.7 64 64 64h117.3l81.1 60.8c4.8 3.6 11.3 4.2 16.8 1.5s8.8-8.2 8.8-14.3v-48h32c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64H448v128c0 53-43 96-96 96z"
        }
    ]
};

const FasMeteor = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMeteor",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M493.7.9 299.4 75.6l2.3-29.3c1-12.8-12.8-21.5-24-15.1L101.3 133.4C38.6 169.7 0 236.6 0 309c0 112.1 90.9 203 203 203 72.4 0 139.4-38.6 175.7-101.3l102.1-176.4c6.5-11.1-2.2-25-15.1-24l-29.3 2.3 74.7-194.3c.6-1.5.9-3.2.9-4.8C512 6 506 0 498.5 0c-1.7 0-3.3.3-4.8.9zM192 192a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 96a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm16 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
        }
    ]
};

const FasMeterBolt = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMeterBolt",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512c73.7 0 140.1-31.1 186.8-81l7.5-15H432c-20.4 0-38.5-12.9-45.3-32.1s-.6-40.6 15.3-53.4l109.6-87.7C504.8 107.5 393 0 256 0 114.6 0 0 114.6 0 256s114.6 256 256 256zm-64-352v32c0 17.7-14.3 32-32 32s-32-14.3-32-32v-32c0-17.7 14.3-32 32-32s32 14.3 32 32zm96 0v32c0 17.7-14.3 32-32 32s-32-14.3-32-32v-32c0-17.7 14.3-32 32-32s32 14.3 32 32zm96 0v32c0 17.7-14.3 32-32 32s-32-14.3-32-32v-32c0-17.7 14.3-32 32-32s32 14.3 32 32zm218.1 67.6c-5.8-4.7-14.2-4.7-20.1-.1l-160 128c-5.3 4.2-7.4 11.4-5.1 17.8S425.2 384 432 384h70.1l-52.4 104.8c-3.4 6.7-1.6 14.9 4.3 19.6s14.2 4.7 20.1.1l160-128c5.3-4.2 7.4-11.4 5.1-17.8s-8.3-10.7-15.1-10.7h-70.2l52.4-104.8c3.4-6.7 1.6-14.9-4.2-19.6z"
        }
    ]
};

const FasMeterDroplet = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMeterDroplet",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512c53.7 0 103.5-16.5 144.6-44.7-10.6-20.1-16.6-43-16.6-67.3 0-23.6 5.8-46.9 16.9-67.8L476.2 191c4.9-9.2 12.1-16.7 20.6-22.1C461.2 70.4 366.8 0 256 0 114.6 0 0 114.6 0 256s114.6 256 256 256zm-64-352v32c0 17.7-14.3 32-32 32s-32-14.3-32-32v-32c0-17.7 14.3-32 32-32s32 14.3 32 32zm96 0v32c0 17.7-14.3 32-32 32s-32-14.3-32-32v-32c0-17.7 14.3-32 32-32s32 14.3 32 32zm96 0v32c0 17.7-14.3 32-32 32s-32-14.3-32-32v-32c0-17.7 14.3-32 32-32s32 14.3 32 32zm120.5 46.1-75.3 141.2c-8.7 16.2-13.2 34.3-13.2 52.7 0 61.9 50.1 112 112 112s112-50.1 112-112c0-18.4-4.5-36.5-13.2-52.7l-75.3-141.2c-4.6-8.7-13.7-14.1-23.5-14.1s-18.9 5.4-23.5 14.1z"
        }
    ]
};

const FasMeterFire = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMeterFire",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512c33.6 0 65.7-6.5 95.1-18.3-39-35.9-63.1-87.5-63.1-143.7 0-35.2 16.3-73.6 37.2-107.4 4.4-7.1 9.1-14.2 14.1-21.3-11.4-4.8-19.3-16.1-19.3-29.3v-32c0-17.7 14.3-32 32-32s32 14.3 32 32v7.4c9-9.4 18.5-18.6 28.5-27.5 17.7-15.9 44.8-15.9 62.5.1 5.6 5.1 11.1 10.2 16.6 15.5C452.5 64.1 361.7 0 256 0 114.6 0 0 114.6 0 256s114.6 256 256 256zm-64-352v32c0 17.7-14.3 32-32 32s-32-14.3-32-32v-32c0-17.7 14.3-32 32-32s32 14.3 32 32zm96 0v32c0 17.7-14.3 32-32 32s-32-14.3-32-32v-32c0-17.7 14.3-32 32-32s32 14.3 32 32zm165.5 3.6c-2.8-2.5-6.3-3.7-9.8-3.8-3.6 0-7.2 1.2-10 3.7-33.2 29.7-61.4 63.4-81.4 95.8-19.6 32-32.3 66.3-32.3 92.7 0 87.8 70.3 159.8 160 159.8 88.7 0 160-72 160-159.8 0-20.2-9.6-50.9-24.2-79-14.8-28.5-35.7-58.5-60.4-81.1-5.6-5.1-14.4-5.2-20 0-9.6 8.8-18.6 19.6-26.5 29.5-17.3-20.7-35.8-39.9-55.5-57.7zM530 432.9c-15 10-31 15-49 15-45 0-81-29-81-78 0-24 15-45 45-82 4 5 62 79 62 79l36-42c3 4 5 8 7 12 18 33 10 75-20 96z"
        }
    ]
};

const FasMeter = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMeter",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-64-352v32c0 17.7-14.3 32-32 32s-32-14.3-32-32v-32c0-17.7 14.3-32 32-32s32 14.3 32 32zm96 0v32c0 17.7-14.3 32-32 32s-32-14.3-32-32v-32c0-17.7 14.3-32 32-32s32 14.3 32 32zm96 0v32c0 17.7-14.3 32-32 32s-32-14.3-32-32v-32c0-17.7 14.3-32 32-32s32 14.3 32 32z"
        }
    ]
};

const FasMicrochipAi = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMicrochipAi",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v40c-35.3 0-64 28.7-64 64H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h40v56H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h40v56H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h40c0 35.3 28.7 64 64 64v40c0 13.3 10.7 24 24 24s24-10.7 24-24v-40h56v40c0 13.3 10.7 24 24 24s24-10.7 24-24v-40h56v40c0 13.3 10.7 24 24 24s24-10.7 24-24v-40c35.3 0 64-28.7 64-64h40c13.3 0 24-10.7 24-24s-10.7-24-24-24h-40v-56h40c13.3 0 24-10.7 24-24s-10.7-24-24-24h-40v-56h40c13.3 0 24-10.7 24-24s-10.7-24-24-24h-40c0-35.3-28.7-64-64-64V24c0-13.3-10.7-24-24-24s-24 10.7-24 24v40h-56V24c0-13.3-10.7-24-24-24s-24 10.7-24 24v40h-56V24zm32 152c6.4 0 12.1 3.8 14.7 9.6l42 96 14 32c3.5 8.1-.1 17.5-8.2 21.1s-17.5-.2-21.1-8.2l-9.9-22.5h-63l-9.8 22.4c-3.5 8.1-13 11.8-21.1 8.2s-11.8-13-8.2-21.1l14-32 42-96c2.5-5.8 8.3-9.6 14.7-9.6zm17.5 96L208 231.9 190.5 272h35.1zM336 176c8.8 0 16 7.2 16 16v128c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8 7.2-16 16-16z"
        }
    ]
};

const FasMicrochip = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMicrochip",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v40c-35.3 0-64 28.7-64 64H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h40v56H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h40v56H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h40c0 35.3 28.7 64 64 64v40c0 13.3 10.7 24 24 24s24-10.7 24-24v-40h56v40c0 13.3 10.7 24 24 24s24-10.7 24-24v-40h56v40c0 13.3 10.7 24 24 24s24-10.7 24-24v-40c35.3 0 64-28.7 64-64h40c13.3 0 24-10.7 24-24s-10.7-24-24-24h-40v-56h40c13.3 0 24-10.7 24-24s-10.7-24-24-24h-40v-56h40c13.3 0 24-10.7 24-24s-10.7-24-24-24h-40c0-35.3-28.7-64-64-64V24c0-13.3-10.7-24-24-24s-24 10.7-24 24v40h-56V24c0-13.3-10.7-24-24-24s-24 10.7-24 24v40h-56V24zm-16 104h192c17.7 0 32 14.3 32 32v192c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32zm192 32H160v192h192V160z"
        }
    ]
};

const FasMicrophoneLinesSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMicrophoneLinesSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L472.1 344.7c15.2-26 23.9-56.3 23.9-88.7v-40c0-13.3-10.7-24-24-24s-24 10.7-24 24v40c0 21.2-5.1 41.1-14.2 58.7L416 300.8V256h-57.1l-34.5-27c2.9-3.1 7-5 11.6-5h80v-32h-80c-8.8 0-16-7.2-16-16s7.2-16 16-16h80v-32h-80c-8.8 0-16-7.2-16-16s7.2-16 16-16h80c0-53-43-96-96-96s-96 43-96 96v54.3L38.8 5.1zm362.5 407-43.1-33.9c-12.1 3.8-24.9 5.8-38.2 5.8-70.7 0-128-57.3-128-128v-8.7L144.7 210c-.5 1.9-.7 3.9-.7 6v40c0 89.1 66.2 162.7 152 174.4V464h-48c-13.3 0-24 10.7-24 24s10.7 24 24 24h144c13.3 0 24-10.7 24-24s-10.7-24-24-24h-48v-33.6c20.4-2.8 39.7-9.1 57.3-18.2z"
        }
    ]
};

const FasMicrophoneLines = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMicrophoneLines",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 96v160c0 53 43 96 96 96s96-43 96-96h-80c-8.8 0-16-7.2-16-16s7.2-16 16-16h80v-32h-80c-8.8 0-16-7.2-16-16s7.2-16 16-16h80v-32h-80c-8.8 0-16-7.2-16-16s7.2-16 16-16h80c0-53-43-96-96-96S96 43 96 96zm224 144v16c0 70.7-57.3 128-128 128S64 326.7 64 256v-40c0-13.3-10.7-24-24-24s-24 10.7-24 24v40c0 89.1 66.2 162.7 152 174.4V464h-48c-13.3 0-24 10.7-24 24s10.7 24 24 24h144c13.3 0 24-10.7 24-24s-10.7-24-24-24h-48v-33.6c85.8-11.7 152-85.3 152-174.4v-40c0-13.3-10.7-24-24-24s-24 10.7-24 24v24z"
        }
    ]
};

const FasMicrophoneSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMicrophoneSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L472.1 344.7c15.2-26 23.9-56.3 23.9-88.7v-40c0-13.3-10.7-24-24-24s-24 10.7-24 24v40c0 21.2-5.1 41.1-14.2 58.7L416 300.8V96c0-53-43-96-96-96s-96 43-96 96v54.3L38.8 5.1zM344 430.4c20.4-2.8 39.7-9.1 57.3-18.2l-43.1-33.9c-12.1 3.7-24.9 5.7-38.2 5.7-70.7 0-128-57.3-128-128v-8.7L144.7 210c-.5 1.9-.7 3.9-.7 6v40c0 89.1 66.2 162.7 152 174.4V464h-48c-13.3 0-24 10.7-24 24s10.7 24 24 24h144c13.3 0 24-10.7 24-24s-10.7-24-24-24h-48v-33.6z"
        }
    ]
};

const FasMicrophoneStand = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMicrophoneStand",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M479.2 32.8c-43.7-43.7-114.7-43.7-158.4 0l-4.7 4.7 158.4 158.4 4.7-4.7c43.7-43.7 43.7-114.7 0-158.4zM293.5 60.1l-4.7 4.7c-24.4 24.4-35.2 57.2-32.4 89l101.8 101.8c31.8 2.8 64.6-8 89-32.4l4.7-4.7L293.5 60.1zm-64.4 111.6L215.8 187 7.8 427c-11 12.7-10.3 31.7 1.6 43.6l32 32c11.9 11.9 30.9 12.6 43.6 1.6l139-120.5V480c0 17.7 14.3 32 32 32s32-14.3 32-32V328.2l37-32 15.3-13.3-111.2-111.2z"
        }
    ]
};

const FasMicrophone = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMicrophone",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 0c-53 0-96 43-96 96v160c0 53 43 96 96 96s96-43 96-96V96c0-53-43-96-96-96zM64 216c0-13.3-10.7-24-24-24s-24 10.7-24 24v40c0 89.1 66.2 162.7 152 174.4V464h-48c-13.3 0-24 10.7-24 24s10.7 24 24 24h144c13.3 0 24-10.7 24-24s-10.7-24-24-24h-48v-33.6c85.8-11.7 152-85.3 152-174.4v-40c0-13.3-10.7-24-24-24s-24 10.7-24 24v40c0 70.7-57.3 128-128 128S64 326.7 64 256v-40z"
        }
    ]
};

const FasMicroscope = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMicroscope",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 32c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32 17.7 0 32 14.3 32 32v224c0 17.7-14.3 32-32 32 0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32zM32 448h288c70.7 0 128-57.3 128-128s-57.3-128-128-128v-64c106 0 192 86 192 192 0 49.2-18.5 94-48.9 128H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32zm80-64h192c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FasMicrowave = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMicrowave",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 96c0-35.3 28.7-64 64-64h448c35.3 0 64 28.7 64 64v288c0 35.3-28.7 64-64 64 0 17.7-14.3 32-32 32s-32-14.3-32-32H128c0 17.7-14.3 32-32 32s-32-14.3-32-32c-35.3 0-64-28.7-64-64V96zm96 56v176c0 13.3 10.7 24 24 24h272c13.3 0 24-10.7 24-24V152c0-13.3-10.7-24-24-24H120c-13.3 0-24 10.7-24 24zm400-40c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16V128c0-8.8-7.2-16-16-16z"
        }
    ]
};

const FasMillSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMillSign",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M302.1 42.8c5.9-16.6-2.7-35-19.4-40.9s-35 2.7-40.9 19.4L208 116.1c-5.7 4-11.1 8.5-16 13.5-20.3-20.7-48.7-33.6-80-33.6-19.5 0-37.8 5-53.7 13.7C52.5 101.4 42.9 96 32 96c-17.7 0-32 14.3-32 32v288c0 17.7 14.3 32 32 32s32-14.3 32-32V208c0-26.5 21.5-48 48-48s48 21.5 48 48v42.5L81.9 469.2c-5.9 16.6 2.7 35 19.4 40.9s35-2.7 40.9-19.4l21.4-60c5.3 10.3 16 17.3 28.4 17.3 17.7 0 32-14.3 32-32V261.5l35.7-100c3.9-1 8.1-1.6 12.3-1.6 26.5 0 48 21.5 48 48V416c0 17.7 14.3 32 32 32s32-14.3 32-32V208c0-58.2-44.3-106-101.1-111.5l19.2-53.8z"
        }
    ]
};

const FasMinimize = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMinimize",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M456 224H312c-13.3 0-24-10.7-24-24V56c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2l40 40 73.3-73.3C446 2 450.9 0 456 0s10 2 13.7 5.7l36.7 36.7C510 46 512 50.9 512 56s-2 10-5.7 13.7L433 143l40 40c6.9 6.9 8.9 17.2 5.2 26.2S465.7 224 456 224zm0 64c9.7 0 18.5 5.8 22.2 14.8s1.7 19.3-5.2 26.2l-40 40 73.4 73.4c3.6 3.6 5.7 8.5 5.7 13.7s-2 10-5.7 13.7l-36.7 36.7c-3.7 3.5-8.6 5.5-13.7 5.5s-10-2-13.7-5.7L369 433l-40 40c-6.9 6.9-17.2 8.9-26.2 5.2S288 465.7 288 456V312c0-13.3 10.7-24 24-24h144zm-256 0c13.3 0 24 10.7 24 24v144c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-40-40-73.3 73.3C66 510 61.1 512 56 512s-10-2-13.7-5.7L5.7 469.7C2 466 0 461.1 0 456s2-10 5.7-13.7L79 369l-40-40c-6.9-6.9-8.9-17.2-5.2-26.2S46.3 288 56 288h144zM56 224c-9.7 0-18.5-5.8-22.2-14.8S32.1 189.9 39 183l40-40L5.7 69.7C2 66 0 61.1 0 56s2-10 5.7-13.7L42.3 5.7C46 2 50.9 0 56 0s10 2 13.7 5.7L143 79l40-40c6.9-6.9 17.2-8.9 26.2-5.2S224 46.3 224 56v144c0 13.3-10.7 24-24 24H56z"
        }
    ]
};

const FasMinus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMinus",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M432 256c0 17.7-14.3 32-32 32H48c-17.7 0-32-14.3-32-32s14.3-32 32-32h352c17.7 0 32 14.3 32 32z"
        }
    ]
};

const FasMistletoe = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMistletoe",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M312 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v94.1l-98 98-74.7 14.3C38.3 240.6 0 287 0 341c0 41.4 33.6 75 75 75 50.5 0 94.3-33.5 108.1-81.2 7.2 10.4 19.3 17.2 32.9 17.2 22.1 0 40-17.9 40-40s-17.9-40-40-40c-7.9 0-15.3 2.3-21.5 6.3l5.4-28.2 64.1-64.2v72.4c14.7 13.2 24 32.3 24 53.7 0 39.8-32.2 72-72 72-7.2 0-14.2-1.1-20.8-3-2.1 8.4-3.2 17.1-3.2 25.9v9.1c0 53 43 96 96 96s96-43 96-96v-9.1c0-25.1-9-49.4-25.3-68.4L312 284v-98.1l64.1 64.1 14.4 74.7C400.6 377.7 447 416 501 416c41.4 0 75-33.6 75-75 0-54-38.3-100.3-91.3-110.5L410 216.1l-98-98V24zm64 88a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"
        }
    ]
};

const FasMitten = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMitten",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 384H64L5.4 178.9C1.8 166.4 0 153.4 0 140.3 0 62.8 62.8 0 140.3 0h3.4c66 0 123.5 44.9 139.5 108.9l31.4 125.8 17.6-20.1c12.6-14.4 30.7-22.6 49.8-22.6h2.8c34.9 0 63.3 28.3 63.3 63.3 0 15.9-6 31.2-16.8 42.9L352 384zM32 448c0-17.7 14.3-32 32-32h288c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32v-32z"
        }
    ]
};

const FasMobileButton = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMobileButton",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 0C44.7 0 16 28.7 16 64v384c0 35.3 28.7 64 64 64h224c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H80zm112 400a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FasMobileNotch = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMobileNotch",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 64v16c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V64h32c8.8 0 16 7.2 16 16v352c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16h32zM96 0C51.8 0 16 35.8 16 80v352c0 44.2 35.8 80 80 80h192c44.2 0 80-35.8 80-80V80c0-44.2-35.8-80-80-80H96zm32 400c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16h-96c-8.8 0-16 7.2-16 16z"
        }
    ]
};

const FasMobileRetro = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMobileRetro",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 64C0 28.7 28.7 0 64 0h192c35.3 0 64 28.7 64 64v384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm64 96v64c0 17.7 14.3 32 32 32h128c17.7 0 32-14.3 32-32v-64c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32zm16 192a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 56a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm56-56a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 56a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm56-56a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 56a24 24 0 1 0-48 0 24 24 0 1 0 48 0zM128 48c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16h-64z"
        }
    ]
};

const FasMobileScreenButton = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMobileScreenButton",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M16 64C16 28.7 44.7 0 80 0h224c35.3 0 64 28.7 64 64v384c0 35.3-28.7 64-64 64H80c-35.3 0-64-28.7-64-64V64zm208 384a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm80-384H80v320h224V64z"
        }
    ]
};

const FasMobileScreen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMobileScreen",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M16 64C16 28.7 44.7 0 80 0h224c35.3 0 64 28.7 64 64v384c0 35.3-28.7 64-64 64H80c-35.3 0-64-28.7-64-64V64zm128 384c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16h-64c-8.8 0-16 7.2-16 16zM304 64H80v320h224V64z"
        }
    ]
};

const FasMobileSignalOut = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMobileSignalOut",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64h160V0H64C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h224c35.3 0 64-28.7 64-64V288h-64v160H64V64zm80 320c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16h-64zM280 0c-13.3 0-24 10.7-24 24s10.7 24 24 24c101.6 0 184 82.4 184 184 0 13.3 10.7 24 24 24s24-10.7 24-24C512 103.9 408.1 0 280 0zm8 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-32-136c0 13.3 10.7 24 24 24 48.6 0 88 39.4 88 88 0 13.3 10.7 24 24 24s24-10.7 24-24c0-75.1-60.9-136-136-136-13.3 0-24 10.7-24 24z"
        }
    ]
};

const FasMobileSignal = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMobileSignal",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64h224v251.7c18.3-21.2 39.9-39.5 64-54V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h160v-24c0-13.6 1-27 3-40H64V64zm80 320c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16h-64zm344-128c-128.1 0-232 103.9-232 232 0 13.3 10.7 24 24 24s24-10.7 24-24c0-101.6 82.4-184 184-184 13.3 0 24-10.7 24-24s-10.7-24-24-24zm-8 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32-136c0-13.3-10.7-24-24-24-75.1 0-136 60.9-136 136 0 13.3 10.7 24 24 24s24-10.7 24-24c0-48.6 39.4-88 88-88 13.3 0 24-10.7 24-24z"
        }
    ]
};

const FasMobile = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMobile",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 0C44.7 0 16 28.7 16 64v384c0 35.3 28.7 64 64 64h224c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H80zm80 432h64c8.8 0 16 7.2 16 16s-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FasMoneyBill1Wave = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMoneyBill1Wave",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 112.5v309.8c0 18 10.1 35 27 41.3 87 32.5 174 10.3 261-11.9 79.8-20.3 159.6-40.7 239.3-18.9 23 6.3 48.7-9.5 48.7-33.4V89.7c0-18-10.1-35-27-41.3-87-32.5-174-10.3-261 11.9-79.8 20.3-159.6 40.6-239.3 18.8C25.6 72.8 0 88.6 0 112.5zM128 416H64v-64c35.3 0 64 28.7 64 64zM64 224v-64h64c0 35.3-28.7 64-64 64zm384 128c0-35.3 28.7-64 64-64v64h-64zm64-192c-35.3 0-64-28.7-64-64h64v64zm-128 96c0 61.9-43 112-96 112s-96-50.1-96-112 43-112 96-112 96 50.1 96 112zm-132-48c0 9.7 6.9 17.7 16 19.6V276h-4c-11 0-20 9-20 20s9 20 20 20h48c11 0 20-9 20-20s-9-20-20-20h-4v-68c0-11-9-20-20-20h-16c-11 0-20 9-20 20z"
        }
    ]
};

const FasMoneyBill1 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMoneyBill1",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64C28.7 64 0 92.7 0 128v256c0 35.3 28.7 64 64 64h448c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm64 320H64v-64c35.3 0 64 28.7 64 64zM64 192v-64h64c0 35.3-28.7 64-64 64zm384 192c0-35.3 28.7-64 64-64v64h-64zm64-192c-35.3 0-64-28.7-64-64h64v64zm-336 64a112 112 0 1 1 224 0 112 112 0 1 1-224 0zm76-48c0 9.7 6.9 17.7 16 19.6V276h-4c-11 0-20 9-20 20s9 20 20 20h48c11 0 20-9 20-20s-9-20-20-20h-4v-68c0-11-9-20-20-20h-16c-11 0-20 9-20 20z"
        }
    ]
};

const FasMoneyBillSimpleWave = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMoneyBillSimpleWave",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 112.5v309.8c0 18 10.1 35 27 41.3 87 32.5 174 10.3 261-11.9 79.8-20.3 159.6-40.7 239.3-18.9 23 6.3 48.7-9.5 48.7-33.4V89.7c0-18-10.1-35-27-41.3-87-32.5-174-10.3-261 11.9-79.8 20.3-159.6 40.6-239.3 18.8C25.6 72.8 0 88.6 0 112.5zM288 352c-44.2 0-80-43-80-96s35.8-96 80-96 80 43 80 96-35.8 96-80 96z"
        }
    ]
};

const FasMoneyBillSimple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMoneyBillSimple",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64C28.7 64 0 92.7 0 128v256c0 35.3 28.7 64 64 64h448c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm224 96a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"
        }
    ]
};

const FasMoneyBillTransfer = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMoneyBillTransfer",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M535 41c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l64 64c4.5 4.5 7 10.6 7 17s-2.5 12.5-7 17l-64 64c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l23-23-174-.2c-13.3 0-24-10.7-24-24s10.7-24 24-24h174.1L535 41zM105 377l-23 23h174c13.3 0 24 10.7 24 24s-10.7 24-24 24H81.9l23 23c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L7 441c-4.5-4.5-7-10.6-7-17s2.5-12.5 7-17l64-64c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM96 64h241.9c-3.7 7.2-5.9 15.3-5.9 24 0 28.7 23.3 52 52 52h117.4c-4 17 .6 35.5 13.8 48.8 20.3 20.3 53.2 20.3 73.5 0l19.3-19.3V384c0 35.3-28.7 64-64 64H302.1c3.7-7.2 5.9-15.3 5.9-24 0-28.7-23.3-52-52-52H138.6c4-17-.6-35.5-13.8-48.8-20.3-20.3-53.2-20.3-73.5 0L32 342.5V128c0-35.3 28.7-64 64-64zm64 64H96v64c35.3 0 64-28.7 64-64zm384 192c-35.3 0-64 28.7-64 64h64v-64zm-224 32a96 96 0 1 0 0-192 96 96 0 1 0 0 192z"
        }
    ]
};

const FasMoneyBillTrendUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMoneyBillTrendUp",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M470.7 9.4c3 3.1 5.3 6.6 6.9 10.3s2.4 7.8 2.4 12.2V128c0 17.7-14.3 32-32 32s-32-14.3-32-32v-18.7L310.6 214.6c-11.8 11.8-30.8 12.6-43.5 1.7L176 138.1l-91.2 78.2c-13.4 11.5-33.6 9.9-45.1-3.5s-9.9-33.6 3.5-45.1l112-96c12-10.3 29.7-10.3 41.7 0l89.5 76.7L370.7 64H352c-17.7 0-32-14.3-32-32s14.3-32 32-32h96c8.8 0 16.8 3.6 22.6 9.3l.1.1zM0 304c0-26.5 21.5-48 48-48h416c26.5 0 48 21.5 48 48v160c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V304zm48 112v48h48c0-26.5-21.5-48-48-48zm48-112H48v48c26.5 0 48-21.5 48-48zm368 112c-26.5 0-48 21.5-48 48h48v-48zm-48-112c0 26.5 21.5 48 48 48v-48h-48zm-96 80a64 64 0 1 0-128 0 64 64 0 1 0 128 0z"
        }
    ]
};

const FasMoneyBillWave = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMoneyBillWave",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 112.5v309.8c0 18 10.1 35 27 41.3 87 32.5 174 10.3 261-11.9 79.8-20.3 159.6-40.7 239.3-18.9 23 6.3 48.7-9.5 48.7-33.4V89.7c0-18-10.1-35-27-41.3-87-32.5-174-10.3-261 11.9-79.8 20.3-159.6 40.6-239.3 18.8C25.6 72.8 0 88.6 0 112.5zM288 352c-44.2 0-80-43-80-96s35.8-96 80-96 80 43 80 96-35.8 96-80 96zm-224 0c35.3 0 64 28.7 64 64H64v-64zm64-208c0 35.3-28.7 64-64 64v-64h64zm384 160v64h-64c0-35.3 28.7-64 64-64zM448 96h64v64c-35.3 0-64-28.7-64-64z"
        }
    ]
};

const FasMoneyBillWheat = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMoneyBillWheat",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 0c44.2 0 80 35.8 80 80 0 8.8-7.2 16-16 16-44.2 0-80-35.8-80-80 0-8.8 7.2-16 16-16zM56 16h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-13.3 0-24-10.7-24-24s10.7-24 24-24zM24 88h112c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24zm8 96c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-13.3 0-24-10.7-24-24zM272 16c0-8.8 7.2-16 16-16 44.2 0 80 35.8 80 80 0 8.8-7.2 16-16 16-44.2 0-80-35.8-80-80zM400 0c44.2 0 80 35.8 80 80 0 8.8-7.2 16-16 16-44.2 0-80-35.8-80-80 0-8.8 7.2-16 16-16zm80 144c0 44.2-35.8 80-80 80-8.8 0-16-7.2-16-16 0-44.2 35.8-80 80-80 8.8 0 16 7.2 16 16zm-128-16c8.8 0 16 7.2 16 16 0 44.2-35.8 80-80 80-8.8 0-16-7.2-16-16 0-44.2 35.8-80 80-80zm-96 16c0 44.2-35.8 80-80 80-8.8 0-16-7.2-16-16 0-44.2 35.8-80 80-80 8.8 0 16 7.2 16 16zM0 304c0-26.5 21.5-48 48-48h416c26.5 0 48 21.5 48 48v160c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V304zm48 112v48h48c0-26.5-21.5-48-48-48zm48-112H48v48c26.5 0 48-21.5 48-48zm368 112c-26.5 0-48 21.5-48 48h48v-48zm-48-112c0 26.5 21.5 48 48 48v-48h-48zm-96 80a64 64 0 1 0-128 0 64 64 0 1 0 128 0z"
        }
    ]
};

const FasMoneyBill = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMoneyBill",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64C28.7 64 0 92.7 0 128v256c0 35.3 28.7 64 64 64h448c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm64 320H64v-64c35.3 0 64 28.7 64 64zM64 192v-64h64c0 35.3-28.7 64-64 64zm384 192c0-35.3 28.7-64 64-64v64h-64zm64-192c-35.3 0-64-28.7-64-64h64v64zm-224-32a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"
        }
    ]
};

const FasMoneyBillsSimple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMoneyBillsSimple",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 96v224c0 35.3 28.7 64 64 64h416c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H160c-35.3 0-64 28.7-64 64zm192 112a80 80 0 1 1 160 0 80 80 0 1 1-160 0zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120v240c0 66.3 53.7 120 120 120h400c13.3 0 24-10.7 24-24s-10.7-24-24-24H120c-39.8 0-72-32.2-72-72V120z"
        }
    ]
};

const FasMoneyBills = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMoneyBills",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 96v224c0 35.3 28.7 64 64 64h416c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H160c-35.3 0-64 28.7-64 64zm64 160c35.3 0 64 28.7 64 64h-64v-64zm64-160c0 35.3-28.7 64-64 64V96h64zm352 160v64h-64c0-35.3 28.7-64 64-64zM512 96h64v64c-35.3 0-64-28.7-64-64zM288 208a80 80 0 1 1 160 0 80 80 0 1 1-160 0zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120v240c0 66.3 53.7 120 120 120h400c13.3 0 24-10.7 24-24s-10.7-24-24-24H120c-39.8 0-72-32.2-72-72V120z"
        }
    ]
};

const FasMoneyCheckDollarPen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMoneyCheckDollarPen",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 128c0-35.3 28.7-64 64-64h448c35.3 0 64 28.7 64 64v64.6c-15.2 2-29.8 8.8-41.4 20.5L353.3 394.3c-8.2 8.2-14 18.5-16.8 29.7l-6 23.9H64c-35.3 0-64-28.7-64-64V128zm256 176c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16h-64c-8.8 0-16 7.2-16 16zm16-112c-8.8 0-16 7.2-16 16s7.2 16 16 16h160c8.8 0 16-7.2 16-16s-7.2-16-16-16H272zm-128-52.1c-11.1 0-20.1 9-20.1 20.1v6c-5.6 1.2-10.9 2.9-15.9 5.1-15 6.8-27.9 19.4-31.1 37.7-1.8 10.2-.8 20 3.4 29 4.2 8.8 10.7 15 17.3 19.5 11.6 7.9 26.9 12.5 38.6 16l2.2.7c13.9 4.2 23.4 7.4 29.3 11.7 2.5 1.8 3.4 3.2 3.7 4 .3.8.9 2.6.2 6.7-.6 3.5-2.5 6.4-8 8.8-6.1 2.6-16 3.9-28.8 1.9-6-1-16.7-4.6-26.2-7.9-2.2-.7-4.3-1.5-6.4-2.1-10.5-3.5-21.8 2.2-25.3 12.7s2.2 21.8 12.7 25.3c1.2.4 2.7.9 4.4 1.5 7.9 2.7 20.3 6.9 29.8 9.1v6.3c0 11.1 9 20.1 20.1 20.1s20.1-9 20.1-20.1v-5.5c5.3-1 10.5-2.5 15.4-4.6 15.7-6.7 28.4-19.7 31.6-38.7 1.8-10.4 1-20.3-3-29.4-3.9-9-10.2-15.6-16.9-20.5-12.2-8.8-28.3-13.7-40.4-17.4l-.8-.2c-14.2-4.3-23.8-7.3-29.9-11.4-2.6-1.8-3.4-3-3.6-3.5-.2-.3-.7-1.6-.1-5 .3-1.9 1.9-5.2 8.2-8.1 6.4-2.9 16.4-4.5 28.6-2.6 4.3.7 17.9 3.3 21.7 4.3 10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-4.4-1.2-14.4-3.2-21-4.4V160c0-11.1-9-20.1-20.1-20.1zm469.8 95.8 14.4 14.4c15.6 15.6 15.6 40.9 0 56.6l-29.4 29.4-71-71 29.4-29.4c15.6-15.6 40.9-15.6 56.6 0zM375.9 417l129.2-129.2 71 71-129.2 129.1c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9z"
        }
    ]
};

const FasMoneyCheckDollar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMoneyCheckDollar",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64C28.7 64 0 92.7 0 128v256c0 35.3 28.7 64 64 64h448c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm208 128h224c8.8 0 16 7.2 16 16s-7.2 16-16 16H272c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-16 112c0-8.8 7.2-16 16-16h224c8.8 0 16 7.2 16 16s-7.2 16-16 16H272c-8.8 0-16-7.2-16-16zm-92-152v13.9c7.5 1.2 14.6 2.9 21.1 4.7 10.7 2.8 17 13.8 14.2 24.5s-13.8 17-24.5 14.2c-11-2.9-21.6-5-31.2-5.2-7.9-.1-16 1.8-21.5 5-4.8 2.8-6.2 5.6-6.2 9.3 0 1.8.1 3.5 5.3 6.7 6.3 3.8 15.5 6.7 28.3 10.5l.7.2c11.2 3.4 25.6 7.7 37.1 15 12.9 8.1 24.3 21.3 24.6 41.6.3 20.9-10.5 36.1-24.8 45-7.2 4.5-15.2 7.3-23.2 9V360c0 11-9 20-20 20s-20-9-20-20v-14.6c-10.3-2.2-20-5.5-28.2-8.4-2.1-.7-4.1-1.4-6.1-2.1-10.5-3.5-16.1-14.8-12.6-25.3s14.8-16.1 25.3-12.6c2.5.8 4.9 1.7 7.2 2.4 13.6 4.6 24 8.1 35.1 8.5 8.6.3 16.5-1.6 21.4-4.7 4.1-2.5 6-5.5 5.9-10.5 0-2.9-.8-5-5.9-8.2-6.3-4-15.4-6.9-28-10.7l-1.7-.5c-10.9-3.3-24.6-7.4-35.6-14-12.7-7.7-24.6-20.5-24.7-40.7-.1-21.1 11.8-35.7 25.8-43.9 6.9-4.1 14.5-6.8 22.2-8.5V152c0-11 9-20 20-20s20 9 20 20z"
        }
    ]
};

const FasMoneyCheckPen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMoneyCheckPen",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64C28.7 64 0 92.7 0 128v256c0 35.3 28.7 64 64 64h266.5l6-23.9c2.8-11.3 8.6-21.5 16.8-29.7l181.3-181.3c11.6-11.6 26.3-18.5 41.4-20.5V128c0-35.3-28.7-64-64-64H64zm48 224h224c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-16-80c0-8.8 7.2-16 16-16h320c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16zm517.8 27.7c-15.6-15.6-40.9-15.6-56.6 0l-29.4 29.4 71 71 29.4-29.4c15.6-15.6 15.6-40.9 0-56.6l-14.4-14.4zM375.9 417c-4.1 4.1-7 9.2-8.4 14.9l-15 60.1c-1.4 5.5.2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l60.1-15c5.6-1.4 10.8-4.3 14.9-8.4l129.2-129.3-71-71L375.9 417z"
        }
    ]
};

const FasMoneyCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMoneyCheck",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64C28.7 64 0 92.7 0 128v256c0 35.3 28.7 64 64 64h448c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm48 160h160c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zM96 336c0-8.8 7.2-16 16-16h352c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16zm280-176h80c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24h-80c-13.3 0-24-10.7-24-24v-48c0-13.3 10.7-24 24-24z"
        }
    ]
};

const FasMoneyFromBracket = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMoneyFromBracket",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 96v64c0 17.7-14.3 32-32 32S0 177.7 0 160V96C0 43 43 0 96 0h448c53 0 96 43 96 96v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V96c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32zm64 0h384v352c0 35.3-28.7 64-64 64H192c-35.3 0-64-28.7-64-64V96zm128 352c0-35.3-28.7-64-64-64v64h64zm192-64c-35.3 0-64 28.7-64 64h64v-64zm-128-32c53 0 96-35.8 96-80s-43-80-96-80-96 35.8-96 80 43 80 96 80z"
        }
    ]
};

const FasMoneySimpleFromBracket = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMoneySimpleFromBracket",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 96v64c0 17.7-14.3 32-32 32S0 177.7 0 160V96C0 43 43 0 96 0h448c53 0 96 43 96 96v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V96c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32zm64 0h384v352c0 35.3-28.7 64-64 64H192c-35.3 0-64-28.7-64-64V96zm192 256c53 0 96-35.8 96-80s-43-80-96-80-96 35.8-96 80 43 80 96 80z"
        }
    ]
};

const FasMonitorWaveform = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMonitorWaveform",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm16 64h416c8.8 0 16 7.2 16 16v288c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm16 160h96c6.1 0 11.6 3.4 14.3 8.8l17.7 35.4 49.7-99.4c2.7-5.4 8.3-8.8 14.3-8.8s11.6 3.4 14.3 8.8l27.6 55.2H400c8.8 0 16 7.2 16 16s-7.2 16-16 16h-80c-6.1 0-11.6-3.4-14.3-8.8L288 243.8l-49.7 99.4c-2.7 5.4-8.3 8.8-14.3 8.8s-11.6-3.4-14.3-8.8L182.1 288H96v96h384V128H96v128z"
        }
    ]
};

const FasMonkey = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMonkey",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 416c0-89.7 61.4-165 144.5-186.1C329.1 265 369.9 288 416 288c9.8 0 19.4-1 28.7-3l81.8 78c31.6 30.2 49.5 72 49.5 115.7v1.3c0 17.7-14.3 32-32 32s-32-14.3-32-32v-1.2c0-26.2-10.7-51.3-29.7-69.4L416 346.1V448h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H160C71.6 512 0 440.4 0 352V110.1C0 49.3 49.3 0 110.1 0h10.4c57.2 0 102.8 47.8 100.1 104.9-2.3 48.2-38.6 88-86.4 94.6l-1.9.3c-17.5 2.4-33.7-9.8-36.1-27.3s9.8-33.7 27.3-36.1l1.9-.3c17.3-2.4 30.4-16.7 31.2-34.2 1-20.6-15.5-37.9-36.2-37.9h-10.3C84.7 64 64 84.7 64 110.1V352c0 53 43 96 96 96v-32zm256-160c-29.3 0-55.9-12.2-74.8-31.7-9-9.3-16.2-20.2-21.3-32.3-35.3 0-64-28.7-64-64s28.6-64 64-64c15.7-37.6 52.8-64 96-64s80.4 26.4 96 64c35.3 0 64 28.7 64 64s-28.6 64-64 64c-15.7 37.6-52.8 64-96 64zM384 64c-26.5 0-48 21.5-48 48 0 20.8 13.2 38.4 31.6 45.1 4.7 1.7 8.4 5.9 8.4 10.9 0 22.1 17.9 40 40 40s40-17.9 40-40c0-5 3.7-9.2 8.4-10.9 18.5-6.7 31.6-24.4 31.6-45.1 0-26.5-21.5-48-48-48h-64zm0 32a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1-32 0z"
        }
    ]
};

const FasMonument = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMonument",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M180.7 4.7c6.2-6.2 16.4-6.2 22.6 0l80 80c2.5 2.5 4.1 5.8 4.6 9.3l40.2 322H55.9L96.1 94c.4-3.5 2-6.8 4.6-9.3l80-80zM152 272c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24h-80zM32 448h320c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
        }
    ]
};

const FasMoonCloud = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMoonCloud",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M479.5 32c-118.2 0-214.9 92-223 208.3C310 244.7 352 289.4 352 344c0 27.9-11 53.3-29 72 40.3 39.6 95.5 64 156.4 64 60.6 0 115.5-24.2 155.8-63.4 5-4.9 6.3-12.5 3.1-18.7s-10.1-9.7-17-8.5c-9.8 1.7-19.8 2.6-30.1 2.6-96.9 0-175.5-78.8-175.5-176 0-65.8 36-123.1 89.3-153.3 6.1-3.5 9.2-10.5 7.7-17.3s-7.3-11.9-14.3-12.5c-6.2-.5-12.6-.8-19-.8zM64 416h184c39.8 0 72-32.2 72-72s-32.2-72-72-72c-10.1 0-19.7 2.1-28.4 5.8C208.8 246.5 179 224 144 224c-38.7 0-71 27.5-78.4 64H64c-35.3 0-64 28.7-64 64s28.7 64 64 64z"
        }
    ]
};

const FasMoonOverSun = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMoonOverSun",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M361.5 1.2c5 2.1 8.6 6.6 9.6 11.9L391 121l107.9 19.8c5.3 1 9.8 4.6 11.9 9.6s1.5 10.7-1.6 15.2L446.9 256l62.3 90.3c3.1 4.5 3.7 10.2 1.6 15.2s-6.6 8.6-11.9 9.6L391 391l-19.9 107.9c-1 5.3-4.6 9.8-9.6 11.9s-10.7 1.5-15.2-1.6L256 446.9l-90.3 62.3c-4.5 3.1-10.2 3.7-15.2 1.6s-8.6-6.6-9.6-11.9L121 391 13.1 371.1c-5.3-1-9.8-4.6-11.9-9.6s-1.5-10.7 1.6-15.2L65.1 256 2.8 165.7c-3.1-4.5-3.7-10.2-1.6-15.2s6.6-8.6 11.9-9.6L121 121l19.9-107.9c1-5.3 4.6-9.8 9.6-11.9s10.7-1.5 15.2 1.6L256 65.1l90.3-62.3c4.5-3.1 10.2-3.7 15.2-1.6zM400 256a144 144 0 1 0-288 0 144 144 0 1 0 288 0zm-258 0c0-63.1 51.6-114 115-114 3.3 0 6.5.1 9.7.4 7 .6 12.8 5.7 14.3 12.6s-1.7 13.9-7.8 17.4c-22.9 12.8-38.3 37.1-38.3 64.8 0 41 33.6 74.5 75.4 74.5 4.4 0 8.8-.4 13-1.1 6.9-1.2 13.8 2.3 17 8.6s1.9 13.9-3.2 18.7c-20.7 19.9-49 32.2-80.1 32.2-63.4 0-115-50.9-115-114z"
        }
    ]
};

const FasMoonStars = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMoonStars",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m284.8 99.2 11 38.6c1 3.6 4.4 6.2 8.2 6.2s7.1-2.5 8.2-6.2l11-38.6 38.6-11c3.6-1 6.2-4.4 6.2-8.2s-2.5-7.1-6.2-8.2l-38.6-11-11-38.6c-1-3.6-4.4-6.2-8.2-6.2s-7.1 2.5-8.2 6.2l-11 38.6-38.6 11c-3.6 1-6.2 4.4-6.2 8.2s2.5 7.1 6.2 8.2l38.6 11zm119 211.6c1.6 5.5 6.6 9.2 12.2 9.2s10.7-3.8 12.2-9.2l16.6-58 58-16.6c5.5-1.6 9.2-6.6 9.2-12.2s-3.8-10.7-9.2-12.2l-58-16.6-16.6-58c-1.6-5.5-6.6-9.2-12.2-9.2s-10.7 3.8-12.2 9.2l-16.6 58-58 16.6c-5.5 1.6-9.2 6.6-9.2 12.2s3.8 10.7 9.2 12.2l58 16.6 16.6 58zM191.8 128C85.8 128 0 214.1 0 320.2s85.8 192.2 191.8 192.2c52 0 99.1-20.7 133.6-54.4 5-4.9 6.3-12.5 3.1-18.7s-10.1-9.7-17-8.5c-8.1 1.4-16.5 2.2-25.1 2.2-80.7 0-146.2-65.6-146.2-146.6 0-54.8 30-102.6 74.4-127.8 6.1-3.5 9.2-10.5 7.7-17.3s-7.3-11.9-14.3-12.5c-5.4-.5-10.8-.7-16.3-.7z"
        }
    ]
};

const FasMoon = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMoon",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M223.5 32C100 32 0 132.3 0 256s100 224 223.5 224c60.6 0 115.5-24.2 155.8-63.4 5-4.9 6.3-12.5 3.1-18.7s-10.1-9.7-17-8.5c-9.8 1.7-19.8 2.6-30.1 2.6-96.9 0-175.5-78.8-175.5-176 0-65.8 36-123.1 89.3-153.3 6.1-3.5 9.2-10.5 7.7-17.3s-7.3-11.9-14.3-12.5c-6.3-.5-12.6-.8-19-.8z"
        }
    ]
};

const FasMoped = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMoped",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M328 56c0-13.3 10.7-24 24-24h41.3c23.8 0 45.1 15.1 52.9 37.6l8.1 23.3 51-25.5c4.4-2.2 9.3-3.4 14.3-3.4h8.4c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16h-8.4c-5 0-9.9-1.2-14.3-3.4l-34.9-17.5 29.6 85.3c4-.3 8-.4 12-.4 43.7 0 83.3 17.5 112.1 45.8 9.5 9.3 9.6 24.5.3 33.9s-24.5 9.6-33.9.3c-20.3-19.8-47.9-32-78.5-32-55.1 0-101 39.8-110.3 92.3-2 11.5-12 19.8-23.6 19.8H336c-.9 0-1.7 0-2.6-.1H256c0 53-43 96-96 96s-96-43-96-96H32c-17.7 0-32-14.3-32-32v-32c0-70.7 57.3-128 128-128h96c17.7 0 32 14.3 32 32v64c0 17.7 14.3 32 32 32h77.3c16.8-38.5 48.4-69.2 87.6-84.7L400.8 85.4c-1.1-3.2-4.2-5.4-7.6-5.4H352c-13.3 0-24-10.7-24-24zM128 96h96c17.7 0 32 14.3 32 32s-14.3 32-32 32h-96c-17.7 0-32-14.3-32-32s14.3-32 32-32zm32 336c26.5 0 48-21.5 48-48h-96c0 26.5 21.5 48 48 48zm352 0a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0-144a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"
        }
    ]
};

const FasMortarPestle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMortarPestle",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M504.3 11.1c-11-12.7-29.8-14.8-43.3-4.9L252.3 160h145L502.6 54.6c11.8-11.8 12.6-30.8 1.6-43.5zM32 192c-17.7 0-32 14.3-32 32s14.3 32 32 32c0 82.5 43.4 147.7 123.9 176.2-11.1 13.9-19.4 30.3-23.9 48.1-4.4 17.1 10.3 31.7 28 31.7h192c17.7 0 32.4-14.6 28.1-31.7-4.5-17.8-12.8-34.1-23.9-48.1C436.6 403.7 480 338.5 480 256c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"
        }
    ]
};

const FasMosque = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMosque",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M400 0c5 0 9.8 2.4 12.8 6.4 34.7 46.3 78.1 74.9 133.5 111.5 5.2 3.4 10.5 7 16 10.6 28.9 19.2 45.7 51.7 45.7 86.1 0 28.6-11.3 54.5-29.8 73.4H221.8c-18.4-19-29.8-44.9-29.8-73.4 0-34.4 16.7-66.9 45.7-86.1 5.4-3.6 10.8-7.1 16-10.6 55.4-36.6 98.8-65.2 133.5-111.5 3-4 7.8-6.4 12.8-6.4zM288 512v-72c0-13.3-10.7-24-24-24s-24 10.7-24 24v72h-48c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32h416c17.7 0 32 14.3 32 32v128c0 17.7-14.3 32-32 32h-48v-72c0-13.3-10.7-24-24-24s-24 10.7-24 24v72h-64v-58c0-19-8.4-37-23-49.2L400 384l-25 20.8C360.4 417 352 435 352 454v58h-64zM70.4 5.2a15.9 15.9 0 0 1 19.2 0l16 12C139.8 42.9 160 83.2 160 126v2H0v-2C0 83.2 20.2 42.9 54.4 17.2l16-12zM0 160h160v136.6c-19.1 11.1-32 31.7-32 55.4v128c0 9.6 2.1 18.6 5.8 26.8-6.6 3.4-14 5.2-21.8 5.2H48c-26.5 0-48-21.5-48-48V160z"
        }
    ]
};

const FasMosquitoNet = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMosquitoNet",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M168.8 462.3c-7.9-4-11.1-13.6-7.2-21.5l30.4-60.6V336c0-4.2 1.7-8.3 4.7-11.3l59.3-59.3v-23.2L139.2 344C87.8 395.3 0 358.9 0 286.3c0-41.1 30.6-75.8 71.4-80.9l159.9-23.9-49.6-41.3c-5.1-4.2-7-11.1-4.9-17.4l13.9-41.7-29-58.1c-4-7.9-.7-17.5 7.2-21.5s17.5-.7 21.5 7.2l32 64c1.9 3.8 2.2 8.2.9 12.2l-12.5 37.6 45.2 38v-22.6c0-14.9 10.1-27.3 23.8-31V63.7c0-4.5 3.7-8.2 8.2-8.2s8.2 3.7 8.2 8.2V107c13.7 3.6 23.8 16.1 23.8 31v22.6l45.4-37.8-12.6-37.7c-1.3-4-1-8.4.9-12.2l32-64c4-7.9 13.6-11.1 21.5-7.2s11.1 13.6 7.2 21.5l-29 58.1 13.9 41.7c2.1 6.2.1 13.1-4.9 17.4l-49.6 41.3 159.9 23.9c22.5 2.8 41.8 14.6 54.7 31.4-2.7 2.6-5.2 5.4-7.3 8.6-8.6-12.9-23.3-21.5-40-21.5s-31.4 8.5-40 21.5c-8.6-12.9-23.3-21.5-40-21.5-21.7 0-40 14.3-45.9 34.1-10.7 3.2-19.8 10.1-25.9 19.2l-40.2-35v23.1l32.4 32.4c-.3 2-.4 4.1-.4 6.2 0 16.7 8.5 31.4 21.5 40-4 2.6-7.5 5.9-10.6 9.5l-43-43v50c0 17.7-14.3 32-32 32s-32-14.3-32-32v-50l-32 32V384c0 2.5-.6 4.9-1.7 7.2l-32 64c-4 7.9-13.6 11.1-21.5 7.2zM512 256c8.8 0 16 7.2 16 16v16h48v-16c0-8.8 7.2-16 16-16s16 7.2 16 16v16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16h-16v48h16c8.8 0 16 7.2 16 16s-7.2 16-16 16h-16v48h16c8.8 0 16 7.2 16 16s-7.2 16-16 16h-16v16c0 8.8-7.2 16-16 16s-16-7.2-16-16v-16h-48v16c0 8.8-7.2 16-16 16s-16-7.2-16-16v-16h-48v16c0 8.8-7.2 16-16 16s-16-7.2-16-16v-16h-16c-8.8 0-16-7.2-16-16s7.2-16 16-16h16v-48h-16c-8.8 0-16-7.2-16-16s7.2-16 16-16h16v-48h-16c-8.8 0-16-7.2-16-16s7.2-16 16-16h16v-16c0-8.8 7.2-16 16-16s16 7.2 16 16v16h48v-16c0-8.8 7.2-16 16-16zm16 112h48v-48h-48v48zm0 80h48v-48h-48v48zm-80-128v48h48v-48h-48zm0 80v48h48v-48h-48z"
        }
    ]
};

const FasMosquito = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMosquito",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M463.7 505.9c9.8-8.9 10.7-24.3 2.1-34.3l-42.1-49v-54.7c0-5.5-1.8-10.8-5.1-15.1L352 266.3v-.3l133.4 121.8c57 59.8 154.6 17.4 154.6-67.2 0-47.9-34-88.3-79.4-94.2l-153-23.9 40.8-40.9c7.8-7.8 9.4-20.1 3.9-29.8l-23.8-41.7 38.2-50.9c8-10.6 6.1-25.9-4.3-34.1s-25.2-6.3-33.2 4.4l-48 63.9c-5.9 7.9-6.6 18.6-1.7 27.2l22.7 39.4-50.2 50.3v-38.2c0-14.9-10.2-27.4-24-31V63.9c0-4.4-3.6-8-8-8s-8 3.6-8 8v57.2c-13.8 3.6-24 16.1-24 31v38.1L237.8 140l22.6-39.5c4.9-8.6 4.2-19.3-1.7-27.2l-48-63.9c-8-10.6-22.8-12.6-33.2-4.4s-12.2 23.5-4.3 34.1L211.4 90l-23.9 41.7c-5.5 9.7-3.9 22 3.9 29.8l40.8 40.9-153 23.9C34 232.3 0 272.7 0 320.6c0 84.6 97.6 127 154.6 67.1L288 266v.3l-66.5 86.4c-3.3 4.3-5.1 9.6-5.1 15.1v54.7l-42.1 49c-8.6 10.1-7.7 25.5 2.1 34.3s24.7 7.9 33.4-2.1l48-55.9c3.8-4.4 5.9-10.2 5.9-16.1v-55.4l24.3-31.6v63.1c0 17.7 14.3 32 32 32s32-14.3 32-32v-63.1l24.3 31.6v55.4c0 5.9 2.1 11.7 5.9 16.1l48 55.9c8.6 10.1 23.6 11 33.4 2.1z"
        }
    ]
};

const FasMotorcycle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMotorcycle",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M280 32c-13.3 0-24 10.7-24 24s10.7 24 24 24h57.7l16.4 30.3L256 192l-45.3-45.3c-12-12-28.3-18.7-45.3-18.7H64c-17.7 0-32 14.3-32 32v32h96c88.4 0 160 71.6 160 160 0 11-1.1 21.7-3.2 32h70.4c-2.1-10.3-3.2-21-3.2-32 0-52.2 25-98.6 63.7-127.8l15.4 28.6C402.4 276.3 384 312 384 352c0 70.7 57.3 128 128 128s128-57.3 128-128-57.3-128-128-128c-13.5 0-26.5 2.1-38.7 6l-55.1-102H480c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32h-20.4c-7.5 0-14.7 2.6-20.5 7.4l-47.4 39.5-14-26c-7-12.9-20.5-21-35.2-21H280zm182.7 279.2 28.2 52.2c6.3 11.7 20.9 16 32.5 9.7s16-20.9 9.7-32.5l-28.2-52.2c2.3-.3 4.7-.4 7.1-.4 35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64c0-15.5 5.5-29.7 14.7-40.8zM187.3 376c-9.5 23.5-32.5 40-59.3 40-35.3 0-64-28.7-64-64s28.7-64 64-64c26.9 0 49.9 16.5 59.3 40h66.4c-11.2-59.2-63.2-104-125.7-104C57.3 224 0 281.3 0 352s57.3 128 128 128c62.5 0 114.5-44.8 125.8-104h-66.5zm-59.3 8a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FasMound = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMound",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144.1 179.2C173.8 127.7 228.6 96 288 96s114.2 31.7 143.9 83.2L540.4 368c12.3 21.3-3.1 48-27.7 48H63.3c-24.6 0-40-26.6-27.7-48l108.5-188.8z"
        }
    ]
};

const FasMountainCity = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMountainCity",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M336 0c-26.5 0-48 21.5-48 48v92.1l71.4 118.4c2.5-1.6 5.4-2.5 8.6-2.5h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-3.5l73.8 122.4c12.4 20.6 12.9 46.3 1.2 67.3-.4.8-.9 1.6-1.4 2.3H592c26.5 0 48-21.5 48-48V240c0-26.5-21.5-48-48-48h-24v-72c0-13.3-10.7-24-24-24s-24 10.7-24 24v72h-40V48c0-26.5-21.5-48-48-48h-96zm32 64h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16zm-16 112c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32zm160 96c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16zM224 188.9l59.8 99.1H223l-48 64-24.6-41.2L224 188.9zm29.4-44.2C247.1 134.3 236 128 224 128s-23.1 6.3-29.4 16.7L5.1 458.9c-6.5 10.8-6.7 24.3-.7 35.3S22 512 34.5 512h379c12.5 0 24-6.8 30.1-17.8s5.8-24.5-.7-35.3L253.4 144.7z"
        }
    ]
};

const FasMountainSun = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMountainSun",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M560 160a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM55.9 512h523c33.8 0 61.1-27.4 61.1-61.1 0-11.2-3.1-22.2-8.9-31.8l-132-216.3C495 196.1 487.8 192 480 192s-15 4.1-19.1 10.7l-48.2 79L286.8 81c-6.6-10.6-18.3-17-30.8-17s-24.1 6.4-30.8 17L8.6 426.4C3 435.3 0 445.6 0 456.1 0 487 25 512 55.9 512z"
        }
    ]
};

const FasMountain = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMountain",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32c12.5 0 24.1 6.4 30.8 17l216.6 345.4c5.6 8.9 8.6 19.2 8.6 29.7 0 30.9-25 55.9-55.9 55.9H55.9C25 480 0 455 0 424.1c0-10.5 3-20.8 8.6-29.7L225.2 49c6.6-10.6 18.3-17 30.8-17zm65 192-65-103.6-79.1 126.1 18.3 24.4c6.4 8.5 19.2 8.5 25.6 0l25.6-34.1c6-8.1 15.5-12.8 25.6-12.8h49z"
        }
    ]
};

const FasMountains = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMountains",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M381.1 480H55.9C25 480 0 455 0 424.1c0-10.5 3-20.8 8.6-29.7L225.2 49c6.6-10.6 18.3-17 30.8-17s24.1 6.4 30.8 17l126 200.7 48.2-79c4-6.6 11.2-10.7 19-10.7s15 4.1 19.1 10.7l132 216.3c5.8 9.6 8.9 20.6 8.9 31.8 0 33.8-27.4 61.1-61.1 61.1H381.1z"
        }
    ]
};

const FasMouseField = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMouseField",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M396.4 112.9c2.4-7.9 3.6-16.3 3.6-24.9 0-48.6-39.4-88-88-88s-88 39.4-88 88c0 29.9 14.9 56.3 37.6 72.2C169.5 164.3 96 240.4 96 333.6c0 12.3 2.7 24 7.5 34.4H72c-39.8 0-72 32.2-72 72s32.2 72 72 72h384c13.3 0 24-10.7 24-24s-10.7-24-24-24H72c-13.3 0-24-10.7-24-24s10.7-24 24-24h310.6c18.5 0 33.4-15 33.4-33.4 0-14.1-8.8-26.6-22-31.4l-43.7-15.9 23.8-63.5c2 .1 4 .2 6 .2h102.8c16.1 0 29.1-13 29.1-29.1 0-41.5-19.3-78.4-49.4-102.4C473.5 125.8 480 107.7 480 88c0-46.4-35.9-84.4-81.4-87.8C419.2 20.6 432 48.8 432 80c0 13.9-2.5 27.2-7.2 39.5-9.1-3.2-18.6-5.5-28.4-6.6zM400 196a20 20 0 1 1 40 0 20 20 0 1 1-40 0zM312 48c22.1 0 40 17.9 40 40v24c0 8.8-7.2 16-16 16h-24c-22.1 0-40-17.9-40-40s17.9-40 40-40z"
        }
    ]
};

const FasMp3Player = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMp3Player",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 64C0 28.7 28.7 0 64 0h256c35.3 0 64 28.7 64 64v384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm192 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 128a96 96 0 1 0 0-192 96 96 0 1 0 0 192zM96 64c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h192c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H96z"
        }
    ]
};

const FasMugHot = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMugHot",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M88 0C74.7 0 64 10.7 64 24c0 38.9 23.4 59.4 39.1 73.1l1.1 1c16.3 14.2 23.8 21.8 23.8 37.9 0 13.3 10.7 24 24 24s24-10.7 24-24c0-38.9-23.4-59.4-39.1-73.1l-1.1-1C119.5 47.7 112 40.1 112 24c0-13.3-10.7-24-24-24zM32 192c-17.7 0-32 14.3-32 32v192c0 53 43 96 96 96h192c53 0 96-43 96-96h16c61.9 0 112-50.1 112-112s-50.1-112-112-112H32zm352 64h16c26.5 0 48 21.5 48 48s-21.5 48-48 48h-16v-96zM224 24c0-13.3-10.7-24-24-24s-24 10.7-24 24c0 38.9 23.4 59.4 39.1 73.1l1.1 1c16.3 14.2 23.8 21.8 23.8 37.9 0 13.3 10.7 24 24 24s24-10.7 24-24c0-38.9-23.4-59.4-39.1-73.1l-1.1-1C231.5 47.7 224 40.1 224 24z"
        }
    ]
};

const FasMugMarshmallows = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMugMarshmallows",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 32c7.5 0 14.4 2.6 19.8 6.9L175 75.7c-9.6 9.6-15 22.7-15 36.3 0 5.5.9 10.9 2.6 16H32V64c0-17.7 14.3-32 32-32h128zm5.7 93.7c-3.7-3.7-5.7-8.6-5.7-13.7s2-10 5.7-13.7l60.7-60.7C262 34 266.9 32 272 32s10 2 13.7 5.7l60.7 60.7c3.6 3.6 5.7 8.5 5.7 13.7s-2 10-5.7 13.7L344 128H200l-2.3-2.3zM0 192c0-17.7 14.3-32 32-32h64v64c0 17.7 14.3 32 32 32s32-14.3 32-32v-64h240c61.9 0 112 50.1 112 112s-50.1 112-112 112h-16c0 53-43 96-96 96H96c-53 0-96-43-96-96V192zm384 32v96h16c26.5 0 48-21.5 48-48s-21.5-48-48-48h-16z"
        }
    ]
};

const FasMugSaucer = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMugSaucer",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 64c0-17.7 14.3-32 32-32h384c70.7 0 128 57.3 128 128s-57.3 128-128 128h-32c0 53-43 96-96 96H192c-53 0-96-43-96-96V64zm384 160h32c35.3 0 64-28.7 64-64s-28.7-64-64-64h-32v128zM32 416h512c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
        }
    ]
};

const FasMugTeaSaucer = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMugTeaSaucer",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M208 82.7V32h-80c-17.7 0-32 14.3-32 32v224c0 53 43 96 96 96h192c53 0 96-43 96-96h32c70.7 0 128-57.3 128-128S582.7 32 512 32H240v50.7c0 8.5 3.4 16.6 9.4 22.6l29.3 29.3c6 6 9.4 14.1 9.4 22.6V224c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32v-66.7c0-8.5 3.4-16.6 9.4-22.6l29.3-29.3c6-6 9.4-14.1 9.4-22.6zM480 96h32c35.3 0 64 28.7 64 64s-28.7 64-64 64h-32V96zM32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32h512c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"
        }
    ]
};

const FasMugTea = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMugTea",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 64v50.7c0 8.5-3.4 16.6-9.4 22.6l-29.3 29.3c-6 6-9.4 14.1-9.4 22.6V256c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32v-66.7c0-8.5-3.4-16.6-9.4-22.6l-29.3-29.3c-6-6-9.4-14.1-9.4-22.6V64H448c70.7 0 128 57.3 128 128s-57.3 128-128 128h-32v32c0 53-43 96-96 96H128c-53 0-96-43-96-96V96c0-17.7 14.3-32 32-32h80zm272 192h32c35.3 0 64-28.7 64-64s-28.7-64-64-64h-32v128z"
        }
    ]
};

const FasMug = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMug",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c-17.7 0-32 14.3-32 32v256c0 53 43 96 96 96h192c53 0 96-43 96-96v-32h32c70.7 0 128-57.3 128-128S518.7 64 448 64H64zm352 64h32c35.3 0 64 28.7 64 64s-28.7 64-64 64h-32V128z"
        }
    ]
};

const FasMushroom = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMushroom",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M24 258.1C24 133.2 125.2 32 250.1 32h11.8C386.8 32 488 133.2 488 258.1c0 34.2-27.7 61.9-61.9 61.9H85.9C51.7 320 24 292.3 24 258.1zm387.5-96.7c-3.7-.9-7.5-1.4-11.5-1.4-26.5 0-48 21.5-48 48s21.5 48 48 48c15.9 0 30-7.7 38.7-19.6-3.3-27.4-12.9-52.9-27.2-75zm-265.6-47.8c8 35.7 39.9 62.4 78.1 62.4 44.2 0 80-35.8 80-80 0-3.8-.3-7.5-.8-11.2-13.2-3.1-27.1-4.8-41.3-4.8h-11.8c-38.9 0-74.9 12.5-104.2 33.6zM191 352h130l22 88.2c2.4 9.6.2 19.7-5.8 27.5S321.8 480 312 480H200c-9.9 0-19.2-4.5-25.2-12.3s-8.2-17.9-5.8-27.5l22-88.2zm-31-128a32 32 0 1 0-64 0 32 32 0 1 0 64 0z"
        }
    ]
};

const FasMusicNoteSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMusicNoteSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 32c0-9.9-4.5-19.2-12.3-25.2S481.8-1.4 472.2 1l-128 32C330 36.5 320 49.3 320 64v161.5L38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L384 275.7V153l103.8-26c14.2-3.5 24.2-16.3 24.2-31V32zM272 352c-61.9 0-112 35.8-112 80s50.1 80 112 80 112-35.8 112-80v-20.8L317.8 359c-14-4.5-29.5-7-45.8-7z"
        }
    ]
};

const FasMusicNote = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMusicNote",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 32c0-9.9-4.5-19.2-12.3-25.2S353.8-1.4 344.2 1l-128 32C202 36.5 192 49.3 192 64v295.7c-14.5-4.9-30.8-7.7-48-7.7-61.9 0-112 35.8-112 80s50.1 80 112 80 112-35.8 112-80V153l103.8-26c14.2-3.5 24.2-16.3 24.2-31V32z"
        }
    ]
};

const FasMusicSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMusicSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-71.5-56c10.5-12.9 16.7-28.4 16.7-45.1V32c0-10.1-4.8-19.6-12.9-25.7s-18.6-7.9-28.3-5l-320 96c-12.7 3.8-21.6 14.9-22.7 27.9L38.8 5.1zm261.9 205.3L512 147v145.6c-10-2.9-20.8-4.6-32-4.6-22.2 0-42.6 6.3-58.8 16.8l-120.5-94.4zM192 247.3v109.3c-10-3-20.8-4.6-32-4.6-53 0-96 35.8-96 80s43 80 96 80 96-35.8 96-80V297.7l-64-50.4z"
        }
    ]
};

const FasMusic = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMusic",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M499.1 6.3c8.1 6 12.9 15.6 12.9 25.7v336c0 44.2-43 80-96 80s-96-35.8-96-80 43-80 96-80c11.2 0 22 1.6 32 4.6V147l-256 76.8V432c0 44.2-43 80-96 80S0 476.2 0 432s43-80 96-80c11.2 0 22 1.6 32 4.6V128c0-14.1 9.3-26.6 22.8-30.7l320-96c9.7-2.9 20.2-1.1 28.3 5z"
        }
    ]
};

const FasMustache = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasMustache",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M147.9 148.4c21.4-23.2 51.5-36.4 83.1-36.4 33 0 64.4 14.4 85.9 39.5l3.1 3.6 3.1-3.6C344.6 126.4 376 112 409 112c31.6 0 61.7 13.2 83.1 36.4l2 2.1c27.6 29.9 74.6 30.9 103.4 2.1l1.5-1.6c2.5-2.5 5.5-4.4 8.6-5.5 2.6-1 5.4-1.5 8.4-1.5 5.7 0 10.9 2 15 5.2 1.3 1.1 2.6 2.3 3.6 3.6.4.5.7 1 1.1 1.4.3.4.5.8.7 1.1.3.5.6.9.8 1.4 1.8 3.3 2.7 7.1 2.7 11.2v39.4C640 313.8 553.8 400 447.4 400c-46.7 0-91.7-16.9-126.9-47.7l-.5-.4-.5.4c-35.1 30.8-80.2 47.7-126.9 47.7C86.2 400 0 313.8 0 207.4V168c0-4.2 1.1-8.1 2.9-11.5.6-1 1.2-2.1 2-3 1.2-1.6 2.6-3 4.1-4.2 1.5-1.2 3.1-2.2 4.8-3 3.1-1.5 6.5-2.3 10.2-2.3 2.9 0 5.8.5 8.4 1.5 3.1 1.2 6.1 3 8.6 5.5l1.6 1.6c28.8 28.8 75.8 27.9 103.4-2.1l2-2.1z"
        }
    ]
};

const FasN = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasN",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M21.1 33.9c12.7-4.6 26.9-.7 35.5 9.6L320 359.6V64c0-17.7 14.3-32 32-32s32 14.3 32 32v384c0 13.5-8.4 25.5-21.1 30.1s-26.9.7-35.5-9.6L64 152.4V448c0 17.7-14.3 32-32 32S0 465.7 0 448V64c0-13.5 8.4-25.5 21.1-30.1z"
        }
    ]
};

const FasNairaSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasNairaSign",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M122.6 46.3c-7.8-11.7-22.4-17-35.9-12.9S64 49.9 64 64v192H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h32v128c0 17.7 14.3 32 32 32s32-14.3 32-32V320h100.2l97.2 145.8c7.8 11.7 22.4 17 35.9 12.9s22.7-16.5 22.7-30.6V320h32c17.7 0 32-14.3 32-32s-14.3-32-32-32h-32V64c0-17.7-14.3-32-32-32s-32 14.3-32 32v192h-57.5L122.6 46.3zM305.1 320H320v22.3L305.1 320zm-119.6-64H128v-86.3l57.5 86.3z"
        }
    ]
};

const FasNarwhal = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasNarwhal",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M639.3 20.7c2.4-7.8-1.4-16.1-8.9-19.4s-16.2-.4-20.2 6.6l-93.5 160.4c-16.9-5.4-34.9-8.3-53.6-8.3-50.9 0-100.7 17.5-140.2 49.6L154.1 346.8c-10.5 8.5-26.1 1.1-26.1-12.4v-81.3l29.9-20.9c21.4-15 34.1-39.4 34.1-65.5V112c0-6-3.3-11.4-8.6-14.2s-11.7-2.3-16.6 1.1L96 148.5 25.2 98.9c-4.9-3.4-11.3-3.8-16.6-1.1S0 106 0 112v54.7c0 26.1 12.7 50.6 34.1 65.5L64 253.1V352c0 88.4 71.6 160 160 160h240c97.2 0 176-78.8 176-176 0-51.4-22.3-97.7-57.8-129.9l57-185.4zM496 280a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FasNestingDolls = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasNestingDolls",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 0c61.9 0 112 50.1 112 112v112H80V112C80 50.1 130.1 0 192 0zm-8.7 64.9c-11.7 15.1-28.7 26-48.2 29.7-4 .8-7.2 4.2-6.8 8.2 1.5 14 7.6 27.7 18.4 38.5 25 25 65.5 25 90.5 0 10.8-10.8 16.9-24.4 18.4-38.5.4-4.1-2.7-7.5-6.8-8.2-19.5-3.7-36.5-14.6-48.2-29.7-4.1-5.3-13.2-5.3-17.3 0zm452.2 409.2c5.2 7.3 5.9 16.9 1.8 24.9s-12.4 13-21.3 13H312c-9 0-17.2-5-21.3-13-4.1-8-3.4-17.6 1.8-24.9l.2-.3c.2-.3.6-.8 1-1.5.9-1.4 2.3-3.5 4-6.3 3.4-5.6 7.9-13.8 12.5-23.8 9.2-20.3 17.8-46.8 17.8-74.1v-8c0-75.1 60.9-136 136-136s136 60.9 136 136v8c0 27.3 8.6 53.7 17.8 74.1 4.6 10 9.1 18.2 12.5 23.8 1.7 2.8 3.1 5 4 6.3.5.7.8 1.2 1 1.5l.2.3zM455.3 320.9C440.7 339.8 417.8 352 392 352c-4.3 0-8 3.3-7.6 7.6 1.7 17.9 9.4 35.3 23.1 49 31.2 31.2 81.9 31.2 113.1 0 13.7-13.7 21.4-31.1 23.1-49 .4-4.3-3.3-7.6-7.6-7.6-25.8 0-48.7-12.2-63.3-31.1-4.1-5.3-13.2-5.3-17.3 0zM296 360v8c0 21-6.8 42.7-15 60.8-4 8.7-7.9 15.8-10.8 20.6-1.4 2.4-2.6 4.1-3.2 5.2-.3.5-.6.9-.7 1v.1c-11.7 16.6-13.5 38.1-4.9 56.3H74.5c-17 0-33.4-6.7-42.7-20.9C17.9 469.7 0 432.8 0 384c0-44.4 20.2-84.4 37.9-119.4 2.7-5.3 8.1-8.6 14-8.6h280.2c-22.6 28.6-36.1 64.7-36.1 104z"
        }
    ]
};

const FasNetworkWired = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasNetworkWired",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 64h128v64H256V64zM240 0c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48h48v32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h96v32H80c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48h160c26.5 0 48-21.5 48-48v-96c0-26.5-21.5-48-48-48h-48v-32h256v32h-48c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48h160c26.5 0 48-21.5 48-48v-96c0-26.5-21.5-48-48-48h-48v-32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H352v-32h48c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H240zM96 448v-64h128v64H96zm320-64h128v64H416v-64z"
        }
    ]
};

const FasNeuter = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasNeuter",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 176a112 112 0 1 1 224 0 112 112 0 1 1-224 0zm144 173.1c81.9-15 144-86.8 144-173.1C368 78.8 289.2 0 192 0S16 78.8 16 176c0 86.3 62.1 158.1 144 173.1V480c0 17.7 14.3 32 32 32s32-14.3 32-32V349.1z"
        }
    ]
};

const FasNewspaper = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasNewspaper",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 96c0-35.3 28.7-64 64-64h288c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H80c-44.2 0-80-35.8-80-80V128c0-17.7 14.3-32 32-32s32 14.3 32 32v272c0 8.8 7.2 16 16 16s16-7.2 16-16V96zm64 24v80c0 13.3 10.7 24 24 24h112c13.3 0 24-10.7 24-24v-80c0-13.3-10.7-24-24-24H184c-13.3 0-24 10.7-24 24zm208-8c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16s-7.2-16-16-16h-48c-8.8 0-16 7.2-16 16zm0 96c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16s-7.2-16-16-16h-48c-8.8 0-16 7.2-16 16zm-208 96c0 8.8 7.2 16 16 16h256c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zm0 96c0 8.8 7.2 16 16 16h256c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16z"
        }
    ]
};

const FasNfcLock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasNfcLock",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v65.1c-24.9 3.6-47.2 15.3-64 32.5V144c0-26.5-21.5-48-48-48h-80c-26.5 0-48 21.5-48 48v66.7c-18.6 6.6-32 24.4-32 45.3 0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.7-32-45.3V144c0-8.8 7.2-16 16-16h80c8.8 0 16 7.2 16 16v152.6c-19.1 11.1-32 31.7-32 55.4v32H112c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32c-26.5 0-48 21.5-48 48v224c0 26.5 21.5 48 48 48h208v64H64c-35.3 0-64-28.7-64-64V96zm464 144c-17.7 0-32 14.3-32 32v48h64v-48c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32v128c0 17.7-14.3 32-32 32H384c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32v-48z"
        }
    ]
};

const FasNfcMagnifyingGlass = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasNfcMagnifyingGlass",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v64c-22.8 0-44.4 4.8-64 13.3V144c0-26.5-21.5-48-48-48h-80c-26.5 0-48 21.5-48 48v66.7c-18.6 6.6-32 24.4-32 45.3 0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.7-32-45.3V144c0-8.8 7.2-16 16-16h80c8.8 0 16 7.2 16 16v48c-38.9 29.2-64 75.7-64 128 0 22.8 4.8 44.4 13.3 64H112c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32c-26.5 0-48 21.5-48 48v224c0 26.5 21.5 48 48 48h208c21.6 28.8 52.7 50 88.6 59.1-7.6 3.2-15.9 4.9-24.6 4.9H64c-35.3 0-64-28.7-64-64V96zm448 304.2a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0 48c-70.7 0-128-57.3-128-128s57.3-128 128-128 128 57.3 128 128c0 26.7-8.2 51.4-22.1 71.9l79.1 79.1c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L519.9 426c-20.5 14-45.3 22.1-71.9 22.1z"
        }
    ]
};

const FasNfcPen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasNfcPen",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v139.6l-64 64V144c0-26.5-21.5-48-48-48h-80c-26.5 0-48 21.5-48 48v66.7c-18.6 6.6-32 24.4-32 45.3 0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.7-32-45.3V144c0-8.8 7.2-16 16-16h80c8.8 0 16 7.2 16 16v187.6L299.6 384H112c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32c-26.5 0-48 21.5-48 48v224c0 26.5 21.5 48 48 48h163.1c-1 2.6-1.9 5.3-2.6 8.1l-14 55.9H64c-35.3 0-64-28.7-64-64V96zm549.8 139.7 14.4 14.4c15.6 15.6 15.6 40.9 0 56.6l-29.4 29.4-71-71 29.4-29.4c15.6-15.6 40.9-15.6 56.6 0zM311.9 417l129.2-129.2 71 71-129.2 129.1c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9z"
        }
    ]
};

const FasNfcSignal = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasNfcSignal",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v131c-22.4 3.4-43.8 9.6-64 18.3V144c0-26.5-21.5-48-48-48h-80c-26.5 0-48 21.5-48 48v66.7c-18.6 6.6-32 24.4-32 45.3 0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.7-32-45.3V144c0-8.8 7.2-16 16-16h80c8.8 0 16 7.2 16 16v117.7c-47.2 28.4-84.8 71.2-106.7 122.3H112c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32c-26.5 0-48 21.5-48 48v224c0 26.5 21.5 48 48 48h121.9c-5.8 20.4-9.2 41.9-9.8 64H64c-35.3 0-64-28.7-64-64V96zm488 160c13.3 0 24 10.7 24 24s-10.7 24-24 24c-101.6 0-184 82.4-184 184 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-128.1 103.9-232 232-232zm-8 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm32-72c0 13.3-10.7 24-24 24-48.6 0-88 39.4-88 88 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-75.1 60.9-136 136-136 13.3 0 24 10.7 24 24z"
        }
    ]
};

const FasNfcSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasNfcSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-86.8-68V96c0-35.3-28.7-64-64-64H160c-21.6 0-40.7 10.7-52.3 27.1l-68.9-54zm134.7 105.6c8.7-9 21-14.7 34.5-14.7h32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32c-3.3 0-6.4 1-8.9 2.7l-25.6-20.1zm128.6 100.8c.6-.3 1.3-.5 1.9-.7V144c0-26.5 21.5-48 48-48h80c26.5 0 48 21.5 48 48v206.9l-32-25.1V144c0-8.8-7.2-16-16-16h-80c-8.8 0-16 7.2-16 16v66.7c18.6 6.6 32 24.4 32 45.3 0 2.3-.2 4.6-.5 6.8L302 211.5zm184.8 268.1L406.2 416H208c-26.5 0-48-21.5-48-48V222.1l-64-50.5V416c0 35.3 28.7 64 64 64h320c2.3 0 4.6-.1 6.9-.4zM208 384h157.5L192 247.3V368c0 8.8 7.2 16 16 16z"
        }
    ]
};

const FasNfcSymbol = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasNfcSymbol",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M348.9 471.8c10.3 9.3 25.4 10.8 37.4 3.9C461.6 432.1 512 348.8 512 256S461.7 79.9 386.3 36.3c-15.3-8.8-34.9-3.6-43.7 11.7s-3.6 34.9 11.7 43.7C410.1 124 448 186.4 448 256c0 61.4-29.5 117.2-74.8 151.7L213.4 264.2c-13.2-11.8-33.4-10.7-45.2 2.4s-10.7 33.4 2.4 45.2l178.3 160zM163.1 40.2c-10.3-9.3-25.4-10.8-37.4-3.9C50.3 79.9 0 163.2 0 256s50.3 176.1 125.7 219.7c15.3 8.8 34.9 3.6 43.7-11.7s3.6-34.9-11.7-43.7C101.9 388 64 325.7 64 256c0-61.4 29.5-117.2 74.8-151.7l159.8 143.5c13.2 11.8 33.4 10.7 45.2-2.4s10.7-33.4-2.4-45.2l-178.3-160z"
        }
    ]
};

const FasNfcTrash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasNfcTrash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v66.7c-11.5 4.1-21.3 12.5-26.9 23.8l-2.7 5.5H400c-5.6 0-11 1-16 2.7V144c0-26.5-21.5-48-48-48h-80c-26.5 0-48 21.5-48 48v66.7c-18.6 6.6-32 24.4-32 45.3 0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.7-32-45.3V144c0-8.8 7.2-16 16-16h80c8.8 0 16 7.2 16 16v224c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32c-26.5 0-48 21.5-48 48v224c0 26.5 21.5 48 48 48h224c16.4 0 30.9-8.2 39.6-20.8l6.1 84.8H64c-35.3 0-64-28.7-64-64V96zm449.7 104.8c2.7-5.4 8.2-8.8 14.3-8.8h96c6.1 0 11.6 3.4 14.3 8.8l11.6 23.2H624c8.8 0 16 7.2 16 16s-7.2 16-16 16H400c-8.8 0-16-7.2-16-16s7.2-16 16-16h38.1l11.6-23.2zm-35.8 281.5L400 288h224l-13.9 194.3C608.9 499 595 512 578.2 512H445.8c-16.8 0-30.7-13-31.9-29.7z"
        }
    ]
};

const FasNfc = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasNfc",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm64 48v224c0 26.5 21.5 48 48 48h224c26.5 0 48-21.5 48-48V144c0-26.5-21.5-48-48-48h-80c-26.5 0-48 21.5-48 48v66.7c-18.6 6.6-32 24.4-32 45.3 0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.7-32-45.3V144c0-8.8 7.2-16 16-16h80c8.8 0 16 7.2 16 16v224c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32c-26.5 0-48 21.5-48 48z"
        }
    ]
};

const FasNose = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasNose",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M324.2 231.9 421 338.3c17.4 19.1 27 44 27 69.9 0 57.3-46.5 103.8-103.9 103.8h-9.4c-32.3 0-63.6-11.3-88.4-32l-6.4-5.3c-20.7-17.2-46.7-26.7-73.6-26.7-21.2 0-38.3 17.2-38.3 38.3v5.7c0 1.7.1 3.4.3 5.1.8 7.1-4 14.9-11.2 14.9H112C50.8 512 1.1 462.9 0 401.9 1 345.3 44.3 298 100.9 292.4l44.7-4.5c8.8-.9 15.2-8.7 14.3-17.5s-8.7-15.2-17.5-14.3l-44.7 4.5c-7.1.7-14 1.9-20.7 3.6-6.4 1.6-13-3-13-9.7V32C64 14.3 78.3 0 96 0h61.6c11.4 0 21.9 6 27.6 15.9l75.6 129.6c18.1 30.9 39.3 59.9 63.4 86.4z"
        }
    ]
};

const FasNotEqual = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasNotEqual",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M369.8 37.4c14.7 9.8 18.7 29.7 8.9 44.4L337.1 144H400c17.7 0 32 14.3 32 32s-14.3 32-32 32H294.5l-64 96H400c17.7 0 32 14.3 32 32s-14.3 32-32 32H187.8l-65.2 97.7c-9.8 14.7-29.7 18.7-44.4 8.9s-18.7-29.7-8.9-44.4l41.6-62.2H48c-17.7 0-32-14.3-32-32s14.3-32 32-32h105.5l64-96H48c-17.7 0-32-14.3-32-32s14.3-32 32-32h212.2l65.2-97.7c9.8-14.7 29.7-18.7 44.4-8.9z"
        }
    ]
};

const FasNotdef = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasNotdef",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 390.3 153.5 256 64 121.7v268.6zm38.5 57.7h179L192 313.7 102.5 448zm128-192L320 390.3V121.7L230.5 256zm51-192h-179L192 198.3 281.5 64zM0 48C0 21.5 21.5 0 48 0h288c26.5 0 48 21.5 48 48v416c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V48z"
        }
    ]
};

const FasNoteMedical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasNoteMedical",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v224H336c-26.5 0-48 21.5-48 48v112H64c-35.3 0-64-28.7-64-64V96zm402.7 256H448l-32 32-64 64-32 32V368c0-8.8 7.2-16 16-16h66.7zM192 144v48h-48c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-48h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-48v-48c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16z"
        }
    ]
};

const FasNoteSticky = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasNoteSticky",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h224V368c0-26.5 21.5-48 48-48h112V96c0-35.3-28.7-64-64-64H64zm384 320H336c-8.8 0-16 7.2-16 16v112l32-32 64-64 32-32z"
        }
    ]
};

const FasNote = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasNote",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v224H336c-26.5 0-48 21.5-48 48v112H64c-35.3 0-64-28.7-64-64V96zm402.7 256H448l-32 32-64 64-32 32V368c0-8.8 7.2-16 16-16h66.7zM112 376a24 24 0 1 0-48 0 24 24 0 1 0 48 0zM88 112a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm24 144a24 24 0 1 0-48 0 24 24 0 1 0 48 0z"
        }
    ]
};

const FasNotebook = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasNotebook",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 48v56H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h40v80H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h40v80H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h40v56c0 26.5 21.5 48 48 48h80V0h-80C85.5 0 64 21.5 64 48zM432 0H224v512h208c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48z"
        }
    ]
};

const FasNotesMedical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasNotesMedical",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 352V96c0-35.3 28.7-64 64-64h256c35.3 0 64 28.7 64 64v197.5c0 17-6.7 33.3-18.7 45.3l-58.5 58.5c-12 12-28.3 18.7-45.3 18.7H160c-35.3 0-64-28.7-64-64zm176-224c-8.8 0-16 7.2-16 16v48h-48c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-48h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-48v-48c0-8.8-7.2-16-16-16h-32zm24 336c13.3 0 24 10.7 24 24s-10.7 24-24 24H136C60.9 512 0 451.1 0 376V152c0-13.3 10.7-24 24-24s24 10.7 24 24v224c0 48.6 39.4 88 88 88h160z"
        }
    ]
};

const FasNotes = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasNotes",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 32c-35.3 0-64 28.7-64 64v256c0 35.3 28.7 64 64 64h179.2c4.3 0 8.6-.4 12.8-1.3V320c0-17.7 14.3-32 32-32h94.7c.9-4.2 1.3-8.5 1.3-12.8V96c0-35.3-28.7-64-64-64H160zm224 320v64l96-96h-96v32zm-88 112H136c-48.6 0-88-39.4-88-88V152c0-13.3-10.7-24-24-24S0 138.7 0 152v224c0 75.1 60.9 136 136 136h160c13.3 0 24-10.7 24-24s-10.7-24-24-24z"
        }
    ]
};

const FasO = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasO",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 96a160 160 0 1 0 0 320 160 160 0 1 0 0-320zm224 160a224 224 0 1 1-448 0 224 224 0 1 1 448 0z"
        }
    ]
};

const FasObjectExclude = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasObjectExclude",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 64C0 28.7 28.7 0 64 0h224c35.3 0 64 28.7 64 64v96h96c35.3 0 64 28.7 64 64v224c0 35.3-28.7 64-64 64H224c-35.3 0-64-28.7-64-64v-96H64c-35.3 0-64-28.7-64-64V64zm320 128H192v128h128V192z"
        }
    ]
};

const FasObjectGroup = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasObjectGroup",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 119.4C12.9 108.4 0 87.7 0 64 0 28.7 28.7 0 64 0c23.7 0 44.4 12.9 55.4 32h337.2c11-19.1 31.7-32 55.4-32 35.3 0 64 28.7 64 64 0 23.7-12.9 44.4-32 55.4v273.2c19.1 11.1 32 31.7 32 55.4 0 35.3-28.7 64-64 64-23.7 0-44.4-12.9-55.4-32H119.4c-11.1 19.1-31.7 32-55.4 32-35.3 0-64-28.7-64-64 0-23.7 12.9-44.4 32-55.4V119.4zM456.6 96H119.4c-5.6 9.7-13.7 17.8-23.4 23.4v273.2c9.7 5.6 17.8 13.7 23.4 23.4h337.2c5.6-9.7 13.7-17.8 23.4-23.4V119.4c-9.7-5.6-17.8-13.7-23.4-23.4zM128 160c0-17.7 14.3-32 32-32h128c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32v-96zm128 160h32c35.3 0 64-28.7 64-64v-32h64c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H288c-17.7 0-32-14.3-32-32v-32z"
        }
    ]
};

const FasObjectIntersect = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasObjectIntersect",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 64v96h-64c-35.3 0-64 28.7-64 64v64H64V64h224zM64 352h96v96c0 35.3 28.7 64 64 64h224c35.3 0 64-28.7 64-64V224c0-35.3-28.7-64-64-64h-96V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64v224c0 35.3 28.7 64 64 64zm384-128v224H224v-96h64c35.3 0 64-28.7 64-64v-64h96z"
        }
    ]
};

const FasObjectSubtract = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasObjectSubtract",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 448c0 35.3-28.7 64-64 64H224c-35.3 0-64-28.7-64-64v-96H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0h224c35.3 0 64 28.7 64 64v96h96c35.3 0 64 28.7 64 64v224zM288 288V64H64v224h224z"
        }
    ]
};

const FasObjectUngroup = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasObjectUngroup",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 119.4C12.9 108.4 0 87.7 0 64 0 28.7 28.7 0 64 0c23.7 0 44.4 12.9 55.4 32h209.2c11-19.1 31.7-32 55.4-32 35.3 0 64 28.7 64 64 0 23.7-12.9 44.4-32 55.4v113.2c19.1 11.1 32 31.7 32 55.4 0 35.3-28.7 64-64 64-23.7 0-44.4-12.9-55.4-32H119.4c-11.1 19.1-31.7 32-55.4 32-35.3 0-64-28.7-64-64 0-23.7 12.9-44.4 32-55.4V119.4zM119.4 96c-5.6 9.7-13.7 17.8-23.4 23.4v113.2c9.7 5.6 17.8 13.7 23.4 23.4h209.2c5.6-9.7 13.7-17.8 23.4-23.4V119.4c-9.7-5.6-17.8-13.7-23.4-23.4H119.4zm192 384c-11.1 19.1-31.7 32-55.4 32-35.3 0-64-28.7-64-64 0-23.7 12.9-44.4 32-55.4V352h64v40.6c9.7 5.6 17.8 13.7 23.4 23.4h209.2c5.6-9.7 13.7-17.8 23.4-23.4V279.4c-9.7-5.6-17.8-13.7-23.4-23.4h-46c-5.4-15.4-14.6-28.9-26.5-39.6V192h72.6c11.1-19.1 31.7-32 55.4-32 35.3 0 64 28.7 64 64 0 23.7-12.9 44.4-32 55.4v113.2c19.1 11.1 32 31.7 32 55.4 0 35.3-28.7 64-64 64-23.7 0-44.4-12.9-55.4-32H311.4z"
        }
    ]
};

const FasObjectUnion = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasObjectUnion",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 0C28.7 0 0 28.7 0 64v224c0 35.3 28.7 64 64 64h96v96c0 35.3 28.7 64 64 64h224c35.3 0 64-28.7 64-64V224c0-35.3-28.7-64-64-64h-96V64c0-35.3-28.7-64-64-64H64z"
        }
    ]
};

const FasObjectsAlignBottom = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasObjectsAlignBottom",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M24 512h464c13.3 0 24-10.7 24-24s-10.7-24-24-24H24c-13.3 0-24 10.7-24 24s10.7 24 24 24zm40-176c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48h-64C85.5 0 64 21.5 64 48v288zm224 0c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48h-64c-26.5 0-48 21.5-48 48v160z"
        }
    ]
};

const FasObjectsAlignCenterHorizontal = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasObjectsAlignCenterHorizontal",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 0c-13.3 0-24 10.7-24 24v40H80c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h152v64h-88c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h88v40c0 13.3 10.7 24 24 24s24-10.7 24-24v-40h88c26.5 0 48-21.5 48-48v-64c0-26.5-21.5-48-48-48h-88v-64h152c26.5 0 48-21.5 48-48v-64c0-26.5-21.5-48-48-48H280V24c0-13.3-10.7-24-24-24z"
        }
    ]
};

const FasObjectsAlignCenterVertical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasObjectsAlignCenterVertical",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 80c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48v152h64v-88c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48v88h40c13.3 0 24 10.7 24 24s-10.7 24-24 24h-40v88c0 26.5-21.5 48-48 48h-64c-26.5 0-48-21.5-48-48v-88h-64v152c0 26.5-21.5 48-48 48h-64c-26.5 0-48-21.5-48-48V280H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h40V80z"
        }
    ]
};

const FasObjectsAlignLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasObjectsAlignLeft",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 24v464c0 13.3 10.7 24 24 24s24-10.7 24-24V24C48 10.7 37.3 0 24 0S0 10.7 0 24zm176 40c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-64c0-26.5-21.5-48-48-48H176zm0 224c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h160c26.5 0 48-21.5 48-48v-64c0-26.5-21.5-48-48-48H176z"
        }
    ]
};

const FasObjectsAlignRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasObjectsAlignRight",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 24v464c0 13.3-10.7 24-24 24s-24-10.7-24-24V24c0-13.3 10.7-24 24-24s24 10.7 24 24zM336 64c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48v-64c0-26.5 21.5-48 48-48h288zm0 224c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H176c-26.5 0-48-21.5-48-48v-64c0-26.5 21.5-48 48-48h160z"
        }
    ]
};

const FasObjectsAlignTop = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasObjectsAlignTop",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M24 0h464c13.3 0 24 10.7 24 24s-10.7 24-24 24H24C10.7 48 0 37.3 0 24S10.7 0 24 0zm40 176c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48v288c0 26.5-21.5 48-48 48h-64c-26.5 0-48-21.5-48-48V176zm224 0c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48v160c0 26.5-21.5 48-48 48h-64c-26.5 0-48-21.5-48-48V176z"
        }
    ]
};

const FasObjectsColumn = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasObjectsColumn",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 32C21.5 32 0 53.5 0 80v160c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H48zm256 192c-26.5 0-48 21.5-48 48v160c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48h-96zM0 400v32c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48v-32c0-26.5-21.5-48-48-48H48c-26.5 0-48 21.5-48 48zM304 32c-26.5 0-48 21.5-48 48v32c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48h-96z"
        }
    ]
};

const FasOctagonCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasOctagonCheck",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M140.6 21.2C154.1 7.7 172.4.1 191.5.1h129c19.1 0 37.4 7.6 50.9 21.1l119.4 119.4c13.5 13.5 21.1 31.8 21.1 50.9v129c0 19.1-7.6 37.4-21.1 50.9L371.4 490.8a71.983 71.983 0 0 1-50.9 21.1h-129c-19.1 0-37.4-7.6-50.9-21.1L21.2 371.4A71.983 71.983 0 0 1 .1 320.5v-129c0-19.1 7.6-37.4 21.1-50.9L140.6 21.2zM369 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 209z"
        }
    ]
};

const FasOctagonDivide = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasOctagonDivide",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M140.6 21.2C154.1 7.7 172.4.1 191.5.1h129c19.1 0 37.4 7.6 50.9 21.1l119.4 119.4c13.5 13.5 21.1 31.8 21.1 50.9v129c0 19.1-7.6 37.4-21.1 50.9L371.4 490.8a71.983 71.983 0 0 1-50.9 21.1h-129c-19.1 0-37.4-7.6-50.9-21.1L21.2 371.4A71.983 71.983 0 0 1 .1 320.5v-129c0-19.1 7.6-37.4 21.1-50.9L140.6 21.2zM256 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-88 40c-13.3 0-24 10.7-24 24s10.7 24 24 24h176c13.3 0 24-10.7 24-24s-10.7-24-24-24H168zm120 120a32 32 0 1 0-64 0 32 32 0 1 0 64 0z"
        }
    ]
};

const FasOctagonExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasOctagonExclamation",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M140.6 21.2C154.1 7.7 172.4.1 191.5.1h129c19.1 0 37.4 7.6 50.9 21.1l119.4 119.4c13.5 13.5 21.1 31.8 21.1 50.9v129c0 19.1-7.6 37.4-21.1 50.9L371.4 490.8a71.983 71.983 0 0 1-50.9 21.1h-129c-19.1 0-37.4-7.6-50.9-21.1L21.2 371.4A71.983 71.983 0 0 1 .1 320.5v-129c0-19.1 7.6-37.4 21.1-50.9L140.6 21.2zM256 128c-13.3 0-24 10.7-24 24v112c0 13.3 10.7 24 24 24s24-10.7 24-24V152c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0-64 0 32 32 0 1 0 64 0z"
        }
    ]
};

const FasOctagonMinus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasOctagonMinus",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M140.6 21.2C154.1 7.7 172.4.1 191.5.1h129c19.1 0 37.4 7.6 50.9 21.1l119.4 119.4c13.5 13.5 21.1 31.8 21.1 50.9v129c0 19.1-7.6 37.4-21.1 50.9L371.4 490.8a71.983 71.983 0 0 1-50.9 21.1h-129c-19.1 0-37.4-7.6-50.9-21.1L21.2 371.4A71.983 71.983 0 0 1 .1 320.5v-129c0-19.1 7.6-37.4 21.1-50.9L140.6 21.2zM184 232c-13.3 0-24 10.7-24 24s10.7 24 24 24h144c13.3 0 24-10.7 24-24s-10.7-24-24-24H184z"
        }
    ]
};

const FasOctagonPlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasOctagonPlus",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M140.6 21.2C154.1 7.7 172.4.1 191.5.1h129c19.1 0 37.4 7.6 50.9 21.1l119.4 119.4c13.5 13.5 21.1 31.8 21.1 50.9v129c0 19.1-7.6 37.4-21.1 50.9L371.4 490.8a71.983 71.983 0 0 1-50.9 21.1h-129c-19.1 0-37.4-7.6-50.9-21.1L21.2 371.4A71.983 71.983 0 0 1 .1 320.5v-129c0-19.1 7.6-37.4 21.1-50.9L140.6 21.2zM232 344c0 13.3 10.7 24 24 24s24-10.7 24-24v-64h64c13.3 0 24-10.7 24-24s-10.7-24-24-24h-64v-64c0-13.3-10.7-24-24-24s-24 10.7-24 24v64h-64c-13.3 0-24 10.7-24 24s10.7 24 24 24h64v64z"
        }
    ]
};

const FasOctagonXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasOctagonXmark",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M140.6 21.2C154.1 7.7 172.4.1 191.5.1h129c19.1 0 37.4 7.6 50.9 21.1l119.4 119.4c13.5 13.5 21.1 31.8 21.1 50.9v129c0 19.1-7.6 37.4-21.1 50.9L371.4 490.8a71.983 71.983 0 0 1-50.9 21.1h-129c-19.1 0-37.4-7.6-50.9-21.1L21.2 371.4A71.983 71.983 0 0 1 .1 320.5v-129c0-19.1 7.6-37.4 21.1-50.9L140.6 21.2zM175 175c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z"
        }
    ]
};

const FasOctagon = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasOctagon",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M191.5.1c-19.1 0-37.4 7.6-50.9 21.1L21.2 140.6A71.983 71.983 0 0 0 .1 191.5v129c0 19.1 7.6 37.4 21.1 50.9l119.4 119.4c13.5 13.5 31.8 21.1 50.9 21.1h129c19.1 0 37.4-7.6 50.9-21.1l119.4-119.4c13.5-13.5 21.1-31.8 21.1-50.9v-129c0-19.1-7.6-37.4-21.1-50.9L371.4 21.2A71.983 71.983 0 0 0 320.5.1h-129z"
        }
    ]
};

const FasOilCanDrip = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasOilCanDrip",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 96c0 17.7-14.3 32-32 32h-32v32h80.9c9.9 0 19.7 2.3 28.6 6.8L448 192l167-35.8c18.1-3.9 30.7 17.6 18.4 31.5L451.1 394.3c-12.1 13.8-29.6 21.7-48 21.7H144c-26.5 0-48-21.5-48-48v-21.3l-67.5-30C11.2 309 0 291.8 0 272.8V208c0-26.5 21.5-48 48-48h176v-32h-32c-17.7 0-32-14.3-32-32s14.3-32 32-32h128c17.7 0 32 14.3 32 32zM48 208v64.8l48 21.3V208H48zm544 240c-26.5 0-48-21.5-48-48 0-21 20.6-62.6 34.9-88.8 5.8-10.6 20.5-10.6 26.3 0C619.4 337.4 640 379 640 400c0 32-21.5 48-48 48z"
        }
    ]
};

const FasOilCan = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasOilCan",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 128c17.7 0 32-14.3 32-32s-14.3-32-32-32H192c-17.7 0-32 14.3-32 32s14.3 32 32 32h32v32H48c-26.5 0-48 21.5-48 48v64.8c0 19 11.2 36.2 28.5 43.9l67.5 30V368c0 26.5 21.5 48 48 48h259.1c18.4 0 35.8-7.9 48-21.7l182.4-206.6c12.3-13.9-.3-35.4-18.4-31.5L448 192l-50.5-25.2c-8.9-4.4-18.7-6.8-28.6-6.8H288v-32h32zM96 208v86.1l-48-21.3V208h48z"
        }
    ]
};

const FasOilTemperature = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasOilTemperature",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32s-14.3 32-32 32h-32v32h32c17.7 0 32 14.3 32 32s-14.3 32-32 32h-32v70.7c28.3 12.3 48 40.5 48 73.3 0 44.2-35.8 80-80 80s-80-35.8-80-80c0-32.8 19.7-61 48-73.3V32zm144 272v-1.2c21.9-3.2 43.7-12.6 61.5-24.9 11.9-8.5 28.1-7.8 39.2 1.7 14.4 11.9 32.5 21 50.6 25.2 17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 357.7 417 368 384 368c-1.4 0-2.7 0-4-.1 12.6-18.1 20-40.2 20-63.9zm-208 64c-33 0-65.5-10.3-94.5-25.8-13.4 8.4-33.7 19.3-58.2 25-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2 11.1-9.5 27.3-10.1 39.2-1.7 17.8 12.3 39.6 21.7 61.4 24.9v1.2c0 23.8 7.4 45.8 20 63.9-1.3 0-2.7.1-4 .1zm192 80c26.9 0 55.4-10.8 77.4-26.1 11.9-8.5 28.1-7.8 39.2 1.7 14.4 11.9 32.5 21 50.6 25.2 17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25-29 15.6-61.5 25.9-94.5 25.9-31.9 0-60.6-9.9-80.4-18.9-5.8-2.7-11.1-5.3-15.6-7.7-4.5 2.4-9.7 5.1-15.6 7.7-19.8 9-48.5 18.9-80.4 18.9-33 0-65.5-10.3-94.5-25.8-13.4 8.4-33.7 19.3-58.2 25-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2 11.1-9.4 27.3-10.1 39.2-1.7 22.1 15.2 50.5 26 77.4 26 27.5 0 55-10.6 77.5-26.1 11.1-7.9 25.9-7.9 37 0 22.5 15.5 50 26.1 77.5 26.1z"
        }
    ]
};

const FasOilWell = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasOilWell",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M528.3 61.3c-11.4-42.7-55.3-68-98-56.6l-15.4 4.1C397.8 13.4 387.7 31 392.3 48l24.5 91.4-108.3 28.1-6.3-18.1c-4.5-12.8-16.6-21.4-30.2-21.4s-25.7 8.6-30.2 21.4l-13.6 39L96 222.6V184c0-13.3-10.7-24-24-24s-24 10.7-24 24v264H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h512c17.7 0 32-14.3 32-32s-14.3-32-32-32H406.7L340 257.5l-62.2 16.1 27.5 78.4h-66.6l26.3-75-74.6 19.3L137.3 448H96V288.8l337.4-87.5 25.2 94c4.6 17.1 22.1 27.2 39.2 22.6l15.5-4.1c42.7-11.4 68-55.3 56.6-98L528.3 61.3zM205.1 448l11.2-32h111.4l11.2 32H205.1z"
        }
    ]
};

const FasOliveBranch = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasOliveBranch",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M2.7 53.1C13.8 41.6 59 0 128 0c66.9 0 111.4 39.1 124.2 52L306 26.7C343.3 9.1 384 0 425.2 0H616c13.3 0 24 10.7 24 24s-10.7 24-24 24H425.2c-34.2 0-67.9 7.5-98.8 22.1l-134.5 63.3C189.1 219.3 118.6 288 32 288H16c-8.8 0-16-7.2-16-16v-16c0-61.4 34.5-114.6 85.2-141.5-44.8-11.7-73.9-38.7-82.5-47.6C.9 65 0 62.6 0 60s.9-5 2.7-6.9zM480 320c0 106-64.5 192-144 192s-144-86-144-192 64.5-192 144-192 144 86 144 192zm-14.3 151.8c29.2-40.5 46.3-94 46.3-151.8 0-59.3-18-114.2-48.6-155-10.5-14-22.7-26.5-36.2-36.9 48.2 1.6 101.3 25.8 144.2 70.3 75 77.8 90.2 188.1 33.9 246.4-34.1 35.4-86.8 43.5-139.6 27z"
        }
    ]
};

const FasOlive = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasOlive",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 480C71.6 480 0 408.4 0 320 0 128 181.9 32 280 32c56 0 112 56 112 56s56 56 56 112c0 98.1-96 280-288 280zm127.1-287.1c30.3 30.3 69.6 40.1 87.8 21.9s8.4-57.5-21.9-87.8-69.6-40.1-87.8-21.9-8.4 57.5 21.9 87.8z"
        }
    ]
};

const FasOm = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasOm",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M379.3 4.7c-6.2-6.2-16.4-6.2-22.6 0l-16 16c-6.2 6.2-6.2 16.4 0 22.6l16 16c6.2 6.2 16.4 6.2 22.6 0l16-16c6.2-6.2 6.2-16.4 0-22.6l-16-16zM115.2 169.6c8-6 17.9-9.6 28.8-9.6 26.5 0 48 21.5 48 48s-21.5 48-48 48h-34.2c-7.6 0-13.8 6.2-13.8 13.8 0 1.5.2 2.9.7 4.4l8 24c4.4 13.1 16.6 21.9 30.4 21.9H160c35.3 0 64 28.7 64 64s-28.7 64-64 64c-50.8 0-82.7-21.5-102.2-42.8-9.9-10.8-16.6-21.6-20.9-29.7-2.1-4-3.6-7.3-4.5-9.6-.5-1.1-.8-2-1-2.5l-.2-.5v-.1c-2.6-7.8-10.7-12.3-18.7-10.5C4.4 354.2-.9 361.8.1 370l15.9-2-15.9 2v.1l.1.4c0 .3.1.8.2 1.3.2 1.1.4 2.7.8 4.6.8 3.9 2 9.4 3.9 15.9 3.8 13 10.3 30.4 21.3 48C48.7 476.2 89.4 512 160 512c70.7 0 128-57.3 128-128 0-23.3-6.2-45.2-17.1-64h22.6c25.5 0 49.9-10.1 67.9-28.1l26.5-26.5c6-6 14.1-9.4 22.6-9.4h5.5c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32-25.7 0-41.4-12.5-51.2-25.6-5-6.7-8.4-13.4-10.5-18.6-1.1-2.5-1.8-4.6-2.2-6-.2-.7-.4-1.2-.5-1.5l-.1-.3c-1.9-7.3-8.6-12.4-16.2-12.1-7.6.3-13.9 5.9-15.1 13.4L336 368l-15.8-2.6v.1l-.1.3c0 .3-.1.6-.2 1.1-.1.9-.3 2.1-.4 3.6-.3 3-.6 7.3-.6 12.4 0 10.1 1.1 23.9 5.8 38.1 4.8 14.3 13.4 29.3 28.6 40.7 15.4 11.6 36 18.3 62.7 18.3 53 0 96-43 96-96v-96c0-53-43-96-96-96h-5.5c-25.5 0-49.9 10.1-67.9 28.1l-26.5 26.5c-6 6-14.1 9.4-22.6 9.4h-48.3c6.9-14.5 10.8-30.8 10.8-48 0-61.9-50.1-112-112-112-25.2 0-48.5 8.3-67.2 22.4-14.1 10.6-17 30.7-6.4 44.8s30.7 17 44.8 6.4zM280.9 66.7c-6-4-14-3.5-19.5 1.3s-7 12.7-3.7 19.2L272 80l-14.3 7.2v.1l.1.2.4.7c.3.6.8 1.4 1.4 2.4 1.2 2 2.9 4.8 5.1 8.2 4.4 6.7 11.1 15.5 20 24.4 17.7 17.9 45.6 36.8 83.3 36.8 31.2 0 56.6-10.4 73.9-20.2 8.7-5 15.6-9.9 20.4-13.8 2.4-1.9 4.3-3.6 5.7-4.9.7-.6 1.3-1.2 1.7-1.6l.6-.5.2-.2.1-.1L448 96.1l22.6 22.6c12.5-12.5 12.5-32.8 0-45.3-12.4-12.4-32.6-12.5-45.1-.2-.1.1-.2.2-.5.4-.5.5-1.5 1.3-2.8 2.4-2.7 2.2-6.8 5.2-12.1 8.2C399.4 90.4 384.8 96 368 96c-20.8 0-42.4-7-59.5-14.6-8.4-3.7-15.4-7.5-20.3-10.3-2.4-1.4-4.3-2.5-5.6-3.3-.6-.4-1.1-.7-1.4-.9l-.3-.2z"
        }
    ]
};

const FasOmega = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasOmega",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 96c-88.4 0-160 71.6-160 160 0 56.4 29.1 106 73.3 134.5 13.3 8.6 22.7 23.7 22.7 41.2 0 26.7-21.6 48.3-48.3 48.3H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h35.2C25.8 375.4 0 318.7 0 256 0 132.3 100.3 32 224 32s224 100.3 224 224c0 62.7-25.8 119.4-67.2 160H416c17.7 0 32 14.3 32 32s-14.3 32-32 32h-79.7c-26.7 0-48.3-21.6-48.3-48.3 0-17.5 9.4-32.6 22.7-41.2C354.9 362 384 312.4 384 256c0-88.4-71.6-160-160-160z"
        }
    ]
};

const FasOnion = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasOnion",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m216.8 17.7-3.4-6.8C210.1 4.2 203.3 0 195.8 0c-10.9 0-19.6 9-21.3 19.8C167 67.8 132 96.2 95.3 126 49 163.7 0 203.5 0 288c0 80.4 58 135.2 131.9 160.3l-10.7 32.1c-4.2 12.6 2.6 26.2 15.2 30.4s26.2-2.6 30.4-15.2l11.8-35.6c7.1 1.2 14.2 2.1 21.4 2.7V488c0 13.3 10.7 24 24 24s24-10.7 24-24v-25.3c7.2-.7 14.3-1.6 21.4-2.7l11.9 35.6c4.2 12.6 17.8 19.4 30.4 15.2s19.4-17.8 15.2-30.4l-10.7-32.1C390 423.2 448 368.4 448 288c0-84.5-49-124.3-95.3-162C316 96.2 281 67.8 273.5 19.8 271.8 9 263.1 0 252.2 0c-7.5 0-14.3 4.2-17.7 10.9l-3.4 6.8c-2.9 5.9-11.4 5.9-14.3 0zM97 186.2l.4-.9c.4-.8.8-1.5 1.2-2.2 2.5-3.8 6.6-6.4 11.3-6.9 1.9-.2 3.8-.1 5.6.3s3.6 1.2 5.2 2.2c3.9 2.6 6.4 6.8 7 11.2.3 1.9.2 3.9-.3 5.9-.3 1.3-.8 2.5-1.3 3.6l-.3.7c-.3.6-.8 1.6-1.4 2.9-1.2 2.6-2.9 6.4-4.9 11.2-4 9.6-9 23-13.3 38.2-8.8 31.3-13.5 67.1-3.4 94 3.1 8.3-1.1 17.5-9.4 20.6s-17.5-1.1-20.6-9.4c-13.9-37-6.6-81.3 2.6-114 4.7-16.7 10.2-31.4 14.5-41.8 2.2-5.2 4-9.4 5.4-12.3.7-1.5 1.2-2.6 1.6-3.4zm112-63.7c.3-.9.8-1.8 1.3-2.7 1.2-2.1 2.9-3.8 4.8-5 3.4-2.3 7.7-3.3 11.9-2.5 1.9.4 3.7 1 5.2 2 2 1.2 3.7 2.9 5 4.8s2.2 4.1 2.6 6.4c.3 1.8.3 3.7-.1 5.5-.2 1.1-.5 2.2-1 3.3v.1l-.5 1.3c-.4 1.1-1.1 2.8-1.9 5-1.6 4.4-4 10.9-6.6 18.9-5.4 16.2-12.2 38.7-18.1 64-11.9 51.7-18.9 111.9-4.4 155.3 2.8 8.4-1.7 17.4-10.1 20.2s-17.4-1.7-20.2-10.1c-17.5-52.5-8.5-120.3 3.6-172.7 6.1-26.6 13.3-50.1 18.9-67 2.8-8.4 5.2-15.2 7-19.9.9-2.4 1.6-4.2 2.1-5.4l.6-1.5.1-.1zm79 37.5c0-8.8 7.2-16 16-16h.6c5.8-.2 11.6 2.7 14.6 8.2l-1 .6 1-.5v.1l.2.3.6 1.1c.5.9 1.2 2.2 2.1 3.9 1.8 3.4 4.2 8.3 7.1 14.3 5.7 12.1 13.1 29.2 19.8 48.9 13.1 38.7 24.5 90.6 11.7 135.5-2.4 8.5-11.3 13.4-19.8 11s-13.4-11.3-11-19.8c10-35.1 1.4-79.2-11.2-116.5-6.2-18.3-13.1-34.2-18.4-45.6-2.7-5.7-4.9-10.2-6.5-13.2l-.1-.1c-3.5-2.9-5.7-7.3-5.7-12.2z"
        }
    ]
};

const FasOption = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasOption",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 448c-9.7 0-18.9-4.4-25-12L176.6 128H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h160c9.7 0 18.9 4.4 25 12l246.4 308H608c17.7 0 32 14.3 32 32s-14.3 32-32 32H448zm0-320c-17.7 0-32-14.3-32-32s14.3-32 32-32h160c17.7 0 32 14.3 32 32s-14.3 32-32 32H448z"
        }
    ]
};

const FasOrnament = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasOrnament",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm55.4 64c5.4-9.4 8.6-20.3 8.6-32 0-35.3-28.7-64-64-64s-64 28.7-64 64c0 11.7 3.1 22.6 8.6 32H128c-17.7 0-32 14.3-32 32v25.7c-29.1 16.8-53.5 41.2-70.3 70.3h332.6c-16.9-29.1-41.2-53.5-70.3-70.3V128c0-17.7-14.3-32-32-32h-8.6zM0 320c0 22.4 3.8 44 10.9 64h362.2c7.1-20 10.9-41.6 10.9-64s-3.8-44-10.9-64H10.9C3.8 276 0 297.6 0 320zm25.7 96c33.2 57.4 95.2 96 166.3 96s133.1-38.6 166.3-96H25.7z"
        }
    ]
};

const FasOtter = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasOtter",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m181.5 197.1 12.9 6.4c5.9 3 12.4 4.5 19.1 4.5 23.5 0 42.6-19.1 42.6-42.6V144c0-35.3-28.7-64-64-64H128c-35.3 0-64 28.7-64 64v21.4c0 23.5 19.1 42.6 42.6 42.6 6.6 0 13.1-1.5 19.1-4.5l12.9-6.4 8.4-4.2-11.9-7.9c-4.5-3-7.1-8-7.1-13.3V168c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24v3.7c0 5.3-2.7 10.3-7.1 13.3l-11.8 7.9 8.4 4.2zm-8.6 49.4L160 240l-12.9 6.4c-12.6 6.3-26.5 9.6-40.5 9.6-3.6 0-7.1-.2-10.6-.6v.6c0 35.3 28.7 64 64 64h64c17.7 0 32 14.3 32 32s-14.3 32-32 32h160v-64c0-23.7 12.9-44.4 32-55.4 9.4-5.4 20.3-8.6 32-8.6v-16c0-26.5 21.5-48 48-48 8.8 0 16 7.2 16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16v-99.7c0-48.2-30.8-91-76.6-106.3l-8.5-2.8c-8-2.7-12.6-11.1-10.4-19.3s10.3-13.2 18.6-11.6l19.9 4c89 17.8 153 95.9 153 186.6v1.1c0 123.7-100.3 224-224 224H255.4C132 480 32 380 32 256.6v-39.8c-10.1-14.6-16-32.3-16-51.4v-22.8C6.7 139.3 0 130.5 0 120c0-13.3 10.7-24 24-24h2.8c18-37.8 56.5-64 101.2-64h64c44.7 0 83.2 26.2 101.2 64h2.8c13.3 0 24 10.7 24 24 0 10.5-6.7 19.3-16 22.6v22.8c0 1.4 0 2.8-.1 4.3 12-6.2 25.7-9.6 40.1-9.6h8c17.7 0 32 14.3 32 32s-14.3 32-32 32h-8c-13.3 0-24 10.7-24 24v8h56.4c-15.2 17-24.4 39.4-24.4 64h-32c-42.3 0-78.2-27.4-91-65.3-5.1.9-10.3 1.3-15.6 1.3-14.1 0-27.9-3.3-40.5-9.6zM96 128a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm112 16a16 16 0 1 1 32 0 16 16 0 1 1-32 0z"
        }
    ]
};

const FasOutdent = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasOutdent",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 64c0-17.7 14.3-32 32-32h384c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64zm192 128c0-17.7 14.3-32 32-32h192c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32zm32 96h192c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32zM0 448c0-17.7 14.3-32 32-32h384c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zm.2-179.4c-8.2-6.4-8.2-18.9 0-25.3L102.1 164c10.5-8.2 25.8-.7 25.8 12.6v158.7c0 13.3-15.3 20.8-25.8 12.6L.2 268.6z"
        }
    ]
};

const FasOutlet = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasOutlet",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm0 224c0-61.1 30.8-99.1 49.7-116.6 8.8-8.2 20.7-11.4 32.6-11.4h155.3c12 0 23.9 3.3 32.6 11.4 19 17.5 49.8 55.5 49.8 116.6s-30.8 99-49.7 116.6c-8.8 8.2-20.7 11.4-32.6 11.4H146.4c-12 0-23.9-3.3-32.6-11.4C94.8 355 64 317.1 64 256zm96-64c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48c0-8.8-7.2-16-16-16zm128 0c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48c0-8.8-7.2-16-16-16zm-64 96c-13.3 0-24 10.7-24 24v16c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8v-16c0-13.3-10.7-24-24-24z"
        }
    ]
};

const FasOven = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasOven",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 96v64h448V96c0-53-43-96-96-96H96C43 0 0 43 0 96zm56-16a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm120-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 24a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm120-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm16 200v192H64V256h320zM64 192H0v256c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V192H64zm48 96c-8.8 0-16 7.2-16 16s7.2 16 16 16h224c8.8 0 16-7.2 16-16s-7.2-16-16-16H112z"
        }
    ]
};

const FasOverline = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasOverline",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 32C14.3 32 0 46.3 0 64s14.3 32 32 32h384c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zm192 96a176 176 0 1 0 0 352 176 176 0 1 0 0-352zm112 176a112 112 0 1 1-224 0 112 112 0 1 1 224 0z"
        }
    ]
};

const FasP = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasP",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 96c0-35.3 28.7-64 64-64h96c88.4 0 160 71.6 160 160s-71.6 160-160 160H64v96c0 17.7-14.3 32-32 32S0 465.7 0 448V96zm64 192h96c53 0 96-43 96-96s-43-96-96-96H64v192z"
        }
    ]
};

const FasPageCaretDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPageCaretDown",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 512c35.3 0 64-28.7 64-64V138.5c0-17-6.7-33.3-18.7-45.3l-74.6-74.5C278.7 6.7 262.5 0 245.5 0H64C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256zM192 352c-4.5 0-8.8-1.9-11.8-5.2l-75.7-82.6c-14.1-15.4-3.2-40.2 17.7-40.2h139.6c20.9 0 31.8 24.8 17.7 40.2l-75.7 82.6c-3 3.3-7.3 5.2-11.8 5.2z"
        }
    ]
};

const FasPageCaretUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPageCaretUp",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 512c35.3 0 64-28.7 64-64V138.5c0-17-6.7-33.3-18.7-45.3l-74.6-74.5C278.7 6.7 262.5 0 245.5 0H64C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256zM192 192c4.5 0 8.8 1.9 11.8 5.2l75.7 82.6c14.1 15.4 3.2 40.2-17.7 40.2H122.2c-20.9 0-31.8-24.8-17.7-40.2l75.7-82.6c3-3.3 7.3-5.2 11.8-5.2z"
        }
    ]
};

const FasPage = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPage",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 512h256c35.3 0 64-28.7 64-64V138.5c0-17-6.7-33.3-18.7-45.3l-74.6-74.5C278.7 6.7 262.5 0 245.5 0H64C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64z"
        }
    ]
};

const FasPager = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPager",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 128c0-35.3 28.7-64 64-64h384c35.3 0 64 28.7 64 64v256c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zm64 32v64c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32v-64c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32zm16 160c-13.3 0-24 10.7-24 24s10.7 24 24 24h56c13.3 0 24-10.7 24-24s-10.7-24-24-24H80zm136 0c-13.3 0-24 10.7-24 24s10.7 24 24 24h48c13.3 0 24-10.7 24-24s-10.7-24-24-24h-48z"
        }
    ]
};

const FasPaintRoller = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPaintRoller",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 64C0 28.7 28.7 0 64 0h288c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm160 288c0-17.7 14.3-32 32-32v-16c0-44.2 35.8-80 80-80h144c17.7 0 32-14.3 32-32V69.5c37.3 13.2 64 48.7 64 90.5v32c0 53-43 96-96 96H272c-8.8 0-16 7.2-16 16v16c17.7 0 32 14.3 32 32v128c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32V352z"
        }
    ]
};

const FasPaintbrushFine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPaintbrushFine",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M559.6 16.4c21.9 21.9 21.9 57.3 0 79.2L306.9 348.3l-79.2-79.2L480.4 16.4c21.9-21.9 57.3-21.9 79.2 0zM205.1 291.7l79.2 79.2-.1.1c2.5 9.3 3.8 19 3.8 29 0 61.9-50.1 112-112 112H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h4.8c17.6 0 29.6-18.9 27.8-36.4-.4-3.8-.6-7.7-.6-11.6 0-61.9 50.1-112 112-112 10 0 19.8 1.3 29 3.8l.1-.1z"
        }
    ]
};

const FasPaintbrushPencil = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPaintbrushPencil",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M559.6 95.6c21.9-21.9 21.9-57.3 0-79.2s-57.3-21.9-79.2 0L227.7 269.1l79.2 79.2L559.6 95.6zM205 291.8c-9.3-2.5-19-3.8-29-3.8-61.9 0-112 50.1-112 112 0 3.9.2 7.8.6 11.6 1.8 17.5-10.2 36.4-27.8 36.4H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h144c61.9 0 112-50.1 112-112 0-10-1.3-19.8-3.8-29l.1-.1-79.2-79.2-.1.1zm93.4-138.7L164.7 19.3c-25-25-65.5-25-90.5 0L50.7 42.7c-25 25-25 65.5 0 90.5L173.5 256h2.5c6.2 0 12.4.4 18.4 1.2l104.1-104.1zM320 402.5l64.6 64.6c6.7 6.7 15.1 11.6 24.2 14.2l104 29.7c8.4 2.4 17.4.1 23.6-6.1s8.5-15.2 6.1-23.6l-29.7-104c-2.6-9.2-7.5-17.5-14.2-24.2L423 277.5 318.8 381.6c.8 6 1.2 12.2 1.2 18.4v2.5z"
        }
    ]
};

const FasPaintbrush = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPaintbrush",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M339.3 367.1c27.3-3.9 51.9-19.4 67.2-42.9L568.2 74.1c12.6-19.5 9.4-45.3-7.6-61.2s-42.9-17.3-61.5-3.3L262.4 187.2c-24 18-38.2 46.1-38.4 76.1l115.3 103.8zm-19.6 25.4-116-104.4C143.9 290.3 96 339.6 96 400c0 3.9.2 7.8.6 11.6 1.8 17.5-10.2 36.4-27.8 36.4H64c-17.7 0-32 14.3-32 32s14.3 32 32 32h144c61.9 0 112-50.1 112-112 0-2.5-.1-5-.2-7.5z"
        }
    ]
};

const FasPalette = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPalette",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 256v2.7c-.4 36.5-33.6 61.3-70.1 61.3H344c-26.5 0-48 21.5-48 48 0 3.4.4 6.7 1 9.9 2.1 10.2 6.5 20 10.8 29.9 6.1 13.8 12.1 27.5 12.1 42 0 31.8-21.6 60.7-53.4 62-3.5.1-7 .2-10.6.2C114.6 512 0 397.4 0 256S114.6 0 256 0s256 114.6 256 256zm-384 32a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm0-96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160-96a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm96 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FasPalletBox = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPalletBox",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 0h80v112c0 5.9 3.2 11.3 8.5 14.1s11.5 2.5 16.4-.8L320 99.2l39.1 26.1c4.9 3.3 11.2 3.6 16.4.8s8.5-8.2 8.5-14.1V0h80c26.5 0 48 21.5 48 48v160c0 26.5-21.5 48-48 48H176c-26.5 0-48-21.5-48-48V48c0-26.5 21.5-48 48-48zM0 352c0-17.7 14.3-32 32-32h576c17.7 0 32 14.3 32 32s-14.3 32-32 32h-32v64h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h32v-64H32c-17.7 0-32-14.3-32-32zm128 96h160v-64H128v64zm224 0h160v-64H352v64z"
        }
    ]
};

const FasPalletBoxes = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPalletBoxes",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C64 14.3 78.3 0 96 0h192c17.7 0 32 14.3 32 32v192c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V32zm320 64c0-17.7 14.3-32 32-32h128c17.7 0 32 14.3 32 32v128c0 17.7-14.3 32-32 32H416c-17.7 0-32-14.3-32-32V96zM0 352c0-17.7 14.3-32 32-32h576c17.7 0 32 14.3 32 32s-14.3 32-32 32h-32v64h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h32v-64H32c-17.7 0-32-14.3-32-32zm128 96h160v-64H128v64zm224 0h160v-64H352v64z"
        }
    ]
};

const FasPallet = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPallet",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 320c-17.7 0-32 14.3-32 32s14.3 32 32 32h32v64H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h576c17.7 0 32-14.3 32-32s-14.3-32-32-32h-32v-64h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zm96 64h160v64H128v-64zm224 0h160v64H352v-64z"
        }
    ]
};

const FasPanFood = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPanFood",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm0-448c37.2 0 69.3 26.3 76.6 62.8l.6 3.2c1.4 7.3-4.1 14-11.5 14H254.3c-7.4 0-12.9-6.8-11.5-14l.6-3.2C250.7 90.3 282.8 64 320 64zm-89.9 121.9c7.8 7.8 7.8 20.5 0 28.3l-32 32c-7.8 7.8-20.5 7.8-28.3 0s-7.8-20.5 0-28.3l32-32c7.8-7.8 20.5-7.8 28.3 0zM296 224a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm120 136a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-188.7-75.3c2.1 2.1 3.5 4.6 4.2 7.3.4 1.7.8 3.4 1.1 5.1 1.1 5.4 2.1 11 5.9 14.7l3.4 3.4c3 3 7.1 4.7 11.3 4.7H280c30.9 0 56 25.1 56 56s-25.1 56-56 56-56-25.1-56-56v-26.6c0-4.2-1.7-8.3-4.7-11.3l-3.4-3.4c-3.8-3.8-9.3-4.8-14.7-5.9-1.7-.3-3.5-.7-5.1-1.1-2.7-.7-5.2-2.1-7.3-4.2-6.2-6.2-6.2-16.4 0-22.6l8-8 8-8c6.2-6.2 16.4-6.2 22.6 0zm228.5-100.5c4.5-4.5 11.9-4.5 16.4 0l2.8 2.8c13.4 13.4 21 31.6 21 50.6v4.8c0 18.7-8.5 36.4-23.1 48.1-10.9 8.7-24.5 13.5-38.5 13.5h-4.1c-19.4 0-38-7.7-51.8-21.4l-2.4-2.4c-4.5-4.5-4.5-11.9 0-16.4l79.6-79.6zM24 160c-13.3 0-24 10.7-24 24v144c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24zm616 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v144c0 13.3 10.7 24 24 24s24-10.7 24-24V184z"
        }
    ]
};

const FasPanFrying = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPanFrying",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 224c0 33.4-7.3 65.1-20.4 93.6l123.7 79.9c15.4 11.7 24.7 29.6 24.7 50.5 0 35.3-28.7 64-64 64-15.2 0-28.3-4.6-39.3-13.5L364.8 398.3C326.3 429.4 277.3 448 224 448 100.3 448 0 347.7 0 224S100.3 0 224 0s224 100.3 224 224zm-128.1-70c-21.2-5.4-50.6-22.6-65.8-38.4-24.5-25.5-65-26.3-90.5-1.8-11.6 11.2-18.1 25.6-19.4 40.5-2.2 24.7-9.2 56.2-21.5 77.6-22.1 38.3-9 87.2 29.3 109.3s87.2 9 109.3-29.3c9.4-16.3 33-30 51.6-32.6 10.2-1.4 20.3-5.4 29.2-12 28.4-21.1 34.3-61.1 13.3-89.5a63.69 63.69 0 0 0-35.5-23.9zM528 448a16 16 0 1 0-32 0 16 16 0 1 0 32 0zM224 176a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
        }
    ]
};

const FasPancakes = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPancakes",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 192c0-17.7 14.3-31.9 32-32.6C396.6 155 480 128.3 480 96c0-35.3-100.3-64-224-64S32 60.7 32 96c0 13.8 15.3 26.6 41.3 37 13.2 5.3 22.7 17.6 22.7 31.8V272c0 17.7 14.3 32 32 32s32-14.3 32-32V171.7c0-9.5 8.1-16.8 17.5-15.7 8.1.9 14.5 7.6 14.5 15.7V224c0 17.7 14.3 32 32 32s32-14.3 32-32v-32zM192 80c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16zM14.9 133C5.3 141.4 0 150.5 0 160c0 20.3 24.2 38.8 64 52.9v-48.1c0-.1-.1-.2-.2-.4-.4-.5-1.2-1.3-2.4-1.8-14.7-5.9-28.7-13.4-39.6-22.9-2.3-2-4.6-4.3-6.8-6.8zm271.2 106.5C413.3 234.8 512 201 512 160c0-9.5-5.3-18.6-14.9-27-4 4.5-8.5 8.4-12.7 11.5-13.4 10-30.9 17.8-49.8 24-38 12.5-89.1 20.5-145.3 22.8-.5 0-.9.2-1.2.5-.1.1-.1.2-.1.2v32c0 5.3-.7 10.5-1.9 15.5zM7.2 221.1C2.5 227.2 0 233.5 0 240c0 21 25.8 40 68 54.3-2.6-6.9-4-14.5-4-22.3v-25.3c-21.5-6.8-41.1-15.2-56.8-25.6zM256 320c141.4 0 256-35.8 256-80 0-6.5-2.5-12.8-7.2-18.9-16.1 10.6-36.2 19.1-58.3 26-47.8 14.9-111.2 24-180.2 24.8-11.3 10-26.1 16.1-42.4 16.1-11.8 0-22.9-3.2-32.4-8.8-1.6 14.1-7.8 26.9-17 36.7 25.6 2.7 52.9 4.1 81.4 4.1zm256 0c0-6.5-2.5-12.8-7.2-18.9-16.1 10.6-36.2 19.1-58.3 26C396.4 342.8 329 352 256 352s-140.4-9.2-190.6-24.9c-22-6.9-42.2-15.4-58.3-26C2.5 307.2 0 313.5 0 320c0 44.2 114.6 80 256 80s256-35.8 256-80zm0 80c0-6.5-2.5-12.8-7.2-18.9-16.1 10.6-36.2 19.1-58.3 26C396.4 422.8 329 432 256 432s-140.4-9.2-190.6-24.9c-22-6.9-42.2-15.4-58.3-26C2.5 387.2 0 393.5 0 400c0 44.2 114.6 80 256 80s256-35.8 256-80z"
        }
    ]
};

const FasPanelEws = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPanelEws",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 0C28.7 0 0 28.7 0 64v224h16c44.2 0 80 35.8 80 80v16c0 17.7 14.3 32 32 32s32-14.3 32-32v-32c-17.7 0-32-14.3-32-32v-32c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32v32c0 35.3-28.7 64-64 64s-64-28.7-64-64v-16c0-26.5-21.5-48-48-48H0v128c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm48 64h96c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16s7.2-16 16-16zm192 0h96c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-192 64h96c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16s7.2-16 16-16zm192 0h96c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16s7.2-16 16-16zm16 128h64c17.7 0 32 14.3 32 32v128c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32V288c0-17.7 14.3-32 32-32z"
        }
    ]
};

const FasPanelFire = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPanelFire",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v32.2c-12.6-1.2-25.5 2.7-35.5 11.7-9.9 8.9-19.4 18.1-28.5 27.5V128c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h241.5c-4.4 6.2-8.5 12.5-12.3 18.7-10.9 17.6-20.5 36.4-27.2 55.4-3-1.4-6.4-2.1-9.9-2.1-13.3 0-24 10.7-24 24s10.7 24 24 24h.2c-.1 2-.2 4.1-.2 6.1 0 49.3 18.6 95.2 49.6 129.9H64c-35.3 0-64-28.7-64-64V96zm120 224a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm72 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm261.5-180.4c19.7 17.8 38.2 37 55.5 57.7 7.9-9.9 16.8-20.7 26.5-29.5 5.6-5.1 14.4-5.1 20 0 24.7 22.7 45.6 52.7 60.4 81.1 14.5 28 24.2 58.8 24.2 79 0 87.8-71.3 159.8-160 159.8-89.7 0-160-72.1-160-159.8 0-26.4 12.7-60.7 32.4-92.6 20-32.4 48.1-66.1 81.4-95.8 2.8-2.5 6.4-3.8 10-3.7 3.5 0 7 1.3 9.8 3.8zM530 432.9c30-21 38-63 20-96-2-4-4-8-7-12l-36 42s-58-74-62-79c-30 37-45 58-45 82 0 49 36 78 81 78 18 0 34-5 49-15z"
        }
    ]
};

const FasPanorama = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPanorama",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M45.6 32C20.4 32 0 52.4 0 77.6v356.8C0 459.6 20.4 480 45.6 480c5.1 0 10-.8 14.7-2.4C74.6 472.8 177.6 440 320 440s245.4 32.8 259.6 37.6c4.7 1.6 9.7 2.4 14.7 2.4 25.2 0 45.6-20.4 45.6-45.6V77.6C640 52.4 619.6 32 594.4 32c-5 0-10 .8-14.7 2.4C565.4 39.2 462.4 72 320 72S74.6 39.2 60.4 34.4c-4.8-1.6-9.7-2.4-14.8-2.4zM96 160a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm272 0c7.9 0 15.4 3.9 19.8 10.5L512.3 353c5.4 8 5.6 18.4.4 26.5s-14.7 12.3-24.2 10.7C442.7 382.4 385.2 376 320 376c-65.6 0-123.4 6.5-169.3 14.4-9.8 1.7-19.7-2.9-24.7-11.5s-4.3-19.4 1.9-27.2l69.4-86.7c4.6-5.7 11.4-9 18.7-9s14.2 3.3 18.7 9l26.4 33.1 87-127.6c4.5-6.6 11.9-10.5 19.8-10.5z"
        }
    ]
};

const FasPaperPlaneTop = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPaperPlaneTop",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M49.9 27.8C15.1 12.7-19.2 50.1-1.2 83.5l69.3 128.7c4.4 8.3 12.6 13.8 21.9 15l176 22c3.4.4 6 3.3 6 6.7s-2.6 6.3-6 6.7l-176 22c-9.3 1.2-17.5 6.8-21.9 15L-1.2 428.5c-18 33.4 16.3 70.8 51.1 55.7l441.9-191.5c32.1-13.9 32.1-59.5 0-73.4L49.9 27.8z"
        }
    ]
};

const FasPaperPlane = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPaperPlane",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M498.1 5.6c10.1 7 15.4 19.1 13.5 31.2l-64 416c-1.5 9.7-7.4 18.2-16 23s-18.9 5.4-28 1.6L284 427.7l-68.5 74.1c-8.9 9.7-22.9 12.9-35.2 8.1S160 493.2 160 480v-83.6c0-4 1.5-7.8 4.2-10.7l167.6-182.9c5.8-6.3 5.6-16-.4-22s-15.7-6.4-22-.7L106 360.8l-88.3-44.2C7.1 311.3.3 300.7 0 288.9s5.9-22.8 16.1-28.7l448-256c10.7-6.1 23.9-5.5 34 1.4z"
        }
    ]
};

const FasPaperclipVertical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPaperclipVertical",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 128C32 57.3 89.3 0 160 0s128 57.3 128 128v192c0 44.2-35.8 80-80 80s-80-35.8-80-80V160c0-17.7 14.3-32 32-32s32 14.3 32 32v160c0 8.8 7.2 16 16 16s16-7.2 16-16V128c0-35.3-28.7-64-64-64s-64 28.7-64 64v208c0 61.9 50.1 112 112 112s112-50.1 112-112V160c0-17.7 14.3-32 32-32s32 14.3 32 32v176c0 97.2-78.8 176-176 176S32 433.2 32 336V128z"
        }
    ]
};

const FasPaperclip = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPaperclip",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M364.2 83.8c-24.4-24.4-64-24.4-88.4 0l-184 184c-42.1 42.1-42.1 110.3 0 152.4s110.3 42.1 152.4 0l152-152c10.9-10.9 28.7-10.9 39.6 0s10.9 28.7 0 39.6l-152 152c-64 64-167.6 64-231.6 0s-64-167.6 0-231.6l184-184c46.3-46.3 121.3-46.3 167.6 0s46.3 121.3 0 167.6l-176 176c-28.6 28.6-75 28.6-103.6 0s-28.6-75 0-103.6l144-144c10.9-10.9 28.7-10.9 39.6 0s10.9 28.7 0 39.6l-144 144c-6.7 6.7-6.7 17.7 0 24.4s17.7 6.7 24.4 0l176-176c24.4-24.4 24.4-64 0-88.4z"
        }
    ]
};

const FasParachuteBox = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasParachuteBox",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M383.5 192c.3-5.3.5-10.6.5-16 0-51-15.9-96-40.2-127.6C319.5 16.9 288.2 0 256 0s-63.5 16.9-87.8 48.4C143.9 80 128 125 128 176c0 5.4.2 10.7.5 16H240v128h-32c-7 0-13.7 1.5-19.7 4.2L68.2 192h28.3c-.3-5.3-.5-10.6-.5-16 0-64 22.2-121.2 57.1-159.3C62 49.3 18.6 122.6 4.2 173.6 1.5 183.1 9 192 18.9 192h6l140.3 154.3c-3.3 6.5-5.2 13.9-5.2 21.7v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48v-96c0-7.8-1.9-15.2-5.2-21.7L487.1 192h6c9.9 0 17.4-8.9 14.7-18.4-14.4-51-57.8-124.3-148.9-156.9C393.8 54.8 416 112.1 416 176c0 5.4-.2 10.7-.5 16h28.3L323.7 324.2c-6-2.7-12.7-4.2-19.7-4.2h-32V192h111.5z"
        }
    ]
};

const FasParagraphLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasParagraphLeft",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 64c17.7 0 32-14.3 32-32S337.7 0 320 0H144C82.1 0 32 50.1 32 112s50.1 112 112 112h16v64c0 17.7 14.3 32 32 32s32-14.3 32-32V64h32v224c0 17.7 14.3 32 32 32s32-14.3 32-32V64zM128 384v-46.4c0-9.7-7.9-17.6-17.6-17.6-4.2 0-8.2 1.5-11.3 4.2l-93 78.7c-3.9 3.2-6.1 8-6.1 13.1s2.2 9.9 6.1 13.2l93 78.7c3.2 2.7 7.2 4.2 11.3 4.2 9.7 0 17.6-7.9 17.6-17.6V448h224c17.7 0 32-14.3 32-32s-14.3-32-32-32H128z"
        }
    ]
};

const FasParagraph = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasParagraph",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 32h224c17.7 0 32 14.3 32 32s-14.3 32-32 32h-32v352c0 17.7-14.3 32-32 32s-32-14.3-32-32V96h-32v352c0 17.7-14.3 32-32 32s-32-14.3-32-32v-96h-32c-88.4 0-160-71.6-160-160S103.6 32 192 32z"
        }
    ]
};

const FasPartyBell = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPartyBell",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 224C0 100.3 100.3 0 224 0c35.3 0 68.9 8.2 98.7 22.8 19.2 9.5 29.3 28.9 29.3 47.9 0 14.5-5.7 28.3-16 38.5L109.2 336c-10.2 10.3-24.1 16-38.5 16-19 0-38.4-10.1-47.8-29.3C8.2 292.9 0 259.3 0 224zM480 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM352 448a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM96 480a32 32 0 1 1-64 0 32 32 0 1 1 64 0zm263-313c9.4-9.4 24.6-9.4 33.9 0l8.3 8.3c16.7 16.7 38.6 27.2 62.1 29.8l27.4 3c13.2 1.5 22.7 13.3 21.2 26.5s-13.3 22.7-26.5 21.2l-27.4-3c-34.3-3.8-66.3-19.2-90.7-43.6L359 201c-9.4-9.4-9.4-24.6 0-33.9zM201 359l8.3 8.2c24.4 24.4 39.8 56.4 43.6 90.7l3 27.4c1.5 13.2-8 25-21.2 26.5s-25-8-26.5-21.2l-3-27.4c-2.6-23.5-13.1-45.4-29.8-62.1L167 393c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0zm302.5 147.3c-10.1 8.6-25.3 7.3-33.8-2.8l-8.5-10a79.026 79.026 0 0 1-18.6-53c.5-16.6-12.4-30.6-29-31.6l-30-1.8c-42.5-2.5-75.3-38.3-74.2-80.8.2-7.6-2.4-15-7.3-20.7l-8.5-10c-8.6-10.1-7.3-25.3 2.8-33.8s25.3-7.3 33.8 2.8l8.5 10c12.5 14.8 19.1 33.7 18.6 53-.5 16.6 12.4 30.6 29 31.6l30 1.8c42.5 2.5 75.3 38.3 74.2 80.8-.2 7.6 2.4 15 7.3 20.7l8.5 10c8.6 10.1 7.3 25.3-2.8 33.8z"
        }
    ]
};

const FasPartyHorn = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPartyHorn",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 32a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm416 128a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm32 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM167 153c-9.4-9.4-9.4-24.6 0-33.9l8.3-8.3c16.7-16.7 27.2-38.6 29.8-62.1l3-27.4C209.6 8.2 221.5-1.3 234.7.1s22.7 13.3 21.2 26.5l-3 27.4c-3.8 34.3-19.2 66.3-43.6 90.7L201 153c-9.4 9.4-24.6 9.4-33.9 0zm192 158 8.2-8.3c24.4-24.4 56.4-39.8 90.7-43.6l27.4-3c13.2-1.5 25 8 26.5 21.2s-8 25-21.2 26.5l-27.4 3c-23.5 2.6-45.4 13.1-62.1 29.8L393 345c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9zM506.3 8.5c8.6 10.1 7.3 25.3-2.8 33.8l-10 8.5a79.026 79.026 0 0 1-53 18.6c-16.6-.4-30.6 12.4-31.6 29l-1.8 30c-2.5 42.5-38.3 75.3-80.8 74.2-7.6-.2-15 2.4-20.7 7.3l-10 8.5c-10.1 8.6-25.3 7.3-33.8-2.8s-7.3-25.3 2.8-33.8l10-8.5c14.8-12.5 33.7-19.1 53-18.6 16.6.4 30.6-12.4 31.6-29l1.8-30c2.5-42.5 38.3-75.3 80.8-74.2 7.6.2 15-2.4 20.7-7.3l10-8.5c10.1-8.6 25.3-7.3 33.8 2.8zM150.6 201.4l160 160c7.7 7.7 11 18.8 8.6 29.4s-9.9 19.4-20 23.2l-39.7 14.9L83.1 252.5 98 212.8c3.8-10.2 12.6-17.7 23.2-20s21.7 1 29.4 8.6zM48.2 345.6l22.6-60.2 155.8 155.8-60.2 22.6L48.2 345.6zm-12.3 32.9 97.6 97.6L43.2 510c-11.7 4.4-25 1.5-33.9-7.3S-2.4 480.5 2 468.8l33.8-90.3z"
        }
    ]
};

const FasPassport = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPassport",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 64C0 28.7 28.7 0 64 0h320c35.3 0 64 28.7 64 64v384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm183 214.8c-27.9-13.2-48.4-39.4-53.7-70.8h39.1c1.6 30.4 7.7 53.8 14.6 70.8zm41.3 9.2h-.6c-2.4-3.5-5.7-8.9-9.1-16.5-6-13.6-12.4-34.3-14.2-63.5h47.1c-1.8 29.2-8.1 49.9-14.2 63.5-3.4 7.6-6.7 13-9.1 16.5zm40.7-9.2c6.8-17.1 12.9-40.4 14.6-70.8h39.1c-5.3 31.4-25.8 57.6-53.7 70.8zM279.6 176c-1.6-30.4-7.7-53.8-14.6-70.8 27.9 13.2 48.4 39.4 53.7 70.8h-39.1zm-55.9-80h.6c2.4 3.5 5.7 8.9 9.1 16.5 6 13.6 12.4 34.3 14.2 63.5h-47.1c1.8-29.2 8.1-49.9 14.2-63.5 3.4-7.6 6.7-13 9.1-16.5zm-40.7 9.2c-6.8 17.1-12.9 40.4-14.6 70.8h-39.1c5.3-31.4 25.8-57.6 53.7-70.8zM352 192a128 128 0 1 0-256 0 128 128 0 1 0 256 0zM112 384c-8.8 0-16 7.2-16 16s7.2 16 16 16h224c8.8 0 16-7.2 16-16s-7.2-16-16-16H112z"
        }
    ]
};

const FasPaste = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPaste",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 0c-23.7 0-44.4 12.9-55.4 32H48C21.5 32 0 53.5 0 80v320c0 26.5 21.5 48 48 48h144V176c0-44.2 35.8-80 80-80h48V80c0-26.5-21.5-48-48-48h-56.6c-11-19.1-31.7-32-55.4-32zm112 128c-26.5 0-48 21.5-48 48v288c0 26.5 21.5 48 48 48h192c26.5 0 48-21.5 48-48V256h-96c-17.7 0-32-14.3-32-32v-96H272zM160 40a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm256 88v96h96l-96-96z"
        }
    ]
};

const FasPause = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPause",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 64C21.5 64 0 85.5 0 112v288c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48H48zm192 0c-26.5 0-48 21.5-48 48v288c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48h-32z"
        }
    ]
};

const FasPawClaws = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPawClaws",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M178.1 15.3c4.9-5.4 13.9-1.9 13.9 5.4v50.5c18.3 9.8 34.3 28.9 42.5 53.6 14.3 42.9-.3 86.2-32.6 96.8s-70.1-15.6-84.4-58.5c-4-11.9-5.7-23.9-5.5-35.2 0-25.7 9.6-50.6 26.9-69.6l39.2-43.1zm132 206.3c-32.3-10.6-46.9-53.9-32.6-96.8 8.2-24.7 24.2-43.8 42.5-53.6V20.7c0-7.3 9-10.8 13.9-5.4l39.2 43.1c17.3 19 26.9 43.9 26.9 69.6.2 11.3-1.5 23.2-5.5 35.1-14.3 42.9-52.1 69.1-84.4 58.5zm-209.7 8.9c18.9 32.4 14.3 70.1-10.2 84.1s-59.7-.9-78.5-33.3C3.7 267.8-.1 253.3 0 240v-3.2c0-13.5 4.3-26.7 12.2-37.6l37.3-51.3c4.6-6.3 14.5-3 14.5 4.7v44.2c13.9 6.1 27.1 17.8 36.4 33.7zM69.2 433.2C121.6 291.9 214.7 256 256 256s134.4 35.9 186.8 177.2c3.6 9.7 5.2 20.1 5.2 30.5v1.6c0 25.8-20.9 46.7-46.7 46.7-11.5 0-22.9-1.4-34-4.2l-88-22c-15.3-3.8-31.3-3.8-46.6 0l-88 22c-11.1 2.8-22.5 4.2-34 4.2-25.8 0-46.7-20.9-46.7-46.7v-1.6c0-10.4 1.6-20.7 5.2-30.5zm352.6-118.5c-24.5-14-29.1-51.7-10.2-84.1 9.3-15.9 22.4-27.6 36.4-33.7v-44.3c0-7.7 9.9-11 14.5-4.7l37.3 51.3c8 10.9 12.2 24.1 12.2 37.6v3.2c.1 13.3-3.7 27.8-11.6 41.4-18.9 32.4-54 47.3-78.5 33.3z"
        }
    ]
};

const FasPawSimple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPawSimple",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 80a48 48 0 1 1 96 0 48 48 0 1 1-96 0zm1.7 206c6.2-2.3 11.8-6.3 15-12.2l40-71.9c14.4-25.9 41.7-42 71.3-42s56.9 16.1 71.3 42l40 71.9c3.2 5.8 8.8 9.9 15 12.2 38.3 14 65.7 50.8 65.7 94 0 55.2-44.8 100-100 100-21.2 0-40.8-6.6-56.9-17.8-17.4-12-52.8-12-70.1 0-16.2 11.2-35.8 17.8-57 17.8-55.2 0-100-44.8-100-100 0-43.2 27.4-80 65.7-94zM304 32a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm48 160a48 48 0 1 1 96 0 48 48 0 1 1-96 0zM48 144a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
        }
    ]
};

const FasPaw = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPaw",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M226.5 92.9c14.3 42.9-.3 86.2-32.6 96.8s-70.1-15.6-84.4-58.5.3-86.2 32.6-96.8 70.1 15.6 84.4 58.5zM100.4 198.6c18.9 32.4 14.3 70.1-10.2 84.1s-59.7-.9-78.5-33.3-14.4-70.1 10.1-84.1 59.7.9 78.5 33.3zM69.2 401.2C121.6 259.9 214.7 224 256 224s134.4 35.9 186.8 177.2c3.6 9.7 5.2 20.1 5.2 30.5v1.6c0 25.8-20.9 46.7-46.7 46.7-11.5 0-22.9-1.4-34-4.2l-88-22c-15.3-3.8-31.3-3.8-46.6 0l-88 22c-11.1 2.8-22.5 4.2-34 4.2-25.8 0-46.7-20.9-46.7-46.7v-1.6c0-10.4 1.6-20.8 5.2-30.5zm352.6-118.5c-24.5-14-29.1-51.7-10.2-84.1s54-47.3 78.5-33.3 29.1 51.7 10.2 84.1-54 47.3-78.5 33.3zm-111.7-93c-32.3-10.6-46.9-53.9-32.6-96.8s52.1-69.1 84.4-58.5 46.9 53.9 32.6 96.8-52.1 69.1-84.4 58.5z"
        }
    ]
};

const FasPeace = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPeace",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 445.3V323.5l-94.3 77.1c26.1 22.8 58.5 38.7 94.3 44.7zM89.2 351.1 224 240.8V66.7C133.2 81.9 64 160.9 64 256c0 34.6 9.2 67.1 25.2 95.1zm293.1 49.5L288 323.5v121.8c35.7-6 68.1-21.9 94.3-44.7zm40.6-49.5c16-28 25.2-60.5 25.2-95.1 0-95.1-69.2-174.1-160-189.3v174.1l134.7 110.3zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0z"
        }
    ]
};

const FasPeach = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPeach",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M344 80c-31.5 0-61.4 7.3-88 20.4C229.4 87.3 199.5 80 168 80c-11.4 0-22.6 1-33.5 2.8C120.5 67.2 112 46.6 112 24c0-13.3 10.7-24 24-24h24c53 0 96 43 96 96 0-53 43-96 96-96h24c13.3 0 24 10.7 24 24 0 22.6-8.5 43.2-22.5 58.8C366.6 81 355.4 80 344 80zm-176 32c17.8 0 34.9 2.8 50.9 7.9 63 20 109.9 76.2 116.3 144.2.8 8.8 7.9 16 16.8 16s16.1-7.2 15.4-16c-4.6-58.2-34.2-109.5-78-143 .8-.2 1.5-.5 2.3-.7 16.5-5.4 34-8.3 52.3-8.3 92.8 0 168 75.2 168 168 0 136.2-199.3 214.6-240.6 229.4-5 1.8-10.1 2.6-15.4 2.6s-10.4-.8-15.4-2.6C199.3 494.6 0 416.2 0 280c0-92.8 75.2-168 168-168z"
        }
    ]
};

const FasPeanut = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPeanut",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M432 0h-68c-20.1 0-39.2 4-56.7 11.2-17.4 7.2-33.7 17.8-47.8 32l-.4.4C245 57.8 234.4 74 227.2 91.4c-4 9.5-6.9 19.6-8.8 30-4.8 24.5-12.6 49.1-30.3 66.7s-42.2 25.4-66.7 30.3c-10.4 1.9-20.5 4.9-30 8.8-17.5 7.2-33.9 17.9-48.1 32.1-14.2 14.2-24.9 30.5-32.1 48C4 324.8 0 343.9 0 364v68c0 44.2 35.8 80 80 80h68c40.5 0 77.1-16.2 103.8-42.5l1.7-1.7c13.8-14 24.2-30.1 31.3-47.2 4-9.5 6.9-19.6 8.8-30 4.8-24.5 12.6-49.1 30.3-66.7s42.2-25.4 66.7-30.3c10.4-1.9 20.5-4.9 30-8.8 17.3-7.2 33.5-17.7 47.6-31.7l.9-.9C495.6 225.4 512 188.6 512 148V80c0-44.2-35.8-80-80-80zm-35.2 128a19.2 19.2 0 1 1 38.4 0 19.2 19.2 0 1 1-38.4 0zm0 64a19.2 19.2 0 1 1 38.4 0 19.2 19.2 0 1 1-38.4 0zm-64 0a19.2 19.2 0 1 1 38.4 0 19.2 19.2 0 1 1-38.4 0zm-224 224a19.2 19.2 0 1 1 38.4 0 19.2 19.2 0 1 1-38.4 0zm83.2-19.2a19.2 19.2 0 1 1 0 38.4 19.2 19.2 0 1 1 0-38.4zm0-64a19.2 19.2 0 1 1 0 38.4 19.2 19.2 0 1 1 0-38.4z"
        }
    ]
};

const FasPeanuts = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPeanuts",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m299.2 38.9 22.6 50.7c-3.6 10.8-6.5 22.2-8.8 31.5-1.2 4.6-2.2 8.8-3.1 12.1-4.2 14.8-8.7 24.6-16.3 32.2s-17.4 12.1-32.2 16.3c-3.4 1-7.5 2-12.1 3.1-12.5 3.1-28.5 7.1-42 12.7-21.3 8.8-41.2 21.9-58.4 39.1C114.3 271.1 96 315.4 96 364v68c0 27.8 10.2 53.3 27 72.9l-3.2 1.4c-33.1 14.7-71.8-.2-86.6-33.2l-22.7-50.9C3.8 407.2.4 391.5 0 376c-.4-15.5 2.2-31.3 8-46.6 6-15.4 14.7-28.9 25.4-40.1 5.8-6.1 12.3-11.7 19.5-16.6 16.7-11.8 32.5-25.8 39.8-44.9s5-40.1.4-60c-2.1-8.4-3.2-17-3.4-25.4-.4-15.4 2.1-31.1 7.9-46.4l.2-.5c5.9-15.3 14.5-28.7 25.2-39.9s23.6-20.6 38.7-27.3l50.9-22.6c33.1-14.7 71.8.1 86.6 33.2zM492 0h68c44.2 0 80 35.8 80 80v68c0 40.6-16.4 77.4-42.9 104.2l-.9.9c-14.1 14-30.3 24.6-47.6 31.7-9.5 4-19.6 6.9-30 8.8-24.5 4.8-49.1 12.6-66.7 30.3s-25.4 42.2-30.3 66.7c-1.9 10.4-4.9 20.5-8.8 30-7.1 17.1-17.5 33.2-31.3 47.2l-1.7 1.7C353.1 495.8 316.5 512 276 512h-68c-44.2 0-80-35.8-80-80v-68c0-20.1 4-39.2 11.2-56.7 7.2-17.5 17.9-33.8 32.1-48 14.2-14.2 30.6-24.9 48.1-32.1 9.5-4 19.6-6.9 30-8.8 24.5-4.8 49.1-12.6 66.7-30.3s25.4-42.2 30.3-66.7c1.9-10.4 4.9-20.5 8.8-30 7.2-17.4 17.8-33.6 31.9-47.8l.4-.4c14.2-14.1 30.5-24.8 47.8-32C452.8 4 471.9 0 492 0zm52 147.2a19.2 19.2 0 1 0 0-38.4 19.2 19.2 0 1 0 0 38.4zm0 64a19.2 19.2 0 1 0 0-38.4 19.2 19.2 0 1 0 0 38.4zm-64 0a19.2 19.2 0 1 0 0-38.4 19.2 19.2 0 1 0 0 38.4zm-224 224a19.2 19.2 0 1 0 0-38.4 19.2 19.2 0 1 0 0 38.4zm83.2-19.2a19.2 19.2 0 1 0-38.4 0 19.2 19.2 0 1 0 38.4 0zm0-64a19.2 19.2 0 1 0-38.4 0 19.2 19.2 0 1 0 38.4 0z"
        }
    ]
};

const FasPeapod = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPeapod",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 0h-48C186.2 0 0 186.2 0 416v48c0 26.5 21.5 48 48 48h48c229.8 0 416-186.2 416-416V48c0-26.5-21.5-48-48-48zM256 200a56 56 0 1 1 0 112 56 56 0 1 1 0-112zM88 368a56 56 0 1 1 112 0 56 56 0 1 1-112 0zM368 88a56 56 0 1 1 0 112 56 56 0 1 1 0-112z"
        }
    ]
};

const FasPear = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPear",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M505 7c9.4 9.4 9.4 24.6 0 33.9l-47.1 47.2c14 20.5 22.1 45.3 22.1 71.9 0 30.7-10.8 58.9-28.9 81-29.9 36.5-61.4 81.8-73.3 127.4-8.3 32-25 62.3-50.1 87.3-75 75-196.5 75-271.5 0s-75-196.5 0-271.5c25.1-25.1 55.3-41.8 87.3-50.1 45.7-11.8 90.9-43.4 127.4-73.3 22.1-18 50.3-28.9 81-28.9 26.7 0 51.4 8.2 71.9 22.1L471 7c9.4-9.4 24.6-9.4 33.9 0zM320 320c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 53-43 96-96 96-8.8 0-16 7.2-16 16s7.2 16 16 16c70.7 0 128-57.3 128-128z"
        }
    ]
};

const FasPedestal = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPedestal",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 0C60.7 0 32 28.7 32 64v352h384V64c0-35.3-28.7-64-64-64H96zm24 64a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm184 24a24 24 0 1 1 48 0 24 24 0 1 1-48 0zM32 448c-17.7 0-32 14.3-32 32s14.3 32 32 32h384c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"
        }
    ]
};

const FasPegasus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPegasus",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 238.1V160h16l9.8 19.6c12.5 25.1 42.2 36.4 68.3 26 20.5-8.2 33.9-28 33.9-50.1V80c0-19.1-8.4-36.3-21.7-48h5.7c8.8 0 16-7.2 16-16s-7.2-16-16-16H448c-69.6 0-126.3 55.6-128 124.8L184.9 34.7c-4.9-3.3-11.2-3.6-16.4-.8S160 42.1 160 48c0 48.1 3.8 99.9 26 139.8 9.2 16.6 21.7 31.3 38.2 42.7-7.2-2.5-14-5.4-20.3-8.8-22.5-12.1-38.6-29.4-49.9-49.8-7.3-13.2-12.7-27.8-16.5-43-25.9 3.5-48.1 18.6-61.1 40C33.2 174.5 0 211.4 0 256v56c0 13.3 10.7 24 24 24s24-10.7 24-24v-56c0-13.4 6.6-25.2 16.7-32.5 1.6 13 6.3 25.4 13.6 36.4l28.2 42.4c8.3 12.4 6.4 28.7-1.2 41.6-16.5 28-20.6 62.2-10 93.9l17.5 52.4c4.4 13.1 16.6 21.9 30.4 21.9h33.7c21.8 0 37.3-21.4 30.4-42.1l-20.8-62.5c-2.1-6.4-.5-13.4 4.3-18.2l12.7-12.7c13.2-13.2 20.6-31.1 20.6-49.7 0-2.3-.1-4.6-.3-6.9l84 24c4.1 1.2 8.2 2.1 12.3 2.8V480c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V315.7c19.2-19.2 31.5-45.7 32-75.7v-1.9zM496 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
        }
    ]
};

const FasPenCircle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPenCircle",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm101.8-372.3 14.4 14.4c15.6 15.6 15.6 40.9 0 56.6l-21.4 21.4-71-71 21.4-21.4c15.6-15.6 40.9-15.6 56.6 0zM151.9 289l105.2-105.2 71 71-105.2 105.1c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9z"
        }
    ]
};

const FasPenClipSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPenClipSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L409.9 296l55-55 17-17-1-1-16-16-96-96-17-17-13-13c-28.1-28.1-73.7-28.1-101.8 0l-44.6 44.6L38.8 5.1zm191.7 150.3 40.5-40.5c9.4-9.4 24.6-9.4 33.9 0l13.2 13.1-53.8 53.8-33.7-26.4zm-67 127.1c-48 48-80.8 109.2-94.1 175.8l-5 25c-1.6 7.9.9 16 6.6 21.7s13.8 8.1 21.7 6.6l25-5c66.6-13.3 127.8-46.1 175.8-94.1l47.7-47.7-145.4-114.5-32.3 32.3zM517.3 19.3c-25-25-65.5-25-90.5 0l-52.2 52.1 17 17 96 96 16 16 1 1 52.1-52.1c25-25 25-65.5 0-90.5l-39.4-39.5z"
        }
    ]
};

const FasPenClip = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPenClip",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m453.3 19.3 39.4 39.4c25 25 25 65.5 0 90.5l-52.1 52.1-1-1-16-16-96-96-17-17 52.1-52.1c25-25 65.5-25 90.5 0zM241 114.9c-9.4-9.4-24.6-9.4-33.9 0L105 217c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L173.1 81c28.1-28.1 73.7-28.1 101.8 0L288 94.1l17 17 96 96 16 16 1 1-17 17-171.5 171.4c-48 48-109.2 80.8-175.8 94.1l-25 5c-7.9 1.6-16-.9-21.7-6.6s-8.1-13.8-6.6-21.7l5-25c13.3-66.6 46.1-127.8 94.1-175.8L254.1 128 241 114.9z"
        }
    ]
};

const FasPenFancySlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPenFancySlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L387.9 278.7l161-140.2c17.2-15 27.1-36.7 27.1-59.6 0-43.6-35.4-79-79-79-22.8 0-44.6 9.9-59.6 27.1L287.1 199.7 38.8 5.1zM318 346.5l-107-84.2-60.1 13.9c-17.1 3.9-30.7 16.9-35.4 33.8L65.7 487.6l95.4-95.4c-.7-2.6-1.1-5.4-1.1-8.3 0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32c-2.9 0-5.6-.4-8.3-1.1l-95.3 95.5L266 460.5c16.9-4.7 29.9-18.3 33.8-35.4l18.2-78.6z"
        }
    ]
};

const FasPenFancy = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPenFancy",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M373.5 27.1C388.5 9.9 410.2 0 433 0c43.6 0 79 35.4 79 79 0 22.8-9.9 44.6-27.1 59.6L277.7 319l-10.3-10.3-64-64-10.4-10.4L373.5 27.1zM170.3 256.9l10.4 10.4 64 64 10.4 10.4-19.2 83.4c-3.9 17.1-16.9 30.7-33.8 35.4L24.4 510.3l95.4-95.4c2.6.7 5.4 1.1 8.3 1.1 17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32c0 2.9.4 5.6 1.1 8.3L1.7 487.6 51.5 310c4.7-16.9 18.3-29.9 35.4-33.8l83.4-19.2z"
        }
    ]
};

const FasPenField = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPenField",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M601.9 16C583.1-2.8 552.7-2.7 534 16l-39.6 39.7 89.3 89.3 39.8-38.9c19.1-18.7 19.2-49.4.4-68.2l-22-21.9zM328.5 221.8c-7 7-12.3 15.6-15.4 25l-23.8 71.3c-2.9 8.6-.6 18.1 5.8 24.6s15.9 8.7 24.6 5.8l71.5-23.9c9.2-3.1 17.6-8.2 24.5-15l145.1-142.1-89.1-89.1-143.2 143.4zM80 128c-44.2 0-80 35.8-80 80v224c0 44.2 35.8 80 80 80h416c44.2 0 80-35.8 80-80V304c0-17.7-14.3-32-32-32s-32 14.3-32 32v128c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V208c0-8.8 7.2-16 16-16h192c17.7 0 32-14.3 32-32s-14.3-32-32-32H80zm80 192a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm64 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FasPenLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPenLine",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m453.3 19.3 39.4 39.4c25 25 25 65.5 0 90.5l-48.4 48.4-130-129.9 48.4-48.4c25-25 65.5-25 90.5 0zM58.6 323.5 291.7 90.3l130 130-233.2 233.1c-10.4 10.4-23.3 18-37.4 22.2L30.8 511c-8.4 2.5-17.5.2-23.7-6.1s-8.6-15.2-6.1-23.7l35.4-120.3c4.2-14.1 11.8-27 22.2-37.4zM248 464h304c13.3 0 24 10.7 24 24s-10.7 24-24 24H248c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
        }
    ]
};

const FasPenNibSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPenNibSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L450.3 327.6l28.3-94.4 2.8-9.2L352 94.6l-9.2 2.8-134.7 40.4L38.8 5.1zm29 440.7c-3.8 11.3-1 23.9 7.3 32.4l153.6-153.5c-3-6.3-4.7-13.3-4.7-20.7 0-9.4 2.7-18.2 7.4-25.7l-85-67-78.6 234.5zM272 352c-7.4 0-14.4-1.7-20.7-4.7L97.7 500.9c8.6 8.3 21.1 11.2 32.4 7.3l264.3-88.6c3.6-1.2 7.1-2.8 10.5-4.6l-98.5-77.6c-8.7 9-20.9 14.6-34.4 14.6zM432.4 18.3l-55.7 55.8 125.2 125.2 55.7-55.7c21.9-21.9 21.9-57.3 0-79.2l-46-46.1c-21.9-21.9-57.3-21.9-79.2 0z"
        }
    ]
};

const FasPenNib = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPenNib",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m368.4 18.3-55.7 55.8 125.2 125.2 55.7-55.7c21.9-21.9 21.9-57.3 0-79.2l-46-46.1c-21.9-21.9-57.3-21.9-79.2 0zM288 94.6l-9.2 2.8-144.1 43.2c-19.9 6-35.7 21.2-42.3 41L3.8 445.8c-3.8 11.3-1 23.9 7.3 32.4l153.6-153.5c-3-6.3-4.7-13.3-4.7-20.7 0-26.5 21.5-48 48-48s48 21.5 48 48-21.5 48-48 48c-7.4 0-14.4-1.7-20.7-4.7L33.7 500.9c8.6 8.3 21.1 11.2 32.4 7.3l264.3-88.6c19.7-6.6 35-22.4 41-42.3l43.2-144.1 2.8-9.2L288 94.6z"
        }
    ]
};

const FasPenPaintbrush = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPenPaintbrush",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m95.6 16.4 130.7 130.7-79.2 79.2L16.4 95.6c-21.9-21.9-21.9-57.3 0-79.2s57.3-21.9 79.2 0zM400 512c-53.6 0-98.5-37.7-109.4-88.1l133.3-133.3c50.3 11 88.1 55.8 88.1 109.4 0 3.9-.2 7.8-.6 11.6-1.8 17.5 10.2 36.4 27.8 36.4h4.8c17.7 0 32 14.3 32 32s-14.3 32-32 32H400zM501.3 19.3l23.4 23.4c25 25 25 65.5 0 90.5l-56.4 56.4-114-113.9 56.4-56.4c25-25 65.5-25 90.5 0zM76.9 353.2 331.7 98.3l114 114-254.9 254.8c-6.7 6.7-15.1 11.6-24.2 14.2L62.6 511c-8.4 2.4-17.4.1-23.6-6.1s-8.5-15.2-6.1-23.6l29.7-104c2.6-9.2 7.5-17.5 14.2-24.2z"
        }
    ]
};

const FasPenRuler = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPenRuler",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m469.3 19.3 23.4 23.4c25 25 25 65.5 0 90.5l-56.4 56.4-114-113.9 56.4-56.4c25-25 65.5-25 90.5 0zM44.9 353.2 299.7 98.3l114 114-254.9 254.8c-6.7 6.7-15.1 11.6-24.2 14.2L30.6 511c-8.4 2.4-17.4.1-23.6-6.1s-8.5-15.2-6.1-23.6l29.7-104c2.6-9.2 7.5-17.5 14.2-24.2zm204.5-249.8-146 146L16 161.9C-2.7 143.2-2.7 112.8 16 94l78.1-78c18.7-18.7 49.1-18.7 67.9 0l19.8 19.8c-.3.3-.7.6-1 .9l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64c.3-.3.6-.7.9-1l45.1 45.1zm159.2 159.2 45.1 45.1c-.3.3-.7.6-1 .9l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64c.3-.3.6-.7.9-1l19.8 19.9c18.7 18.7 18.7 49.1 0 67.9l-78.1 78c-18.7 18.7-49.1 18.7-67.9 0l-87.4-87.4 146-146z"
        }
    ]
};

const FasPenSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPenSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L409.9 296l75.7-75.7-129.9-130-91.5 91.5L38.8 5.1zm78 324.1c-6.6 6.6-11.5 14.8-14.1 23.8L65 481.2c-2.5 8.4-.2 17.5 6.1 23.7s15.3 8.5 23.7 6.1L223 473.3c9-2.6 17.2-7.5 23.8-14.1l94.4-94.4-145.4-114.5-79 79zM426.7 19.3l-48.4 48.4 130 130 48.4-48.4c25-25 25-65.5 0-90.5l-39.4-39.5c-25-25-65.5-25-90.5 0z"
        }
    ]
};

const FasPenSwirl = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPenSwirl",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M347.8 17C319.3 6 288.4 0 256 0 114.6 0 0 114.6 0 256s114.6 256 256 256c17.7 0 32-14.3 32-32s-14.3-32-32-32c-106 0-192-86-192-192S150 64 256 64c14.1 0 27.8 1.5 41 4.4L347.8 17zm-37.2 332.4c-5.4 5.3-11.4 9.8-17.8 13.6-1.7 2.7-3 5.7-3.8 9-4.4 17.1 5.9 34.6 23 39 12.8 3.3 26.2 5 40 5 88.4 0 160-71.6 160-160 0-32.2-5.9-63-16.8-91.3l-51.4 51.4c2.7 12.9 4.2 26.2 4.2 39.9 0 53-43 96-96 96-8.3 0-16.4-1.1-24-3-5.9-1.5-11.9-1.3-17.4.4zM473.9 16C455.1-2.8 424.7-2.7 406 16l-39.6 39.7 89.3 89.3 39.8-38.9c19.1-18.7 19.2-49.4.4-68.2l-22-21.9zM200.5 221.8c-7 7-12.3 15.6-15.4 25l-23.8 71.3c-2.9 8.6-.6 18.1 5.8 24.6s15.9 8.7 24.6 5.8l71.5-23.9c9.2-3.1 17.6-8.2 24.5-15l145.1-142.1-89.1-89.1-143.2 143.4z"
        }
    ]
};

const FasPenToSquare = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPenToSquare",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M471.6 21.7c-21.9-21.9-57.3-21.9-79.2 0l-30.1 30 97.9 97.9 30.1-30.1c21.9-21.9 21.9-57.3 0-79.2l-18.7-18.6zm-299.2 220c-6.1 6.1-10.8 13.6-13.5 21.9l-29.6 88.8c-2.9 8.6-.6 18.1 5.8 24.6s15.9 8.7 24.6 5.8l88.8-29.6c8.2-2.7 15.7-7.4 21.9-13.5l167.3-167.4-98-98-167.3 167.4zM96 64c-53 0-96 43-96 96v256c0 53 43 96 96 96h256c53 0 96-43 96-96v-96c0-17.7-14.3-32-32-32s-32 14.3-32 32v96c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H96z"
        }
    ]
};

const FasPen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPen",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m362.7 19.3-48.4 48.4 130 130 48.4-48.4c25-25 25-65.5 0-90.5l-39.4-39.5c-25-25-65.5-25-90.5 0zm-71 71L58.6 323.5c-10.4 10.4-18 23.3-22.2 37.4L1 481.2c-2.5 8.5-.2 17.6 6 23.8s15.3 8.5 23.7 6.1L151 475.7c14.1-4.2 27-11.8 37.4-22.2l233.3-233.2-130-130z"
        }
    ]
};

const FasPencilMechanical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPencilMechanical",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M475.3 11.3C468.1 4.1 458.2 0 448 0s-20.1 4.1-27.3 11.3l-30.1 30.1 80 80 30.1-30.1C507.9 84.1 512 74.2 512 64s-4.1-20.1-11.3-27.3l-25.4-25.4zm-233 76.3c3.1-3.1 8.2-3.1 11.3 0L283 117 72.8 327.2c-5.8 5.8-10 12.9-12.2 20.8l-27.8 97.3L7 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l25.7-25.7 97.4-27.8c7.8-2.2 15-6.4 20.8-12.2l251.9-251.9c7.2-7.2 11.3-17.1 11.3-27.3s-4.1-20.1-11.3-27.3l-57.4-57.4C372.1 68.1 362.2 64 352 64s-20.1 4.1-27.3 11.3L317 83l-29.4-29.3c-21.9-21.9-57.3-21.9-79.2 0L103 159c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L242.3 87.6zM89.1 422.9l17.3-60.5 43.2 43.2-60.5 17.3z"
        }
    ]
};

const FasPencilSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPencilSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L409.6 295.8l42.1-42.1 22.6-22.7 11.3-11.3-33.9-33.9-62.1-62.1-33.9-33.9-11.3 11.3-22.6 22.6-57.8 57.8L38.8 5.1zm267.4 209.6 50.5-50.5c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-47.8 47.8-25.4-19.9zM195.5 250l-72.9 72.9c-10.4 10.4-18 23.3-22.2 37.4L65 480.7c-2.5 8.4-.2 17.5 6.1 23.7s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2l88.3-88.3-77.9-61.4-27.6 27.6c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l24.9-24.9-42.1-33.3zM224 399.4l-9.1 22.7c-4 3.1-8.5 5.4-13.3 6.9l-78.1 23 23-78.1c1.4-4.9 3.8-9.4 6.9-13.3l22.7-9.1v32c0 8.8 7.2 16 16 16h32zM426.7 18.7l-14.4 14.5-22.6 22.6-11.4 11.3 33.9 33.9 62.1 62.1 33.9 33.9 11.3-11.3 22.6-22.6 14.5-14.5c25-25 25-65.5 0-90.5l-39.3-39.4c-25-25-65.5-25-90.5 0z"
        }
    ]
};

const FasPencil = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPencil",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m410.3 231 11.3-11.3-33.9-33.9-62.1-62.1-33.9-33.9-11.3 11.3-22.6 22.6L58.6 322.9c-10.4 10.4-18 23.3-22.2 37.4L1 480.7c-2.5 8.4-.2 17.5 6.1 23.7s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2l199.2-199.2 22.6-22.7zM160 399.4l-9.1 22.7c-4 3.1-8.5 5.4-13.3 6.9l-78.2 23 23-78.1c1.4-4.9 3.8-9.4 6.9-13.3l22.7-9.1v32c0 8.8 7.2 16 16 16h32zM362.7 18.7l-14.4 14.5-22.6 22.6-11.4 11.3 33.9 33.9 62.1 62.1 33.9 33.9 11.3-11.3 22.6-22.6 14.5-14.5c25-25 25-65.5 0-90.5l-39.3-39.4c-25-25-65.5-25-90.5 0zm-47.4 168-144 144c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l144-144c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
        }
    ]
};

const FasPeopleArrows = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPeopleArrows",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64a64 64 0 1 1 128 0 64 64 0 1 1-128 0zM25.9 233.4C29.3 191.9 64 160 105.6 160h44.8c27 0 51 13.4 65.5 34.1-2.7 1.9-5.2 4-7.5 6.3l-64 64c-21.9 21.9-21.9 57.3 0 79.2l47.6 47.6V464c0 26.5-21.5 48-48 48h-32c-26.5 0-48-21.5-48-48V348.3c-26.5-9.5-44.7-35.8-42.2-65.6l4.1-49.3zM448 64a64 64 0 1 1 128 0 64 64 0 1 1-128 0zm-16.4 136.4c-2.3-2.3-4.9-4.4-7.5-6.3 14.5-20.7 38.6-34.1 65.5-34.1h44.8c41.6 0 76.3 31.9 79.7 73.4l4.1 49.3c2.5 29.8-15.7 56.1-42.2 65.6V464c0 26.5-21.5 48-48 48h-32c-26.5 0-48-21.5-48-48v-72.8l47.6-47.6c21.9-21.9 21.9-57.3 0-79.2l-64-64zM272 240v32h96v-32c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2l64 64c9.4 9.4 9.4 24.6 0 33.9l-64 64c-6.9 6.9-17.2 8.9-26.2 5.2S368 377.6 368 367.9V336h-96v32c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-64-64c-9.4-9.4-9.4-24.6 0-33.9l64-64c6.9-6.9 17.2-8.9 26.2-5.2s14.8 12.5 14.8 22.2z"
        }
    ]
};

const FasPeopleCarryBox = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPeopleCarryBox",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 48a48 48 0 1 1 96 0 48 48 0 1 1-96 0zm64 193.7v65.1l51 51c7.1 7.1 11.8 16.2 13.4 26.1l15.2 90.9c2.9 17.4-8.9 33.9-26.3 36.8s-33.9-8.9-36.8-26.3l-14.3-85.9L66.8 320c-12-12-18.8-28.3-18.8-45.3v-88.1c0-32.4 26.2-58.6 58.6-58.6 24.1 0 46.5 12 59.9 32l47.4 71.1 10.1 5V160c0-17.7 14.3-32 32-32h128c17.7 0 32 14.3 32 32v76.2l10.1-5 47.4-71.2c13.3-20 35.8-32 59.9-32 32.4 0 58.6 26.2 58.6 58.6v88.1c0 17-6.7 33.3-18.7 45.3l-79.4 79.4-14.3 85.9c-2.9 17.4-19.4 29.2-36.8 26.3s-29.2-19.4-26.3-36.8l15.2-90.9c1.6-9.9 6.3-19 13.4-26.1l51-51v-65.1l-19 28.5c-4.6 7-11 12.6-18.5 16.3L399 316.3c-2.4 1.3-4.9 2.2-7.6 2.8-2.6.6-5.3.9-7.9.8H256.7c-2.5.1-5-.2-7.5-.7-2.9-.6-5.6-1.6-8.1-3l-59.5-29.8c-7.5-3.7-13.8-9.4-18.5-16.3l-19-28.5zM2.3 468.1l47.8-119.5 49.2 49.2-37.6 94c-6.6 16.4-25.2 24.4-41.6 17.8s-24.4-25.1-17.8-41.5zM512 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm77.9 348.6 47.8 119.5c6.6 16.4-1.4 35-17.8 41.6s-35-1.4-41.6-17.8l-37.6-94 49.2-49.2z"
        }
    ]
};

const FasPeopleDressSimple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPeopleDressSimple",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 128a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-15.7 32c-28.6 0-53.7 18.9-61.5 46.4L11.7 343.2C5.8 363.7 21.2 384 42.4 384H64v80c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48v-80h21.6c21.3 0 36.6-20.3 30.8-40.8l-39.1-136.8c-7.9-27.5-33-46.4-61.5-46.4h-31.5zM384 128a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-15.7 32c-28.6 0-53.7 18.9-61.5 46.4l-39.1 136.8c-5.8 20.4 9.5 40.8 30.8 40.8H320v80c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48v-80h21.6c21.3 0 36.6-20.3 30.8-40.8l-39.1-136.8c-7.8-27.5-33-46.4-61.5-46.4h-31.5z"
        }
    ]
};

const FasPeopleDress = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPeopleDress",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M208 48a48 48 0 1 0-96 0 48 48 0 1 0 96 0zM70.2 384H88v96c0 17.7 14.3 32 32 32s32-14.3 32-32v-96h16v96c0 17.7 14.3 32 32 32s32-14.3 32-32v-96h17.8c10.9 0 18.6-10.7 15.2-21.1l-38.3-114.8 33.9 56.3c9.1 15.1 28.8 20 43.9 10.9 9.8-5.9 15.3-16.2 15.5-26.9.2 10.7 5.7 21 15.5 26.9 15.1 9.1 34.8 4.2 43.9-10.9l33.9-56.3L375 362.9c-3.5 10.4 4.3 21.1 15.2 21.1H408v96c0 17.7 14.3 32 32 32s32-14.3 32-32v-96h16v96c0 17.7 14.3 32 32 32s32-14.3 32-32v-96h17.8c10.9 0 18.6-10.7 15.2-21.1l-38.3-114.8 33.9 56.3c9.1 15.1 28.8 20 43.9 10.9s20-28.8 10.9-43.9l-53.6-89.2c-20.2-33.7-56.7-54.3-96-54.3h-11.6c-39.3 0-75.7 20.6-96 54.3l-53.6 89.2c-3 5-4.5 10.5-4.6 15.9-.1-5.4-1.6-10.9-4.6-15.9l-53.6-89.2c-20.3-33.7-56.7-54.3-96-54.3h-11.6c-39.3 0-75.7 20.6-96 54.3L4.6 271.5c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9l33.9-56.3L55 362.9c-3.4 10.4 4.3 21.1 15.2 21.1zM528 48a48 48 0 1 0-96 0 48 48 0 1 0 96 0z"
        }
    ]
};

const FasPeopleGroup = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPeopleGroup",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M72 88a56 56 0 1 1 112 0 56 56 0 1 1-112 0zm-8 157.7c-10 11.2-16 26.1-16 42.3s6 31.1 16 42.3v-84.6zm144.4-49.3C178.7 222.7 160 261.2 160 304c0 34.3 12 65.8 32 90.5V416c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32v-26.8C26.2 371.2 0 332.7 0 288c0-61.9 50.1-112 112-112h32c24 0 46.2 7.5 64.4 20.3zM448 416v-21.5c20-24.7 32-56.2 32-90.5 0-42.8-18.7-81.3-48.4-107.7C449.8 183.5 472 176 496 176h32c61.9 0 112 50.1 112 112 0 44.7-26.2 83.2-64 101.2V416c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32zm8-328a56 56 0 1 1 112 0 56 56 0 1 1-112 0zm120 157.7v84.7c10-11.3 16-26.1 16-42.3s-6-31.1-16-42.3zM320 32a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm-80 272c0 16.2 6 31 16 42.3v-84.6c-10 11.3-16 26.1-16 42.3zm144-42.3v84.7c10-11.3 16-26.1 16-42.3s-6-31.1-16-42.3zm64 42.3c0 44.7-26.2 83.2-64 101.2V448c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32v-42.8c-37.8-18-64-56.5-64-101.2 0-61.9 50.1-112 112-112h32c61.9 0 112 50.1 112 112z"
        }
    ]
};

const FasPeopleLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPeopleLine",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M360 72a40 40 0 1 0-80 0 40 40 0 1 0 80 0zM144 208a40 40 0 1 0 0-80 40 40 0 1 0 0 80zM32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32h576c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zm464-208a40 40 0 1 0 0-80 40 40 0 1 0 0 80zM200 313.5l26.9 49.9c6.3 11.7 20.8 16 32.5 9.8s16-20.8 9.8-32.5l-36.3-67.5c1.7-1.7 3.2-3.6 4.3-5.8l26.8-49.9V272c0 17.7 14.3 32 32 32h48c17.7 0 32-14.3 32-32v-54.5l26.9 49.9c1.2 2.2 2.6 4.1 4.3 5.8l-36.3 67.5c-6.3 11.7-1.9 26.2 9.8 32.5s26.2 1.9 32.5-9.8l26.8-49.9V352c0 17.7 14.3 32 32 32h48c17.7 0 32-14.3 32-32v-38.5l26.9 49.9c6.3 11.7 20.8 16 32.5 9.8s16-20.8 9.8-32.5l-37.9-70.3c-15.3-28.5-45.1-46.3-77.5-46.3h-19.6c-16.3 0-31.9 4.5-45.4 12.6l-33.6-62.3c-15.3-28.5-45.1-46.3-77.5-46.3h-19.5c-32.4 0-62.1 17.8-77.5 46.3l-33.6 62.3c-13.5-8.1-29.1-12.6-45.4-12.6h-19.5c-32.4 0-62.1 17.8-77.5 46.3l-37.8 70.2c-6.3 11.7-1.9 26.2 9.8 32.5s26.2 1.9 32.5-9.8L88 313.5V352c0 17.7 14.3 32 32 32h48c17.7 0 32-14.3 32-32v-38.5z"
        }
    ]
};

const FasPeoplePantsSimple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPeoplePantsSimple",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 128a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-22.4 32c-41.6 0-76.3 31.9-79.7 73.4l-4.1 49.3c-2.5 29.8 15.7 56.1 42.2 65.6V464c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V348.3c26.5-9.5 44.7-35.8 42.2-65.6l-4.1-49.3c-3.4-41.5-38.1-73.4-79.7-73.4h-44.8zM384 128a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-22.4 32c-41.6 0-76.3 31.9-79.7 73.4l-4.1 49.3c-2.5 29.8 15.7 56.1 42.2 65.6V464c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V348.3c26.5-9.5 44.7-35.8 42.2-65.6l-4.1-49.3c-3.4-41.5-38.1-73.4-79.7-73.4h-44.8z"
        }
    ]
};

const FasPeoplePants = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPeoplePants",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-8 384V352h16v128c0 17.7 14.3 32 32 32s32-14.3 32-32V256.9l28.6 47.5c9.1 15.1 28.8 20 43.9 10.9 9.8-5.9 15.3-16.2 15.5-26.9.2 10.7 5.7 21 15.5 26.9 15.1 9.1 34.8 4.2 43.9-10.9l28.6-47.5V480c0 17.7 14.3 32 32 32s32-14.3 32-32V352h16v128c0 17.7 14.3 32 32 32s32-14.3 32-32V256.9l28.6 47.5c9.1 15.1 28.8 20 43.9 10.9s20-28.8 10.9-43.9l-58.3-97c-17.4-28.9-48.6-46.6-82.3-46.6h-29.7c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-3 5-4.5 10.5-4.6 15.9-.1-5.4-1.6-10.9-4.6-15.9l-58.3-97c-17.4-28.9-48.6-46.6-82.3-46.6h-29.6c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9L88 256.9V480c0 17.7 14.3 32 32 32s32-14.3 32-32zM480 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
        }
    ]
};

const FasPeoplePulling = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPeoplePulling",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-16 32c-35.3 0-64 28.7-64 64v128c0 17.7 14.3 32 32 32 9.8 0 18.5-4.4 24.4-11.2l24 144.5c2.9 17.4 19.4 29.2 36.8 26.3s29.2-19.4 26.3-36.8L123.1 352h15.7l30 134.9c3.8 17.3 20.9 28.1 38.2 24.3s28.1-20.9 24.3-38.2L174 215l116.3 53.8c.5.3 1.1.5 1.6.7 8.6 3.6 18 3.1 25.9-.7 3.4-1.6 6.6-3.9 9.3-6.7 3.1-3.2 5.5-7 7.1-11.4.1-.3.2-.7.3-1l2.5-7.5c5.7-17.1 18.3-30.9 34.7-38.2l8-3.5c1-.4 1.9-.8 2.9-1.2l-16.9 63.5c-5.6 21.1-.1 43.6 14.7 59.7l70.7 77.1 22 88.1c4.3 17.1 21.7 27.6 38.8 23.3s27.6-21.7 23.3-38.8l-23-92.1c-1.9-7.8-5.8-14.9-11.2-20.8l-49.5-54 19.3-65.5 9.6 23c4.4 10.6 12.5 19.3 22.8 24.5l26.7 13.3c15.8 7.9 35 1.5 42.9-14.3s1.5-35-14.3-42.9L537 232.7l-15.3-36.8c-17.2-41.1-57.4-67.9-102-67.9-22.8 0-45.3 4.8-66.1 14l-8 3.5a128.9 128.9 0 0 0-58.1 51.6l-130.2-60.2c-12.6-5.9-26.4-8.9-40.3-8.9H64zm400-32a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM349.7 335.6l-25 62.4-59.4 59.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l61.7-61.7c4.6-4.6 8.2-10.1 10.6-16.1l14.5-36.2-40.7-44.4c-2.5-2.7-4.8-5.6-7-8.6z"
        }
    ]
};

const FasPeopleRobbery = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPeopleRobbery",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M488.2 59.1C478.1 99.6 441.7 128 400 128s-78.1-28.4-88.2-68.9L303 24.2C298.8 7.1 281.4-3.3 264.2 1S236.7 22.6 241 39.8l8.7 34.9c11 44 40.2 79.6 78.3 99.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32V352h16v128c0 17.7 14.3 32 32 32s32-14.3 32-32V174.3c38.1-20 67.3-55.6 78.3-99.6l8.7-34.9c4.3-17.1-6.1-34.5-23.3-38.8S501.2 7.1 497 24.2l-8.7 34.9zM400 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM80 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-8 32c-35.3 0-64 28.7-64 64v288c0 17.7 14.3 32 32 32s32-14.3 32-32V352h16v128c0 17.7 14.3 32 32 32s32-14.3 32-32V252.7l13 20.5c5.9 9.2 16.1 14.9 27 14.9h48c17.7 0 32-14.3 32-32s-14.3-32-32-32h-30.4l-37.4-58.9C157.6 142 132.1 128 104.7 128H72z"
        }
    ]
};

const FasPeopleRoof = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPeopleRoof",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m335.5 4 288 160c15.4 8.6 21 28.1 12.4 43.5s-28.1 21-43.5 12.4L320 68.6 47.5 220c-15.4 8.6-34.9 3-43.5-12.4s-3-34.9 12.4-43.5L304.5 4c9.7-5.4 21.4-5.4 31.1 0zM320 160a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm-176 96a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm312 40a40 40 0 1 1 80 0 40 40 0 1 1-80 0zM226.9 491.4 200 441.5V480c0 17.7-14.3 32-32 32h-48c-17.7 0-32-14.3-32-32v-38.5l-26.9 49.9c-6.3 11.7-20.8 16-32.5 9.8s-16-20.8-9.8-32.5l37.9-70.3c15.3-28.5 45.1-46.3 77.5-46.3h19.5c16.3 0 31.9 4.5 45.4 12.6l33.6-62.3c15.3-28.5 45.1-46.3 77.5-46.3h19.5c32.4 0 62.1 17.8 77.5 46.3l33.6 62.3c13.5-8.1 29.1-12.6 45.4-12.6h19.5c32.4 0 62.1 17.8 77.5 46.3l37.9 70.3c6.3 11.7 1.9 26.2-9.8 32.5s-26.2 1.9-32.5-9.8L552 441.5V480c0 17.7-14.3 32-32 32h-48c-17.7 0-32-14.3-32-32v-38.5l-26.9 49.9c-6.3 11.7-20.8 16-32.5 9.8s-16-20.8-9.8-32.5l36.3-67.5c-1.7-1.7-3.2-3.6-4.3-5.8L376 345.5V400c0 17.7-14.3 32-32 32h-48c-17.7 0-32-14.3-32-32v-54.5l-26.9 49.9c-1.2 2.2-2.6 4.1-4.3 5.8l36.3 67.5c6.3 11.7 1.9 26.2-9.8 32.5s-26.2 1.9-32.5-9.8z"
        }
    ]
};

const FasPeopleSimple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPeopleSimple",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 128a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-22.4 32c-41.6 0-76.3 31.9-79.7 73.4l-4.1 49.3c-2.5 29.8 15.7 56.1 42.2 65.6V464c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V348.3c26.5-9.5 44.7-35.8 42.2-65.6l-4.1-49.3c-3.4-41.5-38.1-73.4-79.7-73.4h-44.8zM384 128a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-15.7 32c-28.6 0-53.7 18.9-61.5 46.4l-39.1 136.8c-5.8 20.4 9.5 40.8 30.8 40.8H320v80c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48v-80h21.6c21.3 0 36.6-20.3 30.8-40.8l-39.1-136.8c-7.9-27.5-33-46.4-61.5-46.4h-31.5z"
        }
    ]
};

const FasPeople = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPeople",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-8 384V352h16v128c0 17.7 14.3 32 32 32s32-14.3 32-32V256.9l28.6 47.5c9.1 15.1 28.8 20 43.9 10.9 9.8-5.9 15.3-16.2 15.5-26.9.2 10.7 5.7 21 15.5 26.9 15.1 9.1 34.8 4.2 43.9-10.9l33.9-56.3L375 362.9c-3.5 10.4 4.3 21.1 15.2 21.1H408v96c0 17.7 14.3 32 32 32s32-14.3 32-32v-96h16v96c0 17.7 14.3 32 32 32s32-14.3 32-32v-96h17.8c10.9 0 18.6-10.7 15.2-21.1l-38.3-114.8 33.9 56.3c9.1 15.1 28.8 20 43.9 10.9s20-28.8 10.9-43.9l-53.6-89.2c-20.2-33.7-56.7-54.3-96-54.3h-11.6c-39.3 0-75.7 20.6-96 54.3l-53.6 89.2c-3 5-4.5 10.5-4.6 15.9-.1-5.4-1.6-10.9-4.6-15.9l-58.3-97c-17.4-28.9-48.6-46.6-82.3-46.6h-29.7c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9L88 256.9V480c0 17.7 14.3 32 32 32s32-14.3 32-32zM528 48a48 48 0 1 0-96 0 48 48 0 1 0 96 0z"
        }
    ]
};

const FasPepperHot = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPepperHot",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M428.3 3c11.6-6.4 26.2-2.3 32.6 9.3l4.8 8.7c19.3 34.7 19.8 75.7 3.4 110 26.7 28.6 42.9 66.9 42.9 109 0 18.5-3.1 36.3-8.9 52.8-6.1 17.3-28.5 16.3-36.8-.1l-11.7-23.4c-4.1-8.1-12.4-13.3-21.5-13.3H360c-13.3 0-24-10.7-24-24v-80c0-13.3-10.7-24-24-24h-17.1c-21.3 0-30-23.9-10.8-32.9C304.7 85.4 327.7 80 352 80c28.3 0 54.8 7.3 77.8 20.2 5.5-18.2 3.7-38.4-6-55.8l-4.8-8.7c-6.4-11.6-2.3-26.2 9.3-32.6zM171.2 345.5 264 160h40v80c0 26.5 21.5 48 48 48h76.2l23.9 47.8C372.3 443.9 244.3 512 103.2 512H44.4C19.9 512 0 492.1 0 467.6c0-20.8 14.5-38.8 34.8-43.3l49.8-11.1c37.6-8.4 69.5-33.2 86.7-67.7z"
        }
    ]
};

const FasPepper = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPepper",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M252.6 11.7C245.8.3 231-3.4 219.7 3.4s-15.1 21.6-8.2 32.9l10.3 17.2c6.7 11.2 10.3 24 10.3 37v10.9c-5.6-2-11.5-3.5-17.4-4.4l-1.1-.2c-8.1-1.2-16.4-1.3-24.9-.3-4 .5-7.9 1.2-11.9 2.2-51.4 12.9-74.7 65-61.9 116.4L152 363.4c2.1 8.6-3.1 17.3-11.6 19.4s-17.3-3.1-19.4-11.6L83.8 223c-11.8-47 .4-94.4 31.3-125.2-13.6-2.8-28-2.6-42.4 1-51.4 12.9-82.7 65-69.8 116.5l56 224c12.9 51.4 65 82.7 116.4 69.8 7-1.7 13.6-4.2 19.8-7.3 5.6-2.8 12.3-2.8 17.9 0 3 1.5 6 2.8 9.2 4 10.7 4 22.2 6.2 34 6.2 11.6 0 22.9-2.1 33.5-6.1 3.2-1.2 6.4-2.6 9.4-4.1 5.6-2.8 12.3-2.8 17.9 0 6.2 3.1 12.8 5.6 19.8 7.3 51.4 12.9 103.6-18.4 116.4-69.8l56-224c12.9-51.4-18.4-103.6-69.8-116.4-23.2-5.8-46.5-2.6-66.3 7.3-5.6 2.8-12.3 2.8-17.9 0-6.2-3.1-12.8-5.6-19.8-7.3-19-4.8-38.1-3.5-55.3 2.6V90.6c0-21.7-5.9-43.1-17.1-61.7l-10.4-17.2z"
        }
    ]
};

const FasPercent = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPercent",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M374.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-320 320c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l320-320zM128 128a64 64 0 1 0-128 0 64 64 0 1 0 128 0zm256 256a64 64 0 1 0-128 0 64 64 0 1 0 128 0z"
        }
    ]
};

const FasPeriod = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPeriod",
    "viewBox": "0 0 128 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 416a64 64 0 1 1 128 0 64 64 0 1 1-128 0z"
        }
    ]
};

const FasPersonArrowDownToLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPersonArrowDownToLine",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-8 352v-96h16v96h-16zm-64 0H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h576c17.7 0 32-14.3 32-32s-14.3-32-32-32H264V256.9l28.6 47.5c9.1 15.1 28.8 20 43.9 10.9s20-28.8 10.9-43.9l-58.3-97c-17.4-28.9-48.6-46.6-82.3-46.6h-29.7c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9l28.7-47.5V448zM464 64v242.7l-25.4-25.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l80 80c12.5 12.5 32.8 12.5 45.3 0l80-80c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L528 306.7V64c0-17.7-14.3-32-32-32s-32 14.3-32 32z"
        }
    ]
};

const FasPersonArrowUpFromLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPersonArrowUpFromLine",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-8 352v-96h16v96h-16zm-64 0H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h576c17.7 0 32-14.3 32-32s-14.3-32-32-32H264V256.9l28.6 47.5c9.1 15.1 28.8 20 43.9 10.9s20-28.8 10.9-43.9l-58.3-97c-17.4-28.9-48.6-46.6-82.3-46.6h-29.7c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9l28.7-47.5V448zm478.6-326.6-80-80c-12.5-12.5-32.8-12.5-45.3 0l-80 80c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l25.4-25.4V384c0 17.7 14.3 32 32 32s32-14.3 32-32V141.3l25.4 25.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3z"
        }
    ]
};

const FasPersonBikingMountain = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPersonBikingMountain",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 48a48 48 0 1 0-96 0 48 48 0 1 0 96 0zm-20.8 112-61.8-48.8c-17.3-13.6-41.7-13.8-59.1-.3l-83.1 64.2c-30.7 23.8-28.5 70.8 4.3 91.6l60.5 38.4V416c0 17.7 14.3 32 32 32s32-14.3 32-32V288c0-10.7-5.3-20.7-14.2-26.6L295 232.9l60.3-48.5L396 217c5.7 4.5 12.7 7 20 7h64c17.7 0 32-14.3 32-32s-14.3-32-32-32h-52.8zm-238.8 6.7 102.4-76.8c7.2-5.4 8.5-15.7 2.9-22.8l-14.9-18.7c-21.6-27-60.7-32-88.4-11.2l-65.2 48.9c-7.2 5.4-8.5 15.7-2.9 22.8l44 55c5.4 6.7 15.2 8 22.1 2.8zM120 256c-12.1 0-22.1 8.9-23.8 20.6-7.6 2.2-14.9 5.3-21.7 9-9.4-7.1-22.8-6.3-31.3 2.3l-11.4 11.2c-8.6 8.6-9.3 21.9-2.3 31.3-3.7 6.9-6.8 14.1-9 21.8C8.9 353.9 0 363.9 0 376v16c0 12.1 8.9 22.1 20.6 23.8 2.2 7.6 5.3 14.9 9 21.8-7 9.4-6.3 22.8 2.3 31.3l11.3 11.3c8.6 8.6 21.9 9.3 31.3 2.2 6.8 3.7 14.1 6.8 21.7 9 1.7 11.7 11.7 20.6 23.8 20.6h16c12.1 0 22.1-8.9 23.8-20.6 7.6-2.2 14.9-5.3 21.7-9 9.4 7 22.8 6.3 31.3-2.2l11.3-11.3c8.6-8.6 9.3-21.9 2.3-31.3 3.7-6.8 6.8-14.1 9-21.7 11.6-1.7 20.6-11.7 20.6-23.8V376c0-12.1-8.9-22.1-20.6-23.8-2.2-7.6-5.3-14.9-9-21.7 7-9.4 6.3-22.8-2.3-31.3l-11.3-11.3c-8.6-8.6-21.9-9.3-31.3-2.3-6.8-3.7-14.1-6.8-21.7-9-1.7-11.7-11.7-20.6-23.8-20.6h-16zm8 64a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm352.2-43.4c-7.6 2.2-14.9 5.3-21.7 9-9.4-7.1-22.8-6.3-31.3 2.3l-11.3 11.3c-8.6 8.6-9.3 21.9-2.2 31.3-3.7 6.9-6.8 14.1-9 21.8-11.8 1.6-20.7 11.6-20.7 23.7v16c0 12.1 8.9 22.1 20.6 23.8 2.2 7.6 5.3 14.9 9 21.8-7 9.4-6.3 22.8 2.2 31.3l11.3 11.3c8.5 8.6 21.9 9.3 31.3 2.2 6.8 3.7 14.1 6.8 21.7 9 1.7 11.6 11.7 20.6 23.8 20.6h16c12.1 0 22.1-8.9 23.8-20.6 7.6-2.2 14.9-5.3 21.8-9 9.4 7 22.8 6.3 31.3-2.2l11.3-11.3c8.6-8.6 9.3-21.9 2.2-31.3 3.7-6.8 6.8-14.1 9-21.7 11.6-1.7 20.6-11.7 20.6-23.8V376c0-12.1-8.9-22.1-20.6-23.8-2.2-7.6-5.3-14.9-9-21.7 7-9.4 6.3-22.8-2.2-31.3l-11.3-11.3c-8.6-8.6-21.9-9.3-31.3-2.3-6.9-3.7-14.1-6.8-21.8-9-1.6-11.7-11.6-20.6-23.7-20.6h-16c-12.1 0-22.1 8.9-23.8 20.6zM448 384a64 64 0 1 1 128 0 64 64 0 1 1-128 0z"
        }
    ]
};

const FasPersonBiking = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPersonBiking",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M400 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm27.2 64-61.8-48.8c-17.3-13.6-41.7-13.8-59.1-.3l-83.1 64.2c-30.7 23.8-28.5 70.8 4.3 91.6l60.5 38.4V416c0 17.7 14.3 32 32 32s32-14.3 32-32V288c0-10.7-5.3-20.7-14.2-26.6L295 232.9l60.3-48.5L396 217c5.7 4.5 12.7 7 20 7h64c17.7 0 32-14.3 32-32s-14.3-32-32-32h-52.8zM56 384a72 72 0 1 1 144 0 72 72 0 1 1-144 0zm200 0a128 128 0 1 0-256 0 128 128 0 1 0 256 0zm184 0a72 72 0 1 1 144 0 72 72 0 1 1-144 0zm200 0a128 128 0 1 0-256 0 128 128 0 1 0 256 0z"
        }
    ]
};

const FasPersonBooth = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPersonBooth",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32c0-17.7-14.3-32-32-32s-32 14.3-32 32v160h64V32zm320 0c0-17.7-14.3-32-32-32s-32 14.3-32 32v448c0 17.7 14.3 32 32 32s32-14.3 32-32V32zM224 512c17.7 0 32-14.3 32-32V320h-64v160c0 17.7 14.3 32 32 32zM320 0c-9.3 0-18.1 4-24.2 11s-8.8 16.3-7.5 25.5l31.2 218.6-30.9 154.6c-3.5 17.3 7.8 34.2 25.1 37.7s34.2-7.8 37.7-25.1l.7-3.6c1.3 16.4 15.1 29.4 31.9 29.4 17.7 0 32-14.3 32-32 0 17.7 14.3 32 32 32s32-14.3 32-32V32c0-17.7-14.3-32-32-32H320zM112 80a48 48 0 1 0-96 0 48 48 0 1 0 96 0zm0 261.3v-72l4.7 4.7c9 9 21.2 14.1 33.9 14.1H224c17.7 0 32-14.3 32-32s-14.3-32-32-32h-66.7l-41.6-41.6c-14.3-14.3-33.8-22.4-54-22.4C27.6 160 0 187.6 0 221.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32v-96l32 42.7V480c0 17.7 14.3 32 32 32s32-14.3 32-32v-58.7c0-10.4-3.4-20.5-9.6-28.8L112 341.3z"
        }
    ]
};

const FasPersonBreastfeeding = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPersonBreastfeeding",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 0a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm212.8 382.8L373.5 462c-16.6 20.7-46.8 24.1-67.5 7.5-17.6-14.1-22.7-38.1-13.5-57.7l-.8-.1c-38.9-5.6-74.3-25.1-99.7-54.8V320c0-17.7-14.3-32-32-32s-32 14.3-32 32v48c0 .8 0 1.6.1 2.4l101.4 50.7c23.7 11.9 33.3 40.7 21.5 64.4s-40.7 33.3-64.4 21.5L27.2 427.3c-1.1-.5-2.2-1.1-3.3-1.7-4.9-2.8-9.2-6.4-12.6-10.6-4.6-5.4-7.8-11.7-9.6-18.4-3.3-12-1.9-25.2 4.8-36.6.6-1.1 1.3-2.2 2-3.2l67.1-100.7C102.3 216 147.3 192 195.4 192h75.2c46.5 0 90.1 22.5 117.2 60.3l50.7 70.9c2.2 3 4 6.1 5.5 9.4 2.9 6.7 4.3 13.8 4 20.8-.3 10.6-4.2 21-11.2 29.4zM320 332a44 44 0 1 0-88 0 44 44 0 1 0 88 0z"
        }
    ]
};

const FasPersonBurst = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPersonBurst",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-8 384V352h16v128c0 17.7 14.3 32 32 32s32-14.3 32-32V256.9l28.6 47.5c9.1 15.1 28.8 20 43.9 10.9s20-28.8 10.9-43.9l-58.3-97c-17.4-28.9-48.6-46.6-82.3-46.6h-29.7c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9l28.7-47.5V480c0 17.7 14.3 32 32 32s32-14.3 32-32zM190.9 18.1C188.4 12 182.6 8 176 8s-12.4 4-14.9 10.1l-29.4 74-76.1-23.2c-6.3-1.9-13.1.2-17.2 5.3S33.8 86.4 37 92.1l39.5 69.1-65.6 45.2c-5.4 3.7-8 10.3-6.5 16.7s6.7 11.2 13.1 12.2l78.7 12.2-5.6 79.5c-.5 6.5 3.1 12.7 9 15.5s12.9 1.8 17.8-2.6l58.6-53.8 58.6 53.9c4.8 4.4 11.9 5.5 17.8 2.6s9.5-9 9-15.5l-5.6-79.4 50.5-7.8 24.4-40.5-55.2-38L315 92.2c3.3-5.7 2.7-12.8-1.4-17.9s-10.9-7.2-17.2-5.3l-76.1 23.1-29.4-74z"
        }
    ]
};

const FasPersonCane = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPersonCane",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M272 48a48 48 0 1 0-96 0 48 48 0 1 0 96 0zm-8 187.3 47.4 57.1c11.3 13.6 31.5 15.5 45.1 4.2s15.5-31.5 4.2-45.1L287 162.6c-18.2-22-45.3-34.7-73.9-34.7h-36c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9l28.7-47.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32V352h16v128c0 17.7 14.3 32 32 32s32-14.3 32-32V235.3zM352 376c0-4.4 3.6-8 8-8s8 3.6 8 8v112c0 13.3 10.7 24 24 24s24-10.7 24-24V376c0-30.9-25.1-56-56-56s-56 25.1-56 56v8c0 13.3 10.7 24 24 24s24-10.7 24-24v-8z"
        }
    ]
};

const FasPersonCarryBox = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPersonCarryBox",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm16 210.7v-65l16.6 24.9c8.9 13.4 23.9 21.4 39.9 21.4H352c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H224c-17.7 0-32 14.3-32 32v96h-30.9l-42.6-64c-13.3-20-35.8-32-59.9-32C26.2 128 0 154.2 0 186.6v88.1c0 17 6.7 33.3 18.7 45.3l79.4 79.4 14.3 85.9c2.9 17.4 19.4 29.2 36.8 26.3s29.2-19.4 26.3-36.8l-15.2-90.9c-1.6-9.9-6.3-19-13.4-26.1l-51-51zM0 346.5V480c0 17.7 14.3 32 32 32s32-14.3 32-32v-69.5l-64-64z"
        }
    ]
};

const FasPersonChalkboard = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPersonChalkboard",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-8 384V352h16v128c0 17.7 14.3 32 32 32s32-14.3 32-32V192h136c17.7 0 32-14.3 32-32s-14.3-32-32-32h-16V64h192v192H384v-32h-64v48c0 26.5 21.5 48 48 48h224c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H368c-26.5 0-48 21.5-48 48v80H177.1c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9l28.7-47.7V480c0 17.7 14.3 32 32 32s32-14.3 32-32z"
        }
    ]
};

const FasPersonCircleCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPersonCircleCheck",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M112 48a48 48 0 1 1 96 0 48 48 0 1 1-96 0zm40 304v128c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9l-28.6 47.6c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6h29.7c33.7 0 64.9 17.7 82.3 46.6l44.9 74.7c-16.1 17.6-28.6 38.5-36.6 61.5-1.9-1.8-3.5-3.9-4.9-6.3L232 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352h-16zm136 16a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L416 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"
        }
    ]
};

const FasPersonCircleExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPersonCircleExclamation",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M112 48a48 48 0 1 1 96 0 48 48 0 1 1-96 0zm40 304v128c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9l-28.6 47.6c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6h29.7c33.7 0 64.9 17.7 82.3 46.6l44.9 74.7c-16.1 17.6-28.6 38.5-36.6 61.5-1.9-1.8-3.5-3.9-4.9-6.3L232 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352h-16zm280-128a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-192c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16v-80c0-8.8-7.2-16-16-16z"
        }
    ]
};

const FasPersonCircleMinus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPersonCircleMinus",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M112 48a48 48 0 1 1 96 0 48 48 0 1 1-96 0zm40 304v128c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9l-28.6 47.6c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6h29.7c33.7 0 64.9 17.7 82.3 46.6l44.9 74.7c-16.1 17.6-28.6 38.5-36.6 61.5-1.9-1.8-3.5-3.9-4.9-6.3L232 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352h-16zm136 16a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm224 0c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16s7.2 16 16 16h128c8.8 0 16-7.2 16-16z"
        }
    ]
};

const FasPersonCirclePlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPersonCirclePlus",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M112 48a48 48 0 1 1 96 0 48 48 0 1 1-96 0zm40 304v128c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9l-28.6 47.6c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6h29.7c33.7 0 64.9 17.7 82.3 46.6l44.9 74.7c-16.1 17.6-28.6 38.5-36.6 61.5-1.9-1.8-3.5-3.9-4.9-6.3L232 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352h-16zm280-128a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48h-48c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48h48c8.8 0 16-7.2 16-16s-7.2-16-16-16h-48v-48z"
        }
    ]
};

const FasPersonCircleQuestion = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPersonCircleQuestion",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M112 48a48 48 0 1 1 96 0 48 48 0 1 1-96 0zm40 304v128c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9l-28.6 47.6c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6h29.7c33.7 0 64.9 17.7 82.3 46.6l44.9 74.7c-16.1 17.6-28.6 38.5-36.6 61.5-1.9-1.8-3.5-3.9-4.9-6.3L232 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352h-16zm280-128a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-64-142.4v6.4c0 8.8 7.2 16 16 16s16-7.2 16-16v-6.4c0-5.3 4.3-9.6 9.6-9.6h40.5c7.7 0 13.9 6.2 13.9 13.9 0 5.2-2.9 9.9-7.4 12.3l-32 16.8c-5.3 2.8-8.6 8.2-8.6 14.2V384c0 8.8 7.2 16 16 16s16-7.2 16-16v-5.1l23.5-12.3C486.6 358.7 496 343 496 326c0-25.4-20.6-45.9-45.9-45.9h-40.5c-23 0-41.6 18.6-41.6 41.6z"
        }
    ]
};

const FasPersonCircleXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPersonCircleXmark",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M112 48a48 48 0 1 1 96 0 48 48 0 1 1-96 0zm40 304v128c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9l-28.6 47.6c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6h29.7c33.7 0 64.9 17.7 82.3 46.6l44.9 74.7c-16.1 17.6-28.6 38.5-36.6 61.5-1.9-1.8-3.5-3.9-4.9-6.3L232 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352h-16zm280-128a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm59.3 107.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L432 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l36.7 36.7-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l36.7-36.7 36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L454.6 368l36.7-36.7z"
        }
    ]
};

const FasPersonDigging = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPersonDigging",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M208 64a48 48 0 1 1 96 0 48 48 0 1 1-96 0zM9.8 214.8c5.1-12.2 19.1-18 31.4-12.9l19.5 8.1 22.9-38.1C99.9 144.6 129.3 128 161 128c51.4 0 97 32.9 113.3 81.7l34.6 103.7 79.3 33.1 34.2-45.6c6.4-8.5 16.6-13.3 27.2-12.8s20.3 6.4 25.8 15.5l96 160c5.9 9.9 6.1 22.2.4 32.2S555.5 512 544 512H288c-11.1 0-21.4-5.7-27.2-15.2s-6.4-21.2-1.4-31.1l16-32c5.4-10.8 16.5-17.7 28.6-17.7h32l22.5-30L22.8 246.2c-12.2-5.1-18-19.1-12.9-31.4zm82.8 91.8 112 48c11.8 5 19.4 16.6 19.4 29.4v96c0 17.7-14.3 32-32 32s-32-14.3-32-32v-74.9l-60.6-26-37 111c-5.6 16.8-23.7 25.8-40.5 20.2s-25.8-23.7-20.3-40.4l48-144 11-33 32 13.7z"
        }
    ]
};

const FasPersonDollyEmpty = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPersonDollyEmpty",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm16 210.7v-65l16.6 24.9c8.9 13.4 23.9 21.4 39.9 21.4h70.7l27.1 108.3c-16 11.6-26.3 30.5-26.3 51.7 0 35.3 28.7 64 64 64 32.3 0 59.1-24 63.4-55.1l134.4-33.6c12.9-3.2 20.7-16.2 17.5-29.1s-16.2-20.7-29.1-17.5l-134.5 33.6c-10-13.7-25.3-23.3-42.8-25.7l-49.6-198.4c-3.2-12.9-16.2-20.7-29.1-17.5s-20.7 16.2-17.5 29.1l6.5 26.2h-46.1l-42.6-64c-13.3-20-35.8-32-59.9-32C26.2 128 0 154.2 0 186.6v88.1c0 17 6.7 33.3 18.7 45.3l79.4 79.4 14.3 85.9c2.9 17.4 19.4 29.2 36.8 26.3s29.2-19.4 26.3-36.8l-15.2-90.9c-1.6-9.9-6.3-19-13.4-26.1l-51-51zM0 346.5V480c0 17.7 14.3 32 32 32s32-14.3 32-32v-69.5l-64-64zM272 448a16 16 0 1 1 32 0 16 16 0 1 1-32 0z"
        }
    ]
};

const FasPersonDolly = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPersonDolly",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 48a48 48 0 1 1 96 0 48 48 0 1 1-96 0zm64 193.7v65.1l51 51c7.1 7.1 11.8 16.2 13.4 26.1l15.2 90.9c2.9 17.4-8.9 33.9-26.3 36.8s-33.9-8.9-36.8-26.3l-14.4-85.9L18.7 320C6.7 308 0 291.7 0 274.7v-88.1C0 154.2 26.2 128 58.6 128c24.1 0 46.5 12 59.9 32l42.6 64h46.1l-6.5-26.2c-3.2-12.9 4.6-25.9 17.5-29.1s25.9 4.6 29.1 17.5l49.6 198.4c17.6 2.4 32.9 12 42.8 25.7l134.4-33.6c12.9-3.2 25.9 4.6 29.1 17.5s-4.6 25.9-17.5 29.1l-134.3 33.6C347.1 488 320.3 512 288 512c-35.3 0-64-28.7-64-64 0-21.3 10.4-40.1 26.3-51.7l-27-108.3h-70.7c-16 0-31-8-39.9-21.4L96 241.7zM0 480V346.5l64 64V480c0 17.7-14.3 32-32 32S0 497.7 0 480zm288-16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm69.4-87.8c-17.1 4.3-34.5-6.1-38.8-23.3l-22.9-91.5c-4.3-17.1 6.1-34.5 23.3-38.8l91.5-22.9c17.1-4.3 34.5 6.1 38.8 23.3l22.9 91.5c4.3 17.1-6.1 34.5-23.3 38.8l-91.5 22.9z"
        }
    ]
};

const FasPersonDotsFromLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPersonDotsFromLine",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 176a88 88 0 1 0 0-176 88 88 0 1 0 0 176zM78.7 372.9c15-12.5 50-34.4 97.3-50.1V432h224V322.7c47.3 15.8 82.3 37.7 97.3 50.1 20.4 17 50.6 14.2 67.6-6.1s14.2-50.6-6.1-67.6c-12-10-30.1-22.5-53.2-35-8.4 14.3-23.9 23.9-41.6 23.9-26.5 0-48-21.5-48-48 0-4.3.6-8.4 1.6-12.4C379.1 215.9 335.3 208 288 208c-60.2 0-114.9 12.9-160 29.9v2.1c0 26.5-21.5 48-48 48-11.8 0-22.7-4.3-31-11.4-13.1 8.1-23.7 15.9-31.7 22.5-20.4 17-23.1 47.2-6.1 67.6s47.2 23.1 67.6 6.1zM24 464c-13.3 0-24 10.7-24 24s10.7 24 24 24h528c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zm200-184a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm104 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM96 240a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm368 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
        }
    ]
};

const FasPersonDressBurst = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPersonDressBurst",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M528 48a48 48 0 1 0-96 0 48 48 0 1 0 96 0zM390.2 384H408v96c0 17.7 14.3 32 32 32s32-14.3 32-32v-96h16v96c0 17.7 14.3 32 32 32s32-14.3 32-32v-96h17.8c10.9 0 18.6-10.7 15.2-21.1l-38.3-114.8 33.9 56.3c9.1 15.1 28.8 20 43.9 10.9s20-28.8 10.9-43.9l-53.6-89.2c-20.2-33.7-56.7-54.3-96-54.3h-11.6c-39.3 0-75.7 20.6-96 54.3l-53.6 89.2c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9l33.9-56.3L375 362.9c-3.5 10.4 4.3 21.1 15.2 21.1zM190.9 18.1C188.4 12 182.6 8 176 8s-12.4 4-14.9 10.1l-29.4 74-76.1-23.2c-6.3-1.9-13.1.2-17.2 5.3S33.8 86.4 37 92.1l39.5 69.1-65.6 45.2c-5.4 3.7-8 10.3-6.5 16.7s6.7 11.2 13.1 12.2l78.7 12.2-5.6 79.5c-.5 6.5 3.1 12.7 9 15.5s12.9 1.8 17.8-2.6l58.6-53.8 58.6 53.9c4.8 4.4 11.9 5.5 17.8 2.6s9.5-9 9-15.5l-5.6-79.4 50.5-7.8 24.4-40.5-55.2-38L315 92.2c3.3-5.7 2.7-12.8-1.4-17.9s-10.9-7.2-17.2-5.3l-76.1 23.1-29.4-74z"
        }
    ]
};

const FasPersonDressFairy = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPersonDressFairy",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 0a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm-15.7 160h31.5c28.6 0 53.7 18.9 61.5 46.4l39.1 136.8c5.8 20.4-9.5 40.8-30.8 40.8H384v80c0 26.5-21.5 48-48 48h-32c-26.5 0-48-21.5-48-48v-80h-21.6c-21.3 0-36.6-20.3-30.8-40.8l39.1-136.8c7.8-27.5 33-46.4 61.5-46.4zM32 32c91.1 0 172.4 42.3 225.1 108.4-21.5 12.1-38 32.3-45.2 57.3l-39 136.7c-10.7 37.5 14.2 74.8 51.1 80.7v32.1C191.7 468 153.2 480 112 480H96c-17.7 0-32-14.3-32-32 0-45.7 14.7-88 39.7-122.3C40.6 275.9 0 198.7 0 112V64c0-17.7 14.3-32 32-32zm496 448c-41.2 0-79.7-12-112-32.7v-32.1c36.9-6 61.8-43.3 51.1-80.7L428 197.6c-7.1-24.9-23.7-45.1-45.2-57.3C435.6 74.3 516.9 32 608 32c17.7 0 32 14.3 32 32v48c0 86.7-40.6 163.9-103.7 213.7C561.3 360 576 402.3 576 448c0 17.7-14.3 32-32 32h-16z"
        }
    ]
};

const FasPersonDressSimple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPersonDressSimple",
    "viewBox": "0 0 256 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64a64 64 0 1 1 128 0 64 64 0 1 1-128 0zM50.7 206.4c7.8-27.5 33-46.4 61.5-46.4h31.4c28.6 0 53.7 18.9 61.5 46.4l39.1 136.8c5.8 20.4-9.5 40.8-30.8 40.8H192v80c0 26.5-21.5 48-48 48h-32c-26.5 0-48-21.5-48-48v-80H42.4c-21.3 0-36.6-20.3-30.8-40.8l39.1-136.8z"
        }
    ]
};

const FasPersonDress = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPersonDress",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM88 384H70.2c-10.9 0-18.6-10.7-15.2-21.1l38.3-114.8-33.9 56.4c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l53.6-89.2c20.3-33.7 56.7-54.3 96-54.3h11.6c39.3 0 75.7 20.6 96 54.3l53.6 89.2c9.1 15.1 4.2 34.8-10.9 43.9s-34.8 4.2-43.9-10.9l-33.9-56.3L265 362.9c3.5 10.4-4.3 21.1-15.2 21.1H232v96c0 17.7-14.3 32-32 32s-32-14.3-32-32v-96h-16v96c0 17.7-14.3 32-32 32s-32-14.3-32-32v-96z"
        }
    ]
};

const FasPersonDrowning = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPersonDrowning",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 64c0-17.7-14.3-32-32-32s-32 14.3-32 32v32.2c0 54.1 23.5 104 62.2 138.3l-21 146.7c7.8 2.1 15.5 3.3 22.8 3.3 21.1 0 42-8.5 59.2-20.3 22.1-15.5 51.6-15.5 73.7 0 12.4 8.5 26.1 14.8 39.7 18l17.7-97.6c10.7-1.2 21.3-3.1 31.9-5.5l105-23.9c17.2-3.9 28-21.1 24.1-38.3s-21.1-28-38.3-24.1l-105 23.8c-41 9.3-83.7 7.5-123.7-5.2-50.2-16-84.3-62.6-84.3-115.3V64zm128 128a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-13.5 197.9c-11.1-7.9-25.9-7.9-37 0-22.5 15.5-50 26.1-77.5 26.1-26.9 0-55.3-10.8-77.4-26.1-11.9-8.5-28.1-7.8-39.2 1.7-14.4 11.9-32.5 21-50.6 25.2-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25 29 15.6 61.5 25.9 94.5 25.9 31.9 0 60.6-9.9 80.4-18.9 5.8-2.7 11.1-5.3 15.6-7.7 4.5 2.4 9.7 5.1 15.6 7.7 19.8 9 48.5 18.9 80.4 18.9 33 0 65.5-10.3 94.5-25.8 13.4 8.4 33.7 19.3 58.2 25 17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2-11.1-9.4-27.3-10.1-39.2-1.7-22 15.2-50.5 26-77.4 26-27.5 0-55-10.6-77.5-26.1z"
        }
    ]
};

const FasPersonFairy = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPersonFairy",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 0a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm-22.4 160h44.8c41.6 0 76.3 31.9 79.7 73.4l4.1 49.3c2.5 29.8-15.7 56.1-42.2 65.6V464c0 26.5-21.5 48-48 48h-32c-26.5 0-48-21.5-48-48V348.3c-26.5-9.5-44.7-35.8-42.2-65.6l4.1-49.3c3.5-41.5 38.1-73.4 79.7-73.4zM32 32c89.4 0 169.4 40.8 222.2 104.7-37.4 15.7-64.6 51.2-68.2 94l-4.1 49.3c-3 36.2 14.4 69 42.1 87.7v79.6C191.7 468 153.2 480 112 480H96c-17.7 0-32-14.3-32-32 0-45.7 14.7-88 39.7-122.3C40.6 275.9 0 198.7 0 112V64c0-17.7 14.3-32 32-32zm496 448c-41.2 0-79.7-12-112-32.7v-79.6c27.8-18.7 45.1-51.5 42.1-87.7l-4.1-49.3c-3.6-42.7-30.8-78.2-68.2-94C438.6 72.8 518.6 32 608 32c17.7 0 32 14.3 32 32v48c0 86.7-40.6 163.9-103.7 213.7C561.3 360 576 402.3 576 448c0 17.7-14.3 32-32 32h-16z"
        }
    ]
};

const FasPersonFallingBurst = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPersonFallingBurst",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32c0-17.7-14.3-32-32-32s-32 14.3-32 32v9.8c0 39-23.7 74-59.9 88.4C71.6 154.5 32 213 32 278.2V352c0 17.7 14.3 32 32 32s32-14.3 32-32v-73.8c0-10 1.6-19.8 4.5-29l160.6 248.2c9.6 14.8 29.4 19.1 44.3 9.5s19.1-29.4 9.5-44.3L222.6 320H304l38.4 51.2c10.6 14.1 30.7 17 44.8 6.4s17-30.7 6.4-44.8l-43.2-57.6c-9.1-12.1-23.3-19.2-38.4-19.2h-71.5l-56.8-80.2-.2-.3c44.7-29 72.5-79 72.5-133.6v-9.8zM96 80a48 48 0 1 0-96 0 48 48 0 1 0 96 0zm368 206.1 58.6 53.9c4.8 4.4 11.9 5.5 17.8 2.6s9.5-9 9-15.5l-5.6-79.4 78.7-12.2c6.5-1 11.7-5.9 13.1-12.2s-1.1-13-6.5-16.7l-65.6-45.1L603 92.2c3.3-5.7 2.7-12.8-1.4-17.9s-10.9-7.2-17.2-5.3l-76.1 23.1-29.4-74C476.4 12 470.6 8 464 8s-12.4 4-14.9 10.1l-29.4 74-76.1-23.2c-6.3-1.9-13.1.2-17.2 5.3s-4.6 12.2-1.4 17.9l39.5 69.1-65.6 45.1c-5.4 3.7-8 10.3-6.5 16.7.1.3.1.6.2.8H312c20.1 0 39.2 7.5 53.8 20.8l18.4 2.9-1.2 17.8 36.2 48.3c2.1 2.8 3.9 5.7 5.5 8.6l39.3-36.1z"
        }
    ]
};

const FasPersonFalling = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPersonFalling",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 0c17.7 0 32 14.3 32 32v9.8c0 54.6-27.9 104.6-72.5 133.6l.2.3 56.8 80.3H392c15.1 0 29.3 7.1 38.4 19.2l43.2 57.6c10.6 14.1 7.7 34.2-6.4 44.8s-34.2 7.7-44.8-6.4L384 320h-97.4l92.3 142.6c9.6 14.8 5.4 34.6-9.5 44.3s-34.6 5.4-44.3-9.5L164.5 249.2c-2.9 9.2-4.5 19-4.5 29V352c0 17.7-14.3 32-32 32s-32-14.3-32-32v-73.8c0-65.1 39.6-123.7 100.1-147.9 36.2-14.5 59.9-49.5 59.9-88.5V32c0-17.7 14.3-32 32-32zM112 32a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
        }
    ]
};

const FasPersonFromPortal = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPersonFromPortal",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M154.2 352c3.8-29.6 5.8-62.1 5.8-96 0-18.3-.6-36.1-1.7-53.4 12.4 8.3 29.4 7 40.4-4l23.1-23.1c9.9-9.9 23.4-15.5 37.5-15.5 1.9 0 3.8.1 5.6.3L233.6 254c-9.3 28 1.7 58.8 26.8 74.5l86.2 53.9-25.4 88.8c-4.9 17 5 34.7 22 39.6s34.7-5 39.6-22l28.7-100.4c5.9-20.6-2.6-42.6-20.7-53.9L334 299l30.9-82.4 5.1 12.3c15 35.8 49.9 59.1 88.7 59.1H480c17.7 0 32-14.3 32-32s-14.3-32-32-32h-21.3c-12.9 0-24.6-7.8-29.5-19.7l-6.3-15c-14.6-35.1-44.1-61.9-80.5-73.1l-48.7-15C282.6 97.8 271 96 259.3 96c-31 0-60.8 12.3-82.7 34.3l-23.1 23.1-.1.1C141 63.1 112.8 0 80 0 35.8 0 0 114.6 0 256s35.8 256 80 256c25.3 0 47.8-37.5 62.5-96h55.1c19 0 36.2-11.2 43.9-28.5l11.5-25.9-9.5-6a95.394 95.394 0 0 1-37.9-44.9L187.2 352h-33zM368 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
        }
    ]
};

const FasPersonHalfDress = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPersonHalfDress",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm8 352V128h6.9c33.7 0 64.9 17.7 82.3 46.6l58.3 97c9.1 15.1 4.2 34.8-10.9 43.9s-34.8 4.2-43.9-10.9L232 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352zM58.2 182.3c19.9-33.1 55.3-53.5 93.8-54.3v352c0 17.7-14.3 32-32 32s-32-14.3-32-32v-96H70.2c-10.9 0-18.6-10.7-15.2-21.1l38.3-114.8-33.9 56.4c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l53.6-89.2z"
        }
    ]
};

const FasPersonHarassing = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPersonHarassing",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM59.4 304.5 88 256.9V480c0 17.7 14.3 32 32 32s32-14.3 32-32V352h16v128c0 17.7 14.3 32 32 32s32-14.3 32-32V235.3l47.4 57.1c11.3 13.6 31.5 15.5 45.1 4.2s15.5-31.5 4.2-45.1L255 162.6c-18.2-22-45.3-34.7-73.9-34.7h-36c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9zM480 240a48 48 0 1 0-96 0 48 48 0 1 0 96 0zm-16 104v58.7l-41.4-41.4c-7.3-7.3-17.6-10.6-27.8-9s-18.9 8.1-23.5 17.3l-48 96c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3l28.3-56.2 54.7 54.7c12.4 12.4 29.1 19.3 46.6 19.3 36.4 0 65.9-29.5 65.9-65.9V344c0-30.9-25.1-56-56-56s-56 25.1-56 56zM288 48c0 8.8 7.2 16 16 16h56c8.8 0 16-7.2 16-16s-7.2-16-16-16h-56c-8.8 0-16 7.2-16 16zm-.8 49.7c-7.9-4-17.5-.7-21.5 7.2s-.7 17.5 7.2 21.5l48 24c7.9 4 17.5.7 21.5-7.2s.7-17.5-7.2-21.5l-48-24z"
        }
    ]
};

const FasPersonHiking = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPersonHiking",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 48a48 48 0 1 1 96 0 48 48 0 1 1-96 0zm51.3 182.7L224.2 307l49.7 49.7c9 9 14.1 21.2 14.1 33.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32v-82.7l-73.9-73.9c-15.8-15.8-22.2-38.6-16.9-60.3l20.4-84c8.3-34.1 42.7-54.9 76.7-46.4 19 4.8 35.6 16.4 46.4 32.7l28.4 42.6H336v-24c0-13.3 10.7-24 24-24s24 10.7 24 24v304c0 13.3-10.7 24-24 24s-24-10.7-24-24V272h-39.4c-16 0-31-8-39.9-21.4l-13.3-20zM81.1 471.9 117.3 334c3 4.2 6.4 8.2 10.1 11.9l41.9 41.9-26.4 100.3c-4.5 17.1-22 27.3-39.1 22.8s-27.3-22-22.8-39.1zm55.5-346-35.2 140.6c-3 12.1-14.9 19.9-27.2 17.9l-47.9-8c-14-2.3-22.9-16.3-19.2-30L31.9 155c9.5-34.8 41.1-59 77.2-59h4.2c15.6 0 27.1 14.7 23.3 29.8z"
        }
    ]
};

const FasPersonMilitaryPointing = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPersonMilitaryPointing",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M246.9 14.1C234 15.2 224 26 224 39c0 13.8 11.2 25 25 25h151c8.8 0 16-7.2 16-16V17.4c0-9.4-8-16.7-17.3-16L246.9 14.1zM240 112c0 44.2 35.8 80 80 80s80-35.8 80-80c0-5.5-.6-10.8-1.6-16H241.6c-1 5.2-1.6 10.5-1.6 16zM72 224c-22.1 0-40 17.9-40 40s17.9 40 40 40h152v89.4l162.8-162.9c-13.3-4.3-27.3-6.5-41.6-6.5H72zm345.7 20.9L246.6 416H416v-46.3l53.6 90.6c11.2 19 35.8 25.3 54.8 14.1s25.3-35.8 14.1-54.8l-76.2-128.8c-11.2-18.9-26.6-34.5-44.6-45.9zM224 448v32c0 17.7 14.3 32 32 32h128c17.7 0 32-14.3 32-32v-32H224z"
        }
    ]
};

const FasPersonMilitaryRifle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPersonMilitaryRifle",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 39c0-13 10-23.8 22.9-24.9L334.7 1.4C344 .7 352 8 352 17.4V48c0 8.8-7.2 16-16 16H185c-13.8 0-25-11.2-25-25zm17.6 57h156.8c1 5.2 1.6 10.5 1.6 16 0 44.2-35.8 80-80 80s-80-35.8-80-80c0-5.5.6-10.8 1.6-16zm228 364.3L352 369.7V480c0 1.3-.1 2.5-.2 3.8L177.5 234.9c16.6-7.1 34.6-10.9 53.3-10.9h50.4c15.9 0 31.3 2.8 45.8 7.9l94.9-164.2c-7.7-4.4-10.3-14.2-5.9-21.9s14.2-10.3 21.9-5.9l13.9 8 13.9 8c7.7 4.4 10.3 14.2 5.9 21.9L416 173.9l1.6.9c15.3 8.8 20.6 28.4 11.7 43.7L392.6 282c2 2.8 3.9 5.8 5.7 8.8l76.1 128.8c11.2 19 4.9 43.5-14.1 54.8s-43.5 4.9-54.8-14.1zM320 512H192c-17.7 0-32-14.3-32-32V369.7l-53.6 90.6c-11.2 19-35.8 25.3-54.8 14.1s-25.3-35.8-14.1-54.8l76.1-128.8c9.4-15.8 21.7-29.3 36-40L331.1 510c-3.5 1.3-7.2 2-11.1 2zm-24-192a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FasPersonMilitaryToPerson = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPersonMilitaryToPerson",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M71 12.5c-8.6 1-15 8.2-15 16.8 0 9.3 7.5 16.8 16.7 16.9h111.4c8.8-.1 15.9-7.2 15.9-16V16c0-9.5-8.3-17-17.8-15.9L71 12.5zm118.5 65.6h-123C64.9 83.8 64 89.8 64 96c0 35.3 28.7 64 64 64s64-28.7 64-64c0-6.2-.9-12.2-2.5-17.9zM32 256v32c0 17.7 14.3 32 32 32h128c1.8 0 3.5-.1 5.2-.4L53 208.6c-12.9 11.7-21 28.6-21 47.4zm190.2 42.5c1.1-3.3 1.8-6.8 1.8-10.5v-32c0-35.3-28.7-64-64-64H96c-3.7 0-7.4.3-10.9.9l137.1 105.6zM384 160a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-32 32c-35.3 0-64 28.7-64 64v32c0 17.7 14.3 32 32 32h128c17.7 0 32-14.3 32-32v-32c0-35.3-28.7-64-64-64h-64zM215.8 450.1c5.2-4.6 8.2-11.1 8.2-18.1s-3-13.5-8.2-18.1l-64-56c-7.1-6.2-17.1-7.7-25.7-3.8S112 366.6 112 376v32H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h88v32c0 9.4 5.5 18 14.1 21.9s18.6 2.4 25.7-3.8l64-56zm72.2-18.2c0 6.9 2.9 13.5 8.1 18.1l64 56.4c7.1 6.2 17.1 7.8 25.7 3.9s14.1-12.4 14.1-21.9V456h88c13.3 0 24-10.7 24-24s-10.7-24-24-24h-88v-32c0-9.4-5.5-18-14.1-21.9s-18.6-2.4-25.7 3.8l-64 56c-5.2 4.5-8.2 11.1-8.2 18z"
        }
    ]
};

const FasPersonPinball = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPersonPinball",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 48a48 48 0 1 1 96 0 48 48 0 1 1-96 0zm64 193.7v65.1l49.9 49.9c9 9 14.1 21.2 14.1 33.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32v-82.7L18.7 320C6.7 308 0 291.7 0 274.7v-88.1C0 154.2 26.2 128 58.6 128c24.1 0 46.5 12 59.9 32l42.6 64H224c12.9 0 24.1 7.7 29.1 18.7l295-49.2L515.3 95c-2.2-6.5-3.3-13.4-3.3-20.2V32c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v448c0 17.7-14.3 32-32 32s-32-14.3-32-32v-96H256v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V288h-39.4c-16 0-31-8-39.9-21.4L96 241.7zM0 480V346.5l64 64V480c0 17.7-14.3 32-32 32S0 497.7 0 480zm280-144a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FasPersonPraying = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPersonPraying",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 64a64 64 0 1 0-128 0 64 64 0 1 0 128 0zM232.7 264l22.9 31.5c6.5 8.9 16.3 14.7 27.2 16.1s21.9-1.7 30.4-8.7l88-72c17.1-14 19.6-39.2 5.6-56.3s-39.2-19.6-56.3-5.6l-55.2 45.2-26.2-36C253.6 156.7 228.6 144 202 144c-30.9 0-59.2 17.1-73.6 44.4l-48.6 92.5c-20.2 38.5-9.4 85.9 25.6 111.8l53.2 39.3H72c-22.1 0-40 17.9-40 40s17.9 40 40 40h208c17.3 0 32.6-11.1 38-27.5s-.3-34.4-14.2-44.7L187.7 354l45-90z"
        }
    ]
};

const FasPersonPregnant = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPersonPregnant",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm-72 383c-13.8-3.6-24-16.1-24-31v-55.1l-4.6 7.6c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c15-24.9 40.3-41.5 68.7-45.6 4.1-.6 8.2-1 12.5-1H192c1.4 0 2.8.1 4.1.3 35.7 2.9 65.4 29.3 72.1 65l6.1 32.5c44.3 8.6 77.7 47.5 77.7 94.3v32c0 17.7-14.3 32-32 32h-56v96c0 17.7-14.3 32-32 32s-32-14.3-32-32v-96h-16v96c0 17.7-14.3 32-32 32s-32-14.3-32-32v-97z"
        }
    ]
};

const FasPersonRays = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPersonRays",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M208 48a48 48 0 1 1 96 0 48 48 0 1 1-96 0zm40 304v128c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9l-28.6 47.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6h29.7c33.7 0 64.9 17.7 82.3 46.6l58.3 97c9.1 15.1 4.2 34.8-10.9 43.9s-34.8 4.2-43.9-10.9L328 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352h-16zM7 7c9.4-9.3 24.6-9.3 34 0l80 80c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L7 41c-9.3-9.4-9.3-24.6 0-34zm464 0c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l80-80zM7 505c-9.4-9.4-9.4-24.6 0-33.9l80-80c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L41 505c-9.4 9.4-24.6 9.4-33.9 0zm464 0-80-80c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l80 80c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0z"
        }
    ]
};

const FasPersonRifle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPersonRifle",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M265.2 192c25.4 0 49.8 7.1 70.8 19.9V512H144V337.7l-53.6 90.6c-11.2 19-35.8 25.3-54.8 14.1s-25.3-35.8-14.1-54.8l76.2-128.8c24.5-41.4 69-66.8 117.1-66.8h50.4zM160 80a80 80 0 1 1 160 0 80 80 0 1 1-160 0zM448 0c8.8 0 16 7.2 16 16v116.3c9.6 5.5 16 15.9 16 27.7v109.3l16-5.3v-56c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v84.5c0 6.9-4.4 13-10.9 15.2L480 325.3V352h48c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-44l23 92.1c2.5 10.1-5.1 19.9-15.5 19.9H432c-8.8 0-16-7.2-16-16v-96h-16c-17.7 0-32-14.3-32-32V224c0-17.7 14.3-32 32-32v-32c0-11.8 6.4-22.2 16-27.7V32c-8.8 0-16-7.2-16-16s7.2-16 16-16h32z"
        }
    ]
};

const FasPersonRunningFast = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPersonRunningFast",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M368 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM259.2 160c-14.1 0-27.5 5.6-37.5 15.5l-23.1 23.1c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l23.1-23.1c22-21.9 51.8-34.2 82.8-34.2 11.7 0 23.3 1.7 34.4 5.2l48.7 15c36.4 11.2 65.9 38 80.5 73.1l6.3 15c5 11.9 16.6 19.7 29.5 19.7H480c17.7 0 32 14.3 32 32s-14.3 32-32 32h-21.3c-38.8 0-73.7-23.3-88.6-59.1l-5.1-12.3-31 82.4 56.7 35.4c18.1 11.3 26.6 33.3 20.7 53.9l-28.6 100.5c-4.9 17-22.6 26.8-39.6 22s-26.8-22.6-22-39.6l25.4-88.8-86.2-53.9c-25.1-15.7-36.1-46.5-26.8-74.5l31.2-93.7c-1.9-.2-3.7-.3-5.6-.3zm-53.7 150.7c7.4 18.1 20.4 33.9 37.9 44.9l9.5 6-11.5 25.9c-7.7 17.3-24.9 28.5-43.9 28.5H128c-17.7 0-32-14.3-32-32s14.3-32 32-32h59.2l18.3-41.3zM16 95.8h128c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-16 80c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16zm16 48h128c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FasPersonRunning = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPersonRunning",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 48a48 48 0 1 0-96 0 48 48 0 1 0 96 0zM125.7 175.5c9.9-9.9 23.4-15.5 37.5-15.5 1.9 0 3.8.1 5.6.3L137.6 254c-9.3 28 1.7 58.8 26.8 74.5l86.2 53.9-25.4 88.8c-4.9 17 5 34.7 22 39.6s34.7-5 39.6-22l28.7-100.4c5.9-20.6-2.6-42.6-20.7-53.9L238 299l30.9-82.4 5.1 12.3c15 35.8 49.9 59.1 88.7 59.1H384c17.7 0 32-14.3 32-32s-14.3-32-32-32h-21.3c-12.9 0-24.6-7.8-29.5-19.7l-6.3-15c-14.6-35.1-44.1-61.9-80.5-73.1l-48.7-15C186.6 97.8 175 96 163.3 96c-31 0-60.8 12.3-82.7 34.3l-23.2 23.1c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l23.1-23.1zM91.2 352H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h69.6c19 0 36.2-11.2 43.9-28.5l11.5-25.9-9.5-6a95.394 95.394 0 0 1-37.9-44.9L91.2 352z"
        }
    ]
};

const FasPersonSeatReclined = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPersonSeatReclined",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 128a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm89 160-8-32h63c17.7 0 32-14.3 32-32s-14.3-32-32-32h-79.2c-6.6-19-24.5-32-44.9-32-30.9 0-53.6 29.1-46.1 59l21.1 84.5C178 332 203.6 352 233 352h85.8c6.7 0 12.6 4.1 15 10.4l36.2 96.8c6 16.1 23.8 24.6 40.1 19.1l48-16c16.8-5.6 25.8-23.7 20.2-40.5s-23.7-25.8-40.5-20.2l-18.7 6.2-25.5-68c-11.7-31.2-41.6-51.9-74.9-51.9H265zM95.5 154.1c-3.3-17.4-20-28.8-37.3-25.6s-28.8 20-25.6 37.3l33.3 177.8C77.2 404.1 130.1 448 191.7 448H272c17.7 0 32-14.3 32-32s-14.3-32-32-32h-80.3c-30.8 0-57.2-21.9-62.9-52.2L95.5 154.1z"
        }
    ]
};

const FasPersonSeat = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPersonSeat",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 128a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm48 160v-32h64c17.7 0 32-14.3 32-32s-14.3-32-32-32h-66.7c-6.6-18.6-24.4-32-45.3-32-26.5 0-48 21.5-48 48v80c0 35.3 28.7 64 64 64h85.6c8.1 0 14.9 6 15.9 14l10.7 86c2 16 15.6 28 31.8 28h48c17.7 0 32-14.3 32-32s-14.3-32-32-32h-19.8l-7.2-57.9c-5-40-39-70.1-79.4-70.1H192zM64 160c0-17.7-14.3-32-32-32S0 142.3 0 160v160c0 70.7 57.3 128 128 128h64c17.7 0 32-14.3 32-32s-14.3-32-32-32h-64c-35.3 0-64-28.7-64-64V160z"
        }
    ]
};

const FasPersonShelter = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPersonShelter",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M271.9 4.2c-9.8-5.6-21.9-5.6-31.8 0l-224 128C6.2 137.9 0 148.5 0 160v320c0 17.7 14.3 32 32 32s32-14.3 32-32V178.6L256 68.9l192 109.7V480c0 17.7 14.3 32 32 32s32-14.3 32-32V160c0-11.5-6.2-22.1-16.1-27.8l-224-128zM256 208a40 40 0 1 0 0-80 40 40 0 1 0 0 80zm-8 280v-88h16v88c0 13.3 10.7 24 24 24s24-10.7 24-24V313.5l26.9 49.9c6.3 11.7 20.8 16 32.5 9.8s16-20.8 9.8-32.5l-37.9-70.3c-15.3-28.5-45.1-46.3-77.5-46.3h-19.6c-32.4 0-62.1 17.8-77.5 46.3l-37.9 70.3c-6.3 11.7-1.9 26.2 9.8 32.5s26.2 1.9 32.5-9.8l26.9-49.9V488c0 13.3 10.7 24 24 24s24-10.7 24-24z"
        }
    ]
};

const FasPersonSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPersonSign",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M438.1 32.2c4.5-12.5-1.9-26.2-14.3-30.8S397.5 3.3 393 15.8l-4.6 12.7-59.7-21.8c-12.5-4.5-26.2 1.9-30.8 14.3l-38.3 105.3c-4.5 12.5 1.9 26.2 14.3 30.8l59.7 21.7-15.4 42.4-28.8-10.8c-9.7-3.7-18.4-9.6-25.4-17.4l-29-32.8c-18.2-20.5-44.3-32.2-71.8-32.2h-27.6c-36.4 0-69.6 20.5-85.9 53.1L3.4 273.7c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3L80 263.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32V352h20.2l27.8 55.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32v-72.4c0-9.9-2.3-19.7-6.8-28.6L216 312.4v-77.2l.3.3c13.8 15.6 31.2 27.5 50.7 34.8l29.3 11-7.3 20.2c-4.5 12.5 1.9 26.2 14.3 30.8s26.2-1.9 30.8-14.3l44.6-122.6 60.6 22c12.5 4.5 26.2-1.9 30.8-14.3l38.3-105.4c4.5-12.5-1.9-26.2-14.3-30.8l-60.6-22 4.6-12.7zM192 48a48 48 0 1 0-96 0 48 48 0 1 0 96 0z"
        }
    ]
};

const FasPersonSimple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPersonSimple",
    "viewBox": "0 0 256 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64a64 64 0 1 1 128 0 64 64 0 1 1-128 0zM25.9 233.4C29.3 191.9 64 160 105.6 160h44.8c41.6 0 76.3 31.9 79.7 73.4l4.1 49.3c2.5 29.8-15.7 56.1-42.2 65.6V464c0 26.5-21.5 48-48 48h-32c-26.5 0-48-21.5-48-48V348.3c-26.5-9.5-44.7-35.8-42.2-65.6l4.1-49.3z"
        }
    ]
};

const FasPersonSkating = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPersonSkating",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 48a48 48 0 1 1 96 0 48 48 0 1 1-96 0zm-224 80c0-17.7 14.3-32 32-32h159.4c43.6 0 64.6 53.4 32.8 83.1l-74.4 69.4 60.2 60.2c9 9 14.1 21.2 14.1 33.9V416c0 17.7-14.3 32-32 32s-32-14.3-32-32v-66.7l-77.9-77.8c-26.6-26.6-24.6-70.3 4.3-94.4l20.4-17H160c-17.7 0-32-14.3-32-32zM81.4 353.4l86.9-86.9c4.6 10 11 19.3 19.3 27.5l21.8 21.8-82.7 82.7c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3zm322.5 95.1c8.6 2.1 13.8 10.8 11.6 19.4l-.4 1.7c-6.2 24.9-28.6 42.4-54.3 42.4H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h88.8c11 0 20.6-7.5 23.3-18.2l.4-1.7c2.1-8.6 10.8-13.8 19.4-11.6zm-268.7 29.8-6.2 3.1c-21.6 10.8-47.6 6.6-64.6-10.5L4.7 411.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l59.6 59.6c7.3 7.3 18.5 9.1 27.7 4.5l6.2-3.1c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5z"
        }
    ]
};

const FasPersonSkiJumping = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPersonSkiJumping",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 48a48 48 0 1 1 96 0 48 48 0 1 1-96 0zm-224 80c0-17.7 14.3-32 32-32h144.5c46 0 65.7 58.4 29 86.2l-103.4 78.6-6.4 7.5c-2.4 2.8-4.4 6.1-5.7 9.6l-38.5 102.7 254.2-131.5c18.6-9.6 30.3-28.8 30.3-49.7V192c0-13.3 10.7-24 24-24s24 10.7 24 24v7.3c0 38.9-21.7 74.5-56.2 92.4L35 509.3c-11.7 6.1-26.2 1.5-32.3-10.3S1.2 472.7 13 466.7l111.2-57.5c-10.7-8.4-15.2-23-10.2-36.4l44-117.4c3.9-10.5 9.7-20.2 17-28.8l57.1-66.6H160c-17.7 0-32-14.3-32-32z"
        }
    ]
};

const FasPersonSkiLift = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPersonSkiLift",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M240 0c8.8 0 16 7.2 16 16v182.3l-32 8.5V16c0-8.8 7.2-16 16-16zM64 80a48 48 0 1 1 96 0 48 48 0 1 1-96 0zm36.4 138c-14.2-30.8 8.3-66 42.2-66 18.2 0 34.8 10.7 42.3 27.3l28.8 63.4 55.9-14.9c25.4-6.8 50.3 12.4 50.3 38.6v122.1L443.1 343c12.6-4.6 20.9-16.6 20.9-30v-1c0-13.3 10.7-24 24-24s24 10.7 24 24v1c0 33.5-20.9 63.4-52.3 75L128.3 510.5c-12.4 4.6-26.2-1.8-30.8-14.2s1.8-26.2 14.2-30.8L256 412.2V297.7l-66.7 17.8c-22.6 6-46.2-5.1-56-26.3L100.4 218zm-54.7-28.4 65 135.8c8.3 17.4 28 26.4 46.6 21.3l36.5-9.9c12.8-3.5 26 4.1 29.5 16.8s-4.1 26-16.8 29.5L170 393c-41 11.2-84.2-8.6-102.5-46.9L2.3 210.4c-5.7-12-.7-26.3 11.3-32s26.3-.7 32 11.3z"
        }
    ]
};

const FasPersonSkiingNordic = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPersonSkiingNordic",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M336 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-108.8 64c1.9 0 3.8.1 5.6.3L201.6 254c-9.3 28 1.7 58.8 26.8 74.5l86.2 53.9-23.3 81.6h-88.5l41.1-88.1-32.4-20.3c-7.8-4.9-14.7-10.7-20.6-17.3L132.2 464H99.7l54.2-257.6c4.6-1.5 9-4.1 12.7-7.8l23.1-23.1c9.9-9.9 23.4-15.5 37.5-15.5zm-105.8 38.6c.4.4.8.8 1.3 1.2L67 464H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h480c39.8 0 72-32.2 72-72v-8c0-13.3-10.7-24-24-24s-24 10.7-24 24v8c0 13.3-10.7 24-24 24h-69.4l27.6-179.3c10.5-5.2 17.8-16.1 17.8-28.7 0-17.7-14.3-32-32-32h-21.3c-12.9 0-24.6-7.8-29.5-19.7l-6.3-15c-14.6-35.1-44.1-61.9-80.5-73.1l-48.7-15C250.6 97.8 239 96 227.3 96c-31 0-60.8 12.3-82.7 34.3l-23.1 23.1c-12.5 12.5-12.5 32.8 0 45.3zm308 89.4-27.1 176h-44.5l21.6-75.6c5.9-20.6-2.6-42.6-20.7-53.9L302 299l30.9-82.4 5.1 12.3c15 35.8 49.9 59.1 88.7 59.1h2.7z"
        }
    ]
};

const FasPersonSkiing = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPersonSkiing",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M380.7 48a48 48 0 1 1 96 0 48 48 0 1 1-96 0zM2.7 268.9c6.1-11.8 20.6-16.3 32.4-10.2l197.6 102.6 46.2-69.2-75.1-75.1c-14.6-14.6-20.4-33.9-18.4-52.1l108.8 52 39.3 39.3c16.2 16.2 18.7 41.5 6 60.6L289.8 391l128.7 66.8c13.6 7.1 29.8 7.2 43.6.3l15.2-7.6c11.9-5.9 26.3-1.1 32.2 10.7s1.1 26.3-10.7 32.2l-15.2 7.6c-27.5 13.7-59.9 13.5-87.2-.7l-383.5-199c-11.7-6.1-16.3-20.6-10.2-32.4zM118.9 65.6l18.1 8.6 8.7-17.4c4-7.9 13.6-11.1 21.5-7.2s11.1 13.6 7.2 21.5L165.9 88l54.7 26.2c1.5-.7 3.1-1.4 4.7-2.1l83.4-33.4c34.2-13.7 72.8 4.2 84.5 39.2l17.1 51.2 52.1 26.1c15.8 7.9 22.2 27.1 14.3 42.9s-27.1 22.2-42.9 14.3l-58.1-29c-11.4-5.7-20-15.7-24.1-27.8l-5.8-17.3-27.3 12.1-6.8 3-6.7-3.2-153.5-73.5-9.2 18.4c-4 7.9-13.6 11.1-21.5 7.2s-11.1-13.6-7.2-21.5l9-18-17.6-8.4c-8-3.8-11.3-13.4-7.5-21.3s13.4-11.3 21.3-7.5z"
        }
    ]
};

const FasPersonSledding = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPersonSledding",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M400 128a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM35.1 226.7c-11.8-6.1-26.3-1.5-32.4 10.2s-1.5 26.3 10.2 32.4l383.5 199.1c27.3 14.2 59.7 14.4 87.2.7l15.2-7.6c11.9-5.9 16.7-20.3 10.7-32.2s-20.3-16.7-32.2-10.7l-15.2 7.6c-13.7 6.9-29.9 6.7-43.6-.3l-41.7-21.6c4.5-5.5 7.2-12.5 7.2-20.2V304c0-26.5-21.5-48-48-48h-34.7l59.7-59.7c25.2-25.2 7.4-68.3-28.3-68.3H160c-17.7 0-32 14.3-32 32s14.3 32 32 32h84l-59.2 40.3c-23.6 16.1-26 44.8-13.8 64.9L35.1 226.7zM320 320v54.6L214.7 320H320z"
        }
    ]
};

const FasPersonSnowboarding = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPersonSnowboarding",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M209.7 3.4c15.8-7.9 35-1.5 42.9 14.3l25 50 42.4 8.5c19.5 3.9 37.8 12.3 53.5 24.5l126.1 98.1c14 10.9 16.5 31 5.6 44.9s-31 16.5-44.9 5.6l-72.1-56.1-71.5 31.8 33.1 27.6c23.2 19.3 33.5 50 26.7 79.4l-17.4 75.2c-2.2 9.4-8.2 16.8-16.1 21l86.5 33.1c4.6 1.8 9.4 2.6 14.3 2.6H472c13.3 0 24 10.7 24 24s-10.7 24-24 24h-28.2c-10.8 0-21.4-2-31.5-5.8L60.1 371.3c-11.5-4.4-22-11.2-30.8-20L7 329c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l22.4 22.4c4 4 8.7 7.1 14 9.1l22.4 8.6c-.8-1.6-1.5-3.2-2.1-4.9-5.6-16.8 3.5-34.9 20.2-40.5l74.2-24.9v-53.2c0-24.2 13.7-46.4 35.4-57.2l45.2-22.6-7.5-1.5c-19.4-3.9-35.9-16.5-44.7-34.1l-25-50c-7.9-15.8-1.5-35 14.3-42.9zM139 350.1 298 411c-2.1-5.6-2.6-11.9-1.1-18.2l17.4-75.2c1.4-5.9-.7-12-5.3-15.9l-52.8-44v18.8c0 20.7-13.2 39-32.8 45.5L139 350.1zM432 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
        }
    ]
};

const FasPersonSnowmobiling = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPersonSnowmobiling",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M240 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm133.5-10.7c-5.9-11.9-20.3-16.7-32.2-10.7s-16.7 20.3-10.7 32.2l37.4 74.7-8 10.5h-56l-61.7-55.6c-11.8-10.6-27-16.4-42.8-16.4h-.9c-23.7 0-45.5 13.1-56.6 34.1l-35.3 66.6c-11.4 21.6-9.4 47.8 5.3 67.4H99.8c-12.1 0-23.2 6.8-28.6 17.7l-32 64c-2.5 5-3.6 10.2-3.4 15.2 4-.6 8.1-.9 12.3-.9H272c26.2 0 49.4 12.6 64 32h114l36 48h-46c-13.3 0-24 10.7-24 24s10.7 24 24 24h136c6.4 0 12.5-2.5 17-7l40-40c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-33 33H546l-46-61.3 68.9-45.9c4.5-3 7.1-8 7.1-13.3v-77.8c0-6.1-3.4-11.6-8.8-14.3l-147.4-73.7-46.3-92.6zm-75 170.7H312l-24 32h-24l-72-32 32-48 29.3 29.3c12 12 28.3 18.7 45.3 18.7zM48 416c-26.5 0-48 21.5-48 48s21.5 48 48 48h224c26.5 0 48-21.5 48-48s-21.5-48-48-48H48z"
        }
    ]
};

const FasPersonSwimming = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPersonSwimming",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m309.5 178.4 138.4 118.7c-1.6.9-3.2 2-4.8 3-18 12.4-40.1 20.3-59.2 20.3-19.6 0-40.8-7.7-59.2-20.3-22.1-15.5-51.6-15.5-73.7 0-17.1 11.8-38 20.3-59.2 20.3-10.1 0-21.1-2.2-31.9-6.2C163.1 193.2 262.2 96 384 96h64c17.7 0 32 14.3 32 32s-14.3 32-32 32h-64c-26.9 0-52.3 6.6-74.5 18.4zM160 160a64 64 0 1 1-128 0 64 64 0 1 1 128 0zm146.5 165.9c22.5 15.5 50 26.1 77.5 26.1 26.9 0 55.4-10.8 77.4-26.1 11.9-8.5 28.1-7.8 39.2 1.7 14.4 11.9 32.5 21 50.6 25.2 17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25-29 15.6-61.5 25.9-94.5 25.9-31.9 0-60.6-9.9-80.4-18.9-5.8-2.7-11.1-5.3-15.6-7.7-4.5 2.4-9.7 5.1-15.6 7.7-19.8 9-48.5 18.9-80.4 18.9-33 0-65.5-10.3-94.5-25.8-13.4 8.4-33.7 19.3-58.2 25-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2 11.1-9.4 27.3-10.1 39.2-1.7 22.1 15.2 50.5 26 77.4 26 27.5 0 55-10.6 77.5-26.1 11.1-7.9 25.9-7.9 37 0z"
        }
    ]
};

const FasPersonThroughWindow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPersonThroughWindow",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64h224v9.8c0 39-23.7 74-59.9 88.4C167.6 186.5 128 245 128 310.2V384H64V64zm288 0h224v320h-67.7l-3.7-4.5-75.2-90.2c-9.1-10.9-22.6-17.3-36.9-17.3h-71.1l-41-63.1c-.3-.5-.6-1-1-1.4 44.7-29 72.5-79 72.5-133.6v-9.8zm73 320h-45.8l42.7 64H592c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48v352c0 26.5 21.5 48 48 48h260.2l33.2 49.8c9.8 14.7 29.7 18.7 44.4 8.9s18.7-29.7 8.9-44.4L310.5 336h74.6l40 48zm-159.5 0H192v-73.8c0-10.2 1.6-20.1 4.7-29.5L265.5 384zM192 128a48 48 0 1 0-96 0 48 48 0 1 0 96 0z"
        }
    ]
};

const FasPersonToDoor = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPersonToDoor",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M272 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM163.2 160c-14.1 0-27.5 5.6-37.5 15.5l-23.1 23.1c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l23.1-23.1c22-21.9 51.8-34.2 82.8-34.2 11.7 0 23.3 1.7 34.4 5.2l48.7 15c36.4 11.2 65.9 38 80.5 73.1l6.3 15c5 11.9 16.6 19.7 29.5 19.7H384c17.7 0 32 14.3 32 32s-14.3 32-32 32h-21.3c-38.8 0-73.7-23.3-88.6-59.1l-5.1-12.3-31 82.4 56.7 35.4c18.1 11.3 26.6 33.3 20.7 53.9l-28.6 100.5c-4.9 17-22.6 26.8-39.6 22s-26.8-22.6-22-39.6l25.4-88.8-86.2-53.9c-25.1-15.7-36.1-46.5-26.8-74.5l31.2-93.7c-1.9-.2-3.7-.3-5.6-.3zm-53.7 150.7c7.4 18.1 20.4 33.9 37.9 44.9l9.5 6-11.5 25.9c-7.7 17.3-24.9 28.5-43.9 28.5H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h59.2l18.3-41.3zM384 48c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v416c0 26.5-21.5 48-48 48h-96c-26.5 0-48-21.5-48-48V320c35.3 0 64-28.7 64-64s-28.7-64-64-64V48z"
        }
    ]
};

const FasPersonToPortal = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPersonToPortal",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M272 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM163.2 160c-14.1 0-27.5 5.6-37.5 15.5l-23.1 23.1c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l23.1-23.1c22-21.9 51.8-34.2 82.8-34.2 11.7 0 23.3 1.7 34.4 5.2l48.7 15c36.4 11.2 65.9 38 80.5 73.1l6.3 15c3.6 8.7 10.9 15.2 19.6 18.1C357.8 96.9 391.4 0 432 0c44.2 0 80 114.6 80 256s-35.8 256-80 256c-40.9 0-74.6-98-79.4-224.5-34.6-3.6-64.9-25.9-78.5-58.5l-5.1-12.3-31 82.3 56.7 35.4c18.1 11.3 26.6 33.3 20.7 53.9l-28.6 100.5c-4.9 17-22.6 26.8-39.6 22s-26.8-22.6-22-39.6l25.4-88.8-86.2-53.9c-25.1-15.7-36.1-46.5-26.8-74.5l31.2-93.7c-1.9-.2-3.7-.3-5.6-.3zm-53.7 150.7c7.4 18.1 20.4 33.9 37.9 44.9l9.5 6-11.5 25.9c-7.7 17.3-24.9 28.5-43.9 28.5H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h59.2l18.3-41.3z"
        }
    ]
};

const FasPersonWalkingArrowLoopLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPersonWalkingArrowLoopLeft",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M208 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-84.3 104.5c1-.4 1.9-.8 2.9-1.2l-16.9 63.5c-5.6 21.1-.1 43.6 14.7 59.7l70.7 77.1 22 88.1c4.3 17.1 21.7 27.6 38.8 23.3s27.6-21.7 23.3-38.8l-23-92.1c-1.9-7.8-5.8-14.9-11.2-20.8l-49.5-54 19.3-65.5 9.6 23c4.4 10.6 12.5 19.3 22.8 24.5l26.7 13.3c15.8 7.9 35 1.5 42.9-14.3s1.5-35-14.3-42.9L281 232.7l-15.3-36.8c-17.2-41.1-57.4-67.9-102-67.9-22.8 0-45.3 4.8-66.1 14l-8 3.5c-32.9 14.6-58.1 42.4-69.4 76.5l-2.6 7.8c-5.6 16.8 3.5 34.9 20.2 40.5s34.9-3.5 40.5-20.2l2.6-7.8c5.7-17.1 18.3-30.9 34.7-38.2l8-3.5zm-30 135.1-25 62.4-59.3 59.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l61.6-61.7c4.6-4.6 8.2-10.1 10.6-16.1l14.5-36.2-40.7-44.4c-2.5-2.7-4.8-5.6-7-8.6zm347.7 119c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L461.3 384H480c88.4 0 160-71.6 160-160S568.4 64 480 64H352c-17.7 0-32 14.3-32 32s14.3 32 32 32h128c53 0 96 43 96 96s-43 96-96 96h-18.7l25.4-25.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-80 80c-12.5 12.5-12.5 32.8 0 45.3l80 80z"
        }
    ]
};

const FasPersonWalkingArrowRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPersonWalkingArrowRight",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M208 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-84.3 104.5c1-.4 1.9-.8 2.9-1.2l-16.9 63.5c-5.6 21.1-.1 43.6 14.7 59.7l70.7 77.1 22 88.1c4.3 17.1 21.7 27.6 38.8 23.3s27.6-21.7 23.3-38.8l-23-92.1c-1.9-7.8-5.8-14.9-11.2-20.8l-49.5-54 19.3-65.5 9.6 23c4.4 10.6 12.5 19.3 22.8 24.5l26.7 13.3c15.8 7.9 35 1.5 42.9-14.3s1.5-35-14.3-42.9L281 232.7l-15.3-36.8c-17.2-41.1-57.4-67.9-102-67.9-22.8 0-45.3 4.8-66.1 14l-8 3.5c-32.9 14.6-58.1 42.4-69.4 76.5l-2.6 7.8c-5.6 16.8 3.5 34.9 20.2 40.5s34.9-3.5 40.5-20.2l2.6-7.8c5.7-17.1 18.3-30.9 34.7-38.2l8-3.5zm-30 135.1-25 62.4-59.3 59.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l61.6-61.7c4.6-4.6 8.2-10.1 10.6-16.1l14.5-36.2-40.7-44.4c-2.5-2.7-4.8-5.6-7-8.6zm456.9-182.2c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l25.4 25.3H384c-17.7 0-32 14.3-32 32s14.3 32 32 32h146.7l-25.4 25.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l80-80c12.5-12.5 12.5-32.8 0-45.3l-80-80z"
        }
    ]
};

const FasPersonWalkingDashedLineArrowRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPersonWalkingDashedLineArrowRight",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M208 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-84.3 104.5c1-.4 1.9-.8 2.9-1.2l-16.9 63.5c-5.6 21.1-.1 43.6 14.7 59.7l70.7 77.1 22 88.1c4.3 17.1 21.7 27.6 38.8 23.3s27.6-21.7 23.3-38.8l-23-92.1c-1.9-7.8-5.8-14.9-11.2-20.8l-49.5-54 19.3-65.5 9.6 23c4.4 10.6 12.5 19.3 22.8 24.5l26.7 13.3c15.8 7.9 35 1.5 42.9-14.3s1.5-35-14.3-42.9L281 232.7l-15.3-36.8c-17.2-41.1-57.4-67.9-102-67.9-22.8 0-45.3 4.8-66.1 14l-8 3.5c-32.9 14.6-58.1 42.4-69.4 76.5l-2.6 7.8c-5.6 16.8 3.5 34.9 20.2 40.5s34.9-3.5 40.5-20.2l2.6-7.8c5.7-17.1 18.3-30.9 34.7-38.2l8-3.5zm-30 135.1-25 62.4-59.3 59.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l61.6-61.7c4.6-4.6 8.2-10.1 10.6-16.1l14.5-36.2-40.7-44.4c-2.5-2.7-4.8-5.6-7-8.6zm456.9-182.2c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l25.4 25.3H384c-17.7 0-32 14.3-32 32s14.3 32 32 32h146.7l-25.4 25.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l80-80c12.5-12.5 12.5-32.8 0-45.3l-80-80zM392 0c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24s24-10.7 24-24V24c0-13.3-10.7-24-24-24zm24 152c0-13.3-10.7-24-24-24s-24 10.7-24 24v16c0 13.3 10.7 24 24 24s24-10.7 24-24v-16zm-24 168c-13.3 0-24 10.7-24 24v16c0 13.3 10.7 24 24 24s24-10.7 24-24v-16c0-13.3-10.7-24-24-24zm24 120c0-13.3-10.7-24-24-24s-24 10.7-24 24v48c0 13.3 10.7 24 24 24s24-10.7 24-24v-48z"
        }
    ]
};

const FasPersonWalkingLuggage = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPersonWalkingLuggage",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M432 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-84.3 104.5c1-.4 1.9-.8 2.9-1.2l-16.9 63.5c-5.6 21.1-.1 43.6 14.7 59.7l70.7 77.1 22 88.1c4.3 17.1 21.7 27.6 38.8 23.3s27.6-21.7 23.3-38.8l-23-92.1c-1.9-7.8-5.8-14.9-11.2-20.8l-49.5-54 19.3-65.5 9.6 23c4.4 10.6 12.5 19.3 22.8 24.5l26.7 13.3c15.8 7.9 35 1.5 42.9-14.3s1.5-35-14.3-42.9L505 232.7l-15.3-36.8c-17.2-41.1-57.4-67.9-102-67.9-22.8 0-45.3 4.8-66.1 14l-8 3.5c-32.9 14.6-58.1 42.4-69.4 76.5l-2.6 7.8c-5.6 16.8 3.5 34.9 20.2 40.5s34.9-3.5 40.5-20.2l2.6-7.8c5.7-17.1 18.3-30.9 34.7-38.2l8-3.5zm-30 135.1-25 62.4-59.4 59.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l61.7-61.7c4.6-4.6 8.2-10.1 10.6-16.1l14.5-36.2-40.7-44.4c-2.5-2.7-4.8-5.6-7-8.6zM256 274.1c-7.7-4.4-17.4-1.8-21.9 5.9l-32 55.4-54.4-31.4c-15.3-8.8-34.9-3.6-43.7 11.7L40 426.6c-8.8 15.3-3.6 34.9 11.7 43.7l55.4 32c15.3 8.8 34.9 3.6 43.7-11.7l64-110.9c1.5-2.6 2.6-5.2 3.3-8l43.8-75.7c4.4-7.7 1.8-17.4-5.9-21.9z"
        }
    ]
};

const FasPersonWalkingWithCane = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPersonWalkingWithCane",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-8.4 32c-36.4 0-69.6 20.5-85.9 53.1l-46.3 92.6c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3l35.4-70.7v43.2c0 17 6.7 33.3 18.7 45.3l77.3 77.2V480c0 17.7 14.3 32 32 32s32-14.3 32-32v-89.4c0-12.7-5.1-24.9-14.1-33.9l-49.9-50v-93.4l70.4 93.9c10.6 14.1 30.7 17 44.8 6.4s17-30.7 6.4-44.8l-76.8-102.4C250.7 142.2 222.2 128 192 128h-24.4zm-39.3 218.8L97 472.2c-4.3 17.1 6.1 34.5 23.3 38.8s34.5-6.1 38.8-23.3l22-88.2-52.8-52.8zm322.5 158.3c5 7.3 15 9.1 22.3 4s9.1-15 4-22.3L358.9 316.1c-2.8 3.8-6.1 7.3-10.1 10.3-5 3.8-10.5 6.4-16.2 7.9l118.2 170.8z"
        }
    ]
};

const FasPersonWalking = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPersonWalking",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 48a48 48 0 1 1 96 0 48 48 0 1 1-96 0zm-33.5 151.3c-1 .4-1.9.8-2.9 1.2l-8 3.5c-16.4 7.3-29 21.2-34.7 38.2l-2.6 7.8c-5.6 16.8-23.7 25.8-40.5 20.2S12 246.5 17.6 229.7l2.6-7.8c11.4-34.1 36.6-61.9 69.4-76.5l8-3.5c20.8-9.2 43.3-14 66.1-14 44.6 0 84.8 26.8 101.9 67.9l15.4 36.9 21.4 10.7c15.8 7.9 22.2 27.1 14.3 42.9s-27.1 22.2-42.9 14.3L247 287.3c-10.3-5.2-18.4-13.8-22.8-24.5l-9.6-23-19.3 65.5 49.5 54c5.4 5.9 9.2 13 11.2 20.8l23 92.1c4.3 17.1-6.1 34.5-23.3 38.8s-34.5-6.1-38.8-23.3l-22-88.1-70.7-77.1c-14.8-16.1-20.3-38.6-14.7-59.7l16.9-63.5zM68.7 398l25-62.4c2.1 3 4.5 5.8 7 8.6l40.7 44.4-14.5 36.2c-2.4 6-6 11.5-10.6 16.1l-61.7 61.7c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L68.7 398z"
        }
    ]
};

const FasPerson = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPerson",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M112 48a48 48 0 1 1 96 0 48 48 0 1 1-96 0zm40 304v128c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9l-28.6 47.6c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6h29.7c33.7 0 64.9 17.7 82.3 46.6l58.3 97c9.1 15.1 4.2 34.8-10.9 43.9s-34.8 4.2-43.9-10.9L232 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352h-16z"
        }
    ]
};

const FasPesetaSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPesetaSign",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32c-17.7 0-32 14.3-32 32v96c-17.7 0-32 14.3-32 32s14.3 32 32 32v224c0 17.7 14.3 32 32 32s32-14.3 32-32v-96h96c77.4 0 142-55 156.8-128h3.2c17.7 0 32-14.3 32-32s-14.3-32-32-32h-3.2C334 87 269.4 32 192 32H64zm218.5 128H96V96h96c41.8 0 77.4 26.7 90.5 64zM96 224h186.5c-13.2 37.3-48.7 64-90.5 64H96v-64z"
        }
    ]
};

const FasPesoSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPesoSign",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32c-17.7 0-32 14.3-32 32v64c-17.7 0-32 14.3-32 32s14.3 32 32 32v32c-17.7 0-32 14.3-32 32s14.3 32 32 32v160c0 17.7 14.3 32 32 32s32-14.3 32-32v-64h80c68.4 0 127.7-39 156.8-96H352c17.7 0 32-14.3 32-32s-14.3-32-32-32h-.7c.5-5.3.7-10.6.7-16s-.2-10.7-.7-16h.7c17.7 0 32-14.3 32-32s-14.3-32-32-32h-19.2C303.7 71 244.4 32 176 32H64zm190.4 96H96V96h80c30.5 0 58.2 12.2 78.4 32zM96 192h190.9c.7 5.2 1.1 10.6 1.1 16s-.4 10.8-1.1 16H96v-32zm158.4 96c-20.2 19.8-47.9 32-78.4 32H96v-32h158.4z"
        }
    ]
};

const FasPhoneArrowDownLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPhoneArrowDownLeft",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M505 41 370 176h46c13.3 0 24 10.7 24 24s-10.7 24-24 24H312c-13.3 0-24-10.7-24-24V96c0-13.3 10.7-24 24-24s24 10.7 24 24v46.1L471 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM117.5 1.4c19.4-5.3 39.7 4.6 47.4 23.2l40 96c6.8 16.3 2.1 35.2-11.6 46.3L144 207.3c33.3 70.4 90.3 127.4 160.7 160.7l40.3-49.3c11.2-13.7 30-18.4 46.3-11.6l96 40c18.6 7.7 28.5 28 23.2 47.4l-24 88C481.8 499.9 466 512 448 512 200.6 512 0 311.4 0 64c0-18 12.1-33.8 29.5-38.6l88-24z"
        }
    ]
};

const FasPhoneArrowRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPhoneArrowRight",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M117.5 1.4c19.4-5.3 39.7 4.6 47.4 23.2l40 96c6.8 16.3 2.1 35.2-11.6 46.3L144 207.3c33.3 70.4 90.3 127.4 160.7 160.7l40.3-49.3c11.2-13.7 30-18.4 46.3-11.6l96 40c18.6 7.7 28.5 28 23.2 47.4l-24 88C481.8 499.9 466 512 448 512 200.6 512 0 311.4 0 64c0-18 12.1-33.8 29.5-38.6l88-24zM425 7l80 80c9.4 9.4 9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l39-39H312c-13.3 0-24-10.7-24-24s10.7-24 24-24h118.1L391 41c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z"
        }
    ]
};

const FasPhoneArrowUpRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPhoneArrowUpRight",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M295 183 430 48h-46c-13.3 0-24-10.7-24-24s10.7-24 24-24h104c13.3 0 24 10.7 24 24v104c0 13.3-10.7 24-24 24s-24-10.7-24-24V81.9L329 217c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9zM117.5 1.4c19.4-5.3 39.7 4.6 47.4 23.2l40 96c6.8 16.3 2.1 35.2-11.6 46.3L144 207.3c33.3 70.4 90.3 127.4 160.7 160.7l40.3-49.3c11.2-13.7 30-18.4 46.3-11.6l96 40c18.6 7.7 28.5 28 23.2 47.4l-24 88C481.8 499.9 466 512 448 512 200.6 512 0 311.4 0 64c0-18 12.1-33.8 29.5-38.6l88-24z"
        }
    ]
};

const FasPhoneFlip = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPhoneFlip",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M347.1 24.6c7.7-18.6 28-28.5 47.4-23.2l88 24C499.9 30.2 512 46 512 64c0 247.4-200.6 448-448 448-18 0-33.8-12.1-38.6-29.5l-24-88c-5.3-19.4 4.6-39.7 23.2-47.4l96-40c16.3-6.8 35.2-2.1 46.3 11.6l40.4 49.3c70.4-33.3 127.4-90.3 160.7-160.7L318.7 167c-13.7-11.2-18.4-30-11.6-46.3l40-96z"
        }
    ]
};

const FasPhoneHangup = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPhoneHangup",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m11.7 266.3 41.9 94.3c6.1 13.7 20.8 21.3 35.5 18.4l109.2-21.8c15-3 25.7-16.1 25.7-31.4V240c62.3-20.8 129.7-20.8 192 0v85.8c0 15.3 10.8 28.4 25.7 31.4L550.9 379c14.7 2.9 29.4-4.7 35.5-18.4l41.9-94.3c7.2-16.2 5.1-35.1-7.4-47.7C570.8 168.1 464.2 96 320 96S69.2 168.1 19.1 218.6c-12.5 12.6-14.6 31.5-7.4 47.7z"
        }
    ]
};

const FasPhoneIntercom = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPhoneIntercom",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 32h32c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48zm112 64c0-35.3 28.7-64 64-64h224c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H224c-35.3 0-64-28.7-64-64V96zm160 272a48 48 0 1 0-96 0 48 48 0 1 0 96 0zm48-48c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16h-64zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16h-64zM224 128v96c0 17.7 14.3 32 32 32h160c17.7 0 32-14.3 32-32v-96c0-17.7-14.3-32-32-32H256c-17.7 0-32 14.3-32 32z"
        }
    ]
};

const FasPhoneMissed = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPhoneMissed",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M232 0c9.7 0 18.5 5.8 22.2 14.8s1.7 19.3-5.2 26.2l-39 39 58.7 58.7c13.6 13.7 32.1 21.3 51.3 21.3s37.7-7.6 51.3-21.3L503 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L405.3 172.7C382.6 195.3 352 208 320 208s-62.6-12.7-85.3-35.3L176 113.9l-39 39c-6.9 6.9-17.2 8.9-26.2 5.2S96 145.6 96 135.9V24c0-13.3 10.7-24 24-24h112zM51.4 489.9l-35.4-62c-9.7-16.9-8.3-38.1 5.5-51.7C72.6 325.9 178.1 256 320 256s247.4 69.9 298.5 120.2c13.9 13.6 15.2 34.8 5.5 51.7l-35.4 62c-7.4 12.9-22.7 19.1-37 14.8l-112.8-33.9c-13.5-4.1-22.8-16.5-22.8-30.6V384c-62.3-20.8-129.7-20.8-192 0v56.2c0 14.1-9.3 26.6-22.8 30.6L88.4 504.7c-14.3 4.3-29.6-1.8-37-14.8z"
        }
    ]
};

const FasPhoneOffice = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPhoneOffice",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 0c-17.7 0-32 14.3-32 32v352c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32h-64zM64 32C28.7 32 0 60.7 0 96v352c0 35.3 28.7 64 64 64h448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H256v352c0 35.3-28.7 64-64 64h-64c-35.3 0-64-28.7-64-64V32zm256 96c0-17.7 14.3-32 32-32h128c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32v-32zm32 192a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm160-32a32 32 0 1 1-64 0 32 32 0 1 1 64 0zm-32 160a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm-96-32a32 32 0 1 1-64 0 32 32 0 1 1 64 0z"
        }
    ]
};

const FasPhonePlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPhonePlus",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M456 200v-64h-64c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V24c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24h-64v64c0 13.3-10.7 24-24 24s-24-10.7-24-24zM181.5 1.4c19.4-5.3 39.7 4.6 47.4 23.2l40 96c6.8 16.3 2.1 35.2-11.6 46.3L208 207.3c33.3 70.4 90.3 127.4 160.7 160.7l40.3-49.3c11.2-13.7 30-18.4 46.3-11.6l96 40c18.6 7.7 28.5 28 23.2 47.4l-24 88C545.8 499.9 530 512 512 512 264.6 512 64 311.4 64 64c0-18 12.1-33.8 29.5-38.6l88-24z"
        }
    ]
};

const FasPhoneRotary = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPhoneRotary",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 141.3c0-8.5 3.4-16.6 9.9-22.1C38.2 95.4 125.9 32 256 32s217.8 63.4 246.1 87.2c6.5 5.5 9.9 13.6 9.9 22.1V176c0 17.7-14.3 32-32 32h-42.3c-13.1 0-24.9-8-29.7-20.1l-19.4-48.6c-2.9-7.3-8.4-13.2-15.7-16-18.6-7-59.5-19.3-116.8-19.3s-98.2 12.3-116.8 19.3c-7.3 2.8-12.8 8.7-15.7 16L104 187.9C99.2 200 87.4 208 74.3 208H32c-17.7 0-32-14.3-32-32v-34.7zM32 432v-31c0-11.1 2.9-22.1 8.4-31.8l101.1-177c11.5-19.9 32.7-32.2 55.6-32.2h117.8c23 0 44.2 12.3 55.6 32.2l101.1 177c5.5 9.7 8.4 20.6 8.4 31.8v31c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48zm296-120a72 72 0 1 0-144 0 72 72 0 1 0 144 0z"
        }
    ]
};

const FasPhoneSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPhoneSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M228.9 24.6c-7.7-18.6-28-28.5-47.4-23.2l-88 24C76.1 30.2 64 46 64 64c0 107.4 37.8 206 100.8 283.1L9.2 469.1c-10.4 8.2-12.3 23.3-4.1 33.7s23.3 12.3 33.7 4.1l592-464c10.4-8.2 12.3-23.3 4.1-33.7s-23.3-12.3-33.7-4.1L253 278c-17.8-21.5-32.9-45.2-45-70.7l49.3-40.3c13.7-11.2 18.4-30 11.6-46.3l-40-96zm96.8 319-91.3 72C310.7 476 407.1 512 512 512c18 0 33.8-12.1 38.6-29.5l24-88c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6L368.7 368c-15-7.1-29.3-15.2-43-24.3z"
        }
    ]
};

const FasPhoneVolume = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPhoneVolume",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M280 0c128.1 0 232 103.9 232 232 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-101.6-82.4-184-184-184-13.3 0-24-10.7-24-24s10.7-24 24-24zm8 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-32-72c0-13.3 10.7-24 24-24 75.1 0 136 60.9 136 136 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-48.6-39.4-88-88-88-13.3 0-24-10.7-24-24zM117.5 1.4c19.4-5.3 39.7 4.6 47.4 23.2l40 96c6.8 16.3 2.1 35.2-11.6 46.3L144 207.3c33.3 70.4 90.3 127.4 160.7 160.7l40.3-49.3c11.2-13.7 30-18.4 46.3-11.6l96 40c18.6 7.7 28.5 28 23.2 47.4l-24 88C481.8 499.9 466 512 448 512 200.6 512 0 311.4 0 64c0-18 12.1-33.8 29.5-38.6l88-24z"
        }
    ]
};

const FasPhoneXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPhoneXmark",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M181.5 1.4c19.4-5.3 39.7 4.6 47.4 23.2l40 96c6.8 16.3 2.1 35.2-11.6 46.3L208 207.3c33.3 70.4 90.3 127.4 160.7 160.7l40.3-49.3c11.2-13.7 30-18.4 46.3-11.6l96 40c18.6 7.7 28.5 28 23.2 47.4l-24 88C545.8 499.9 530 512 512 512 264.6 512 64 311.4 64 64c0-18 12.1-33.8 29.5-38.6l88-24zM399 15c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47L399 49c-9.4-9.4-9.4-24.6 0-33.9z"
        }
    ]
};

const FasPhone = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPhone",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M164.9 24.6c-7.7-18.6-28-28.5-47.4-23.2l-88 24C12.1 30.2 0 46 0 64c0 247.4 200.6 448 448 448 18 0 33.8-12.1 38.6-29.5l24-88c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6L304.7 368c-70.4-33.3-127.4-90.3-160.7-160.7l49.3-40.3c13.7-11.2 18.4-30 11.6-46.3l-40-96z"
        }
    ]
};

const FasPhotoFilmMusic = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPhotoFilmMusic",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 64c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v69.6c-12.9-6.1-27.9-7.1-41.7-2.5l-98.9 33-37.8-60.5c-2.9-4.7-8.1-7.5-13.6-7.5s-10.6 2.8-13.6 7.5L388 177.9l-15.3-19.7c-3-3.9-7.7-6.2-12.6-6.2s-9.6 2.3-12.6 6.2l-56 72c-3.8 4.8-4.4 11.4-1.7 16.9s8.3 9 14.4 9h64v64H256c-35.3 0-64-28.7-64-64V64zm127.5 340.6c-13.8 10.3-25.2 25.2-29.6 43.4H64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64h96v264c0 17.7 14.3 32 32 32h150.2c-8.2 3.3-15.8 7.5-22.6 12.6zM320 96a32 32 0 1 0-64 0 32 32 0 1 0 64 0zM56 168v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16H72c-8.8 0-16 7.2-16 16zm16 80c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16H72zM56 360v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16H72c-8.8 0-16 7.2-16 16zm574-195.5c6.3 4.5 10 11.8 10 19.5v208c0 1.2-.1 2.4-.3 3.6.2 1.5.3 2.9.3 4.4 0 26.5-28.7 48-64 48s-64-21.5-64-48 28.7-48 64-48c5.5 0 10.9.5 16 1.5v-88.2l-144 48V464c0 26.5-28.7 48-64 48s-64-21.5-64-48 28.7-48 64-48c5.5 0 10.9.5 16 1.5V248c0-10.3 6.6-19.5 16.4-22.8l192-64c7.3-2.4 15.4-1.2 21.6 3.3z"
        }
    ]
};

const FasPhotoFilm = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPhotoFilm",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 0h320c35.3 0 64 28.7 64 64v224c0 35.3-28.7 64-64 64H256c-35.3 0-64-28.7-64-64V64c0-35.3 28.7-64 64-64zm220 106.7C471.5 100 464 96 456 96s-15.5 4-20 10.7l-56 84-17.3-21.7c-4.6-5.7-11.5-9-18.7-9s-14.2 3.3-18.7 9l-64 80c-5.8 7.2-6.9 17.1-2.9 25.4S270.8 288 280 288h272c8.9 0 17-4.9 21.2-12.7s3.7-17.3-1.2-24.6l-96-144zM336 96a32 32 0 1 0-64 0 32 32 0 1 0 64 0zM64 128h96v288c0 17.7 14.3 32 32 32h128c17.7 0 32-14.3 32-32v-32h160v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192c0-35.3 28.7-64 64-64zm8 64c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16H72zm0 104c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16H72zm0 104c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16H72zm336 16v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16h-16c-8.8 0-16 7.2-16 16z"
        }
    ]
};

const FasPi = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPi",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 64C14.3 64 0 78.3 0 96s14.3 32 32 32h64v156c0 39.7-9.3 78.9-27 114.5l-1.6 3.2c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3l1.6-3.2C148.4 382.7 160 333.7 160 284V128h128v238.6c0 45 36.5 81.4 81.4 81.4 30.8 0 59-17.4 72.8-45l2.3-4.7c7.9-15.8 1.5-35-14.3-42.9s-35-1.5-42.9 14.3l-2.3 4.7c-3 5.9-9 9.6-15.6 9.6-9.6 0-17.4-7.8-17.4-17.4V128h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"
        }
    ]
};

const FasPianoKeyboard = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPianoKeyboard",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64C28.7 64 0 92.7 0 128v256c0 35.3 28.7 64 64 64h448c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm448 160v160h-80v-68.3c9.6-5.5 16-15.9 16-27.7v-64h64zM400 384h-96v-68.3c9.6-5.5 16-15.9 16-27.7v-64h64v64c0 11.8 6.4 22.2 16 27.7V384zm-128 0h-96v-68.3c9.6-5.5 16-15.9 16-27.7v-64h64v64c0 11.8 6.4 22.2 16 27.7V384zm-128 0H64V224h64v64c0 11.8 6.4 22.2 16 27.7V384z"
        }
    ]
};

const FasPiano = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPiano",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 192v256c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V327.6c0-24.2-13.7-46.4-35.4-57.2l-58.4-29.2c-21-10.5-34.2-31.9-34.2-55.4C384 83.2 300.8 0 198.3 0H192C86 0 0 86 0 192zm416 160h32v96H64v-96h32v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48h32v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48h32v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48h64v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48h32v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48z"
        }
    ]
};

const FasPickaxe = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPickaxe",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m462.4 373.5-.1-.2-.3-.8c-.3-.7-.7-1.8-1.3-3.3-1.2-2.9-3-7.2-5.5-12.7-5-11-12.6-26.7-23.1-45.3-21-37.3-53.6-86-99.5-132s-94.7-78.5-132-99.5c-18.6-10.5-34.3-18.1-45.3-23.1-5.5-2.5-9.8-4.3-12.7-5.5-1.4-.6-2.5-1-3.3-1.3l-.8-.3-.2-.1c-6.2-2.3-10.4-8.2-10.5-14.8s3.9-12.6 10-15.1C169.5 7 204 0 240 0c59.6 0 114.7 19.2 159.5 51.6l9.4-9.8c6-6.2 14.2-9.7 22.8-9.8s16.9 3.3 22.9 9.4l16 16c6.1 6.1 9.5 14.3 9.4 22.9s-3.6 16.8-9.8 22.8l-9.8 9.4C492.8 157.3 512 212.4 512 272c0 36-7 70.5-19.8 102-2.5 6.1-8.5 10.1-15.1 10s-12.5-4.3-14.8-10.5zM9.4 502.6c-12.4-12.3-12.5-32.2-.5-44.8l272-282.9c9.7 8.4 19.5 17.4 29.1 27s18.6 19.4 27 29.1L54.2 503.1c-12.6 12.1-32.5 11.9-44.8-.4z"
        }
    ]
};

const FasPickleball = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPickleball",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M250.4 28c37.5-37.4 98.4-37.4 136 0l113.5 113.3c29.2 29.2 35.7 72.4 19.4 107.8-24.9-15.8-54.4-25-86.1-25-72 0-133 47.3-153.3 112.5L155.7 212.8c-6.3-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L273 374.9c-.2 3-.3 6.1-.3 9.1 0 27.8 7.1 53.8 19.6 76.6-9.3.5-18.7-1-27.6-4.7L208 432.7c-23.9-9.8-51.4-4.3-69.6 13.9l-54 53.7c-15.6 15.6-41 15.6-56.7 0s-15.6-40.9 0-56.5l53.5-53.4c18.4-18.3 23.8-45.8 13.9-69.8l-24-57.8c-10-23.9-4.5-51.4 13.9-69.7L250.4 28zM304 384a128 128 0 1 1 256 0 128 128 0 1 1-256 0zm32-16a16 16 0 1 0 32 0 16 16 0 1 0-32 0zm80 80a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm0-64a16 16 0 1 0 32 0 16 16 0 1 0-32 0zm96 0a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm-80-80a16 16 0 1 0 32 0 16 16 0 1 0-32 0z"
        }
    ]
};

const FasPie = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPie",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M544 240c-7.6 0-14.3-4.9-17-12-37-95.9-130-164-239-164S86 132.1 49 228c-2.7 7.1-9.4 12-17 12-17.7 0-32 14.3-32 32 0 17.2 13.6 31.3 30.7 32 17.7-.5 35-7 48.7-14.2 7-3.6 12.7-7.3 16.7-10 2-1.4 3.5-2.5 4.5-3.2.5-.4.9-.7 1.1-.8l.2-.2 20.7.4.2.1c.2.2.5.4.9.8.9.7 2.2 1.8 4.1 3.1 3.7 2.6 9.1 6.2 16.1 9.8 14 7.2 33.4 14.2 56.1 14.2s42.2-7 56.1-14.2c7-3.6 12.4-7.2 16.1-9.8 1.8-1.3 3.2-2.4 4.1-3.1.4-.4.7-.6.9-.8l.1-.1c6.1-5.4 15.2-5.4 21.2 0l.1.1c.2.2.5.4.9.8.9.7 2.2 1.8 4.1 3.1 3.7 2.6 9.1 6.2 16.1 9.8 14 7.2 33.4 14.2 56.1 14.2s42.2-7 56.1-14.2c7-3.6 12.4-7.2 16.1-9.8 1.8-1.3 3.2-2.4 4.1-3.1.4-.4.7-.6.9-.8l.1-.1c5.9-5.2 14.6-5.4 20.7-.4l.2.2c.2.2.6.5 1.1.8 1 .7 2.5 1.9 4.5 3.2 4 2.7 9.7 6.4 16.7 10C510 297 527.4 303.5 545 304c17.1-.7 30.7-14.7 30.7-32 0-17.7-14.3-32-32-32zm-421.4 36c-5.9-5.2-14.6-5.4-20.7-.4l20.7.4zM81.4 404.2c8.7 26.1 33.2 43.8 60.7 43.8h291.8c27.5 0 52-17.6 60.7-43.8l24-71.9c-14.2-3.5-26.8-9-36.8-14.2-7-3.7-12.9-7.3-17.5-10.3-4.5 3.1-10.3 6.7-17.4 10.4C429.8 327 405.2 336 376 336s-53.8-9-70.8-17.8c-6.9-3.6-12.7-7.2-17.2-10.2-4.5 3-10.2 6.6-17.2 10.2-17 8.8-41.6 17.8-70.8 17.8s-53.8-9-70.8-17.8c-7.1-3.6-12.9-7.3-17.4-10.4-4.6 3-10.5 6.7-17.5 10.3-10 5.2-22.7 10.7-36.8 14.2l24 71.9zm124.9-253-16 32c-4 7.9-13.6 11.1-21.5 7.2s-11.1-13.6-7.2-21.5l16-32c4-7.9 13.6-11.1 21.5-7.2s11.1 13.6 7.2 21.5zm192-14.3 16 32c4 7.9.7 17.5-7.2 21.5s-17.5.7-21.5-7.2l-16-32c-4-7.9-.7-17.5 7.2-21.5s17.5-.7 21.5 7.2zM304 144v32c0 8.8-7.2 16-16 16s-16-7.2-16-16v-32c0-8.8 7.2-16 16-16s16 7.2 16 16z"
        }
    ]
};

const FasPig = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPig",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M513.5 32c8 0 14.5 6.5 14.5 14.5V78c0 19.7-9 37.8-23.6 49.7 6.4 4.9 12.7 10.1 18.6 15.7 17.6-15.9 28.5-38.6 29-63.3h40c8.8 0 16 7.2 16 16v16c0 32.8-24.6 59.8-56.3 63.5l6.8 9c11.5 15.4 26.5 27.9 43.7 36.5l5.8 2.9h8c13.3 0 24 10.7 24 24v96c0 13.3-10.7 24-24 24h-43.5c-22.2 21.2-49.7 36.2-79.8 43.3l-13 45.5c-3.9 13.7-16.4 23.2-30.7 23.2h-33c-17.7 0-32-14.3-32-32v-32H272v32c0 17.7-14.3 32-32 32h-33c-14.3 0-26.8-9.5-30.8-23.2L155 382.4C110.3 358 80 310.5 80 256v-16H47.4C21.2 240 0 218.8 0 192.6c0-21.8 14.8-40.7 35.9-46l8.2-2c8.6-2.1 17.3 3.1 19.4 11.6s-3.1 17.3-11.6 19.4l-8.2 2c-6.9 1.7-11.7 7.9-11.7 15 0 8.5 6.9 15.4 15.4 15.4h35.8C98 135 162.6 80 240 80h122.4c14.5 0 28.8 1.3 42.7 3.9 8.1-19.5 25.4-34.4 47-39.1l58.4-12.5c1-.2 2-.3 3-.3zM468 256a20 20 0 1 0 0-40 20 20 0 1 0 0 40z"
        }
    ]
};

const FasPiggyBank = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPiggyBank",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M400 96v.7c-5.3-.4-10.6-.7-16-.7H256c-16.5 0-32.5 2.1-47.8 6-.1-2-.2-4-.2-6 0-53 43-96 96-96s96 43 96 96zm-16 32c3.5 0 7 .1 10.4.3 4.2.3 8.4.7 12.6 1.3 17.6-20.5 43.8-33.6 73-33.6h11.5c10.4 0 18 9.8 15.5 19.9l-13.8 55.2c15.8 14.8 28.7 32.8 37.5 52.9H544c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32h-32c-9.1 12.1-19.9 22.9-32 32v64c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32v-32H256v32c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32v-64c-34.9-26.2-58.7-66.3-63.2-112H68c-37.6 0-68-30.4-68-68s30.4-68 68-68h4c13.3 0 24 10.7 24 24s-10.7 24-24 24h-4c-11 0-20 9-20 20s9 20 20 20h31.2c12.1-59.8 57.7-107.5 116.3-122.8 12.9-3.4 26.5-5.2 40.5-5.2h128zm64 136a24 24 0 1 0-48 0 24 24 0 1 0 48 0z"
        }
    ]
};

const FasPills = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPills",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M112 96c-26.5 0-48 21.5-48 48v112h96V144c0-26.5-21.5-48-48-48zM0 144C0 82.1 50.1 32 112 32s112 50.1 112 112v224c0 61.9-50.1 112-112 112S0 429.9 0 368V144zm554.9 255.4c-7.1 12.3-23.7 13.1-33.8 3.1L333.5 214.9c-10-10-9.3-26.7 3.1-33.8C360 167.7 387.1 160 416 160c88.4 0 160 71.6 160 160 0 28.9-7.7 56-21.1 79.4zm-59.5 59.5C472 472.3 444.9 480 416 480c-88.4 0-160-71.6-160-160 0-28.9 7.7-56 21.1-79.4 7.1-12.3 23.7-13.1 33.8-3.1l187.6 187.6c10 10 9.3 26.7-3.1 33.8z"
        }
    ]
};

const FasPinata = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPinata",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M112 318.1v-63.4l25.8 9.9c14.7 5.6 31.1 4.9 45.1-2.2l76.9-38.4H432c44.2 0 80 35.8 80 80v13.2l-23.3 9.3-19.1-9.6c-8.2-4.1-17.7-4.5-26.2-1.1l-26.7 10.7-19.1-9.6c-8.2-4.1-17.7-4.5-26.2-1.1l-26.7 10.7-19.1-9.6c-8.2-4.1-17.7-4.5-26.2-1.1l-26.7 10.7-19.1-9.6c-8.2-4.1-17.7-4.5-26.2-1.1l-26.7 10.7-19.1-9.6c-8.2-4.1-17.7-4.5-26.2-1.1l-26.7 10.7-16.7-8.4zm0 35.8 2.4 1.2c8.2 4.1 17.7 4.5 26.2 1.1l26.7-10.7 19.1 9.6c8.2 4.1 17.7 4.5 26.2 1.1l26.7-10.7 19.1 9.6c8.2 4.1 17.7 4.5 26.2 1.1l26.7-10.7 19.1 9.6c8.2 4.1 17.7 4.5 26.2 1.1l26.7-10.7 19.1 9.6c8.2 4.1 17.7 4.5 26.2 1.1l26.7-10.7 19.1 9.6c8.2 4.1 17.7 4.5 26.2 1.1l11.4-4.6v50.5l-24 12-17.7-8.8c-9-4.5-19.6-4.5-28.6 0l-16.5 8.3-16.3-10.8c-2.6-1.8-5.7-2.7-8.9-2.7H224c-3.2 0-6.2.9-8.9 2.7l-16.3 10.8-16.5-8.3c-9-4.5-19.6-4.5-28.6 0l-17.7 8.8-24-12v-48.2zm37.3-119.2L34.4 190.6c-21-11-34.4-32.8-34.4-56.8V128c0-35.3 28.7-64 64-64h112V32c0-17.7 14.3-32 32-32s32 14.3 32 32v166.1l-71.4 35.7c-6 3-13.1 3.4-19.3.9zM112 437.9l9.7 4.8c9 4.5 19.6 4.5 28.6 0l17.7-8.8 16.5 8.3c10.3 5.1 22.5 4.4 32.1-2l7.4-4.9V480c0 17.7-14.3 32-32 32h-48c-17.7 0-32-14.3-32-32v-42.1zm288-2.7 7.4 4.9c9.6 6.4 21.8 7.1 32.1 2l16.5-8.3 17.7 8.8c9 4.5 19.6 4.5 28.6 0l9.7-4.8V480c0 17.7-14.3 32-32 32h-48c-17.7 0-32-14.3-32-32v-44.8zM200 144a24 24 0 1 0-48 0 24 24 0 1 0 48 0z"
        }
    ]
};

const FasPinball = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPinball",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 224a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm22.1 254.4c14.9 4.8 30.7-1.8 37.9-15 7.4-13.5 4.2-30.8-8.4-40.6l-246-208.3C117 180.4 56.4 185.7 22.4 226.3S-6.3 327.5 34.3 361.6c9.2 7.7 19.9 13.8 32 17.7l307.8 99.1zM64 288a32 32 0 1 1 64 0 32 32 0 1 1-64 0z"
        }
    ]
};

const FasPineapple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPineapple",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M431.5 12.1c-1.1-4.5-4.2-8.4-8.4-10.5s-9.1-2.2-13.4-.4c-15.9 6.9-26.7 19.6-31.6 34.2l-14.8-14.7c-6.2-6.2-16.4-6.2-22.6 0-15.4 15.4-23.6 35.3-24.5 55.5-18.9-8-39.3-12.2-60.2-12.2-41 0-80.3 16.3-109.3 45.3L45.3 210.7C16.3 239.7 0 279 0 320s16.3 80.3 45.3 109.3l37.5 37.5c29 29 68.3 45.3 109.3 45.3s80.3-16.3 109.3-45.3l101.3-101.5c29-29 45.3-68.3 45.3-109.3 0-20.9-4.2-41.3-12.2-60.2 20.2-.9 40.1-9.1 55.5-24.5 6.2-6.2 6.2-16.4 0-22.6L476.6 134c14.6-4.9 27.3-15.8 34.1-31.6 1.8-4.3 1.7-9.2-.4-13.4s-5.9-7.3-10.5-8.4L485.5 77c6.9-12 10.5-25.6 10.5-39.5V32c0-8.8-7.2-16-16-16h-5.5c-13.9 0-27.5 3.6-39.4 10.4l-3.6-14.3zM164.7 212.7c6.2-6.2 16.4-6.2 22.6 0l20.7 20.7 20.7-20.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-32 32c-6.2 6.2-16.4 6.2-22.6 0l-32-32c-6.2-6.2-6.2-16.4 0-22.6zm-80 80c6.2-6.2 16.4-6.2 22.6 0l20.7 20.7 20.7-20.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-32 32c-6.2 6.2-16.4 6.2-22.6 0l-32-32c-6.2-6.2-6.2-16.4 0-22.6zm182.6 0 20.7 20.7 20.7-20.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-32 32c-6.2 6.2-16.4 6.2-22.6 0l-32-32c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zM164.7 395.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l20.7 20.7 20.7-20.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-32 32c-6.2 6.2-16.4 6.2-22.6 0l-32-32z"
        }
    ]
};

const FasPipeCircleCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPipeCircleCheck",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 96c17.7 0 32 14.3 32 32v256c0 17.7-14.3 32-32 32S0 401.7 0 384V128c0-17.7 14.3-32 32-32zm448 0c17.7 0 32 14.3 32 32v64.7c-5.3-.5-10.6-.7-16-.7-16.6 0-32.7 2.3-48 6.6V128c0-17.7 14.3-32 32-32zM320 368c0 5.4.2 10.7.7 16H96V128h320v83.2c-57 29.1-96 88.4-96 156.8zm32 0a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L480 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"
        }
    ]
};

const FasPipeCollar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPipeCollar",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M18.7 18.7c25-25 65.5-25 90.5 0L126 35.4C164.1 12.9 208.5 0 256 0s91.9 12.9 130 35.4l16.7-16.7c25-25 65.5-25 90.5 0s25 65.5 0 90.5L476.6 126c22.5 38.1 35.4 82.6 35.4 130s-12.9 91.9-35.4 130l16.7 16.7c25 25 25 65.5 0 90.5s-65.5 25-90.5 0L386 476.6c-38.1 22.5-82.5 35.4-130 35.4s-91.9-12.9-130-35.4l-16.7 16.7c-25 25-65.5 25-90.5 0s-25-65.5 0-90.5L35.4 386C12.9 347.9 0 303.5 0 256s12.9-91.9 35.4-130l-16.7-16.7c-25-25-25-65.5 0-90.5zM64 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm192 336a160 160 0 1 0 0-320 160 160 0 1 0 0 320zM80 448a16 16 0 1 0-32 0 16 16 0 1 0 32 0zM448 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16 368a16 16 0 1 0-32 0 16 16 0 1 0 32 0z"
        }
    ]
};

const FasPipeSection = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPipeSection",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 96c-17.7 0-32 14.3-32 32v256c0 17.7 14.3 32 32 32s32-14.3 32-32V128c0-17.7-14.3-32-32-32zm576 0c-17.7 0-32 14.3-32 32v256c0 17.7 14.3 32 32 32s32-14.3 32-32V128c0-17.7-14.3-32-32-32zm-64 32H96v256h448V128z"
        }
    ]
};

const FasPipeSmoking = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPipeSmoking",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M575.2 64c-32.1 0-62.1 16-79.9 42.7l-61.8 92.7c-3.9-4.8-8.6-9.1-14-12.7l-24-16c-4.7-3.2-9.7-5.6-14.9-7.4L442 71.2C471.7 26.7 521.7 0 575.2 0H608c17.7 0 32 14.3 32 32s-14.3 32-32 32h-32.8zM333.4 206.2c9.8-14.7 29.7-18.7 44.4-8.9l24 16c14.7 9.8 18.7 29.7 8.9 44.4L287.8 442.1c-29.2 43.7-78.2 69.9-130.7 69.9C70.3 512 0 441.7 0 354.9V272c0-26.5 21.5-48 48-48h160c26.5 0 48 21.5 48 48v50.3l77.4-116.1z"
        }
    ]
};

const FasPipeValve = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPipeValve",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 64c0-17.7-14.3-32-32-32s-32 14.3-32 32v12l-96-12c-17.7 0-32 14.3-32 32s14.3 32 32 32l128-16 128 16c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 12V64zm0 84.2-32-4-32 4V192H96v256h320V192H288v-43.8zM32 160c-17.7 0-32 14.3-32 32v256c0 17.7 14.3 32 32 32s32-14.3 32-32V192c0-17.7-14.3-32-32-32zm480 32c0-17.7-14.3-32-32-32s-32 14.3-32 32v256c0 17.7 14.3 32 32 32s32-14.3 32-32V192z"
        }
    ]
};

const FasPipe = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPipe",
    "viewBox": "0 0 64 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 0c17.7 0 32 14.3 32 32v448c0 17.7-14.3 32-32 32S0 497.7 0 480V32C0 14.3 14.3 0 32 0z"
        }
    ]
};

const FasPizzaSlice = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPizzaSlice",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M169.7.9c-22.8-1.6-41.9 14-47.5 34.7L110.4 80h1.6c176.7 0 320 143.3 320 320v1.6l44.4-11.8c20.8-5.5 36.3-24.7 34.7-47.5C498.5 159.5 352.5 13.5 169.7.9zm230.1 409.3c.1-3.4.2-6.8.2-10.2 0-159.1-128.9-288-288-288-3.4 0-6.8.1-10.2.2L.5 491.9c-1.5 5.5.1 11.4 4.1 15.4s9.9 5.6 15.4 4.1l379.8-101.2zM176 208a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64 128a32 32 0 1 1 64 0 32 32 0 1 1-64 0zM96 384a32 32 0 1 1 64 0 32 32 0 1 1-64 0z"
        }
    ]
};

const FasPizza = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPizza",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M385.2 419c10.4-8.2 25.5-8.4 34.9 1s9.4 24.7-.8 33.1C375 489.9 318.1 512 256 512 114.6 512 0 397.4 0 256S114.6 0 256 0c62.1 0 119 22.1 163.3 58.8 10.2 8.5 10.1 23.8.8 33.1s-24.5 9.2-34.9 1C349.7 64.8 304.8 48 256 48 141.1 48 48 141.1 48 256s93.1 208 208 208c48.8 0 93.7-16.8 129.2-45zm-16-49.9c6.2 6.2 6.3 16.5-.5 22.1-69.1 57.7-172.2 54.1-237.1-10.8-68.7-68.7-68.7-180.2 0-248.9 64.9-64.9 167.9-68.5 237-10.7 6.8 5.7 6.7 15.9.5 22.1L267.3 244.7c-6.2 6.2-6.2 16.4 0 22.6l101.8 101.8zM192 264a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm24-88a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm72 200a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm155.4-219.4c6.7-6.7 17.7-6.2 23 1.7 39.5 59 39.5 136.5 0 195.5-5.2 7.8-16.3 8.3-23 1.7l-88.1-88.1c-6.2-6.2-6.2-16.4 0-22.6l24.2-24.2c3.6 2.2 7.9 3.5 12.5 3.5 13.3 0 24-10.7 24-24 0-4.6-1.3-8.9-3.5-12.5l30.9-30.9zM472 280a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm22.4 126.4c-8.9-8.9-9.4-23.1-2.3-33.5C514.8 339.6 528 299.3 528 256s-13.2-83.6-35.9-116.9c-7.1-10.4-6.6-24.6 2.3-33.5 9.9-9.9 26.2-9.4 34.3 2C558.5 149.5 576 200.7 576 256s-17.5 106.5-47.4 148.4c-8.1 11.4-24.4 11.9-34.3 2z"
        }
    ]
};

const FasPlaceOfWorship = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPlaceOfWorship",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 109.3v108.3L183.3 242c-14.5 8.7-23.3 24.3-23.3 41.2V512h96v-96c0-35.3 28.7-64 64-64s64 28.7 64 64v96h96V283.2c0-16.9-8.8-32.5-23.3-41.2L416 217.6V109.3c0-8.5-3.4-16.6-9.4-22.6l-75.3-75.4c-6.2-6.2-16.4-6.2-22.6 0l-75.3 75.3c-6 6-9.4 14.1-9.4 22.6zm-199.1 221C9.5 338.8 0 354.9 0 372.4V464c0 26.5 21.5 48 48 48h80V273.6L24.9 330.3zM592 512c26.5 0 48-21.5 48-48v-91.6c0-17.5-9.5-33.6-24.9-42.1L512 273.6V512h80z"
        }
    ]
};

const FasPlaneArrival = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPlaneArrival",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M.3 166.9 0 68c0-10.3 9.5-17.9 19.5-15.7l35.6 7.9c10.6 2.3 19.2 9.9 23 20L96 128l127.3 37.6-41.5-145.2C178.9 10.2 186.6 0 197.2 0h40.1c11.6 0 22.2 6.2 27.9 16.3l109 193.8 107.2 31.7c15.9 4.7 30.8 12.5 43.7 22.8l34.4 27.6c24 19.2 18.1 57.3-10.7 68.2-41.2 15.6-86.2 18.1-128.8 7l-298.3-77.6c-11.1-2.9-21.2-8.7-29.3-16.9L9.5 189.4c-5.9-6-9.3-14-9.3-22.5zM32 448h576c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32zm96-80a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm128-16a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FasPlaneCircleCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPlaneCircleCheck",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 0c-35 0-64 59.5-64 93.7v84.6L8.1 283.4c-5 2.8-8.1 8.2-8.1 13.9v65.5c0 10.6 10.2 18.3 20.4 15.4l171.6-49v70.9l-57.6 43.2c-4 3-6.4 7.8-6.4 12.8v42c0 7.8 6.3 14 14 14 1.3 0 2.6-.2 3.9-.5L256 480l110.1 31.5c1.3.4 2.6.5 3.9.5 6 0 11.1-3.7 13.1-9-38.6-32.3-63.1-80.8-63.1-135 0-60.6 30.6-114 77.1-145.6L320 178.3V93.7C320 59.5 292 0 256 0zm384 368a144 144 0 1 0-288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l28.7 28.7 60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"
        }
    ]
};

const FasPlaneCircleExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPlaneCircleExclamation",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 0c-35 0-64 59.5-64 93.7v84.6L8.1 283.4c-5 2.8-8.1 8.2-8.1 13.9v65.5c0 10.6 10.2 18.3 20.4 15.4l171.6-49v70.9l-57.6 43.2c-4 3-6.4 7.8-6.4 12.8v42c0 7.8 6.3 14 14 14 1.3 0 2.6-.2 3.9-.5L256 480l110.1 31.5c1.3.4 2.6.5 3.9.5 6 0 11.1-3.7 13.1-9-38.6-32.3-63.1-80.8-63.1-135 0-60.6 30.6-114 77.1-145.6L320 178.3V93.7C320 59.5 292 0 256 0zm240 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16v-80c0-8.8 7.2-16 16-16z"
        }
    ]
};

const FasPlaneCircleXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPlaneCircleXmark",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 0c-35 0-64 59.5-64 93.7v84.6L8.1 283.4c-5 2.8-8.1 8.2-8.1 13.9v65.5c0 10.6 10.2 18.3 20.4 15.4l171.6-49v70.9l-57.6 43.2c-4 3-6.4 7.8-6.4 12.8v42c0 7.8 6.3 14 14 14 1.3 0 2.6-.2 3.9-.5L256 480l110.1 31.5c1.3.4 2.6.5 3.9.5 6 0 11.1-3.7 13.1-9-38.6-32.3-63.1-80.8-63.1-135 0-60.6 30.6-114 77.1-145.6L320 178.3V93.7C320 59.5 292 0 256 0zm240 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L518.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l36.7-36.7-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l36.7 36.7 36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
        }
    ]
};

const FasPlaneDeparture = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPlaneDeparture",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M381 114.9 186.1 41.8c-16.7-6.2-35.2-5.3-51.1 2.7L89.1 67.4C78 73 77.2 88.5 87.6 95.2l146.9 94.5L136 240l-58.2-25.9c-8.7-3.9-18.8-3.7-27.3.6l-32.2 16.1c-9.3 4.7-11.8 16.8-5 24.7l73.1 85.3c6.1 7.1 15 11.2 24.3 11.2h137.7c5 0 9.9-1.2 14.3-3.4l272.9-136.4c46.5-23.3 82.5-63.3 100.8-112C645.9 75 627.2 48 600.2 48h-57.4c-20.2 0-40.2 4.8-58.2 14L381 114.9zM0 480c0 17.7 14.3 32 32 32h576c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32z"
        }
    ]
};

const FasPlaneEngines = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPlaneEngines",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M576 256c0-35-59.5-64-93.7-64H365.7l-37.2-65.1C342 123.1 352 110.7 352 96c0-17.7-14.3-32-32-32h-27.4l-27.4-47.9C259.5 6.2 248.9 0 237.4 0h-56.2c-10.6 0-18.3 10.2-15.4 20.4l49 171.6H112l-43.2-57.6c-3-4-7.8-6.4-12.8-6.4H14c-7.8 0-14 6.3-14 14 0 1.3.2 2.6.5 3.9l22.7 79.3C9.8 229 0 241.4 0 256s9.8 27 23.2 30.8L.5 366.1c-.4 1.3-.5 2.6-.5 3.9 0 7.8 6.3 14 14 14h42c5 0 9.8-2.4 12.8-6.4L112 320h102.9l-49 171.6c-2.9 10.2 4.8 20.4 15.4 20.4h56.2c11.5 0 22.1-6.2 27.8-16.1l27.3-47.9H320c17.7 0 32-14.3 32-32 0-14.7-10-27.1-23.5-30.9l37.2-65.1h116.6c34.2 0 93.7-28 93.7-64z"
        }
    ]
};

const FasPlaneLock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPlaneLock",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 93.7C192 59.5 221 0 256 0c36 0 64 59.5 64 93.7v84.6l101.8 58.2c-3.8 11.1-5.8 23.1-5.8 35.5v24.6c-17.9 10.4-30.3 29.1-31.8 50.9L320 329.1V400l57.6 43.2c4 3 6.4 7.8 6.4 12.8v42c0 7.8-6.3 14-14 14-1.3 0-2.6-.2-3.9-.5L256 480l-110.1 31.5c-1.3.4-2.6.5-3.9.5-7.8 0-14-6.3-14-14v-42c0-5 2.4-9.8 6.4-12.8L192 400v-70.9l-171.6 49c-10.2 3-20.4-4.7-20.4-15.3v-65.5c0-5.7 3.1-11 8.1-13.9L192 178.3V93.7zM528 240c-17.7 0-32 14.3-32 32v48h64v-48c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32v128c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32v-48z"
        }
    ]
};

const FasPlaneProp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPlaneProp",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m240 384-8.3-66.4-110-11-7.9 63.4c-1 8-7.8 14-15.9 14H62.1c-8.1 0-14.9-6-15.9-14L36 287.8c-1.3.2-2.6.2-4 .2-17.7 0-32-14.3-32-32s14.3-32 32-32c1.3 0 2.7.1 4 .2L46.2 142c1-8 7.8-14 15.9-14h35.8c8.1 0 14.9 6 15.9 14l7.9 63.4 110-11L240 128h-16c-17.7 0-32-14.3-32-32s14.3-32 32-32h24l6.2-50c1-8 7.8-14 15.9-14h35.8c8.1 0 14.9 6 15.9 14l6.2 50h40V48c0-8.8 7.2-16 16-16s16 7.2 16 16v32c8.8 0 16 7.2 16 16s-7.2 16-16 16v32c0 8.8-7.2 16-16 16s-16-7.2-16-16v-16h-32l8 64h138.3c34.2 0 93.7 29 93.7 64 0 36-59.5 64-93.7 64H344l-8 64h32v-16c0-8.8 7.2-16 16-16s16 7.2 16 16v32c8.8 0 16 7.2 16 16s-7.2 16-16 16v32c0 8.8-7.2 16-16 16s-16-7.2-16-16v-16h-40l-6.2 50c-1 8-7.8 14-15.9 14h-35.8c-8.1 0-14.9-6-15.9-14l-6.2-50h-24c-17.7 0-32-14.3-32-32s14.3-32 32-32h16z"
        }
    ]
};

const FasPlaneSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPlaneSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M514.3 192c34.2 0 93.7 29 93.7 64 0 36-59.5 64-93.7 64h-73.7l190.2 149.1c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1l-592-464C-1.2 34.7-3.1 19.6 5.1 9.2S28.4-3.1 38.8 5.1l199.3 156.2-40.3-140.9C194.9 10.2 202.6 0 213.2 0h56.2c11.5 0 22.1 6.2 27.8 16.1L397.7 192h116.6zM41.5 128.7l321 252.9-65.3 114.3c-5.7 10-16.3 16.1-27.8 16.1h-56.2c-10.6 0-18.3-10.2-15.4-20.4l49-171.6H144l-43.2 57.6c-3 4-7.8 6.4-12.8 6.4H46c-7.8 0-14-6.3-14-14 0-1.3.2-2.6.5-3.9L64 256 32.5 145.9c-.4-1.3-.5-2.6-.5-3.9 0-6.2 4-11.4 9.5-13.3z"
        }
    ]
};

const FasPlaneTail = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPlaneTail",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M61.5 308.8.8 39C-3.7 19 11.5 0 32 0h76.9a64 64 0 0 1 46 19.5L384 256h128v256H267.7c-10.7 0-21.2-1.9-31.2-5.7L40.4 431.9C16.1 422.7 0 399.4 0 373.4c0-28.2 18.8-52.8 45.9-60.3l15.5-4.3zM216 352c-13.3 0-24 10.7-24 24s10.7 24 24 24h144c13.3 0 24-10.7 24-24s-10.7-24-24-24H216z"
        }
    ]
};

const FasPlaneUpSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPlaneUpSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L482.4 352.8l72.5 24.2c10.4 3.5 21.1-4.3 21.1-15.2v-56.7c0-10.7-5.3-20.7-14.2-26.6L384 160V93.7C384 59.5 356 0 320 0c-35 0-64 59.5-64 93.7V160l-10.6 7.1L38.8 5.1zm122.5 218-83.1 55.4c-8.9 5.9-14.2 15.9-14.2 26.6v56.7c0 10.9 10.7 18.6 21.1 15.2L256 320v80l-57.6 43.2c-4 3-6.4 7.8-6.4 12.8v42c0 7.8 6.3 14 14 14 1.3 0 2.6-.2 3.9-.5L320 480l110.1 31.5c1.3.4 2.6.5 3.9.5 7.8 0 14-6.3 14-14v-42.7c0-2.8-.7-5.6-2.1-8L161.3 223.1z"
        }
    ]
};

const FasPlaneUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPlaneUp",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 93.7C192 59.5 221 0 256 0c36 0 64 59.5 64 93.7V160l177.8 118.5c8.9 5.9 14.2 15.9 14.2 26.6v56.7c0 10.9-10.7 18.6-21.1 15.2L320 320v80l57.6 43.2c4 3 6.4 7.8 6.4 12.8v42c0 7.8-6.3 14-14 14-1.3 0-2.6-.2-3.9-.5L256 480l-110.1 31.5c-1.3.4-2.6.5-3.9.5-7.8 0-14-6.3-14-14v-42c0-5 2.4-9.8 6.4-12.8L192 400v-80L21.1 377C10.7 380.4 0 372.7 0 361.8v-56.7c0-10.7 5.3-20.7 14.2-26.6L192 160V93.7z"
        }
    ]
};

const FasPlane = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPlane",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M482.3 192c34.2 0 93.7 29 93.7 64 0 36-59.5 64-93.7 64H365.7L265.2 495.9c-5.7 10-16.3 16.1-27.8 16.1h-56.2c-10.6 0-18.3-10.2-15.4-20.4l49-171.6H112l-43.2 57.6c-3 4-7.8 6.4-12.8 6.4H14c-7.8 0-14-6.3-14-14 0-1.3.2-2.6.5-3.9L32 256 .5 145.9c-.4-1.3-.5-2.6-.5-3.9 0-7.8 6.3-14 14-14h42c5 0 9.8 2.4 12.8 6.4L112 192h102.9l-49-171.6c-3-10.2 4.7-20.4 15.3-20.4h56.2c11.5 0 22.1 6.2 27.8 16.1L365.7 192h116.6z"
        }
    ]
};

const FasPlanetMoon = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPlanetMoon",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 0a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM0 288a224 224 0 1 1 448 0 224 224 0 1 1-448 0zm236.2-175.6c-4-.3-8.1-.4-12.2-.4-76.2 0-141.1 48.4-165.6 116.2-5.1 14.1 6.3 27.8 21.3 27.8h28.4c12.7 0 24.9 5.1 33.9 14.1l43 42.9c4.5 4.5 7 10.6 7 17v22c0 9.2 3.9 17.6 10.2 23.4l1.9 1.8c9.3 8.6 19.9 18.4 19.9 30.8v23c0 13.8 11.2 25 25 25 9.2 0 17.7-5.1 22-13.2l41.3-76.6c5-9.3 7.6-19.8 7.6-30.3V320c0-17.7-14.3-32-32-32h-65.8c-9 0-17.7-3.6-24.1-10-12.5-12.5-13.4-32.4-2.1-45.9l52.7-63.2c4.8-5.8 7.4-13 7.4-20.5v-13.5c0-11.6-8.3-21.7-19.8-22.5z"
        }
    ]
};

const FasPlanetRinged = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPlanetRinged",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M319.7 319.7C456.6 182.8 539.1 43.3 503.9 8.1c-22.2-22.1-85.6 2.3-163.7 57.6C314.4 54.3 286 48 256 48 141.1 48 48 141.1 48 256c0 30 6.3 58.4 17.7 84.2C10.4 418.3-14 481.7 8.1 503.9c35.2 35.2 174.7-47.3 311.6-184.2zM256 464c114.9 0 208-93.1 208-208 0-16.1-1.8-31.8-5.3-46.9-31.8 42.6-71.4 88.2-116.4 133.2s-90.6 84.6-133.2 116.4c15.1 3.5 30.7 5.3 46.9 5.3z"
        }
    ]
};

const FasPlantWilt = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPlantWilt",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 120c0-30.9 25.1-56 56-56s56 25.1 56 56v13c-29.3 10-48 34.5-48 70.1 0 27.9 25.3 74.8 66 111.6 3.8 3.5 8.9 5.3 14 5.3s10.2-1.8 14-5.3c40.7-36.8 66-83.7 66-111.6 0-35.6-18.7-60.2-48-70.1v-13C464 53.7 410.3 0 344 0S224 53.7 224 120v21.8c-16.7-8.8-35.8-13.8-56-13.8-66.3 0-120 53.7-120 120v13c-29.3 10-48 34.5-48 70.1 0 27.9 25.3 74.8 66 111.6 3.8 3.5 8.9 5.3 14 5.3s10.2-1.8 14-5.3c40.7-36.8 66-83.7 66-111.6 0-35.6-18.7-60.2-48-70.1v-13c0-30.9 25.1-56 56-56s56 25.1 56 56v232c0 17.7 14.3 32 32 32s32-14.3 32-32V120z"
        }
    ]
};

const FasPlateUtensils = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPlateUtensils",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M40.7 16c4 .3 7.1 3.5 7.3 7.5L55.5 152h17.4L88.1 23.1c.5-4 3.9-7.1 7.9-7.1s7.5 3 7.9 7.1L119.1 152h17.3L144 23.5c.2-4 3.3-7.2 7.3-7.5s7.6 2.3 8.5 6.1l30.3 128.7c1.3 5.4 1.9 11 1.9 16.6 0 39.9-32.2 72.2-72 72.5V472c0 13.3-10.7 24-24 24s-24-10.7-24-24V240c-39.8-.3-72-32.6-72-72.5 0-5.6.6-11.2 1.9-16.6L32.2 22.2c.9-3.9 4.5-6.5 8.5-6.1zm572.4 1c2-.7 4-1 6.1-1 11.5 0 20.9 9.3 20.9 20.9V472c0 13.3-10.7 24-24 24s-24-10.7-24-24V320H544c-17.7 0-32-14.3-32-32V160c0-100.8 84.2-136.8 101.1-143zM221.2 143.6l-16.3-69.3C241.8 47.7 287.1 32 336 32c60.3 0 115 23.8 155.3 62.5-7 18.8-11.3 40.5-11.3 65.5v26.2C454.1 132.8 399.3 96 336 96c-44.9 0-85.5 18.5-114.6 48.3l-.2-.8zM336 480c-76.2 0-143.5-38.1-184-96.2v-117c8.5-2.8 16.6-6.7 24-11.4v.6c0 88.4 71.6 160 160 160 68.1 0 126.2-42.5 149.3-102.4 9.2 21 29.3 36.2 53.2 38.2C502.6 427.6 425.4 480 336 480zM208 256a128 128 0 1 1 256 0 128 128 0 1 1-256 0z"
        }
    ]
};

const FasPlateWheat = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPlateWheat",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 32c44.2 0 80 35.8 80 80v16c0 8.8-7.2 16-16 16-44.2 0-80-35.8-80-80V48c0-8.8 7.2-16 16-16zM56 64h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-13.3 0-24-10.7-24-24s10.7-24 24-24zm-32 72h112c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24zm8 96c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-13.3 0-24-10.7-24-24zM272 48c0-8.8 7.2-16 16-16 44.2 0 80 35.8 80 80v16c0 8.8-7.2 16-16 16-44.2 0-80-35.8-80-80V48zm128-16c44.2 0 80 35.8 80 80v16c0 8.8-7.2 16-16 16-44.2 0-80-35.8-80-80V48c0-8.8 7.2-16 16-16zm80 160v16c0 44.2-35.8 80-80 80-8.8 0-16-7.2-16-16v-16c0-44.2 35.8-80 80-80 8.8 0 16 7.2 16 16zm-128-16c8.8 0 16 7.2 16 16v16c0 44.2-35.8 80-80 80-8.8 0-16-7.2-16-16v-16c0-44.2 35.8-80 80-80zm-96 16v16c0 44.2-35.8 80-80 80-8.8 0-16-7.2-16-16v-16c0-44.2 35.8-80 80-80 8.8 0 16 7.2 16 16zM3.5 347.6C1.6 332.9 13 320 27.8 320h456.4c14.8 0 26.2 12.9 24.4 27.6-6.3 50.2-44.4 89.4-92.6 98.4v2c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32v-2c-48.2-9-86.3-48.2-92.5-98.4z"
        }
    ]
};

const FasPlayPause = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPlayPause",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M116.5 71.4c-9.5-7.9-22.8-9.7-34.1-4.4S64 83.6 64 96v320c0 12.4 7.2 23.7 18.4 29s24.5 3.6 34.1-4.4l192-160c7.3-6.1 11.5-15.1 11.5-24.6s-4.2-18.5-11.5-24.6l-192-160zM448 96c0-17.7-14.3-32-32-32s-32 14.3-32 32v320c0 17.7 14.3 32 32 32s32-14.3 32-32V96zm128 0c0-17.7-14.3-32-32-32s-32 14.3-32 32v320c0 17.7 14.3 32 32 32s32-14.3 32-32V96z"
        }
    ]
};

const FasPlay = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPlay",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M73 39c-14.8-9.1-33.4-9.4-48.5-.9S0 62.6 0 80v352c0 17.4 9.4 33.4 24.5 41.9S58.2 482 73 473l288-176c14.3-8.7 23-24.2 23-41s-8.7-32.2-23-41L73 39z"
        }
    ]
};

const FasPlugCircleBolt = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPlugCircleBolt",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 0C78.3 0 64 14.3 64 32v96h64V32c0-17.7-14.3-32-32-32zm192 0c-17.7 0-32 14.3-32 32v96h64V32c0-17.7-14.3-32-32-32zM32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32v32c0 77.4 55 142 128 156.8V480c0 17.7 14.3 32 32 32s32-14.3 32-32v-67.2c12.3-2.5 24.1-6.4 35.1-11.5-2.1-10.8-3.1-21.9-3.1-33.3 0-80.3 53.8-148 127.3-169.2.5-2.2.7-4.5.7-6.8 0-17.7-14.3-32-32-32H32zm400 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm47.9-225c4.3 3.7 5.4 9.9 2.6 14.9L452.4 356H488c5.2 0 9.8 3.3 11.4 8.2s-.1 10.3-4.2 13.4l-96 72c-4.5 3.4-10.8 3.2-15.1-.6s-5.4-9.9-2.6-14.9l30.1-54.1H376c-5.2 0-9.8-3.3-11.4-8.2s.1-10.3 4.2-13.4l96-72c4.5-3.4 10.8-3.2 15.1.6z"
        }
    ]
};

const FasPlugCircleCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPlugCircleCheck",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 0C78.3 0 64 14.3 64 32v96h64V32c0-17.7-14.3-32-32-32zm192 0c-17.7 0-32 14.3-32 32v96h64V32c0-17.7-14.3-32-32-32zM32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32v32c0 77.4 55 142 128 156.8V480c0 17.7 14.3 32 32 32s32-14.3 32-32v-67.2c12.3-2.5 24.1-6.4 35.1-11.5-2.1-10.8-3.1-21.9-3.1-33.3 0-80.3 53.8-148 127.3-169.2.5-2.2.7-4.5.7-6.8 0-17.7-14.3-32-32-32H32zm544 208a144 144 0 1 0-288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l28.7 28.7 60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"
        }
    ]
};

const FasPlugCircleExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPlugCircleExclamation",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 0C78.3 0 64 14.3 64 32v96h64V32c0-17.7-14.3-32-32-32zm192 0c-17.7 0-32 14.3-32 32v96h64V32c0-17.7-14.3-32-32-32zM32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32v32c0 77.4 55 142 128 156.8V480c0 17.7 14.3 32 32 32s32-14.3 32-32v-67.2c12.3-2.5 24.1-6.4 35.1-11.5-2.1-10.8-3.1-21.9-3.1-33.3 0-80.3 53.8-148 127.3-169.2.5-2.2.7-4.5.7-6.8 0-17.7-14.3-32-32-32H32zm400 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16v-80c0-8.8 7.2-16 16-16z"
        }
    ]
};

const FasPlugCircleMinus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPlugCircleMinus",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 0C78.3 0 64 14.3 64 32v96h64V32c0-17.7-14.3-32-32-32zm192 0c-17.7 0-32 14.3-32 32v96h64V32c0-17.7-14.3-32-32-32zM32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32v32c0 77.4 55 142 128 156.8V480c0 17.7 14.3 32 32 32s32-14.3 32-32v-67.2c12.3-2.5 24.1-6.4 35.1-11.5-2.1-10.8-3.1-21.9-3.1-33.3 0-80.3 53.8-148 127.3-169.2.5-2.2.7-4.5.7-6.8 0-17.7-14.3-32-32-32H32zm544 208a144 144 0 1 0-288 0 144 144 0 1 0 288 0zm-64 0c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16h128c8.8 0 16 7.2 16 16z"
        }
    ]
};

const FasPlugCirclePlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPlugCirclePlus",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 0C78.3 0 64 14.3 64 32v96h64V32c0-17.7-14.3-32-32-32zm192 0c-17.7 0-32 14.3-32 32v96h64V32c0-17.7-14.3-32-32-32zM32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32v32c0 77.4 55 142 128 156.8V480c0 17.7 14.3 32 32 32s32-14.3 32-32v-67.2c12.3-2.5 24.1-6.4 35.1-11.5-2.1-10.8-3.1-21.9-3.1-33.3 0-80.3 53.8-148 127.3-169.2.5-2.2.7-4.5.7-6.8 0-17.7-14.3-32-32-32H32zm400 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-208v48h48c8.8 0 16 7.2 16 16s-7.2 16-16 16h-48v48c0 8.8-7.2 16-16 16s-16-7.2-16-16v-48h-48c-8.8 0-16-7.2-16-16s7.2-16 16-16h48v-48c0-8.8 7.2-16 16-16s16 7.2 16 16z"
        }
    ]
};

const FasPlugCircleXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPlugCircleXmark",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 0C78.3 0 64 14.3 64 32v96h64V32c0-17.7-14.3-32-32-32zm192 0c-17.7 0-32 14.3-32 32v96h64V32c0-17.7-14.3-32-32-32zM32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32v32c0 77.4 55 142 128 156.8V480c0 17.7 14.3 32 32 32s32-14.3 32-32v-67.2c12.3-2.5 24.1-6.4 35.1-11.5-2.1-10.8-3.1-21.9-3.1-33.3 0-80.3 53.8-148 127.3-169.2.5-2.2.7-4.5.7-6.8 0-17.7-14.3-32-32-32H32zm400 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L454.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L432 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l36.7-36.7-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l36.7 36.7 36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
        }
    ]
};

const FasPlug = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPlug",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 0C78.3 0 64 14.3 64 32v96h64V32c0-17.7-14.3-32-32-32zm192 0c-17.7 0-32 14.3-32 32v96h64V32c0-17.7-14.3-32-32-32zM32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32v32c0 77.4 55 142 128 156.8V480c0 17.7 14.3 32 32 32s32-14.3 32-32v-67.2C297 398 352 333.4 352 256v-32c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"
        }
    ]
};

const FasPlusLarge = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPlusLarge",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32v192H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h192v192c0 17.7 14.3 32 32 32s32-14.3 32-32V288h192c17.7 0 32-14.3 32-32s-14.3-32-32-32H288V32z"
        }
    ]
};

const FasPlusMinus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPlusMinus",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 32c0-17.7-14.3-32-32-32s-32 14.3-32 32v112H48c-17.7 0-32 14.3-32 32s14.3 32 32 32h112v112c0 17.7 14.3 32 32 32s32-14.3 32-32V208h112c17.7 0 32-14.3 32-32s-14.3-32-32-32H224V32zM0 480c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32z"
        }
    ]
};

const FasPlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPlus",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32v144H48c-17.7 0-32 14.3-32 32s14.3 32 32 32h144v144c0 17.7 14.3 32 32 32s32-14.3 32-32V288h144c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z"
        }
    ]
};

const FasPodcast = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPodcast",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M319.4 372c48.5-31.3 80.6-85.9 80.6-148 0-97.2-78.8-176-176-176S48 126.8 48 224c0 62.1 32.1 116.6 80.6 148 1.2 17.3 4 38 7.2 57.1l.2 1C56 395.8 0 316.5 0 224 0 100.3 100.3 0 224 0s224 100.3 224 224c0 92.5-56 171.9-136 206.1l.2-1.1c3.1-19.2 6-39.8 7.2-57zm-2.3-38.1c-1.6-5.7-3.9-11.1-7-16.2-5.8-9.7-13.5-17-21.9-22.4 19.5-17.6 31.8-43 31.8-71.3 0-53-43-96-96-96s-96 43-96 96c0 28.3 12.3 53.8 31.8 71.3-8.4 5.4-16.1 12.7-21.9 22.4-3.1 5.1-5.4 10.5-7 16.2C99.8 307.5 80 268 80 224c0-79.5 64.5-144 144-144s144 64.5 144 144c0 44-19.8 83.5-50.9 109.9zM224 312c32.9 0 64 8.6 64 43.8 0 33-12.9 104.1-20.6 132.9-5.1 19-24.5 23.4-43.4 23.4s-38.2-4.4-43.4-23.4C172.8 460.2 160 389 160 355.9c0-35.1 31.1-43.8 64-43.8zm0-144a56 56 0 1 1 0 112 56 56 0 1 1 0-112z"
        }
    ]
};

const FasPodiumStar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPodiumStar",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M168 72c-22.1 0-40 17.9-40 40v32h296c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h56v-32c0-48.6 39.4-88 88-88h14.4C190.7 9.7 206.2 0 224 0h64c26.5 0 48 21.5 48 48s-21.5 48-48 48h-64c-17.8 0-33.3-9.7-41.6-24H168zM73.7 455.1 48 224h352l-25.7 231.1c-3.6 32.4-31 56.9-63.6 56.9H137.3c-32.6 0-60-24.5-63.6-56.9zm157.6-178.3c-2.9-6.4-11.7-6.4-14.5 0l-20.2 45.5c-1.2 2.6-3.6 4.4-6.3 4.8l-47.9 5.9c-6.8.8-9.5 9.5-4.5 14.3l35.4 34c2 2 3 4.9 2.4 7.7l-9.4 49.1c-1.3 6.9 5.8 12.3 11.8 8.9l42.1-24.4c2.4-1.4 5.4-1.4 7.8 0l42 24.3c6 3.5 13.1-1.9 11.8-8.9l-9.5-49c-.5-2.8.4-5.8 2.4-7.7l35.4-34c5-4.8 2.3-13.5-4.5-14.3l-47.8-6c-2.8-.3-5.2-2.1-6.3-4.8l-20.2-45.5z"
        }
    ]
};

const FasPodium = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPodium",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M182.4 72c8.3 14.3 23.8 24 41.6 24h64c26.5 0 48-21.5 48-48S314.5 0 288 0h-64c-17.8 0-33.3 9.7-41.6 24H168c-48.6 0-88 39.4-88 88v32H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h400c13.3 0 24-10.7 24-24s-10.7-24-24-24H128v-32c0-22.1 17.9-40 40-40h14.4zM48 224l25.7 231.1c3.6 32.4 31 56.9 63.6 56.9h173.4c32.6 0 60-24.5 63.6-56.9L400 224H48z"
        }
    ]
};

const FasPoliceBox = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPoliceBox",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 0c8.8 0 16 7.2 16 16v16h80c17.7 0 32 14.3 32 32 17.7 0 32 14.3 32 32v368h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h8V96c0-17.7 14.3-32 32-32 0-17.7 14.3-32 32-32h80V16c0-8.8 7.2-16 16-16zM96 136v24h32v-32h-24c-4.4 0-8 3.6-8 8zm0 40v24c0 4.4 3.6 8 8 8h24v-32H96zm72-48h-24v32h32v-24c0-4.4-3.6-8-8-8zm-24 48v32h24c4.4 0 8-3.6 8-8v-24h-32zm72-48c-4.4 0-8 3.6-8 8v24h32v-32h-24zm24 48h-32v24c0 4.4 3.6 8 8 8h24v-32zm16-48v32h32v-24c0-4.4-3.6-8-8-8h-24zm32 48h-32v32h24c4.4 0 8-3.6 8-8v-24zM96 256v48c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16v-48c0-8.8-7.2-16-16-16h-48c-8.8 0-16 7.2-16 16z"
        }
    ]
};

const FasPollPeople = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPollPeople",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 48a48 48 0 1 0-96 0 48 48 0 1 0 96 0zm448 80h-96V96h96v32zM272 32c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h320c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H272zm304 384H352v-32h224v32zm-304-96c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h320c26.5 0 48-21.5 48-48v-64c0-26.5-21.5-48-48-48H272zM64 128c-35.3 0-64 28.7-64 64 0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32 0-35.3-28.7-64-64-64H64zm64 208a48 48 0 1 0-96 0 48 48 0 1 0 96 0zm-64 80c-35.3 0-64 28.7-64 64 0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32 0-35.3-28.7-64-64-64H64z"
        }
    ]
};

const FasPompebled = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPompebled",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M460.3 172c-46.2-33.2-117-14.1-165.1 44.3-5.9 8.6-17.2 10.6-25.6 4.5s-10.3-17.6-4.4-26.2c36.9-66.9 29-141.3-17.7-173.5C188.6-20.6 103.1 1.5 56.9 70.4c-85.5 126.3-77.6 313.4 44.2 400.4 121.4 87 296.3 27.7 381.8-98.6 46.2-68.4 36.4-158.5-22.6-200.2z"
        }
    ]
};

const FasPooStorm = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPooStorm",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M236.9.2c-5.5-.7-11 1.4-14.5 5.7s-4.6 10.1-2.8 15.3c2.8 8.2 4.3 16.9 4.3 26.1 0 21.7-8.5 37.2-21.9 47.6-13.8 10.8-34 17-57.8 17H128c-35.3 0-64 28.7-64 64 0 12.2 3.4 23.5 9.3 33.2C31.7 216.2 0 252.4 0 296c0 41 28 75.4 65.8 85.2-5.3-18.5 1-38.5 16.2-50.7l160-128c17.6-14.1 42.6-14 60.2.2s22.8 38.6 12.8 58.8L285.7 320H304c20.4 0 38.5 12.9 45.3 32.1 3.7 10.6 3.5 21.8 0 31.9H360c48.6 0 88-39.4 88-88 0-43.6-31.7-79.8-73.3-86.8 5.9-9.7 9.3-21.1 9.3-33.2 0-35.3-28.7-64-64-64h-1.4c.9-5.4 1.4-10.9 1.4-16.6 0-48.7-36.1-88.9-83.1-95.2zM282 227.6c-5.8-4.7-14.2-4.7-20.1-.1l-160 128c-5.3 4.2-7.4 11.4-5.1 17.8s8.3 10.7 15.1 10.7H182l-52.3 104.8c-3.4 6.7-1.6 14.9 4.3 19.6s14.2 4.7 20.1.1l160-128c5.3-4.2 7.4-11.4 5.1-17.8s-8.3-10.7-15.1-10.7h-70.2l52.4-104.8c3.4-6.7 1.6-14.9-4.3-19.6z"
        }
    ]
};

const FasPoo = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPoo",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M268.9.9c-5.5-.7-11 1.4-14.5 5.7s-4.6 10.1-2.8 15.4c2.8 8.2 4.3 16.9 4.3 26.1 0 44.1-35.7 79.9-79.8 80H160c-35.3 0-64 28.7-64 64 0 19.1 8.4 36.3 21.7 48H104c-39.8 0-72 32.2-72 72 0 23.2 11 43.8 28 57-34.1 5.7-60 35.3-60 71 0 39.8 32.2 72 72 72h368c39.8 0 72-32.2 72-72 0-35.7-25.9-65.3-60-71 17-13.2 28-33.8 28-57 0-39.8-32.2-72-72-72h-13.7c13.3-11.7 21.7-28.9 21.7-48 0-35.3-28.7-64-64-64h-5.5c3.5-10 5.5-20.8 5.5-32 0-48.6-36.2-88.8-83.1-95.1zM192 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 32a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm64 108.3c0 2.4-.7 4.8-2.2 6.7-8.2 10.5-39.5 45-93.8 45s-85.6-34.6-93.8-45c-1.5-1.9-2.2-4.3-2.2-6.7 0-6.8 5.5-12.3 12.3-12.3h167.4c6.8 0 12.3 5.5 12.3 12.3z"
        }
    ]
};

const FasPool8Ball = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPool8Ball",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm384-64a128 128 0 1 0-256 0 128 128 0 1 0 256 0zm-80-48c0 11.5-4 22-10.7 30.2 11.5 10.3 18.7 25.2 18.7 41.8 0 30.9-25.1 56-56 56s-56-25.1-56-56c0-16.6 7.2-31.5 18.7-41.8C212 166 208 155.5 208 144c0-26.5 21.5-48 48-48s48 21.5 48 48zm-48 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm24 56a24 24 0 1 0-48 0 24 24 0 1 0 48 0z"
        }
    ]
};

const FasPoop = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPoop",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M254.4 6.6c3.5-4.3 9-6.5 14.5-5.7C315.8 7.2 352 47.4 352 96c0 11.2-1.9 22-5.5 32h5.5c35.3 0 64 28.7 64 64 0 19.1-8.4 36.3-21.7 48H408c39.8 0 72 32.2 72 72 0 23.2-11 43.8-28 57 34.1 5.7 60 35.3 60 71 0 39.8-32.2 72-72 72H72c-39.8 0-72-32.2-72-72 0-35.7 25.9-65.3 60-71-17-13.2-28-33.8-28-57 0-39.8 32.2-72 72-72h13.7C104.4 228.3 96 211.1 96 192c0-35.3 28.7-64 64-64h16.2c44.1-.1 79.8-35.9 79.8-80 0-9.2-1.5-17.9-4.3-26.1-1.8-5.2-.8-11.1 2.8-15.4z"
        }
    ]
};

const FasPopcorn = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPopcorn",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32.2 160c-.1-1.3-.2-2.7-.2-4 0-20.9 14.5-38.3 34-42.9-1.3-4.2-2-8.6-2-13.1 0-24.3 19.7-44 44-44 1.9 0 3.7.1 5.6.3C118.7 37.7 135.7 24 156 24c8.5 0 16.5 2.4 23.2 6.6C186.2 12.7 203.6 0 224 0s37.8 12.7 44.8 30.6c6.7-4.2 14.7-6.6 23.2-6.6 20.3 0 37.3 13.7 42.4 32.3 1.8-.2 3.7-.3 5.6-.3 24.3 0 44 19.7 44 44 0 4.6-.7 9-2 13.1 19.5 4.5 34 22 34 42.9 0 1.3-.1 2.7-.2 4H32.2zm-4 32h69.6l30.3 257.9c1 8.8 9 15.1 17.8 14s15.1-9 14-17.8L130 192h78v256c0 8.8 7.2 16 16 16s16-7.2 16-16V192h78l-29.9 254.1c-1 8.8 5.2 16.7 14 17.8s16.7-5.2 17.8-14L350.2 192h69.6c15.6 0 28.2 12.6 28.2 28.2 0 2.5-.3 5.1-1 7.5l-69.2 249.1c-5.8 20.8-24.7 35.2-46.3 35.2h-215c-21.6 0-40.5-14.4-46.2-35.2L1 227.7c-.7-2.5-1-5-1-7.5C0 204.6 12.6 192 28.2 192z"
        }
    ]
};

const FasPopsicle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPopsicle",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 0C71.6 0 0 71.6 0 160v176c0 26.5 21.5 48 48 48h224c26.5 0 48-21.5 48-48V160C320 71.6 248.4 0 160 0zm32 480v-64h-64v64c0 17.7 14.3 32 32 32s32-14.3 32-32z"
        }
    ]
};

const FasPotFood = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPotFood",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M112 24c0 26.5 10.5 38.7 25.9 56.1l.4.4C154.8 99 176 122.9 176 168c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-26.5-10.5-38.7-25.9-56.1l-.4-.4C85.2 93 64 69.1 64 24 64 10.7 74.7 0 88 0s24 10.7 24 24zm112 0c0 26.5 10.5 38.7 25.9 56.1l.4.4C266.8 99 288 122.9 288 168c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-26.5-10.5-38.7-25.9-56.1l-.4-.4C197.2 93 176 69.1 176 24c0-13.3 10.7-24 24-24s24 10.7 24 24zm208 88c50.7 0 93.6 33.7 107.4 80H324.6c13.8-46.3 56.6-80 107.4-80zM77.7 320H48c-17.7 0-32-14.3-32-32s14.3-32 32-32h17.9c-.2-17.5 14-32 31.7-32h444.8c17.7 0 31.9 14.5 31.7 32H592c17.7 0 32 14.3 32 32s-14.3 32-32 32h-29.7c-20.6 64-66.1 116.7-124.7 147.2l-1.2 9.7c-2.5 20-19.5 35-39.7 35H243.3c-20.2 0-37.2-15-39.7-35l-1.2-9.7C143.8 436.7 98.3 384 77.7 320z"
        }
    ]
};

const FasPotato = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPotato",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M466.3 249.2C494.4 222.9 512 185.5 512 144 512 64.5 447.5 0 368 0c-39.8 0-75.9 16.2-102 42.3-27.4 27.5-61 52.7-95.1 71.3-24.1 13.2-44 33.1-57.3 57.3C95 205 69.8 238.6 42.3 266 16.2 292.1 0 328.2 0 368c0 79.5 64.5 144 144 144 30.3 0 58.4-9.3 81.5-25.3 28.1-19.3 60.2-35.3 92.5-46.2 44.1-14.9 80.1-50.9 93.1-99.2 9.2-34.2 29.4-67.9 55.2-92.1zM384 168a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-192 32a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-56 216a24 24 0 1 1 48 0 24 24 0 1 1-48 0z"
        }
    ]
};

const FasPowerOff = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPowerOff",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32v224c0 17.7 14.3 32 32 32s32-14.3 32-32V32zm-144.5 88.6c13.6-11.3 15.4-31.5 4.1-45.1s-31.5-15.4-45.1-4.1C49.7 115.4 16 181.8 16 256c0 132.5 107.5 240 240 240s240-107.5 240-240c0-74.2-33.8-140.6-86.6-184.6-13.6-11.3-33.8-9.4-45.1 4.1s-9.4 33.8 4.1 45.1c38.9 32.3 63.5 81 63.5 135.4 0 97.2-78.8 176-176 176s-176-78.8-176-176c0-54.4 24.7-103.1 63.5-135.4z"
        }
    ]
};

const FasPrescriptionBottleMedical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPrescriptionBottleMedical",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 32C0 14.3 14.3 0 32 0h320c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H32C14.3 96 0 81.7 0 64V32zm32 96h320v320c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V128zm128 112v48h-48c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-48h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-48v-48c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16z"
        }
    ]
};

const FasPrescriptionBottlePill = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPrescriptionBottlePill",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 32C0 14.3 14.3 0 32 0h320c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H32C14.3 96 0 81.7 0 64V32zm32 96h320v83.2c-57 29.1-96 88.4-96 156.8 0 54.5 24.8 103.3 63.8 135.6-9.4 5.4-20.2 8.4-31.8 8.4H96c-35.3 0-64-28.7-64-64v-32h112c8.8 0 16-7.2 16-16s-7.2-16-16-16H32v-64h112c8.8 0 16-7.2 16-16s-7.2-16-16-16H32v-64h112c8.8 0 16-7.2 16-16s-7.2-16-16-16H32v-64zm272.8 172.5c6.7-12.6 23.6-13.5 33.7-3.4l164.4 164.4c10.1 10.1 9.2 27-3.4 33.7-20.1 10.7-43.1 16.8-67.5 16.8-79.5 0-144-64.5-144-144 0-24.4 6.1-47.4 16.8-67.5zm254.5 135c-6.7 12.6-23.6 13.5-33.7 3.4L361.1 274.5c-10.1-10.1-9.2-27 3.4-33.7 20.1-10.7 43.1-16.8 67.5-16.8 79.5 0 144 64.5 144 144 0 24.4-6.1 47.4-16.8 67.5z"
        }
    ]
};

const FasPrescriptionBottle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPrescriptionBottle",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 32C0 14.3 14.3 0 32 0h320c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H32C14.3 96 0 81.7 0 64V32zm32 96h320v320c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64v-32h112c8.8 0 16-7.2 16-16s-7.2-16-16-16H32v-64h112c8.8 0 16-7.2 16-16s-7.2-16-16-16H32v-64h112c8.8 0 16-7.2 16-16s-7.2-16-16-16H32v-64z"
        }
    ]
};

const FasPrescription = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPrescription",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 0C14.3 0 0 14.3 0 32v256c0 17.7 14.3 32 32 32s32-14.3 32-32v-64h50.7l128 128-105.3 105.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L288 397.3l105.4 105.3c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L333.3 352l105.3-105.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 306.7l-85.8-85.8C251.4 209.1 288 164.8 288 112 288 50.1 237.9 0 176 0H32zm144 160H64V64h112c26.5 0 48 21.5 48 48s-21.5 48-48 48z"
        }
    ]
};

const FasPresentationScreen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPresentationScreen",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 0C14.3 0 0 14.3 0 32s14.3 32 32 32v224c0 35.3 28.7 64 64 64h160v34.7l-70.6 70.6c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l57.3-57.3 57.4 57.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L320 386.7V352h160c35.3 0 64-28.7 64-64V64c17.7 0 32-14.3 32-32S561.7 0 544 0H32zm64 64h384v224H96V64z"
        }
    ]
};

const FasPretzel = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPretzel",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M138.6 32C62.1 32 0 94.1 0 170.6 0 253.3 40.9 326.5 103.7 371l-32.4 46c-12.7 18-8.4 43 9.7 55.7s43 8.4 55.7-9.7l40-56.8c21.8 6.4 44.9 9.8 68.7 9.8h21.2c23.9 0 46.9-3.4 68.7-9.8l40 56.8c12.7 18.1 37.7 22.4 55.7 9.7s22.4-37.7 9.7-55.7l-32.4-46C471.1 326.5 512 253.3 512 170.6 512 94.1 449.9 32 373.4 32H364c-42.6 0-81 18-108 46.8C229 50 190.6 32 148 32h-9.4zM216 180v7.4c0 15.5-4.8 30.7-13.7 43.4l-52.5 74.7C107.5 275.6 80 226.3 80 170.6c0-32.4 26.2-58.6 58.6-58.6h9.4c37.6 0 68 30.4 68 68zm40 113.5 29.2 41.5c-6.1.7-12.3 1-18.6 1h-21.2c-6.3 0-12.5-.3-18.6-1l29.2-41.5zm53.7-62.6c-8.9-12.7-13.7-27.9-13.7-43.5V180c0-37.6 30.4-68 68-68h9.4c32.4 0 58.6 26.2 58.6 58.6 0 55.7-27.5 105-69.7 134.9l-52.5-74.7z"
        }
    ]
};

const FasPrintMagnifyingGlass = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPrintMagnifyingGlass",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 0h226.7c17 0 33.3 6.7 45.3 18.7L493.3 48c12 12 18.7 28.3 18.7 45.3V160h-64V93.3L418.7 64H192v96h-64V64c0-35.3 28.7-64 64-64zm-64 192h224c-38.9 29.2-64 75.7-64 128 0 11 1.1 21.7 3.2 32H192v96h160c26.7 20.1 60 32 96 32 17.5 0 34.4-2.8 50.2-8l6.3 6.3c-10.8 20.1-32 33.8-56.4 33.8H192c-35.3 0-64-28.7-64-64V384H96c-17.7 0-32-14.3-32-32v-96c0-35.3 28.7-64 64-64zm320 208.2a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0 48c-70.7 0-128-57.3-128-128s57.3-128 128-128 128 57.3 128 128c0 26.7-8.2 51.4-22.1 71.9l79.1 79.1c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L519.9 426c-20.5 14-45.3 22.1-71.9 22.1z"
        }
    ]
};

const FasPrintSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPrintSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L522.2 384H544c17.7 0 32-14.3 32-32v-96c0-35.3-28.7-64-64-64H277.2L192 125.2V64h226.7L448 93.3V160h64V93.3c0-17-6.7-33.3-18.7-45.3L464 18.7C452 6.7 435.7 0 418.7 0H192c-35.3 0-64 28.7-64 64v11L38.8 5.1zm459 483.1-51-40.2H192v-96h132.9L122.2 192.3C89.6 195.2 64 222.6 64 256v96c0 17.7 14.3 32 32 32h32v64c0 35.3 28.7 64 64 64h256c20.1 0 38.1-9.3 49.8-23.8zM496 248a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FasPrint = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPrint",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 0C92.7 0 64 28.7 64 64v96h64V64h226.7L384 93.3V160h64V93.3c0-17-6.7-33.3-18.7-45.3L400 18.7C388 6.7 371.7 0 354.7 0H128zm256 352v96H128v-96h256zm64 32h32c17.7 0 32-14.3 32-32v-96c0-35.3-28.7-64-64-64H64c-35.3 0-64 28.7-64 64v96c0 17.7 14.3 32 32 32h32v64c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64v-64zm-16-136a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FasProjector = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasProjector",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M440 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v80c0 13.3 10.7 24 24 24s24-10.7 24-24V24zM281 39c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l56 56c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-56-56zm304 34c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L495 95c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l56-56zm-9 119h-64c-26.7-20.1-60-32-96-32s-69.3 11.9-96 32H64c-35.3 0-64 28.7-64 64v128c0 35.3 28.7 64 64 64l9.9 39.8C77.5 502 90.3 512 105 512h14c14.7 0 27.5-10 31-24.2l10-39.8h160c26.7 20.1 60 32 96 32 24.4 0 47.5-5.5 68.2-15.2l5.7 23c3.6 14.2 16.4 24.2 31 24.2h14c14.7 0 27.5-10 31-24.2L576 448c35.3 0 64-28.7 64-64V256c0-35.3-28.7-64-64-64zm-160 32a96 96 0 1 1 0 192 96 96 0 1 1 0-192zM64 320a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm128-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FasPumpMedical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPumpMedical",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 32v96h128V96h60.1c4.2 0 8.3 1.7 11.3 4.7l33.9 33.9c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-33.9-33.9c-15-15-35.4-23.4-56.6-23.4H256c0-17.7-14.3-32-32-32h-64c-17.7 0-32 14.3-32 32zm-10.6 128c-33.3 0-61 25.5-63.8 58.7L35 442.7C31.9 480 61.3 512 98.8 512h186.4c37.4 0 66.9-32 63.8-69.3l-18.7-224c-2.8-33.2-30.5-58.7-63.8-58.7H117.4zM216 280v32h32c13.3 0 24 10.7 24 24s-10.7 24-24 24h-32v32c0 13.3-10.7 24-24 24s-24-10.7-24-24v-32h-32c-13.3 0-24-10.7-24-24s10.7-24 24-24h32v-32c0-13.3 10.7-24 24-24s24 10.7 24 24z"
        }
    ]
};

const FasPumpSoap = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPumpSoap",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 32v96h128V96h60.1c4.2 0 8.3 1.7 11.3 4.7l33.9 33.9c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-33.9-33.9c-15-15-35.4-23.4-56.6-23.4H256c0-17.7-14.3-32-32-32h-64c-17.7 0-32 14.3-32 32zm-10.6 128c-33.3 0-61 25.5-63.8 58.7L35 442.7C31.9 480 61.3 512 98.8 512h186.4c37.4 0 66.9-32 63.8-69.3l-18.7-224c-2.8-33.2-30.5-58.7-63.8-58.7H117.4zM256 360c0 35.3-28.7 56-64 56s-64-20.7-64-56c0-32.5 37-80.9 50.9-97.9 3.2-3.9 8.1-6.1 13.1-6.1s9.9 2.2 13.1 6.1c13.9 17 50.9 65.4 50.9 97.9z"
        }
    ]
};

const FasPump = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPump",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 32c0 17.7 14.3 32 32 32h160c17.7 0 32-14.3 32-32S337.7 0 320 0H160c-17.7 0-32 14.3-32 32zM32 176c-17.7 0-32 14.3-32 32v176c0 17.7 14.3 32 32 32s32-14.3 32-32V208c0-17.7-14.3-32-32-32zm128 48H96v160h224V96H160v128zm271.9-117.3L380.5 141c-17.8 11.9-28.5 31.9-28.5 53.3v219.4c0 21.4 10.7 41.4 28.5 53.3l51.4 34.3c10.5 7 22.9 10.7 35.5 10.7H576c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H467.4c-12.6 0-25 3.7-35.5 10.7zM448 208c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16zm0 96c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16zm0 96c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16z"
        }
    ]
};

const FasPumpkin = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPumpkin",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M234.6 103.9c16.9-5.1 34.8-7.9 53.4-7.9 22.8 0 44.7 4.2 64.8 11.7-.6-2-.8-4.1-.8-6.3v-66c0-6.9-4.1-13.2-10.5-15.9L299.3 1.4c-2.2-.9-4.5-1.4-6.8-1.4h-1.2c-6.9 0-13.1 4.1-15.8 10.4l-40.9 93.5zm161.6 27.3c12.1 8.8 23.1 19.1 32.7 30.5 5.6 6.7-2.9 14.6-10.4 10.1C380.3 149 335.7 136 288 136s-92.3 13-130.5 35.7c-7.5 4.5-16-3.4-10.4-10.1 9.6-11.4 20.6-21.7 32.7-30.5l-1.8-.3c-8.5-1.8-17.2-2.8-26-2.8C68.1 128 0 214 0 320s68.1 192 152 192c19.3 0 37.8-4.5 54.7-12.8 8.3-4.1 18.2-4.1 26.5 0 17 8.3 35.4 12.8 54.7 12.8s37.8-4.5 54.7-12.8c8.3-4.1 18.2-4.1 26.5 0 17 8.3 35.4 12.8 54.7 12.8 83.9 0 152-86 152-192s-68.1-192-152-192c-8.9 0-17.6 1-26 2.8l-1.8.3z"
        }
    ]
};

const FasPuzzlePieceSimple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPuzzlePieceSimple",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M264.8 64c12.8 0 23.2 10.4 23.2 23.2 0 9.2-5.8 17.3-13.2 22.8-11.6 8.7-18.8 20.7-18.8 34 0 26.5 28.7 48 64 48s64-21.5 64-48c0-13.3-7.2-25.3-18.8-34-7.4-5.5-13.2-13.6-13.2-22.8 0-12.8 10.4-23.2 23.2-23.2H464c26.5 0 48 21.5 48 48v88.8c0 12.8 10.4 23.2 23.2 23.2 9.2 0 17.3-5.8 22.8-13.2 8.7-11.6 20.7-18.8 34-18.8 26.5 0 48 28.7 48 64s-21.5 64-48 64c-13.3 0-25.3-7.2-34-18.8-5.5-7.4-13.6-13.2-22.8-13.2-12.8 0-23.2 10.4-23.2 23.2V400c0 26.5-21.5 48-48 48h-88.8c-12.8 0-23.2-10.4-23.2-23.2 0-9.2 5.8-17.3 13.2-22.8 11.6-8.7 18.8-20.7 18.8-34 0-26.5-28.7-48-64-48s-64 21.5-64 48c0 13.3 7.2 25.3 18.8 34 7.4 5.5 13.2 13.6 13.2 22.8 0 12.8-10.4 23.2-23.2 23.2H176c-26.5 0-48-21.5-48-48v-88.8c0-12.8-10.4-23.2-23.2-23.2-9.2 0-17.3 5.8-22.8 13.2-8.7 11.6-20.7 18.8-34 18.8-26.5 0-48-28.7-48-64s21.5-64 48-64c13.3 0 25.3 7.2 34 18.8 5.5 7.4 13.6 13.2 22.8 13.2 12.8 0 23.2-10.4 23.2-23.2V112c0-26.5 21.5-48 48-48h88.8z"
        }
    ]
};

const FasPuzzlePiece = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPuzzlePiece",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 104.8c0-9.2-5.8-17.3-13.2-22.8-11.6-8.7-18.8-20.7-18.8-34 0-26.5 28.7-48 64-48s64 21.5 64 48c0 13.3-7.2 25.3-18.8 34-7.4 5.5-13.2 13.6-13.2 22.8 0 12.8 10.4 23.2 23.2 23.2H336c26.5 0 48 21.5 48 48v56.8c0 12.8 10.4 23.2 23.2 23.2 9.2 0 17.3-5.8 22.8-13.2 8.7-11.6 20.7-18.8 34-18.8 26.5 0 48 28.7 48 64s-21.5 64-48 64c-13.3 0-25.3-7.2-34-18.8-5.5-7.4-13.6-13.2-22.8-13.2-12.8 0-23.2 10.4-23.2 23.2V464c0 26.5-21.5 48-48 48h-56.8c-12.8 0-23.2-10.4-23.2-23.2 0-9.2 5.8-17.3 13.2-22.8 11.6-8.7 18.8-20.7 18.8-34 0-26.5-28.7-48-64-48s-64 21.5-64 48c0 13.3 7.2 25.3 18.8 34 7.4 5.5 13.2 13.6 13.2 22.8 0 12.8-10.4 23.2-23.2 23.2H48c-26.5 0-48-21.5-48-48V343.2C0 330.4 10.4 320 23.2 320c9.2 0 17.3 5.8 22.8 13.2 8.7 11.6 20.7 18.8 34 18.8 26.5 0 48-28.7 48-64s-21.5-64-48-64c-13.3 0-25.3 7.2-34 18.8-5.5 7.4-13.6 13.2-22.8 13.2C10.4 256 0 245.6 0 232.8V176c0-26.5 21.5-48 48-48h120.8c12.8 0 23.2-10.4 23.2-23.2z"
        }
    ]
};

const FasPuzzle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasPuzzle",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 0h128c35.3 0 64 28.7 64 64v128c0 8.8-7.2 16-16 16h-52c-6.6 0-12 5.4-12 12v4c0 17.7-14.3 32-32 32s-32-14.3-32-32v-4c0-6.6-5.4-12-12-12h-36c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h16c17.7 0 32-14.3 32-32s-14.3-32-32-32h-16c-8.8 0-16-7.2-16-16V16c0-8.8 7.2-16 16-16zM0 256V128c0-35.3 28.7-64 64-64h128c8.8 0 16 7.2 16 16v36c0 6.6 5.4 12 12 12h4c17.7 0 32 14.3 32 32s-14.3 32-32 32h-4c-6.6 0-12 5.4-12 12v52c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-16c0-17.7-14.3-32-32-32s-32 14.3-32 32v16c0 8.8-7.2 16-16 16H16c-8.8 0-16-7.2-16-16zm0 192V320c0-8.8 7.2-16 16-16h176c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-16c-17.7 0-32 14.3-32 32s14.3 32 32 32h16c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16H64c-35.3 0-64-28.7-64-64zm240-128c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v16c0 17.7 14.3 32 32 32s32-14.3 32-32v-16c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v128c0 35.3-28.7 64-64 64H256c-8.8 0-16-7.2-16-16V320z"
        }
    ]
};

const FasQ = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasQ",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 256c0 88.4 71.6 160 160 160 28.9 0 56-7.7 79.4-21.1l-72-86.4c-11.3-13.6-9.5-33.8 4.1-45.1s33.8-9.5 45.1 4.1l70.9 85.1c20.4-26.8 32.5-60.3 32.5-96.6 0-88.4-71.6-160-160-160S64 167.6 64 256zm280.9 188.6C310 467 268.5 480 224 480 100.3 480 0 379.7 0 256S100.3 32 224 32s224 100.3 224 224c0 56.1-20.6 107.4-54.7 146.7l47.3 56.8c11.3 13.6 9.5 33.8-4.1 45.1s-33.8 9.5-45.1-4.1l-46.6-55.9z"
        }
    ]
};

const FasQrcode = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasQrcode",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 80c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80zm64 16v64h64V96H64zM0 336c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48v-96zm64 16v64h64v-64H64zM304 32h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48h-96c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48zm80 64h-64v64h64V96zM256 304c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s7.2-16 16-16 16 7.2 16 16v96c0 8.8-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16s-7.2-16-16-16-16 7.2-16 16v64c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16V304zm112 176a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm64 0a16 16 0 1 1 0-32 16 16 0 1 1 0 32z"
        }
    ]
};

const FasQuestion = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasQuestion",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 160c0-35.3 28.7-64 64-64h32c35.3 0 64 28.7 64 64v3.6c0 21.8-11.1 42.1-29.4 53.8l-42.2 27.1a87.983 87.983 0 0 0-40.4 74v1.5c0 17.7 14.3 32 32 32s32-14.3 32-32v-1.4c0-8.2 4.2-15.8 11-20.2l42.2-27.1c36.6-23.6 58.8-64.1 58.8-107.7V160c0-70.7-57.3-128-128-128h-32C73.3 32 16 89.3 16 160c0 17.7 14.3 32 32 32s32-14.3 32-32zm80 320a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"
        }
    ]
};

const FasQuoteLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasQuoteLeft",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 216C0 149.7 53.7 96 120 96h8c17.7 0 32 14.3 32 32s-14.3 32-32 32h-8c-30.9 0-56 25.1-56 56v8h64c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V216zm256 0c0-66.3 53.7-120 120-120h8c17.7 0 32 14.3 32 32s-14.3 32-32 32h-8c-30.9 0-56 25.1-56 56v8h64c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64h-64c-35.3 0-64-28.7-64-64V216z"
        }
    ]
};

const FasQuoteRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasQuoteRight",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 296c0 66.3-53.7 120-120 120h-8c-17.7 0-32-14.3-32-32s14.3-32 32-32h8c30.9 0 56-25.1 56-56v-8h-64c-35.3 0-64-28.7-64-64v-64c0-35.3 28.7-64 64-64h64c35.3 0 64 28.7 64 64v136zm-256 0c0 66.3-53.7 120-120 120h-8c-17.7 0-32-14.3-32-32s14.3-32 32-32h8c30.9 0 56-25.1 56-56v-8H64c-35.3 0-64-28.7-64-64v-64c0-35.3 28.7-64 64-64h64c35.3 0 64 28.7 64 64v136z"
        }
    ]
};

const FasQuotes = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasQuotes",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M88 0C39.4 0 0 39.4 0 88v104c0 26.5 21.5 48 48 48h48c26.5 0 48-21.5 48-48v-48c0-26.5-21.5-48-48-48H64v-8c0-13.3 10.7-24 24-24h8c17.7 0 32-14.3 32-32S113.7 0 96 0h-8zm176 0c-48.6 0-88 39.4-88 88v104c0 26.5 21.5 48 48 48h48c26.5 0 48-21.5 48-48v-48c0-26.5-21.5-48-48-48h-32v-8c0-13.3 10.7-24 24-24h8c17.7 0 32-14.3 32-32S289.7 0 272 0h-8zm312 424V320c0-26.5-21.5-48-48-48h-48c-26.5 0-48 21.5-48 48v48c0 26.5 21.5 48 48 48h32v8c0 13.3-10.7 24-24 24h-8c-17.7 0-32 14.3-32 32s14.3 32 32 32h8c48.6 0 88-39.4 88-88zm-264 88c48.6 0 88-39.4 88-88V320c0-26.5-21.5-48-48-48h-48c-26.5 0-48 21.5-48 48v48c0 26.5 21.5 48 48 48h32v8c0 13.3-10.7 24-24 24h-8c-17.7 0-32 14.3-32 32s14.3 32 32 32h8z"
        }
    ]
};

const FasR = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasR",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v352c0 17.7 14.3 32 32 32s32-14.3 32-32V320h95.3l102.5 146.4c10.1 14.5 30.1 18 44.6 7.9s18-30.1 7.9-44.6l-84.2-120.2C282.8 288.1 320 236.4 320 176c0-79.5-64.5-144-144-144H64zm112 224H64V96h112c44.2 0 80 35.8 80 80s-35.8 80-80 80z"
        }
    ]
};

const FasRabbitRunning = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasRabbitRunning",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m460.7 39.3-2.2-2.1c-4.7-4.6-11.5-6.4-17.9-4.7s-11.4 6.6-13.1 13l-.8 2.9c-3.3 11.8-5.1 23.7-5.5 35.6 24.3 20.6 42.9 47.8 53.3 78.8-8.2-1.9-16.5-2.9-25-2.9h-1.7c-18.4-44-56.5-77.4-103.6-89.3l-3.4-.9c-6.2-1.6-12.9-.6-18.5 2.6-10.8 6.2-15.6 19.5-11.2 31.1 14.9 39.5 44.3 71.4 81.4 89.7-3.7 6.6-6.4 14-7.6 21.8l-105.2-60c-30.9-17.6-65.9-26.9-101.5-26.9-32.3 0-62.2 16.8-78.9 44.4C89 159.9 73.4 152 56 152c-30.9 0-56 25.1-56 56s25.1 56 56 56c11.3 0 21.8-3.3 30.6-9.1 4.9 17.2 14.5 33.1 28.4 45.9l142.2 130.4C269 442 284.4 448 300.4 448H416c17.7 0 32-14.3 32-32s-14.3-32-32-32h-96v-43.5c0-42.9-28.4-80.5-69.6-92.3l-30.8-8.8c-8.5-2.4-13.4-11.3-11-19.8s11.3-13.4 19.8-11l30.8 8.8c55 15.7 92.8 65.9 92.8 123.1v15.7l56-32.4 6.4-3.7h101.3c33.3 0 60.3-27 60.3-60.3 0-18.1-8.2-35.3-22.2-46.7l-34.6-28.2c-4.6-3.7-9.4-7.1-14.5-10 8.4-49.3-7.8-100-43.9-135.5zm-318.5 382c-14.7 9.8-18.7 29.7-8.9 44.4s29.7 18.7 44.4 8.9l46-30.7-48.6-44.5-32.9 22zM480 240a16 16 0 1 1 32 0 16 16 0 1 1-32 0z"
        }
    ]
};

const FasRabbit = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasRabbit",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M321.4 128c4.8 0 9.6.3 14.3.9 1.1-24-2.6-47.9-10.9-70.1 7.6-17.8 18.6-34.2 32.7-48.3l4.6-4.6c3.7-3.7 8.8-5.8 14-5.8 9.2 0 17.2 6.4 19.3 15.4l1 4.4c9.8 42.4 1.8 86.5-21 122.4 5.5 3.1 10.7 6.6 15.6 10.6l34.8 28.1c14 11.4 22.2 28.6 22.2 46.7 0 33.3-27 60.3-60.3 60.3H352v25.8l61.7 154.3c6.6 16.4-1.4 35-17.8 41.6s-35-1.4-41.6-17.8l-39.4-98.6-49.3 54.7H288c17.7 0 32 14.3 32 32s-14.3 32-32 32H160c-28.5 0-52.6-18.6-60.9-44.2C88.8 480.1 73.3 488 56 488c-30.9 0-56-25.1-56-56s25.1-56 56-56c17.4 0 33 8 43.3 20.5C114 317.7 176.8 255.9 256 242.7v-49.3c0-10.9 2.7-21.2 7.4-30.2-34.3-36.5-50.3-86.8-43.2-136.8l.7-4.9C222.7 9.2 233.2 0 245.7 0c6.6 0 12.9 2.6 17.6 7.3l3.1 3.1c31.8 31.5 47.9 74.8 45.4 118.4 3.1-.5 6.3-.7 9.6-.7zm46.6 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
        }
    ]
};

const FasRaccoon = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasRaccoon",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M336 32c20.5 0 39.9 9.2 52.8 25.1l28.9 35.6-31.5-7.3c-20.2-4.7-39.7 4.2-50.2 19.9-10.5-15.7-30.1-24.6-50.2-19.9l-31.5 7.3 28.9-35.6C296.1 41.2 315.5 32 336 32zm-39.3 173.3c-5.6-3.7-11.4-7-17.5-10l39.9-21.8c6.9-3.8 12.6-9.1 16.8-15.3 4.2 6.3 9.9 11.6 16.8 15.3l39.9 21.8c-6 2.9-11.9 6.2-17.5 10L360 215.4c-.3-13-10.9-23.4-24-23.4s-23.7 10.4-24 23.4l-15.3-10.2zm187.5-81.4-20.3-25 13.8-41.5c1.5-4.4 2.2-9.1 2.2-13.8C480 19.5 460.5 0 436.5 0h-1.3c-3.3 0-6.5.4-9.7 1.1l-44.1 9.8C367.5 3.8 352 0 336 0s-31.5 3.8-45.3 10.9l-44.1-9.8c-3.2-.7-6.5-1.1-9.7-1.1h-1.3C211.5 0 192 19.5 192 43.5c0 4.7.8 9.3 2.2 13.8L208 98.8l-20.3 25c-7.6 9.3-11.7 21-11.7 33 0 23.1 15.2 43.5 37.3 50.2l35.8 10.7c10.6 3.2 20.6 7.9 29.8 14l18.8 12.6C309.1 252 322.4 256 336 256s26.9-4 38.2-11.6l18.8-12.5c9.2-6.1 19.2-10.9 29.8-14l35.8-10.7c22.2-6.6 37.3-27 37.3-50.2 0-12-4.1-23.7-11.7-33zM288 112a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm80 16a16 16 0 1 1 32 0 16 16 0 1 1-32 0zM185.1 229.3C131.2 266.9 96 329.4 96 400c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-16.4 1.7-32.5 4.8-48H0v48c0 61.9 50.1 112 112 112h208v-16c0-26.5-21.5-48-48-48h-32c-8.8 0-16-7.2-16-16s7.2-16 16-16h32c44.2 0 80 35.8 80 80v16h128v-16.4c-.2-26.3-21.6-47.6-48-47.6h-16v-72l-6.4 4.8c-7.1 5.3-17.1 3.9-22.4-3.2s-3.9-17.1 3.2-22.4l38.1-28.5c12.3-9.2 19.5-23.7 19.5-39.1 0-14.9-6.8-29-18.5-38.3-6.6 2.2-12.9 5.3-18.7 9.2L392 271.1c-16.6 11-36 16.9-55.9 16.9s-39.4-5.9-55.9-16.9l-18.8-12.6c-6.6-4.4-13.7-7.7-21.3-10l-35.8-10.7c-6.8-2-13.2-4.9-19.1-8.4zM0 128h128V96c0-35.3-28.7-64-64-64S0 60.7 0 96v32zm0 32v64h128v-64H0zm0 160h77.7c8.2-23.2 19.8-44.7 34.3-64H0v64zm480-24-.3-.9c0 .4-.1.9-.1 1.3l.5-.4zm-162.3 80.2c-4.5 7.6-14.4 10-22 5.5l-80-48c-7.6-4.5-10-14.4-5.5-22s14.4-10 22-5.5l80 48c7.6 4.5 10 14.4 5.5 21.9z"
        }
    ]
};

const FasRacquet = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasRacquet",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M349 64c-36 0-76.4 15.8-108.8 48.2S192 184.9 192 221c0 28.2 9.6 53.2 27.7 71.3 40.4 40.4 120.7 38.9 180.1-20.5C432.2 239.4 448 199.1 448 163c0-28.2-9.6-53.2-27.7-71.3S377.1 64 349 64zm-154 2.9C238.5 23.4 294.8 0 349 0c42.8 0 84.9 14.8 116.6 46.5S512 120.2 512 163c0 54.2-23.4 110.5-66.9 154-54.4 54.4-131.9 78.7-198.2 61.7-29.4-7.5-62.9-5.5-84.3 16L148.3 409c6.4 12.1 4.5 27.4-5.6 37.6l-56 56c-12.5 12.5-32.8 12.5-45.3 0l-32-32c-12.5-12.5-12.5-32.8 0-45.3l56-56c10.2-10.2 25.5-12.1 37.6-5.6l14.5-14.5c21.4-21.4 23.5-54.7 16-84-3.7-14.3-5.5-29.2-5.5-44.2 0-54.2 23.4-110.5 66.9-154z"
        }
    ]
};

const FasRadar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasRadar",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M304.8 173.3c-14.3-8.4-31-13.3-48.8-13.3-53 0-96 43-96 96s43 96 96 96 96-43 96-96h64c0 73.5-49.6 135.5-117.2 154.2-8-15.5-24.1-26.2-42.8-26.2s-34.8 10.7-42.8 26.2c-51.7-14.3-92.8-53.9-109.4-104.6 14.4-8.3 24.1-23.8 24.1-41.7 0-19.4-11.5-36.1-28-43.7C116.2 149.1 179.9 96 256 96c35.5 0 68.3 11.6 94.9 31.2l22.8-22.8C341.2 79 300.4 64 256 64c-92.9 0-170.3 65.9-188.1 153.6C47.2 222.9 32 241.7 32 264c0 23.8 17.3 43.6 40.1 47.4 19.3 64.3 71.5 114.4 137 130.9C213.8 463.8 233 480 256 480s42.2-16.2 46.9-37.8C386.3 421.3 448 345.9 448 256h64c0 141.4-114.6 256-256 256S0 397.4 0 256 114.6 0 256 0c62.1 0 118.9 22.1 163.3 58.8L463 15c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-182 182c3.3 7.7 5.1 16.1 5.1 25 0 35.3-28.7 64-64 64s-64-28.7-64-64 28.7-64 64-64c8.9 0 17.3 1.8 25 5.1l23.8-23.8z"
        }
    ]
};

const FasRadiation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasRadiation",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M216 186.7c-23.9 13.8-40 39.7-40 69.3H32c-17.7 0-32.2-14.4-30-31.9C10.7 154 47.8 92.7 101.3 52c14.1-10.7 33.8-5.3 42.7 10l72 124.7zM256 336c14.6 0 28.2-3.9 40-10.7l72 124.8c8.8 15.3 3.7 35.1-12.6 41.9-30.6 12.9-64.2 20-99.4 20s-68.9-7.1-99.4-20c-16.3-6.9-21.4-26.6-12.6-41.9l72-124.8c11.8 6.8 25.4 10.7 40 10.7zm224-80H336c0-29.6-16.1-55.5-40-69.3L368 62c8.8-15.3 28.6-20.7 42.7-10 53.6 40.7 90.6 102 99.4 172.1 2.2 17.5-12.4 31.9-30 31.9zm-224-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
        }
    ]
};

const FasRadioTuner = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasRadioTuner",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M494.8 47c12.7-3.7 20-17.1 16.3-29.8S494-2.8 481.2 1L51.7 126.9c-9.4 2.7-17.9 7.3-25.1 13.2C10.5 151.7 0 170.6 0 192v256c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64H218.5l276.3-81zM320 384a64 64 0 1 1 128 0 64 64 0 1 1-128 0zM80 336h128c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zm16 64h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H96c-8.8 0-16-7.2-16-16s7.2-16 16-16zM64 224c0-17.7 14.3-32 32-32h320c17.7 0 32 14.3 32 32s-14.3 32-32 32H96c-17.7 0-32-14.3-32-32z"
        }
    ]
};

const FasRadio = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasRadio",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M494.8 47c12.7-3.7 20-17.1 16.3-29.8S494-2.8 481.2 1L51.7 126.9c-9.4 2.7-17.9 7.3-25.1 13.2C10.5 151.7 0 170.6 0 192v256c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64H218.5l276.3-81zM368 240a80 80 0 1 1 0 160 80 80 0 1 1 0-160zM80 256c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H96c-8.8 0-16-7.2-16-16zm-16 64c0-8.8 7.2-16 16-16h128c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm16 64c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H96c-8.8 0-16-7.2-16-16z"
        }
    ]
};

const FasRainbow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasRainbow",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 96C178.6 96 64 210.6 64 352v96c0 17.7-14.3 32-32 32S0 465.7 0 448v-96C0 175.3 143.3 32 320 32s320 143.3 320 320v96c0 17.7-14.3 32-32 32s-32-14.3-32-32v-96c0-141.4-114.6-256-256-256zm0 192c-35.3 0-64 28.7-64 64v96c0 17.7-14.3 32-32 32s-32-14.3-32-32v-96c0-70.7 57.3-128 128-128s128 57.3 128 128v96c0 17.7-14.3 32-32 32s-32-14.3-32-32v-96c0-35.3-28.7-64-64-64zm-160 64v96c0 17.7-14.3 32-32 32s-32-14.3-32-32v-96c0-123.7 100.3-224 224-224s224 100.3 224 224v96c0 17.7-14.3 32-32 32s-32-14.3-32-32v-96c0-88.4-71.6-160-160-160s-160 71.6-160 160z"
        }
    ]
};

const FasRaindrops = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasRaindrops",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M102.4 133.6c-4.2 8.6-6.4 18-6.4 27.6 0 34.7 28.1 62.8 62.8 62.8h2.4c34.7 0 62.8-28.1 62.8-62.8 0-9.6-2.2-19-6.4-27.6l-46.1-94.4c-2.1-4.4-6.6-7.2-11.5-7.2s-9.4 2.8-11.5 7.2l-46.1 94.4zm-96 192c-4.2 8.6-6.4 18-6.4 27.6C0 387.9 28.1 416 62.8 416h2.4c34.7 0 62.8-28.1 62.8-62.8 0-9.6-2.2-19-6.4-27.6l-46.1-94.4c-2.1-4.4-6.6-7.2-11.5-7.2s-9.4 2.8-11.5 7.2L6.4 325.6zm301.4-190.8L210 294.2c-11.8 19.2-18 41.3-18 63.8 0 67.4 54.6 122 122 122h12c67.4 0 122-54.6 122-122 0-22.5-6.2-44.6-18-63.8l-97.8-159.4c-2.6-4.2-7.2-6.8-12.2-6.8s-9.6 2.6-12.2 6.8z"
        }
    ]
};

const FasRam = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasRam",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M336 64v8c0 13.3 10.7 24 24 24s24-10.7 24-24v-8c0-8.8 7.2-16 16-16s16 7.2 16 16v24.4c-6.8 6.1-12.8 13.2-17.6 21l-47.8 20.5c-12.2 5.2-17.8 19.3-12.6 31.5s19.3 17.8 31.5 12.6l14.5-6.2V240c0 44.2 35.8 80 80 80h32c44.2 0 80-35.8 80-80v-72.2l14.5 6.2c12.2 5.2 26.3-.4 31.5-12.6s-.4-26.3-12.6-31.5l-47.8-20.5c-4.9-7.8-10.8-14.9-17.6-21V64c0-8.8 7.2-16 16-16s16 7.2 16 16v8c0 13.3 10.7 24 24 24s24-10.7 24-24v-8c0-35.3-28.7-64-64-64s-64 28.7-64 64v1.3c-5.2-.9-10.5-1.3-16-1.3s-10.8.5-16 1.3V64c0-35.3-28.7-64-64-64s-64 28.7-64 64zm-27.5 110.1c-8.9-20.8-4.3-44 10-59.7C312.3 85.6 286.7 64 256 64c-19.2 0-36.5 8.5-48.2 21.9C196.9 77.2 183 72 168 72c-30.1 0-55.3 20.8-62.2 48.8-3.2-.5-6.5-.8-9.8-.8-35.3 0-64 28.7-64 64 0 5.3.7 10.5 1.9 15.5C13.7 210.3 0 231.5 0 256s13.7 45.7 33.9 56.5c-1.2 5-1.9 10.2-1.9 15.5 0 35.3 28.7 64 64 64h1.5l17.6 93.9c2.8 15.1 16.1 26.1 31.5 26.1H176c17.7 0 32-14.3 32-32v-53.7c11.7 13.3 28.9 21.7 48 21.7s36.3-8.4 48-21.7V480c0 17.7 14.3 32 32 32h29.4c15.4 0 28.6-11 31.4-26.1l17.7-93.9h1.5c26.9 0 49.9-16.5 59.3-40H464c-61.9 0-112-50.1-112-112v-32.6c-18.7-2.7-35.5-14.8-43.5-33.4zM464 160a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1-32 0z"
        }
    ]
};

const FasRampLoading = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasRampLoading",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 48C32 21.5 53.5 0 80 0h288c26.5 0 48 21.5 48 48v392.4l-64-128V64H96v248.4l-64 128V48zm372.4 440.8c.8 1.5 1.2 3 1.5 4.6 1.5 9.3-5.6 18.6-15.8 18.6H57.9c-10.2 0-17.4-9.2-15.8-18.6.3-1.5.7-3.1 1.5-4.6L96 384l32-64h192l32 64 52.4 104.8z"
        }
    ]
};

const FasRankingStar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasRankingStar",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M353.8 54.1 330.2 6.3c-3.9-8.3-16.1-8.6-20.4 0l-23.6 47.8-52.3 7.5c-9.3 1.4-13.3 12.9-6.4 19.8l38 37-9 52.1c-1.4 9.3 8.2 16.5 16.8 12.2l46.9-24.8 46.6 24.4c8.6 4.3 18.3-2.9 16.8-12.2l-9-52.1 38-36.6c6.8-6.8 2.9-18.3-6.4-19.8l-52.3-7.5zM256 256c-17.7 0-32 14.3-32 32v192c0 17.7 14.3 32 32 32h128c17.7 0 32-14.3 32-32V288c0-17.7-14.3-32-32-32H256zM32 320c-17.7 0-32 14.3-32 32v128c0 17.7 14.3 32 32 32h128c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32H32zm416 96v64c0 17.7 14.3 32 32 32h128c17.7 0 32-14.3 32-32v-64c0-17.7-14.3-32-32-32H480c-17.7 0-32 14.3-32 32z"
        }
    ]
};

const FasRaygun = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasRaygun",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 64h96v-8c0-13.3 10.7-24 24-24s24 10.7 24 24v240c0 13.3-10.7 24-24 24s-24-10.7-24-24v-.4l-99.4 198.7c-7.9 15.8-27.1 22.2-42.9 14.3l-80-40c-15.8-7.9-22.2-27.1-14.3-42.9L120.2 288H112C50.1 288 0 237.9 0 176c0-44.7 26.2-83.2 64-101.2V24.6C64 11 75 0 88.6 0c4.8 0 9.6 1.4 13.6 4.1L192 64zm200 0c13.3 0 24 10.7 24 24v56h60.9l77.1-30.9c4.9-2 10.5-1.4 14.9 1.6s7 7.9 7 13.2v96c0 5.3-2.6 10.3-7 13.2s-10 3.6-14.9 1.6L476.9 208H416v56c0 13.3-10.7 24-24 24s-24-10.7-24-24V88c0-13.3 10.7-24 24-24zM136 176a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm72 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FasReceipt = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasReceipt",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M14 2.2c8.5-3.9 18.5-2.5 25.6 3.6L80 40.4l40.4-34.6c9-7.7 22.3-7.7 31.2 0L192 40.4l40.4-34.6c9-7.7 22.3-7.7 31.2 0L304 40.4l40.4-34.6c7.1-6.1 17.1-7.5 25.6-3.6s14 12.4 14 21.8v464c0 9.4-5.5 17.9-14 21.8s-18.5 2.5-25.6-3.6L304 471.6l-40.4 34.6c-9 7.7-22.3 7.7-31.2 0L192 471.6l-40.4 34.6c-9 7.7-22.3 7.7-31.2 0L80 471.6l-40.4 34.6c-7.1 6.1-17.1 7.5-25.6 3.6S0 497.4 0 488V24C0 14.6 5.5 6.1 14 2.2zM96 144c-8.8 0-16 7.2-16 16s7.2 16 16 16h192c8.8 0 16-7.2 16-16s-7.2-16-16-16H96zM80 352c0 8.8 7.2 16 16 16h192c8.8 0 16-7.2 16-16s-7.2-16-16-16H96c-8.8 0-16 7.2-16 16zm16-112c-8.8 0-16 7.2-16 16s7.2 16 16 16h192c8.8 0 16-7.2 16-16s-7.2-16-16-16H96z"
        }
    ]
};

const FasRecordVinyl = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasRecordVinyl",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm256-96a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm0 224a128 128 0 1 0 0-256 128 128 0 1 0 0 256zm0-96a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FasRectangleAd = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasRectangleAd",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm165.5 141.3 72 144c5.9 11.9 1.1 26.3-10.7 32.2s-26.3 1.1-32.2-10.7l-5.4-10.8h-90.4l-5.4 10.7c-5.9 11.9-20.3 16.7-32.2 10.7s-16.7-20.3-10.7-32.2l72-144c4.1-8.1 12.4-13.3 21.5-13.3s17.4 5.1 21.5 13.3zM208 237.7 186.8 280h42.3L208 237.7zM392 256a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm24-43.9V184c0-13.3 10.7-24 24-24s24 10.7 24 24v144c0 13.3-10.7 24-24 24-6.6 0-12.6-2.7-17-7-9.4 4.5-19.9 7-31 7-39.8 0-72-32.2-72-72s32.2-72 72-72c8.4 0 16.5 1.4 24 4.1z"
        }
    ]
};

const FasRectangleBarcode = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasRectangleBarcode",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm56 96c13.3 0 24 10.7 24 24v208c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zm56 16c0-8.8 7.2-16 16-16s16 7.2 16 16v224c0 8.8-7.2 16-16 16s-16-7.2-16-16V144zm88-16c13.3 0 24 10.7 24 24v208c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zm88 24c0-13.3 10.7-24 24-24s24 10.7 24 24v208c0 13.3-10.7 24-24 24s-24-10.7-24-24V152zm112-24c8.8 0 16 7.2 16 16v224c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16z"
        }
    ]
};

const FasRectangleCode = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasRectangleCode",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 96c0-35.3 28.7-64 64-64h384c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm294.2 71.9c-8.9 9.9-8.1 25 1.8 33.9l60.1 54.2-60.2 54.2c-9.9 8.9-10.7 24-1.8 33.9s24 10.7 33.9 1.8l80-72c5.1-4.6 7.9-11 7.9-17.8s-2.9-13.3-7.9-17.8l-80-72c-9.9-8.9-25-8.1-33.9 1.8zm-78.1 33.9c9.9-8.9 10.7-24 1.8-33.9s-24-10.7-33.9-1.8l-80 72c-5.1 4.6-7.9 11-7.9 17.8s2.9 13.3 7.9 17.8l80 72c9.9 8.9 25 8.1 33.9-1.8s8.1-25-1.8-33.9l-60.2-54 60.2-54.2z"
        }
    ]
};

const FasRectangleHistoryCirclePlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasRectangleHistoryCirclePlus",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 368c0 59.5 29.5 112.1 74.8 144H64c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64h384c23.8 0 44.5 12.9 55.5 32.2-2.5-.1-5-.2-7.5-.2-97.2 0-176 78.8-176 176zM440 80c13.3 0 24 10.7 24 24s-10.7 24-24 24H72c-13.3 0-24-10.7-24-24s10.7-24 24-24h368zM392 0c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24s10.7-24 24-24h272zm104 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48h-48c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48h48c8.8 0 16-7.2 16-16s-7.2-16-16-16h-48v-48z"
        }
    ]
};

const FasRectangleHistoryCircleUser = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasRectangleHistoryCircleUser",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 368c0 59.5 29.5 112.1 74.8 144H64c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64h384c23.8 0 44.5 12.9 55.5 32.2-2.5-.1-5-.2-7.5-.2-97.2 0-176 78.8-176 176zM440 80c13.3 0 24 10.7 24 24s-10.7 24-24 24H72c-13.3 0-24-10.7-24-24s10.7-24 24-24h368zM392 0c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24s10.7-24 24-24h272zm-40 368a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm221.7 80.7c-6.2-19-24-32.7-45.1-32.7h-65.2c-21 0-38.9 13.7-45.1 32.7 20.2 19.4 47.5 31.3 77.7 31.3s57.5-11.9 77.7-31.3zM544 336a48 48 0 1 0-96 0 48 48 0 1 0 96 0z"
        }
    ]
};

const FasRectangleHistory = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasRectangleHistory",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 224c0-35.3-28.7-64-64-64H64c-35.3 0-64 28.7-64 64v224c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V224zM440 80H72c-13.3 0-24 10.7-24 24s10.7 24 24 24h368c13.3 0 24-10.7 24-24s-10.7-24-24-24zM392 0H120c-13.3 0-24 10.7-24 24s10.7 24 24 24h272c13.3 0 24-10.7 24-24S405.3 0 392 0z"
        }
    ]
};

const FasRectangleList = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasRectangleList",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 96c0-35.3 28.7-64 64-64h448c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm128 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32-128a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm-32 224a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm96-248c-13.3 0-24 10.7-24 24s10.7 24 24 24h224c13.3 0 24-10.7 24-24s-10.7-24-24-24H224zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24h224c13.3 0 24-10.7 24-24s-10.7-24-24-24H224zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24h224c13.3 0 24-10.7 24-24s-10.7-24-24-24H224z"
        }
    ]
};

const FasRectanglePro = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasRectanglePro",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm40 128h56c35.3 0 64 28.7 64 64s-28.7 64-64 64h-32v40c0 13.3-10.7 24-24 24s-24-10.7-24-24V184c0-13.3 10.7-24 24-24zm56 80c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32v32h32zm80-56c0-13.3 10.7-24 24-24h56c35.3 0 64 28.7 64 64 0 21.9-11 41.2-27.7 52.7l24.1 38.5c7 11.2 3.6 26-7.6 33.1s-26 3.6-33.1-7.6l-33-52.7H288v40c0 13.3-10.7 24-24 24s-24-10.7-24-24V184zm48 56h32c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32v32zm200-80c48.6 0 88 39.4 88 88v16c0 48.6-39.4 88-88 88s-88-39.4-88-88v-16c0-48.6 39.4-88 88-88zm-40 88v16c0 22.1 17.9 40 40 40s40-17.9 40-40v-16c0-22.1-17.9-40-40-40s-40 17.9-40 40z"
        }
    ]
};

const FasRectangleTerminal = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasRectangleTerminal",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 96c0-35.3 28.7-64 64-64h384c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm102.3 55.8c-9 9.8-8.3 25 1.5 33.9l76.7 70.3-76.7 70.3c-9.8 9-10.4 24.1-1.5 33.9s24.1 10.4 33.9 1.5l96-88c5-4.5 7.8-11 7.8-17.7s-2.8-13.1-7.8-17.7l-96-88c-9.8-9-25-8.3-33.9 1.5zM248 336c-13.3 0-24 10.7-24 24s10.7 24 24 24h144c13.3 0 24-10.7 24-24s-10.7-24-24-24H248z"
        }
    ]
};

const FasRectangleVerticalHistory = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasRectangleVerticalHistory",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 0c-35.3 0-64 28.7-64 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H256zM96 72v368c0 13.3 10.7 24 24 24s24-10.7 24-24V72c0-13.3-10.7-24-24-24S96 58.7 96 72zM0 120v272c0 13.3 10.7 24 24 24s24-10.7 24-24V120c0-13.3-10.7-24-24-24S0 106.7 0 120z"
        }
    ]
};

const FasRectangleVertical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasRectangleVertical",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 0c35.3 0 64 28.7 64 64v384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0h256z"
        }
    ]
};

const FasRectangleWide = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasRectangleWide",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 128c0-35.3 28.7-64 64-64h512c35.3 0 64 28.7 64 64v256c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128z"
        }
    ]
};

const FasRectangleXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasRectangleXmark",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm111 143c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"
        }
    ]
};

const FasRectangle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasRectangle",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 128c0-35.3 28.7-64 64-64h384c35.3 0 64 28.7 64 64v256c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128z"
        }
    ]
};

const FasRectanglesMixed = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasRectanglesMixed",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 80c0-26.5 21.5-48 48-48h224c26.5 0 48 21.5 48 48v128c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80zm384 0c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v256c0 26.5-21.5 48-48 48h-96c-26.5 0-48-21.5-48-48V80zM112 304h176c26.5 0 48 21.5 48 48v80c0 26.5-21.5 48-48 48H112c-26.5 0-48-21.5-48-48v-80c0-26.5 21.5-48 48-48z"
        }
    ]
};

const FasRecycle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasRecycle",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M174.7 45.1C192.2 17 223 0 256 0s63.8 17 81.3 45.1l38.6 61.7 27-15.6c8.4-4.9 18.9-4.2 26.6 1.7s11.1 15.9 8.6 25.3l-23.4 87.4c-3.4 12.8-16.6 20.4-29.4 17l-87.4-23.4c-9.4-2.5-16.3-10.4-17.6-20s3.4-19.1 11.8-23.9l28.4-16.4L283 79c-5.8-9.3-16-15-27-15s-21.2 5.7-27 15l-17.5 28c-9.2 14.8-28.6 19.5-43.6 10.5-15.3-9.2-20.2-29.2-10.7-44.4l17.5-28zm254.8 206.8c15-9 34.4-4.3 43.6 10.5l24.4 39.1c9.4 15.1 14.4 32.4 14.6 50.2.3 53.1-42.7 96.4-95.8 96.4L320 448v32c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-64-64c-9.4-9.4-9.4-24.6 0-33.9l64-64c6.9-6.9 17.2-8.9 26.2-5.2s14.8 12.5 14.8 22.2v32h96.2c17.6 0 31.9-14.4 31.8-32 0-5.9-1.7-11.7-4.8-16.7l-24.4-39.1c-9.5-15.2-4.7-35.2 10.7-44.4zm-364.6-31L36 204.2c-8.4-4.9-13.1-14.3-11.8-23.9s8.2-17.5 17.6-20l87.4-23.4c12.8-3.4 26 4.2 29.4 17l23.4 87.3c2.5 9.4-.9 19.3-8.6 25.3s-18.2 6.6-26.6 1.7l-26.5-15.3-51.5 82.4c-3.1 5-4.8 10.8-4.8 16.7-.1 17.6 14.2 32 31.8 32H128c17.7 0 32 14.3 32 32s-14.3 32-32 32H95.8C42.7 448-.3 404.8 0 351.6c.1-17.8 5.1-35.1 14.6-50.2l50.3-80.5z"
        }
    ]
};

const FasReel = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasReel",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 32C0 14.3 14.3 0 32 0h384c17.7 0 32 14.3 32 32s-14.3 32-32 32h-32v24c0 13.3-10.7 24-24 24H88c-13.3 0-24-10.7-24-24V64H32C14.3 64 0 49.7 0 32zm0 448c0-17.7 14.3-32 32-32h32v-24c0-13.3 10.7-24 24-24h272c13.3 0 24 10.7 24 24v24h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zm80-336h288c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64h352c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64h288c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64h288c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FasRefrigerator = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasRefrigerator",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 0C43 0 0 43 0 96v64h288v-48c0-8.8 7.2-16 16-16s16 7.2 16 16v48h64V96c0-53-43-96-96-96H96zm288 192h-64v176c0 8.8-7.2 16-16 16s-16-7.2-16-16V192H0v256c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V192z"
        }
    ]
};

const FasRegistered = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasRegistered",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-96-360c0-13.3 10.7-24 24-24h88c44.2 0 80 35.8 80 80 0 28-14.4 52.7-36.3 67l34.1 75.1c5.5 12.1.1 26.3-11.9 31.8s-26.3.1-31.8-11.9l-37.2-82H208v72c0 13.3-10.7 24-24 24s-24-10.7-24-24V152zm48 88h64c17.7 0 32-14.3 32-32s-14.3-32-32-32h-64v64z"
        }
    ]
};

const FasRepeat1 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasRepeat1",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 256c-17.7 0-32-14.3-32-32C0 135.6 71.6 64 160 64h160V32c0-12.9 7.8-24.6 19.8-29.6s25.7-2.2 34.9 6.9l64 64c12.5 12.5 12.5 32.8 0 45.3l-64 64c-9.2 9.2-22.9 11.9-34.9 6.9S320 172.9 320 159.9V128H160c-53 0-96 43-96 96 0 17.7-14.3 32-32 32zm448 0c17.7 0 32 14.3 32 32 0 88.4-71.6 160-160 160H192v32c0 12.9-7.8 24.6-19.8 29.6s-25.7 2.2-34.9-6.9l-64-64c-12.5-12.5-12.5-32.8 0-45.3l64-64c9.2-9.2 22.9-11.9 34.9-6.9s19.8 16.6 19.8 29.6v32h160c53 0 96-43 96-96 0-17.7 14.3-32 32-32zm-192-40v80c0 13.3-10.7 24-24 24s-24-10.7-24-24v-48c-10 0-19.4-6.4-22.8-16.4-4.2-12.6 2.6-26.2 15.2-30.4l24-8c7.3-2.4 15.4-1.2 21.6 3.3s10 11.8 10 19.5z"
        }
    ]
};

const FasRepeat = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasRepeat",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 224c0 17.7 14.3 32 32 32s32-14.3 32-32c0-53 43-96 96-96h160v32c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l64-64c12.5-12.5 12.5-32.8 0-45.3l-64-64c-9.2-9.2-22.9-11.9-34.9-6.9S320 19.1 320 32v32H160C71.6 64 0 135.6 0 224zm512 64c0-17.7-14.3-32-32-32s-32 14.3-32 32c0 53-43 96-96 96H192v-32c0-12.9-7.8-24.6-19.8-29.6s-25.7-2.2-34.9 6.9l-64 64c-12.5 12.5-12.5 32.8 0 45.3l64 64c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6V448h160c88.4 0 160-71.6 160-160z"
        }
    ]
};

const FasReplyAll = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasReplyAll",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M209.4 39.5c-9.1-9.6-24.3-10-33.9-.9L33.8 173.2c-19.9 18.9-19.9 50.7 0 69.6l141.7 134.6c9.6 9.1 24.8 8.7 33.9-.9s8.7-24.8-.9-33.9L66.8 208 208.5 73.4c9.6-9.1 10-24.3.9-33.9zM352 64c0-12.6-7.4-24.1-19-29.2s-25-3-34.4 5.4l-160 144c-6.7 6.1-10.6 14.7-10.6 23.8s3.9 17.7 10.6 23.8l160 144c9.4 8.5 22.9 10.6 34.4 5.4s19-16.6 19-29.2v-64h32c53 0 96 43 96 96 0 30.4-12.8 47.9-22.2 56.7-5.5 5.1-9.8 12-9.8 19.5 0 10.9 8.8 19.7 19.7 19.7 2.8 0 5.6-.6 8.1-1.9C494.5 467.9 576 417.3 576 304c0-97.2-78.8-176-176-176h-48V64z"
        }
    ]
};

const FasReplyClock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasReplyClock",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 144a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm144-80c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32V80c0-8.8-7.2-16-16-16zm0 256c5.1 0 10.2-.2 15.2-.6.5 5.5.8 11 .8 16.6 0 113.3-81.5 163.9-100.2 174.1-2.5 1.4-5.3 1.9-8.1 1.9-10.9 0-19.7-8.9-19.7-19.7 0-7.5 4.3-14.4 9.8-19.5 9.4-8.8 22.2-26.4 22.2-56.7 0-53-43-96-96-96h-96v64c0 12.6-7.4 24.1-19 29.2s-25 3-34.4-5.4l-160-144C3.9 257.7 0 249.1 0 240s3.9-17.7 10.6-23.8l160-144c9.4-8.5 22.9-10.6 34.4-5.4s19 16.6 19 29.2v64h96.7c8.1 89.7 83.5 160 175.3 160z"
        }
    ]
};

const FasReply = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasReply",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M205 34.8c11.5 5.1 19 16.6 19 29.2v64h112c97.2 0 176 78.8 176 176 0 113.3-81.5 163.9-100.2 174.1-2.5 1.4-5.3 1.9-8.1 1.9-10.9 0-19.7-8.9-19.7-19.7 0-7.5 4.3-14.4 9.8-19.5 9.4-8.8 22.2-26.4 22.2-56.7 0-53-43-96-96-96h-96v64c0 12.6-7.4 24.1-19 29.2s-25 3-34.4-5.4l-160-144C3.9 225.7 0 217.1 0 208s3.9-17.7 10.6-23.8l160-144c9.4-8.5 22.9-10.6 34.4-5.4z"
        }
    ]
};

const FasRepublican = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasRepublican",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 192C0 103.6 71.6 32 160 32h224c88.4 0 160 71.6 160 160v64H0v-64zm415.9-64c-2.4 0-4.7 1.3-5.7 3.4L397.6 156l-28.2 4c-2.4.3-4.4 2-5.2 4.2s-.1 4.7 1.6 6.3l20.4 19.2-4.8 27.1c-.4 2.3.6 4.7 2.5 6s4.6 1.6 6.7.5l25.2-12.8 25.2 12.8c2.2 1.1 4.8.9 6.7-.5s3-3.7 2.5-6l-4.8-27.1 20.6-19.2c1.7-1.6 2.4-4.1 1.6-6.3s-2.8-3.9-5.2-4.2l-28.2-4-12.6-24.6c-1.1-2.1-3.3-3.4-5.7-3.4zm-138.3 3.4c-1.1-2.1-3.3-3.4-5.7-3.4s-4.7 1.3-5.7 3.4L253.6 156l-28.2 4c-2.4.3-4.4 2-5.2 4.2s-.1 4.7 1.6 6.3l20.4 19.2-4.8 27.1c-.4 2.3.6 4.7 2.5 6s4.6 1.6 6.7.5l25.2-12.8 25.2 12.8c2.2 1.1 4.8.9 6.7-.5s3-3.7 2.5-6l-4.8-27.1 20.6-19.2c1.7-1.6 2.4-4.1 1.6-6.3s-2.8-3.9-5.2-4.2l-28.2-4-12.6-24.6zM127.9 128c-2.4 0-4.7 1.3-5.7 3.4L109.6 156l-28.2 4c-2.4.3-4.4 2-5.2 4.2s-.1 4.7 1.6 6.3l20.4 19.2-4.8 27.1c-.4 2.3.6 4.7 2.5 6s4.6 1.6 6.7.5l25.2-12.8 25.2 12.8c2.2 1.1 4.8.9 6.7-.5s3-3.7 2.5-6l-4.8-27.1 20.6-19.2c1.7-1.6 2.4-4.1 1.6-6.3s-2.8-3.9-5.2-4.2l-28.2-4-12.6-24.6c-1.1-2.1-3.3-3.4-5.7-3.4zm.1 160h416v112c0 8.8 7.2 16 16 16s16-7.2 16-16v-48c0-17.7 14.3-32 32-32s32 14.3 32 32v48c0 44.2-35.8 80-80 80s-80-35.8-80-80v-48h-32v96c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32v-64H128v64c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V288h128z"
        }
    ]
};

const FasRestroomSimple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasRestroomSimple",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 64a64 64 0 1 0-128 0 64 64 0 1 0 128 0zM25.9 233.4l-4.1 49.3c-2.5 29.8 15.7 56.1 42.2 65.6V464c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V348.3c26.5-9.5 44.7-35.8 42.2-65.6l-4.1-49.3c-3.4-41.5-38.1-73.4-79.7-73.4h-44.8c-41.6 0-76.3 31.9-79.7 73.4zM320 0c-13.3 0-24 10.7-24 24v464c0 13.3 10.7 24 24 24s24-10.7 24-24V24c0-13.3-10.7-24-24-24zm192 128a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-15.7 32c-28.6 0-53.7 18.9-61.5 46.4l-39.1 136.8c-5.8 20.4 9.5 40.8 30.8 40.8H448v80c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48v-80h21.6c21.3 0 36.6-20.3 30.8-40.8l-39.1-136.8c-7.8-27.5-33-46.4-61.5-46.4h-31.5z"
        }
    ]
};

const FasRestroom = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasRestroom",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 48a48 48 0 1 1 96 0 48 48 0 1 1-96 0zm40 304v128c0 17.7-14.3 32-32 32s-32-14.3-32-32V325.2c-8.1 9.2-21.1 13.2-33.5 9.4-16.9-5.3-26.3-23.2-21-40.1l30.9-99.1C44.9 155.3 82 128 124 128h8c42 0 79.1 27.3 91.6 67.4l30.9 99.1c5.3 16.9-4.1 34.8-21 40.1-12.4 3.9-25.4-.2-33.5-9.4V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352h-16zM320 0c13.3 0 24 10.7 24 24v464c0 13.3-10.7 24-24 24s-24-10.7-24-24V24c0-13.3 10.7-24 24-24zm144 48a48 48 0 1 1 96 0 48 48 0 1 1-96 0zm-24 432v-96h-17.8c-10.9 0-18.6-10.7-15.2-21.1l9-26.9c-3.2 0-6.4-.5-9.5-1.5-16.9-5.3-26.3-23.2-21-40.1l29.7-95.2c13.2-42.3 52.4-71.2 96.8-71.2s83.6 28.9 96.8 71.2l29.7 95.2c5.3 16.9-4.1 34.8-21 40.1-3.2 1-6.4 1.5-9.5 1.5l9 26.9c3.5 10.4-4.3 21.1-15.2 21.1H584v96c0 17.7-14.3 32-32 32s-32-14.3-32-32v-96h-16v96c0 17.7-14.3 32-32 32s-32-14.3-32-32z"
        }
    ]
};

const FasRetweet = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasRetweet",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M272 416c17.7 0 32-14.3 32-32s-14.3-32-32-32H160c-17.7 0-32-14.3-32-32V192h32c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-64-64c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-9.2 9.2-11.9 22.9-6.9 34.9S19.1 192 32.1 192h32v128c0 53 43 96 96 96H272zm32-320c-17.7 0-32 14.3-32 32s14.3 32 32 32h112c17.7 0 32 14.3 32 32v128h-32c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l64 64c12.5 12.5 32.8 12.5 45.3 0l64-64c9.2-9.2 11.9-22.9 6.9-34.9S556.9 320 543.9 320h-32V192c0-53-43-96-96-96H304z"
        }
    ]
};

const FasRhombus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasRhombus",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M254.4 14.1C246.8 5.1 235.7 0 224 0s-22.8 5.1-30.4 14.1l-184 216C-3.2 245-3.2 267 9.6 281.9l184 216c7.6 8.9 18.7 14.1 30.4 14.1s22.8-5.1 30.4-14.1l184-216c12.7-14.9 12.7-36.9 0-51.9l-184-216z"
        }
    ]
};

const FasRibbon = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasRibbon",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m333.2 322.8-133.9-146-53.3-58.2c7.8-5.1 37-22.6 78-22.6s70.2 17.4 78 22.6L245.7 180l85.6 93.4 27.4-29.8c16.3-17.7 25.3-40.9 25.3-65v-29.5c0-19-5.6-37.5-16.1-53.3l-40.1-60.2C312.9 13.4 287.9 0 261.2 0h-76c-25.8 0-50.1 12.5-65.1 33.5L81.9 87C70.3 103.2 64 122.8 64 142.8V164c0 23.2 8.4 45.6 23.6 63.1l56 64.2 83.3 95.6 91.8 105.3c10 11.5 26.8 14.3 40 6.8l54.5-31.1c17.8-10.2 21.6-34.3 7.7-49.4l-87.7-95.7zm-128 87.8L121.9 315 27.1 418.5c-13.9 15.1-10.1 39.2 7.7 49.4l55.1 31.5c13 7.4 29.3 4.9 39.4-6.1l75.9-82.6z"
        }
    ]
};

const FasRightFromBracket = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasRightFromBracket",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m377.9 105.9 122.8 122.8c7.2 7.2 11.3 17.1 11.3 27.3s-4.1 20.1-11.3 27.3L377.9 406.1c-6.4 6.4-15 9.9-24 9.9-18.7 0-33.9-15.2-33.9-33.9V320H192c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32h128v-62.1c0-18.7 15.2-33.9 33.9-33.9 9 0 17.6 3.6 24 9.9zM160 96H96c-17.7 0-32 14.3-32 32v256c0 17.7 14.3 32 32 32h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H96c-53 0-96-43-96-96V128c0-53 43-96 96-96h64c17.7 0 32 14.3 32 32s-14.3 32-32 32z"
        }
    ]
};

const FasRightFromLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasRightFromLine",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m313.9 105.9 122.8 122.8c7.2 7.2 11.3 17.1 11.3 27.3s-4.1 20.1-11.3 27.3L313.9 406.1c-6.4 6.4-15 9.9-24 9.9-18.7 0-33.9-15.2-33.9-33.9V320H128c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32h128v-62.1c0-18.7 15.2-33.9 33.9-33.9 9 0 17.6 3.6 24 9.9zM64 96v320c0 17.7-14.3 32-32 32S0 433.7 0 416V96c0-17.7 14.3-32 32-32s32 14.3 32 32z"
        }
    ]
};

const FasRightLeftLarge = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasRightLeftLarge",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M184.4 512c-19 0-37.2-7.5-50.6-21L15 372.3C5.4 362.7 0 349.6 0 336s5.4-26.7 15-36.3L133.8 181c13.4-13.4 31.6-21 50.6-21 37 0 67.4 28 71.2 64H432c8.8 0 16 7.2 16 16v40.4c0 4.2 3.4 7.6 7.6 7.6 2 0 3.9-.8 5.4-2.2L570.7 176 461 66.2c-1.4-1.4-3.4-2.2-5.4-2.2-4.2 0-7.6 3.4-7.6 7.6V112c0 8.8-7.2 16-16 16H320c-17.7 0-32-14.3-32-32s14.3-32 32-32h64.4c3.8-36 34.2-64 71.2-64 19 0 37.2 7.5 50.6 21L625 139.7c9.6 9.6 15 22.7 15 36.3s-5.4 26.7-15 36.3L506.2 331c-13.4 13.4-31.6 21-50.6 21-37 0-67.4-28-71.2-64H208c-8.8 0-16-7.2-16-16v-40.4c0-4.2-3.4-7.6-7.6-7.6-2 0-3.9.8-5.4 2.2L69.3 336 179 445.8c1.4 1.4 3.4 2.2 5.4 2.2 4.2 0 7.6-3.4 7.6-7.6V400c0-8.8 7.2-16 16-16h112c17.7 0 32 14.3 32 32s-14.3 32-32 32h-64.4c-3.8 36-34.2 64-71.2 64z"
        }
    ]
};

const FasRightLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasRightLeft",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 96h320V32c0-12.9 7.8-24.6 19.8-29.6s25.7-2.2 34.9 6.9l96 96c6 6 9.4 14.1 9.4 22.6s-3.4 16.6-9.4 22.6l-96 96c-9.2 9.2-22.9 11.9-34.9 6.9S352 236.8 352 223.8V160H32c-17.7 0-32-14.3-32-32s14.3-32 32-32zm448 256c17.7 0 32 14.3 32 32s-14.3 32-32 32H160v64c0 12.9-7.8 24.6-19.8 29.6s-25.7 2.2-34.9-6.9l-96-96c-6-6-9.4-14.1-9.4-22.6s3.4-16.6 9.4-22.6l96-96c9.2-9.2 22.9-11.9 34.9-6.9s19.8 16.6 19.8 29.6v64h320z"
        }
    ]
};

const FasRightLongToLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasRightLongToLine",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M640 96v320c0 17.7-14.3 32-32 32s-32-14.3-32-32V96c0-17.7 14.3-32 32-32s32 14.3 32 32zM360.5 409.4c-7 6.6-17.2 8.4-26 4.6S320 401.5 320 392v-72H32c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32h288v-72c0-9.6 5.7-18.2 14.5-22s19-2 26 4.6l144 136c4.8 4.5 7.5 10.8 7.5 17.4s-2.7 12.9-7.5 17.4l-144 136z"
        }
    ]
};

const FasRightLong = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasRightLong",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M334.5 414c8.8 3.8 19 2 26-4.6l144-136c4.8-4.5 7.5-10.8 7.5-17.4s-2.7-12.9-7.5-17.4l-144-136c-7-6.6-17.2-8.4-26-4.6S320 110.5 320 120v72H32c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h288v72c0 9.6 5.7 18.2 14.5 22z"
        }
    ]
};

const FasRightToBracket = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasRightToBracket",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m217.9 105.9 122.8 122.8c7.2 7.2 11.3 17.1 11.3 27.3s-4.1 20.1-11.3 27.3L217.9 406.1c-6.4 6.4-15 9.9-24 9.9-18.7 0-33.9-15.2-33.9-33.9V320H32c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32h128v-62.1c0-18.7 15.2-33.9 33.9-33.9 9 0 17.6 3.6 24 9.9zM352 416h64c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32h-64c-17.7 0-32-14.3-32-32s14.3-32 32-32h64c53 0 96 43 96 96v256c0 53-43 96-96 96h-64c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
        }
    ]
};

const FasRightToLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasRightToLine",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m217.9 105.9 122.8 122.8c7.2 7.2 11.3 17.1 11.3 27.3s-4.1 20.1-11.3 27.3L217.9 406.1c-6.4 6.4-15 9.9-24 9.9-18.7 0-33.9-15.2-33.9-33.9V320H32c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32h128v-62.1c0-18.7 15.2-33.9 33.9-33.9 9 0 17.6 3.6 24 9.9zM384 416V96c0-17.7 14.3-32 32-32s32 14.3 32 32v320c0 17.7-14.3 32-32 32s-32-14.3-32-32z"
        }
    ]
};

const FasRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasRight",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M438.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-9.2 9.2-22.9 11.9-34.9 6.9S223.9 429 223.9 416v-96H40c-22.1 0-40-17.9-40-40v-48c0-22.1 17.9-40 40-40h184V96c0-12.9 7.8-24.6 19.8-29.6s25.7-2.2 34.9 6.9l160 160z"
        }
    ]
};

const FasRingDiamond = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasRingDiamond",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M122.5 13.3C126.6 5.1 134.9 0 144 0h96c9.1 0 17.4 5.1 21.5 13.3l24 48c3.5 7.1 3.4 15.5-.5 22.4l-30.4 54.8C329.9 164.4 384 235.9 384 320c0 106-86 192-192 192S0 426 0 320c0-84.1 54.1-155.6 129.4-181.6L99 83.7c-3.8-6.9-4-15.3-.5-22.4l24-48zM192 192a128 128 0 1 0 0 256 128 128 0 1 0 0-256z"
        }
    ]
};

const FasRing = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasRing",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 208c0 7.8 4.4 18.7 17.1 30.3C126.5 214.1 188.9 200 256 200s129.5 14.1 174.9 38.3c12.7-11.6 17.1-22.5 17.1-30.3 0-12.3-10.8-32-47.9-50.6C364.9 139.8 314 128 256 128s-108.9 11.8-144.1 29.4C74.8 176 64 195.7 64 208zm192 40c-47 0-89.3 7.6-122.9 19.7C166.3 280.2 208.8 288 256 288s89.7-7.8 122.9-20.3C345.3 255.6 303 248 256 248zM0 208c0-49.6 39.4-85.8 83.3-107.8C129.1 77.3 190.3 64 256 64s126.9 13.3 172.7 36.2c43.9 22 83.3 58.2 83.3 107.8v96c0 49.6-39.4 85.8-83.3 107.8-45.8 22.9-107 36.2-172.7 36.2s-126.9-13.3-172.7-36.2C39.4 389.8 0 353.6 0 304v-96z"
        }
    ]
};

const FasRingsWedding = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasRingsWedding",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M113.7 8.8C116.4 3.4 121.9 0 128 0h96c6.1 0 11.6 3.4 14.3 8.8l16 32c2.3 4.5 2.3 9.8 0 14.3l-24.6 49.2C300.6 127.1 352 193.5 352 272c0 52.3-22.8 99.2-59 131.5-18.7-11.9-32.1-31.5-35.9-54.2C276.2 329.2 288 302 288 272c0-12-1.9-23.6-5.4-34.5-34.9 19-58.6 56-58.6 98.5 0 61.9 50.1 112 112 112s112-50.1 112-112c0-46.1-27.8-85.7-67.6-102.9-5-26.2-14.8-50.7-28.6-72.4 89.8 8 160.2 83.4 160.2 175.3 0 97.2-78.8 176-176 176-55.3 0-104.7-25.5-137-65.5-7.5 1-15.2 1.5-23 1.5C78.8 448 0 369.2 0 272c0-78.5 51.4-144.9 122.3-167.7L97.7 55.2c-2.3-4.5-2.3-9.8 0-14.3l16-32zM176 160c-61.9 0-112 50.1-112 112 0 58.7 45.1 106.8 102.5 111.6-4.2-15.1-6.5-31.1-6.5-47.6 0-64.4 34.5-120.7 86.1-151.3-19.2-15.5-43.6-24.7-70.1-24.7z"
        }
    ]
};

const FasRoadBarrier = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasRoadBarrier",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 32C14.3 32 0 46.3 0 64v384c0 17.7 14.3 32 32 32s32-14.3 32-32V266.3L149.2 96H64V64c0-17.7-14.3-32-32-32zm373.2 64h-74.4l-5.4 10.7L234.8 288h74.3l5.4-10.7L405.2 96zm-42.4 192h74.3l5.4-10.7L533.2 96h-74.4l-5.4 10.7L362.8 288zm-160-192-5.4 10.7L106.8 288h74.3l5.4-10.7L277.2 96h-74.4zm288 192H576v160c0 17.7 14.3 32 32 32s32-14.3 32-32V64c0-17.7-14.3-32-32-32s-32 14.3-32 32v53.7L490.8 288z"
        }
    ]
};

const FasRoadBridge = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasRoadBridge",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 0h256c17.7 0 32 14.3 32 32v448c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V32c0-17.7 14.3-32 32-32zm128 200c-13.3 0-24 10.7-24 24v64c0 13.3 10.7 24 24 24s24-10.7 24-24v-64c0-13.3-10.7-24-24-24zm24 184c0-13.3-10.7-24-24-24s-24 10.7-24 24v64c0 13.3 10.7 24 24 24s24-10.7 24-24v-64zM480 40c-13.3 0-24 10.7-24 24v64c0 13.3 10.7 24 24 24s24-10.7 24-24V64c0-13.3-10.7-24-24-24zM32 96h256v64h-40v64h40v96c-53 0-96 43-96 96v64c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32v-64c0-53-43-96-96-96v-96h72v-64H32c-17.7 0-32-14.3-32-32s14.3-32 32-32zm168 64h-80v64h80v-64z"
        }
    ]
};

const FasRoadCircleCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasRoadCircleCheck",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M213.2 32H288v64c0 17.7 14.3 32 32 32s32-14.3 32-32V32h74.8c27.1 0 51.3 17.1 60.3 42.6l42.7 120.6c-10.9-2.1-22.2-3.2-33.8-3.2-59.5 0-112.1 29.6-144 74.8V224c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 17.7 14.3 32 32 32 2.3 0 4.6-.3 6.8-.7-4.5 15.5-6.8 31.8-6.8 48.7 0 5.4.2 10.7.7 16h-.7c-17.7 0-32 14.3-32 32v64H86.6C56.5 480 32 455.5 32 425.4c0-6.2 1.1-12.4 3.1-18.2L152.9 74.6C162 49.1 186.1 32 213.2 32zM352 368a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L480 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"
        }
    ]
};

const FasRoadCircleExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasRoadCircleExclamation",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M213.2 32H288v64c0 17.7 14.3 32 32 32s32-14.3 32-32V32h74.8c27.1 0 51.3 17.1 60.3 42.6l42.7 120.6c-10.9-2.1-22.2-3.2-33.8-3.2-59.5 0-112.1 29.6-144 74.8V224c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 17.7 14.3 32 32 32 2.3 0 4.6-.3 6.8-.7-4.5 15.5-6.8 31.8-6.8 48.7 0 5.4.2 10.7.7 16h-.7c-17.7 0-32 14.3-32 32v64H86.6C56.5 480 32 455.5 32 425.4c0-6.2 1.1-12.4 3.1-18.2L152.9 74.6C162 49.1 186.1 32 213.2 32zM496 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-192c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16v-80c0-8.8-7.2-16-16-16z"
        }
    ]
};

const FasRoadCircleXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasRoadCircleXmark",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M213.2 32H288v64c0 17.7 14.3 32 32 32s32-14.3 32-32V32h74.8c27.1 0 51.3 17.1 60.3 42.6l42.7 120.6c-10.9-2.1-22.2-3.2-33.8-3.2-59.5 0-112.1 29.6-144 74.8V224c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 17.7 14.3 32 32 32 2.3 0 4.6-.3 6.8-.7-4.5 15.5-6.8 31.8-6.8 48.7 0 5.4.2 10.7.7 16h-.7c-17.7 0-32 14.3-32 32v64H86.6C56.5 480 32 455.5 32 425.4c0-6.2 1.1-12.4 3.1-18.2L152.9 74.6C162 49.1 186.1 32 213.2 32zM496 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm22.6 144 36.7-36.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L496 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l36.7 36.7-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l36.7-36.7 36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L518.6 368z"
        }
    ]
};

const FasRoadLock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasRoadLock",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 32h-74.8c-27.1 0-51.3 17.1-60.3 42.6L35.1 407.2c-2.1 5.9-3.1 12-3.1 18.2 0 30.1 24.5 54.6 54.6 54.6H288v-64c0-17.7 14.3-32 32-32s32 14.3 32 32v64h32V352c0-23.7 12.9-44.4 32-55.4V272c0-58.3 44.6-106.2 101.5-111.5l-30.4-85.9C478 49.1 453.9 32 426.8 32H352v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V32zm64 192v64c0 17.7-14.3 32-32 32s-32-14.3-32-32v-64c0-17.7 14.3-32 32-32s32 14.3 32 32zm176 16c17.7 0 32 14.3 32 32v48h-64v-48c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32v128c0 17.7 14.3 32 32 32h160c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32v-48c0-44.2-35.8-80-80-80s-80 35.8-80 80z"
        }
    ]
};

const FasRoadSpikes = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasRoadSpikes",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 116.8c0-15.8 20.5-22 29.3-8.9L192 256V116.8c0-15.8 20.5-22 29.3-8.9L320 256V116.8c0-15.8 20.5-22 29.3-8.9L448 256V116.8c0-15.8 20.5-22 29.3-8.9l129.5 194.3c14.2 21.3-1.1 49.7-26.6 49.7H64V116.8zM32 384h576c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
        }
    ]
};

const FasRoad = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasRoad",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32h-74.8c-27.1 0-51.3 17.1-60.3 42.6L3.1 407.2c-2 5.8-3.1 12-3.1 18.2C0 455.5 24.5 480 54.6 480H256v-64c0-17.7 14.3-32 32-32s32 14.3 32 32v64h201.4c30.2 0 54.6-24.5 54.6-54.6 0-6.2-1.1-12.4-3.1-18.2L455.1 74.6C446 49.1 421.9 32 394.8 32H320v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V32zm64 192v64c0 17.7-14.3 32-32 32s-32-14.3-32-32v-64c0-17.7 14.3-32 32-32s32 14.3 32 32z"
        }
    ]
};

const FasRobotAstromech = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasRobotAstromech",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 0c70.7 0 128 57.3 128 128v32H128v-32C128 57.3 185.3 0 256 0zm0 96a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm48 32a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM48 240c0-26.5 21.5-48 48-48h320c26.5 0 48 21.5 48 48v158.3c0 8.7 2.4 17.2 6.8 24.7l38.9 64.8c3 4.9 3 11.1.2 16.1s-8.2 8.1-13.9 8.1h-96c-8.8 0-16-7.2-16-16V384l-45.3 45.3c-12 12-28.3 18.7-45.3 18.7h-75c-17 0-33.3-6.7-45.3-18.7L128 384v112c0 8.8-7.2 16-16 16H16c-5.8 0-11.1-3.1-13.9-8.1s-2.8-11.2.2-16.1L41.2 423c4.5-7.5 6.8-16 6.8-24.7V240zm160 16c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16h-96zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16h-96z"
        }
    ]
};

const FasRobot = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasRobot",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 0c17.7 0 32 14.3 32 32v64h120c39.8 0 72 32.2 72 72v272c0 39.8-32.2 72-72 72H168c-39.8 0-72-32.2-72-72V168c0-39.8 32.2-72 72-72h120V32c0-17.7 14.3-32 32-32zM208 384c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32zm96 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32zm96 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32zM264 256a40 40 0 1 0-80 0 40 40 0 1 0 80 0zm152 40a40 40 0 1 0 0-80 40 40 0 1 0 0 80zM48 224h16v192H48c-26.5 0-48-21.5-48-48v-96c0-26.5 21.5-48 48-48zm544 0c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48h-16V224h16z"
        }
    ]
};

const FasRocketLaunch = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasRocketLaunch",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M117.8 128H207C286.9-3.7 409.5-8.5 483.9 5.3c11.6 2.2 20.7 11.2 22.8 22.8 13.8 74.4 9 197-122.7 276.9v89.3c0 25.4-13.4 49-35.3 61.9l-88.5 52.5c-7.4 4.4-16.6 4.5-24.1.2S224 496.7 224 488V373.3c0-22.6-9-44.3-25-60.3s-37.7-25-60.3-25H24c-8.6 0-16.6-4.6-20.9-12.1s-4.2-16.7.2-24.1l52.5-88.5c13-21.9 36.5-35.3 61.9-35.3zm306.2 0a40 40 0 1 0-80 0 40 40 0 1 0 80 0zM166.5 470C132.3 504.3 66 511 28.3 511.9c-16 .4-28.6-12.2-28.2-28.2C1 446 7.7 379.7 42 345.5c34.4-34.4 90.1-34.4 124.5 0s34.4 90.1 0 124.5zm-46.7-36.4c11.4-11.4 11.4-30 0-41.4s-30-11.4-41.4 0c-10.1 10.1-13 28.5-13.7 41.3-.5 8 5.9 14.3 13.9 13.9 12.8-.7 31.2-3.7 41.3-13.7z"
        }
    ]
};

const FasRocket = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasRocket",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M156.6 384.9 125.7 354c-8.5-8.5-11.5-20.8-7.7-32.2 3-8.9 7-20.5 11.8-33.8H24c-8.6 0-16.6-4.6-20.9-12.1s-4.2-16.7.2-24.1l52.5-88.5c13-21.9 36.5-35.3 61.9-35.3H200c2.4-4 4.8-7.7 7.2-11.3C289.1-4.1 411.1-8.1 483.9 5.3c11.6 2.1 20.6 11.2 22.8 22.8 13.4 72.9 9.3 194.8-111.4 276.7-3.5 2.4-7.3 4.8-11.3 7.2v82.3c0 25.4-13.4 49-35.3 61.9l-88.5 52.5c-7.4 4.4-16.6 4.5-24.1.2S224 496.7 224 488V380.8c-14.1 4.9-26.4 8.9-35.7 11.9-11.2 3.6-23.4.5-31.8-7.8zM384 168a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"
        }
    ]
};

const FasRollerCoaster = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasRollerCoaster",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 190.1c0-31.8 15.8-60 40-77V456c0 13.3 10.7 24 24 24s24-10.7 24-24V96.2c2-.1 4-.2 6.1-.2 14.8 0 29.1 3.5 41.9 9.9V456c0 13.3 10.7 24 24 24s24-10.7 24-24V154.7l48 69.1V456c0 13.3 10.7 24 24 24s24-10.7 24-24V292.9l20.3 29.2c7.9 11.3 17.2 21.3 27.7 29.8V456c0 13.3 10.7 24 24 24s24-10.7 24-24v-78.4c13.6 4.2 28 6.4 42.6 6.4h5.4v72c0 13.3 10.7 24 24 24s24-10.7 24-24v-77.6c14.4-4.2 27.8-10.5 40-18.6V448c0 17.7 14.3 32 32 32s32-14.3 32-32V248h-.2c.1-2.6.2-5.3.2-8 0-79.5-64.5-144-144-144h-4c-28.9 0-57.3 7.1-82.8 20.7l-51.6 27.5L432 251.3v-74.2l7.3-3.9c12.7-6.8 26.5-11 40.7-12.5V264c0 13.3 10.7 24 24 24s24-10.7 24-24v-97.3c28.3 12.3 48 40.5 48 73.3 0 44.2-35.8 80-80 80h-13.4c-26.2 0-50.8-12.8-65.7-34.4l-129-185.7C258.4 57.4 209.9 32 158.1 32 70.8 32 0 102.8 0 190.1V448c0 17.7 14.3 32 32 32s32-14.3 32-32V190.1z"
        }
    ]
};

const FasRotateExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasRotateExclamation",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m74.9 192-28.8-13.8c-7.6 15.9-.9 35 15 42.7s35 .9 42.7-15v-.1l.2-.3.7-1.5c.6-1.3 1.6-3.2 2.8-5.6 2.5-4.8 5.9-11.4 10-18.5 8.7-15.3 18.2-29.8 25.3-36.9 62.5-62.5 163.8-62.5 226.3 0l17.2 17H352c-17.7 0-32 14.3-32 32s14.3 32 32 32h112c17.7 0 32-14.3 32-32V80c0-17.7-14.3-32-32-32s-32 14.3-32 32v35.2l-17.6-17.6c-87.5-87.5-229.3-87.5-316.8 0-13.8 13.8-27 35.2-35.7 50.6-4.6 8.2-8.6 15.6-11.3 21-1.4 2.7-2.5 4.9-3.3 6.5l-.9 1.8-.2.5-.1.2L75 192zM280 152c0-13.3-10.7-24-24-24s-24 10.7-24 24v112c0 13.3 10.7 24 24 24s24-10.7 24-24V152zm-24 232a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM48 464c17.7 0 32-14.3 32-32v-35.2l17.6 17.6c87.5 87.5 229.3 87.5 316.8 0 24.4-24.4 42.1-53.1 52.9-83.7 5.9-16.7-2.9-34.9-19.5-40.8s-34.9 2.9-40.8 19.5c-7.7 21.8-20.2 42.3-37.8 59.8-62.5 62.5-163.8 62.5-226.3 0L125.7 352H160c17.7 0 32-14.3 32-32s-14.3-32-32-32H48c-17.7 0-32 14.3-32 32v112c0 17.7 14.3 32 32 32z"
        }
    ]
};

const FasRotateLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasRotateLeft",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2S50.1 48.1 57 55l41.6 41.6c87.6-86.5 228.7-86.2 315.8 1 87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2S177.7 224 168 224H48.5z"
        }
    ]
};

const FasRotateRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasRotateRight",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M463.5 224h8.5c13.3 0 24-10.7 24-24V72c0-9.7-5.8-18.5-14.8-22.2S461.9 48.1 455 55l-41.6 41.6c-87.6-86.5-228.7-86.2-315.8 1-87.5 87.5-87.5 229.3 0 316.8s229.3 87.5 316.8 0c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0c-62.5 62.5-163.8 62.5-226.3 0s-62.5-163.8 0-226.3c62.2-62.2 162.7-62.5 225.3-1L327 183c-6.9 6.9-8.9 17.2-5.2 26.2S334.3 224 344 224h119.5z"
        }
    ]
};

const FasRotate = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasRotate",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M142.9 142.9c62.2-62.2 162.7-62.5 225.3-1L327 183c-6.9 6.9-8.9 17.2-5.2 26.2S334.3 224 344 224h128c13.3 0 24-10.7 24-24V72c0-9.7-5.8-18.5-14.8-22.2S461.9 48.1 455 55l-41.6 41.6c-87.6-86.5-228.7-86.2-315.8 1-24.4 24.4-42 53.1-52.8 83.8-5.9 16.7 2.9 34.9 19.5 40.8s34.9-2.9 40.8-19.5c7.7-21.8 20.2-42.3 37.8-59.8zM16 312v128c0 9.7 5.8 18.5 14.8 22.2s19.3 1.7 26.2-5.2l41.6-41.6c87.6 86.5 228.7 86.2 315.8-1 24.4-24.4 42.1-53.1 52.9-83.7 5.9-16.7-2.9-34.9-19.5-40.8s-34.9 2.9-40.8 19.5c-7.7 21.8-20.2 42.3-37.8 59.8-62.2 62.2-162.7 62.5-225.3 1L185 329c6.9-6.9 8.9-17.2 5.2-26.2S177.7 288 168 288H40c-13.3 0-24 10.7-24 24z"
        }
    ]
};

const FasRouteHighway = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasRouteHighway",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M240.5 4.6c-10.1-6.1-22.8-6.1-32.9 0l-4.7 2.8c-37.5 22.5-84 24.3-123.1 4.7l-1.4-.7c-15.2-7.6-33.7-2-42.1 12.7l-32 56c-5.3 9.3-5.6 20.6-.8 30.2l16.2 32.5C27.8 159.1 32 177 32 195.2c0 14.9-2.8 29.7-8.4 43.6L9.3 274.5C3.2 289.9 0 306.4 0 323c0 49.5 28 94.8 72.2 116.9l137.4 68.7c9 4.5 19.6 4.5 28.6 0l137.4-68.7C420 417.8 448 372.5 448 323c0-16.6-3.2-33.1-9.3-48.5l-14.3-35.7c-5.5-13.9-8.4-28.6-8.4-43.6 0-18.2 4.2-36.2 12.4-52.5l16.2-32.5c4.8-9.6 4.5-20.9-.8-30.2l-32-56c-8.4-14.7-26.9-20.3-42.1-12.7l-1.4.7c-39.1 19.6-85.6 17.8-123.1-4.7l-4.7-2.8zM96 192h256v3.2c0 23.1 4.4 45.9 13 67.3l14.3 35.7c3.2 7.9 4.8 16.3 4.8 24.8 0 25.3-14.3 48.4-36.9 59.7L224 444.2l-123.1-61.5C78.3 371.4 64 348.3 64 323c0-8.5 1.6-16.9 4.8-24.8L83 262.6c8.6-21.4 13-44.3 13-67.3v-3.2z"
        }
    ]
};

const FasRouteInterstate = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasRouteInterstate",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M85.3 192h341c-.8 44.3-7.9 81.8-21.9 114.4-23.4 54.1-68.5 99.1-149 138.5-81.5-36.2-126.1-80.9-149-135.4-14-33.3-20.6-72-21-117.4zM276.9 7.3c-12.8-7.8-29-7.8-41.8 0-27.5 16.8-50.2 26-73.4 30-23.3 4-49.2 3.2-83.7-3.2C55.9 30 34.4 45 31.1 67.7 16 170.4 15.9 259.5 47.3 334.2c32.1 76.4 94.6 132.5 193 173.9 10.4 4.4 22.3 4.1 32.5-.6 95.7-44.8 157.8-100.7 190.3-175.7 32-73.9 32.9-161.2 17.8-264.1-3.3-22.6-24.8-37.7-46.9-33.6-34.4 6.3-60.3 7.2-83.7 3.2-23.2-4-45.9-13.2-73.4-30z"
        }
    ]
};

const FasRoute = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasRoute",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 96c0 50.2-59.1 125.1-84.6 155-3.8 4.4-9.4 6.1-14.5 5H320c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c53 0 96 43 96 96s-43 96-96 96H139.6c8.7-9.9 19.3-22.6 30-36.8 6.3-8.4 12.8-17.6 19-27.2H416c17.7 0 32-14.3 32-32s-14.3-32-32-32h-96c-53 0-96-43-96-96s43-96 96-96h39.8c-21-31.5-39.8-67.7-39.8-96 0-53 43-96 96-96s96 43 96 96zM117.1 489.1c-3.8 4.3-7.2 8.1-10.1 11.3l-1.8 2-.2-.2c-6 4.6-14.6 4-20-1.8C59.8 473 0 402.5 0 352c0-53 43-96 96-96s96 43 96 96c0 30-21.1 67-43.5 97.9-10.7 14.7-21.7 28-30.8 38.5l-.6.7zM128 352a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm288-224a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FasRouter = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasRouter",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 48c58.8 0 112.5 21.8 153.4 57.9 9.9 8.8 25.1 7.8 33.9-2.1s7.8-25.1-2.1-33.9C487.8 26.4 422.9 0 352 0S216.2 26.4 166.9 69.9c-9.9 8.8-10.9 23.9-2.1 33.9s23.9 10.9 33.9 2.1C239.5 69.8 293.2 48 352 48zm24 200c0-13.3-10.7-24-24-24s-24 10.7-24 24v72H64c-35.3 0-64 28.7-64 64v64c0 35.3 28.7 64 64 64h448c35.3 0 64-28.7 64-64v-64c0-35.3-28.7-64-64-64H376v-72zM96 384a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64 32a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm116.5-229.3C297.1 170 323.4 160 352 160s54.9 10 75.5 26.7c10.3 8.3 25.4 6.8 33.8-3.5s6.8-25.4-3.5-33.8C428.8 126 392 112 352 112s-76.8 14-105.7 37.4c-10.3 8.3-11.9 23.5-3.5 33.8s23.5 11.9 33.8 3.5z"
        }
    ]
};

const FasRss = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasRss",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 64c0-17.7 14.3-32 32-32 229.8 0 416 186.2 416 416 0 17.7-14.3 32-32 32s-32-14.3-32-32C384 253.6 226.4 96 32 96 14.3 96 0 81.7 0 64zm0 352a64 64 0 1 1 128 0 64 64 0 1 1-128 0zm32-256c159.1 0 288 128.9 288 288 0 17.7-14.3 32-32 32s-32-14.3-32-32c0-123.7-100.3-224-224-224-17.7 0-32-14.3-32-32s14.3-32 32-32z"
        }
    ]
};

const FasRubleSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasRubleSign",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 32c-17.7 0-32 14.3-32 32v192H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h32v32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h32v32c0 17.7 14.3 32 32 32s32-14.3 32-32v-32h160c17.7 0 32-14.3 32-32s-14.3-32-32-32H128v-32h112c79.5 0 144-64.5 144-144S319.5 32 240 32H96zm144 224H128V96h112c44.2 0 80 35.8 80 80s-35.8 80-80 80z"
        }
    ]
};

const FasRug = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasRug",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M24 64h56v384H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h8v-40h-8c-13.3 0-24-10.7-24-24s10.7-24 24-24h8v-32h-8c-13.3 0-24-10.7-24-24s10.7-24 24-24h8v-32h-8c-13.3 0-24-10.7-24-24s10.7-24 24-24h8v-40h-8c-13.3 0-24-10.7-24-24s10.7-24 24-24zm88 0h416v384H112V64zm528 24c0 13.3-10.7 24-24 24h-8v40h8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8v32h8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8v32h8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8v40h8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-56V64h56c13.3 0 24 10.7 24 24z"
        }
    ]
};

const FasRugbyBall = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasRugbyBall",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M368 16c13.4 0 26.4 2.1 38.5 5.9-21.1 1.8-44.5 8.7-69 19.5-53.4 23.5-114.8 66.9-172.1 124.1S64.9 284.1 41.4 337.6c-10.8 24.5-17.7 47.9-19.5 69-3.8-12.2-5.9-25.2-5.9-38.6v-32C16 159.3 159.3 16 336 16h32zm122.1 89.5c3.8 12.2 5.9 25.1 5.9 38.5v32c0 176.7-143.3 320-320 320h-32c-13.4 0-26.4-2.1-38.5-5.9 21.1-1.8 44.5-8.7 69-19.5 53.4-23.5 114.8-66.9 172.1-124.1s100.6-118.6 124.1-172.1c10.8-24.5 17.7-47.9 19.5-69zM63.7 448.3c-6.7-6.7-10.9-17.8-10.2-34.8.7-17.1 6.3-38.5 17.1-63 21.5-49 62.3-107.1 117.5-162.3S301.5 92.3 350.4 70.7c24.5-10.8 45.9-16.4 63-17.1 17.1-.7 28.1 3.5 34.8 10.2s10.9 17.8 10.2 34.8c-.7 17.1-6.3 38.5-17.1 63-21.5 49-62.3 107.1-117.5 162.3s-113.4 95.9-162.3 117.5c-24.5 10.8-45.9 16.4-63 17.1-17.1.7-28.1-3.4-34.8-10.2z"
        }
    ]
};

const FasRulerCombined = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasRulerCombined",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M.2 468.9C2.7 493.1 23.1 512 48 512h416c26.5 0 48-21.5 48-48v-96c0-26.5-21.5-48-48-48h-48v80c0 8.8-7.2 16-16 16s-16-7.2-16-16v-80h-64v80c0 8.8-7.2 16-16 16s-16-7.2-16-16v-80h-64v80c0 8.8-7.2 16-16 16s-16-7.2-16-16v-80h-80c-8.8 0-16-7.2-16-16s7.2-16 16-16h80v-64h-80c-8.8 0-16-7.2-16-16s7.2-16 16-16h80v-64h-80c-8.8 0-16-7.2-16-16s7.2-16 16-16h80V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48v416c0 1.7.1 3.3.2 4.9z"
        }
    ]
};

const FasRulerHorizontal = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasRulerHorizontal",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 336c0 26.5 21.5 48 48 48h544c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48h-64v80c0 8.8-7.2 16-16 16s-16-7.2-16-16v-80h-64v80c0 8.8-7.2 16-16 16s-16-7.2-16-16v-80h-64v80c0 8.8-7.2 16-16 16s-16-7.2-16-16v-80h-64v80c0 8.8-7.2 16-16 16s-16-7.2-16-16v-80h-64v80c0 8.8-7.2 16-16 16s-16-7.2-16-16v-80H48c-26.5 0-48 21.5-48 48v160z"
        }
    ]
};

const FasRulerTriangle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasRulerTriangle",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 32v416c0 35.3 28.7 64 64 64h416c17.7 0 32-14.3 32-32v-2.7c0-8.5-3.4-16.6-9.4-22.6l-51.3-51.3-24 24c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l24-24-57.4-57.4-24 24c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l24-24-57.4-57.4-24 24c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l24-24-57.4-57.4-24 24c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l24-24-57.4-57.5-24 24c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l24-24L57.4 9.4c-6-6-14.2-9.4-22.7-9.4H32C14.3 0 0 14.3 0 32zm128 224 128 128H128V256z"
        }
    ]
};

const FasRulerVertical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasRulerVertical",
    "viewBox": "0 0 256 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 48C0 21.5 21.5 0 48 0h160c26.5 0 48 21.5 48 48v48h-80c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v64h-80c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v64h-80c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v64h-80c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v48c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V48z"
        }
    ]
};

const FasRuler = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasRuler",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M177.9 494.1c-18.7 18.7-49.1 18.7-67.9 0l-92.1-92.2c-18.7-18.7-18.7-49.1 0-67.9l50.7-50.7 48 48c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-48-48 41.4-41.4 48 48c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-48-48 41.4-41.4 48 48c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-48-48 41.4-41.4 48 48c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-48-48L333.9 18C352.6-.7 383-.7 401.8 18l92.1 92.1c18.7 18.7 18.7 49.1 0 67.9l-316 316.1z"
        }
    ]
};

const FasRupeeSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasRupeeSign",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 64c0-17.7 14.3-32 32-32h80c79.5 0 144 64.5 144 144 0 58.8-35.2 109.3-85.7 131.7l51.4 128.4c6.6 16.4-1.4 35-17.8 41.6s-35-1.4-41.6-17.8l-56-139.9H64v128c0 17.7-14.3 32-32 32S0 465.7 0 448V64zm64 192h48c44.2 0 80-35.8 80-80s-35.8-80-80-80H64v160zm256.5 16.4c-.9 6 0 8.7.4 9.8.4 1.1 1.4 2.6 4.2 4.9 7.2 5.7 18.7 10 37.9 16.8l1.3.5c16 5.6 38.7 13.6 55.7 28.1 9.5 8.1 17.9 18.6 23.1 32.3 5.1 13.7 6.1 28.5 3.8 44-4.2 28.1-20.5 49.3-43.8 60.9-22.1 11-48.1 12.5-73.2 8h-.2c-9.3-1.8-20.5-5.7-29.3-9-6-2.3-12.6-4.9-17.7-6.9-2.5-1-4.6-1.8-6.3-2.5-16.5-6.4-24.6-25-18.2-41.4s24.9-24.6 41.4-18.2c2.6 1 5.2 2 7.9 3.1 4.8 1.9 9.8 3.9 15.4 6 8.8 3.3 15.3 5.4 18.7 6 15.7 2.8 26.7.8 32.9-2.3 5-2.5 8-6 9.1-13 1-6.9.2-10.5-.5-12.3-.6-1.7-1.8-3.6-4.5-5.9-6.9-5.8-18.2-10.4-36.9-17l-3-1.1c-15.5-5.4-37-13-53.3-25.9-9.5-7.5-18.3-17.6-23.7-31-5.5-13.4-6.6-28-4.4-43.2 8.4-57.1 67-78 116.9-68.9 6.9 1.3 27.3 5.8 35.4 8.4 16.9 5.2 26.3 23.2 21.1 40.1s-23.2 26.3-40.1 21.1c-4.7-1.4-22.3-5.5-27.9-6.5-14.6-2.7-25.8-.4-32.6 3.2-6.3 3.3-8.9 7.6-9.5 12z"
        }
    ]
};

const FasRupiahSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasRupiahSign",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 64c0-17.7 14.3-32 32-32h80c79.5 0 144 64.5 144 144 0 58.8-35.2 109.3-85.7 131.7l51.4 128.4c6.6 16.4-1.4 35-17.8 41.6s-35-1.4-41.6-17.8l-56-139.9H64v128c0 17.7-14.3 32-32 32S0 465.7 0 448V64zm64 192h48c44.2 0 80-35.8 80-80s-35.8-80-80-80H64v160zm256-96h80c61.9 0 112 50.1 112 112s-50.1 112-112 112h-48v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V192c0-17.7 14.3-32 32-32zm80 160c26.5 0 48-21.5 48-48s-21.5-48-48-48h-48v96h48z"
        }
    ]
};

const FasRv = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasRv",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 16c0-8.8 7.2-16 16-16h128c8.8 0 16 7.2 16 16v16h128c53 0 96 43 96 96 0 17.7-14.3 32-32 32H384v256H254.4c1 5.2 1.6 10.5 1.6 16 0 44.2-35.8 80-80 80s-80-35.8-80-80c0-5.5.6-10.8 1.6-16H96l-77.3-77.3C6.7 326.7 0 310.5 0 293.5V96c0-35.3 28.7-64 64-64h160V16zM112 128c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16H112zm96 304a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm288 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-80-48V192h100.6c12.9 0 25.5 4.5 35.5 12.7l67.4 55.2c13 10.6 20.5 26.5 20.5 43.3V384c0 17.7-14.3 32-32 32h-33.6c1 5.2 1.6 10.5 1.6 16 0 44.2-35.8 80-80 80s-80-35.8-80-80v-16zm162.1-128-56.5-46.2c-1.4-1.2-3.2-1.8-5.1-1.8H464v48h114.1z"
        }
    ]
};

const FasS = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasS",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M99.1 105.4C79 114 68.2 127.2 65.2 144.8c-2.4 14.1-.7 23.2 2 29.4 2.8 6.3 7.9 12.4 16.7 18.6 19.2 13.4 48.3 22.1 84.9 32.5 1 .3 1.9.6 2.9.8 32.7 9.3 72 20.6 100.9 40.7 15.7 10.9 29.9 25.5 38.6 45.1 8.8 19.8 10.8 42 6.6 66.3-7.3 42.5-35.3 71.7-71.8 87.3-35.4 15.2-79.1 17.9-123.7 10.9h-.2c-24-3.9-62.7-17.1-87.6-25.6-4.8-1.7-9.2-3.1-12.8-4.3-16.6-5.7-25.6-23.8-20.1-40.6s23.7-25.8 40.5-20.3C47 387.2 52.3 389 58 391c25.4 8.6 56.4 19.2 74.4 22.1 36.8 5.7 67.5 2.5 88.5-6.5 20.1-8.6 30.8-21.8 33.9-39.4 2.4-14.1.7-23.2-2-29.4-2.8-6.3-7.9-12.4-16.7-18.6-19.2-13.4-48.3-22.1-84.9-32.5-1-.3-1.9-.6-2.9-.8-32.7-9.3-72-20.6-100.9-40.7-15.7-10.9-29.9-25.5-38.6-45.1-8.8-19.8-10.8-42-6.6-66.3l31.5 5.5-31.6-5.4c7.3-42.5 35.3-71.7 71.8-87.3 35.4-15.2 79.1-17.9 123.7-10.9 13 2 52.4 9.6 66.6 13.4 17.1 4.5 27.2 22.1 22.7 39.2s-22.1 27.2-39.2 22.7c-11.2-3-48.1-10.2-60.1-12l4.9-31.5-4.9 31.5c-36.9-5.8-67.5-2.5-88.6 6.5z"
        }
    ]
};

const FasSackDollar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSackDollar",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 96H192l-47.4-71.1c-7.1-10.7.5-24.9 13.3-24.9h196.2c12.8 0 20.4 14.2 13.3 24.9L320 96zm-128 32h128c3.8 2.5 8.1 5.3 13 8.4 56.7 36.3 179 114.5 179 279.6 0 53-43 96-96 96H96c-53 0-96-43-96-96 0-165.1 122.3-243.3 179-279.6 4.8-3.1 9.2-5.9 13-8.4zm84 88c0-11-9-20-20-20s-20 9-20 20v14c-7.6 1.7-15.2 4.4-22.2 8.5-13.9 8.3-25.9 22.8-25.8 43.9.1 20.3 12 33.1 24.7 40.7 11 6.6 24.7 10.8 35.6 14l1.7.5c12.6 3.8 21.8 6.8 28 10.7 5.1 3.2 5.8 5.4 5.9 8.2.1 5-1.8 8-5.9 10.5-5 3.1-12.9 5-21.4 4.7-11.1-.4-21.5-3.9-35.1-8.5-2.3-.8-4.7-1.6-7.2-2.4-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9.6 4 1.3 6.1 2.1 8.3 2.9 17.9 6.2 28.2 8.4V424c0 11 9 20 20 20s20-9 20-20v-13.8c8-1.7 16-4.5 23.2-9 14.3-8.9 25.1-24.1 24.8-45-.3-20.3-11.7-33.4-24.6-41.6-11.5-7.2-25.9-11.6-37.1-15l-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5-5.2-3.1-5.3-4.9-5.3-6.7 0-3.7 1.4-6.5 6.2-9.3 5.4-3.2 13.6-5.1 21.5-5 9.6.1 20.2 2.2 31.2 5.2 10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7V216z"
        }
    ]
};

const FasSackXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSackXmark",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 96h128l47.4-71.1c7.1-10.7-.5-24.9-13.3-24.9H157.9c-12.8 0-20.4 14.2-13.3 24.9L192 96zm128 32H192c-3.8 2.5-8.1 5.3-13 8.4C122.3 172.7 0 250.9 0 416c0 53 43 96 96 96h320c53 0 96-43 96-96 0-165.1-122.3-243.3-179-279.6-4.8-3.1-9.2-5.9-13-8.4zm-30.1 208 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47z"
        }
    ]
};

const FasSack = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSack",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 96h128l47.4-71.1c7.1-10.7-.5-24.9-13.3-24.9H157.9c-12.8 0-20.4 14.2-13.3 24.9L192 96zm128 32H192c-3.8 2.5-8.1 5.3-13 8.4C122.3 172.7 0 250.9 0 416c0 53 43 96 96 96h320c53 0 96-43 96-96 0-165.1-122.3-243.3-179-279.6-4.8-3.1-9.2-5.9-13-8.4z"
        }
    ]
};

const FasSailboat = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSailboat",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 16c0-7 4.5-13.2 11.2-15.3s13.9.4 17.9 6.1l224 320c3.4 4.9 3.8 11.3 1.1 16.6S502 352 496 352H272c-8.8 0-16-7.2-16-16V16zm-43.9 80.5c7 1.9 11.9 8.2 11.9 15.5v224c0 8.8-7.2 16-16 16H80c-5.7 0-11-3-13.8-8s-2.9-11-.1-16l128-224c3.6-6.3 11-9.4 18-7.5zM5.7 404.3C2.8 394.1 10.5 384 21.1 384h533.8c10.6 0 18.3 10.1 15.4 20.3l-4 14.3C550.7 473.9 500.4 512 443 512H133c-57.4 0-107.7-38.1-123.3-93.3l-4-14.3z"
        }
    ]
};

const FasSalad = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSalad",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M416 96c2.6 0 5.2.1 7.8.2C406.2 76.5 380.5 64 352 64c-8.7 0-17.2 1.2-25.3 3.4C309.5 27.7 270 0 224 0s-85.5 27.7-102.7 67.4c-8-2.2-16.5-3.4-25.3-3.4-53 0-96 43-96 96s43 96 96 96h73.4l-84.7-84.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L208 249.4V112c0-8.8 7.2-16 16-16s16 7.2 16 16v144h52c-2.6-10.2-4-21-4-32 0-70.7 57.3-128 128-128zM27.4 288C12.3 288 0 300.3 0 315.4c0 70.5 44.4 130.7 106.7 154.1l1.8 14.4c2 16 15.6 28 31.8 28h231.5c16.1 0 29.8-12 31.8-28l1.8-14.4C467.6 446.1 512 385.9 512 315.4c0-15.1-12.3-27.4-27.4-27.4H27.4zM512 224c0-53-43-96-96-96s-96 43-96 96c0 11.2 1.9 22 5.5 32h181c3.5-10 5.5-20.8 5.5-32z"
        }
    ]
};

const FasSaltShaker = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSaltShaker",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M319.4 448H64.6l36.6-256h181.6l36.6 256zM59.8 512h264.4c33 0 59.8-26.8 59.8-59.8 0-2.8-.2-5.7-.6-8.5l-45.3-317C327.7 54 265.4 0 192 0S56.3 54 45.9 126.7L.6 443.8c-.4 2.8-.6 5.6-.6 8.5 0 33 26.8 59.8 59.8 59.8zM192 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-64 48a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm112-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
        }
    ]
};

const FasSandwich = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSandwich",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 96c0-17.7 14.3-32 32-32h448c17.7 0 32 14.3 32 32v48c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V96zm303.9 286.6c10 5.8 22.3 5.8 32.2 0l70.2-40.9c6.4-3.7 13.6-5.7 20.9-5.7H480c17.7 0 32 14.3 32 32v48c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32v-48c0-17.7 14.3-32 32-32h180.8c7.4 0 14.6 2 20.9 5.7l70.2 40.9zM32 304c-17.7 0-32-14.3-32-32s14.3-32 32-32c7.2 0 15.8-3.7 35.4-13 16.6-7.8 40.6-19 68.6-19 30.6 0 53 10.2 70.1 18l1.9.9c17.2 7.8 29.7 13.1 48.1 13.1s30.9-5.3 48.1-13.1l1.9-.9c17-7.8 39.4-18 70.1-18 28 0 52.1 11.3 68.6 19 19.6 9.2 28.2 13 35.4 13 17.7 0 32 14.3 32 32s-14.3 32-32 32c-22.7 0-44.3-10.3-58.8-17.2-1.3-.6-2.6-1.2-3.8-1.8-17.4-8.2-29.4-13-41.4-13-16.2 0-27.5 5-45.4 13.1h-.1c-18 8.2-41.4 18.9-74.5 18.9s-56.6-10.7-74.5-18.9h-.1C163.5 277 152.2 272 136 272c-12 0-23.9 4.7-41.4 13-1.2.6-2.5 1.2-3.8 1.8C76.3 293.7 54.7 304 32 304z"
        }
    ]
};

const FasSatelliteDish = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSatelliteDish",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 32c0-17.7 14.3-32 32-32 159.1 0 288 128.9 288 288 0 17.7-14.3 32-32 32s-32-14.3-32-32c0-123.7-100.3-224-224-224-17.7 0-32-14.3-32-32zM60.6 220.6l104.1 104.1 28.4-28.4c-.7-2.6-1.1-5.4-1.1-8.3 0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32c-2.9 0-5.6-.4-8.3-1.1l-28.4 28.4 104.1 104.1c14.5 14.5 11.8 38.8-7.3 46.3-23.6 9.2-49.2 14.3-76.1 14.3C93.1 512 0 418.9 0 304c0-26.9 5.1-52.5 14.4-76.1 7.5-19 31.8-21.8 46.3-7.3zM224 96c106 0 192 86 192 192 0 17.7-14.3 32-32 32s-32-14.3-32-32c0-70.7-57.3-128-128-128-17.7 0-32-14.3-32-32s14.3-32 32-32z"
        }
    ]
};

const FasSatellite = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSatellite",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M233 7c-9.4-9.4-24.6-9.4-33.9 0l-96 96c-9.4 9.4-9.4 24.6 0 33.9l89.4 89.4-15.5 15.5c-24.7-11.4-52.1-17.8-81-17.8-31.7 0-61.5 7.7-87.8 21.2-9 4.7-10.3 16.7-3.1 23.8l107.6 107.7-16.4 16.4c-2.6-.7-5.4-1.1-8.3-1.1-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32c0-2.9-.4-5.6-1.1-8.3l16.4-16.4 107.6 107.6c7.2 7.2 19.2 5.9 23.8-3.1 13.6-26.3 21.3-56.1 21.3-87.8 0-28.9-6.4-56.3-17.8-80.9l15.5-15.5L375 409c9.4 9.4 24.6 9.4 33.9 0l96-96c9.4-9.4 9.4-24.6 0-33.9l-89.4-89.4 55-55c12.5-12.5 12.5-32.8 0-45.3l-48-48c-12.5-12.5-32.8-12.5-45.3 0l-55 55L233 7zm159 351-72.4-72.4 62.1-62.1 72.4 72.5-62.1 62.1zM226.3 192.4 153.9 120 216 57.9l72.4 72.4-62.1 62.1z"
        }
    ]
};

const FasSausage = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSausage",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 160c0-42 26.9-77.7 64.5-90.7l-15.3-41.9c-.8-2.2-1.2-4.6-1.2-7C368 9.1 377.1 0 388.4 0h55.2C454.9 0 464 9.1 464 20.4c0 2.4-.4 4.7-1.2 7l-15.3 41.9C485.1 82.3 512 118 512 160c0 194.4-157.6 352-352 352-42 0-77.7-26.9-90.7-64.5l-41.9 15.3c-2.2.8-4.6 1.2-7 1.2C9.1 464 0 454.9 0 443.6v-55.2C0 377.1 9.1 368 20.4 368c2.4 0 4.7.4 7 1.2l41.9 15.2C82.3 346.9 118 320 160 320c88.4 0 160-71.6 160-160zm80 0c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 114.9-93.1 208-208 208-8.8 0-16 7.2-16 16s7.2 16 16 16c132.5 0 240-107.5 240-240z"
        }
    ]
};

const FasSaxophoneFire = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSaxophoneFire",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M102.6 0c-2.5 0-5 .9-7 2.6-23.3 20.8-43 44.4-57 67.1C24.9 92 16 116 16 134.5c0 14.6 2.8 28.6 7.9 41.5h55.6c-4.8-8-7.5-17.8-7.5-29 0-16.8 10.5-31.5 31.5-57.4 2.8 3.5 43.4 55.3 43.4 55.3l25.2-29.4c2.1 2.8 3.5 5.6 4.9 8.4 9.1 16.7 8.7 36.7-.2 52.1H232c5.1-12.9 8-26.9 8-41.5 0-14.1-6.7-35.7-16.9-55.3-10.3-19.9-25-40.9-42.3-56.8-3.9-3.6-10.1-3.6-14 0-6.7 6.1-13 13.7-18.5 20.7-12.1-14.5-25-28-38.8-40.4-2-1.8-4.4-2.7-6.9-2.7zm68.8 338.1 47.5-82.1H232c13.3 0 24-10.7 24-24s-10.7-24-24-24H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h-7.1L4.4 309.4c-2.9 12.4-4.4 25-4.4 37.7v3.1C0 439.6 72.4 512 161.8 512c49.4 0 96.1-22.6 126.8-61.4l245.8-310.5c6.1-7.7 15.3-12.1 25.1-12.1h64.2c9 0 16.3-7.3 16.3-16.3 0-4.9-2.2-9.5-5.9-12.6l-24.3-20.3c-11.5-9.6-26-14.8-41-14.8h-30.3c-17 0-33.3 6.7-45.3 18.7L449 127l-8-8c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l8 8L401 175l-8-8c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l8 8L353 223l-8-8c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l8 8-112.5 112.5c-4.2 4.2-10 6.6-16 6.6-12.5 0-22.6-10.1-22.6-22.6v-2.6c0-4.4 1.2-8.8 3.4-12.6zM144 280a24 24 0 1 1-48 0 24 24 0 1 1 48 0zm-56 64a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FasSaxophone = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSaxophone",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m246.7 176-75.3 130.1c-2.2 3.8-3.4 8.2-3.4 12.6v2.6c0 12.5 10.1 22.6 22.6 22.6 6 0 11.8-2.4 16-6.6L319 225l-8-8c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l8 8L367 177l-8-8c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l8 8L415 129l-8-8c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l8 8 44.3-44.3c12-12 28.3-18.7 45.3-18.7h30.3c15 0 29.5 5.2 41 14.8l24.3 20.3c3.7 3.1 5.9 7.7 5.9 12.6 0 9-7.3 16.3-16.3 16.3h-64.2c-9.8 0-19 4.5-25.1 12.1L288.6 418.6c-30.7 38.8-77.4 61.4-126.8 61.4C72.4 480 0 407.6 0 318.2v-3.1c0-12.7 1.5-25.4 4.4-37.8L28.2 176H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h240c13.3 0 24 10.7 24 24s-10.7 24-24 24h-17.3zM120 320a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm8-72a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FasScaleBalanced = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasScaleBalanced",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 32h128c17.7 0 32 14.3 32 32s-14.3 32-32 32H398.4c-5.2 25.8-22.9 47.1-46.4 57.3V448h160c17.7 0 32 14.3 32 32s-14.3 32-32 32H128c-17.7 0-32-14.3-32-32s14.3-32 32-32h160V153.3c-23.5-10.3-41.2-31.6-46.4-57.3H128c-17.7 0-32-14.3-32-32s14.3-32 32-32h128c14.6-19.4 37.8-32 64-32s49.4 12.6 64 32zm55.6 288h144.8L512 195.8 439.6 320zm72.4 96c-62.9 0-115.2-34-126-78.9-2.6-11 1-22.3 6.7-32.1l95.2-163.2c5-8.6 14.2-13.8 24.1-13.8s19.1 5.3 24.1 13.8L631.3 305c5.7 9.8 9.3 21.1 6.7 32.1C627.2 382 574.9 416 512 416zM126.8 195.8 54.4 320h144.9l-72.5-124.2zM.9 337.1c-2.6-11 1-22.3 6.7-32.1l95.2-163.2c5-8.6 14.2-13.8 24.1-13.8s19.1 5.3 24.1 13.8L246.2 305c5.7 9.8 9.3 21.1 6.7 32.1C242 382 189.7 416 126.8 416S11.7 382 .9 337.1z"
        }
    ]
};

const FasScaleUnbalancedFlip = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasScaleUnbalancedFlip",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M117.9 62.4c-16.8-5.6-25.8-23.7-20.2-40.5s23.7-25.8 40.5-20.2l113 37.7C265 15.8 290.7 0 320 0c44.2 0 80 35.8 80 80 0 3-.2 5.9-.5 8.8l122.6 40.9c16.8 5.6 25.8 23.7 20.2 40.5s-23.7 25.8-40.5 20.2l-135.4-45.2c-4.5 3.2-9.3 5.9-14.4 8.2V480c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32s14.3-32 32-32h160V153.3c-21-9.2-37.2-27-44.2-49l-125.9-42zM200.4 288 128 163.8 55.6 288h144.8zM128 384c-62.9 0-115.2-34-126-78.9-2.6-11 1-22.3 6.7-32.1l95.2-163.2c5-8.6 14.2-13.8 24.1-13.8s19.1 5.3 24.1 13.8L247.3 273c5.7 9.8 9.3 21.1 6.7 32.1C243.2 350 190.9 384 128 384zm382.8-92.2L438.4 416h144.9l-72.5-124.2zm126 141.3C626 478 573.7 512 510.8 512s-115.2-34-126-78.9c-2.6-11 1-22.3 6.7-32.1l95.2-163.2c5-8.6 14.2-13.8 24.1-13.8s19.1 5.3 24.1 13.8L630.1 401c5.7 9.8 9.3 21.1 6.7 32.1z"
        }
    ]
};

const FasScaleUnbalanced = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasScaleUnbalanced",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M522.1 62.4c16.8-5.6 25.8-23.7 20.2-40.5S518.6-3.9 501.9 1.6l-113 37.7C375 15.8 349.3 0 320 0c-44.2 0-80 35.8-80 80 0 3 .2 5.9.5 8.8l-122.6 40.8c-16.8 5.6-25.8 23.7-20.2 40.5s23.7 25.8 40.5 20.2l135.5-45.2c4.5 3.2 9.3 5.9 14.4 8.2V480c0 17.7 14.3 32 32 32H512c17.7 0 32-14.3 32-32s-14.3-32-32-32H352V153.3c21-9.2 37.2-27 44.2-49l125.9-42zM439.6 288 512 163.8 584.4 288H439.6zm72.4 96c62.9 0 115.2-34 126-78.9 2.6-11-1-22.3-6.7-32.1l-95.2-163.2c-5-8.6-14.2-13.8-24.1-13.8s-19.1 5.3-24.1 13.8l-95.2 163.3c-5.7 9.8-9.3 21.1-6.7 32.1C396.8 350 449.1 384 512 384zm-382.8-92.2L201.6 416H56.7l72.4-124.2zM3.2 433.1C14 478 66.3 512 129.2 512s115.2-34 126-78.9c2.6-11-1-22.3-6.7-32.1l-95.3-163.2c-5-8.6-14.2-13.8-24.1-13.8s-19.1 5.3-24.1 13.8L9.9 401.1c-5.7 9.8-9.3 21.1-6.7 32.1z"
        }
    ]
};

const FasScalpelLineDashed = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasScalpelLineDashed",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M441.4 0c-20.8 0-40.6 9.2-54 25.1L187.8 261.7c-4 4.8-4.9 11.4-2.3 17.1s8.3 9.3 14.5 9.3h132.6c14.1 0 27.6-6.2 36.7-17l125.1-148.4c11.4-13.5 17.6-30.5 17.6-48.1v-4c0-39-31.6-70.6-70.6-70.6zM164.7 324.7l-160 160c-4.6 4.6-5.9 11.5-3.5 17.4S9.5 512 16 512c18.1 0 84.1-8.4 145.9-33.1C222.5 454.6 288 410.9 288 336v-16H169.4l-4.7 4.7zM304 480h-64c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16zm64 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16h-64zm128 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16h-64z"
        }
    ]
};

const FasScalpel = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasScalpel",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M387.4 25.1C400.8 9.2 420.6 0 441.4 0c39 0 70.6 31.6 70.6 70.6v4c0 17.6-6.2 34.6-17.6 48.1L369.3 271c-9.1 10.8-22.5 17-36.7 17H200c-6.2 0-11.9-3.6-14.5-9.3s-1.7-12.3 2.3-17.1L387.4 25.1zM169.4 320H288v16c0 74.9-65.5 118.6-126.1 142.9C100.1 503.6 34.1 512 16 512c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4l160-160 4.7-4.7z"
        }
    ]
};

const FasScannerGun = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasScannerGun",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M112 32C50.1 32 0 82.1 0 144c0 50.7 33.8 93.6 80 107.4L8.1 374.7c-13.3 22.8-5.7 52.2 17.1 65.6l53.4 31.4c22.8 13.4 52.3 5.8 65.7-17L261.2 256H304c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H112zm328 0c-13.3 0-24 10.7-24 24v16c0 13.3 10.7 24 24 24h112c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24H440zm-24 184v16c0 13.3 10.7 24 24 24h112c13.3 0 24-10.7 24-24v-16c0-13.3-10.7-24-24-24H440c-13.3 0-24 10.7-24 24zm24 200c-13.3 0-24 10.7-24 24v16c0 13.3 10.7 24 24 24h112c13.3 0 24-10.7 24-24v-16c0-13.3-10.7-24-24-24H440zm-24-272c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16s-7.2-16-16-16H432c-8.8 0-16 7.2-16 16zm16 144c-8.8 0-16 7.2-16 16s7.2 16 16 16h128c8.8 0 16-7.2 16-16s-7.2-16-16-16H432zm-16 80c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16s-7.2-16-16-16H432c-8.8 0-16 7.2-16 16z"
        }
    ]
};

const FasScannerImage = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasScannerImage",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M79.1 35.8c-15.6-8.3-35-2.4-43.3 13.2S33.4 84 49 92.3L416 288H64c-35.3 0-64 28.7-64 64v64c0 35.3 28.7 64 64 64h448c35.3 0 64-28.7 64-64v-76.8c0-23.6-13-45.3-33.9-56.5L79.1 35.8zM64 384a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm128-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FasScannerKeyboard = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasScannerKeyboard",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M152 0h16c13.3 0 24 10.7 24 24v40h-64V24c0-13.3 10.7-24 24-24zm160 0h16c13.3 0 24 10.7 24 24v40h-64V24c0-13.3 10.7-24 24-24zm-88 16c0-8.8 7.2-16 16-16s16 7.2 16 16v48h-32V16zM400 0c8.8 0 16 7.2 16 16v256c0 8.8-7.2 16-16 16s-16-7.2-16-16V16c0-8.8 7.2-16 16-16zm48 24c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24v240c0 13.3-10.7 24-24 24h-16c-13.3 0-24-10.7-24-24V24zM0 160c0-35.3 28.7-64 64-64h224c35.3 0 64 28.7 64 64v288c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V160zm64 24v16c0 13.3 10.7 24 24 24h176c13.3 0 24-10.7 24-24v-16c0-13.3-10.7-24-24-24H88c-13.3 0-24 10.7-24 24zm0 120v32c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm16 80c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16H80zm112-80v32c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-64c-8.8 0-16 7.2-16 16zm16 80c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-64z"
        }
    ]
};

const FasScannerTouchscreen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasScannerTouchscreen",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M152 0h16c13.3 0 24 10.7 24 24v40h-64V24c0-13.3 10.7-24 24-24zM0 160c0-35.3 28.7-64 64-64h224c35.3 0 64 28.7 64 64v288c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V160zm64 16v256c0 8.8 7.2 16 16 16h192c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zM288 24c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24v40h-64V24zM240 0c8.8 0 16 7.2 16 16v48h-32V16c0-8.8 7.2-16 16-16zm144 16c0-8.8 7.2-16 16-16s16 7.2 16 16v256c0 8.8-7.2 16-16 16s-16-7.2-16-16V16zm88-16h16c13.3 0 24 10.7 24 24v240c0 13.3-10.7 24-24 24h-16c-13.3 0-24-10.7-24-24V24c0-13.3 10.7-24 24-24z"
        }
    ]
};

const FasScarecrow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasScarecrow",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 96c0 11.2-1.9 22-5.5 32H416c5.9 0 11.3 3.2 14.1 8.5s2.5 11.5-.8 16.4l-7.6 11.4 19.9 14.9c4 3 6.4 7.8 6.4 12.8s-2.4 9.8-6.4 12.8l-19.9 14.9 7.6 11.4c3.3 4.9 3.6 11.2.8 16.4s-8.2 8.5-14.1 8.5h-73c-10.1 0-17.7 9.2-15.7 19.1l24.3 121.7c1.2 6.2-1.2 12.5-6.3 16.1s-11.8 4-17.3.9L287.9 391c-4.9-2.8-11-2.8-15.9 0l-40.1 22.9c-4.9 2.8-11 2.8-15.9 0L175.9 391c-4.9-2.8-11-2.8-15.9 0l-40.1 22.9c-5.4 3.1-12.2 2.8-17.3-.9s-7.6-10-6.3-16.1l24.3-121.7c2-9.9-5.6-19.1-15.7-19.1H32c-5.9 0-11.3-3.2-14.1-8.5s-2.5-11.5.8-16.4l7.6-11.4-19.9-15c-4-3-6.4-7.8-6.4-12.8s2.4-9.8 6.4-12.8l19.9-14.9-7.6-11.4c-3.3-4.9-3.6-11.2-.8-16.4S26.1 128 32 128h101.5c-3.5-10-5.5-20.8-5.5-32 0-53 43-96 96-96s96 43 96 96zM208 80a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm48 32a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm-64 368v-52.2l12.2 6.9c12.3 7 27.4 7 39.7 0l12.2-6.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32z"
        }
    ]
};

const FasScarf = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasScarf",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M416 168.8c0 22.8-7 44.9-19.9 63.4L278.6 114.7l15.1-15.1C283.1 97.5 270.3 96 256 96s-27.1 1.5-37.8 3.6l37.8 37.8L374.6 256l9.4 9.4 11.3 11.3 112 112c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L384 310.6 358.6 336l100.7 100.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L336 358.6 310.6 384l100.7 100.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-112-112L128.4 247C107.7 226.3 96 198.1 96 168.8c0-19 4.9-37.7 14.2-54.2l41.5-73.8C165.9 15.6 192.5 0 221.4 0h69.1c28.9 0 55.6 15.6 69.7 40.8l41.5 73.8c9.3 16.6 14.2 35.2 14.2 54.2zM4.7 388.7l112-112 22.6 22.6-112 112c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6zm48 48 112-112 22.6 22.6-112 112c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6zm48 48 112-112 22.6 22.6-112 112c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6z"
        }
    ]
};

const FasSchoolCircleCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSchoolCircleCheck",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M337.8 5.4c-10.8-7.2-24.8-7.2-35.6 0L166.3 96H48c-26.5 0-48 21.5-48 48v320c0 26.5 21.5 48 48 48h272-64v-96c0-35.3 28.7-64 64-64h.8c3.4-37.7 18.7-72.1 42.2-99.1-12.8 7.1-27.4 11.1-43 11.1-48.6 0-88-39.4-88-88s39.4-88 88-88 88 39.4 88 88c0 18.3-5.6 35.3-15.1 49.4 29-21 64.6-33.4 103.1-33.4 59.5 0 112.1 29.6 144 74.8V144c0-26.5-21.5-48-48-48H473.7L337.8 5.4zM96 192h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16v-64c0-8.8 7.2-16 16-16zm0 128h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16v-64c0-8.8 7.2-16 16-16zm224-192c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16h-16v-16c0-8.8-7.2-16-16-16zm320 240a144 144 0 1 0-288 0 144 144 0 1 0 288 0zm-99.3-43.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l28.7 28.7 60.7-60.7z"
        }
    ]
};

const FasSchoolCircleExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSchoolCircleExclamation",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M337.8 5.4c-10.8-7.2-24.8-7.2-35.6 0L166.3 96H48c-26.5 0-48 21.5-48 48v320c0 26.5 21.5 48 48 48h272-64v-96c0-35.3 28.7-64 64-64h.8c3.4-37.7 18.7-72.1 42.2-99.1-12.8 7.1-27.4 11.1-43 11.1-48.6 0-88-39.4-88-88s39.4-88 88-88 88 39.4 88 88c0 18.3-5.6 35.3-15.1 49.4 29-21 64.6-33.4 103.1-33.4 59.5 0 112.1 29.6 144 74.8V144c0-26.5-21.5-48-48-48H473.7L337.8 5.4zM96 192h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16v-64c0-8.8 7.2-16 16-16zm0 128h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16v-64c0-8.8 7.2-16 16-16zm224-192c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16h-16v-16c0-8.8-7.2-16-16-16zm176 384a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16v-80c0-8.8 7.2-16 16-16z"
        }
    ]
};

const FasSchoolCircleXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSchoolCircleXmark",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M337.8 5.4c-10.8-7.2-24.8-7.2-35.6 0L166.3 96H48c-26.5 0-48 21.5-48 48v320c0 26.5 21.5 48 48 48h272-64v-96c0-35.3 28.7-64 64-64h.8c3.4-37.7 18.7-72.1 42.2-99.1-12.8 7.1-27.4 11.1-43 11.1-48.6 0-88-39.4-88-88s39.4-88 88-88 88 39.4 88 88c0 18.3-5.6 35.3-15.1 49.4 29-21 64.6-33.4 103.1-33.4 59.5 0 112.1 29.6 144 74.8V144c0-26.5-21.5-48-48-48H473.7L337.8 5.4zM96 192h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16v-64c0-8.8 7.2-16 16-16zm0 128h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16v-64c0-8.8 7.2-16 16-16zm224-192c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16h-16v-16c0-8.8-7.2-16-16-16zm176 384a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm22.6-144 36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l36.7-36.7-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l36.7 36.7 36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L518.6 368z"
        }
    ]
};

const FasSchoolFlag = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSchoolFlag",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 0h112c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16h-79.3l89.6 64H512c35.3 0 64 28.7 64 64v224c0 35.3-28.7 64-64 64H336V400c0-26.5-21.5-48-48-48s-48 21.5-48 48v112H64c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64h101.7L256 95.5V32c0-17.7 14.3-32 32-32zm48 240a48 48 0 1 0-96 0 48 48 0 1 0 96 0zM80 224c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16H80zm368 16v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16zM80 352c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16H80zm384 0c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16h-32z"
        }
    ]
};

const FasSchoolLock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSchoolLock",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M302.2 5.4c10.7-7.2 24.8-7.2 35.5 0l136 90.6H592c26.5 0 48 21.5 48 48v128c0-61.9-50.1-112-112-112s-112 50.1-112 112v24.6c-19.1 11.1-32 31.7-32 55.4h-64c-35.3 0-64 28.7-64 64v96h64H48c-26.5 0-48-21.5-48-48V144c0-26.5 21.5-48 48-48h118.3L302.2 5.4zM80 208v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16H96c-8.8 0-16 7.2-16 16zm0 128v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16H96c-8.8 0-16 7.2-16 16zm240-72a88 88 0 1 0 0-176 88 88 0 1 0 0 176zm16-120v16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16s16 7.2 16 16zm192 96c-17.7 0-32 14.3-32 32v48h64v-48c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32v128c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32v-48z"
        }
    ]
};

const FasSchool = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSchool",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M337.8 5.4c-10.8-7.2-24.8-7.2-35.6 0L166.3 96H48c-26.5 0-48 21.5-48 48v320c0 26.5 21.5 48 48 48h544c26.5 0 48-21.5 48-48V144c0-26.5-21.5-48-48-48H473.7L337.8 5.4zM256 416c0-35.3 28.7-64 64-64s64 28.7 64 64v96H256v-96zM96 192h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16v-64c0-8.8 7.2-16 16-16zm400 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-64zM96 320h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16v-64c0-8.8 7.2-16 16-16zm400 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-64zM232 176a88 88 0 1 1 176 0 88 88 0 1 1-176 0zm88-48c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16h-16v-16c0-8.8-7.2-16-16-16z"
        }
    ]
};

const FasScissors = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasScissors",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m256 192-39.5-39.5c4.9-12.6 7.5-26.2 7.5-40.5C224 50.1 173.9 0 112 0S0 50.1 0 112s50.1 112 112 112c14.3 0 27.9-2.7 40.5-7.5L192 256l-39.5 39.5c-12.6-4.9-26.2-7.5-40.5-7.5C50.1 288 0 338.1 0 400s50.1 112 112 112 112-50.1 112-112c0-14.3-2.7-27.9-7.5-40.5L499.2 76.8c7.1-7.1 7.1-18.5 0-25.6-28.3-28.3-74.1-28.3-102.4 0L256 192zm22.6 150.6 118.2 118.2c28.3 28.3 74.1 28.3 102.4 0 7.1-7.1 7.1-18.5 0-25.6L342.6 278.6l-64 64zM64 112a48 48 0 1 1 96 0 48 48 0 1 1-96 0zm48 240a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
        }
    ]
};

const FasScreenUsers = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasScreenUsers",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 0C60.7 0 32 28.7 32 64v184.4C49 233.2 71.4 224 96 224V64h448v160c24.6 0 47 9.2 64 24.4V64c0-35.3-28.7-64-64-64H96zm64 320a64 64 0 1 0-128 0 64 64 0 1 0 128 0zM0 480c0 17.7 14.3 32 32 32h128c17.7 0 32-14.3 32-32 0-35.3-28.7-64-64-64H64c-35.3 0-64 28.7-64 64zm384-160a64 64 0 1 0-128 0 64 64 0 1 0 128 0zM224 480c0 17.7 14.3 32 32 32h128c17.7 0 32-14.3 32-32 0-35.3-28.7-64-64-64h-64c-35.3 0-64 28.7-64 64zm320-96a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-32 32c-35.3 0-64 28.7-64 64 0 17.7 14.3 32 32 32h128c17.7 0 32-14.3 32-32 0-35.3-28.7-64-64-64h-64z"
        }
    ]
};

const FasScreencast = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasScreencast",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 96H64v99c-13-2-26.4-3-40-3H0V96c0-35.3 28.7-64 64-64h448c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H288v-24c0-13.6-1-27-3-40h227V96zM24 224c128.1 0 232 103.9 232 232 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-101.6-82.4-184-184-184-13.3 0-24-10.7-24-24s10.7-24 24-24zm8 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM0 344c0-13.3 10.7-24 24-24 75.1 0 136 60.9 136 136 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-48.6-39.4-88-88-88-13.3 0-24-10.7-24-24z"
        }
    ]
};

const FasScrewdriverWrench = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasScrewdriverWrench",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M78.6 5c-9.5-7.4-23-6.5-31.6 2L7 47c-8.5 8.5-9.4 22-2.1 31.6l80 104c4.5 5.9 11.6 9.4 19 9.4H158l109 109c-14.7 29-10 65.4 14.3 89.6l112 112c12.5 12.5 32.8 12.5 45.3 0l64-64c12.5-12.5 12.5-32.8 0-45.3l-112-112c-24.2-24.2-60.6-29-89.6-14.3L192 158v-54c0-7.5-3.5-14.5-9.4-19L78.6 5zM19.9 396.1C7.2 408.8 0 426.1 0 444.1 0 481.6 30.4 512 67.9 512c18 0 35.3-7.2 48-19.9l117.8-117.8c-7.8-20.9-9-43.6-3.6-65.1l-61.7-61.7L19.9 396.1zM512 144c0-10.5-1.1-20.7-3.2-30.5-2.4-11.2-16.1-14.1-24.2-6l-63.9 63.9c-3 3-7.1 4.7-11.3 4.7H352c-8.8 0-16-7.2-16-16v-57.5c0-4.2 1.7-8.3 4.7-11.3l63.9-63.9c8.1-8.1 5.2-21.8-6-24.2C388.7 1.1 378.5 0 368 0c-79.5 0-144 64.5-144 144v.8l85.3 85.3c36-9.1 75.8.5 104 28.7l15.7 15.7c49-23 83-72.8 83-130.5zM56 432a24 24 0 1 1 48 0 24 24 0 1 1-48 0z"
        }
    ]
};

const FasScrewdriver = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasScrewdriver",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M465 7c-8.5-8.5-22-9.4-31.6-2.1l-104 80c-5.9 4.5-9.4 11.6-9.4 19V158l-85.6 85.6c6.7 4.2 13 9.3 18.8 15.1s10.9 12.2 15.1 18.8l85.6-85.5H408c7.5 0 14.5-3.5 19-9.4l80-104c7.4-9.6 6.5-23.1-2.1-31.6L465 7zM121.4 281.4l-112 112c-12.5 12.5-12.5 32.8 0 45.3l64 64c12.5 12.5 32.8 12.5 45.3 0l112-112c30.2-30.2 30.2-79.1 0-109.3s-79.1-30.2-109.3 0z"
        }
    ]
};

const FasScribble = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasScribble",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M170 23.3C186.5 8.3 208 0 230.3 0h1.1C280.3 0 320 39.7 320 88.6c0 23.5-9.3 46-25.9 62.6L103.2 342.1c-4.6 4.6-7.2 10.9-7.2 17.4 0 13.5 11 24.5 24.6 24.5 6.5 0 12.8-2.6 17.4-7.2l222.8-222.9c16.6-16.6 39.1-25.9 62.6-25.9 48.9 0 88.6 39.7 88.6 88.6 0 23.5-9.3 46-25.9 62.6l-88.2 88.2c-8.8 8.8-13.8 20.9-13.8 33.4 0 26 21.1 47.1 47 47.1 6.2 0 12.4-1.5 18-4.2l16.7-8.4c15.8-7.9 35-1.5 42.9 14.3s1.5 35-14.3 42.9l-16.8 8.5c-14.5 7.2-30.4 11-46.6 11-61.4 0-111-49.9-111-111.1 0-29.5 11.7-57.8 32.6-78.7l88.2-88.2c4.6-4.6 7.2-10.9 7.2-17.4 0-13.6-11-24.6-24.6-24.6-6.5 0-12.8 2.6-17.4 7.2L183.2 422.1c-16.6 16.6-39.1 25.9-62.6 25.9-48.9 0-88.6-39.7-88.6-88.6 0-23.5 9.3-46 25.9-62.6l190.9-190.9c4.6-4.6 7.2-10.9 7.2-17.4C256 75 245 64 231.4 64h-1.1c-6.4 0-12.6 2.4-17.3 6.7l-159.5 145c-13.1 11.9-33.3 10.9-45.2-2.2s-10.9-33.3 2.2-45.2L170 23.3z"
        }
    ]
};

const FasScrollOld = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasScrollOld",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 32c26.5 0 48 21.5 48 48v80H32c-17.7 0-32-14.3-32-32V80c0-26.5 21.5-48 48-48zm80 48c0-18-6-34.6-16-48h272c51.4 0 93.4 40.5 95.9 91.3-.4 3.5-2 6.9-4.6 9.4l-21.7 21.7c-3.1 3.1-3.1 8.2 0 11.3l21.7 21.7c3 3 4.7 7.1 4.7 11.3v18.7c0 4.2-1.7 8.3-4.7 11.3l-21.7 21.7c-3.1 3.1-3.1 8.2 0 11.3l21.7 21.7c3 3 4.7 7.1 4.7 11.3V320H314.7c-32.4 0-58.7 26.3-58.7 58.7v5.3c0 35.3-28.7 64-64 64s-64-28.7-64-64V262.6c0-4.2 1.7-8.3 4.7-11.3l21.7-21.7c3.1-3.1 3.1-8.2 0-11.3l-21.7-21.7c-3-3-4.7-7.1-4.7-11.3V80zm448 288c0 61.9-50.1 112-112 112H192c53 0 96-43 96-96v-5.3c0-14.7 11.9-26.7 26.7-26.7h30.7c4.2 0 8.3 1.7 11.3 4.7l21.7 21.7c3.1 3.1 8.2 3.1 11.3 0l21.7-21.7c3-3 7.1-4.7 11.3-4.7H560c8.8 0 16 7.2 16 16z"
        }
    ]
};

const FasScrollTorah = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasScrollTorah",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 480V32C96 14.3 74.5 0 48 0S0 14.3 0 32v448c0 17.7 21.5 32 48 32s48-14.3 48-32zM512 32H128v448h384V32zm80-32c-26.5 0-48 14.3-48 32v448c0 17.7 21.5 32 48 32s48-14.3 48-32V32c0-17.7-21.5-32-48-32zM196 313.7c0-3.2.9-6.4 2.5-9.2l28.2-48.5-28.3-48.5c-1.6-2.8-2.5-6-2.5-9.2 0-10.1 8.2-18.3 18.3-18.3H271l31.4-53.9c3.6-6.3 10.3-10.1 17.6-10.1s13.9 3.8 17.6 10.1L369 180h56.7c10.1 0 18.3 8.2 18.3 18.3 0 3.2-.9 6.4-2.5 9.2L413.3 256l28.3 48.5c1.6 2.8 2.5 6 2.5 9.2 0 10.1-8.2 18.3-18.3 18.3H369l-31.4 53.9C334 392.2 327.3 396 320 396s-13.9-3.8-17.6-10.1L271 332h-56.7c-10.1 0-18.3-8.2-18.3-18.3zm124 54.7 21.2-36.4h-42.4l21.2 36.4zM254.5 256l30.3 52h70.4l30.3-52-30.3-52h-70.4l-30.3 52zm144.9 23.8L383 308h32.8l-16.4-28.2zm16.4-75.8H383l16.4 28.2 16.4-28.2zM320 143.6 298.8 180h42.4L320 143.6zM224.2 204l16.4 28.2L257 204h-32.8zM257 308l-16.4-28.2-16.4 28.2H257z"
        }
    ]
};

const FasScroll = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasScroll",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 80v48c0 17.7 14.3 32 32 32h64V80c0-26.5-21.5-48-48-48S0 53.5 0 80zm112-48c10 13.4 16 30 16 48v304c0 35.3 28.7 64 64 64s64-28.7 64-64v-5.3c0-32.4 26.3-58.7 58.7-58.7H480V128c0-53-43-96-96-96H112zm352 448c61.9 0 112-50.1 112-112 0-8.8-7.2-16-16-16H314.7c-14.7 0-26.7 11.9-26.7 26.7v5.3c0 53-43 96-96 96h272z"
        }
    ]
};

const FasScrubber = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasScrubber",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm0-320a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"
        }
    ]
};

const FasScythe = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasScythe",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M614.7.7c5.6 1.2 10.5 3.8 14.5 7.3 8.4 7.4 12.6 19 10.1 30.7l-4.8 22.6-56.9 265.4-34.3 160c-3.7 17.3-20.7 28.3-38 24.6s-28.3-20.7-24.6-38l26-121.3H416c-17.7 0-32-14.3-32-32s14.3-32 32-32h104.4L569 61.3l7.7-36L582.1 0H608c2.2 0 4.5.2 6.7.7zM352 0h197.4l-4 18.6L508.3 192H12.7c-7 0-12.7-5.7-12.7-12.7 0-2.1.5-4.1 1.6-6C15 151.1 114.8 0 352 0z"
        }
    ]
};

const FasSdCard = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSdCard",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 0H141.3C124.3 0 108 6.7 96 18.7L18.7 96C6.7 108 0 124.3 0 141.3V448c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zM160 88v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V88c0-13.3 10.7-24 24-24s24 10.7 24 24zm80 0v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V88c0-13.3 10.7-24 24-24s24 10.7 24 24zm80 0v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V88c0-13.3 10.7-24 24-24s24 10.7 24 24z"
        }
    ]
};

const FasSdCards = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSdCards",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 0H237.3c-17 0-33.3 6.7-45.3 18.7L114.7 96c-12 12-18.7 28.3-18.7 45.3V352c0 35.3 28.7 64 64 64h224c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zM280 64c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V88c0-13.3 10.7-24 24-24zm80 0c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V88c0-13.3 10.7-24 24-24zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120v256c0 75.1 60.9 136 136 136h224c13.3 0 24-10.7 24-24s-10.7-24-24-24H136c-48.6 0-88-39.4-88-88V120z"
        }
    ]
};

const FasSealExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSealExclamation",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M222.1 17.9c18.7-18.7 49.1-18.7 67.9 0L336 64h64c26.5 0 48 21.5 48 48v64l45.6 45.6c18.7 18.7 18.7 49.1 0 67.9L448 335.1V400c0 26.5-21.5 48-48 48h-64.9L290 493.1c-18.7 18.7-49.1 18.7-67.9 0L176.9 448H112c-26.5 0-48-21.5-48-48v-64.9l-45.6-45.6c-18.7-18.7-18.7-49.1 0-67.9L64 176v-64c0-26.5 21.5-48 48-48h64l46.1-46.1zM256 128c-13.3 0-24 10.7-24 24v112c0 13.3 10.7 24 24 24s24-10.7 24-24V152c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0-64 0 32 32 0 1 0 64 0z"
        }
    ]
};

const FasSealQuestion = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSealQuestion",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M222.1 17.9c18.7-18.7 49.1-18.7 67.9 0L336 64h64c26.5 0 48 21.5 48 48v64l45.6 45.6c18.7 18.7 18.7 49.1 0 67.9L448 335.1V400c0 26.5-21.5 48-48 48h-64.9L290 493.1c-18.7 18.7-49.1 18.7-67.9 0L176.9 448H112c-26.5 0-48-21.5-48-48v-64.9l-45.6-45.6c-18.7-18.7-18.7-49.1 0-67.9L64 176v-64c0-26.5 21.5-48 48-48h64l46.1-46.1zm-52.3 147.4-.4 1.2c-4.4 12.5 2.1 26.2 14.6 30.6s26.2-2.1 30.6-14.6l.4-1.2c1.1-3.2 4.2-5.3 7.5-5.3h58.3c8.4 0 15.1 6.8 15.1 15.1 0 5.4-2.9 10.4-7.6 13.1L244 229.6c-7.5 4.3-12.1 12.2-12.1 20.8V264c0 13.3 10.7 24 24 24 13.1 0 23.8-10.5 24-23.6l32.3-18.5c19.6-11.3 31.7-32.2 31.7-54.8 0-34.9-28.3-63.1-63.1-63.1h-58.2c-23.7 0-44.8 14.9-52.8 37.3zM288 352a32 32 0 1 0-64 0 32 32 0 1 0 64 0z"
        }
    ]
};

const FasSeal = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSeal",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M289.9 18.4C271.2-.3 240.8-.3 222 18.4L176.5 64H112c-26.5 0-48 21.5-48 48v64.5l-45.6 45.6c-18.7 18.7-18.7 49.1 0 67.9L64 335.5V400c0 26.5 21.5 48 48 48h64.5l45.6 45.6c18.7 18.7 49.1 18.7 67.9 0l45.5-45.6H400c26.5 0 48-21.5 48-48v-64.5l45.6-45.6c18.7-18.7 18.7-49.1 0-67.9L448 176.5V112c0-26.5-21.5-48-48-48h-64.5l-45.6-45.6z"
        }
    ]
};

const FasSeatAirline = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSeatAirline",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C64 14.3 49.7 0 32 0S0 14.3 0 32v111.6c0 15.2 3.1 30.2 9.1 44.1L82 357.8c15.1 35.3 49.8 58.2 88.2 58.2H216v48h-96c-13.3 0-24 10.7-24 24s10.7 24 24 24h240c13.3 0 24-10.7 24-24s-10.7-24-24-24h-96v-48h96c15.1 0 29.3-7.1 38.4-19.2l43.2-57.6c7.3-9.7 8.4-22.7 3-33.5S428.1 288 416 288H121.7L108 256h212c17.7 0 32-14.3 32-32s-14.3-32-32-32H80.5l-12.6-29.5c-2.6-6-3.9-12.4-3.9-18.9V32z"
        }
    ]
};

const FasSection = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSection",
    "viewBox": "0 0 256 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64.9 96c2.2-11.6 8.8-19.8 21.1-25.4 13.8-6.2 34.8-8.9 61.2-4.5 8.8 1.4 36.1 7.1 44.1 9.3 17 4.8 34.7-5.1 39.5-22.2s-5.1-34.7-22.2-39.5c-11.1-3.1-41-9.2-50.9-10.8-34.7-5.6-69.4-3.5-98 9.4C29.9 25.8 7.5 50.9 1.6 86.5c-.1.5-.2 1.1-.2 1.6-2.2 19.7.3 37.9 8.1 54.1 7.7 16.1 19.4 28 32 36.9.6.5 1.3.9 2 1.4-21.2 13.7-37 34.6-41.8 62.5-.1.6-.2 1.1-.2 1.7-2.3 19.3.4 37.1 8.4 53 7.9 15.6 19.8 27 32.3 35.5 22.4 15.2 51.9 24 75.4 31l3.7 1.1c27.2 8.2 46.9 14.6 59.4 23.8 5.5 4 8.2 7.6 9.5 10.9 1.3 3.2 2.6 8.6.9 18.1-1.7 10.1-7.7 18-20.7 23.5-14 6-35.4 8.5-62 4.4-12.8-2.1-35.1-9.7-54.1-16.2-4.3-1.5-8.5-2.9-12.3-4.2-16.7-5.6-34.8 3.5-40.4 20.2s3.5 34.9 20.3 40.5c2.6.8 5.7 1.9 9.2 3.1 18.6 6.3 48.5 16.6 67.3 19.6h.2c34.5 5.4 68.8 3.4 97.2-8.7 29.4-12.6 52.5-36.5 58.5-71.5 3.3-19.3 1.9-37.4-5-53.9-6.3-15-16.4-26.4-27.6-35.2 16.5-13.9 28.5-33.2 32.6-58.2 3.2-19.8 1.9-38.3-4.8-55.1-6.7-16.8-17.8-29.4-30.2-39-22.8-17.6-53.6-27.4-77.7-35l-1.4-.5c-27.4-8.7-47.8-15.3-61.5-25-6.1-4.4-9.5-8.5-11.4-12.4-1.8-3.7-3.2-9.3-2.3-18.5zm76.7 208.5c-.2-.1-.4-.1-.6-.2l-1.4-.4c-27.4-8.2-47.9-14.5-61.7-23.8-6.2-4.2-9.3-7.9-11-11.3-1.5-3-2.9-7.7-2.1-15.7 1.9-9.7 7.9-17.3 20.5-22.7 14-6 35.4-8.5 62.1-4.3l16.4 2.6c6.3 2.9 11.7 6 16.2 9.5 5.5 4.2 8.4 8.2 10 12.2 1.6 4 2.8 10.4 1.1 20.9-2.4 14.7-12.8 26.4-37.1 31l-12.4 2.3z"
        }
    ]
};

const FasSeedling = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSeedling",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 32c0 113.6-84.6 207.5-194.2 222-7.1-53.4-30.6-101.6-65.3-139.3C290.8 46.3 364 0 448 0h32c17.7 0 32 14.3 32 32zM0 96c0-17.7 14.3-32 32-32h32c123.7 0 224 100.3 224 224v192c0 17.7-14.3 32-32 32s-32-14.3-32-32V320C100.3 320 0 219.7 0 96z"
        }
    ]
};

const FasSemicolon = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSemicolon",
    "viewBox": "0 0 192 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 64a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm54.8 319L83.7 492.8C76.4 504.7 63.5 512 49.5 512 24 512 5 488.5 10.4 463.6L37.5 337c6.1-28.6 31.4-49 60.6-49 34.2 0 61.9 28.1 61.9 62.3 0 11.5-3.2 22.9-9.2 32.7z"
        }
    ]
};

const FasSendBack = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSendBack",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 64v128H64V64h128zM64 0C28.7 0 0 28.7 0 64v128c0 35.3 28.7 64 64 64h128c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm512 320v128H448V320h128zm-128-64c-35.3 0-64 28.7-64 64v128c0 35.3 28.7 64 64 64h128c35.3 0 64-28.7 64-64V320c0-35.3-28.7-64-64-64H448zm-288 32v64c0 35.3 28.7 64 64 64h128v-96c0-53 43-96 96-96h32v-64c0-35.3-28.7-64-64-64H288v96c0 53-43 96-96 96h-32z"
        }
    ]
};

const FasSendBackward = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSendBackward",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 0C28.7 0 0 28.7 0 64v224c0 35.3 28.7 64 64 64h64V224c0-53 43-96 96-96h128V64c0-35.3-28.7-64-64-64H64zm160 224h224v224H224V224zm-64 0v224c0 35.3 28.7 64 64 64h224c35.3 0 64-28.7 64-64V224c0-35.3-28.7-64-64-64H224c-35.3 0-64 28.7-64 64z"
        }
    ]
};

const FasSensorCloud = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSensorCloud",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h170.8c-6.9-14.5-10.8-30.8-10.8-48 0-44.7 26.2-83.3 64.1-101.3C290.9 271.3 339.9 224 400 224c17.2 0 33.5 3.9 48 10.8V96c0-35.3-28.7-64-64-64H64zm48 88v144c0 13.3-10.7 24-24 24s-24-10.7-24-24V120c0-13.3 10.7-24 24-24s24 10.7 24 24zm96 0v144c0 13.3-10.7 24-24 24s-24-10.7-24-24V120c0-13.3 10.7-24 24-24s24 10.7 24 24zm128 392h224c44.2 0 80-35.8 80-80 0-39-27.9-71.5-64.8-78.6.5-3.1.8-6.2.8-9.4 0-30.9-25.1-56-56-56-18.1 0-34.1 8.6-44.4 21.8C464.8 278.5 435 256 400 256c-44.2 0-80 35.8-80 80 0 5.9.6 11.7 1.9 17.2-37.5 6.7-65.9 39.4-65.9 78.8 0 44.2 35.8 80 80 80z"
        }
    ]
};

const FasSensorFire = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSensorFire",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h273.6c-31-34.7-49.6-80.6-49.6-129.9 0-35.2 16.3-73.6 37.2-107.4 21.7-35.2 51.9-71.2 87.3-102.8 10-8.9 23-12.8 35.5-11.7V96c0-35.3-28.7-64-64-64H64zm48 88v144c0 13.3-10.7 24-24 24s-24-10.7-24-24V120c0-13.3 10.7-24 24-24s24 10.7 24 24zm96 0v144c0 13.3-10.7 24-24 24s-24-10.7-24-24V120c0-13.3 10.7-24 24-24s24 10.7 24 24zm245.5 43.6c-2.8-2.5-6.3-3.7-9.8-3.8-3.6 0-7.2 1.2-10 3.7-33.2 29.7-61.4 63.4-81.4 95.8-19.6 32-32.3 66.3-32.3 92.7 0 87.8 70.3 159.8 160 159.8 88.7 0 160-72 160-159.8 0-20.2-9.6-50.9-24.2-79-14.8-28.5-35.7-58.5-60.4-81.1-5.6-5.1-14.4-5.2-20 0-9.6 8.8-18.6 19.6-26.5 29.5-17.3-20.7-35.8-39.9-55.5-57.7zM530 432.9c-15 10-31 15-49 15-45 0-81-29-81-78 0-24 15-45 45-82 4 5 62 79 62 79l36-42c3 4 5 8 7 12 18 33 10 75-20 96z"
        }
    ]
};

const FasSensorOn = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSensorOn",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm88 0c-13.3 0-24 10.7-24 24v144c0 13.3 10.7 24 24 24s24-10.7 24-24V120c0-13.3-10.7-24-24-24zm96 0c-13.3 0-24 10.7-24 24v144c0 13.3 10.7 24 24 24s24-10.7 24-24V120c0-13.3-10.7-24-24-24zm413.3 12-48 32c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l48-32c11-7.4 25.9-4.4 33.3 6.7s4.4 25.9-6.7 33.3zM536 232h80c13.3 0 24 10.7 24 24s-10.7 24-24 24h-80c-13.3 0-24-10.7-24-24s10.7-24 24-24zm13.3 140 48 32c11 7.4 14 22.3 6.7 33.3s-22.3 14-33.3 6.7l-48-32c-11-7.4-14-22.3-6.7-33.3s22.3-14 33.3-6.7z"
        }
    ]
};

const FasSensorTriangleExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSensorTriangleExclamation",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h161c-.6-4-1-8.1-1-12.3 0-13.2 3.4-26.2 9.9-37.7l150.4-265c13-22.9 37.3-37.1 63.7-37.1V96c0-35.3-28.7-64-64-64H64zm48 88v144c0 13.3-10.7 24-24 24s-24-10.7-24-24V120c0-13.3 10.7-24 24-24s24 10.7 24 24zm96 0v144c0 13.3-10.7 24-24 24s-24-10.7-24-24V120c0-13.3 10.7-24 24-24s24 10.7 24 24zm53.8 325.8c-3.8 6.7-5.8 14.2-5.8 21.9 0 24.5 19.8 44.3 44.3 44.3h295.4c24.5 0 44.3-19.8 44.3-44.3 0-7.7-2-15.2-5.8-21.9l-150.4-265c-7.3-12.8-21-20.8-35.8-20.8s-28.5 8-35.8 20.9l-150.4 265zM464 272v88c0 8.8-7.2 16-16 16s-16-7.2-16-16v-88c0-8.8 7.2-16 16-16s16 7.2 16 16zm-16 136a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FasSensor = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSensor",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm48 88v144c0 13.3-10.7 24-24 24s-24-10.7-24-24V120c0-13.3 10.7-24 24-24s24 10.7 24 24zm96 0v144c0 13.3-10.7 24-24 24s-24-10.7-24-24V120c0-13.3 10.7-24 24-24s24 10.7 24 24z"
        }
    ]
};

const FasServer = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasServer",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v64c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm280 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm48 24a24 24 0 1 1 48 0 24 24 0 1 1-48 0zM64 288c-35.3 0-64 28.7-64 64v64c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64v-64c0-35.3-28.7-64-64-64H64zm280 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm56 24a24 24 0 1 1 48 0 24 24 0 1 1-48 0z"
        }
    ]
};

const FasShapes = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasShapes",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M315.4 15.5C309.7 5.9 299.2 0 288 0s-21.7 5.9-27.4 15.5l-96 160c-5.9 9.9-6.1 22.2-.4 32.2s16.3 16.2 27.8 16.2h192c11.5 0 22.2-6.2 27.8-16.2s5.5-22.3-.4-32.2l-96-160zM288 312v144c0 22.1 17.9 40 40 40h144c22.1 0 40-17.9 40-40V312c0-22.1-17.9-40-40-40H328c-22.1 0-40 17.9-40 40zM128 512a128 128 0 1 0 0-256 128 128 0 1 0 0 256z"
        }
    ]
};

const FasShareAll = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasShareAll",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M366.6 39.5c9.1-9.6 24.3-10 33.9-.9l141.7 134.6c19.9 18.9 19.9 50.7 0 69.6L400.5 377.4c-9.6 9.1-24.8 8.7-33.9-.9s-8.7-24.8.9-33.9L509.2 208 367.5 73.4c-9.6-9.1-10-24.3-.9-33.9zM224 64c0-12.6 7.4-24.1 19-29.2s25-3 34.4 5.4l160 144c6.7 6.1 10.6 14.7 10.6 23.8s-3.8 17.7-10.6 23.8l-160 144c-9.4 8.5-22.9 10.6-34.4 5.4s-19-16.6-19-29.2v-64h-32c-53 0-96 43-96 96 0 30.4 12.8 47.9 22.2 56.7 5.5 5.1 9.8 12 9.8 19.5 0 10.9-8.8 19.7-19.7 19.7-2.8 0-5.6-.6-8.1-1.9C81.5 467.9 0 417.3 0 304c0-97.2 78.8-176 176-176h48V64z"
        }
    ]
};

const FasShareFromSquare = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasShareFromSquare",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 224h-46.5c-45 0-81.5 36.5-81.5 81.5 0 22.3 10.3 34.3 19.2 40.5 6.8 4.7 12.8 12 12.8 20.3 0 9.8-8 17.8-17.8 17.8h-2.5c-2.4 0-4.8-.4-7.1-1.4C210.8 374.8 128 333.4 128 240c0-79.5 64.5-144 144-144h80V34.7C352 15.5 367.5 0 386.7 0c8.6 0 16.8 3.2 23.2 8.9l138.2 124.4c7.6 6.8 11.9 16.5 11.9 26.7s-4.3 19.9-11.9 26.7l-139 125.1c-5.9 5.3-13.5 8.2-21.4 8.2H384c-17.7 0-32-14.3-32-32v-64zM80 96c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16v-48c0-17.7 14.3-32 32-32s32 14.3 32 32v48c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80V112c0-44.2 35.8-80 80-80h48c17.7 0 32 14.3 32 32s-14.3 32-32 32H80z"
        }
    ]
};

const FasShareNodes = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasShareNodes",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 224c53 0 96-43 96-96s-43-96-96-96-96 43-96 96c0 4 .2 8 .7 11.9l-94.1 47C145.4 170.2 121.9 160 96 160c-53 0-96 43-96 96s43 96 96 96c25.9 0 49.4-10.2 66.6-26.9l94.1 47c-.5 3.9-.7 7.8-.7 11.9 0 53 43 96 96 96s96-43 96-96-43-96-96-96c-25.9 0-49.4 10.2-66.6 26.9l-94.1-47c.5-3.9.7-7.8.7-11.9s-.2-8-.7-11.9l94.1-47c17.2 16.7 40.7 26.9 66.6 26.9z"
        }
    ]
};

const FasShare = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasShare",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M307 34.8c-11.5 5.1-19 16.6-19 29.2v64H176C78.8 128 0 206.8 0 304c0 113.3 81.5 163.9 100.2 174.1 2.5 1.4 5.3 1.9 8.1 1.9 10.9 0 19.7-8.9 19.7-19.7 0-7.5-4.3-14.4-9.8-19.5-9.4-8.9-22.2-26.4-22.2-56.8 0-53 43-96 96-96h96v64c0 12.6 7.4 24.1 19 29.2s25 3 34.4-5.4l160-144c6.7-6.1 10.6-14.7 10.6-23.8s-3.8-17.7-10.6-23.8l-160-144a31.76 31.76 0 0 0-34.4-5.4z"
        }
    ]
};

const FasSheep = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSheep",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 135.8V208c0 44.2 35.8 80 80 80h32c44.2 0 80-35.8 80-80v-72.2l14.5 6.2c12.2 5.2 26.3-.4 31.5-12.6s-.4-26.3-12.6-31.5l-47.8-20.5C544.7 50.2 514.5 32 480 32s-64.7 18.2-81.6 45.4l-47.9 20.5c-12.2 5.2-17.8 19.3-12.6 31.5s19.3 17.8 31.5 12.6l14.5-6.2zm80-7.8a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm-160 31.4c-18.7-2.7-35.5-14.8-43.5-33.4-6.9-16.1-5.7-33.5 1.8-47.9C299 76 278.9 64 256 64c-19.2 0-36.5 8.5-48.2 21.9C196.9 77.2 183 72 168 72c-30.1 0-55.3 20.8-62.2 48.8-3.2-.5-6.5-.8-9.8-.8-35.3 0-64 28.7-64 64 0 5.3.7 10.5 1.9 15.5C13.7 210.3 0 231.5 0 256s13.7 45.7 33.9 56.5c-1.2 5-1.9 10.2-1.9 15.5 0 35.3 28.7 64 64 64h1.5l17.6 93.9c2.8 15.1 16.1 26.1 31.5 26.1H176c17.7 0 32-14.3 32-32v-53.7c11.7 13.3 28.9 21.7 48 21.7s36.3-8.4 48-21.7V480c0 17.7 14.3 32 32 32h29.4c15.4 0 28.6-11 31.4-26.1l17.7-93.9h1.5c35.3 0 64-28.7 64-64 0-2.7-.2-5.4-.5-8H464c-61.9 0-112-50.1-112-112v-32.6z"
        }
    ]
};

const FasSheetPlastic = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSheetPlastic",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 448c0 35.3 28.7 64 64 64h160V384c0-17.7 14.3-32 32-32h128V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64v384zM171.3 75.3l-96 96c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l96-96c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zm96 32-160 160c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l160-160c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zM384 384H256v128l128-128z"
        }
    ]
};

const FasShekelSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasShekelSign",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 32C14.3 32 0 46.3 0 64v384c0 17.7 14.3 32 32 32s32-14.3 32-32V96h128c35.3 0 64 28.7 64 64v160c0 17.7 14.3 32 32 32s32-14.3 32-32V160c0-70.7-57.3-128-128-128H32zm288 448c70.7 0 128-57.3 128-128V64c0-17.7-14.3-32-32-32s-32 14.3-32 32v288c0 35.3-28.7 64-64 64H192V192c0-17.7-14.3-32-32-32s-32 14.3-32 32v256c0 17.7 14.3 32 32 32h160z"
        }
    ]
};

const FasShelvesEmpty = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasShelvesEmpty",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C64 14.3 49.7 0 32 0S0 14.3 0 32v448c0 17.7 14.3 32 32 32s32-14.3 32-32h512c0 17.7 14.3 32 32 32s32-14.3 32-32V32c0-17.7-14.3-32-32-32s-32 14.3-32 32v128H64V32zm0 192h512v192H64V224z"
        }
    ]
};

const FasShelves = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasShelves",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 0c17.7 0 32 14.3 32 32v128h512V32c0-17.7 14.3-32 32-32s32 14.3 32 32v448c0 17.7-14.3 32-32 32s-32-14.3-32-32H64c0 17.7-14.3 32-32 32S0 497.7 0 480V32C0 14.3 14.3 0 32 0zm32 416h512V224H64v192zM352 32c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32V32zM128 256h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32zm160 0h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32z"
        }
    ]
};

const FasShieldCat = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasShieldCat",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2.5 99.2 41.3 280.7 213.6 363.2 16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM160 154.4c0-5.8 4.7-10.4 10.4-10.4h.2c3.4 0 6.5 1.6 8.5 4.3l40 53.3c3 4 7.8 6.4 12.8 6.4h48c5 0 9.8-2.4 12.8-6.4l40-53.3c2-2.7 5.2-4.3 8.5-4.3h.2c5.8 0 10.4 4.7 10.4 10.4V272c0 53-43 96-96 96s-96-43-96-96V154.4zM216 288a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm96-16a16 16 0 1 0-32 0 16 16 0 1 0 32 0z"
        }
    ]
};

const FasShieldCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasShieldCheck",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2.5 99.2 41.3 280.7 213.6 363.2 16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM369 209 241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
        }
    ]
};

const FasShieldCross = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasShieldCross",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2.5 99.2 41.3 280.7 213.6 363.2 16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM256 66.8l32 13.6V128c0 17.7 14.3 32 32 32h111.3c-1.2 19.6-4.2 41.4-9.4 64H320c-17.7 0-32 14.3-32 32v170.8c-10 6.5-20.7 12.5-32 18-11.3-5.5-22-11.5-32-18V256c0-17.7-14.3-32-32-32H90.1c-5.2-22.6-8.1-44.4-9.4-64H192c17.7 0 32-14.3 32-32V80.3l32-13.6z"
        }
    ]
};

const FasShieldDog = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasShieldDog",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2.5 99.2 41.3 280.7 213.6 363.2 16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM160.9 286.2c4.8 1.2 9.9 1.8 15.1 1.8 35.3 0 64-28.7 64-64v-64h44.2c12.1 0 23.2 6.8 28.6 17.7L320 192h64c8.8 0 16 7.2 16 16v32c0 44.2-35.8 80-80 80h-48v50.7c0 7.3-5.9 13.3-13.3 13.3-1.8 0-3.6-.4-5.2-1.1l-98.7-42.3c-6.6-2.8-10.8-9.3-10.8-16.4 0-2.8.6-5.5 1.9-8l15-30zM160 160h48v64c0 17.7-14.3 32-32 32s-32-14.3-32-32v-48c0-8.8 7.2-16 16-16zm128 48a16 16 0 1 0-32 0 16 16 0 1 0 32 0z"
        }
    ]
};

const FasShieldExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasShieldExclamation",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2.5 99.2 41.3 280.7 213.6 363.2 16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM256 128c13.3 0 24 10.7 24 24v112c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zm-32 224a32 32 0 1 1 64 0 32 32 0 1 1-64 0z"
        }
    ]
};

const FasShieldHalved = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasShieldHalved",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 0c4.6 0 9.2 1 13.4 2.9l188.3 79.9c22 9.3 38.4 31 38.3 57.2-.5 99.2-41.3 280.7-213.6 363.2-16.7 8-36.1 8-52.8 0C57.3 420.7 16.5 239.2 16 140c-.1-26.2 16.3-47.9 38.3-57.2L242.7 2.9C246.8 1 251.4 0 256 0zm0 66.8v378C394 378 431.1 230.1 432 141.4L256 66.8z"
        }
    ]
};

const FasShieldHeart = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasShieldHeart",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2.5 99.2 41.3 280.7 213.6 363.2 16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM144 221.3c0-33.8 27.4-61.3 61.3-61.3 16.2 0 31.8 6.5 43.3 17.9l7.4 7.4 7.4-7.4c11.5-11.5 27.1-17.9 43.3-17.9 33.8 0 61.3 27.4 61.3 61.3 0 16.2-6.5 31.8-17.9 43.3l-82.7 82.7c-6.2 6.2-16.4 6.2-22.6 0l-82.7-82.7c-11.5-11.5-17.9-27.1-17.9-43.3z"
        }
    ]
};

const FasShieldKeyhole = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasShieldKeyhole",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2.5 99.2 41.3 280.7 213.6 363.2 16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM312 208c0 22.3-13.1 41.6-32 50.6V328c0 13.3-10.7 24-24 24s-24-10.7-24-24v-69.4c-18.9-9-32-28.3-32-50.6 0-30.9 25.1-56 56-56s56 25.1 56 56z"
        }
    ]
};

const FasShieldMinus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasShieldMinus",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2.5 99.2 41.3 280.7 213.6 363.2 16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM184 232h144c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
        }
    ]
};

const FasShieldPlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasShieldPlus",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2.5 99.2 41.3 280.7 213.6 363.2 16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM232 344v-64h-64c-13.3 0-24-10.7-24-24s10.7-24 24-24h64v-64c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24h-64v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"
        }
    ]
};

const FasShieldQuartered = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasShieldQuartered",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2.5 99.2 41.3 280.7 213.6 363.2 16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM80 141.4l176-74.6V224H90.1c-6.9-30-9.8-58.5-10.1-82.6zm176 303.4V224h166c-18.5 80.5-65.5 172.2-166 220.8z"
        }
    ]
};

const FasShieldSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasShieldSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 0c4.6 0 9.2 1 13.4 2.9l188.3 79.9c22 9.3 38.4 31 38.3 57.2-.3 58.7-14.7 146.2-62.1 225l132.9 104.1c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1l-592-464C-1.2 34.7-3.1 19.6 5.1 9.2S28.4-3.1 38.8 5.1L131 77.4 306.7 2.9C310.8 1 315.4 0 320 0zM80.6 159.5l356.9 281.2c-25.2 24-55.3 45.4-91.1 62.5-16.7 8-36.1 8-52.8 0C132 425.8 86.1 261.5 80.6 159.5z"
        }
    ]
};

const FasShieldVirus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasShieldVirus",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2.5 99.2 41.3 280.7 213.6 363.2 16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM256 112c8.8 0 16 7.2 16 16 0 33 39.9 49.5 63.2 26.2 6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6C334.5 200.1 351 240 384 240c8.8 0 16 7.2 16 16s-7.2 16-16 16c-33 0-49.5 39.9-26.2 63.2 6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0C311.9 334.5 272 351 272 384c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-33-39.9-49.5-63.2-26.2-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6C177.5 311.9 161 272 128 272c-8.8 0-16-7.2-16-16s7.2-16 16-16c33 0 49.5-39.9 26.2-63.2-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0C200.1 177.5 240 161 240 128c0-8.8 7.2-16 16-16zm-24 144a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm72 32a16 16 0 1 0-32 0 16 16 0 1 0 32 0z"
        }
    ]
};

const FasShieldXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasShieldXmark",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2.5 99.2 41.3 280.7 213.6 363.2 16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"
        }
    ]
};

const FasShield = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasShield",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 0c4.6 0 9.2 1 13.4 2.9l188.3 79.9c22 9.3 38.4 31 38.3 57.2-.5 99.2-41.3 280.7-213.6 363.2-16.7 8-36.1 8-52.8 0C57.3 420.7 16.5 239.2 16 140c-.1-26.2 16.3-47.9 38.3-57.2L242.7 2.9C246.8 1 251.4 0 256 0z"
        }
    ]
};

const FasShip = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasShip",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 32c0-17.7 14.3-32 32-32h128c17.7 0 32 14.3 32 32v32h48c26.5 0 48 21.5 48 48v128l44.4 14.8c23.1 7.7 29.5 37.5 11.5 53.9l-101 92.6c-16.2 9.4-34.7 15.1-50.9 15.1-19.6 0-40.8-7.7-59.2-20.3-22.1-15.5-51.6-15.5-73.7 0-17.1 11.8-38 20.3-59.2 20.3-16.2 0-34.7-5.7-50.9-15.1L40 308.7c-18-16.5-11.6-46.2 11.5-53.9L96 240V112c0-26.5 21.5-48 48-48h48V32zm-32 186.7 107.8-35.9c13.1-4.4 27.3-4.4 40.5 0L416 218.7V128H160v90.7zm146.5 203.2c22.5 15.5 50 26.1 77.5 26.1 26.9 0 55.4-10.8 77.4-26.1 11.9-8.5 28.1-7.8 39.2 1.7 14.4 11.9 32.5 21 50.6 25.2 17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25-29 15.6-61.5 25.9-94.5 25.9-31.9 0-60.6-9.9-80.4-18.9-5.8-2.7-11.1-5.3-15.6-7.7-4.5 2.4-9.7 5.1-15.6 7.7-19.8 9-48.5 18.9-80.4 18.9-33 0-65.5-10.3-94.5-25.8-13.4 8.4-33.7 19.3-58.2 25-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2 11.1-9.4 27.3-10.1 39.2-1.7 22.1 15.2 50.5 26 77.4 26 27.5 0 55-10.6 77.5-26.1 11.1-7.9 25.9-7.9 37 0z"
        }
    ]
};

const FasShirtLongSleeve = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasShirtLongSleeve",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M157 .3c-32.1 2.5-61 20.9-76.7 49.5L13.9 170.5C4.8 187 0 205.6 0 224.4V384c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V224.4c0-2.7.7-5.3 2-7.7l46-83.7v315c0 35.3 28.7 64 64 64h224c35.3 0 64-28.7 64-64V133.1l46 83.7c1.3 2.4 2 5 2 7.7V384c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V224.4c0-18.9-4.8-37.4-13.9-54L559.7 49.7C544.1 21.2 515.1 2.8 483 .3c-1-.2-2-.3-3-.3h-48c-8.8 0-15.9 7.2-17.3 15.9C407.1 61.4 367.6 96 320 96s-87.1-34.6-94.7-80.1C223.9 7.2 216.8 0 208 0h-48c-1 0-2 .1-3 .3z"
        }
    ]
};

const FasShirtRunning = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasShirtRunning",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 0c17.7 0 32 14.3 32 32v48c0 44.2 35.8 80 80 80s80-35.8 80-80V32c0-17.7 14.3-32 32-32s32 14.3 32 32v32c0 33.3 2.6 61.5 6.5 85.2L0 393.8V282.5c0-17 6.7-33.5 14.7-48.4C28.8 207.6 48 155 48 64V32C48 14.3 62.3 0 80 0zM3.8 469.8 360.4 215c3 7.5 6 13.8 8.9 19 8 15 14.7 31.5 14.7 48.4V448c0 35.3-28.7 64-64 64H64c-27.7 0-51.3-17.6-60.2-42.2z"
        }
    ]
};

const FasShirtTankTop = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasShirtTankTop",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M112 32c0-17.7-14.3-32-32-32S48 14.3 48 32v32c0 91-19.2 143.6-33.3 170.1-8 15-14.7 31.4-14.7 48.4V448c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V282.5c0-17-6.7-33.5-14.7-48.4C355.2 207.6 336 155 336 64V32c0-17.7-14.3-32-32-32s-32 14.3-32 32v48c0 44.2-35.8 80-80 80s-80-35.8-80-80V32z"
        }
    ]
};

const FasShirt = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasShirt",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M211.8 0c7.8 0 14.3 5.7 16.7 13.2C240.8 51.9 277.1 80 320 80s79.2-28.1 91.5-66.8C413.9 5.7 420.4 0 428.2 0h12.6c22.5 0 44.2 7.9 61.5 22.3l126.2 105.1c6.6 5.5 10.7 13.5 11.4 22.1s-2.1 17.1-7.8 23.6l-56 64c-11.4 13.1-31.2 14.6-44.6 3.5L480 197.7V448c0 35.3-28.7 64-64 64H224c-35.3 0-64-28.7-64-64V197.7l-51.5 42.9c-13.3 11.1-33.1 9.6-44.6-3.5l-56-64c-5.7-6.5-8.5-15-7.8-23.6s4.8-16.6 11.4-22.1L137.7 22.3C155 7.9 176.7 0 199.2 0h12.6z"
        }
    ]
};

const FasShishKebab = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasShishKebab",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M438.6 73.4c-12.5-12.5-32.8-12.5-45.3 0-8.5 8.5-11.3 20.7-8.1 31.7 3.2 10.9 5.6 24.2 4.5 38-1.1 14-5.9 30.3-19.1 43.4L346.2 211 301 165.8l24.4-24.4c.2-.3.5-1.3.6-3.2.3-3.8-.3-9.1-2.1-15.2-9.5-32.5-1.5-69.2 24.3-94.9 37.5-37.5 98.3-37.5 135.8 0 31.4 31.4 36.5 79.2 15.3 115.9-8.8 15.3-28.4 20.5-43.7 11.7s-20.5-28.4-11.7-43.7c7.1-12.2 5.3-28.2-5.1-38.6zM61.8 405l45.2 45.2-52.4 52.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L61.8 405zm263.5-263.5a.1.1 0 1 0-.1-.2.1.1 0 1 0 .1.2zM233 143l136 136c9.4 9.4 9.4 24.6 0 33.9l-48 48c-9.4 9.4-24.6 9.4-33.9 0L151 225c-9.4-9.4-9.4-24.6 0-33.9l48-48c9.4-9.4 24.6-9.4 33.9 0zM87 255c9.4-9.4 24.6-9.4 33.9 0L257 391c9.4 9.4 9.4 24.6 0 33.9l-48 48c-9.4 9.4-24.6 9.4-33.9 0L39 337c-9.4-9.4-9.4-24.6 0-33.9l48-48z"
        }
    ]
};

const FasShoePrints = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasShoePrints",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M416 0c-63.7 0-160 32-160 32v128c48 0 76 16 104 32s56 32 104 32c56.4 0 176-16 176-96S512 0 416 0zM128 96c0 35.3 28.7 64 64 64h32V32h-32c-35.3 0-64 28.7-64 64zm160 416c96 0 224-48 224-128s-119.6-96-176-96c-48 0-76 16-104 32s-56 32-104 32v128s96.3 32 160 32zM0 416c0 35.3 28.7 64 64 64h32V352H64c-35.3 0-64 28.7-64 64z"
        }
    ]
};

const FasShopLock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasShopLock",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M36.8 192h412.8c20.2-19.8 47.9-32 78.4-32 30.5 0 58.1 12.2 78.3 31.9 18.9-1.6 33.7-17.4 33.7-36.7 0-7.3-2.2-14.4-6.2-20.4L558.2 21.4C549.3 8 534.4 0 518.3 0H121.7c-16 0-31 8-39.9 21.4L6.2 134.7c-4 6.1-6.2 13.2-6.2 20.4C0 175.5 16.5 192 36.8 192zM384 224h-64v160H128V224H64v240c0 26.5 21.5 48 48 48h224c26.5 0 48-21.5 48-48V224zm144 16c17.7 0 32 14.3 32 32v48h-64v-48c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32v128c0 17.7 14.3 32 32 32h160c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32v-48c0-44.2-35.8-80-80-80s-80 35.8-80 80z"
        }
    ]
};

const FasShopSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasShopSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-54.8-43V224h-64v152L384 275.7V224h-64v1.5L277.2 192h326c20.3 0 36.8-16.5 36.8-36.8 0-7.3-2.2-14.4-6.2-20.4L558.2 21.4C549.3 8 534.4 0 518.3 0H121.7c-16 0-31 8-39.9 21.4l-7.7 11.4L38.8 5.1zm-2 186.9h85L21 112.5 6.2 134.7c-4 6.1-6.2 13.2-6.2 20.4C0 175.5 16.5 192 36.8 192zM320 384H128V224H64v240c0 26.5 21.5 48 48 48h224c26.5 0 48-21.5 48-48v-65.5l-64-50.4V384z"
        }
    ]
};

const FasShop = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasShop",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M36.8 192h566.4c20.3 0 36.8-16.5 36.8-36.8 0-7.3-2.2-14.4-6.2-20.4L558.2 21.4C549.3 8 534.4 0 518.3 0H121.7c-16 0-31 8-39.9 21.4L6.2 134.7c-4 6.1-6.2 13.2-6.2 20.4C0 175.5 16.5 192 36.8 192zM64 224v240c0 26.5 21.5 48 48 48h224c26.5 0 48-21.5 48-48V224h-64v160H128V224H64zm448 0v256c0 17.7 14.3 32 32 32s32-14.3 32-32V224h-64z"
        }
    ]
};

const FasShovelSnow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasShovelSnow",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M391 7c9.4-9.4 24.6-9.4 33.9 0l80 80c9.4 9.4 9.4 24.6 0 33.9l-31.4 31.4a80.607 80.607 0 0 1-57 23.6c-13.5 0-26.2-3.3-37.4-9.2l-83.5 83.5 47 47c11.3 11.3 12.5 29.1 3 41.8l-120 160c-5.6 7.4-14.1 12.1-23.3 12.7s-18.3-2.7-24.9-9.3l-168-168c-6.6-6.3-10-15.4-9.3-24.7s5.3-17.8 12.7-23.3l160-120c12.7-9.6 30.6-8.3 41.8 3l47 47 83.5-83.5c-5.9-11.2-9.2-23.9-9.2-37.4 0-21.4 8.5-41.9 23.6-57L391 7zm17 50.9-14.5 14.5c-6.1 6.1-9.5 14.4-9.5 23 0 18 14.6 32.6 32.6 32.6 8.6 0 16.9-3.4 23-9.5l14.5-14.5L408 57.9zM203.3 267.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-80 80c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l80-80zm64 64c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-80 80c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l80-80z"
        }
    ]
};

const FasShovel = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasShovel",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M361.4 9.4c12.5-12.5 32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3l-44.1 44.1c-18.7 18.7-44.1 29.3-70.6 29.3-15.9 0-30.9-3.7-44.3-10.3l-97 97 50.7 50.7c12.5 12.5 12.5 32.8 0 45.3l-58.5 58.5c-30 30-70.7 46.9-113.1 46.9H32c-17.7 0-32-14.3-32-32v-93.9c0-42.4 16.9-83.1 46.9-113.1l58.5-58.5c12.5-12.5 32.8-12.5 45.3 0l50.7 50.7 97-97c-6.7-13.3-10.4-28.4-10.4-44.3 0-26.5 10.5-51.9 29.3-70.6l44.1-44.1zM384 77.3l-21.5 21.4c-6.7 6.7-10.5 15.9-10.5 25.4 0 19.8 16.1 35.9 35.9 35.9 9.5 0 18.6-3.8 25.4-10.5l21.4-21.5L384 77.3z"
        }
    ]
};

const FasShowerDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasShowerDown",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 0c17.7 0 32 14.3 32 32v3.2C297 50 352 114.6 352 192c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32c0-77.4 55-142 128-156.8V32c0-17.7 14.3-32 32-32zm52.8 423.4c1.9-4.5 6.3-7.4 11.2-7.4s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1v1.1c0 17.7-14.3 32-32 32s-32-14.3-32-32v-1.2c0-4.5.9-8.9 2.7-13.1l18.2-42.4zm-82.2-85.6 18.2-42.4c1.9-4.5 6.3-7.4 11.2-7.4s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1v1.1c0 17.7-14.3 32-32 32s-32-14.3-32-32v-1.2c0-4.5.9-8.9 2.7-13.1zm146.2-42.4c1.9-4.5 6.3-7.4 11.2-7.4s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1v1.1c0 17.7-14.3 32-32 32s-32-14.3-32-32v-1.2c0-4.5.9-8.9 2.7-13.1l18.2-42.4zM98.7 465.7l18.2-42.4c1.9-4.5 6.3-7.4 11.2-7.4s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1v1.2c0 17.7-14.3 32-32 32s-32-14.3-32-32v-1.2c0-4.5.9-8.9 2.7-13.1zM52.8 295.4c1.9-4.5 6.3-7.4 11.2-7.4s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1v1.1c0 17.7-14.3 32-32 32s-32-14.3-32-32v-1.2c0-4.5.9-8.9 2.7-13.1L53 295.3z"
        }
    ]
};

const FasShower = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasShower",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 131.9C64 112.1 80.1 96 99.9 96c9.5 0 18.6 3.8 25.4 10.5l16.2 16.2c-21 38.9-17.4 87.5 10.9 123L151 247c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L345 121c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-1.3 1.3c-35.5-28.3-84.2-31.9-123-10.9l-16.3-16.2C151.8 42.5 126.4 32 99.9 32 44.7 32 0 76.7 0 131.9V448c0 17.7 14.3 32 32 32s32-14.3 32-32V131.9zM256 352a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm64 64a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm0-128a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm64 64a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm0-128a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm64 64a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm32-32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FasShredder = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasShredder",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c0-35.3 28.7-64 64-64h226.7c17 0 33.3 6.7 45.3 18.7L429.3 48c12 12 18.7 28.3 18.7 45.3V192c35.3 0 64 28.7 64 64v96c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32v-96c0-35.3 28.7-64 64-64V64zm320 29.3L354.7 64H128v128h256V93.3zM432 296a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM40 416h48v72c0 13.3-10.7 24-24 24s-24-10.7-24-24v-72zm96 0h48v72c0 13.3-10.7 24-24 24s-24-10.7-24-24v-72zm96 0h48v72c0 13.3-10.7 24-24 24s-24-10.7-24-24v-72zm96 0h48v72c0 13.3-10.7 24-24 24s-24-10.7-24-24v-72zm96 0h48v72c0 13.3-10.7 24-24 24s-24-10.7-24-24v-72z"
        }
    ]
};

const FasShrimp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasShrimp",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96s28.7 64 64 64h1c3.7 88.9 77 160 167 160h56V128H64c-17.7 0-32-14.3-32-32s14.3-32 32-32h400c8.8 0 16-7.2 16-16s-7.2-16-16-16H64zm160 424c0 13.3 10.7 24 24 24h72v-72.2l-64.1-22.4c-12.5-4.4-26.2 2.2-30.6 14.7s2.2 26.2 14.7 30.6l4.5 1.6C233 433.9 224 443.9 224 456zm128 23.3c36.4-3.3 69.5-17.6 96.1-39.6l-86.5-34.6c-3 1.8-6.2 3.2-9.6 4.3v69.9zM472.6 415c24.6-30.3 39.4-68.9 39.4-111 0-12.3-1.3-24.3-3.7-35.9l-125.5 87c.8 3.4 1.2 7 1.2 10.6 0 4.6-.7 9-1.9 13.1l90.5 36.2zM336 128h-16v192h18.3c9.9 0 19.1 3.2 26.6 8.5l133.5-92.4C471.8 172.6 409.1 128 336 128zm-168 64a24 24 0 1 1 48 0 24 24 0 1 1-48 0z"
        }
    ]
};

const FasShuffle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasShuffle",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M403.8 34.4c12-5 25.7-2.2 34.9 6.9l64 64c6 6 9.4 14.1 9.4 22.6s-3.4 16.6-9.4 22.6l-64 64c-9.2 9.2-22.9 11.9-34.9 6.9S384 204.8 384 191.8V160h-32c-10.1 0-19.6 4.7-25.6 12.8L284 229.3 244 176l31.2-41.6C293.3 110.2 321.8 96 352 96h32V64c0-12.9 7.8-24.6 19.8-29.6zM164 282.7l40 53.3-31.2 41.6C154.7 401.8 126.2 416 96 416H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h64c10.1 0 19.6-4.7 25.6-12.8l42.4-56.5zm274.6 188c-9.2 9.2-22.9 11.9-34.9 6.9S383.9 461 383.9 448v-32H352c-30.2 0-58.7-14.2-76.8-38.4L121.6 172.8c-6-8.1-15.5-12.8-25.6-12.8H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h64c30.2 0 58.7 14.2 76.8 38.4l153.6 204.8c6 8.1 15.5 12.8 25.6 12.8h32v-32c0-12.9 7.8-24.6 19.8-29.6s25.7-2.2 34.9 6.9l64 64c6 6 9.4 14.1 9.4 22.6s-3.4 16.6-9.4 22.6l-64 64z"
        }
    ]
};

const FasShutters = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasShutters",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 32C14.3 32 0 46.3 0 64s14.3 32 32 32h448c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zM20.6 224h470.8c11.4 0 20.6-9.2 20.6-20.6 0-2.2-.4-4.4-1.1-6.5L488 128H24L1.1 196.8c-.7 2.1-1.1 4.3-1.1 6.5C0 214.8 9.2 224 20.6 224zm470.8 128c11.4 0 20.6-9.2 20.6-20.6 0-2.2-.4-4.4-1.1-6.5L488 256H24L1.1 324.8c-.7 2.1-1.1 4.3-1.1 6.5C0 342.8 9.2 352 20.6 352h470.8zM20.6 480h470.8c11.4 0 20.6-9.2 20.6-20.6 0-2.2-.4-4.4-1.1-6.5L488 384H24L1.1 452.8c-.7 2.1-1.1 4.3-1.1 6.5C0 470.8 9.2 480 20.6 480z"
        }
    ]
};

const FasShuttleSpace = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasShuttleSpace",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M130 480c40.6 0 80.4-11 115.2-31.9L352 384H128v96h2zm222-352L245.2 63.9C210.4 43 170.6 32 130 32h-2v96h224zm-256 0V32H80c-26.5 0-48 21.5-48 48v48h8c-22.1 0-40 17.9-40 40v176c0 22.1 17.9 40 40 40h-8v48c0 26.5 21.5 48 48 48h16v-96h8c26.2 0 49.4-12.6 64-32h288c69.3 0 135-22.7 179.2-81.6 6.4-8.5 6.4-20.3 0-28.8C591 182.7 525.3 160 456 160H168c-14.6-19.4-37.8-32-64-32h-8zm416 115.6v24.9c0 19.6-15.9 35.6-35.6 35.6-2.5 0-4.4-2-4.4-4.4v-87.3c0-2.5 2-4.4 4.4-4.4 19.6 0 35.6 15.9 35.6 35.6z"
        }
    ]
};

const FasShuttlecock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasShuttlecock",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 32c0 8.8-7.2 16-16 16-24.4 0-46 15.8-53.4 39.1l-29.3 92.8c-1.3 4.1-4.2 7.6-8.1 9.5l-32.4 16.2c-3.1 1.5-5.6 4.1-7.2 7.2l-32.5 64.9c-3.1 6.2-1.9 13.6 3 18.5L163 315l71.9-71.9 46.2-146.3c3.2-10 12.4-16.8 22.9-16.8h104c13.3 0 24 10.7 24 24v104c0 10.5-6.8 19.7-16.8 22.9l-146.4 46.2L197 349l18.9 18.9c4.9 4.9 12.3 6.1 18.5 3l64.9-32.5c3.1-1.5 5.6-4.1 7.2-7.2l16.2-32.4c1.9-3.9 5.4-6.8 9.5-8.1l92.8-29.3c23.3-7.4 39.1-29 39.1-53.4 0-8.8 7.2-16 16-16h8c13.3 0 24 10.7 24 24v51.7c0 12.4-7.2 23.7-18.4 29L250.1 411.2c-6.7 3.1-12.8 7.4-18 12.7l-28.8 28.8-144-144 28.8-28.8a65.2 65.2 0 0 0 12.7-18L215.4 18.4C220.6 7.2 231.9 0 244.3 0H296c13.3 0 24 10.7 24 24v8zM36.7 331.3l144 144-6.9 6.9a101.8 101.8 0 0 1-72 29.8C45.6 512 0 466.4 0 410.2c0-27 10.7-52.9 29.8-72l6.9-6.9z"
        }
    ]
};

const FasSickle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSickle",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M212.7 340.7 181 309c-33.9-33.9-53-80-53-128C128 81 209 0 309 0h11c90.1 0 165.8 62.1 186.4 145.8 1.8 7.3-4 14.2-11.5 14.2-3.9 0-7.5-1.9-9.9-4.9-26.1-32.2-65.5-51.1-107.2-51.1-76.1 0-137.8 61.7-137.8 137.8v9.8c0 20.7 5.2 39.7 12.2 58.6 2.2 6 .9 12.8-3.7 17.3l-13.2 13.2c-6.2 6.2-16.4 6.2-22.6 0zM121 311l24 24 32 32 24 24c9.4 9.4 9.4 24.6 0 33.9l-16 16c-9.4 9.4-24.6 9.4-33.9 0l-7-7L73 505c-9.4 9.4-24.6 9.4-33.9 0L7 473c-9.4-9.4-9.4-24.6 0-33.9l71-71-7-7c-9.4-9.4-9.4-24.6 0-33.9l16-16c9.4-9.4 24.6-9.4 33.9 0z"
        }
    ]
};

const FasSidebarFlip = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSidebarFlip",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V96zm-224 0v320H64V96h224zm136 0c13.3 0 24 10.7 24 24s-10.7 24-24 24h-48c-13.3 0-24-10.7-24-24s10.7-24 24-24h48zm24 120c0 13.3-10.7 24-24 24h-48c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24zm-24 72c13.3 0 24 10.7 24 24s-10.7 24-24 24h-48c-13.3 0-24-10.7-24-24s10.7-24 24-24h48z"
        }
    ]
};

const FasSidebar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSidebar",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 96c0-35.3 28.7-64 64-64h384c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm224 0v320h224V96H224zM88 96c-13.3 0-24 10.7-24 24s10.7 24 24 24h48c13.3 0 24-10.7 24-24s-10.7-24-24-24H88zM64 216c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24s-10.7-24-24-24H88c-13.3 0-24 10.7-24 24zm24 72c-13.3 0-24 10.7-24 24s10.7 24 24 24h48c13.3 0 24-10.7 24-24s-10.7-24-24-24H88z"
        }
    ]
};

const FasSigma = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSigma",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M2.4 51.8C7.4 39.8 19.1 32 32 32h288c35.3 0 64 28.7 64 64v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V96H109.3l137.3 137.4c12.5 12.5 12.5 32.8 0 45.3L109.3 416H320v-32c0-17.7 14.3-32 32-32s32 14.3 32 32v32c0 35.3-28.7 64-64 64H32c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9L178.7 256 9.4 86.6c-9.2-9.1-11.9-22.9-7-34.8z"
        }
    ]
};

const FasSignHanging = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSignHanging",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 0c17.7 0 32 14.3 32 32v32h352c17.7 0 32 14.3 32 32s-14.3 32-32 32H128v352c0 17.7-14.3 32-32 32s-32-14.3-32-32V128H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h32V32C64 14.3 78.3 0 96 0zm96 160h256c17.7 0 32 14.3 32 32v160c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V192c0-17.7 14.3-32 32-32z"
        }
    ]
};

const FasSignalBarsFair = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSignalBarsFair",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M240 256c-26.5 0-48 21.5-48 48v160c0 26.5 21.5 48 48 48s48-21.5 48-48V304c0-26.5-21.5-48-48-48zM80 384c-26.5 0-48 21.5-48 48v32c0 26.5 21.5 48 48 48s48-21.5 48-48v-32c0-26.5-21.5-48-48-48z"
        }
    ]
};

const FasSignalBarsGood = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSignalBarsGood",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M400 128c-26.5 0-48 21.5-48 48v288c0 26.5 21.5 48 48 48s48-21.5 48-48V176c0-26.5-21.5-48-48-48zM192 304v160c0 26.5 21.5 48 48 48s48-21.5 48-48V304c0-26.5-21.5-48-48-48s-48 21.5-48 48zM32 432v32c0 26.5 21.5 48 48 48s48-21.5 48-48v-32c0-26.5-21.5-48-48-48s-48 21.5-48 48z"
        }
    ]
};

const FasSignalBarsSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSignalBarsSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L608 451.2V48c0-26.5-21.5-48-48-48s-48 21.5-48 48v328l-64-50.2V176c0-26.5-21.5-48-48-48s-48 21.5-48 48v74.6L38.8 5.1zM288 322.9l-74.7-58.8c-12.8 8.6-21.3 23.3-21.3 39.9v160c0 26.5 21.5 48 48 48s48-21.5 48-48V322.9zM448 464v-15l-96-75.6V464c0 26.5 21.5 48 48 48s48-21.5 48-48zM80 384c-26.5 0-48 21.5-48 48v32c0 26.5 21.5 48 48 48s48-21.5 48-48v-32c0-26.5-21.5-48-48-48z"
        }
    ]
};

const FasSignalBarsWeak = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSignalBarsWeak",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 432c0-26.5 21.5-48 48-48s48 21.5 48 48v32c0 26.5-21.5 48-48 48s-48-21.5-48-48v-32z"
        }
    ]
};

const FasSignalBars = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSignalBars",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M560 0c-26.5 0-48 21.5-48 48v416c0 26.5 21.5 48 48 48s48-21.5 48-48V48c0-26.5-21.5-48-48-48zM352 176v288c0 26.5 21.5 48 48 48s48-21.5 48-48V176c0-26.5-21.5-48-48-48s-48 21.5-48 48zm-112 80c-26.5 0-48 21.5-48 48v160c0 26.5 21.5 48 48 48s48-21.5 48-48V304c0-26.5-21.5-48-48-48zM80 384c-26.5 0-48 21.5-48 48v32c0 26.5 21.5 48 48 48s48-21.5 48-48v-32c0-26.5-21.5-48-48-48z"
        }
    ]
};

const FasSignalFair = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSignalFair",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 320c0-17.7-14.3-32-32-32s-32 14.3-32 32v160c0 17.7 14.3 32 32 32s32-14.3 32-32V320zM96 416c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 17.7 14.3 32 32 32s32-14.3 32-32v-64z"
        }
    ]
};

const FasSignalGood = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSignalGood",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 192c17.7 0 32 14.3 32 32v256c0 17.7-14.3 32-32 32s-32-14.3-32-32V224c0-17.7 14.3-32 32-32zm-128 96c17.7 0 32 14.3 32 32v160c0 17.7-14.3 32-32 32s-32-14.3-32-32V320c0-17.7 14.3-32 32-32zM96 416v64c0 17.7-14.3 32-32 32s-32-14.3-32-32v-64c0-17.7 14.3-32 32-32s32 14.3 32 32z"
        }
    ]
};

const FasSignalSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSignalSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L608 451.2V32c0-17.7-14.3-32-32-32s-32 14.3-32 32v369.1l-64-50.2V128c0-17.7-14.3-32-32-32s-32 14.3-32 32v172.8l-64-50.2V224c0-17.7-14.3-32-32-32-10.7 0-20.1 5.2-25.9 13.2L38.8 5.1zM576 512h-.3.6-.3zm-96-32v-5.8l-64-50.4V480c0 17.7 14.3 32 32 32s32-14.3 32-32zM352 373.3l-64-50.4V480c0 17.7 14.3 32 32 32s32-14.3 32-32V373.3zM192 288c-17.7 0-32 14.3-32 32v160c0 17.7 14.3 32 32 32s32-14.3 32-32V320c0-17.7-14.3-32-32-32zM96 416c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 17.7 14.3 32 32 32s32-14.3 32-32v-64z"
        }
    ]
};

const FasSignalStreamSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSignalStreamSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-91.7-71.9C562.6 355.5 576 307.3 576 256c0-68.1-23.7-130.7-63.2-180-11.1-13.8-31.2-16-45-5s-16 31.2-5 45c30.7 38.4 49.1 87 49.1 140 0 36.4-8.7 70.8-24.1 101.1l-38.7-30.4c9.5-21.7 14.8-45.6 14.8-70.8 0-45.1-17-86.2-44.8-117.3-11.8-13.2-32-14.3-45.2-2.5s-14.3 32-2.5 45.2c17.8 19.8 28.5 46 28.5 74.7 0 10.1-1.3 19.9-3.8 29.2l-53.6-42c-5.8-24.7-28-43.2-54.5-43.2h-.5L38.8 5.1zm84.7 188.2c-7.4 19.5-11.5 40.6-11.5 62.7 0 45.1 17 86.2 44.8 117.3 11.8 13.2 32 14.3 45.2 2.5s14.3-32 2.5-45.2c-17.8-19.8-28.5-46-28.5-74.7 0-6.8.6-13.5 1.8-19.9l-54.3-42.8zM33 122C11.9 162 0 207.6 0 256c0 68.1 23.7 130.7 63.2 180 11.1 13.8 31.2 16 45 5s16-31.2 5-45C82.4 357.6 64 309 64 256c0-33.4 7.3-65.1 20.4-93.5L33 122z"
        }
    ]
};

const FasSignalStream = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSignalStream",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M108.2 71c13.8 11.1 16 31.2 5 45C82.4 154.4 64 203 64 256s18.4 101.6 49.1 140c11.1 13.8 8.8 33.9-5 45s-33.9 8.8-45-5C23.7 386.7 0 324.1 0 256S23.7 125.3 63.2 76c11.1-13.8 31.2-16 45-5zm359.7 0c13.8-11.1 33.9-8.8 45 5 39.4 49.3 63.1 111.9 63.1 180s-23.7 130.7-63.2 180c-11.1 13.8-31.2 16-45 5s-16-31.2-5-45c30.7-38.4 49.1-87 49.1-140s-18.4-101.6-49.1-140c-11.1-13.8-8.8-33.9 5-45zM232 256a56 56 0 1 1 112 0 56 56 0 1 1-112 0zm-27.5-74.7c-17.8 19.8-28.5 46-28.5 74.7s10.8 54.8 28.5 74.7c11.8 13.2 10.7 33.4-2.5 45.2s-33.4 10.7-45.2-2.5C129 342.2 112 301.1 112 256s17-86.2 44.8-117.3c11.8-13.2 32-14.3 45.2-2.5s14.3 32 2.5 45.2zm214.7-42.7C447 169.8 464 210.9 464 256s-17 86.2-44.8 117.3c-11.8 13.2-32 14.3-45.2 2.5s-14.3-32-2.5-45.2c17.8-19.8 28.5-46 28.5-74.7s-10.8-54.8-28.5-74.7c-11.8-13.2-10.7-33.4 2.5-45.2s33.4-10.7 45.2 2.5z"
        }
    ]
};

const FasSignalStrong = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSignalStrong",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 128c0-17.7-14.3-32-32-32s-32 14.3-32 32v352c0 17.7 14.3 32 32 32s32-14.3 32-32V128zm-128 96c0-17.7-14.3-32-32-32s-32 14.3-32 32v256c0 17.7 14.3 32 32 32s32-14.3 32-32V224zm-160 64c-17.7 0-32 14.3-32 32v160c0 17.7 14.3 32 32 32s32-14.3 32-32V320c0-17.7-14.3-32-32-32zM96 416c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 17.7 14.3 32 32 32s32-14.3 32-32v-64z"
        }
    ]
};

const FasSignalWeak = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSignalWeak",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 384c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32v-64c0-17.7 14.3-32 32-32z"
        }
    ]
};

const FasSignal = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSignal",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M576 0c17.7 0 32 14.3 32 32v448c0 17.7-14.3 32-32 32s-32-14.3-32-32V32c0-17.7 14.3-32 32-32zM448 96c17.7 0 32 14.3 32 32v352c0 17.7-14.3 32-32 32s-32-14.3-32-32V128c0-17.7 14.3-32 32-32zm-96 128v256c0 17.7-14.3 32-32 32s-32-14.3-32-32V224c0-17.7 14.3-32 32-32s32 14.3 32 32zm-160 64c17.7 0 32 14.3 32 32v160c0 17.7-14.3 32-32 32s-32-14.3-32-32V320c0-17.7 14.3-32 32-32zM96 416v64c0 17.7-14.3 32-32 32s-32-14.3-32-32v-64c0-17.7 14.3-32 32-32s32 14.3 32 32z"
        }
    ]
};

const FasSignatureLock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSignatureLock",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 128c0-17.7 14.3-32 32-32s32 14.3 32 32v7.8c0 27.7-2.4 55.3-7.1 82.5l-84.5 25.4C27.8 255.8 0 293.2 0 335.6v71.9c0 40 32.5 72.5 72.5 72.5 26 0 50-13.9 62.9-36.5l13.9-24.3c26.8-47 46.5-97.7 58.4-150.5l94.4-28.3-12.5 37.5c-3.3 9.8-1.6 20.5 4.4 28.8s15.7 13.3 26 13.3h72.6c5.6-9.7 13.7-17.8 23.4-23.4V272c0-5.4.4-10.8 1.1-16h-52.7l18-53.9c3.8-11.3.9-23.8-7.4-32.4s-20.7-11.8-32.2-8.4l-122.4 36.8c2.4-20.7 3.6-41.4 3.6-62.3V128c0-53-43-96-96-96s-96 43-96 96v32c0 17.7 14.3 32 32 32s32-14.3 32-32v-32zm113.9 240c-6.7 16.3-14.2 32.3-22.3 48H384v-48H209.9zM86.8 305l49-14.7c-10.4 33.8-24.5 66.4-42.1 97.2l-13.8 24.2c-1.5 2.6-4.3 4.3-7.4 4.3-4.7 0-8.5-3.8-8.5-8.5v-71.9c0-14.1 9.3-26.6 22.8-30.7zM528 240c17.7 0 32 14.3 32 32v48h-64v-48c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32v128c0 17.7 14.3 32 32 32h160c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32v-48c0-44.2-35.8-80-80-80s-80 35.8-80 80z"
        }
    ]
};

const FasSignatureSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSignatureSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L563 416h53c13.3 0 24-10.7 24-24s-10.7-24-24-24H501.8l-61.2-48H544c17.7 0 32-14.3 32-32s-14.3-32-32-32h-83.6l18-53.9c3.8-11.3.9-23.8-7.4-32.4s-20.7-11.8-32.2-8.4l-122.4 36.8c2.4-20.7 3.6-41.4 3.6-62.3V128c0-53-43-96-96-96-37 0-69.1 20.9-85.1 51.6L38.8 5.1zm153.3 120.2C193.5 108.9 207.2 96 224 96c17.7 0 32 14.3 32 32v7.8c0 12.8-.5 25.6-1.5 38.3l-62.4-48.9zm163.2 127.9 42.8-12.8-12.3 36.8-30.5-23.9zm-190.9-9.5c-40.6 12.2-68.4 49.6-68.4 92v71.9c0 40 32.5 72.5 72.5 72.5 26 0 50-13.9 62.9-36.5l13.9-24.3c17.5-30.5 31.9-62.7 43.1-95.9l-107.3-84.7-16.7 5zm67.4 46.6c-10.4 33.8-24.5 66.4-42.1 97.2l-13.9 24.3c-1.5 2.6-4.3 4.3-7.4 4.3-4.7 0-8.5-3.8-8.5-8.5v-72c0-14.1 9.3-26.6 22.8-30.7l49-14.7zM24 368c-13.3 0-24 10.7-24 24s10.7 24 24 24h40.3c-.2-2.8-.3-5.6-.3-8.5V368H24z"
        }
    ]
};

const FasSignature = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSignature",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 128c0-17.7 14.3-32 32-32s32 14.3 32 32v7.8c0 27.7-2.4 55.3-7.1 82.5l-84.4 25.3c-40.6 12.2-68.4 49.6-68.4 92v71.9c0 40 32.5 72.5 72.5 72.5 26 0 50-13.9 62.9-36.5l13.9-24.3c26.8-47 46.5-97.7 58.4-150.5l94.4-28.3-12.5 37.5c-3.3 9.8-1.6 20.5 4.4 28.8s15.7 13.3 26 13.3H544c17.7 0 32-14.3 32-32s-14.3-32-32-32h-83.6l18-53.9c3.8-11.3.9-23.8-7.4-32.4s-20.7-11.8-32.2-8.4l-122.4 36.8c2.4-20.7 3.6-41.4 3.6-62.3V128c0-53-43-96-96-96s-96 43-96 96v32c0 17.7 14.3 32 32 32s32-14.3 32-32v-32zm-9.2 177 49-14.7c-10.4 33.8-24.5 66.4-42.1 97.2l-13.9 24.3c-1.5 2.6-4.3 4.3-7.4 4.3-4.7 0-8.5-3.8-8.5-8.5v-72c0-14.1 9.3-26.6 22.8-30.7zM24 368c-13.3 0-24 10.7-24 24s10.7 24 24 24h40.3c-.2-2.8-.3-5.6-.3-8.5V368H24zm592 48c13.3 0 24-10.7 24-24s-10.7-24-24-24H305.9c-6.7 16.3-14.2 32.3-22.3 48H616z"
        }
    ]
};

const FasSignsPost = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSignsPost",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 32H64c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h377.4c4.2 0 8.3-1.7 11.3-4.7l48-48c6.2-6.2 6.2-16.4 0-22.6l-48-48c-3-3-7.1-4.7-11.3-4.7H288c0-17.7-14.3-32-32-32s-32 14.3-32 32zm256 224c0-17.7-14.3-32-32-32H288v-32h-64v32H70.6c-4.2 0-8.3 1.7-11.3 4.7l-48 48c-6.2 6.2-6.2 16.4 0 22.6l48 48c3 3 7.1 4.7 11.3 4.7H448c17.7 0 32-14.3 32-32v-64zM288 480v-96h-64v96c0 17.7 14.3 32 32 32s32-14.3 32-32z"
        }
    ]
};

const FasSimCard = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSimCard",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 0h178.7c17 0 33.3 6.7 45.3 18.7L365.3 96c12 12 18.7 28.3 18.7 45.3V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0zm32 192c-17.7 0-32 14.3-32 32v32h64v-64H96zM64 352h256v-64H64v64zm256-128c0-17.7-14.3-32-32-32h-32v64h64v-32zm-160-32v64h64v-64h-64zm128 256c17.7 0 32-14.3 32-32v-32h-64v64h32zm-128-64v64h64v-64h-64zm-96 32c0 17.7 14.3 32 32 32h32v-64H64v32z"
        }
    ]
};

const FasSimCards = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSimCards",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 0c-35.3 0-64 28.7-64 64v288c0 35.3 28.7 64 64 64h224c35.3 0 64-28.7 64-64V141.3c0-17-6.7-33.3-18.7-45.3L352 18.7C340 6.7 323.7 0 306.7 0H160zm48 144v48h-48v-16c0-17.7 14.3-32 32-32h16zm-48 80h224v48H160v-48zm224-32h-48v-48h16c17.7 0 32 14.3 32 32v16zm-80-48v48h-64v-48h64zm80 160v16c0 17.7-14.3 32-32 32h-16v-48h48zm-80 48h-64v-48h64v48zm-96 0h-16c-17.7 0-32-14.3-32-32v-16h48v48zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120v256c0 75.1 60.9 136 136 136h224c13.3 0 24-10.7 24-24s-10.7-24-24-24H136c-48.6 0-88-39.4-88-88V120z"
        }
    ]
};

const FasSink = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSink",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 96c0-17.7 14.3-32 32-32s32 14.3 32 32 14.3 32 32 32 32-14.3 32-32c0-53-43-96-96-96s-96 43-96 96v192h-64v-24c0-30.9-25.1-56-56-56H56c-13.3 0-24 10.7-24 24s10.7 24 24 24h48c4.4 0 8 3.6 8 8v24H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h448c17.7 0 32-14.3 32-32s-14.3-32-32-32h-80v-24c0-4.4 3.6-8 8-8h56c13.3 0 24-10.7 24-24s-10.7-24-24-24h-56c-30.9 0-56 25.1-56 56v24h-64V96zm192 320v-32H32v32c0 53 43 96 96 96h256c53 0 96-43 96-96z"
        }
    ]
};

const FasSirenOn = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSirenOn",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m69.3 36 48 32c11 7.4 14 22.3 6.7 33.3s-22.3 14-33.3 6.7l-48-32c-11-7.4-14-22.3-6.7-33.3s22.3-14 33.3-6.7zm528 40-48 32c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l48-32c11-7.4 25.9-4.4 33.3 6.7s4.4 25.9-6.7 33.3zM24 192h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24zm528 0h64c13.3 0 24 10.7 24 24s-10.7 24-24 24h-64c-13.3 0-24-10.7-24-24s10.7-24 24-24zM144 352l25-199.9c4-32 31.2-56.1 63.5-56.1h175c32.3 0 59.5 24 63.5 56.1L496 352H234.1l21.8-174c1.1-8.8-5.1-16.8-13.9-17.9s-16.8 5.1-17.9 13.9l-22.2 178H144zm-48 64c0-17.7 14.3-32 32-32h384c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32v-32z"
        }
    ]
};

const FasSiren = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSiren",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M73 152.1 48 352h57.9l22.2-178c1.1-8.8 9.1-15 17.9-13.9s15 9.1 13.9 17.9l-21.8 174H400l-25-199.9C371 120 343.8 96 311.5 96h-175C104.2 96 77 120 73 152.1zM32 384c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32v-32c0-17.7-14.3-32-32-32H32z"
        }
    ]
};

const FasSitemap = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSitemap",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M208 80c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48h-8v40h152c30.9 0 56 25.1 56 56v32h8c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48h-64c-26.5 0-48-21.5-48-48v-64c0-26.5 21.5-48 48-48h8v-32c0-4.4-3.6-8-8-8H312v40h8c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48h-64c-26.5 0-48-21.5-48-48v-64c0-26.5 21.5-48 48-48h8v-40H112c-4.4 0-8 3.6-8 8v32h8c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48v-64c0-26.5 21.5-48 48-48h8v-32c0-30.9 25.1-56 56-56h152v-40h-8c-26.5 0-48-21.5-48-48V80z"
        }
    ]
};

const FasSkeletonRibs = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSkeletonRibs",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 32c0-17.7-14.3-32-32-32s-32 14.3-32 32v32h-27.8c-33.5 0-65.7 17.6-82.1 48.9C150.5 165.8 96 282.2 96 384v17c0 43.6 35.4 79 79 79 15.1 0 30.1-2.7 44.2-8l67.1-25.2c.6-.2 1.1-.4 1.7-.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32v-33.8c.6.2 1.1.4 1.7.6l67.1 25.2c14.1 5.3 29.1 8 44.2 8 43.6 0 79-35.4 79-79v-17c0-101.8-54.5-218.2-82.2-271.1-16.3-31.3-48.5-48.9-82-48.9H352V32zm-64 96v38.3l-72.7 16.2c7-15.2 13.8-28.7 19.6-40 4.5-8.6 13.9-14.5 25.3-14.5H288zM186 254.6l102-22.7v39.7l-116.8 31.8c4.1-16.5 9.2-32.9 14.7-48.8zm-25.7 118.1L288 337.9v42c-8.2 1.7-16.3 4-24.2 7l-67.1 25.2c-7 2.6-14.3 3.9-21.7 3.9-8.3 0-15-6.7-15-15v-17c0-3.7.1-7.5.3-11.3zm191.7 7.2V339l118.8 35.6c3 .9 6.1 1.3 9.1 1.4.1 2.7.1 5.3.1 8v17c0 8.3-6.7 15-15 15-7.4 0-14.8-1.3-21.7-3.9l-67.1-25.2c-7.9-3-16-5.3-24.2-7zm117.8-72.4L352 272.2v-40.3l102 22.7c6 17.2 11.4 35.1 15.7 53zm-45-125L352 166.3V128h27.8c11.4 0 20.8 5.9 25.3 14.5 5.9 11.3 12.6 24.8 19.6 40zM0 144v336c0 17.7 14.3 32 32 32s32-14.3 32-32V240c0-10.1 4.7-19.6 12.8-25.6l25.6-19.2c16.1-12.1 25.6-31.1 25.6-51.2 0-35.3-28.7-64-64-64S0 108.7 0 144zm576-64c-35.3 0-64 28.7-64 64 0 20.1 9.5 39.1 25.6 51.2l25.6 19.2c8.1 6 12.8 15.5 12.8 25.6v240c0 17.7 14.3 32 32 32s32-14.3 32-32V144c0-35.3-28.7-64-64-64z"
        }
    ]
};

const FasSkeleton = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSkeleton",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 0c17.7 0 32 14.3 32 32v32h128c17.7 0 32 14.3 32 32s-14.3 32-32 32H288v32h192c17.7 0 32 14.3 32 32s-14.3 32-32 32H288v32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32h-96v64c0 .8 0 1.6-.1 2.3l67.6-29c8.3-3.5 17.2-5.4 26.1-5.4 36.7 0 66.4 29.7 66.4 66.4v1.5c0 18-7.2 35.3-19.9 48l-25.8 25.8c-11.7 11.7-27.6 18.3-44.1 18.3H153.9c-16.6 0-32.4-6.6-44.1-18.3l-25.9-25.7c-12.7-12.7-19.9-30-19.9-48v-1.5c0-36.7 29.7-66.4 66.4-66.4 9 0 17.9 1.8 26.1 5.4l67.6 29c-.1-.8-.1-1.5-.1-2.3V320h-96c-17.7 0-32-14.3-32-32s14.3-32 32-32h96v-32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h192v-32H96c-17.7 0-32-14.3-32-32s14.3-32 32-32h128V32c0-17.7 14.3-32 32-32zm-72 440a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm192 0a24 24 0 1 0-48 0 24 24 0 1 0 48 0z"
        }
    ]
};

const FasSkiBootSki = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSkiBootSki",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M390.3.6c17.3 3.5 28.6 20.3 25.1 37.7l-6.4 32-11.6 57.7H336c-8.8 0-16 7.2-16 16s7.2 16 16 16h55l-9.6 48H320c-8.8 0-16 7.2-16 16s7.2 16 16 16h62.2l78.7 34.7c11.6 5.1 19.1 16.6 19.1 29.3v80c0 17.7-14.3 32-32 32H120c-9.6 0-18.7-4.3-24.7-11.7s-8.5-17.2-6.6-26.6l24.7-123.6c2.9-.5 6.1-1.2 9.5-2.1 15.6-3.9 36.4-11.6 58.3-26.9 42.4-29.7 86.4-86.4 104.5-193.1h65.7l1.3-6.3C356.1 8.4 372.9-2.8 390.3.6zM162.8 198.9c-15.8 11-30.8 17.2-42.6 20.7l32.4-161.9c3-15 16.1-25.7 31.4-25.7h69.2c-17.4 96-56.7 143.3-90.4 166.9zM640 416c0 53-43 96-96 96H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h512c17.7 0 32-14.3 32-32s14.3-32 32-32 32 14.3 32 32z"
        }
    ]
};

const FasSkiBoot = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSkiBoot",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M383.4 38c3.3-17.4-8-34.1-25.4-37.5s-34.1 8-37.5 25.4l-1.2 6h-73.6c-22.1 130.8-76 201.3-127.2 238.9-26.2 19.3-51.2 29.5-69.9 35-6.3 1.8-11.8 3.1-16.5 4L.6 474c-1.8 9.4.7 19.1 6.8 26.4S22.5 512 32 512h448c17.7 0 32-14.3 32-32s-14.3-32-32-32v-72c0-12.3-7-23.4-18-28.8L340 288h-68c-8.8 0-16-7.2-16-16s7.2-16 16-16h69.5l12.3-64H288c-8.8 0-16-7.2-16-16s7.2-16 16-16h72l17.3-90 6.2-32zM38.8 275.4l.9-.3c15.6-4.6 37.1-13.3 59.9-30 43-31.6 92.3-92.9 113.7-213.1H112c-15.3 0-28.5 10.9-31.4 26L38.8 275.4z"
        }
    ]
};

const FasSkullCow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSkullCow",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M63.2 21.1c2.5-7.4-.7-15.4-7.5-19.1S40.3 0 35.5 6L28 15.3C9.9 38 0 66.4 0 95.5 0 166.1 57.2 224 128 224v-96h-23c-28.7 0-52.7-21.7-55.6-50.3-.8-7.8.1-15.8 2.6-23.2l11.2-33.4zM240 96c-44.2 0-80 35.8-80 80v112c0 37 25.2 68.2 59.3 77.3l27.6 110.3c5.3 21.4 24.5 36.4 46.6 36.4h53c22 0 41.2-15 46.6-36.4l27.6-110.3C454.8 356.2 480 325 480 288V176c0-44.2-35.8-80-80-80H240zm-16 160a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm160-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM584.4 1.9c-6.8 3.7-10 11.8-7.5 19.1L588 54.5c2.5 7.5 3.4 15.4 2.6 23.2-2.9 28.6-26.9 50.3-55.6 50.3h-23v96c70.8 0 128-57.9 128-128.5 0-29-9.9-57.4-28-80.1L604.5 6c-4.8-6.1-13.3-7.8-20.1-4.1z"
        }
    ]
};

const FasSkullCrossbones = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSkullCrossbones",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M368 128c0 44.4-25.4 83.5-64 106.4V256c0 17.7-14.3 32-32 32h-96c-17.7 0-32-14.3-32-32v-21.6c-38.6-23-64-62.1-64-106.4C80 57.3 144.5 0 224 0s144 57.3 144 128zm-200 48a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm144-32a32 32 0 1 0-64 0 32 32 0 1 0 64 0zM3.4 273.7c7.9-15.8 27.1-22.2 42.9-14.3L224 348.2l177.7-88.8c15.8-7.9 35-1.5 42.9 14.3s1.5 35-14.3 42.9L295.6 384l134.8 67.4c15.8 7.9 22.2 27.1 14.3 42.9s-27.1 22.2-42.9 14.3L224 419.8 46.3 508.6c-15.8 7.9-35 1.5-42.9-14.3s-1.5-35 14.3-42.9L152.4 384 17.7 316.6c-15.8-7.9-22.2-27.1-14.3-42.9z"
        }
    ]
};

const FasSkull = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSkull",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M416 398.9c58.5-41.1 96-104.1 96-174.9C512 100.3 397.4 0 256 0S0 100.3 0 224c0 70.7 37.5 133.8 96 174.9V464c0 26.5 21.5 48 48 48h48v-48c0-8.8 7.2-16 16-16s16 7.2 16 16v48h64v-48c0-8.8 7.2-16 16-16s16 7.2 16 16v48h48c26.5 0 48-21.5 48-48v-65.1zM96 256a64 64 0 1 1 128 0 64 64 0 1 1-128 0zm256-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"
        }
    ]
};

const FasSlashBack = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSlashBack",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M16.1 4.2C.8 13-4.6 32.5 4.2 47.9l256 448c8.8 15.3 28.3 20.7 43.7 11.9s20.7-28.3 11.9-43.7l-256-448C51 .8 31.5-4.6 16.1 4.2z"
        }
    ]
};

const FasSlashForward = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSlashForward",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M303.9 4.2c15.3 8.8 20.7 28.3 11.9 43.7l-256 448c-8.8 15.3-28.3 20.7-43.7 11.9s-20.7-28.3-11.9-43.7l256-448C269 .8 288.5-4.6 303.9 4.2z"
        }
    ]
};

const FasSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1l-592-464C-1.2 34.7-3.1 19.6 5.1 9.2z"
        }
    ]
};

const FasSleigh = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSleigh",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 32C14.3 32 0 46.3 0 64s14.3 32 32 32v160c0 53 43 96 96 96v32h64v-32h192v32h64v-32c53 0 96-43 96-96v-96c17.7 0 32-14.3 32-32s-14.3-32-32-32h-64c-17.7 0-32 14.3-32 32v41.3c0 30.2-24.5 54.7-54.7 54.7-75.5 0-145.6-38.9-185.6-102.9l-4.3-6.9C174.2 67.6 125 37.6 70.7 32.7c-2.2-.5-4.4-.7-6.7-.7H32zm608 352c0-17.7-14.3-32-32-32s-32 14.3-32 32v8c0 13.3-10.7 24-24 24H64c-17.7 0-32 14.3-32 32s14.3 32 32 32h488c48.6 0 88-39.4 88-88v-8z"
        }
    ]
};

const FasSlider = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSlider",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 160v192h-32V160h32zm-32-64c-35.3 0-64 28.7-64 64v192c0 35.3 28.7 64 64 64h32c35.3 0 64-28.7 64-64v-64h64c17.7 0 32-14.3 32-32s-14.3-32-32-32h-64v-64c0-35.3-28.7-64-64-64h-32zM0 256c0 17.7 14.3 32 32 32h192v-64H32c-17.7 0-32 14.3-32 32z"
        }
    ]
};

const FasSlidersSimple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSlidersSimple",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 320a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm90.5 0H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H186.5c-13.2 37.3-48.7 64-90.5 64-53 0-96-43-96-96s43-96 96-96c41.8 0 77.4 26.7 90.5 64zM384 160a32 32 0 1 0 64 0 32 32 0 1 0-64 0zm-58.5-32c13.2-37.3 48.7-64 90.5-64 53 0 96 43 96 96s-43 96-96 96c-41.8 0-77.4-26.7-90.5-64H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h293.5z"
        }
    ]
};

const FasSlidersUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSlidersUp",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 0c17.7 0 32 14.3 32 32v54.7c28.3 12.3 48 40.5 48 73.3s-19.7 61-48 73.3V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V233.3C35.7 221 16 192.8 16 160s19.7-61 48-73.3V32C64 14.3 78.3 0 96 0zm0 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm80-32c0 32.8-19.7 61-48 73.3V480c0 17.7-14.3 32-32 32s-32-14.3-32-32v-54.7c-28.3-12.3-48-40.5-48-73.3s19.7-61 48-73.3V32c0-17.7 14.3-32 32-32s32 14.3 32 32v246.7c28.3 12.3 48 40.5 48 73.3zm112-160a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm0 73.3V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V265.3c-28.3-12.3-48-40.5-48-73.3s19.7-61 48-73.3V32c0-17.7 14.3-32 32-32s32 14.3 32 32v86.7c28.3 12.3 48 40.5 48 73.3s-19.7 61-48 73.3z"
        }
    ]
};

const FasSliders = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSliders",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 416c0 17.7 14.3 32 32 32h54.7c12.3 28.3 40.5 48 73.3 48s61-19.7 73.3-48H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H233.3c-12.3-28.3-40.5-48-73.3-48s-61 19.7-73.3 48H32c-17.7 0-32 14.3-32 32zm128 0a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm192-160a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm32-80c-32.8 0-61 19.7-73.3 48H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h246.7c12.3 28.3 40.5 48 73.3 48s61-19.7 73.3-48H480c17.7 0 32-14.3 32-32s-14.3-32-32-32h-54.7c-12.3-28.3-40.5-48-73.3-48zm-160-48a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm73.3-64C253 35.7 224.8 16 192 16s-61 19.7-73.3 48H32C14.3 64 0 78.3 0 96s14.3 32 32 32h86.7c12.3 28.3 40.5 48 73.3 48s61-19.7 73.3-48H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H265.3z"
        }
    ]
};

const FasSlotMachine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSlotMachine",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 0C92.7 0 64 28.7 64 64h384c0-35.3-28.7-64-64-64H128zM64 96c-35.3 0-64 28.7-64 64v192c0 35.3 28.7 64 64 64v32c0 35.3 28.7 64 64 64h400c53 0 96-43 96-96V211.8c9.8-8.8 16-21.6 16-35.8 0-26.5-21.5-48-48-48s-48 21.5-48 48c0 14.2 6.2 27 16 35.8V416c0 17.7-14.3 32-32 32h-80v-32c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H64zm-8 104c0-13.3 10.7-24 24-24h59.9c23 0 38.5 23.5 29.4 44.6l-43.2 100.9c-5.2 12.2-19.3 17.8-31.5 12.6S76.8 314.8 82 302.6l33.6-78.6H80c-13.3 0-24-10.7-24-24zm168-24h59.9c23 0 38.5 23.5 29.4 44.6l-43.2 100.9c-5.2 12.2-19.3 17.8-31.5 12.6s-17.8-19.3-12.6-31.5l33.6-78.6H224c-13.3 0-24-10.7-24-24s10.7-24 24-24zm120 24c0-13.3 10.7-24 24-24h59.9c23 0 38.5 23.5 29.4 44.6l-43.2 100.9c-5.2 12.2-19.3 17.8-31.5 12.6s-17.8-19.3-12.6-31.5l33.6-78.6H368c-13.3 0-24-10.7-24-24z"
        }
    ]
};

const FasSmog = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSmog",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 144c0 79.5 64.5 144 144 144h123.3c22.6 19.9 52.2 32 84.7 32s62.1-12.1 84.7-32H496c61.9 0 112-50.1 112-112S557.9 64 496 64c-10.7 0-21 1.5-30.8 4.3C443.8 27.7 401.1 0 352 0c-32.6 0-62.4 12.2-85.1 32.3C242.1 12.1 210.5 0 176 0 96.5 0 32 64.5 32 144zm584 224H280c-13.3 0-24 10.7-24 24s10.7 24 24 24h336c13.3 0 24-10.7 24-24s-10.7-24-24-24zm-64 96H440c-13.3 0-24 10.7-24 24s10.7 24 24 24h112c13.3 0 24-10.7 24-24s-10.7-24-24-24zm-192 0H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h336c13.3 0 24-10.7 24-24s-10.7-24-24-24zm-136-72c0-13.3-10.7-24-24-24H96c-13.3 0-24 10.7-24 24s10.7 24 24 24h104c13.3 0 24-10.7 24-24z"
        }
    ]
};

const FasSmoke = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSmoke",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M172.3 194.3c-9.2-1.5-18.7-2.3-28.3-2.3-29.2 0-56.7 7.1-80.9 19.6C43.7 189.2 32 160 32 128 32 57.3 89.3 0 160 0c40.1 0 75.9 18.4 99.3 47.3C277.4 37.5 298 32 320 32c44.3 0 83.4 22.5 106.4 56.8-11.5 7.3-22 16-31.2 25.9-22.5-11.9-48-18.7-75.2-18.7-66.5 0-123.5 40.6-147.7 98.3zm276.3 62.5C419.5 217.5 372.7 192 320 192c-31.5 0-60.9 9.1-85.7 24.9-9.6-5.8-19.8-10.6-30.5-14.5C224 158.5 268.4 128 320 128c31.3 0 60.1 11.3 82.3 30 22.4-37.1 63.1-62 109.7-62 70.7 0 128 57.3 128 128 0 42.2-20.4 79.6-51.9 102.9-25-42.4-71.2-70.9-124.1-70.9-5.2 0-10.3.3-15.4.8zM144 512C64.5 512 0 447.5 0 368s64.5-144 144-144c34.5 0 66.1 12.1 90.9 32.3 22.7-20.1 52.5-32.3 85.1-32.3 49.1 0 91.8 27.7 113.2 68.3 9.8-2.8 20.1-4.3 30.8-4.3 61.9 0 112 50.1 112 112s-50.1 112-112 112H144z"
        }
    ]
};

const FasSmoking = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSmoking",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 32v11c0 38.2 15.2 74.8 42.2 101.8l21 21c21 21 32.8 49.5 32.8 79.2v11c0 17.7-14.3 32-32 32s-32-14.3-32-32v-11c0-12.7-5.1-24.9-14.1-33.9l-21-21c-39-39-60.9-92-60.9-147.1V32c0-17.7 14.3-32 32-32s32 14.3 32 32zm128 224v-11c0-38.2-15.2-74.8-42.2-101.8l-21-21c-21-21-32.8-49.5-32.8-79.2V32c0-17.7 14.3-32 32-32s32 14.3 32 32v11c0 12.7 5.1 24.9 14.1 33.9l21 21c39 39 60.9 91.9 60.9 147.1v11c0 17.7-14.3 32-32 32s-32-14.3-32-32zM0 416c0-35.3 28.7-64 64-64h352c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H64c-35.3 0-64-28.7-64-64v-32zm224 0v32h160v-32H224zm288-64c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32s-32-14.3-32-32v-96c0-17.7 14.3-32 32-32zm96 0c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32s-32-14.3-32-32v-96c0-17.7 14.3-32 32-32z"
        }
    ]
};

const FasSnake = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSnake",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m483.4 65.7-79.8-39.9c-30.8-15.4-68-9.4-92.3 15L288 64H176C96.5 64 32 128.5 32 208s64.5 144 144 144h144c17.7 0 32 14.3 32 32s-14.3 32-32 32H111.6c-10.3 0-20.6 1.7-30.4 4.9l-66 22C6.1 446 0 454.4 0 464s6.1 18 15.2 21.1l66 22c9.8 3.3 20 4.9 30.4 4.9H320c70.7 0 128-57.3 128-128s-57.3-128-128-128H176c-26.5 0-48-21.5-48-48s21.5-48 48-48h112l23.2 23.2c24.3 24.3 61.5 30.4 92.3 15l79.8-39.9c17.5-8.8 28.6-26.7 28.6-46.3s-11.1-37.5-28.6-46.3zM352 80a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm16 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
        }
    ]
};

const FasSnooze = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSnooze",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h32l-57.6 76.8c-7.3 9.7-8.4 22.7-3 33.5S179.9 192 192 192h96c17.7 0 32-14.3 32-32s-14.3-32-32-32h-32l57.6-76.8c7.3-9.7 8.4-22.7 3-33.5S300.1 0 288 0h-96zm128 224c-17.7 0-32 14.3-32 32s14.3 32 32 32h32l-57.6 76.8c-7.3 9.7-8.4 22.7-3 33.5S307.9 416 320 416h96c17.7 0 32-14.3 32-32s-14.3-32-32-32h-32l57.6-76.8c7.3-9.7 8.4-22.7 3-33.5S428.1 224 416 224h-96zM32 256c-17.7 0-32 14.3-32 32s14.3 32 32 32h91.7L7.4 459.5C-.5 469-2.3 482.3 3 493.6S19.6 512 32 512h160c17.7 0 32-14.3 32-32s-14.3-32-32-32h-91.7l116.3-139.5c7.9-9.5 9.7-22.8 4.4-34.1S204.4 256 192 256H32z"
        }
    ]
};

const FasSnowBlowing = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSnowBlowing",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 48h32c53 0 96 43 96 96s-43 96-96 96H416c-17.7 0-32-14.3-32-32s14.3-32 32-32h128c17.7 0 32-14.3 32-32s-14.3-32-32-32h-32c-17.7 0-32-14.3-32-32s14.3-32 32-32zM176 64c13.3 0 24 10.7 24 24v25.4l12.7-12.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L200 158.6v55.8l48.3-27.9 12.9-48.2c2.3-8.5 11.1-13.6 19.6-11.3s13.6 11.1 11.3 19.6l-4.6 17.3 22-12.7c11.5-6.6 26.2-2.7 32.8 8.8s2.7 26.2-8.8 32.8l-22 12.7 17.3 4.6c8.5 2.3 13.6 11.1 11.3 19.6S329 243.3 320.5 241l-48.2-12.9L224 256l48.3 27.9 48.3-12.9c8.5-2.3 17.3 2.8 19.6 11.3s-2.8 17.3-11.3 19.6l-17.3 4.6 22 12.7c11.5 6.6 15.4 21.3 8.8 32.8s-21.3 15.4-32.8 8.8l-22-12.7 4.6 17.3c2.3 8.5-2.8 17.3-11.3 19.6s-17.3-2.8-19.6-11.3l-12.9-48.2-48.4-27.9v55.8l35.3 35.3c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L200 398.6V424c0 13.3-10.7 24-24 24s-24-10.7-24-24v-25.4l-12.7 12.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l35.3-35.3v-55.8l-48.3 27.9-13 48.2c-2.3 8.5-11.1 13.6-19.6 11.3s-13.6-11.1-11.3-19.6l4.6-17.3-22 12.7c-11.4 6.6-26 2.7-32.7-8.8s-2.7-26.2 8.8-32.8l22-12.7-17.3-4.6c-8.5-2.3-13.6-11.1-11.3-19.6S23 268.7 31.5 271l48.2 12.9L128 256l-48.3-27.9L31.4 241c-8.5 2.3-17.3-2.8-19.6-11.3s2.8-17.3 11.3-19.6l17.3-4.6-22-12.7C7 186.2 3.1 171.5 9.7 160s21.3-15.4 32.8-8.8l22 12.7-4.6-17.3c-2.3-8.5 2.8-17.3 11.3-19.6s17.3 2.8 19.6 11.3l12.9 48.2 48.3 27.9v-55.8l-35.3-35.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l12.7 12.7V88c0-13.3 10.7-24 24-24zm304 368c0-17.7 14.3-32 32-32h24c17.7 0 32-14.3 32-32s-14.3-32-32-32H416c-17.7 0-32-14.3-32-32s14.3-32 32-32h120c53 0 96 43 96 96s-43 96-96 96h-24c-17.7 0-32-14.3-32-32z"
        }
    ]
};

const FasSnowflakeDroplets = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSnowflakeDroplets",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 0c17.7 0 32 14.3 32 32v30.1l15-15c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-49 49v70.3l61.4-35.8L431 98.4c3.4-12.8 16.6-20.4 29.4-17s20.4 16.6 17 29.4l-5.2 19.3 23.6-13.8c15.3-8.9 34.9-3.7 43.8 11.5s3.7 34.9-11.5 43.8l-25.3 14.8 21.7 5.8c12.8 3.4 20.4 16.6 17 29.4s-16.6 20.4-29.4 17l-67.7-18.1-60.9 35.5 60.9 35.5 67.7-18.1c12.8-3.4 26 4.2 29.4 17s-4.2 26-17 29.4l-21.7 5.8 21.5 12.6-29.3 57-22.7-13.2 5.2 19.3c3.4 12.8-4.2 26-17 29.4s-26-4.2-29.4-17l-17.7-66.1-61.4-35.9V382l49 49c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-15-15V480c0 17.7-14.3 32-32 32s-32-14.3-32-32v-30.1l-15 15c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l49-49v-70.3l-61.4 35.8-17.7 66.1c-3.4 12.8-16.6 20.4-29.4 17s-20.4-16.6-17-29.4l5.2-19.3-22.9 13.2-29.3-57 21.5-12.6-21.7-5.8c-12.8-3.4-20.4-16.6-17-29.4s16.6-20.4 29.4-17l67.7 18.1 60.9-35.4-60.9-35.5-67.7 18.1c-12.8 3.4-26-4.2-29.4-17s4.2-26 17-29.4l21.7-5.8-25.3-14.8c-15.3-8.9-20.4-28.5-11.5-43.8s28.5-20.4 43.8-11.5l23.6 13.8-5.2-19.3c-3.4-12.8 4.2-26 17-29.4s26 4.2 29.4 17l17.7 66.1 61.3 35.8v-70.4L239 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l15 15V32c0-17.7 14.3-32 32-32zm199.1 418.1 47.5-92.4c1.8-3.5 5.4-5.7 9.3-5.7s7.5 2.2 9.3 5.7l47.5 92.4c4.7 9.1 7.1 19.3 7.1 29.5 0 35.3-28.7 64.3-64 64.3s-64-29-64-64.3c0-10.2 2.4-20.4 7.1-29.5zM54.7 325.7c1.8-3.5 5.4-5.7 9.3-5.7s7.5 2.2 9.3 5.7l47.5 92.4c4.7 9.1 7.1 19.3 7.1 29.5C128 483 99.3 512 64 512S0 483 0 447.7c0-10.2 2.4-20.4 7.1-29.5l47.5-92.4z"
        }
    ]
};

const FasSnowflake = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSnowflake",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 0c17.7 0 32 14.3 32 32v30.1l15-15c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-49 49v70.3l61.4-35.8L335 98.4c3.4-12.8 16.6-20.4 29.4-17s20.4 16.6 17 29.4l-5.2 19.3 23.6-13.8c15.3-8.9 34.9-3.7 43.8 11.5s3.8 34.9-11.5 43.8l-25.3 14.8 21.7 5.8c12.8 3.4 20.4 16.6 17 29.4s-16.6 20.4-29.4 17l-67.7-18.1-60.9 35.5 60.9 35.5 67.7-18.1c12.8-3.4 26 4.2 29.4 17s-4.2 26-17 29.4l-21.7 5.8 25.3 14.8c15.3 8.9 20.4 28.5 11.5 43.8s-28.5 20.4-43.8 11.5l-23.6-13.8 5.2 19.3c3.4 12.8-4.2 26-17 29.4s-26-4.2-29.4-17l-17.7-66.1-61.3-35.8V382l49 49c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-15-15V480c0 17.7-14.3 32-32 32s-32-14.3-32-32v-30.1l-15 15c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l49-49v-70.3l-61.4 35.8-17.7 66.1c-3.4 12.8-16.6 20.4-29.4 17s-20.4-16.6-17-29.4l5.2-19.3-23.8 13.7c-15.3 8.9-34.9 3.7-43.8-11.5s-3.7-34.9 11.5-43.8l25.3-14.8-21.7-5.8c-12.8-3.4-20.4-16.6-17-29.4s16.6-20.4 29.4-17l67.7 18.1 61-35.4-60.9-35.5-67.7 18.1c-12.8 3.4-26-4.2-29.4-17s4.2-26 17-29.4l21.7-5.8-25.3-14.8C.6 162.7-4.5 143.1 4.4 127.9s28.5-20.4 43.8-11.5l23.6 13.8-5.2-19.3c-3.4-12.8 4.2-26 17-29.4s26 4.2 29.4 17l17.7 66.1 61.3 35.7v-70.4L143 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l15 15V32c0-17.7 14.3-32 32-32z"
        }
    ]
};

const FasSnowflakes = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSnowflakes",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 0c17.7 0 32 14.3 32 32v30.1l15-15c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-49 49v70.3l61.4-35.8L335 98.4c3.4-12.8 16.6-20.4 29.4-17s20.4 16.6 17 29.4l-5.2 19.3 23.6-13.8c15.3-8.9 34.9-3.7 43.8 11.5s3.8 34.9-11.5 43.8l-25.3 14.8 21.7 5.8c12.8 3.4 20.4 16.6 17 29.4s-16.6 20.4-29.4 17l-67.7-18.1-60.9 35.5 60.9 35.5 67.7-18.1c12.8-3.4 26 4.2 29.4 17s-4.2 26-17 29.4l-21.7 5.8 25.3 14.8c15.3 8.9 20.4 28.5 11.5 43.8s-28.5 20.4-43.8 11.5l-23.6-13.8 5.2 19.3c3.4 12.8-4.2 26-17 29.4s-26-4.2-29.4-17l-17.7-66.1-61.3-35.8V382l49 49c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-15-15V480c0 17.7-14.3 32-32 32s-32-14.3-32-32v-30.1l-15 15c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l49-49v-70.3l-61.4 35.8-17.7 66.1c-3.4 12.8-16.6 20.4-29.4 17s-20.4-16.6-17-29.4l5.2-19.3-23.8 13.7c-15.3 8.9-34.9 3.7-43.8-11.5s-3.7-34.9 11.5-43.8l25.3-14.8-21.7-5.8c-12.8-3.4-20.4-16.6-17-29.4s16.6-20.4 29.4-17l67.7 18.1 61-35.4-60.9-35.5-67.7 18.1c-12.8 3.4-26-4.2-29.4-17s4.2-26 17-29.4l21.7-5.8-25.3-14.8C.6 162.7-4.5 143.1 4.4 127.9s28.5-20.4 43.8-11.5l23.6 13.8-5.2-19.3c-3.4-12.8 4.2-26 17-29.4s26 4.2 29.4 17l17.7 66.1 61.3 35.7v-70.4L143 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l15 15V32c0-17.7 14.3-32 32-32zm263 7c9.4-9.4 24.6-9.4 33.9 0l23 23L567 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-23 23 23 23c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-23-23-23 23c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l23-23L487 41c-9.4-9.4-9.4-24.6 0-33.9zm32 192c9.4-9.4 24.6-9.4 33.9 0l23 23 23-23c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-23 23 23 23c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-23-23-23 23c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l23-23-23-23c-9.4-9.4-9.4-24.6 0-33.9z"
        }
    ]
};

const FasSnowmanHead = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSnowmanHead",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c0-35.3 28.7-64 64-64h192c35.3 0 64 28.7 64 64v96H64V64zm266.2 128H416c17.7 0 32 14.3 32 32s-14.3 32-32 32h-25.7c16.3 28.2 25.7 61 25.7 96 0 59.8-27.4 113.3-70.3 148.5-9.7 8-22.3 11.5-34.9 11.5H137.2c-12.6 0-25.1-3.5-34.9-11.5C59.4 465.3 32 411.8 32 352c0-35 9.3-67.8 25.7-96H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h298.2zM152 336a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm168-24a24 24 0 1 0-48 0 24 24 0 1 0 48 0zM219.3 445.2c.9 1.7 2.7 2.8 4.7 2.8s3.8-1.1 4.7-2.8l23.8-46.3c2.3-4.5 3.5-9.6 3.5-14.7 0-17.7-14.3-32.2-32-32.2s-32 14.5-32 32.2c0 5.1 1.2 10.2 3.5 14.7l23.8 46.3z"
        }
    ]
};

const FasSnowman = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSnowman",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M341.1 140.6c-2 3.9-1.6 8.6 1.2 12 7 8.5 12.9 18.1 17.2 28.4l48.5-20.8V120c0-13.3 10.7-24 24-24s24 10.7 24 24v19.6l22.5-9.7c12.2-5.2 26.3.4 31.5 12.6s-.4 26.3-12.6 31.5l-56 24-73.6 31.5c-.5 9.5-2.1 18.6-4.8 27.3-1.2 3.8-.1 8 2.8 10.8C396.7 296.9 416 338.2 416 384c0 44.7-18.3 85-47.8 114.1-9.9 9.7-23.7 13.9-37.5 13.9H181.3c-13.9 0-27.7-4.2-37.5-13.9C114.3 469 96 428.7 96 384c0-45.8 19.3-87.1 50.1-116.3 2.9-2.8 4-6.9 2.8-10.8-2.7-8.7-4.3-17.9-4.8-27.3l-73.6-31.5-56-24c-12.1-5.3-17.8-19.4-12.6-31.6s19.3-17.8 31.5-12.6l22.6 9.7V120c0-13.3 10.7-24 24-24s24 10.7 24 24v40.2l48.6 20.8c4.3-10.3 10.1-19.9 17.2-28.4 2.8-3.4 3.3-8.1 1.2-12-7-13.4-11-28.5-11-44.6 0-53 43-96 96-96s96 43 96 96c0 16.1-4 31.2-10.9 44.6zM224 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm48 128a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm-16 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16 48a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm16-256a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm-48 24v3.2c0 3.2.8 6.3 2.3 9l9 16.9c.9 1.7 2.7 2.8 4.7 2.8s3.8-1.1 4.7-2.8l9-16.9c1.5-2.8 2.3-5.9 2.3-9V120c0-8.8-7.2-16-16-16s-16 7.2-16 16z"
        }
    ]
};

const FasSnowplow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSnowplow",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m298.9 64 68.6 160H256l-64-64V64h106.9zm146.2 178.7-87.4-204C347.6 15.3 324.5 0 298.9 0H176c-26.5 0-48 21.5-48 48v112H96c-17.7 0-32 14.3-32 32v106.8C26.2 316.8 0 355.3 0 400c0 61.9 50.1 112 112 112h256c61.9 0 112-50.1 112-112 0-17.2-3.9-33.5-10.8-48H512v50.7c0 17 6.7 33.3 18.7 45.3l54.6 54.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L576 402.7V235.2l57-71.2c11-13.8 8.8-33.9-5-45s-33.9-8.8-45 5l-57 71.2c-9.1 11.3-14 25.4-14 40V288h-64v-31.3c.1-2.4-.2-4.8-.6-7.1s-1.2-4.7-2.2-6.8zM368 352c26.5 0 48 21.5 48 48s-21.5 48-48 48H112c-26.5 0-48-21.5-48-48s21.5-48 48-48h256zm-224 48a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm216 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-56-24a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm-104 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FasSoap = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSoap",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M208 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm112 160a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm96-224a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm0 160c0 27.6-11.7 52.5-30.4 70.1 36.5 13.6 62.4 48.7 62.4 89.9 0 53-43 96-96 96H160c-53 0-96-43-96-96s43-96 96-96h88.4c-15.2-17-24.4-39.4-24.4-64H96c-53 0-96 43-96 96v128c0 53 43 96 96 96h320c53 0 96-43 96-96V288c0-53-43-96-96-96zm-256 96c-35.3 0-64 28.7-64 64s28.7 64 64 64h192c35.3 0 64-28.7 64-64s-28.7-64-64-64H160z"
        }
    ]
};

const FasSocks = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSocks",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M175.2 476.6c-9.7-18-15.2-38.7-15.2-60.6 0-40.3 19-78.2 51.2-102.4l64-48c8.1-6 12.8-15.5 12.8-25.6V96H128v144c0 20.1-9.5 39.1-25.6 51.2l-64 48C14.2 357.3 0 385.8 0 416c0 53 43 96 96 96 20.8 0 41-6.7 57.6-19.2l21.6-16.2zM128 64h160V48c0-14.5 3.9-28.2 10.7-39.9C291 3 281.9 0 272 0h-96c-26.5 0-48 21.5-48 48v16zm192 32v144c0 20.1-9.5 39.1-25.6 51.2l-64 48C206.2 357.3 192 385.8 192 416c0 53 43 96 96 96 20.8 0 41-6.7 57.6-19.2l115.2-86.4C493 382.2 512 344.3 512 304V96H320zm192-32V48c0-26.5-21.5-48-48-48h-96c-26.5 0-48 21.5-48 48v16h192z"
        }
    ]
};

const FasSoftServe = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSoftServe",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M208 0c-6.5 0-12.3 3.9-14.8 9.9s-1.1 12.9 3.5 17.4l6.1 6.1c3.4 3.4 5.3 7.9 5.3 12.7C208 56 200 64 190.1 64H128c-35.3 0-64 28.7-64 64 0 11.8 3.2 22.9 8.8 32.4C40.8 164 16 191.1 16 224c0 35.3 28.7 64 64 64h224c35.3 0 64-28.7 64-64s-28.7-64-64-64h-2.3c11.5-14.4 18.3-32.7 18.3-52.6C320 48.1 271.9 0 212.6 0H208zM48 320v32c0 17.7 14.3 32 32 32h1.8l11.1 99.5c1.8 16.2 15.5 28.5 31.8 28.5h134.7c16.3 0 30-12.3 31.8-28.5l11-99.5h1.8c17.7 0 32-14.3 32-32v-32H48z"
        }
    ]
};

const FasSolarPanel = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSolarPanel",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M122.2 0C91.7 0 65.5 21.5 59.5 51.4l-51.2 256C.4 347 30.6 384 71 384h217v64h-64c-17.7 0-32 14.3-32 32s14.3 32 32 32h192c17.7 0 32-14.3 32-32s-14.3-32-32-32h-64v-64h217c40.4 0 70.7-36.9 62.8-76.6l-51.2-256C574.5 21.5 548.3 0 517.8 0H122.2zm138.7 64h118.2l10.4 104h-139l10.4-104zm-58.6 104H101.4l20.8-104h90.4l-10.3 104zM91.8 216h105.7l-10.4 104H71l20.8-104zm153.9 0h148.6l10.4 104H235.3l10.4-104zm196.8 0h105.7L569 320H453l-10.5-104zm96-48H437.7L427.3 64h90.4l31.4-6.3-31.3 6.3 20.8 104z"
        }
    ]
};

const FasSolarSystem = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSolarSystem",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 256c0 41.9-13.4 80.6-36.2 112.2-24.5 2.1-43.8 22.7-43.8 47.8 0 26.5 21.5 48 48 48s48-21.5 48-48c0-3.2-.3-6.4-.9-9.4C493.8 364.3 512 312.3 512 256 512 114.6 397.4 0 256 0c-42.3 0-82.1 10.2-117.2 28.4 18.6 11.8 32 31.1 36 53.6C199.4 70.4 227 64 256 64c106 0 192 86 192 192zM256 448c-106 0-192-86-192-192 0-41.9 13.4-80.6 36.2-112.2 24.5-2.1 43.8-22.7 43.8-47.8 0-26.5-21.5-48-48-48S48 69.5 48 96c0 3.2.3 6.4.9 9.4C18.2 147.7 0 199.7 0 256c0 141.4 114.6 256 256 256 42.1 0 81.7-10.1 116.8-28.1-18.5-11.9-31.8-31.3-35.6-53.8C312.5 441.6 285 448 256 448zm133.2-265.3c1.8-4.6 2.8-9.5 2.8-14.7 0-22.1-17.9-40-40-40-4 0-7.8.6-11.5 1.7-24.1-16.2-53.2-25.7-84.5-25.7-83.9 0-152 68.1-152 152s68.1 152 152 152 152-68.1 152-152c0-26.6-6.8-51.5-18.8-73.3zM312 168.4c.2 20.6 16 37.6 36.2 39.5 7.5 14.4 11.8 30.8 11.8 48.2 0 57.4-46.6 104-104 104s-104-46.6-104-104 46.6-104 104-104c20.6 0 39.8 6 56 16.4zm8 87.6a64 64 0 1 0-128 0 64 64 0 1 0 128 0z"
        }
    ]
};

const FasSortDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSortDown",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M182.6 470.6c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-9.2-9.2-11.9-22.9-6.9-34.9S19 287.9 32 287.9h256c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-128 128z"
        }
    ]
};

const FasSortUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSortUp",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M182.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-9.2 9.2-11.9 22.9-6.9 34.9S19 224.1 32 224.1h256c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-128-128z"
        }
    ]
};

const FasSort = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSort",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M137.4 41.4c12.5-12.5 32.8-12.5 45.3 0l128 128c9.2 9.2 11.9 22.9 6.9 34.9S301 224.1 288 224.1H32c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9l128-128zm0 429.3-128-128c-9.2-9.2-11.9-22.9-6.9-34.9S19.1 288 32.1 288H288c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-128 128c-12.5 12.5-32.8 12.5-45.3 0z"
        }
    ]
};

const FasSpa = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSpa",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M183.1 235.3c33.7 20.7 62.9 48.1 85.8 80.5 7 9.9 13.4 20.3 19.1 31 5.7-10.8 12.1-21.1 19.1-31 22.9-32.4 52.1-59.8 85.8-80.5C437.6 207.8 490.1 192 546 192h9.9c11.1 0 20.1 9 20.1 20.1 0 148-119.9 267.9-267.9 267.9h-40.2C119.9 480 0 360.1 0 212.1 0 201 9 192 20.1 192H30c55.9 0 108.4 15.8 153.1 43.3zM301.5 37.6c15.7 16.9 61.1 71.8 84.4 164.6-38 21.6-71.4 50.8-97.9 85.6-26.5-34.8-59.9-63.9-97.9-85.6 23.2-92.8 68.6-147.7 84.4-164.6 3.5-3.7 8.4-5.6 13.5-5.6s10 1.9 13.5 5.6z"
        }
    ]
};

const FasSpaceStationMoonConstruction = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSpaceStationMoonConstruction",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 256c0 7.8-.3 15.5-1 23.1-72.2 25.6-159.8 40.9-255 40.9S73.2 304.7 1 279.1c-.7-7.6-1-15.3-1-23.1C0 114.6 114.6 0 256 0c57.8 0 111.1 19.1 153.9 51.4 3.9 2.9 6.1 7.5 6.1 12.4V80c0 8.8-7.2 16-16 16h-32c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h64c8.8 0 16 7.2 16 16v32c0 8.8 7.2 16 16 16h31.9c8.1 0 14.9 6 15.5 14.1.4 5.9.6 11.9.6 17.9zM256 512C134.9 512 33.4 427.9 6.8 314.8 79.4 338.4 164.7 352 256 352c44.3 0 87.3-3.2 128-9.2V368c0 8.8 7.2 16 16 16h32c8.8 0 16 7.2 16 16v19.3c0 3.9-1.4 7.7-4.1 10.5C397.2 480.4 330.3 512 256 512zm-96-352a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm112 0a80 80 0 1 0-160 0 80 80 0 1 0 160 0z"
        }
    ]
};

const FasSpaceStationMoon = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSpaceStationMoon",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 256c0 7.8-.3 15.5-1 23.1-72.2 25.6-159.8 40.9-255 40.9S73.2 304.7 1 279.1c-.7-7.6-1-15.3-1-23.1C0 114.6 114.6 0 256 0s256 114.6 256 256zM256 512C134.9 512 33.4 427.9 6.8 314.8 79.4 338.4 164.7 352 256 352s176.6-13.6 249.2-37.2C478.6 427.9 377.1 512 256 512zm-96-352a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm112 0a80 80 0 1 0-160 0 80 80 0 1 0 160 0z"
        }
    ]
};

const FasSpade = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSpade",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M278 12.5C265.7.8 246.3.8 234 12.5l-66 62.6L40 196.3c-51.3 48.6-53.5 129.6-4.9 181s129.6 53.5 181 4.9l8-7.6V448H192c-17.7 0-32 14.3-32 32s14.3 32 32 32h128c17.7 0 32-14.3 32-32s-14.3-32-32-32h-32v-73.4l8 7.6c51.3 48.6 132.3 46.4 181-4.9s46.4-132.3-4.9-181L344 75.1l-66-62.6z"
        }
    ]
};

const FasSpaghettiMonsterFlying = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSpaghettiMonsterFlying",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M208 64a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm48 0c0 16.2-6 31.1-16 42.3l15.6 31.2c18.7-6 39.9-9.5 64.4-9.5s45.8 3.5 64.4 9.5l15.6-31.2c-10-11.2-16-26.1-16-42.3 0-35.3 28.7-64 64-64s64 28.7 64 64-28.7 64-64 64c-1.7 0-3.4-.1-5.1-.2L427.8 158c21.1 13.6 37.7 30.2 51.4 46.4 7.1 8.3 13.5 16.6 19.3 24l1.4 1.8c6.3 8.1 11.6 14.8 16.7 20.4 10.7 11.7 16.1 13.4 19.4 13.4 2.5 0 4.3-.6 7.1-3.3 3.7-3.5 7.1-8.8 12.5-17.4l.6-.9c4.6-7.4 11-17.6 19.4-25.7 9.7-9.3 22.9-16.7 40.4-16.7 13.3 0 24 10.7 24 24s-10.7 24-24 24c-2.5 0-4.3.6-7.1 3.3-3.7 3.5-7.1 8.8-12.5 17.4l-.6.9c-4.6 7.4-11 17.6-19.4 25.7-9.7 9.3-22.9 16.7-40.4 16.7-18.5 0-32.9-8.5-44.3-18.6-3.1 4-6.6 8.3-10.5 12.7 1.4 4.3 2.8 8.5 4 12.5.9 3 1.8 5.8 2.6 8.6 3 9.8 5.5 18.2 8.6 25.9 3.9 9.8 7.4 15.4 10.8 18.5 2.6 2.4 5.9 4.3 12.8 4.3 8.7 0 16.9-4.2 33.7-13.2 15-8 35.7-18.8 62.3-18.8 13.3 0 24 10.7 24 24s-10.7 24-24 24c-13.4 0-24.7 5.2-39.7 13.2-1 .6-2.1 1.1-3.2 1.7C559.9 414 541.4 424 520 424c-18.4 0-33.6-6.1-45.5-17.2-11.1-10.3-17.9-23.7-22.7-36-3.6-9-6.7-19.1-9.5-28.5-16.4 12.3-36.1 23.6-58.9 31.3 3.6 10.8 8.4 23.5 14.4 36.2 7.5 15.9 16.2 30.4 25.8 40.5C433 460.5 441.2 464 448 464c13.3 0 24 10.7 24 24s-10.7 24-24 24c-25.2 0-45-13.5-59.5-28.8-14.5-15.4-25.7-34.9-34.2-53-8-17-14.1-33.8-18.3-46.9-5.2.4-10.6.6-16 .6s-10.8-.2-16-.6c-4.2 13-10.3 29.9-18.3 46.9-8.5 18.1-19.8 37.6-34.2 53C237 498.5 217.2 512 192 512c-13.3 0-24-10.7-24-24s10.7-24 24-24c6.8 0 15-3.5 24.5-13.7 9.5-10.1 18.3-24.6 25.8-40.5 5.9-12.6 10.7-25.4 14.4-36.2-22.8-7.7-42.5-19-58.9-31.3-2.9 9.4-6 19.5-9.5 28.5-4.8 12.2-11.6 25.6-22.7 36-12 11.1-27.2 17.2-45.6 17.2-21.4 0-39.9-10-53.1-17.1-1.1-.6-2.2-1.2-3.2-1.7-15-8-26.3-13.2-39.7-13.2-13.3 0-24-10.7-24-24s10.7-24 24-24c26.6 0 47.3 10.8 62.3 18.8 16.8 9 25 13.2 33.7 13.2 6.8 0 10.2-1.9 12.8-4.3 3.4-3.2 7-8.8 10.8-18.5 3-7.7 5.6-16.1 8.6-25.9.8-2.7 1.7-5.6 2.6-8.6 1.2-4 2.6-8.2 4-12.5-3.9-4.5-7.4-8.8-10.5-12.7-11.4 10-25.8 18.5-44.3 18.5-17.5 0-30.7-7.4-40.4-16.7-8.4-8.1-14.8-18.3-19.4-25.7l-.6-.9c-5.4-8.6-8.8-13.9-12.5-17.4-2.8-2.7-4.6-3.3-7.1-3.3-13.3 0-24-10.7-24-24s10.7-24 24-24c17.5 0 30.7 7.4 40.4 16.7 8.4 8.1 14.8 18.3 19.4 25.7l.6.9c5.4 8.6 8.8 13.9 12.5 17.4 2.8 2.7 4.6 3.3 7.1 3.3 3.3 0 8.7-1.7 19.4-13.4 5.1-5.6 10.4-12.3 16.7-20.4l1.4-1.8c5.8-7.4 12.2-15.7 19.3-24 13.8-16.2 30.3-32.8 51.4-46.4l-15.1-30.2c-1.7.1-3.4.2-5.1.2-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64zm208 0a16 16 0 1 0-32 0 16 16 0 1 0 32 0z"
        }
    ]
};

const FasSparkle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSparkle",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M245.8 45.9C241.9 37.4 233.4 32 224 32s-17.9 5.4-21.8 13.9l-59.5 128.8-128.8 59.5C5.4 238.1 0 246.6 0 256s5.4 17.9 13.9 21.8l128.8 59.5 59.5 128.8c3.9 8.5 12.4 13.9 21.8 13.9s17.9-5.4 21.8-13.9l59.5-128.8 128.8-59.5c8.5-3.9 13.9-12.4 13.9-21.8s-5.4-17.9-13.9-21.8l-128.8-59.5-59.5-128.8z"
        }
    ]
};

const FasSparkles = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSparkles",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M327.5 85.2c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L384 128l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L448 128l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L448 64 426.8 7.5C425.1 3 420.8 0 416 0s-9.1 3-10.8 7.5L384 64l-56.5 21.2zM205.1 73.3c-2.6-5.7-8.3-9.3-14.5-9.3s-11.9 3.6-14.5 9.3l-52.8 114L9.3 240c-5.7 2.6-9.3 8.3-9.3 14.6s3.6 11.9 9.3 14.5l114.1 52.7 52.6 114c2.6 5.7 8.3 9.3 14.5 9.3s11.9-3.6 14.5-9.3l52.7-114.1L371.8 269c5.7-2.6 9.3-8.3 9.3-14.5s-3.6-11.9-9.3-14.5l-114-52.6-52.7-114.1zM384 384l-56.5 21.2c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L384 448l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L448 448l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L448 384l-21.2-56.5c-1.7-4.5-6-7.5-10.8-7.5s-9.1 3-10.8 7.5L384 384z"
        }
    ]
};

const FasSpeaker = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSpeaker",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 64C0 28.7 28.7 0 64 0h256c35.3 0 64 28.7 64 64v384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm304 272a112 112 0 1 0-224 0 112 112 0 1 0 224 0zm-112-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm0-112a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
        }
    ]
};

const FasSpeakers = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSpeakers",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 0h216.4C265.2 17 256 39.4 256 64v193.6c-20.3-20.7-48.7-33.6-80-33.6-61.9 0-112 50.1-112 112s50.1 112 112 112c31.3 0 59.7-12.9 80-33.6V448c0 24.6 9.2 47 24.4 64H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0zm256 503.4c-19.1-11.1-32-31.7-32-55.4V64c0-23.7 12.9-44.4 32-55.4 9.4-5.5 20.3-8.6 32-8.6h224c35.3 0 64 28.7 64 64v384c0 35.3-28.7 64-64 64H352c-11.7 0-22.6-3.1-32-8.6zM352 336a112 112 0 1 0 224 0 112 112 0 1 0-224 0zm-176-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm0-112a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm224 176a64 64 0 1 1 128 0 64 64 0 1 1-128 0zm112-224a48 48 0 1 0-96 0 48 48 0 1 0 96 0z"
        }
    ]
};

const FasSpellCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSpellCheck",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M112 0C99.1 0 87.4 7.8 82.5 19.7l-66.7 160-13.3 32c-6.8 16.3.9 35 17.2 41.8s35-.9 41.8-17.2l5.2-12.3h90.7l5.1 12.3c6.8 16.3 25.5 24 41.8 17.2s24-25.5 17.2-41.8l-13.3-32-66.7-160C136.6 7.8 124.9 0 112 0zm18.7 160H93.3l18.7-44.8 18.7 44.8zM256 32v192c0 17.7 14.3 32 32 32h80c44.2 0 80-35.8 80-80 0-23.1-9.8-43.8-25.4-58.4 6-11.2 9.4-24 9.4-37.6 0-44.2-35.8-80-80-80h-64c-17.7 0-32 14.3-32 32zm96 64h-32V64h32c8.8 0 16 7.2 16 16s-7.2 16-16 16zm-32 64h48c8.8 0 16 7.2 16 16s-7.2 16-16 16h-48v-32zm246.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L352 434.7l-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0l192-192z"
        }
    ]
};

const FasSpiderBlackWidow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSpiderBlackWidow",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144.6 1.6c12.4 4.8 18.5 18.6 13.8 31l-32.5 84.6c-1.1 3-.4 6.3 1.8 8.5l48.3 48.4V160c0-31.8 18.6-59.3 45.5-72.2 9.1-4.4 18.5 3.3 18.5 13.4V112c0 8.8 7.2 16 16 16s16-7.2 16-16v-10.8c0-10.1 9.4-17.7 18.5-13.4 26.9 12.9 45.5 40.4 45.5 72.2v14.1l48.3-48.3c2.2-2.2 2.9-5.6 1.8-8.5l-32.5-84.7c-4.8-12.4 1.4-26.3 13.8-31s26.3 1.4 31 13.8l32.5 84.6c7.9 20.7 3 44.1-12.7 59.7l-57.4 57.4 80.4-26.8c2.4-.8 4.3-2.7 5.1-5.1l18.9-56.8c4.2-12.6 17.8-19.4 30.4-15.2s19.4 17.8 15.2 30.4l-18.9 56.8c-5.6 16.7-18.7 29.8-35.4 35.4L395.9 256l60.5 20.2c16.7 5.6 29.8 18.7 35.4 35.4l18.9 56.8c4.2 12.6-2.6 26.2-15.2 30.4s-26.2-2.6-30.4-15.2l-18.9-56.8c-.8-2.4-2.7-4.3-5.1-5.1l-80.4-26.8 57.4 57.4c15.6 15.6 20.6 39 12.7 59.7l-32.5 84.6c-4.8 12.4-18.6 18.5-31 13.8s-18.5-18.6-13.8-31l32.5-84.6c1.1-3 .4-6.3-1.8-8.5L352 353.9c-1 52.1-43.6 94.1-96 94.1s-95-41.9-96-94.1l-32.3 32.3c-2.2 2.2-2.9 5.6-1.8 8.5l32.5 84.6c4.8 12.4-1.4 26.3-13.8 31s-26.3-1.4-31-13.8L81.1 412c-7.9-20.7-3-44.1 12.7-59.7l57.4-57.4-80.4 26.8c-2.4.8-4.3 2.7-5.1 5.1l-18.9 56.8C42.6 396.2 29 403 16.4 398.8S-3 381 1.2 368.4l18.9-56.8c5.6-16.7 18.7-29.8 35.4-35.4l60.6-20.2-60.5-20.2c-16.7-5.6-29.8-18.7-35.4-35.4l-19-56.8C-3 131 3.8 117.4 16.4 113.2s26.2 2.6 30.4 15.2l18.9 56.8c.8 2.4 2.7 4.3 5.1 5.1l80.4 26.8-57.5-57.4C78.1 144 73.1 120.6 81.1 100l32.5-84.6c4.8-12.4 18.6-18.5 31-13.8zm73.8 305.6L240 336l-21.6 28.8c-1.6 2.1-2.4 4.6-2.4 7.2 0 6.6 5.4 12 12 12h56c6.6 0 12-5.4 12-12 0-2.6-.8-5.1-2.4-7.2L272 336l21.6-28.8c1.6-2.1 2.4-4.6 2.4-7.2 0-6.6-5.4-12-12-12h-56c-6.6 0-12 5.4-12 12 0 2.6.8 5.1 2.4 7.2z"
        }
    ]
};

const FasSpiderWeb = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSpiderWeb",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M133.8 22.2c4.8-12.7 18-20.2 31.4-17.7l69 12.9c35.6 6.7 72.1 6.7 107.6 0l69-12.9c13.4-2.5 26.6 5 31.4 17.7l28.9 77.2c11.5 30.7 28.1 59.2 49.1 84.4l45.3 54.3c8.7 10.4 8.7 25.5 0 35.9l-45.3 54.3c-21 25.2-37.6 53.7-49.1 84.4l-28.9 77.2c-4.8 12.7-18 20.2-31.4 17.7l-69-12.9c-35.6-6.7-72.1-6.7-107.6 0l-69 12.9c-13.4 2.5-26.6-5-31.4-17.7l-28.9-77.2c-11.6-30.7-28.2-59.3-49.2-84.5l-45.2-54.3c-8.7-10.4-8.7-25.5 0-35.9l45.3-54.3c21-25.2 37.6-53.7 49.1-84.4l28.9-77.2zm33.3 70.6-9.8 26.2c-13.7 36.6-33.5 70.6-58.5 100.6L88.4 232H133c23.5-27.6 41.7-59.2 53.7-93.4l2.5-7-22.1-38.8zm42.1-23.1 21.4 37.4c37.7 9.5 77.2 9.5 114.9 0l21.4-37.4-14.7 2.8c-42.4 7.9-85.9 7.9-128.3 0l-14.7-2.8zm199.7 23.1-22.2 38.8 2.5 7c12.1 34.2 30.3 65.8 53.8 93.4h44.6l-10.3-12.4c-25-30-44.8-64-58.5-100.6L409 92.8zM487.6 280H443c-23.6 28.1-41.8 60.4-53.6 95.3l-2.1 6.1 21.6 37.9 9.8-26.2c13.7-36.6 33.5-70.6 58.5-100.6l10.4-12.5zM366.8 442.3l-19.5-34.2c-37.9-11.7-78.3-12.8-116.7-3.2l-21.3 37.4 14.7-2.8c42.4-7.9 85.9-7.9 128.3 0l14.7 2.8zm-199.7-23.1 22.2-38.8-2.5-7a298.12 298.12 0 0 0-53.7-93.4H88.4l10.3 12.4c25 30 44.8 64 58.5 100.6l9.8 26.2zM193.2 280c10.1 15 18.9 30.7 26.5 47.1l26.9-47.1h-53.4zm67.9 71.4c18.1-1.5 36.3-1.2 54.3 1l-27.4-48-26.9 47zm95.5-23.7c7.6-16.6 16.4-32.5 26.5-47.7h-53.7l27.3 47.7zm26.2-95.7c-10.1-15-18.9-30.7-26.5-47.1L329.4 232h53.4zm-68.1-71c-17.7 1.7-35.6 1.7-53.3 0l26.6 46.6 26.7-46.6zm-94.9 23.9c-7.6 16.4-16.5 32.1-26.5 47.1h53.4l-26.9-47.1z"
        }
    ]
};

const FasSpider = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSpider",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M158.4 32.6c4.8-12.4-1.4-26.3-13.8-31s-26.3 1.4-31 13.8L81.1 100c-7.9 20.7-3 44.1 12.7 59.7l57.4 57.4-80.4-26.8c-2.4-.8-4.3-2.7-5.1-5.1l-18.9-56.8C42.6 115.8 29 109 16.4 113.2S-3 131 1.2 143.6l18.9 56.8c5.6 16.7 18.7 29.8 35.4 35.4l60.6 20.2-60.5 20.2c-16.7 5.6-29.8 18.7-35.4 35.4l-19 56.8C-3 381 3.8 394.6 16.4 398.8s26.2-2.6 30.4-15.2l18.9-56.8c.8-2.4 2.7-4.3 5.1-5.1l80.4-26.8-57.5 57.4C78.1 368 73.1 391.4 81.1 412l32.5 84.6c4.8 12.4 18.6 18.5 31 13.8s18.5-18.6 13.8-31l-32.5-84.6c-1.1-3-.4-6.3 1.8-8.5l32.3-32.4c1 52.1 43.6 94.1 96 94.1s95-41.9 96-94.1l32.3 32.3c2.2 2.2 2.9 5.6 1.8 8.5l-32.5 84.6c-4.8 12.4 1.4 26.3 13.8 31s26.3-1.4 31-13.8l32.5-84.5c7.9-20.7 3-44.1-12.7-59.7l-57.4-57.4 80.4 26.8c2.4.8 4.3 2.7 5.1 5.1l18.9 56.8c4.2 12.6 17.8 19.4 30.4 15.2s19.4-17.8 15.2-30.4l-18.9-56.8c-5.6-16.7-18.7-29.8-35.4-35.4L395.9 256l60.5-20.2c16.7-5.6 29.8-18.7 35.4-35.4l18.9-56.8c4.2-12.6-2.6-26.2-15.2-30.4s-26.2 2.6-30.4 15.2l-18.9 56.8c-.8 2.4-2.7 4.3-5.1 5.1l-80.4 26.8 57.4-57.4c15.6-15.6 20.6-39 12.7-59.7l-32.4-84.6c-4.8-12.4-18.6-18.6-31-13.8s-18.5 18.6-13.8 31l32.5 84.6c1.1 3 .4 6.3-1.8 8.5L336 174.1V160c0-31.8-18.6-59.3-45.5-72.2-9.1-4.4-18.5 3.3-18.5 13.4V112c0 8.8-7.2 16-16 16s-16-7.2-16-16v-10.8c0-10.1-9.4-17.7-18.5-13.4-26.9 12.9-45.5 40.4-45.5 72.2v14.1l-48.3-48.3c-2.2-2.2-2.9-5.6-1.8-8.5l32.5-84.6z"
        }
    ]
};

const FasSpinnerThird = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSpinnerThird",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 32c0-17.7 14.3-32 32-32 141.4 0 256 114.6 256 256 0 46.6-12.5 90.4-34.3 128-8.8 15.3-28.4 20.5-43.7 11.7s-20.5-28.4-11.7-43.7c16.3-28.2 25.7-61 25.7-96 0-106-86-192-192-192-17.7 0-32-14.3-32-32z"
        }
    ]
};

const FasSpinner = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSpinner",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M304 48a48 48 0 1 0-96 0 48 48 0 1 0 96 0zm0 416a48 48 0 1 0-96 0 48 48 0 1 0 96 0zM48 304a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm464-48a48 48 0 1 0-96 0 48 48 0 1 0 96 0zM142.9 437A48 48 0 1 0 75 369.1a48 48 0 1 0 67.9 67.9zm0-294.2A48 48 0 1 0 75 75a48 48 0 1 0 67.9 67.9zM369.1 437a48 48 0 1 0 67.9-67.9 48 48 0 1 0-67.9 67.9z"
        }
    ]
};

const FasSplit = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSplit",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M403.8 34.4c12-5 25.7-2.2 34.9 6.9l64 64c6 6 9.4 14.1 9.4 22.6s-3.4 16.6-9.4 22.6l-64 64c-9.2 9.2-22.9 11.9-34.9 6.9S384 204.8 384 191.8V160h-37.5c-8.5 0-16.6 3.4-22.6 9.4L237.3 256l86.6 86.6c6 6 14.1 9.4 22.6 9.4H384v-32c0-12.9 7.8-24.6 19.8-29.6s25.7-2.2 34.9 6.9l64 64c6 6 9.4 14.1 9.4 22.6s-3.4 16.6-9.4 22.6l-64 64c-9.2 9.2-22.9 11.9-34.9 6.9S384 460.8 384 447.8V416h-37.5c-25.5 0-49.9-10.1-67.9-28.1L178.7 288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h146.7l99.9-99.9c18-18 42.4-28.1 67.9-28.1H384V64c0-12.9 7.8-24.6 19.8-29.6z"
        }
    ]
};

const FasSplotch = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSplotch",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m208.5 62.3 28.1-36.9C248.8 9.4 267.8 0 288 0c28.5 0 53.6 18.7 61.8 46l17.8 59.4c10.3 34.4 36.1 62 69.8 74.6l39.8 14.9c20.9 7.9 34.8 27.9 34.8 50.2 0 16.9-7.9 32.8-21.5 42.9l-67.3 50.5c-24.3 18.2-37.2 47.9-33.8 78.1l2.5 22.7c4.3 38.7-26 72.6-65 72.6-14.8 0-29.3-5.1-40.8-14.3l-55.4-44.3c-4.5-3.6-9.3-6.7-14.5-9.2-15.8-7.9-33.7-10.4-51-7.3l-82.8 15.1C47.8 458.2 16 431.6 16 396.5c0-13.2 4.7-26 13.1-36.2l11.2-13.4c14.6-17.4 22.6-39.4 22.6-62.1 0-18.8-5.5-37.2-15.8-53L8.8 173.5C3.1 164.7 0 154.4 0 143.9c0-33.4 30.1-58.8 63-53.2l51.3 8.7c35.9 6.1 72.2-8.2 94.2-37.1z"
        }
    ]
};

const FasSpoon = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSpoon",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M245.8 220.9c-14.5-17.6-21.8-39.2-21.8-60.8C224 80 320 0 416 0c53 0 96 43 96 96 0 96-80 192-160.2 192-21.6 0-43.2-7.3-60.8-21.8L54.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l236.5-236.4z"
        }
    ]
};

const FasSportsball = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSportsball",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m487.6 48.9-.3-1.5-122 121.9c34.8 30.2 79 49.8 127.6 53.9 9.3-63 4.7-125.5-5.4-174.3zm-22.8-24.3c-1.1-.3-2.2-.5-3.3-.7-65.6-11-122.9-12.5-172.8-6 3.9 49.1 23.6 93.7 54 128.8L464.8 24.6zM446 358.4c19.8-32.3 33-67.7 41.1-103.6C432 249.5 382 226.7 342.7 192l-64 64 139.8 139.9c10.3-11.8 19.4-24.4 27.4-37.5zm-126-189c-35-39.7-57.9-90.3-63-146.1-17 3.6-33 8.3-48.1 13.9-37 13.7-67.8 33-93.1 56L256 233.4l64-64zM233.4 256l-140-139.9c-10.2 11.8-19.3 24.4-27.4 37.5-19.8 32.3-33 67.7-41.1 103.6C80 262.5 130 285.3 169.3 320l64-64zM192 342.6c35 39.7 58 90.3 63 146.1 17-3.6 33-8.3 48.1-13.9 37-13.7 67.8-33 93.1-56L256 278.6l-64 64zm-45.3.1c-34.8-30.2-79-49.8-127.6-53.9-9.3 63-4.7 125.5 5.4 174.3l.3 1.5 121.9-121.9zm22.6 22.6L47.2 487.4c1.1.3 2.2.5 3.3.7 65.6 11 122.9 12.5 172.8 6-3.9-49.1-23.6-93.7-54-128.8z"
        }
    ]
};

const FasSprayCanSparkles = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSprayCanSparkles",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 32v96h128V32c0-17.7-14.3-32-32-32h-64c-17.7 0-32 14.3-32 32zm0 128c-53 0-96 43-96 96v208c0 26.5 21.5 48 48 48h224c26.5 0 48-21.5 48-48V256c0-53-43-96-96-96H96zm64 96a80 80 0 1 1 0 160 80 80 0 1 1 0-160zM384 48c0-1.4-1-3-2.2-3.6L352 32 339.6 2.2C339 1 337.4 0 336 0s-3 1-3.6 2.2L320 32l-29.8 12.4c-1.2.6-2.2 2.2-2.2 3.6s1 3 2.2 3.6L320 64l12.4 29.8c.6 1.2 2.2 2.2 3.6 2.2s3-1 3.6-2.2L352 64l29.8-12.4c1.2-.6 2.2-2.2 2.2-3.6zm76.4 45.8c.6 1.2 2.2 2.2 3.6 2.2s3-1 3.6-2.2L480 64l29.8-12.4c1.2-.6 2.2-2.2 2.2-3.6s-1-3-2.2-3.6L480 32 467.6 2.2C467 1 465.4 0 464 0s-3 1-3.6 2.2L448 32l-29.8 12.4c-1.2.6-2.2 2.2-2.2 3.6s1 3 2.2 3.6L448 64l12.4 29.8zm7.2 100.4c-.6-1.2-2.2-2.2-3.6-2.2s-3 1-3.6 2.2L448 224l-29.8 12.4c-1.2.6-2.2 2.2-2.2 3.6s1 3 2.2 3.6L448 256l12.4 29.8c.6 1.2 2.2 2.2 3.6 2.2s3-1 3.6-2.2L480 256l29.8-12.4c1.2-.6 2.2-2.2 2.2-3.6s-1-3-2.2-3.6L480 224l-12.4-29.8zM448 144c0-1.4-1-3-2.2-3.6L416 128l-12.4-29.8C403 97 401.4 96 400 96s-3 1-3.6 2.2L384 128l-29.8 12.4c-1.2.6-2.2 2.2-2.2 3.6s1 3 2.2 3.6L384 160l12.4 29.8c.6 1.2 2.2 2.2 3.6 2.2s3-1 3.6-2.2L416 160l29.8-12.4c1.2-.6 2.2-2.2 2.2-3.6z"
        }
    ]
};

const FasSprayCan = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSprayCan",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 0h64c17.7 0 32 14.3 32 32v96H96V32c0-17.7 14.3-32 32-32zM0 256c0-53 43-96 96-96h128c53 0 96 43 96 96v208c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V256zm240 80a80 80 0 1 0-160 0 80 80 0 1 0 160 0zm16-272a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm128-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64 32a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm32 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-32 128a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm-64-128a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FasSprinklerCeiling = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSprinklerCeiling",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 0v96c0 15.3 10.8 28.4 25.7 31.4L128 147.8V82.6L64 69.8V0H0zm256 82.6v65.3l102.3-20.5c15-3 25.7-16.1 25.7-31.4V0h-64v69.8l-64 12.8zM160 344a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm-48 64a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm-88 88a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm248-152a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm-80 88a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-32 40a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm136-40a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-24 40a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm88 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM224 64c0-17.7-14.3-32-32-32s-32 14.3-32 32v128H96c-17.7 0-32 14.3-32 32s14.3 32 32 32h192c17.7 0 32-14.3 32-32s-14.3-32-32-32h-64V64z"
        }
    ]
};

const FasSprinkler = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSprinkler",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M24 0a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM0 128a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm0 104a24 24 0 1 1 48 0 24 24 0 1 1-48 0zM64 72a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm24 88a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm40-32a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm360 80a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm24-80a24 24 0 1 1-48 0 24 24 0 1 1 48 0zM488 0a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-40 72a24 24 0 1 1-48 0 24 24 0 1 1 48 0zm-24 88a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-40-32a24 24 0 1 1-48 0 24 24 0 1 1 48 0zM256 64c17.7 0 32 14.3 32 32v160h100.2c15.3 0 27.8 12.4 27.8 27.8 0 7.8-3.3 15.2-9 20.5L320 384v96c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32v-96l-87-79.7c-5.7-5.3-9-12.7-9-20.5 0-15.3 12.4-27.8 27.8-27.8H224V96c0-17.7 14.3-32 32-32z"
        }
    ]
};

const FasSquare0 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquare0",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm160 96c53 0 96 43 96 96v64c0 53-43 96-96 96s-96-43-96-96v-64c0-53 43-96 96-96zm-48 96v64c0 26.5 21.5 48 48 48s48-21.5 48-48v-64c0-26.5-21.5-48-48-48s-48 21.5-48 48z"
        }
    ]
};

const FasSquare1 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquare1",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm236 35.2c-7.4-4.3-16.5-4.3-24-.1l-56 32c-11.5 6.6-15.5 21.2-8.9 32.7s21.2 15.5 32.7 8.9l20.2-11.3V336h-40c-13.3 0-24 10.7-24 24s10.7 24 24 24h128c13.3 0 24-10.7 24-24s-10.7-24-24-24h-40V152c0-8.6-4.6-16.5-12-20.8z"
        }
    ]
};

const FasSquare2 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquare2",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm126.7 152.7-24.2 18.4c-10.5 8-25.6 6-33.6-4.5s-6-25.6 4.5-33.6l24.2-18.4c15.8-12 35.2-18.4 55.1-18.1l3.4.1c46.5.7 83.8 38.6 83.8 85.1 0 23.5-9.7 46-26.9 62.1L212.7 336H296c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-9.8 0-18.7-6-22.3-15.2s-1.3-19.6 5.9-26.3l108.7-101.9c7.5-7 11.7-16.8 11.7-27.1 0-20.3-16.3-36.8-36.6-37.1l-3.4-.1c-9.1-.1-18 2.8-25.3 8.3z"
        }
    ]
};

const FasSquare3 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquare3",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm88 96h128c9.9 0 18.8 6.1 22.4 15.3s1.1 19.7-6.2 26.4l-50.8 46.5c41.9 4.8 74.6 40.4 74.6 83.6 0 46.5-37.7 84.2-84.2 84.2H208c-30.1 0-58.1-15.6-73.9-41.2l-2.6-4.2c-7-11.3-3.5-26.1 7.8-33s26.1-3.5 33 7.8l2.6 4.2a38.75 38.75 0 0 0 33 18.4h27.8c20 0 36.2-16.2 36.2-36.2 0-20.1-16.3-36.3-36.4-36.2l-51.5.3c-9.9.1-18.9-6-22.5-15.2s-1.2-19.8 6.1-26.5l50.7-46.2H152c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
        }
    ]
};

const FasSquare4 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquare4",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm191.6 33.2c-12.6-4.2-26.2 2.6-30.4 15.2l-48 144c-2.4 7.3-1.2 15.4 3.3 21.6s11.8 10 19.5 10h104v40c0 13.3 10.7 24 24 24s24-10.7 24-24v-40h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8v-56c0-13.3-10.7-24-24-24s-24 10.7-24 24v56h-70.7l37.5-112.4c4.2-12.6-2.6-26.2-15.2-30.4z"
        }
    ]
};

const FasSquare5 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquare5",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm112 96h104c13.3 0 24 10.7 24 24s-10.7 24-24 24h-84l-7.8 43 61.4 6.9c40.1 4.5 70.4 38.4 70.4 78.8 0 43.8-35.5 79.3-79.3 79.3h-36c-27.5 0-53.3-13.7-68.6-36.6l-4.1-6.1c-7.4-11-4.5-25.9 6.5-33.3s25.9-4.5 33.3 6.5l4.1 6.1c6.4 9.6 17.2 15.3 28.8 15.3h36c17.3 0 31.3-14 31.3-31.3 0-15.9-12-29.3-27.8-31.1l-86.9-9.8c-6.6-.7-12.6-4.2-16.6-9.5s-5.5-12.1-4.4-18.6l16-88c2.1-11.4 12-19.7 23.6-19.7z"
        }
    ]
};

const FasSquare6 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquare6",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm224 144a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm-96 48c0 53 43 96 96 96s96-43 96-96c0-44-29.6-81.1-70-92.4l29.6-25.4c10.1-8.6 11.2-23.8 2.6-33.8s-23.8-11.2-33.8-2.6l-81.6 70c-24.6 21-38.8 51.8-38.8 84.2z"
        }
    ]
};

const FasSquare7 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquare7",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm88 96h144c8.4 0 16.3 4.4 20.6 11.7s4.5 16.2.5 23.7l-112 208c-6.3 11.7-20.8 16-32.5 9.8s-16-20.8-9.8-32.5l93-172.6H152c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
        }
    ]
};

const FasSquare8 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquare8",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm232 32h-16c-39.8 0-72 32.2-72 72 0 15.7 5 30.1 13.5 42-18 14.7-29.5 37-29.5 62 0 44.2 35.8 80 80 80h32c44.2 0 80-35.8 80-80 0-25-11.5-47.4-29.5-62 8.5-11.8 13.5-26.3 13.5-42 0-39.8-32.2-72-72-72zm-16 96c-13.2 0-24-10.8-24-24s10.7-24 24-24h16c13.3 0 24 10.7 24 24s-10.7 24-24 24h-16zm16 48h8c17.7 0 32 14.3 32 32s-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32s14.3-32 32-32h24z"
        }
    ]
};

const FasSquare9 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquare9",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm224 176a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm-26 44.4-29.6 25.4c-10.1 8.6-11.2 23.8-2.6 33.8s23.8 11.2 33.8 2.6l81.6-70c24.6-21 38.8-51.8 38.8-84.2 0-53-43-96-96-96s-96 43-96 96c0 44 29.6 81.1 70 92.4z"
        }
    ]
};

const FasSquareALock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquareALock",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h256v-96c-9.1 0-17.7-5.2-21.8-13.9l-12-26.1H161.8l-12 26.1c-5.6 12-19.8 17.3-31.8 11.7S100.7 362 106.3 350l96-208c3.9-8.5 12.4-13.9 21.8-13.9s17.9 5.4 21.8 13.9l82.4 178.6c5.6-10 13.9-18.3 23.8-24V272c0-56.4 41.7-103.1 96-110.9V96c0-35.3-28.7-64-64-64H64zm160 177.3L184 296h80l-40-86.7zM464 240c17.7 0 32 14.3 32 32v48h-64v-48c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32v128c0 17.7 14.3 32 32 32h160c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32v-48c0-44.2-35.8-80-80-80s-80 35.8-80 80z"
        }
    ]
};

const FasSquareA = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquareA",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm160 96c9.1 0 17.4 5.1 21.5 13.3l104 208c5.9 11.9 1.1 26.3-10.7 32.2s-26.3 1.1-32.2-10.7L289.2 336H158.8l-17.4 34.7c-5.9 11.9-20.3 16.7-32.2 10.7s-16.7-20.3-10.7-32.2l104-208c4.1-8.1 12.4-13.3 21.5-13.3zm0 77.7L182.8 288h82.3L224 205.7z"
        }
    ]
};

const FasSquareAmpersand = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquareAmpersand",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm120 159.6c0 4.1 1.6 8.1 4.6 11l14.4 14.5 23.6-17.3c3.4-2.5 5.4-6.4 5.4-10.6 0-7.3-5.9-13.2-13.2-13.2h-19.2c-8.6 0-15.6 7-15.6 15.6zm71 46.9-17.6 12.9 28.7 28.7 26.2-37.8c7.5-10.9 22.5-13.6 33.4-6.1s13.6 22.5 6.1 33.4l-31.1 45L329 343c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-22.4-22.4a79.997 79.997 0 0 1-62 29.4h-32.2c-36.7 0-66.5-29.8-66.5-66.5 0-21.2 10.1-41.1 27.2-53.6l24.7-18.1-9.2-9.2c-11.9-11.9-18.6-28.1-18.6-45 0-35.1 28.5-63.6 63.6-63.6h19.2c33.8 0 61.2 27.4 61.2 61.2 0 19.5-9.3 37.8-25 49.3zm-87.5 64.1c-4.7 3.5-7.5 9-7.5 14.9 0 10.2 8.3 18.5 18.5 18.5h32.2c10.5 0 20.3-5.2 26.3-13.8l1.4-2-40.1-40.1-30.7 22.5z"
        }
    ]
};

const FasSquareArrowDownLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquareArrowDownLeft",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 480c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64zm224-112c13.3 0 24-10.7 24-24s-10.7-24-24-24h-94.1L329 185c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-135 135V184c0-13.3-10.7-24-24-24s-24 10.7-24 24v160c0 13.3 10.7 24 24 24H288z"
        }
    ]
};

const FasSquareArrowDownRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquareArrowDownRight",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 480c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320zM160 368c-13.3 0-24-10.7-24-24s10.7-24 24-24h94.1L119 185c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l135 135V184c0-13.3 10.7-24 24-24s24 10.7 24 24v160c0 13.3-10.7 24-24 24H160z"
        }
    ]
};

const FasSquareArrowDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquareArrowDown",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 480c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64zm177-87 112-112c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-71 71V136c0-13.3-10.7-24-24-24s-24 10.7-24 24v182.1l-71-71c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L207 393c9.4 9.4 24.6 9.4 33.9 0z"
        }
    ]
};

const FasSquareArrowLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquareArrowLeft",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 416c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v320zm87-177 112-112c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-71 71 182.1.1c13.3 0 24 10.7 24 24s-10.7 24-24 24H161.9l71 71c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L87 273c-9.4-9.4-9.4-24.6 0-33.9z"
        }
    ]
};

const FasSquareArrowRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquareArrowRight",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96zm-87 177L249 385c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l71-71L104 280c-13.3 0-24-10.7-24-24s10.7-24 24-24h182.1l-71-71c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L361 239c9.4 9.4 9.4 24.6 0 33.9z"
        }
    ]
};

const FasSquareArrowUpLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquareArrowUpLeft",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm224 112c13.3 0 24 10.7 24 24s-10.7 24-24 24h-94.1L329 327c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-135-135V328c0 13.3-10.7 24-24 24s-24-10.7-24-24V168c0-13.3 10.7-24 24-24H288z"
        }
    ]
};

const FasSquareArrowUpRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquareArrowUpRight",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 32c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h320zM160 144c-13.3 0-24 10.7-24 24s10.7 24 24 24h94.1L119 327c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l135-135V328c0 13.3 10.7 24 24 24s24-10.7 24-24V168c0-13.3-10.7-24-24-24H160z"
        }
    ]
};

const FasSquareArrowUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquareArrowUp",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm177 87 112 112c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-71-71V376c0 13.3-10.7 24-24 24s-24-10.7-24-24V193.9l-71 71c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L207 119c9.4-9.4 24.6-9.4 33.9 0z"
        }
    ]
};

const FasSquareB = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquareB",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm64 120c0-13.3 10.7-24 24-24h92c42 0 76 34 76 76 0 16.2-5.1 31.3-13.8 43.7 18.1 13.9 29.8 35.7 29.8 60.3 0 42-34 76-76 76H152c-13.3 0-24-10.7-24-24V152zm144 52c0-15.5-12.5-28-28-28h-68v56h68c15.5 0 28-12.5 28-28zm-96 132h84c15.5 0 28-12.5 28-28s-12.5-28-28-28h-84v56z"
        }
    ]
};

const FasSquareBolt = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquareBolt",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm234.1 83.6c5.8 4.7 7.6 12.9 4.3 19.6L249.9 240H320c6.8 0 12.9 4.3 15.1 10.7s.2 13.5-5.1 17.8l-160 128c-5.9 4.7-14.2 4.7-20.1-.1s-7.6-12.9-4.3-19.6L198.1 272H128c-6.8 0-12.8-4.3-15.1-10.7s-.2-13.5 5.1-17.8l160-128c5.9-4.7 14.2-4.7 20.1.1z"
        }
    ]
};

const FasSquareC = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquareC",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm103.4 167.4c-31.2 31.2-31.2 81.9 0 113.1s81.9 31.2 113.1 0c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9c-50 50-131 50-181 0s-50-131 0-181 131-50 181 0c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0c-31.2-31.2-81.9-31.2-113.1 0z"
        }
    ]
};

const FasSquareCaretDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquareCaretDown",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 480c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320zM224 352c-6.7 0-13-2.8-17.6-7.7l-104-112c-6.5-7-8.2-17.2-4.4-25.9s12.5-14.4 22-14.4h208c9.5 0 18.2 5.7 22 14.4s2.1 18.9-4.4 25.9l-104 112c-4.5 4.9-10.9 7.7-17.6 7.7z"
        }
    ]
};

const FasSquareCaretLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquareCaretLeft",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 416c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v320zm128-160c0-6.7 2.8-13 7.7-17.6l112-104c7-6.5 17.2-8.2 25.9-4.4s14.4 12.5 14.4 22v208c0 9.5-5.7 18.2-14.4 22s-18.9 2.1-25.9-4.4l-112-104c-4.9-4.5-7.7-10.9-7.7-17.6z"
        }
    ]
};

const FasSquareCaretRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquareCaretRight",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96zM320 256c0 6.7-2.8 13-7.7 17.6l-112 104c-7 6.5-17.2 8.2-25.9 4.4S160 369.5 160 360V152c0-9.5 5.7-18.2 14.4-22s18.9-2.1 25.9 4.4l112 104c4.9 4.5 7.7 10.9 7.7 17.6z"
        }
    ]
};

const FasSquareCaretUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquareCaretUp",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm160 128c6.7 0 13 2.8 17.6 7.7l104 112c6.5 7 8.2 17.2 4.4 25.9S337.5 320 328 320H120c-9.5 0-18.2-5.7-22-14.4s-2.1-18.9 4.4-25.9l104-112c4.5-4.9 10.9-7.7 17.6-7.7z"
        }
    ]
};

const FasSquareCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquareCheck",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm273 177L209 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L303 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
        }
    ]
};

const FasSquareChevronDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquareChevronDown",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 480c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320zM207 345 103 241c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l87 87 87-87c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L241 345c-9.4 9.4-24.6 9.4-33.9 0z"
        }
    ]
};

const FasSquareChevronLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquareChevronLeft",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 416c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v320zm135-177 104-104c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-87 87 87 87c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L135 273c-9.4-9.4-9.4-24.6 0-33.9z"
        }
    ]
};

const FasSquareChevronRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquareChevronRight",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96zM313 273 209 377c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l87-87-87-87c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L313 239c9.4 9.4 9.4 24.6 0 33.9z"
        }
    ]
};

const FasSquareChevronUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquareChevronUp",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm177 135 104 104c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-87-87-87 87c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L207 167c9.4-9.4 24.6-9.4 33.9 0z"
        }
    ]
};

const FasSquareCode = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquareCode",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm262.2 71.9c-8.9 9.9-8.1 25 1.8 33.9l60.1 54.2-60.2 54.2c-9.9 8.9-10.7 24-1.8 33.9s24 10.7 33.9 1.8l80-72c5.1-4.6 7.9-11 7.9-17.8s-2.9-13.3-7.9-17.8l-80-72c-9.9-8.9-25-8.1-33.9 1.8zm-78.1 33.9c9.9-8.9 10.7-24 1.8-33.9s-24-10.7-33.9-1.8l-80 72c-5.1 4.6-7.9 11-7.9 17.8s2.9 13.3 7.9 17.8l80 72c9.9 8.9 25 8.1 33.9-1.8s8.1-25-1.8-33.9l-60.2-54 60.2-54.2z"
        }
    ]
};

const FasSquareD = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquareD",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm88 96h72c70.7 0 128 57.3 128 128s-57.3 128-128 128h-72c-13.3 0-24-10.7-24-24V152c0-13.3 10.7-24 24-24zm24 208h48c44.2 0 80-35.8 80-80s-35.8-80-80-80h-48v160z"
        }
    ]
};

const FasSquareDashedCirclePlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquareDashedCirclePlus",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 32C43 32 0 75 0 128v32h64v-32c0-17.7 14.3-32 32-32h32V32H96zM0 192v128h64V192H0zm64 160H0v32c0 53 43 96 96 96h32v-64H96c-17.7 0-32-14.3-32-32v-32zm320-224v70.6c15.3-4.3 31.4-6.6 48-6.6 5.4 0 10.7.2 16 .7V128c0-53-43-96-96-96h-32v64h32c17.7 0 32 14.3 32 32zM160 480h136.2c-15.3-18.5-26.9-40.2-33.6-64H160v64zm0-384h128V32H160v64zm272 416a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-208v48h48c8.8 0 16 7.2 16 16s-7.2 16-16 16h-48v48c0 8.8-7.2 16-16 16s-16-7.2-16-16v-48h-48c-8.8 0-16-7.2-16-16s7.2-16 16-16h48v-48c0-8.8 7.2-16 16-16s16 7.2 16 16z"
        }
    ]
};

const FasSquareDashed = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquareDashed",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 32h32v64H96c-17.7 0-32 14.3-32 32v32H0v-32c0-53 43-96 96-96zM0 192h64v128H0V192zm384 0h64v128h-64V192zm64-32h-64v-32c0-17.7-14.3-32-32-32h-32V32h32c53 0 96 43 96 96v32zm0 192v32c0 53-43 96-96 96h-32v-64h32c17.7 0 32-14.3 32-32v-32h64zm-384 0v32c0 17.7 14.3 32 32 32h32v64H96c-53 0-96-43-96-96v-32h64zm96 128v-64h128v64H160zm0-384V32h128v64H160z"
        }
    ]
};

const FasSquareDivide = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquareDivide",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm160 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-88 104h176c13.3 0 24 10.7 24 24s-10.7 24-24 24H136c-13.3 0-24-10.7-24-24s10.7-24 24-24zm56 120a32 32 0 1 1 64 0 32 32 0 1 1-64 0z"
        }
    ]
};

const FasSquareDollar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquareDollar",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm180.8 101.6v14.2c9.7 1.2 19.4 3.9 29 6.6 1.9.5 3.7 1 5.6 1.6 11.5 3.2 18.3 15.1 15.1 26.6s-15.1 18.2-26.6 15.1c-1.6-.4-3.1-.9-4.7-1.3-7-2-14-3.9-21.1-5.3-13.2-2.5-28.5-1.3-40.8 4-11 4.8-20.1 16.4-7.6 24.4 9.8 6.3 21.8 9.5 33.2 12.6 2.4.6 4.7 1.3 7 1.9 15.6 4.4 35.5 10.1 50.4 20.3 19.4 13.3 28.5 34.9 24.2 58.1-4.1 22.4-19.7 37.1-38.4 44.7-7.8 3.2-16.3 5.2-25.2 6.2v15.2c0 11.9-9.7 21.6-21.6 21.6s-21.6-9.7-21.6-21.6v-17.4c-14.5-3.3-28.7-7.9-42.8-12.5-11.3-3.7-17.5-16-13.7-27.3s16-17.5 27.3-13.7c2.5.8 5 1.7 7.5 2.5 11.3 3.8 22.9 7.7 34.5 9.6 17 2.5 30.6 1 39.5-2.6 12-4.8 17.7-19.1 5.9-27.1-10.1-6.9-22.6-10.3-34.5-13.5-2.3-.6-4.5-1.2-6.8-1.9-15.1-4.3-34-9.6-48.2-18.7-19.5-12.5-29.4-33.3-25.2-56.4 4-21.8 21-36.3 39-44.1 5.5-2.4 11.4-4.3 17.5-5.7v-16.1c0-11.9 9.7-21.6 21.6-21.6s21.6 9.7 21.6 21.6z"
        }
    ]
};

const FasSquareDownLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquareDownLeft",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 480c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64zm64-281.4V336c0 8.8 7.2 16 16 16h137.4c12.5 0 22.6-10.1 22.6-22.6 0-6-2.4-11.8-6.6-16L264 280l66.3-66.3c3.6-3.6 5.7-8.5 5.7-13.7s-2-10-5.7-13.7l-36.7-36.7c-3.6-3.6-8.5-5.6-13.6-5.6s-10 2-13.7 5.7L200 216l-33.4-33.4c-4.2-4.2-10-6.6-16-6.6-12.5 0-22.6 10.1-22.6 22.6z"
        }
    ]
};

const FasSquareDownRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquareDownRight",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 480c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320zm-64-281.4V336c0 8.8-7.2 16-16 16H166.6c-12.5 0-22.6-10.1-22.6-22.6 0-6 2.4-11.8 6.6-16L184 280l-66.3-66.3c-3.7-3.7-5.7-8.6-5.7-13.7s2-10 5.7-13.7l36.7-36.7c3.6-3.6 8.5-5.7 13.7-5.7s10 2 13.7 5.7L248 216l33.4-33.4c4.2-4.2 10-6.6 16-6.6 12.5 0 22.6 10.1 22.6 22.6z"
        }
    ]
};

const FasSquareDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquareDown",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 480c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64zm39.1-185.4 107.1 99.9c3.8 3.5 8.7 5.5 13.8 5.5s10.1-2 13.8-5.5l107.1-99.9c4.5-4.2 7.1-10.1 7.1-16.3 0-12.3-10-22.3-22.3-22.3H272v-96c0-17.7-14.3-32-32-32h-32c-17.7 0-32 14.3-32 32v96h-57.7C106 256 96 266 96 278.3c0 6.2 2.6 12.1 7.1 16.3z"
        }
    ]
};

const FasSquareE = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquareE",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm88 96h144c13.3 0 24 10.7 24 24s-10.7 24-24 24H176v56h88c13.3 0 24 10.7 24 24s-10.7 24-24 24h-88v56h120c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24V152c0-13.3 10.7-24 24-24z"
        }
    ]
};

const FasSquareEllipsisVertical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquareEllipsisVertical",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm160 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-32-64a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm32 160a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FasSquareEllipsis = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquareEllipsis",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96zM256 256a32 32 0 1 1-64 0 32 32 0 1 1 64 0zm64-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-160 32a32 32 0 1 1-64 0 32 32 0 1 1 64 0z"
        }
    ]
};

const FasSquareEnvelope = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquareEnvelope",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm154 239.7L64.2 172.4C66 156.4 79.5 144 96 144h256c16.5 0 30 12.4 31.8 28.4L230 271.7c-1.8 1.2-3.9 1.8-6 1.8s-4.2-.6-6-1.8zm29.4 26.9L384 210.4V336c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V210.4l136.6 88.2c7 4.5 15.1 6.9 23.4 6.9s16.4-2.4 23.4-6.9z"
        }
    ]
};

const FasSquareExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquareExclamation",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm160 96c13.3 0 24 10.7 24 24v112c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zm-32 224a32 32 0 1 1 64 0 32 32 0 1 1-64 0z"
        }
    ]
};

const FasSquareF = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquareF",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm88 96h144c13.3 0 24 10.7 24 24s-10.7 24-24 24H176v64h88c13.3 0 24 10.7 24 24s-10.7 24-24 24h-88v72c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24z"
        }
    ]
};

const FasSquareFragile = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquareFragile",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm64 86.3C128 106 138 96 150.3 96H176l32 64-32 32 80 64-32-64 48-32-32-64h57.7c12.3 0 22.3 10 22.3 22.3V208c0 47.6-34.6 87.1-80 94.7V384h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H160c-8.8 0-16-7.2-16-16s7.2-16 16-16h48v-81.3c-45.4-7.6-80-47.1-80-94.7v-89.7z"
        }
    ]
};

const FasSquareFull = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquareFull",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 0h512v512H0V0z"
        }
    ]
};

const FasSquareG = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquareG",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm80 224c0 44.2 35.8 80 80 80 35.8 0 66.1-23.5 76.3-56H248c-13.3 0-24-10.7-24-24s10.7-24 24-24h80c13.3 0 24 10.7 24 24 0 70.7-57.3 128-128 128S96 326.7 96 256s57.3-128 128-128c32.8 0 62.7 12.3 85.3 32.6 9.9 8.8 10.7 24 1.9 33.9s-24 10.7-33.9 1.9C263.2 183.7 244.5 176 224 176c-44.2 0-80 35.8-80 80z"
        }
    ]
};

const FasSquareH = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquareH",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm272 120v208c0 13.3-10.7 24-24 24s-24-10.7-24-24v-80H160v80c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24s24 10.7 24 24v80h128v-80c0-13.3 10.7-24 24-24s24 10.7 24 24z"
        }
    ]
};

const FasSquareHeart = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquareHeart",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm35.9 248.9c-29.4-29.8-29.4-78.2 0-108s77-29.8 106.4 0l17.7 18 17.7-18c29.4-29.8 77-29.8 106.4 0s29.4 78.2 0 108L246.5 384.1c-6.2 6.3-14.3 9.4-22.5 9.4s-16.3-3.1-22.5-9.4L99.9 280.9z"
        }
    ]
};

const FasSquareI = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquareI",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm88 96h144c13.3 0 24 10.7 24 24s-10.7 24-24 24h-48v160h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24s10.7-24 24-24h48V176h-48c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
        }
    ]
};

const FasSquareInfo = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquareInfo",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm120 304h24v-64h-24c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24v88h8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-80c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FasSquareJ = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquareJ",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm240 120v136c0 53-43 96-96 96s-96-43-96-96v-8c0-13.3 10.7-24 24-24s24 10.7 24 24v8c0 26.5 21.5 48 48 48s48-21.5 48-48V152c0-13.3 10.7-24 24-24s24 10.7 24 24z"
        }
    ]
};

const FasSquareK = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquareK",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm249.1 136.8-73 74.3 75.3 102.7c7.8 10.7 5.5 25.7-5.2 33.5s-25.7 5.5-33.5-5.2L206 277.8l-30 30.5V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24s24 10.7 24 24v87.8l102.9-104.6c9.3-9.5 24.5-9.6 33.9-.3s9.6 24.5.3 33.9z"
        }
    ]
};

const FasSquareKanban = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquareKanban",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 480c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320zm-64-96c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32v192c0 17.7-14.3 32-32 32zm-64-160c0 17.7-14.3 32-32 32s-32-14.3-32-32v-64c0-17.7 14.3-32 32-32s32 14.3 32 32v64zm-128 96c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32v128c0 17.7-14.3 32-32 32z"
        }
    ]
};

const FasSquareL = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquareL",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm112 120v184h120c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24V152c0-13.3 10.7-24 24-24s24 10.7 24 24z"
        }
    ]
};

const FasSquareLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquareLeft",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm185.4 39.1L85.5 242.2C82 245.9 80 250.9 80 256s2 10.1 5.5 13.8l99.9 107.1c4.2 4.5 10.1 7.1 16.3 7.1 12.3 0 22.3-10 22.3-22.3V304h96c17.7 0 32-14.3 32-32v-32c0-17.7-14.3-32-32-32h-96v-57.7c0-12.3-10-22.3-22.3-22.3-6.2 0-12.1 2.6-16.3 7.1z"
        }
    ]
};

const FasSquareList = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquareList",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm96 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32-128a32 32 0 1 0-64 0 32 32 0 1 0 64 0zM96 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm96-248c-13.3 0-24 10.7-24 24s10.7 24 24 24h160c13.3 0 24-10.7 24-24s-10.7-24-24-24H192zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24h160c13.3 0 24-10.7 24-24s-10.7-24-24-24H192zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24h160c13.3 0 24-10.7 24-24s-10.7-24-24-24H192z"
        }
    ]
};

const FasSquareM = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquareM",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm75.5 105.9L224 255l84.5-117.1c6.1-8.4 16.9-12 26.8-8.8s16.6 12.4 16.6 22.8V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V226.2L243.4 310c-4.5 6.2-11.7 9.9-19.5 9.9s-14.9-3.7-19.5-9.9L144 226.2V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-10.4 6.7-19.6 16.6-22.8s20.7.3 26.8 8.8z"
        }
    ]
};

const FasSquareMinus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquareMinus",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm88 200h144c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
        }
    ]
};

const FasSquareN = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquareN",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm90.3 104.5 133.7 158V152c0-13.3 10.7-24 24-24s24 10.7 24 24v208c0 10.1-6.3 19.1-15.7 22.5s-20.1.7-26.6-7L160 217.5V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-10.1 6.3-19.1 15.7-22.5s20.1-.7 26.6 7z"
        }
    ]
};

const FasSquareNfi = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquareNfi",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm75.7 64.6C68.8 162.5 64 168.8 64 176v160c0 8.8 7.2 16 16 16s16-7.2 16-16V233.8l66.3 110.5c3.7 6.2 11.1 9.1 18 7.2s11.7-8.2 11.7-15.4V176c0-8.8-7.2-16-16-16s-16 7.2-16 16v102.2L93.7 167.8c-3.7-6.2-11.1-9.1-18-7.2zM224 176v160c0 8.8 7.2 16 16 16s16-7.2 16-16v-80h48c8.8 0 16-7.2 16-16s-7.2-16-16-16h-48v-32h48c8.8 0 16-7.2 16-16s-7.2-16-16-16h-64c-8.8 0-16 7.2-16 16zm160 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v160c0 8.8 7.2 16 16 16s16-7.2 16-16V176z"
        }
    ]
};

const FasSquareO = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquareO",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm80 224a80 80 0 1 0 160 0 80 80 0 1 0-160 0zm80 128a128 128 0 1 1 0-256 128 128 0 1 1 0 256z"
        }
    ]
};

const FasSquareP = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquareP",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm88 96h92c50.8 0 92 41.2 92 92s-41.2 92-92 92h-68v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zm92 136c24.3 0 44-19.7 44-44s-19.7-44-44-44h-68v88h68z"
        }
    ]
};

const FasSquareParkingSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquareParkingSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-86.8-68V96c0-35.3-28.7-64-64-64H160c-21.6 0-40.7 10.7-52.3 27.1l-68.9-54zM227 152.7c6-14.5 20.3-24.7 37-24.7h72c53 0 96 43 96 96 0 26.3-10.6 50.2-27.8 67.5l-51.4-40.3c9.1-5.6 15.2-15.7 15.2-27.2 0-17.7-14.3-32-32-32h-48v8.4l-61-47.8zM224 288v-15.5L96 171.6V416c0 35.3 28.7 64 64 64h320c2.3 0 4.6-.1 6.9-.4L288 322.9V352c0 17.7-14.3 32-32 32s-32-14.3-32-32v-64z"
        }
    ]
};

const FasSquareParking = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquareParking",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm128 224h48c17.7 0 32-14.3 32-32s-14.3-32-32-32h-48v64zm48 64h-48v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V168c0-22.1 17.9-40 40-40h72c53 0 96 43 96 96s-43 96-96 96z"
        }
    ]
};

const FasSquarePen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquarePen",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm261.8 107.7 14.4 14.4c15.6 15.6 15.6 40.9 0 56.6l-21.4 21.4-71-71 21.4-21.4c15.6-15.6 40.9-15.6 56.6 0zM119.9 289l105.2-105.2 71 71-105.2 105.1c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9z"
        }
    ]
};

const FasSquarePersonConfined = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquarePersonConfined",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm96 112a48 48 0 1 1 96 0 48 48 0 1 1-96 0zm80 104c0-30.9 25.1-56 56-56s56 25.1 56 56v102.1c0 36.4-29.5 65.9-65.9 65.9-17.5 0-34.3-6.9-46.6-19.3L184.8 342l-28.1 56.3c-7.9 15.8-27.1 22.2-42.9 14.3s-22.2-27.1-14.3-42.9l48-96c4.6-9.2 13.3-15.6 23.5-17.3s20.5 1.7 27.8 9l41.2 41.3V248z"
        }
    ]
};

const FasSquarePhoneFlip = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquarePhoneFlip",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 32c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h320zm-90.7 96.7c-9.7-2.6-19.9 2.3-23.7 11.6l-20 48c-3.4 8.2-1 17.6 5.8 23.2l24.6 20.2c-16.6 35.2-45.1 63.7-80.3 80.3l-20.2-24.7c-5.6-6.8-15-9.2-23.2-5.8l-48 20c-9.3 3.9-14.2 14-11.6 23.7l12 44C111.1 378 119 384 128 384c123.7 0 224-100.3 224-224 0-9-6-16.9-14.7-19.3l-44-12z"
        }
    ]
};

const FasSquarePhoneHangup = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquarePhoneHangup",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm295.4 278c-5.3 8.6-16.8 12.3-26.7 8.5l-46.2-17.6c-8.7-3.3-14.1-11.6-13.1-20.3l2.9-26.7c-33.8-10.8-70.8-10.8-104.6 0l2.9 26.7c.9 8.7-4.4 16.9-13.1 20.3l-46.2 17.6c-9.9 3.8-21.4.2-26.7-8.5l-21.8-35.2c-4.8-7.8-3.4-17.5 3.5-23.8 84.9-78.6 222.6-78.6 307.5 0 6.8 6.3 8.2 16.1 3.4 23.8L359.4 310z"
        }
    ]
};

const FasSquarePhone = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquarePhone",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm90.7 96.7c9.7-2.6 19.9 2.3 23.7 11.6l20 48c3.4 8.2 1 17.6-5.8 23.2L168 231.7c16.6 35.2 45.1 63.7 80.3 80.3l20.2-24.7c5.6-6.8 15-9.2 23.2-5.8l48 20c9.3 3.9 14.2 14 11.6 23.7l-12 44C336.9 378 329 384 320 384 196.3 384 96 283.7 96 160c0-9 6-16.9 14.7-19.3l44-12z"
        }
    ]
};

const FasSquarePlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquarePlus",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm136 312v-64h-64c-13.3 0-24-10.7-24-24s10.7-24 24-24h64v-64c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24h-64v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"
        }
    ]
};

const FasSquarePollHorizontal = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquarePollHorizontal",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96zm-192 64c0 17.7-14.3 32-32 32h-96c-17.7 0-32-14.3-32-32s14.3-32 32-32h96c17.7 0 32 14.3 32 32zm64 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H128c-17.7 0-32-14.3-32-32s14.3-32 32-32h192zM192 352c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32s14.3-32 32-32h32c17.7 0 32 14.3 32 32z"
        }
    ]
};

const FasSquarePollVertical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquarePollVertical",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm64 192c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32s-32-14.3-32-32v-96c0-17.7 14.3-32 32-32zm64-64c0-17.7 14.3-32 32-32s32 14.3 32 32v192c0 17.7-14.3 32-32 32s-32-14.3-32-32V160zm128 128c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32s-32-14.3-32-32v-32c0-17.7 14.3-32 32-32z"
        }
    ]
};

const FasSquareQ = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquareQ",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm80 224c0 44.2 35.8 80 80 80 13.4 0 25.9-3.3 37-9.1l-30-30c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l30 30c5.8-11.1 9.1-23.7 9.1-37 0-44.2-35.8-80-80-80s-80 35.8-80 80zm208 0c0 26.7-8.2 51.4-22.1 71.9L345 343c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L296 361.8c-20.5 14-45.3 22.1-71.9 22.1-70.7 0-128-57.3-128-128s57.3-128 128-128 128 57.3 128 128z"
        }
    ]
};

const FasSquareQuarters = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquareQuarters",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm64 0 160 160L384 96H64zm0 320h320L224 256 64 416z"
        }
    ]
};

const FasSquareQuestion = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquareQuestion",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm73.8 133.3c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1 0 22.6-12.1 43.5-31.7 54.8L248 264.4c-.2 13-10.9 23.6-24 23.6-13.3 0-24-10.7-24-24v-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1 0-8.4-6.8-15.1-15.1-15.1h-58.3c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM192 352a32 32 0 1 1 64 0 32 32 0 1 1-64 0z"
        }
    ]
};

const FasSquareQuote = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquareQuote",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm64 128h48c17.7 0 32 14.3 32 32v87.3c0 35.2-25.4 65.2-60.2 71l-7.9 1.3c-13.1 2.2-25.4-6.7-27.6-19.7s6.7-25.4 19.7-27.6l7.9-1.3c11.6-1.9 20.1-11.9 20.1-23.7V272h-32c-17.7 0-32-14.3-32-32v-48c0-17.7 14.3-32 32-32zm224 80v39.3c0 35.2-25.4 65.2-60.2 71l-7.9 1.3c-13.1 2.2-25.4-6.7-27.6-19.7s6.7-25.4 19.7-27.6l7.9-1.3c11.6-1.9 20.1-11.9 20.1-23.7V272h-32c-17.7 0-32-14.3-32-32v-48c0-17.7 14.3-32 32-32h48c17.7 0 32 14.3 32 32v48z"
        }
    ]
};

const FasSquareR = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquareR",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm88 96h104c44.2 0 80 35.8 80 80 0 36.6-24.6 67.5-58.2 77l45.4 60.6c8 10.6 5.8 25.6-4.8 33.6s-25.6 5.8-33.6-4.8L220 288h-44v72c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zm80 112h24c17.7 0 32-14.3 32-32s-14.3-32-32-32h-80v64h56z"
        }
    ]
};

const FasSquareRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquareRight",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96zm-185.4 39.1 99.9 107.1c3.5 3.8 5.5 8.7 5.5 13.8s-2 10.1-5.5 13.8l-99.9 107.1c-4.2 4.5-10.1 7.1-16.3 7.1-12.3 0-22.3-10-22.3-22.3V304h-96c-17.7 0-32-14.3-32-32v-32c0-17.7 14.3-32 32-32h96v-57.7c0-12.3 10-22.3 22.3-22.3 6.2 0 12.1 2.6 16.3 7.1z"
        }
    ]
};

const FasSquareRing = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquareRing",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm64 224a96 96 0 1 0 192 0 96 96 0 1 0-192 0zm96 160a160 160 0 1 1 0-320 160 160 0 1 1 0 320z"
        }
    ]
};

const FasSquareRootVariable = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquareRootVariable",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M282.6 78.1c8-27.3 33-46.1 61.4-46.1h200c17.7 0 32 14.3 32 32s-14.3 32-32 32H344L238.7 457c-3.6 12.3-14.1 21.2-26.8 22.8s-25.1-4.6-31.5-15.6L77.6 288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h45.6c22.8 0 43.8 12.1 55.3 31.8l65.2 111.8 84.5-289.5zm110.8 155.3c12.5-12.5 32.8-12.5 45.3 0l41.3 41.3 41.4-41.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L525.3 320l41.4 41.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L480 365.3l-41.4 41.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l41.4-41.4-41.4-41.4c-12.5-12.5-12.5-32.8 0-45.3z"
        }
    ]
};

const FasSquareRoot = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquareRoot",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M282.6 78.1c8-27.3 33-46.1 61.4-46.1h200c17.7 0 32 14.3 32 32s-14.3 32-32 32H344L238.7 457c-3.6 12.3-14.1 21.2-26.8 22.8s-25.1-4.6-31.5-15.6L77.6 288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h45.6c22.8 0 43.8 12.1 55.3 31.8l65.2 111.8 84.5-289.5z"
        }
    ]
};

const FasSquareRss = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquareRss",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm32 104c0-13.3 10.7-24 24-24 137 0 248 111 248 248 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-110.5-89.5-200-200-200-13.3 0-24-10.7-24-24zm0 96c0-13.3 10.7-24 24-24 83.9 0 152 68.1 152 152 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-57.4-46.6-104-104-104-13.3 0-24-10.7-24-24zm0 120a32 32 0 1 1 64 0 32 32 0 1 1-64 0z"
        }
    ]
};

const FasSquareS = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquareS",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm111.6 164.2c-1.1 6.4-.2 9.7.6 11.6 1 2 2.9 4.6 7.4 7.7 10.1 6.8 25.7 11.5 46.8 17.4l2 .6c18.4 5.2 41.4 11.7 58.6 23.2 9.5 6.4 18.5 15.1 24.1 27.2 5.7 12.3 7 25.9 4.4 40.3-4.7 26.3-23.1 43.3-45 52-21.3 8.4-47 9.6-72.6 5.7h-.1c-16.3-2.6-43.7-10.7-57.3-15.1-12.6-4-19.6-17.6-15.5-30.2s17.6-19.6 30.2-15.5c13.9 4.5 37.8 11.4 50 13.4 20.2 3 36.8 1.4 47.7-2.9 10.3-4.1 14.2-9.6 15.4-15.8 1.1-6.4.2-9.7-.6-11.6-1-2-2.9-4.6-7.4-7.7-10.1-6.8-25.7-11.5-46.8-17.4l-2-.6c-18.4-5.2-41.4-11.7-58.6-23.2-9.5-6.4-18.5-15.1-24.1-27.2-5.7-12.3-7-25.9-4.4-40.3 4.7-26.3 23.1-43.3 45-52 21.3-8.4 47-9.6 72.6-5.7 8.1 1.2 24.4 4.8 32 6.7 12.8 3.3 20.6 16.4 17.3 29.2s-16.4 20.6-29.2 17.3c-6.7-1.7-21.3-4.9-27.3-5.7-20.3-3.1-36.8-1.4-47.8 2.9-10.3 4.1-14.2 9.6-15.4 15.8z"
        }
    ]
};

const FasSquareShareNodes = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquareShareNodes",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm320 128c0 35.3-28.7 64-64 64-15.4 0-29.5-5.4-40.6-14.5L194.1 256l85.3 46.5c11-9.1 25.2-14.5 40.6-14.5 35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64c0-2.5.1-4.9.4-7.3L174.5 300c-11.7 12.3-28.2 20-46.5 20-35.3 0-64-28.7-64-64s28.7-64 64-64c18.3 0 34.8 7.7 46.5 20l81.9-44.7c-.3-2.4-.4-4.9-.4-7.3 0-35.3 28.7-64 64-64s64 28.7 64 64z"
        }
    ]
};

const FasSquareSlidersVertical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquareSlidersVertical",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm144 0c-17.7 0-32 14.3-32 32v32H96c-17.7 0-32 14.3-32 32s14.3 32 32 32h16v160c0 17.7 14.3 32 32 32s32-14.3 32-32V224h16c17.7 0 32-14.3 32-32s-14.3-32-32-32h-16v-32c0-17.7-14.3-32-32-32zm192 32c0-17.7-14.3-32-32-32s-32 14.3-32 32v160h-16c-17.7 0-32 14.3-32 32s14.3 32 32 32h16v32c0 17.7 14.3 32 32 32s32-14.3 32-32v-32h16c17.7 0 32-14.3 32-32s-14.3-32-32-32h-16V128z"
        }
    ]
};

const FasSquareSliders = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquareSliders",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 480c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320zm0-144c0 17.7-14.3 32-32 32h-32v16c0 17.7-14.3 32-32 32s-32-14.3-32-32v-16H96c-17.7 0-32-14.3-32-32s14.3-32 32-32h160v-16c0-17.7 14.3-32 32-32s32 14.3 32 32v16h32c17.7 0 32 14.3 32 32zm-32-192c17.7 0 32 14.3 32 32s-14.3 32-32 32H192v16c0 17.7-14.3 32-32 32s-32-14.3-32-32v-16H96c-17.7 0-32-14.3-32-32s14.3-32 32-32h32v-16c0-17.7 14.3-32 32-32s32 14.3 32 32v16h160z"
        }
    ]
};

const FasSquareSmall = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquareSmall",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 160c0-35.3 28.7-64 64-64h192c35.3 0 64 28.7 64 64v192c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V160z"
        }
    ]
};

const FasSquareStar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquareStar",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm224 8c-6.1 0-11.7 3.5-14.3 8.9l-36.2 73.4-81 11.8c-6 .9-11 5.1-12.9 10.9s-.3 12.2 4 16.4l58.6 57.2-13.8 80.7c-1 6 1.4 12.1 6.4 15.6s11.5 4.1 16.8 1.2l72.4-38 72.5 38.1c5.4 2.8 11.9 2.4 16.8-1.2s7.4-9.6 6.4-15.6l-13.8-80.7 58.6-57.2c4.4-4.3 5.9-10.6 4-16.4s-6.9-10-12.9-10.9l-81.1-11.8-36.2-73.4c-2.7-5.5-8.3-8.9-14.3-8.9z"
        }
    ]
};

const FasSquareT = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquareT",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm56 112h208c13.3 0 24 10.7 24 24s-10.7 24-24 24h-80v168c0 13.3-10.7 24-24 24s-24-10.7-24-24V192h-80c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
        }
    ]
};

const FasSquareTerminal = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquareTerminal",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm70.3 55.8c-9 9.8-8.3 25 1.5 33.9l76.7 70.3-76.7 70.3c-9.8 9-10.4 24.1-1.5 33.9s24.1 10.4 33.9 1.5l96-88c5-4.5 7.8-11 7.8-17.7s-2.8-13.1-7.8-17.7l-96-88c-9.8-9-25-8.3-33.9 1.5zM216 336c-13.3 0-24 10.7-24 24s10.7 24 24 24h144c13.3 0 24-10.7 24-24s-10.7-24-24-24H216z"
        }
    ]
};

const FasSquareThisWayUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquareThisWayUp",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm16 352h288c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zm185.4-192c-9.6 0-17.4-7.8-17.4-17.4 0-4.3 1.6-8.4 4.4-11.6l54.3-61c3.4-3.8 8.2-6 13.3-6s9.9 2.2 13.3 6l54.3 61.1c2.8 3.2 4.4 7.3 4.4 11.6 0 9.6-7.8 17.4-17.4 17.4H352V304c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16V192h-22.6zm-192 0c-9.6 0-17.4-7.8-17.4-17.4 0-4.3 1.6-8.4 4.4-11.6l54.3-61c3.4-3.8 8.2-6 13.3-6s9.9 2.2 13.3 6l54.3 61.1c2.8 3.2 4.4 7.3 4.4 11.6 0 9.6-7.8 17.4-17.4 17.4H160V304c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16V192H73.4z"
        }
    ]
};

const FasSquareU = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquareU",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm96 136v120c0 35.3 28.7 64 64 64s64-28.7 64-64V168c0-13.3 10.7-24 24-24s24 10.7 24 24v120c0 61.9-50.1 112-112 112s-112-50.1-112-112V168c0-13.3 10.7-24 24-24s24 10.7 24 24z"
        }
    ]
};

const FasSquareUpLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquareUpLeft",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm64 281.4V176c0-8.8 7.2-16 16-16h137.4c12.5 0 22.6 10.1 22.6 22.6 0 6-2.4 11.8-6.6 16L264 232l66.3 66.3c3.6 3.6 5.7 8.5 5.7 13.7s-2 10-5.7 13.7l-36.7 36.7c-3.6 3.6-8.5 5.6-13.6 5.6s-10-2-13.7-5.7L200 296l-33.4 33.4c-4.2 4.2-10 6.6-16 6.6-12.5 0-22.6-10.1-22.6-22.6z"
        }
    ]
};

const FasSquareUpRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquareUpRight",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 32c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h320zm-64 281.4V176c0-8.8-7.2-16-16-16H166.6c-12.5 0-22.6 10.1-22.6 22.6 0 6 2.4 11.8 6.6 16L184 232l-66.3 66.3c-3.7 3.7-5.7 8.6-5.7 13.7s2 10 5.7 13.7l36.7 36.7c3.6 3.6 8.5 5.7 13.7 5.7s10-2 13.7-5.7L248 296l33.4 33.4c4.2 4.2 10 6.6 16 6.6 12.5 0 22.6-10.1 22.6-22.6z"
        }
    ]
};

const FasSquareUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquareUp",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm39.1 185.4 107.1-99.9c3.8-3.5 8.7-5.5 13.8-5.5s10.1 2 13.8 5.5l107.1 99.9c4.5 4.2 7.1 10.1 7.1 16.3 0 12.3-10 22.3-22.3 22.3H272v96c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32v-96h-57.7C106 256 96 246 96 233.7c0-6.2 2.6-12.1 7.1-16.3z"
        }
    ]
};

const FasSquareUser = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquareUser",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M81.1 416h285.8c-7.8-54.3-54.4-96-110.9-96h-64c-56.4 0-103.1 41.7-110.9 96zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm224 176a72 72 0 1 0 0-144 72 72 0 1 0 0 144z"
        }
    ]
};

const FasSquareV = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquareV",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm77.5 125.3 82.5 165 82.5-165.1c5.9-11.9 20.3-16.7 32.2-10.7s16.7 20.3 10.7 32.2l-104 208c-4.1 8.1-12.4 13.3-21.5 13.3s-17.4-5.1-21.5-13.3l-104-208c-5.9-11.9-1.1-26.3 10.7-32.2s26.3-1.1 32.2 10.7z"
        }
    ]
};

const FasSquareVirus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquareVirus",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm159.8 61.7c13.3 0 24 10.7 24 24 0 29.3 35.4 43.9 56.1 23.2 9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9c-20.7 20.7-6 56.1 23.2 56.1 13.3 0 24 10.7 24 24s-10.7 24-24 24c-29.3 0-43.9 35.4-23.2 56.1 9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0c-20.7-20.7-56.1-6-56.1 23.2 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-29.3-35.4-43.9-56.1-23.2-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9c20.7-20.7 6-56.1-23.2-56.1-13.3 0-24-10.7-24-24s10.7-24 24-24c29.3 0 43.9-35.4 23.2-56.1-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0c20.7 20.7 56.1 6 56.1-23.2 0-13.3 10.7-24 24-24zM192 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm88 32a24 24 0 1 0-48 0 24 24 0 1 0 48 0z"
        }
    ]
};

const FasSquareW = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquareW",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm54.9 136.7L160 297.3l41.1-128.6c3.2-9.9 12.4-16.7 22.9-16.7s19.7 6.7 22.9 16.7L288 297.3l41.1-128.6c4-12.6 17.5-19.6 30.2-15.5s19.6 17.5 15.5 30.2l-64 200c-3.2 9.9-12.4 16.7-22.9 16.7s-19.7-6.7-22.9-16.7l-41-128.7-41.1 128.6c-3.2 9.9-12.4 16.7-22.9 16.7s-19.7-6.7-22.9-16.7l-64-200c-4-12.6 2.9-26.1 15.5-30.2s26.1 2.9 30.2 15.5z"
        }
    ]
};

const FasSquareX = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquareX",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm90.3 104.5 69.7 82.3 69.7-82.3c8.6-10.1 23.7-11.4 33.8-2.8s11.4 23.7 2.8 33.8L255.4 256l74.9 88.5c8.6 10.1 7.3 25.3-2.8 33.8s-25.3 7.3-33.8-2.8L224 293.2l-69.7 82.3c-8.6 10.1-23.7 11.4-33.8 2.8s-11.4-23.7-2.8-33.8l74.9-88.5-74.9-88.5c-8.6-10.1-7.3-25.3 2.8-33.8s25.3-7.3 33.8 2.8z"
        }
    ]
};

const FasSquareXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquareXmark",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm79 143c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"
        }
    ]
};

const FasSquareY = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquareY",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm74.1 120.3 85.9 99.1 85.9-99.1c8.7-10 23.8-11.1 33.9-2.4s11.1 23.8 2.4 33.9L248 297v79c0 13.3-10.7 24-24 24s-24-10.7-24-24v-79l-98.1-113.3c-8.7-10-7.6-25.2 2.4-33.9s25.2-7.6 33.9 2.4z"
        }
    ]
};

const FasSquareZ = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquareZ",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm72 96h176c9.3 0 17.8 5.4 21.8 13.9s2.6 18.5-3.5 25.6L187.7 336H312c13.3 0 24 10.7 24 24s-10.7 24-24 24H136c-9.3 0-17.8-5.4-21.8-13.9s-2.6-18.5 3.5-25.6L260.3 176H136c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
        }
    ]
};

const FasSquare = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquare",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96z"
        }
    ]
};

const FasSquid = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquid",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M276 .3c-5.3-1.1-10.8.6-14.6 4.5s-5.4 9.4-4.2 14.7l13.1 58.9c-71.9 46.2-103.4 101.8-110.6 148.4L146 213l-2.3-2.3-22.6-22.6c-6.2-6.2-6.2-16.4 0-22.6l56.4-56.4c18.9-18.9 18.7-49.5-.3-68.2L140.1 4.6c-6.3-6.1-16.3-6.1-22.5.1l-2.8 2.8c-34 34-33.3 87.7-1.9 121l-14.4 14.4c-18.7 18.7-18.7 49.1 0 67.9l22.6 22.6 5.7 5.7c9.3 9.4 9.3 24.5 0 33.9-9.3 9.3-24.4 9.4-33.8.2l-16.5-16.6c-19.1-19.1-50.2-18.7-68.7.9L4.4 261c-6.1 6.4-5.8 16.5.6 22.6s16.5 5.8 22.6-.6l3.3-3.5c6.2-6.5 16.6-6.7 22.9-.3l10.6 10.6.1.2 22.6 22.6c10.1 10.2 9 26.9-2.4 35.8l-20 15.6c-3.5 2.7-7.7 4.2-12.1 4.2-10.9 0-19.7-8.8-19.7-19.7V336c0-8.8-7.2-16-16-16s-16 7.2-16 16v12.3c0 28.5 23.2 51.7 51.7 51.7 11.5 0 22.7-3.8 31.8-10.9l28.2-21.9c9.4-7.3 22.8-6.5 31.2 1.9s9.3 21.8 1.9 31.2l-21.9 28.2c-7.1 9.1-10.9 20.3-10.9 31.8 0 28.6 23.2 51.7 51.7 51.7h12.3c8.8 0 16-7.2 16-16s-7.2-16-16-16h-12.3c-10.9 0-19.7-8.8-19.7-19.7 0-4.4 1.5-8.7 4.2-12.1l15.6-20c8.8-11.4 25.6-12.4 35.8-2.3l.1.1 22.4 22.3.1.1 9.9 9.8c6.5 6.5 6.2 17.2-.7 23.3l-2.8 2.5c-6.6 5.9-7.2 16-1.3 22.6s16 7.2 22.6 1.3l2.8-2.5c20.7-18.3 21.6-50.3 2.1-69.8l-9.9-9.9-5.7-5.7-.1-.1c-9.3-9.3-9.3-24.4 0-33.8l.1-.1.1-.1c9.3-9.2 24.4-9.2 33.7 0l28.4 28.4c18.7 18.7 49.1 18.7 67.9 0l14.2-14.3c33.3 31.4 87 32.1 121-1.9l2.8-2.8c6.2-6.2 6.3-16.3.1-22.5L472 335.7c-18.7-19-49.3-19.2-68.2-.3l-56.4 56.3c-6.2 6.2-16.4 6.2-22.6 0l-22.5-22.5-.1-.1-16-16c46.6-7.2 102.2-38.7 148.4-110.6l58.9 13.1c5.3 1.2 10.8-.4 14.7-4.2s5.6-9.3 4.5-14.6l-23.4-116.6c9.2-30.2 17.2-64 23.4-101.5.9-5.1-.8-10.3-4.5-13.9S499.4-.6 494.3.2C456.7 6.5 423 14.4 392.7 23.6L276 .3zM168.9 280a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm64 32a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
        }
    ]
};

const FasSquirrel = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSquirrel",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 296.2c0 2-.7 3.9-2 5.4-18.7 22.3-30 51-30 82.3 0 70.7 57.3 128 128 128h192c17.7 0 32-14.3 32-32s-14.3-32-32-32h-16c10-13.4 16-30 16-48 0-26.2-12.6-49.4-32-64-13.4-10-30-16-48-16-9.4 0-18.3 1.6-26.7 4.5-8.3 2.9-17.5-1.4-20.4-9.8s1.4-17.5 9.8-20.4c11.7-4.1 24.3-6.4 37.3-6.4 17.2 0 33.5 3.9 48 10.8V240h21.2c26.7 0 51.7-13.4 66.6-35.6L512 192c0-53-43-96-96-96V75.2c0-6.2-5-11.2-11.2-11.2-15.2 0-28.7 7.6-36.8 19.2-8.1-11.6-21.6-19.2-36.8-19.2-6.2 0-11.2 5-11.2 11.2V96c0 54.4-10.5 108.1-30.7 158-.9-2-1.3-4.2-1.3-6.4V144C288 64.5 223.5 0 144 0S0 64.5 0 144s64.5 144 144 144c2.3 0 4.6-.1 6.9-.2 4.9-.2 9.1 3.5 9.1 8.4zM416 144a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
        }
    ]
};

const FasStaffSnake = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasStaffSnake",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m222.6 43.2-.1 4.8H288c53 0 96 43 96 96s-43 96-96 96h-40v-80h40c8.8 0 16-7.2 16-16s-7.2-16-16-16h-68l-4.5 144H256c53 0 96 43 96 96s-43 96-96 96h-16v-80h16c8.8 0 16-7.2 16-16s-7.2-16-16-16h-43l-3.1 99.5-1.4 43.5v1c-.3 8.9-7.6 16-16.5 16s-16.2-7.1-16.5-16v-1l-1-31H136c-22.1 0-40-17.9-40-40s17.9-40 40-40h36l-1-32h-19c-53 0-96-43-96-96 0-47.6 34.6-87.1 80-94.7V256c0 8.8 7.2 16 16 16h16.5L164 128h-41.4c-9 18.9-28.3 32-50.6 32H56c-30.9 0-56-25.1-56-56s25.1-56 56-56h105.5l-.1-4.8L161 32v-1.9c.5-16.6 14.1-30 31-30s30.5 13.4 31 30V32l-.4 11.2zM64 112a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
        }
    ]
};

const FasStaff = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasStaff",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M284.2 44.2C297.8 17.1 325.5 0 355.8 0H432c44.2 0 80 35.8 80 80v103.9c0 35.7-23.7 67.1-58 76.9l-3.9 1.1c-4 1.2-7.5 3.9-9.5 7.5l-19 33.6c-4.3 7.7-14.1 10.4-21.8 6.1L367 290.6c-3.7-2.1-8.1-2.6-12.3-1.5l-85.5 24.4c-2.6.7-5 2.1-6.9 4.1L81.9 497.9c-18.7 18.7-49.1 18.7-67.9 0s-18.7-49.1 0-67.9l77.3-77.3c3-3 4.7-7.1 4.7-11.3V304c0-8.8 7.2-16 16-16h37.5c4.2 0 8.3-1.7 11.3-4.7l39.4-39.4c9.6-9.6 21.5-16.6 34.6-20.4L404.4 175c6.9-2 11.6-8.2 11.6-15.4V112c0-8.8-7.2-16-16-16h-28.2c-3.7 0-7.2 2.1-8.8 5.5-11.9 23.7-40.7 33.3-64.4 21.5s-33.3-40.7-21.5-64.4l7.2-14.3z"
        }
    ]
};

const FasStairs = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasStairs",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 64c0-17.7 14.3-32 32-32h128c17.7 0 32 14.3 32 32s-14.3 32-32 32h-96v96c0 17.7-14.3 32-32 32h-96v96c0 17.7-14.3 32-32 32h-96v96c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h96v-96c0-17.7 14.3-32 32-32h96v-96c0-17.7 14.3-32 32-32h96V64z"
        }
    ]
};

const FasStamp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasStamp",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M312 201.8c0-17.4 9.2-33.2 19.9-47C344.5 138.5 352 118.1 352 96c0-53-43-96-96-96s-96 43-96 96c0 22.1 7.5 42.5 20.1 58.8 10.7 13.8 19.9 29.6 19.9 47 0 29.9-24.3 54.2-54.2 54.2H112C50.1 256 0 306.1 0 368c0 20.9 13.4 38.7 32 45.3V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-50.7c18.6-6.6 32-24.4 32-45.3 0-61.9-50.1-112-112-112h-33.8c-29.9 0-54.2-24.3-54.2-54.2zM416 416v32H96v-32h320z"
        }
    ]
};

const FasStandardDefinition = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasStandardDefinition",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 96c0-35.3 28.7-64 64-64h448c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm304 88v144c0 13.3 10.7 24 24 24h56c53 0 96-43 96-96s-43-96-96-96h-56c-13.3 0-24 10.7-24 24zm48 24h32c26.5 0 48 21.5 48 48s-21.5 48-48 48h-32v-96zm-184.9.1c7.4-2.4 19.5-2.9 36.2-.7l3-22.2-3 22.2c5.1.7 21.1 3.4 25.7 4.4 12.1 2.8 24.1-4.8 26.8-16.9s-4.8-24.1-16.9-26.8c-6.5-1.5-23.9-4.4-29.7-5.1-18.9-2.5-38.9-3.1-56 2.5-18.8 6.1-33.9 19.7-38.5 42.3-.1.4-.1.8-.2 1.2-1.7 11.4-.2 22.4 5 32.3 5.1 9.6 12.9 16.1 20.5 20.7 13.7 8.2 31.5 12.3 45.1 15.5l1.7.4c16 3.7 27.1 6.5 34.1 10.7 3 1.8 3.8 3 3.9 3.3.1.1.7 1.2.2 4.7-.4 2.7-1.2 3.8-1.7 4.3-.7.7-2.3 2-5.8 3.1-7.7 2.4-20.1 2.9-36.9.6-7.4-1-20.3-4.8-31.4-8-2.5-.7-5-1.4-7.2-2.1-11.9-3.4-24.3 3.5-27.7 15.4s3.5 24.3 15.4 27.7c1.5.4 3.3.9 5.3 1.5 10.8 3.2 28.4 8.3 39.4 9.9h.1c18.9 2.5 39.2 3.1 56.4-2.3 8.9-2.8 17.8-7.5 24.9-15.2 7.3-7.8 11.8-17.6 13.4-28.5 1.7-11.4.2-22.4-5-32.3-5.1-9.6-12.9-16.1-20.5-20.7-13.7-8.2-31.5-12.3-45.1-15.5l-1.7-.4c-16-3.7-27.1-6.5-34.1-10.7-3-1.8-3.8-3-3.9-3.3-.1-.1-.6-1.1-.3-4.1.9-4 2.8-6.2 8.3-8z"
        }
    ]
};

const FasStapler = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasStapler",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M640 299.3V432c0 26.5-21.5 48-48 48H64c-17.7 0-32-14.3-32-32s14.3-32 32-32h384v-48H96c-17.7 0-32-14.3-32-32V219.4L33.8 214C14.2 210.5 0 193.5 0 173.7c0-8.9 2.9-17.5 8.2-24.6l35.6-47.5C76.7 57.8 128.2 32 182.9 32c27 0 53.6 6.3 77.8 18.4l326.2 163.1c32.6 16.2 53.1 49.5 53.1 85.8zM448 304v-16l-320-57.1V304h320z"
        }
    ]
};

const FasStarAndCrescent = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasStarAndCrescent",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 256C0 114.6 114.6 0 256 0c33 0 64.6 6.3 93.6 17.7 7.4 2.9 11.5 10.7 9.8 18.4s-8.8 13-16.7 12.4c-4.8-.3-9.7-.5-14.6-.5-114.9 0-208 93.1-208 208s93.1 208 208 208c4.9 0 9.8-.2 14.6-.5 7.9-.5 15 4.7 16.7 12.4s-2.4 15.5-9.8 18.4C320.6 505.7 289 512 256 512 114.6 512 0 397.4 0 256zm375.4-118.6c3.5-7.1 13.7-7.1 17.2 0l31.5 63.8c1.4 2.8 4.1 4.8 7.2 5.3l70.4 10.2c7.9 1.1 11 10.8 5.3 16.4l-50.9 49.6c-2.3 2.2-3.3 5.4-2.8 8.5l12 70.1c1.3 7.8-6.9 13.8-13.9 10.1l-63-33.1c-2.8-1.5-6.1-1.5-8.9 0l-63 33.1c-7 3.7-15.3-2.3-13.9-10.1l12-70.1c.5-3.1-.5-6.3-2.8-8.5L261 233.1c-5.7-5.6-2.6-15.2 5.3-16.4l70.4-10.2c3.1-.5 5.8-2.4 7.2-5.3l31.5-63.8z"
        }
    ]
};

const FasStarChristmas = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasStarChristmas",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M15.5 275.9 192 320l44.1 176.5c2.3 9.1 10.5 15.5 19.9 15.5s17.6-6.4 19.9-15.5L320 320l176.5-44.1c9.1-2.3 15.5-10.5 15.5-19.9s-6.4-17.6-15.5-19.9L320 192 275.9 15.5C273.6 6.4 265.4 0 256 0s-17.6 6.4-19.9 15.5L192 192 15.5 236.1C6.4 238.4 0 246.6 0 256s6.4 17.6 15.5 19.9zM71 71c-9.4 9.4-9.4 24.6 0 33.9l48 48c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L105 71c-9.4-9.4-24.6-9.4-33.9 0zm370 0c-9.4-9.4-24.6-9.4-33.9 0l-48 48c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l48-48c9.4-9.4 9.4-24.6 0-33.9zm0 336-48-48c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l48 48c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9zM71 441c9.4 9.4 24.6 9.4 33.9 0l48-48c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L71 407c-9.4 9.4-9.4 24.6 0 33.9z"
        }
    ]
};

const FasStarExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasStarExclamation",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288.1 0c12.2 0 23.4 7 28.8 18l64.3 132.3 143.6 21.2c12 1.8 22 10.2 25.7 21.7s.7 24.2-7.9 32.7L438.5 329l24.6 145.7c2 12-3 24.2-12.9 31.3s-23 8-33.8 2.3l-128.3-68.5-128.3 68.5c-10.8 5.7-23.9 4.8-33.8-2.3s-14.9-19.3-12.9-31.3L137.8 329 33.6 225.9c-8.6-8.5-11.7-21.2-7.9-32.7s13.7-19.9 25.7-21.7L195 150.3 259.4 18c5.4-11 16.5-18 28.8-18zm-.1 128c-13.3 0-24 10.7-24 24v112c0 13.3 10.7 24 24 24s24-10.7 24-24V152c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0-64 0 32 32 0 1 0 64 0z"
        }
    ]
};

const FasStarHalfStroke = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasStarHalfStroke",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m320 376.4.1-.1 26.4 14.1 85.2 45.5-16.5-97.6-4.8-28.7 20.7-20.5 70.1-69.3-96.1-14.2-29.3-4.3-12.9-26.6-42.8-87.8-.1.3v289.2zm175.1 98.3c2 12-3 24.2-12.9 31.3s-23 8-33.8 2.3l-128.3-68.5-128.3 68.5c-10.8 5.7-23.9 4.8-33.8-2.3s-14.9-19.3-12.9-31.3L169.8 329 65.6 225.9c-8.6-8.5-11.7-21.2-7.9-32.7s13.7-19.9 25.7-21.7L227 150.3 291.4 18c5.4-11 16.5-18 28.8-18s23.4 7 28.8 18l64.3 132.3 143.6 21.2c12 1.8 22 10.2 25.7 21.7s.7 24.2-7.9 32.7L470.5 329l24.6 145.7z"
        }
    ]
};

const FasStarHalf = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasStarHalf",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 0c-12.2.1-23.3 7-28.6 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329l-24.6 145.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3L288 439.8V0zm141.9 512c1.1.1 2.1.1 3.2 0h-3.2z"
        }
    ]
};

const FasStarOfDavid = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasStarOfDavid",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M404.2 309.5 383.1 344h42.3l-21.1-34.5zM371.4 256l-54-88H194.6l-54 88 54 88h122.8l54-88zm65.7 0 53.4 87c3.6 5.9 5.5 12.7 5.5 19.6 0 20.7-16.8 37.4-37.4 37.4H348.7l-56.2 91.5c-7.7 12.8-21.6 20.5-36.5 20.5s-28.8-7.7-36.6-20.5L163.3 400H53.4C32.8 400 16 383.2 16 362.6c0-6.9 1.9-13.7 5.5-19.6l53.4-87-53.4-87c-3.6-5.9-5.5-12.7-5.5-19.6 0-20.6 16.8-37.4 37.4-37.4h109.9l56.2-91.5C227.2 7.7 241.1 0 256 0s28.8 7.7 36.6 20.5l56.1 91.5h109.9c20.7 0 37.4 16.8 37.4 37.4 0 6.9-1.9 13.7-5.5 19.6l-53.4 87zm-54-88 21.1 34.5 21.2-34.5h-42.3zM283 112l-27-44-27 44h54zm-154.1 56H86.6l21.1 34.5 21.2-34.5zm-21.1 141.5L86.6 344h42.3l-21.1-34.5zM229 400l27 44 27-44h-54z"
        }
    ]
};

const FasStarOfLife = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasStarOfLife",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M208 32c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32v140.9l122-70.4c15.3-8.8 34.9-3.6 43.7 11.7l16 27.7c8.8 15.3 3.6 34.9-11.7 43.7L352 256l122 70.4c15.3 8.8 20.5 28.4 11.7 43.7l-16 27.7c-8.8 15.3-28.4 20.6-43.7 11.7l-122-70.4V480c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32V339.1L86 409.6c-15.3 8.8-34.9 3.6-43.7-11.7l-16-27.7c-8.8-15.3-3.6-34.9 11.7-43.7L160 256 38 185.6c-15.3-8.8-20.5-28.4-11.7-43.7l16-27.7c8.8-15.4 28.4-20.6 43.7-11.8l122 70.4V32z"
        }
    ]
};

const FasStarSharpHalfStroke = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasStarSharpHalfStroke",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m56 230.4-14.7-11.5c-8.1-6.3-11.3-17-8-26.7S45.7 176 56 176h158.5l44.1-138.8.1-.3 1.3-4 5.2-16.2C268.3 6.8 277.6 0 288 0s19.7 6.8 22.9 16.7l5.1 16.2 1.3 4 .1.3L361.6 176H520c10.3 0 19.4 6.5 22.7 16.2s.1 20.4-8 26.7L520 230.4l-2 1.5-.1.1-114 88.7 44.4 139.5.1.4 1.4 4.5 5 15.7c3.2 10-.5 21-9.1 27s-20.2 5.7-28.5-.7l-13-10.1-3.7-2.9-.3-.3L288 406.4l-112.2 87.3-.3.3-3.7 2.9-13 10.1c-8.3 6.5-19.8 6.8-28.5.7s-12.3-16.9-9.1-27l5-15.7 1.4-4.5.1-.4 44.4-139.5-114-88.6-.1-.1-2-1.5zm232 105.1 34.4 26.7 47.9 37.2-19.7-61.8-11.8-37.2 30.8-24 57.1-44.4H320.6l-12.4-39-20.2-63.5v206z"
        }
    ]
};

const FasStarSharpHalf = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasStarSharpHalf",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M254.4 50.4 214.5 176H56c-10.3 0-19.4 6.5-22.7 16.2s-.1 20.4 8 26.7L56 230.4l10.5 8.2 1.8 1.4L172 320.7l-40 126-1.1 3.5-4.8 14.8-5 15.7c-3.2 10 .5 21 9.1 27s20.2 5.7 28.5-.7l13-10.1 12.3-9.5 2.9-2.3L288 406.4V0c-10.5 0-19.7 6.8-22.9 16.7L260 32.9l-4.6 14.3-1 3.2z"
        }
    ]
};

const FasStarSharp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasStarSharp",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M310.9 16.7C307.7 6.8 298.5 0 288 0s-19.7 6.8-22.9 16.7L214.5 176H56c-10.3 0-19.4 6.5-22.7 16.2s-.1 20.4 8 26.7l130.8 101.8-51 160c-3.2 10 .5 21 9.1 27s20.2 5.7 28.5-.7L288 406.4l129.3 100.5c8.3 6.5 19.8 6.8 28.5.7s12.3-16.9 9.1-27l-51-159.9 130.8-101.8c8.1-6.3 11.3-17 8-26.7S530.3 176 520 176H361.5L310.9 16.7z"
        }
    ]
};

const FasStarShooting = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasStarShooting",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m313 41-48 48c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L279 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM170.4 157.4c8.8-17.9 34.3-17.9 43.1 0l46.3 94 103.5 15.1c19.7 2.9 27.5 27 13.3 40.9l-74.9 73.2 17.7 103.3c3.4 19.6-17.2 34.6-34.8 25.3L192 460.4l-92.7 48.8c-17.6 9.3-38.2-5.7-34.8-25.3l17.7-103.3-75-73.2C-7 293.5.9 269.3 20.5 266.5L124 251.4l46.3-94zM505 199c9.4 9.4 9.4 24.6 0 33.9l-48 48c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l48-48c9.4-9.4 24.6-9.4 33.9 0zm0-158L361 185c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L471 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
        }
    ]
};

const FasStar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasStar",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M316.9 18c-5.3-11-16.5-18-28.8-18s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329l-24.6 145.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329l104.2-103.1c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7l-143.7-21.2L316.9 18z"
        }
    ]
};

const FasStarfighterTwinIonEngineAdvanced = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasStarfighterTwinIonEngineAdvanced",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M148.8 7.7c13.4 11.5 15 31.7 3.5 45.1L64 155.8v61.8l107.6-21.5C195.3 137.4 252.8 96 320 96s124.7 41.4 148.4 100.1L576 217.6v-69.1l-87.5-94.8c-12-13-11.2-33.2 1.8-45.2s33.2-11.2 45.2 1.8l87.5 94.8c10.9 11.8 17 27.3 17 43.4v200.3c0 14.5-4.9 28.6-14 40L537 500c-11 13.8-31.2 16-45 5s-16-31.2-5-45l89-111.2v-54.4l-107.6 21.5C444.7 374.6 387.2 416 320 416s-124.7-41.4-148.4-100.1L64 294.4v61.8l88.3 103c11.5 13.4 9.9 33.6-3.5 45.1s-33.6 9.9-45.1-3.5l-88.3-103C5.5 386.2 0 371.4 0 356.2V155.8c0-15.3 5.5-30.1 15.4-41.7l88.3-103c11.5-13.4 31.7-15 45.1-3.5zm155.2 343V318c-5.9-1.5-11.4-3.8-16.5-6.8l-23.1 23.1c11.6 8.2 25 14 39.6 16.4zm-62.3-39 23.1-23.1c-3-5.1-5.3-10.6-6.8-16.5h-32.7c2.4 14.6 8.2 28.1 16.4 39.6zM225.3 240H258c1.5-5.9 3.8-11.4 6.8-16.5l-23.1-23.1c-8.2 11.6-14 25-16.4 39.6zm39-62.3 23.1 23.1c5.1-3 10.6-5.3 16.5-6.8v-32.7c-14.6 2.4-28.1 8.2-39.6 16.4zm111.3 156.6-23.1-23.1c-5.1 3-10.6 5.3-16.5 6.8v32.7c14.6-2.4 28.1-8.2 39.6-16.4zm22.6-22.6c8.2-11.6 14-25 16.4-39.6H382c-1.5 5.9-3.8 11.4-6.8 16.5l23.1 23.1zM382 240h32.7c-2.4-14.6-8.2-28.1-16.4-39.6l-23.1 23.1c3 5.1 5.3 10.6 6.8 16.5zm-6.4-62.3c-11.6-8.2-25-14-39.6-16.4V194c5.9 1.5 11.4 3.8 16.5 6.8l23.1-23.1zm-32.8 100.8c5.7-5.8 9.2-13.7 9.2-22.5 0-17.7-14.3-32-32-32s-32 14.3-32 32 14.3 32 32 32c8.8 0 16.7-3.5 22.5-9.2l.3-.3z"
        }
    ]
};

const FasStarfighterTwinIonEngine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasStarfighterTwinIonEngine",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 32c17.7 0 32 14.3 32 32v147.2l75.6-15.1C163.3 137.4 220.8 96 288 96s124.7 41.4 148.4 100.1l75.6 15.1V64c0-17.7 14.3-32 32-32s32 14.3 32 32v384c0 17.7-14.3 32-32 32s-32-14.3-32-32V300.8l-75.6 15.1C412.7 374.6 355.2 416 288 416s-124.7-41.4-148.4-100.1L64 300.8V448c0 17.7-14.3 32-32 32S0 465.7 0 448V64c0-17.7 14.3-32 32-32zm240 318.7V318c-5.9-1.5-11.4-3.8-16.5-6.8l-23.1 23.1c11.6 8.2 25 14 39.6 16.4zm-62.3-39 23.1-23.1c-3-5.1-5.3-10.6-6.8-16.5h-32.7c2.4 14.6 8.2 28.1 16.4 39.6zM193.3 240H226c1.5-5.9 3.8-11.4 6.8-16.5l-23.1-23.1c-8.2 11.6-14 25-16.4 39.6zm39-62.3 23.1 23.1c5.1-3 10.6-5.3 16.5-6.8v-32.7c-14.6 2.4-28.1 8.2-39.6 16.4zm111.3 156.6-23.1-23.1c-5.1 3-10.6 5.3-16.5 6.8v32.7c14.6-2.4 28.1-8.2 39.6-16.4zm22.6-22.6c8.2-11.6 14-25 16.4-39.6H350c-1.5 5.9-3.8 11.4-6.8 16.5l23.1 23.1zM350 240h32.7c-2.4-14.6-8.2-28.1-16.4-39.6l-23.1 23.1c3 5.1 5.3 10.6 6.8 16.5zm-6.4-62.3c-11.6-8.2-25-14-39.6-16.4V194c5.9 1.5 11.4 3.8 16.5 6.8l23.1-23.1zm-32.8 100.8c5.7-5.8 9.2-13.7 9.2-22.5 0-17.7-14.3-32-32-32s-32 14.3-32 32 14.3 32 32 32c8.8 0 16.7-3.5 22.5-9.2l.3-.3z"
        }
    ]
};

const FasStarfighter = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasStarfighter",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M353.8 14 384 256v208c0 8.8-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16V256l30.2-242c1-8 7.8-14 15.9-14h35.8c8.1 0 14.9 6 15.9 14zM288 256v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-48c0-17.7-14.3-32-32-32s-32 14.3-32 32zM48 72c13.3 0 24 10.7 24 24v24c13.3 0 24 10.7 24 24s-10.7 24-24 24v184h56v-32c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32v160c0 17.7-14.3 32-32 32s-32-14.3-32-32v-9.6L72 444v4c0 13.3-10.7 24-24 24s-24-10.7-24-24V168c-13.3 0-24-10.7-24-24s10.7-24 24-24V96c0-13.3 10.7-24 24-24zm544 0c13.3 0 24 10.7 24 24v24c13.3 0 24 10.7 24 24s-10.7 24-24 24v280c0 13.3-10.7 24-24 24s-24-10.7-24-24v-4l-88 26.4v9.6c0 17.7-14.3 32-32 32s-32-14.3-32-32V320c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32v32h56V168c-13.3 0-24-10.7-24-24s10.7-24 24-24V96c0-13.3 10.7-24 24-24z"
        }
    ]
};

const FasStars = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasStars",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M325.8 152.3c1.3 4.6 5.5 7.7 10.2 7.7s8.9-3.1 10.2-7.7L360 104l48.3-13.8c4.6-1.3 7.7-5.5 7.7-10.2s-3.1-8.9-7.7-10.2L360 56 346.2 7.7C344.9 3.1 340.7 0 336 0s-8.9 3.1-10.2 7.7L312 56l-48.3 13.8c-4.6 1.3-7.7 5.5-7.7 10.2s3.1 8.9 7.7 10.2L312 104l13.8 48.3zm-112.4 5.1c-8.8-17.9-34.3-17.9-43.1 0l-46.3 94-103.5 15.1C.9 269.3-7 293.5 7.2 307.4l74.9 73.2-17.6 103.3c-3.4 19.6 17.2 34.6 34.8 25.3l92.6-48.8 92.6 48.8c17.6 9.3 38.2-5.7 34.8-25.3l-17.7-103.3 74.9-73.2c14.2-13.9 6.4-38.1-13.3-40.9l-103.5-15.1-46.3-94zm215.4 85.8 11 38.6c1 3.6 4.4 6.2 8.2 6.2s7.1-2.5 8.2-6.2l11-38.6 38.6-11c3.6-1 6.2-4.4 6.2-8.2s-2.5-7.1-6.2-8.2l-38.6-11-11-38.6c-1-3.6-4.4-6.2-8.2-6.2s-7.1 2.5-8.2 6.2l-11 38.6-38.6 11c-3.6 1-6.2 4.4-6.2 8.2s2.5 7.1 6.2 8.2l38.6 11z"
        }
    ]
};

const FasStarshipFreighter = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasStarshipFreighter",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 480C100.3 480 0 379.7 0 256S100.3 32 224 32c42.3 0 84.2 7.9 123.6 23.2l207.9 80.9c12.3 4.8 20.4 16.6 20.4 29.8V208c0 8.8-7.2 16-16 16H432c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h128c8.8 0 16 7.2 16 16v42.1c0 13.2-8.1 25-20.4 29.8l-82.1 31.9c4.1 7.1 6.5 15.3 6.5 24.1 0 26.5-21.5 48-48 48h-80c-11.5 0-21.6-6.1-27.3-15.2C292.2 474.9 258.2 480 224 480zm0-272a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 128a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM80 272a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm48-112a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm-16 208a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
        }
    ]
};

const FasStarship = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasStarship",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 192a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm0 256a192 192 0 1 0 0-384 192 192 0 1 0 0 384zm32-192a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm-291.1-50.6L137 160h71c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h32.1l65.5 57.3-2.2.4C109.1 221.4 96 237.4 96 256s13.1 34.6 31.4 38.3l2.2.4L64.1 352H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h176c17.7 0 32-14.3 32-32s-14.3-32-32-32h-71l51.9-45.4 43 8.6c-5.2-18.9-7.9-38.7-7.9-59.2s2.7-40.3 7.9-59.2l-43 8.6z"
        }
    ]
};

const FasSteak = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSteak",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M268.8 37.4C295.7 12.4 329.7 0 368 0c65 0 117.7 39 150.5 80 33.9 42.4 57.5 99.6 57.5 160 0 83.9-55.1 152.8-113.4 196.2-60.5 45-140.9 75.8-222.6 75.8-36.8 0-86.5-4.4-130-19.3C73.4 480.1 0 444.3 0 360c0-38.6 17.8-68.3 42.5-88.1 19.6-15.8 41.4-26.8 63.3-37.8 27.3-13.8 54.6-27.6 77.7-50.7 13.8-13.8 19.7-27.9 30-52.9 3.2-7.7 6.8-16.5 11.2-26.6 7.7-17.6 20.6-44.7 44.1-66.5zm36.8 122c2.5-6 4.8-11.8 7.1-17 6.9-15.7 13.3-27.1 21.5-34.7 7.5-7 17.5-11.7 33.9-11.7 25.4 0 53.3 16.2 75.5 44 22 27.5 36.5 64.1 36.5 100 0 40.8-28.3 84.6-74.7 119.2-46 34.2-106.8 56.8-165.4 56.8-31 0-69.1-3.9-98.8-14.1C110.1 391.2 96 376.7 96 360c0-9 2.6-13.2 6.9-16.9 5.8-5 15-9.1 30.2-15.5l1.2-.5c29.3-12.4 71.2-30 117-75.8 28.6-28.6 42.9-63.7 54.3-91.9zm6.8-75.2c-13.3 12.4-21.9 29-29 45.3-2.9 6.6-5.6 13.2-8.3 19.8-11.4 27.8-22.8 55.7-46.4 79.3-41.4 41.4-78.6 57.1-107 69l-1.1.5-.7.3c-13.5 5.7-27.5 11.6-37.7 20.3C70.4 328.8 64 342.1 64 360c0 39.3 33.9 60.8 66.8 72.1C165.1 443.9 207 448 240 448c66.3 0 133.6-25.4 184.4-63.2C474.8 347.4 512 295.2 512 240c0-44.1-17.5-87.5-43.5-120-25.8-32.2-61.9-56-100.5-56-23.7 0-41.7 7.3-55.6 20.3zM384 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FasSteeringWheel = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSteeringWheel",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 358.9v86.5c-80.4-13.5-143.9-77-157.3-157.4h102.2l55.1 70.9zm64 0 55.1-70.9h102.2c-13.4 80.4-76.9 143.9-157.3 157.3v-86.4zM352 224l-7.2-14.3c-5.4-10.8-16.5-17.7-28.6-17.7H195.8c-12.1 0-23.2 6.8-28.6 17.7L160 224H66.7C81.9 133.2 160.9 64 256 64s174.1 69.2 189.3 160H352zm-96 288a256 256 0 1 0 0-512 256 256 0 1 0 0 512z"
        }
    ]
};

const FasSterlingSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSterlingSign",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M112 160.4c0-35.5 28.8-64.4 64.4-64.4 6.9 0 13.8 1.1 20.4 3.3l81.2 27.1c16.8 5.6 34.9-3.5 40.5-20.2s-3.5-34.9-20.2-40.5L217 38.6c-13.1-4.4-26.8-6.6-40.6-6.6C105.5 32 48 89.5 48 160.4V224H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h16v44.5c0 17.4-4.7 34.5-13.7 49.4L4.6 431.5c-5.9 9.9-6.1 22.2-.4 32.2S20.5 480 32 480h256c17.7 0 32-14.3 32-32s-14.3-32-32-32H88.5l.7-1.1c14.9-24.9 22.8-53.4 22.8-82.4V288h112c17.7 0 32-14.3 32-32s-14.3-32-32-32H112v-63.6z"
        }
    ]
};

const FasStethoscope = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasStethoscope",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M142.4 21.9c5.6 16.8-3.5 34.9-20.2 40.5L96 71.1V192c0 53 43 96 96 96s96-43 96-96V71.1l-26.1-8.7c-16.8-5.6-25.8-23.7-20.2-40.5s23.7-25.8 40.5-20.2l26.1 8.7c26.1 8.7 43.7 33.1 43.7 60.7V192c0 77.2-54.6 141.6-127.3 156.7C231 404.6 278.4 448 336 448c61.9 0 112-50.1 112-112v-70.7c-28.3-12.3-48-40.5-48-73.3 0-44.2 35.8-80 80-80s80 35.8 80 80c0 32.8-19.7 61-48 73.3V336c0 97.2-78.8 176-176 176-92.9 0-168.9-71.9-175.5-163.1C87.2 334.2 32 269.6 32 192V71.1c0-27.5 17.6-52 43.8-60.7l26.1-8.7c16.8-5.6 34.9 3.5 40.5 20.2zM480 224a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FasStocking = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasStocking",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 0C78.3 0 64 14.3 64 32v32c0 17.7 14.3 32 32 32h256c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H96zm0 128v110.9c0 10.7-5.3 20.7-14.2 26.6l-26.1 17.4C20.9 306.1 0 345.1 0 386.9v2.2C0 457 55 512 122.8 512c24.2 0 48-7.2 68.1-20.6L295 422c35.6-23.7 57-63.7 57-106.5V128H96z"
        }
    ]
};

const FasStomach = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasStomach",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 32c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 70.7 57.3 128 128 128v64c0 35.3-28.7 64-64 64h-64C57.3 352 0 409.3 0 480c0 17.7 14.3 32 32 32s32-14.3 32-32c0-26.5 21.5-48 48-48 24.6 0 36 9.5 58.2 28.2 1.7 1.4 3.4 2.9 5.3 4.4 12.6 10.5 28.4 22.9 49.6 32.2C246.5 506.2 272 512 304 512c114.9 0 208-93.1 208-208v-80c0-70.7-57.3-128-128-128-47.4 0-88.7 25.7-110.9 64H256c-35.3 0-64-28.7-64-64V32zm253.1 300.7c-7.2 1.9-14.6 3.3-21.1 3.3-16.8.2-28.4-7.9-40-16s-23.2-16.3-40-16c-7.9.1-17.1 2.1-25.6 4.6 1.1-6.7 1.6-13.6 1.6-20.6v-64c0-35.3 28.7-64 64-64s64 28.7 64 64v80c0 9.8-1 19.4-2.9 28.7z"
        }
    ]
};

const FasStop = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasStop",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 128c0-35.3 28.7-64 64-64h256c35.3 0 64 28.7 64 64v256c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128z"
        }
    ]
};

const FasStopwatch20 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasStopwatch20",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h16v34.4C92.3 113.8 16 200 16 304c0 114.9 93.1 208 208 208s208-93.1 208-208c0-41.8-12.3-80.7-33.5-113.2l24.1-24.1c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L355.7 143c-28.1-23-62.2-38.8-99.7-44.6V64h16c17.7 0 32-14.3 32-32S289.7 0 272 0h-96zm112 204c28.7 0 52 23.3 52 52v96c0 28.7-23.3 52-52 52s-52-23.3-52-52v-96c0-28.7 23.3-52 52-52zm-12 52v96c0 6.6 5.4 12 12 12s12-5.4 12-12v-96c0-6.6-5.4-12-12-12s-12 5.4-12 12zm-116.5-12c-5.4 0-10.2 3.5-11.9 8.6l-.6 1.7c-3.5 10.5-14.8 16.1-25.3 12.6s-16.1-14.8-12.6-25.3l.6-1.7c7.2-21.5 27.2-35.9 49.8-35.9 29 0 52.5 23.5 52.5 52.5v2.2c0 13.4-4.9 26.4-13.8 36.4l-39 43.9c-6.2 7-10 15.7-10.9 24.9H192c11 0 20 9 20 20s-9 20-20 20h-64c-11 0-20-9-20-20v-15.6c0-20.6 7.5-40.4 21.2-55.8l39-43.9c2.4-2.7 3.7-6.2 3.7-9.8v-2.2c0-6.9-5.6-12.5-12.5-12.5z"
        }
    ]
};

const FasStopwatch = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasStopwatch",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h16v34.4C92.3 113.8 16 200 16 304c0 114.9 93.1 208 208 208s208-93.1 208-208c0-41.8-12.3-80.7-33.5-113.2l24.1-24.1c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L355.7 143c-28.1-23-62.2-38.8-99.7-44.6V64h16c17.7 0 32-14.3 32-32S289.7 0 272 0h-96zm72 192v128c0 13.3-10.7 24-24 24s-24-10.7-24-24V192c0-13.3 10.7-24 24-24s24 10.7 24 24z"
        }
    ]
};

const FasStoreLock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasStoreLock",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m547.6 103.8-57.3-90.7C485.2 5 476.1 0 466.4 0H109.6c-9.7 0-18.8 5-23.9 13.1l-57.4 90.7c-29.6 46.8-3.4 111.9 51.9 119.4 4 .5 8.1.8 12.1.8 26.1 0 49.3-11.4 65.2-29 15.9 17.6 39.1 29 65.2 29s49.3-11.4 65.2-29c15.9 17.6 39.1 29 65.2 29 26.2 0 49.3-11.4 65.2-29 5 5.5 10.6 10.3 16.8 14.4 20.1-29.8 54.2-49.4 92.9-49.4 10.4 0 20.5 1.4 30.1 4.1 4.4-19.8 1.5-41.5-10.4-60.3zM128 384V250.6c-11.2 3.5-23.2 5.4-35.6 5.4-5.5 0-11-.4-16.3-1.1H76c-4.1-.6-8.1-1.3-12-2.3V448c0 35.3 28.7 64 64 64h264.6c-5.4-9.4-8.6-20.3-8.6-32v-96H128zm400-144c17.7 0 32 14.3 32 32v48h-64v-48c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32v128c0 17.7 14.3 32 32 32h160c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32v-48c0-44.2-35.8-80-80-80s-80 35.8-80 80z"
        }
    ]
};

const FasStoreSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasStoreSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-86.8-68V252.6c-4 1-8 1.8-12.3 2.3h-.1c-5.3.7-10.7 1.1-16.2 1.1-12.4 0-24.3-1.9-35.4-5.3v100.2L301.2 210.7c7-4.4 13.3-9.7 18.8-15.7 15.9 17.6 39.1 29 65.2 29 26.2 0 49.3-11.4 65.2-29 16 17.6 39.1 29 65.2 29 4.1 0 8.1-.3 12.1-.8 55.5-7.4 81.8-72.5 52.1-119.4l-57.5-90.7C517.2 5 508.1 0 498.4 0H141.6c-9.7 0-18.8 5-23.9 13.1L95 49.1l-56.2-44zm73.4 218.1c4 .5 8.1.8 12.1.8 11 0 21.4-2 31-5.6L48.9 134.5c-6.1 40.6 19.5 82.8 63.3 88.7zM160 384V250.6c-11.2 3.5-23.2 5.4-35.6 5.4-5.5 0-11-.4-16.3-1.1h-.1c-4.1-.6-8.1-1.3-12-2.3V448c0 35.3 28.7 64 64 64h320c12.9 0 24.8-3.8 34.9-10.3L365.5 384H160z"
        }
    ]
};

const FasStore = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasStore",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m547.6 103.8-57.3-90.7C485.2 5 476.1 0 466.4 0H109.6c-9.7 0-18.8 5-23.9 13.1l-57.4 90.7c-29.6 46.8-3.4 111.9 51.9 119.4 4 .5 8.1.8 12.1.8 26.1 0 49.3-11.4 65.2-29 15.9 17.6 39.1 29 65.2 29s49.3-11.4 65.2-29c15.9 17.6 39.1 29 65.2 29 26.2 0 49.3-11.4 65.2-29 16 17.6 39.1 29 65.2 29 4.1 0 8.1-.3 12.1-.8 55.5-7.4 81.8-72.5 52.1-119.4zm-47.9 151.1h-.1c-5.3.7-10.7 1.1-16.2 1.1-12.4 0-24.3-1.9-35.4-5.3V384H128V250.6c-11.2 3.5-23.2 5.4-35.6 5.4-5.5 0-11-.4-16.3-1.1H76c-4.1-.6-8.1-1.3-12-2.3V448c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V252.6c-4 1-8 1.8-12.3 2.3z"
        }
    ]
};

const FasStrawberry = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasStrawberry",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M481.5 1.9c12.2 5.2 17.8 19.3 12.6 31.5-13.4 31.2-36.9 59-56.3 78.7 32.8 1.8 57.4 18 68.2 26.6 4 3.2 6 8.1 6 13.2s-2 10-6 13.3c-11 9.2-36.3 26.8-66 26.8-40 0-55.3-15.3-80-40s-40-40-40-80c0-29.7 17.6-55 26.7-66 3.3-4 8.2-6 13.3-6s10 2 13.2 6c9.1 11.4 26.8 38.3 26.8 74v2.1c.7-.7 1.4-1.3 2-2 18.2-18.2 37.7-41.7 47.9-65.5C455.1 2.4 469.2-3.2 481.4 2zM0 336C0 160 96.2 64 192.2 64c32.7.1 65.3 12.6 90.3 37.5l128 128c25 25 37.5 57.8 37.5 90.5 0 96-96 192-272 192C48 512 0 464 0 336zm172.8-163.2c11.9-11.9 14.6-28.3 8.7-34.3s-22.4-3.2-34.3 8.7-14.6 28.3-8.7 34.3 22.4 3.2 34.3-8.7zm72.7 29.7c-5.9-5.9-22.4-3.2-34.3 8.7s-14.6 28.3-8.7 34.3 22.4 3.2 34.3-8.7 14.6-28.3 8.7-34.3zm-32 96c-5.9-5.9-22.4-3.2-34.3 8.7s-14.6 28.3-8.7 34.3 22.4 3.2 34.3-8.7 14.6-28.3 8.7-34.3zm-32 96c-5.9-5.9-22.4-3.2-34.3 8.7s-14.6 28.3-8.7 34.3 22.4 3.2 34.3-8.7 14.6-28.3 8.7-34.3zm87.3 2.3c11.9-11.9 14.6-28.3 8.7-34.3s-22.4-3.2-34.3 8.7-14.6 28.3-8.7 34.3 22.4 3.2 34.3-8.7zm32-96c11.9-11.9 14.6-28.3 8.7-34.3s-22.4-3.2-34.3 8.7-14.6 28.3-8.7 34.3 22.4 3.2 34.3-8.7zm72.7 29.7c-5.9-5.9-22.4-3.2-34.3 8.7s-14.6 28.3-8.7 34.3 22.4 3.2 34.3-8.7 14.6-28.3 8.7-34.3zm-224-96c-5.9-5.9-22.4-3.2-34.3 8.7s-14.6 28.3-8.7 34.3 22.4 3.2 34.3-8.7 14.6-28.3 8.7-34.3zm-40.7 130.3c11.9-11.9 14.6-28.3 8.7-34.3s-22.4-3.2-34.3 8.7-14.6 28.3-8.7 34.3 22.4 3.2 34.3-8.7z"
        }
    ]
};

const FasStreetView = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasStreetView",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 64a64 64 0 1 0-128 0 64 64 0 1 0 128 0zm-96 96c-35.3 0-64 28.7-64 64v48c0 17.7 14.3 32 32 32h1.8l11.1 99.5c1.8 16.2 15.5 28.5 31.8 28.5h38.7c16.3 0 30-12.3 31.8-28.5l11-99.5h1.8c17.7 0 32-14.3 32-32v-48c0-35.3-28.7-64-64-64h-64zm-91.7 234.2c13-2.4 21.7-14.9 19.3-27.9s-14.9-21.7-27.9-19.3c-32.4 5.9-60.9 14.2-82 24.8-10.5 5.3-20.3 11.7-27.8 19.6C6.4 399.5 0 410.5 0 424c0 21.4 15.5 36.1 29.1 45 14.7 9.6 34.3 17.3 56.4 23.4C130.2 504.7 190.4 512 256 512s125.8-7.3 170.4-19.6c22.1-6.1 41.8-13.8 56.4-23.4 13.7-8.9 29.1-23.6 29.1-45 0-13.5-6.4-24.5-14-32.6-7.5-7.9-17.3-14.3-27.8-19.6-21-10.6-49.5-18.9-82-24.8-13-2.4-25.5 6.3-27.9 19.3s6.3 25.5 19.3 27.9c30.2 5.5 53.7 12.8 69 20.5 3.2 1.6 5.8 3.1 7.9 4.5 3.6 2.4 3.6 7.2 0 9.6-8.8 5.7-23.1 11.8-43 17.3C374.3 457 318.5 464 256 464s-118.3-7-157.7-17.9c-19.9-5.5-34.2-11.6-43-17.3-3.6-2.4-3.6-7.2 0-9.6 2.1-1.4 4.8-2.9 7.9-4.5 15.3-7.7 38.8-14.9 69-20.5z"
        }
    ]
};

const FasStretcher = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasStretcher",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M83 79.2C64.9 59.8 34.5 58.9 15.2 77s-20.3 48.5-2.2 67.8l110.5 117.9c15.1 16.1 36.3 25.3 58.4 25.3H592c26.5 0 48-21.5 48-48s-21.5-48-48-48H188.8L83 79.2zM240 448a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm80 0c0-5.3-.7-10.5-1.9-15.5l49.9-36.3 49.9 36.3c-1.2 5-1.9 10.2-1.9 15.5 0 35.3 28.7 64 64 64s64-28.7 64-64-28.7-64-64-64c-12.4 0-24 3.5-33.9 9.7l-37.3-27.1 64-46.5h-81.6L368 336.9 344.8 320h-81.6l64 46.5-37.3 27.1c-9.8-6.1-21.4-9.7-33.9-9.7-35.3 0-64 28.7-64 64s28.7 64 64 64 64-28.7 64-64zm160-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
        }
    ]
};

const FasStrikethrough = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasStrikethrough",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M161.3 144c3.2-17.2 14-30.1 33.7-38.6 21.1-9 51.8-12.3 88.6-6.5 11.9 1.9 48.8 9.1 60.1 12 17.1 4.5 34.6-5.6 39.2-22.7s-5.6-34.6-22.7-39.2c-14.3-3.8-53.6-11.4-66.6-13.4-44.7-7-88.3-4.2-123.7 10.9-36.5 15.6-64.4 44.8-71.8 87.3-.1.6-.2 1.1-.2 1.7-2.8 23.9.5 45.6 10.1 64.6 4.5 9 10.2 16.9 16.7 23.9H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h448c17.7 0 32-14.3 32-32s-14.3-32-32-32H270.1c-.1 0-.3-.1-.4-.1l-1.1-.3c-36-10.8-65.2-19.6-85.2-33.1-9.3-6.3-15-12.6-18.2-19.1-3.1-6.1-5.2-14.6-3.8-27.4zm187.6 193.2c2.7 6.5 4.4 15.8 1.9 30.1-3 17.6-13.8 30.8-33.9 39.4-21.1 9-51.7 12.3-88.5 6.5-18-2.9-49.1-13.5-74.4-22.1-5.6-1.9-11-3.7-15.9-5.4-16.8-5.6-34.9 3.5-40.5 20.3s3.5 34.9 20.3 40.5c3.6 1.2 7.9 2.7 12.7 4.3 24.9 8.5 63.6 21.7 87.6 25.6h.2c44.7 7 88.3 4.2 123.7-10.9 36.5-15.6 64.4-44.8 71.8-87.3 3.6-21 2.7-40.4-3.1-58.1h-75.7c7 5.6 11.4 11.2 13.9 17.2z"
        }
    ]
};

const FasStroopwafel = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasStroopwafel",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zM312.6 63.7c-6.2-6.2-16.4-6.2-22.6 0l-34 33.9-33.9-33.9c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l33.9 33.9-45.3 45.3-56.6-56.6c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l56.6 56.6-45.3 45.3-33.9-34c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l33.9 34-33.9 33.9c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l33.9-33.9 45.3 45.3-56.6 56.6c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l56.6-56.6 45.3 45.3-33.9 33.9c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l33.9-33.9 33.9 33.9c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-33.9-33.9 45.3-45.3 56.6 56.6c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-56.6-56.6 45.3-45.3 33.9 33.9c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L414.4 256l33.9-33.9c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-33.9 33.9-45.3-45.3 56.6-56.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-56.6 56.6-45.3-45.3 33.9-33.9c6.2-6.2 6.2-16.4 0-22.6zM142.9 256l45.3-45.3 45.2 45.3-45.3 45.3-45.2-45.3zm67.9 67.9 45.2-45.3 45.3 45.3-45.3 45.2-45.3-45.3zm67.8-67.9 45.3-45.3 45.2 45.3-45.3 45.3-45.2-45.3zm22.6-67.9L256 233.4l-45.3-45.3 45.3-45.2 45.3 45.3z"
        }
    ]
};

const FasSubscript = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSubscript",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 64C14.3 64 0 78.3 0 96s14.3 32 32 32h15.3l89.6 128-89.6 128H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h32c10.4 0 20.2-5.1 26.2-13.6L176 311.8l85.8 122.6c6 8.6 15.8 13.6 26.2 13.6h32c17.7 0 32-14.3 32-32s-14.3-32-32-32h-15.3l-89.6-128 89.6-128H320c17.7 0 32-14.3 32-32s-14.3-32-32-32h-32c-10.4 0-20.2 5.1-26.2 13.6L176 200.2 90.2 77.6C84.2 69.1 74.4 64 64 64H32zm448 256c0-11.1-5.7-21.4-15.2-27.2s-21.2-6.4-31.1-1.4l-32 16c-15.8 7.9-22.2 27.1-14.3 42.9C393 361.5 404.3 368 416 368v80c-17.7 0-32 14.3-32 32s14.3 32 32 32h64c17.7 0 32-14.3 32-32s-14.3-32-32-32V320z"
        }
    ]
};

const FasSubtitlesSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSubtitlesSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-30-23.5c4.6-8.8 7.2-18.9 7.2-29.6V96c0-35.3-28.7-64-64-64H96c-6.7 0-13.1 1-19.2 2.9l-38-29.8zm355 278.2-1.2-.9c-5.3-4.4-8.6-11-8.6-18.4 0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24s-10.7 24-24 24h-80c-5.3 0-10.2-1.7-14.2-4.6zM461 336h27c13.3 0 24 10.7 24 24 0 4.8-1.4 9.3-3.8 13L461 336zm26.4 144-121.9-96H312c-13.3 0-24-10.7-24-24 0-11.1 7.5-20.4 17.7-23.2l-62-48.8H152c-13.3 0-24-10.7-24-24s10.7-24 24-24h30.8L32 121.2V416c0 35.3 28.7 64 64 64h391.4zM152 336h80c13.3 0 24 10.7 24 24s-10.7 24-24 24h-80c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
        }
    ]
};

const FasSubtitles = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSubtitles",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm56 208h176c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24s10.7-24 24-24zm256 0h80c13.3 0 24 10.7 24 24s-10.7 24-24 24h-80c-13.3 0-24-10.7-24-24s10.7-24 24-24zm-256 96h80c13.3 0 24 10.7 24 24s-10.7 24-24 24h-80c-13.3 0-24-10.7-24-24s10.7-24 24-24zm160 0h176c13.3 0 24 10.7 24 24s-10.7 24-24 24H280c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
        }
    ]
};

const FasSuitcaseMedical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSuitcaseMedical",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M184 48h144c4.4 0 8 3.6 8 8v40H176V56c0-4.4 3.6-8 8-8zm-56 8v424h256V56c0-30.9-25.1-56-56-56H184c-30.9 0-56 25.1-56 56zM96 96H64c-35.3 0-64 28.7-64 64v256c0 35.3 28.7 64 64 64h32V96zm320 384h32c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64h-32v384zM224 208c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-48v48c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-48h-48c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h48v-48z"
        }
    ]
};

const FasSuitcaseRolling = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSuitcaseRolling",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 56c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v72h-96V56zm176 72h-32V56c0-30.9-25.1-56-56-56h-80c-30.9 0-56 25.1-56 56v72H64c-35.3 0-64 28.7-64 64v224c0 35.3 28.7 64 64 64 0 17.7 14.3 32 32 32s32-14.3 32-32h128c0 17.7 14.3 32 32 32s32-14.3 32-32c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64zm-208 96h160c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 128h160c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FasSuitcase = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSuitcase",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 56v40h160V56c0-4.4-3.6-8-8-8H184c-4.4 0-8 3.6-8 8zm-48 40V56c0-30.9 25.1-56 56-56h144c30.9 0 56 25.1 56 56v424H128V96zm-64 0h32v384H64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64zm384 384h-32V96h32c35.3 0 64 28.7 64 64v256c0 35.3-28.7 64-64 64z"
        }
    ]
};

const FasSunBright = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSunBright",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 0c-13.3 0-24 10.7-24 24v64c0 13.3 10.7 24 24 24s24-10.7 24-24V24c0-13.3-10.7-24-24-24zm0 400c-13.3 0-24 10.7-24 24v64c0 13.3 10.7 24 24 24s24-10.7 24-24v-64c0-13.3-10.7-24-24-24zm232-120c13.3 0 24-10.7 24-24s-10.7-24-24-24h-64c-13.3 0-24 10.7-24 24s10.7 24 24 24h64zm-376-24c0-13.3-10.7-24-24-24H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h64c13.3 0 24-10.7 24-24zm325-147.1c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-45.3 45.3c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l45.3-45.3zM154.2 357.8c-9.4-9.4-24.6-9.4-33.9 0L75 403.1c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l45.3-45.3c9.4-9.4 9.4-24.6 0-33.9zM403.1 437c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-45.3-45.3c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l45.3 45.3zM154.2 154.2c9.4-9.4 9.4-24.6 0-33.9L108.9 75c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l45.3 45.3c9.4 9.4 24.6 9.4 33.9 0zM256 368a112 112 0 1 0 0-224 112 112 0 1 0 0 224z"
        }
    ]
};

const FasSunCloud = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSunCloud",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M361.5 1.2c5 2.1 8.6 6.6 9.6 11.9L391 121l107.9 19.8c5.3 1 9.8 4.6 11.9 9.6s1.5 10.7-1.6 15.2l-20.1 29.1C481 193 472.6 192 464 192c-32.9 0-62.4 14.2-82.9 36.7C368.6 171.1 317.3 128 256 128c-70.7 0-128 57.3-128 128s57.3 128 128 128c12.4 0 24.5-1.8 35.8-5.1 11.3 38.8 46.5 67.5 88.7 69l-9.4 51c-1 5.3-4.6 9.8-9.6 11.9s-10.7 1.5-15.2-1.6L256 446.9l-90.3 62.3c-4.5 3.1-10.2 3.7-15.2 1.6s-8.6-6.6-9.6-11.9L121 391 13.1 371.1c-5.3-1-9.8-4.6-11.9-9.6s-1.5-10.7 1.6-15.2L65.1 256 2.8 165.7c-3.1-4.5-3.7-10.2-1.6-15.2s6.6-8.6 11.9-9.6L121 121l19.9-107.9c1-5.3 4.6-9.8 9.6-11.9s10.7-1.5 15.2 1.6L256 65.1l90.3-62.3c4.5-3.1 10.2-3.7 15.2-1.6zM352 256c0 1.9-.1 3.7-.2 5.5-35.6 12.6-61.5 45.6-63.7 85-10.1 3.6-20.9 5.5-32.2 5.5-53 0-96-43-96-96s43-96 96-96 96 43 96 96zm32 160c-35.3 0-64-28.7-64-64s28.7-64 64-64h1.6c7.4-36.5 39.7-64 78.4-64 35 0 64.8 22.5 75.6 53.8 8.7-3.7 18.3-5.8 28.4-5.8 39.8 0 72 32.2 72 72s-32.2 72-72 72H384z"
        }
    ]
};

const FasSunDust = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSunDust",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M371.1 13.1 391 121l-44.5 44.5C323.3 142.3 291.3 128 256 128c-70.7 0-128 57.3-128 128 0 35.3 14.3 67.3 37.5 90.5L121 391 13.1 371.1c-5.3-1-9.8-4.6-11.9-9.6s-1.5-10.7 1.6-15.2L65.1 256 2.8 165.7c-3.1-4.5-3.7-10.2-1.6-15.2s6.6-8.6 11.9-9.6L121 121l19.9-107.9c1-5.3 4.6-9.8 9.6-11.9s10.7-1.5 15.2 1.6L256 65.1l90.3-62.3c4.5-3.1 10.2-3.7 15.2-1.6s8.6 6.6 9.6 11.9zM256 160c26.5 0 50.5 10.7 67.9 28.1L188.1 323.9C170.7 306.5 160 282.5 160 256c0-53 43-96 96-96zm192 0a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm-80 80a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm112 48a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-240 80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-80 80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-112-48a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm-48-112a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FasSunHaze = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSunHaze",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M425.5 1.2c5 2.1 8.6 6.6 9.6 11.9L455 121l107.9 19.8c5.3 1 9.8 4.6 11.9 9.6s1.5 10.7-1.6 15.2L510.9 256H448c0-70.7-57.3-128-128-128s-128 57.3-128 128h-62.9l-62.3-90.3c-3.1-4.5-3.7-10.2-1.6-15.2s6.6-8.6 11.9-9.6L185 121l19.9-107.9c1-5.3 4.6-9.8 9.6-11.9s10.7-1.5 15.2 1.6L320 65.1l90.3-62.3c4.5-3.1 10.2-3.7 15.2-1.6zM320 160c53 0 96 43 96 96H224c0-53 43-96 96-96zm296 128c13.3 0 24 10.7 24 24s-10.7 24-24 24H504c-13.3 0-24-10.7-24-24s10.7-24 24-24h112zm-208 0c13.3 0 24 10.7 24 24s-10.7 24-24 24H88c-13.3 0-24-10.7-24-24s10.7-24 24-24h320zm144 88c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h528zM64 488c0-13.3 10.7-24 24-24h112c13.3 0 24 10.7 24 24s-10.7 24-24 24H88c-13.3 0-24-10.7-24-24zm208 0c0-13.3 10.7-24 24-24h320c13.3 0 24 10.7 24 24s-10.7 24-24 24H296c-13.3 0-24-10.7-24-24z"
        }
    ]
};

const FasSunPlantWilt = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSunPlantWilt",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 0c-6.3 0-12 3.7-14.6 9.5l-24.8 55.4-56.7-21.7c-5.9-2.3-12.6-.8-17 3.6s-5.9 11.1-3.6 17L65 120.5 9.5 145.4C3.7 148 0 153.7 0 160s3.7 12 9.5 14.6l55.4 24.8-21.7 56.7c-2.3 5.9-.8 12.6 3.6 17s11.1 5.9 17 3.6l56.7-21.7 24.8 55.4c2.6 5.8 8.3 9.5 14.6 9.5s12-3.7 14.6-9.5l24.8-55.4 56.7 21.7c5.9 2.3 12.6.8 17-3.6s5.9-11.1 3.6-17l-21.7-56.7 55.4-24.8c5.8-2.6 9.5-8.3 9.5-14.6s-3.7-12-9.5-14.6l-55.4-24.8 21.7-56.7c2.3-5.9.8-12.6-3.6-17s-11.1-5.9-17-3.6l-56.6 21.6-24.8-55.4C172 3.7 166.3 0 160 0zm0 96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm32 64a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm312 16c0-17.7 14.3-32 32-32s32 14.3 32 32v53.4c-14.8 7.7-24 23.1-24 44.6 0 16.8 16 44 37.4 67.2 5.8 6.2 15.5 6.2 21.2 0C624 318 640 290.7 640 274c0-21.5-9.2-37-24-44.6V176c0-44.2-35.8-80-80-80s-80 35.8-80 80v22.7c-9.8-4.3-20.6-6.7-32-6.7-44.2 0-80 35.8-80 80v21.4c-14.8 7.7-24 23.1-24 44.6 0 16.8 16 44 37.4 67.2 5.8 6.2 15.5 6.2 21.2 0C400 382 416 354.7 416 338c0-21.5-9.2-37-24-44.6V272c0-17.7 14.3-32 32-32s32 14.3 32 32v176H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h576c17.7 0 32-14.3 32-32s-14.3-32-32-32H504V176z"
        }
    ]
};

const FasSun = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSun",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M361.5 1.2c5 2.1 8.6 6.6 9.6 11.9L391 121l107.9 19.8c5.3 1 9.8 4.6 11.9 9.6s1.5 10.7-1.6 15.2L446.9 256l62.3 90.3c3.1 4.5 3.7 10.2 1.6 15.2s-6.6 8.6-11.9 9.6L391 391l-19.9 107.9c-1 5.3-4.6 9.8-9.6 11.9s-10.7 1.5-15.2-1.6L256 446.9l-90.3 62.3c-4.5 3.1-10.2 3.7-15.2 1.6s-8.6-6.6-9.6-11.9L121 391 13.1 371.1c-5.3-1-9.8-4.6-11.9-9.6s-1.5-10.7 1.6-15.2L65.1 256 2.8 165.7c-3.1-4.5-3.7-10.2-1.6-15.2s6.6-8.6 11.9-9.6L121 121l19.9-107.9c1-5.3 4.6-9.8 9.6-11.9s10.7-1.5 15.2 1.6L256 65.1l90.3-62.3c4.5-3.1 10.2-3.7 15.2-1.6zM160 256a96 96 0 1 1 192 0 96 96 0 1 1-192 0zm224 0a128 128 0 1 0-256 0 128 128 0 1 0 256 0z"
        }
    ]
};

const FasSunglasses = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSunglasses",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M118.6 80c-11.5 0-21.4 7.9-24 19.1L57 260.3c20.5-6.2 48.3-12.3 78.7-12.3 32.3 0 61.8 6.9 82.8 13.5 10.6 3.3 19.3 6.7 25.4 9.2 3.1 1.3 5.5 2.4 7.3 3.2.9.4 1.6.7 2.1 1l.6.3.2.1h.1l-6.3 12.7 6.3-12.7c5.8 2.9 10.4 7.3 13.5 12.7h40.6c3.1-5.3 7.7-9.8 13.5-12.7l6.3 12.7-6.3-12.7h.1l.2-.1.6-.3c.5-.2 1.2-.6 2.1-1 1.8-.8 4.2-1.9 7.3-3.2 6.1-2.6 14.8-5.9 25.4-9.2 21-6.6 50.4-13.5 82.8-13.5 30.4 0 58.2 6.1 78.7 12.3L481.4 99.1c-2.6-11.2-12.6-19.1-24-19.1-3.1 0-6.2.6-9.2 1.8l-31.3 12.5c-12.3 4.9-26.3-1.1-31.2-13.4s1.1-26.3 13.4-31.2l31.3-12.5c8.6-3.4 17.7-5.2 27-5.2 33.8 0 63.1 23.3 70.8 56.2l43.9 188c1.7 7.3 2.9 14.7 3.5 22.1.3 1.9.5 3.8.5 5.7v64c0 61.9-50.1 112-112 112h-44.4c-59.4 0-108.5-46.4-111.8-105.8l-1.3-22.2h-37.2l-1.2 22.2C264.9 433.6 215.8 480 156.3 480H112C50.1 480 0 429.9 0 368v-64c0-1.9.2-3.8.5-5.7.6-7.4 1.8-14.8 3.5-22.1l43.9-188C55.5 55.3 84.8 32 118.6 32c9.2 0 18.4 1.8 27 5.2l31.3 12.5c12.3 4.9 18.3 18.9 13.4 31.2s-18.9 18.3-31.2 13.4l-31.3-12.5c-2.9-1.2-6-1.8-9.2-1.8zM64 325.4V368l105.6-52.8c-10.7-1.9-22.2-3.2-33.9-3.2-23.7 0-46.2 5.1-63.2 10.5-3.1 1-5.9 1.9-8.5 2.9zm409.8-10.3c-10.5-1.9-21.9-3.1-33.4-3.1-23.7 0-46.4 5.1-63.6 10.5-2.7.8-5.2 1.7-7.5 2.5l2.3 41.2 102.3-51.1z"
        }
    ]
};

const FasSunrise = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSunrise",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M354.5 135.7 320 104.3V208c0 17.7-14.3 32-32 32s-32-14.3-32-32V104.3l-34.5 31.3c-13.1 11.9-33.3 10.9-45.2-2.2s-10.9-33.3 2.2-45.2l88-80c12.2-11.1 30.8-11.1 43.1 0l88 80c13.1 11.9 14 32.1 2.2 45.2s-32.1 14-45.2 2.2zm39.1 89.5c5 2.1 8.6 6.6 9.6 11.9L423 345l107.9 19.8c5.3 1 9.8 4.6 11.9 9.6s1.5 10.7-1.6 15.2L512 432H406.7c-19-46.9-65-80-118.7-80s-99.7 33.1-118.7 80H64l-29.2-42.3c-3.1-4.5-3.7-10.2-1.6-15.2s6.6-8.6 11.9-9.6L153 345l19.8-107.9c1-5.3 4.6-9.8 9.6-11.9s10.7-1.5 15.2 1.6l90.4 62.3 90.3-62.3c4.5-3.1 10.2-3.7 15.2-1.6zM0 488c0-13.3 10.7-24 24-24h528c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24z"
        }
    ]
};

const FasSunset = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSunset",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M354.5 104.3 320 135.7V32c0-17.7-14.3-32-32-32s-32 14.3-32 32v103.7l-34.5-31.3c-13.1-11.9-33.3-10.9-45.2 2.2s-10.9 33.3 2.2 45.2l88 80c12.2 11.1 30.8 11.1 43.1 0l88-80c13.1-11.9 14-32.1 2.2-45.2s-32.1-14-45.2-2.2zm48.7 132.8c-1-5.3-4.6-9.8-9.6-11.9s-10.7-1.5-15.2 1.6L288 289.1l-90.3-62.3c-4.5-3.1-10.2-3.7-15.2-1.6s-8.6 6.6-9.6 11.9L153 345 45.1 364.9c-5.3 1-9.8 4.6-11.9 9.6s-1.5 10.7 1.6 15.2L64 432h105.3c19-46.9 65-80 118.7-80s99.7 33.1 118.7 80H512l29.2-42.3c3.1-4.5 3.7-10.2 1.6-15.2s-6.6-8.6-11.9-9.6L423 345l-19.9-107.9zM0 488c0 13.3 10.7 24 24 24h528c13.3 0 24-10.7 24-24s-10.7-24-24-24H24c-13.3 0-24 10.7-24 24z"
        }
    ]
};

const FasSuperscript = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSuperscript",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 32c0-11.1-5.7-21.4-15.2-27.2s-21.2-6.4-31.1-1.4l-32 16c-15.8 7.9-22.2 27.1-14.3 42.9C393 73.5 404.3 80 416 80v80c-17.7 0-32 14.3-32 32s14.3 32 32 32h64c17.7 0 32-14.3 32-32s-14.3-32-32-32V32zM32 64C14.3 64 0 78.3 0 96s14.3 32 32 32h15.3l89.6 128-89.6 128H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h32c10.4 0 20.2-5.1 26.2-13.6L176 311.8l85.8 122.6c6 8.6 15.8 13.6 26.2 13.6h32c17.7 0 32-14.3 32-32s-14.3-32-32-32h-15.3l-89.6-128 89.6-128H320c17.7 0 32-14.3 32-32s-14.3-32-32-32h-32c-10.4 0-20.2 5.1-26.2 13.6L176 200.2 90.2 77.6C84.2 69.1 74.4 64 64 64H32z"
        }
    ]
};

const FasSushiRoll = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSushiRoll",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 368V144c0-61.9-100.3-112-224-112S0 82.1 0 144v224c0 61.9 100.3 112 224 112s224-50.1 224-112zM308.2 198.4c-24.5 6.1-53.3 9.6-84.2 9.6-40.7 0-77.8-6.1-106-16.1 14.8-14.8 32.8-26.7 51.4-36.1 20.5-10.3 40.9-17 56.9-20.8 18.2 27.3 46.6 49.9 82 63.4zm-103.1-118c.8 6 2.1 11.9 3.8 17.7-17.3 4.7-37.4 11.8-57.5 21.9-24.5 12.3-49.9 29.4-70.3 52.7C70.2 164.1 64 154.4 64 144c0-32.8 61.7-59.8 141.1-63.6zm40.7.2c78 4.3 138.2 31 138.2 63.4 0 9.8-5.5 19.1-15.4 27.4-69.5-5.5-113.5-48.4-122.8-90.8z"
        }
    ]
};

const FasSushi = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSushi",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m479.7 320-73.8-24.5 100.4-169.9c24.8 26.7 42.1 60.7 48.5 98.8l12.5 75.2c4 23.8-18.8 43.2-41.7 35.6l-7-2.3-38.9-12.9zM393.5 66.1c32.9 4.8 63.2 18 88.7 37.5L374.8 285.2 323.1 268c-14.6-4.9-30-7-45.2-6.4L393.5 66.1zm-36-2.1L235.6 270.4 96.1 318.7 246.6 64h110.9zM21.3 224.4C36.6 132.2 116.1 64.6 209.5 64L49.4 334.8c-22.4 6.6-44.5-12.5-40.6-36l12.4-74.4zM32 384v-15c8.5.7 17.5-.3 26.4-3.4l193-66.9c20-6.9 41.6-7.1 61.7-.4l205.5 68.2c8.6 2.9 17.2 3.8 25.5 3.1V384c0 35.3-28.7 64-64 64-19.1 0-36.3-8.4-48-21.7-11.7 13.3-28.9 21.7-48 21.7s-36.3-8.4-48-21.7c-11.7 13.3-28.9 21.7-48 21.7s-36.3-8.4-48-21.7c-11.7 13.3-28.9 21.7-48 21.7s-36.3-8.4-48-21.7c-11.8 13.3-29 21.7-48.1 21.7-35.3 0-64-28.7-64-64z"
        }
    ]
};

const FasSwapArrows = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSwapArrows",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M105.4 9.4c12.5-12.5 32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L160 109.3V352c0 35.3 28.7 64 64 64s64-28.7 64-64V160c0-70.7 57.3-128 128-128s128 57.3 128 128v242.7l41.4-41.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-96 96c-12.5 12.5-32.8 12.5-45.3 0l-96-96c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l41.3 41.4V160c0-35.3-28.7-64-64-64s-64 28.7-64 64v192c0 70.7-57.3 128-128 128S96 422.7 96 352V109.3l-41.4 41.3c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l96-96z"
        }
    ]
};

const FasSwap = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSwap",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M237 141.6c-5.3 11.2-16.6 18.4-29 18.4h-48v192c0 35.3 28.7 64 64 64s64-28.7 64-64V160c0-70.7 57.3-128 128-128s128 57.3 128 128v192h48c12.4 0 23.7 7.2 29 18.4s3.6 24.5-4.4 34.1l-80 96c-6.1 7.3-15.1 11.5-24.6 11.5s-18.5-4.2-24.6-11.5l-80-96c-7.9-9.5-9.7-22.8-4.4-34.1s16.6-18.4 29-18.4h48V160c0-35.3-28.7-64-64-64s-64 28.7-64 64v192c0 70.7-57.3 128-128 128S96 422.7 96 352V160H48c-12.4 0-23.7-7.2-29-18.4s-3.6-24.5 4.4-34.1l80-96C109.5 4.2 118.5 0 128 0s18.5 4.2 24.6 11.5l80 96c7.9 9.5 9.7 22.8 4.4 34.1z"
        }
    ]
};

const FasSwatchbook = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSwatchbook",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 32C0 14.3 14.3 0 32 0h128c17.7 0 32 14.3 32 32v384c0 53-43 96-96 96S0 469 0 416V32zm223.6 393.9c.3-3.3.4-6.6.4-9.9V154l75.4-75.4c12.5-12.5 32.8-12.5 45.3 0l90.5 90.5c12.5 12.5 12.5 32.8 0 45.3L223.6 425.9zM182.8 512l192-192H480c17.7 0 32 14.3 32 32v128c0 17.7-14.3 32-32 32H182.8zM128 64H64v64h64V64zM64 192v64h64v-64H64zm32 248a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FasSwordLaserAlt = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSwordLaserAlt",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M505.7 40.2c8.7-9.5 8.3-24.1-.7-33.2s-23.7-9.4-33.2-.7L225.1 232h105.1L505.7 40.2zM189.3 256c-12.7 0-24.9 5.1-33.9 14.1l-49 49 27.3 27.3 32 32 27.3 27.3 122.3-122.4c4.6-4.6 5.9-11.5 3.5-17.4s-8.3-9.9-14.8-9.9H189.3zm-7.6 161L160 395.3 54.3 501l3.5 3.5c4.8 4.8 11.3 7.5 18.1 7.5s13.3-2.7 18.1-7.5l87.7-87.5zM43 489.7 148.7 384 128 363.3 22.3 469 43 489.7zm-32-32L116.7 352 95 330.3 7.5 417.9C2.7 422.7 0 429.2 0 436s2.7 13.3 7.5 18.1l3.5 3.5z"
        }
    ]
};

const FasSwordLaser = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSwordLaser",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M505 7c9.1 9.1 9.4 23.7.7 33.2L285.2 281.3l-54.4-54.4 241-220.6c9.5-8.7 24.1-8.3 33.2.7zM195.3 236.7l80 80c6.2 6.2 6.2 16.4 0 22.6-6.1 6.1-15.8 6.2-22.1.5l-81-81c-5.8-6.3-5.6-16 .5-22.1 6.2-6.2 16.4-6.2 22.6 0zm-57.7 57.7 23.7-23.7 80 80-23.7 23.7-80-80zm-11.3 11.3 80 80-20.7 20.7-80-80 20.7-20.7zM87 330.3l94.7 94.7-2.3 2.3-74.4 74.4c-6.7 6.6-15.6 10.3-25 10.3s-18.3-3.7-25-10.3L10.3 457C3.7 450.3 0 441.4 0 432s3.7-18.3 10.3-25l74.3-74.3 2.3-2.3z"
        }
    ]
};

const FasSword = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSword",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M511.8 18.6c.8-5.1-.8-10.3-4.5-13.9S498.5-.6 493.4.2l-75.8 12.6c-16.4 2.7-31.6 10.6-43.4 22.3L166.6 242.7l102.7 102.7 207.5-207.6c11.8-11.8 19.6-27 22.3-43.4l12.6-75.8zM84.7 228.7l-16 16c-5.4 5.4-6.2 13.8-2 20.2l53.1 79.6c2.1 3.2 1.7 7.4-1 10.1l-39.6 39.6c-2.1 2.1-5.3 2.9-8.2 1.9l-33.9-11.3c-5.7-1.9-12.1-.4-16.4 3.9l-16 16c-6.2 6.2-6.2 16.4 0 22.6l80 80c6.2 6.2 16.4 6.2 22.6 0l16-16c4.3-4.3 5.8-10.6 3.9-16.4L115.9 441c-1-2.9-.2-6 1.9-8.2l39.6-39.6c2.7-2.7 6.9-3.1 10.1-1l79.6 53.1c6.3 4.2 14.8 3.4 20.2-2l16-16c6.2-6.2 6.2-16.4 0-22.6l-176-176c-6.2-6.2-16.4-6.2-22.6 0z"
        }
    ]
};

const FasSwordsLaser = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSwordsLaser",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M135 7c-9.1 9.1-9.4 23.7-.7 33.2L360 286.9V181.8L168.2 6.3c-9.5-8.7-24.1-8.4-33.2.7zm263 349.7 49 49 27.3-27.3 32-32 27.4-27.4-122.4-122.3c-4.6-4.6-11.5-5.9-17.4-3.5s-9.9 8.3-9.9 14.8v114.7c0 12.7 5.1 24.9 14.1 33.9zm125.3-4.7L629 457.7l3.5-3.5c4.8-4.8 7.5-11.3 7.5-18.1s-2.7-13.3-7.5-18.1L545 330.3 523.3 352zM512 363.3 491.3 384 597 489.7l20.7-20.7L512 363.3zm-32 32L458.3 417l87.5 87.5c4.8 4.8 11.3 7.5 18.1 7.5s13.3-2.7 18.1-7.5l3.5-3.5L480 395.3zM247.6 211.4 222.9 234c-1.6-3.9-4.7-7.2-8.7-8.8-6-2.5-12.9-1.1-17.4 3.5l-25.4 25.4-4.9-4.9c-12.5-12.3-32.6-12.2-45 .2-12.5 12.5-12.5 32.8 0 45.3l4.7 4.7L7.5 417.9C2.7 422.7 0 429.2 0 436s2.7 13.3 7.5 18.1l50.3 50.3c4.8 4.8 11.3 7.5 18.1 7.5s13.3-2.7 18.1-7.5l115.9-115.7c9-9 14.1-21.2 14.1-33.9v-6.6l74.3-81.2-50.7-55.5zm142.8-45.2 115.3-126c8.7-9.5 8.3-24.1-.7-33.2s-23.7-9.4-33.2-.7L343.7 123.5l46.7 42.7zM152 344a16 16 0 1 1 32 0 16 16 0 1 1-32 0z"
        }
    ]
};

const FasSwords = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSwords",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M4.7 4.7C8.5.9 13.9-.7 19.1.3l70.5 14.1c9.3 1.9 17.8 6.4 24.5 13.1l279.3 279.2-86.6 86.6L27.5 114.2c-6.7-6.7-11.3-15.2-13.1-24.5L.3 19.1c-1-5.2.6-10.6 4.4-14.4zm454.6 304 16 16c4.7 4.7 6 11.8 3.3 17.8l-27.5 62 56.2 56.2c6.2 6.2 6.2 16.4 0 22.6l-24 24c-6.2 6.2-16.4 6.2-22.6 0l-56.2-56.2-62 27.5c-6.1 2.7-13.1 1.4-17.8-3.3l-16-16c-6.2-6.2-6.2-16.4 0-22.6l128-128c6.2-6.2 16.4-6.2 22.6 0zM96 329.4l50.7-50.7 86.6 86.6-50.7 50.7 20.7 20.7c6.2 6.2 6.2 16.4 0 22.6l-16 16c-4.7 4.7-11.8 6-17.8 3.3l-62-27.5-56.2 56.2c-6.2 6.2-16.4 6.2-22.6 0l-24-24c-6.2-6.2-6.2-16.4 0-22.6l56.2-56.2-27.5-62c-2.7-6.1-1.4-13.1 3.3-17.8l16-16c6.2-6.2 16.4-6.2 22.6 0L96 329.4zm388.5-215.2L365.3 233.4l-86.6-86.6L397.8 27.5c6.7-6.7 15.2-11.3 24.5-13.1L492.9.3c5.2-1 10.7.6 14.5 4.4s5.4 9.2 4.4 14.5l-14.2 70.4c-1.9 9.3-6.4 17.8-13.1 24.5z"
        }
    ]
};

const FasSymbols = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSymbols",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M500.3 7.3c7.4 6 11.7 15.1 11.7 24.7v144c0 26.5-28.7 48-64 48s-64-21.5-64-48 28.7-48 64-48V71l-96 19.2V208c0 26.5-28.7 48-64 48s-64-21.5-64-48 28.7-48 64-48V64c0-15.3 10.8-28.4 25.7-31.4l160-32c9.4-1.9 19.1.6 26.6 6.6zM32 0h160c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 64 0 49.7 0 32S14.3 0 32 0zm470.6 342.6-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l160-160c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3zM0 128c0-17.7 14.3-32 32-32h160c17.7 0 32 14.3 32 32s-14.3 32-32 32h-48v32c0 17.7-14.3 32-32 32s-32-14.3-32-32v-32H32c-17.7 0-32-14.3-32-32zm288 200a40 40 0 1 1 80 0 40 40 0 1 1-80 0zm184 104a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm-336.4-58 10.3 10.8 23.5-23.5c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L190 431.3l25.2 26.7c12.2 12.8 11.6 33.1-1.2 45.2s-33.1 11.6-45.2-1.2l-24.1-25.4-12.8 12.8C117.4 503.9 97.7 512 77.3 512 34.6 512 0 477.4 0 434.7v-.9c0-19.4 7.2-38.2 20.3-52.6l13.1-14.4C22.5 354.3 16 337.9 16 320c0-39.8 32.2-72 72-72s72 32.2 72 72c0 21.5-9.4 40.8-24.4 54zm-68 50.3c-2.4 2.6-3.7 6-3.7 9.5v.9c0 7.3 5.9 13.3 13.3 13.3 3.5 0 6.9-1.4 9.4-3.9l14-14-19.5-20.6-13.4 14.8zM104 320a16 16 0 1 0-32 0 16 16 0 1 0 32 0z"
        }
    ]
};

const FasSynagogue = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSynagogue",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M309.8 3.7c5.9-4.9 14.6-4.9 20.5 0l121 100.8c18.2 15.2 28.7 37.7 28.7 61.5v346H352v-96c0-17.7-14.3-32-32-32s-32 14.3-32 32v96H160V166c0-23.7 10.5-46.3 28.8-61.5l121-100.8zM512 512V244.5l28.1-31.2c3-3.4 7.4-5.3 11.9-5.3s8.9 1.9 11.9 5.3l63.8 70.9c7.9 8.8 12.3 20.3 12.3 32.1V448c0 35.3-28.7 64-64 64h-64zM128 244.5V512H64c-35.3 0-64-28.7-64-64V316.3c0-11.9 4.4-23.3 12.3-32.1l63.8-70.9c3-3.4 7.4-5.3 11.9-5.3s8.9 1.9 11.9 5.3l28.1 31.2zm199-120.2c-3.1-5.4-10.9-5.4-13.9 0l-15.9 28.1-32.3-.3c-6.2-.1-10.1 6.7-7 12.1l16.4 27.8-16.4 27.8c-3.2 5.4.7 12.1 7 12.1l32.3-.3 15.8 28.1c3.1 5.4 10.9 5.4 13.9 0l15.9-28.1 32.3.3c6.2.1 10.1-6.7 7-12.1L365.7 192l16.4-27.8c3.2-5.4-.7-12.1-7-12.1l-32.3.3-15.8-28.1z"
        }
    ]
};

const FasSyringe = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasSyringe",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m441 7 32 32 32 32c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-15-15-38.2 38.1 55 55c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-72-72L295 73c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l55 55L422.1 56 407 41c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0zM210.3 155.7l61.1-61.1c.3.3.6.7 1 1l16 16 56 56 56 56 16 16 1 1-191 191a55.924 55.924 0 0 1-39.6 16.4H97.9L41 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l57-57v-88.8c0-14.9 5.9-29.1 16.4-39.6l43.3-43.3 57 57c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-57-57 41.4-41.4 57 57c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-57-57z"
        }
    ]
};

const FasT = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasT",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 32C14.3 32 0 46.3 0 64s14.3 32 32 32h128v352c0 17.7 14.3 32 32 32s32-14.3 32-32V96h128c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"
        }
    ]
};

const FasTableCellsLarge = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTableCellsLarge",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 96v128H288V96h160zm0 192v128H288V288h160zm-224-64H64V96h160v128zM64 288h160v128H64V288zm0-256C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z"
        }
    ]
};

const FasTableCells = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTableCells",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm88 64v64H64V96h88zm56 0h88v64h-88V96zm240 0v64h-88V96h88zM64 224h88v64H64v-64zm232 0v64h-88v-64h88zm64 0h88v64h-88v-64zM152 352v64H64v-64h88zm56 0h88v64h-88v-64zm240 0v64h-88v-64h88z"
        }
    ]
};

const FasTableColumns = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTableColumns",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 96c0-35.3 28.7-64 64-64h384c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm64 64v256h160V160H64zm384 0H288v256h160V160z"
        }
    ]
};

const FasTableLayout = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTableLayout",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm384 64v64H64V96h384zM64 224h64v192H64V224zm384 0v192H192V224h256z"
        }
    ]
};

const FasTableList = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTableList",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 96c0-35.3 28.7-64 64-64h384c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm64 0v64h64V96H64zm384 0H192v64h256V96zM64 224v64h64v-64H64zm384 0H192v64h256v-64zM64 352v64h64v-64H64zm384 0H192v64h256v-64z"
        }
    ]
};

const FasTablePicnic = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTablePicnic",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M319.3 64H96c-17.7 0-32 14.3-32 32s14.3 32 32 32h48.7l-38.4 96H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h448c17.7 0 32-14.3 32-32s-14.3-32-32-32h-74.3l-38.4-96H416c17.7 0 32-14.3 32-32s-14.3-32-32-32h-96.8zm124.8 256h-69l43.2 107.9c6.6 16.4 25.2 24.4 41.6 17.8s24.4-25.2 17.8-41.6L444.1 320zm-307.2 0h-69l-33.6 84.1c-6.6 16.4 1.4 35 17.8 41.6s35-1.4 41.6-17.8L136.9 320zm38.4-96 38.4-96h84.7l38.4 96H175.3z"
        }
    ]
};

const FasTablePivot = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTablePivot",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 96c0-35.3 28.7-64 64-64h64v128H0V96zm448 64H160V32h288c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192h128v224h320V160zm-33.2 86.1c-2.5 6-8.3 9.9-14.8 9.9h-16v48c0 26.5-21.5 48-48 48h-48v16c0 6.5-3.9 12.3-9.9 14.8s-12.9 1.1-17.4-3.5l-32-32c-6.2-6.2-6.2-16.4 0-22.6l32-32c4.6-4.6 11.5-5.9 17.4-3.5s9.9 8.3 9.9 14.8v16h48c8.8 0 16-7.2 16-16v-48h-16c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4l32-32c6.2-6.2 16.4-6.2 22.6 0l32 32c4.6 4.6 5.9 11.5 3.5 17.4z"
        }
    ]
};

const FasTableRows = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTableRows",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 96c0-35.3 28.7-64 64-64h384c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm128 0v128h320V96H128zm320 192H128v128h320V288z"
        }
    ]
};

const FasTableTennisPaddleBall = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTableTennisPaddleBall",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 288c-50.1 0-93.6 28.8-114.6 70.8L132.9 126.3l.6-.6 60.1-60.1c87.5-87.5 229.3-87.5 316.8 0 67.1 67.1 82.7 166.3 46.8 248.3C535.8 297.6 509 288 480 288zM113.3 151.9l240.8 240.8c-1.4 7.5-2.1 15.3-2.1 23.3 0 23.2 6.2 44.9 16.9 63.7-3 .2-6.1.3-9.2.3H357c-33.9 0-66.5-13.5-90.5-37.5l-9.8-9.8c-13.1-13.1-34.6-12.4-46.8 1.7L152.2 501c-5.8 6.7-14.2 10.7-23 11s-17.5-3.1-23.8-9.4l-32-32c-6.3-6.3-9.7-14.9-9.4-23.8s4.3-17.2 11-23l66.6-57.7c14-12.2 14.8-33.7 1.7-46.8l-9.8-9.8c-24-24-37.5-56.6-37.5-90.5v-2.7c0-22.8 6.1-44.9 17.3-64.3zM480 320a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"
        }
    ]
};

const FasTableTree = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTableTree",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm384 128v256H64V160h32v160c0 26.5 21.5 48 48 48h96c8.8 0 16-7.2 16-16s-7.2-16-16-16h-96c-8.8 0-16-7.2-16-16v-50.7c5 1.8 10.4 2.7 16 2.7h32c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32c-8.8 0-16-7.2-16-16v-64h320zm-224 80v32c0 8.8 7.2 16 16 16h160c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16H240c-8.8 0-16 7.2-16 16zm80 80c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-96z"
        }
    ]
};

const FasTable = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTable",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 256v-96h160v96H64zm0 64h160v96H64v-96zm224 96v-96h160v96H288zm160-160H288v-96h160v96zM64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z"
        }
    ]
};

const FasTabletButton = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTabletButton",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm160 400a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FasTabletRugged = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTabletRugged",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 176 8.8 164.4c-5.4-2.7-8.8-8.2-8.8-14.3V73.9c0-6.1 3.4-11.6 8.8-14.3l25.5-12.8C41.8 19.8 66.6 0 96 0h256c29.4 0 54.2 19.8 61.7 46.8l25.5 12.7c5.4 2.7 8.8 8.3 8.8 14.3V150c0 6.1-3.4 11.6-8.8 14.3L416 176v16l23.2 11.6c5.4 2.7 8.8 8.3 8.8 14.3v76.2c0 6.1-3.4 11.6-8.8 14.3L416 320v16l23.2 11.6c5.4 2.7 8.8 8.2 8.8 14.3v76.2c0 6.1-3.4 11.6-8.8 14.3l-25.5 12.7c-7.5 27-32.3 46.8-61.7 46.8H96c-29.4 0-54.2-19.8-61.7-46.8L8.8 452.4c-5.4-2.7-8.8-8.2-8.8-14.3v-76.2c0-6.1 3.4-11.6 8.8-14.3L32 336v-16L8.8 308.4c-5.4-2.7-8.8-8.2-8.8-14.3v-76.2c0-6.1 3.4-11.6 8.8-14.3L32 192v-16zm80-112c-8.8 0-16 7.2-16 16v352c0 8.8 7.2 16 16 16h224c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H112z"
        }
    ]
};

const FasTabletScreenButton = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTabletScreenButton",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 64C0 28.7 28.7 0 64 0h320c35.3 0 64 28.7 64 64v384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm256 384a32 32 0 1 0-64 0 32 32 0 1 0 64 0zM384 64H64v320h320V64z"
        }
    ]
};

const FasTabletScreen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTabletScreen",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 64C0 28.7 28.7 0 64 0h320c35.3 0 64 28.7 64 64v384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm160 384c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16h-96c-8.8 0-16 7.2-16 16zM384 64H64v320h320V64z"
        }
    ]
};

const FasTablet = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTablet",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm112 432h96c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FasTablets = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTablets",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M614.3 247c16.3-25 25.7-54.9 25.7-87C640 71.6 568.4 0 480 0c-32.1 0-61.9 9.4-87 25.7-7.9 5.2-8.5 16.2-1.8 22.9l200.2 200.2c6.7 6.7 17.8 6.2 22.9-1.8zM567 294.3c7.9-5.2 8.5-16.2 1.8-22.9L368.6 71.2c-6.7-6.7-17.8-6.2-22.9 1.8-16.3 25-25.7 54.9-25.7 87 0 88.4 71.6 160 160 160 32.1 0 61.9-9.4 87-25.7zM301.5 368h-283c-9.5 0-16.9 8.2-15 17.5C18.9 457.8 83.1 512 160 512s141.1-54.2 156.5-126.5c2-9.3-5.5-17.5-15-17.5zm0-32c9.5 0 16.9-8.2 15-17.5C301.1 246.2 236.9 192 160 192S18.9 246.2 3.5 318.5c-2 9.3 5.5 17.5 15 17.5h283z"
        }
    ]
};

const FasTachographDigital = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTachographDigital",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64C28.7 64 0 92.7 0 128v256c0 35.3 28.7 64 64 64h512c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm32 64h224c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32zM64 368c0-8.8 7.2-16 16-16h256c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm320 0c0-8.8 7.2-16 16-16h160c8.8 0 16 7.2 16 16s-7.2 16-16 16H400c-8.8 0-16-7.2-16-16zM80 288a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
        }
    ]
};

const FasTaco = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTaco",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m274.8 38.4 44.1 34.2c5.6 4.4 12.6 6.6 19.7 6.4l55.8-1.7c14-.4 26.5 8.6 30.4 22.1l15.6 53.6c2 6.8 6.3 12.8 12.2 16.8l46 31.2c11.6 7.9 16.3 22.5 11.6 35.7l-17.1 47.7C441.1 209.2 354.3 160 256 160S70.9 209.2 18.9 284.4L1.8 236.7c-4.7-13.1 0-27.8 11.6-35.7l46.1-31.4c5.9-4 10.2-9.9 12.2-16.8l15.6-53.5c3.9-13.4 16.4-22.5 30.4-22.1l55.7 1.8c7.1.2 14.1-2 19.7-6.4l44.1-34.2c11-8.6 26.5-8.6 37.5 0zM512 448c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32 0-141.4 114.6-256 256-256s256 114.6 256 256zm-400-32a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-80a16 16 0 1 0-32 0 16 16 0 1 0 32 0z"
        }
    ]
};

const FasTag = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTag",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 80v149.5c0 17 6.7 33.3 18.7 45.3l176 176c25 25 65.5 25 90.5 0l133.5-133.5c25-25 25-65.5 0-90.5l-176-176c-12-12-28.3-18.7-45.3-18.7H48C21.5 32 0 53.5 0 80zm112 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FasTags = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTags",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m345 39.1 127.8 129.3c52.4 53 52.4 138.2 0 191.2l-112 113.3c-9.3 9.4-24.5 9.5-33.9.2s-9.5-24.5-.2-33.9l111.9-113.3c33.9-34.3 33.9-89.4 0-123.7L310.9 72.9c-9.3-9.4-9.2-24.6.2-33.9s24.6-9.2 33.9.2zM0 229.5V80c0-26.5 21.5-48 48-48h149.5c17 0 33.3 6.7 45.3 18.7l168 168c25 25 25 65.5 0 90.5L277.3 442.7c-25 25-65.5 25-90.5 0l-168-168C6.7 262.7 0 246.5 0 229.5zM144 144a32 32 0 1 0-64 0 32 32 0 1 0 64 0z"
        }
    ]
};

const FasTally1 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTally1",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 32c17.7 0 32 14.3 32 32v384c0 17.7-14.3 32-32 32s-32-14.3-32-32V64c0-17.7 14.3-32 32-32z"
        }
    ]
};

const FasTally2 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTally2",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 64c0-17.7-14.3-32-32-32S96 46.3 96 64v384c0 17.7 14.3 32 32 32s32-14.3 32-32V64zm128 0c0-17.7-14.3-32-32-32s-32 14.3-32 32v384c0 17.7 14.3 32 32 32s32-14.3 32-32V64z"
        }
    ]
};

const FasTally3 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTally3",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 32c17.7 0 32 14.3 32 32v384c0 17.7-14.3 32-32 32s-32-14.3-32-32V64c0-17.7 14.3-32 32-32zm128 0c17.7 0 32 14.3 32 32v384c0 17.7-14.3 32-32 32s-32-14.3-32-32V64c0-17.7 14.3-32 32-32zm160 32v384c0 17.7-14.3 32-32 32s-32-14.3-32-32V64c0-17.7 14.3-32 32-32s32 14.3 32 32z"
        }
    ]
};

const FasTally4 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTally4",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 64c0-17.7-14.3-32-32-32S96 46.3 96 64v384c0 17.7 14.3 32 32 32s32-14.3 32-32V64zm128 0c0-17.7-14.3-32-32-32s-32 14.3-32 32v384c0 17.7 14.3 32 32 32s32-14.3 32-32V64zm96-32c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32s32-14.3 32-32V64c0-17.7-14.3-32-32-32zm160 32c0-17.7-14.3-32-32-32s-32 14.3-32 32v384c0 17.7 14.3 32 32 32s32-14.3 32-32V64z"
        }
    ]
};

const FasTally = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTally",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 32c17.7 0 32 14.3 32 32v211.6l64-21.3V64c0-17.7 14.3-32 32-32s32 14.3 32 32v168.9l64-21.3V64c0-17.7 14.3-32 32-32s32 14.3 32 32v126.3l64-21.3V64c0-17.7 14.3-32 32-32s32 14.3 32 32v83.6l53.9-18c16.8-5.6 34.9 3.5 40.5 20.2s-3.5 34.9-20.2 40.5L544 215.1V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V236.4l-64 21.3V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V279.1l-64 21.3V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V321.7L160 343v105c0 17.7-14.3 32-32 32s-32-14.3-32-32v-83.6l-53.9 18c-16.8 5.6-34.9-3.5-40.5-20.2s3.5-34.9 20.2-40.5L96 296.9V64c0-17.7 14.3-32 32-32z"
        }
    ]
};

const FasTamale = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTamale",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48.1 18.3C72.3 8.6 108.4 0 160 0s87.7 8.6 111.9 18.3c12.1 4.8 21 9.9 27.4 14.1 12.7 8.5 23.1 20.4 20.3 36.9L296.4 208h-60.2L248 72.7c.4-4.4-2.9-8.3-7.3-8.7s-8.3 2.9-8.7 7.3L220.1 208H168V64c0-4.4-3.6-8-8-8s-8 3.6-8 8v144H99.9L88 71.3c-.4-4.4-4.3-7.7-8.7-7.3s-7.7 4.3-7.3 8.7L83.8 208H23.6L.4 69.3c-2.7-16.5 7.7-28.5 20.4-36.9 6.3-4.2 15.3-9.3 27.4-14.1zM24 240h272c8.8 0 16 7.2 16 16s-7.2 16-16 16H192l28.8 38.4c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2L160 282.7l-35.2 46.9c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4L128 272H24c-8.8 0-16-7.2-16-16s7.2-16 16-16zm128 208c0 4.4 3.6 8 8 8s8-3.6 8-8V346.7c13.4 17.9 35.9 26.5 57.4 18.1l6.6 76c.4 4.4 4.3 7.7 8.7 7.3s7.7-4.3 7.3-8.7l-7.3-84.1c14.2-13.2 18.9-33.4 12.6-51.2h43.1l23.1 138.7c1.7 10.2-1.6 20.6-8.9 27.9-10.6 10.5-25.1 17.6-38.7 23-24.2 9.7-60.3 18.3-111.9 18.3s-87.7-8.6-111.9-18.3c-13.7-5.5-28.1-12.5-38.7-23-7.3-7.3-10.6-17.7-8.9-27.9L23.6 304h43.1c-6.3 17.7-1.6 38 12.6 51.2L72 439.3c-.4 4.4 2.9 8.3 7.3 8.7s8.3-2.9 8.7-7.3l6.6-76c21.5 8.4 44-.2 57.4-18.1V448z"
        }
    ]
};

const FasTankWater = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTankWater",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m285.9 96-22-40.3L251 32h133c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h133l-12.9 23.7-22 40.3H64v201.9c8.3-3 16.2-6.8 23.3-10.8 6.9-3.9 13.1-8.2 18.9-12.7 12.9-10 30.6-10 43.4 0 5.9 4.6 12 8.8 18.9 12.7 15.8 9 35.5 16.8 55.2 16.9h.4c19.6 0 39.3-7.9 55.2-16.9 6.9-3.9 13.1-8.2 18.9-12.7 12.9-10 30.6-10 43.4 0 5.9 4.6 12 8.8 19 12.8 7.1 4 15 7.9 23.4 10.8V96h-98.1zM175 139.2 212.2 71c2.4-4.3 6.9-7 11.8-7s9.5 2.7 11.8 7l37.2 68.2c4.6 8.4 7 17.9 7 27.5v1.3c0 30.9-25.1 56-56 56s-56-25.1-56-56v-1.4c0-9.6 2.4-19 7-27.5z"
        }
    ]
};

const FasTape = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTape",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M380.8 416c41.5-40.7 67.2-97.3 67.2-160 0-123.7-100.3-224-224-224S0 132.3 0 256s100.3 224 224 224h320c17.7 0 32-14.3 32-32s-14.3-32-32-32H380.8zM224 160a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm64 96a64 64 0 1 0-128 0 64 64 0 1 0 128 0z"
        }
    ]
};

const FasTarpDroplet = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTarpDroplet",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 160c-35.3 0-64-26.9-64-60 0-24 33.7-70.1 52.2-93.5 6.1-7.7 17.5-7.7 23.6 0C318.3 29.9 352 76 352 100c0 33.1-28.7 60-64 60zM64 128h133.5c13.2 37.3 48.7 64 90.5 64s77.4-26.7 90.5-64H512c35.3 0 64 28.7 64 64v160H448c-17.7 0-32 14.3-32 32v128H64c-35.3 0-64-28.7-64-64V192c0-35.3 28.7-64 64-64zm384 384V384h128L448 512zM96 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FasTarp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTarp",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M576 128c0-35.3-28.7-64-64-64H64C28.7 64 0 92.7 0 128v256c0 35.3 28.7 64 64 64h352V320c0-17.7 14.3-32 32-32h128V128zM448 448l128-128H448v128zM96 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FasTaxiBus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTaxiBus",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 416H32c-17.7 0-32-14.3-32-32V74.5c0-16.2 9.2-31 23.7-38.3C71.2 12.4 123.7 0 176.9 0h30.3c53.2 0 105.6 12.4 153.2 36.2 14.4 7.2 23.6 22 23.6 38.3V96c-21.9 0-40.4 14.7-46.2 34.8-6.1 1.4-12.1 3.3-17.8 5.6V120c0-13.3-10.7-24-24-24h-88v128h41.9l-16.3 48.9C208.5 290.2 192 319.2 192 352v64h-64v32c0 17.7-14.3 32-32 32H80c-17.7 0-32-14.3-32-32v-32zm16-296v80c0 13.3 10.7 24 24 24h88V96H88c-13.3 0-24 10.7-24 24zm56 200a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm248-168c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24v8h5.4c34.4 0 65 22 75.9 54.7l26.6 79.7c21.3 10.3 36.1 32.2 36.1 57.6v128c0 17.7-14.3 32-32 32h-16c-17.7 0-32-14.3-32-32v-32H304v32c0 17.7-14.3 32-32 32h-16c-17.7 0-32-14.3-32-32V352c0-25.4 14.8-47.3 36.1-57.6l26.6-79.7c10.9-32.7 41.5-54.7 75.9-54.7h5.4v-8zm-20.6 82.9L329.7 288h204.6l-17.7-53.1c-2.2-6.5-8.3-10.9-15.2-10.9H362.6c-6.9 0-13 4.4-15.2 10.9zM328 368a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm232 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FasTaxi = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTaxi",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 0c-17.7 0-32 14.3-32 32v32.2c-38.6 2.2-72.3 27.3-85.2 64.1L39.6 228.8C16.4 238.4 0 261.3 0 288v192c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32v-48h320v48c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V288c0-26.7-16.4-49.6-39.6-59.2l-35.2-100.5c-12.9-36.8-46.6-62-85.2-64.1V32c0-17.7-14.3-32-32-32H192zm-26.6 128h181.2c13.6 0 25.7 8.6 30.2 21.4l26.1 74.6H109.1l26.1-74.6c4.5-12.8 16.6-21.4 30.2-21.4zM96 288a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm288 32a32 32 0 1 1 64 0 32 32 0 1 1-64 0z"
        }
    ]
};

const FasTeddyBear = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTeddyBear",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M154.7 103.7C138.7 93.9 128 76.2 128 56c0-30.9 25.1-56 56-56 24.2 0 44.7 15.3 52.6 36.7 15.9-3.2 33.2-4.7 51.4-4.7s35.5 1.5 51.4 4.7C347.3 15.3 367.8 0 392 0c30.9 0 56 25.1 56 56 0 20.2-10.7 37.9-26.7 47.7 1.8 7.4 2.7 15.5 2.7 24.3 0 70.7-60.9 128-136 128s-136-57.3-136-128c0-8.8.9-16.8 2.7-24.3zM240 128a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm112-16a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm0 64c0-26.5-28.7-48-64-48s-64 21.5-64 48 28.7 48 64 48 64-21.5 64-48zm-32-8c0 13.3-14.3 24-32 24s-32-10.7-32-24 14.3-24 32-24 32 10.7 32 24zM50.3 178.3c20.8-16.4 51-12.8 67.4 8l25.8 32.7c73.7 93.5 215.4 93.5 289.1 0l25.8-32.7c16.4-20.8 46.6-24.4 67.4-8s24.4 46.6 8 67.4L508 278.4c-17.7 22.4-37.9 41.3-59.9 56.7V400h16.6c3.9-27.1 27.2-48 55.4-48 30.9 0 56 25.1 56 56 0 2.7-.2 5.4-.6 8l-13 53.3c-5.8 23.8-26.3 40.9-50.4 42.6v.1H64v-.1c-24.1-1.7-44.6-18.8-50.4-42.6L.6 416c-.4-2.6-.6-5.3-.6-8 0-30.9 25.1-56 56-56 28.2 0 51.6 20.9 55.4 48H128v-64.9c-22-15.4-42.3-34.3-59.9-56.7l-25.8-32.7c-16.4-20.8-12.8-51 8-67.4zM256 352c-35.3 0-64 28.7-64 64h192c0-35.3-28.7-64-64-64h-64z"
        }
    ]
};

const FasTeethOpen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTeethOpen",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 32C43 32 0 75 0 128v64c0 35.3 28.7 64 64 64h448c35.3 0 64-28.7 64-64v-64c0-53-43-96-96-96H96zm128 64c26.5 0 48 21.5 48 48v56c0 13.3-10.7 24-24 24h-48c-13.3 0-24-10.7-24-24v-56c0-26.5 21.5-48 48-48zm80 48c0-26.5 21.5-48 48-48s48 21.5 48 48v56c0 13.3-10.7 24-24 24h-48c-13.3 0-24-10.7-24-24v-56zM96 128c26.5 0 48 21.5 48 48v24c0 13.3-10.7 24-24 24H72c-13.3 0-24-10.7-24-24v-24c0-26.5 21.5-48 48-48zm336 48c0-26.5 21.5-48 48-48s48 21.5 48 48v24c0 13.3-10.7 24-24 24h-48c-13.3 0-24-10.7-24-24v-24zM96 480h384c53 0 96-43 96-96v-32c0-35.3-28.7-64-64-64H64c-35.3 0-64 28.7-64 64v32c0 53 43 96 96 96zm0-64c-26.5 0-48-21.5-48-48v-24c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v24c0 26.5-21.5 48-48 48zm80-48v-24c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v24c0 26.5-21.5 48-48 48s-48-21.5-48-48zm176 48c-26.5 0-48-21.5-48-48v-24c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v24c0 26.5-21.5 48-48 48zm80-48v-24c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v24c0 26.5-21.5 48-48 48s-48-21.5-48-48z"
        }
    ]
};

const FasTeeth = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTeeth",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 128c0-53 43-96 96-96h384c53 0 96 43 96 96v256c0 53-43 96-96 96H96c-53 0-96-43-96-96V128zm176 48v56c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24v-56c0-26.5-21.5-48-48-48s-48 21.5-48 48zm176-48c-26.5 0-48 21.5-48 48v56c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24v-56c0-26.5-21.5-48-48-48zM48 208v24c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24v-24c0-26.5-21.5-48-48-48s-48 21.5-48 48zm48 176c26.5 0 48-21.5 48-48v-24c0-13.3-10.7-24-24-24H72c-13.3 0-24 10.7-24 24v24c0 26.5 21.5 48 48 48zm80-48c0 26.5 21.5 48 48 48s48-21.5 48-48v-24c0-13.3-10.7-24-24-24h-48c-13.3 0-24 10.7-24 24v24zm176 48c26.5 0 48-21.5 48-48v-24c0-13.3-10.7-24-24-24h-48c-13.3 0-24 10.7-24 24v24c0 26.5 21.5 48 48 48zm80-176v24c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24v-24c0-26.5-21.5-48-48-48s-48 21.5-48 48zm48 176c26.5 0 48-21.5 48-48v-24c0-13.3-10.7-24-24-24h-48c-13.3 0-24 10.7-24 24v24c0 26.5 21.5 48 48 48z"
        }
    ]
};

const FasTelescope = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTelescope",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M375.7 40c-15.3 8.8-20.6 28.4-11.7 43.7L460 250c8.8 15.3 28.4 20.5 43.7 11.7l55.4-32c15.3-8.8 20.5-28.4 11.7-43.7l-96-166.3C466 4.4 446.4-.8 431.1 8l-55.4 32zM11.8 343.6c-11.4 6.7-15.4 21.3-8.7 32.8L29 421.3c6.6 11.5 21.3 15.4 32.8 8.8l44.1-25.5.8 1.4c8.6 15 27.6 20.4 42.8 12.2l88.4-47.4-44.1 108.1c-5 12.3.9 26.3 13.2 31.3s26.3-.9 31.3-13.2L304 335.6 369.8 497c5 12.3 19 18.2 31.3 13.2s18.2-19 13.2-31.3l-67.9-166.4 86.1-46.2-.2-.3-96-166.3c-1-1.8-2-3.6-2.8-5.4L62.4 268.4c-14.4 9.2-19 28.1-10.4 42.9l4 6.9-44.2 25.4z"
        }
    ]
};

const FasTemperatureArrowDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTemperatureArrowDown",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 112c0-26.5 21.5-48 48-48s48 21.5 48 48v164.5c0 17.3 7.1 31.9 15.3 42.5 10.5 13.6 16.7 30.5 16.7 49 0 44.2-35.8 80-80 80s-80-35.8-80-80c0-18.5 6.2-35.4 16.7-48.9 8.2-10.6 15.3-25.2 15.3-42.5V112zM176 0C114.1 0 64 50.1 64 112v164.4c0 .1-.1.3-.2.6-.2.6-.8 1.6-1.7 2.8C43.2 304.2 32 334.8 32 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-33.2-11.2-63.8-30.1-88.1-.9-1.2-1.5-2.2-1.7-2.8-.1-.3-.2-.5-.2-.6V112C288 50.1 237.9 0 176 0zm0 416c26.5 0 48-21.5 48-48 0-20.9-13.4-38.7-32-45.3V272c0-8.8-7.2-16-16-16s-16 7.2-16 16v50.7c-18.6 6.6-32 24.4-32 45.3 0 26.5 21.5 48 48 48zm336-64h-32V64c0-17.7-14.3-32-32-32s-32 14.3-32 32v288h-32c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l64 64c6 6 14.1 9.4 22.6 9.4s16.6-3.4 22.6-9.4l64-64c9.2-9.2 11.9-22.9 6.9-34.9S524.8 352 511.8 352z"
        }
    ]
};

const FasTemperatureArrowUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTemperatureArrowUp",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 112c0-26.5 21.5-48 48-48s48 21.5 48 48v164.5c0 17.3 7.1 31.9 15.3 42.5 10.5 13.6 16.7 30.5 16.7 49 0 44.2-35.8 80-80 80s-80-35.8-80-80c0-18.5 6.2-35.4 16.7-48.9 8.2-10.6 15.3-25.2 15.3-42.5V112zM176 0C114.1 0 64 50.1 64 112v164.4c0 .1-.1.3-.2.6-.2.6-.8 1.6-1.7 2.8C43.2 304.2 32 334.8 32 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-33.2-11.2-63.8-30.1-88.1-.9-1.2-1.5-2.2-1.7-2.8-.1-.3-.2-.5-.2-.6V112C288 50.1 237.9 0 176 0zm0 416c26.5 0 48-21.5 48-48 0-20.9-13.4-38.7-32-45.3V112c0-8.8-7.2-16-16-16s-16 7.2-16 16v210.7c-18.6 6.6-32 24.4-32 45.3 0 26.5 21.5 48 48 48zm304-256h32c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-64-64c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8h32v288c0 17.7 14.3 32 32 32s32-14.3 32-32V160z"
        }
    ]
};

const FasTemperatureEmpty = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTemperatureEmpty",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M112 112c0-26.5 21.5-48 48-48s48 21.5 48 48v164.5c0 17.3 7.1 31.9 15.3 42.5 10.5 13.6 16.7 30.5 16.7 49 0 44.2-35.8 80-80 80s-80-35.8-80-80c0-18.5 6.2-35.4 16.7-48.9 8.2-10.6 15.3-25.2 15.3-42.5V112zM160 0C98.1 0 48 50.2 48 112v164.5c0 .1-.1.3-.2.6-.2.6-.8 1.6-1.7 2.8C27.2 304.2 16 334.8 16 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-33.2-11.2-63.8-30.1-88.1-.9-1.2-1.5-2.2-1.7-2.8-.1-.3-.2-.5-.2-.6V112C272 50.2 221.9 0 160 0zm0 416a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
        }
    ]
};

const FasTemperatureFull = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTemperatureFull",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 64c-26.5 0-48 21.5-48 48v164.5c0 17.3-7.1 31.9-15.3 42.5C86.2 332.6 80 349.5 80 368c0 44.2 35.8 80 80 80s80-35.8 80-80c0-18.5-6.2-35.4-16.7-48.9-8.2-10.6-15.3-25.2-15.3-42.5V112c0-26.5-21.5-48-48-48zM48 112C48 50.2 98.1 0 160 0s112 50.1 112 112v164.5c0 .1.1.3.2.6.2.6.8 1.6 1.7 2.8 18.9 24.4 30.1 55 30.1 88.1 0 79.5-64.5 144-144 144S16 447.5 16 368c0-33.2 11.2-63.8 30.1-88.1.9-1.2 1.5-2.2 1.7-2.8.1-.3.2-.5.2-.6V112zm160 256c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V112c0-8.8 7.2-16 16-16s16 7.2 16 16v210.7c18.6 6.6 32 24.4 32 45.3z"
        }
    ]
};

const FasTemperatureHalf = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTemperatureHalf",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 64c-26.5 0-48 21.5-48 48v164.5c0 17.3-7.1 31.9-15.3 42.5C86.2 332.6 80 349.5 80 368c0 44.2 35.8 80 80 80s80-35.8 80-80c0-18.5-6.2-35.4-16.7-48.9-8.2-10.6-15.3-25.2-15.3-42.5V112c0-26.5-21.5-48-48-48zM48 112C48 50.2 98.1 0 160 0s112 50.1 112 112v164.5c0 .1.1.3.2.6.2.6.8 1.6 1.7 2.8 18.9 24.4 30.1 55 30.1 88.1 0 79.5-64.5 144-144 144S16 447.5 16 368c0-33.2 11.2-63.8 30.1-88.1.9-1.2 1.5-2.2 1.7-2.8.1-.3.2-.5.2-.6V112zm160 256c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V208c0-8.8 7.2-16 16-16s16 7.2 16 16v114.7c18.6 6.6 32 24.4 32 45.3z"
        }
    ]
};

const FasTemperatureHigh = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTemperatureHigh",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M416 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 128a96 96 0 1 0 0-192 96 96 0 1 0 0 192zM96 112c0-26.5 21.5-48 48-48s48 21.5 48 48v164.5c0 17.3 7.1 31.9 15.3 42.5 10.5 13.6 16.7 30.5 16.7 49 0 44.2-35.8 80-80 80s-80-35.8-80-80c0-18.5 6.2-35.4 16.7-48.9 8.2-10.7 15.3-25.3 15.3-42.6V112zM144 0C82.1 0 32 50.2 32 112v164.5c0 .1-.1.3-.2.6-.2.6-.8 1.6-1.7 2.8C11.2 304.2 0 334.8 0 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-33.2-11.2-63.8-30.1-88.1-.9-1.2-1.5-2.2-1.7-2.8-.1-.3-.2-.5-.2-.6V112C256 50.2 205.9 0 144 0zm0 416c26.5 0 48-21.5 48-48 0-20.9-13.4-38.7-32-45.3V112c0-8.8-7.2-16-16-16s-16 7.2-16 16v210.7c-18.6 6.6-32 24.4-32 45.3 0 26.5 21.5 48 48 48z"
        }
    ]
};

const FasTemperatureList = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTemperatureList",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 112c0-26.5 21.5-48 48-48s48 21.5 48 48v164.5c0 17.3 7.1 31.9 15.3 42.5 10.5 13.6 16.7 30.5 16.7 49 0 44.2-35.8 80-80 80s-80-35.8-80-80c0-18.5 6.2-35.4 16.7-48.9 8.2-10.7 15.3-25.3 15.3-42.6V112zM144 0C82.1 0 32 50.2 32 112v164.5c0 .1-.1.3-.2.6-.2.6-.8 1.6-1.7 2.8C11.2 304.2 0 334.8 0 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-33.2-11.2-63.8-30.1-88.1-.9-1.2-1.5-2.2-1.7-2.8-.1-.3-.2-.5-.2-.6V112C256 50.2 205.9 0 144 0zm0 416c26.5 0 48-21.5 48-48 0-20.9-13.4-38.7-32-45.3V176c0-8.8-7.2-16-16-16s-16 7.2-16 16v146.7c-18.6 6.6-32 24.4-32 45.3 0 26.5 21.5 48 48 48zM352 32c-17.7 0-32 14.3-32 32s14.3 32 32 32h128c17.7 0 32-14.3 32-32s-14.3-32-32-32H352zm-32 160c0 17.7 14.3 32 32 32h128c17.7 0 32-14.3 32-32s-14.3-32-32-32H352c-17.7 0-32 14.3-32 32zm64 96c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32h-96z"
        }
    ]
};

const FasTemperatureLow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTemperatureLow",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 96a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm-128 0a96 96 0 1 1 192 0 96 96 0 1 1-192 0zM144 64c-26.5 0-48 21.5-48 48v164.5c0 17.3-7.1 31.9-15.3 42.5C70.2 332.6 64 349.5 64 368c0 44.2 35.8 80 80 80s80-35.8 80-80c0-18.5-6.2-35.4-16.7-48.9-8.2-10.6-15.3-25.2-15.3-42.5V112c0-26.5-21.5-48-48-48zM32 112C32 50.2 82.1 0 144 0s112 50.1 112 112v164.5c0 .1.1.3.2.6.2.6.8 1.6 1.7 2.8 18.9 24.4 30.1 55 30.1 88.1 0 79.5-64.5 144-144 144S0 447.5 0 368c0-33.2 11.2-63.8 30.1-88.1.9-1.2 1.5-2.2 1.7-2.8.1-.3.2-.5.2-.6V112zm160 256c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V272c0-8.8 7.2-16 16-16s16 7.2 16 16v50.7c18.6 6.6 32 24.4 32 45.3z"
        }
    ]
};

const FasTemperatureQuarter = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTemperatureQuarter",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 64c-26.5 0-48 21.5-48 48v164.5c0 17.3-7.1 31.9-15.3 42.5C86.2 332.6 80 349.5 80 368c0 44.2 35.8 80 80 80s80-35.8 80-80c0-18.5-6.2-35.4-16.7-48.9-8.2-10.6-15.3-25.2-15.3-42.5V112c0-26.5-21.5-48-48-48zM48 112C48 50.2 98.1 0 160 0s112 50.1 112 112v164.5c0 .1.1.3.2.6.2.6.8 1.6 1.7 2.8 18.9 24.4 30.1 55 30.1 88.1 0 79.5-64.5 144-144 144S16 447.5 16 368c0-33.2 11.2-63.8 30.1-88.1.9-1.2 1.5-2.2 1.7-2.8.1-.3.2-.5.2-.6V112zm160 256c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V272c0-8.8 7.2-16 16-16s16 7.2 16 16v50.7c18.6 6.6 32 24.4 32 45.3z"
        }
    ]
};

const FasTemperatureSnow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTemperatureSnow",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 112c0-26.5 21.5-48 48-48s48 21.5 48 48v164.5c0 17.3 7.1 31.9 15.3 42.5 10.5 13.6 16.7 30.5 16.7 49 0 44.2-35.8 80-80 80s-80-35.8-80-80c0-18.5 6.2-35.4 16.7-48.9 8.2-10.6 15.3-25.2 15.3-42.5V112zM432 0c-61.9 0-112 50.1-112 112v164.4c0 .1-.1.3-.2.6-.2.6-.8 1.6-1.7 2.8-18.9 24.4-30.1 55-30.1 88.1 0 79.5 64.5 144 144 144s144-64.5 144-144c0-33.2-11.3-63.8-30.1-88.1-.9-1.2-1.5-2.2-1.7-2.8-.1-.3-.2-.5-.2-.6V112C544 50.1 493.9 0 432 0zm0 416c26.5 0 48-21.5 48-48 0-20.9-13.4-38.7-32-45.3V272c0-8.8-7.2-16-16-16s-16 7.2-16 16v50.7c-18.6 6.6-32 24.4-32 45.3 0 26.5 21.5 48 48 48zM288 131.6l-88 50.8v-55.8l35.3-35.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L200 81.4V56c0-13.3-10.7-24-24-24s-24 10.7-24 24v25.4l-12.7-12.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l35.3 35.3v55.8l-48.3-27.9-13-48.2c-2.2-8.6-11-13.6-19.5-11.3s-13.6 11.1-11.3 19.6l4.6 17.3-22-12.7c-11.5-6.6-26.2-2.7-32.8 8.8s-2.7 26.2 8.8 32.8l22 12.7-17.3 4.6c-8.5 2.3-13.6 11.1-11.3 19.6S23 211.3 31.5 209l48.2-12.9L128 224l-48.3 27.9L31.4 239c-8.5-2.3-17.3 2.8-19.6 11.3s2.8 17.3 11.3 19.6l17.3 4.6-22 12.7C7 293.8 3.1 308.5 9.7 320s21.3 15.4 32.8 8.8l22-12.7-4.6 17.3c-2.3 8.5 2.8 17.3 11.3 19.6s17.3-2.8 19.6-11.3l12.9-48.2 48.3-27.9v55.8l-35.3 35.3c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l12.7-12.7V392c0 13.3 10.7 24 24 24s24-10.7 24-24v-25.4l12.7 12.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L200 321.4v-55.8l67.7 39.1c5.2-13.5 12-26.2 20.3-37.9V261l-64-37 64-37v-55.4z"
        }
    ]
};

const FasTemperatureSun = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTemperatureSun",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m320.6 98.5-2.7-.5-14.1-84.6c-.9-5.4-4.5-10-9.6-12.1s-10.9-1.5-15.4 1.6L208 52.5 137.2 2.9c-4.5-3.2-10.3-3.8-15.4-1.6s-8.7 6.7-9.6 12.1L98.1 98.1l-84.7 14.1c-5.4.9-10 4.5-12.1 9.6s-1.5 10.9 1.6 15.4L52.5 208 2.9 278.8c-3.2 4.5-3.8 10.3-1.6 15.4s6.7 8.7 12.1 9.6l84.7 14.1 14.1 84.7c.9 5.4 4.5 10 9.6 12.1s10.9 1.5 15.4-1.6l70.8-49.6 70.8 49.6c4.5 3.1 10.3 3.8 15.4 1.6.7-.3 1.5-.7 2.1-1.1-5.4-16.9-8.3-34.9-8.3-53.7 0-37.7 11.8-72.6 32-101.2V112c0-4.5.2-9 .6-13.5zM208 272a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm0-160a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm208 0c0-26.5 21.5-48 48-48s48 21.5 48 48v164.5c0 17.3 7.1 31.9 15.3 42.5 10.5 13.6 16.7 30.5 16.7 49 0 44.2-35.8 80-80 80s-80-35.8-80-80c0-18.5 6.2-35.4 16.7-48.9 8.2-10.6 15.3-25.2 15.3-42.5V112zM464 0c-61.9 0-112 50.2-112 112v164.5c0 .1-.1.3-.2.6-.2.6-.8 1.6-1.7 2.8-18.9 24.4-30.1 55-30.1 88.1 0 79.5 64.5 144 144 144s144-64.5 144-144c0-33.2-11.3-63.8-30.1-88.1-.9-1.2-1.5-2.2-1.7-2.8-.1-.3-.2-.5-.2-.6V112C576 50.2 525.9 0 464 0zm0 416c26.5 0 48-21.5 48-48 0-20.9-13.4-38.7-32-45.3V112c0-8.8-7.2-16-16-16s-16 7.2-16 16v210.7c-18.6 6.6-32 24.4-32 45.3 0 26.5 21.5 48 48 48z"
        }
    ]
};

const FasTemperatureThreeQuarters = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTemperatureThreeQuarters",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 64c-26.5 0-48 21.5-48 48v164.5c0 17.3-7.1 31.9-15.3 42.5C86.2 332.6 80 349.5 80 368c0 44.2 35.8 80 80 80s80-35.8 80-80c0-18.5-6.2-35.4-16.7-48.9-8.2-10.6-15.3-25.2-15.3-42.5V112c0-26.5-21.5-48-48-48zM48 112C48 50.2 98.1 0 160 0s112 50.1 112 112v164.5c0 .1.1.3.2.6.2.6.8 1.6 1.7 2.8 18.9 24.4 30.1 55 30.1 88.1 0 79.5-64.5 144-144 144S16 447.5 16 368c0-33.2 11.2-63.8 30.1-88.1.9-1.2 1.5-2.2 1.7-2.8.1-.3.2-.5.2-.6V112zm160 256c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V144c0-8.8 7.2-16 16-16s16 7.2 16 16v178.7c18.6 6.6 32 24.4 32 45.3z"
        }
    ]
};

const FasTengeSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTengeSign",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 64c0-17.7 14.3-32 32-32h320c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64zm0 128c0-17.7 14.3-32 32-32h320c17.7 0 32 14.3 32 32s-14.3 32-32 32H224v224c0 17.7-14.3 32-32 32s-32-14.3-32-32V224H32c-17.7 0-32-14.3-32-32z"
        }
    ]
};

const FasTennisBall = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTennisBall",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M.2 245.1c-.1 3.6-.2 7.2-.2 10.9 0 141.4 114.6 256 256 256 3.7 0 7.3-.1 10.9-.2-3.8-10.7-6.6-21.8-8.4-33.1-4.4-27.2-2.9-55 4.4-81.6s20.2-51.2 37.9-72.4 39.7-38.2 64.5-50.1 52-18.2 79.5-18.7c22.8-.4 45.5 3.3 67 10.9.2-3.6.2-7.2.2-10.9C512 114.6 397.4 0 256 0c-3.7 0-7.3.1-10.9.2 10.7 30.5 13.7 63.4 8.2 95.6-7.1 42.4-28.3 81.2-60 110.1s-72.4 46.4-115.2 49.6c-26.6 2-53.1-1.7-77.9-10.4zM206.8 4.7C104.9 24.6 24.6 104.9 4.7 206.8c22.2 9.2 46.4 13.2 70.6 11.4 34.5-2.5 67.2-16.6 92.8-39.9s42.6-54.5 48.4-88.7c4.8-28.7 1.4-58.2-9.7-84.9zm238.6 288.7c-22.2.4-44 5.5-64 15.1s-37.7 23.3-52 40.3-24.6 36.9-30.5 58.3-7.1 43.8-3.5 65.7c1.9 11.9 5.2 23.5 9.8 34.6 101.9-19.8 182.2-100.2 202.1-202.1-19.6-8.1-40.6-12.1-61.9-11.8z"
        }
    ]
};

const FasTentArrowDownToLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTentArrowDownToLine",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M241.8 111.9c8.9 9.9 8.1 25-1.8 33.9l-80 72c-9.1 8.2-23 8.2-32.1 0l-80-72c-9.9-8.9-10.7-24-1.8-33.9s24-10.7 33.9-1.8l39.9 36L120 24c0-13.3 10.7-24 24-24s24 10.7 24 24v122.1l39.9-36c9.9-8.9 25-8.1 33.9 1.8zm122.8 22.6c11.5-8.7 27.3-8.7 38.8 0l168 128c6.6 5 11 12.5 12.3 20.7l24 160 .7 4.7c17.5.2 31.6 14.4 31.6 32 0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h127.6l.7-4.7 24-160c1.2-8.2 5.6-15.7 12.3-20.7l168-128zM384 448h76.8L384 320v128z"
        }
    ]
};

const FasTentArrowLeftRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTentArrowLeftRight",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M488.1 6.2c-9.9-8.9-25-8.1-33.9 1.8s-8.1 25 1.8 33.9L489.5 72h-403L120 41.8c9.9-8.9 10.7-24 1.8-33.9s-24-10.6-33.9-1.7l-80 72C2.9 82.7 0 89.2 0 96s2.9 13.3 7.9 17.8l80 72c9.9 8.9 25 8.1 33.9-1.8s8.1-25-1.8-33.9L86.5 120h402.9l-33.5 30.2c-9.9 8.9-10.7 24-1.8 33.9s24 10.7 33.9 1.8l80-72c5.1-4.6 7.9-11 7.9-17.8S573 82.8 568 78.3l-80-72zM307.4 166.5c-11.5-8.7-27.3-8.7-38.8 0l-168 128c-6.6 5-11 12.5-12.3 20.7l-24 160c-1.4 9.2 1.3 18.6 7.4 25.6S86.7 512 96 512h192V352l96 160h96c9.3 0 18.2-4.1 24.2-11.1s8.8-16.4 7.4-25.6l-24-160c-1.2-8.2-5.6-15.7-12.3-20.7l-168-128z"
        }
    ]
};

const FasTentArrowTurnLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTentArrowTurnLeft",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M120.1 41.8c9.9-8.9 10.7-24 1.8-33.9s-24.1-10.6-34-1.7l-80 72C2.9 82.7 0 89.2 0 96s2.9 13.3 7.9 17.8l80 72c9.9 8.9 25 8.1 33.9-1.8s8.1-25-1.8-33.9L86.5 120H456c39.8 0 72 32.2 72 72v40c0 13.3 10.7 24 24 24s24-10.7 24-24v-40c0-66.3-53.7-120-120-120H86.5L120 41.8zm187.3 124.7c-11.5-8.7-27.3-8.7-38.8 0l-168 128c-6.6 5-11 12.5-12.3 20.7l-24 160c-1.4 9.2 1.3 18.6 7.4 25.6S86.7 512 96 512h192V352l96 160h96c9.3 0 18.2-4.1 24.2-11.1s8.8-16.4 7.4-25.6l-24-160c-1.2-8.2-5.6-15.7-12.3-20.7l-168-128z"
        }
    ]
};

const FasTentArrowsDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTentArrowsDown",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M209.8 111.9c-8.9-9.9-24-10.7-33.9-1.8l-39.9 36V24c0-13.3-10.7-24-24-24S88 10.7 88 24v122.1l-39.9-36c-9.9-8.9-25-8.1-33.9 1.8s-8.1 25 1.8 33.9l80 72c9.1 8.2 23 8.2 32.1 0l80-72c9.9-8.9 10.7-24 1.8-33.9zm352 0c-8.9-9.9-24-10.7-33.9-1.8l-39.9 36V24c0-13.3-10.7-24-24-24s-24 10.7-24 24v122.1l-39.9-36c-9.9-8.9-25-8.1-33.9 1.8s-8.1 25 1.8 33.9l80 72c9.1 8.2 23 8.2 32.1 0l80-72c9.9-8.9 10.7-24 1.8-33.9zm-254.4 54.6c-11.5-8.7-27.3-8.7-38.8 0l-168 128c-6.6 5-11 12.5-12.3 20.7l-24 160c-1.4 9.2 1.3 18.6 7.4 25.6S86.7 512 96 512h192V352l96 160h96c9.3 0 18.2-4.1 24.2-11.1s8.8-16.4 7.4-25.6l-24-160c-1.2-8.2-5.6-15.7-12.3-20.7l-168-128z"
        }
    ]
};

const FasTent = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTent",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M269.4 6c11.1-8 26.1-8 37.2 0l224 160c7.4 5.3 12.2 13.5 13.2 22.5l32 288c1 9-1.9 18.1-8 24.9s-14.7 10.7-23.8 10.7H416L288 288v224H32c-9.1 0-17.8-3.9-23.8-10.7s-9-15.8-8-24.9l32-288c1-9 5.8-17.2 13.2-22.5L269.4 6z"
        }
    ]
};

const FasTents = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTents",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M396.6 6.5 235.8 129.1c9.6 1.8 18.9 5.8 27 12l168 128c13.2 10.1 22 24.9 24.5 41.4l6.2 41.5H608c9.3 0 18.2-4.1 24.2-11.1s8.8-16.4 7.4-25.6l-24-160c-1.2-8.2-5.6-15.7-12.3-20.7l-168-128c-11.5-8.7-27.3-8.7-38.8 0zm-153.2 160c-11.5-8.7-27.3-8.7-38.8 0l-168 128c-6.6 5-11 12.5-12.3 20.7l-24 160c-1.4 9.2 1.3 18.6 7.4 25.6S22.7 512 32 512h192V352l96 160h96c9.3 0 18.2-4.1 24.2-11.1s8.8-16.4 7.4-25.6l-24-160c-1.2-8.2-5.6-15.7-12.3-20.7l-168-128z"
        }
    ]
};

const FasTerminal = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTerminal",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M9.4 86.6c-12.5-12.5-12.5-32.7 0-45.2s32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L178.7 256 9.4 86.6zM256 416h288c17.7 0 32 14.3 32 32s-14.3 32-32 32H256c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
        }
    ]
};

const FasTextHeight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTextHeight",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 128V96h64v320H96c-17.7 0-32 14.3-32 32s14.3 32 32 32h128c17.7 0 32-14.3 32-32s-14.3-32-32-32h-32V96h64v32c0 17.7 14.3 32 32 32s32-14.3 32-32V80c0-26.5-21.5-48-48-48H48C21.5 32 0 53.5 0 80v48c0 17.7 14.3 32 32 32s32-14.3 32-32zm438.6-86.6c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8h32V352h-32c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l64 64c12.5 12.5 32.8 12.5 45.3 0l64-64c9.2-9.2 11.9-22.9 6.9-34.9S556.9 352 543.9 352H512V160h32c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-64-64z"
        }
    ]
};

const FasTextSize = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTextSize",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 128V96h96v320h-32c-17.7 0-32 14.3-32 32s14.3 32 32 32h128c17.7 0 32-14.3 32-32s-14.3-32-32-32h-32V96h96v32c0 17.7 14.3 32 32 32s32-14.3 32-32V80c0-26.5-21.5-48-48-48H48C21.5 32 0 53.5 0 80v48c0 17.7 14.3 32 32 32s32-14.3 32-32zm320 176v-16h64v128h-16c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32h-16V288h64v16c0 17.7 14.3 32 32 32s32-14.3 32-32v-32c0-26.5-21.5-48-48-48H368c-26.5 0-48 21.5-48 48v32c0 17.7 14.3 32 32 32s32-14.3 32-32z"
        }
    ]
};

const FasTextSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTextSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L355.7 253.5 400.2 96H503l-6 24.2c-4.3 17.1 6.1 34.5 23.3 38.8s34.5-6.1 38.8-23.3l11-44.1c7.5-30.3-15.4-59.6-46.6-59.6h-319c-22 0-41.2 15-46.6 36.4l-6.3 25.2L38.8 5.1zm168 131.7c.1-.3.2-.7.3-1L217 96h116.7l-32.4 114.8-94.5-74.1zM243.3 416H192c-17.7 0-32 14.3-32 32s14.3 32 32 32h160c17.7 0 32-14.3 32-32s-14.3-32-32-32h-42.2l17.6-62.1-54.5-42.9-29.6 105z"
        }
    ]
};

const FasTextWidth = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTextWidth",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 128V96h128v128h-16c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32h-16V96h128v32c0 17.7 14.3 32 32 32s32-14.3 32-32V80c0-26.5-21.5-48-48-48H48C21.5 32 0 53.5 0 80v48c0 17.7 14.3 32 32 32s32-14.3 32-32zM9.4 361.4c-12.5 12.5-12.5 32.8 0 45.3l64 64c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6v-32H320v32c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l64-64c12.5-12.5 12.5-32.8 0-45.3l-64-64c-9.2-9.2-22.9-11.9-34.9-6.9S320 307.1 320 320.1v32H128V320c0-12.9-7.8-24.6-19.8-29.6s-25.7-2.2-34.9 6.9l-64 64z"
        }
    ]
};

const FasText = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasText",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 96v32c0 17.7-14.3 32-32 32S0 145.7 0 128V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48v48c0 17.7-14.3 32-32 32s-32-14.3-32-32V96H256v320h48c17.7 0 32 14.3 32 32s-14.3 32-32 32H144c-17.7 0-32-14.3-32-32s14.3-32 32-32h48V96H64z"
        }
    ]
};

const FasThermometer = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasThermometer",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 382.1v-88.8c0-14.9 5.9-29.1 16.4-39.6l27.3-27.3 57 57c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-57-57 41.4-41.4 57 57c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-57-57 41.4-41.4 57 57c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-57-57 45.5-45.5C355.2 10.9 381.4 0 408.8 0 465.8 0 512 46.2 512 103.2c0 27.4-10.9 53.6-30.2 73L258.3 399.6a55.924 55.924 0 0 1-39.6 16.4h-88.8L41 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l89-89z"
        }
    ]
};

const FasTheta = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTheta",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 256c0-51 15.9-96 40.2-127.6C128.5 96.9 159.8 80 192 80s63.5 16.9 87.8 48.4C304.1 160 320 205 320 256s-15.9 96-40.2 127.6C255.5 415.1 224.2 432 192 432s-63.5-16.9-87.8-48.4C79.9 352 64 307 64 256zM192 16C135.8 16 87.1 45.7 53.5 89.4 19.9 133.1 0 192.1 0 256s19.9 122.9 53.5 166.6C87.1 466.3 135.8 496 192 496s104.9-29.7 138.5-73.4C364.1 378.9 384 319.9 384 256s-19.9-122.9-53.5-166.6C296.9 45.7 248.2 16 192 16zm-64 208c-17.7 0-32 14.3-32 32s14.3 32 32 32h128c17.7 0 32-14.3 32-32s-14.3-32-32-32H128z"
        }
    ]
};

const FasThoughtBubble = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasThoughtBubble",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M374.8 80.3C355.9 33.2 309.8 0 256 0s-99.9 33.2-118.8 80.3c-3-.2-6.1-.3-9.2-.3C57.3 80 0 137.3 0 208s57.3 128 128 128c14.4 0 28.3-2.4 41.3-6.8 15.4 32.4 48.4 54.8 86.7 54.8s71.3-22.4 86.7-54.8c12.9 4.4 26.8 6.8 41.3 6.8 70.7 0 128-57.3 128-128S454.7 80 384 80c-3.1 0-6.1.1-9.2.3zM144 480a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM32 512a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FasThumbsDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasThumbsDown",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M313.4 479.1c26-5.2 42.9-30.5 37.7-56.5l-2.3-11.4c-5.3-26.7-15.1-52.1-28.8-75.2h144c26.5 0 48-21.5 48-48 0-18.5-10.5-34.6-25.9-42.6C497 236.6 504 223.1 504 208c0-23.4-16.8-42.9-38.9-47.1 4.4-7.3 6.9-15.8 6.9-24.9 0-21.3-13.9-39.4-33.1-45.6.7-3.3 1.1-6.8 1.1-10.4 0-26.5-21.5-48-48-48h-97.5c-19 0-37.5 5.6-53.3 16.1l-38.5 25.7C176 91.6 160 121.6 160 153.7v111.2c0 29.2 13.3 56.7 36 75l7.4 5.9c26.5 21.2 44.6 51 51.2 84.2l2.3 11.4c5.2 26 30.5 42.9 56.5 37.7zM32 384h64c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H32c-17.7 0-32 14.3-32 32v224c0 17.7 14.3 32 32 32z"
        }
    ]
};

const FasThumbsUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasThumbsUp",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M313.4 32.9c26 5.2 42.9 30.5 37.7 56.5l-2.3 11.4c-5.3 26.7-15.1 52.1-28.8 75.2h144c26.5 0 48 21.5 48 48 0 18.5-10.5 34.6-25.9 42.6C497 275.4 504 288.9 504 304c0 23.4-16.8 42.9-38.9 47.1 4.4 7.3 6.9 15.8 6.9 24.9 0 21.3-13.9 39.4-33.1 45.6.7 3.3 1.1 6.8 1.1 10.4 0 26.5-21.5 48-48 48h-97.5c-19 0-37.5-5.6-53.3-16.1l-38.5-25.7C176 420.4 160 390.4 160 358.3V247.1c0-29.2 13.3-56.7 36-75l7.4-5.9c26.5-21.2 44.6-51 51.2-84.2l2.3-11.4c5.2-26 30.5-42.9 56.5-37.7zM32 192h64c17.7 0 32 14.3 32 32v224c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V224c0-17.7 14.3-32 32-32z"
        }
    ]
};

const FasThumbtack = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasThumbtack",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 32C32 14.3 46.3 0 64 0h256c17.7 0 32 14.3 32 32s-14.3 32-32 32h-29.5l11.4 148.2c36.7 19.9 65.7 53.2 79.5 94.7l1 3c3.3 9.8 1.6 20.5-4.4 28.8S362.3 352 352 352H32c-10.3 0-19.9-4.9-26-13.3s-7.7-19.1-4.4-28.8l1-3c13.8-41.5 42.8-74.8 79.5-94.7L93.5 64H64c-17.7 0-32-14.3-32-32zm128 352h64v96c0 17.7-14.3 32-32 32s-32-14.3-32-32v-96z"
        }
    ]
};

const FasTick = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTick",
    "viewBox": "0 0 128 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 98.3V96c0-35.3 28.7-64 64-64s64 28.7 64 64v2.3c0 3.8-.3 7.6-1 11.4l-25.5 146.8C98.3 274.7 82.5 288 64 288s-34.3-13.3-37.5-31.5L1 109.6c-.7-3.8-1-7.5-1-11.4z"
        }
    ]
};

const FasTicketAirline = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTicketAirline",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64C28.7 64 0 92.7 0 128v256c0 35.3 28.7 64 64 64h512c35.3 0 64-28.7 64-64v-48c0-8.8-7.3-15.8-15.8-18-27.7-7-48.2-32.1-48.2-62s20.5-55 48.2-62c8.6-2.2 15.8-9.1 15.8-18v-48c0-35.3-28.7-64-64-64H64zm352 64a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm0 64a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm16 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-16 80a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm16 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM176 224l-28.5-85.5c-1.7-5.2 2.1-10.5 7.6-10.5h31.1c8.5 0 16.4 4.5 20.7 11.9L256 224h46.9c16.1 0 31.5 6.4 42.8 17.7 7.9 7.9 7.9 20.7 0 28.5-11.3 11.4-26.7 17.8-42.8 17.8H256l-49.1 84.1a23.93 23.93 0 0 1-20.7 11.9h-31.1c-5.5 0-9.3-5.4-7.6-10.5L176 288h-56l-19.2 25.6c-3 4-7.8 6.4-12.8 6.4H74.2c-5.2 0-9-4.9-7.8-9.9L79 259.9c.6-2.5.6-5.2 0-7.8l-12.5-50.2c-1.3-5 2.6-9.9 7.8-9.9H88c5 0 9.8 2.4 12.8 6.4L120 224h56z"
        }
    ]
};

const FasTicketSimple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTicketSimple",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 128c0-35.3 28.7-64 64-64h448c35.3 0 64 28.7 64 64v64c0 8.8-7.4 15.7-15.7 18.6C541.5 217.1 528 235 528 256s13.5 38.9 32.3 45.4c8.3 2.9 15.7 9.8 15.7 18.6v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64v-64c0-8.8 7.4-15.7 15.7-18.6C34.5 294.9 48 277 48 256s-13.5-38.9-32.3-45.4C7.4 207.7 0 200.8 0 192v-64z"
        }
    ]
};

const FasTicket = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTicket",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64C28.7 64 0 92.7 0 128v64c0 8.8 7.4 15.7 15.7 18.6C34.5 217.1 48 235 48 256s-13.5 38.9-32.3 45.4C7.4 304.3 0 311.2 0 320v64c0 35.3 28.7 64 64 64h448c35.3 0 64-28.7 64-64v-64c0-8.8-7.4-15.7-15.7-18.6C541.5 294.9 528 277 528 256s13.5-38.9 32.3-45.4c8.3-2.9 15.7-9.8 15.7-18.6v-64c0-35.3-28.7-64-64-64H64zm64 112v160c0 8.8 7.2 16 16 16h288c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16H144c-8.8 0-16 7.2-16 16zm-32-16c0-17.7 14.3-32 32-32h320c17.7 0 32 14.3 32 32v192c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V160z"
        }
    ]
};

const FasTicketsAirline = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTicketsAirline",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 96v224c0 35.3 28.7 64 64 64h416c35.3 0 64-28.7 64-64v-48c0-8.8-7.4-15.7-15.7-18.6C605.5 246.9 592 229 592 208s13.5-38.9 32.3-45.4c8.3-2.9 15.7-9.8 15.7-18.6V96c0-35.3-28.7-64-64-64H160c-35.3 0-64 28.7-64 64zm416 16a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm0 64a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm16 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-16 80a16 16 0 1 1 32 0 16 16 0 1 1-32 0zM265.3 106.5c-1.7-5.2 2.1-10.5 7.6-10.5H304c8.5 0 16.4 4.5 20.7 11.9l39.7 68.1h40.3c16.1 0 31.5 6.4 42.8 17.7 7.9 7.9 7.9 20.7 0 28.5-11.4 11.4-26.8 17.7-42.8 17.7h-40.3L324.7 308a23.93 23.93 0 0 1-20.7 11.9h-31.1c-5.5 0-9.3-5.3-7.6-10.5l23.1-69.4h-42.6l-19.2 25.6c-3 4-7.8 6.4-12.8 6.4H200c-5.2 0-9-4.9-7.8-9.9l12.5-50.2c.6-2.5.6-5.2 0-7.8l-12.5-50.2c-1.3-5 2.6-9.9 7.8-9.9h13.8c5 0 9.8 2.4 12.8 6.4l19.2 25.6h42.7l-23.2-69.5zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120v240c0 66.3 53.7 120 120 120h400c13.3 0 24-10.7 24-24s-10.7-24-24-24H120c-39.8 0-72-32.2-72-72V120z"
        }
    ]
};

const FasTilde = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTilde",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M99.9 192C80.1 192 64 208.1 64 227.9V320c0 17.7-14.3 32-32 32S0 337.7 0 320v-92.1C0 172.7 44.7 128 99.9 128c26.5 0 51.9 10.5 70.6 29.3l152.2 152.2c6.7 6.7 15.9 10.5 25.4 10.5 19.8 0 35.9-16.1 35.9-35.9V192c0-17.7 14.3-32 32-32s32 14.3 32 32v92.1c0 55.2-44.7 99.9-99.9 99.9-26.5 0-51.9-10.5-70.6-29.3L125.3 202.5c-6.7-6.7-15.9-10.5-25.4-10.5z"
        }
    ]
};

const FasTimelineArrow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTimelineArrow",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm32 97.3c28.3-12.3 48-40.5 48-73.3 0-44.2-35.8-80-80-80S48 51.8 48 96c0 32.8 19.7 61 48 73.3V224H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h160v54.7c-28.3 12.3-48 40.5-48 73.3 0 44.2 35.8 80 80 80s80-35.8 80-80c0-32.8-19.7-61-48-73.3V288h274.7l-41.4 41.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l96-96c12.5-12.5 12.5-32.8 0-45.3l-96-96c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l41.4 41.3H384v-54.7c28.3-12.3 48-40.5 48-73.3 0-44.2-35.8-80-80-80s-80 35.8-80 80c0 32.8 19.7 61 48 73.3V224H160v-54.7zM328 96a24 24 0 1 1 48 0 24 24 0 1 1-48 0zM224 392a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FasTimeline = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTimeline",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm32 97.3c28.3-12.3 48-40.5 48-73.3 0-44.2-35.8-80-80-80S48 51.8 48 96c0 32.8 19.7 61 48 73.3V224H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h256v54.7c-28.3 12.3-48 40.5-48 73.3 0 44.2 35.8 80 80 80s80-35.8 80-80c0-32.8-19.7-61-48-73.3V288h256c17.7 0 32-14.3 32-32s-14.3-32-32-32h-64v-54.7c28.3-12.3 48-40.5 48-73.3 0-44.2-35.8-80-80-80s-80 35.8-80 80c0 32.8 19.7 61 48 73.3V224H160v-54.7zM488 96a24 24 0 1 1 48 0 24 24 0 1 1-48 0zM320 392a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FasTimer = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTimer",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 0c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32s32-14.3 32-32V66.7c90.8 15.2 160 94.2 160 189.3 0 106-86 192-192 192S64 362 64 256c0-53.7 22-102.3 57.6-137.1 12.6-12.4 12.8-32.6.5-45.3s-32.6-12.8-45.3-.5C29.5 119.6 0 184.4 0 256c0 141.4 114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zm-63 159c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l80 80c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-80-80z"
        }
    ]
};

const FasTireFlat = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTireFlat",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32C114.6 32 0 146.6 0 288c0 47.3 12.8 91.7 35.2 129.7C14.9 423.3 0 441.9 0 464c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48 0-22.1-14.9-40.7-35.2-46.3 22.4-38 35.2-82.4 35.2-129.7 0-141.4-114.6-256-256-256zm96 384c-2.1 1.6-4.3 3.2-6.6 4.7-25.5 17.2-56.3 27.3-89.4 27.3-36 0-69.3-11.9-96-32-38.9-29.2-64-75.7-64-128 0-88.4 71.6-160 160-160s160 71.6 160 160c0 52.3-25.1 98.8-64 128zm-96-96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm16 95c44.3-5.5 81.5-33.6 99.8-72.4l-61.9-20.1c-8.6 13.5-22.1 23.5-38 27.6v65zm109.7-102.8c1.5-7.8 2.3-15.9 2.3-24.2 0-36.8-15.5-69.9-40.3-93.3l-38.2 52.6c9.1 11 14.5 25.2 14.5 40.6 0 1.4 0 2.7-.1 4l61.8 20.1zM256 224c8.3 0 16.3 1.6 23.6 4.5l38.2-52.6C299.5 165.8 278.4 160 256 160s-43.5 5.8-61.8 15.9l28.1 38.8 10 13.8c7.3-2.9 15.3-4.5 23.6-4.5zm-128 64c0 8.3.8 16.3 2.3 24.2l61.8-20.2c-.1-1.3-.1-2.7-.1-4 0-15.4 5.5-29.6 14.5-40.6l-10.1-13.9-28.1-38.7C143.5 218.1 128 251.2 128 288zm12.2 54.6c18.3 38.8 55.5 66.9 99.8 72.4v-65c-15.8-4.1-29.3-14.1-37.9-27.5l-61.9 20.1z"
        }
    ]
};

const FasTirePressureWarning = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTirePressureWarning",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 32c0-17.7 14.3-32 32-32s32 14.3 32 32v22.5c0 24.1 3.9 48 11.5 70.8l2.5 7.4c4.8 14.4 11.5 28.6 19.3 44.4 17.5 35.6 33.4 82.6 27.5 136.2-5.3 48.6-28.1 99-76.8 148.7v34c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-8h-32v8c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-8h-32v8c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-8h-32v8c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16v-34C31.3 412.3 8.6 361.9 3.2 313.3c-5.9-53.6 9.9-100.6 27.5-136.2 7.8-15.8 14.5-30 19.3-44.4l2.5-7.4C60.1 102.5 64 78.5 64 54.5V32C64 14.3 78.3 0 96 0s32 14.3 32 32v22.5c0 31-5 61.7-14.8 91.1l-2.5 7.4c-6.3 19-14.8 36.6-22.6 52.5-14.7 29.7-25.3 64-21.3 100.9 3.7 34 20.4 74.1 65.7 117.7h246.9c45.3-43.6 62-83.7 65.7-117.7 4.1-36.9-6.6-71.1-21.3-100.9-7.8-15.8-16.3-33.5-22.6-52.5l-2.5-7.4C389 116.2 384 85.4 384 54.5V32zm-104 88v112c0 13.3-10.7 24-24 24s-24-10.7-24-24V120c0-13.3 10.7-24 24-24s24 10.7 24 24zm-24 168a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FasTireRugged = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTireRugged",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 24c0-13.3-10.7-24-24-24h-80c-13.3 0-24 10.7-24 24v17.3c-14.9 4.4-29.2 10.4-42.6 17.7l-.9-.9-11.3-11.4c-9.4-9.4-24.6-9.4-33.9 0l-56.6 56.6c-9.4 9.4-9.4 24.6 0 33.9L58 148.5l.9.9c-7.3 13.4-13.2 27.7-17.7 42.6H24c-13.3 0-24 10.7-24 24v80c0 13.3 10.7 24 24 24h17.3c4.4 14.9 10.4 29.2 17.7 42.6l-.9.9-11.4 11.3c-9.4 9.4-9.4 24.6 0 33.9l56.6 56.6c9.4 9.4 24.6 9.4 33.9 0l11.3-11.3.9-.9c13.4 7.3 27.7 13.2 42.6 17.7v17.3c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24v-17.4c14.9-4.4 29.2-10.4 42.6-17.7l.9.9 11.3 11.3c9.4 9.4 24.6 9.4 33.9 0l56.6-56.6c9.4-9.4 9.4-24.6 0-33.9L454 363.5l-.9-.9c7.3-13.4 13.2-27.7 17.7-42.6h17.3c13.3 0 24-10.7 24-24v-80c0-13.3-10.7-24-24-24h-17.4c-4.4-14.9-10.4-29.2-17.7-42.6l.9-.9 11.3-11.3c9.4-9.4 9.4-24.6 0-33.9l-56.5-56.6c-9.4-9.4-24.6-9.4-33.9 0L363.5 58l-.9.9c-13.4-7.3-27.7-13.2-42.6-17.7V24zm-64 104a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-61.1 2.9a24 24 0 1 0-14.8 45.7 24 24 0 1 0 14.8-45.7zm106.7 30.2a24 24 0 1 0 45.7-14.8 24 24 0 1 0-45.7 14.8zm-22.7 87.2a24 24 0 1 0 38.8-28.2 24 24 0 1 0-38.8 28.2zm-51.1-33.5a24 24 0 1 0-28.2 38.8 24 24 0 1 0 28.2-38.8z"
        }
    ]
};

const FasTire = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTire",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm32-256a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm-16.1 62v65c44.3-5.5 81.5-33.6 99.8-72.4l-61.9-20.1c-8.6 13.5-22.1 23.5-38 27.6zm47.9-58 61.8 20.1c1.5-7.8 2.3-15.9 2.3-24.2 0-36.8-15.5-69.9-40.3-93.3l-38.2 52.6c9.1 11 14.5 25.2 14.5 40.6 0 1.4 0 2.7-.1 4zm-40.2-63.5 38.2-52.6C299.5 133.8 278.4 128 256 128s-43.5 5.8-61.8 15.9l28.1 38.8 10 13.8c7.3-2.9 15.3-4.5 23.6-4.5s16.3 1.6 23.6 4.5zm-111.3-33.8C143.5 186.1 128 219.2 128 256c0 8.3.8 16.3 2.3 24.2l61.8-20.2c-.1-1.3-.1-2.7-.1-4 0-15.4 5.5-29.6 14.5-40.6l-10.1-13.9-28.1-38.7zM202 290.4l-61.9 20.1c18.3 38.8 55.5 66.9 99.8 72.4v-65c-15.8-4.1-29.3-14.1-37.9-27.5zM256 96a160 160 0 1 1 0 320 160 160 0 1 1 0-320z"
        }
    ]
};

const FasToggleLargeOff = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasToggleLargeOff",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 384a128 128 0 1 1 0-256 128 128 0 1 1 0 256zm0 64h192c106 0 192-86 192-192S490 64 384 64H192C86 64 0 150 0 256s86 192 192 192zm143.1-64c30.4-34 48.9-78.8 48.9-128s-18.5-94-48.9-128H384c70.7 0 128 57.3 128 128s-57.3 128-128 128h-48.9z"
        }
    ]
};

const FasToggleLargeOn = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasToggleLargeOn",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 64C86 64 0 150 0 256s86 192 192 192h192c106 0 192-86 192-192S490 64 384 64H192zm192 64a128 128 0 1 1 0 256 128 128 0 1 1 0-256z"
        }
    ]
};

const FasToggleOff = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasToggleOff",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 128c70.7 0 128 57.3 128 128s-57.3 128-128 128H192c-70.7 0-128-57.3-128-128s57.3-128 128-128h192zm192 128c0-106-86-192-192-192H192C86 64 0 150 0 256s86 192 192 192h192c106 0 192-86 192-192zm-384 96a96 96 0 1 0 0-192 96 96 0 1 0 0 192z"
        }
    ]
};

const FasToggleOn = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasToggleOn",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 64C86 64 0 150 0 256s86 192 192 192h192c106 0 192-86 192-192S490 64 384 64H192zm192 96a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"
        }
    ]
};

const FasToiletPaperBlankUnder = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasToiletPaperBlankUnder",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M348.2 0H96C43 0 0 86 0 192s43 192 96 192h252.2c-11.6-12.2-21.1-26.9-28.7-41.9C299.5 302 288 248.9 288 192s11.5-110 31.5-150.1c7.5-15 17.1-29.7 28.7-41.9zM384 10.9c-37.3 26.4-64 97.5-64 181.1s26.7 154.7 64 181.1c10 7.1 20.8 10.9 32 10.9 35.5 0 66.6-38.6 83.2-96 8.2-28.2 12.8-61 12.8-96C512 86 469 0 416 0c-11.2 0-22 3.8-32 10.9zM416 256c-17.7 0-32-28.7-32-64s14.3-64 32-64 32 28.7 32 64-14.3 64-32 64zM160 464c0 26.5 21.5 48 48 48h256c26.5 0 48-21.5 48-48V343.1c-19.1 37.8-51.2 72.9-96 72.9H160v48z"
        }
    ]
};

const FasToiletPaperBlank = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasToiletPaperBlank",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 192c0-65.5 13.2-142.4 60.2-192H160c-53 0-96 86-96 192 0 101.5-11.7 170.8-23 213.9-5.1 19.4-10.7 39.9-20.5 57.7-5.9 9.9-6.1 22.1-.4 32.2S36.5 512 48 512h237.9c22.3 0 45.4-12.1 55.4-36.1C356.7 439 384 350.8 384 192zm224 0C608 86 565 0 512 0s-96 86-96 192 43 192 96 192 96-86 96-192zm-64 0c0 35.3-14.3 64-32 64s-32-28.7-32-64 14.3-64 32-64 32 28.7 32 64z"
        }
    ]
};

const FasToiletPaperCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasToiletPaperCheck",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M444.2 0c-47 49.6-60.2 126.5-60.2 192 0 158.8-27.3 247-42.7 283.9-10 24-33.2 36.1-55.4 36.1H48c-11.5 0-22.2-6.2-27.8-16.2s-5.6-22.3.4-32.2c9.8-17.7 15.4-38.2 20.5-57.7C52.3 362.8 64 293.5 64 192 64 86 107 0 160 0h284.2zM512 384c-53 0-96-86-96-192S459 0 512 0s96 86 96 192-43 192-96 192zm0-128c17.7 0 32-28.7 32-64s-14.3-64-32-64-32 28.7-32 64 14.3 64 32 64zm-220.7-68.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L208 225.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72z"
        }
    ]
};

const FasToiletPaperSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasToiletPaperSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-109.7-86C569.9 374 608 291.9 608 192 608 86 565 0 512 0s-96 86-96 192c0 49.1 9.2 93.9 24.4 127.9l-59-46.2c1.6-24.8 2.6-52 2.6-81.6 0-65.5 13.2-142.4 60.2-192H160c-24.8 0-47.4 18.8-64.4 49.6L38.8 5.1zm328.5 380.3-300.8-237C64.9 162.4 64 177 64 192c0 101.5-11.7 170.8-23 213.9-5.1 19.4-10.7 39.9-20.5 57.7-5.9 9.9-6.1 22.1-.4 32.2S36.5 512 48 512h237.9c22.3 0 45.4-12.1 55.4-36.1 7.4-17.7 17.5-47.2 26-90.6zM544 192c0 35.3-14.3 64-32 64s-32-28.7-32-64 14.3-64 32-64 32 28.7 32 64z"
        }
    ]
};

const FasToiletPaperUnderSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasToiletPaperUnderSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-54.8-43v-83c-9.9 19.5-23.2 38.2-39.9 51.8L510 374.4c22.6-14.8 41.4-46 53.1-86.4 8.2-28.2 12.8-61 12.8-96C576 86 533 0 480 0c-11.2 0-22 3.8-32 10.9-37.3 26.4-64 97.5-64 181.1 0 33.8 4.4 65.5 12 93.1l-39.3-30.8c-3.1-19.9-4.7-40.8-4.7-62.3 0-56.9 11.5-110 31.5-150.1 7.5-15 17.1-29.7 28.7-41.9H160c-24.8 0-47.4 18.8-64.4 49.6L38.8 5.1zM528 512l-121.8-96H224v48c0 26.5 21.5 48 48 48h256.3-.3zM64 192c0 106 43 192 96 192h205.5l-299-235.6C64.9 162.4 64 177 64 192zm416 64c-17.7 0-32-28.7-32-64s14.3-64 32-64 32 28.7 32 64-14.3 64-32 64z"
        }
    ]
};

const FasToiletPaperUnder = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasToiletPaperUnder",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 0h252.2c-11.6 12.2-21.2 26.9-28.7 41.9C299.5 82 288 135.1 288 192s11.5 110 31.5 150.1c7.5 15 17.1 29.7 28.7 41.9H96c-53 0-96-86-96-192S43 0 96 0zm224 192c0-83.6 26.7-154.7 64-181.1C394 3.8 404.8 0 416 0c53 0 96 86 96 192 0 35-4.7 67.8-12.8 96-16.6 57.4-47.6 96-83.2 96-11.2 0-22-3.8-32-10.9-37.3-26.4-64-97.5-64-181.1zm64 0c0 35.3 14.3 64 32 64s32-28.7 32-64-14.3-64-32-64-32 28.7-32 64zM160 416h256c44.8 0 76.9-35.2 96-72.9V464c0 26.5-21.5 48-48 48H208c-26.5 0-48-21.5-48-48v-48zM64 208a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm64 0a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm48 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-16a16 16 0 1 0-32 0 16 16 0 1 0 32 0z"
        }
    ]
};

const FasToiletPaperXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasToiletPaperXmark",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 0h252.2c-11.6 12.2-21.2 26.9-28.7 41.9C299.5 82 288 135.1 288 192s11.5 110 31.5 150.1c7.5 15 17.1 29.7 28.7 41.9H96c-53 0-96-86-96-192S43 0 96 0zm224 192c0-83.6 26.7-154.7 64-181.1C394 3.8 404.8 0 416 0c53 0 96 86 96 192 0 35-4.7 67.8-12.8 96-16.6 57.4-47.6 96-83.2 96-11.2 0-22-3.8-32-10.9-37.3-26.4-64-97.5-64-181.1zm64 0c0 35.3 14.3 64 32 64s32-28.7 32-64-14.3-64-32-64-32 28.7-32 64zM160 416h256c44.8 0 76.9-35.2 96-72.9V464c0 26.5-21.5 48-48 48H208c-26.5 0-48-21.5-48-48v-48zm51.3-283.3c-6.2-6.2-16.4-6.2-22.6 0L152 169.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l36.7 36.7-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l36.7-36.7 36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L174.6 192l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6z"
        }
    ]
};

const FasToiletPaper = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasToiletPaper",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M444.2 0c-47 49.6-60.2 126.5-60.2 192 0 158.8-27.3 247-42.7 283.9-10 24-33.2 36.1-55.4 36.1H48c-11.5 0-22.2-6.2-27.8-16.2s-5.6-22.3.4-32.2c9.8-17.7 15.4-38.2 20.5-57.7C52.3 362.8 64 293.5 64 192 64 86 107 0 160 0h284.2zM512 384c-53 0-96-86-96-192S459 0 512 0s96 86 96 192-43 192-96 192zm0-128c17.7 0 32-28.7 32-64s-14.3-64-32-64-32 28.7-32 64 14.3 64 32 64zm-368-48a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm64 0a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm48 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-16a16 16 0 1 0-32 0 16 16 0 1 0 32 0z"
        }
    ]
};

const FasToiletPortable = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasToiletPortable",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 32v32h320V32c0-17.7-14.3-32-32-32H32C14.3 0 0 14.3 0 32zm24 64H0v392c0 13.3 10.7 24 24 24s24-10.7 24-24v-8h224v8c0 13.3 10.7 24 24 24s24-10.7 24-24V96H24zm232 144v64c0 8.8-7.2 16-16 16s-16-7.2-16-16v-64c0-8.8 7.2-16 16-16s16 7.2 16 16z"
        }
    ]
};

const FasToilet = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasToilet",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M24 0C10.7 0 0 10.7 0 24s10.7 24 24 24h8v148.9c-1.9 1.4-3.8 2.9-5.6 4.4C10.9 214.5 0 232.9 0 256c0 46.9 14.3 84.1 37 112.5 14.2 17.7 31.1 31.3 48.5 41.8l-19.9 59.6c-3.3 9.8-1.6 20.5 4.4 28.8S85.7 512 96 512h256c10.3 0 19.9-4.9 26-13.3s7.7-19.1 4.4-28.8l-19.8-59.5c17.4-10.5 34.3-24.1 48.5-41.8 22.7-28.4 37-65.5 37-112.5 0-23.1-10.9-41.5-26.4-54.6-1.8-1.5-3.7-3-5.6-4.4V48h8c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zm360 256.3c0 1-.3 2.6-3.8 5.6-4.8 4.1-14 9-29.3 13.4C320.5 284 276.1 288 224 288s-96.5-4-126.9-12.8c-15.3-4.4-24.5-9.3-29.3-13.4-3.5-3-3.8-4.6-3.8-5.6v-.4c0-1 0-2.5 3.8-5.8 4.8-4.1 14-9 29.3-13.4C127.5 228 171.9 224 224 224s96.5 4 126.9 12.8c15.3 4.4 24.5 9.3 29.3 13.4 3.8 3.2 3.8 4.8 3.8 5.8v.4zM328.2 384l-.2.5v-.5h.2zM112 64h32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FasToiletsPortable = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasToiletsPortable",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 0h192c17.7 0 32 14.3 32 32v32H0V32C0 14.3 14.3 0 32 0zM0 96h256v392c0 13.3-10.7 24-24 24s-24-10.7-24-24v-8H48v8c0 13.3-10.7 24-24 24S0 501.3 0 488V96zm192 128c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16v-64c0-8.8-7.2-16-16-16zM352 0h192c17.7 0 32 14.3 32 32v32H320V32c0-17.7 14.3-32 32-32zm-32 96h256v392c0 13.3-10.7 24-24 24s-24-10.7-24-24v-8H368v8c0 13.3-10.7 24-24 24s-24-10.7-24-24V96zm192 128c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16v-64c0-8.8-7.2-16-16-16z"
        }
    ]
};

const FasTomato = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTomato",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m241 7-17 17 17-17 .1.1.2.2.5.5c.4.4 1 1 1.7 1.8 1.4 1.5 3.2 3.6 5.4 6.3 4.4 5.4 10.1 13.1 15.8 22.8 6.6 11.2 13.4 25.5 18 42.1 45.7 3.1 88.5 14.2 125.1 32.8 6.6 3.4 10 10.8 8.3 18s-8.2 12.3-15.6 12.3h-34.6l15.4 23.1c3.9 5.9 3.5 13.7-1 19.1s-12.1 7.3-18.6 4.5L256 145.4l-105.7 45.3c-6.5 2.8-14.1 1-18.6-4.5s-4.9-13.2-1-19.1l15.5-23.3-31.3-.2c-7 1.5-14.3-1.7-17.7-8.4-4-7.9-.9-17.5 7-21.5l.8-.4c37.2-18.7 80.6-29.8 127-32.6-2.6-6.4-5.6-12.3-8.7-17.6-4.3-7.3-8.6-13-11.7-16.9-1.6-1.9-2.8-3.4-3.6-4.3-.4-.4-.7-.8-.9-.9l-.1-.1c-9.3-9.4-9.3-24.5.1-33.9 9.4-9.4 24.6-9.4 33.9 0zM71.1 154c6 9.4 14.9 16.1 25 19.5-.6 11.8 3.1 23.7 11 33.2 13.6 16.3 36.3 21.8 55.8 13.4l93.1-39.9 93.1 39.9c19.5 8.4 42.2 2.9 55.8-13.4 7.9-9.5 11.7-21.5 11-33.2 10.3-3.5 19.1-10.4 25-19.5 44 35.5 71.1 86.4 71.1 150 0 130.9-114.6 208-256 208S0 434.9 0 304c0-63.6 27.1-114.5 71.1-150z"
        }
    ]
};

const FasTombstoneBlank = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTombstoneBlank",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 0C118 0 32 86 32 192v224h384V192C416 86 330 0 224 0zM32 448c-17.7 0-32 14.3-32 32s14.3 32 32 32h384c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"
        }
    ]
};

const FasTombstone = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTombstone",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 192C32 86 118 0 224 0s192 86 192 192v224H32V192zM0 480c0-17.7 14.3-32 32-32h384c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zm248-360c0-13.3-10.7-24-24-24s-24 10.7-24 24v40h-48c-13.3 0-24 10.7-24 24s10.7 24 24 24h48v120c0 13.3 10.7 24 24 24s24-10.7 24-24V208h48c13.3 0 24-10.7 24-24s-10.7-24-24-24h-48v-40z"
        }
    ]
};

const FasToolbox = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasToolbox",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 88v40h160V88c0-4.4-3.6-8-8-8H184c-4.4 0-8 3.6-8 8zm-48 40V88c0-30.9 25.1-56 56-56h144c30.9 0 56 25.1 56 56v40h28.1c12.7 0 24.9 5.1 33.9 14.1l51.9 51.9c9 9 14.1 21.2 14.1 33.9V304H384v-16c0-17.7-14.3-32-32-32s-32 14.3-32 32v16H192v-16c0-17.7-14.3-32-32-32s-32 14.3-32 32v16H0v-76.1C0 215.2 5.1 203 14.1 194L66 142.1c9-9 21.2-14.1 33.9-14.1H128zM0 416v-80h128v16c0 17.7 14.3 32 32 32s32-14.3 32-32v-16h128v16c0 17.7 14.3 32 32 32s32-14.3 32-32v-16h128v80c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64z"
        }
    ]
};

const FasTooth = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTooth",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M186.1 52.1c-16.8-13-37.4-20.1-58.6-20.1C74.7 32 32 74.7 32 127.5v6.2c0 15.8 3.7 31.3 10.7 45.5l23.5 47.1c4.5 8.9 7.6 18.4 9.4 28.2l36.7 205.8c2 11.2 11.6 19.4 22.9 19.8s21.4-7.4 24-18.4l28.9-121.3C192.2 323.7 207 312 224 312s31.8 11.7 35.8 28.3l28.9 121.3c2.6 11.1 12.7 18.8 24 18.4s20.9-8.6 22.9-19.8l36.7-205.8c1.8-9.8 4.9-19.3 9.4-28.2l23.5-47.1c7.1-14.1 10.7-29.7 10.7-45.5v-2.1c0-55-44.6-99.6-99.6-99.6-24.1 0-47.4 8.8-65.6 24.6l-3.2 2.8L267 74.5c7 5.4 8.2 15.5 2.8 22.5s-15.5 8.2-22.5 2.8l-24.4-19-37-28.8z"
        }
    ]
};

const FasToothbrush = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasToothbrush",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 224c-35.3 0-64-28.7-64-64s28.7-64 64-64h224c31.2 0 38.2-22.7 39.6-48 .5-8.8 7.6-16.1 16.4-15.2 52.4 5.3 104 36.7 104 95.2 0 53-43 96-96 96H64zm-8 32c13.3 0 24 10.7 24 24v136h32V280c0-13.3 10.7-24 24-24s24 10.7 24 24v136h32V280c0-13.3 10.7-24 24-24s24 10.7 24 24v136h32V280c0-13.3 10.7-24 24-24s24 10.7 24 24v136h32V280c0-13.3 10.7-24 24-24s24 10.7 24 24v136h144c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32V280c0-13.3 10.7-24 24-24z"
        }
    ]
};

const FasToriiGate = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasToriiGate",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 80c0 26.5 21.5 48 48 48h16v64h64v-64h96v64h64v-64h96v64h64v-64h16c26.5 0 48-21.5 48-48V13.4C512 6 506 0 498.6 0c-1.7 0-3.4.3-5 1l-49 19.6C425.7 28.1 405.5 32 385.2 32H126.8c-20.4 0-40.5-3.9-59.4-11.4L18.4 1c-1.6-.6-3.3-1-5-1C6 0 0 6 0 13.4V80zm64 208v192c0 17.7 14.3 32 32 32s32-14.3 32-32V288h256v192c0 17.7 14.3 32 32 32s32-14.3 32-32V288h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h32z"
        }
    ]
};

const FasTornado = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTornado",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 32v13.6c0 17.1 1.7 34 5 50.4h352.8c3.2-6.9 7.5-13.3 13-18.8l38.6-38.6c4.2-4.2 6.6-10 6.6-16C416 10.1 405.9 0 393.4 0H32C14.3 0 0 14.3 0 32zm352.2 96H13.6c12.2 35.9 32.3 68.7 58.8 96H412l-47.2-62.9c-7.3-9.7-11.6-21.2-12.6-33.1zm-226 138.2 116.4 68.5c8.2 4.8 15.8 10.7 22.5 17.3H445c2-9.8 3-19.9 3-30.1 0-23-5.3-45.5-15.3-65.9H110.2c5.2 3.6 10.5 7 16 10.2zM288 384c10.3 21.4 13.8 45.5 9.9 69l-5.9 35.7c-2 12.2 7.4 23.4 19.8 23.4 5.3 0 10.4-2.1 14.2-5.9l78.2-78.2c12.8-12.8 23.1-27.7 30.4-43.9H288z"
        }
    ]
};

const FasTowerBroadcast = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTowerBroadcast",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80.3 44C69.8 69.9 64 98.2 64 128s5.8 58.1 16.3 84c6.6 16.4-1.3 35-17.7 41.7s-35-1.3-41.7-17.7C7.4 202.6 0 166.1 0 128S7.4 53.4 20.9 20C27.6 3.6 46.2-4.3 62.6 2.3S86.9 27.6 80.3 44zm474.8-24C568.6 53.4 576 89.9 576 128s-7.4 74.6-20.9 108c-6.6 16.4-25.3 24.3-41.7 17.7s-24.3-25.3-17.7-41.7c10.5-25.9 16.3-54.2 16.3-84s-5.8-58.1-16.3-84c-6.6-16.4 1.3-35 17.7-41.7s35 1.3 41.7 17.7zM352 128c0 23.7-12.9 44.4-32 55.4V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V183.4c-19.1-11.1-32-31.7-32-55.4 0-35.3 28.7-64 64-64s64 28.7 64 64zM170.6 76.8C163.8 92.4 160 109.7 160 128s3.8 35.6 10.6 51.2c7.1 16.2-.3 35.1-16.5 42.1S119 221 112 204.8c-10.3-23.6-16-49.6-16-76.8s5.7-53.2 16-76.8c7.1-16.2 25.9-23.6 42.1-16.5s23.6 25.9 16.5 42.1zM464 51.2c10.3 23.6 16 49.6 16 76.8s-5.7 53.2-16 76.8c-7.1 16.2-25.9 23.6-42.1 16.5s-23.6-25.9-16.5-42.1c6.8-15.6 10.6-32.9 10.6-51.2s-3.8-35.6-10.6-51.2c-7.1-16.2.3-35.1 16.5-42.1S457 35 464 51.2z"
        }
    ]
};

const FasTowerCell = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTowerCell",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M62.6 2.3C46.2-4.3 27.6 3.6 20.9 20 7.4 53.4 0 89.9 0 128s7.4 74.6 20.9 108c6.6 16.4 25.3 24.3 41.7 17.7s24.3-25.3 17.7-41.7C69.8 186.1 64 157.8 64 128s5.8-58.1 16.3-84C86.9 27.6 79 9 62.6 2.3zm450.8 0C497 9 489.1 27.6 495.7 44c10.5 25.9 16.3 54.2 16.3 84s-5.8 58.1-16.3 84c-6.6 16.4 1.3 35 17.7 41.7s35-1.3 41.7-17.7c13.5-33.4 20.9-69.9 20.9-108s-7.4-74.6-20.9-108c-6.7-16.4-25.3-24.3-41.7-17.7zM340.1 165.2c7.5-10.5 11.9-23.3 11.9-37.2 0-35.3-28.7-64-64-64s-64 28.7-64 64c0 13.9 4.4 26.7 11.9 37.2l-137 301.6c-7.3 16.1-.2 35.1 15.9 42.4s35.1.2 42.4-15.9l20.5-45.3h220.6l20.6 45.2c7.3 16.1 26.3 23.2 42.4 15.9s23.2-26.3 15.9-42.4L340.1 165.2zM369.2 384H206.8l14.5-32h133.4l14.5 32zM288 205.3l37.6 82.7h-75.2l37.6-82.7zM163.3 73.6c5.3-12.1-.2-26.3-12.4-31.6s-26.3.2-31.6 12.4C109.5 77 104 101.9 104 128s5.5 51 15.3 73.6c5.3 12.1 19.5 17.7 31.6 12.4s17.7-19.5 12.4-31.6c-7.3-16.6-11.3-35-11.3-54.4s4-37.8 11.3-54.4zm293.4-19.2c-5.3-12.1-19.5-17.7-31.6-12.4s-17.7 19.5-12.4 31.6c7.3 16.6 11.3 35 11.3 54.4s-4 37.8-11.3 54.4c-5.3 12.1.2 26.3 12.4 31.6s26.3-.2 31.6-12.4C466.5 179 472 154.1 472 128s-5.5-51-15.3-73.6z"
        }
    ]
};

const FasTowerControl = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTowerControl",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M184 0c-13.3 0-24 10.7-24 24s10.7 24 24 24h16v48h-40c-17.7 0-32 14.3-32 32H42.6C16 128-3.2 153.4 4.1 179l40.4 141.2C28.5 321.9 16 335.5 16 352c0 17.7 14.3 32 32 32h32v96c0 17.7 14.3 32 32 32h224c17.7 0 32-14.3 32-32v-96h32c17.7 0 32-14.3 32-32 0-16.5-12.5-30.1-28.5-31.8L443.9 179c7.3-25.6-11.9-51-38.5-51H320c0-17.7-14.3-32-32-32h-40V48h16c13.3 0 24-10.7 24-24S277.3 0 264 0h-80zm-56 192v128h-17c-.1-.3-.1-.5-.2-.8L74.4 192H128zm48 128V192h96v128h-96zm144-128h53.6l-36.4 127.2-.1.3-.1.5h-17V192z"
        }
    ]
};

const FasTowerObservation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTowerObservation",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M241.7 3.4c9-4.5 19.6-4.5 28.6 0l160 80c15.8 7.9 22.2 27.1 14.3 42.9C439 137.5 427.7 144 416 144v80c0 17.7-14.3 32-32 32h-4.9l32 192H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h68.9l32-192H128c-17.7 0-32-14.3-32-32v-80c-11.7 0-23-6.5-28.6-17.7-7.9-15.8-1.5-35 14.3-42.9l160-80zM314.5 448 256 399.2 197.5 448h117zM197.8 256l-4.7 28.3 62.9 52.5 62.9-52.5-4.7-28.3H197.8zm-13.9 83.2-11.2 67 45.8-38.2-34.6-28.8zM293.5 368l45.8 38.1-11.2-67-34.6 28.9zM176 128c-8.8 0-16 7.2-16 16s7.2 16 16 16h160c8.8 0 16-7.2 16-16s-7.2-16-16-16H176z"
        }
    ]
};

const FasTractor = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTractor",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 64c0-35.3 28.7-64 64-64h106.3c26.2 0 49.7 15.9 59.4 40.2l48 119.8H480v-33.8c0-24.8 5.8-49.3 16.9-71.6l2.5-5c7.9-15.8 27.1-22.2 42.9-14.3s22.2 27.1 14.3 42.9l-2.5 5c-6.7 13.3-10.1 28-10.1 42.9V160h56c22.1 0 40 17.9 40 40v45.4c0 16.5-8.5 31.9-22.6 40.7l-43.3 27.1c-14.2-5.9-29.8-9.2-46.1-9.2-39.3 0-74.1 18.9-96 48h-80c0 17.7-14.3 32-32 32h-8.2c-1.7 4.8-3.7 9.5-5.8 14.1l5.8 5.8c12.5 12.5 12.5 32.8 0 45.3l-22.6 22.6c-12.5 12.5-32.8 12.5-45.3 0l-5.8-5.8c-4.6 2.2-9.3 4.1-14.1 5.8v8.2c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32v-8.2c-4.8-1.7-9.5-3.7-14.1-5.8l-5.8 5.8c-12.5 12.5-32.8 12.5-45.3 0l-22.6-22.7c-12.5-12.5-12.5-32.8 0-45.3L46 398c-2.2-4.6-4.1-9.3-5.8-14.1H32c-17.7 0-32-14.3-32-32V320c0-17.7 14.3-32 32-32h8.2c1.7-4.8 3.7-9.5 5.8-14.1l-5.8-5.8c-12.5-12.5-12.5-32.8 0-45.3l22.6-22.6c9-9 21.9-11.5 33.1-7.6V64zm170.3 0H160v96h144.7l-38.4-96zM176 256a80 80 0 1 0 0 160 80 80 0 1 0 0-160zm352 192a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0 64c-48.6 0-88-39.4-88-88 0-29.8 14.8-56.1 37.4-72 14.3-10.1 31.8-16 50.6-16 2.7 0 5.3.1 7.9.3 44.9 4 80.1 41.7 80.1 87.7 0 48.6-39.4 88-88 88z"
        }
    ]
};

const FasTrademark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTrademark",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M345.6 108.8c-8.3-11-22.7-15.5-35.7-11.2S288 114.2 288 128v256c0 17.7 14.3 32 32 32s32-14.3 32-32V224l86.4 115.2c6 8.1 15.5 12.8 25.6 12.8s19.6-4.7 25.6-12.8L576 224v160c0 17.7 14.3 32 32 32s32-14.3 32-32V128c0-13.8-8.8-26-21.9-30.4s-27.5.1-35.7 11.2L464 266.7 345.6 108.8zM0 128c0 17.7 14.3 32 32 32h64v224c0 17.7 14.3 32 32 32s32-14.3 32-32V160h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32z"
        }
    ]
};

const FasTrafficCone = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTrafficCone",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M173.7 128 216 20.3C220.8 8.1 232.7 0 245.8 0h20.4c13.2 0 25 8.1 29.8 20.3L338.3 128H173.7zm-25.1 64h214.8l37.7 96H110.9l37.7-96zM48 448l37.7-96h340.6l37.7 96h16c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h16z"
        }
    ]
};

const FasTrafficLightGo = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTrafficLightGo",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 0C28.7 0 0 28.7 0 64v288c0 88.4 71.6 160 160 160s160-71.6 160-160V64c0-35.3-28.7-64-64-64H64zm96 416a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm0-200a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm0 72a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm-24-176a24 24 0 1 0 48 0 24 24 0 1 0-48 0zm72 0a48 48 0 1 1-96 0 48 48 0 1 1 96 0z"
        }
    ]
};

const FasTrafficLightSlow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTrafficLightSlow",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 0C28.7 0 0 28.7 0 64v288c0 88.4 71.6 160 160 160s160-71.6 160-160V64c0-35.3-28.7-64-64-64H64zm72 368a24 24 0 1 0 48 0 24 24 0 1 0-48 0zm72 0a48 48 0 1 1-96 0 48 48 0 1 1 96 0zm0-128a48 48 0 1 1-96 0 48 48 0 1 1 96 0zm-72-128a24 24 0 1 0 48 0 24 24 0 1 0-48 0zm72 0a48 48 0 1 1-96 0 48 48 0 1 1 96 0z"
        }
    ]
};

const FasTrafficLightStop = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTrafficLightStop",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 0C28.7 0 0 28.7 0 64v288c0 88.4 71.6 160 160 160s160-71.6 160-160V64c0-35.3-28.7-64-64-64H64zm72 368a24 24 0 1 0 48 0 24 24 0 1 0-48 0zm72 0a48 48 0 1 1-96 0 48 48 0 1 1 96 0zm-48-152a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm0 72a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm0-128a48 48 0 1 1 0-96 48 48 0 1 1 0 96z"
        }
    ]
};

const FasTrafficLight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTrafficLight",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 0C28.7 0 0 28.7 0 64v288c0 88.4 71.6 160 160 160s160-71.6 160-160V64c0-35.3-28.7-64-64-64H64zm96 416a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm48-176a48 48 0 1 1-96 0 48 48 0 1 1 96 0zm-48-80a48 48 0 1 1 0-96 48 48 0 1 1 0 96z"
        }
    ]
};

const FasTrailer = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTrailer",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 32C21.5 32 0 53.5 0 80v256c0 26.5 21.5 48 48 48h17.1c7.8-54.3 54.4-96 110.9-96s103.1 41.7 110.9 96H608c17.7 0 32-14.3 32-32s-14.3-32-32-32h-64V80c0-26.5-21.5-48-48-48H48zm32 64c8.8 0 16 7.2 16 16v131.2c-11.4 5.9-22.2 12.9-32 21V112c0-8.8 7.2-16 16-16zm96 128c-5.4 0-10.7.2-16 .7V112c0-8.8 7.2-16 16-16s16 7.2 16 16v112.7c-5.3-.5-10.6-.7-16-.7zm80 19.2V112c0-8.8 7.2-16 16-16s16 7.2 16 16v152.2c-9.8-8.1-20.6-15.2-32-21zM368 96c8.8 0 16 7.2 16 16v192c0 8.8-7.2 16-16 16s-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm112 16v192c0 8.8-7.2 16-16 16s-16-7.2-16-16V112c0-8.8 7.2-16 16-16s16 7.2 16 16zM176 480a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0-112a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FasTrainSubwayTunnel = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTrainSubwayTunnel",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 0C114.6 0 0 114.6 0 256v192c0 35.3 28.7 64 64 64h41.4l64.3-64.3c-32.4-3.2-57.7-30.5-57.7-63.7V192c0-35.3 28.7-64 64-64h160c35.3 0 64 28.7 64 64v192c0 33.2-25.3 60.5-57.7 63.7l64.3 64.3H448c35.3 0 64-28.7 64-64V256C512 114.6 397.4 0 256 0zm105.4 512-64-64h-82.8l-64 64h210.8zM184 192c-13.3 0-24 10.7-24 24v80c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24v-80c0-13.3-10.7-24-24-24h-32zm88 24v80c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24v-80c0-13.3-10.7-24-24-24h-32c-13.3 0-24 10.7-24 24zm-88 184a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm168-24a24 24 0 1 0-48 0 24 24 0 1 0 48 0z"
        }
    ]
};

const FasTrainSubway = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTrainSubway",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 0C43 0 0 43 0 96v256c0 48 35.2 87.7 81.1 94.9l-46 46c-7 7-2 19.1 7.9 19.1h39.7c8.5 0 16.6-3.4 22.6-9.4L160 448h128l54.6 54.6c6 6 14.1 9.4 22.6 9.4H405c10 0 15-12.1 7.9-19.1l-46-46c46-7.1 81.1-46.9 81.1-94.9V96c0-53-43-96-96-96H96zM64 128c0-17.7 14.3-32 32-32h80c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32v-96zm208-32h80c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32h-80c-17.7 0-32-14.3-32-32v-96c0-17.7 14.3-32 32-32zM64 352a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm288-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FasTrainTrack = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTrainTrack",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M222.4 74.1c5.6-16.8-3.5-34.9-20.2-40.5s-34.9 3.5-40.5 20.2L147.6 96H112c-17.7 0-32 14.3-32 32s14.3 32 32 32h14.3L105 224H72c-17.7 0-32 14.3-32 32s14.3 32 32 32h11.6l-21.3 64H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h8.9l-7.3 21.9c-5.6 16.8 3.5 34.9 20.2 40.5s34.9-3.5 40.5-20.2l14-42.1h359.3l14 42.1c5.6 16.8 23.7 25.8 40.5 20.2s25.8-23.7 20.2-40.5l-7.2-21.9h8.9c17.7 0 32-14.3 32-32s-14.3-32-32-32h-30.3l-21.3-64H504c17.7 0 32-14.3 32-32s-14.3-32-32-32h-32.9l-21.3-64H464c17.7 0 32-14.3 32-32s-14.3-32-32-32h-35.6l-14-42.1c-5.6-16.8-23.7-25.8-40.5-20.2s-25.8 23.7-20.2 40.5l7.2 21.8H215.1l7.3-21.9zM193.7 160h188.6l21.3 64H172.4l21.3-64zm252.6 192H129.7l21.3-64h273.9l21.3 64z"
        }
    ]
};

const FasTrainTram = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTrainTram",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M86.8 48c-12.2 0-23.6 5.5-31.2 15L42.7 79C34.5 89.3 19.4 91 9 82.7S-3 59.4 5.3 49L18 33C34.7 12.2 60 0 86.8 0h274.4c26.7 0 52 12.2 68.7 33l12.8 16c8.3 10.4 6.6 25.5-3.8 33.7s-25.5 6.6-33.7-3.7l-12.7-16c-7.6-9.5-19.1-15-31.2-15H248v48h40c53 0 96 43 96 96v160c0 30.6-14.3 57.8-36.6 75.4l65.5 65.5C420 500 415 512 405 512h-39.7c-8.5 0-16.6-3.4-22.6-9.4L288 448H160l-54.6 54.6c-6 6-14.1 9.4-22.6 9.4H43c-10 0-15-12.1-7.9-19.1l65.5-65.5C78.3 409.8 64 382.6 64 352V192c0-53 43-96 96-96h40V48H86.8zM160 160c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h128c17.7 0 32-14.3 32-32v-32c0-17.7-14.3-32-32-32H160zm32 192a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm96 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FasTrainTunnel = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTrainTunnel",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 0C114.6 0 0 114.6 0 256v192c0 35.3 28.7 64 64 64h41.4l64.3-64.3c-32.4-3.2-57.7-30.5-57.7-63.7V192c0-35.3 28.7-64 64-64h160c35.3 0 64 28.7 64 64v192c0 33.2-25.3 60.5-57.7 63.7l64.3 64.3H448c35.3 0 64-28.7 64-64V256C512 114.6 397.4 0 256 0zm105.4 512-64-64h-82.8l-64 64h210.8zM184 192c-13.3 0-24 10.7-24 24v80c0 13.3 10.7 24 24 24h144c13.3 0 24-10.7 24-24v-80c0-13.3-10.7-24-24-24H184zm104 192a32 32 0 1 0-64 0 32 32 0 1 0 64 0z"
        }
    ]
};

const FasTrain = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTrain",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 0C43 0 0 43 0 96v256c0 48 35.2 87.7 81.1 94.9l-46 46c-7 7-2 19.1 7.9 19.1h39.7c8.5 0 16.6-3.4 22.6-9.4L160 448h128l54.6 54.6c6 6 14.1 9.4 22.6 9.4H405c10 0 15-12.1 7.9-19.1l-46-46c46-7.1 81.1-46.9 81.1-94.9V96c0-53-43-96-96-96H96zM64 96c0-17.7 14.3-32 32-32h256c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V96zm160 192a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
        }
    ]
};

const FasTransformerBolt = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTransformerBolt",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M136 24v8h24c8.8 0 16 7.2 16 16s-7.2 16-16 16H64c-8.8 0-16-7.2-16-16s7.2-16 16-16h24v-8c0-13.3 10.7-24 24-24s24 10.7 24 24zm160 0v8h24c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16s7.2-16 16-16h24v-8c0-13.3 10.7-24 24-24s24 10.7 24 24zM48 112c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H64c-8.8 0-16-7.2-16-16zm160 0c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16zM0 192c0-17.7 14.3-32 32-32h320c17.7 0 32 14.3 32 32s-14.3 32-32 32v224c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32V224c-17.7 0-32-14.3-32-32zm232.9 34.7c-6-4-13.9-3.6-19.3 1.1l-112 96c-5.1 4.4-6.9 11.4-4.6 17.7s8.3 10.4 15 10.4h57.8l-25 74.9c-2.3 6.8.3 14.3 6.3 18.3s13.9 3.6 19.3-1.1l112-96c5.1-4.4 6.9-11.4 4.6-17.7s-8.3-10.4-15-10.4h-57.8l25-74.9c2.3-6.8-.3-14.3-6.3-18.3z"
        }
    ]
};

const FasTransgender = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTransgender",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M112 0c6.5 0 12.3 3.9 14.8 9.9s1.1 12.9-3.5 17.4l-31 31L112 78.1l7-7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-7 7 15.2 15.2C187.7 107.6 220.5 96 256 96s68.3 11.6 94.9 31.2l68.8-68.8-31-31c-4.6-4.6-5.9-11.5-3.5-17.4S393.5.1 400 .1h96c8.8 0 16 7.2 16 16v96c0 6.5-3.9 12.3-9.9 14.8s-12.9 1.1-17.4-3.5l-31-31-68.8 68.8c19.5 26.5 31.1 59.3 31.1 94.8 0 80.2-59 146.6-136 158.2V432h16c13.3 0 24 10.7 24 24s-10.7 24-24 24h-16v8c0 13.3-10.7 24-24 24s-24-10.7-24-24v-8h-16c-13.3 0-24-10.7-24-24s10.7-24 24-24h16v-17.8c-77-11.6-136-78-136-158.2 0-35.5 11.6-68.3 31.2-94.9L112 145.9l-7 7c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l7-7-19.8-19.7-31 31c-4.6 4.6-11.5 5.9-17.4 3.5S0 118.5 0 112V16C0 7.2 7.2 0 16 0h96zm240 256a96 96 0 1 0-192 0 96 96 0 1 0 192 0z"
        }
    ]
};

const FasTransporter1 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTransporter1",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM128 512c-17.7 0-32-14.3-32-32s14.3-32 32-32h256c17.7 0 32 14.3 32 32s-14.3 32-32 32H128zm255.7-224c-9.3-.1-18.5-4.2-24.7-12l-31-38.7V288H184v-50.7L153 276c-6.3 7.8-15.4 11.9-24.7 12h-.3c-7 0-14.1-2.3-20-7-13.8-11.1-16-31.2-5-45l57.7-72c18.2-22.7 45.8-36 74.9-36h40.7c29.1 0 56.7 13.2 74.9 36l57.8 72c11 13.8 8.8 33.9-5 45-5.9 4.7-13 7-20 7h-.3zm-327 38.6L64 352l25.4 7.3c3.9 1.1 6.6 4.7 6.6 8.7s-2.7 7.6-6.6 8.7L64 384l-7.3 25.4c-1.1 3.9-4.7 6.6-8.7 6.6s-7.6-2.7-8.7-6.6L32 384l-25.4-7.3C2.7 375.6 0 372.1 0 368s2.7-7.6 6.6-8.7L32 352l7.3-25.4c1.1-3.9 4.7-6.6 8.7-6.6s7.6 2.7 8.7 6.6zM480 160l25.4 7.3c3.9 1.1 6.6 4.7 6.6 8.7s-2.7 7.6-6.6 8.7L480 192l-7.3 25.4c-1.1 3.9-4.7 6.6-8.7 6.6s-7.6-2.7-8.7-6.6L448 192l-25.4-7.3c-3.9-1.1-6.6-4.7-6.6-8.7s2.7-7.6 6.6-8.7L448 160l7.3-25.4c1.1-3.9 4.7-6.6 8.7-6.6s7.6 2.7 8.7 6.6L480 160zM176 320h160c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64h160c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FasTransporter2 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTransporter2",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M56.7 6.6C55.6 2.7 52.1 0 48 0s-7.6 2.7-8.7 6.6L32 32 6.6 39.3C2.7 40.4 0 43.9 0 48s2.7 7.6 6.6 8.7L32 64l7.3 25.4c1.1 3.9 4.6 6.6 8.7 6.6s7.6-2.7 8.7-6.6L64 64l25.4-7.3c3.9-1.1 6.6-4.6 6.6-8.7s-2.7-7.6-6.6-8.7L64 32 56.7 6.6zM256 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM128 512h256c17.7 0 32-14.3 32-32s-14.3-32-32-32H128c-17.7 0-32 14.3-32 32s14.3 32 32 32zm271.4-288-48.1-60c-18.2-22.7-45.8-36-74.9-36h-40.7c-29.1 0-56.7 13.2-74.9 36l-48.1 60h286.7zM480 352l-7.3-25.4c-1.1-3.9-4.7-6.6-8.7-6.6s-7.6 2.7-8.7 6.6L448 352l-25.4 7.3c-3.9 1.1-6.6 4.7-6.6 8.7s2.7 7.6 6.6 8.7L448 384l7.3 25.4c1.1 3.9 4.7 6.6 8.7 6.6s7.6-2.7 8.7-6.6L480 384l25.4-7.3c3.9-1.1 6.6-4.7 6.6-8.7s-2.7-7.6-6.6-8.7L480 352zm-368-96c-8.8 0-16 7.2-16 16s7.2 16 16 16h288c8.8 0 16-7.2 16-16s-7.2-16-16-16H112zm64 64c-8.8 0-16 7.2-16 16s7.2 16 16 16h160c8.8 0 16-7.2 16-16s-7.2-16-16-16H176zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16h160c8.8 0 16-7.2 16-16s-7.2-16-16-16H176z"
        }
    ]
};

const FasTransporter3 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTransporter3",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM128 512h256c17.7 0 32-14.3 32-32s-14.3-32-32-32H128c-17.7 0-32 14.3-32 32s14.3 32 32 32zM56.7 102.6C55.6 98.7 52.1 96 48 96s-7.6 2.7-8.7 6.6L32 128l-25.4 7.3C2.7 136.4 0 139.9 0 144s2.7 7.6 6.6 8.7L32 160l7.3 25.4c1.1 3.9 4.7 6.6 8.7 6.6s7.6-2.7 8.7-6.6L64 160l25.4-7.3c3.9-1.1 6.6-4.7 6.6-8.7s-2.7-7.6-6.6-8.7L64 128l-7.3-25.4zM480 32l-7.3-25.4C471.6 2.7 468.1 0 464 0s-7.6 2.7-8.7 6.6L448 32l-25.4 7.3c-3.9 1.1-6.6 4.7-6.6 8.7s2.7 7.6 6.6 8.7L448 64l7.3 25.4c1.1 3.9 4.7 6.6 8.7 6.6s7.6-2.7 8.7-6.6L480 64l25.4-7.3c3.9-1.1 6.6-4.7 6.6-8.7s-2.7-7.6-6.6-8.7L480 32zm-304 96c-8.8 0-16 7.2-16 16s7.2 16 16 16h160c8.8 0 16-7.2 16-16s-7.2-16-16-16H176zm-32 64c-8.8 0-16 7.2-16 16s7.2 16 16 16h224c8.8 0 16-7.2 16-16s-7.2-16-16-16H144zm-32 64c-8.8 0-16 7.2-16 16s7.2 16 16 16h288c8.8 0 16-7.2 16-16s-7.2-16-16-16H112zm64 64c-8.8 0-16 7.2-16 16s7.2 16 16 16h160c8.8 0 16-7.2 16-16s-7.2-16-16-16H176zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16h160c8.8 0 16-7.2 16-16s-7.2-16-16-16H176z"
        }
    ]
};

const FasTransporter4 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTransporter4",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 0h64c8.8 0 16 7.2 16 16s-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64h64c8.8 0 16 7.2 16 16s-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-48 64h160c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-32 64h224c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-32 64h288c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm64 64h160c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64h160c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16zm304-224 25.4 7.3c3.9 1.1 6.6 4.7 6.6 8.7s-2.7 7.6-6.6 8.7L480 192l-7.3 25.4c-1.1 3.9-4.7 6.6-8.7 6.6s-7.6-2.7-8.7-6.6L448 192l-25.4-7.3c-3.9-1.1-6.6-4.7-6.6-8.7s2.7-7.6 6.6-8.7L448 160l7.3-25.4c1.1-3.9 4.7-6.6 8.7-6.6s7.6 2.7 8.7 6.6L480 160zM56.7 358.6 64 384l25.4 7.3c3.9 1.1 6.6 4.7 6.6 8.7s-2.7 7.6-6.6 8.7L64 416l-7.3 25.4c-1.1 3.9-4.7 6.6-8.7 6.6s-7.6-2.7-8.7-6.6L32 416l-25.4-7.3C2.7 407.6 0 404.1 0 400s2.7-7.6 6.6-8.7L32 384l7.3-25.4c1.1-3.9 4.7-6.6 8.7-6.6s7.6 2.7 8.7 6.6zM96 480c0-17.7 14.3-32 32-32h256c17.7 0 32 14.3 32 32s-14.3 32-32 32H128c-17.7 0-32-14.3-32-32z"
        }
    ]
};

const FasTransporter5 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTransporter5",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m480 32 25.4 7.3c3.9 1.1 6.6 4.7 6.6 8.7s-2.7 7.6-6.6 8.7L480 64l-7.3 25.4c-1.1 3.9-4.7 6.6-8.7 6.6s-7.6-2.7-8.7-6.6L448 64l-25.4-7.3c-3.9-1.1-6.6-4.7-6.6-8.7s2.7-7.6 6.6-8.7L448 32l7.3-25.4c1.1-3.9 4.6-6.6 8.7-6.6s7.6 2.7 8.7 6.6L480 32zM56.7 134.6 64 160l25.4 7.3c3.9 1.1 6.6 4.7 6.6 8.7s-2.7 7.6-6.6 8.7L64 192l-7.3 25.4c-1.1 3.9-4.7 6.6-8.7 6.6s-7.6-2.7-8.7-6.6L32 192l-25.4-7.3C2.7 183.6 0 180.1 0 176s2.7-7.6 6.6-8.7L32 160l7.3-25.4c1.1-3.9 4.7-6.6 8.7-6.6s7.6 2.7 8.7 6.6zM384 512H128c-17.7 0-32-14.3-32-32s14.3-32 32-32h256c17.7 0 32 14.3 32 32s-14.3 32-32 32zM224 0h64c8.8 0 16 7.2 16 16s-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-48 128h160c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-64 128h288c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm64 128h160c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FasTransporter6 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTransporter6",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M56.7 6.6 64 32l25.4 7.3c3.9 1.1 6.6 4.6 6.6 8.7s-2.7 7.6-6.6 8.7L64 64l-7.3 25.4C55.6 93.3 52.1 96 48 96s-7.6-2.7-8.7-6.6L32 64 6.6 56.7C2.7 55.6 0 52.1 0 48s2.7-7.6 6.6-8.7L32 32l7.3-25.4C40.4 2.7 43.9 0 48 0s7.6 2.7 8.7 6.6zM384 512H128c-17.7 0-32-14.3-32-32s14.3-32 32-32h256c17.7 0 32 14.3 32 32s-14.3 32-32 32zm96-128 25.4 7.3c3.9 1.1 6.6 4.7 6.6 8.7s-2.7 7.6-6.6 8.7L480 416l-7.3 25.4c-1.1 3.9-4.7 6.6-8.7 6.6s-7.6-2.7-8.7-6.6L448 416l-25.4-7.3c-3.9-1.1-6.6-4.7-6.6-8.7s2.7-7.6 6.6-8.7L448 384l7.3-25.4c1.1-3.9 4.7-6.6 8.7-6.6s7.6 2.7 8.7 6.6L480 384zM224 0h64c8.8 0 16 7.2 16 16s-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16s7.2-16 16-16zM112 256h288c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FasTransporter7 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTransporter7",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M472.7 38.6c-1.1-3.9-4.7-6.6-8.7-6.6s-7.6 2.7-8.7 6.6L448 64l-25.4 7.3c-3.9 1.1-6.6 4.7-6.6 8.7s2.7 7.6 6.6 8.7L448 96l7.3 25.4c1.1 3.9 4.7 6.6 8.7 6.6s7.6-2.7 8.7-6.6L480 96l25.4-7.3c3.9-1.1 6.6-4.7 6.6-8.7s-2.7-7.6-6.6-8.7L480 64l-7.3-25.4zM64 288l-7.3-25.4c-1.1-3.9-4.7-6.6-8.7-6.6s-7.6 2.7-8.7 6.6L32 288l-25.4 7.3C2.7 296.4 0 299.9 0 304s2.7 7.6 6.6 8.7L32 320l7.3 25.4c1.1 3.9 4.7 6.6 8.7 6.6s7.6-2.7 8.7-6.6L64 320l25.4-7.3c3.9-1.1 6.6-4.7 6.6-8.7s-2.7-7.6-6.6-8.7L64 288zm232 224h88c17.7 0 32-14.3 32-32s-14.3-32-32-32H128c-17.7 0-32 14.3-32 32s14.3 32 32 32h168z"
        }
    ]
};

const FasTransporterEmpty = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTransporterEmpty",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M296 512h88c17.7 0 32-14.3 32-32s-14.3-32-32-32H128c-17.7 0-32 14.3-32 32s14.3 32 32 32h168z"
        }
    ]
};

const FasTransporter = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTransporter",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M208 48a48 48 0 1 1 96 0 48 48 0 1 1-96 0zm40 272v96h-64V237.3L153 276c-11.1 13.8-31.2 16-45 5s-16-31.2-5-45l57.7-72c18.2-22.7 45.8-36 74.9-36h40.7c29.1 0 56.7 13.2 74.9 36l57.8 72c11 13.8 8.8 33.9-5 45s-33.9 8.8-45-5l-31-38.7V416h-64v-96h-16zm-32 192h-88c-17.7 0-32-14.3-32-32s14.3-32 32-32h256c17.7 0 32 14.3 32 32s-14.3 32-32 32H216zM64 96l25.4 7.3c3.9 1.1 6.6 4.7 6.6 8.7s-2.7 7.6-6.6 8.7L64 128l-7.3 25.4c-1.1 3.9-4.7 6.6-8.7 6.6s-7.6-2.7-8.7-6.6L32 128l-25.4-7.3C2.7 119.6 0 116.1 0 112s2.7-7.6 6.6-8.7L32 96l7.3-25.4c1.1-3.9 4.6-6.6 8.7-6.6s7.6 2.7 8.7 6.6L64 96zM472.7 6.6 480 32l25.4 7.3c3.9 1.1 6.6 4.7 6.6 8.7s-2.7 7.6-6.6 8.7L480 64l-7.3 25.4c-1.1 3.9-4.7 6.6-8.7 6.6s-7.6-2.7-8.7-6.6L448 64l-25.4-7.3c-3.9-1.1-6.6-4.7-6.6-8.7s2.7-7.6 6.6-8.7L448 32l7.3-25.4c1.1-3.9 4.6-6.6 8.7-6.6s7.6 2.7 8.7 6.6z"
        }
    ]
};

const FasTrashArrowUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTrashArrowUp",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M163.8 0h120.4c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64s14.3-32 32-32h96l7.2-14.3C140.6 6.8 151.7 0 163.8 0zM32 128h384l-21.2 339c-1.6 25.3-22.6 45-47.9 45H101.1c-25.3 0-46.3-19.7-47.9-45L32 128zm192 64c-6.4 0-12.5 2.5-17 7l-80 80c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l39-39V408c0 13.3 10.7 24 24 24s24-10.7 24-24V273.9l39 39c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-80-80c-4.5-4.5-10.6-7-17-7z"
        }
    ]
};

const FasTrashCanArrowUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTrashCanArrowUp",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M163.8 0h120.4c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64s14.3-32 32-32h96l7.2-14.3C140.6 6.8 151.7 0 163.8 0zM32 128h384v320c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V128zm192 64c-6.4 0-12.5 2.5-17 7l-80 80c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l39-39V408c0 13.3 10.7 24 24 24s24-10.7 24-24V273.9l39 39c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-80-80c-4.5-4.5-10.6-7-17-7z"
        }
    ]
};

const FasTrashCanCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTrashCanCheck",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M163.8 0h120.4c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64s14.3-32 32-32h96l7.2-14.3C140.6 6.8 151.7 0 163.8 0zM32 128h384v320c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V128zm305 137c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L337 265z"
        }
    ]
};

const FasTrashCanClock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTrashCanClock",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M135.2 17.7C140.6 6.8 151.7 0 163.8 0h120.4c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64s14.3-32 32-32h96l7.2-14.3zM32 128h384v64.7c-29.3 2.6-56.6 12.5-80 27.7V208c0-8.8-7.2-16-16-16s-16 7.2-16 16v39.2c-29.8 31.5-48 74-48 120.8 0 59.5 29.6 112.1 74.8 144H96c-35.3 0-64-28.7-64-64V128zm96 64c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm64 176a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm144-80c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32v-48c0-8.8-7.2-16-16-16z"
        }
    ]
};

const FasTrashCanList = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTrashCanList",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M147.8 0c-12.1 0-23.2 6.8-28.6 17.7L112 32H32C14.3 32 0 46.3 0 64s14.3 32 32 32h352c17.7 0 32-14.3 32-32s-14.3-32-32-32h-80l-7.2-14.3C291.4 6.8 280.3 0 268.2 0H147.8zM384 128H32v336c0 26.5 21.5 48 48 48h256c26.5 0 48-21.5 48-48V128zm-224 80v224c0 8.8-7.2 16-16 16s-16-7.2-16-16V208c0-8.8 7.2-16 16-16s16 7.2 16 16zm128 0v224c0 8.8-7.2 16-16 16s-16-7.2-16-16V208c0-8.8 7.2-16 16-16s16 7.2 16 16zm192-80c-17.7 0-32 14.3-32 32s14.3 32 32 32h128c17.7 0 32-14.3 32-32s-14.3-32-32-32H480zm0 128c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32h-96zm-32 160c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32s-14.3-32-32-32h-32c-17.7 0-32 14.3-32 32z"
        }
    ]
};

const FasTrashCanPlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTrashCanPlus",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M163.8 0h120.4c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64s14.3-32 32-32h96l7.2-14.3C140.6 6.8 151.7 0 163.8 0zM32 128h384v320c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V128zm168 280c0 13.3 10.7 24 24 24s24-10.7 24-24v-64h64c13.3 0 24-10.7 24-24s-10.7-24-24-24h-64v-64c0-13.3-10.7-24-24-24s-24 10.7-24 24v64h-64c-13.3 0-24 10.7-24 24s10.7 24 24 24h64v64z"
        }
    ]
};

const FasTrashCanSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTrashCanSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L512 376V128H195.6l-40.8-32H512c17.7 0 32-14.3 32-32s-14.3-32-32-32h-96l-7.2-14.3C403.4 6.8 392.3 0 380.2 0H259.8c-12.1 0-23.2 6.8-28.6 17.7L224 32h-96c-13.4 0-24.8 8.2-29.6 19.8L38.8 5.1zM304 213v-5c0-8.8 7.2-16 16-16s16 7.2 16 16v30l-32-25zm96 75.2V208c0-8.8 7.2-16 16-16s16 7.2 16 16v105.3l-32-25.1zM128 448c0 35.3 28.7 64 64 64h256c20.1 0 38.1-9.3 49.8-23.8L431.5 436c-1.8 6.9-8 12-15.5 12-8.8 0-16-7.2-16-16v-20.8l-64-50.4V432c0 8.8-7.2 16-16 16s-16-7.2-16-16v-96.5l-64-50.4V432c0 8.8-7.2 16-16 16s-16-7.2-16-16V259.9l-80-63V448z"
        }
    ]
};

const FasTrashCanUndo = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTrashCanUndo",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M135.2 17.7 128 32H32C14.3 32 0 46.3 0 64s14.3 32 32 32h384c17.7 0 32-14.3 32-32s-14.3-32-32-32h-96l-7.2-14.3C307.4 6.8 296.3 0 284.2 0H163.8c-12.1 0-23.2 6.8-28.6 17.7zM416 128H32v320c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V128zm-198.2 71.9c8.9 9.9 8.1 25-1.8 33.9L182.5 264H240c48.6 0 88 39.4 88 88v40c0 13.3-10.7 24-24 24s-24-10.7-24-24v-40c0-22.1-17.9-40-40-40h-57.5l33.5 30.2c9.9 8.9 10.7 24 1.8 33.9s-24 10.7-33.9 1.8l-80-72c-5.1-4.6-7.9-11-7.9-17.8s2.9-13.3 7.9-17.8l80-72c9.9-8.9 25-8.1 33.9 1.8z"
        }
    ]
};

const FasTrashCanXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTrashCanXmark",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M163.8 0h120.4c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64s14.3-32 32-32h96l7.2-14.3C140.6 6.8 151.7 0 163.8 0zM32 128h384v320c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V128zm111 111c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z"
        }
    ]
};

const FasTrashCan = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTrashCan",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M135.2 17.7C140.6 6.8 151.7 0 163.8 0h120.4c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64s14.3-32 32-32h96l7.2-14.3zM32 128h384v320c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V128zm96 64c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16z"
        }
    ]
};

const FasTrashCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTrashCheck",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M163.8 0h120.4c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64s14.3-32 32-32h96l7.2-14.3C140.6 6.8 151.7 0 163.8 0zM32 128h384l-21.2 339c-1.6 25.3-22.6 45-47.9 45H101.1c-25.3 0-46.3-19.7-47.9-45L32 128zm305 121c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L337 249z"
        }
    ]
};

const FasTrashClock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTrashClock",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M135.2 17.7 128 32H32C14.3 32 0 46.3 0 64s14.3 32 32 32h384c17.7 0 32-14.3 32-32s-14.3-32-32-32h-96l-7.2-14.3C307.4 6.8 296.3 0 284.2 0H163.8c-12.1 0-23.2 6.8-28.6 17.7zM416 128H32l21.2 339c1.6 25.3 22.6 45 47.9 45h229.7c-45.2-31.9-74.8-84.5-74.8-144 0-90.4 68.2-164.9 155.9-174.9L416 128zm160 240a144 144 0 1 0-288 0 144 144 0 1 0 288 0zm-144-80c8.8 0 16 7.2 16 16v48h32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16v-64c0-8.8 7.2-16 16-16z"
        }
    ]
};

const FasTrashList = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTrashList",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M147.8 0h120.4c12.1 0 23.2 6.8 28.6 17.7L304 32h80c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64s14.3-32 32-32h80l7.2-14.3C124.6 6.8 135.7 0 147.8 0zM32 128h352l-21.2 339c-1.6 25.3-22.6 45-47.9 45H101.1c-25.3 0-46.3-19.7-47.9-45L32 128zm448 0h128c17.7 0 32 14.3 32 32s-14.3 32-32 32H480c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 128h96c17.7 0 32 14.3 32 32s-14.3 32-32 32h-96c-17.7 0-32-14.3-32-32s14.3-32 32-32zm-32 160c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32s-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32z"
        }
    ]
};

const FasTrashPlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTrashPlus",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M163.8 0h120.4c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64s14.3-32 32-32h96l7.2-14.3C140.6 6.8 151.7 0 163.8 0zM32 128h384l-21.2 339c-1.6 25.3-22.6 45-47.9 45H101.1c-25.3 0-46.3-19.7-47.9-45L32 128zm168 280c0 13.3 10.7 24 24 24s24-10.7 24-24v-64h64c13.3 0 24-10.7 24-24s-10.7-24-24-24h-64v-64c0-13.3-10.7-24-24-24s-24 10.7-24 24v64h-64c-13.3 0-24 10.7-24 24s10.7 24 24 24h64v64z"
        }
    ]
};

const FasTrashSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTrashSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L497.2 364.4 512 128H195.6l-40.8-32H512c17.7 0 32-14.3 32-32s-14.3-32-32-32h-96l-7.2-14.3C403.4 6.8 392.3 0 380.2 0H259.8c-12.1 0-23.2 6.8-28.6 17.7L224 32h-96c-13.4 0-24.8 8.2-29.6 19.8L38.8 5.1zM149.2 467c1.6 25.3 22.6 45 47.9 45h245.8c20.6 0 38.3-13 45.1-31.5L132.5 200.4 149.2 467z"
        }
    ]
};

const FasTrashUndo = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTrashUndo",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M135.2 17.7 128 32H32C14.3 32 0 46.3 0 64s14.3 32 32 32h384c17.7 0 32-14.3 32-32s-14.3-32-32-32h-96l-7.2-14.3C307.4 6.8 296.3 0 284.2 0H163.8c-12.1 0-23.2 6.8-28.6 17.7zM416 128H32l21.2 339c1.6 25.3 22.6 45 47.9 45h245.8c25.3 0 46.3-19.7 47.9-45L416 128zm-198.2 71.9c8.9 9.9 8.1 25-1.8 33.9L182.5 264H240c48.6 0 88 39.4 88 88v40c0 13.3-10.7 24-24 24s-24-10.7-24-24v-40c0-22.1-17.9-40-40-40h-57.5l33.5 30.2c9.9 8.9 10.7 24 1.8 33.9s-24 10.7-33.9 1.8l-80-72c-5.1-4.6-7.9-11-7.9-17.8s2.9-13.3 7.9-17.8l80-72c9.9-8.9 25-8.1 33.9 1.8z"
        }
    ]
};

const FasTrashXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTrashXmark",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M163.8 0h120.4c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64s14.3-32 32-32h96l7.2-14.3C140.6 6.8 151.7 0 163.8 0zM32 128h384l-21.2 339c-1.6 25.3-22.6 45-47.9 45H101.1c-25.3 0-46.3-19.7-47.9-45L32 128zm111 111c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z"
        }
    ]
};

const FasTrash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTrash",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M135.2 17.7 128 32H32C14.3 32 0 46.3 0 64s14.3 32 32 32h384c17.7 0 32-14.3 32-32s-14.3-32-32-32h-96l-7.2-14.3C307.4 6.8 296.3 0 284.2 0H163.8c-12.1 0-23.2 6.8-28.6 17.7zM416 128H32l21.2 339c1.6 25.3 22.6 45 47.9 45h245.8c25.3 0 46.3-19.7 47.9-45L416 128z"
        }
    ]
};

const FasTreasureChest = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTreasureChest",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 160v96h128V32C57.3 32 0 89.3 0 160zm0 272c0 26.5 21.5 48 48 48h80V288H0v144zm416-144h-64v32c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32v-32h-64v192h256V288zm112 192c26.5 0 48-21.5 48-48V288H448v192h80zm48-320c0-70.7-57.3-128-128-128v224h128v-96zm-160 96V32H160v224h64v-32c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v32h64zm-112-16c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16v-64z"
        }
    ]
};

const FasTreeChristmas = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTreeChristmas",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m150.2 71 47.1-17.7L215 6.2c1.4-3.8 5-6.2 9-6.2s7.6 2.5 9 6.2l17.7 47.1L297.8 71c3.8 1.4 6.2 5 6.2 9s-2.5 7.6-6.2 9l-47.1 17.7-17.7 47.1c-1.4 3.8-5 6.2-9 6.2s-7.6-2.5-9-6.2l-17.7-47.1L150.2 89c-3.8-1.4-6.2-5-6.2-9s2.5-7.6 6.2-9zM263 165l11.8-31.5 144 180c3.4 4.2 5.2 9.4 5.2 14.8 0 13.1-10.6 23.7-23.7 23.7H368l76.2 122c2.5 4 3.8 8.5 3.8 13.2 0 13.7-11.1 24.9-24.9 24.9H24.9C11.1 512 0 500.9 0 487.1c0-4.7 1.3-9.2 3.8-13.2L80 352H47.7C34.6 352 24 341.4 24 328.3c0-5.4 1.8-10.6 5.2-14.8l144-180L185 165c6.1 16.2 21.6 27 39 27s32.9-10.8 39-27zm-79 123a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm104 152a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FasTreeCity = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTreeCity",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 48c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v144h40v-72c0-13.3 10.7-24 24-24s24 10.7 24 24v72h24c26.5 0 48 21.5 48 48v224c0 26.5-21.5 48-48 48H336c-26.5 0-48-21.5-48-48V48zm64 32v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16zm16 80c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32zm-16 112v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16zm176-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32zm-16 112v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16zM224 160c0 6-1 11-2 16 20 14 34 38 34 64 0 45-36 80-80 80h-16v160c0 18-15 32-32 32-18 0-32-14-32-32V320H80c-45 0-80-35-80-80 0-26 13-50 33-64-1-5-1-10-1-16 0-53 42-96 96-96 53 0 96 43 96 96z"
        }
    ]
};

const FasTreeDeciduous = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTreeDeciduous",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 80c-11.5 0-22.5 2.4-32.4 6.8C347 38.1 305.9 0 256 0s-91 38.1-95.6 86.8c-9.9-4.4-20.9-6.8-32.4-6.8-44.2 0-80 35.8-80 80 0 14.4 3.8 27.9 10.5 39.6C24.1 214.2 0 248.3 0 288c0 53 43 96 96 96h128v96c0 17.7 14.3 32 32 32s32-14.3 32-32v-96h128c53 0 96-43 96-96 0-39.7-24.1-73.8-58.5-88.4 6.7-11.7 10.5-25.2 10.5-39.6 0-44.2-35.8-80-80-80z"
        }
    ]
};

const FasTreeDecorated = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTreeDecorated",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M210.6 5.9 62 169.4c-3.9 4.2-6 9.8-6 15.5 0 12.8 10.3 23.1 23.1 23.1H104L28.5 313.7c-2.9 4.1-4.5 9-4.5 14.1 0 13.3 10.8 24.2 24.2 24.2H80L3.8 474c-2.5 4-3.8 8.5-3.8 13.2C0 500.9 11.1 512 24.9 512h398.2c13.7 0 24.9-11.1 24.9-24.9 0-4.7-1.3-9.2-3.8-13.2L368 352h31.8c13.4 0 24.2-10.9 24.2-24.2 0-5-1.6-10-4.5-14.1L344 208h24.9c12.7 0 23.1-10.3 23.1-23.1 0-5.7-2.1-11.3-6-15.5L237.4 5.9C234 2.1 229.1 0 224 0s-10 2.1-13.4 5.9zM160 264a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72-104a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm56 232a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FasTreeLarge = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTreeLarge",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M62 169.4 210.6 5.9C214 2.1 218.9 0 224 0s10 2.1 13.4 5.9L386 169.4c3.9 4.2 6 9.8 6 15.5 0 12.7-10.3 23.1-23.1 23.1H344l75.5 105.7c2.9 4.1 4.5 9 4.5 14.1 0 13.4-10.9 24.2-24.2 24.2H368l76.2 122c2.5 4 3.8 8.5 3.8 13.2 0 13.7-11.1 24.9-24.9 24.9H24.9C11.1 512 0 500.9 0 487.1c0-4.7 1.3-9.2 3.8-13.2L80 352H48.2C34.8 352 24 341.1 24 327.8c0-5 1.6-10 4.5-14.1L104 208H79.1C66.3 208 56 197.7 56 184.9c0-5.7 2.1-11.3 6-15.5z"
        }
    ]
};

const FasTreePalm = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTreePalm",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m102.9 91.4 30.3 50.5c-4 3.5-8 7.2-12 11.2-71 71-60.2 151-32.7 191.3 5 7.3 15.2 7.3 21.4 1l138.5-138.5c4 10.8 7.8 26.2 9.7 47.2 4.2 46.5-1.6 116.8-32.7 216.4-3 9.7-1.3 20.3 4.8 28.5s15.6 13 25.8 13h64c16.1 0 29.8-12 31.8-28 12.4-99-2.3-207.2-31.7-292h126.6c2.8 0 5.4-1.5 6.9-3.9l19.6-32.7c3.1-5.2 10.6-5.2 13.7 0l19.6 32.7c1.4 2.4 4.1 3.9 6.9 3.9H560c8.8 0 16.1-7.2 14.4-15.9C565.3 128.2 516.4 64 416 64c-43.7 0-77.6 12.2-102.8 29.8C296.5 49.4 248 0 160 0 59.6 0 10.7 64.2 1.6 112.1-.1 120.8 7.2 128 16 128h46.7c2.8 0 5.4-1.5 6.9-3.9l19.5-32.7c3.1-5.2 10.6-5.2 13.7 0z"
        }
    ]
};

const FasTree = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTree",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M210.6 5.9 62 169.4c-3.9 4.2-6 9.8-6 15.5 0 12.8 10.3 23.1 23.1 23.1H104l-73.4 73.4c-4.2 4.2-6.6 10-6.6 16 0 12.5 10.1 22.6 22.6 22.6H80L5.4 409.5c-3.5 4.2-5.4 9.5-5.4 15 0 13 10.5 23.5 23.5 23.5H192v32c0 17.7 14.3 32 32 32s32-14.3 32-32v-32h168.5c13 0 23.5-10.5 23.5-23.5 0-5.5-1.9-10.8-5.4-15L368 320h33.4c12.5 0 22.6-10.1 22.6-22.6 0-6-2.4-11.8-6.6-16L344 208h24.9c12.7 0 23.1-10.3 23.1-23.1 0-5.7-2.1-11.3-6-15.5L237.4 5.9C234 2.1 229.1 0 224 0s-10 2.1-13.4 5.9z"
        }
    ]
};

const FasTrees = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTrees",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M70.2 121.4 178.5 5.8C182 2.1 186.9 0 192 0s10 2.1 13.5 5.8l108.3 115.6c4 4.3 6.2 9.9 6.2 15.7 0 12.7-10.3 22.9-22.9 22.9H272l74.6 89.5c3.5 4.2 5.4 9.5 5.4 15 0 13-10.5 23.5-23.5 23.5H304l74.6 89.5c3.5 4.2 5.4 9.5 5.4 15 0 13-10.5 23.5-23.5 23.5H224v64c0 17.7-14.3 32-32 32s-32-14.3-32-32v-64H23.5C10.5 416 0 405.5 0 392.5c0-5.5 1.9-10.8 5.4-15L80 288H55.5c-13 0-23.5-10.5-23.5-23.5 0-5.5 1.9-10.8 5.4-15L112 160H86.9C74.3 160 64 149.7 64 137.1c0-5.8 2.2-11.4 6.2-15.7zM341.6 105l92.9-99.2C438 2.1 442.9 0 448 0s10 2.1 13.5 5.8l108.3 115.6c4 4.3 6.2 9.9 6.2 15.7 0 12.7-10.3 22.9-22.9 22.9H528l74.6 89.5c3.5 4.2 5.4 9.5 5.4 15 0 13-10.5 23.5-23.5 23.5H560l74.6 89.5c3.5 4.2 5.4 9.5 5.4 15 0 13-10.5 23.5-23.5 23.5H480v64c0 17.7-14.3 32-32 32s-32-14.3-32-32v-88c-.1-12.8-4.7-25.2-12.9-35l-40.6-48.7c13-10.2 21.4-26 21.4-43.8 0-13-4.6-25.6-12.9-35.5l-40.4-48.5c12.9-10 21.3-25.8 21.3-43.4 0-11.6-3.7-22.8-10.4-32.1z"
        }
    ]
};

const FasTriangleExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTriangleExclamation",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32c14.2 0 27.3 7.5 34.5 19.8l216 368c7.3 12.4 7.3 27.7.2 40.1S486.3 480 472 480H40c-14.3 0-27.6-7.7-34.7-20.1s-7-27.8.2-40.1l216-368C228.7 39.5 241.8 32 256 32zm0 128c-13.3 0-24 10.7-24 24v112c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0-64 0 32 32 0 1 0 64 0z"
        }
    ]
};

const FasTriangleInstrument = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTriangleInstrument",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 32c0-17.7-14.3-32-32-32s-32 14.3-32 32v37.9c-18 6.8-33.6 19.4-44.1 36.1L46.5 367.7C37 382.8 32 400.2 32 418c0 51.9 42.1 94 94 94h324c51.9 0 94-42.1 94-94 0-17.8-5-35.2-14.5-50.2L448.2 239l-46.4 46.4 73.6 116.5c3 4.8 4.6 10.4 4.6 16 0 16.6-13.5 30-30 30H126c-16.6 0-30-13.5-30-30 0-5.7 1.6-11.2 4.6-16L266 140.1c4.8-7.6 13.1-12.1 22-12.1s17.3 4.6 22 12.1l48 75.9-51.2 51.2c-5.9-2.1-12.2-3.2-18.8-3.2-30.9 0-56 25.1-56 56s25.1 56 56 56 56-25.1 56-56c0-6.6-1.1-12.9-3.2-18.8l43.5-43.5 46.4-46.4L537 105c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-98.6 98.6-40.4-63.7C353.6 89.2 338 76.7 320 69.9V32z"
        }
    ]
};

const FasTrianglePersonDigging = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTrianglePersonDigging",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M354.5 51.8C347.3 39.5 334.2 32 320 32s-27.3 7.5-34.5 19.8l-216 368c-7.3 12.4-7.3 27.7-.2 40.1S89.7 480 104 480h432c14.3 0 27.6-7.7 34.7-20.1s7-27.8-.2-40.1l-216-368zM216.9 304.7l15.6 9.8 64 40c4.7 2.9 7.5 8.1 7.5 13.6v32c0 8.8-7.2 16-16 16s-16-7.2-16-16v-23.2l-40.9-25.5-24.5 55.2c-3.6 8.1-13 11.7-21.1 8.1s-11.7-13-8.1-21.1l32-72 7.5-16.8zm112-45.7 19.7 49.2L402 339l16.3-27.2c2.9-4.8 8.1-7.8 13.7-7.8s10.8 2.9 13.7 7.8l48 80c3 4.9 3 11.1.2 16.1s-8.2 8.1-13.9 8.1h-96c-5.8 0-11.1-3.1-13.9-8.1s-2.8-11.2.2-16.1l15.2-25.4L232 277.9c-3.8-2.2-6.6-5.9-7.6-10.2s-.2-8.8 2.3-12.5l4.2-6.4c10.3-15.5 27.7-24.8 46.3-24.8 22.7 0 43.2 13.8 51.6 34.9zM288 184a24 24 0 1 1 48 0 24 24 0 1 1-48 0z"
        }
    ]
};

const FasTriangle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTriangle",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M290.5 51.8C283.3 39.5 270.2 32 256 32s-27.3 7.5-34.5 19.8l-216 368c-7.3 12.4-7.3 27.7-.2 40.1S25.7 480 40 480h432c14.3 0 27.6-7.7 34.7-20.1s7-27.8-.2-40.1l-216-368z"
        }
    ]
};

const FasTricycleAdult = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTricycleAdult",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M312 64c-13.3 0-24 10.7-24 24s10.7 24 24 24h31.4c2.6 0 5 1.3 6.5 3.4l79.2 112.5-48.2 64.3a29.6 29.6 0 0 1-23.7 11.9c-1.9 0-3.8-.2-5.7-.5l-322.9-63c-13-2.5-25.6 6-28.2 19s6 25.6 19 28.2l4.6.9C9.1 305.4 0 327.6 0 352c0 53 43 96 96 96 18.2 0 35.3-5.1 49.8-13.9-.6.4-1.2.7-1.8 1.1 14.1 8.2 30.5 12.8 48 12.8 53 0 96-43 96-96 0-4.1-.3-8.2-.8-12.2l55.1 10.7c4.9 1 9.9 1.4 14.9 1.4 24.4 0 47.4-11.5 62.1-31.1l38.8-51.8 13.7 19.5C457 305.6 448 327.7 448 352c0 53 43 96 96 96s96-43 96-96-43-96-96-96c-11.4 0-22.3 2-32.5 5.6L389.2 87.8C378.7 72.9 361.6 64 343.4 64H312zm-88.5 263.4c5.3 6.8 8.5 15.3 8.5 24.6 0 22.1-17.9 40-40 40-2.9 0-5.6-.3-8.3-.9 5.3-12 8.3-25.2 8.3-39.1 0-11.2-1.9-21.9-5.4-31.8l36.9 7.2zM96 312a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm448 0a40 40 0 1 1 0 80 40 40 0 1 1 0-80zM94.1 117.2c-6-16.6-24.3-25.3-40.9-19.3s-25.3 24.3-19.3 40.9l14.9 41.7c9.4 26.2 31.7 45.6 58.9 51.3l77.7 16.3c17.3 3.6 34.3-7.4 37.9-24.7s-7.4-34.3-24.7-37.9l-77.7-16.3c-5.4-1.1-9.9-5-11.8-10.3l-15-41.7z"
        }
    ]
};

const FasTricycle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTricycle",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M280 32c-13.3 0-24 10.7-24 24s10.7 24 24 24h73.6c7.9 0 14.4 6.4 14.4 14.4 0 4.2-1.8 8.2-5 10.9l-42.6 36.5c-.8.7-1.6 1.4-2.3 2.2h-10.9c-58.8 0-114 23.9-154.1 64.6L133.6 176h2.4c13.3 0 24-10.7 24-24s-10.7-24-24-24H56c-13.3 0-24 10.7-24 24s10.7 24 24 24h21.6l44 73.4c-1.3 2.2-2.6 4.5-3.9 6.7-1.9-.1-3.9-.1-5.8-.1C50.1 256 0 306.1 0 368s50.1 112 112 112 112-50.1 112-112c0-42.4-23.6-79.4-58.4-98.4 30.7-48.1 84-77.6 141.6-77.6h12.1l11 43.8C286.4 256.1 256 300.5 256 352c0 70.7 57.3 128 128 128s128-57.3 128-128-57.3-128-128-128c-2.4 0-4.8.1-7.2.2l-13.9-55.6 31.3-26.9C408 129.9 416 112.6 416 94.4c0-34.5-27.9-62.4-62.4-62.4H280zm64.2 260 16.5 65.9c3.2 12.9 16.2 20.7 29.1 17.5s20.7-16.2 17.5-29.1l-16.5-65.9c36.6 3.4 65.2 34.2 65.2 71.7 0 39.8-32.2 72-72 72s-72-32.2-72-72c0-25.1 12.8-47.1 32.2-60zM112 312a56 56 0 1 1 0 112 56 56 0 1 1 0-112z"
        }
    ]
};

const FasTrillium = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTrillium",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 160c0-64.1 61.6-128.2 86.1-151.1 5.6-5.3 14.1-5.3 19.8 0 24.5 23 86.1 87 86.1 151.1 0 15.7-3.7 30.4-10.4 43.5 16.2 0 32.6 4.2 47.7 12.9 55.5 32 80.2 117.4 87.8 150.2 1.8 7.5-2.5 14.9-9.9 17.1-32.1 9.7-118.4 31.1-173.9-1-16.6-9.6-29.2-23.3-37.4-39.2-8.1 15.9-20.8 29.6-37.4 39.2-55.5 32-141.8 10.7-173.9 1-7.4-2.2-11.6-9.6-9.9-17.1 7.6-32.7 32.3-118.1 87.8-150.2 15.1-8.7 31.6-12.9 47.8-12.9-6.6-13.1-10.3-27.8-10.3-43.5zm136 80a40 40 0 1 0-80 0 40 40 0 1 0 80 0zm88-80c0-12.5-1.8-24.8-4.8-36.6 38.6-12.8 68.2-11.9 83-10 14.9 1.9 23.7 17.1 17.9 31-5.6 13.3-19 38.4-47.7 64.6-8.1-7.7-17.1-14.6-27-20.3-7.3-4.2-14.9-7.6-22.6-10.3.9-6 1.3-12.1 1.3-18.4zm-251.2-36.6c-3 11.8-4.8 24.1-4.8 36.6 0 6.2.4 12.3 1.3 18.3-7.8 2.7-15.4 6.1-22.7 10.3-9.9 5.7-18.8 12.6-26.9 20.2C19 182.7 5.6 157.6 0 144.3c-5.8-13.8 3-29.1 17.9-31 14.7-1.9 44.4-2.8 83 10zm73.3 299.4c9.8-3.1 19.4-7.2 28.5-12.5 7.8-4.5 14.9-9.7 21.4-15.4 6.5 5.8 13.6 11 21.4 15.4 9.2 5.3 18.8 9.4 28.6 12.5-8.2 36.1-22.6 61.6-31 74.2-9.1 13.7-28.8 13.7-37.9 0-8.3-12.6-22.8-38.2-31-74.3z"
        }
    ]
};

const FasTrophyStar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTrophyStar",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 0h224c26.5 0 48.1 21.8 47.1 48.2-.2 5.3-.4 10.6-.7 15.8H552c13.3 0 24 10.7 24 24 0 92.6-33.5 157-78.5 200.7-44.3 43.1-98.3 64.8-138.2 75.8-23.4 6.5-39.4 26-39.4 45.6 0 20.9 17 37.9 37.9 37.9H384c17.7 0 32 14.3 32 32s-14.3 32-32 32H192c-17.7 0-32-14.3-32-32s14.3-32 32-32h26.1c20.9 0 37.9-17 37.9-37.9 0-19.6-15.9-39.2-39.4-45.6-39.9-11-93.9-32.7-138.1-75.8C33.5 245 0 180.6 0 88c0-13.3 10.7-24 24-24h105.6c-.3-5.2-.5-10.4-.7-15.8C127.9 21.8 149.5 0 176 0zm-42.8 112H48.9c5.1 66.3 31.1 111.2 63 142.3 22.4 21.8 48.3 37.3 73.2 48.3-22.7-40.3-42.8-100.5-51.9-190.6zm257.6 190.6c24.9-11 50.8-26.5 73.2-48.3 32-31.1 58-76 63-142.3h-84.3c-9.1 90.1-29.2 150.3-51.9 190.6zM295.2 86.5c-2.9-5.9-11.4-5.9-14.3 0l-19.2 38.9c-1.2 2.4-3.4 4-6 4.4l-43 6.2c-6.6 1-9.2 9-4.4 13.6l31 30.2c1.9 1.8 2.7 4.5 2.3 7.1l-7.3 42.7c-1.1 6.5 5.7 11.5 11.6 8.4l38.4-20c2.3-1.2 5.1-1.2 7.4 0l38.4 20.2c5.9 3.1 12.7-1.9 11.6-8.4l-7.3-42.8c-.4-2.6.4-5.2 2.3-7.1l31-30.2c4.7-4.6 2.1-12.7-4.4-13.6l-42.9-6.2c-2.6-.4-4.9-2-6-4.4l-19.2-39z"
        }
    ]
};

const FasTrophy = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTrophy",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M400 0H176c-26.5 0-48.1 21.8-47.1 48.2.2 5.3.4 10.6.7 15.8H24C10.7 64 0 74.7 0 88c0 92.6 33.5 157 78.5 200.7 44.3 43.1 98.3 64.8 138.1 75.8 23.4 6.5 39.4 26 39.4 45.6 0 20.9-17 37.9-37.9 37.9H192c-17.7 0-32 14.3-32 32s14.3 32 32 32h192c17.7 0 32-14.3 32-32s-14.3-32-32-32h-26.1c-20.9 0-37.9-17-37.9-37.9 0-19.6 15.9-39.2 39.4-45.6 39.9-11 93.9-32.7 138.2-75.8C542.5 245 576 180.6 576 88c0-13.3-10.7-24-24-24H446.4c.3-5.2.5-10.4.7-15.8C448.1 21.8 426.5 0 400 0zM48.9 112h84.4c9.1 90.1 29.2 150.3 51.9 190.6-24.9-11-50.8-26.5-73.2-48.3-32-31.1-58-76-63-142.3zm415.2 142.3c-22.4 21.8-48.3 37.3-73.2 48.3 22.7-40.3 42.8-100.5 51.9-190.6h84.4c-5.1 66.3-31.1 111.2-63 142.3z"
        }
    ]
};

const FasTrowelBricks = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTrowelBricks",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M240.8 4.8C250.3 10.6 256 20.9 256 32v72h89c3.6-13.8 16.1-24 31-24h88c26.5 0 48 21.5 48 48s-21.5 48-48 48h-88c-14.9 0-27.4-10.2-31-24h-89v72c0 11.1-5.7 21.4-15.2 27.2s-21.2 6.4-31.1 1.4l-192-96C6.8 151.2 0 140.1 0 128s6.8-23.2 17.7-28.6l192-96c9.9-5 21.7-4.4 31.1 1.4zM288 256c0-17.7 14.3-32 32-32h160c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H320c-17.7 0-32-14.3-32-32v-64zM32 384h96c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32zm192 0h256c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32z"
        }
    ]
};

const FasTrowel = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTrowel",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M343.9 213.4 245.3 312l65.4 65.4c7.9 7.9 11.1 19.4 8.4 30.3s-10.8 19.6-21.5 22.9l-256 80c-11.4 3.5-23.8.5-32.2-7.9s-11.5-20.9-7.9-32.2l80-256c3.3-10.7 12-18.9 22.9-21.5s22.4.5 30.3 8.4l65.3 65.3 98.6-98.6c-14.3-14.6-14.2-38 .3-52.5l95.4-95.4c26.9-26.9 70.5-26.9 97.5 0s26.9 70.5 0 97.5l-95.4 95.4c-14.5 14.5-37.9 14.6-52.5.3z"
        }
    ]
};

const FasTruckArrowRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTruckArrowRight",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 48C0 21.5 21.5 0 48 0h320c26.5 0 48 21.5 48 48v48h50.7c17 0 33.3 6.7 45.3 18.7l77.3 77.3c12 12 18.7 28.3 18.7 45.3V352c17.7 0 32 14.3 32 32s-14.3 32-32 32h-32c0 53-43 96-96 96s-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96H48c-26.5 0-48-21.5-48-48V48zm416 208h128v-18.7L466.7 160H416v96zM160 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm368-48a48 48 0 1 0-96 0 48 48 0 1 0 96 0zM257 95c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l39 39H96c-13.3 0-24 10.7-24 24s10.7 24 24 24h166.1l-39 39c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9L257 95z"
        }
    ]
};

const FasTruckBolt = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTruckBolt",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 0C21.5 0 0 21.5 0 48v320c0 26.5 21.5 48 48 48h16c0 53 43 96 96 96s96-43 96-96h128c0 53 43 96 96 96s96-43 96-96h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V237.3c0-17-6.7-33.3-18.7-45.3L512 114.7c-12-12-28.3-18.7-45.3-18.7H416V48c0-26.5-21.5-48-48-48H48zm368 160h50.7l77.3 77.3V256H416v-96zM112 416a48 48 0 1 1 96 0 48 48 0 1 1-96 0zm368-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM270.3 87.2 233.9 160H288c6.9 0 13 4.4 15.2 10.9s-.1 13.7-5.6 17.9l-128 96c-5.9 4.5-14.2 4.2-19.9-.5s-7.4-12.8-4.1-19.4l36.5-72.9H128c-6.9 0-13-4.4-15.2-10.9s.1-13.7 5.6-17.9l128-96c5.9-4.5 14.2-4.2 19.9.5s7.4 12.8 4.1 19.4z"
        }
    ]
};

const FasTruckClock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTruckClock",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 48C0 21.5 21.5 0 48 0h320c26.5 0 48 21.5 48 48v48h50.7c17 0 33.3 6.7 45.3 18.7l77.3 77.3c12 12 18.7 28.3 18.7 45.3V352c17.7 0 32 14.3 32 32s-14.3 32-32 32h-32c0 53-43 96-96 96s-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96H48c-26.5 0-48-21.5-48-48V48zm416 208h128v-18.7L466.7 160H416v96zM160 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm368-48a48 48 0 1 0-96 0 48 48 0 1 0 96 0zM320 176a112 112 0 1 0-224 0 112 112 0 1 0 224 0zM208 96c8.8 0 16 7.2 16 16v48h16c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-64c0-8.8 7.2-16 16-16z"
        }
    ]
};

const FasTruckContainerEmpty = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTruckContainerEmpty",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M456 144c-13.3 0-24 10.7-24 24v152H32c-17.7 0-32 14.3-32 32v48c0 44.2 35.8 80 80 80 26.2 0 49.4-12.6 64-32 14.6 19.4 37.8 32 64 32 44.2 0 80-35.8 80-80 0-5.5-.6-10.8-1.6-16h163.2c-1 5.2-1.6 10.5-1.6 16 0 44.2 35.8 80 80 80s80-35.8 80-80c0-5.5-.6-10.8-1.6-16h1.6c17.7 0 32-14.3 32-32v-90.3c0-9.2-3.2-18.2-9-25.3l-58.8-71.8c-10.6-13-26.5-20.5-43.3-20.5H456zm129 112H480v-64h48.8c2.4 0 4.7 1.1 6.2 2.9l50 61.1zm-57 112a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-352 32a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm-96-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FasTruckContainer = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTruckContainer",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 32h304c26.5 0 48 21.5 48 48v160c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48zm32 48c-8.8 0-16 7.2-16 16v128c0 8.8 7.2 16 16 16s16-7.2 16-16V96c0-8.8-7.2-16-16-16zm144 16v128c0 8.8 7.2 16 16 16s16-7.2 16-16V96c0-8.8-7.2-16-16-16s-16 7.2-16 16zm-64-16c-8.8 0-16 7.2-16 16v128c0 8.8 7.2 16 16 16s16-7.2 16-16V96c0-8.8-7.2-16-16-16zm144 16v128c0 8.8 7.2 16 16 16s16-7.2 16-16V96c0-8.8-7.2-16-16-16s-16 7.2-16 16zm128 72c0-13.3 10.7-24 24-24h72.8c16.8 0 32.7 7.5 43.3 20.5l58.9 71.9c5.8 7.1 9 16.1 9 25.3V352c0 17.7-14.3 32-32 32h-1.6c1 5.2 1.6 10.5 1.6 16 0 44.2-35.8 80-80 80s-80-35.8-80-80c0-5.5.6-10.8 1.6-16H286.4c1 5.2 1.6 10.5 1.6 16 0 44.2-35.8 80-80 80-26.2 0-49.4-12.6-64-32-14.6 19.4-37.8 32-64 32-44.2 0-80-35.8-80-80v-48c0-17.7 14.3-32 32-32h400V168zm48 88h105l-50-61.1c-1.5-1.9-3.8-2.9-6.2-2.9H480v64zm80 144a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm-352 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-96-32a32 32 0 1 0-64 0 32 32 0 1 0 64 0z"
        }
    ]
};

const FasTruckDroplet = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTruckDroplet",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 48C0 21.5 21.5 0 48 0h320c26.5 0 48 21.5 48 48v48h50.7c17 0 33.3 6.7 45.3 18.7l77.3 77.3c12 12 18.7 28.3 18.7 45.3V352c17.7 0 32 14.3 32 32s-14.3 32-32 32h-32c0 53-43 96-96 96s-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96H48c-26.5 0-48-21.5-48-48V48zm416 208h128v-18.7L466.7 160H416v96zM160 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm368-48a48 48 0 1 0-96 0 48 48 0 1 0 96 0zM208 272c39.8 0 72-29.6 72-66 0-27-39.4-82.9-59.9-110.3-6.1-8.2-18.1-8.2-24.2 0C175.4 123 136 179 136 206c0 36.5 32.2 66 72 66z"
        }
    ]
};

const FasTruckFast = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTruckFast",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M112 0C85.5 0 64 21.5 64 48v48H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h256c8.8 0 16 7.2 16 16s-7.2 16-16 16H48c-8.8 0-16 7.2-16 16s7.2 16 16 16h192c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h192c8.8 0 16 7.2 16 16s-7.2 16-16 16H64v128c0 53 43 96 96 96s96-43 96-96h128c0 53 43 96 96 96s96-43 96-96h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V237.3c0-17-6.7-33.3-18.7-45.3L512 114.7c-12-12-28.3-18.7-45.3-18.7H416V48c0-26.5-21.5-48-48-48H112zm432 237.3V256H416v-96h50.7l77.3 77.3zM160 368a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm272 48a48 48 0 1 1 96 0 48 48 0 1 1-96 0z"
        }
    ]
};

const FasTruckFieldUn = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTruckFieldUn",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 32c-35.3 0-64 28.7-64 64v32c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32v32c-17.7 0-32 14.3-32 32s14.3 32 32 32h32c0 53 43 96 96 96s96-43 96-96h128c0 53 43 96 96 96s96-43 96-96h32c17.7 0 32-14.3 32-32s-14.3-32-32-32v-32c0-35.3-28.7-64-64-64h-4.2c-.4-1.1-.9-2.1-1.3-3.2L485.7 102c-10.3-23.1-33.2-38-58.5-38h-51.8c-11-19.1-31.7-32-55.4-32H96zm288 96h43.2l42.7 96H384v-96zM112 384a48 48 0 1 1 96 0 48 48 0 1 1-96 0zm368-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM253.3 135.1l34.7 52V144c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 7.1-4.6 13.3-11.4 15.3s-14-.6-17.9-6.4l-34.7-52V240c0 8.8-7.2 16-16 16s-16-7.2-16-16v-96c0-7.1 4.6-13.3 11.4-15.3s14 .6 17.9 6.4zM128 144v64c0 8.8 7.2 16 16 16s16-7.2 16-16v-64c0-8.8 7.2-16 16-16s16 7.2 16 16v64c0 26.5-21.5 48-48 48s-48-21.5-48-48v-64c0-8.8 7.2-16 16-16s16 7.2 16 16z"
        }
    ]
};

const FasTruckField = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTruckField",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 96c0-35.3 28.7-64 64-64h224c23.7 0 44.4 12.9 55.4 32h51.8c25.3 0 48.2 14.9 58.5 38l52.8 118.8c.5 1.1.9 2.1 1.3 3.2h4.2c35.3 0 64 28.7 64 64v32c17.7 0 32 14.3 32 32s-14.3 32-32 32h-32c0 53-43 96-96 96s-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96H32c-17.7 0-32-14.3-32-32s14.3-32 32-32v-32c-17.7 0-32-14.3-32-32v-96c0-17.7 14.3-32 32-32V96zm352 128h85.9l-42.7-96H384v96zM160 432a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm368-48a48 48 0 1 0-96 0 48 48 0 1 0 96 0z"
        }
    ]
};

const FasTruckFlatbed = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTruckFlatbed",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M608 416h-32c0 53-43 96-96 96s-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h56.4c17.6-19.6 43.1-32 71.6-32s54 12.4 71.6 32H352V128c0-17.7 14.3-32 32-32h82.7c17 0 33.3 6.7 45.3 18.7l77.3 77.3c12 12 18.7 28.3 18.7 45.3V352c17.7 0 32 14.3 32 32s-14.3 32-32 32zM416 160v96h128v-18.7L466.7 160H416zM208 416a48 48 0 1 0-96 0 48 48 0 1 0 96 0zm272 48a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
        }
    ]
};

const FasTruckFront = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTruckFront",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 80C0 35.8 35.8 0 80 0h352c44.2 0 80 35.8 80 80v288c0 26.2-12.6 49.4-32 64v48c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32v-32H128v32c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32v-48c-19.4-14.6-32-37.8-32-64V80zm129.9 72.2L112 224h288l-17.9-71.8C378.5 138 365.7 128 351 128H161c-14.7 0-27.5 10-31 24.2zM128 320a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm288 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FasTruckMedical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTruckMedical",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 48C0 21.5 21.5 0 48 0h320c26.5 0 48 21.5 48 48v48h50.7c17 0 33.3 6.7 45.3 18.7l77.3 77.3c12 12 18.7 28.3 18.7 45.3V352c17.7 0 32 14.3 32 32s-14.3 32-32 32h-32c0 53-43 96-96 96s-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96H48c-26.5 0-48-21.5-48-48V48zm416 208h128v-18.7L466.7 160H416v96zM160 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm368-48a48 48 0 1 0-96 0 48 48 0 1 0 96 0zM176 80v48h-48c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-48h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-48V80c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16z"
        }
    ]
};

const FasTruckMonster = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTruckMonster",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 64v64h128l-48-64h-80zm131.2-38.4L496 128h80c17.7 0 32 14.3 32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32c-29.2-38.9-75.7-64-128-64s-98.8 25.1-128 64h-64c-29.2-38.9-75.7-64-128-64s-98.8 25.1-128 64c-17.7 0-32-14.3-32-32s14.3-32 32-32v-64c0-17.7 14.3-32 32-32h160V48c0-26.5 21.5-48 48-48h96c20.1 0 39.1 9.5 51.2 25.6zM152 256h16c12.1 0 22.1 8.9 23.8 20.6 7.6 2.2 14.9 5.3 21.7 9 9.4-7 22.8-6.3 31.3 2.3l11.3 11.3c8.6 8.6 9.3 21.9 2.3 31.3 3.7 6.8 6.8 14.1 9 21.7C279 353.9 288 363.9 288 376v16c0 12.1-8.9 22.1-20.6 23.8-2.2 7.6-5.3 14.9-9 21.7 7 9.4 6.3 22.8-2.3 31.3l-11.3 11.3c-8.6 8.6-21.9 9.3-31.3 2.2-6.8 3.7-14.1 6.8-21.7 9-1.7 11.8-11.7 20.7-23.8 20.7h-16c-12.1 0-22.1-8.9-23.8-20.6-7.6-2.2-14.9-5.3-21.7-9-9.4 7.1-22.8 6.3-31.3-2.2l-11.4-11.3c-8.6-8.6-9.3-21.9-2.3-31.3-3.7-6.9-6.8-14.1-9-21.8C40.9 414.1 32 404.1 32 392v-16c0-12.1 8.9-22.1 20.6-23.8 2.2-7.6 5.3-14.9 9-21.8-7-9.4-6.3-22.8 2.3-31.3l11.3-11.3c8.6-8.6 21.9-9.3 31.3-2.3 6.8-3.7 14.1-6.8 21.7-9 1.7-11.6 11.7-20.6 23.8-20.6zm8 176a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm288.2-155.4C449.9 265 459.9 256 472 256h16c12.1 0 22.1 8.9 23.8 20.6 7.6 2.2 14.9 5.3 21.8 9 9.4-7 22.8-6.3 31.3 2.3l11.3 11.3c8.6 8.6 9.3 21.9 2.2 31.3 3.7 6.8 6.8 14.1 9 21.7C599 353.9 608 363.9 608 376v16c0 12.1-8.9 22.1-20.6 23.8-2.2 7.6-5.3 14.9-9 21.7 7 9.4 6.3 22.8-2.2 31.3l-11.3 11.3c-8.6 8.6-21.9 9.3-31.3 2.2-6.9 3.7-14.1 6.8-21.8 9-1.7 11.8-11.7 20.7-23.8 20.7h-16c-12.1 0-22.1-8.9-23.8-20.6-7.6-2.2-14.9-5.3-21.7-9-9.4 7.1-22.8 6.3-31.3-2.2l-11.3-11.3c-8.6-8.6-9.3-21.9-2.2-31.3-3.7-6.9-6.8-14.1-9-21.8-11.8-1.7-20.7-11.7-20.7-23.8v-16c0-12.1 8.9-22.1 20.6-23.8 2.2-7.6 5.3-14.9 9-21.8-7-9.4-6.3-22.8 2.2-31.3l11.3-11.3c8.6-8.6 21.9-9.3 31.3-2.3 6.8-3.7 14.1-6.8 21.7-9zM528 384a48 48 0 1 0-96 0 48 48 0 1 0 96 0z"
        }
    ]
};

const FasTruckMoving = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTruckMoving",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v304c0 44.2 35.8 80 80 80 26.2 0 49.4-12.6 64-32 14.6 19.4 37.8 32 64 32 44.2 0 80-35.8 80-80 0-5.5-.6-10.8-1.6-16h163.2c-1 5.2-1.6 10.5-1.6 16 0 44.2 35.8 80 80 80s80-35.8 80-80c0-5.5-.6-10.8-1.6-16h1.6c17.7 0 32-14.3 32-32v-90.3c0-9.2-3.2-18.2-9-25.3l-58.8-71.8c-10.6-13-26.5-20.5-43.3-20.5H480V96c0-35.3-28.7-64-64-64H64zm521 224H480v-64h48.8c2.4 0 4.7 1.1 6.2 2.9l50 61.1zm-57 112a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-352 32a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm-96-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FasTruckPickup = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTruckPickup",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m368.6 96 76.8 96H288V96h80.6zM224 80v112H64c-17.7 0-32 14.3-32 32v64c-17.7 0-32 14.3-32 32s14.3 32 32 32h33.1c-.7 5.2-1.1 10.6-1.1 16 0 61.9 50.1 112 112 112s112-50.1 112-112c0-5.4-.4-10.8-1.1-16h66.3c-.7 5.2-1.1 10.6-1.1 16 0 61.9 50.1 112 112 112s112-50.1 112-112c0-5.4-.4-10.8-1.1-16h33c17.7 0 32-14.3 32-32s-14.3-32-32-32v-64c0-17.7-14.3-32-32-32h-48.6L418.6 56c-12.1-15.2-30.5-24-50-24H272c-26.5 0-48 21.5-48 48zm0 288a48 48 0 1 1-96 0 48 48 0 1 1 96 0zm288 0a48 48 0 1 1-96 0 48 48 0 1 1 96 0z"
        }
    ]
};

const FasTruckPlane = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTruckPlane",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M200 0c-30.6 0-56 54.7-56 86.1v106.4L7.8 274.3C2.9 277.2 0 282.4 0 288v64c0 5.1 2.4 9.8 6.4 12.8s9.3 3.9 14.1 2.5l123.4-37v81.2l-50 40c-3.8 3-6 7.6-6 12.5v32c0 5.1 2.5 10 6.6 13s9.5 3.8 14.4 2.2l91.1-30.3 90.4 30.1c-1.6-4.7-2.4-9.8-2.4-15v-32.6c-18.2-10.5-30.7-29.7-31.9-51.8l-.1-.1V86.1C256 54.7 231.5 0 200 0zm88 176v224c0 20.9 13.4 38.7 32 45.3V488c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24v-40h160v40c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24v-42.7c18.6-6.6 32-24.4 32-45.3V176c0-26.5-21.5-48-48-48H336c-26.5 0-48 21.5-48 48zm79.8 78.7c3.3-8.7 11.2-14.7 20.5-14.7h151.4c9.2 0 17.2 6 20.5 14.7L576 304H352l15.8-49.3zM568 352a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-232 24a24 24 0 1 1 48 0 24 24 0 1 1-48 0z"
        }
    ]
};

const FasTruckPlow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTruckPlow",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 96v96h135.5l-57.6-96H192zm-64 96V80c0-26.5 21.5-48 48-48h93.9c22.5 0 43.3 11.8 54.9 31.1L402.1 192H448c17.7 0 32 14.3 32 32v64h32V176c0-7.3 2.5-14.3 7-20l64-80c11-13.8 31.2-16 45-5s16 31.2 5 45l-57 71.2v169.6l57 71.2c11 13.8 8.8 33.9-5 45s-33.9 8.8-45-5l-64-80c-4.5-5.7-7-12.7-7-20v-16h-37.5c3.5 10 5.5 20.8 5.5 32 0 53-43 96-96 96s-96-43-96-96c0-11.2 1.9-22 5.5-32H224c-1.9 0-3.8-.2-5.6-.5 3.7 10.2 5.6 21.1 5.6 32.5 0 53-43 96-96 96s-96-43-96-96c0-11.2 1.9-22 5.5-32H32c-17.7 0-32-14.3-32-32v-96c0-17.7 14.3-32 32-32h96zm32 192a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm256 0a32 32 0 1 0-64 0 32 32 0 1 0 64 0z"
        }
    ]
};

const FasTruckRampBox = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTruckRampBox",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M640 0v400c0 61.9-50.1 112-112 112-61 0-110.5-48.7-112-109.3L48.4 502.9c-17.1 4.6-34.6-5.4-39.3-22.5s5.4-34.6 22.5-39.3L352 353.8V64c0-35.3 28.7-64 64-64h224zm-64 400a48 48 0 1 0-96 0 48 48 0 1 0 96 0zM23.1 207.7c-4.6-17.1 5.6-34.6 22.6-39.2l46.4-12.4 20.7 77.3c2.3 8.5 11.1 13.6 19.6 11.3l30.9-8.3c8.5-2.3 13.6-11.1 11.3-19.6l-20.7-77.3 46.4-12.4c17.1-4.6 34.6 5.6 39.2 22.6l41.4 154.5c4.6 17.1-5.6 34.6-22.6 39.2l-154.6 41.5c-17.1 4.6-34.6-5.6-39.2-22.6L23.1 207.7z"
        }
    ]
};

const FasTruckRampCouch = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTruckRampCouch",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M640 0v400c0 61.9-50.1 112-112 112-61 0-110.5-48.7-112-109.3L48.4 502.9c-17.1 4.6-34.6-5.4-39.3-22.5s5.4-34.6 22.5-39.3L352 353.8V64c0-35.3 28.7-64 64-64h224zm-64 400a48 48 0 1 0-96 0 48 48 0 1 0 96 0zM294.5 209.2c8.7-2.3 17.4-2.1 25.5.2v125.4l-38.7 10.4-154.6 41.4-61.8 16.6c-17.1 4.6-34.6-5.6-39.2-22.6l-12.4-46.4c-6.9-25.6 8.3-51.9 33.9-58.8s51.9 8.3 58.8 33.9l4.1 15.5 154.5-41.4-4.1-15.5c-6.9-25.6 8.3-51.9 33.9-58.8zM8 252.8c-9.1-34.1 11.1-69.2 45.3-78.4l185.5-49.7c34.1-9.1 69.2 11.1 78.4 45.3l1.7 6.4c-10.6-1.6-21.6-1.1-32.6 1.9-37.4 10-61.5 44.9-59.2 82.1L131.2 286c-16.6-33.4-54.9-51.5-92.3-41.5-11 2.9-20.8 8-29.2 14.7L8 252.8z"
        }
    ]
};

const FasTruckRamp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTruckRamp",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M640 400V0H416c-35.3 0-64 28.7-64 64v289.8L31.6 441.1c-17.1 4.6-27.1 22.2-22.5 39.3s22.2 27.1 39.3 22.5L416 402.7c1.5 60.6 51 109.3 112 109.3 61.9 0 112-50.1 112-112zm-112-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
        }
    ]
};

const FasTruckTow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTruckTow",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 0h49.6c9.1 0 17.8 3.9 23.9 10.7L384 252V128c0-17.7 14.3-32 32-32h82.7c17 0 33.3 6.7 45.3 18.7l77.3 77.3c12 12 18.7 28.3 18.7 45.3V376c0 22.1-17.9 40-40 40h-24c0 53-43 96-96 96s-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96H48c-26.5 0-48-21.5-48-48v-64c0-26.5 21.5-48 48-48h144L96 64v112c0 26.5-21.5 48-48 48S0 202.5 0 176v-16c0-8.8 7.2-16 16-16s16 7.2 16 16v16c0 8.8 7.2 16 16 16s16-7.2 16-16V32C64 14.3 78.3 0 96 0zm480 256v-18.7L498.7 160H448v96h128zM208 416a48 48 0 1 0-96 0 48 48 0 1 0 96 0zm272 48a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
        }
    ]
};

const FasTruck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTruck",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 0C21.5 0 0 21.5 0 48v320c0 26.5 21.5 48 48 48h16c0 53 43 96 96 96s96-43 96-96h128c0 53 43 96 96 96s96-43 96-96h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V237.3c0-17-6.7-33.3-18.7-45.3L512 114.7c-12-12-28.3-18.7-45.3-18.7H416V48c0-26.5-21.5-48-48-48H48zm368 160h50.7l77.3 77.3V256H416v-96zM112 416a48 48 0 1 1 96 0 48 48 0 1 1-96 0zm368-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
        }
    ]
};

const FasTrumpet = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTrumpet",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M628.7 64.7C635.4 66.8 640 73 640 80v288c0 7-4.6 13.2-11.3 15.3s-14-.4-17.9-6.2l-.1-.2-.7-.9c-.6-.8-1.5-2.1-2.8-3.8-2.5-3.3-6.2-8.1-11-13.9-9.6-11.6-23.6-26.9-40.8-42.3-35-31.1-81.3-60-131.4-60h-24v126c27.6-7.1 48-32.2 48-62v-29.2c22 5 43.7 16.4 64 31.2-1.1 69.8-58 126-128 126H192c-70.7 0-128-57.3-128-128 0-23.3 6.2-45.2 17.1-64H46.6c-3.3 9.3-12.2 16-22.6 16-13.3 0-24-10.7-24-24v-48c0-13.3 10.7-24 24-24 10.4 0 19.3 6.7 22.6 16H176v-32c0-13.3 10.7-24 24-24s24 10.7 24 24v32h40v-32c0-13.3 10.7-24 24-24s24 10.7 24 24v32h40v-32c0-13.3 10.7-24 24-24s24 10.7 24 24v32h24c50.1 0 96.4-28.8 131.4-60 17.3-15.3 31.2-30.7 40.8-42.3 4.8-5.8 8.5-10.6 11-13.9 1.2-1.7 2.2-2.9 2.8-3.8l.7-.9.1-.2c4-5.8 11.2-8.3 17.9-6.2zM312 384h40V256h-40v128zm-88-128v128h40V256h-40zm-96 64c0 29.8 20.4 54.9 48 62V258c-27.6 7.1-48 32.2-48 62z"
        }
    ]
};

const FasTtyAnswer = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTtyAnswer",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M117.5 1.4c19.4-5.3 39.7 4.6 47.4 23.2l40 96c6.8 16.3 2.1 35.2-11.6 46.3L144 207.3c33.3 70.4 90.3 127.4 160.7 160.7l40.3-49.3c11.2-13.7 30-18.4 46.3-11.6l96 40c18.6 7.7 28.5 28 23.2 47.4l-24 88C481.8 499.9 466 512 448 512 200.6 512 0 311.4 0 64c0-18 12.1-33.8 29.5-38.6l88-24zM304 64h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16zm0 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16zm80-80c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16V80zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16V80zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16zm-208 16c0-8.8 7.2-16 16-16h128c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H400c-8.8 0-16-7.2-16-16v-32z"
        }
    ]
};

const FasTty = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTty",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m38.3 241.3-23.2-40.7c-9.2-16.2-8.4-36.5 4.5-50C61.4 106.8 144.7 48 256 48s194.6 58.8 236.4 102.6c12.9 13.5 13.7 33.8 4.5 50l-23.1 40.7c-7.5 13.2-23.3 19.3-37.8 14.6l-81.1-26.6c-13.1-4.3-22-16.6-22-30.4V144c-49.6-18.1-104-18.1-153.6 0v54.8c0 13.8-8.9 26.1-22 30.4l-81.2 26.6c-14.5 4.7-30.3-1.4-37.8-14.6zM32 336c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16v-32zm0 96c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16v-32zm112-112h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16zm-304 16c0-8.8 7.2-16 16-16h224c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H144c-8.8 0-16-7.2-16-16v-32z"
        }
    ]
};

const FasTugrikSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTugrikSign",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 32C14.3 32 0 46.3 0 64s14.3 32 32 32h128v103L56.2 225c-17.1 4.3-27.6 21.7-23.3 38.8s21.7 27.6 38.8 23.3L160 265v30L56.2 321c-17.1 4.3-27.6 21.7-23.3 38.8s21.7 27.6 38.8 23.3L160 361v87c0 17.7 14.3 32 32 32s32-14.3 32-32V345l103.8-26c17.1-4.3 27.6-21.7 23.3-38.8s-21.7-27.6-38.8-23.3L224 279v-30l103.8-26c17.1-4.3 27.6-21.7 23.3-38.8s-21.7-27.6-38.8-23.3L224 183V96h128c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"
        }
    ]
};

const FasTurkey = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTurkey",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M472 56c0 22.1-1.2 49.3-19.3 62l-31.6 22.3C375.9 112.2 327.9 96 288 96 176 96 0 224 0 384c0 128 160 128 288 128s288 0 288-128c0-63-27.3-121.1-67.3-168.3-.4.2-.7.4-1 .6l-28.3 20c-8.3 5.9-15.1 15-21.2 28.3-6.1 13.4-10.5 28.6-15.4 46l-.3 1c-7.9 27.5-24 53-47.9 72.3-61.8 50-152.5 40.5-202.5-21.4-13.9-17.2-23.2-36.6-28.1-56.7-2.3-9.4 5.3-17.9 15-17.9 8 0 14.6 5.8 16.9 13.5 4 14.5 10.9 28.5 21 41 21.3 26.3 52.1 40.5 83.5 41.5 25.9.8 52.2-7.3 74-24.9 18.6-15 31.1-34.8 37.2-56.2l.6-2c9.6-33.7 20.1-70.5 48.7-90.6l25.8-18.2 2.5-1.8c18.3-12.9 43.3-10.4 67.4-8 9.4.9 18.6 1.8 27.3 1.8 30.9 0 56-25.1 56-56s-25.1-56-56-56c-1.1 0-2-1.1-1.7-2.2 1.1-4.4 1.7-9 1.7-13.8 0-30.9-25.1-56-56-56s-56 25.1-56 56z"
        }
    ]
};

const FasTurkishLiraSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTurkishLiraSign",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 32c17.7 0 32 14.3 32 32v35.3l119.2-34.1c17-4.9 34.7 5 39.6 22s-5 34.7-22 39.6L128 165.9v29.4l119.2-34.1c17-4.9 34.7 5 39.6 22s-5 34.7-22 39.6L128 261.9V416h63.8c68.2 0 124.4-53.5 127.8-121.6l.4-8c.9-17.7 15.9-31.2 33.6-30.4s31.2 15.9 30.4 33.6l-.4 8C378.5 399.8 294.1 480 191.8 480H96c-17.7 0-32-14.3-32-32V280.1l-23.2 6.6c-17 4.9-34.7-5-39.6-22s5-34.7 22-39.6L64 213.6v-29.5l-23.2 6.6c-17 4.9-34.7-5-39.6-22s5-34.7 22-39.6L64 117.6V64c0-17.7 14.3-32 32-32z"
        }
    ]
};

const FasTurnDownLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTurnDownLeft",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M177.5 446c-8.8 3.8-19 2-26-4.6l-144-136C2.7 300.9 0 294.6 0 288s2.7-12.9 7.5-17.4l144-136c7-6.6 17.2-8.4 26-4.6s14.5 12.5 14.5 22v88h192c17.7 0 32-14.3 32-32V64c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32v144c0 70.7-57.3 128-128 128H192v88c0 9.6-5.7 18.2-14.5 22z"
        }
    ]
};

const FasTurnDownRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTurnDownRight",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M334.5 446c8.8 3.8 19 2 26-4.6l144-136c4.8-4.5 7.5-10.8 7.5-17.4s-2.7-12.9-7.5-17.4l-144-136c-7-6.6-17.2-8.4-26-4.6S320 142.5 320 152v88H128c-17.7 0-32-14.3-32-32V64c0-17.7-14.3-32-32-32H32C14.3 32 0 46.3 0 64v144c0 70.7 57.3 128 128 128h192v88c0 9.6 5.7 18.2 14.5 22z"
        }
    ]
};

const FasTurnDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTurnDown",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M350 334.5c3.8 8.8 2 19-4.6 26l-136 144c-4.5 4.8-10.8 7.5-17.4 7.5s-12.9-2.7-17.4-7.5l-136-144c-6.6-7-8.4-17.2-4.6-26S46.5 320 56 320h88V128c0-17.7-14.3-32-32-32H32C14.3 96 0 81.7 0 64V32C0 14.3 14.3 0 32 0h80c70.7 0 128 57.3 128 128v192h88c9.6 0 18.2 5.7 22 14.5z"
        }
    ]
};

const FasTurnUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTurnUp",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M350 177.5c3.8-8.8 2-19-4.6-26l-136-144C204.9 2.7 198.6 0 192 0s-12.9 2.7-17.4 7.5l-136 144c-6.6 7-8.4 17.2-4.6 26S46.5 192 56 192h88v192c0 17.7-14.3 32-32 32H32c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h80c70.7 0 128-57.3 128-128V192h88c9.6 0 18.2-5.7 22-14.5z"
        }
    ]
};

const FasTurntable = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTurntable",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 96c0-35.3 28.7-64 64-64h448c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm384 160a160 160 0 1 0-320 0 160 160 0 1 0 320 0zm128-144c0-8.8-7.2-16-16-16s-16 7.2-16 16v160.4c0 2.5-.6 4.9-1.7 7.2l-16.2 32.5c-11 .7-21.4 7-26.7 17.6l-16 32c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3l16-32c5.3-10.6 4.2-22.7-1.9-31.9l16.2-32.4c3.3-6.7 5.1-14 5.1-21.5V112zM224 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FasTurtle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTurtle",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 249.2c0 21.4-17.4 38.8-38.8 38.8H70.8C49.4 288 32 270.6 32 249.2V208c0-97.2 78.8-176 176-176s176 78.8 176 176v41.2zm96 38.8c-2 0-4-.1-5.9-.3-16.3 53.3-64.3 92.7-122.1 96V440c0 22.1-17.9 40-40 40h-48c-22.1 0-40-17.9-40-40v-56h-32v56c0 22.1-17.9 40-40 40h-48c-22.1 0-40-17.9-40-40v-56H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h312c39.8 0 72-32.2 72-72v-72c0-35.3 28.7-64 64-64 53 0 96 43 96 96v16c0 35.3-28.7 64-64 64h-32zm16-64a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
        }
    ]
};

const FasTvMusic = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTvMusic",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M576 64v288H64V64h512zM64 0C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h512c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm32 480c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32s-14.3-32-32-32H128c-17.7 0-32 14.3-32 32zm320-368c0-5.2-2.6-10.2-6.9-13.2s-9.8-3.7-14.7-1.8l-128 48c-6.2 2.3-10.4 8.3-10.4 15v97.8c-5-1.2-10.4-1.8-16-1.8-26.5 0-48 14.3-48 32s21.5 32 48 32 48-14.3 48-32v-68.9l96-36v42.7c-5-1.2-10.4-1.8-16-1.8-26.5 0-48 14.3-48 32s21.5 32 48 32 48-14.3 48-32V112z"
        }
    ]
};

const FasTvRetro = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTvRetro",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M169 7c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l55 55H80C35.8 96 0 131.8 0 176v256c0 44.2 35.8 80 80 80h352c44.2 0 80-35.8 80-80V176c0-44.2-35.8-80-80-80H321.9l55-55c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-87 87L169 7zm255 225a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm24 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM64 224c0-35.3 28.7-64 64-64h192c35.3 0 64 28.7 64 64v160c0 35.3-28.7 64-64 64H128c-35.3 0-64-28.7-64-64V224z"
        }
    ]
};

const FasTv = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTv",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64v288h512V64H64zM0 64C0 28.7 28.7 0 64 0h512c35.3 0 64 28.7 64 64v288c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm128 384h384c17.7 0 32 14.3 32 32s-14.3 32-32 32H128c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
        }
    ]
};

const FasTypewriter = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasTypewriter",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c0-35.3 28.7-64 64-64h226.7c17 0 33.3 6.7 45.3 18.7L429.3 48c12 12 18.7 28.3 18.7 45.3V192h32c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32v160c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V288c-17.7 0-32-14.3-32-32v-32c0-17.7 14.3-32 32-32h32V64zm320 64h-32c-17.7 0-32-14.3-32-32V64H128v128h18.7c8.5 0 16.6 3.4 22.6 9.4l13.3 13.3c6 6 14.1 9.4 22.6 9.4h101.5c8.5 0 16.6-3.4 22.6-9.4l13.3-13.3c6-6 14.1-9.4 22.6-9.4H384v-64zM160 288a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm64 0a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm64 0a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm64 0a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm64 0a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm-320 0a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm64 128c-8.8 0-16 7.2-16 16s7.2 16 16 16h192c8.8 0 16-7.2 16-16s-7.2-16-16-16H160zm-32-32a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm64 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-16a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm48 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-16a16 16 0 1 0-32 0 16 16 0 1 0 32 0z"
        }
    ]
};

const FasU = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasU",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 32c17.7 0 32 14.3 32 32v224c0 70.7 57.3 128 128 128s128-57.3 128-128V64c0-17.7 14.3-32 32-32s32 14.3 32 32v224c0 106-86 192-192 192S0 394 0 288V64c0-17.7 14.3-32 32-32z"
        }
    ]
};

const FasUfoBeam = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasUfoBeam",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M184 152s24 40 104 40 104-40 104-40c0-48-33.3-104-104-104s-104 56-104 104zm-42.6-40.4C159.1 47.2 218.1 0 288 0s128.9 47.2 146.6 111.6C519.2 131.1 576 167 576 208c0 61.9-128.9 112-288 112S0 269.9 0 208c0-41 56.8-76.9 141.4-96.4zM120 208a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm360 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-168 24a24 24 0 1 0-48 0 24 24 0 1 0 48 0zM74.3 325.7l4.2-8.9c14.3 5.6 29.7 10.6 46 15l-6.8 14.5-72 152c-5.7 12-20 17.1-32 11.4s-17.1-20-11.4-32l72-152zm384 20.6-6.8-14.5c16.3-4.4 31.7-9.4 46-15l4.2 8.9 72 152c5.7 12 .6 26.3-11.4 32s-26.3.6-32-11.4l-72-152z"
        }
    ]
};

const FasUfo = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasUfo",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 112c59.2 0 109.6 37.9 128.3 90.7 5 14.2 7.7 29.4 7.7 45.3 0 0-40 40-136 40s-136-40-136-40c0-15.9 2.7-31.1 7.7-45.3 18.7-52.8 69-90.7 128.3-90.7zm0-48c-90.1 0-165.2 64.8-180.9 150.4C55.1 237.5 0 276.2 0 320c0 70.7 143.3 128 320 128s320-57.3 320-128c0-43.8-55.1-82.5-139.1-105.6C485.2 128.8 410.2 64 320 64zm0 288a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-216-24a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm408-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FasUmbrellaBeach = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasUmbrellaBeach",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m346.3 271.8-60.1-21.9L214 448H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h512c17.7 0 32-14.3 32-32s-14.3-32-32-32H282.1l64.1-176.2zm121.1-.2-3.3 9.1 67.7 24.6c18.1 6.6 38-4.2 39.6-23.4 6.5-78.5-23.9-155.5-80.8-208.5 2 8 3.2 16.3 3.4 24.8l.2 6c1.8 57-7.3 113.8-26.8 167.4zM462 99.1c-1.1-34.4-22.5-64.8-54.4-77.4-.9-.4-1.9-.7-2.8-1.1-33-11.7-69.8-2.4-93.1 23.8l-4 4.5C272.4 88.3 245 134.2 226.8 184l-3.3 9.1L434 269.7l3.3-9.1c18.1-49.8 26.6-102.5 24.9-155.5l-.2-6zm-354.8 13.8c-11.1 15.7-2.8 36.8 15.3 43.4l71 25.8 3.3-9.1c19.5-53.6 49.1-103 87.1-145.5l4-4.5c6.2-6.9 13.1-13 20.5-18.2-79.6 2.5-154.7 42.2-201.2 108z"
        }
    ]
};

const FasUmbrellaSimple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasUmbrellaSimple",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 0c17.7 0 32 14.3 32 32v2c115.8 14.4 207.6 106.2 222 222.1 2.2 17.5-12.4 31.9-30 31.9H32c-17.7 0-32.2-14.4-30-31.9C16.4 140.2 108.2 48.4 224 34v-2c0-17.7 14.3-32 32-32zm32 430.6c0 45-36.5 81.4-81.4 81.4-30.8 0-59-17.4-72.8-45l-2.3-4.7c-7.9-15.8-1.5-35 14.3-42.9s35-1.5 42.9 14.3l2.3 4.7c3 5.9 9 9.6 15.6 9.6 9.6 0 17.4-7.8 17.4-17.4V320h64v110.6z"
        }
    ]
};

const FasUmbrella = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasUmbrella",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 0c17.7 0 32 14.3 32 32v17.7C451.8 63.4 557.7 161 573.9 285.9c2 15.6-17.3 24.4-27.8 12.7-14-15.6-41.3-26.6-66.1-26.6-38.7 0-71 27.5-78.4 64.1-1.7 8.7-8.7 15.9-17.6 15.9s-15.8-7.2-17.6-15.9C359 299.5 326.7 272 288 272s-71 27.5-78.4 64.1c-1.7 8.7-8.7 15.9-17.6 15.9s-15.8-7.2-17.6-15.9C167 299.5 134.7 272 96 272c-24.8 0-52.1 11-66.1 26.7-10.5 11.7-29.8 2.8-27.8-12.8C18.3 161 124.2 63.4 256 49.7V32c0-17.7 14.3-32 32-32zm0 304c12.3 0 23.5 4.6 32 12.2v114.4c0 45-36.5 81.4-81.4 81.4-30.8 0-59-17.4-72.8-45l-2.3-4.7c-7.9-15.8-1.5-35 14.3-42.9s35-1.5 42.9 14.3l2.3 4.7c3 5.9 9 9.6 15.6 9.6 9.6 0 17.4-7.8 17.4-17.4V316.2c8.5-7.6 19.7-12.2 32-12.2z"
        }
    ]
};

const FasUnderline = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasUnderline",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M16 64c0-17.7 14.3-32 32-32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32h-16v128c0 53 43 96 96 96s96-43 96-96V96h-16c-17.7 0-32-14.3-32-32s14.3-32 32-32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32h-16v128c0 88.4-71.6 160-160 160S64 312.4 64 224V96H48c-17.7 0-32-14.3-32-32zM0 448c0-17.7 14.3-32 32-32h384c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32z"
        }
    ]
};

const FasUnicorn = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasUnicorn",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 160v80c-.5 30-12.8 56.4-32 75.7V480c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32V346.7c-4.1-.7-8.2-1.6-12.3-2.8l-84-24c.2 2.3.3 4.6.3 6.9 0 18.6-7.4 36.5-20.6 49.7l-12.7 12.7c-4.8 4.8-6.4 11.8-4.3 18.2l20.8 62.5c6.9 20.7-8.5 42.1-30.4 42.1h-33.7c-13.8 0-26-8.8-30.4-21.9l-17.4-52.4c-10.6-31.7-6.5-65.9 10-93.9 7.6-12.9 9.5-29.1 1.2-41.6l-28.3-42.3c-7.3-11-11.9-23.4-13.6-36.4-10 7.3-16.6 19.1-16.6 32.5v56c0 13.3-10.7 24-24 24S0 325.3 0 312v-56c0-44.6 33.2-81.5 76.3-87.2 14.9-24.4 41.8-40.8 72.5-40.8H320C320 57.3 377.3 0 448 0h96c8.8 0 16 7.2 16 16s-7.2 16-16 16h-5.7c5.2 4.6 9.6 10 13.1 16h79.3c5.1 0 9.3 4.2 9.3 9.3 0 4-2.6 7.6-6.4 8.8L560 90.7v64.8c0 22.1-13.4 41.9-33.9 50.1-26.1 10.4-55.7-.9-68.3-26L448 160zm64-80a16 16 0 1 0-32 0 16 16 0 1 0 32 0z"
        }
    ]
};

const FasUniformMartialArts = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasUniformMartialArts",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M180 0h37.6c12.3 0 23.5 7 28.8 18.1l61.1 126.7L253 288H144V133.1l-46 83.6c-1.3 2.4-2 5-2 7.7V384c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V224.4c0-18.9 4.8-37.4 13.9-54L80.3 49.7C95.9 21.2 124.9 2.8 157 .3c1-.2 2-.3 3-.3h20zm209.1 20.6C393.8 8.2 405.7 0 419 0h61c1 0 2 .1 3 .3 32.1 2.5 61 20.9 76.7 49.5l66.4 120.7c9.1 16.5 13.9 35.1 13.9 54V384c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32V224.4c0-2.7-.7-5.3-2-7.7L496 133v155H287.2l52.7-138.3 49.2-129.1zM320 320h176v32H349.9l47.4 71.1c4.9 7.4 2.9 17.3-4.4 22.2s-17.3 2.9-22.2-4.4l-50.7-76-50.7 76c-4.9 7.4-14.8 9.3-22.2 4.4s-9.3-14.8-4.4-22.2l47.4-71.1H144v-32h176zm-103.9 85.4c-14.7 22.1-8.7 51.9 13.3 66.6s51.9 8.7 66.6-13.3l24-36.2 24.1 36.1c14.7 22.1 44.5 28 66.6 13.3s28-44.5 13.3-66.6L409.7 384H496v64c0 35.3-28.7 64-64 64H208c-35.3 0-64-28.7-64-64v-64h86.3l-14.2 21.4z"
        }
    ]
};

const FasUnion = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasUnion",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 32c17.7 0 32 14.3 32 32v224c0 70.7 57.3 128 128 128s128-57.3 128-128V64c0-17.7 14.3-32 32-32s32 14.3 32 32v224c0 106-86 192-192 192S0 394 0 288V64c0-17.7 14.3-32 32-32z"
        }
    ]
};

const FasUniversalAccess = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasUniversalAccess",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm161.5-86.1c-12.2-5.2-26.3.4-31.5 12.6s.4 26.3 12.6 31.5l11.9 5.1c17.3 7.4 35.2 12.9 53.6 16.3v50.1c0 4.3-.7 8.6-2.1 12.6l-28.7 86.1c-4.2 12.6 2.6 26.2 15.2 30.4s26.2-2.6 30.4-15.2l24.4-73.2c1.3-3.8 4.8-6.4 8.8-6.4s7.6 2.6 8.8 6.4l24.4 73.2c4.2 12.6 17.8 19.4 30.4 15.2s19.4-17.8 15.2-30.4l-28.7-86.1c-1.4-4.1-2.1-8.3-2.1-12.6v-50c18.4-3.5 36.3-8.9 53.6-16.3l11.9-5.1c12.2-5.2 17.8-19.3 12.6-31.5s-19.3-17.8-31.5-12.6l-12 5c-26.1 11.2-54.2 17-82.7 17s-56.5-5.8-82.7-17l-11.9-5.1zM256 160a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"
        }
    ]
};

const FasUnlockKeyhole = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasUnlockKeyhole",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 64c-44.2 0-80 35.8-80 80v48h240c35.3 0 64 28.7 64 64v192c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256c0-35.3 28.7-64 64-64h16v-48C80 64.5 144.5 0 224 0c57.5 0 107 33.7 130.1 82.3 7.6 16 .8 35.1-15.2 42.6s-35.1.8-42.6-15.2C283.4 82.6 255.9 64 224 64zm32 320c17.7 0 32-14.3 32-32s-14.3-32-32-32h-64c-17.7 0-32 14.3-32 32s14.3 32 32 32h64z"
        }
    ]
};

const FasUnlock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasUnlock",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 144c0-44.2 35.8-80 80-80 31.9 0 59.4 18.6 72.3 45.7 7.6 16 26.7 22.8 42.6 15.2s22.8-26.7 15.2-42.6C331 33.7 281.5 0 224 0 144.5 0 80 64.5 80 144v48H64c-35.3 0-64 28.7-64 64v192c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V256c0-35.3-28.7-64-64-64H144v-48z"
        }
    ]
};

const FasUpDownLeftRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasUpDownLeftRight",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M278.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8h32v96h-96V192c0-12.9-7.8-24.6-19.8-29.6s-25.7-2.2-34.9 6.9l-64 64c-12.5 12.5-12.5 32.8 0 45.3l64 64c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6V288h96v96h-32c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l64 64c12.5 12.5 32.8 12.5 45.3 0l64-64c9.2-9.2 11.9-22.9 6.9-34.9S332.9 384 319.9 384H288v-96h96v32c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l64-64c12.5-12.5 12.5-32.8 0-45.3l-64-64c-9.2-9.2-22.9-11.9-34.9-6.9S384 179.1 384 192.1v32h-96V128h32c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-64-64z"
        }
    ]
};

const FasUpDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasUpDown",
    "viewBox": "0 0 256 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M145.6 7.7C141 2.8 134.7 0 128 0s-13 2.8-17.6 7.7l-104 112c-6.5 7-8.2 17.2-4.4 25.9S14.5 160 24 160h56v192H24c-9.5 0-18.2 5.7-22 14.4s-2.1 18.9 4.4 25.9l104 112c4.5 4.9 10.9 7.7 17.6 7.7s13-2.8 17.6-7.7l104-112c6.5-7 8.2-17.2 4.4-25.9S241.5 352 232 352h-56V160h56c9.5 0 18.2-5.7 22-14.4s2.1-18.9-4.4-25.9l-104-112z"
        }
    ]
};

const FasUpFromBracket = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasUpFromBracket",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M73.9 134.1 196.7 11.3C203.9 4.1 213.8 0 224 0s20.1 4.1 27.3 11.3l122.8 122.8c6.4 6.4 9.9 15 9.9 24 0 18.7-15.2 33.9-33.9 33.9H288v128c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32V192H97.9C79.2 192 64 176.8 64 158.1c0-9 3.6-17.6 9.9-24zM64 352v64c0 17.7 14.3 32 32 32h256c17.7 0 32-14.3 32-32v-64c0-17.7 14.3-32 32-32s32 14.3 32 32v64c0 53-43 96-96 96H96c-53 0-96-43-96-96v-64c0-17.7 14.3-32 32-32s32 14.3 32 32z"
        }
    ]
};

const FasUpFromDottedLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasUpFromDottedLine",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M73.9 166.1 196.7 43.3C203.9 36.1 213.8 32 224 32s20.1 4.1 27.3 11.3l122.8 122.8c6.4 6.4 9.9 15 9.9 24 0 18.7-15.2 33.9-33.9 33.9H288v128c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32V224H97.9C79.2 224 64 208.8 64 190.1c0-9 3.6-17.6 9.9-24zM32 416a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64 32a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm128-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64 32a32 32 0 1 1 64 0 32 32 0 1 1-64 0z"
        }
    ]
};

const FasUpFromLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasUpFromLine",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M41.9 166.1 164.7 43.3C171.9 36.1 181.8 32 192 32s20.1 4.1 27.3 11.3l122.8 122.8c6.4 6.4 9.9 15 9.9 24 0 18.7-15.2 33.9-33.9 33.9H256v128c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32V224H65.9C47.2 224 32 208.8 32 190.1c0-9 3.6-17.6 9.9-24zM32 416h320c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
        }
    ]
};

const FasUpLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasUpLeft",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 80h240c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-72 72 134 134c7.2 7.2 11.3 17.1 11.3 27.3s-4.1 20.1-11.3 27.3l-41.4 41.4c-7.2 7.2-17.1 11.3-27.3 11.3s-20.1-4.1-27.3-11.3L142.6 302.6l-72 72c-9.2 9.2-22.9 11.9-34.9 6.9s-19.8-16.6-19.8-29.6V112c0-17.7 14.3-32 32-32z"
        }
    ]
};

const FasUpLong = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasUpLong",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M318 177.5c3.8-8.8 2-19-4.6-26l-136-144C172.9 2.7 166.6 0 160 0s-12.9 2.7-17.4 7.5l-136 144c-6.6 7-8.4 17.2-4.6 26S14.4 192 24 192h72v288c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V192h72c9.6 0 18.2-5.7 22-14.5z"
        }
    ]
};

const FasUpRightAndDownLeftFromCenter = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasUpRightAndDownLeftFromCenter",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M344 0h144c13.3 0 24 10.7 24 24v144c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-39-39-87 87c-9.4 9.4-24.6 9.4-33.9 0l-32-32c-9.4-9.4-9.4-24.6 0-33.9l87-87L327 41c-6.9-6.9-8.9-17.2-5.2-26.2S334.3 0 344 0zM168 512H24c-13.3 0-24-10.7-24-24V344c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2l39 39 87-87c9.4-9.4 24.6-9.4 33.9 0l32 32c9.4 9.4 9.4 24.6 0 33.9l-87 87 39 39c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8z"
        }
    ]
};

const FasUpRightFromSquare = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasUpRightFromSquare",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 0c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9L370.7 96 201.4 265.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L416 141.3l41.4 41.4c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6V32c0-17.7-14.3-32-32-32H352zM80 32C35.8 32 0 67.8 0 112v320c0 44.2 35.8 80 80 80h320c44.2 0 80-35.8 80-80V320c0-17.7-14.3-32-32-32s-32 14.3-32 32v112c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16h112c17.7 0 32-14.3 32-32s-14.3-32-32-32H80z"
        }
    ]
};

const FasUpRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasUpRight",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M336 80H96c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l72 72-134 134C4.1 347.9 0 357.8 0 368s4.1 20.1 11.3 27.3l41.4 41.4C59.9 443.9 69.8 448 80 448s20.1-4.1 27.3-11.3l134.1-134.1 72 72c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6V112c0-17.7-14.3-32-32-32z"
        }
    ]
};

const FasUpToDottedLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasUpToDottedLine",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64a32 32 0 1 1-64 0 32 32 0 1 1 64 0zm64 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm128-32a32 32 0 1 1-64 0 32 32 0 1 1 64 0zm64 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm96 0a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM73.9 262.1l122.8-122.8c7.2-7.2 17.1-11.3 27.3-11.3s20.1 4.1 27.3 11.3l122.8 122.8c6.4 6.4 9.9 15 9.9 24 0 18.7-15.2 33.9-33.9 33.9H288v128c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32V320H97.9C79.2 320 64 304.8 64 286.1c0-9 3.6-17.6 9.9-24z"
        }
    ]
};

const FasUpToLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasUpToLine",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M342.1 262.1 219.3 139.3c-7.2-7.2-17.1-11.3-27.3-11.3s-20.1 4.1-27.3 11.3L41.9 262.1c-6.4 6.4-9.9 15-9.9 24 0 18.7 15.2 33.9 33.9 33.9H128v128c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V320h62.1c18.7 0 33.9-15.2 33.9-33.9 0-9-3.6-17.6-9.9-24zM32 96h320c17.7 0 32-14.3 32-32s-14.3-32-32-32H32C14.3 32 0 46.3 0 64s14.3 32 32 32z"
        }
    ]
};

const FasUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasUp",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M169.4 41.4c12.5-12.5 32.8-12.5 45.3 0l160 160c9.2 9.2 11.9 22.9 6.9 34.9S365 256.1 352 256.1h-96V440c0 22.1-17.9 40-40 40h-48c-22.1 0-40-17.9-40-40V256H32c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9l160-160z"
        }
    ]
};

const FasUpload = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasUpload",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 109.3V352c0 17.7-14.3 32-32 32s-32-14.3-32-32V109.3l-73.4 73.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l128-128c12.5-12.5 32.8-12.5 45.3 0l128 128c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L288 109.3zM64 352h128c0 35.3 28.7 64 64 64s64-28.7 64-64h128c35.3 0 64 28.7 64 64v32c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64v-32c0-35.3 28.7-64 64-64zm368 104a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FasUsbDrive = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasUsbDrive",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 96c-35.3 0-64 28.7-64 64v192c0 35.3 28.7 64 64 64h352c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H64zm544 32H480v256h128c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32zm-48 104a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm24 72a24 24 0 1 1-48 0 24 24 0 1 1 48 0z"
        }
    ]
};

const FasUserAlien = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasUserAlien",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 167C64 74.8 135.6 0 224 0s160 74.8 160 167c0 101-106.6 185-139.2 208.3-6.1 4.3-13.4 6.5-20.8 6.5s-14.7-2.1-20.8-6.5C170.6 352 64 268.1 64 167zm244.6 9c-37.9 0-68.6 30.7-68.6 68.6 0 6.3 5.1 11.4 11.4 11.4h16c37.9 0 68.6-30.7 68.6-68.6 0-6.3-5.1-11.4-11.4-11.4h-16zM208 244.6c0-37.9-30.7-68.6-68.6-68.6h-16c-6.3 0-11.4 5.1-11.4 11.4 0 37.9 30.7 68.6 68.6 68.6h16c6.3 0 11.4-5.1 11.4-11.4zM0 486.4C0 415 55.7 356.6 126.1 352.3c23.8 23.2 46.1 40.2 58.5 49.1 12 8.6 25.9 12.4 39.4 12.4s27.4-3.8 39.4-12.4c12.4-8.8 34.7-25.8 58.5-49.1C392.3 356.6 448 415 448 486.4c0 14.1-11.5 25.6-25.6 25.6H25.6C11.5 512 0 500.5 0 486.4z"
        }
    ]
};

const FasUserAstronaut = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasUserAstronaut",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M370.7 96.1C346.1 39.5 289.7 0 224 0S101.9 39.5 77.3 96.1C60.9 97.5 48 111.2 48 128v64c0 16.8 12.9 30.5 29.3 31.9 24.6 56.6 81 96.1 146.7 96.1s122.1-39.5 146.7-96.1c16.4-1.4 29.3-15.1 29.3-31.9v-64c0-16.8-12.9-30.5-29.3-31.9zM336 144v16c0 53-43 96-96 96h-32c-53 0-96-43-96-96v-16c0-26.5 21.5-48 48-48h128c26.5 0 48 21.5 48 48zm-146.7 18.7-6-21.2c-.9-3.3-3.9-5.5-7.3-5.5s-6.4 2.2-7.3 5.5l-6 21.2-21.2 6c-3.3.9-5.5 3.9-5.5 7.3s2.2 6.4 5.5 7.3l21.2 6 6 21.2c.9 3.3 3.9 5.5 7.3 5.5s6.4-2.2 7.3-5.5l6-21.2 21.2-6c3.3-.9 5.5-3.9 5.5-7.3s-2.2-6.4-5.5-7.3l-21.2-6zm-76.6 153.8C46.7 342.6 0 407 0 482.3 0 498.7 13.3 512 29.7 512H128v-64c0-17.7 14.3-32 32-32h128c17.7 0 32 14.3 32 32v64h98.3c16.4 0 29.7-13.3 29.7-29.7 0-75.3-46.7-139.7-112.7-165.8C303.9 338.8 265.5 352 224 352s-79.9-13.2-111.3-35.5zM176 448c-8.8 0-16 7.2-16 16v48h32v-48c0-8.8-7.2-16-16-16zm96 32a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
        }
    ]
};

const FasUserBountyHunter = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasUserBountyHunter",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M323 120c-13.6-42-53-72-99-72s-85.4 30-99 72h198zm5.5 36.4L248 171.5v98.4l9.5-1.9c7.6-49.7 42.9-81.5 71.9-97.8l-.9-13.8zm-209 0-.9 13.8c29 16.3 64.2 48.1 71.9 97.8l9.5 1.9v-98.4l-80.5-15.1zM96 70c27.1-42.3 74.5-70 128-70 80.1 0 146.5 62.2 151.7 142.2l7.3 114.3c1.3 20-12.4 37.9-32.1 41.8l-100.8 20.1c-5.2 1-10.4 1.6-15.7 1.6h-20.9c-5.3 0-10.5-.5-15.7-1.6L97 298.3c-16.2-3.2-28.4-16-31.4-31.6-1-3.4-1.6-7-1.6-10.7V16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16v38zm38.4 282h179.2c74.2 0 134.4 60.2 134.4 134.4 0 14.1-11.5 25.6-25.6 25.6H25.6C11.5 512 0 500.5 0 486.4 0 412.2 60.2 352 134.4 352zm37.1 103.4c-3.7 2.8-1.7 8.6 2.9 8.6h99.2c4.6 0 6.6-5.9 2.9-8.6l-47.7-35.8c-2.8-2.1-6.8-2.1-9.6 0l-47.7 35.8z"
        }
    ]
};

const FasUserCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasUserCheck",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 128a128 128 0 1 1 256 0 128 128 0 1 1-256 0zM0 482.3C0 383.8 79.8 304 178.3 304h91.4c98.5 0 178.3 79.8 178.3 178.3 0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM625 177 497 305c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L591 143c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
        }
    ]
};

const FasUserChef = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasUserChef",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 48c0 20.9-13.4 38.7-32 45.3V176c0 70.7-57.3 128-128 128S96 246.7 96 176V93.3C77.4 86.7 64 68.9 64 48c0-26.5 21.5-48 48-48 14.3 0 27.2 6.3 36 16.3C156.8 6.3 169.7 0 184 0c16.7 0 31.4 8.5 40 21.5C232.6 8.5 247.3 0 264 0c14.3 0 27.2 6.3 36 16.3C308.8 6.3 321.7 0 336 0c26.5 0 48 21.5 48 48zm-80 128v-16H144v16c0 44.2 35.8 80 80 80s80-35.8 80-80zM178.4 340.6c7.5 1.9 8.2 12.3 1 15.2l-43.2 17.3c-24.3 9.7-40.2 33.2-40.2 59.4V512H25.6C11.5 512 0 500.5 0 486.4c0-58.8 37.7-108.8 90.3-127 3.3-1.2 5.7-4.3 5.7-7.8v-21.4c0-5.2 4.9-9 9.9-7.8l72.5 18.1zM352 512H128v-79.5c0-13.1 8-24.9 20.1-29.7L341 325.6c5.3-2.1 11 1.8 11 7.4v18.6c0 3.5 2.3 6.6 5.7 7.8 52.6 18.2 90.3 68.2 90.3 127 0 14.1-11.5 25.6-25.6 25.6H352zm-128-80a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm80 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
        }
    ]
};

const FasUserClock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasUserClock",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 0a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm-45.7 304h91.4c20.6 0 40.4 3.5 58.8 9.9C323 331 320 349.1 320 368c0 59.5 29.5 112.1 74.8 144H29.7C13.3 512 0 498.7 0 482.3 0 383.8 79.8 304 178.3 304zM352 368a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm144-80c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32v-48c0-8.8-7.2-16-16-16z"
        }
    ]
};

const FasUserCowboy = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasUserCowboy",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 16c6.7 0 10.8-2.8 15.5-6.1C246.1 5.4 254 0 272 0c35.2 0 58.3 58.1 72 110.4-27.6 9.6-67 17.6-120 17.6s-92.4-8-120-17.6C117.7 58.1 140.8 0 176 0c18 0 25.9 5.4 32.5 9.9 4.8 3.3 8.8 6.1 15.5 6.1zM8.6 97.8c7-3.6 15.5-1.7 20.2 4.6 5.6 7.5 22.7 22 55 34.7 32 12.5 78 22.9 140.2 22.9s108.2-10.4 140.2-22.9c32.4-12.7 49.4-27.2 55-34.7 4.7-6.3 13.3-8.2 20.2-4.6s10.2 11.8 7.8 19.2c-9.3 27.9-35 62.4-72.5 89.9-7.1 5.2-14.7 10.1-22.7 14.8v2.3c0 70.7-57.3 128-128 128S96 294.7 96 224v-2.3c-8-4.6-15.6-9.6-22.7-14.8C35.8 179.5 10.1 145 .8 117.1c-2.5-7.4.8-15.6 7.8-19.2zM100.7 384h246.6c48.4 0 89.3 36.1 95.3 84.1l1 7.9c2.4 19.1-12.5 36-31.8 36H36.2C17 512 2.1 495.1 4.5 476l1-7.9c6-48 46.8-84.1 95.3-84.1z"
        }
    ]
};

const FasUserCrown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasUserCrown",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 128v16c0 44.2 35.8 80 80 80s80-35.8 80-80v-16H144zm0-108.8c10.2 7.5 23.8 8.3 34.9 2L209.1 4c4.6-2.6 9.7-4 14.9-4s10.4 1.4 14.9 4l30.2 17.2c11 6.3 24.7 5.5 34.9-2l.1-.1c.3-.2.6-.4.8-.6l3-2.4 15.7-12.6c2.8-2.3 6.4-3.5 10-3.5h2.4c8.8 0 16 7.2 16 16v128c0 70.7-57.3 128-128 128S96 214.7 96 144V16c0-8.8 7.2-16 16-16h2.4c3.6 0 7.2 1.2 10 3.5L140 16l3 2.4c.3.2.6.4.8.6l.1.1zM0 472c0-92.8 75.2-168 168-168h112c92.8 0 168 75.2 168 168v8c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32v-8z"
        }
    ]
};

const FasUserDoctorHairLong = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasUserDoctorHairLong",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M304 128c0-11.4-2.4-22.2-6.7-32H296c-20.5 0-38.7-9.6-50.4-24.5C231.9 95.7 205.8 112 176 112h-30.4c-1 5.2-1.6 10.5-1.6 16v16c0 44.2 35.8 80 80 80s80-35.8 80-80v-16zm-208 0C96 57.3 153.3 0 224 0s128 57.3 128 128v11c0 33.9 13.5 66.5 37.5 90.5l3.9 3.9c4.2 4.2 6.6 10 6.6 16 0 12.5-10.1 22.6-22.6 22.6H70.6C58.1 272 48 261.9 48 249.4c0-6 2.4-11.8 6.6-16l3.9-3.9c24-24 37.5-56.6 37.5-90.5v-11zm192 192v42c-27.6 7.1-48 32.2-48 62v40c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16s-7.2-16-16-16v-24c0-17.7 14.3-32 32-32s32 14.3 32 32v24c-8.8 0-16 7.2-16 16s7.2 16 16 16h16c8.8 0 16-7.2 16-16v-40c0-29.8-20.4-54.9-48-62v-38.6c73.1 15.3 128 80.2 128 157.8 0 17-13.8 30.7-30.7 30.7H30.7C13.8 512 0 498.2 0 481.3c0-77.7 54.9-142.5 128-157.8v46.9c-23.1 6.9-40 28.3-40 53.7 0 30.9 25.1 56 56 56s56-25.1 56-56c0-25.4-16.9-46.8-40-53.7V320h128zM120 424a24 24 0 1 1 48 0 24 24 0 1 1-48 0z"
        }
    ]
};

const FasUserDoctorHair = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasUserDoctorHair",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M304 144c0 44.2-35.8 80-80 80s-80-35.8-80-80v-16c0-5.5.6-10.8 1.6-16h31.8c28.9 0 55.8-15.2 70.6-40l5.3 5.3C265 89 280.8 95.7 297.3 96c4.3 9.8 6.7 20.6 6.7 32v16zM224 0C153.3 0 96 57.3 96 128v16c0 70.7 57.3 128 128 128s128-57.3 128-128v-16C352 57.3 294.7 0 224 0zm64 320H160v50.3c23.1 6.9 40 28.3 40 53.7 0 30.9-25.1 56-56 56s-56-25.1-56-56c0-25.4 16.9-46.8 40-53.7v-46.9C54.9 338.8 0 403.6 0 481.3c0 17 13.8 30.7 30.7 30.7h386.6c17 0 30.7-13.8 30.7-30.7 0-77.7-54.9-142.5-128-157.8V362c27.6 7.1 48 32.2 48 62v40c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16s7.2-16 16-16v-24c0-17.7-14.3-32-32-32s-32 14.3-32 32v24c8.8 0 16 7.2 16 16s-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-40c0-29.8 20.4-54.9 48-62v-42zM168 424a24 24 0 1 0-48 0 24 24 0 1 0 48 0z"
        }
    ]
};

const FasUserDoctorMessage = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasUserDoctorMessage",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 128a128 128 0 1 1 256 0 128 128 0 1 1-256 0zM0 482.3c0-81 54-149.4 128-171.1v59.1c-23.1 6.9-40 28.3-40 53.7 0 30.9 25.1 56 56 56s56-25.1 56-56c0-25.4-16.9-46.8-40-53.7v-65.4c6-.6 12.1-.9 18.3-.9h91.4c6.2 0 12.3.3 18.3.9V362c-27.6 7.1-48 32.2-48 62v40c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16s-7.2-16-16-16v-24c0-17.7 14.3-32 32-32s32 14.3 32 32v24c-8.8 0-16 7.2-16 16s7.2 16 16 16h16c8.8 0 16-7.2 16-16v-40c0-29.8-20.4-54.9-48-62v-50.8c74 21.7 128 90.1 128 171.1 0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM120 424a24 24 0 1 1 48 0 24 24 0 1 1-48 0zM432 0h160c26.5 0 48 21.5 48 48v128c0 26.5-21.5 48-48 48h-48l-83.2 62.4c-2.4 1.8-5.7 2.1-8.4.8s-4.4-4.1-4.4-7.2v-56h-16c-26.5 0-48-21.5-48-48V48c0-26.5 21.5-48 48-48z"
        }
    ]
};

const FasUserDoctor = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasUserDoctor",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 256a128 128 0 1 0 0-256 128 128 0 1 0 0 256zm-96 55.2C54 332.9 0 401.3 0 482.3 0 498.7 13.3 512 29.7 512h388.6c16.4 0 29.7-13.3 29.7-29.7 0-81-54-149.4-128-171.1V362c27.6 7.1 48 32.2 48 62v40c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16s7.2-16 16-16v-24c0-17.7-14.3-32-32-32s-32 14.3-32 32v24c8.8 0 16 7.2 16 16s-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-40c0-29.8 20.4-54.9 48-62v-57.1c-6-.6-12.1-.9-18.3-.9h-91.4c-6.2 0-12.3.3-18.3.9v65.4c23.1 6.9 40 28.3 40 53.7 0 30.9-25.1 56-56 56s-56-25.1-56-56c0-25.4 16.9-46.8 40-53.7v-59.1zM144 448a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FasUserGear = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasUserGear",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 0a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm-45.7 304h91.4c11.8 0 23.4 1.2 34.5 3.3-2.1 18.5 7.4 35.6 21.8 44.8-16.6 10.6-26.7 31.6-20 53.3 4 12.9 9.4 25.5 16.4 37.6s15.2 23.1 24.4 33c15.7 16.9 39.6 18.4 57.2 8.7v.9c0 9.2 2.7 18.5 7.9 26.3H29.7C13.3 512 0 498.7 0 482.3 0 383.8 79.8 304 178.3 304zM436 218.2c0-7 4.5-13.3 11.3-14.8 10.5-2.4 21.5-3.7 32.7-3.7s22.2 1.3 32.7 3.7c6.8 1.5 11.3 7.8 11.3 14.8v30.6c7.9 3.4 15.4 7.7 22.3 12.8l24.9-14.3c6.1-3.5 13.7-2.7 18.5 2.4 7.6 8.1 14.3 17.2 20.1 27.2s10.3 20.4 13.5 31c2.1 6.7-1.1 13.7-7.2 17.2l-25 14.4c.4 4 .7 8.1.7 12.3s-.2 8.2-.7 12.3l25 14.4c6.1 3.5 9.2 10.5 7.2 17.2-3.3 10.6-7.8 21-13.5 31s-12.5 19.1-20.1 27.2c-4.8 5.1-12.5 5.9-18.5 2.4L546.3 442c-6.9 5.1-14.3 9.4-22.3 12.8v30.6c0 7-4.5 13.3-11.3 14.8-10.5 2.4-21.5 3.7-32.7 3.7s-22.2-1.3-32.7-3.7c-6.8-1.5-11.3-7.8-11.3-14.8v-30.6c-8-3.4-15.6-7.7-22.5-12.9l-24.7 14.3c-6.1 3.5-13.7 2.7-18.5-2.4-7.6-8.1-14.3-17.2-20.1-27.2s-10.3-20.4-13.5-31c-2.1-6.7 1.1-13.7 7.2-17.2l24.8-14.3c-.4-4.1-.7-8.2-.7-12.4s.2-8.3.7-12.4L343.8 325c-6.1-3.5-9.2-10.5-7.2-17.2 3.3-10.6 7.7-21 13.5-31s12.5-19.1 20.1-27.2c4.8-5.1 12.4-5.9 18.5-2.4l24.8 14.3c6.9-5.1 14.5-9.4 22.5-12.9v-30.4zm92.1 133.5a48.1 48.1 0 1 0-96.1 0 48.1 48.1 0 1 0 96.1 0z"
        }
    ]
};

const FasUserGraduate = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasUserGraduate",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M219.3.5c3.1-.6 6.3-.6 9.4 0l200 40C439.9 42.7 448 52.6 448 64s-8.1 21.3-19.3 23.5L352 102.9V160c0 70.7-57.3 128-128 128S96 230.7 96 160v-57.1l-48-9.6v65.1l15.7 78.4c.9 4.7-.3 9.6-3.3 13.3S52.8 256 48 256H16c-4.8 0-9.3-2.1-12.4-5.9s-4.3-8.6-3.3-13.3L16 158.4V86.6C6.5 83.3 0 74.3 0 64c0-11.4 8.1-21.3 19.3-23.5l200-40zM111.9 327.7c10.5-3.4 21.8.4 29.4 8.5l71 75.5c6.3 6.7 17 6.7 23.3 0l71-75.5c7.6-8.1 18.9-11.9 29.4-8.5 65 20.9 112 81.7 112 153.6 0 17-13.8 30.7-30.7 30.7H30.7C13.8 512 0 498.2 0 481.3c0-71.9 47-132.7 111.9-153.6z"
        }
    ]
};

const FasUserGroupCrown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasUserGroupCrown",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 144v-16h160v16c0 44.2-35.8 80-80 80s-80-35.8-80-80zm-.1-124.9c-.3-.2-.6-.4-.8-.6L140 16 124.4 3.5c-2.9-2.3-6.4-3.5-10-3.5H112c-8.8 0-16 7.2-16 16v128c0 70.7 57.3 128 128 128s128-57.3 128-128V16c0-8.8-7.2-16-16-16h-2.4c-3.6 0-7.2 1.2-10 3.5L308 16l-3 2.4c-.3.2-.6.4-.8.6l-.1.1c-10.2 7.5-23.8 8.3-34.9 2L238.9 4c-4.6-2.6-9.7-4-14.9-4s-10.4 1.4-14.9 4l-30.2 17.2c-11 6.3-24.7 5.5-34.9-2l-.1-.1zM168 304C75.2 304 0 379.2 0 472v8c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32v-8c0-92.8-75.2-168-168-168H168zm264-48c61.9 0 112-50.1 112-112S493.9 32 432 32c-17.2 0-33.5 3.9-48 10.8V144c0 5.4-.3 10.7-.8 16-2.4 24.3-10.3 47.1-22.4 67-.5.8-1 1.6-1.4 2.3C379 245.9 404.3 256 432 256zm39.4 256h137.9c17 0 30.7-13.8 30.7-30.7 0-89.1-72.2-161.3-161.3-161.3h-61.4c-2.4 0-4.8.1-7.1.2C452.9 356.8 480 411.3 480 472v8c0 11.7-3.1 22.6-8.6 32z"
        }
    ]
};

const FasUserGroupSimple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasUserGroupSimple",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 32a104 104 0 1 1 0 208 104 104 0 1 1 0-208zm320 0a104 104 0 1 1 0 208 104 104 0 1 1 0-208zM0 416c0-70.7 57.3-128 128-128h64c70.7 0 128 57.3 128 128v16c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48v-16zm448 64c-38.3 0-72.7-16.8-96.1-43.5.1-1.5.1-3 .1-4.5v-16c0-34.9-11.2-67.1-30.1-93.4 5.8-20 24.2-34.6 46.1-34.6h224c26.5 0 48 21.5 48 48v16c0 70.7-57.3 128-128 128h-64z"
        }
    ]
};

const FasUserGroup = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasUserGroup",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 128a128 128 0 1 1 256 0 128 128 0 1 1-256 0zM0 482.3C0 383.8 79.8 304 178.3 304h91.4c98.5 0 178.3 79.8 178.3 178.3 0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM609.3 512H471.4c5.4-9.4 8.6-20.3 8.6-32v-8c0-60.7-27.1-115.2-69.8-151.8 2.4-.1 4.7-.2 7.1-.2h61.4c89.1 0 161.3 72.2 161.3 161.3 0 17-13.8 30.7-30.7 30.7zM432 256c-31 0-59-12.6-79.3-32.9 19.7-26.6 31.3-59.5 31.3-95.1 0-26.8-6.6-52.1-18.3-74.3C384.3 40.1 407.2 32 432 32c61.9 0 112 50.1 112 112s-50.1 112-112 112z"
        }
    ]
};

const FasUserHairBuns = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasUserHairBuns",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M304 128v16c0 44.2-35.8 80-80 80s-80-35.8-80-80v-16c0-5.5.6-10.8 1.6-16H160c26.2 0 49.4-12.6 64-32 14.6 19.4 37.8 32 64 32h14.4c1 5.2 1.6 10.5 1.6 16zM84 192c7 0 13.7-1.6 19.6-4.6 17.8 49.3 65 84.6 120.4 84.6s102.7-35.3 120.4-84.6c5.9 2.9 12.5 4.6 19.6 4.6 24.3 0 44-19.7 44-44v-40c0-24.3-19.7-44-44-44-9.3 0-17.9 2.9-25 7.8C318.2 29.3 274.5 0 224 0s-94.2 29.3-115 71.8c-7.1-4.9-15.7-7.8-25-7.8-24.3 0-44 19.7-44 44v40c0 24.3 19.7 44 44 44zm77.3 128C72.2 320 0 392.2 0 481.3c0 17 13.8 30.7 30.7 30.7h386.6c17 0 30.7-13.8 30.7-30.7 0-89.1-72.2-161.3-161.3-161.3H161.3z"
        }
    ]
};

const FasUserHairLong = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasUserHairLong",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M304 128c0-11.4-2.4-22.2-6.7-32H296c-20.5 0-38.7-9.6-50.4-24.5C231.9 95.7 205.8 112 176 112h-30.4c-1 5.2-1.6 10.5-1.6 16v16c0 44.2 35.8 80 80 80s80-35.8 80-80v-16zm-208 0C96 57.3 153.3 0 224 0s128 57.3 128 128v11c0 33.9 13.5 66.5 37.5 90.5l3.9 3.9c4.2 4.2 6.6 10 6.6 16 0 12.5-10.1 22.6-22.6 22.6H70.6C58.1 272 48 261.9 48 249.4c0-6 2.4-11.8 6.6-16l3.9-3.9c24-24 37.5-56.6 37.5-90.5v-11zm65.3 192h125.4c89.1 0 161.3 72.2 161.3 161.3 0 17-13.8 30.7-30.7 30.7H30.7C13.8 512 0 498.2 0 481.3 0 392.2 72.2 320 161.3 320z"
        }
    ]
};

const FasUserHairMullet = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasUserHairMullet",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M304 128v16c0 18-6 34.6-16 48-14.6 19.4-37.8 32-64 32s-49.4-12.6-64-32c-10-13.4-16-30-16-48v-16c0-5.7.6-11.3 1.7-16.6 30.6-3.1 58.5-17.9 78.3-40.6 19.8 22.7 47.6 37.5 78.3 40.6 1.1 5.4 1.7 10.9 1.7 16.6zm-66.6 143.3L255 289c5.5 5.5 13.2 8 20.8 6.7s14.2-6.1 17.6-13l6.1-12.2 19.5 7.8c9.3 3.7 19.8 1.3 26.6-6s8.3-18.1 3.8-27c-8.5-17-11-22.3-12.2-27.1-.7-2.9-1.1-5.9-1.2-12.3 10.2-18.4 16-39.5 16-61.9v-16c0-7.1-.6-14-1.7-20.7 5.9-4.4 9.7-11.4 9.7-19.3 0-13.3-10.7-24-24-24h-1.1C312.7 25.7 271.4 0 224 0s-88.7 25.7-110.9 64H112c-13.3 0-24 10.7-24 24 0 7.9 3.8 14.9 9.7 19.3C96.6 114 96 120.9 96 128v16c0 22.4 5.8 43.5 15.9 61.8-.1 6.4-.5 9.4-1.2 12.3-1.2 4.8-3.7 10.1-12.2 27.1-4.5 8.9-2.9 19.7 3.8 27s17.3 9.7 26.6 6l19.5-7.8 6.1 12.2c3.5 6.9 10 11.7 17.6 13s15.4-1.3 20.8-6.7l17.7-17.7c4.4.5 8.9.7 13.4.7s9-.2 13.4-.7zM161.3 320C72.2 320 0 392.2 0 481.3c0 17 13.8 30.7 30.7 30.7h386.6c17 0 30.7-13.8 30.7-30.7 0-89.1-72.2-161.3-161.3-161.3H161.3z"
        }
    ]
};

const FasUserHair = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasUserHair",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M304 128v16c0 44.2-35.8 80-80 80s-80-35.8-80-80v-16c0-5.5.6-10.8 1.6-16H176c29.8 0 55.9-16.3 69.6-40.5C257.3 86.4 275.5 96 296 96h1.3c4.3 9.8 6.7 20.6 6.7 32zm-208 0v16c0 70.7 57.3 128 128 128s128-57.3 128-128v-16C352 57.3 294.7 0 224 0S96 57.3 96 128zm65.3 192C72.2 320 0 392.2 0 481.3c0 17 13.8 30.7 30.7 30.7h386.6c17 0 30.7-13.8 30.7-30.7 0-89.1-72.2-161.3-161.3-161.3H161.3z"
        }
    ]
};

const FasUserHeadset = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasUserHeadset",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 32c-88.4 0-160 71.6-160 160v16c0 8.8-7.2 16-16 16s-16-7.2-16-16v-16C32 86 118 0 224 0s192 86 192 192v16c0 61.9-50.1 112-112 112h-96c-17.7 0-32-14.3-32-32s14.3-32 32-32h32c17.7 0 32 14.3 32 32h32c44.2 0 80-35.8 80-80v-16c0-88.4-71.6-160-160-160zM96 192c0-70.7 57.3-128 128-128s128 57.3 128 128c0 13.9-2.2 27.3-6.3 39.8-8.3 14.5-23.9 24.2-41.7 24.2h-8.6c-11.1-19.1-31.7-32-55.4-32h-32c-35.3 0-64 28.7-64 64 0 1.4 0 2.7.1 4C114.8 268.6 96 232.5 96 192zm128 160h89.6c74.2 0 134.4 60.2 134.4 134.4 0 14.1-11.5 25.6-25.6 25.6H25.6C11.5 512 0 500.5 0 486.4 0 412.2 60.2 352 134.4 352H224z"
        }
    ]
};

const FasUserHelmetSafety = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasUserHelmetSafety",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M216 0c-13.3 0-24 10.7-24 24v56l-28.4-56.9C125.6 43.5 99 82.6 96.2 128H96c-13.3 0-24 10.7-24 24s10.7 24 24 24h256c13.3 0 24-10.7 24-24s-10.7-24-24-24h-.2c-2.8-45.4-29.4-84.5-67.4-104.9L256 80V24c0-13.3-10.7-24-24-24h-16zm8 320c65.3 0 119.1-48.9 127-112H97c7.9 63.1 61.7 112 127 112zm-89.6 32C60.2 352 0 412.2 0 486.4 0 500.5 11.5 512 25.6 512h396.8c14.1 0 25.6-11.5 25.6-25.6 0-74.2-60.2-134.4-134.4-134.4H134.4z"
        }
    ]
};

const FasUserInjured = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasUserInjured",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M240 80h102.7c-7.9-19.5-20.4-36.5-36.2-49.9L240 80zm37.7-68.2C261.3 4.2 243.2 0 224 0c-53.7 0-99.7 33.1-118.7 80h81.4l91-68.2zM224 256c70.7 0 128-57.3 128-128 0-5.4-.3-10.8-1-16H97c-.7 5.2-1 10.6-1 16 0 70.7 57.3 128 128 128zm-100 56.4c-9.7 3.1-19.1 7-28 11.7V512h147.7l-62.2-103.8-57.5-95.8zm33-7.2 47.3 78.8H272c44.2 0 80 35.8 80 80 0 18-6 34.6-16 48h82.3c16.4 0 29.7-13.3 29.7-29.7 0-98.5-79.8-178.3-178.3-178.3h-91.4c-7.2 0-14.3.4-21.3 1.3zM0 482.3C0 498.7 13.3 512 29.7 512H64V345.4C24.9 378.1 0 427.3 0 482.3zM320 464c0-26.5-21.5-48-48-48h-48.5l57.1 95.2c22.4-4 39.4-23.6 39.4-47.2z"
        }
    ]
};

const FasUserLargeSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasUserLargeSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L381.9 274c48.5-23.2 82.1-72.7 82.1-130C464 64.5 399.5 0 320 0c-69.6 0-127.6 49.3-141.1 114.9L38.8 5.1zM545.5 512H528L284.3 320h-59C136.2 320 64 392.2 64 481.3c0 17 13.8 30.7 30.7 30.7h450.9z"
        }
    ]
};

const FasUserLarge = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasUserLarge",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 288a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm-94.7 32C72.2 320 0 392.2 0 481.3c0 17 13.8 30.7 30.7 30.7h450.6c17 0 30.7-13.8 30.7-30.7 0-89.1-72.2-161.3-161.3-161.3H161.3z"
        }
    ]
};

const FasUserLock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasUserLock",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 256a128 128 0 1 0 0-256 128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3 0 498.7 13.3 512 29.7 512h362.9c-5.4-9.4-8.6-20.3-8.6-32V352c0-2.1.1-4.2.3-6.3-31-26-71-41.7-114.6-41.7h-91.4zM528 240c17.7 0 32 14.3 32 32v48h-64v-48c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32v128c0 17.7 14.3 32 32 32h160c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32v-48c0-44.2-35.8-80-80-80s-80 35.8-80 80z"
        }
    ]
};

const FasUserMagnifyingGlass = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasUserMagnifyingGlass",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 256a128 128 0 1 0 0-256 128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3 0 498.7 13.3 512 29.7 512h388.6c16.4 0 29.7-13.3 29.7-29.7V480c-88.4 0-160-71.6-160-160 0-5.1.2-10.1.7-15-6.2-.7-12.6-1-19-1h-91.4zM448 240.1a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm0 208c26.7 0 51.4-8.2 71.9-22.1l79.1 79.1c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-79.1-79.1c14-20.5 22.1-45.3 22.1-71.9 0-70.7-57.3-128-128-128s-128 57.3-128 128 57.3 128 128 128z"
        }
    ]
};

const FasUserMinus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasUserMinus",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 128a128 128 0 1 1 256 0 128 128 0 1 1-256 0zM0 482.3C0 383.8 79.8 304 178.3 304h91.4c98.5 0 178.3 79.8 178.3 178.3 0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM472 200h144c13.3 0 24 10.7 24 24s-10.7 24-24 24H472c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
        }
    ]
};

const FasUserMusic = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasUserMusic",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 0a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm-45.7 304h91.4c36.3 0 70.1 10.9 98.3 29.5v51.6c-18 2.5-34.8 9.1-48.5 19.4-17.6 13.2-31.5 34-31.5 59.5 0 19.1 7.7 35.4 18.9 48H29.7C13.3 512 0 498.7 0 482.3 0 383.8 79.8 304 178.3 304zM630 164.5c6.3 4.5 10 11.8 10 19.5v208c0 1.2-.1 2.4-.3 3.6.2 1.5.3 2.9.3 4.4 0 26.5-28.7 48-64 48s-64-21.5-64-48 28.7-48 64-48c5.5 0 10.9.5 16 1.5v-88.2l-144 48V464c0 26.5-28.7 48-64 48s-64-21.5-64-48 28.7-48 64-48c5.5 0 10.9.5 16 1.5V248c0-10.3 6.6-19.5 16.4-22.8l192-64c7.3-2.4 15.4-1.2 21.6 3.3z"
        }
    ]
};

const FasUserNinja = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasUserNinja",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 256c-57.2 0-105.6-37.5-122-89.3-1.1 1.3-2.2 2.6-3.5 3.8-15.8 15.8-38.8 20.7-53.6 22.1-8.1.8-14.6-5.7-13.8-13.8 1.4-14.7 6.3-37.8 22.1-53.6 5.8-5.8 12.6-10.1 19.6-13.4-7-3.2-13.8-7.6-19.6-13.4-15.8-15.7-20.6-38.7-22.1-53.5-.8-8.1 5.7-14.6 13.8-13.8 14.7 1.4 37.8 6.3 53.6 22.1 4.8 4.8 8.7 10.4 11.7 16.1C131.4 28.2 174.4 0 224 0c70.7 0 128 57.3 128 128s-57.3 128-128 128zM0 482.3C0 399.5 56.4 330 132.8 309.9c6-1.6 12.2.9 15.9 5.8l62.5 83.3c6.4 8.5 19.2 8.5 25.6 0l62.5-83.3c3.7-4.9 9.9-7.4 15.9-5.8C391.6 330 448 399.5 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM160 96c-8.8 0-16 7.2-16 16s7.2 16 16 16h128c8.8 0 16-7.2 16-16s-7.2-16-16-16H160z"
        }
    ]
};

const FasUserNurseHairLong = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasUserNurseHairLong",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 70.2V128h.3c-.2 2.6-.3 5.3-.3 8v35c0 33.9-13.5 66.5-37.5 90.5l-3.9 3.9c-4.2 4.2-6.6 10-6.6 16 0 12.5 10.1 22.6 22.6 22.6h306.8c12.5 0 22.6-10.1 22.6-22.6 0-6-2.4-11.8-6.6-16l-3.9-3.9c-24-24-37.5-56.6-37.5-90.5v-35c0-2.7-.1-5.4-.3-8h.3V70.2c0-13.3-8.3-25.3-20.8-30l-96-36c-7.2-2.7-15.2-2.7-22.5 0l-96 36C104.3 44.9 96 56.8 96 70.2zM304 160v16c0 44.2-35.8 80-80 80s-80-35.8-80-80h32c29.8 0 55.9-16.3 69.6-40.5 11.7 14.9 29.9 24.5 50.4 24.5h8zM151.4 346.8c-6.4-6.8-15.4-10.6-24.6-9.3C55.1 347.7 0 409.4 0 483.8 0 499.4 12.6 512 28.2 512h391.6c15.6 0 28.2-12.6 28.2-28.2 0-74.5-55.1-136.1-126.7-146.3-9.2-1.3-18.3 2.5-24.6 9.3l-61 64.8c-6.3 6.7-17 6.7-23.3 0l-61-64.8zM208 48c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v16h16c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8h-16v16c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8V96h-16c-4.4 0-8-3.6-8-8V72c0-4.4 3.6-8 8-8h16V48z"
        }
    ]
};

const FasUserNurseHair = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasUserNurseHair",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 70.2V128h.3c-.2 2.6-.3 5.3-.3 8v40c0 70.7 57.3 128 128 128s128-57.3 128-128v-40c0-2.7-.1-5.4-.3-8h.3V70.2c0-13.3-8.3-25.3-20.8-30l-96-36c-7.2-2.7-15.2-2.7-22.5 0l-96 36C104.3 44.9 96 56.8 96 70.2zM304 160v16c0 44.2-35.8 80-80 80s-80-35.8-80-80h32c29.8 0 55.9-16.3 69.6-40.5 11.7 14.9 29.9 24.5 50.4 24.5h8zM141.3 336.2c-7.6-8.1-18.9-11.9-29.4-8.5C47 348.5 0 409.4 0 481.3c0 17 13.8 30.7 30.7 30.7h386.6c17 0 30.7-13.8 30.7-30.7 0-71.8-47-132.7-111.9-153.6-10.5-3.4-21.8.4-29.4 8.5l-71 75.5c-6.3 6.7-17 6.7-23.3 0l-71-75.5zM208 48c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v16h16c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8h-16v16c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8V96h-16c-4.4 0-8-3.6-8-8V72c0-4.4 3.6-8 8-8h16V48z"
        }
    ]
};

const FasUserNurse = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasUserNurse",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 128V70.2c0-13.3 8.3-25.3 20.8-30l96-36c7.2-2.7 15.2-2.7 22.5 0l96 36c12.5 4.7 20.8 16.6 20.8 30V128h-.3c.2 2.6.3 5.3.3 8v40c0 70.7-57.3 128-128 128s-128-57.3-128-128v-40c0-2.7.1-5.4.3-8H96zm48 48c0 44.2 35.8 80 80 80s80-35.8 80-80v-16H144v16zm-32.1 151.7c10.5-3.4 21.8.4 29.4 8.5l71 75.5c6.3 6.7 17 6.7 23.3 0l71-75.5c7.6-8.1 18.9-11.9 29.4-8.5 65 20.9 112 81.7 112 153.6 0 17-13.8 30.7-30.7 30.7H30.7C13.8 512 0 498.2 0 481.3c0-71.9 47-132.7 111.9-153.6zM208 48v16h-16c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h16v16c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V96h16c4.4 0 8-3.6 8-8V72c0-4.4-3.6-8-8-8h-16V48c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8z"
        }
    ]
};

const FasUserPen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasUserPen",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 256a128 128 0 1 0 0-256 128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3 0 498.7 13.3 512 29.7 512h293.1c-3.1-8.8-3.7-18.4-1.4-27.8l15-60.1c2.8-11.3 8.6-21.5 16.8-29.7l40.3-40.3c-32.1-31-75.7-50.1-123.9-50.1h-91.3zm435.5-68.3c-15.6-15.6-40.9-15.6-56.6 0l-29.4 29.4 71 71 29.4-29.4c15.6-15.6 15.6-40.9 0-56.6l-14.4-14.4zM375.9 417c-4.1 4.1-7 9.2-8.4 14.9l-15 60.1c-1.4 5.5.2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l60.1-15c5.6-1.4 10.8-4.3 14.9-8.4l129.2-129.3-71-71L375.9 417z"
        }
    ]
};

const FasUserPilotTie = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasUserPilotTie",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M230.1.8c-4-1.1-8.2-1.1-12.2 0l-152 40c-8.6 2.3-15.3 9.1-17.3 17.8s1 17.8 7.8 23.6L80 102.5v8.4c0 10.7 5.3 20.8 15.1 25.2 24.1 10.8 68.6 24 128.9 24s104.8-13.2 128.9-24c9.8-4.4 15.1-14.5 15.1-25.2v-8.4l23.6-20.2c6.8-5.8 9.8-14.9 7.8-23.6s-8.7-15.6-17.3-17.8l-152-40zm-68.4 72c4-7.9 13.6-11.1 21.5-7.2L224 86.1l40.8-20.4c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5l-48 24c-4.5 2.3-9.8 2.3-14.3 0l-48-24c-7.9-4-11.1-13.6-7.2-21.5zm-63.6 96c-1.4 7.5-2.1 15.3-2.1 23.2 0 70.7 57.3 128 128 128s128-57.3 128-128c0-7.9-.7-15.7-2.1-23.2-39.1 15-81.5 23.2-125.9 23.2s-86.8-8.2-125.9-23.2zm89.5 206.3L208 416l-12.2 48.9L133 360.3c-3-5-8.6-8.1-14.4-7.4C51.8 360.8 0 417.5 0 486.4 0 500.5 11.5 512 25.6 512h396.8c14.1 0 25.6-11.5 25.6-25.6 0-68.9-51.8-125.6-118.6-133.5-5.8-.7-11.4 2.4-14.4 7.4l-62.8 104.6L240 416l20.4-40.8c5.3-10.6-2.4-23.2-14.3-23.2h-44.2c-11.9 0-19.6 12.5-14.3 23.2zM320 432c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16z"
        }
    ]
};

const FasUserPilot = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasUserPilot",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M230.1.8c-4-1.1-8.2-1.1-12.2 0l-152 40c-8.6 2.3-15.3 9.1-17.3 17.8s1 17.8 7.8 23.6L80 102.5v8.4c0 10.7 5.3 20.8 15.1 25.2 24.1 10.8 68.6 24 128.9 24s104.8-13.2 128.9-24c9.8-4.4 15.1-14.5 15.1-25.2v-8.4l23.6-20.2c6.8-5.8 9.8-14.9 7.8-23.6s-8.7-15.6-17.3-17.8l-152-40zm-68.4 72c4-7.9 13.6-11.1 21.5-7.2L224 86.1l40.8-20.4c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5l-48 24c-4.5 2.3-9.8 2.3-14.3 0l-48-24c-7.9-4-11.1-13.6-7.2-21.5zm-63.6 96c-1.4 7.5-2.1 15.3-2.1 23.2 0 70.7 57.3 128 128 128s128-57.3 128-128c0-7.9-.7-15.7-2.1-23.2-39.1 15-81.5 23.2-125.9 23.2s-86.8-8.2-125.9-23.2zm116.3 240-72.3-54.2c-2.2-1.7-4.9-2.6-7.7-2.6C60.2 352 0 412.2 0 486.4 0 500.5 11.5 512 25.6 512h396.8c14.1 0 25.6-11.5 25.6-25.6 0-74.2-60.2-134.4-134.4-134.4-2.8 0-5.5.9-7.7 2.6l-72.3 54.2a15.9 15.9 0 0 1-19.2 0zM336 416h32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FasUserPlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasUserPlus",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 128a128 128 0 1 1 256 0 128 128 0 1 1-256 0zM0 482.3C0 383.8 79.8 304 178.3 304h91.4c98.5 0 178.3 79.8 178.3 178.3 0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM504 312v-64h-64c-13.3 0-24-10.7-24-24s10.7-24 24-24h64v-64c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24h-64v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"
        }
    ]
};

const FasUserPoliceTie = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasUserPoliceTie",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M230.1.8c-4-1.1-8.2-1.1-12.2 0l-152 40c-8.6 2.3-15.3 9.1-17.3 17.8s1 17.8 7.8 23.6L80 102.5v8.4c0 10.7 5.3 20.8 15.1 25.2 24.1 10.8 68.6 24 128.9 24s104.8-13.2 128.9-24c9.8-4.4 15.1-14.5 15.1-25.2v-8.4l23.6-20.2c6.8-5.8 9.8-14.9 7.8-23.6s-8.7-15.6-17.3-17.8l-152-40zM227 48.6l32 12.8c3 1.2 5 4.2 5 7.4 0 17.2-7 46.1-36.9 58.6-2 .8-4.2.8-6.2 0C191 114.9 184 86 184 68.8c0-3.3 2-6.2 5-7.4l32-12.8c1.9-.8 4-.8 5.9 0zM98.1 168.8c-1.4 7.5-2.1 15.3-2.1 23.2 0 70.7 57.3 128 128 128s128-57.3 128-128c0-7.9-.7-15.7-2.1-23.2-39.1 15-81.5 23.2-125.9 23.2s-86.8-8.2-125.9-23.2zm89.5 206.3L208 416l-12.2 48.9L133 360.3c-3-5-8.6-8.1-14.4-7.4C51.8 360.8 0 417.5 0 486.4 0 500.5 11.5 512 25.6 512h396.8c14.1 0 25.6-11.5 25.6-25.6 0-68.9-51.8-125.6-118.6-133.5-5.8-.7-11.4 2.4-14.4 7.4l-62.8 104.6L240 416l20.4-40.8c5.3-10.6-2.4-23.2-14.3-23.2h-44.2c-11.9 0-19.6 12.5-14.3 23.2zm172 38.4 5.4 16.6h17.4c3.5 0 6.6 2.2 7.6 5.5s-.1 6.9-2.9 9L373 454.8l5.4 16.6c1.1 3.3-.1 6.9-2.9 9s-6.6 2-9.4 0L352 470.1l-14.1 10.3c-2.8 2-6.6 2.1-9.4 0s-4-5.7-2.9-9l5.4-16.6-14.1-10.2c-2.8-2-4-5.7-2.9-9s4.2-5.5 7.6-5.5H339l5.4-16.6c1.1-3.3 4.1-5.5 7.6-5.5s6.5 2.2 7.6 5.5z"
        }
    ]
};

const FasUserPolice = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasUserPolice",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m230.1.8 152 40c8.6 2.3 15.3 9.1 17.3 17.8s-1 17.8-7.8 23.6L368 102.5v8.4c0 10.7-5.3 20.8-15.1 25.2-24.1 10.8-68.6 24-128.9 24s-104.8-13.2-128.9-24c-9.8-4.4-15.1-14.5-15.1-25.2v-8.4L56.4 82.2c-6.8-5.8-9.8-14.9-7.8-23.6S57.3 43 65.9 40.8l152-40c4-1.1 8.2-1.1 12.2 0zM227 48.6c-1.9-.8-4-.8-5.9 0L189 61.4c-3 1.2-5 4.2-5 7.4 0 17.2 7 46.1 36.9 58.6 2 .8 4.2.8 6.2 0C257 114.9 264 86 264 68.8c0-3.3-2-6.2-5-7.4l-32-12.8zM98.1 168.8c39.1 15 81.5 23.2 125.9 23.2s86.8-8.2 125.9-23.2c1.4 7.5 2.1 15.3 2.1 23.2 0 70.7-57.3 128-128 128S96 262.7 96 192c0-7.9.7-15.7 2.1-23.2zM134.4 352c2.8 0 5.5.9 7.7 2.6l72.3 54.2a15.9 15.9 0 0 0 19.2 0l72.3-54.2c2.2-1.7 4.9-2.6 7.7-2.6 74.2 0 134.4 60.2 134.4 134.4 0 14.1-11.5 25.6-25.6 25.6H25.6C11.5 512 0 500.5 0 486.4 0 412.2 60.2 352 134.4 352zM352 408c-3.5 0-6.5 2.2-7.6 5.5l-5.4 16.7h-17.4c-3.5 0-6.6 2.2-7.6 5.5s.1 6.9 2.9 9l14.1 10.1-5.4 16.6c-1.1 3.3.1 6.9 2.9 9s6.6 2 9.4 0l14.1-10.3 14.1 10.3c2.8 2 6.6 2.1 9.4 0s4-5.7 2.9-9l-5.4-16.6 14.1-10.2c2.8-2 4-5.7 2.9-9s-4.2-5.5-7.6-5.5H365l-5.4-16.6c-1.1-3.3-4.1-5.5-7.6-5.5z"
        }
    ]
};

const FasUserRobotXmarks = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasUserRobotXmarks",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 0c8.8 0 16 7.2 16 16v48h64c35.3 0 64 28.7 64 64v128c0 35.3-28.7 64-64 64H144c-35.3 0-64-28.7-64-64V128c0-35.3 28.7-64 64-64h64V16c0-8.8 7.2-16 16-16zM16 144c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16v-96zm400-16c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16v-96c0-8.8 7.2-16 16-16zM160 240a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm48 16a16 16 0 1 0 32 0 16 16 0 1 0-32 0zm80-16a16 16 0 1 0 0 32 16 16 0 1 0 0-32zM96 352h256c53 0 96 43 96 96v32c0 17.7-14.3 32-32 32h-64v-64c0-17.7-14.3-32-32-32H128c-17.7 0-32 14.3-32 32v64H32c-17.7 0-32-14.3-32-32v-32c0-53 43-96 96-96zm80 112v48h-32v-48c0-8.8 7.2-16 16-16s16 7.2 16 16zm48-16c8.8 0 16 7.2 16 16v48h-32v-48c0-8.8 7.2-16 16-16zm80 16v48h-32v-48c0-8.8 7.2-16 16-16s16 7.2 16 16zM119.5 119.5c-4.7 4.7-4.7 12.3 0 17L143 160l-23.5 23.5c-4.7 4.7-4.7 12.3 0 17s12.3 4.7 17 0L160 177l23.5 23.5c4.7 4.7 12.3 4.7 17 0s4.7-12.3 0-17L177 160l23.5-23.5c4.7-4.7 4.7-12.3 0-17s-12.3-4.7-17 0L160 143l-23.5-23.5c-4.7-4.7-12.3-4.7-17 0zm145 0c-4.7-4.7-12.3-4.7-17 0s-4.7 12.3 0 17L271 160l-23.5 23.5c-4.7 4.7-4.7 12.3 0 17s12.3 4.7 17 0L288 177l23.5 23.5c4.7 4.7 12.3 4.7 17 0s4.7-12.3 0-17L305 160l23.5-23.5c4.7-4.7 4.7-12.3 0-17s-12.3-4.7-17 0L288 143l-23.5-23.5z"
        }
    ]
};

const FasUserRobot = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasUserRobot",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 0c8.8 0 16 7.2 16 16v48h64c35.3 0 64 28.7 64 64v128c0 35.3-28.7 64-64 64H144c-35.3 0-64-28.7-64-64V128c0-35.3 28.7-64 64-64h64V16c0-8.8 7.2-16 16-16zM16 144c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16v-96zm400-16c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16v-96c0-8.8 7.2-16 16-16zm-256 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160-32a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm-160 80a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm48 16a16 16 0 1 0 32 0 16 16 0 1 0-32 0zm80-16a16 16 0 1 0 0 32 16 16 0 1 0 0-32zM96 352h256c53 0 96 43 96 96v32c0 17.7-14.3 32-32 32h-64v-64c0-17.7-14.3-32-32-32H128c-17.7 0-32 14.3-32 32v64H32c-17.7 0-32-14.3-32-32v-32c0-53 43-96 96-96zm80 112v48h-32v-48c0-8.8 7.2-16 16-16s16 7.2 16 16zm48-16c8.8 0 16 7.2 16 16v48h-32v-48c0-8.8 7.2-16 16-16zm80 16v48h-32v-48c0-8.8 7.2-16 16-16s16 7.2 16 16z"
        }
    ]
};

const FasUserSecret = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasUserSecret",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 16c-6.7 0-10.8-2.8-15.5-6.1C201.9 5.4 194 0 176 0c-30.5 0-52 43.7-66 89.4-47.3 8.7-78 22.8-78 38.6 0 14.3 25 27.1 64.6 35.9-.4 4-.6 8-.6 12.1 0 17 3.3 33.2 9.3 48H45.4C38 224 32 230 32 237.4c0 1.7.3 3.4 1 5l38.8 96.9C28.2 371.8 0 423.8 0 482.3 0 498.7 13.3 512 29.7 512h388.6c16.4 0 29.7-13.3 29.7-29.7 0-58.5-28.2-110.4-71.7-143l38.7-96.9c.6-1.6 1-3.3 1-5 0-7.4-6-13.4-13.4-13.4h-59.9c6-14.8 9.3-31 9.3-48 0-4.1-.2-8.1-.6-12.1C391 155.1 416 142.3 416 128c0-15.8-30.7-29.9-78-38.6C324 43.7 302.5 0 272 0c-18 0-25.9 5.4-32.5 9.9-4.8 3.3-8.8 6.1-15.5 6.1zm56 208h-12.4c-16.5 0-31.1-10.6-36.3-26.2-2.3-7-12.2-7-14.5 0-5.2 15.6-19.9 26.2-36.3 26.2H168c-22.1 0-40-17.9-40-40v-14.4c28.2 4.1 61 6.4 96 6.4s67.8-2.3 96-6.4V184c0 22.1-17.9 40-40 40zm-88 96 16 32-32 128-48-192 64 32zm128-32-48 192-32-128 16-32 64-32z"
        }
    ]
};

const FasUserShakespeare = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasUserShakespeare",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 48c-44.2 0-80 35.8-80 80v32c0 40.1 29.5 73.3 68 79.1V224c0-6.6 5.4-12 12-12s12 5.4 12 12v15.1c38.5-5.8 68-39 68-79.1v-32c0-44.2-35.8-80-80-80zM96 128C96 57.3 153.3 0 224 0s128 57.3 128 128v23.2c0 10.9 3.7 21.5 10.5 30l11.1 13.8c6.7 8.4 10.4 18.8 10.4 29.6 0 26.2-21.2 47.4-47.4 47.4H286c-18.4 10.2-39.5 16-62 16s-43.6-5.8-62-16h-50.6C85.2 272 64 250.8 64 224.6c0-10.8 3.7-21.2 10.4-29.6l11.1-13.9c6.8-8.5 10.5-19.1 10.5-30V128zm96-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm-7.5 39.5c2 2 6 5.3 10.7 8.1 4.9 2.9 9.4 4.4 12.8 4.4 6.6 0 12 5.4 12 12s-5.4 12-12 12c-9.5 0-18.3-3.8-24.8-7.6-2.5-1.5-4.9-3.1-7.1-4.6C211.6 201 199 204 192 204c-6.6 0-12-5.4-12-12s5.4-12 12-12c2.1 0 12.9-1.9 23.5-12.5 4.7-4.7 12.3-4.7 17 0zM272 304c23.9 0 45.8 8.8 62.6 23.2 65.7 20.4 113.4 81.7 113.4 154 0 17-13.8 30.7-30.7 30.7H240c0-8.8-7.2-16-16-16s-16 7.2-16 16H30.7C13.8 512 0 498.2 0 481.3c0-72.4 47.7-133.6 113.4-154 16.8-14.5 38.7-23.3 62.6-23.3h96zm-64 144a16 16 0 1 0 32 0 16 16 0 1 0-32 0zm-80-48c26.4-10.6 54.6-16 83.1-16h25.8c28.5 0 56.7 5.4 83.1 16 0-26.5-21.5-48-48-48h-96c-26.5 0-48 21.5-48 48z"
        }
    ]
};

const FasUserShield = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasUserShield",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 256a128 128 0 1 0 0-256 128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3 0 498.7 13.3 512 29.7 512h388.6c1.8 0 3.5-.2 5.3-.5-76.3-55.1-99.8-141-103.1-200.2-16.1-4.8-33.1-7.3-50.7-7.3h-91.5zm308.8-78.3-120 48C358 277.4 352 286.2 352 296c0 63.3 25.9 168.8 134.8 214.2 5.9 2.5 12.6 2.5 18.5 0C614.1 464.8 640 359.3 640 296c0-9.8-6-18.6-15.1-22.3l-120-48c-5.7-2.3-12.1-2.3-17.8 0zM591.4 312c-3.9 50.7-27.2 116.7-95.4 149.7V273.8l95.4 38.2z"
        }
    ]
};

const FasUserSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasUserSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L353.3 251.6C407.9 237 448 187.2 448 128 448 57.3 390.7 0 320 0c-69.8 0-126.5 55.8-128 125.2L38.8 5.1zm225.5 299.2C170.5 309.4 96 387.2 96 482.3c0 16.4 13.3 29.7 29.7 29.7h388.6c3.9 0 7.6-.7 11-2.1l-261-205.6z"
        }
    ]
};

const FasUserTag = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasUserTag",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 256a128 128 0 1 0 0-256 128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3 0 498.7 13.3 512 29.7 512h388.6c10 0 18.8-4.9 24.2-12.5l-99.2-99.2c-14.9-14.9-23.3-35.1-23.3-56.1v-33c-15.9-4.7-32.8-7.2-50.3-7.2h-91.4zM384 224c-17.7 0-32 14.3-32 32v82.7c0 17 6.7 33.3 18.7 45.3l107.4 107.3c18.7 18.7 49.1 18.7 67.9 0l73.4-73.4c18.7-18.7 18.7-49.1 0-67.9L512 242.7c-12-12-28.3-18.7-45.3-18.7H384zm24 80a24 24 0 1 1 48 0 24 24 0 1 1-48 0z"
        }
    ]
};

const FasUserTieHairLong = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasUserTieHairLong",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M304 144c0 44.2-35.8 80-80 80s-80-35.8-80-80v-16c0-5.5.6-10.8 1.6-16H176c29.8 0 55.9-16.3 69.6-40.5C257.3 86.4 275.5 96 296 96h1.3c4.3 9.8 6.7 20.6 6.7 32v16zM224 0C153.3 0 96 57.3 96 128v11c0 33.9-13.5 66.5-37.5 90.5l-3.9 3.9c-4.2 4.2-6.6 10-6.6 16 0 12.5 10.1 22.6 22.6 22.6h306.8c12.5 0 22.6-10.1 22.6-22.6 0-6-2.4-11.8-6.6-16l-3.9-3.9c-24-24-37.5-56.6-37.5-90.5v-11C352 57.3 294.7 0 224 0zm55.7 510.9c1.8.7 3.8 1.1 5.8 1.1h131.8c17 0 30.7-13.8 30.7-30.7 0-75.5-51.9-138.9-121.9-156.4-8.1-2-15.9 3.3-17.9 11.3l-36 146.9-33.3-123.9 18.6-31c6.4-10.7-1.3-24.2-13.7-24.2h-39.5c-12.4 0-20.1 13.6-13.7 24.2l18.6 31-33.4 123.9-36-146.9c-2-8.1-9.8-13.4-17.9-11.3C51.9 342.4 0 405.8 0 481.3c0 17 13.8 30.7 30.7 30.7h131.8c2.1 0 4-.4 5.8-1.1l-.3 1.1h112l-.3-1.1z"
        }
    ]
};

const FasUserTieHair = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasUserTieHair",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M304 144c0 44.2-35.8 80-80 80s-80-35.8-80-80v-16c0-5.5.6-10.8 1.6-16H176c29.8 0 55.9-16.3 69.6-40.5C257.3 86.4 275.5 96 296 96h1.3c4.3 9.8 6.7 20.6 6.7 32v16zM224 0C153.3 0 96 57.3 96 128v16c0 70.7 57.3 128 128 128s128-57.3 128-128v-16C352 57.3 294.7 0 224 0zm55.7 510.9c1.8.7 3.8 1.1 5.8 1.1h131.8c17 0 30.7-13.8 30.7-30.7 0-75.5-51.9-138.9-121.9-156.4-8.1-2-15.9 3.3-17.9 11.3l-36 146.9-33.3-123.9 18.6-31c6.4-10.7-1.3-24.2-13.7-24.2h-39.5c-12.4 0-20.1 13.6-13.7 24.2l18.6 31-33.4 123.9-36-146.9c-2-8.1-9.8-13.4-17.9-11.3C51.9 342.4 0 405.8 0 481.3c0 17 13.8 30.7 30.7 30.7h131.8c2.1 0 4-.4 5.8-1.1l-.3 1.1h112l-.3-1.1z"
        }
    ]
};

const FasUserTie = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasUserTie",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 256a128 128 0 1 1 0-256 128 128 0 1 1 0 256zm-14.9 103.2-18.6-31c-6.4-10.7 1.3-24.2 13.7-24.2h39.5c12.4 0 20.1 13.6 13.7 24.2l-18.6 31 33.4 123.9 36-146.9c2-8.1 9.8-13.4 17.9-11.3 70.1 17.6 121.9 81 121.9 156.4 0 17-13.8 30.7-30.7 30.7H285.5c-2.1 0-4-.4-5.8-1.1l.3 1.1H168l.3-1.1c-1.8.7-3.8 1.1-5.8 1.1H30.7C13.8 512 0 498.2 0 481.3c0-75.5 51.9-138.9 121.9-156.4 8.1-2 15.9 3.3 17.9 11.3l36 146.9 33.4-123.9z"
        }
    ]
};

const FasUserUnlock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasUserUnlock",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 128a128 128 0 1 1 256 0 128 128 0 1 1-256 0zM0 482.3C0 383.8 79.8 304 178.3 304h91.4c43.6 0 83.6 15.7 114.6 41.7-.2 2.1-.3 4.2-.3 6.3v128c0 11.7 3.1 22.6 8.6 32H29.7C13.3 512 0 498.7 0 482.3zM496 272v48h112c17.7 0 32 14.3 32 32v128c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32v-48c0-44.2 35.8-80 80-80s80 35.8 80 80h-48c0-17.7-14.3-32-32-32s-32 14.3-32 32z"
        }
    ]
};

const FasUserVisor = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasUserVisor",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M343 175.2c-18.8 47.3-65 80.8-119 80.8s-100.2-33.5-119-80.8c-14.3-3.2-25-16-25-31.2V80c0-17.7 14.3-32 32-32h12.1C147.5 18.7 183.6 0 224 0s76.5 18.7 99.9 48H336c17.7 0 32 14.3 32 32v64c0 15.3-10.7 28-25 31.2zM0 482.3C0 383.8 79.8 304 178.3 304h91.4c98.5 0 178.3 79.8 178.3 178.3 0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zm348.7-19.9c2.4 3.2 7.3 1.4 7.3-2.5-1.1-35.3-11.3-65.6-30.1-90.2-1.2-2-4.6-1.9-6.1-.1-19.9 23-31.9 53-35.8 89.5-.3 3.5 3.7 5.5 6.5 3.5 1.8-1.4 4.1-3.4 6.6-5.6 9.2-8.1 22.3-19.5 31.7-19.5 2.3 2 7.6 7.8 19.9 25zM144 96c-8.8 0-16 7.2-16 16s7.2 16 16 16h160c8.8 0 16-7.2 16-16s-7.2-16-16-16H144z"
        }
    ]
};

const FasUserVneckHairLong = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasUserVneckHairLong",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M304 128c0-11.4-2.4-22.2-6.7-32H296c-20.5 0-38.7-9.6-50.4-24.5C231.9 95.7 205.8 112 176 112h-30.4c-1 5.2-1.6 10.5-1.6 16v16c0 44.2 35.8 80 80 80s80-35.8 80-80v-16zm-208 0C96 57.3 153.3 0 224 0s128 57.3 128 128v11c0 33.9 13.5 66.5 37.5 90.5l3.9 3.9c4.2 4.2 6.6 10 6.6 16 0 12.5-10.1 22.6-22.6 22.6H70.6C58.1 272 48 261.9 48 249.4c0-6 2.4-11.8 6.6-16l3.9-3.9c24-24 37.5-56.6 37.5-90.5v-11zm61.3 199.1 53.9 71.8c6.4 8.5 19.2 8.5 25.6 0l53.9-71.8c3.2-4.3 8.4-6.7 13.7-6.2 80.7 8.8 143.6 77.3 143.6 160.4 0 17-13.8 30.7-30.7 30.7H30.7C13.8 512 0 498.2 0 481.3 0 398.2 62.9 329.7 143.7 321c5.3-.6 10.5 1.9 13.7 6.2z"
        }
    ]
};

const FasUserVneckHair = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasUserVneckHair",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M304 128v16c0 44.2-35.8 80-80 80s-80-35.8-80-80v-16c0-5.5.6-10.8 1.6-16H176c29.8 0 55.9-16.3 69.6-40.5C257.3 86.4 275.5 96 296 96h1.3c4.3 9.8 6.7 20.6 6.7 32zm-208 0v16c0 70.7 57.3 128 128 128s128-57.3 128-128v-16C352 57.3 294.7 0 224 0S96 57.3 96 128zm61.3 199.1c-3.2-4.3-8.4-6.7-13.7-6.2C62.9 329.7 0 398.2 0 481.3c0 17 13.8 30.7 30.7 30.7h386.6c17 0 30.7-13.8 30.7-30.7 0-83.1-62.9-151.5-143.7-160.3-5.3-.6-10.5 1.9-13.7 6.2L236.7 399c-6.4 8.5-19.2 8.5-25.6 0l-53.9-71.8z"
        }
    ]
};

const FasUserVneck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasUserVneck",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 0a128 128 0 1 0 0 256 128 128 0 1 0 0-256zm-66.7 327.1c-3.2-4.3-8.4-6.7-13.7-6.2C62.9 329.7 0 398.2 0 481.3c0 17 13.8 30.7 30.7 30.7h386.6c17 0 30.7-13.8 30.7-30.7 0-83.1-62.9-151.5-143.7-160.3-5.3-.6-10.5 1.9-13.7 6.2L236.7 399c-6.4 8.5-19.2 8.5-25.6 0l-53.9-71.8z"
        }
    ]
};

const FasUserXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasUserXmark",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 128a128 128 0 1 1 256 0 128 128 0 1 1-256 0zM0 482.3C0 383.8 79.8 304 178.3 304h91.4c98.5 0 178.3 79.8 178.3 178.3 0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM471 143c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"
        }
    ]
};

const FasUser = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasUser",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 256a128 128 0 1 0 0-256 128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3 0 498.7 13.3 512 29.7 512h388.6c16.4 0 29.7-13.3 29.7-29.7 0-98.5-79.8-178.3-178.3-178.3h-91.4z"
        }
    ]
};

const FasUsersBetweenLines = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasUsersBetweenLines",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 24C0 10.7 10.7 0 24 0h592c13.3 0 24 10.7 24 24s-10.7 24-24 24H24C10.7 48 0 37.3 0 24zm0 464c0-13.3 10.7-24 24-24h592c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24zm83.2-328a64 64 0 1 1 128 0 64 64 0 1 1-128 0zM32 320c0-35.3 28.7-64 64-64h96c12.2 0 23.7 3.4 33.4 9.4-37.2 15.1-65.6 47.2-75.8 86.6H64c-17.7 0-32-14.3-32-32zm461.6 32c-10.3-40.1-39.6-72.6-77.7-87.4 9.4-5.5 20.4-8.6 32.1-8.6h96c35.3 0 64 28.7 64 64 0 17.7-14.3 32-32 32h-82.4zm-102.4-61.6c32.1 7.4 58.1 30.9 68.9 61.6 3.5 10 5.5 20.8 5.5 32 0 17.7-14.3 32-32 32h-224c-17.7 0-32-14.3-32-32 0-11.2 1.9-22 5.5-32 10.5-29.7 35.3-52.8 66.1-60.9 7.8-2.1 16-3.1 24.5-3.1h96c7.4 0 14.7.8 21.6 2.4zm44-130.4a64 64 0 1 1 128 0 64 64 0 1 1-128 0zM321.6 96a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"
        }
    ]
};

const FasUsersGear = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasUsersGear",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 160a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm368 0a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM0 298.7C0 310.4 9.6 320 21.3 320h214.1c-26.6-23.5-43.3-57.8-43.3-96 0-7.6.7-15 1.9-22.3-13.6-6.3-28.7-9.7-44.6-9.7h-42.7C47.8 192 0 239.8 0 298.7zM320 320c24 0 45.9-8.8 62.7-23.3 2.5-3.7 5.2-7.3 8-10.7 2.7-3.3 5.7-6.1 9-8.3C410 262.3 416 243.9 416 224c0-53-43-96-96-96s-96 43-96 96 43 96 96 96zm65.4 60.2c-10.3-5.9-18.1-16.2-20.8-28.2H261.3C187.7 352 128 411.7 128 485.3c0 14.7 11.9 26.7 26.7 26.7h300.5c-2.1-5.2-3.2-10.9-3.2-16.4v-3c-1.3-.7-2.7-1.5-4-2.3l-2.6 1.5c-16.8 9.7-40.5 8-54.7-9.7-4.5-5.6-8.6-11.5-12.4-17.6l-.1-.2-.1-.2-2.4-4.1-.1-.2-.1-.2c-3.4-6.2-6.4-12.6-9-19.3-8.2-21.2 2.2-42.6 19-52.3l2.7-1.5v-4.6l-2.7-1.5zM533.3 192h-42.6c-15.9 0-31 3.5-44.6 9.7 1.3 7.2 1.9 14.7 1.9 22.3 0 17.4-3.5 33.9-9.7 49 2.5.9 4.9 2 7.1 3.3l2.6 1.5c1.3-.8 2.6-1.6 4-2.3v-3c0-19.4 13.3-39.1 35.8-42.6 7.9-1.2 16-1.9 24.2-1.9s16.3.6 24.2 1.9c22.5 3.5 35.8 23.2 35.8 42.6v3c1.3.7 2.7 1.5 4 2.3l2.6-1.5c16.8-9.7 40.5-8 54.7 9.7 2.3 2.8 4.5 5.8 6.6 8.7-2.1-57.1-49-102.7-106.6-102.7zm91.3 163.9c6.3-3.6 9.5-11.1 6.8-18-2.1-5.5-4.6-10.8-7.4-15.9l-2.3-4c-3.1-5.1-6.5-9.9-10.2-14.5-4.6-5.7-12.7-6.7-19-3L574.4 311c-8.9-7.6-19.1-13.6-30.4-17.6v-21c0-7.3-4.9-13.8-12.1-14.9-6.5-1-13.1-1.5-19.9-1.5s-13.4.5-19.9 1.5c-7.2 1.1-12.1 7.6-12.1 14.9v21c-11.2 4-21.5 10-30.4 17.6l-18.2-10.5c-6.3-3.6-14.4-2.6-19 3-3.7 4.6-7.1 9.5-10.2 14.6l-2.3 3.9c-2.8 5.1-5.3 10.4-7.4 15.9-2.6 6.8.5 14.3 6.8 17.9l18.2 10.5c-1 5.7-1.6 11.6-1.6 17.6s.6 11.9 1.6 17.5l-18.2 10.5c-6.3 3.6-9.5 11.1-6.8 17.9 2.1 5.5 4.6 10.7 7.4 15.8l2.4 4.1c3 5.1 6.4 9.9 10.1 14.5 4.6 5.7 12.7 6.7 19 3l18.2-10.2c8.9 7.6 19.2 13.6 30.4 17.6v21c0 7.3 4.9 13.8 12.1 14.9 6.5 1 13.1 1.5 19.9 1.5s13.4-.5 19.9-1.5c7.2-1.1 12.1-7.6 12.1-14.9v-21c11.2-4 21.5-10 30.4-17.6l18.2 10.5c6.3 3.6 14.4 2.6 19-3 3.7-4.6 7.1-9.4 10.1-14.5l2.4-4.2c2.8-5.1 5.3-10.3 7.4-15.8 2.6-6.8-.5-14.3-6.8-17.9l-18.2-10.5c1-5.7 1.6-11.6 1.6-17.5s-.6-11.9-1.6-17.6l18.2-10.5zM472 384a40 40 0 1 1 80 0 40 40 0 1 1-80 0z"
        }
    ]
};

const FasUsersLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasUsersLine",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M211.2 96a64 64 0 1 0-128 0 64 64 0 1 0 128 0zM32 256c0 17.7 14.3 32 32 32h85.6c10.1-39.4 38.6-71.5 75.8-86.6-9.7-6-21.2-9.4-33.4-9.4H96c-35.3 0-64 28.7-64 64zm461.6 32H576c17.7 0 32-14.3 32-32 0-35.3-28.7-64-64-64h-96c-11.7 0-22.7 3.1-32.1 8.6 38.1 14.8 67.4 47.3 77.7 87.4zm-102.4-61.6c-6.9-1.6-14.2-2.4-21.6-2.4h-96c-8.5 0-16.7 1.1-24.5 3.1-30.8 8.1-55.6 31.1-66.1 60.9-3.5 10-5.5 20.8-5.5 32 0 17.7 14.3 32 32 32h224c17.7 0 32-14.3 32-32 0-11.2-1.9-22-5.5-32-10.8-30.7-36.8-54.2-68.9-61.6zM563.2 96a64 64 0 1 0-128 0 64 64 0 1 0 128 0zm-241.6 96a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32h576c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"
        }
    ]
};

const FasUsersMedical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasUsersMedical",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 160a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm368 0a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM0 298.7C0 310.4 9.6 320 21.3 320h214.1c-26.6-23.5-43.3-57.8-43.3-96 0-7.6.7-15 1.9-22.3-13.6-6.3-28.7-9.7-44.6-9.7h-42.7C47.8 192 0 239.8 0 298.7zM405.3 320h77.4c6.6-18.6 24.4-32 45.3-32h32c20.9 0 38.7 13.4 45.3 32h13.4c11.8 0 21.3-9.6 21.3-21.3 0-58.9-47.8-106.7-106.7-106.7h-42.6c-15.9 0-31 3.5-44.6 9.7 1.3 7.2 1.9 14.7 1.9 22.3 0 38.2-16.8 72.5-43.3 96h.7zm10.7 80c0-14.6 6.5-27.7 16.9-36.5-16.6-7.4-34.9-11.5-54.2-11.5H261.3C187.7 352 128 411.7 128 485.3c0 14.7 11.9 26.7 26.7 26.7h328c-1.8-5-2.7-10.4-2.7-16v-16h-16c-26.5 0-48-21.5-48-48v-32zm0-176a96 96 0 1 0-192 0 96 96 0 1 0 192 0zm96 112v48h-48c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-48h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-48v-48c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16z"
        }
    ]
};

const FasUsersRays = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasUsersRays",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M41 7C31.6-2.3 16.4-2.3 7 7s-9.3 24.6 0 34l72 72c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L41 7zm558 0-72 72c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9S608.3-2.4 599 7zM7 505c9.4 9.4 24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L7 471c-9.4 9.4-9.4 24.6 0 33.9zm592 0c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-72-72c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l72 72zM320 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-107.9 80c-2.7 7.5-4.1 15.6-4.1 24 0 13.3 10.7 24 24 24h176c13.3 0 24-10.7 24-24 0-8.4-1.4-16.5-4.1-24-.5-1.4-1-2.7-1.6-4-9.4-22.3-29.8-38.9-54.3-43-3.9-.7-7.9-1-12-1h-80c-4.1 0-8.1.3-12 1-.8.1-1.7.3-2.5.5-24.9 5.1-45.1 23-53.4 46.5zm-36.3-112a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-26.5 32c-29.4 0-53.3 23.9-53.3 53.3 0 14.7 11.9 26.7 26.7 26.7h56.1c8-34.1 32.8-61.7 65.2-73.6-7.5-4.1-16.2-6.4-25.3-6.4h-69.4zm368 80c14.7 0 26.7-11.9 26.7-26.7 0-29.5-23.9-53.3-53.3-53.3h-69.4c-9.2 0-17.8 2.3-25.3 6.4 32.4 11.9 57.2 39.5 65.2 73.6h56.1zM464 224a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
        }
    ]
};

const FasUsersRectangle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasUsersRectangle",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 0C43 0 0 43 0 96v320c0 53 43 96 96 96h448c53 0 96-43 96-96V96c0-53-43-96-96-96H96zM64 96c0-17.7 14.3-32 32-32h448c17.7 0 32 14.3 32 32v320c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V96zm159.8 80a48 48 0 1 0-96 0 48 48 0 1 0 96 0zM96 309.3c0 14.7 11.9 26.7 26.7 26.7h56.1c8-34.1 32.8-61.7 65.2-73.6-7.5-4.1-16.2-6.4-25.3-6.4h-69.4c-29.4 0-53.3 23.9-53.3 53.3zM461.2 336h56.1c14.7 0 26.7-11.9 26.7-26.7 0-29.5-23.9-53.3-53.3-53.3h-69.4c-9.2 0-17.8 2.3-25.3 6.4 32.4 11.9 57.2 39.5 65.2 73.6zM372 289c-3.9-.7-7.9-1-12-1h-80c-4.1 0-8.1.3-12 1-26 4.4-47.3 22.7-55.9 47-2.7 7.5-4.1 15.6-4.1 24 0 13.3 10.7 24 24 24h176c13.3 0 24-10.7 24-24 0-8.4-1.4-16.5-4.1-24-8.6-24.3-29.9-42.6-55.9-47zm140-113a48 48 0 1 0-96 0 48 48 0 1 0 96 0zm-192 80a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"
        }
    ]
};

const FasUsersSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasUsersSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L440.6 320h178.1c11.8 0 21.3-9.6 21.3-21.3 0-58.9-47.8-106.7-106.7-106.7h-42.6c-15.9 0-31 3.5-44.6 9.7 1.3 7.2 1.9 14.7 1.9 22.3 0 30.2-10.5 58-28 79.9l-25.2-19.7c13.3-16.5 21.2-37.4 21.2-60.2 0-53-43-96-96-96-31.1 0-58.7 14.8-76.3 37.7l-40.6-31.8c13-14.2 20.9-33.1 20.9-53.9 0-44.2-35.8-80-80-80-27.7 0-52.1 14.1-66.5 35.5L38.8 5.1zM106.7 192C47.8 192 0 239.8 0 298.7 0 310.4 9.6 320 21.3 320h214.1c-20.6-18.2-35.2-42.8-40.8-70.8L121.8 192h-15.1zm154.6 160C187.7 352 128 411.7 128 485.3c0 14.7 11.9 26.7 26.7 26.7h330.6c10.5 0 19.5-6 23.9-14.8L324.9 352h-63.6zM512 160a80 80 0 1 0 0-160 80 80 0 1 0 0 160z"
        }
    ]
};

const FasUsersViewfinder = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasUsersViewfinder",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 48h88c13.3 0 24-10.7 24-24S149.3 0 136 0H32C14.3 0 0 14.3 0 32v104c0 13.3 10.7 24 24 24s24-10.7 24-24V48zm127.8 176a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-26.5 32c-29.4 0-53.3 23.9-53.3 53.3 0 14.7 11.9 26.7 26.7 26.7h56.1c8-34.1 32.8-61.7 65.2-73.6-7.5-4.1-16.2-6.4-25.3-6.4h-69.4zm368 80c14.7 0 26.7-11.9 26.7-26.7 0-29.5-23.9-53.3-53.3-53.3h-69.4c-9.2 0-17.8 2.3-25.3 6.4 32.4 11.9 57.2 39.5 65.2 73.6h56.1zm-89.4 0c-8.6-24.3-29.9-42.6-55.9-47-3.9-.7-7.9-1-12-1h-80c-4.1 0-8.1.3-12 1-26 4.4-47.3 22.7-55.9 47-2.7 7.5-4.1 15.6-4.1 24 0 13.3 10.7 24 24 24h176c13.3 0 24-10.7 24-24 0-8.4-1.4-16.5-4.1-24zM464 224a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-80-32a64 64 0 1 0-128 0 64 64 0 1 0 128 0zM504 48h88v88c0 13.3 10.7 24 24 24s24-10.7 24-24V32c0-17.7-14.3-32-32-32H504c-13.3 0-24 10.7-24 24s10.7 24 24 24zM48 464v-88c0-13.3-10.7-24-24-24S0 362.7 0 376v104c0 17.7 14.3 32 32 32h104c13.3 0 24-10.7 24-24s-10.7-24-24-24H48zm456 0c-13.3 0-24 10.7-24 24s10.7 24 24 24h104c17.7 0 32-14.3 32-32V376c0-13.3-10.7-24-24-24s-24 10.7-24 24v88h-88z"
        }
    ]
};

const FasUsers = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasUsers",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 0a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm368 0a80 80 0 1 1 0 160 80 80 0 1 1 0-160zM0 298.7C0 239.8 47.8 192 106.7 192h42.7c15.9 0 31 3.5 44.6 9.7-1.3 7.2-1.9 14.7-1.9 22.3 0 38.2 16.8 72.5 43.3 96H21.3C9.6 320 0 310.4 0 298.7zM405.3 320h-.7c26.6-23.5 43.3-57.8 43.3-96 0-7.6-.7-15-1.9-22.3 13.6-6.3 28.7-9.7 44.6-9.7h42.7c58.9 0 106.7 47.8 106.7 106.7 0 11.8-9.6 21.3-21.3 21.3H405.3zM224 224a96 96 0 1 1 192 0 96 96 0 1 1-192 0zm-96 261.3c0-73.6 59.7-133.3 133.3-133.3h117.4c73.6 0 133.3 59.7 133.3 133.3 0 14.7-11.9 26.7-26.7 26.7H154.7c-14.7 0-26.7-11.9-26.7-26.7z"
        }
    ]
};

const FasUtensilsSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasUtensilsSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-86.8-68V32c0-17.7-14.3-32-32-32-16 0-128 32-128 176v99.7l-77.6-60.8c8.6-13.6 13.6-29.7 13.6-47 0-6.4-.7-12.8-2.1-19.1L287.6 12.5c-1.8-8-9.3-13.3-17.4-12.4S256 7.8 256 16v134.2c0 5.4-4.4 9.8-9.8 9.8-5.1 0-9.3-3.9-9.8-9L223.9 14.6C223.2 6.3 216.3 0 208 0s-15.2 6.3-15.9 14.6l-9.4 103.3-22.7-17.8V16c0-8.2-6.1-15-14.3-15.9s-15.6 4.5-17.4 12.4L116.5 66 38.8 5.1zM176 255.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32V285.1L96.1 171.7c1.9 44.2 36.3 80 79.9 83.9z"
        }
    ]
};

const FasUtensils = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasUtensils",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M416 0c-16 0-128 32-128 176v112c0 35.3 28.7 64 64 64h32v128c0 17.7 14.3 32 32 32s32-14.3 32-32V32c0-17.7-14.3-32-32-32zM64 16C64 7.8 57.9 1 49.7.1S34.2 4.6 32.4 12.5L2.1 148.8C.7 155.1 0 161.5 0 167.9c0 45.9 35.1 83.6 80 87.7V480c0 17.7 14.3 32 32 32s32-14.3 32-32V255.6c44.9-4.1 80-41.8 80-87.7 0-6.4-.7-12.8-2.1-19.1L191.6 12.5c-1.8-8-9.3-13.3-17.4-12.4S160 7.8 160 16v134.2c0 5.4-4.4 9.8-9.8 9.8-5.1 0-9.3-3.9-9.8-9L127.9 14.6C127.2 6.3 120.3 0 112 0S96.8 6.3 96.1 14.6L83.7 151c-.5 5.1-4.7 9-9.8 9-5.4 0-9.8-4.4-9.8-9.8V16zm48.3 152h-.6l.3-.7.3.7z"
        }
    ]
};

const FasUtilityPoleDouble = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasUtilityPoleDouble",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 0c17.7 0 32 14.3 32 32v32h96v-8c0-13.3 10.7-24 24-24s24 10.7 24 24v8h32v-8c0-13.3 10.7-24 24-24s24 10.7 24 24v40c0 17.7-14.3 32-32 32h-51.2L288 221.9V256h96v-8c0-13.3 10.7-24 24-24s24 10.7 24 24v8h32v-8c0-13.3 10.7-24 24-24s24 10.7 24 24v40c0 17.7-14.3 32-32 32h-51.2L288 413.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32v-66.1L83.2 320H32c-17.7 0-32-14.3-32-32v-40c0-13.3 10.7-24 24-24s24 10.7 24 24v8h32v-8c0-13.3 10.7-24 24-24s24 10.7 24 24v8h96v-34.1L83.2 128H32c-17.7 0-32-14.3-32-32V56c0-13.3 10.7-24 24-24s24 10.7 24 24v8h32v-8c0-13.3 10.7-24 24-24s24 10.7 24 24v8h96V32c0-17.7 14.3-32 32-32zM140.8 128l83.2 55.4V128h-83.2zM288 183.4l83.2-55.4H288v55.4zM140.8 320l83.2 55.4V320h-83.2zM288 375.4l83.2-55.4H288v55.4z"
        }
    ]
};

const FasUtilityPole = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasUtilityPole",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 0c17.7 0 32 14.3 32 32v32h96v-8c0-13.3 10.7-24 24-24s24 10.7 24 24v8h32v-8c0-13.3 10.7-24 24-24s24 10.7 24 24v40c0 17.7-14.3 32-32 32h-51.2L288 221.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V221.9L83.2 128H32c-17.7 0-32-14.3-32-32V56c0-13.3 10.7-24 24-24s24 10.7 24 24v8h32v-8c0-13.3 10.7-24 24-24s24 10.7 24 24v8h96V32c0-17.7 14.3-32 32-32zM140.8 128l83.2 55.4V128h-83.2zM288 183.4l83.2-55.4H288v55.4z"
        }
    ]
};

const FasV = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasV",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M19.7 34.5c16.3-6.8 35 .9 41.8 17.2L192 364.8 322.5 51.7c6.8-16.3 25.5-24 41.8-17.2s24 25.5 17.2 41.8l-160 384c-5 11.9-16.6 19.7-29.5 19.7s-24.6-7.8-29.5-19.7l-160-384c-6.8-16.3.9-35 17.2-41.8z"
        }
    ]
};

const FasVacuumRobot = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasVacuumRobot",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm100.7-155.3c55.6-55.6 55.6-145.8 0-201.4s-145.8-55.6-201.4 0c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6c68.1-68.1 178.5-68.1 246.6 0s68.1 178.5 0 246.6c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6zm-144-144c6.2-6.2 16.4-6.2 22.6 0l64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6zm-80 16c6.2-6.2 16.4-6.2 22.6 0l128 128c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-128-128c-6.2-6.2-6.2-16.4 0-22.6zm-16 102.6c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-64-64z"
        }
    ]
};

const FasVacuum = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasVacuum",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M301.6 64H512c35.3 0 64 28.7 64 64 0 21.9-11 41.2-27.8 52.8-34.4-32.7-81-52.8-132.2-52.8-35.3 0-64 28.7-64 64v100c10.2-2.6 21-4 32-4 70.7 0 128 57.3 128 128 0 38.2-16.8 72.5-43.3 96H544c35.3 0 64-28.7 64-64V320c0-31.7-7.7-61.7-21.3-88C619 208.7 640 170.8 640 128 640 57.3 582.7 0 512 0H301.6c-60.3 0-112.5 42.2-125.2 101.2L150.1 224h65.5L239 114.6c6.4-29.5 32.4-50.6 62.6-50.6zm-92.9 192h-65.4L109 416H83.8c-33.8 0-64.7 18.9-80 49-2.4 4.5-3.8 9.6-3.8 15 0 17.7 14.3 32 32 32h144c26.5 0 48-21.5 48-48s-21.5-48-48-48h-1.6l34.3-160zM480 416a96 96 0 1 0-192 0 96 96 0 1 0 192 0zm-128 0a32 32 0 1 1 64 0 32 32 0 1 1-64 0z"
        }
    ]
};

const FasValueAbsolute = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasValueAbsolute",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 32C14.3 32 0 46.3 0 64v384c0 17.7 14.3 32 32 32s32-14.3 32-32V64c0-17.7-14.3-32-32-32zm150.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l73.4 73.3-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l73.4-73.4 73.4 73.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L301.3 256l73.4-73.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 210.7l-73.4-73.4zM512 64c0-17.7-14.3-32-32-32s-32 14.3-32 32v384c0 17.7 14.3 32 32 32s32-14.3 32-32V64z"
        }
    ]
};

const FasVanShuttle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasVanShuttle",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 104v88h96V96H72c-4.4 0-8 3.6-8 8zm482 88-80.9-96H384v96h162zm-226 0V96h-96v96h96zm272 192h-16c0 53-43 96-96 96s-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96H48c-26.5 0-48-21.5-48-48V104c0-39.8 32.2-72 72-72h393.1c18.9 0 36.8 8.3 49 22.8L625 186.5c9.7 11.5 15 26.1 15 41.2V336c0 26.5-21.5 48-48 48zm-64 0a48 48 0 1 0-96 0 48 48 0 1 0 96 0zm-368 48a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
        }
    ]
};

const FasVault = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasVault",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 0C28.7 0 0 28.7 0 64v352c0 35.3 28.7 64 64 64h16l16 32h64l16-32h224l16 32h64l16-32h16c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm160 320a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0-240a160 160 0 1 1 0 320 160 160 0 1 1 0-320zm256 141.3V336c0 8.8-7.2 16-16 16s-16-7.2-16-16V221.3c-18.6-6.6-32-24.4-32-45.3 0-26.5 21.5-48 48-48s48 21.5 48 48c0 20.9-13.4 38.7-32 45.3z"
        }
    ]
};

const FasVectorCircle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasVectorCircle",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 32c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v9.3c72.2 21.5 129.2 78.5 150.7 150.7h9.3c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32h-9.3c-21.5 72.2-78.5 129.2-150.7 150.7v9.3c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32v-9.3C119.8 449.2 62.8 392.2 41.3 320H32c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32h9.3C62.8 119.8 119.8 62.8 192 41.3V32zm211.7 162.4c-16.2-38.9-47.3-70-86.2-86.2-4.8 11.7-16.2 19.8-29.5 19.8h-64c-13.3 0-24.7-8.1-29.6-19.7-38.9 16.2-70 47.3-86.2 86.2 11.6 4.8 19.7 16.2 19.7 29.6v64c0 13.3-8.1 24.7-19.7 29.6 16.2 38.9 47.3 70 86.2 86.2 4.8-11.6 16.2-19.7 29.6-19.7h64c13.3 0 24.7 8.1 29.6 19.7 38.9-16.2 70-47.3 86.2-86.2-11.7-5-19.8-16.4-19.8-29.7v-64c0-13.3 8.1-24.7 19.7-29.6zM240 48v32h32V48h-32zm32 384h-32v32h32v-32zm160-192v32h32v-32h-32zm-352 0H48v32h32v-32z"
        }
    ]
};

const FasVectorPolygon = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasVectorPolygon",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 64c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32h192c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32h-31.7l-4.5 7.9-28.4 49.7c.4 2.1.6 4.2.6 6.4v64c0 2.2-.2 4.3-.6 6.4l28.4 49.7 4.5 7.9H416c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32H128c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32V160c-17.7 0-32-14.3-32-32V64zm322.2 308.3L292.3 320H256c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32h36.3l29.9-52.3c-1.4-3.6-2.2-7.5-2.2-11.7H128c0 17.7-14.3 32-32 32v192c17.7 0 32 14.3 32 32h192c0-4.1.8-8.1 2.2-11.7zM48 80v32h32V80H48zm320 0v32h32V80h-32zM80 400H48v32h32v-32zm288 0v32h32v-32h-32zm-64-160h-32v32h32v-32z"
        }
    ]
};

const FasVectorSquare = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasVectorSquare",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M368 80h32v32h-32V80zm-16-48c-17.7 0-32 14.3-32 32H128c0-17.7-14.3-32-32-32H32C14.3 32 0 46.3 0 64v64c0 17.7 14.3 32 32 32v192c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32h192c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32v-64c0-17.7-14.3-32-32-32V160c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32h-64zM96 160c17.7 0 32-14.3 32-32h192c0 17.7 14.3 32 32 32v192c-17.7 0-32 14.3-32 32H128c0-17.7-14.3-32-32-32V160zM48 400h32v32H48v-32zm320 32v-32h32v32h-32zM48 112V80h32v32H48z"
        }
    ]
};

const FasVentDamper = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasVentDamper",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 128c0-35.3 28.7-64 64-64h384c35.3 0 64 28.7 64 64v32h32c17.7 0 32 14.3 32 32v128c0 17.7-14.3 32-32 32h-32v32c0 35.3-28.7 64-64 64H128c-35.3 0-64-28.7-64-64v-32H32c-17.7 0-32-14.3-32-32V192c0-17.7 14.3-32 32-32h32v-32zm120 16c-13.3 0-24 10.7-24 24s10.7 24 24 24h272c13.3 0 24-10.7 24-24s-10.7-24-24-24H184zm0 88c-13.3 0-24 10.7-24 24s10.7 24 24 24h272c13.3 0 24-10.7 24-24s-10.7-24-24-24H184zm0 88c-13.3 0-24 10.7-24 24s10.7 24 24 24h272c13.3 0 24-10.7 24-24s-10.7-24-24-24H184z"
        }
    ]
};

const FasVenusDouble = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasVenusDouble",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 288a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm176-112c0 86.3-62.1 158.1-144 173.1V384h32c17.7 0 32 14.3 32 32s-14.3 32-32 32h-32v32c0 17.7-14.3 32-32 32s-32-14.3-32-32v-32h-32c-17.7 0-32-14.3-32-32s14.3-32 32-32h32v-34.9C78.1 334.1 16 262.3 16 176 16 78.8 94.8 0 192 0s176 78.8 176 176zm-24 142c14.6-15.6 26.8-33.4 36-53 18.8 14.4 42.4 23 68 23 61.9 0 112-50.1 112-112S509.9 64 448 64c-25.6 0-49.1 8.6-68 23-9.3-19.5-21.5-37.4-36-53 29.1-21.4 65.1-34 104-34 97.2 0 176 78.8 176 176 0 86.3-62.1 158.1-144 173.1V384h32c17.7 0 32 14.3 32 32s-14.3 32-32 32h-32v32c0 17.7-14.3 32-32 32s-32-14.3-32-32v-32h-32c-17.7 0-32-14.3-32-32s14.3-32 32-32h32v-34.9c-26.6-4.9-51.1-15.7-72-31.1z"
        }
    ]
};

const FasVenusMars = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasVenusMars",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 288a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm176-112c0 86.3-62.1 158.1-144 173.1V384h32c17.7 0 32 14.3 32 32s-14.3 32-32 32h-32v32c0 17.7-14.3 32-32 32s-32-14.3-32-32v-32h-32c-17.7 0-32-14.3-32-32s14.3-32 32-32h32v-34.9C62.1 334.1 0 262.3 0 176 0 78.8 78.8 0 176 0s176 78.8 176 176zm-80.1 184.6c19.3-10.1 36.9-23.1 52.1-38.4 20 18.5 46.7 29.8 76.1 29.8 61.9 0 112-50.1 112-112s-50.1-112-112-112c-7.2 0-14.3.7-21.1 2-4.9-21.5-13-41.7-24-60.2 14.3-3.8 29.4-5.8 45-5.8 37 0 71.4 11.4 99.8 31l20.6-20.6L487 41c-6.9-6.9-8.9-17.2-5.2-26.2S494.3 0 504 0h112c13.3 0 24 10.7 24 24v112c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-33.4-33.4-20.6 20.6c19.5 28.4 31 62.7 31 99.8 0 97.2-78.8 176-176 176-50.5 0-96-21.3-128.1-55.4z"
        }
    ]
};

const FasVenus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasVenus",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 176a112 112 0 1 1 224 0 112 112 0 1 1-224 0zm144 173.1c81.9-15 144-86.8 144-173.1C368 78.8 289.2 0 192 0S16 78.8 16 176c0 86.3 62.1 158.1 144 173.1V384h-32c-17.7 0-32 14.3-32 32s14.3 32 32 32h32v32c0 17.7 14.3 32 32 32s32-14.3 32-32v-32h32c17.7 0 32-14.3 32-32s-14.3-32-32-32h-32v-34.9z"
        }
    ]
};

const FasVestPatches = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasVestPatches",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m151.2 69.7 55.9 167.7-11 33.1c-2.7 8.2-4.1 16.7-4.1 25.3V464c0 14.5 3.9 28.2 10.7 39.9-7.7 5.1-16.8 8.1-26.7 8.1H48c-26.5 0-48-21.5-48-48V270.5c0-9.5 2.8-18.7 8.1-26.6L56 172.1c5.3-7.9 8.1-17.1 8.1-26.6V48C64 21.5 85.5 0 112 0h6.3c18.8 0 34.1 9.7 44.1 18.8C171.6 27.2 190.8 40 224 40s52.4-12.8 61.7-21.2C295.7 9.7 311 0 329.7 0h6.3c26.5 0 48 21.5 48 48v97.5c0 9.5 2.8 18.7 8.1 26.6l47.9 71.8c5.3 7.9 8.1 17.1 8.1 26.6V464c0 26.5-21.5 48-48 48H272c-26.5 0-48-21.5-48-48V295.8c0-5.2.8-10.3 2.5-15.2l70.3-210.9C279.4 79.7 255.4 88 224 88s-55.4-8.3-72.8-18.3zM96 456a40 40 0 1 0 0-80 40 40 0 1 0 0 80zM63.5 255.5c-4.7 4.7-4.7 12.3 0 17L79 288l-15.5 15.5c-4.7 4.7-4.7 12.3 0 17s12.3 4.7 17 0L96 305l15.5 15.5c4.7 4.7 12.3 4.7 17 0s4.7-12.3 0-17L113 288l15.5-15.5c4.7-4.7 4.7-12.3 0-17s-12.3-4.7-17 0L96 271l-15.5-15.5c-4.7-4.7-12.3-4.7-17 0zM304 280v40c0 8.8 7.2 16 16 16h40c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8v-8c0-13.3-10.7-24-24-24s-24 10.7-24 24z"
        }
    ]
};

const FasVest = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasVest",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M207.1 237.4 151.2 69.7C168.6 79.7 192.6 88 224 88s55.4-8.3 72.8-18.3l-70.3 210.9c-1.6 4.9-2.5 10-2.5 15.2V464c0 26.5 21.5 48 48 48h128c26.5 0 48-21.5 48-48V270.5c0-9.5-2.8-18.7-8.1-26.6L392 172.1c-5.3-7.9-8.1-17.1-8.1-26.6V48c0-26.5-21.5-48-48-48h-6.3c-18.6 0-33.9 9.7-43.9 18.8C276.4 27.2 257.2 40 224 40s-52.4-12.8-61.7-21.2C152.3 9.7 137 0 118.3 0H112C85.5 0 64 21.5 64 48v97.5c0 9.5-2.8 18.7-8.1 26.6L8.1 243.9C2.8 251.8 0 261.1 0 270.5V464c0 26.5 21.5 48 48 48h128c9.9 0 19-3 26.7-8.1-6.8-11.7-10.7-25.4-10.7-39.9V295.8c0-8.6 1.4-17.1 4.1-25.3l11-33.1zm140.2 119.3 48 48c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-48-48c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zm-294.6 48 48-48c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-48 48c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6z"
        }
    ]
};

const FasVialCircleCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasVialCircleCheck",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 64c0-17.7 14.3-32 32-32h192c17.7 0 32 14.3 32 32s-14.3 32-32 32v170.8c-20.2 28.6-32 63.5-32 101.2 0 25.2 5.3 49.1 14.8 70.8-17.3 24.9-46.2 41.2-78.8 41.2-53 0-96-43-96-96V96C14.3 96 0 81.7 0 64zm96 32v96h64V96H96zm128 272a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L352 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"
        }
    ]
};

const FasVialVirus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasVialVirus",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 32C14.3 32 0 46.3 0 64s14.3 32 32 32v288c0 53 43 96 96 96 28.6 0 54.2-12.5 71.8-32.3.1-14.2 5.6-28.3 16.4-39.1.2-.2.1-.6-.2-.6-30.9 0-56-25.1-56-56s25.1-56 56-56c.3 0 .4-.4.2-.6-21.9-21.9-21.9-57.3 0-79.2 2.4-2.4 5-4.6 7.8-6.5V96c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zm64 160V96h64v96H96zm120 184c28.8 0 43.2 34.8 22.9 55.2-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0c20.4-20.4 55.2-5.9 55.2 22.9 0 13.3 10.7 24 24 24s24-10.7 24-24c0-28.8 34.8-43.2 55.2-22.9 9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9c-20.3-20.4-5.9-55.2 22.9-55.2 13.3 0 24-10.7 24-24s-10.7-24-24-24c-28.8 0-43.2-34.8-22.9-55.2 9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0c-20.4 20.3-55.2 5.9-55.2-22.9 0-13.3-10.7-24-24-24s-24 10.7-24 24c0 28.8-34.8 43.2-55.2 22.9-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9c20.4 20.4 5.9 55.2-22.9 55.2-13.3 0-24 10.7-24 24s10.7 24 24 24zm104-88a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm40 96a24 24 0 1 1 48 0 24 24 0 1 1-48 0z"
        }
    ]
};

const FasVial = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasVial",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M342.6 9.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l9.4 9.4L28.1 342.6C10.1 360.6 0 385 0 410.5v5.5c0 53 43 96 96 96h5.5c25.5 0 49.9-10.1 67.9-28.1L448 205.3l9.4 9.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-32-32-96-96-32-32zM205.3 256 352 109.3l50.7 50.7-96 96H205.3z"
        }
    ]
};

const FasVials = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasVials",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 64c0-17.7 14.3-32 32-32h160c17.7 0 32 14.3 32 32s-14.3 32-32 32v304c0 44.2-35.8 80-80 80s-80-35.8-80-80V96C14.3 96 0 81.7 0 64zm136 32H88v160h48V96zm152-32c0-17.7 14.3-32 32-32h160c17.7 0 32 14.3 32 32s-14.3 32-32 32v304c0 44.2-35.8 80-80 80s-80-35.8-80-80V96c-17.7 0-32-14.3-32-32zm136 32h-48v160h48V96z"
        }
    ]
};

const FasVideoArrowDownLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasVideoArrowDownLeft",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64C28.7 64 0 92.7 0 128v256c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm512 64c0-11.8-6.5-22.6-16.9-28.2s-23-5-32.9 1.6l-96 64-14.2 9.5v162.2l14.2 9.5 96 64c9.8 6.5 22.4 7.2 32.9 1.6S576 395.8 576 384V128zM232 352H120c-13.3 0-24-10.7-24-24V216c0-13.3 10.7-24 24-24s24 10.7 24 24v54.1L247 167c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-103 103H232c13.3 0 24 10.7 24 24s-10.7 24-24 24z"
        }
    ]
};

const FasVideoArrowUpRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasVideoArrowUpRight",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64C28.7 64 0 92.7 0 128v256c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm512 64c0-11.8-6.5-22.6-16.9-28.2s-23-5-32.9 1.6l-96 64-14.2 9.5v162.2l14.2 9.5 96 64c9.8 6.5 22.4 7.2 32.9 1.6S576 395.8 576 384V128zm-424 32h112c13.3 0 24 10.7 24 24v112c0 13.3-10.7 24-24 24s-24-10.7-24-24v-54.1L137 345c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l103-103H152c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
        }
    ]
};

const FasVideoPlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasVideoPlus",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64C28.7 64 0 92.7 0 128v256c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm512 64c0-11.8-6.5-22.6-16.9-28.2s-23-5-32.9 1.6l-96 64-14.2 9.5v162.2l14.2 9.5 96 64c9.8 6.5 22.4 7.2 32.9 1.6S576 395.8 576 384V128zm-360 56v48h48c13.3 0 24 10.7 24 24s-10.7 24-24 24h-48v48c0 13.3-10.7 24-24 24s-24-10.7-24-24v-48h-48c-13.3 0-24-10.7-24-24s10.7-24 24-24h48v-48c0-13.3 10.7-24 24-24s24 10.7 24 24z"
        }
    ]
};

const FasVideoSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasVideoSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-86.4-67.7 13.8 9.2c9.8 6.5 22.4 7.2 32.9 1.6S608 395.8 608 384V128c0-11.8-6.5-22.6-16.9-28.2s-23-5-32.9 1.6l-96 64-14.2 9.5v150.9l-32-25.1V128c0-35.3-28.7-64-64-64H113.9L38.8 5.1zM407 416.7 32.3 121.5c-.2 2.1-.3 4.3-.3 6.5v256c0 35.3 28.7 64 64 64h256c23.4 0 43.9-12.6 55-31.3z"
        }
    ]
};

const FasVideo = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasVideo",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 128c0-35.3 28.7-64 64-64h256c35.3 0 64 28.7 64 64v256c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zm559.1-28.2c10.4 5.6 16.9 16.4 16.9 28.2v256c0 11.8-6.5 22.6-16.9 28.2s-23 5-32.9-1.6l-96-64-14.2-9.5V174.9l14.2-9.5 96-64c9.8-6.5 22.4-7.2 32.9-1.6z"
        }
    ]
};

const FasVihara = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasVihara",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m281 22 24.8-17.3c1.3-.9 2.7-1.8 4.1-2.4C313.1.7 316.6 0 320 0s6.9.7 10.1 2.2c1.4.7 2.8 1.5 4.1 2.4L359 22c34 23.8 71.8 41.5 111.8 52.4l23 6.3c1.8.5 3.6 1.1 5.2 2 3.2 1.7 5.9 4 8.1 6.8 3.8 4.9 5.6 11.3 4.7 17.8-.4 2.8-1.2 5.4-2.5 7.8-1.7 3.2-4 5.9-6.8 8.1-4.3 3.2-9.6 5.1-15.1 4.9H480v56.1l6.4 5.1 5.2 4.1c21.1 16.7 45 29.6 70.5 38.1l28.9 9.6c1.6.5 3.2 1.2 4.6 2 3.1 1.7 5.8 4.1 7.8 6.9s3.5 6.1 4.1 9.6c.5 2.7.6 5.5.1 8.3s-1.4 5.4-2.7 7.8c-1.7 3.1-4.1 5.8-6.9 7.8s-6.1 3.5-9.6 4.1c-1.6.3-3.3.4-5 .4H544v65.9c20.5 22.8 47.4 39.2 77.4 46.7C632 403 640 412.6 640 424c0 13.3-10.7 24-24 24h-40v32c0 17.7-14.3 32-32 32s-32-14.3-32-32v-32H352v32c0 17.7-14.3 32-32 32s-32-14.3-32-32v-32H128v32c0 17.7-14.3 32-32 32s-32-14.3-32-32v-32H24c-13.3 0-24-10.7-24-24 0-11.4 8-21 18.6-23.4 30-7.6 56.9-23.9 77.4-46.7V288H56.6c-1.7 0-3.4-.1-5-.4-3.5-.7-6.8-2.1-9.6-4.1s-5.2-4.7-7-7.8c-1.3-2.4-2.3-5-2.7-7.8s-.4-5.6.1-8.3c.7-3.5 2.1-6.8 4.1-9.6s4.7-5.2 7.8-6.9c1.4-.8 3-1.5 4.6-2l28.9-9.6c25.5-8.5 49.4-21.4 70.5-38.1l5.2-4.1 6.4-5.1V128h-7.5c-5.5.1-10.8-1.7-15.1-4.9-2.8-2.1-5.1-4.8-6.8-8.1-1.2-2.4-2.1-5-2.5-7.8-.9-6.5.9-12.8 4.7-17.8 2.1-2.8 4.8-5.1 8.1-6.8 1.6-.8 3.4-1.5 5.2-2l23-6.3c40.2-10.8 78-28.5 112-52.3zm135 106H224v64h192v-64zM160 288v64h320v-64H160z"
        }
    ]
};

const FasViolin = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasViolin",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M630.6 54.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L417 177.7c-19-11.2-41.3-17.7-65-17.7-20.8 0-40.4 5-57.8 13.8-6.7 3.4-9.1 11.4-7.7 18.8 1 5 1.5 10.2 1.5 15.4 0 44.2-35.8 80-80 80-11.6 0-22.7-2.5-32.7-7-7.4-3.3-16.6-2.4-21.3 4.3-16.4 23.4-26 51.9-26 82.7 0 15 2.3 29.5 6.6 43.1l44.6-33.5c19.1-14.3 45.9-12.4 62.7 4.5l16 16c16.9 16.9 18.8 43.6 4.5 62.7l-33.5 44.6c13.6 4.3 28.1 6.6 43.1 6.6 30.8 0 59.3-9.6 82.6-26.1 6.7-4.7 7.6-13.8 4.3-21.3-4.5-10-7-21-7-32.7 0-44.2 35.8-80 80-80 5.3 0 10.5.5 15.4 1.5 7.4 1.4 15.4-1 18.8-7.7 8.8-17.4 13.8-37 13.8-57.8 0-23.7-6.5-46-17.7-65L630.6 54.6zM520 48a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-175-7c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L7 311c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L345 41zm127 55a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm120 72a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm48-48a24 24 0 1 0-48 0 24 24 0 1 0 48 0zM198.4 403.2l-64 48c-3.7 2.8-6 7-6.4 11.7s1.4 9.2 4.6 12.4l32 32c3.3 3.3 7.8 5 12.4 4.6s8.9-2.6 11.7-6.4l48-64c4.8-6.4 4.1-15.3-1.5-20.9l-16-16c-5.6-5.6-14.5-6.3-20.9-1.5z"
        }
    ]
};

const FasVirusCovidSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasVirusCovidSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L472.1 344.7c11.4-19.5 19.1-41.4 22.3-64.7H528v16c0 13.3 10.7 24 24 24s24-10.7 24-24v-80c0-13.3-10.7-24-24-24s-24 10.7-24 24v16h-33.6c-4.2-30.7-16.3-58.8-34.1-82.3l23.7-23.8 11.3 11.3c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-56.5-56.6c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L450.1 92l-23.8 23.8c-23.5-17.9-51.6-30-82.3-34.2V48h16c13.3 0 24-10.7 24-24S373.3 0 360 0h-80c-13.3 0-24 10.7-24 24s10.7 24 24 24h16v33.6c-30.7 4.2-58.8 16.3-82.3 34.1L189.9 92l11.3-11.3c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-33.2 33L38.8 5.1zm110.4 208.4c-1.5 6-2.7 12.2-3.5 18.5H112v-16c0-13.3-10.7-24-24-24s-24 10.7-24 24v80c0 13.3 10.7 24 24 24s24-10.7 24-24v-16h33.6c4.2 30.7 16.3 58.8 34.1 82.3L156 386.1l-11.3-11.3c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l56.6 56.6c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L189.9 420l23.8-23.8c23.5 17.9 51.7 29.9 82.3 34.1V464h-16c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24h-16v-33.6c20.4-2.8 39.7-9.1 57.3-18.2L149.2 213.5z"
        }
    ]
};

const FasVirusCovid = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasVirusCovid",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 24c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24s-10.7 24-24 24h-16v33.6c30.7 4.2 58.8 16.3 82.3 34.1L386.1 92l-11.3-11.4c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l56.6 56.6c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L420 125.9l-23.8 23.8c17.9 23.5 29.9 51.7 34.1 82.3H464v-16c0-13.3 10.7-24 24-24s24 10.7 24 24v80c0 13.3-10.7 24-24 24s-24-10.7-24-24v-16h-33.6c-4.2 30.7-16.3 58.8-34.1 82.3l23.7 23.8 11.3-11.3c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-56.6 56.6c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l11.4-11.4-23.8-23.8c-23.5 17.9-51.7 29.9-82.3 34.1V464h16c13.3 0 24 10.7 24 24s-10.7 24-24 24h-80c-13.3 0-24-10.7-24-24s10.7-24 24-24h16v-33.6c-30.7-4.2-58.8-16.3-82.3-34.1L125.9 420l11.3 11.3c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-56.6-56.5c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L92 386.1l23.8-23.8c-17.9-23.5-30-51.6-34.2-82.3H48v16c0 13.3-10.7 24-24 24S0 309.3 0 296v-80c0-13.3 10.7-24 24-24s24 10.7 24 24v16h33.6c4.2-30.7 16.3-58.8 34.1-82.3L92 125.9l-11.4 11.3c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l56.6-56.6c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L125.9 92l23.8 23.8c23.5-17.9 51.7-29.9 82.3-34.1V48h-16c-13.3 0-24-10.7-24-24zm48 200a48 48 0 1 0-96 0 48 48 0 1 0 96 0zm64 104a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FasVirusSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasVirusSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-154.3-121c-2-30.1 20.8-60.1 56-60.1H544c17.7 0 32-14.3 32-32s-14.3-32-32-32h-11.5c-49.9 0-74.9-60.3-39.6-95.6l8.2-8.2c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-8.2 8.2C412.3 118.4 352 93.4 352 43.5V32c0-17.7-14.3-32-32-32s-32 14.3-32 32v11.5c0 49.9-60.3 74.9-95.6 39.6l-8.2-8.1c-12.5-12.5-32.8-12.5-45.3 0-1.6 1.6-3.1 3.4-4.3 5.3L38.8 5.1zm225.8 177c6.9-3.9 14.9-6.1 23.4-6.1 26.5 0 48 21.5 48 48 0 4.4-.6 8.7-1.7 12.7l-69.7-54.6zM402 412.7 144.7 210c-9.5 8.5-22.2 14-37.2 14H96c-17.7 0-32 14.3-32 32s14.3 32 32 32h11.5c49.9 0 74.9 60.3 39.6 95.6l-8.2 8.2c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l8.2-8.2c35.3-35.3 95.6-10.3 95.6 39.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32v-11.5c0-31.2 23.6-52.7 50-55.7z"
        }
    ]
};

const FasVirus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasVirus",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32v11.5c0 49.9-60.3 74.9-95.6 39.6l-8.2-8.1C107.7 62.5 87.5 62.5 75 75s-12.5 32.8 0 45.3l8.2 8.2c35.2 35.2 10.2 95.5-39.7 95.5H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h11.5c49.9 0 74.9 60.3 39.6 95.6l-8.1 8.2c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l8.2-8.2c35.3-35.3 95.6-10.3 95.6 39.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32v-11.5c0-49.9 60.3-74.9 95.6-39.6l8.2 8.2c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-8.2-8.2c-35.3-35.3-10.3-95.6 39.6-95.6H480c17.7 0 32-14.3 32-32s-14.3-32-32-32h-11.5c-49.9 0-74.9-60.3-39.6-95.6l8.2-8.2c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-8.2 8.2C348.3 118.4 288 93.4 288 43.5V32zM176 224a48 48 0 1 1 96 0 48 48 0 1 1-96 0zm128 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FasViruses = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasViruses",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 0c13.3 0 24 10.7 24 24v13.5c0 35.6 43.1 53.5 68.3 28.3l9.5-9.5c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-9.5 9.5c-25.2 25.2-7.3 68.3 28.3 68.3H360c13.3 0 24 10.7 24 24s-10.7 24-24 24h-13.5c-35.6 0-53.5 43.1-28.3 68.3l9.5 9.5c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-9.5-9.5c-25.2-25.2-68.3-7.3-68.3 28.3V360c0 13.3-10.7 24-24 24s-24-10.7-24-24v-13.5c0-35.6-43.1-53.5-68.3-28.3l-9.5 9.5c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l9.5-9.5C91 259.1 73.1 216 37.5 216H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h13.5c35.6 0 53.5-43.1 28.3-68.3l-9.5-9.5c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l9.5 9.5C124.9 91 168 73.1 168 37.5V24c0-13.3 10.7-24 24-24zm48 224a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm-48-64a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm320 80c0 33 39.9 49.5 63.2 26.2 6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6C574.5 312.1 591 352 624 352c8.8 0 16 7.2 16 16s-7.2 16-16 16c-33 0-49.5 39.9-26.2 63.2 6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0C551.9 446.5 512 463 512 496c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-33-39.9-49.5-63.2-26.2-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6C417.5 423.9 401 384 368 384c-8.8 0-16-7.2-16-16s7.2-16 16-16c33 0 49.5-39.9 26.2-63.2-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0C440.1 289.5 480 273 480 240c0-8.8 7.2-16 16-16s16 7.2 16 16zm0 112a32 32 0 1 0-64 0 32 32 0 1 0 64 0z"
        }
    ]
};

const FasVoicemail = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasVoicemail",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 320a80 80 0 1 1 0-160 80 80 0 1 1 0 160zm119.8 0c15.3-22.9 24.2-50.4 24.2-80 0-79.5-64.5-144-144-144S0 160.5 0 240s64.5 144 144 144h352c79.5 0 144-64.5 144-144S575.5 96 496 96s-144 64.5-144 144c0 29.6 8.9 57.1 24.2 80H263.8zM496 160a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"
        }
    ]
};

const FasVolcano = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasVolcano",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 144c-35.3 0-64-28.7-64-64s28.7-64 64-64c15.7 0 30 5.6 41.2 15C212.4 12.4 232.7 0 256 0s43.6 12.4 54.8 31c11.2-9.4 25.5-15 41.2-15 35.3 0 64 28.7 64 64s-28.7 64-64 64c-14.7 0-28.3-5-39.1-13.3l-32 48C275.3 187 266 192 256 192s-19.3-5-24.9-13.3l-32-48C188.3 139 174.7 144 160 144zm-16 208 48.4-24.2c10.2-5.1 21.6-7.8 33-7.8 19.6 0 38.4 7.8 52.2 21.6l32.5 32.5c6.3 6.3 14.9 9.9 23.8 9.9 11.3 0 21.8-5.6 28-15l9.7-14.6-58.9-66.3c-9.1-10.2-22.2-16.1-35.9-16.1h-41.7c-13.7 0-26.8 5.9-35.9 16.1l-59.9 67.4 4.7-3.5zm19.4-95.8c18.2-20.5 44.3-32.2 71.8-32.2H277c27.4 0 53.5 11.7 71.8 32.2l150.2 169c8.5 9.5 13.2 21.9 13.2 34.7 0 28.8-23.4 52.2-52.2 52.2H52.2C23.4 512 0 488.6 0 459.8c0-12.8 4.7-25.1 13.2-34.7l150.2-169z"
        }
    ]
};

const FasVolleyball = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasVolleyball",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M511.8 267.4c-26.1 8.7-53.4 13.8-81 15.1C440 177.2 399.3 78.3 327.6 10.1 434.1 41.1 512 139.5 512 256c0 3.8-.1 7.6-.2 11.4zm-3.9 34.7c-5.8 32-17.6 62-34.2 88.7-97.5 48.5-217.7 42.6-311.9-24.5 23.7-36.2 55.4-67.7 94.5-91.8 79.9 43.2 170.1 50.8 251.6 27.6zm-236-55.5C269.4 155.7 230.8 73.9 170 14.9 196.8 5.2 225.8 0 256 0c2.7 0 5.3 0 7.9.1 90.8 60.2 145.7 167.2 134.7 282.3-43.1-2.4-86.4-14.1-126.8-35.9zM138 28.8c20.6 18.3 38.7 39.4 53.7 62.6C95.9 136.1 30.6 220.8 7.3 316.9 2.5 297.4 0 277 0 256 0 157.2 56 71.5 138 28.8zm69.6 90.5c19.5 38.6 31 81.9 32.3 127.7-77.4 47.6-129 121.9-149.7 204-24.2-20.6-44.6-45.6-59.8-73.8 6.7-108.7 71.9-209.9 177.1-257.9zM256 512c-50.7 0-98-14.7-137.8-40.2 5.6-27 14.8-53.1 27.4-77.7 86.6 60.5 192.5 74.7 287.4 46.9-46 44-108.3 71-177 71z"
        }
    ]
};

const FasVolumeHigh = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasVolumeHigh",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M533.6 32.5C598.5 85.3 640 165.8 640 256s-41.5 170.8-106.4 223.5c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8c54.2-44 88.7-111 88.7-186.2s-34.5-142.2-88.7-186.3c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5zM473.1 107c43.2 35.2 70.9 88.9 70.9 149s-27.7 113.8-70.9 149c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C475.3 341.3 496 301.1 496 256s-20.7-85.3-53.2-111.8c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5zm-60.5 74.5c21.5 17.6 35.4 44.4 35.4 74.5s-13.9 56.9-35.4 74.5c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C393.1 284.4 400 271 400 256s-6.9-28.4-17.7-37.3c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5zM301.1 34.8C312.6 40 320 51.4 320 64v384c0 12.6-7.4 24-18.9 29.2s-25 3.1-34.4-5.3L131.8 352H64c-35.3 0-64-28.7-64-64v-64c0-35.3 28.7-64 64-64h67.8L266.7 40.1c9.4-8.4 22.9-10.4 34.4-5.3z"
        }
    ]
};

const FasVolumeLow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasVolumeLow",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M301.1 34.8C312.6 40 320 51.4 320 64v384c0 12.6-7.4 24-18.9 29.2s-25 3.1-34.4-5.3L131.8 352H64c-35.3 0-64-28.7-64-64v-64c0-35.3 28.7-64 64-64h67.8L266.7 40.1c9.4-8.4 22.9-10.4 34.4-5.3zm111.5 146.7c21.5 17.6 35.4 44.4 35.4 74.5s-13.9 56.9-35.4 74.5c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C393.1 284.4 400 271 400 256s-6.9-28.4-17.7-37.3c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5z"
        }
    ]
};

const FasVolumeOff = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasVolumeOff",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 64c0-12.6-7.4-24-18.9-29.2s-25-3.1-34.4 5.3L131.8 160H64c-35.3 0-64 28.7-64 64v64c0 35.3 28.7 64 64 64h67.8l134.9 119.9c9.4 8.4 22.9 10.4 34.4 5.3S320 460.6 320 448V64z"
        }
    ]
};

const FasVolumeSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasVolumeSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-105.7-82.9C556.7 352 576 306.3 576 256c0-60.1-27.7-113.8-70.9-149-10.3-8.4-25.4-6.8-33.8 3.5s-6.8 25.4 3.5 33.8C507.3 170.7 528 210.9 528 256c0 39.1-15.6 74.5-40.9 100.5L449 326.6c19-17.5 31-42.7 31-70.6 0-30.1-13.9-56.9-35.4-74.5-10.3-8.4-25.4-6.8-33.8 3.5s-6.8 25.4 3.5 33.8C425.1 227.6 432 241 432 256s-6.9 28.4-17.7 37.3c-1.3 1-2.4 2.2-3.4 3.4L352 250.6V64c0-12.6-7.4-24-18.9-29.2s-25-3.1-34.4 5.3l-100.9 89.7L38.8 5.1zM352 373.3l-269.1-212C53.8 167.4 32 193.1 32 224v64c0 35.3 28.7 64 64 64h67.8l134.9 119.9c9.4 8.4 22.9 10.4 34.4 5.3S352 460.6 352 448v-74.7z"
        }
    ]
};

const FasVolumeXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasVolumeXmark",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M301.1 34.8C312.6 40 320 51.4 320 64v384c0 12.6-7.4 24-18.9 29.2s-25 3.1-34.4-5.3L131.8 352H64c-35.3 0-64-28.7-64-64v-64c0-35.3 28.7-64 64-64h67.8L266.7 40.1c9.4-8.4 22.9-10.4 34.4-5.3zM425 167l55 55 55-55c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-55 55 55 55c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-55-55-55 55c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l55-55-55-55c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z"
        }
    ]
};

const FasVolume = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasVolume",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M333.1 34.8C344.6 40 352 51.4 352 64v384c0 12.6-7.4 24-18.9 29.2s-25 3.1-34.4-5.3L163.8 352H96c-35.3 0-64-28.7-64-64v-64c0-35.3 28.7-64 64-64h67.8L298.7 40.1c9.4-8.4 22.9-10.4 34.4-5.3zm172 72.2c43.2 35.2 70.9 88.9 70.9 149s-27.7 113.8-70.9 149c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C507.3 341.3 528 301.1 528 256s-20.7-85.3-53.2-111.8c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5zm-60.5 74.5c21.5 17.6 35.4 44.4 35.4 74.5s-13.9 56.9-35.4 74.5c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C425.1 284.4 432 271 432 256s-6.9-28.4-17.7-37.3c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5z"
        }
    ]
};

const FasVrCardboard = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasVrCardboard",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M576 64H64C28.7 64 0 92.7 0 128v256c0 35.3 28.7 64 64 64h120.4c24.2 0 46.4-13.7 57.2-35.4l32-64c8.8-17.5 26.7-28.6 46.3-28.6s37.5 11.1 46.3 28.6l32 64c10.8 21.7 33 35.4 57.2 35.4H576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zM96 240a64 64 0 1 1 128 0 64 64 0 1 1-128 0zm384-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"
        }
    ]
};

const FasW = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasW",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M20.8 34c16.5-6.2 35 2.2 41.2 18.7l110.2 294L257.3 55c4-13.7 16.5-23 30.7-23s26.7 9.4 30.7 23l85.1 291.7L514 52.8c6.2-16.5 24.6-24.9 41.2-18.7s24.9 24.7 18.7 41.2l-144 384c-4.8 12.9-17.4 21.3-31.2 20.7s-25.7-9.8-29.5-23L288 178.3 206.7 457c-3.9 13.2-15.8 22.5-29.5 23s-26.3-7.8-31.2-20.7L2 75.2c-6.2-16.5 2.2-35 18.8-41.2z"
        }
    ]
};

const FasWaffle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasWaffle",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zM160 80c-8.8 0-16 7.2-16 16v48H96c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v64H64c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v64H96c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48h64v80c0 8.8 7.2 16 16 16s16-7.2 16-16v-80h64v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48h48c8.8 0 16-7.2 16-16s-7.2-16-16-16h-48v-64h80c8.8 0 16-7.2 16-16s-7.2-16-16-16h-80v-64h48c8.8 0 16-7.2 16-16s-7.2-16-16-16h-48V96c0-8.8-7.2-16-16-16s-16 7.2-16 16v48h-64V64c0-8.8-7.2-16-16-16s-16 7.2-16 16v80h-64V96c0-8.8-7.2-16-16-16zm16 256v-64h64v64h-64zm96 0v-64h64v64h-64zm64-160v64h-64v-64h64zm-96 0v64h-64v-64h64z"
        }
    ]
};

const FasWagonCovered = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasWagonCovered",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M4.5 57.4C-5.2 30.3 16.1 2.1 44.8 4.1L194.1 14c16.8 1.1 29.9 15.1 29.9 31.9V224H64L4.5 57.4zM288 16h64c17.7 0 32 14.3 32 32v176H256V48c0-17.7 14.3-32 32-32zM64 288c0-17.7 14.3-32 32-32h448c17.7 0 32 14.3 32 32s-14.3 32-32 32h-1.6c20.7 20.3 33.6 48.7 33.6 80 0 61.9-50.1 112-112 112-56.4 0-103.1-41.7-110.9-96h-66.2c-7.8 54.3-54.4 96-110.9 96-61.9 0-112-50.1-112-112 0-31.3 12.9-59.7 33.6-80H96c-17.7 0-32-14.3-32-32zm96 128h-46c5.8 22.5 23.5 40.2 46 46v-46zm0-32v-46c-22.5 5.8-40.2 23.5-46 46h46zm32 78c22.5-5.8 40.2-23.5 46-46h-46v46zm0-124v46h46c-5.8-22.5-23.5-40.2-46-46zm256 124v-46h-46c5.8 22.5 23.5 40.2 46 46zm-46-78h46v-46c-22.5 5.8-40.2 23.5-46 46zm124 32h-46v46c22.5-5.8 40.2-23.5 46-46zm0-32c-5.8-22.5-23.5-40.2-46-46v46h46zM595.2 4.1c28.7-1.9 50 26.2 40.3 53.4L576 224H416V45.9c0-16.8 13.1-30.8 29.9-31.9L595.2 4z"
        }
    ]
};

const FasWalker = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasWalker",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M194 64h126c17.7 0 32 14.3 32 32v64H145l17.9-71.8C166.5 74 179.3 64 194 64zm158 160v168.6c-19.1 11.1-32 31.7-32 55.4 0 35.3 28.7 64 64 64s64-28.7 64-64c0-23.7-12.9-44.4-32-55.4V96c0-53-43-96-96-96H194c-44.1 0-82.4 30-93.1 72.7L1 472.2c-4.3 17.1 6.1 34.5 23.3 38.8s34.5-6.1 38.8-23.3L129 224h223zm32 208a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
        }
    ]
};

const FasWalkieTalkie = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasWalkieTalkie",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M112 24c0-13.3-10.7-24-24-24S64 10.7 64 24v72H48c-26.5 0-48 21.5-48 48v156.1C0 312.8 5.1 325 14.1 334l3.9 3.9c9 9 14.1 21.2 14.1 33.9V464c0 26.5 21.5 48 48 48H304c26.5 0 48-21.5 48-48v-92.1c0-12.7 5.1-24.9 14.1-33.9l3.9-3.9c9-9 14.1-21.2 14.1-33.9V144c0-26.5-21.5-48-48-48H320c0-17.7-14.3-32-32-32s-32 14.3-32 32h-32c0-17.7-14.3-32-32-32s-32 14.3-32 32h-48V24zm0 136h160c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64h160c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64h160c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FasWallet = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasWallet",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64H80c-8.8 0-16-7.2-16-16s7.2-16 16-16h368c17.7 0 32-14.3 32-32s-14.3-32-32-32H64zm352 240a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FasWandMagicSparkles = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasWandMagicSparkles",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M234.7 42.7 197 56.8c-3 1.1-5 4-5 7.2s2 6.1 5 7.2l37.7 14.1 14.1 37.7c1.1 3 4 5 7.2 5s6.1-2 7.2-5l14.1-37.7L315 71.2c3-1.1 5-4 5-7.2s-2-6.1-5-7.2l-37.7-14.1L263.2 5c-1.1-3-4-5-7.2-5s-6.1 2-7.2 5l-14.1 37.7zM46.1 395.4c-18.7 18.7-18.7 49.1 0 67.9l34.6 34.6c18.7 18.7 49.1 18.7 67.9 0l381.3-381.4c18.7-18.7 18.7-49.1 0-67.9l-34.6-34.5c-18.7-18.7-49.1-18.7-67.9 0L46.1 395.4zM484.6 82.6l-105 105-23.3-23.3 105-105 23.3 23.3zM7.5 117.2C3 118.9 0 123.2 0 128s3 9.1 7.5 10.8L64 160l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L128 160l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L128 96l-21.2-56.5c-1.7-4.5-6-7.5-10.8-7.5s-9.1 3-10.8 7.5L64 96 7.5 117.2zm352 256c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L416 416l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L480 416l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L480 352l-21.2-56.5c-1.7-4.5-6-7.5-10.8-7.5s-9.1 3-10.8 7.5L416 352l-56.5 21.2z"
        }
    ]
};

const FasWandMagic = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasWandMagic",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M14.1 463.3c-18.7-18.7-18.7-49.1 0-67.9L395.4 14.1c18.7-18.7 49.1-18.7 67.9 0l34.6 34.6c18.7 18.7 18.7 49.1 0 67.9L116.5 497.9c-18.7 18.7-49.1 18.7-67.9 0l-34.5-34.6zm333.5-275.7 105-105-23.2-23.3-105 105 23.3 23.3z"
        }
    ]
};

const FasWandSparkles = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasWandSparkles",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 6.1c9.5-8.5 24-8.1 33 .9l8 8c9 9 9.4 23.5.9 33l-85.8 95.9c-2.6 2.9-4.1 6.7-4.1 10.7V176c0 8.8-7.2 16-16 16h-15.8c-4.6 0-8.9 1.9-11.9 5.3L100.7 500.9C94.3 508 85.3 512 75.8 512c-8.8 0-17.3-3.5-23.5-9.8L9.7 459.7C3.5 453.4 0 445 0 436.2c0-9.5 4-18.5 11.1-24.8l111.6-99.8c3.4-3 5.3-7.4 5.3-11.9V272c0-8.8 7.2-16 16-16h34.6c3.9 0 7.7-1.5 10.7-4.1L464 6.1zM432 288c3.6 0 6.7 2.4 7.7 5.8l14.8 51.7 51.7 14.8c3.4 1 5.8 4.1 5.8 7.7s-2.4 6.7-5.8 7.7l-51.7 14.8-14.8 51.7c-1 3.4-4.1 5.8-7.7 5.8s-6.7-2.4-7.7-5.8l-14.8-51.7-51.7-14.8c-3.4-1-5.8-4.1-5.8-7.7s2.4-6.7 5.8-7.7l51.7-14.8 14.8-51.7c1-3.4 4.1-5.8 7.7-5.8zM87.7 69.8l14.8 51.7 51.7 14.8c3.4 1 5.8 4.1 5.8 7.7s-2.4 6.7-5.8 7.7l-51.7 14.8-14.8 51.7c-1 3.4-4.1 5.8-7.7 5.8s-6.7-2.4-7.7-5.8l-14.8-51.7-51.7-14.8c-3.4-1-5.8-4.1-5.8-7.7s2.4-6.7 5.8-7.7l51.7-14.8 14.8-51.7c1-3.4 4.1-5.8 7.7-5.8s6.7 2.4 7.7 5.8zM208 0c3.7 0 6.9 2.5 7.8 6.1l6.8 27.3 27.3 6.8c3.6.9 6.1 4.1 6.1 7.8s-2.5 6.9-6.1 7.8l-27.3 6.8-6.8 27.3c-.9 3.6-4.1 6.1-7.8 6.1s-6.9-2.5-7.8-6.1l-6.8-27.3-27.3-6.8c-3.6-.9-6.1-4.1-6.1-7.8s2.5-6.9 6.1-7.8l27.3-6.8 6.8-27.3c.9-3.6 4.1-6.1 7.8-6.1z"
        }
    ]
};

const FasWand = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasWand",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M497 7c-9-9-23.5-9.4-33-.9L189.3 251.9c-2.9 2.6-6.7 4.1-10.7 4.1H144c-8.8 0-16 7.2-16 16v27.6c0 4.6-1.9 8.9-5.3 11.9L11.1 411.3C4 417.7 0 426.7 0 436.2c0 8.8 3.5 17.3 9.7 23.5l42.6 42.6c6.2 6.2 14.7 9.8 23.5 9.8 9.5 0 18.5-4 24.8-11.1l271.7-303.7c3-3.4 7.4-5.3 11.9-5.3H400c8.8 0 16-7.2 16-16v-21.4c0-3.9 1.5-7.7 4.1-10.7L505.9 48c8.5-9.5 8.1-24-.9-33l-8-8z"
        }
    ]
};

const FasWarehouseFull = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasWarehouseFull",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 488V171.3c0-26.2 15.9-49.7 40.2-59.4L308.1 4.8c7.6-3.1 16.1-3.1 23.8 0l267.9 107.1c24.3 9.7 40.2 33.3 40.2 59.4V488c0 13.3-10.7 24-24 24h-48c-13.3 0-24-10.7-24-24V224c0-17.7-14.3-32-32-32H128c-17.7 0-32 14.3-32 32v264c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24zm376-104h112c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24H376c-13.3 0-24-10.7-24-24v-80c0-13.3 10.7-24 24-24zM128 248c0-13.3 10.7-24 24-24h144c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24H152c-13.3 0-24-10.7-24-24v-80zm24 136h144c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24H152c-13.3 0-24-10.7-24-24v-80c0-13.3 10.7-24 24-24z"
        }
    ]
};

const FasWarehouse = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasWarehouse",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 488V171.3c0-26.2 15.9-49.7 40.2-59.4L308.1 4.8c7.6-3.1 16.1-3.1 23.8 0l267.9 107.1c24.3 9.7 40.2 33.3 40.2 59.4V488c0 13.3-10.7 24-24 24h-48c-13.3 0-24-10.7-24-24V224c0-17.7-14.3-32-32-32H128c-17.7 0-32 14.3-32 32v264c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24zm488 24H152c-13.3 0-24-10.7-24-24v-56h384v56c0 13.3-10.7 24-24 24zM128 400v-64h384v64H128zm0-96v-80h384v80H128z"
        }
    ]
};

const FasWashingMachine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasWashingMachine",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 64C0 28.7 28.7 0 64 0h320c35.3 0 64 28.7 64 64v384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm368 240a144 144 0 1 0-288 0 144 144 0 1 0 288 0zM88 112a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm120-24a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm16 328c-61.9 0-112-50.1-112-112 0-16.5 3.6-32.2 10-46.3 7.4-1.1 14.8-1.7 22-1.7 32 0 56 16 80 32s48 32 80 32c10.9 0 21.4-.9 31.2-2.5C328.5 373 281.3 416 224 416z"
        }
    ]
};

const FasWatchApple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasWatchApple",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 48h256c0-26.5-21.5-48-48-48H112C85.5 0 64 21.5 64 48zm16 32c-44.2 0-80 35.8-80 80v192c0 44.2 35.8 80 80 80h224c44.2 0 80-35.8 80-80V160c0-44.2-35.8-80-80-80H80zm112 133.3a42.7 42.7 0 1 1 0 85.3 42.7 42.7 0 1 1 0-85.3zM213.3 352a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm-74.7-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm74.7-160a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm-74.7-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 256a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm224-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM112 512h160c26.5 0 48-21.5 48-48H64c0 26.5 21.5 48 48 48z"
        }
    ]
};

const FasWatchCalculator = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasWatchCalculator",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 48h256c0-26.5-21.5-48-48-48H112C85.5 0 64 21.5 64 48zm16 32c-44.2 0-80 35.8-80 80v192c0 44.2 35.8 80 80 80h224c44.2 0 80-35.8 80-80V160c0-44.2-35.8-80-80-80H80zm0 64h224c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16zm32 128a24 24 0 1 1-48 0 24 24 0 1 1 48 0zm80 24a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm128-24a24 24 0 1 1-48 0 24 24 0 1 1 48 0zM88 384a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm128-24a24 24 0 1 1-48 0 24 24 0 1 1 48 0zm80 24a24 24 0 1 1 0-48 24 24 0 1 1 0 48zM112 512h160c26.5 0 48-21.5 48-48H64c0 26.5 21.5 48 48 48z"
        }
    ]
};

const FasWatchFitness = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasWatchFitness",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 48c0-26.5 21.5-48 48-48h160c26.5 0 48 21.5 48 48H64zm0 416h256c0 26.5-21.5 48-48 48H112c-26.5 0-48-21.5-48-48zM0 160c0-44.2 35.8-80 80-80h224c44.2 0 80 35.8 80 80v192c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80V160zm141.3 0c-33.9 0-61.3 27.4-61.3 61.3 0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3 0-33.8-27.4-61.3-61.3-61.3-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9z"
        }
    ]
};

const FasWatchSmart = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasWatchSmart",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 48h256c0-26.5-21.5-48-48-48H112C85.5 0 64 21.5 64 48zm16 32c-44.2 0-80 35.8-80 80v192c0 44.2 35.8 80 80 80h224c44.2 0 80-35.8 80-80V160c0-44.2-35.8-80-80-80H80zm136 80v86.1l41 41c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-48-48c-4.5-4.5-7-10.6-7-17v-96c0-13.3 10.7-24 24-24s24 10.7 24 24zM112 512h160c26.5 0 48-21.5 48-48H64c0 26.5 21.5 48 48 48z"
        }
    ]
};

const FasWatch = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasWatch",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M112 0h160c26.5 0 48 21.5 48 48v24.2C283.7 46.8 239.6 32 192 32S100.3 46.8 64 72.2V48c0-26.5 21.5-48 48-48zM64 464v-24.2c36.3 25.3 80.4 40.2 128 40.2s91.7-14.8 128-40.2V464c0 26.5-21.5 48-48 48H112c-26.5 0-48-21.5-48-48zM0 256a192 192 0 1 1 384 0 192 192 0 1 1-384 0zm192-104c-13.3 0-24 10.7-24 24v80c0 8 4 15.5 10.7 20l48 32c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L216 243.2V176c0-13.3-10.7-24-24-24z"
        }
    ]
};

const FasWaterArrowDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasWaterArrowDown",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M354.5 104.3 320 135.7V32c0-17.7-14.3-32-32-32s-32 14.3-32 32v103.7l-34.5-31.3c-13.1-11.9-33.3-10.9-45.2 2.2s-10.9 33.3 2.2 45.2l88 80c12.2 11.1 30.8 11.1 43.1 0l88-80c13.1-11.9 14-32.1 2.2-45.2s-32.1-14-45.2-2.2zm-85 189.6C247 309.4 219.5 320 192 320c-26.9 0-55.3-10.8-77.4-26.1-11.9-8.5-28.1-7.8-39.2 1.7-14.4 11.9-32.5 21-50.6 25.2-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25 29 15.6 61.5 25.9 94.5 25.9 31.9 0 60.6-9.9 80.4-18.9 5.8-2.7 11.1-5.3 15.6-7.7 4.5 2.4 9.7 5.1 15.6 7.7 19.8 9 48.5 18.9 80.4 18.9 33 0 65.5-10.3 94.5-25.8 13.4 8.4 33.7 19.3 58.2 25 17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2-11.1-9.5-27.3-10.1-39.2-1.7-22 15.2-50.5 26-77.4 26-27.5 0-55-10.6-77.5-26.1-11.1-7.9-25.9-7.9-37 0zm37 128c-11.1-7.9-25.9-7.9-37 0-22.5 15.5-50 26.1-77.5 26.1-26.9 0-55.3-10.8-77.4-26.1-11.9-8.5-28.1-7.8-39.2 1.7-14.4 11.9-32.5 21-50.6 25.2-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25 29 15.6 61.5 25.9 94.5 25.9 31.9 0 60.6-9.9 80.4-18.9 5.8-2.7 11.1-5.3 15.6-7.7 4.5 2.4 9.7 5.1 15.6 7.7 19.8 9 48.5 18.9 80.4 18.9 33 0 65.5-10.3 94.5-25.8 13.4 8.4 33.7 19.3 58.2 25 17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2-11.1-9.4-27.3-10.1-39.2-1.7-22 15.2-50.5 26-77.4 26-27.5 0-55-10.6-77.5-26.1z"
        }
    ]
};

const FasWaterArrowUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasWaterArrowUp",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M354.5 135.7 320 104.3V208c0 17.7-14.3 32-32 32s-32-14.3-32-32V104.3l-34.5 31.3c-13.1 11.9-33.3 10.9-45.2-2.2s-10.9-33.3 2.2-45.2l88-80c12.2-11.1 30.8-11.1 43.1 0l88 80c13.1 11.9 14 32.1 2.2 45.2s-32.1 14-45.2 2.2zm-85 158.2c11.1-7.9 25.9-7.9 37 0 22.5 15.5 50 26.1 77.5 26.1 26.9 0 55.4-10.8 77.4-26.1 11.9-8.5 28.1-7.8 39.2 1.7 14.4 11.9 32.5 21 50.6 25.2 17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25-29 15.6-61.5 25.9-94.5 25.9-31.9 0-60.6-9.9-80.4-18.9-5.8-2.7-11.1-5.3-15.6-7.7-4.5 2.4-9.7 5.1-15.6 7.7-19.8 9-48.5 18.9-80.4 18.9-33 0-65.5-10.3-94.5-25.8-13.4 8.4-33.7 19.3-58.2 25-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2 11.1-9.5 27.3-10.1 39.2-1.7 22.1 15.2 50.5 26 77.4 26 27.5 0 55-10.6 77.5-26.1zm37 128c22.5 15.5 50 26.1 77.5 26.1 26.9 0 55.4-10.8 77.4-26.1 11.9-8.5 28.1-7.8 39.2 1.7 14.4 11.9 32.5 21 50.6 25.2 17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25-29 15.6-61.5 25.9-94.5 25.9-31.9 0-60.6-9.9-80.4-18.9-5.8-2.7-11.1-5.3-15.6-7.7-4.5 2.4-9.7 5.1-15.6 7.7-19.8 9-48.5 18.9-80.4 18.9-33 0-65.5-10.3-94.5-25.8-13.4 8.4-33.7 19.3-58.2 25-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2 11.1-9.4 27.3-10.1 39.2-1.7 22.1 15.2 50.5 26 77.4 26 27.5 0 55-10.6 77.5-26.1 11.1-7.9 25.9-7.9 37 0z"
        }
    ]
};

const FasWaterLadder = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasWaterLadder",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 127.7c0-52.8 42.9-95.7 95.7-95.7 48.3 0 89 36 95 83.9l1 8.2c2.2 17.5-10.2 33.5-27.8 35.7s-33.5-10.2-35.7-27.8l-1-8.2c-2-15.9-15.5-27.8-31.5-27.8-17.5 0-31.7 14.2-31.7 31.7V224h192v-96.3c0-52.8 42.9-95.7 95.7-95.7 48.3 0 89 36 95 83.9l1 8.2c2.2 17.5-10.2 33.5-27.8 35.7s-33.5-10.2-35.7-27.8l-1-8.2c-2-15.9-15.5-27.8-31.5-27.8-17.5 0-31.7 14.2-31.7 31.7V361c-1.6 1-3.3 2-4.8 3.1-18 12.4-40.1 20.3-59.2 20.3V288H192v96.5c-19 0-41.2-7.9-59.1-20.3-1.6-1.1-3.2-2.2-4.9-3.1V127.7zm178.5 262.2c22.5 15.5 50 26.1 77.5 26.1 26.9 0 55.4-10.8 77.4-26.1 11.9-8.5 28.1-7.8 39.2 1.7 14.4 11.9 32.5 21 50.6 25.2 17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25-29 15.6-61.5 25.9-94.5 25.9-31.9 0-60.6-9.9-80.4-18.9-5.8-2.7-11.1-5.3-15.6-7.7-4.5 2.4-9.7 5.1-15.6 7.7-19.8 9-48.5 18.9-80.4 18.9-33 0-65.5-10.3-94.5-25.8-13.4 8.4-33.7 19.3-58.2 25-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2 11.1-9.4 27.3-10.1 39.2-1.7 22.1 15.2 50.5 26 77.4 26 27.5 0 55-10.6 77.5-26.1 11.1-7.9 25.9-7.9 37 0z"
        }
    ]
};

const FasWater = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasWater",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M269.5 69.9c11.1-7.9 25.9-7.9 37 0C329 85.4 356.5 96 384 96c26.9 0 55.4-10.8 77.4-26.1 11.9-8.5 28.1-7.8 39.2 1.7 14.4 11.9 32.5 21 50.6 25.2 17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25-29 15.6-61.5 25.9-94.5 25.9-31.9 0-60.6-9.9-80.4-18.9-5.8-2.7-11.1-5.3-15.6-7.7-4.5 2.4-9.7 5.1-15.6 7.7-19.8 9-48.5 18.9-80.4 18.9-33 0-65.5-10.3-94.5-25.8-13.4 8.4-33.7 19.3-58.2 25-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18-4.3 36.2-13.4 50.5-25.3 11.1-9.5 27.3-10.1 39.2-1.7C136.7 85.2 165.1 96 192 96c27.5 0 55-10.6 77.5-26.1zm37 288c22.5 15.5 50 26.1 77.5 26.1 26.9 0 55.4-10.8 77.4-26.1 11.9-8.5 28.1-7.8 39.2 1.7 14.4 11.9 32.5 21 50.6 25.2 17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25-29 15.6-61.5 25.9-94.5 25.9-31.9 0-60.6-9.9-80.4-18.9-5.8-2.7-11.1-5.3-15.6-7.7-4.5 2.4-9.7 5.1-15.6 7.7-19.8 9-48.5 18.9-80.4 18.9-33 0-65.5-10.3-94.5-25.8-13.4 8.4-33.7 19.3-58.2 25-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2 11.1-9.4 27.3-10.1 39.2-1.7 22.1 15.2 50.5 26 77.4 26 27.5 0 55-10.6 77.5-26.1 11.1-7.9 25.9-7.9 37 0zm0-144c22.5 15.5 50 26.1 77.5 26.1 26.9 0 55.4-10.8 77.4-26.1 11.9-8.5 28.1-7.8 39.2 1.7 14.4 11.9 32.5 21 50.6 25.2 17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25-29 15.6-61.5 25.9-94.5 25.9-31.9 0-60.6-9.9-80.4-18.9-5.8-2.7-11.1-5.3-15.6-7.7-4.5 2.4-9.7 5.1-15.6 7.7-19.8 9-48.5 18.9-80.4 18.9-33 0-65.5-10.3-94.5-25.8-13.4 8.4-33.7 19.3-58.2 25-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2 11.1-9.5 27.3-10.1 39.2-1.7 22.1 15.2 50.5 26 77.4 26 27.5 0 55-10.6 77.5-26.1 11.1-7.9 25.9-7.9 37 0z"
        }
    ]
};

const FasWatermelonSlice = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasWatermelonSlice",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M41 391c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9c115.6 115.6 302.6 116 418.3.3S540.5 122.6 425 7c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9c96.9 96.9 97.1 253.6.3 350.4S137.9 487.9 41 391zm22.3-22.3c84.4 84.4 221.1 84.4 305.5 0 84.2-84.2 84.4-220.7.3-305.1l-4.3-4.3c-6.2-6.2-16.4-6.2-22.6 0L59.3 342.2c-6.2 6.2-6.2 16.4 0 22.6l4 4zm245.4-220c6.2-6.2 16.4-6.2 22.6 0l16 16c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-16-16c-6.2-6.2-6.2-16.4 0-22.6zm-80 80c6.2-6.2 16.4-6.2 22.6 0l16 16c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-16-16c-6.2-6.2-6.2-16.4 0-22.6zm88 8c6.2-6.2 16.4-6.2 22.6 0l16 16c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-16-16c-6.2-6.2-6.2-16.4 0-22.6zm-168 72c6.2-6.2 16.4-6.2 22.6 0l16 16c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-16-16c-6.2-6.2-6.2-16.4 0-22.6zm88 8c6.2-6.2 16.4-6.2 22.6 0l16 16c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-16-16c-6.2-6.2-6.2-16.4 0-22.6z"
        }
    ]
};

const FasWavePulse = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasWavePulse",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M319.1 0c14.8-.4 27.9 9.3 31.8 23.6l74 271.2 17.7-35.4c10.8-21.7 33-35.4 57.2-35.4H608c17.7 0 32 14.3 32 32s-14.3 32-32 32H499.8l-55.2 110.3c-5.9 11.9-18.6 18.8-31.8 17.5s-24.2-10.6-27.7-23.4l-61.4-225.1-68.4 319.4c-3.1 14.4-15.5 24.8-30.2 25.3s-27.8-9.1-31.8-23.2L135.9 288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h103.9c28.6 0 53.7 18.9 61.5 46.4l22.2 77.6 69.1-322.7C291.8 10.9 304.4.4 319.1 0z"
        }
    ]
};

const FasWaveSine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasWaveSine",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M63.4 230.3v-.1l.2-1c.2-.9.5-2.4 1-4.3 1-3.8 2.5-9.4 4.6-16.2C73.6 195 80.3 177 90 159.4c20.2-36.6 47.8-63.4 86-63.4 29 0 49.1 14.4 67 44.4 19 31.8 31.9 75.4 46.3 124.5.2.8.5 1.6.7 2.4 13.5 46.2 28.4 97.5 52 137 25.1 42 63 75.6 122 75.6 73.8 0 118.2-53.2 142-96.6 12.3-22.4 20.6-44.5 25.7-60.8 2.6-8.2 4.5-15.1 5.7-20 .6-2.5 1.1-4.4 1.4-5.9.2-.7.3-1.3.4-1.7l.1-.5v-.3l-31.4-6.3 31.4 6.3c3.5-17.3-7.8-34.2-25.1-37.7s-34.2 7.8-37.7 25.1v.1l-.2 1c-.2.9-.5 2.4-1 4.3-1 3.8-2.5 9.4-4.6 16.2-4.3 13.7-11.1 31.6-20.8 49.2-20.1 36.6-47.8 63.4-86 63.4-29 0-49.1-14.4-67-44.4-19-31.8-31.9-75.4-46.3-124.5-.2-.8-.5-1.6-.7-2.4-13.5-46.2-28.4-97.5-52-137C272.9 65.6 235 32 176 32c-73.8 0-118.2 53.2-142 96.6C21.7 151 13.4 173 8.2 189.3c-2.6 8.2-4.5 15.1-5.7 20-.6 2.5-1.1 4.4-1.4 5.9-.2.7-.3 1.3-.4 1.7l-.1.5v.3L32 224 .6 217.7c-3.5 17.3 7.8 34.2 25.1 37.7s34.2-7.8 37.7-25.1"
        }
    ]
};

const FasWaveSquare = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasWaveSquare",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 64c0-17.7 14.3-32 32-32h160c17.7 0 32 14.3 32 32v352h96V256c0-17.7 14.3-32 32-32h128c17.7 0 32 14.3 32 32s-14.3 32-32 32h-96v160c0 17.7-14.3 32-32 32H320c-17.7 0-32-14.3-32-32V96h-96v160c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h96V64z"
        }
    ]
};

const FasWaveTriangle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasWaveTriangle",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 32c10.1 0 19.6 4.7 25.6 12.8L464 394.7l118.4-157.9c10.6-14.1 30.7-17 44.8-6.4s17 30.7 6.4 44.8l-144 192c-6 8.1-15.5 12.8-25.6 12.8s-19.6-4.7-25.6-12.8L176 117.3 57.6 275.2c-10.6 14.1-30.7 17-44.8 6.4s-17-30.7-6.4-44.8l144-192c6-8.1 15.5-12.8 25.6-12.8z"
        }
    ]
};

const FasWaveformLines = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasWaveformLines",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 32c0-17.7-14.3-32-32-32s-32 14.3-32 32v448c0 17.7 14.3 32 32 32s32-14.3 32-32V32zm192 64c0-17.7-14.3-32-32-32s-32 14.3-32 32v320c0 17.7 14.3 32 32 32s32-14.3 32-32V96zm-288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32v256c0 17.7 14.3 32 32 32s32-14.3 32-32V128zm192 32c0-17.7-14.3-32-32-32s-32 14.3-32 32v192c0 17.7 14.3 32 32 32s32-14.3 32-32V160zm-288 64c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 17.7 14.3 32 32 32s32-14.3 32-32v-64zM0 256a32 32 0 1 0 64 0 32 32 0 1 0-64 0zm576 0a32 32 0 1 0 64 0 32 32 0 1 0-64 0z"
        }
    ]
};

const FasWaveform = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasWaveform",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 0c12 0 22.1 8.8 23.8 20.7l42 304.4 38.5-240.9c1.9-11.7 12-20.3 23.9-20.2s21.9 8.9 23.6 20.6L500 281.9l20.5-102.6c2.2-10.8 11.3-18.7 22.3-19.3s20.9 6.4 24.2 16.9l26.7 87.1H616c13.3 0 24 10.7 24 24s-10.7 24-24 24h-40c-10.5 0-19.8-6.9-22.9-16.9l-4.1-13.4-29.4 147c-2.3 11.5-12.5 19.6-24.2 19.3s-21.4-9-23.1-20.6l-25.6-179.1-39 243.5c-1.9 11.7-12.1 20.3-24 20.2s-21.9-8.9-23.5-20.7L320 199.6l-40.2 291.7c-1.6 11.8-11.6 20.6-23.5 20.7s-22.1-8.5-24-20.2l-39-243.5-25.5 179.1c-1.7 11.6-11.4 20.3-23.1 20.6s-21.9-7.8-24.2-19.3l-29.4-147-4.1 13.4c-3.2 10-12.5 16.9-23 16.9H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h22.3l26.8-87.1c3.2-10.5 13.2-17.5 24.2-16.9s20.2 8.5 22.3 19.3l20.5 102.6 28.1-197.3c1.7-11.7 11.7-20.5 23.6-20.6s22 8.5 23.9 20.2l38.5 240.9 42-304.4C297.9 8.8 308 0 320 0z"
        }
    ]
};

const FasWebhook = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasWebhook",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M306 50c-43.1-9.9-86 16.9-95.9 60-7.9 34.1 7.4 68.2 35.5 85.9 5.4 3.4 9.2 8.8 10.7 15s.3 12.7-3 18.1l-82.9 132.5c3.6 6.7 5.6 14.4 5.6 22.5 0 26.5-21.5 48-48 48s-48-21.5-48-48 21.5-48 48-48h1.7L201 221.9c-32.5-30.2-48.4-76.4-37.7-122.7 15.9-68.9 84.6-111.8 153.5-95.9 65.9 15.2 108 78.7 97.7 144.4-2.1 13.1-14.3 22-27.4 20s-22-14.3-20-27.4c6.4-41.1-20-80.8-61.1-90.3zm-16.3 126H288c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48c0 8.1-2 15.8-5.6 22.5l71.3 114.1c45.8-17.7 99.8-8.2 136.8 28.9 50 50 50 131 0 181-43 43-109 49-158.4 18-11.2-7-14.6-21.8-7.6-33.1s21.8-14.6 33.1-7.6c30.9 19.3 72.1 15.5 99-11.3 31.2-31.2 31.2-81.9 0-113.1-26.8-26.8-68.1-30.6-99-11.3-5.4 3.4-11.9 4.5-18.1 3s-11.6-5.3-15-10.7L289.7 176zM448 432c-17.8 0-33.3-9.7-41.6-24H253.8c-9.2 48.3-46 88.9-97 100.7-68.9 15.9-137.6-27-153.5-95.9-14.3-61.8 18.8-123.4 75.4-147 12.2-5.1 26.3.7 31.4 12.9s-.7 26.3-12.9 31.4c-35.4 14.7-56 53.3-47.1 91.8 9.9 43.1 52.9 69.9 95.9 60 37-8.5 62.1-41.5 62-77.9 0-6.4 2.5-12.5 7-17s10.6-7 17-7h174.4c8.3-14.3 23.8-24 41.6-24 26.5 0 48 21.5 48 48s-21.5 48-48 48z"
        }
    ]
};

const FasWeightHanging = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasWeightHanging",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 96a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm122.5 32c3.5-10 5.5-20.8 5.5-32 0-53-43-96-96-96s-96 43-96 96c0 11.2 1.9 22 5.5 32H120c-22 0-41.2 15-46.6 36.4l-72 288c-3.6 14.3-.4 29.5 8.7 41.2S33.2 512 48 512h416c14.8 0 28.7-6.8 37.8-18.5s12.3-26.8 8.7-41.2l-72-288C433.2 143 414 128 392 128h-45.5z"
        }
    ]
};

const FasWeightScale = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasWeightScale",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 176a128 128 0 1 1 256 0 128 128 0 1 1-256 0zM391.8 64C359.5 24.9 310.7 0 256 0S152.5 24.9 120.2 64H64C28.7 64 0 92.7 0 128v320c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64h-56.2zM296 224c0-10.6-4.1-20.2-10.9-27.4l33.6-78.3c3.5-8.1-.3-17.5-8.4-21s-17.5.3-21 8.4L255.7 184c-22 .1-39.7 18-39.7 40 0 22.1 17.9 40 40 40s40-17.9 40-40z"
        }
    ]
};

const FasWhale = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasWhale",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M175.8 13.4c-1-5.9-5.2-10.8-10.9-12.6s-12-.3-16.2 3.9L108 45.4a80.057 80.057 0 0 0-22.4 69.7l7.9 47.4-49.9 49.9C15.7 240.3 0 278.2 0 317.6 0 407.3 72.7 480 162.4 480H544c53 0 96-43 96-96V272.1c0-79.6-64.5-144.1-144.1-144.1-82.5 0-162.4 29.5-225 83.2l-114.5 98.2c-8 6.8-18.1 10.6-28.6 10.6h-1.1c-18.3 0-34.5-11.7-40.3-29-4-12-2.4-25.2 4.3-35.9l37.6-60.1 44.7 7.5c25.5 4.2 51.5-4.1 69.7-22.3l40.7-40.7c4.2-4.2 5.8-10.5 3.9-16.2s-6.7-9.9-12.6-10.9l-84.8-14.3-14.1-84.7zM400 280a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FasWheatAwnCircleExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasWheatAwnCircleExclamation",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M505 41c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L383 95c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l88-88zM305.5 27.3c-6.2-6.2-16.4-6.2-22.6 0l-11.4 11.3c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4-30.5 30.5c-3.4-27.3-15.5-53.8-36.5-74.8l-11.3-11.3c-6.2-6.2-16.4-6.2-22.6 0l-11.3 11.3c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4-30.5 30.5c-3.4-27.3-15.5-53.8-36.5-74.8L101.8 231c-6.2-6.2-16.4-6.2-22.6 0l-11.3 11.3c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4-68.9 68.9c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l68.9-68.9 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6l-11.3-11.3c-21.8-21.8-49.6-34.1-78.1-36.9l31.9-31.9 12.2 12.2c22.5 22.5 53.3 31.5 82.4 27v-3.1c0-33.1 9.1-64.1 25-90.6-15.5-8.7-32.5-13.8-49.8-15.5l31.9-31.9 12.2 12.2c6 6 12.6 11.1 19.7 15.2 27.5-34 67.3-57.5 112.6-63.8-4.1-3.8-8.4-7.3-12.9-10.5L505 137c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-59.4 59.4c-20.6-4.4-42-3.7-62.3 2.1 6.1-21.3 6.6-43.8 1.4-65.3L409 41c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-46 45.8c-3.7-5-7.8-9.8-12.4-14.3l-11.2-11.3zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16v-80c0-8.8 7.2-16 16-16z"
        }
    ]
};

const FasWheatAwnSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasWheatAwnSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L362.5 258.8l28.7-28.7 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6L539.2 197c-5.2-5.2-10.6-9.8-16.4-13.9L569 137c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-59.4 59.4c-20.6-4.4-42-3.7-62.3 2.1 6.1-21.3 6.6-43.8 1.4-65.3L473 41c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-46 45.8c-3.7-5-7.8-9.8-12.4-14.3l-11.2-11.3c-6.2-6.2-16.4-6.2-22.6 0l-11.4 11.3c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4-30.5 30.5c-3.4-27.3-15.5-53.8-36.5-74.8l-11.3-11.3c-6.2-6.2-16.4-6.2-22.6 0l-11.3 11.3c-3.3 3.3-6.3 6.8-9 10.4L38.8 5.1zm255 322.4-50.6-39.9-29.5 29.5c-3.4-27.3-15.5-53.8-36.5-74.8L165.8 231c-6.2-6.2-16.4-6.2-22.6 0l-11.3 11.3c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4-68.9 68.9c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l68.9-68.9 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6l-11.3-11.3c-21.8-21.8-49.6-34.1-78.1-36.9l36.3-36.3zM569 41c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L447 95c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l88-88z"
        }
    ]
};

const FasWheatAwn = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasWheatAwn",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M505 41c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L383 95c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l88-88zM305.5 27.3c-6.2-6.2-16.4-6.2-22.6 0l-11.4 11.3c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4-30.5 30.5c-3.4-27.3-15.5-53.8-36.5-74.8l-11.3-11.3c-6.2-6.2-16.4-6.2-22.6 0l-11.3 11.3c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4-30.5 30.5c-3.4-27.3-15.5-53.8-36.5-74.8L101.8 231c-6.2-6.2-16.4-6.2-22.6 0l-11.3 11.3c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4-68.9 68.9c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l68.9-68.9 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6l-11.3-11.3c-21.8-21.8-49.6-34.1-78.1-36.9l31.9-31.9 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6L373.4 299c-21.8-21.8-49.6-34.1-78.1-36.9l31.9-31.9 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0l11.3-11.4c6.2-6.2 6.2-16.4 0-22.6L475.2 197c-5.2-5.2-10.6-9.8-16.4-13.9L505 137c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-59.4 59.4c-20.6-4.4-42-3.7-62.3 2.1 6.1-21.3 6.6-43.8 1.4-65.3L409 41c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-46 45.8c-3.7-5-7.8-9.8-12.4-14.3l-11.2-11.3z"
        }
    ]
};

const FasWheatSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasWheatSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L362.5 258.8l28.7-28.7 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6L539.2 197c-34.1-34.1-82.6-44.9-125.9-32.5 12.4-43.3 1.5-91.8-32.5-125.9l-11.3-11.3c-6.2-6.2-16.4-6.2-22.6 0l-11.4 11.3c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4-30.5 30.5c-3.4-27.3-15.5-53.8-36.5-74.8l-11.3-11.3c-6.2-6.2-16.4-6.2-22.6 0l-11.3 11.3c-3.3 3.3-6.3 6.8-9 10.4L38.8 5.1zm255 322.4-50.6-39.9-29.5 29.5c-3.4-27.3-15.5-53.8-36.5-74.8L165.8 231c-6.2-6.2-16.4-6.2-22.6 0l-11.3 11.3c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4-68.9 68.9c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l68.9-68.9 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6l-11.3-11.3c-21.8-21.8-49.6-34.1-78.1-36.9l36.3-36.3zM536 0c-48.6 0-88 39.4-88 88v24c0 8.8 7.2 16 16 16h24c48.6 0 88-39.4 88-88V16c0-8.8-7.2-16-16-16h-24z"
        }
    ]
};

const FasWheat = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasWheat",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M472 0c-48.6 0-88 39.4-88 88v24c0 8.8 7.2 16 16 16h24c48.6 0 88-39.4 88-88V16c0-8.8-7.2-16-16-16h-24zM305.5 27.3c-6.2-6.2-16.4-6.2-22.6 0l-11.4 11.3c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4-30.5 30.5c-3.4-27.3-15.5-53.8-36.5-74.8l-11.3-11.3c-6.2-6.2-16.4-6.2-22.6 0l-11.3 11.3c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4-30.5 30.5c-3.4-27.3-15.5-53.8-36.5-74.8L101.8 231c-6.2-6.2-16.4-6.2-22.6 0l-11.3 11.3c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4-68.9 68.9c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l68.9-68.9 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6l-11.3-11.3c-21.8-21.8-49.6-34.1-78.1-36.9l31.9-31.9 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6L373.4 299c-21.8-21.8-49.6-34.1-78.1-36.9l31.9-31.9 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0l11.3-11.4c6.2-6.2 6.2-16.4 0-22.6L475.2 197c-34.1-34.1-82.6-44.9-125.9-32.5 12.4-43.3 1.5-91.8-32.5-125.9l-11.3-11.3z"
        }
    ]
};

const FasWheelchairMove = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasWheelchairMove",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 48a48 48 0 1 1 96 0 48 48 0 1 1-96 0zm-115.5 73.3c-5.4-2.5-11.7-1.9-16.4 1.7l-40.9 30.7c-14.1 10.6-34.2 7.7-44.8-6.4s-7.7-34.2 6.4-44.8l40.9-30.7c23.7-17.8 55.3-21 82.1-8.4l90.4 42.5c29.1 13.7 36.8 51.6 15.2 75.5L299.1 224h97.4c30.3 0 53 27.7 47.1 57.4l-28.2 140.9c-3.5 17.3-20.3 28.6-37.7 25.1s-28.6-20.3-25.1-37.7L377 288h-70.3c8.6 19.6 13.3 41.2 13.3 64 0 88.4-71.6 160-160 160S0 440.4 0 352s71.6-160 160-160c11.1 0 22 1.1 32.4 3.3l54.2-54.2-42.1-19.8zM160 448a96 96 0 1 0 0-192 96 96 0 1 0 0 192z"
        }
    ]
};

const FasWheelchair = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasWheelchair",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-71.5 151.2c12.4-4.7 18.7-18.5 14-30.9s-18.5-18.7-30.9-14C43.1 225.1 0 283.5 0 352c0 88.4 71.6 160 160 160 61.2 0 114.3-34.3 141.2-84.7 6.2-11.7 1.8-26.2-9.9-32.5s-26.2-1.8-32.5 9.9C240 440 202.8 464 160 464c-61.9 0-112-50.1-112-112 0-47.9 30.1-88.8 72.5-104.8zM259.8 176l-1.9-9.7c-4.5-22.3-24-38.3-46.8-38.3-30.1 0-52.7 27.5-46.8 57l23.1 115.5c6 29.9 32.2 51.4 62.8 51.4h100.5c6.7 0 12.6 4.1 15 10.4l36.3 96.9c6 16.1 23.8 24.6 40.1 19.1l48-16c16.8-5.6 25.8-23.7 20.2-40.5s-23.7-25.8-40.5-20.2l-18.7 6.2-25.5-68c-11.7-31.2-41.6-51.9-74.9-51.9h-68.5l-9.6-48H336c17.7 0 32-14.3 32-32s-14.3-32-32-32h-76.2z"
        }
    ]
};

const FasWhiskeyGlassIce = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasWhiskeyGlassIce",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 32c-9.3 0-18.1 4-24.2 11.1S-1 59.4.3 68.6l50 342.9C56 450.8 89.7 480 129.5 480h253c39.7 0 73.4-29.1 79.2-68.5l50-342.9c1.3-9.2-1.4-18.5-7.5-25.5S489.3 32 480 32H32zm385 251.7c9.6 9.6 15 22.7 15 36.3s-5.4 26.7-15 36.3L356.3 417c-9.6 9.6-22.7 15-36.3 15s-26.7-5.4-36.3-15l-49-49H160c-35.3 0-64-28.7-64-64v-22.9L69 96h374l-27.2 186.5 1.2 1.2zM160 208c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h50.6a50.6 50.6 0 0 1-2.6-16c0-13.6 5.4-26.7 15-36.3l33-33V240c0-17.7-14.3-32-32-32h-64zm85.7 98.3c-3.7 3.7-5.7 8.6-5.7 13.7s2 10 5.7 13.7l60.7 60.7c3.6 3.6 8.5 5.7 13.7 5.7s10-2 13.7-5.7l60.7-60.7c3.6-3.6 5.7-8.5 5.7-13.7s-2-10-5.7-13.7l-60.7-60.7c-3.8-3.6-8.7-5.6-13.8-5.6s-10 2-13.7 5.7l-60.7 60.7z"
        }
    ]
};

const FasWhiskeyGlass = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasWhiskeyGlass",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 32c-9.3 0-18.1 4-24.2 11.1S-1 59.4.3 68.6l50 342.9C56 450.8 89.7 480 129.5 480h253c39.7 0 73.4-29.1 79.2-68.5l50-342.9c1.3-9.2-1.4-18.5-7.5-25.5S489.3 32 480 32H32zm55.7 192L69 96h374l-18.7 128H87.7z"
        }
    ]
};

const FasWhistle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasWhistle",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M44.1 188.8C18.5 180.5 0 156.4 0 128c0-35.3 28.7-64 64-64 23.4 0 43.8 12.5 55 31.2C149.2 75.5 185.2 64 224 64c51 0 97.4 19.9 131.8 52.4 1.1.5 2.2 1.2 3.2 2l62.4 48.3c5.1 4 7.3 10.6 5.6 16.9l-5.7 21.1c-3.2 11.7 1.1 24.2 10.8 31.5 9.6 7.2 22.7 7.9 33 1.7l17.7-10.6c5.7-3.4 12.8-3 18 1.1L629.4 328c6.7 5 10.6 13 10.6 21.4 0 6.8-2.5 13.4-7.1 18.4l-63.4 69.7a32.05 32.05 0 0 1-23.7 10.5h-2c-5.2 0-10.2-1.2-14.8-3.6L380.7 367c-34.8 49-92 81-156.7 81-106 0-192-86-192-192 0-23.6 4.3-46.3 12.1-67.2zM288 256a64 64 0 1 0-128 0 64 64 0 1 0 128 0zM64 144a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
        }
    ]
};

const FasWifiExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasWifiExclamation",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 32c-27.2 0-48.7 23.1-46.8 50.2l14.9 208C289.3 307 303.2 320 320 320s30.7-13 31.9-29.7l14.9-208C368.7 55.1 347.2 32 320 32zm-78.7 52.5c-1.2-17.4 3.3-33.9 11.9-47.6C159.4 51 75.1 94.1 9.8 156.7-2.9 169-3.3 189.2 8.9 202s32.5 13.2 45.2.9c51.3-49.2 116.2-84.3 188.5-99.1l-1.4-19.3zm157.4 0-1.4 19.3c72.3 14.8 137.2 49.9 188.5 99.1 12.8 12.2 33 11.8 45.2-.9s11.8-33-.9-45.2C564.9 94.1 480.6 51 386.8 37c8.6 13.7 13.1 30.1 11.9 47.6zM129.5 264c-13.3 11.7-14.5 31.9-2.8 45.2s31.9 14.5 45.2 2.8c23.6-20.8 51.6-36.7 82.4-46.2l-4.7-65.1c-45.2 11.3-86.2 33.4-120.1 63.3zm260.9-63.3-4.6 65.1c30.8 9.4 58.8 25.4 82.4 46.2 13.3 11.7 33.5 10.4 45.2-2.8s10.4-33.5-2.8-45.2c-33.9-29.9-74.9-52-120.1-63.3zM384 416a64 64 0 1 0-128 0 64 64 0 1 0 128 0z"
        }
    ]
};

const FasWifiFair = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasWifiFair",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 352a64 64 0 1 0 0 128 64 64 0 1 0 0-128zm0-160c-70.2 0-137.9 25.6-190.5 72-13.2 11.7-14.5 31.9-2.8 45.2 11.8 13.3 32 14.5 45.2 2.8 40.9-36.1 93.5-56 148.1-56s107.3 19.9 148.1 56c6.1 5.4 13.7 8 21.2 8 8.8 0 17.7-3.7 24-10.8 11.7-13.2 10.4-33.5-2.8-45.2-52.6-46.4-120.2-72-190.5-72zM171.8 312c39.5-34.9 91.3-56 148.2-56s108.6 21.1 148.2 56c13.3 11.7 33.5 10.4 45.2-2.8s10.4-33.5-2.8-45.2C459.8 219.2 393 192 320 192s-139.8 27.2-190.5 72c-13.3 11.7-14.5 31.9-2.8 45.2s31.9 14.5 45.2 2.8zM320 480a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"
        }
    ]
};

const FasWifiSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasWifiSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L364.6 260.4c39.2 7.9 74.7 26.1 103.6 51.6 13.3 11.7 33.5 10.4 45.2-2.8s10.4-33.5-2.8-45.2C459.8 219.2 393 192 320 192c-13.3 0-26.5.9-39.3 2.7l-95.1-74.5C227.4 104.5 272.7 96 320 96c103.2 0 196.8 40.7 265.8 106.9 12.8 12.2 33 11.8 45.2-.9s11.8-33-.9-45.2C549.7 79.5 440.4 32 320 32c-68.7 0-133.7 15.5-191.9 43.1l-89.3-70zm54.8 164.7-51.9-40.9c-11 8.8-21.7 18.1-31.9 27.8C-2.9 169-3.3 189.2 8.9 202s32.5 13.2 45.2.9c12.4-11.9 25.6-23 39.5-33.1zM228 275.7l-55-43.4c-15.5 9.2-30.1 19.8-43.5 31.7-13.3 11.7-14.5 31.9-2.8 45.2s31.9 14.5 45.2 2.8c16.7-14.8 35.6-27 56.2-36.3zm92 76.3c-35.3 0-64 28.7-64 64s28.7 64 64 64 64-28.7 64-64c0-7-1.1-13.7-3.2-20l-55.6-43.8c-1.7-.1-3.4-.2-5.2-.2z"
        }
    ]
};

const FasWifiWeak = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasWifiWeak",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 416a64 64 0 1 1 128 0 64 64 0 1 1-128 0z"
        }
    ]
};

const FasWifi = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasWifi",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M54.2 202.9C123.2 136.7 216.8 96 320 96s196.8 40.7 265.8 106.9c12.8 12.2 33 11.8 45.2-.9s11.8-33-.9-45.2C549.7 79.5 440.4 32 320 32S90.3 79.5 9.8 156.7C-2.9 169-3.3 189.2 8.9 202s32.5 13.2 45.2.9zM320 256c56.8 0 108.6 21.1 148.2 56 13.3 11.7 33.5 10.4 45.2-2.8s10.4-33.5-2.8-45.2C459.8 219.2 393 192 320 192s-139.8 27.2-190.5 72c-13.3 11.7-14.5 31.9-2.8 45.2s31.9 14.5 45.2 2.8c39.5-34.9 91.3-56 148.2-56zm64 160a64 64 0 1 0-128 0 64 64 0 1 0 128 0z"
        }
    ]
};

const FasWindTurbine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasWindTurbine",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M315.7 414.8c9.1 14.8 32 6.5 29.5-10.7L316.8 212c-.5-3.4.1-6.9 1.8-9.9L411 31.2c8.3-15.3-10.4-31-24-20.1L234.7 131.7c-2.7 2.1-6 3.4-9.5 3.5l-194.1 5.4c-17.4.4-21.6 24.4-5.4 30.8l180.6 71.5c3.2 1.3 5.9 3.5 7.7 6.5l101.7 165.4zm-91.7-88V464h-72c-13.3 0-24 10.7-24 24s10.7 24 24 24h208c13.3 0 24-10.7 24-24s-10.7-24-24-24h-72v-33.2l-64-104zM256 168a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FasWindWarning = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasWindWarning",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M418 368c-38.7 67-111.1 112-194 112C100.3 480 0 379.7 0 256S100.3 32 224 32c118.3 0 215.2 91.8 223.4 208H384c-35.3 0-64 28.7-64 64s28.7 64 64 64h34zM248 152c0-13.3-10.7-24-24-24s-24 10.7-24 24v112c0 13.3 10.7 24 24 24s24-10.7 24-24V152zm-24 232a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm248 48c0-17.7 14.3-32 32-32h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H384c-17.7 0-32-14.3-32-32s14.3-32 32-32h152c53 0 96 43 96 96s-43 96-96 96h-32c-17.7 0-32-14.3-32-32zm72-192h-64.5c-1.4-22.2-5.6-43.7-12.3-64H544c17.7 0 32-14.3 32-32s-14.3-32-32-32h-32c-17.7 0-32-14.3-32-32s14.3-32 32-32h32c53 0 96 43 96 96s-43 96-96 96z"
        }
    ]
};

const FasWind = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasWind",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 32c0 17.7 14.3 32 32 32h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h320c53 0 96-43 96-96S405 0 352 0h-32c-17.7 0-32 14.3-32 32zm64 352c0 17.7 14.3 32 32 32h32c53 0 96-43 96-96s-43-96-96-96H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h384c17.7 0 32 14.3 32 32s-14.3 32-32 32h-32c-17.7 0-32 14.3-32 32zM128 512h32c53 0 96-43 96-96s-43-96-96-96H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h128c17.7 0 32 14.3 32 32s-14.3 32-32 32h-32c-17.7 0-32 14.3-32 32s14.3 32 32 32z"
        }
    ]
};

const FasWindowFlip = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasWindowFlip",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 96c0-35.3 28.7-64 64-64h384c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm416 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-128-32a32 32 0 1 0 64 0 32 32 0 1 0-64 0zm-64 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FasWindowFrameOpen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasWindowFrameOpen",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 224V64c0-35.3-28.7-64-64-64H96C60.7 0 32 28.7 32 64v224h448v-64zm-64 0H280V64h136v160zm-184 0H96V64h136v160zM96 448V320H32v128c-17.7 0-32 14.3-32 32s14.3 32 32 32h448c17.7 0 32-14.3 32-32s-14.3-32-32-32V320h-64v128H96z"
        }
    ]
};

const FasWindowFrame = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasWindowFrame",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 256V64C32 28.7 60.7 0 96 0h320c35.3 0 64 28.7 64 64v384c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32V256zm384 32H280v160h136V288zm-184 0H96v160h136V288zm48-64h136V64H280v160zM232 64H96v160h136V64z"
        }
    ]
};

const FasWindowMaximize = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasWindowMaximize",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm32 64h320c17.7 0 32 14.3 32 32s-14.3 32-32 32H96c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
        }
    ]
};

const FasWindowMinimize = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasWindowMinimize",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32h448c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"
        }
    ]
};

const FasWindowRestore = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasWindowRestore",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M432 64H208c-8.8 0-16 7.2-16 16v16h-64V80c0-44.2 35.8-80 80-80h224c44.2 0 80 35.8 80 80v224c0 44.2-35.8 80-80 80h-16v-64h16c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16zM0 192c0-35.3 28.7-64 64-64h256c35.3 0 64 28.7 64 64v256c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192zm64 32c0 17.7 14.3 32 32 32h192c17.7 0 32-14.3 32-32s-14.3-32-32-32H96c-17.7 0-32 14.3-32 32z"
        }
    ]
};

const FasWindow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasWindow",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V96zM96 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64 32a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm128-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FasWindsock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasWindsock",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32C64 14.3 49.7 0 32 0S0 14.3 0 32v448c0 17.7 14.3 32 32 32s32-14.3 32-32V320h64v8.6c0 20.3 18.7 35.5 38.5 31.3l41.5-8.6V64.7L166.5 56C146.6 51.9 128 67 128 87.3V96H64V32zm64 112v128H64V144h64zm144-66v260l96-20V98l-96-20zm214.5 215.3c14.8-3.1 25.5-16.2 25.5-31.3V154c0-15.2-10.6-28.2-25.5-31.3L432 111.3v193.4l54.5-11.4z"
        }
    ]
};

const FasWineBottle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasWineBottle",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M393.4 9.4c12.5-12.5 32.8-12.5 45.3 0l64 64c12.5 12.5 12.5 32.8 0 45.3-11.8 11.8-30.7 12.5-43.2 1.9l-9.5 9.5-48.8 48.8c-9.2 9.2-11.5 22.9-8.6 35.6 9.4 40.9-1.9 85.6-33.8 117.5L197.3 493.3c-25 25-65.5 25-90.5 0l-88-88c-25-25-25-65.5 0-90.5l161.4-161.5c31.9-31.9 76.6-43.1 117.5-33.8 12.6 2.9 26.4.5 35.5-8.6L382 62.1l9.5-9.5c-10.6-12.6-10-31.4 1.9-43.2zM99.3 347.3l65.4 65.4c6.2 6.2 16.4 6.2 22.6 0l97.4-97.4c6.2-6.2 6.2-16.4 0-22.6l-65.4-65.4c-6.2-6.2-16.4-6.2-22.6 0l-97.4 97.4c-6.2 6.2-6.2 16.4 0 22.6z"
        }
    ]
};

const FasWineGlassCrack = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasWineGlassCrack",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 0C47.4 0 33.5 12.8 32.1 29.3l-14 168.4c-6 72 42.5 135.2 109.9 150.6V448H80c-17.7 0-32 14.3-32 32s14.3 32 32 32h160c17.7 0 32-14.3 32-32s-14.3-32-32-32h-48v-99.6c67.4-15.4 115.9-78.6 109.9-150.6l-14-168.4C286.5 12.8 272.6 0 256 0h-22.1c-11.9 0-19.6 12.5-14.3 23.2l14.2 28.5c3.5 7.1 1.4 15.7-5.1 20.3l-58.4 40.9c-6 4.2-8.4 12-5.8 18.9l31.1 81c2.1 5.5-1.9 11.4-7.8 11.4-2.4 0-4.7-1.1-6.3-2.9L92.1 118c-6.4-7.4-4.7-18.7 3.5-24l58.6-37.3c7.6-4.8 9.7-14.9 4.7-22.4L140.7 7.1c-3-4.5-8-7.1-13.3-7.1H64z"
        }
    ]
};

const FasWineGlassEmpty = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasWineGlassEmpty",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 0C47.4 0 33.5 12.8 32.1 29.3l-14 168.4c-6 72 42.5 135.2 109.9 150.6V448H80c-17.7 0-32 14.3-32 32s14.3 32 32 32h160c17.7 0 32-14.3 32-32s-14.3-32-32-32h-48v-99.6c67.4-15.4 115.9-78.6 109.9-150.6l-14-168.4C286.5 12.8 272.6 0 256 0H64zm17.9 203.1L93.4 64h133.2l11.6 139.1C242 248.8 205.9 288 160 288s-82-39.2-78.1-84.9z"
        }
    ]
};

const FasWineGlass = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasWineGlass",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32.1 29.3C33.5 12.8 47.4 0 64 0h192c16.6 0 30.5 12.8 31.9 29.3l14 168.4c6 72-42.5 135.2-109.9 150.6V448h48c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-17.7 0-32-14.3-32-32s14.3-32 32-32h48v-99.6C60.6 333 12.1 269.8 18.1 197.8l14-168.4zm56 98.7h143.8l-5.3-64H93.4l-5.3 64z"
        }
    ]
};

const FasWonSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasWonSign",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M62.4 53.9c-5.6-16.8-23.8-25.8-40.5-20.3S-3.9 57.4 1.6 74.1l50 149.9H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h40.9l56.7 170.1c4.5 13.5 17.4 22.4 31.6 21.9s26.4-10.4 29.8-24.2L233 288h46l42 167.8c3.4 13.8 15.6 23.7 29.8 24.2s27.1-8.4 31.6-21.9L439.1 288H480c17.7 0 32-14.3 32-32s-14.3-32-32-32h-19.6l50-149.9c5.6-16.8-3.5-34.9-20.2-40.5s-34.9 3.5-40.5 20.2L392.9 224H329L287 56.2C283.5 42 270.7 32 256 32s-27.5 10-31 24.2L183 224h-64L62.4 53.9zm78 234.1H167l-11.4 45.6-15.2-45.6zM249 224l7-28.1 7 28.1h-14zm96 64h26.6l-15.2 45.6L345 288z"
        }
    ]
};

const FasWorm = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasWorm",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 96c0-53 43-96 96-96h38.4C439.9 0 480 40.1 480 89.6V376c0 75.1-60.9 136-136 136s-136-60.9-136-136v-80c0-22.1-17.9-40-40-40s-40 17.9-40 40v168c0 26.5-21.5 48-48 48s-48-21.5-48-48V296c0-75.1 60.9-136 136-136s136 60.9 136 136v80c0 22.1 17.9 40 40 40s40-17.9 40-40V192h-32c-53 0-96-43-96-96zm144-8a24 24 0 1 0-48 0 24 24 0 1 0 48 0z"
        }
    ]
};

const FasWreathLaurel = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasWreathLaurel",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 112C144 50.1 194.1 0 256 0h16c8.8 0 16 7.2 16 16v16c0 60.2-47.5 109.3-107 111.9-23.9 32.2-37 71.5-37 112.1 0 97.2 78.8 176 176 176h11.6c43.5 0 86.3 10.1 125.2 29.6l9.9 5c11.9 5.9 16.7 20.3 10.7 32.2s-20.3 16.7-32.2 10.7l-9.9-5c-32.2-16.1-67.7-24.5-103.7-24.5h-23.2c-36 0-71.5 8.4-103.8 24.5l-9.9 5c-11.9 5.9-26.3 1.1-32.2-10.7s-1.1-26.3 10.7-32.2l9.9-5c8.3-4.2 16.8-7.9 25.4-11.2-5.6-3.2-11-6.7-16.3-10.3-59.6 28.2-131.9 6.3-165.4-51.8l-8-13.9c-4.4-7.7-1.8-17.4 5.9-21.9 13.8-8 28.4-13.1 43.3-15.5-40.5-21.4-68-64-68-113v-16c0-8.8 7.2-16 16-16 15.9 0 31.1 2.9 45.2 8.2-24.3-38.8-26.8-89.5-2.3-131.9l8-13.9c4.4-7.7 14.2-10.3 21.9-5.9 26.2 15.2 45 38.3 55.2 64.5v-1zm315 31.9C399.5 141.3 352 92.2 352 32V16c0-8.8 7.2-16 16-16h16c61.9 0 112 50.1 112 112v1c10.2-26.2 29-49.2 55.3-64.4 7.7-4.4 17.4-1.8 21.9 5.9l8 13.9c24.5 42.4 21.9 93.1-2.3 131.9 14.1-5.3 29.3-8.2 45.2-8.2 8.8 0 16 7.2 16 16v16c0 49-27.5 91.6-68 113.1 14.8 2.4 29.5 7.5 43.3 15.5 7.7 4.4 10.3 14.2 5.9 21.9l-8 13.9c-24.2 42-68.7 65.1-114 64a56.04 56.04 0 0 0-18.1-14.4l-9.9-5c-2.8-1.4-5.7-2.8-8.6-4.1-10.4-4.8-21-9-31.8-12.6-7.9-2.7-15.9-5-24-7C460 378.9 496 321.7 496 256c0-40.6-13.1-79.9-37-112.1z"
        }
    ]
};

const FasWreath = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasWreath",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M122.2 42.6C131 17.8 154.7 0 182.6 0c15.8 0 30.2 5.7 41.4 15.2C235.2 5.7 249.6 0 265.4 0c27.9 0 51.6 17.8 60.3 42.6 5.8-1.7 11.9-2.6 18.2-2.6 35.3 0 64 28.7 64 64 0 6.3-.9 12.5-2.6 18.2 24.8 8.8 42.6 32.5 42.6 60.3 0 15.8-5.7 30.2-15.2 41.4 9.5 11.2 15.2 25.6 15.2 41.4 0 27.9-17.8 51.6-42.6 60.3 1.7 5.8 2.6 11.9 2.6 18.2 0 32.6-24.4 59.6-56 63.5v-3.7c0-28.6-23.2-51.8-51.8-51.8-7.2 0-14.4 1.5-21 4.5L224 381l-55.2-24.5c-6.6-2.9-13.8-4.5-21-4.5-28.6 0-51.8 23.2-51.8 51.8v3.7c-31.6-3.9-56-30.9-56-63.5 0-6.3.9-12.5 2.6-18.2C17.8 317 0 293.3 0 265.4c0-15.8 5.7-30.2 15.2-41.4C5.7 212.8 0 198.4 0 182.6c0-27.9 17.8-51.6 42.6-60.3-1.7-5.8-2.6-12-2.6-18.3 0-35.3 28.7-64 64-64 6.3 0 12.5.9 18.2 2.6zm80.8 99.8c-5.7 6-13.6 9.4-21.9 9.1-16.6-.6-30.2 13-29.6 29.6.3 8.3-3 16.3-9.1 21.9-12.1 11.3-12.1 30.6 0 41.9 6 5.7 9.4 13.6 9.1 21.9-.6 16.6 13 30.2 29.6 29.6 8.3-.3 16.3 3 21.9 9.1 11.3 12.1 30.6 12.1 41.9 0 5.7-6 13.6-9.4 21.9-9.1 16.6.6 30.2-13 29.6-29.6-.3-8.3 3-16.3 9.1-21.9 12.1-11.3 12.1-30.6 0-41.9-6-5.7-9.4-13.6-9.1-21.9.6-16.6-13-30.2-29.6-29.6-8.3.3-16.3-3-21.9-9.1-11.3-12.1-30.6-12.1-41.9 0zm-75 261.4c0-10.9 8.9-19.8 19.8-19.8 2.8 0 5.5.6 8 1.7L224 416l68.2-30.3c2.5-1.1 5.3-1.7 8-1.7 10.9 0 19.8 8.9 19.8 19.8v88.4c0 10.9-8.9 19.8-19.8 19.8-2.8 0-5.5-.6-8-1.7L224 480l-68.2 30.3c-2.5 1.1-5.3 1.7-8 1.7-10.9 0-19.8-8.9-19.8-19.8v-88.4z"
        }
    ]
};

const FasWrenchSimple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasWrenchSimple",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m132.7 164.7 48 48c6.2 6.2 16.4 6.2 22.6 0l48-48c3-3 4.7-7.1 4.7-11.3V17.6c0-11 10.9-18.7 20.8-13.8C340.3 35 384 100.4 384 176c0 71.1-38.6 133.1-96 166.3V464c0 26.5-21.5 48-48 48h-96c-26.5 0-48-21.5-48-48V342.3C38.6 309.1 0 247.1 0 176 0 100.4 43.7 35 107.2 3.7c9.9-4.9 20.8 2.8 20.8 13.9v135.8c0 4.2 1.7 8.3 4.7 11.3z"
        }
    ]
};

const FasWrench = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasWrench",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 320c88.4 0 160-71.6 160-160 0-15.3-2.2-30.1-6.2-44.2-3.1-10.8-16.4-13.2-24.3-5.3l-76.8 76.8c-3 3-7.1 4.7-11.3 4.7H336c-8.8 0-16-7.2-16-16v-57.4c0-4.2 1.7-8.3 4.7-11.3l76.8-76.8c7.9-7.9 5.4-21.2-5.3-24.3C382.1 2.2 367.3 0 352 0c-88.4 0-160 71.6-160 160 0 19.1 3.4 37.5 9.5 54.5L19.9 396.1C7.2 408.8 0 426.1 0 444.1 0 481.6 30.4 512 67.9 512c18 0 35.3-7.2 48-19.9l181.6-181.6c17 6.2 35.4 9.5 54.5 9.5zM80 408a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FasXRay = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasXRay",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 64c0-17.7 14.3-32 32-32h448c17.7 0 32 14.3 32 32s-14.3 32-32 32v320c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32V96C14.3 96 0 81.7 0 64zm256 32c-8.8 0-16 7.2-16 16v32h-80c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v48H128c-8.8 0-16 7.2-16 16s7.2 16 16 16h112v70.6L189.1 307c-5.2-2-10.6-3-16.2-3h-2.1c-23.6 0-42.8 19.2-42.8 42.8 0 9.6 3.2 18.9 9.1 26.4l18.2 23.2c9.7 12.4 24.6 19.6 40.3 19.6h120.8c15.7 0 30.6-7.2 40.3-19.6l18.2-23.2c5.9-7.5 9.1-16.8 9.1-26.4 0-23.6-19.2-42.8-42.8-42.8H339c-5.5 0-11 1-16.2 3L272 326.6V256h112c8.8 0 16-7.2 16-16s-7.2-16-16-16H272v-48h80c8.8 0 16-7.2 16-16s-7.2-16-16-16h-80v-32c0-8.8-7.2-16-16-16zm-48 256a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm80 16a16 16 0 1 1 32 0 16 16 0 1 1-32 0z"
        }
    ]
};

const FasX = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasX",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M376.6 84.5c11.3-13.6 9.5-33.8-4.1-45.1s-33.8-9.5-45.1 4.1L192 206 56.6 43.5c-11.3-13.6-31.5-15.4-45.1-4.1S-3.9 70.9 7.4 84.5L150.3 256 7.4 427.5c-11.3 13.6-9.5 33.8 4.1 45.1s33.8 9.5 45.1-4.1L192 306l135.4 162.5c11.3 13.6 31.5 15.4 45.1 4.1s15.4-31.5 4.1-45.1L233.7 256 376.6 84.5z"
        }
    ]
};

const FasXmarkLarge = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasXmarkLarge",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M393.4 41.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L269.3 256l169.3 169.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L224 301.3 54.6 470.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L178.7 256 9.4 86.6c-12.5-12.5-12.5-32.7 0-45.2s32.8-12.5 45.3 0L224 210.7 393.4 41.4z"
        }
    ]
};

const FasXmarkToSlot = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasXmarkToSlot",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 80c0-26.5 21.5-48 48-48h288c26.5 0 48 21.5 48 48v304H96V80zm145 47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47zM0 336c0-26.5 21.5-48 48-48h16v128h448V288h16c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48v-96z"
        }
    ]
};

const FasXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasXmark",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3l105.4 105.3c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256l105.3-105.4z"
        }
    ]
};

const FasXmarksLines = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasXmarksLines",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 32C14.3 32 0 46.3 0 64s14.3 32 32 32h576c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zm0 384c-17.7 0-32 14.3-32 32s14.3 32 32 32h576c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zM7 167c-9.4 9.4-9.4 24.6 0 33.9l55 55L7 311c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l55-55 55 55c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-55-55 55-55c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55L41 167c-9.4-9.4-24.6-9.4-33.9 0zm258 0c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l55 55-55 55c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l55-55 55 55c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-55-55 55-55c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55-55-55zm190 0c-9.4 9.4-9.4 24.6 0 33.9l55 55-55 55c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l55-55 55 55c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-55-55 55-55c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55-55-55c-9.4-9.4-24.6-9.4-33.9 0z"
        }
    ]
};

const FasY = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasY",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M58 45.4C47.8 31 27.8 27.7 13.4 38S-4.3 68.2 6 82.6l154 215.7V448c0 17.7 14.3 32 32 32s32-14.3 32-32V298.3L378 82.6c10.3-14.4 6.9-34.4-7.4-44.6s-34.4-7-44.6 7.4L192 232.9 58 45.4z"
        }
    ]
};

const FasYenSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasYenSign",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M58.6 46.2C48.8 31.5 29 27.6 14.3 37.4S-4.4 67 5.4 81.7L100.2 224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32h80v32H48c-17.7 0-32 14.3-32 32s14.3 32 32 32h80v64c0 17.7 14.3 32 32 32s32-14.3 32-32v-64h80c17.7 0 32-14.3 32-32s-14.3-32-32-32h-80v-32h80c17.7 0 32-14.3 32-32s-14.3-32-32-32h-52.2l94.8-142.3c9.8-14.7 5.8-34.6-8.9-44.4s-34.6-5.8-44.4 8.9L160 198.3 58.6 46.2z"
        }
    ]
};

const FasYinYang = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasYinYang",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 64c53 0 96 43 96 96s-43 96-96 96-96 43-96 96 43 96 96 96c-106 0-192-86-192-192S150 64 256 64zm0 448a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm32-352a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm-64 192a32 32 0 1 1 64 0 32 32 0 1 1-64 0z"
        }
    ]
};

const FasZ = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FasZ",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 64c0-17.7 14.3-32 32-32h320c12.4 0 23.7 7.2 29 18.4s3.6 24.5-4.4 34.1L100.3 416H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-12.4 0-23.7-7.2-29-18.4s-3.6-24.5 4.4-34.1L283.7 96H32C14.3 96 0 81.7 0 64z"
        }
    ]
};

/**
 * Generated bundle index. Do not edit.
 */

export { Fas0, Fas00, Fas1, Fas2, Fas3, Fas360Degrees, Fas4, Fas5, Fas6, Fas7, Fas8, Fas9, FasA, FasAbacus, FasAccentGrave, FasAcorn, FasAddressBook, FasAddressCard, FasAirConditioner, FasAirplay, FasAlarmClock, FasAlarmExclamation, FasAlarmPlus, FasAlarmSnooze, FasAlbum, FasAlbumCirclePlus, FasAlbumCircleUser, FasAlbumCollection, FasAlbumCollectionCirclePlus, FasAlbumCollectionCircleUser, FasAlicorn, FasAlien, FasAlien8bit, FasAlignCenter, FasAlignJustify, FasAlignLeft, FasAlignRight, FasAlignSlash, FasAlt, FasAmpGuitar, FasAmpersand, FasAnchor, FasAnchorCircleCheck, FasAnchorCircleExclamation, FasAnchorCircleXmark, FasAnchorLock, FasAngel, FasAngle, FasAngle90, FasAngleDown, FasAngleLeft, FasAngleRight, FasAngleUp, FasAnglesDown, FasAnglesLeft, FasAnglesRight, FasAnglesUp, FasAnglesUpDown, FasAnkh, FasApartment, FasAperture, FasApostrophe, FasAppleCore, FasAppleWhole, FasArchway, FasArrowDown, FasArrowDown19, FasArrowDown91, FasArrowDownAZ, FasArrowDownArrowUp, FasArrowDownBigSmall, FasArrowDownFromArc, FasArrowDownFromDottedLine, FasArrowDownFromLine, FasArrowDownLeft, FasArrowDownLeftAndArrowUpRightToCenter, FasArrowDownLong, FasArrowDownRight, FasArrowDownShortWide, FasArrowDownSmallBig, FasArrowDownSquareTriangle, FasArrowDownToArc, FasArrowDownToBracket, FasArrowDownToDottedLine, FasArrowDownToLine, FasArrowDownToSquare, FasArrowDownTriangleSquare, FasArrowDownUpAcrossLine, FasArrowDownUpLock, FasArrowDownWideShort, FasArrowDownZA, FasArrowLeft, FasArrowLeftFromArc, FasArrowLeftFromLine, FasArrowLeftLong, FasArrowLeftLongToLine, FasArrowLeftToArc, FasArrowLeftToLine, FasArrowPointer, FasArrowProgress, FasArrowRight, FasArrowRightArrowLeft, FasArrowRightFromArc, FasArrowRightFromBracket, FasArrowRightFromLine, FasArrowRightLong, FasArrowRightLongToLine, FasArrowRightToArc, FasArrowRightToBracket, FasArrowRightToCity, FasArrowRightToLine, FasArrowRotateLeft, FasArrowRotateRight, FasArrowTrendDown, FasArrowTrendUp, FasArrowTurnDown, FasArrowTurnDownLeft, FasArrowTurnDownRight, FasArrowTurnUp, FasArrowUp, FasArrowUp19, FasArrowUp91, FasArrowUpAZ, FasArrowUpArrowDown, FasArrowUpBigSmall, FasArrowUpFromArc, FasArrowUpFromBracket, FasArrowUpFromDottedLine, FasArrowUpFromGroundWater, FasArrowUpFromLine, FasArrowUpFromSquare, FasArrowUpFromWaterPump, FasArrowUpLeft, FasArrowUpLeftFromCircle, FasArrowUpLong, FasArrowUpRight, FasArrowUpRightAndArrowDownLeftFromCenter, FasArrowUpRightDots, FasArrowUpRightFromSquare, FasArrowUpShortWide, FasArrowUpSmallBig, FasArrowUpSquareTriangle, FasArrowUpToArc, FasArrowUpToDottedLine, FasArrowUpToLine, FasArrowUpTriangleSquare, FasArrowUpWideShort, FasArrowUpZA, FasArrowsCross, FasArrowsDownToLine, FasArrowsDownToPeople, FasArrowsFromDottedLine, FasArrowsFromLine, FasArrowsLeftRight, FasArrowsLeftRightToLine, FasArrowsMaximize, FasArrowsMinimize, FasArrowsRepeat, FasArrowsRepeat1, FasArrowsRetweet, FasArrowsRotate, FasArrowsSpin, FasArrowsSplitUpAndLeft, FasArrowsToCircle, FasArrowsToDot, FasArrowsToDottedLine, FasArrowsToEye, FasArrowsToLine, FasArrowsTurnRight, FasArrowsTurnToDots, FasArrowsUpDown, FasArrowsUpDownLeftRight, FasArrowsUpToLine, FasAsterisk, FasAt, FasAtom, FasAtomSimple, FasAudioDescription, FasAudioDescriptionSlash, FasAustralSign, FasAvocado, FasAward, FasAwardSimple, FasAxe, FasAxeBattle, FasB, FasBaby, FasBabyCarriage, FasBackpack, FasBackward, FasBackwardFast, FasBackwardStep, FasBacon, FasBacteria, FasBacterium, FasBadge, FasBadgeCheck, FasBadgeDollar, FasBadgePercent, FasBadgeSheriff, FasBadgerHoney, FasBadminton, FasBagSeedling, FasBagShopping, FasBagel, FasBagsShopping, FasBaguette, FasBahai, FasBahtSign, FasBallPile, FasBalloon, FasBalloons, FasBallot, FasBallotCheck, FasBan, FasBanBug, FasBanParking, FasBanSmoking, FasBanana, FasBandage, FasBangladeshiTakaSign, FasBanjo, FasBarcode, FasBarcodeRead, FasBarcodeScan, FasBars, FasBarsFilter, FasBarsProgress, FasBarsSort, FasBarsStaggered, FasBaseball, FasBaseballBatBall, FasBasketShopping, FasBasketShoppingSimple, FasBasketball, FasBasketballHoop, FasBat, FasBath, FasBatteryBolt, FasBatteryEmpty, FasBatteryExclamation, FasBatteryFull, FasBatteryHalf, FasBatteryLow, FasBatteryQuarter, FasBatterySlash, FasBatteryThreeQuarters, FasBed, FasBedBunk, FasBedEmpty, FasBedFront, FasBedPulse, FasBee, FasBeerMug, FasBeerMugEmpty, FasBell, FasBellConcierge, FasBellExclamation, FasBellOn, FasBellPlus, FasBellSchool, FasBellSchoolSlash, FasBellSlash, FasBells, FasBenchTree, FasBezierCurve, FasBicycle, FasBillboard, FasBinBottles, FasBinBottlesRecycle, FasBinRecycle, FasBinary, FasBinaryCircleCheck, FasBinaryLock, FasBinarySlash, FasBinoculars, FasBiohazard, FasBird, FasBitcoinSign, FasBlanket, FasBlanketFire, FasBlender, FasBlenderPhone, FasBlinds, FasBlindsOpen, FasBlindsRaised, FasBlock, FasBlockBrick, FasBlockBrickFire, FasBlockQuestion, FasBlockQuote, FasBlog, FasBlueberries, FasBluetooth, FasBold, FasBolt, FasBoltAuto, FasBoltLightning, FasBoltSlash, FasBomb, FasBone, FasBoneBreak, FasBong, FasBook, FasBookArrowRight, FasBookArrowUp, FasBookAtlas, FasBookBible, FasBookBlank, FasBookBookmark, FasBookCircleArrowRight, FasBookCircleArrowUp, FasBookCopy, FasBookFont, FasBookHeart, FasBookJournalWhills, FasBookMedical, FasBookOpen, FasBookOpenCover, FasBookOpenReader, FasBookQuran, FasBookSection, FasBookSkull, FasBookSparkles, FasBookTanakh, FasBookUser, FasBookmark, FasBookmarkSlash, FasBooks, FasBooksMedical, FasBoombox, FasBoot, FasBootHeeled, FasBoothCurtain, FasBorderAll, FasBorderBottom, FasBorderBottomRight, FasBorderCenterH, FasBorderCenterV, FasBorderInner, FasBorderLeft, FasBorderNone, FasBorderOuter, FasBorderRight, FasBorderTop, FasBorderTopLeft, FasBoreHole, FasBottleDroplet, FasBottleWater, FasBowArrow, FasBowlChopsticks, FasBowlChopsticksNoodles, FasBowlFood, FasBowlHot, FasBowlRice, FasBowlScoop, FasBowlScoops, FasBowlSoftServe, FasBowlSpoon, FasBowlingBall, FasBowlingBallPin, FasBowlingPins, FasBox, FasBoxArchive, FasBoxBallot, FasBoxCheck, FasBoxCircleCheck, FasBoxDollar, FasBoxHeart, FasBoxOpen, FasBoxOpenFull, FasBoxTaped, FasBoxTissue, FasBoxesPacking, FasBoxesStacked, FasBoxingGlove, FasBracketCurly, FasBracketCurlyRight, FasBracketRound, FasBracketRoundRight, FasBracketSquare, FasBracketSquareRight, FasBracketsCurly, FasBracketsRound, FasBracketsSquare, FasBraille, FasBrain, FasBrainArrowCurvedRight, FasBrainCircuit, FasBrakeWarning, FasBrazilianRealSign, FasBreadLoaf, FasBreadSlice, FasBreadSliceButter, FasBridge, FasBridgeCircleCheck, FasBridgeCircleExclamation, FasBridgeCircleXmark, FasBridgeLock, FasBridgeSuspension, FasBridgeWater, FasBriefcase, FasBriefcaseArrowRight, FasBriefcaseBlank, FasBriefcaseMedical, FasBrightness, FasBrightnessLow, FasBringForward, FasBringFront, FasBroccoli, FasBroom, FasBroomBall, FasBroomWide, FasBrowser, FasBrowsers, FasBrush, FasBucket, FasBug, FasBugSlash, FasBugs, FasBuilding, FasBuildingCircleArrowRight, FasBuildingCircleCheck, FasBuildingCircleExclamation, FasBuildingCircleXmark, FasBuildingColumns, FasBuildingFlag, FasBuildingLock, FasBuildingNgo, FasBuildingShield, FasBuildingUn, FasBuildingUser, FasBuildingWheat, FasBuildings, FasBullhorn, FasBullseye, FasBullseyeArrow, FasBullseyePointer, FasBuoy, FasBuoyMooring, FasBurger, FasBurgerCheese, FasBurgerFries, FasBurgerGlass, FasBurgerLettuce, FasBurgerSoda, FasBurrito, FasBurst, FasBus, FasBusSchool, FasBusSimple, FasBusinessTime, FasButter, FasC, FasCabin, FasCabinetFiling, FasCableCar, FasCactus, FasCakeCandles, FasCakeSlice, FasCalculator, FasCalculatorSimple, FasCalendar, FasCalendarArrowDown, FasCalendarArrowUp, FasCalendarCheck, FasCalendarCircleExclamation, FasCalendarCircleMinus, FasCalendarCirclePlus, FasCalendarCircleUser, FasCalendarClock, FasCalendarDay, FasCalendarDays, FasCalendarExclamation, FasCalendarHeart, FasCalendarImage, FasCalendarLines, FasCalendarLinesPen, FasCalendarMinus, FasCalendarPen, FasCalendarPlus, FasCalendarRange, FasCalendarStar, FasCalendarUsers, FasCalendarWeek, FasCalendarXmark, FasCalendars, FasCamcorder, FasCamera, FasCameraCctv, FasCameraMovie, FasCameraPolaroid, FasCameraRetro, FasCameraRotate, FasCameraSecurity, FasCameraSlash, FasCameraViewfinder, FasCameraWeb, FasCameraWebSlash, FasCampfire, FasCampground, FasCanFood, FasCandleHolder, FasCandy, FasCandyBar, FasCandyCane, FasCandyCorn, FasCannabis, FasCapsules, FasCar, FasCarBattery, FasCarBolt, FasCarBuilding, FasCarBump, FasCarBurst, FasCarBus, FasCarCircleBolt, FasCarGarage, FasCarMirrors, FasCarOn, FasCarRear, FasCarSide, FasCarSideBolt, FasCarTilt, FasCarTunnel, FasCarWash, FasCarWrench, FasCaravan, FasCaravanSimple, FasCardClub, FasCardDiamond, FasCardHeart, FasCardSpade, FasCards, FasCardsBlank, FasCaretDown, FasCaretLeft, FasCaretRight, FasCaretUp, FasCarrot, FasCars, FasCartArrowDown, FasCartArrowUp, FasCartCircleArrowDown, FasCartCircleArrowUp, FasCartCircleCheck, FasCartCircleExclamation, FasCartCirclePlus, FasCartCircleXmark, FasCartFlatbed, FasCartFlatbedBoxes, FasCartFlatbedEmpty, FasCartFlatbedSuitcase, FasCartMinus, FasCartPlus, FasCartShopping, FasCartShoppingFast, FasCartXmark, FasCashRegister, FasCassetteBetamax, FasCassetteTape, FasCassetteVhs, FasCastle, FasCat, FasCatSpace, FasCauldron, FasCediSign, FasCentSign, FasCertificate, FasChair, FasChairOffice, FasChalkboard, FasChalkboardUser, FasChampagneGlass, FasChampagneGlasses, FasChargingStation, FasChartArea, FasChartBar, FasChartBullet, FasChartCandlestick, FasChartColumn, FasChartGantt, FasChartLine, FasChartLineDown, FasChartLineUp, FasChartLineUpDown, FasChartMixed, FasChartMixedUpCircleCurrency, FasChartMixedUpCircleDollar, FasChartNetwork, FasChartPie, FasChartPieSimple, FasChartPieSimpleCircleCurrency, FasChartPieSimpleCircleDollar, FasChartPyramid, FasChartRadar, FasChartScatter, FasChartScatter3d, FasChartScatterBubble, FasChartSimple, FasChartSimpleHorizontal, FasChartTreeMap, FasChartUser, FasChartWaterfall, FasCheck, FasCheckDouble, FasCheckToSlot, FasCheese, FasCheeseSwiss, FasCherries, FasChess, FasChessBishop, FasChessBishopPiece, FasChessBoard, FasChessClock, FasChessClockFlip, FasChessKing, FasChessKingPiece, FasChessKnight, FasChessKnightPiece, FasChessPawn, FasChessPawnPiece, FasChessQueen, FasChessQueenPiece, FasChessRook, FasChessRookPiece, FasChestnut, FasChevronDown, FasChevronLeft, FasChevronRight, FasChevronUp, FasChevronsDown, FasChevronsLeft, FasChevronsRight, FasChevronsUp, FasChfSign, FasChild, FasChildCombatant, FasChildDress, FasChildReaching, FasChildren, FasChimney, FasChopsticks, FasChurch, FasCircle, FasCircle0, FasCircle1, FasCircle2, FasCircle3, FasCircle4, FasCircle5, FasCircle6, FasCircle7, FasCircle8, FasCircle9, FasCircleA, FasCircleAmpersand, FasCircleArrowDown, FasCircleArrowDownLeft, FasCircleArrowDownRight, FasCircleArrowLeft, FasCircleArrowRight, FasCircleArrowUp, FasCircleArrowUpLeft, FasCircleArrowUpRight, FasCircleB, FasCircleBolt, FasCircleBookOpen, FasCircleBookmark, FasCircleC, FasCircleCalendar, FasCircleCamera, FasCircleCaretDown, FasCircleCaretLeft, FasCircleCaretRight, FasCircleCaretUp, FasCircleCheck, FasCircleChevronDown, FasCircleChevronLeft, FasCircleChevronRight, FasCircleChevronUp, FasCircleD, FasCircleDashed, FasCircleDivide, FasCircleDollar, FasCircleDollarToSlot, FasCircleDot, FasCircleDown, FasCircleDownLeft, FasCircleDownRight, FasCircleE, FasCircleEllipsis, FasCircleEllipsisVertical, FasCircleEnvelope, FasCircleEuro, FasCircleExclamation, FasCircleExclamationCheck, FasCircleF, FasCircleG, FasCircleH, FasCircleHalf, FasCircleHalfStroke, FasCircleHeart, FasCircleI, FasCircleInfo, FasCircleJ, FasCircleK, FasCircleL, FasCircleLeft, FasCircleLocationArrow, FasCircleM, FasCircleMicrophone, FasCircleMicrophoneLines, FasCircleMinus, FasCircleN, FasCircleNodes, FasCircleNotch, FasCircleO, FasCircleP, FasCircleParking, FasCirclePause, FasCirclePhone, FasCirclePhoneFlip, FasCirclePhoneHangup, FasCirclePlay, FasCirclePlus, FasCircleQ, FasCircleQuarter, FasCircleQuarterStroke, FasCircleQuarters, FasCircleQuestion, FasCircleR, FasCircleRadiation, FasCircleRight, FasCircleS, FasCircleSmall, FasCircleSort, FasCircleSortDown, FasCircleSortUp, FasCircleStar, FasCircleSterling, FasCircleStop, FasCircleT, FasCircleThreeQuarters, FasCircleThreeQuartersStroke, FasCircleTrash, FasCircleU, FasCircleUp, FasCircleUpLeft, FasCircleUpRight, FasCircleUser, FasCircleV, FasCircleVideo, FasCircleW, FasCircleWaveformLines, FasCircleX, FasCircleXmark, FasCircleY, FasCircleYen, FasCircleZ, FasCirclesOverlap, FasCitrus, FasCitrusSlice, FasCity, FasClapperboard, FasClapperboardPlay, FasClarinet, FasClawMarks, FasClipboard, FasClipboardCheck, FasClipboardList, FasClipboardListCheck, FasClipboardMedical, FasClipboardPrescription, FasClipboardQuestion, FasClipboardUser, FasClock, FasClockDesk, FasClockEight, FasClockEightThirty, FasClockEleven, FasClockElevenThirty, FasClockFive, FasClockFiveThirty, FasClockFourThirty, FasClockNine, FasClockNineThirty, FasClockOne, FasClockOneThirty, FasClockRotateLeft, FasClockSeven, FasClockSevenThirty, FasClockSix, FasClockSixThirty, FasClockTen, FasClockTenThirty, FasClockThree, FasClockThreeThirty, FasClockTwelve, FasClockTwelveThirty, FasClockTwo, FasClockTwoThirty, FasClone, FasClosedCaptioning, FasClosedCaptioningSlash, FasClothesHanger, FasCloud, FasCloudArrowDown, FasCloudArrowUp, FasCloudBinary, FasCloudBolt, FasCloudBoltMoon, FasCloudBoltSun, FasCloudCheck, FasCloudDrizzle, FasCloudExclamation, FasCloudFog, FasCloudHail, FasCloudHailMixed, FasCloudMeatball, FasCloudMinus, FasCloudMoon, FasCloudMoonRain, FasCloudMusic, FasCloudPlus, FasCloudQuestion, FasCloudRain, FasCloudRainbow, FasCloudShowers, FasCloudShowersHeavy, FasCloudShowersWater, FasCloudSlash, FasCloudSleet, FasCloudSnow, FasCloudSun, FasCloudSunRain, FasCloudWord, FasCloudXmark, FasClouds, FasCloudsMoon, FasCloudsSun, FasClover, FasClub, FasCoconut, FasCode, FasCodeBranch, FasCodeCommit, FasCodeCompare, FasCodeFork, FasCodeMerge, FasCodePullRequest, FasCodePullRequestClosed, FasCodePullRequestDraft, FasCodeSimple, FasCoffeeBean, FasCoffeeBeans, FasCoffeePot, FasCoffin, FasCoffinCross, FasCoin, FasCoinBlank, FasCoinFront, FasCoinVertical, FasCoins, FasColon, FasColonSign, FasColumns3, FasComet, FasComma, FasCommand, FasComment, FasCommentArrowDown, FasCommentArrowUp, FasCommentArrowUpRight, FasCommentCaptions, FasCommentCheck, FasCommentCode, FasCommentDollar, FasCommentDots, FasCommentExclamation, FasCommentHeart, FasCommentImage, FasCommentLines, FasCommentMedical, FasCommentMiddle, FasCommentMiddleTop, FasCommentMinus, FasCommentMusic, FasCommentPen, FasCommentPlus, FasCommentQuestion, FasCommentQuote, FasCommentSlash, FasCommentSmile, FasCommentSms, FasCommentText, FasCommentXmark, FasComments, FasCommentsDollar, FasCommentsQuestion, FasCommentsQuestionCheck, FasCompactDisc, FasCompass, FasCompassDrafting, FasCompassSlash, FasCompress, FasCompressWide, FasComputer, FasComputerClassic, FasComputerMouse, FasComputerMouseScrollwheel, FasComputerSpeaker, FasContainerStorage, FasConveyorBelt, FasConveyorBeltArm, FasConveyorBeltBoxes, FasConveyorBeltEmpty, FasCookie, FasCookieBite, FasCopy, FasCopyright, FasCorn, FasCorner, FasCouch, FasCow, FasCowbell, FasCowbellCirclePlus, FasCrab, FasCrateApple, FasCrateEmpty, FasCreditCard, FasCreditCardBlank, FasCreditCardFront, FasCricketBatBall, FasCroissant, FasCrop, FasCropSimple, FasCross, FasCrosshairs, FasCrosshairsSimple, FasCrow, FasCrown, FasCrutch, FasCrutches, FasCruzeiroSign, FasCrystalBall, FasCube, FasCubes, FasCubesStacked, FasCucumber, FasCupStraw, FasCupStrawSwoosh, FasCupTogo, FasCupcake, FasCurlingStone, FasCustard, FasD, FasDagger, FasDash, FasDatabase, FasDeer, FasDeerRudolph, FasDeleteLeft, FasDeleteRight, FasDemocrat, FasDesktop, FasDesktopArrowDown, FasDharmachakra, FasDiagramCells, FasDiagramLeanCanvas, FasDiagramNested, FasDiagramNext, FasDiagramPredecessor, FasDiagramPrevious, FasDiagramProject, FasDiagramSankey, FasDiagramSubtask, FasDiagramSuccessor, FasDiagramVenn, FasDial, FasDialHigh, FasDialLow, FasDialMax, FasDialMed, FasDialMedLow, FasDialMin, FasDialOff, FasDiamond, FasDiamondExclamation, FasDiamondHalf, FasDiamondHalfStroke, FasDiamondTurnRight, FasDice, FasDiceD10, FasDiceD12, FasDiceD20, FasDiceD4, FasDiceD6, FasDiceD8, FasDiceFive, FasDiceFour, FasDiceOne, FasDiceSix, FasDiceThree, FasDiceTwo, FasDinosaur, FasDiploma, FasDiscDrive, FasDisease, FasDisplay, FasDisplayArrowDown, FasDisplayChartUp, FasDisplayChartUpCircleCurrency, FasDisplayChartUpCircleDollar, FasDisplayCode, FasDisplayMedical, FasDisplaySlash, FasDistributeSpacingHorizontal, FasDistributeSpacingVertical, FasDitto, FasDivide, FasDna, FasDoNotEnter, FasDog, FasDogLeashed, FasDollarSign, FasDolly, FasDollyEmpty, FasDolphin, FasDongSign, FasDonut, FasDoorClosed, FasDoorOpen, FasDove, FasDown, FasDownFromDottedLine, FasDownFromLine, FasDownLeft, FasDownLeftAndUpRightToCenter, FasDownLong, FasDownRight, FasDownToBracket, FasDownToDottedLine, FasDownToLine, FasDownload, FasDragon, FasDrawCircle, FasDrawPolygon, FasDrawSquare, FasDreidel, FasDrone, FasDroneFront, FasDroplet, FasDropletDegree, FasDropletPercent, FasDropletSlash, FasDrum, FasDrumSteelpan, FasDrumstick, FasDrumstickBite, FasDryer, FasDryerHeat, FasDuck, FasDumbbell, FasDumpster, FasDumpsterFire, FasDungeon, FasE, FasEar, FasEarDeaf, FasEarListen, FasEarMuffs, FasEarthAfrica, FasEarthAmericas, FasEarthAsia, FasEarthEurope, FasEarthOceania, FasEclipse, FasEgg, FasEggFried, FasEggplant, FasEject, FasElephant, FasElevator, FasEllipsis, FasEllipsisStroke, FasEllipsisStrokeVertical, FasEllipsisVertical, FasEmptySet, FasEngine, FasEngineWarning, FasEnvelope, FasEnvelopeCircleCheck, FasEnvelopeDot, FasEnvelopeOpen, FasEnvelopeOpenDollar, FasEnvelopeOpenText, FasEnvelopes, FasEnvelopesBulk, FasEquals, FasEraser, FasEscalator, FasEthernet, FasEuroSign, FasExclamation, FasExpand, FasExpandWide, FasExplosion, FasEye, FasEyeDropper, FasEyeDropperFull, FasEyeDropperHalf, FasEyeEvil, FasEyeLowVision, FasEyeSlash, FasEyes, FasF, FasFaceAngry, FasFaceAngryHorns, FasFaceAnguished, FasFaceAnxiousSweat, FasFaceAstonished, FasFaceAwesome, FasFaceBeamHandOverMouth, FasFaceClouds, FasFaceConfounded, FasFaceConfused, FasFaceCowboyHat, FasFaceDiagonalMouth, FasFaceDisappointed, FasFaceDisguise, FasFaceDizzy, FasFaceDotted, FasFaceDowncastSweat, FasFaceDrooling, FasFaceExhaling, FasFaceExplode, FasFaceExpressionless, FasFaceEyesXmarks, FasFaceFearful, FasFaceFlushed, FasFaceFrown, FasFaceFrownOpen, FasFaceFrownSlight, FasFaceGlasses, FasFaceGrimace, FasFaceGrin, FasFaceGrinBeam, FasFaceGrinBeamSweat, FasFaceGrinHearts, FasFaceGrinSquint, FasFaceGrinSquintTears, FasFaceGrinStars, FasFaceGrinTears, FasFaceGrinTongue, FasFaceGrinTongueSquint, FasFaceGrinTongueWink, FasFaceGrinWide, FasFaceGrinWink, FasFaceHandOverMouth, FasFaceHandPeeking, FasFaceHandYawn, FasFaceHeadBandage, FasFaceHoldingBackTears, FasFaceHushed, FasFaceIcicles, FasFaceKiss, FasFaceKissBeam, FasFaceKissClosedEyes, FasFaceKissWinkHeart, FasFaceLaugh, FasFaceLaughBeam, FasFaceLaughSquint, FasFaceLaughWink, FasFaceLying, FasFaceMask, FasFaceMeh, FasFaceMehBlank, FasFaceMelting, FasFaceMonocle, FasFaceNauseated, FasFaceNoseSteam, FasFaceParty, FasFacePensive, FasFacePersevering, FasFacePleading, FasFacePouting, FasFaceRaisedEyebrow, FasFaceRelieved, FasFaceRollingEyes, FasFaceSadCry, FasFaceSadSweat, FasFaceSadTear, FasFaceSaluting, FasFaceScream, FasFaceShush, FasFaceSleeping, FasFaceSleepy, FasFaceSmile, FasFaceSmileBeam, FasFaceSmileHalo, FasFaceSmileHearts, FasFaceSmileHorns, FasFaceSmilePlus, FasFaceSmileRelaxed, FasFaceSmileTear, FasFaceSmileTongue, FasFaceSmileUpsideDown, FasFaceSmileWink, FasFaceSmilingHands, FasFaceSmirking, FasFaceSpiralEyes, FasFaceSunglasses, FasFaceSurprise, FasFaceSwear, FasFaceThermometer, FasFaceThinking, FasFaceTired, FasFaceTissue, FasFaceTongueMoney, FasFaceTongueSweat, FasFaceUnamused, FasFaceViewfinder, FasFaceVomit, FasFaceWeary, FasFaceWoozy, FasFaceWorried, FasFaceZany, FasFaceZipper, FasFalafel, FasFamily, FasFamilyDress, FasFamilyPants, FasFan, FasFanTable, FasFarm, FasFaucet, FasFaucetDrip, FasFax, FasFeather, FasFeatherPointed, FasFence, FasFerrisWheel, FasFerry, FasFieldHockeyStickBall, FasFile, FasFileArrowDown, FasFileArrowUp, FasFileAudio, FasFileBinary, FasFileCertificate, FasFileChartColumn, FasFileChartPie, FasFileCheck, FasFileCircleCheck, FasFileCircleExclamation, FasFileCircleInfo, FasFileCircleMinus, FasFileCirclePlus, FasFileCircleQuestion, FasFileCircleXmark, FasFileCode, FasFileContract, FasFileCsv, FasFileDashedLine, FasFileDoc, FasFileExcel, FasFileExclamation, FasFileExport, FasFileHeart, FasFileImage, FasFileImport, FasFileInvoice, FasFileInvoiceDollar, FasFileLines, FasFileLock, FasFileMagnifyingGlass, FasFileMedical, FasFileMinus, FasFileMusic, FasFilePdf, FasFilePen, FasFilePlus, FasFilePlusMinus, FasFilePowerpoint, FasFilePrescription, FasFileShield, FasFileSignature, FasFileSlash, FasFileSpreadsheet, FasFileUser, FasFileVideo, FasFileWaveform, FasFileWord, FasFileXmark, FasFileZip, FasFileZipper, FasFiles, FasFilesMedical, FasFill, FasFillDrip, FasFilm, FasFilmCanister, FasFilmSimple, FasFilmSlash, FasFilms, FasFilter, FasFilterCircleDollar, FasFilterCircleXmark, FasFilterList, FasFilterSlash, FasFilters, FasFingerprint, FasFire, FasFireBurner, FasFireExtinguisher, FasFireFlame, FasFireFlameCurved, FasFireFlameSimple, FasFireHydrant, FasFireSmoke, FasFireplace, FasFish, FasFishBones, FasFishCooked, FasFishFins, FasFishingRod, FasFlag, FasFlagCheckered, FasFlagPennant, FasFlagSwallowtail, FasFlagUsa, FasFlashlight, FasFlask, FasFlaskGear, FasFlaskRoundPoison, FasFlaskRoundPotion, FasFlaskVial, FasFlatbread, FasFlatbreadStuffed, FasFloppyDisk, FasFloppyDiskCircleArrowRight, FasFloppyDiskCircleXmark, FasFloppyDiskPen, FasFloppyDisks, FasFlorinSign, FasFlower, FasFlowerDaffodil, FasFlowerTulip, FasFlute, FasFluxCapacitor, FasFlyingDisc, FasFolder, FasFolderArrowDown, FasFolderArrowUp, FasFolderBookmark, FasFolderClosed, FasFolderGear, FasFolderGrid, FasFolderHeart, FasFolderImage, FasFolderMagnifyingGlass, FasFolderMedical, FasFolderMinus, FasFolderMusic, FasFolderOpen, FasFolderPlus, FasFolderTree, FasFolderUser, FasFolderXmark, FasFolders, FasFonduePot, FasFont, FasFontAwesome, FasFontCase, FasFootball, FasFootballHelmet, FasFork, FasForkKnife, FasForklift, FasFort, FasForward, FasForwardFast, FasForwardStep, FasFrame, FasFrancSign, FasFrenchFries, FasFrog, FasFunction, FasFutbol, FasG, FasGalaxy, FasGalleryThumbnails, FasGameBoard, FasGameBoardSimple, FasGameConsoleHandheld, FasGameConsoleHandheldCrank, FasGamepad, FasGamepadModern, FasGarage, FasGarageCar, FasGarageOpen, FasGarlic, FasGasPump, FasGasPumpSlash, FasGauge, FasGaugeCircleBolt, FasGaugeCircleMinus, FasGaugeCirclePlus, FasGaugeHigh, FasGaugeLow, FasGaugeMax, FasGaugeMin, FasGaugeSimple, FasGaugeSimpleHigh, FasGaugeSimpleLow, FasGaugeSimpleMax, FasGaugeSimpleMin, FasGavel, FasGear, FasGearCode, FasGearComplex, FasGearComplexCode, FasGears, FasGem, FasGenderless, FasGhost, FasGif, FasGift, FasGiftCard, FasGifts, FasGingerbreadMan, FasGlass, FasGlassCitrus, FasGlassEmpty, FasGlassHalf, FasGlassWater, FasGlassWaterDroplet, FasGlasses, FasGlassesRound, FasGlobe, FasGlobePointer, FasGlobeSnow, FasGlobeStand, FasGoalNet, FasGolfBallTee, FasGolfClub, FasGolfFlagHole, FasGopuram, FasGraduationCap, FasGramophone, FasGrapes, FasGrate, FasGrateDroplet, FasGreaterThan, FasGreaterThanEqual, FasGrid, FasGrid2, FasGrid2Plus, FasGrid4, FasGrid5, FasGridDividers, FasGridHorizontal, FasGridRound, FasGridRound2, FasGridRound2Plus, FasGridRound4, FasGridRound5, FasGrill, FasGrillFire, FasGrillHot, FasGrip, FasGripDots, FasGripDotsVertical, FasGripLines, FasGripLinesVertical, FasGripVertical, FasGroupArrowsRotate, FasGuaraniSign, FasGuitar, FasGuitarElectric, FasGuitars, FasGun, FasGunSlash, FasGunSquirt, FasH, FasH1, FasH2, FasH3, FasH4, FasH5, FasH6, FasHammer, FasHammerCrash, FasHammerWar, FasHamsa, FasHand, FasHandBackFist, FasHandBackPointDown, FasHandBackPointLeft, FasHandBackPointRibbon, FasHandBackPointRight, FasHandBackPointUp, FasHandDots, FasHandFingersCrossed, FasHandFist, FasHandHeart, FasHandHolding, FasHandHoldingBox, FasHandHoldingDollar, FasHandHoldingDroplet, FasHandHoldingHand, FasHandHoldingHeart, FasHandHoldingMagic, FasHandHoldingMedical, FasHandHoldingSeedling, FasHandHoldingSkull, FasHandHorns, FasHandLizard, FasHandLove, FasHandMiddleFinger, FasHandPeace, FasHandPointDown, FasHandPointLeft, FasHandPointRibbon, FasHandPointRight, FasHandPointUp, FasHandPointer, FasHandScissors, FasHandSparkles, FasHandSpock, FasHandWave, FasHandcuffs, FasHands, FasHandsAslInterpreting, FasHandsBound, FasHandsBubbles, FasHandsClapping, FasHandsHolding, FasHandsHoldingChild, FasHandsHoldingCircle, FasHandsHoldingDiamond, FasHandsHoldingDollar, FasHandsHoldingHeart, FasHandsPraying, FasHandshake, FasHandshakeAngle, FasHandshakeSimple, FasHandshakeSimpleSlash, FasHandshakeSlash, FasHanukiah, FasHardDrive, FasHashtag, FasHashtagLock, FasHatBeach, FasHatChef, FasHatCowboy, FasHatCowboySide, FasHatSanta, FasHatWinter, FasHatWitch, FasHatWizard, FasHeadSide, FasHeadSideBrain, FasHeadSideCough, FasHeadSideCoughSlash, FasHeadSideGear, FasHeadSideGoggles, FasHeadSideHeadphones, FasHeadSideHeart, FasHeadSideMask, FasHeadSideMedical, FasHeadSideVirus, FasHeading, FasHeadphones, FasHeadphonesSimple, FasHeadset, FasHeart, FasHeartCircleBolt, FasHeartCircleCheck, FasHeartCircleExclamation, FasHeartCircleMinus, FasHeartCirclePlus, FasHeartCircleXmark, FasHeartCrack, FasHeartHalf, FasHeartHalfStroke, FasHeartPulse, FasHeat, FasHelicopter, FasHelicopterSymbol, FasHelmetBattle, FasHelmetSafety, FasHelmetUn, FasHexagon, FasHexagonCheck, FasHexagonDivide, FasHexagonExclamation, FasHexagonImage, FasHexagonMinus, FasHexagonPlus, FasHexagonVerticalNft, FasHexagonVerticalNftSlanted, FasHexagonXmark, FasHighDefinition, FasHighlighter, FasHighlighterLine, FasHillAvalanche, FasHillRockslide, FasHippo, FasHockeyMask, FasHockeyPuck, FasHockeyStickPuck, FasHockeySticks, FasHollyBerry, FasHoneyPot, FasHoodCloak, FasHorizontalRule, FasHorse, FasHorseHead, FasHorseSaddle, FasHose, FasHoseReel, FasHospital, FasHospitalUser, FasHospitals, FasHotTubPerson, FasHotdog, FasHotel, FasHourglass, FasHourglassClock, FasHourglassEnd, FasHourglassHalf, FasHourglassStart, FasHouse, FasHouseBlank, FasHouseBuilding, FasHouseChimney, FasHouseChimneyBlank, FasHouseChimneyCrack, FasHouseChimneyHeart, FasHouseChimneyMedical, FasHouseChimneyUser, FasHouseChimneyWindow, FasHouseCircleCheck, FasHouseCircleExclamation, FasHouseCircleXmark, FasHouseCrack, FasHouseDay, FasHouseFire, FasHouseFlag, FasHouseFloodWater, FasHouseFloodWaterCircleArrowRight, FasHouseHeart, FasHouseLaptop, FasHouseLock, FasHouseMedical, FasHouseMedicalCircleCheck, FasHouseMedicalCircleExclamation, FasHouseMedicalCircleXmark, FasHouseMedicalFlag, FasHouseNight, FasHousePersonLeave, FasHousePersonReturn, FasHouseSignal, FasHouseTree, FasHouseTsunami, FasHouseTurret, FasHouseUser, FasHouseWater, FasHouseWindow, FasHryvniaSign, FasHundredPoints, FasHurricane, FasHyphen, FasI, FasICursor, FasIceCream, FasIceSkate, FasIcicles, FasIcons, FasIdBadge, FasIdCard, FasIdCardClip, FasIgloo, FasImage, FasImageLandscape, FasImagePolaroid, FasImagePolaroidUser, FasImagePortrait, FasImageSlash, FasImageUser, FasImages, FasImagesUser, FasInbox, FasInboxFull, FasInboxIn, FasInboxOut, FasInboxes, FasIndent, FasIndianRupeeSign, FasIndustry, FasIndustryWindows, FasInfinity, FasInfo, FasInhaler, FasInputNumeric, FasInputPipe, FasInputText, FasIntegral, FasInterrobang, FasIntersection, FasIslandTropical, FasItalic, FasJ, FasJackOLantern, FasJar, FasJarWheat, FasJedi, FasJetFighter, FasJetFighterUp, FasJoint, FasJoystick, FasJug, FasJugBottle, FasJugDetergent, FasK, FasKaaba, FasKazoo, FasKerning, FasKey, FasKeySkeleton, FasKeySkeletonLeftRight, FasKeyboard, FasKeyboardBrightness, FasKeyboardBrightnessLow, FasKeyboardDown, FasKeyboardLeft, FasKeynote, FasKhanda, FasKidneys, FasKipSign, FasKitMedical, FasKitchenSet, FasKite, FasKiwiBird, FasKiwiFruit, FasKnife, FasKnifeKitchen, FasL, FasLacrosseStick, FasLacrosseStickBall, FasLambda, FasLamp, FasLampDesk, FasLampFloor, FasLampStreet, FasLandMineOn, FasLandmark, FasLandmarkDome, FasLandmarkFlag, FasLanguage, FasLaptop, FasLaptopArrowDown, FasLaptopBinary, FasLaptopCode, FasLaptopFile, FasLaptopMedical, FasLaptopMobile, FasLaptopSlash, FasLariSign, FasLasso, FasLassoSparkles, FasLayerGroup, FasLayerMinus, FasLayerPlus, FasLeaf, FasLeafHeart, FasLeafMaple, FasLeafOak, FasLeafyGreen, FasLeft, FasLeftFromLine, FasLeftLong, FasLeftLongToLine, FasLeftRight, FasLeftToLine, FasLemon, FasLessThan, FasLessThanEqual, FasLifeRing, FasLightCeiling, FasLightEmergency, FasLightEmergencyOn, FasLightSwitch, FasLightSwitchOff, FasLightSwitchOn, FasLightbulb, FasLightbulbCfl, FasLightbulbCflOn, FasLightbulbDollar, FasLightbulbExclamation, FasLightbulbExclamationOn, FasLightbulbGear, FasLightbulbOn, FasLightbulbSlash, FasLighthouse, FasLightsHoliday, FasLineColumns, FasLineHeight, FasLinesLeaning, FasLink, FasLinkHorizontal, FasLinkHorizontalSlash, FasLinkSimple, FasLinkSimpleSlash, FasLinkSlash, FasLips, FasLiraSign, FasList, FasListCheck, FasListDropdown, FasListMusic, FasListOl, FasListRadio, FasListTimeline, FasListTree, FasListUl, FasLitecoinSign, FasLoader, FasLobster, FasLocationArrow, FasLocationCheck, FasLocationCrosshairs, FasLocationCrosshairsSlash, FasLocationDot, FasLocationDotSlash, FasLocationExclamation, FasLocationMinus, FasLocationPen, FasLocationPin, FasLocationPinLock, FasLocationPinSlash, FasLocationPlus, FasLocationQuestion, FasLocationSmile, FasLocationXmark, FasLock, FasLockA, FasLockHashtag, FasLockKeyhole, FasLockKeyholeOpen, FasLockOpen, FasLocust, FasLollipop, FasLoveseat, FasLuchadorMask, FasLungs, FasLungsVirus, FasM, FasMace, FasMagnet, FasMagnifyingGlass, FasMagnifyingGlassArrowRight, FasMagnifyingGlassChart, FasMagnifyingGlassDollar, FasMagnifyingGlassLocation, FasMagnifyingGlassMinus, FasMagnifyingGlassPlus, FasMailbox, FasMailboxFlagUp, FasManatSign, FasMandolin, FasMango, FasManhole, FasMap, FasMapLocation, FasMapLocationDot, FasMapPin, FasMarker, FasMars, FasMarsAndVenus, FasMarsAndVenusBurst, FasMarsDouble, FasMarsStroke, FasMarsStrokeRight, FasMarsStrokeUp, FasMartiniGlass, FasMartiniGlassCitrus, FasMartiniGlassEmpty, FasMask, FasMaskFace, FasMaskSnorkel, FasMaskVentilator, FasMasksTheater, FasMattressPillow, FasMaximize, FasMeat, FasMedal, FasMegaphone, FasMelon, FasMelonSlice, FasMemo, FasMemoCircleCheck, FasMemoCircleInfo, FasMemoPad, FasMemory, FasMenorah, FasMercury, FasMerge, FasMessage, FasMessageArrowDown, FasMessageArrowUp, FasMessageArrowUpRight, FasMessageBot, FasMessageCaptions, FasMessageCheck, FasMessageCode, FasMessageDollar, FasMessageDots, FasMessageExclamation, FasMessageHeart, FasMessageImage, FasMessageLines, FasMessageMedical, FasMessageMiddle, FasMessageMiddleTop, FasMessageMinus, FasMessageMusic, FasMessagePen, FasMessagePlus, FasMessageQuestion, FasMessageQuote, FasMessageSlash, FasMessageSmile, FasMessageSms, FasMessageText, FasMessageXmark, FasMessages, FasMessagesDollar, FasMessagesQuestion, FasMeteor, FasMeter, FasMeterBolt, FasMeterDroplet, FasMeterFire, FasMicrochip, FasMicrochipAi, FasMicrophone, FasMicrophoneLines, FasMicrophoneLinesSlash, FasMicrophoneSlash, FasMicrophoneStand, FasMicroscope, FasMicrowave, FasMillSign, FasMinimize, FasMinus, FasMistletoe, FasMitten, FasMobile, FasMobileButton, FasMobileNotch, FasMobileRetro, FasMobileScreen, FasMobileScreenButton, FasMobileSignal, FasMobileSignalOut, FasMoneyBill, FasMoneyBill1, FasMoneyBill1Wave, FasMoneyBillSimple, FasMoneyBillSimpleWave, FasMoneyBillTransfer, FasMoneyBillTrendUp, FasMoneyBillWave, FasMoneyBillWheat, FasMoneyBills, FasMoneyBillsSimple, FasMoneyCheck, FasMoneyCheckDollar, FasMoneyCheckDollarPen, FasMoneyCheckPen, FasMoneyFromBracket, FasMoneySimpleFromBracket, FasMonitorWaveform, FasMonkey, FasMonument, FasMoon, FasMoonCloud, FasMoonOverSun, FasMoonStars, FasMoped, FasMortarPestle, FasMosque, FasMosquito, FasMosquitoNet, FasMotorcycle, FasMound, FasMountain, FasMountainCity, FasMountainSun, FasMountains, FasMouseField, FasMp3Player, FasMug, FasMugHot, FasMugMarshmallows, FasMugSaucer, FasMugTea, FasMugTeaSaucer, FasMushroom, FasMusic, FasMusicNote, FasMusicNoteSlash, FasMusicSlash, FasMustache, FasN, FasNairaSign, FasNarwhal, FasNestingDolls, FasNetworkWired, FasNeuter, FasNewspaper, FasNfc, FasNfcLock, FasNfcMagnifyingGlass, FasNfcPen, FasNfcSignal, FasNfcSlash, FasNfcSymbol, FasNfcTrash, FasNose, FasNotEqual, FasNotdef, FasNote, FasNoteMedical, FasNoteSticky, FasNotebook, FasNotes, FasNotesMedical, FasO, FasObjectExclude, FasObjectGroup, FasObjectIntersect, FasObjectSubtract, FasObjectUngroup, FasObjectUnion, FasObjectsAlignBottom, FasObjectsAlignCenterHorizontal, FasObjectsAlignCenterVertical, FasObjectsAlignLeft, FasObjectsAlignRight, FasObjectsAlignTop, FasObjectsColumn, FasOctagon, FasOctagonCheck, FasOctagonDivide, FasOctagonExclamation, FasOctagonMinus, FasOctagonPlus, FasOctagonXmark, FasOilCan, FasOilCanDrip, FasOilTemperature, FasOilWell, FasOlive, FasOliveBranch, FasOm, FasOmega, FasOnion, FasOption, FasOrnament, FasOtter, FasOutdent, FasOutlet, FasOven, FasOverline, FasP, FasPage, FasPageCaretDown, FasPageCaretUp, FasPager, FasPaintRoller, FasPaintbrush, FasPaintbrushFine, FasPaintbrushPencil, FasPalette, FasPallet, FasPalletBox, FasPalletBoxes, FasPanFood, FasPanFrying, FasPancakes, FasPanelEws, FasPanelFire, FasPanorama, FasPaperPlane, FasPaperPlaneTop, FasPaperclip, FasPaperclipVertical, FasParachuteBox, FasParagraph, FasParagraphLeft, FasPartyBell, FasPartyHorn, FasPassport, FasPaste, FasPause, FasPaw, FasPawClaws, FasPawSimple, FasPeace, FasPeach, FasPeanut, FasPeanuts, FasPeapod, FasPear, FasPedestal, FasPegasus, FasPen, FasPenCircle, FasPenClip, FasPenClipSlash, FasPenFancy, FasPenFancySlash, FasPenField, FasPenLine, FasPenNib, FasPenNibSlash, FasPenPaintbrush, FasPenRuler, FasPenSlash, FasPenSwirl, FasPenToSquare, FasPencil, FasPencilMechanical, FasPencilSlash, FasPeople, FasPeopleArrows, FasPeopleCarryBox, FasPeopleDress, FasPeopleDressSimple, FasPeopleGroup, FasPeopleLine, FasPeoplePants, FasPeoplePantsSimple, FasPeoplePulling, FasPeopleRobbery, FasPeopleRoof, FasPeopleSimple, FasPepper, FasPepperHot, FasPercent, FasPeriod, FasPerson, FasPersonArrowDownToLine, FasPersonArrowUpFromLine, FasPersonBiking, FasPersonBikingMountain, FasPersonBooth, FasPersonBreastfeeding, FasPersonBurst, FasPersonCane, FasPersonCarryBox, FasPersonChalkboard, FasPersonCircleCheck, FasPersonCircleExclamation, FasPersonCircleMinus, FasPersonCirclePlus, FasPersonCircleQuestion, FasPersonCircleXmark, FasPersonDigging, FasPersonDolly, FasPersonDollyEmpty, FasPersonDotsFromLine, FasPersonDress, FasPersonDressBurst, FasPersonDressFairy, FasPersonDressSimple, FasPersonDrowning, FasPersonFairy, FasPersonFalling, FasPersonFallingBurst, FasPersonFromPortal, FasPersonHalfDress, FasPersonHarassing, FasPersonHiking, FasPersonMilitaryPointing, FasPersonMilitaryRifle, FasPersonMilitaryToPerson, FasPersonPinball, FasPersonPraying, FasPersonPregnant, FasPersonRays, FasPersonRifle, FasPersonRunning, FasPersonRunningFast, FasPersonSeat, FasPersonSeatReclined, FasPersonShelter, FasPersonSign, FasPersonSimple, FasPersonSkating, FasPersonSkiJumping, FasPersonSkiLift, FasPersonSkiing, FasPersonSkiingNordic, FasPersonSledding, FasPersonSnowboarding, FasPersonSnowmobiling, FasPersonSwimming, FasPersonThroughWindow, FasPersonToDoor, FasPersonToPortal, FasPersonWalking, FasPersonWalkingArrowLoopLeft, FasPersonWalkingArrowRight, FasPersonWalkingDashedLineArrowRight, FasPersonWalkingLuggage, FasPersonWalkingWithCane, FasPesetaSign, FasPesoSign, FasPhone, FasPhoneArrowDownLeft, FasPhoneArrowRight, FasPhoneArrowUpRight, FasPhoneFlip, FasPhoneHangup, FasPhoneIntercom, FasPhoneMissed, FasPhoneOffice, FasPhonePlus, FasPhoneRotary, FasPhoneSlash, FasPhoneVolume, FasPhoneXmark, FasPhotoFilm, FasPhotoFilmMusic, FasPi, FasPiano, FasPianoKeyboard, FasPickaxe, FasPickleball, FasPie, FasPig, FasPiggyBank, FasPills, FasPinata, FasPinball, FasPineapple, FasPipe, FasPipeCircleCheck, FasPipeCollar, FasPipeSection, FasPipeSmoking, FasPipeValve, FasPizza, FasPizzaSlice, FasPlaceOfWorship, FasPlane, FasPlaneArrival, FasPlaneCircleCheck, FasPlaneCircleExclamation, FasPlaneCircleXmark, FasPlaneDeparture, FasPlaneEngines, FasPlaneLock, FasPlaneProp, FasPlaneSlash, FasPlaneTail, FasPlaneUp, FasPlaneUpSlash, FasPlanetMoon, FasPlanetRinged, FasPlantWilt, FasPlateUtensils, FasPlateWheat, FasPlay, FasPlayPause, FasPlug, FasPlugCircleBolt, FasPlugCircleCheck, FasPlugCircleExclamation, FasPlugCircleMinus, FasPlugCirclePlus, FasPlugCircleXmark, FasPlus, FasPlusLarge, FasPlusMinus, FasPodcast, FasPodium, FasPodiumStar, FasPoliceBox, FasPollPeople, FasPompebled, FasPoo, FasPooStorm, FasPool8Ball, FasPoop, FasPopcorn, FasPopsicle, FasPotFood, FasPotato, FasPowerOff, FasPrescription, FasPrescriptionBottle, FasPrescriptionBottleMedical, FasPrescriptionBottlePill, FasPresentationScreen, FasPretzel, FasPrint, FasPrintMagnifyingGlass, FasPrintSlash, FasProjector, FasPump, FasPumpMedical, FasPumpSoap, FasPumpkin, FasPuzzle, FasPuzzlePiece, FasPuzzlePieceSimple, FasQ, FasQrcode, FasQuestion, FasQuoteLeft, FasQuoteRight, FasQuotes, FasR, FasRabbit, FasRabbitRunning, FasRaccoon, FasRacquet, FasRadar, FasRadiation, FasRadio, FasRadioTuner, FasRainbow, FasRaindrops, FasRam, FasRampLoading, FasRankingStar, FasRaygun, FasReceipt, FasRecordVinyl, FasRectangle, FasRectangleAd, FasRectangleBarcode, FasRectangleCode, FasRectangleHistory, FasRectangleHistoryCirclePlus, FasRectangleHistoryCircleUser, FasRectangleList, FasRectanglePro, FasRectangleTerminal, FasRectangleVertical, FasRectangleVerticalHistory, FasRectangleWide, FasRectangleXmark, FasRectanglesMixed, FasRecycle, FasReel, FasRefrigerator, FasRegistered, FasRepeat, FasRepeat1, FasReply, FasReplyAll, FasReplyClock, FasRepublican, FasRestroom, FasRestroomSimple, FasRetweet, FasRhombus, FasRibbon, FasRight, FasRightFromBracket, FasRightFromLine, FasRightLeft, FasRightLeftLarge, FasRightLong, FasRightLongToLine, FasRightToBracket, FasRightToLine, FasRing, FasRingDiamond, FasRingsWedding, FasRoad, FasRoadBarrier, FasRoadBridge, FasRoadCircleCheck, FasRoadCircleExclamation, FasRoadCircleXmark, FasRoadLock, FasRoadSpikes, FasRobot, FasRobotAstromech, FasRocket, FasRocketLaunch, FasRollerCoaster, FasRotate, FasRotateExclamation, FasRotateLeft, FasRotateRight, FasRoute, FasRouteHighway, FasRouteInterstate, FasRouter, FasRss, FasRubleSign, FasRug, FasRugbyBall, FasRuler, FasRulerCombined, FasRulerHorizontal, FasRulerTriangle, FasRulerVertical, FasRupeeSign, FasRupiahSign, FasRv, FasS, FasSack, FasSackDollar, FasSackXmark, FasSailboat, FasSalad, FasSaltShaker, FasSandwich, FasSatellite, FasSatelliteDish, FasSausage, FasSaxophone, FasSaxophoneFire, FasScaleBalanced, FasScaleUnbalanced, FasScaleUnbalancedFlip, FasScalpel, FasScalpelLineDashed, FasScannerGun, FasScannerImage, FasScannerKeyboard, FasScannerTouchscreen, FasScarecrow, FasScarf, FasSchool, FasSchoolCircleCheck, FasSchoolCircleExclamation, FasSchoolCircleXmark, FasSchoolFlag, FasSchoolLock, FasScissors, FasScreenUsers, FasScreencast, FasScrewdriver, FasScrewdriverWrench, FasScribble, FasScroll, FasScrollOld, FasScrollTorah, FasScrubber, FasScythe, FasSdCard, FasSdCards, FasSeal, FasSealExclamation, FasSealQuestion, FasSeatAirline, FasSection, FasSeedling, FasSemicolon, FasSendBack, FasSendBackward, FasSensor, FasSensorCloud, FasSensorFire, FasSensorOn, FasSensorTriangleExclamation, FasServer, FasShapes, FasShare, FasShareAll, FasShareFromSquare, FasShareNodes, FasSheep, FasSheetPlastic, FasShekelSign, FasShelves, FasShelvesEmpty, FasShield, FasShieldCat, FasShieldCheck, FasShieldCross, FasShieldDog, FasShieldExclamation, FasShieldHalved, FasShieldHeart, FasShieldKeyhole, FasShieldMinus, FasShieldPlus, FasShieldQuartered, FasShieldSlash, FasShieldVirus, FasShieldXmark, FasShip, FasShirt, FasShirtLongSleeve, FasShirtRunning, FasShirtTankTop, FasShishKebab, FasShoePrints, FasShop, FasShopLock, FasShopSlash, FasShovel, FasShovelSnow, FasShower, FasShowerDown, FasShredder, FasShrimp, FasShuffle, FasShutters, FasShuttleSpace, FasShuttlecock, FasSickle, FasSidebar, FasSidebarFlip, FasSigma, FasSignHanging, FasSignal, FasSignalBars, FasSignalBarsFair, FasSignalBarsGood, FasSignalBarsSlash, FasSignalBarsWeak, FasSignalFair, FasSignalGood, FasSignalSlash, FasSignalStream, FasSignalStreamSlash, FasSignalStrong, FasSignalWeak, FasSignature, FasSignatureLock, FasSignatureSlash, FasSignsPost, FasSimCard, FasSimCards, FasSink, FasSiren, FasSirenOn, FasSitemap, FasSkeleton, FasSkeletonRibs, FasSkiBoot, FasSkiBootSki, FasSkull, FasSkullCow, FasSkullCrossbones, FasSlash, FasSlashBack, FasSlashForward, FasSleigh, FasSlider, FasSliders, FasSlidersSimple, FasSlidersUp, FasSlotMachine, FasSmog, FasSmoke, FasSmoking, FasSnake, FasSnooze, FasSnowBlowing, FasSnowflake, FasSnowflakeDroplets, FasSnowflakes, FasSnowman, FasSnowmanHead, FasSnowplow, FasSoap, FasSocks, FasSoftServe, FasSolarPanel, FasSolarSystem, FasSort, FasSortDown, FasSortUp, FasSpa, FasSpaceStationMoon, FasSpaceStationMoonConstruction, FasSpade, FasSpaghettiMonsterFlying, FasSparkle, FasSparkles, FasSpeaker, FasSpeakers, FasSpellCheck, FasSpider, FasSpiderBlackWidow, FasSpiderWeb, FasSpinner, FasSpinnerThird, FasSplit, FasSplotch, FasSpoon, FasSportsball, FasSprayCan, FasSprayCanSparkles, FasSprinkler, FasSprinklerCeiling, FasSquare, FasSquare0, FasSquare1, FasSquare2, FasSquare3, FasSquare4, FasSquare5, FasSquare6, FasSquare7, FasSquare8, FasSquare9, FasSquareA, FasSquareALock, FasSquareAmpersand, FasSquareArrowDown, FasSquareArrowDownLeft, FasSquareArrowDownRight, FasSquareArrowLeft, FasSquareArrowRight, FasSquareArrowUp, FasSquareArrowUpLeft, FasSquareArrowUpRight, FasSquareB, FasSquareBolt, FasSquareC, FasSquareCaretDown, FasSquareCaretLeft, FasSquareCaretRight, FasSquareCaretUp, FasSquareCheck, FasSquareChevronDown, FasSquareChevronLeft, FasSquareChevronRight, FasSquareChevronUp, FasSquareCode, FasSquareD, FasSquareDashed, FasSquareDashedCirclePlus, FasSquareDivide, FasSquareDollar, FasSquareDown, FasSquareDownLeft, FasSquareDownRight, FasSquareE, FasSquareEllipsis, FasSquareEllipsisVertical, FasSquareEnvelope, FasSquareExclamation, FasSquareF, FasSquareFragile, FasSquareFull, FasSquareG, FasSquareH, FasSquareHeart, FasSquareI, FasSquareInfo, FasSquareJ, FasSquareK, FasSquareKanban, FasSquareL, FasSquareLeft, FasSquareList, FasSquareM, FasSquareMinus, FasSquareN, FasSquareNfi, FasSquareO, FasSquareP, FasSquareParking, FasSquareParkingSlash, FasSquarePen, FasSquarePersonConfined, FasSquarePhone, FasSquarePhoneFlip, FasSquarePhoneHangup, FasSquarePlus, FasSquarePollHorizontal, FasSquarePollVertical, FasSquareQ, FasSquareQuarters, FasSquareQuestion, FasSquareQuote, FasSquareR, FasSquareRight, FasSquareRing, FasSquareRoot, FasSquareRootVariable, FasSquareRss, FasSquareS, FasSquareShareNodes, FasSquareSliders, FasSquareSlidersVertical, FasSquareSmall, FasSquareStar, FasSquareT, FasSquareTerminal, FasSquareThisWayUp, FasSquareU, FasSquareUp, FasSquareUpLeft, FasSquareUpRight, FasSquareUser, FasSquareV, FasSquareVirus, FasSquareW, FasSquareX, FasSquareXmark, FasSquareY, FasSquareZ, FasSquid, FasSquirrel, FasStaff, FasStaffSnake, FasStairs, FasStamp, FasStandardDefinition, FasStapler, FasStar, FasStarAndCrescent, FasStarChristmas, FasStarExclamation, FasStarHalf, FasStarHalfStroke, FasStarOfDavid, FasStarOfLife, FasStarSharp, FasStarSharpHalf, FasStarSharpHalfStroke, FasStarShooting, FasStarfighter, FasStarfighterTwinIonEngine, FasStarfighterTwinIonEngineAdvanced, FasStars, FasStarship, FasStarshipFreighter, FasSteak, FasSteeringWheel, FasSterlingSign, FasStethoscope, FasStocking, FasStomach, FasStop, FasStopwatch, FasStopwatch20, FasStore, FasStoreLock, FasStoreSlash, FasStrawberry, FasStreetView, FasStretcher, FasStrikethrough, FasStroopwafel, FasSubscript, FasSubtitles, FasSubtitlesSlash, FasSuitcase, FasSuitcaseMedical, FasSuitcaseRolling, FasSun, FasSunBright, FasSunCloud, FasSunDust, FasSunHaze, FasSunPlantWilt, FasSunglasses, FasSunrise, FasSunset, FasSuperscript, FasSushi, FasSushiRoll, FasSwap, FasSwapArrows, FasSwatchbook, FasSword, FasSwordLaser, FasSwordLaserAlt, FasSwords, FasSwordsLaser, FasSymbols, FasSynagogue, FasSyringe, FasT, FasTable, FasTableCells, FasTableCellsLarge, FasTableColumns, FasTableLayout, FasTableList, FasTablePicnic, FasTablePivot, FasTableRows, FasTableTennisPaddleBall, FasTableTree, FasTablet, FasTabletButton, FasTabletRugged, FasTabletScreen, FasTabletScreenButton, FasTablets, FasTachographDigital, FasTaco, FasTag, FasTags, FasTally, FasTally1, FasTally2, FasTally3, FasTally4, FasTamale, FasTankWater, FasTape, FasTarp, FasTarpDroplet, FasTaxi, FasTaxiBus, FasTeddyBear, FasTeeth, FasTeethOpen, FasTelescope, FasTemperatureArrowDown, FasTemperatureArrowUp, FasTemperatureEmpty, FasTemperatureFull, FasTemperatureHalf, FasTemperatureHigh, FasTemperatureList, FasTemperatureLow, FasTemperatureQuarter, FasTemperatureSnow, FasTemperatureSun, FasTemperatureThreeQuarters, FasTengeSign, FasTennisBall, FasTent, FasTentArrowDownToLine, FasTentArrowLeftRight, FasTentArrowTurnLeft, FasTentArrowsDown, FasTents, FasTerminal, FasText, FasTextHeight, FasTextSize, FasTextSlash, FasTextWidth, FasThermometer, FasTheta, FasThoughtBubble, FasThumbsDown, FasThumbsUp, FasThumbtack, FasTick, FasTicket, FasTicketAirline, FasTicketSimple, FasTicketsAirline, FasTilde, FasTimeline, FasTimelineArrow, FasTimer, FasTire, FasTireFlat, FasTirePressureWarning, FasTireRugged, FasToggleLargeOff, FasToggleLargeOn, FasToggleOff, FasToggleOn, FasToilet, FasToiletPaper, FasToiletPaperBlank, FasToiletPaperBlankUnder, FasToiletPaperCheck, FasToiletPaperSlash, FasToiletPaperUnder, FasToiletPaperUnderSlash, FasToiletPaperXmark, FasToiletPortable, FasToiletsPortable, FasTomato, FasTombstone, FasTombstoneBlank, FasToolbox, FasTooth, FasToothbrush, FasToriiGate, FasTornado, FasTowerBroadcast, FasTowerCell, FasTowerControl, FasTowerObservation, FasTractor, FasTrademark, FasTrafficCone, FasTrafficLight, FasTrafficLightGo, FasTrafficLightSlow, FasTrafficLightStop, FasTrailer, FasTrain, FasTrainSubway, FasTrainSubwayTunnel, FasTrainTrack, FasTrainTram, FasTrainTunnel, FasTransformerBolt, FasTransgender, FasTransporter, FasTransporter1, FasTransporter2, FasTransporter3, FasTransporter4, FasTransporter5, FasTransporter6, FasTransporter7, FasTransporterEmpty, FasTrash, FasTrashArrowUp, FasTrashCan, FasTrashCanArrowUp, FasTrashCanCheck, FasTrashCanClock, FasTrashCanList, FasTrashCanPlus, FasTrashCanSlash, FasTrashCanUndo, FasTrashCanXmark, FasTrashCheck, FasTrashClock, FasTrashList, FasTrashPlus, FasTrashSlash, FasTrashUndo, FasTrashXmark, FasTreasureChest, FasTree, FasTreeChristmas, FasTreeCity, FasTreeDeciduous, FasTreeDecorated, FasTreeLarge, FasTreePalm, FasTrees, FasTriangle, FasTriangleExclamation, FasTriangleInstrument, FasTrianglePersonDigging, FasTricycle, FasTricycleAdult, FasTrillium, FasTrophy, FasTrophyStar, FasTrowel, FasTrowelBricks, FasTruck, FasTruckArrowRight, FasTruckBolt, FasTruckClock, FasTruckContainer, FasTruckContainerEmpty, FasTruckDroplet, FasTruckFast, FasTruckField, FasTruckFieldUn, FasTruckFlatbed, FasTruckFront, FasTruckMedical, FasTruckMonster, FasTruckMoving, FasTruckPickup, FasTruckPlane, FasTruckPlow, FasTruckRamp, FasTruckRampBox, FasTruckRampCouch, FasTruckTow, FasTrumpet, FasTty, FasTtyAnswer, FasTugrikSign, FasTurkey, FasTurkishLiraSign, FasTurnDown, FasTurnDownLeft, FasTurnDownRight, FasTurnUp, FasTurntable, FasTurtle, FasTv, FasTvMusic, FasTvRetro, FasTypewriter, FasU, FasUfo, FasUfoBeam, FasUmbrella, FasUmbrellaBeach, FasUmbrellaSimple, FasUnderline, FasUnicorn, FasUniformMartialArts, FasUnion, FasUniversalAccess, FasUnlock, FasUnlockKeyhole, FasUp, FasUpDown, FasUpDownLeftRight, FasUpFromBracket, FasUpFromDottedLine, FasUpFromLine, FasUpLeft, FasUpLong, FasUpRight, FasUpRightAndDownLeftFromCenter, FasUpRightFromSquare, FasUpToDottedLine, FasUpToLine, FasUpload, FasUsbDrive, FasUser, FasUserAlien, FasUserAstronaut, FasUserBountyHunter, FasUserCheck, FasUserChef, FasUserClock, FasUserCowboy, FasUserCrown, FasUserDoctor, FasUserDoctorHair, FasUserDoctorHairLong, FasUserDoctorMessage, FasUserGear, FasUserGraduate, FasUserGroup, FasUserGroupCrown, FasUserGroupSimple, FasUserHair, FasUserHairBuns, FasUserHairLong, FasUserHairMullet, FasUserHeadset, FasUserHelmetSafety, FasUserInjured, FasUserLarge, FasUserLargeSlash, FasUserLock, FasUserMagnifyingGlass, FasUserMinus, FasUserMusic, FasUserNinja, FasUserNurse, FasUserNurseHair, FasUserNurseHairLong, FasUserPen, FasUserPilot, FasUserPilotTie, FasUserPlus, FasUserPolice, FasUserPoliceTie, FasUserRobot, FasUserRobotXmarks, FasUserSecret, FasUserShakespeare, FasUserShield, FasUserSlash, FasUserTag, FasUserTie, FasUserTieHair, FasUserTieHairLong, FasUserUnlock, FasUserVisor, FasUserVneck, FasUserVneckHair, FasUserVneckHairLong, FasUserXmark, FasUsers, FasUsersBetweenLines, FasUsersGear, FasUsersLine, FasUsersMedical, FasUsersRays, FasUsersRectangle, FasUsersSlash, FasUsersViewfinder, FasUtensils, FasUtensilsSlash, FasUtilityPole, FasUtilityPoleDouble, FasV, FasVacuum, FasVacuumRobot, FasValueAbsolute, FasVanShuttle, FasVault, FasVectorCircle, FasVectorPolygon, FasVectorSquare, FasVentDamper, FasVenus, FasVenusDouble, FasVenusMars, FasVest, FasVestPatches, FasVial, FasVialCircleCheck, FasVialVirus, FasVials, FasVideo, FasVideoArrowDownLeft, FasVideoArrowUpRight, FasVideoPlus, FasVideoSlash, FasVihara, FasViolin, FasVirus, FasVirusCovid, FasVirusCovidSlash, FasVirusSlash, FasViruses, FasVoicemail, FasVolcano, FasVolleyball, FasVolume, FasVolumeHigh, FasVolumeLow, FasVolumeOff, FasVolumeSlash, FasVolumeXmark, FasVrCardboard, FasW, FasWaffle, FasWagonCovered, FasWalker, FasWalkieTalkie, FasWallet, FasWand, FasWandMagic, FasWandMagicSparkles, FasWandSparkles, FasWarehouse, FasWarehouseFull, FasWashingMachine, FasWatch, FasWatchApple, FasWatchCalculator, FasWatchFitness, FasWatchSmart, FasWater, FasWaterArrowDown, FasWaterArrowUp, FasWaterLadder, FasWatermelonSlice, FasWavePulse, FasWaveSine, FasWaveSquare, FasWaveTriangle, FasWaveform, FasWaveformLines, FasWebhook, FasWeightHanging, FasWeightScale, FasWhale, FasWheat, FasWheatAwn, FasWheatAwnCircleExclamation, FasWheatAwnSlash, FasWheatSlash, FasWheelchair, FasWheelchairMove, FasWhiskeyGlass, FasWhiskeyGlassIce, FasWhistle, FasWifi, FasWifiExclamation, FasWifiFair, FasWifiSlash, FasWifiWeak, FasWind, FasWindTurbine, FasWindWarning, FasWindow, FasWindowFlip, FasWindowFrame, FasWindowFrameOpen, FasWindowMaximize, FasWindowMinimize, FasWindowRestore, FasWindsock, FasWineBottle, FasWineGlass, FasWineGlassCrack, FasWineGlassEmpty, FasWonSign, FasWorm, FasWreath, FasWreathLaurel, FasWrench, FasWrenchSimple, FasX, FasXRay, FasXmark, FasXmarkLarge, FasXmarkToSlot, FasXmarksLines, FasY, FasYenSign, FasYinYang, FasZ };
